/*! For license information please see react-design-editor.min.js.LICENSE.txt */
!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define("react-design-editor.js", [], t) : "object" == typeof exports ? exports["react-design-editor.js"] = t() : e["react-design-editor.js"] = t();
}(window, function () {
  return function (e) {
    var t = {};

    function n(i) {
      if (t[i]) return t[i].exports;
      var r = t[i] = {
        i: i,
        l: !1,
        exports: {}
      };
      return e[i].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
    }

    return n.m = e, n.c = t, n.d = function (e, t, i) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: i
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var i = Object.create(null);
      if (n.r(i), Object.defineProperty(i, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var r in e) {
        n.d(i, r, function (t) {
          return e[t];
        }.bind(null, r));
      }
      return i;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "./", n(n.s = 374);
  }([function (e, t) {
    e.exports = function (e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    };
  }, function (e, t) {
    var n = {
      "[object Function]": 1,
      "[object RegExp]": 1,
      "[object Date]": 1,
      "[object Error]": 1,
      "[object CanvasGradient]": 1,
      "[object CanvasPattern]": 1,
      "[object Image]": 1,
      "[object Canvas]": 1
    },
        i = {
      "[object Int8Array]": 1,
      "[object Uint8Array]": 1,
      "[object Uint8ClampedArray]": 1,
      "[object Int16Array]": 1,
      "[object Uint16Array]": 1,
      "[object Int32Array]": 1,
      "[object Uint32Array]": 1,
      "[object Float32Array]": 1,
      "[object Float64Array]": 1
    },
        r = Object.prototype.toString,
        o = Array.prototype,
        a = o.forEach,
        s = o.filter,
        l = o.slice,
        u = o.map,
        c = o.reduce,
        h = {};

    function d(e) {
      if (null == e || "object" != typeof e) return e;
      var t = e,
          o = r.call(e);

      if ("[object Array]" === o) {
        if (!S(e)) {
          t = [];

          for (var a = 0, s = e.length; a < s; a++) {
            t[a] = d(e[a]);
          }
        }
      } else if (i[o]) {
        if (!S(e)) {
          var l = e.constructor;
          if (e.constructor.from) t = l.from(e);else {
            t = new l(e.length);

            for (a = 0, s = e.length; a < s; a++) {
              t[a] = d(e[a]);
            }
          }
        }
      } else if (!n[o] && !S(e) && !w(e)) for (var u in t = {}, e) {
        e.hasOwnProperty(u) && (t[u] = d(e[u]));
      }

      return t;
    }

    function f(e, t, n) {
      if (!_(t) || !_(e)) return n ? d(t) : e;

      for (var i in t) {
        if (t.hasOwnProperty(i)) {
          var r = e[i],
              o = t[i];
          !_(o) || !_(r) || x(o) || x(r) || w(o) || w(r) || b(o) || b(r) || S(o) || S(r) ? !n && i in e || (e[i] = d(t[i])) : f(r, o, n);
        }
      }

      return e;
    }

    function p(e, t, n) {
      for (var i in t) {
        t.hasOwnProperty(i) && (n ? null != t[i] : null == e[i]) && (e[i] = t[i]);
      }

      return e;
    }

    var g,
        v = function v() {
      return h.createCanvas();
    };

    function m(e, t, n) {
      if (e && t) if (e.forEach && e.forEach === a) e.forEach(t, n);else if (e.length === +e.length) for (var i = 0, r = e.length; i < r; i++) {
        t.call(n, e[i], i, e);
      } else for (var o in e) {
        e.hasOwnProperty(o) && t.call(n, e[o], o, e);
      }
    }

    function y(e, t) {
      var n = l.call(arguments, 2);
      return function () {
        return e.apply(t, n.concat(l.call(arguments)));
      };
    }

    function x(e) {
      return "[object Array]" === r.call(e);
    }

    function _(e) {
      var t = typeof e;
      return "function" === t || !!e && "object" === t;
    }

    function b(e) {
      return !!n[r.call(e)];
    }

    function w(e) {
      return "object" == typeof e && "number" == typeof e.nodeType && "object" == typeof e.ownerDocument;
    }

    h.createCanvas = function () {
      return document.createElement("canvas");
    };

    function S(e) {
      return e.__ec_primitive__;
    }

    function T(e) {
      var t = x(e);
      this.data = {};
      var n = this;

      function i(e, i) {
        t ? n.set(e, i) : n.set(i, e);
      }

      e instanceof T ? e.each(i) : e && m(e, i);
    }

    T.prototype = {
      constructor: T,
      get: function get(e) {
        return this.data.hasOwnProperty(e) ? this.data[e] : null;
      },
      set: function set(e, t) {
        return this.data[e] = t;
      },
      each: function each(e, t) {
        for (var n in void 0 !== t && (e = y(e, t)), this.data) {
          this.data.hasOwnProperty(n) && e(this.data[n], n);
        }
      },
      removeKey: function removeKey(e) {
        delete this.data[e];
      }
    }, t.$override = function (e, t) {
      "createCanvas" === e && (g = null), h[e] = t;
    }, t.clone = d, t.merge = f, t.mergeAll = function (e, t) {
      for (var n = e[0], i = 1, r = e.length; i < r; i++) {
        n = f(n, e[i], t);
      }

      return n;
    }, t.extend = function (e, t) {
      for (var n in t) {
        t.hasOwnProperty(n) && (e[n] = t[n]);
      }

      return e;
    }, t.defaults = p, t.createCanvas = v, t.getContext = function () {
      return g || (g = v().getContext("2d")), g;
    }, t.indexOf = function (e, t) {
      if (e) {
        if (e.indexOf) return e.indexOf(t);

        for (var n = 0, i = e.length; n < i; n++) {
          if (e[n] === t) return n;
        }
      }

      return -1;
    }, t.inherits = function (e, t) {
      var n = e.prototype;

      function i() {}

      for (var r in i.prototype = t.prototype, e.prototype = new i(), n) {
        n.hasOwnProperty(r) && (e.prototype[r] = n[r]);
      }

      e.prototype.constructor = e, e.superClass = t;
    }, t.mixin = function (e, t, n) {
      p(e = "prototype" in e ? e.prototype : e, t = "prototype" in t ? t.prototype : t, n);
    }, t.isArrayLike = function (e) {
      if (e) return "string" != typeof e && "number" == typeof e.length;
    }, t.each = m, t.map = function (e, t, n) {
      if (e && t) {
        if (e.map && e.map === u) return e.map(t, n);

        for (var i = [], r = 0, o = e.length; r < o; r++) {
          i.push(t.call(n, e[r], r, e));
        }

        return i;
      }
    }, t.reduce = function (e, t, n, i) {
      if (e && t) {
        if (e.reduce && e.reduce === c) return e.reduce(t, n, i);

        for (var r = 0, o = e.length; r < o; r++) {
          n = t.call(i, n, e[r], r, e);
        }

        return n;
      }
    }, t.filter = function (e, t, n) {
      if (e && t) {
        if (e.filter && e.filter === s) return e.filter(t, n);

        for (var i = [], r = 0, o = e.length; r < o; r++) {
          t.call(n, e[r], r, e) && i.push(e[r]);
        }

        return i;
      }
    }, t.find = function (e, t, n) {
      if (e && t) for (var i = 0, r = e.length; i < r; i++) {
        if (t.call(n, e[i], i, e)) return e[i];
      }
    }, t.bind = y, t.curry = function (e) {
      var t = l.call(arguments, 1);
      return function () {
        return e.apply(this, t.concat(l.call(arguments)));
      };
    }, t.isArray = x, t.isFunction = function (e) {
      return "function" == typeof e;
    }, t.isString = function (e) {
      return "[object String]" === r.call(e);
    }, t.isObject = _, t.isBuiltInObject = b, t.isTypedArray = function (e) {
      return !!i[r.call(e)];
    }, t.isDom = w, t.eqNaN = function (e) {
      return e != e;
    }, t.retrieve = function (e) {
      for (var t = 0, n = arguments.length; t < n; t++) {
        if (null != arguments[t]) return arguments[t];
      }
    }, t.retrieve2 = function (e, t) {
      return null != e ? e : t;
    }, t.retrieve3 = function (e, t, n) {
      return null != e ? e : null != t ? t : n;
    }, t.slice = function () {
      return Function.call.apply(l, arguments);
    }, t.normalizeCssArray = function (e) {
      if ("number" == typeof e) return [e, e, e, e];
      var t = e.length;
      return 2 === t ? [e[0], e[1], e[0], e[1]] : 3 === t ? [e[0], e[1], e[2], e[1]] : e;
    }, t.assert = function (e, t) {
      if (!e) throw new Error(t);
    }, t.trim = function (e) {
      return null == e ? null : "function" == typeof e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
    }, t.setAsPrimitive = function (e) {
      e.__ec_primitive__ = !0;
    }, t.isPrimitive = S, t.createHashMap = function (e) {
      return new T(e);
    }, t.concatArray = function (e, t) {
      for (var n = new e.constructor(e.length + t.length), i = 0; i < e.length; i++) {
        n[i] = e[i];
      }

      var r = e.length;

      for (i = 0; i < t.length; i++) {
        n[i + r] = t[i];
      }

      return n;
    }, t.noop = function () {};
  }, function (e, t, n) {
    (function (e) {
      var i,
          r,
          o,
          a,
          s,
          l,
          u,
          c,
          h,
          d,
          f,
          p,
          g,
          v,
          m,
          y,
          x,
          _,
          b,
          w,
          S,
          T = T || {
        version: "3.6.3"
      };

      if (t.fabric = T, "undefined" != typeof document && "undefined" != typeof window) document instanceof ("undefined" != typeof HTMLDocument ? HTMLDocument : Document) ? T.document = document : T.document = document.implementation.createHTMLDocument(""), T.window = window;else {
        var C = new (n(568).JSDOM)(decodeURIComponent("%3C!DOCTYPE%20html%3E%3Chtml%3E%3Chead%3E%3C%2Fhead%3E%3Cbody%3E%3C%2Fbody%3E%3C%2Fhtml%3E"), {
          features: {
            FetchExternalResources: ["img"]
          },
          resources: "usable"
        }).window;
        T.document = C.document, T.jsdomImplForWrapper = n(569).implForWrapper, T.nodeCanvas = n(570).Canvas, T.window = C, DOMParser = T.window.DOMParser;
      }

      function k(e, t) {
        var n = e.canvas,
            i = t.targetCanvas,
            r = i.getContext("2d");
        r.translate(0, i.height), r.scale(1, -1);
        var o = n.height - i.height;
        r.drawImage(n, 0, o, i.width, i.height, 0, 0, i.width, i.height);
      }

      function M(e, t) {
        var n = t.targetCanvas.getContext("2d"),
            i = t.destinationWidth,
            r = t.destinationHeight,
            o = i * r * 4,
            a = new Uint8Array(this.imageBuffer, 0, o),
            s = new Uint8ClampedArray(this.imageBuffer, 0, o);
        e.readPixels(0, 0, i, r, e.RGBA, e.UNSIGNED_BYTE, a);
        var l = new ImageData(s, i, r);
        n.putImageData(l, 0, 0);
      }

      T.isTouchSupported = "ontouchstart" in T.window || "ontouchstart" in T.document || T.window && T.window.navigator && T.window.navigator.maxTouchPoints > 0, T.isLikelyNode = void 0 !== e && "undefined" == typeof window, T.SHARED_ATTRIBUTES = ["display", "transform", "fill", "fill-opacity", "fill-rule", "opacity", "stroke", "stroke-dasharray", "stroke-linecap", "stroke-dashoffset", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke-width", "id", "paint-order", "vector-effect", "instantiated_by_use", "clip-path"], T.DPI = 96, T.reNum = "(?:[-+]?(?:\\d+|\\d*\\.\\d+)(?:[eE][-+]?\\d+)?)", T.rePathCommand = /([-+]?((\d+\.\d+)|((\d+)|(\.\d+)))(?:[eE][-+]?\d+)?)/gi, T.reNonWord = /[ \n\.,;!\?\-]/, T.fontPaths = {}, T.iMatrix = [1, 0, 0, 1, 0, 0], T.svgNS = "http://www.w3.org/2000/svg", T.perfLimitSizeTotal = 2097152, T.maxCacheSideLimit = 4096, T.minCacheSideLimit = 256, T.charWidthsCache = {}, T.textureSize = 2048, T.disableStyleCopyPaste = !1, T.enableGLFiltering = !0, T.devicePixelRatio = T.window.devicePixelRatio || T.window.webkitDevicePixelRatio || T.window.mozDevicePixelRatio || 1, T.browserShadowBlurConstant = 1, T.arcToSegmentsCache = {}, T.boundsOfCurveCache = {}, T.cachesBoundsOfCurve = !0, T.forceGLPutImageData = !1, T.initFilterBackend = function () {
        return T.enableGLFiltering && T.isWebglSupported && T.isWebglSupported(T.textureSize) ? (console.log("max texture size: " + T.maxTextureSize), new T.WebglFilterBackend({
          tileSize: T.textureSize
        })) : T.Canvas2dFilterBackend ? new T.Canvas2dFilterBackend() : void 0;
      }, "undefined" != typeof document && "undefined" != typeof window && (window.fabric = T), function () {
        function e(e, t) {
          if (this.__eventListeners[e]) {
            var n = this.__eventListeners[e];
            t ? n[n.indexOf(t)] = !1 : T.util.array.fill(n, !1);
          }
        }

        function t(e, t) {
          if (this.__eventListeners || (this.__eventListeners = {}), 1 === arguments.length) for (var n in e) {
            this.on(n, e[n]);
          } else this.__eventListeners[e] || (this.__eventListeners[e] = []), this.__eventListeners[e].push(t);
          return this;
        }

        function n(t, n) {
          if (!this.__eventListeners) return this;
          if (0 === arguments.length) for (t in this.__eventListeners) {
            e.call(this, t);
          } else if (1 === arguments.length && "object" == typeof arguments[0]) for (var i in t) {
            e.call(this, i, t[i]);
          } else e.call(this, t, n);
          return this;
        }

        function i(e, t) {
          if (!this.__eventListeners) return this;
          var n = this.__eventListeners[e];
          if (!n) return this;

          for (var i = 0, r = n.length; i < r; i++) {
            n[i] && n[i].call(this, t || {});
          }

          return this.__eventListeners[e] = n.filter(function (e) {
            return !1 !== e;
          }), this;
        }

        T.Observable = {
          observe: t,
          stopObserving: n,
          fire: i,
          on: t,
          off: n,
          trigger: i
        };
      }(), T.Collection = {
        _objects: [],
        add: function add() {
          if (this._objects.push.apply(this._objects, arguments), this._onObjectAdded) for (var e = 0, t = arguments.length; e < t; e++) {
            this._onObjectAdded(arguments[e]);
          }
          return this.renderOnAddRemove && this.requestRenderAll(), this;
        },
        insertAt: function insertAt(e, t, n) {
          var i = this._objects;
          return n ? i[t] = e : i.splice(t, 0, e), this._onObjectAdded && this._onObjectAdded(e), this.renderOnAddRemove && this.requestRenderAll(), this;
        },
        remove: function remove() {
          for (var e, t = this._objects, n = !1, i = 0, r = arguments.length; i < r; i++) {
            -1 !== (e = t.indexOf(arguments[i])) && (n = !0, t.splice(e, 1), this._onObjectRemoved && this._onObjectRemoved(arguments[i]));
          }

          return this.renderOnAddRemove && n && this.requestRenderAll(), this;
        },
        forEachObject: function forEachObject(e, t) {
          for (var n = this.getObjects(), i = 0, r = n.length; i < r; i++) {
            e.call(t, n[i], i, n);
          }

          return this;
        },
        getObjects: function getObjects(e) {
          return void 0 === e ? this._objects.concat() : this._objects.filter(function (t) {
            return t.type === e;
          });
        },
        item: function item(e) {
          return this._objects[e];
        },
        isEmpty: function isEmpty() {
          return 0 === this._objects.length;
        },
        size: function size() {
          return this._objects.length;
        },
        contains: function contains(e) {
          return this._objects.indexOf(e) > -1;
        },
        complexity: function complexity() {
          return this._objects.reduce(function (e, t) {
            return e += t.complexity ? t.complexity() : 0;
          }, 0);
        }
      }, T.CommonMethods = {
        _setOptions: function _setOptions(e) {
          for (var t in e) {
            this.set(t, e[t]);
          }
        },
        _initGradient: function _initGradient(e, t) {
          !e || !e.colorStops || e instanceof T.Gradient || this.set(t, new T.Gradient(e));
        },
        _initPattern: function _initPattern(e, t, n) {
          !e || !e.source || e instanceof T.Pattern ? n && n() : this.set(t, new T.Pattern(e, n));
        },
        _initClipping: function _initClipping(e) {
          if (e.clipTo && "string" == typeof e.clipTo) {
            var t = T.util.getFunctionBody(e.clipTo);
            void 0 !== t && (this.clipTo = new Function("ctx", t));
          }
        },
        _setObject: function _setObject(e) {
          for (var t in e) {
            this._set(t, e[t]);
          }
        },
        set: function set(e, t) {
          return "object" == typeof e ? this._setObject(e) : "function" == typeof t && "clipTo" !== e ? this._set(e, t(this.get(e))) : this._set(e, t), this;
        },
        _set: function _set(e, t) {
          this[e] = t;
        },
        toggle: function toggle(e) {
          var t = this.get(e);
          return "boolean" == typeof t && this.set(e, !t), this;
        },
        get: function get(e) {
          return this[e];
        }
      }, i = t, r = Math.sqrt, o = Math.atan2, a = Math.pow, s = Math.PI / 180, l = Math.PI / 2, T.util = {
        cos: function cos(e) {
          if (0 === e) return 1;

          switch (e < 0 && (e = -e), e / l) {
            case 1:
            case 3:
              return 0;

            case 2:
              return -1;
          }

          return Math.cos(e);
        },
        sin: function sin(e) {
          if (0 === e) return 0;
          var t = 1;

          switch (e < 0 && (t = -1), e / l) {
            case 1:
              return t;

            case 2:
              return 0;

            case 3:
              return -t;
          }

          return Math.sin(e);
        },
        removeFromArray: function removeFromArray(e, t) {
          var n = e.indexOf(t);
          return -1 !== n && e.splice(n, 1), e;
        },
        getRandomInt: function getRandomInt(e, t) {
          return Math.floor(Math.random() * (t - e + 1)) + e;
        },
        degreesToRadians: function degreesToRadians(e) {
          return e * s;
        },
        radiansToDegrees: function radiansToDegrees(e) {
          return e / s;
        },
        rotatePoint: function rotatePoint(e, t, n) {
          e.subtractEquals(t);
          var i = T.util.rotateVector(e, n);
          return new T.Point(i.x, i.y).addEquals(t);
        },
        rotateVector: function rotateVector(e, t) {
          var n = T.util.sin(t),
              i = T.util.cos(t);
          return {
            x: e.x * i - e.y * n,
            y: e.x * n + e.y * i
          };
        },
        transformPoint: function transformPoint(e, t, n) {
          return n ? new T.Point(t[0] * e.x + t[2] * e.y, t[1] * e.x + t[3] * e.y) : new T.Point(t[0] * e.x + t[2] * e.y + t[4], t[1] * e.x + t[3] * e.y + t[5]);
        },
        makeBoundingBoxFromPoints: function makeBoundingBoxFromPoints(e, t) {
          if (t) for (var n = 0; n < e.length; n++) {
            e[n] = T.util.transformPoint(e[n], t);
          }
          var i = [e[0].x, e[1].x, e[2].x, e[3].x],
              r = T.util.array.min(i),
              o = T.util.array.max(i) - r,
              a = [e[0].y, e[1].y, e[2].y, e[3].y],
              s = T.util.array.min(a);
          return {
            left: r,
            top: s,
            width: o,
            height: T.util.array.max(a) - s
          };
        },
        invertTransform: function invertTransform(e) {
          var t = 1 / (e[0] * e[3] - e[1] * e[2]),
              n = [t * e[3], -t * e[1], -t * e[2], t * e[0]],
              i = T.util.transformPoint({
            x: e[4],
            y: e[5]
          }, n, !0);
          return n[4] = -i.x, n[5] = -i.y, n;
        },
        toFixed: function toFixed(e, t) {
          return parseFloat(Number(e).toFixed(t));
        },
        parseUnit: function parseUnit(e, t) {
          var n = /\D{0,2}$/.exec(e),
              i = parseFloat(e);

          switch (t || (t = T.Text.DEFAULT_SVG_FONT_SIZE), n[0]) {
            case "mm":
              return i * T.DPI / 25.4;

            case "cm":
              return i * T.DPI / 2.54;

            case "in":
              return i * T.DPI;

            case "pt":
              return i * T.DPI / 72;

            case "pc":
              return i * T.DPI / 72 * 12;

            case "em":
              return i * t;

            default:
              return i;
          }
        },
        falseFunction: function falseFunction() {
          return !1;
        },
        getKlass: function getKlass(e, t) {
          return e = T.util.string.camelize(e.charAt(0).toUpperCase() + e.slice(1)), T.util.resolveNamespace(t)[e];
        },
        getSvgAttributes: function getSvgAttributes(e) {
          var t = ["instantiated_by_use", "style", "id", "class"];

          switch (e) {
            case "linearGradient":
              t = t.concat(["x1", "y1", "x2", "y2", "gradientUnits", "gradientTransform"]);
              break;

            case "radialGradient":
              t = t.concat(["gradientUnits", "gradientTransform", "cx", "cy", "r", "fx", "fy", "fr"]);
              break;

            case "stop":
              t = t.concat(["offset", "stop-color", "stop-opacity"]);
          }

          return t;
        },
        resolveNamespace: function resolveNamespace(e) {
          if (!e) return T;
          var t,
              n = e.split("."),
              r = n.length,
              o = i || T.window;

          for (t = 0; t < r; ++t) {
            o = o[n[t]];
          }

          return o;
        },
        loadImage: function loadImage(e, t, n, i) {
          if (e) {
            var r = T.util.createImage(),
                o = function o() {
              t && t.call(n, r), r = r.onload = r.onerror = null;
            };

            r.onload = o, r.onerror = function () {
              T.log("Error loading " + r.src), t && t.call(n, null, !0), r = r.onload = r.onerror = null;
            }, 0 !== e.indexOf("data") && i && (r.crossOrigin = i), "data:image/svg" === e.substring(0, 14) && (r.onload = null, T.util.loadImageInDom(r, o)), r.src = e;
          } else t && t.call(n, e);
        },
        loadImageInDom: function loadImageInDom(e, t) {
          var n = T.document.createElement("div");
          n.style.width = n.style.height = "1px", n.style.left = n.style.top = "-100%", n.style.position = "absolute", n.appendChild(e), T.document.querySelector("body").appendChild(n), e.onload = function () {
            t(), n.parentNode.removeChild(n), n = null;
          };
        },
        enlivenObjects: function enlivenObjects(e, t, n, i) {
          var r = [],
              o = 0,
              a = (e = e || []).length;

          function s() {
            ++o === a && t && t(r.filter(function (e) {
              return e;
            }));
          }

          a ? e.forEach(function (e, t) {
            e && e.type ? T.util.getKlass(e.type, n).fromObject(e, function (n, o) {
              o || (r[t] = n), i && i(e, n, o), s();
            }) : s();
          }) : t && t(r);
        },
        enlivenPatterns: function enlivenPatterns(e, t) {
          function n() {
            ++r === o && t && t(i);
          }

          var i = [],
              r = 0,
              o = (e = e || []).length;
          o ? e.forEach(function (e, t) {
            e && e.source ? new T.Pattern(e, function (e) {
              i[t] = e, n();
            }) : (i[t] = e, n());
          }) : t && t(i);
        },
        groupSVGElements: function groupSVGElements(e, t, n) {
          var i;
          return e && 1 === e.length ? e[0] : (t && (t.width && t.height ? t.centerPoint = {
            x: t.width / 2,
            y: t.height / 2
          } : (delete t.width, delete t.height)), i = new T.Group(e, t), void 0 !== n && (i.sourcePath = n), i);
        },
        populateWithProperties: function populateWithProperties(e, t, n) {
          if (n && "[object Array]" === Object.prototype.toString.call(n)) for (var i = 0, r = n.length; i < r; i++) {
            n[i] in e && (t[n[i]] = e[n[i]]);
          }
        },
        drawDashedLine: function drawDashedLine(e, t, n, i, a, s) {
          var l = i - t,
              u = a - n,
              c = r(l * l + u * u),
              h = o(u, l),
              d = s.length,
              f = 0,
              p = !0;

          for (e.save(), e.translate(t, n), e.moveTo(0, 0), e.rotate(h), t = 0; c > t;) {
            (t += s[f++ % d]) > c && (t = c), e[p ? "lineTo" : "moveTo"](t, 0), p = !p;
          }

          e.restore();
        },
        createCanvasElement: function createCanvasElement() {
          return T.document.createElement("canvas");
        },
        copyCanvasElement: function copyCanvasElement(e) {
          var t = T.util.createCanvasElement();
          return t.width = e.width, t.height = e.height, t.getContext("2d").drawImage(e, 0, 0), t;
        },
        toDataURL: function toDataURL(e, t, n) {
          return e.toDataURL("image/" + t, n);
        },
        createImage: function createImage() {
          return T.document.createElement("img");
        },
        clipContext: function clipContext(e, t) {
          t.save(), t.beginPath(), e.clipTo(t), t.clip();
        },
        multiplyTransformMatrices: function multiplyTransformMatrices(e, t, n) {
          return [e[0] * t[0] + e[2] * t[1], e[1] * t[0] + e[3] * t[1], e[0] * t[2] + e[2] * t[3], e[1] * t[2] + e[3] * t[3], n ? 0 : e[0] * t[4] + e[2] * t[5] + e[4], n ? 0 : e[1] * t[4] + e[3] * t[5] + e[5]];
        },
        qrDecompose: function qrDecompose(e) {
          var t = o(e[1], e[0]),
              n = a(e[0], 2) + a(e[1], 2),
              i = r(n),
              l = (e[0] * e[3] - e[2] * e[1]) / i,
              u = o(e[0] * e[2] + e[1] * e[3], n);
          return {
            angle: t / s,
            scaleX: i,
            scaleY: l,
            skewX: u / s,
            skewY: 0,
            translateX: e[4],
            translateY: e[5]
          };
        },
        calcRotateMatrix: function calcRotateMatrix(e) {
          if (!e.angle) return T.iMatrix.concat();
          var t = T.util.degreesToRadians(e.angle),
              n = T.util.cos(t),
              i = T.util.sin(t);
          return [n, i, -i, n, 0, 0];
        },
        calcDimensionsMatrix: function calcDimensionsMatrix(e) {
          var t = void 0 === e.scaleX ? 1 : e.scaleX,
              n = void 0 === e.scaleY ? 1 : e.scaleY,
              i = [e.flipX ? -t : t, 0, 0, e.flipY ? -n : n, 0, 0],
              r = T.util.multiplyTransformMatrices,
              o = T.util.degreesToRadians;
          return e.skewX && (i = r(i, [1, 0, Math.tan(o(e.skewX)), 1], !0)), e.skewY && (i = r(i, [1, Math.tan(o(e.skewY)), 0, 1], !0)), i;
        },
        composeMatrix: function composeMatrix(e) {
          var t = [1, 0, 0, 1, e.translateX || 0, e.translateY || 0],
              n = T.util.multiplyTransformMatrices;
          return e.angle && (t = n(t, T.util.calcRotateMatrix(e))), (e.scaleX || e.scaleY || e.skewX || e.skewY || e.flipX || e.flipY) && (t = n(t, T.util.calcDimensionsMatrix(e))), t;
        },
        customTransformMatrix: function customTransformMatrix(e, t, n) {
          return T.util.composeMatrix({
            scaleX: e,
            scaleY: t,
            skewX: n
          });
        },
        resetObjectTransform: function resetObjectTransform(e) {
          e.scaleX = 1, e.scaleY = 1, e.skewX = 0, e.skewY = 0, e.flipX = !1, e.flipY = !1, e.rotate(0);
        },
        saveObjectTransform: function saveObjectTransform(e) {
          return {
            scaleX: e.scaleX,
            scaleY: e.scaleY,
            skewX: e.skewX,
            skewY: e.skewY,
            angle: e.angle,
            left: e.left,
            flipX: e.flipX,
            flipY: e.flipY,
            top: e.top
          };
        },
        getFunctionBody: function getFunctionBody(e) {
          return (String(e).match(/function[^{]*\{([\s\S]*)\}/) || {})[1];
        },
        isTransparent: function isTransparent(e, t, n, i) {
          i > 0 && (t > i ? t -= i : t = 0, n > i ? n -= i : n = 0);
          var r,
              o = !0,
              a = e.getImageData(t, n, 2 * i || 1, 2 * i || 1),
              s = a.data.length;

          for (r = 3; r < s && !1 != (o = a.data[r] <= 0); r += 4) {
            ;
          }

          return a = null, o;
        },
        parsePreserveAspectRatioAttribute: function parsePreserveAspectRatioAttribute(e) {
          var t,
              n = "meet",
              i = e.split(" ");
          return i && i.length && ("meet" !== (n = i.pop()) && "slice" !== n ? (t = n, n = "meet") : i.length && (t = i.pop())), {
            meetOrSlice: n,
            alignX: "none" !== t ? t.slice(1, 4) : "none",
            alignY: "none" !== t ? t.slice(5, 8) : "none"
          };
        },
        clearFabricFontCache: function clearFabricFontCache(e) {
          (e = (e || "").toLowerCase()) ? T.charWidthsCache[e] && delete T.charWidthsCache[e] : T.charWidthsCache = {};
        },
        limitDimsByArea: function limitDimsByArea(e, t) {
          var n = Math.sqrt(t * e),
              i = Math.floor(t / n);
          return {
            x: Math.floor(n),
            y: i
          };
        },
        capValue: function capValue(e, t, n) {
          return Math.max(e, Math.min(t, n));
        },
        findScaleToFit: function findScaleToFit(e, t) {
          return Math.min(t.width / e.width, t.height / e.height);
        },
        findScaleToCover: function findScaleToCover(e, t) {
          return Math.max(t.width / e.width, t.height / e.height);
        },
        matrixToSVG: function matrixToSVG(e) {
          return "matrix(" + e.map(function (e) {
            return T.util.toFixed(e, T.Object.NUM_FRACTION_DIGITS);
          }).join(" ") + ")";
        }
      }, function () {
        var e = Array.prototype.join;

        function t(t, r, o, a, s, l, u) {
          var c = e.call(arguments);
          if (T.arcToSegmentsCache[c]) return T.arcToSegmentsCache[c];

          var h = Math.PI,
              d = u * h / 180,
              f = T.util.sin(d),
              p = T.util.cos(d),
              g = 0,
              v = 0,
              m = -p * t * .5 - f * r * .5,
              y = -p * r * .5 + f * t * .5,
              x = (o = Math.abs(o)) * o,
              _ = (a = Math.abs(a)) * a,
              b = y * y,
              w = m * m,
              S = x * _ - x * b - _ * w,
              C = 0;

          if (S < 0) {
            var k = Math.sqrt(1 - S / (x * _));
            o *= k, a *= k;
          } else C = (s === l ? -1 : 1) * Math.sqrt(S / (x * b + _ * w));

          var M = C * o * y / a,
              E = -C * a * m / o,
              A = p * M - f * E + .5 * t,
              I = f * M + p * E + .5 * r,
              P = i(1, 0, (m - M) / o, (y - E) / a),
              O = i((m - M) / o, (y - E) / a, (-m - M) / o, (-y - E) / a);
          0 === l && O > 0 ? O -= 2 * h : 1 === l && O < 0 && (O += 2 * h);

          for (var L = Math.ceil(Math.abs(O / h * 2)), D = [], N = O / L, j = 8 / 3 * Math.sin(N / 4) * Math.sin(N / 4) / Math.sin(N / 2), R = P + N, F = 0; F < L; F++) {
            D[F] = n(P, R, p, f, o, a, A, I, j, g, v), g = D[F][4], v = D[F][5], P = R, R += N;
          }

          return T.arcToSegmentsCache[c] = D, D;
        }

        function n(e, t, n, i, r, o, a, s, l, u, c) {
          var h = T.util.cos(e),
              d = T.util.sin(e),
              f = T.util.cos(t),
              p = T.util.sin(t),
              g = n * r * f - i * o * p + a,
              v = i * r * f + n * o * p + s;
          return [u + l * (-n * r * d - i * o * h), c + l * (-i * r * d + n * o * h), g + l * (n * r * p + i * o * f), v + l * (i * r * p - n * o * f), g, v];
        }

        function i(e, t, n, i) {
          var r = Math.atan2(t, e),
              o = Math.atan2(i, n);
          return o >= r ? o - r : 2 * Math.PI - (r - o);
        }

        function r(t, n, i, r, o, a, s, l) {
          var u;
          if (T.cachesBoundsOfCurve && (u = e.call(arguments), T.boundsOfCurveCache[u])) return T.boundsOfCurveCache[u];
          var c,
              h,
              d,
              f,
              p,
              g,
              v,
              m,
              y = Math.sqrt,
              x = Math.min,
              _ = Math.max,
              b = Math.abs,
              w = [],
              S = [[], []];
          h = 6 * t - 12 * i + 6 * o, c = -3 * t + 9 * i - 9 * o + 3 * s, d = 3 * i - 3 * t;

          for (var C = 0; C < 2; ++C) {
            if (C > 0 && (h = 6 * n - 12 * r + 6 * a, c = -3 * n + 9 * r - 9 * a + 3 * l, d = 3 * r - 3 * n), b(c) < 1e-12) {
              if (b(h) < 1e-12) continue;
              0 < (f = -d / h) && f < 1 && w.push(f);
            } else (v = h * h - 4 * d * c) < 0 || (0 < (p = (-h + (m = y(v))) / (2 * c)) && p < 1 && w.push(p), 0 < (g = (-h - m) / (2 * c)) && g < 1 && w.push(g));
          }

          for (var k, M, E, A = w.length, I = A; A--;) {
            k = (E = 1 - (f = w[A])) * E * E * t + 3 * E * E * f * i + 3 * E * f * f * o + f * f * f * s, S[0][A] = k, M = E * E * E * n + 3 * E * E * f * r + 3 * E * f * f * a + f * f * f * l, S[1][A] = M;
          }

          S[0][I] = t, S[1][I] = n, S[0][I + 1] = s, S[1][I + 1] = l;
          var P = [{
            x: x.apply(null, S[0]),
            y: x.apply(null, S[1])
          }, {
            x: _.apply(null, S[0]),
            y: _.apply(null, S[1])
          }];
          return T.cachesBoundsOfCurve && (T.boundsOfCurveCache[u] = P), P;
        }

        T.util.drawArc = function (e, n, i, r) {
          for (var o = r[0], a = r[1], s = r[2], l = r[3], u = r[4], c = [[], [], [], []], h = t(r[5] - n, r[6] - i, o, a, l, u, s), d = 0, f = h.length; d < f; d++) {
            c[d][0] = h[d][0] + n, c[d][1] = h[d][1] + i, c[d][2] = h[d][2] + n, c[d][3] = h[d][3] + i, c[d][4] = h[d][4] + n, c[d][5] = h[d][5] + i, e.bezierCurveTo.apply(e, c[d]);
          }
        }, T.util.getBoundsOfArc = function (e, n, i, o, a, s, l, u, c) {
          for (var h, d = 0, f = 0, p = [], g = t(u - e, c - n, i, o, s, l, a), v = 0, m = g.length; v < m; v++) {
            h = r(d, f, g[v][0], g[v][1], g[v][2], g[v][3], g[v][4], g[v][5]), p.push({
              x: h[0].x + e,
              y: h[0].y + n
            }), p.push({
              x: h[1].x + e,
              y: h[1].y + n
            }), d = g[v][4], f = g[v][5];
          }

          return p;
        }, T.util.getBoundsOfCurve = r;
      }(), function () {
        var e = Array.prototype.slice;

        function t(e, t, n) {
          if (e && 0 !== e.length) {
            var i = e.length - 1,
                r = t ? e[i][t] : e[i];
            if (t) for (; i--;) {
              n(e[i][t], r) && (r = e[i][t]);
            } else for (; i--;) {
              n(e[i], r) && (r = e[i]);
            }
            return r;
          }
        }

        T.util.array = {
          fill: function fill(e, t) {
            for (var n = e.length; n--;) {
              e[n] = t;
            }

            return e;
          },
          invoke: function invoke(t, n) {
            for (var i = e.call(arguments, 2), r = [], o = 0, a = t.length; o < a; o++) {
              r[o] = i.length ? t[o][n].apply(t[o], i) : t[o][n].call(t[o]);
            }

            return r;
          },
          min: function min(e, n) {
            return t(e, n, function (e, t) {
              return e < t;
            });
          },
          max: function max(e, n) {
            return t(e, n, function (e, t) {
              return e >= t;
            });
          }
        };
      }(), function () {
        function e(t, n, i) {
          if (i) {
            if (!T.isLikelyNode && n instanceof Element) t = n;else if (n instanceof Array) {
              t = [];

              for (var r = 0, o = n.length; r < o; r++) {
                t[r] = e({}, n[r], i);
              }
            } else if (n && "object" == typeof n) for (var a in n) {
              "canvas" === a ? t[a] = e({}, n[a]) : n.hasOwnProperty(a) && (t[a] = e({}, n[a], i));
            } else t = n;
          } else for (var a in n) {
            t[a] = n[a];
          }
          return t;
        }

        T.util.object = {
          extend: e,
          clone: function clone(t, n) {
            return e({}, t, n);
          }
        }, T.util.object.extend(T.util, T.Observable);
      }(), function () {
        function e(e, t) {
          var n = e.charCodeAt(t);
          if (isNaN(n)) return "";
          if (n < 55296 || n > 57343) return e.charAt(t);

          if (55296 <= n && n <= 56319) {
            if (e.length <= t + 1) throw "High surrogate without following low surrogate";
            var i = e.charCodeAt(t + 1);
            if (56320 > i || i > 57343) throw "High surrogate without following low surrogate";
            return e.charAt(t) + e.charAt(t + 1);
          }

          if (0 === t) throw "Low surrogate without preceding high surrogate";
          var r = e.charCodeAt(t - 1);
          if (55296 > r || r > 56319) throw "Low surrogate without preceding high surrogate";
          return !1;
        }

        T.util.string = {
          camelize: function camelize(e) {
            return e.replace(/-+(.)?/g, function (e, t) {
              return t ? t.toUpperCase() : "";
            });
          },
          capitalize: function capitalize(e, t) {
            return e.charAt(0).toUpperCase() + (t ? e.slice(1) : e.slice(1).toLowerCase());
          },
          escapeXml: function escapeXml(e) {
            return e.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&apos;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
          },
          graphemeSplit: function graphemeSplit(t) {
            var n,
                i = 0,
                r = [];

            for (i = 0; i < t.length; i++) {
              !1 !== (n = e(t, i)) && r.push(n);
            }

            return r;
          }
        };
      }(), function () {
        var e = Array.prototype.slice,
            t = function t() {},
            n = function () {
          for (var e in {
            toString: 1
          }) {
            if ("toString" === e) return !1;
          }

          return !0;
        }(),
            i = function i(e, t, _i2) {
          for (var r in t) {
            r in e.prototype && "function" == typeof e.prototype[r] && (t[r] + "").indexOf("callSuper") > -1 ? e.prototype[r] = function (e) {
              return function () {
                var n = this.constructor.superclass;
                this.constructor.superclass = _i2;
                var r = t[e].apply(this, arguments);
                if (this.constructor.superclass = n, "initialize" !== e) return r;
              };
            }(r) : e.prototype[r] = t[r], n && (t.toString !== Object.prototype.toString && (e.prototype.toString = t.toString), t.valueOf !== Object.prototype.valueOf && (e.prototype.valueOf = t.valueOf));
          }
        };

        function r() {}

        function o(t) {
          for (var n = null, i = this; i.constructor.superclass;) {
            var r = i.constructor.superclass.prototype[t];

            if (i[t] !== r) {
              n = r;
              break;
            }

            i = i.constructor.superclass.prototype;
          }

          return n ? arguments.length > 1 ? n.apply(this, e.call(arguments, 1)) : n.call(this) : console.log("tried to callSuper " + t + ", method not found in prototype chain", this);
        }

        T.util.createClass = function () {
          var n = null,
              a = e.call(arguments, 0);

          function s() {
            this.initialize.apply(this, arguments);
          }

          "function" == typeof a[0] && (n = a.shift()), s.superclass = n, s.subclasses = [], n && (r.prototype = n.prototype, s.prototype = new r(), n.subclasses.push(s));

          for (var l = 0, u = a.length; l < u; l++) {
            i(s, a[l], n);
          }

          return s.prototype.initialize || (s.prototype.initialize = t), s.prototype.constructor = s, s.prototype.callSuper = o, s;
        };
      }(), u = !!T.document.createElement("div").attachEvent, T.util.addListener = function (e, t, n, i) {
        e && e.addEventListener(t, n, !u && i);
      }, T.util.removeListener = function (e, t, n, i) {
        e && e.removeEventListener(t, n, !u && i);
      }, T.util.getPointer = function (e) {
        var t = e.target,
            n = T.util.getScrollLeftTop(t),
            i = function (e) {
          var t = e.changedTouches;
          return t && t[0] ? t[0] : e;
        }(e);

        return {
          x: i.clientX + n.left,
          y: i.clientY + n.top
        };
      }, c = T.document.createElement("div"), h = "string" == typeof c.style.opacity, d = "string" == typeof c.style.filter, f = /alpha\s*\(\s*opacity\s*=\s*([^\)]+)\)/, p = function p(e) {
        return e;
      }, h ? p = function p(e, t) {
        return e.style.opacity = t, e;
      } : d && (p = function p(e, t) {
        var n = e.style;
        return e.currentStyle && !e.currentStyle.hasLayout && (n.zoom = 1), f.test(n.filter) ? (t = t >= .9999 ? "" : "alpha(opacity=" + 100 * t + ")", n.filter = n.filter.replace(f, t)) : n.filter += " alpha(opacity=" + 100 * t + ")", e;
      }), T.util.setStyle = function (e, t) {
        var n = e.style;
        if (!n) return e;
        if ("string" == typeof t) return e.style.cssText += ";" + t, t.indexOf("opacity") > -1 ? p(e, t.match(/opacity:\s*(\d?\.?\d*)/)[1]) : e;

        for (var i in t) {
          "opacity" === i ? p(e, t[i]) : n["float" === i || "cssFloat" === i ? void 0 === n.styleFloat ? "cssFloat" : "styleFloat" : i] = t[i];
        }

        return e;
      }, function () {
        var e = Array.prototype.slice;

        var t,
            n,
            i,
            r,
            o = function o(t) {
          return e.call(t, 0);
        };

        try {
          t = o(T.document.childNodes) instanceof Array;
        } catch (e) {}

        function a(e, t) {
          var n = T.document.createElement(e);

          for (var i in t) {
            "class" === i ? n.className = t[i] : "for" === i ? n.htmlFor = t[i] : n.setAttribute(i, t[i]);
          }

          return n;
        }

        function s(e) {
          for (var t = 0, n = 0, i = T.document.documentElement, r = T.document.body || {
            scrollLeft: 0,
            scrollTop: 0
          }; e && (e.parentNode || e.host) && ((e = e.parentNode || e.host) === T.document ? (t = r.scrollLeft || i.scrollLeft || 0, n = r.scrollTop || i.scrollTop || 0) : (t += e.scrollLeft || 0, n += e.scrollTop || 0), 1 !== e.nodeType || "fixed" !== e.style.position);) {
            ;
          }

          return {
            left: t,
            top: n
          };
        }

        t || (o = function o(e) {
          for (var t = new Array(e.length), n = e.length; n--;) {
            t[n] = e[n];
          }

          return t;
        }), n = T.document.defaultView && T.document.defaultView.getComputedStyle ? function (e, t) {
          var n = T.document.defaultView.getComputedStyle(e, null);
          return n ? n[t] : void 0;
        } : function (e, t) {
          var n = e.style[t];
          return !n && e.currentStyle && (n = e.currentStyle[t]), n;
        }, i = T.document.documentElement.style, r = "userSelect" in i ? "userSelect" : "MozUserSelect" in i ? "MozUserSelect" : "WebkitUserSelect" in i ? "WebkitUserSelect" : "KhtmlUserSelect" in i ? "KhtmlUserSelect" : "", T.util.makeElementUnselectable = function (e) {
          return void 0 !== e.onselectstart && (e.onselectstart = T.util.falseFunction), r ? e.style[r] = "none" : "string" == typeof e.unselectable && (e.unselectable = "on"), e;
        }, T.util.makeElementSelectable = function (e) {
          return void 0 !== e.onselectstart && (e.onselectstart = null), r ? e.style[r] = "" : "string" == typeof e.unselectable && (e.unselectable = ""), e;
        }, T.util.getScript = function (e, t) {
          var n = T.document.getElementsByTagName("head")[0],
              i = T.document.createElement("script"),
              r = !0;
          i.onload = i.onreadystatechange = function (e) {
            if (r) {
              if ("string" == typeof this.readyState && "loaded" !== this.readyState && "complete" !== this.readyState) return;
              r = !1, t(e || T.window.event), i = i.onload = i.onreadystatechange = null;
            }
          }, i.src = e, n.appendChild(i);
        }, T.util.getById = function (e) {
          return "string" == typeof e ? T.document.getElementById(e) : e;
        }, T.util.toArray = o, T.util.makeElement = a, T.util.addClass = function (e, t) {
          e && -1 === (" " + e.className + " ").indexOf(" " + t + " ") && (e.className += (e.className ? " " : "") + t);
        }, T.util.wrapElement = function (e, t, n) {
          return "string" == typeof t && (t = a(t, n)), e.parentNode && e.parentNode.replaceChild(t, e), t.appendChild(e), t;
        }, T.util.getScrollLeftTop = s, T.util.getElementOffset = function (e) {
          var t,
              i,
              r = e && e.ownerDocument,
              o = {
            left: 0,
            top: 0
          },
              a = {
            left: 0,
            top: 0
          },
              l = {
            borderLeftWidth: "left",
            borderTopWidth: "top",
            paddingLeft: "left",
            paddingTop: "top"
          };
          if (!r) return a;

          for (var u in l) {
            a[l[u]] += parseInt(n(e, u), 10) || 0;
          }

          return t = r.documentElement, void 0 !== e.getBoundingClientRect && (o = e.getBoundingClientRect()), i = s(e), {
            left: o.left + i.left - (t.clientLeft || 0) + a.left,
            top: o.top + i.top - (t.clientTop || 0) + a.top
          };
        }, T.util.getElementStyle = n, T.util.getNodeCanvas = function (e) {
          var t = T.jsdomImplForWrapper(e);
          return t._canvas || t._image;
        }, T.util.cleanUpJsdomNode = function (e) {
          if (T.isLikelyNode) {
            var t = T.jsdomImplForWrapper(e);
            t && (t._image = null, t._canvas = null, t._currentSrc = null, t._attributes = null, t._classList = null);
          }
        };
      }(), function () {
        function e() {}

        T.util.request = function (t, n) {
          n || (n = {});

          var i = n.method ? n.method.toUpperCase() : "GET",
              r = n.onComplete || function () {},
              o = new T.window.XMLHttpRequest(),
              a = n.body || n.parameters;

          return o.onreadystatechange = function () {
            4 === o.readyState && (r(o), o.onreadystatechange = e);
          }, "GET" === i && (a = null, "string" == typeof n.parameters && (t = function (e, t) {
            return e + (/\?/.test(e) ? "&" : "?") + t;
          }(t, n.parameters))), o.open(i, t, !0), "POST" !== i && "PUT" !== i || o.setRequestHeader("Content-Type", "application/x-www-form-urlencoded"), o.send(a), o;
        };
      }(), T.log = console.log, T.warn = console.warn, function () {
        function e() {
          return !1;
        }

        function t(e, t, n, i) {
          return -n * Math.cos(e / i * (Math.PI / 2)) + n + t;
        }

        var n = T.window.requestAnimationFrame || T.window.webkitRequestAnimationFrame || T.window.mozRequestAnimationFrame || T.window.oRequestAnimationFrame || T.window.msRequestAnimationFrame || function (e) {
          return T.window.setTimeout(e, 1e3 / 60);
        },
            i = T.window.cancelAnimationFrame || T.window.clearTimeout;

        function r() {
          return n.apply(T.window, arguments);
        }

        T.util.animate = function (n) {
          r(function (i) {
            n || (n = {});
            var o,
                a = i || +new Date(),
                s = n.duration || 500,
                l = a + s,
                u = n.onChange || e,
                c = n.abort || e,
                h = n.onComplete || e,
                d = n.easing || t,
                f = "startValue" in n ? n.startValue : 0,
                p = "endValue" in n ? n.endValue : 100,
                g = n.byValue || p - f;
            n.onStart && n.onStart(), function e(t) {
              var n = (o = t || +new Date()) > l ? s : o - a,
                  i = n / s,
                  v = d(n, f, g, s),
                  m = Math.abs((v - f) / g);
              if (!c()) return o > l ? (u(p, 1, 1), void h(p, 1, 1)) : (u(v, m, i), void r(e));
              h(p, 1, 1);
            }(a);
          });
        }, T.util.requestAnimFrame = r, T.util.cancelAnimFrame = function () {
          return i.apply(T.window, arguments);
        };
      }(), T.util.animateColor = function (e, t, n, i) {
        var r = new T.Color(e).getSource(),
            o = new T.Color(t).getSource();
        i = i || {}, T.util.animate(T.util.object.extend(i, {
          duration: n || 500,
          startValue: r,
          endValue: o,
          byValue: o,
          easing: function easing(e, t, n, r) {
            var o,
                a,
                s,
                l,
                u = i.colorEasing ? i.colorEasing(e, r) : 1 - Math.cos(e / r * (Math.PI / 2));
            return o = t, a = n, s = u, l = "rgba(" + parseInt(o[0] + s * (a[0] - o[0]), 10) + "," + parseInt(o[1] + s * (a[1] - o[1]), 10) + "," + parseInt(o[2] + s * (a[2] - o[2]), 10), l += "," + (o && a ? parseFloat(o[3] + s * (a[3] - o[3])) : 1), l += ")";
          }
        }));
      }, function () {
        function e(e, t, n, i) {
          return e < Math.abs(t) ? (e = t, i = n / 4) : i = 0 === t && 0 === e ? n / (2 * Math.PI) * Math.asin(1) : n / (2 * Math.PI) * Math.asin(t / e), {
            a: e,
            c: t,
            p: n,
            s: i
          };
        }

        function t(e, t, n) {
          return e.a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * n - e.s) * (2 * Math.PI) / e.p);
        }

        function n(e, t, n, r) {
          return n - i(r - e, 0, n, r) + t;
        }

        function i(e, t, n, i) {
          return (e /= i) < 1 / 2.75 ? n * (7.5625 * e * e) + t : e < 2 / 2.75 ? n * (7.5625 * (e -= 1.5 / 2.75) * e + .75) + t : e < 2.5 / 2.75 ? n * (7.5625 * (e -= 2.25 / 2.75) * e + .9375) + t : n * (7.5625 * (e -= 2.625 / 2.75) * e + .984375) + t;
        }

        T.util.ease = {
          easeInQuad: function easeInQuad(e, t, n, i) {
            return n * (e /= i) * e + t;
          },
          easeOutQuad: function easeOutQuad(e, t, n, i) {
            return -n * (e /= i) * (e - 2) + t;
          },
          easeInOutQuad: function easeInOutQuad(e, t, n, i) {
            return (e /= i / 2) < 1 ? n / 2 * e * e + t : -n / 2 * (--e * (e - 2) - 1) + t;
          },
          easeInCubic: function easeInCubic(e, t, n, i) {
            return n * (e /= i) * e * e + t;
          },
          easeOutCubic: function easeOutCubic(e, t, n, i) {
            return n * ((e = e / i - 1) * e * e + 1) + t;
          },
          easeInOutCubic: function easeInOutCubic(e, t, n, i) {
            return (e /= i / 2) < 1 ? n / 2 * e * e * e + t : n / 2 * ((e -= 2) * e * e + 2) + t;
          },
          easeInQuart: function easeInQuart(e, t, n, i) {
            return n * (e /= i) * e * e * e + t;
          },
          easeOutQuart: function easeOutQuart(e, t, n, i) {
            return -n * ((e = e / i - 1) * e * e * e - 1) + t;
          },
          easeInOutQuart: function easeInOutQuart(e, t, n, i) {
            return (e /= i / 2) < 1 ? n / 2 * e * e * e * e + t : -n / 2 * ((e -= 2) * e * e * e - 2) + t;
          },
          easeInQuint: function easeInQuint(e, t, n, i) {
            return n * (e /= i) * e * e * e * e + t;
          },
          easeOutQuint: function easeOutQuint(e, t, n, i) {
            return n * ((e = e / i - 1) * e * e * e * e + 1) + t;
          },
          easeInOutQuint: function easeInOutQuint(e, t, n, i) {
            return (e /= i / 2) < 1 ? n / 2 * e * e * e * e * e + t : n / 2 * ((e -= 2) * e * e * e * e + 2) + t;
          },
          easeInSine: function easeInSine(e, t, n, i) {
            return -n * Math.cos(e / i * (Math.PI / 2)) + n + t;
          },
          easeOutSine: function easeOutSine(e, t, n, i) {
            return n * Math.sin(e / i * (Math.PI / 2)) + t;
          },
          easeInOutSine: function easeInOutSine(e, t, n, i) {
            return -n / 2 * (Math.cos(Math.PI * e / i) - 1) + t;
          },
          easeInExpo: function easeInExpo(e, t, n, i) {
            return 0 === e ? t : n * Math.pow(2, 10 * (e / i - 1)) + t;
          },
          easeOutExpo: function easeOutExpo(e, t, n, i) {
            return e === i ? t + n : n * (1 - Math.pow(2, -10 * e / i)) + t;
          },
          easeInOutExpo: function easeInOutExpo(e, t, n, i) {
            return 0 === e ? t : e === i ? t + n : (e /= i / 2) < 1 ? n / 2 * Math.pow(2, 10 * (e - 1)) + t : n / 2 * (2 - Math.pow(2, -10 * --e)) + t;
          },
          easeInCirc: function easeInCirc(e, t, n, i) {
            return -n * (Math.sqrt(1 - (e /= i) * e) - 1) + t;
          },
          easeOutCirc: function easeOutCirc(e, t, n, i) {
            return n * Math.sqrt(1 - (e = e / i - 1) * e) + t;
          },
          easeInOutCirc: function easeInOutCirc(e, t, n, i) {
            return (e /= i / 2) < 1 ? -n / 2 * (Math.sqrt(1 - e * e) - 1) + t : n / 2 * (Math.sqrt(1 - (e -= 2) * e) + 1) + t;
          },
          easeInElastic: function easeInElastic(n, i, r, o) {
            var a = 0;
            return 0 === n ? i : 1 === (n /= o) ? i + r : (a || (a = .3 * o), -t(e(r, r, a, 1.70158), n, o) + i);
          },
          easeOutElastic: function easeOutElastic(t, n, i, r) {
            var o = 0;
            if (0 === t) return n;
            if (1 === (t /= r)) return n + i;
            o || (o = .3 * r);
            var a = e(i, i, o, 1.70158);
            return a.a * Math.pow(2, -10 * t) * Math.sin((t * r - a.s) * (2 * Math.PI) / a.p) + a.c + n;
          },
          easeInOutElastic: function easeInOutElastic(n, i, r, o) {
            var a = 0;
            if (0 === n) return i;
            if (2 === (n /= o / 2)) return i + r;
            a || (a = o * (.3 * 1.5));
            var s = e(r, r, a, 1.70158);
            return n < 1 ? -.5 * t(s, n, o) + i : s.a * Math.pow(2, -10 * (n -= 1)) * Math.sin((n * o - s.s) * (2 * Math.PI) / s.p) * .5 + s.c + i;
          },
          easeInBack: function easeInBack(e, t, n, i, r) {
            return void 0 === r && (r = 1.70158), n * (e /= i) * e * ((r + 1) * e - r) + t;
          },
          easeOutBack: function easeOutBack(e, t, n, i, r) {
            return void 0 === r && (r = 1.70158), n * ((e = e / i - 1) * e * ((r + 1) * e + r) + 1) + t;
          },
          easeInOutBack: function easeInOutBack(e, t, n, i, r) {
            return void 0 === r && (r = 1.70158), (e /= i / 2) < 1 ? n / 2 * (e * e * ((1 + (r *= 1.525)) * e - r)) + t : n / 2 * ((e -= 2) * e * ((1 + (r *= 1.525)) * e + r) + 2) + t;
          },
          easeInBounce: n,
          easeOutBounce: i,
          easeInOutBounce: function easeInOutBounce(e, t, r, o) {
            return e < o / 2 ? .5 * n(2 * e, 0, r, o) + t : .5 * i(2 * e - o, 0, r, o) + .5 * r + t;
          }
        };
      }(), function (e) {
        "use strict";

        var t = e.fabric || (e.fabric = {}),
            n = t.util.object.extend,
            i = t.util.object.clone,
            r = t.util.toFixed,
            o = t.util.parseUnit,
            a = t.util.multiplyTransformMatrices,
            s = {
          cx: "left",
          x: "left",
          r: "radius",
          cy: "top",
          y: "top",
          display: "visible",
          visibility: "visible",
          transform: "transformMatrix",
          "fill-opacity": "fillOpacity",
          "fill-rule": "fillRule",
          "font-family": "fontFamily",
          "font-size": "fontSize",
          "font-style": "fontStyle",
          "font-weight": "fontWeight",
          "letter-spacing": "charSpacing",
          "paint-order": "paintFirst",
          "stroke-dasharray": "strokeDashArray",
          "stroke-dashoffset": "strokeDashOffset",
          "stroke-linecap": "strokeLineCap",
          "stroke-linejoin": "strokeLineJoin",
          "stroke-miterlimit": "strokeMiterLimit",
          "stroke-opacity": "strokeOpacity",
          "stroke-width": "strokeWidth",
          "text-decoration": "textDecoration",
          "text-anchor": "textAnchor",
          opacity: "opacity",
          "clip-path": "clipPath",
          "clip-rule": "clipRule",
          "vector-effect": "strokeUniform"
        },
            l = {
          stroke: "strokeOpacity",
          fill: "fillOpacity"
        };

        function u(e) {
          return e in s ? s[e] : e;
        }

        function c(e, n, i, r) {
          var s,
              l = "[object Array]" === Object.prototype.toString.call(n);
          if ("fill" !== e && "stroke" !== e || "none" !== n) {
            if ("vector-effect" === e) n = "non-scaling-stroke" === n;else if ("strokeDashArray" === e) n = "none" === n ? null : n.replace(/,/g, " ").split(/\s+/).map(parseFloat);else if ("transformMatrix" === e) n = i && i.transformMatrix ? a(i.transformMatrix, t.parseTransformAttribute(n)) : t.parseTransformAttribute(n);else if ("visible" === e) n = "none" !== n && "hidden" !== n, i && !1 === i.visible && (n = !1);else if ("opacity" === e) n = parseFloat(n), i && void 0 !== i.opacity && (n *= i.opacity);else if ("textAnchor" === e) n = "start" === n ? "left" : "end" === n ? "right" : "center";else if ("charSpacing" === e) s = o(n, r) / r * 1e3;else if ("paintFirst" === e) {
              var u = n.indexOf("fill"),
                  c = n.indexOf("stroke");
              n = "fill";
              (u > -1 && c > -1 && c < u || -1 === u && c > -1) && (n = "stroke");
            } else {
              if ("href" === e || "xlink:href" === e) return n;
              s = l ? n.map(o) : o(n, r);
            }
          } else n = "";
          return !l && isNaN(s) ? n : s;
        }

        function h(e) {
          return new RegExp("^(" + e.join("|") + ")\\b", "i");
        }

        function d(e, t) {
          var n,
              i,
              r,
              o,
              a = [];

          for (r = 0, o = t.length; r < o; r++) {
            n = t[r], i = e.getElementsByTagName(n), a = a.concat(Array.prototype.slice.call(i));
          }

          return a;
        }

        function f(e, t) {
          var n,
              i = !0;
          return (n = p(e, t.pop())) && t.length && (i = function (e, t) {
            var n,
                i = !0;

            for (; e.parentNode && 1 === e.parentNode.nodeType && t.length;) {
              i && (n = t.pop()), e = e.parentNode, i = p(e, n);
            }

            return 0 === t.length;
          }(e, t)), n && i && 0 === t.length;
        }

        function p(e, t) {
          var n,
              i,
              r = e.nodeName,
              o = e.getAttribute("class"),
              a = e.getAttribute("id");
          if (n = new RegExp("^" + r, "i"), t = t.replace(n, ""), a && t.length && (n = new RegExp("#" + a + "(?![a-zA-Z\\-]+)", "i"), t = t.replace(n, "")), o && t.length) for (i = (o = o.split(" ")).length; i--;) {
            n = new RegExp("\\." + o[i] + "(?![a-zA-Z\\-]+)", "i"), t = t.replace(n, "");
          }
          return 0 === t.length;
        }

        function g(e, t) {
          var n;
          if (e.getElementById && (n = e.getElementById(t)), n) return n;
          var i,
              r,
              o,
              a = e.getElementsByTagName("*");

          for (r = 0, o = a.length; r < o; r++) {
            if (t === (i = a[r]).getAttribute("id")) return i;
          }
        }

        t.svgValidTagNamesRegEx = h(["path", "circle", "polygon", "polyline", "ellipse", "rect", "line", "image", "text"]), t.svgViewBoxElementsRegEx = h(["symbol", "image", "marker", "pattern", "view", "svg"]), t.svgInvalidAncestorsRegEx = h(["pattern", "defs", "symbol", "metadata", "clipPath", "mask", "desc"]), t.svgValidParentsRegEx = h(["symbol", "g", "a", "svg", "clipPath", "defs"]), t.cssRules = {}, t.gradientDefs = {}, t.clipPaths = {}, t.parseTransformAttribute = function () {
          function e(e, n, i) {
            e[i] = Math.tan(t.util.degreesToRadians(n[0]));
          }

          var n = t.iMatrix,
              i = t.reNum,
              r = "(?:\\s+,?\\s*|,\\s*)",
              o = "(?:" + ("(?:(matrix)\\s*\\(\\s*(" + i + ")" + r + "(" + i + ")" + r + "(" + i + ")" + r + "(" + i + ")" + r + "(" + i + ")" + r + "(" + i + ")\\s*\\))") + "|" + ("(?:(translate)\\s*\\(\\s*(" + i + ")(?:" + r + "(" + i + "))?\\s*\\))") + "|" + ("(?:(scale)\\s*\\(\\s*(" + i + ")(?:" + r + "(" + i + "))?\\s*\\))") + "|" + ("(?:(rotate)\\s*\\(\\s*(" + i + ")(?:" + r + "(" + i + ")" + r + "(" + i + "))?\\s*\\))") + "|" + ("(?:(skewX)\\s*\\(\\s*(" + i + ")\\s*\\))") + "|" + ("(?:(skewY)\\s*\\(\\s*(" + i + ")\\s*\\))") + ")",
              a = new RegExp("^\\s*(?:" + ("(?:" + o + "(?:" + r + "*" + o + ")*)") + "?)\\s*$"),
              s = new RegExp(o, "g");
          return function (i) {
            var r = n.concat(),
                l = [];
            if (!i || i && !a.test(i)) return r;
            i.replace(s, function (i) {
              var a = new RegExp(o).exec(i).filter(function (e) {
                return !!e;
              }),
                  s = a[1],
                  u = a.slice(2).map(parseFloat);

              switch (s) {
                case "translate":
                  !function (e, t) {
                    e[4] = t[0], 2 === t.length && (e[5] = t[1]);
                  }(r, u);
                  break;

                case "rotate":
                  u[0] = t.util.degreesToRadians(u[0]), function (e, n) {
                    var i = t.util.cos(n[0]),
                        r = t.util.sin(n[0]),
                        o = 0,
                        a = 0;
                    3 === n.length && (o = n[1], a = n[2]), e[0] = i, e[1] = r, e[2] = -r, e[3] = i, e[4] = o - (i * o - r * a), e[5] = a - (r * o + i * a);
                  }(r, u);
                  break;

                case "scale":
                  !function (e, t) {
                    var n = t[0],
                        i = 2 === t.length ? t[1] : t[0];
                    e[0] = n, e[3] = i;
                  }(r, u);
                  break;

                case "skewX":
                  e(r, u, 2);
                  break;

                case "skewY":
                  e(r, u, 1);
                  break;

                case "matrix":
                  r = u;
              }

              l.push(r.concat()), r = n.concat();
            });

            for (var u = l[0]; l.length > 1;) {
              l.shift(), u = t.util.multiplyTransformMatrices(u, l[0]);
            }

            return u;
          };
        }();
        var v = new RegExp("^\\s*(" + t.reNum + "+)\\s*,?\\s*(" + t.reNum + "+)\\s*,?\\s*(" + t.reNum + "+)\\s*,?\\s*(" + t.reNum + "+)\\s*$");

        function m(e) {
          var n,
              i,
              r,
              a,
              s,
              l,
              u = e.getAttribute("viewBox"),
              c = 1,
              h = 1,
              d = e.getAttribute("width"),
              f = e.getAttribute("height"),
              p = e.getAttribute("x") || 0,
              g = e.getAttribute("y") || 0,
              m = e.getAttribute("preserveAspectRatio") || "",
              y = !u || !t.svgViewBoxElementsRegEx.test(e.nodeName) || !(u = u.match(v)),
              x = !d || !f || "100%" === d || "100%" === f,
              _ = y && x,
              b = {},
              w = "",
              S = 0,
              T = 0;

          if (b.width = 0, b.height = 0, b.toBeParsed = _, _) return b;
          if (y) return b.width = o(d), b.height = o(f), b;
          if (n = -parseFloat(u[1]), i = -parseFloat(u[2]), r = parseFloat(u[3]), a = parseFloat(u[4]), b.minX = n, b.minY = i, b.viewBoxWidth = r, b.viewBoxHeight = a, x ? (b.width = r, b.height = a) : (b.width = o(d), b.height = o(f), c = b.width / r, h = b.height / a), "none" !== (m = t.util.parsePreserveAspectRatioAttribute(m)).alignX && ("meet" === m.meetOrSlice && (h = c = c > h ? h : c), "slice" === m.meetOrSlice && (h = c = c > h ? c : h), S = b.width - r * c, T = b.height - a * c, "Mid" === m.alignX && (S /= 2), "Mid" === m.alignY && (T /= 2), "Min" === m.alignX && (S = 0), "Min" === m.alignY && (T = 0)), 1 === c && 1 === h && 0 === n && 0 === i && 0 === p && 0 === g) return b;

          if ((p || g) && (w = " translate(" + o(p) + " " + o(g) + ") "), s = w + " matrix(" + c + " 0 0 " + h + " " + (n * c + S) + " " + (i * h + T) + ") ", b.viewboxTransform = t.parseTransformAttribute(s), "svg" === e.nodeName) {
            for (l = e.ownerDocument.createElementNS(t.svgNS, "g"); e.firstChild;) {
              l.appendChild(e.firstChild);
            }

            e.appendChild(l);
          } else s = (l = e).getAttribute("transform") + s;

          return l.setAttribute("transform", s), b;
        }

        function y(e, t) {
          var n = g(e, t.getAttribute("xlink:href").substr(1));
          if (n && n.getAttribute("xlink:href") && y(e, n), ["gradientTransform", "x1", "x2", "y1", "y2", "gradientUnits", "cx", "cy", "r", "fx", "fy"].forEach(function (e) {
            n && !t.hasAttribute(e) && n.hasAttribute(e) && t.setAttribute(e, n.getAttribute(e));
          }), !t.children.length) for (var i = n.cloneNode(!0); i.firstChild;) {
            t.appendChild(i.firstChild);
          }
          t.removeAttribute("xlink:href");
        }

        t.parseSVGDocument = function (e, n, r, o) {
          if (e) {
            !function (e) {
              for (var n = d(e, ["use", "svg:use"]), i = 0; n.length && i < n.length;) {
                var r,
                    o,
                    a,
                    s,
                    l = n[i],
                    u = (l.getAttribute("xlink:href") || l.getAttribute("href")).substr(1),
                    c = l.getAttribute("x") || 0,
                    h = l.getAttribute("y") || 0,
                    f = g(e, u).cloneNode(!0),
                    p = (f.getAttribute("transform") || "") + " translate(" + c + ", " + h + ")",
                    v = n.length,
                    y = t.svgNS;

                if (m(f), /^svg$/i.test(f.nodeName)) {
                  var x = f.ownerDocument.createElementNS(y, "g");

                  for (o = 0, s = (a = f.attributes).length; o < s; o++) {
                    r = a.item(o), x.setAttributeNS(y, r.nodeName, r.nodeValue);
                  }

                  for (; f.firstChild;) {
                    x.appendChild(f.firstChild);
                  }

                  f = x;
                }

                for (o = 0, s = (a = l.attributes).length; o < s; o++) {
                  "x" !== (r = a.item(o)).nodeName && "y" !== r.nodeName && "xlink:href" !== r.nodeName && "href" !== r.nodeName && ("transform" === r.nodeName ? p = r.nodeValue + " " + p : f.setAttribute(r.nodeName, r.nodeValue));
                }

                f.setAttribute("transform", p), f.setAttribute("instantiated_by_use", "1"), f.removeAttribute("id"), l.parentNode.replaceChild(f, l), n.length === v && i++;
              }
            }(e);
            var a,
                s,
                l = t.Object.__uid++,
                u = m(e),
                c = t.util.toArray(e.getElementsByTagName("*"));

            if (u.crossOrigin = o && o.crossOrigin, u.svgUid = l, 0 === c.length && t.isLikelyNode) {
              var h = [];

              for (a = 0, s = (c = e.selectNodes('//*[name(.)!="svg"]')).length; a < s; a++) {
                h[a] = c[a];
              }

              c = h;
            }

            var f = c.filter(function (e) {
              return m(e), t.svgValidTagNamesRegEx.test(e.nodeName.replace("svg:", "")) && !function (e, t) {
                for (; e && (e = e.parentNode);) {
                  if (e.nodeName && t.test(e.nodeName.replace("svg:", "")) && !e.getAttribute("instantiated_by_use")) return !0;
                }

                return !1;
              }(e, t.svgInvalidAncestorsRegEx);
            });
            if (!f || f && !f.length) n && n([], {});else {
              var p = {};
              c.filter(function (e) {
                return "clipPath" === e.nodeName.replace("svg:", "");
              }).forEach(function (e) {
                var n = e.getAttribute("id");
                p[n] = t.util.toArray(e.getElementsByTagName("*")).filter(function (e) {
                  return t.svgValidTagNamesRegEx.test(e.nodeName.replace("svg:", ""));
                });
              }), t.gradientDefs[l] = t.getGradientDefs(e), t.cssRules[l] = t.getCSSRules(e), t.clipPaths[l] = p, t.parseElements(f, function (e, i) {
                n && (n(e, u, i, c), delete t.gradientDefs[l], delete t.cssRules[l], delete t.clipPaths[l]);
              }, i(u), r, o);
            }
          }
        };

        var x = new RegExp("(normal|italic)?\\s*(normal|small-caps)?\\s*(normal|bold|bolder|lighter|100|200|300|400|500|600|700|800|900)?\\s*(" + t.reNum + "(?:px|cm|mm|em|pt|pc|in)*)(?:\\/(normal|" + t.reNum + "))?\\s+(.*)");
        n(t, {
          parseFontDeclaration: function parseFontDeclaration(e, t) {
            var n = e.match(x);

            if (n) {
              var i = n[1],
                  r = n[3],
                  a = n[4],
                  s = n[5],
                  l = n[6];
              i && (t.fontStyle = i), r && (t.fontWeight = isNaN(parseFloat(r)) ? r : parseFloat(r)), a && (t.fontSize = o(a)), l && (t.fontFamily = l), s && (t.lineHeight = "normal" === s ? 1 : s);
            }
          },
          getGradientDefs: function getGradientDefs(e) {
            var t,
                n = d(e, ["linearGradient", "radialGradient", "svg:linearGradient", "svg:radialGradient"]),
                i = 0,
                r = {};

            for (i = n.length; i--;) {
              (t = n[i]).getAttribute("xlink:href") && y(e, t), r[t.getAttribute("id")] = t;
            }

            return r;
          },
          parseAttributes: function parseAttributes(e, i, a) {
            if (e) {
              var s,
                  h,
                  d,
                  p = {};
              void 0 === a && (a = e.getAttribute("svgUid")), e.parentNode && t.svgValidParentsRegEx.test(e.parentNode.nodeName) && (p = t.parseAttributes(e.parentNode, i, a));
              var g = i.reduce(function (t, n) {
                return (s = e.getAttribute(n)) && (t[n] = s), t;
              }, {}),
                  v = n(function (e, n) {
                var i = {};

                for (var r in t.cssRules[n]) {
                  if (f(e, r.split(" "))) for (var o in t.cssRules[n][r]) {
                    i[o] = t.cssRules[n][r][o];
                  }
                }

                return i;
              }(e, a), t.parseStyleAttribute(e));
              g = n(g, v), v["clip-path"] && e.setAttribute("clip-path", v["clip-path"]), h = d = p.fontSize || t.Text.DEFAULT_SVG_FONT_SIZE, g["font-size"] && (g["font-size"] = h = o(g["font-size"], d));
              var m,
                  y,
                  x = {};

              for (var _ in g) {
                y = c(m = u(_), g[_], p, h), x[m] = y;
              }

              x && x.font && t.parseFontDeclaration(x.font, x);
              var b = n(p, x);
              return t.svgValidParentsRegEx.test(e.nodeName) ? b : function (e) {
                for (var n in l) {
                  if (void 0 !== e[l[n]] && "" !== e[n]) {
                    if (void 0 === e[n]) {
                      if (!t.Object.prototype[n]) continue;
                      e[n] = t.Object.prototype[n];
                    }

                    if (0 !== e[n].indexOf("url(")) {
                      var i = new t.Color(e[n]);
                      e[n] = i.setAlpha(r(i.getAlpha() * e[l[n]], 2)).toRgba();
                    }
                  }
                }

                return e;
              }(b);
            }
          },
          parseElements: function parseElements(e, n, i, r, o) {
            new t.ElementsParser(e, n, i, r, o).parse();
          },
          parseStyleAttribute: function parseStyleAttribute(e) {
            var t = {},
                n = e.getAttribute("style");
            return n ? ("string" == typeof n ? function (e, t) {
              var n, i;
              e.replace(/;\s*$/, "").split(";").forEach(function (e) {
                var r = e.split(":");
                n = r[0].trim().toLowerCase(), i = r[1].trim(), t[n] = i;
              });
            }(n, t) : function (e, t) {
              var n, i;

              for (var r in e) {
                void 0 !== e[r] && (n = r.toLowerCase(), i = e[r], t[n] = i);
              }
            }(n, t), t) : t;
          },
          parsePointsAttribute: function parsePointsAttribute(e) {
            if (!e) return null;
            var t,
                n,
                i = [];

            for (t = 0, n = (e = (e = e.replace(/,/g, " ").trim()).split(/\s+/)).length; t < n; t += 2) {
              i.push({
                x: parseFloat(e[t]),
                y: parseFloat(e[t + 1])
              });
            }

            return i;
          },
          getCSSRules: function getCSSRules(e) {
            var n,
                i,
                r = e.getElementsByTagName("style"),
                o = {};

            for (n = 0, i = r.length; n < i; n++) {
              var a = r[n].textContent || "";
              "" !== (a = a.replace(/\/\*[\s\S]*?\*\//g, "")).trim() && a.match(/[^{]*\{[\s\S]*?\}/g).map(function (e) {
                return e.trim();
              }).forEach(function (e) {
                var r = e.match(/([\s\S]*?)\s*\{([^}]*)\}/),
                    a = {},
                    s = r[2].trim().replace(/;$/, "").split(/\s*;\s*/);

                for (n = 0, i = s.length; n < i; n++) {
                  var l = s[n].split(/\s*:\s*/),
                      u = l[0],
                      c = l[1];
                  a[u] = c;
                }

                (e = r[1]).split(",").forEach(function (e) {
                  "" !== (e = e.replace(/^svg/i, "").trim()) && (o[e] ? t.util.object.extend(o[e], a) : o[e] = t.util.object.clone(a));
                });
              });
            }

            return o;
          },
          loadSVGFromURL: function loadSVGFromURL(e, n, i, r) {
            e = e.replace(/^\n\s*/, "").trim(), new t.util.request(e, {
              method: "get",
              onComplete: function onComplete(e) {
                var o = e.responseXML;
                o && !o.documentElement && t.window.ActiveXObject && e.responseText && ((o = new ActiveXObject("Microsoft.XMLDOM")).async = "false", o.loadXML(e.responseText.replace(/<!DOCTYPE[\s\S]*?(\[[\s\S]*\])*?>/i, "")));
                if (!o || !o.documentElement) return n && n(null), !1;
                t.parseSVGDocument(o.documentElement, function (e, t, i, r) {
                  n && n(e, t, i, r);
                }, i, r);
              }
            });
          },
          loadSVGFromString: function loadSVGFromString(e, n, i, r) {
            var o;

            if (e = e.trim(), void 0 !== t.window.DOMParser) {
              var a = new t.window.DOMParser();
              a && a.parseFromString && (o = a.parseFromString(e, "text/xml"));
            } else t.window.ActiveXObject && ((o = new ActiveXObject("Microsoft.XMLDOM")).async = "false", o.loadXML(e.replace(/<!DOCTYPE[\s\S]*?(\[[\s\S]*\])*?>/i, "")));

            t.parseSVGDocument(o.documentElement, function (e, t, i, r) {
              n(e, t, i, r);
            }, i, r);
          }
        });
      }(t), T.ElementsParser = function (e, t, n, i, r, o) {
        this.elements = e, this.callback = t, this.options = n, this.reviver = i, this.svgUid = n && n.svgUid || 0, this.parsingOptions = r, this.regexUrl = /^url\(['"]?#([^'"]+)['"]?\)/g, this.doc = o;
      }, (g = T.ElementsParser.prototype).parse = function () {
        this.instances = new Array(this.elements.length), this.numElements = this.elements.length, this.createObjects();
      }, g.createObjects = function () {
        var e = this;
        this.elements.forEach(function (t, n) {
          t.setAttribute("svgUid", e.svgUid), e.createObject(t, n);
        });
      }, g.findTag = function (e) {
        return T[T.util.string.capitalize(e.tagName.replace("svg:", ""))];
      }, g.createObject = function (e, t) {
        var n = this.findTag(e);
        if (n && n.fromElement) try {
          n.fromElement(e, this.createCallback(t, e), this.options);
        } catch (e) {
          T.log(e);
        } else this.checkIfDone();
      }, g.createCallback = function (e, t) {
        var n = this;
        return function (i) {
          var r;
          n.resolveGradient(i, t, "fill"), n.resolveGradient(i, t, "stroke"), i instanceof T.Image && i._originalElement && (r = i.parsePreserveAspectRatioAttribute(t)), i._removeTransformMatrix(r), n.resolveClipPath(i, t), n.reviver && n.reviver(t, i), n.instances[e] = i, n.checkIfDone();
        };
      }, g.extractPropertyDefinition = function (e, t, n) {
        var i = e[t],
            r = this.regexUrl;

        if (r.test(i)) {
          r.lastIndex = 0;
          var o = r.exec(i)[1];
          return r.lastIndex = 0, T[n][this.svgUid][o];
        }
      }, g.resolveGradient = function (e, t, n) {
        var i = this.extractPropertyDefinition(e, n, "gradientDefs");

        if (i) {
          var r = t.getAttribute(n + "-opacity"),
              o = T.Gradient.fromElement(i, e, r, this.options);
          e.set(n, o);
        }
      }, g.createClipPathCallback = function (e, t) {
        return function (e) {
          e._removeTransformMatrix(), e.fillRule = e.clipRule, t.push(e);
        };
      }, g.resolveClipPath = function (e, t) {
        var n,
            i,
            r,
            o,
            a = this.extractPropertyDefinition(e, "clipPath", "clipPaths");

        if (a) {
          r = [], i = T.util.invertTransform(e.calcTransformMatrix());

          for (var s = a[0].parentNode, l = t; l.parentNode && l.getAttribute("clip-path") !== e.clipPath;) {
            l = l.parentNode;
          }

          l.parentNode.appendChild(s);

          for (var u = 0; u < a.length; u++) {
            n = a[u], this.findTag(n).fromElement(n, this.createClipPathCallback(e, r), this.options);
          }

          a = 1 === r.length ? r[0] : new T.Group(r), o = T.util.multiplyTransformMatrices(i, a.calcTransformMatrix()), a.clipPath && this.resolveClipPath(a, l);
          var c = T.util.qrDecompose(o);
          a.flipX = !1, a.flipY = !1, a.set("scaleX", c.scaleX), a.set("scaleY", c.scaleY), a.angle = c.angle, a.skewX = c.skewX, a.skewY = 0, a.setPositionByOrigin({
            x: c.translateX,
            y: c.translateY
          }, "center", "center"), e.clipPath = a;
        } else delete e.clipPath;
      }, g.checkIfDone = function () {
        0 == --this.numElements && (this.instances = this.instances.filter(function (e) {
          return null != e;
        }), this.callback(this.instances, this.elements));
      }, function (e) {
        "use strict";

        var t = e.fabric || (e.fabric = {});

        function n(e, t) {
          this.x = e, this.y = t;
        }

        t.Point ? t.warn("fabric.Point is already defined") : (t.Point = n, n.prototype = {
          type: "point",
          constructor: n,
          add: function add(e) {
            return new n(this.x + e.x, this.y + e.y);
          },
          addEquals: function addEquals(e) {
            return this.x += e.x, this.y += e.y, this;
          },
          scalarAdd: function scalarAdd(e) {
            return new n(this.x + e, this.y + e);
          },
          scalarAddEquals: function scalarAddEquals(e) {
            return this.x += e, this.y += e, this;
          },
          subtract: function subtract(e) {
            return new n(this.x - e.x, this.y - e.y);
          },
          subtractEquals: function subtractEquals(e) {
            return this.x -= e.x, this.y -= e.y, this;
          },
          scalarSubtract: function scalarSubtract(e) {
            return new n(this.x - e, this.y - e);
          },
          scalarSubtractEquals: function scalarSubtractEquals(e) {
            return this.x -= e, this.y -= e, this;
          },
          multiply: function multiply(e) {
            return new n(this.x * e, this.y * e);
          },
          multiplyEquals: function multiplyEquals(e) {
            return this.x *= e, this.y *= e, this;
          },
          divide: function divide(e) {
            return new n(this.x / e, this.y / e);
          },
          divideEquals: function divideEquals(e) {
            return this.x /= e, this.y /= e, this;
          },
          eq: function eq(e) {
            return this.x === e.x && this.y === e.y;
          },
          lt: function lt(e) {
            return this.x < e.x && this.y < e.y;
          },
          lte: function lte(e) {
            return this.x <= e.x && this.y <= e.y;
          },
          gt: function gt(e) {
            return this.x > e.x && this.y > e.y;
          },
          gte: function gte(e) {
            return this.x >= e.x && this.y >= e.y;
          },
          lerp: function lerp(e, t) {
            return void 0 === t && (t = .5), t = Math.max(Math.min(1, t), 0), new n(this.x + (e.x - this.x) * t, this.y + (e.y - this.y) * t);
          },
          distanceFrom: function distanceFrom(e) {
            var t = this.x - e.x,
                n = this.y - e.y;
            return Math.sqrt(t * t + n * n);
          },
          midPointFrom: function midPointFrom(e) {
            return this.lerp(e);
          },
          min: function min(e) {
            return new n(Math.min(this.x, e.x), Math.min(this.y, e.y));
          },
          max: function max(e) {
            return new n(Math.max(this.x, e.x), Math.max(this.y, e.y));
          },
          toString: function toString() {
            return this.x + "," + this.y;
          },
          setXY: function setXY(e, t) {
            return this.x = e, this.y = t, this;
          },
          setX: function setX(e) {
            return this.x = e, this;
          },
          setY: function setY(e) {
            return this.y = e, this;
          },
          setFromPoint: function setFromPoint(e) {
            return this.x = e.x, this.y = e.y, this;
          },
          swap: function swap(e) {
            var t = this.x,
                n = this.y;
            this.x = e.x, this.y = e.y, e.x = t, e.y = n;
          },
          clone: function clone() {
            return new n(this.x, this.y);
          }
        });
      }(t), function (e) {
        "use strict";

        var t = e.fabric || (e.fabric = {});

        function n(e) {
          this.status = e, this.points = [];
        }

        t.Intersection ? t.warn("fabric.Intersection is already defined") : (t.Intersection = n, t.Intersection.prototype = {
          constructor: n,
          appendPoint: function appendPoint(e) {
            return this.points.push(e), this;
          },
          appendPoints: function appendPoints(e) {
            return this.points = this.points.concat(e), this;
          }
        }, t.Intersection.intersectLineLine = function (e, i, r, o) {
          var a,
              s = (o.x - r.x) * (e.y - r.y) - (o.y - r.y) * (e.x - r.x),
              l = (i.x - e.x) * (e.y - r.y) - (i.y - e.y) * (e.x - r.x),
              u = (o.y - r.y) * (i.x - e.x) - (o.x - r.x) * (i.y - e.y);

          if (0 !== u) {
            var c = s / u,
                h = l / u;
            0 <= c && c <= 1 && 0 <= h && h <= 1 ? (a = new n("Intersection")).appendPoint(new t.Point(e.x + c * (i.x - e.x), e.y + c * (i.y - e.y))) : a = new n();
          } else a = new n(0 === s || 0 === l ? "Coincident" : "Parallel");

          return a;
        }, t.Intersection.intersectLinePolygon = function (e, t, i) {
          var r,
              o,
              a,
              s,
              l = new n(),
              u = i.length;

          for (s = 0; s < u; s++) {
            r = i[s], o = i[(s + 1) % u], a = n.intersectLineLine(e, t, r, o), l.appendPoints(a.points);
          }

          return l.points.length > 0 && (l.status = "Intersection"), l;
        }, t.Intersection.intersectPolygonPolygon = function (e, t) {
          var i,
              r = new n(),
              o = e.length;

          for (i = 0; i < o; i++) {
            var a = e[i],
                s = e[(i + 1) % o],
                l = n.intersectLinePolygon(a, s, t);
            r.appendPoints(l.points);
          }

          return r.points.length > 0 && (r.status = "Intersection"), r;
        }, t.Intersection.intersectPolygonRectangle = function (e, i, r) {
          var o = i.min(r),
              a = i.max(r),
              s = new t.Point(a.x, o.y),
              l = new t.Point(o.x, a.y),
              u = n.intersectLinePolygon(o, s, e),
              c = n.intersectLinePolygon(s, a, e),
              h = n.intersectLinePolygon(a, l, e),
              d = n.intersectLinePolygon(l, o, e),
              f = new n();
          return f.appendPoints(u.points), f.appendPoints(c.points), f.appendPoints(h.points), f.appendPoints(d.points), f.points.length > 0 && (f.status = "Intersection"), f;
        });
      }(t), function (e) {
        "use strict";

        var t = e.fabric || (e.fabric = {});

        function n(e) {
          e ? this._tryParsingColor(e) : this.setSource([0, 0, 0, 1]);
        }

        function i(e, t, n) {
          return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + 6 * (t - e) * n : n < .5 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
        }

        t.Color ? t.warn("fabric.Color is already defined.") : (t.Color = n, t.Color.prototype = {
          _tryParsingColor: function _tryParsingColor(e) {
            var t;
            e in n.colorNameMap && (e = n.colorNameMap[e]), "transparent" === e && (t = [255, 255, 255, 0]), t || (t = n.sourceFromHex(e)), t || (t = n.sourceFromRgb(e)), t || (t = n.sourceFromHsl(e)), t || (t = [0, 0, 0, 1]), t && this.setSource(t);
          },
          _rgbToHsl: function _rgbToHsl(e, n, i) {
            e /= 255, n /= 255, i /= 255;
            var r,
                o,
                a,
                s = t.util.array.max([e, n, i]),
                l = t.util.array.min([e, n, i]);
            if (a = (s + l) / 2, s === l) r = o = 0;else {
              var u = s - l;

              switch (o = a > .5 ? u / (2 - s - l) : u / (s + l), s) {
                case e:
                  r = (n - i) / u + (n < i ? 6 : 0);
                  break;

                case n:
                  r = (i - e) / u + 2;
                  break;

                case i:
                  r = (e - n) / u + 4;
              }

              r /= 6;
            }
            return [Math.round(360 * r), Math.round(100 * o), Math.round(100 * a)];
          },
          getSource: function getSource() {
            return this._source;
          },
          setSource: function setSource(e) {
            this._source = e;
          },
          toRgb: function toRgb() {
            var e = this.getSource();
            return "rgb(" + e[0] + "," + e[1] + "," + e[2] + ")";
          },
          toRgba: function toRgba() {
            var e = this.getSource();
            return "rgba(" + e[0] + "," + e[1] + "," + e[2] + "," + e[3] + ")";
          },
          toHsl: function toHsl() {
            var e = this.getSource(),
                t = this._rgbToHsl(e[0], e[1], e[2]);

            return "hsl(" + t[0] + "," + t[1] + "%," + t[2] + "%)";
          },
          toHsla: function toHsla() {
            var e = this.getSource(),
                t = this._rgbToHsl(e[0], e[1], e[2]);

            return "hsla(" + t[0] + "," + t[1] + "%," + t[2] + "%," + e[3] + ")";
          },
          toHex: function toHex() {
            var e,
                t,
                n,
                i = this.getSource();
            return e = 1 === (e = i[0].toString(16)).length ? "0" + e : e, t = 1 === (t = i[1].toString(16)).length ? "0" + t : t, n = 1 === (n = i[2].toString(16)).length ? "0" + n : n, e.toUpperCase() + t.toUpperCase() + n.toUpperCase();
          },
          toHexa: function toHexa() {
            var e,
                t = this.getSource();
            return e = 1 === (e = (e = Math.round(255 * t[3])).toString(16)).length ? "0" + e : e, this.toHex() + e.toUpperCase();
          },
          getAlpha: function getAlpha() {
            return this.getSource()[3];
          },
          setAlpha: function setAlpha(e) {
            var t = this.getSource();
            return t[3] = e, this.setSource(t), this;
          },
          toGrayscale: function toGrayscale() {
            var e = this.getSource(),
                t = parseInt((.3 * e[0] + .59 * e[1] + .11 * e[2]).toFixed(0), 10),
                n = e[3];
            return this.setSource([t, t, t, n]), this;
          },
          toBlackWhite: function toBlackWhite(e) {
            var t = this.getSource(),
                n = (.3 * t[0] + .59 * t[1] + .11 * t[2]).toFixed(0),
                i = t[3];
            return e = e || 127, n = Number(n) < Number(e) ? 0 : 255, this.setSource([n, n, n, i]), this;
          },
          overlayWith: function overlayWith(e) {
            e instanceof n || (e = new n(e));
            var t,
                i = [],
                r = this.getAlpha(),
                o = this.getSource(),
                a = e.getSource();

            for (t = 0; t < 3; t++) {
              i.push(Math.round(.5 * o[t] + .5 * a[t]));
            }

            return i[3] = r, this.setSource(i), this;
          }
        }, t.Color.reRGBa = /^rgba?\(\s*(\d{1,3}(?:\.\d+)?\%?)\s*,\s*(\d{1,3}(?:\.\d+)?\%?)\s*,\s*(\d{1,3}(?:\.\d+)?\%?)\s*(?:\s*,\s*((?:\d*\.?\d+)?)\s*)?\)$/i, t.Color.reHSLa = /^hsla?\(\s*(\d{1,3})\s*,\s*(\d{1,3}\%)\s*,\s*(\d{1,3}\%)\s*(?:\s*,\s*(\d+(?:\.\d+)?)\s*)?\)$/i, t.Color.reHex = /^#?([0-9a-f]{8}|[0-9a-f]{6}|[0-9a-f]{4}|[0-9a-f]{3})$/i, t.Color.colorNameMap = {
          aliceblue: "#F0F8FF",
          antiquewhite: "#FAEBD7",
          aqua: "#00FFFF",
          aquamarine: "#7FFFD4",
          azure: "#F0FFFF",
          beige: "#F5F5DC",
          bisque: "#FFE4C4",
          black: "#000000",
          blanchedalmond: "#FFEBCD",
          blue: "#0000FF",
          blueviolet: "#8A2BE2",
          brown: "#A52A2A",
          burlywood: "#DEB887",
          cadetblue: "#5F9EA0",
          chartreuse: "#7FFF00",
          chocolate: "#D2691E",
          coral: "#FF7F50",
          cornflowerblue: "#6495ED",
          cornsilk: "#FFF8DC",
          crimson: "#DC143C",
          cyan: "#00FFFF",
          darkblue: "#00008B",
          darkcyan: "#008B8B",
          darkgoldenrod: "#B8860B",
          darkgray: "#A9A9A9",
          darkgrey: "#A9A9A9",
          darkgreen: "#006400",
          darkkhaki: "#BDB76B",
          darkmagenta: "#8B008B",
          darkolivegreen: "#556B2F",
          darkorange: "#FF8C00",
          darkorchid: "#9932CC",
          darkred: "#8B0000",
          darksalmon: "#E9967A",
          darkseagreen: "#8FBC8F",
          darkslateblue: "#483D8B",
          darkslategray: "#2F4F4F",
          darkslategrey: "#2F4F4F",
          darkturquoise: "#00CED1",
          darkviolet: "#9400D3",
          deeppink: "#FF1493",
          deepskyblue: "#00BFFF",
          dimgray: "#696969",
          dimgrey: "#696969",
          dodgerblue: "#1E90FF",
          firebrick: "#B22222",
          floralwhite: "#FFFAF0",
          forestgreen: "#228B22",
          fuchsia: "#FF00FF",
          gainsboro: "#DCDCDC",
          ghostwhite: "#F8F8FF",
          gold: "#FFD700",
          goldenrod: "#DAA520",
          gray: "#808080",
          grey: "#808080",
          green: "#008000",
          greenyellow: "#ADFF2F",
          honeydew: "#F0FFF0",
          hotpink: "#FF69B4",
          indianred: "#CD5C5C",
          indigo: "#4B0082",
          ivory: "#FFFFF0",
          khaki: "#F0E68C",
          lavender: "#E6E6FA",
          lavenderblush: "#FFF0F5",
          lawngreen: "#7CFC00",
          lemonchiffon: "#FFFACD",
          lightblue: "#ADD8E6",
          lightcoral: "#F08080",
          lightcyan: "#E0FFFF",
          lightgoldenrodyellow: "#FAFAD2",
          lightgray: "#D3D3D3",
          lightgrey: "#D3D3D3",
          lightgreen: "#90EE90",
          lightpink: "#FFB6C1",
          lightsalmon: "#FFA07A",
          lightseagreen: "#20B2AA",
          lightskyblue: "#87CEFA",
          lightslategray: "#778899",
          lightslategrey: "#778899",
          lightsteelblue: "#B0C4DE",
          lightyellow: "#FFFFE0",
          lime: "#00FF00",
          limegreen: "#32CD32",
          linen: "#FAF0E6",
          magenta: "#FF00FF",
          maroon: "#800000",
          mediumaquamarine: "#66CDAA",
          mediumblue: "#0000CD",
          mediumorchid: "#BA55D3",
          mediumpurple: "#9370DB",
          mediumseagreen: "#3CB371",
          mediumslateblue: "#7B68EE",
          mediumspringgreen: "#00FA9A",
          mediumturquoise: "#48D1CC",
          mediumvioletred: "#C71585",
          midnightblue: "#191970",
          mintcream: "#F5FFFA",
          mistyrose: "#FFE4E1",
          moccasin: "#FFE4B5",
          navajowhite: "#FFDEAD",
          navy: "#000080",
          oldlace: "#FDF5E6",
          olive: "#808000",
          olivedrab: "#6B8E23",
          orange: "#FFA500",
          orangered: "#FF4500",
          orchid: "#DA70D6",
          palegoldenrod: "#EEE8AA",
          palegreen: "#98FB98",
          paleturquoise: "#AFEEEE",
          palevioletred: "#DB7093",
          papayawhip: "#FFEFD5",
          peachpuff: "#FFDAB9",
          peru: "#CD853F",
          pink: "#FFC0CB",
          plum: "#DDA0DD",
          powderblue: "#B0E0E6",
          purple: "#800080",
          rebeccapurple: "#663399",
          red: "#FF0000",
          rosybrown: "#BC8F8F",
          royalblue: "#4169E1",
          saddlebrown: "#8B4513",
          salmon: "#FA8072",
          sandybrown: "#F4A460",
          seagreen: "#2E8B57",
          seashell: "#FFF5EE",
          sienna: "#A0522D",
          silver: "#C0C0C0",
          skyblue: "#87CEEB",
          slateblue: "#6A5ACD",
          slategray: "#708090",
          slategrey: "#708090",
          snow: "#FFFAFA",
          springgreen: "#00FF7F",
          steelblue: "#4682B4",
          tan: "#D2B48C",
          teal: "#008080",
          thistle: "#D8BFD8",
          tomato: "#FF6347",
          turquoise: "#40E0D0",
          violet: "#EE82EE",
          wheat: "#F5DEB3",
          white: "#FFFFFF",
          whitesmoke: "#F5F5F5",
          yellow: "#FFFF00",
          yellowgreen: "#9ACD32"
        }, t.Color.fromRgb = function (e) {
          return n.fromSource(n.sourceFromRgb(e));
        }, t.Color.sourceFromRgb = function (e) {
          var t = e.match(n.reRGBa);

          if (t) {
            var i = parseInt(t[1], 10) / (/%$/.test(t[1]) ? 100 : 1) * (/%$/.test(t[1]) ? 255 : 1),
                r = parseInt(t[2], 10) / (/%$/.test(t[2]) ? 100 : 1) * (/%$/.test(t[2]) ? 255 : 1),
                o = parseInt(t[3], 10) / (/%$/.test(t[3]) ? 100 : 1) * (/%$/.test(t[3]) ? 255 : 1);
            return [parseInt(i, 10), parseInt(r, 10), parseInt(o, 10), t[4] ? parseFloat(t[4]) : 1];
          }
        }, t.Color.fromRgba = n.fromRgb, t.Color.fromHsl = function (e) {
          return n.fromSource(n.sourceFromHsl(e));
        }, t.Color.sourceFromHsl = function (e) {
          var t = e.match(n.reHSLa);

          if (t) {
            var r,
                o,
                a,
                s = (parseFloat(t[1]) % 360 + 360) % 360 / 360,
                l = parseFloat(t[2]) / (/%$/.test(t[2]) ? 100 : 1),
                u = parseFloat(t[3]) / (/%$/.test(t[3]) ? 100 : 1);
            if (0 === l) r = o = a = u;else {
              var c = u <= .5 ? u * (l + 1) : u + l - u * l,
                  h = 2 * u - c;
              r = i(h, c, s + 1 / 3), o = i(h, c, s), a = i(h, c, s - 1 / 3);
            }
            return [Math.round(255 * r), Math.round(255 * o), Math.round(255 * a), t[4] ? parseFloat(t[4]) : 1];
          }
        }, t.Color.fromHsla = n.fromHsl, t.Color.fromHex = function (e) {
          return n.fromSource(n.sourceFromHex(e));
        }, t.Color.sourceFromHex = function (e) {
          if (e.match(n.reHex)) {
            var t = e.slice(e.indexOf("#") + 1),
                i = 3 === t.length || 4 === t.length,
                r = 8 === t.length || 4 === t.length,
                o = i ? t.charAt(0) + t.charAt(0) : t.substring(0, 2),
                a = i ? t.charAt(1) + t.charAt(1) : t.substring(2, 4),
                s = i ? t.charAt(2) + t.charAt(2) : t.substring(4, 6),
                l = r ? i ? t.charAt(3) + t.charAt(3) : t.substring(6, 8) : "FF";
            return [parseInt(o, 16), parseInt(a, 16), parseInt(s, 16), parseFloat((parseInt(l, 16) / 255).toFixed(2))];
          }
        }, t.Color.fromSource = function (e) {
          var t = new n();
          return t.setSource(e), t;
        });
      }(t), function () {
        function e(e, t) {
          var n,
              i,
              r,
              o,
              a = e.getAttribute("style"),
              s = e.getAttribute("offset") || 0;

          if (s = (s = parseFloat(s) / (/%$/.test(s) ? 100 : 1)) < 0 ? 0 : s > 1 ? 1 : s, a) {
            var l = a.split(/\s*;\s*/);

            for ("" === l[l.length - 1] && l.pop(), o = l.length; o--;) {
              var u = l[o].split(/\s*:\s*/),
                  c = u[0].trim(),
                  h = u[1].trim();
              "stop-color" === c ? n = h : "stop-opacity" === c && (r = h);
            }
          }

          return n || (n = e.getAttribute("stop-color") || "rgb(0,0,0)"), r || (r = e.getAttribute("stop-opacity")), i = (n = new T.Color(n)).getAlpha(), r = isNaN(parseFloat(r)) ? 1 : parseFloat(r), r *= i * t, {
            offset: s,
            color: n.toRgb(),
            opacity: r
          };
        }

        var t = T.util.object.clone;

        function n(e, t, n, i) {
          var r, o;
          Object.keys(t).forEach(function (e) {
            "Infinity" === (r = t[e]) ? o = 1 : "-Infinity" === r ? o = 0 : (o = parseFloat(t[e], 10), "string" == typeof r && /^(\d+\.\d+)%|(\d+)%$/.test(r) && (o *= .01, "pixels" === i && ("x1" !== e && "x2" !== e && "r2" !== e || (o *= n.viewBoxWidth || n.width), "y1" !== e && "y2" !== e || (o *= n.viewBoxHeight || n.height)))), t[e] = o;
          });
        }

        T.Gradient = T.util.createClass({
          offsetX: 0,
          offsetY: 0,
          gradientTransform: null,
          gradientUnits: "pixels",
          type: "linear",
          initialize: function initialize(e) {
            e || (e = {}), e.coords || (e.coords = {});
            var t,
                n = this;
            Object.keys(e).forEach(function (t) {
              n[t] = e[t];
            }), this.id ? this.id += "_" + T.Object.__uid++ : this.id = T.Object.__uid++, t = {
              x1: e.coords.x1 || 0,
              y1: e.coords.y1 || 0,
              x2: e.coords.x2 || 0,
              y2: e.coords.y2 || 0
            }, "radial" === this.type && (t.r1 = e.coords.r1 || 0, t.r2 = e.coords.r2 || 0), this.coords = t, this.colorStops = e.colorStops.slice();
          },
          addColorStop: function addColorStop(e) {
            for (var t in e) {
              var n = new T.Color(e[t]);
              this.colorStops.push({
                offset: parseFloat(t),
                color: n.toRgb(),
                opacity: n.getAlpha()
              });
            }

            return this;
          },
          toObject: function toObject(e) {
            var t = {
              type: this.type,
              coords: this.coords,
              colorStops: this.colorStops,
              offsetX: this.offsetX,
              offsetY: this.offsetY,
              gradientUnits: this.gradientUnits,
              gradientTransform: this.gradientTransform ? this.gradientTransform.concat() : this.gradientTransform
            };
            return T.util.populateWithProperties(this, t, e), t;
          },
          toSVG: function toSVG(e, n) {
            var i,
                r,
                o,
                a,
                s = t(this.coords, !0),
                l = (n = n || {}, t(this.colorStops, !0)),
                u = s.r1 > s.r2,
                c = this.gradientTransform ? this.gradientTransform.concat() : T.iMatrix.concat(),
                h = -this.offsetX,
                d = -this.offsetY,
                f = !!n.additionalTransform,
                p = "pixels" === this.gradientUnits ? "userSpaceOnUse" : "objectBoundingBox";

            if (l.sort(function (e, t) {
              return e.offset - t.offset;
            }), "objectBoundingBox" === p ? (h /= e.width, d /= e.height) : (h += e.width / 2, d += e.height / 2), "path" === e.type && (h -= e.pathOffset.x, d -= e.pathOffset.y), c[4] -= h, c[5] -= d, a = 'id="SVGID_' + this.id + '" gradientUnits="' + p + '"', a += ' gradientTransform="' + (f ? n.additionalTransform + " " : "") + T.util.matrixToSVG(c) + '" ', "linear" === this.type ? o = ["<linearGradient ", a, ' x1="', s.x1, '" y1="', s.y1, '" x2="', s.x2, '" y2="', s.y2, '">\n'] : "radial" === this.type && (o = ["<radialGradient ", a, ' cx="', u ? s.x1 : s.x2, '" cy="', u ? s.y1 : s.y2, '" r="', u ? s.r1 : s.r2, '" fx="', u ? s.x2 : s.x1, '" fy="', u ? s.y2 : s.y1, '">\n']), "radial" === this.type) {
              if (u) for ((l = l.concat()).reverse(), i = 0, r = l.length; i < r; i++) {
                l[i].offset = 1 - l[i].offset;
              }
              var g = Math.min(s.r1, s.r2);

              if (g > 0) {
                var v = g / Math.max(s.r1, s.r2);

                for (i = 0, r = l.length; i < r; i++) {
                  l[i].offset += v * (1 - l[i].offset);
                }
              }
            }

            for (i = 0, r = l.length; i < r; i++) {
              var m = l[i];
              o.push("<stop ", 'offset="', 100 * m.offset + "%", '" style="stop-color:', m.color, void 0 !== m.opacity ? ";stop-opacity: " + m.opacity : ";", '"/>\n');
            }

            return o.push("linear" === this.type ? "</linearGradient>\n" : "</radialGradient>\n"), o.join("");
          },
          toLive: function toLive(e, t) {
            var n,
                i,
                r,
                o = T.util.object.clone(this.coords),
                a = o.x1,
                s = o.y1,
                l = o.x2,
                u = o.y2,
                c = this.colorStops;

            if (this.type) {
              for (t instanceof T.Text && "percentage" === this.gradientUnits && (a *= t.width, s *= t.height, l *= t.width, u *= t.height), "linear" === this.type ? n = e.createLinearGradient(a, s, l, u) : "radial" === this.type && (n = e.createRadialGradient(a, s, o.r1, l, u, o.r2)), i = 0, r = c.length; i < r; i++) {
                var h = c[i].color,
                    d = c[i].opacity,
                    f = c[i].offset;
                void 0 !== d && (h = new T.Color(h).setAlpha(d).toRgba()), n.addColorStop(f, h);
              }

              return n;
            }
          }
        }), T.util.object.extend(T.Gradient, {
          fromElement: function fromElement(t, i, r, o) {
            var a = parseFloat(r) / (/%$/.test(r) ? 100 : 1);
            a = a < 0 ? 0 : a > 1 ? 1 : a, isNaN(a) && (a = 1);
            var s,
                l,
                u,
                c,
                h = t.getElementsByTagName("stop"),
                d = "userSpaceOnUse" === t.getAttribute("gradientUnits") ? "pixels" : "percentage",
                f = t.getAttribute("gradientTransform") || "",
                p = [],
                g = 0,
                v = 0;

            for ("linearGradient" === t.nodeName || "LINEARGRADIENT" === t.nodeName ? (s = "linear", l = function (e) {
              return {
                x1: e.getAttribute("x1") || 0,
                y1: e.getAttribute("y1") || 0,
                x2: e.getAttribute("x2") || "100%",
                y2: e.getAttribute("y2") || 0
              };
            }(t)) : (s = "radial", l = function (e) {
              return {
                x1: e.getAttribute("fx") || e.getAttribute("cx") || "50%",
                y1: e.getAttribute("fy") || e.getAttribute("cy") || "50%",
                r1: 0,
                x2: e.getAttribute("cx") || "50%",
                y2: e.getAttribute("cy") || "50%",
                r2: e.getAttribute("r") || "50%"
              };
            }(t)), u = h.length; u--;) {
              p.push(e(h[u], a));
            }

            return c = T.parseTransformAttribute(f), n(i, l, o, d), "pixels" === d && (g = -i.left, v = -i.top), new T.Gradient({
              id: t.getAttribute("id"),
              type: s,
              coords: l,
              colorStops: p,
              gradientUnits: d,
              gradientTransform: c,
              offsetX: g,
              offsetY: v
            });
          },
          forObject: function forObject(e, t) {
            return t || (t = {}), n(e, t.coords, t.gradientUnits, {
              viewBoxWidth: 100,
              viewBoxHeight: 100
            }), new T.Gradient(t);
          }
        });
      }(), function () {
        "use strict";

        var e = T.util.toFixed;
        T.Pattern = T.util.createClass({
          repeat: "repeat",
          offsetX: 0,
          offsetY: 0,
          crossOrigin: "",
          patternTransform: null,
          initialize: function initialize(e, t) {
            if (e || (e = {}), this.id = T.Object.__uid++, this.setOptions(e), !e.source || e.source && "string" != typeof e.source) t && t(this);else if (void 0 !== T.util.getFunctionBody(e.source)) this.source = new Function(T.util.getFunctionBody(e.source)), t && t(this);else {
              var n = this;
              this.source = T.util.createImage(), T.util.loadImage(e.source, function (e) {
                n.source = e, t && t(n);
              }, null, this.crossOrigin);
            }
          },
          toObject: function toObject(t) {
            var n,
                i,
                r = T.Object.NUM_FRACTION_DIGITS;
            return "function" == typeof this.source ? n = String(this.source) : "string" == typeof this.source.src ? n = this.source.src : "object" == typeof this.source && this.source.toDataURL && (n = this.source.toDataURL()), i = {
              type: "pattern",
              source: n,
              repeat: this.repeat,
              crossOrigin: this.crossOrigin,
              offsetX: e(this.offsetX, r),
              offsetY: e(this.offsetY, r),
              patternTransform: this.patternTransform ? this.patternTransform.concat() : null
            }, T.util.populateWithProperties(this, i, t), i;
          },
          toSVG: function toSVG(e) {
            var t = "function" == typeof this.source ? this.source() : this.source,
                n = t.width / e.width,
                i = t.height / e.height,
                r = this.offsetX / e.width,
                o = this.offsetY / e.height,
                a = "";
            return "repeat-x" !== this.repeat && "no-repeat" !== this.repeat || (i = 1, o && (i += Math.abs(o))), "repeat-y" !== this.repeat && "no-repeat" !== this.repeat || (n = 1, r && (n += Math.abs(r))), t.src ? a = t.src : t.toDataURL && (a = t.toDataURL()), '<pattern id="SVGID_' + this.id + '" x="' + r + '" y="' + o + '" width="' + n + '" height="' + i + '">\n<image x="0" y="0" width="' + t.width + '" height="' + t.height + '" xlink:href="' + a + '"></image>\n</pattern>\n';
          },
          setOptions: function setOptions(e) {
            for (var t in e) {
              this[t] = e[t];
            }
          },
          toLive: function toLive(e) {
            var t = "function" == typeof this.source ? this.source() : this.source;
            if (!t) return "";

            if (void 0 !== t.src) {
              if (!t.complete) return "";
              if (0 === t.naturalWidth || 0 === t.naturalHeight) return "";
            }

            return e.createPattern(t, this.repeat);
          }
        });
      }(), function (e) {
        "use strict";

        var t = e.fabric || (e.fabric = {}),
            n = t.util.toFixed;
        t.Shadow ? t.warn("fabric.Shadow is already defined.") : (t.Shadow = t.util.createClass({
          color: "rgb(0,0,0)",
          blur: 0,
          offsetX: 0,
          offsetY: 0,
          affectStroke: !1,
          includeDefaultValues: !0,
          nonScaling: !1,
          initialize: function initialize(e) {
            for (var n in "string" == typeof e && (e = this._parseShadow(e)), e) {
              this[n] = e[n];
            }

            this.id = t.Object.__uid++;
          },
          _parseShadow: function _parseShadow(e) {
            var n = e.trim(),
                i = t.Shadow.reOffsetsAndBlur.exec(n) || [];
            return {
              color: (n.replace(t.Shadow.reOffsetsAndBlur, "") || "rgb(0,0,0)").trim(),
              offsetX: parseInt(i[1], 10) || 0,
              offsetY: parseInt(i[2], 10) || 0,
              blur: parseInt(i[3], 10) || 0
            };
          },
          toString: function toString() {
            return [this.offsetX, this.offsetY, this.blur, this.color].join("px ");
          },
          toSVG: function toSVG(e) {
            var i = 40,
                r = 40,
                o = t.Object.NUM_FRACTION_DIGITS,
                a = t.util.rotateVector({
              x: this.offsetX,
              y: this.offsetY
            }, t.util.degreesToRadians(-e.angle)),
                s = new t.Color(this.color);
            return e.width && e.height && (i = 100 * n((Math.abs(a.x) + this.blur) / e.width, o) + 20, r = 100 * n((Math.abs(a.y) + this.blur) / e.height, o) + 20), e.flipX && (a.x *= -1), e.flipY && (a.y *= -1), '<filter id="SVGID_' + this.id + '" y="-' + r + '%" height="' + (100 + 2 * r) + '%" x="-' + i + '%" width="' + (100 + 2 * i) + '%" >\n\t<feGaussianBlur in="SourceAlpha" stdDeviation="' + n(this.blur ? this.blur / 2 : 0, o) + '"></feGaussianBlur>\n\t<feOffset dx="' + n(a.x, o) + '" dy="' + n(a.y, o) + '" result="oBlur" ></feOffset>\n\t<feFlood flood-color="' + s.toRgb() + '" flood-opacity="' + s.getAlpha() + '"/>\n\t<feComposite in2="oBlur" operator="in" />\n\t<feMerge>\n\t\t<feMergeNode></feMergeNode>\n\t\t<feMergeNode in="SourceGraphic"></feMergeNode>\n\t</feMerge>\n</filter>\n';
          },
          toObject: function toObject() {
            if (this.includeDefaultValues) return {
              color: this.color,
              blur: this.blur,
              offsetX: this.offsetX,
              offsetY: this.offsetY,
              affectStroke: this.affectStroke,
              nonScaling: this.nonScaling
            };
            var e = {},
                n = t.Shadow.prototype;
            return ["color", "blur", "offsetX", "offsetY", "affectStroke", "nonScaling"].forEach(function (t) {
              this[t] !== n[t] && (e[t] = this[t]);
            }, this), e;
          }
        }), t.Shadow.reOffsetsAndBlur = /(?:\s|^)(-?\d+(?:px)?(?:\s?|$))?(-?\d+(?:px)?(?:\s?|$))?(\d+(?:px)?)?(?:\s?|$)(?:$|\s)/);
      }(t), function () {
        "use strict";

        if (T.StaticCanvas) T.warn("fabric.StaticCanvas is already defined.");else {
          var e = T.util.object.extend,
              t = T.util.getElementOffset,
              n = T.util.removeFromArray,
              i = T.util.toFixed,
              r = T.util.transformPoint,
              o = T.util.invertTransform,
              a = T.util.getNodeCanvas,
              s = T.util.createCanvasElement,
              l = new Error("Could not initialize `canvas` element");
          T.StaticCanvas = T.util.createClass(T.CommonMethods, {
            initialize: function initialize(e, t) {
              t || (t = {}), this.renderAndResetBound = this.renderAndReset.bind(this), this.requestRenderAllBound = this.requestRenderAll.bind(this), this._initStatic(e, t);
            },
            backgroundColor: "",
            backgroundImage: null,
            overlayColor: "",
            overlayImage: null,
            includeDefaultValues: !0,
            stateful: !1,
            renderOnAddRemove: !0,
            clipTo: null,
            controlsAboveOverlay: !1,
            allowTouchScrolling: !1,
            imageSmoothingEnabled: !0,
            viewportTransform: T.iMatrix.concat(),
            backgroundVpt: !0,
            overlayVpt: !0,
            onBeforeScaleRotate: function onBeforeScaleRotate() {},
            enableRetinaScaling: !0,
            vptCoords: {},
            skipOffscreen: !0,
            clipPath: void 0,
            _initStatic: function _initStatic(e, t) {
              var n = this.requestRenderAllBound;
              this._objects = [], this._createLowerCanvas(e), this._initOptions(t), this._setImageSmoothing(), this.interactive || this._initRetinaScaling(), t.overlayImage && this.setOverlayImage(t.overlayImage, n), t.backgroundImage && this.setBackgroundImage(t.backgroundImage, n), t.backgroundColor && this.setBackgroundColor(t.backgroundColor, n), t.overlayColor && this.setOverlayColor(t.overlayColor, n), this.calcOffset();
            },
            _isRetinaScaling: function _isRetinaScaling() {
              return 1 !== T.devicePixelRatio && this.enableRetinaScaling;
            },
            getRetinaScaling: function getRetinaScaling() {
              return this._isRetinaScaling() ? T.devicePixelRatio : 1;
            },
            _initRetinaScaling: function _initRetinaScaling() {
              if (this._isRetinaScaling()) {
                var e = T.devicePixelRatio;
                this.__initRetinaScaling(e, this.lowerCanvasEl, this.contextContainer), this.upperCanvasEl && this.__initRetinaScaling(e, this.upperCanvasEl, this.contextTop);
              }
            },
            __initRetinaScaling: function __initRetinaScaling(e, t, n) {
              t.setAttribute("width", this.width * e), t.setAttribute("height", this.height * e), n.scale(e, e);
            },
            calcOffset: function calcOffset() {
              return this._offset = t(this.lowerCanvasEl), this;
            },
            setOverlayImage: function setOverlayImage(e, t, n) {
              return this.__setBgOverlayImage("overlayImage", e, t, n);
            },
            setBackgroundImage: function setBackgroundImage(e, t, n) {
              return this.__setBgOverlayImage("backgroundImage", e, t, n);
            },
            setOverlayColor: function setOverlayColor(e, t) {
              return this.__setBgOverlayColor("overlayColor", e, t);
            },
            setBackgroundColor: function setBackgroundColor(e, t) {
              return this.__setBgOverlayColor("backgroundColor", e, t);
            },
            _setImageSmoothing: function _setImageSmoothing() {
              var e = this.getContext();
              e.imageSmoothingEnabled = e.imageSmoothingEnabled || e.webkitImageSmoothingEnabled || e.mozImageSmoothingEnabled || e.msImageSmoothingEnabled || e.oImageSmoothingEnabled, e.imageSmoothingEnabled = this.imageSmoothingEnabled;
            },
            __setBgOverlayImage: function __setBgOverlayImage(e, t, n, i) {
              return "string" == typeof t ? T.util.loadImage(t, function (t) {
                if (t) {
                  var r = new T.Image(t, i);
                  this[e] = r, r.canvas = this;
                }

                n && n(t);
              }, this, i && i.crossOrigin) : (i && t.setOptions(i), this[e] = t, t && (t.canvas = this), n && n(t)), this;
            },
            __setBgOverlayColor: function __setBgOverlayColor(e, t, n) {
              return this[e] = t, this._initGradient(t, e), this._initPattern(t, e, n), this;
            },
            _createCanvasElement: function _createCanvasElement() {
              var e = s();
              if (!e) throw l;
              if (e.style || (e.style = {}), void 0 === e.getContext) throw l;
              return e;
            },
            _initOptions: function _initOptions(e) {
              var t = this.lowerCanvasEl;
              this._setOptions(e), this.width = this.width || parseInt(t.width, 10) || 0, this.height = this.height || parseInt(t.height, 10) || 0, this.lowerCanvasEl.style && (t.width = this.width, t.height = this.height, t.style.width = this.width + "px", t.style.height = this.height + "px", this.viewportTransform = this.viewportTransform.slice());
            },
            _createLowerCanvas: function _createLowerCanvas(e) {
              e && e.getContext ? this.lowerCanvasEl = e : this.lowerCanvasEl = T.util.getById(e) || this._createCanvasElement(), T.util.addClass(this.lowerCanvasEl, "lower-canvas"), this.interactive && this._applyCanvasStyle(this.lowerCanvasEl), this.contextContainer = this.lowerCanvasEl.getContext("2d");
            },
            getWidth: function getWidth() {
              return this.width;
            },
            getHeight: function getHeight() {
              return this.height;
            },
            setWidth: function setWidth(e, t) {
              return this.setDimensions({
                width: e
              }, t);
            },
            setHeight: function setHeight(e, t) {
              return this.setDimensions({
                height: e
              }, t);
            },
            setDimensions: function setDimensions(e, t) {
              var n;

              for (var i in t = t || {}, e) {
                n = e[i], t.cssOnly || (this._setBackstoreDimension(i, e[i]), n += "px", this.hasLostContext = !0), t.backstoreOnly || this._setCssDimension(i, n);
              }

              return this._isCurrentlyDrawing && this.freeDrawingBrush && this.freeDrawingBrush._setBrushStyles(), this._initRetinaScaling(), this._setImageSmoothing(), this.calcOffset(), t.cssOnly || this.requestRenderAll(), this;
            },
            _setBackstoreDimension: function _setBackstoreDimension(e, t) {
              return this.lowerCanvasEl[e] = t, this.upperCanvasEl && (this.upperCanvasEl[e] = t), this.cacheCanvasEl && (this.cacheCanvasEl[e] = t), this[e] = t, this;
            },
            _setCssDimension: function _setCssDimension(e, t) {
              return this.lowerCanvasEl.style[e] = t, this.upperCanvasEl && (this.upperCanvasEl.style[e] = t), this.wrapperEl && (this.wrapperEl.style[e] = t), this;
            },
            getZoom: function getZoom() {
              return this.viewportTransform[0];
            },
            setViewportTransform: function setViewportTransform(e) {
              var t,
                  n,
                  i,
                  r = this._activeObject;

              for (this.viewportTransform = e, n = 0, i = this._objects.length; n < i; n++) {
                (t = this._objects[n]).group || t.setCoords(!1, !0);
              }

              return r && "activeSelection" === r.type && r.setCoords(!1, !0), this.calcViewportBoundaries(), this.renderOnAddRemove && this.requestRenderAll(), this;
            },
            zoomToPoint: function zoomToPoint(e, t) {
              var n = e,
                  i = this.viewportTransform.slice(0);
              e = r(e, o(this.viewportTransform)), i[0] = t, i[3] = t;
              var a = r(e, i);
              return i[4] += n.x - a.x, i[5] += n.y - a.y, this.setViewportTransform(i);
            },
            setZoom: function setZoom(e) {
              return this.zoomToPoint(new T.Point(0, 0), e), this;
            },
            absolutePan: function absolutePan(e) {
              var t = this.viewportTransform.slice(0);
              return t[4] = -e.x, t[5] = -e.y, this.setViewportTransform(t);
            },
            relativePan: function relativePan(e) {
              return this.absolutePan(new T.Point(-e.x - this.viewportTransform[4], -e.y - this.viewportTransform[5]));
            },
            getElement: function getElement() {
              return this.lowerCanvasEl;
            },
            _onObjectAdded: function _onObjectAdded(e) {
              this.stateful && e.setupState(), e._set("canvas", this), e.setCoords(), this.fire("object:added", {
                target: e
              }), e.fire("added");
            },
            _onObjectRemoved: function _onObjectRemoved(e) {
              this.fire("object:removed", {
                target: e
              }), e.fire("removed"), delete e.canvas;
            },
            clearContext: function clearContext(e) {
              return e.clearRect(0, 0, this.width, this.height), this;
            },
            getContext: function getContext() {
              return this.contextContainer;
            },
            clear: function clear() {
              return this._objects.length = 0, this.backgroundImage = null, this.overlayImage = null, this.backgroundColor = "", this.overlayColor = "", this._hasITextHandlers && (this.off("mouse:up", this._mouseUpITextHandler), this._iTextInstances = null, this._hasITextHandlers = !1), this.clearContext(this.contextContainer), this.fire("canvas:cleared"), this.renderOnAddRemove && this.requestRenderAll(), this;
            },
            renderAll: function renderAll() {
              var e = this.contextContainer;
              return this.renderCanvas(e, this._objects), this;
            },
            renderAndReset: function renderAndReset() {
              this.isRendering = 0, this.renderAll();
            },
            requestRenderAll: function requestRenderAll() {
              return this.isRendering || (this.isRendering = T.util.requestAnimFrame(this.renderAndResetBound)), this;
            },
            calcViewportBoundaries: function calcViewportBoundaries() {
              var e = {},
                  t = this.width,
                  n = this.height,
                  i = o(this.viewportTransform);
              return e.tl = r({
                x: 0,
                y: 0
              }, i), e.br = r({
                x: t,
                y: n
              }, i), e.tr = new T.Point(e.br.x, e.tl.y), e.bl = new T.Point(e.tl.x, e.br.y), this.vptCoords = e, e;
            },
            cancelRequestedRender: function cancelRequestedRender() {
              this.isRendering && (T.util.cancelAnimFrame(this.isRendering), this.isRendering = 0);
            },
            renderCanvas: function renderCanvas(e, t) {
              var n = this.viewportTransform,
                  i = this.clipPath;
              this.cancelRequestedRender(), this.calcViewportBoundaries(), this.clearContext(e), this.fire("before:render", {
                ctx: e
              }), this.clipTo && T.util.clipContext(this, e), this._renderBackground(e), e.save(), e.transform(n[0], n[1], n[2], n[3], n[4], n[5]), this._renderObjects(e, t), e.restore(), !this.controlsAboveOverlay && this.interactive && this.drawControls(e), this.clipTo && e.restore(), i && (i.canvas = this, i.shouldCache(), i._transformDone = !0, i.renderCache({
                forClipping: !0
              }), this.drawClipPathOnCanvas(e)), this._renderOverlay(e), this.controlsAboveOverlay && this.interactive && this.drawControls(e), this.fire("after:render", {
                ctx: e
              });
            },
            drawClipPathOnCanvas: function drawClipPathOnCanvas(e) {
              var t = this.viewportTransform,
                  n = this.clipPath;
              e.save(), e.transform(t[0], t[1], t[2], t[3], t[4], t[5]), e.globalCompositeOperation = "destination-in", n.transform(e), e.scale(1 / n.zoomX, 1 / n.zoomY), e.drawImage(n._cacheCanvas, -n.cacheTranslationX, -n.cacheTranslationY), e.restore();
            },
            _renderObjects: function _renderObjects(e, t) {
              var n, i;

              for (n = 0, i = t.length; n < i; ++n) {
                t[n] && t[n].render(e);
              }
            },
            _renderBackgroundOrOverlay: function _renderBackgroundOrOverlay(e, t) {
              var n = this[t + "Color"],
                  i = this[t + "Image"],
                  r = this.viewportTransform,
                  o = this[t + "Vpt"];

              if (n || i) {
                if (n) {
                  e.save(), e.beginPath(), e.moveTo(0, 0), e.lineTo(this.width, 0), e.lineTo(this.width, this.height), e.lineTo(0, this.height), e.closePath(), e.fillStyle = n.toLive ? n.toLive(e, this) : n, o && e.transform(r[0], r[1], r[2], r[3], r[4], r[5]), e.transform(1, 0, 0, 1, n.offsetX || 0, n.offsetY || 0);
                  var a = n.gradientTransform || n.patternTransform;
                  a && e.transform(a[0], a[1], a[2], a[3], a[4], a[5]), e.fill(), e.restore();
                }

                i && (e.save(), o && e.transform(r[0], r[1], r[2], r[3], r[4], r[5]), i.render(e), e.restore());
              }
            },
            _renderBackground: function _renderBackground(e) {
              this._renderBackgroundOrOverlay(e, "background");
            },
            _renderOverlay: function _renderOverlay(e) {
              this._renderBackgroundOrOverlay(e, "overlay");
            },
            getCenter: function getCenter() {
              return {
                top: this.height / 2,
                left: this.width / 2
              };
            },
            centerObjectH: function centerObjectH(e) {
              return this._centerObject(e, new T.Point(this.getCenter().left, e.getCenterPoint().y));
            },
            centerObjectV: function centerObjectV(e) {
              return this._centerObject(e, new T.Point(e.getCenterPoint().x, this.getCenter().top));
            },
            centerObject: function centerObject(e) {
              var t = this.getCenter();
              return this._centerObject(e, new T.Point(t.left, t.top));
            },
            viewportCenterObject: function viewportCenterObject(e) {
              var t = this.getVpCenter();
              return this._centerObject(e, t);
            },
            viewportCenterObjectH: function viewportCenterObjectH(e) {
              var t = this.getVpCenter();
              return this._centerObject(e, new T.Point(t.x, e.getCenterPoint().y)), this;
            },
            viewportCenterObjectV: function viewportCenterObjectV(e) {
              var t = this.getVpCenter();
              return this._centerObject(e, new T.Point(e.getCenterPoint().x, t.y));
            },
            getVpCenter: function getVpCenter() {
              var e = this.getCenter(),
                  t = o(this.viewportTransform);
              return r({
                x: e.left,
                y: e.top
              }, t);
            },
            _centerObject: function _centerObject(e, t) {
              return e.setPositionByOrigin(t, "center", "center"), e.setCoords(), this.renderOnAddRemove && this.requestRenderAll(), this;
            },
            toDatalessJSON: function toDatalessJSON(e) {
              return this.toDatalessObject(e);
            },
            toObject: function toObject(e) {
              return this._toObjectMethod("toObject", e);
            },
            toDatalessObject: function toDatalessObject(e) {
              return this._toObjectMethod("toDatalessObject", e);
            },
            _toObjectMethod: function _toObjectMethod(t, n) {
              var i = this.clipPath,
                  r = {
                version: T.version,
                objects: this._toObjects(t, n)
              };
              return i && (r.clipPath = this._toObject(this.clipPath, t, n)), e(r, this.__serializeBgOverlay(t, n)), T.util.populateWithProperties(this, r, n), r;
            },
            _toObjects: function _toObjects(e, t) {
              return this._objects.filter(function (e) {
                return !e.excludeFromExport;
              }).map(function (n) {
                return this._toObject(n, e, t);
              }, this);
            },
            _toObject: function _toObject(e, t, n) {
              var i;
              this.includeDefaultValues || (i = e.includeDefaultValues, e.includeDefaultValues = !1);
              var r = e[t](n);
              return this.includeDefaultValues || (e.includeDefaultValues = i), r;
            },
            __serializeBgOverlay: function __serializeBgOverlay(e, t) {
              var n = {},
                  i = this.backgroundImage,
                  r = this.overlayImage;
              return this.backgroundColor && (n.background = this.backgroundColor.toObject ? this.backgroundColor.toObject(t) : this.backgroundColor), this.overlayColor && (n.overlay = this.overlayColor.toObject ? this.overlayColor.toObject(t) : this.overlayColor), i && !i.excludeFromExport && (n.backgroundImage = this._toObject(i, e, t)), r && !r.excludeFromExport && (n.overlayImage = this._toObject(r, e, t)), n;
            },
            svgViewportTransformation: !0,
            toSVG: function toSVG(e, t) {
              e || (e = {}), e.reviver = t;
              var n = [];
              return this._setSVGPreamble(n, e), this._setSVGHeader(n, e), this.clipPath && n.push('<g clip-path="url(#' + this.clipPath.clipPathId + ')" >\n'), this._setSVGBgOverlayColor(n, "background"), this._setSVGBgOverlayImage(n, "backgroundImage", t), this._setSVGObjects(n, t), this.clipPath && n.push("</g>\n"), this._setSVGBgOverlayColor(n, "overlay"), this._setSVGBgOverlayImage(n, "overlayImage", t), n.push("</svg>"), n.join("");
            },
            _setSVGPreamble: function _setSVGPreamble(e, t) {
              t.suppressPreamble || e.push('<?xml version="1.0" encoding="', t.encoding || "UTF-8", '" standalone="no" ?>\n', '<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" ', '"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">\n');
            },
            _setSVGHeader: function _setSVGHeader(e, t) {
              var n,
                  r = t.width || this.width,
                  o = t.height || this.height,
                  a = 'viewBox="0 0 ' + this.width + " " + this.height + '" ',
                  s = T.Object.NUM_FRACTION_DIGITS;
              t.viewBox ? a = 'viewBox="' + t.viewBox.x + " " + t.viewBox.y + " " + t.viewBox.width + " " + t.viewBox.height + '" ' : this.svgViewportTransformation && (n = this.viewportTransform, a = 'viewBox="' + i(-n[4] / n[0], s) + " " + i(-n[5] / n[3], s) + " " + i(this.width / n[0], s) + " " + i(this.height / n[3], s) + '" '), e.push("<svg ", 'xmlns="http://www.w3.org/2000/svg" ', 'xmlns:xlink="http://www.w3.org/1999/xlink" ', 'version="1.1" ', 'width="', r, '" ', 'height="', o, '" ', a, 'xml:space="preserve">\n', "<desc>Created with Fabric.js ", T.version, "</desc>\n", "<defs>\n", this.createSVGFontFacesMarkup(), this.createSVGRefElementsMarkup(), this.createSVGClipPathMarkup(t), "</defs>\n");
            },
            createSVGClipPathMarkup: function createSVGClipPathMarkup(e) {
              var t = this.clipPath;
              return t ? (t.clipPathId = "CLIPPATH_" + T.Object.__uid++, '<clipPath id="' + t.clipPathId + '" >\n' + this.clipPath.toClipPathSVG(e.reviver) + "</clipPath>\n") : "";
            },
            createSVGRefElementsMarkup: function createSVGRefElementsMarkup() {
              var e = this;
              return ["background", "overlay"].map(function (t) {
                var n = e[t + "Color"];

                if (n && n.toLive) {
                  var i = e[t + "Vpt"],
                      r = e.viewportTransform,
                      o = {
                    width: e.width / (i ? r[0] : 1),
                    height: e.height / (i ? r[3] : 1)
                  };
                  return n.toSVG(o, {
                    additionalTransform: i ? T.util.matrixToSVG(r) : ""
                  });
                }
              }).join("");
            },
            createSVGFontFacesMarkup: function createSVGFontFacesMarkup() {
              var e,
                  t,
                  n,
                  i,
                  r,
                  o,
                  a,
                  s,
                  l = "",
                  u = {},
                  c = T.fontPaths,
                  h = [];

              for (this._objects.forEach(function e(t) {
                h.push(t), t._objects && t._objects.forEach(e);
              }), a = 0, s = h.length; a < s; a++) {
                if (t = (e = h[a]).fontFamily, -1 !== e.type.indexOf("text") && !u[t] && c[t] && (u[t] = !0, e.styles)) for (r in n = e.styles) {
                  for (o in i = n[r]) {
                    !u[t = i[o].fontFamily] && c[t] && (u[t] = !0);
                  }
                }
              }

              for (var d in u) {
                l += ["\t\t@font-face {\n", "\t\t\tfont-family: '", d, "';\n", "\t\t\tsrc: url('", c[d], "');\n", "\t\t}\n"].join("");
              }

              return l && (l = ['\t<style type="text/css">', "<![CDATA[\n", l, "]]>", "</style>\n"].join("")), l;
            },
            _setSVGObjects: function _setSVGObjects(e, t) {
              var n,
                  i,
                  r,
                  o = this._objects;

              for (i = 0, r = o.length; i < r; i++) {
                (n = o[i]).excludeFromExport || this._setSVGObject(e, n, t);
              }
            },
            _setSVGObject: function _setSVGObject(e, t, n) {
              e.push(t.toSVG(n));
            },
            _setSVGBgOverlayImage: function _setSVGBgOverlayImage(e, t, n) {
              this[t] && !this[t].excludeFromExport && this[t].toSVG && e.push(this[t].toSVG(n));
            },
            _setSVGBgOverlayColor: function _setSVGBgOverlayColor(e, t) {
              var n = this[t + "Color"],
                  i = this.viewportTransform,
                  r = this.width,
                  o = this.height;
              if (n) if (n.toLive) {
                var a = n.repeat,
                    s = T.util.invertTransform(i),
                    l = this[t + "Vpt"] ? T.util.matrixToSVG(s) : "";
                e.push('<rect transform="' + l + " translate(", r / 2, ",", o / 2, ')"', ' x="', n.offsetX - r / 2, '" y="', n.offsetY - o / 2, '" ', 'width="', "repeat-y" === a || "no-repeat" === a ? n.source.width : r, '" height="', "repeat-x" === a || "no-repeat" === a ? n.source.height : o, '" fill="url(#SVGID_' + n.id + ')"', "></rect>\n");
              } else e.push('<rect x="0" y="0" width="100%" height="100%" ', 'fill="', n, '"', "></rect>\n");
            },
            sendToBack: function sendToBack(e) {
              if (!e) return this;
              var t,
                  i,
                  r,
                  o = this._activeObject;
              if (e === o && "activeSelection" === e.type) for (t = (r = o._objects).length; t--;) {
                i = r[t], n(this._objects, i), this._objects.unshift(i);
              } else n(this._objects, e), this._objects.unshift(e);
              return this.renderOnAddRemove && this.requestRenderAll(), this;
            },
            bringToFront: function bringToFront(e) {
              if (!e) return this;
              var t,
                  i,
                  r,
                  o = this._activeObject;
              if (e === o && "activeSelection" === e.type) for (r = o._objects, t = 0; t < r.length; t++) {
                i = r[t], n(this._objects, i), this._objects.push(i);
              } else n(this._objects, e), this._objects.push(e);
              return this.renderOnAddRemove && this.requestRenderAll(), this;
            },
            sendBackwards: function sendBackwards(e, t) {
              if (!e) return this;
              var i,
                  r,
                  o,
                  a,
                  s,
                  l = this._activeObject,
                  u = 0;
              if (e === l && "activeSelection" === e.type) for (s = l._objects, i = 0; i < s.length; i++) {
                r = s[i], (o = this._objects.indexOf(r)) > 0 + u && (a = o - 1, n(this._objects, r), this._objects.splice(a, 0, r)), u++;
              } else 0 !== (o = this._objects.indexOf(e)) && (a = this._findNewLowerIndex(e, o, t), n(this._objects, e), this._objects.splice(a, 0, e));
              return this.renderOnAddRemove && this.requestRenderAll(), this;
            },
            _findNewLowerIndex: function _findNewLowerIndex(e, t, n) {
              var i, r;
              if (n) for (i = t, r = t - 1; r >= 0; --r) {
                if (e.intersectsWithObject(this._objects[r]) || e.isContainedWithinObject(this._objects[r]) || this._objects[r].isContainedWithinObject(e)) {
                  i = r;
                  break;
                }
              } else i = t - 1;
              return i;
            },
            bringForward: function bringForward(e, t) {
              if (!e) return this;
              var i,
                  r,
                  o,
                  a,
                  s,
                  l = this._activeObject,
                  u = 0;
              if (e === l && "activeSelection" === e.type) for (i = (s = l._objects).length; i--;) {
                r = s[i], (o = this._objects.indexOf(r)) < this._objects.length - 1 - u && (a = o + 1, n(this._objects, r), this._objects.splice(a, 0, r)), u++;
              } else (o = this._objects.indexOf(e)) !== this._objects.length - 1 && (a = this._findNewUpperIndex(e, o, t), n(this._objects, e), this._objects.splice(a, 0, e));
              return this.renderOnAddRemove && this.requestRenderAll(), this;
            },
            _findNewUpperIndex: function _findNewUpperIndex(e, t, n) {
              var i, r, o;
              if (n) for (i = t, r = t + 1, o = this._objects.length; r < o; ++r) {
                if (e.intersectsWithObject(this._objects[r]) || e.isContainedWithinObject(this._objects[r]) || this._objects[r].isContainedWithinObject(e)) {
                  i = r;
                  break;
                }
              } else i = t + 1;
              return i;
            },
            moveTo: function moveTo(e, t) {
              return n(this._objects, e), this._objects.splice(t, 0, e), this.renderOnAddRemove && this.requestRenderAll();
            },
            dispose: function dispose() {
              return this.isRendering && (T.util.cancelAnimFrame(this.isRendering), this.isRendering = 0), this.forEachObject(function (e) {
                e.dispose && e.dispose();
              }), this._objects = [], this.backgroundImage && this.backgroundImage.dispose && this.backgroundImage.dispose(), this.backgroundImage = null, this.overlayImage && this.overlayImage.dispose && this.overlayImage.dispose(), this.overlayImage = null, this._iTextInstances = null, this.contextContainer = null, T.util.cleanUpJsdomNode(this.lowerCanvasEl), this.lowerCanvasEl = void 0, this;
            },
            toString: function toString() {
              return "#<fabric.Canvas (" + this.complexity() + "): { objects: " + this._objects.length + " }>";
            }
          }), e(T.StaticCanvas.prototype, T.Observable), e(T.StaticCanvas.prototype, T.Collection), e(T.StaticCanvas.prototype, T.DataURLExporter), e(T.StaticCanvas, {
            EMPTY_JSON: '{"objects": [], "background": "white"}',
            supports: function supports(e) {
              var t = s();
              if (!t || !t.getContext) return null;
              var n = t.getContext("2d");
              if (!n) return null;

              switch (e) {
                case "setLineDash":
                  return void 0 !== n.setLineDash;

                default:
                  return null;
              }
            }
          }), T.StaticCanvas.prototype.toJSON = T.StaticCanvas.prototype.toObject, T.isLikelyNode && (T.StaticCanvas.prototype.createPNGStream = function () {
            var e = a(this.lowerCanvasEl);
            return e && e.createPNGStream();
          }, T.StaticCanvas.prototype.createJPEGStream = function (e) {
            var t = a(this.lowerCanvasEl);
            return t && t.createJPEGStream(e);
          });
        }
      }(), T.BaseBrush = T.util.createClass({
        color: "rgb(0, 0, 0)",
        width: 1,
        shadow: null,
        strokeLineCap: "round",
        strokeLineJoin: "round",
        strokeMiterLimit: 10,
        strokeDashArray: null,
        setShadow: function setShadow(e) {
          return this.shadow = new T.Shadow(e), this;
        },
        _setBrushStyles: function _setBrushStyles() {
          var e = this.canvas.contextTop;
          e.strokeStyle = this.color, e.lineWidth = this.width, e.lineCap = this.strokeLineCap, e.miterLimit = this.strokeMiterLimit, e.lineJoin = this.strokeLineJoin, T.StaticCanvas.supports("setLineDash") && e.setLineDash(this.strokeDashArray || []);
        },
        _saveAndTransform: function _saveAndTransform(e) {
          var t = this.canvas.viewportTransform;
          e.save(), e.transform(t[0], t[1], t[2], t[3], t[4], t[5]);
        },
        _setShadow: function _setShadow() {
          if (this.shadow) {
            var e = this.canvas,
                t = this.shadow,
                n = e.contextTop,
                i = e.getZoom();
            e && e._isRetinaScaling() && (i *= T.devicePixelRatio), n.shadowColor = t.color, n.shadowBlur = t.blur * i, n.shadowOffsetX = t.offsetX * i, n.shadowOffsetY = t.offsetY * i;
          }
        },
        needsFullRender: function needsFullRender() {
          return new T.Color(this.color).getAlpha() < 1 || !!this.shadow;
        },
        _resetShadow: function _resetShadow() {
          var e = this.canvas.contextTop;
          e.shadowColor = "", e.shadowBlur = e.shadowOffsetX = e.shadowOffsetY = 0;
        }
      }), T.PencilBrush = T.util.createClass(T.BaseBrush, {
        decimate: .4,
        initialize: function initialize(e) {
          this.canvas = e, this._points = [];
        },
        _drawSegment: function _drawSegment(e, t, n) {
          var i = t.midPointFrom(n);
          return e.quadraticCurveTo(t.x, t.y, i.x, i.y), i;
        },
        onMouseDown: function onMouseDown(e, t) {
          this.canvas._isMainEvent(t.e) && (this._prepareForDrawing(e), this._captureDrawingPath(e), this._render());
        },
        onMouseMove: function onMouseMove(e, t) {
          if (this.canvas._isMainEvent(t.e) && this._captureDrawingPath(e) && this._points.length > 1) if (this.needsFullRender()) this.canvas.clearContext(this.canvas.contextTop), this._render();else {
            var n = this._points,
                i = n.length,
                r = this.canvas.contextTop;
            this._saveAndTransform(r), this.oldEnd && (r.beginPath(), r.moveTo(this.oldEnd.x, this.oldEnd.y)), this.oldEnd = this._drawSegment(r, n[i - 2], n[i - 1], !0), r.stroke(), r.restore();
          }
        },
        onMouseUp: function onMouseUp(e) {
          return !this.canvas._isMainEvent(e.e) || (this.oldEnd = void 0, this._finalizeAndAddPath(), !1);
        },
        _prepareForDrawing: function _prepareForDrawing(e) {
          var t = new T.Point(e.x, e.y);
          this._reset(), this._addPoint(t), this.canvas.contextTop.moveTo(t.x, t.y);
        },
        _addPoint: function _addPoint(e) {
          return !(this._points.length > 1 && e.eq(this._points[this._points.length - 1]) || (this._points.push(e), 0));
        },
        _reset: function _reset() {
          this._points = [], this._setBrushStyles(), this._setShadow();
        },
        _captureDrawingPath: function _captureDrawingPath(e) {
          var t = new T.Point(e.x, e.y);
          return this._addPoint(t);
        },
        _render: function _render() {
          var e,
              t,
              n = this.canvas.contextTop,
              i = this._points[0],
              r = this._points[1];

          if (this._saveAndTransform(n), n.beginPath(), 2 === this._points.length && i.x === r.x && i.y === r.y) {
            var o = this.width / 1e3;
            i = new T.Point(i.x, i.y), r = new T.Point(r.x, r.y), i.x -= o, r.x += o;
          }

          for (n.moveTo(i.x, i.y), e = 1, t = this._points.length; e < t; e++) {
            this._drawSegment(n, i, r), i = this._points[e], r = this._points[e + 1];
          }

          n.lineTo(i.x, i.y), n.stroke(), n.restore();
        },
        convertPointsToSVGPath: function convertPointsToSVGPath(e) {
          var t,
              n = [],
              i = this.width / 1e3,
              r = new T.Point(e[0].x, e[0].y),
              o = new T.Point(e[1].x, e[1].y),
              a = e.length,
              s = 1,
              l = 0,
              u = a > 2;

          for (u && (s = e[2].x < o.x ? -1 : e[2].x === o.x ? 0 : 1, l = e[2].y < o.y ? -1 : e[2].y === o.y ? 0 : 1), n.push("M ", r.x - s * i, " ", r.y - l * i, " "), t = 1; t < a; t++) {
            if (!r.eq(o)) {
              var c = r.midPointFrom(o);
              n.push("Q ", r.x, " ", r.y, " ", c.x, " ", c.y, " ");
            }

            r = e[t], t + 1 < e.length && (o = e[t + 1]);
          }

          return u && (s = r.x > e[t - 2].x ? 1 : r.x === e[t - 2].x ? 0 : -1, l = r.y > e[t - 2].y ? 1 : r.y === e[t - 2].y ? 0 : -1), n.push("L ", r.x + s * i, " ", r.y + l * i), n;
        },
        createPath: function createPath(e) {
          var t = new T.Path(e, {
            fill: null,
            stroke: this.color,
            strokeWidth: this.width,
            strokeLineCap: this.strokeLineCap,
            strokeMiterLimit: this.strokeMiterLimit,
            strokeLineJoin: this.strokeLineJoin,
            strokeDashArray: this.strokeDashArray
          });
          return this.shadow && (this.shadow.affectStroke = !0, t.setShadow(this.shadow)), t;
        },
        decimatePoints: function decimatePoints(e, t) {
          if (e.length <= 2) return e;
          var n,
              i = this.canvas.getZoom(),
              r = Math.pow(t / i, 2),
              o = e.length - 1,
              a = e[0],
              s = [a];

          for (n = 1; n < o; n++) {
            Math.pow(a.x - e[n].x, 2) + Math.pow(a.y - e[n].y, 2) >= r && (a = e[n], s.push(a));
          }

          return 1 === s.length && s.push(new T.Point(s[0].x, s[0].y)), s;
        },
        _finalizeAndAddPath: function _finalizeAndAddPath() {
          this.canvas.contextTop.closePath(), this.decimate && (this._points = this.decimatePoints(this._points, this.decimate));
          var e = this.convertPointsToSVGPath(this._points).join("");

          if ("M 0 0 Q 0 0 0 0 L 0 0" !== e) {
            var t = this.createPath(e);
            this.canvas.clearContext(this.canvas.contextTop), this.canvas.add(t), this.canvas.requestRenderAll(), t.setCoords(), this._resetShadow(), this.canvas.fire("path:created", {
              path: t
            });
          } else this.canvas.requestRenderAll();
        }
      }), T.CircleBrush = T.util.createClass(T.BaseBrush, {
        width: 10,
        initialize: function initialize(e) {
          this.canvas = e, this.points = [];
        },
        drawDot: function drawDot(e) {
          var t = this.addPoint(e),
              n = this.canvas.contextTop;
          this._saveAndTransform(n), this.dot(n, t), n.restore();
        },
        dot: function dot(e, t) {
          e.fillStyle = t.fill, e.beginPath(), e.arc(t.x, t.y, t.radius, 0, 2 * Math.PI, !1), e.closePath(), e.fill();
        },
        onMouseDown: function onMouseDown(e) {
          this.points.length = 0, this.canvas.clearContext(this.canvas.contextTop), this._setShadow(), this.drawDot(e);
        },
        _render: function _render() {
          var e,
              t,
              n = this.canvas.contextTop,
              i = this.points;

          for (this._saveAndTransform(n), e = 0, t = i.length; e < t; e++) {
            this.dot(n, i[e]);
          }

          n.restore();
        },
        onMouseMove: function onMouseMove(e) {
          this.needsFullRender() ? (this.canvas.clearContext(this.canvas.contextTop), this.addPoint(e), this._render()) : this.drawDot(e);
        },
        onMouseUp: function onMouseUp() {
          var e,
              t,
              n = this.canvas.renderOnAddRemove;
          this.canvas.renderOnAddRemove = !1;
          var i = [];

          for (e = 0, t = this.points.length; e < t; e++) {
            var r = this.points[e],
                o = new T.Circle({
              radius: r.radius,
              left: r.x,
              top: r.y,
              originX: "center",
              originY: "center",
              fill: r.fill
            });
            this.shadow && o.setShadow(this.shadow), i.push(o);
          }

          var a = new T.Group(i);
          a.canvas = this.canvas, this.canvas.add(a), this.canvas.fire("path:created", {
            path: a
          }), this.canvas.clearContext(this.canvas.contextTop), this._resetShadow(), this.canvas.renderOnAddRemove = n, this.canvas.requestRenderAll();
        },
        addPoint: function addPoint(e) {
          var t = new T.Point(e.x, e.y),
              n = T.util.getRandomInt(Math.max(0, this.width - 20), this.width + 20) / 2,
              i = new T.Color(this.color).setAlpha(T.util.getRandomInt(0, 100) / 100).toRgba();
          return t.radius = n, t.fill = i, this.points.push(t), t;
        }
      }), T.SprayBrush = T.util.createClass(T.BaseBrush, {
        width: 10,
        density: 20,
        dotWidth: 1,
        dotWidthVariance: 1,
        randomOpacity: !1,
        optimizeOverlapping: !0,
        initialize: function initialize(e) {
          this.canvas = e, this.sprayChunks = [];
        },
        onMouseDown: function onMouseDown(e) {
          this.sprayChunks.length = 0, this.canvas.clearContext(this.canvas.contextTop), this._setShadow(), this.addSprayChunk(e), this.render(this.sprayChunkPoints);
        },
        onMouseMove: function onMouseMove(e) {
          this.addSprayChunk(e), this.render(this.sprayChunkPoints);
        },
        onMouseUp: function onMouseUp() {
          var e = this.canvas.renderOnAddRemove;
          this.canvas.renderOnAddRemove = !1;

          for (var t = [], n = 0, i = this.sprayChunks.length; n < i; n++) {
            for (var r = this.sprayChunks[n], o = 0, a = r.length; o < a; o++) {
              var s = new T.Rect({
                width: r[o].width,
                height: r[o].width,
                left: r[o].x + 1,
                top: r[o].y + 1,
                originX: "center",
                originY: "center",
                fill: this.color
              });
              t.push(s);
            }
          }

          this.optimizeOverlapping && (t = this._getOptimizedRects(t));
          var l = new T.Group(t);
          this.shadow && l.setShadow(this.shadow), this.canvas.add(l), this.canvas.fire("path:created", {
            path: l
          }), this.canvas.clearContext(this.canvas.contextTop), this._resetShadow(), this.canvas.renderOnAddRemove = e, this.canvas.requestRenderAll();
        },
        _getOptimizedRects: function _getOptimizedRects(e) {
          var t,
              n,
              i,
              r = {};

          for (n = 0, i = e.length; n < i; n++) {
            r[t = e[n].left + "" + e[n].top] || (r[t] = e[n]);
          }

          var o = [];

          for (t in r) {
            o.push(r[t]);
          }

          return o;
        },
        render: function render(e) {
          var t,
              n,
              i = this.canvas.contextTop;

          for (i.fillStyle = this.color, this._saveAndTransform(i), t = 0, n = e.length; t < n; t++) {
            var r = e[t];
            void 0 !== r.opacity && (i.globalAlpha = r.opacity), i.fillRect(r.x, r.y, r.width, r.width);
          }

          i.restore();
        },
        _render: function _render() {
          var e,
              t,
              n = this.canvas.contextTop;

          for (n.fillStyle = this.color, this._saveAndTransform(n), e = 0, t = this.sprayChunks.length; e < t; e++) {
            this.render(this.sprayChunks[e]);
          }

          n.restore();
        },
        addSprayChunk: function addSprayChunk(e) {
          this.sprayChunkPoints = [];
          var t,
              n,
              i,
              r,
              o = this.width / 2;

          for (r = 0; r < this.density; r++) {
            t = T.util.getRandomInt(e.x - o, e.x + o), n = T.util.getRandomInt(e.y - o, e.y + o), i = this.dotWidthVariance ? T.util.getRandomInt(Math.max(1, this.dotWidth - this.dotWidthVariance), this.dotWidth + this.dotWidthVariance) : this.dotWidth;
            var a = new T.Point(t, n);
            a.width = i, this.randomOpacity && (a.opacity = T.util.getRandomInt(0, 100) / 100), this.sprayChunkPoints.push(a);
          }

          this.sprayChunks.push(this.sprayChunkPoints);
        }
      }), T.PatternBrush = T.util.createClass(T.PencilBrush, {
        getPatternSrc: function getPatternSrc() {
          var e = T.util.createCanvasElement(),
              t = e.getContext("2d");
          return e.width = e.height = 25, t.fillStyle = this.color, t.beginPath(), t.arc(10, 10, 10, 0, 2 * Math.PI, !1), t.closePath(), t.fill(), e;
        },
        getPatternSrcFunction: function getPatternSrcFunction() {
          return String(this.getPatternSrc).replace("this.color", '"' + this.color + '"');
        },
        getPattern: function getPattern() {
          return this.canvas.contextTop.createPattern(this.source || this.getPatternSrc(), "repeat");
        },
        _setBrushStyles: function _setBrushStyles() {
          this.callSuper("_setBrushStyles"), this.canvas.contextTop.strokeStyle = this.getPattern();
        },
        createPath: function createPath(e) {
          var t = this.callSuper("createPath", e),
              n = t._getLeftTopCoords().scalarAdd(t.strokeWidth / 2);

          return t.stroke = new T.Pattern({
            source: this.source || this.getPatternSrcFunction(),
            offsetX: -n.x,
            offsetY: -n.y
          }), t;
        }
      }), function () {
        var e = T.util.getPointer,
            t = T.util.degreesToRadians,
            n = T.util.radiansToDegrees,
            i = Math.atan2,
            r = Math.abs,
            o = T.StaticCanvas.supports("setLineDash");

        for (var a in T.Canvas = T.util.createClass(T.StaticCanvas, {
          initialize: function initialize(e, t) {
            t || (t = {}), this.renderAndResetBound = this.renderAndReset.bind(this), this.requestRenderAllBound = this.requestRenderAll.bind(this), this._initStatic(e, t), this._initInteractive(), this._createCacheCanvas();
          },
          uniScaleTransform: !1,
          uniScaleKey: "shiftKey",
          centeredScaling: !1,
          centeredRotation: !1,
          centeredKey: "altKey",
          altActionKey: "shiftKey",
          interactive: !0,
          selection: !0,
          selectionKey: "shiftKey",
          altSelectionKey: null,
          selectionColor: "rgba(100, 100, 255, 0.3)",
          selectionDashArray: [],
          selectionBorderColor: "rgba(255, 255, 255, 0.3)",
          selectionLineWidth: 1,
          selectionFullyContained: !1,
          hoverCursor: "move",
          moveCursor: "move",
          defaultCursor: "default",
          freeDrawingCursor: "crosshair",
          rotationCursor: "crosshair",
          notAllowedCursor: "not-allowed",
          containerClass: "canvas-container",
          perPixelTargetFind: !1,
          targetFindTolerance: 0,
          skipTargetFind: !1,
          isDrawingMode: !1,
          preserveObjectStacking: !1,
          snapAngle: 0,
          snapThreshold: null,
          stopContextMenu: !1,
          fireRightClick: !1,
          fireMiddleClick: !1,
          targets: [],
          _hoveredTarget: null,
          _hoveredTargets: [],
          _initInteractive: function _initInteractive() {
            this._currentTransform = null, this._groupSelector = null, this._initWrapperElement(), this._createUpperCanvas(), this._initEventListeners(), this._initRetinaScaling(), this.freeDrawingBrush = T.PencilBrush && new T.PencilBrush(this), this.calcOffset();
          },
          _chooseObjectsToRender: function _chooseObjectsToRender() {
            var e,
                t,
                n,
                i = this.getActiveObjects();

            if (i.length > 0 && !this.preserveObjectStacking) {
              t = [], n = [];

              for (var r = 0, o = this._objects.length; r < o; r++) {
                e = this._objects[r], -1 === i.indexOf(e) ? t.push(e) : n.push(e);
              }

              i.length > 1 && (this._activeObject._objects = n), t.push.apply(t, n);
            } else t = this._objects;

            return t;
          },
          renderAll: function renderAll() {
            !this.contextTopDirty || this._groupSelector || this.isDrawingMode || (this.clearContext(this.contextTop), this.contextTopDirty = !1), this.hasLostContext && this.renderTopLayer(this.contextTop);
            var e = this.contextContainer;
            return this.renderCanvas(e, this._chooseObjectsToRender()), this;
          },
          renderTopLayer: function renderTopLayer(e) {
            e.save(), this.isDrawingMode && this._isCurrentlyDrawing && (this.freeDrawingBrush && this.freeDrawingBrush._render(), this.contextTopDirty = !0), this.selection && this._groupSelector && (this._drawSelection(e), this.contextTopDirty = !0), e.restore();
          },
          renderTop: function renderTop() {
            var e = this.contextTop;
            return this.clearContext(e), this.renderTopLayer(e), this.fire("after:render"), this;
          },
          _resetCurrentTransform: function _resetCurrentTransform() {
            var e = this._currentTransform;
            e.target.set({
              scaleX: e.original.scaleX,
              scaleY: e.original.scaleY,
              skewX: e.original.skewX,
              skewY: e.original.skewY,
              left: e.original.left,
              top: e.original.top
            }), this._shouldCenterTransform(e.target) ? ("center" !== e.originX && ("right" === e.originX ? e.mouseXSign = -1 : e.mouseXSign = 1), "center" !== e.originY && ("bottom" === e.originY ? e.mouseYSign = -1 : e.mouseYSign = 1), e.originX = "center", e.originY = "center") : (e.originX = e.original.originX, e.originY = e.original.originY);
          },
          containsPoint: function containsPoint(e, t, n) {
            var i,
                r = n || this.getPointer(e, !0);
            return i = t.group && t.group === this._activeObject && "activeSelection" === t.group.type ? this._normalizePointer(t.group, r) : {
              x: r.x,
              y: r.y
            }, t.containsPoint(i) || t._findTargetCorner(r);
          },
          _normalizePointer: function _normalizePointer(e, t) {
            var n = e.calcTransformMatrix(),
                i = T.util.invertTransform(n),
                r = this.restorePointerVpt(t);
            return T.util.transformPoint(r, i);
          },
          isTargetTransparent: function isTargetTransparent(e, t, n) {
            if (e.shouldCache() && e._cacheCanvas && e !== this._activeObject) {
              var i = this._normalizePointer(e, {
                x: t,
                y: n
              }),
                  r = Math.max(e.cacheTranslationX + i.x * e.zoomX, 0),
                  o = Math.max(e.cacheTranslationY + i.y * e.zoomY, 0);

              return T.util.isTransparent(e._cacheContext, Math.round(r), Math.round(o), this.targetFindTolerance);
            }

            var a = this.contextCache,
                s = e.selectionBackgroundColor,
                l = this.viewportTransform;
            return e.selectionBackgroundColor = "", this.clearContext(a), a.save(), a.transform(l[0], l[1], l[2], l[3], l[4], l[5]), e.render(a), a.restore(), e === this._activeObject && e._renderControls(a, {
              hasBorders: !1,
              transparentCorners: !1
            }, {
              hasBorders: !1
            }), e.selectionBackgroundColor = s, T.util.isTransparent(a, t, n, this.targetFindTolerance);
          },
          _isSelectionKeyPressed: function _isSelectionKeyPressed(e) {
            return "[object Array]" === Object.prototype.toString.call(this.selectionKey) ? !!this.selectionKey.find(function (t) {
              return !0 === e[t];
            }) : e[this.selectionKey];
          },
          _shouldClearSelection: function _shouldClearSelection(e, t) {
            var n = this.getActiveObjects(),
                i = this._activeObject;
            return !t || t && i && n.length > 1 && -1 === n.indexOf(t) && i !== t && !this._isSelectionKeyPressed(e) || t && !t.evented || t && !t.selectable && i && i !== t;
          },
          _shouldCenterTransform: function _shouldCenterTransform(e) {
            if (e) {
              var t,
                  n = this._currentTransform;
              return "scale" === n.action || "scaleX" === n.action || "scaleY" === n.action ? t = this.centeredScaling || e.centeredScaling : "rotate" === n.action && (t = this.centeredRotation || e.centeredRotation), t ? !n.altKey : n.altKey;
            }
          },
          _getOriginFromCorner: function _getOriginFromCorner(e, t) {
            var n = {
              x: e.originX,
              y: e.originY
            };
            return "ml" === t || "tl" === t || "bl" === t ? n.x = "right" : "mr" !== t && "tr" !== t && "br" !== t || (n.x = "left"), "tl" === t || "mt" === t || "tr" === t ? n.y = "bottom" : "bl" !== t && "mb" !== t && "br" !== t || (n.y = "top"), n;
          },
          _getActionFromCorner: function _getActionFromCorner(e, t, n) {
            if (!t || !e) return "drag";

            switch (t) {
              case "mtr":
                return "rotate";

              case "ml":
              case "mr":
                return n[this.altActionKey] ? "skewY" : "scaleX";

              case "mt":
              case "mb":
                return n[this.altActionKey] ? "skewX" : "scaleY";

              default:
                return "scale";
            }
          },
          _setupCurrentTransform: function _setupCurrentTransform(e, n, i) {
            if (n) {
              var r = this.getPointer(e),
                  o = n._findTargetCorner(this.getPointer(e, !0)),
                  a = this._getActionFromCorner(i, o, e, n),
                  s = this._getOriginFromCorner(n, o);

              this._currentTransform = {
                target: n,
                action: a,
                corner: o,
                scaleX: n.scaleX,
                scaleY: n.scaleY,
                skewX: n.skewX,
                skewY: n.skewY,
                offsetX: r.x - n.left,
                offsetY: r.y - n.top,
                originX: s.x,
                originY: s.y,
                ex: r.x,
                ey: r.y,
                lastX: r.x,
                lastY: r.y,
                theta: t(n.angle),
                width: n.width * n.scaleX,
                mouseXSign: 1,
                mouseYSign: 1,
                shiftKey: e.shiftKey,
                altKey: e[this.centeredKey],
                original: T.util.saveObjectTransform(n)
              }, this._currentTransform.original.originX = s.x, this._currentTransform.original.originY = s.y, this._resetCurrentTransform(), this._beforeTransform(e);
            }
          },
          _translateObject: function _translateObject(e, t) {
            var n = this._currentTransform,
                i = n.target,
                r = e - n.offsetX,
                o = t - n.offsetY,
                a = !i.get("lockMovementX") && i.left !== r,
                s = !i.get("lockMovementY") && i.top !== o;
            return a && i.set("left", r), s && i.set("top", o), a || s;
          },
          _changeSkewTransformOrigin: function _changeSkewTransformOrigin(e, t, n) {
            var i = "originX",
                r = {
              0: "center"
            },
                o = t.target.skewX,
                a = "left",
                s = "right",
                l = "mt" === t.corner || "ml" === t.corner ? 1 : -1,
                u = 1;
            e = e > 0 ? 1 : -1, "y" === n && (o = t.target.skewY, a = "top", s = "bottom", i = "originY"), r[-1] = a, r[1] = s, t.target.flipX && (u *= -1), t.target.flipY && (u *= -1), 0 === o ? (t.skewSign = -l * e * u, t[i] = r[-e]) : (o = o > 0 ? 1 : -1, t.skewSign = o, t[i] = r[o * l * u]);
          },
          _skewObject: function _skewObject(e, t, n) {
            var i,
                r = this._currentTransform,
                o = r.target,
                a = o.get("lockSkewingX"),
                s = o.get("lockSkewingY");
            if (a && "x" === n || s && "y" === n) return !1;

            var l,
                u,
                c = o.getCenterPoint(),
                h = o.toLocalPoint(new T.Point(e, t), "center", "center")[n],
                d = o.toLocalPoint(new T.Point(r.lastX, r.lastY), "center", "center")[n],
                f = o._getTransformedDimensions();

            return this._changeSkewTransformOrigin(h - d, r, n), l = o.toLocalPoint(new T.Point(e, t), r.originX, r.originY)[n], u = o.translateToOriginPoint(c, r.originX, r.originY), i = this._setObjectSkew(l, r, n, f), r.lastX = e, r.lastY = t, o.setPositionByOrigin(u, r.originX, r.originY), i;
          },
          _setObjectSkew: function _setObjectSkew(e, t, n, i) {
            var r,
                o,
                a,
                s,
                l,
                u,
                c,
                h,
                d,
                f,
                p = t.target,
                g = t.skewSign;
            return "x" === n ? (l = "y", u = "Y", c = "X", d = 0, f = p.skewY) : (l = "x", u = "X", c = "Y", d = p.skewX, f = 0), s = p._getTransformedDimensions(d, f), (h = 2 * Math.abs(e) - s[n]) <= 2 ? r = 0 : (r = g * Math.atan(h / p["scale" + c] / (s[l] / p["scale" + u])), r = T.util.radiansToDegrees(r)), o = p["skew" + c] !== r, p.set("skew" + c, r), 0 !== p["skew" + u] && (a = p._getTransformedDimensions(), r = i[l] / a[l] * p["scale" + u], p.set("scale" + u, r)), o;
          },
          _scaleObject: function _scaleObject(e, t, n) {
            var i = this._currentTransform,
                r = i.target,
                o = r.lockScalingX,
                a = r.lockScalingY,
                s = r.lockScalingFlip;
            if (o && a) return !1;

            var l,
                u = r.translateToOriginPoint(r.getCenterPoint(), i.originX, i.originY),
                c = r.toLocalPoint(new T.Point(e, t), i.originX, i.originY),
                h = r._getTransformedDimensions();

            return this._setLocalMouse(c, i), l = this._setObjectScale(c, i, o, a, n, s, h), r.setPositionByOrigin(u, i.originX, i.originY), l;
          },
          _setObjectScale: function _setObjectScale(e, t, n, i, r, o, a) {
            var s = t.target,
                l = !1,
                u = !1,
                c = !1,
                h = e.x * s.scaleX / a.x,
                d = e.y * s.scaleY / a.y,
                f = s.scaleX !== h,
                p = s.scaleY !== d;

            if (t.newScaleX = h, t.newScaleY = d, T.Textbox && "x" === r && s instanceof T.Textbox) {
              var g = s.width * (e.x / a.x);
              return g >= s.getMinWidth() && (c = g !== s.width, s.set("width", g), c);
            }

            return o && h <= 0 && h < s.scaleX && (l = !0, e.x = 0), o && d <= 0 && d < s.scaleY && (u = !0, e.y = 0), "equally" !== r || n || i ? r ? "x" !== r || s.get("lockUniScaling") ? "y" !== r || s.get("lockUniScaling") || u || i || s.set("scaleY", d) && (c = p) : l || n || s.set("scaleX", h) && (c = f) : (l || n || s.set("scaleX", h) && (c = c || f), u || i || s.set("scaleY", d) && (c = c || p)) : c = this._scaleObjectEqually(e, s, t, a), l || u || this._flipObject(t, r), c;
          },
          _scaleObjectEqually: function _scaleObjectEqually(e, t, n, i) {
            var r,
                o,
                a,
                s = e.y + e.x,
                l = i.y * n.original.scaleY / t.scaleY + i.x * n.original.scaleX / t.scaleX,
                u = e.x < 0 ? -1 : 1,
                c = e.y < 0 ? -1 : 1;
            return o = u * Math.abs(n.original.scaleX * s / l), a = c * Math.abs(n.original.scaleY * s / l), r = o !== t.scaleX || a !== t.scaleY, t.set("scaleX", o), t.set("scaleY", a), r;
          },
          _flipObject: function _flipObject(e, t) {
            e.newScaleX < 0 && "y" !== t && ("left" === e.originX ? e.originX = "right" : "right" === e.originX && (e.originX = "left")), e.newScaleY < 0 && "x" !== t && ("top" === e.originY ? e.originY = "bottom" : "bottom" === e.originY && (e.originY = "top"));
          },
          _setLocalMouse: function _setLocalMouse(e, t) {
            var n = t.target,
                i = this.getZoom(),
                o = n.padding / i;
            "right" === t.originX ? e.x *= -1 : "center" === t.originX && (e.x *= 2 * t.mouseXSign, e.x < 0 && (t.mouseXSign = -t.mouseXSign)), "bottom" === t.originY ? e.y *= -1 : "center" === t.originY && (e.y *= 2 * t.mouseYSign, e.y < 0 && (t.mouseYSign = -t.mouseYSign)), r(e.x) > o ? e.x < 0 ? e.x += o : e.x -= o : e.x = 0, r(e.y) > o ? e.y < 0 ? e.y += o : e.y -= o : e.y = 0;
          },
          _rotateObject: function _rotateObject(e, t) {
            var r = this._currentTransform,
                o = r.target,
                a = o.translateToOriginPoint(o.getCenterPoint(), r.originX, r.originY);
            if (o.lockRotation) return !1;
            var s = i(r.ey - a.y, r.ex - a.x),
                l = i(t - a.y, e - a.x),
                u = n(l - s + r.theta),
                c = !0;

            if (o.snapAngle > 0) {
              var h = o.snapAngle,
                  d = o.snapThreshold || h,
                  f = Math.ceil(u / h) * h,
                  p = Math.floor(u / h) * h;
              Math.abs(u - p) < d ? u = p : Math.abs(u - f) < d && (u = f);
            }

            return u < 0 && (u = 360 + u), u %= 360, o.angle === u ? c = !1 : (o.angle = u, o.setPositionByOrigin(a, r.originX, r.originY)), c;
          },
          setCursor: function setCursor(e) {
            this.upperCanvasEl.style.cursor = e;
          },
          _drawSelection: function _drawSelection(e) {
            var t = this._groupSelector,
                n = t.left,
                i = t.top,
                a = r(n),
                s = r(i);
            if (this.selectionColor && (e.fillStyle = this.selectionColor, e.fillRect(t.ex - (n > 0 ? 0 : -n), t.ey - (i > 0 ? 0 : -i), a, s)), this.selectionLineWidth && this.selectionBorderColor) if (e.lineWidth = this.selectionLineWidth, e.strokeStyle = this.selectionBorderColor, this.selectionDashArray.length > 1 && !o) {
              var l = t.ex + .5 - (n > 0 ? 0 : a),
                  u = t.ey + .5 - (i > 0 ? 0 : s);
              e.beginPath(), T.util.drawDashedLine(e, l, u, l + a, u, this.selectionDashArray), T.util.drawDashedLine(e, l, u + s - 1, l + a, u + s - 1, this.selectionDashArray), T.util.drawDashedLine(e, l, u, l, u + s, this.selectionDashArray), T.util.drawDashedLine(e, l + a - 1, u, l + a - 1, u + s, this.selectionDashArray), e.closePath(), e.stroke();
            } else T.Object.prototype._setLineDash.call(this, e, this.selectionDashArray), e.strokeRect(t.ex + .5 - (n > 0 ? 0 : a), t.ey + .5 - (i > 0 ? 0 : s), a, s);
          },
          findTarget: function findTarget(e, t) {
            if (!this.skipTargetFind) {
              var n,
                  i,
                  r = this.getPointer(e, !0),
                  o = this._activeObject,
                  a = this.getActiveObjects();
              if (this.targets = [], a.length > 1 && !t && o === this._searchPossibleTargets([o], r)) return o;
              if (1 === a.length && o._findTargetCorner(r)) return o;

              if (1 === a.length && o === this._searchPossibleTargets([o], r)) {
                if (!this.preserveObjectStacking) return o;
                n = o, i = this.targets, this.targets = [];
              }

              var s = this._searchPossibleTargets(this._objects, r);

              return e[this.altSelectionKey] && s && n && s !== n && (s = n, this.targets = i), s;
            }
          },
          _checkTarget: function _checkTarget(e, t, n) {
            if (t && t.visible && t.evented && this.containsPoint(null, t, e)) {
              if (!this.perPixelTargetFind && !t.perPixelTargetFind || t.isEditing) return !0;
              if (!this.isTargetTransparent(t, n.x, n.y)) return !0;
            }
          },
          _searchPossibleTargets: function _searchPossibleTargets(e, t) {
            for (var n, i, r = e.length; r--;) {
              var o = e[r],
                  a = o.group && "activeSelection" !== o.group.type ? this._normalizePointer(o.group, t) : t;

              if (this._checkTarget(a, o, t)) {
                (n = e[r]).subTargetCheck && n instanceof T.Group && (i = this._searchPossibleTargets(n._objects, t)) && this.targets.push(i);
                break;
              }
            }

            return n;
          },
          restorePointerVpt: function restorePointerVpt(e) {
            return T.util.transformPoint(e, T.util.invertTransform(this.viewportTransform));
          },
          getPointer: function getPointer(t, n) {
            if (this._absolutePointer && !n) return this._absolutePointer;
            if (this._pointer && n) return this._pointer;
            var i,
                r = e(t),
                o = this.upperCanvasEl,
                a = o.getBoundingClientRect(),
                s = a.width || 0,
                l = a.height || 0;
            s && l || ("top" in a && "bottom" in a && (l = Math.abs(a.top - a.bottom)), "right" in a && "left" in a && (s = Math.abs(a.right - a.left))), this.calcOffset(), r.x = r.x - this._offset.left, r.y = r.y - this._offset.top, n || (r = this.restorePointerVpt(r));
            var u = this.getRetinaScaling();
            return 1 !== u && (r.x /= u, r.y /= u), i = 0 === s || 0 === l ? {
              width: 1,
              height: 1
            } : {
              width: o.width / s,
              height: o.height / l
            }, {
              x: r.x * i.width,
              y: r.y * i.height
            };
          },
          _createUpperCanvas: function _createUpperCanvas() {
            var e = this.lowerCanvasEl.className.replace(/\s*lower-canvas\s*/, ""),
                t = this.lowerCanvasEl,
                n = this.upperCanvasEl;
            n ? n.className = "" : (n = this._createCanvasElement(), this.upperCanvasEl = n), T.util.addClass(n, "upper-canvas " + e), this.wrapperEl.appendChild(n), this._copyCanvasStyle(t, n), this._applyCanvasStyle(n), this.contextTop = n.getContext("2d");
          },
          _createCacheCanvas: function _createCacheCanvas() {
            this.cacheCanvasEl = this._createCanvasElement(), this.cacheCanvasEl.setAttribute("width", this.width), this.cacheCanvasEl.setAttribute("height", this.height), this.contextCache = this.cacheCanvasEl.getContext("2d");
          },
          _initWrapperElement: function _initWrapperElement() {
            this.wrapperEl = T.util.wrapElement(this.lowerCanvasEl, "div", {
              class: this.containerClass
            }), T.util.setStyle(this.wrapperEl, {
              width: this.width + "px",
              height: this.height + "px",
              position: "relative"
            }), T.util.makeElementUnselectable(this.wrapperEl);
          },
          _applyCanvasStyle: function _applyCanvasStyle(e) {
            var t = this.width || e.width,
                n = this.height || e.height;
            T.util.setStyle(e, {
              position: "absolute",
              width: t + "px",
              height: n + "px",
              left: 0,
              top: 0,
              "touch-action": this.allowTouchScrolling ? "manipulation" : "none",
              "-ms-touch-action": this.allowTouchScrolling ? "manipulation" : "none"
            }), e.width = t, e.height = n, T.util.makeElementUnselectable(e);
          },
          _copyCanvasStyle: function _copyCanvasStyle(e, t) {
            t.style.cssText = e.style.cssText;
          },
          getSelectionContext: function getSelectionContext() {
            return this.contextTop;
          },
          getSelectionElement: function getSelectionElement() {
            return this.upperCanvasEl;
          },
          getActiveObject: function getActiveObject() {
            return this._activeObject;
          },
          getActiveObjects: function getActiveObjects() {
            var e = this._activeObject;
            return e ? "activeSelection" === e.type && e._objects ? e._objects.slice(0) : [e] : [];
          },
          _onObjectRemoved: function _onObjectRemoved(e) {
            e === this._activeObject && (this.fire("before:selection:cleared", {
              target: e
            }), this._discardActiveObject(), this.fire("selection:cleared", {
              target: e
            }), e.fire("deselected")), e === this._hoveredTarget && (this._hoveredTarget = null, this._hoveredTargets = []), this.callSuper("_onObjectRemoved", e);
          },
          _fireSelectionEvents: function _fireSelectionEvents(e, t) {
            var n = !1,
                i = this.getActiveObjects(),
                r = [],
                o = [],
                a = {
              e: t
            };
            e.forEach(function (e) {
              -1 === i.indexOf(e) && (n = !0, e.fire("deselected", a), o.push(e));
            }), i.forEach(function (t) {
              -1 === e.indexOf(t) && (n = !0, t.fire("selected", a), r.push(t));
            }), e.length > 0 && i.length > 0 ? (a.selected = r, a.deselected = o, a.updated = r[0] || o[0], a.target = this._activeObject, n && this.fire("selection:updated", a)) : i.length > 0 ? (1 === i.length && (a.target = r[0], this.fire("object:selected", a)), a.selected = r, a.target = this._activeObject, this.fire("selection:created", a)) : e.length > 0 && (a.deselected = o, this.fire("selection:cleared", a));
          },
          setActiveObject: function setActiveObject(e, t) {
            var n = this.getActiveObjects();
            return this._setActiveObject(e, t), this._fireSelectionEvents(n, t), this;
          },
          _setActiveObject: function _setActiveObject(e, t) {
            return this._activeObject !== e && !!this._discardActiveObject(t, e) && !e.onSelect({
              e: t
            }) && (this._activeObject = e, !0);
          },
          _discardActiveObject: function _discardActiveObject(e, t) {
            var n = this._activeObject;

            if (n) {
              if (n.onDeselect({
                e: e,
                object: t
              })) return !1;
              this._activeObject = null;
            }

            return !0;
          },
          discardActiveObject: function discardActiveObject(e) {
            var t = this.getActiveObjects(),
                n = this.getActiveObject();
            return t.length && this.fire("before:selection:cleared", {
              target: n,
              e: e
            }), this._discardActiveObject(e), this._fireSelectionEvents(t, e), this;
          },
          dispose: function dispose() {
            var e = this.wrapperEl;
            return this.removeListeners(), e.removeChild(this.upperCanvasEl), e.removeChild(this.lowerCanvasEl), this.contextCache = null, this.contextTop = null, ["upperCanvasEl", "cacheCanvasEl"].forEach(function (e) {
              T.util.cleanUpJsdomNode(this[e]), this[e] = void 0;
            }.bind(this)), e.parentNode && e.parentNode.replaceChild(this.lowerCanvasEl, this.wrapperEl), delete this.wrapperEl, T.StaticCanvas.prototype.dispose.call(this), this;
          },
          clear: function clear() {
            return this.discardActiveObject(), this.clearContext(this.contextTop), this.callSuper("clear");
          },
          drawControls: function drawControls(e) {
            var t = this._activeObject;
            t && t._renderControls(e);
          },
          _toObject: function _toObject(e, t, n) {
            var i = this._realizeGroupTransformOnObject(e),
                r = this.callSuper("_toObject", e, t, n);

            return this._unwindGroupTransformOnObject(e, i), r;
          },
          _realizeGroupTransformOnObject: function _realizeGroupTransformOnObject(e) {
            if (e.group && "activeSelection" === e.group.type && this._activeObject === e.group) {
              var t = {};
              return ["angle", "flipX", "flipY", "left", "scaleX", "scaleY", "skewX", "skewY", "top"].forEach(function (n) {
                t[n] = e[n];
              }), this._activeObject.realizeTransform(e), t;
            }

            return null;
          },
          _unwindGroupTransformOnObject: function _unwindGroupTransformOnObject(e, t) {
            t && e.set(t);
          },
          _setSVGObject: function _setSVGObject(e, t, n) {
            var i = this._realizeGroupTransformOnObject(t);

            this.callSuper("_setSVGObject", e, t, n), this._unwindGroupTransformOnObject(t, i);
          },
          setViewportTransform: function setViewportTransform(e) {
            this.renderOnAddRemove && this._activeObject && this._activeObject.isEditing && this._activeObject.clearContextTop(), T.StaticCanvas.prototype.setViewportTransform.call(this, e);
          }
        }), T.StaticCanvas) {
          "prototype" !== a && (T.Canvas[a] = T.StaticCanvas[a]);
        }
      }(), function () {
        var e = {
          mt: 0,
          tr: 1,
          mr: 2,
          br: 3,
          mb: 4,
          bl: 5,
          ml: 6,
          tl: 7
        },
            t = T.util.addListener,
            n = T.util.removeListener,
            i = {
          passive: !1
        };

        function r(e, t) {
          return e.button && e.button === t - 1;
        }

        T.util.object.extend(T.Canvas.prototype, {
          cursorMap: ["n-resize", "ne-resize", "e-resize", "se-resize", "s-resize", "sw-resize", "w-resize", "nw-resize"],
          mainTouchId: null,
          _initEventListeners: function _initEventListeners() {
            this.removeListeners(), this._bindEvents(), this.addOrRemove(t, "add");
          },
          _getEventPrefix: function _getEventPrefix() {
            return this.enablePointerEvents ? "pointer" : "mouse";
          },
          addOrRemove: function addOrRemove(e, t) {
            var n = this.upperCanvasEl,
                r = this._getEventPrefix();

            e(T.window, "resize", this._onResize), e(n, r + "down", this._onMouseDown), e(n, r + "move", this._onMouseMove, i), e(n, r + "out", this._onMouseOut), e(n, r + "enter", this._onMouseEnter), e(n, "wheel", this._onMouseWheel), e(n, "contextmenu", this._onContextMenu), e(n, "dblclick", this._onDoubleClick), e(n, "dragover", this._onDragOver), e(n, "dragenter", this._onDragEnter), e(n, "dragleave", this._onDragLeave), e(n, "drop", this._onDrop), this.enablePointerEvents || e(n, "touchstart", this._onTouchStart, i), "undefined" != typeof eventjs && t in eventjs && (eventjs[t](n, "gesture", this._onGesture), eventjs[t](n, "drag", this._onDrag), eventjs[t](n, "orientation", this._onOrientationChange), eventjs[t](n, "shake", this._onShake), eventjs[t](n, "longpress", this._onLongPress));
          },
          removeListeners: function removeListeners() {
            this.addOrRemove(n, "remove");

            var e = this._getEventPrefix();

            n(T.document, e + "up", this._onMouseUp), n(T.document, "touchend", this._onTouchEnd, i), n(T.document, e + "move", this._onMouseMove, i), n(T.document, "touchmove", this._onMouseMove, i);
          },
          _bindEvents: function _bindEvents() {
            this.eventsBound || (this._onMouseDown = this._onMouseDown.bind(this), this._onTouchStart = this._onTouchStart.bind(this), this._onMouseMove = this._onMouseMove.bind(this), this._onMouseUp = this._onMouseUp.bind(this), this._onTouchEnd = this._onTouchEnd.bind(this), this._onResize = this._onResize.bind(this), this._onGesture = this._onGesture.bind(this), this._onDrag = this._onDrag.bind(this), this._onShake = this._onShake.bind(this), this._onLongPress = this._onLongPress.bind(this), this._onOrientationChange = this._onOrientationChange.bind(this), this._onMouseWheel = this._onMouseWheel.bind(this), this._onMouseOut = this._onMouseOut.bind(this), this._onMouseEnter = this._onMouseEnter.bind(this), this._onContextMenu = this._onContextMenu.bind(this), this._onDoubleClick = this._onDoubleClick.bind(this), this._onDragOver = this._onDragOver.bind(this), this._onDragEnter = this._simpleEventHandler.bind(this, "dragenter"), this._onDragLeave = this._simpleEventHandler.bind(this, "dragleave"), this._onDrop = this._simpleEventHandler.bind(this, "drop"), this.eventsBound = !0);
          },
          _onGesture: function _onGesture(e, t) {
            this.__onTransformGesture && this.__onTransformGesture(e, t);
          },
          _onDrag: function _onDrag(e, t) {
            this.__onDrag && this.__onDrag(e, t);
          },
          _onMouseWheel: function _onMouseWheel(e) {
            this.__onMouseWheel(e);
          },
          _onMouseOut: function _onMouseOut(e) {
            var t = this._hoveredTarget;
            this.fire("mouse:out", {
              target: t,
              e: e
            }), this._hoveredTarget = null, t && t.fire("mouseout", {
              e: e
            });
            var n = this;
            this._hoveredTargets.forEach(function (i) {
              n.fire("mouse:out", {
                target: t,
                e: e
              }), i && t.fire("mouseout", {
                e: e
              });
            }), this._hoveredTargets = [], this._iTextInstances && this._iTextInstances.forEach(function (e) {
              e.isEditing && e.hiddenTextarea.focus();
            });
          },
          _onMouseEnter: function _onMouseEnter(e) {
            this.currentTransform || this.findTarget(e) || (this.fire("mouse:over", {
              target: null,
              e: e
            }), this._hoveredTarget = null, this._hoveredTargets = []);
          },
          _onOrientationChange: function _onOrientationChange(e, t) {
            this.__onOrientationChange && this.__onOrientationChange(e, t);
          },
          _onShake: function _onShake(e, t) {
            this.__onShake && this.__onShake(e, t);
          },
          _onLongPress: function _onLongPress(e, t) {
            this.__onLongPress && this.__onLongPress(e, t);
          },
          _onDragOver: function _onDragOver(e) {
            e.preventDefault();

            var t = this._simpleEventHandler("dragover", e);

            this._fireEnterLeaveEvents(t, e);
          },
          _onContextMenu: function _onContextMenu(e) {
            return this.stopContextMenu && (e.stopPropagation(), e.preventDefault()), !1;
          },
          _onDoubleClick: function _onDoubleClick(e) {
            this._cacheTransformEventData(e), this._handleEvent(e, "dblclick"), this._resetTransformEventData(e);
          },
          getPointerId: function getPointerId(e) {
            var t = e.changedTouches;
            return t ? t[0] && t[0].identifier : this.enablePointerEvents ? e.pointerId : -1;
          },
          _isMainEvent: function _isMainEvent(e) {
            return !0 === e.isPrimary || !1 !== e.isPrimary && ("touchend" === e.type && 0 === e.touches.length || !e.changedTouches || e.changedTouches[0].identifier === this.mainTouchId);
          },
          _onTouchStart: function _onTouchStart(e) {
            e.preventDefault(), null === this.mainTouchId && (this.mainTouchId = this.getPointerId(e)), this.__onMouseDown(e), this._resetTransformEventData();

            var r = this.upperCanvasEl,
                o = this._getEventPrefix();

            t(T.document, "touchend", this._onTouchEnd, i), t(T.document, "touchmove", this._onMouseMove, i), n(r, o + "down", this._onMouseDown);
          },
          _onMouseDown: function _onMouseDown(e) {
            this.__onMouseDown(e), this._resetTransformEventData();

            var r = this.upperCanvasEl,
                o = this._getEventPrefix();

            n(r, o + "move", this._onMouseMove, i), t(T.document, o + "up", this._onMouseUp), t(T.document, o + "move", this._onMouseMove, i);
          },
          _onTouchEnd: function _onTouchEnd(e) {
            if (!(e.touches.length > 0)) {
              this.__onMouseUp(e), this._resetTransformEventData(), this.mainTouchId = null;

              var r = this._getEventPrefix();

              n(T.document, "touchend", this._onTouchEnd, i), n(T.document, "touchmove", this._onMouseMove, i);
              var o = this;
              this._willAddMouseDown && clearTimeout(this._willAddMouseDown), this._willAddMouseDown = setTimeout(function () {
                t(o.upperCanvasEl, r + "down", o._onMouseDown), o._willAddMouseDown = 0;
              }, 400);
            }
          },
          _onMouseUp: function _onMouseUp(e) {
            this.__onMouseUp(e), this._resetTransformEventData();

            var r = this.upperCanvasEl,
                o = this._getEventPrefix();

            this._isMainEvent(e) && (n(T.document, o + "up", this._onMouseUp), n(T.document, o + "move", this._onMouseMove, i), t(r, o + "move", this._onMouseMove, i));
          },
          _onMouseMove: function _onMouseMove(e) {
            !this.allowTouchScrolling && e.preventDefault && e.preventDefault(), this.__onMouseMove(e);
          },
          _onResize: function _onResize() {
            this.calcOffset();
          },
          _shouldRender: function _shouldRender(e) {
            var t = this._activeObject;
            return !!(!!t != !!e || t && e && t !== e) || (t && t.isEditing, !1);
          },
          __onMouseUp: function __onMouseUp(e) {
            var t,
                n = this._currentTransform,
                i = this._groupSelector,
                o = !1,
                a = !i || 0 === i.left && 0 === i.top;
            if (this._cacheTransformEventData(e), t = this._target, this._handleEvent(e, "up:before"), !r(e, 3)) return r(e, 2) ? (this.fireMiddleClick && this._handleEvent(e, "up", 2, a), void this._resetTransformEventData()) : void (this.isDrawingMode && this._isCurrentlyDrawing ? this._onMouseUpInDrawingMode(e) : this._isMainEvent(e) && (n && (this._finalizeCurrentTransform(e), o = n.actionPerformed), a || (this._maybeGroupObjects(e), o || (o = this._shouldRender(t))), t && (t.isMoving = !1), this._setCursorFromEvent(e, t), this._handleEvent(e, "up", 1, a), this._groupSelector = null, this._currentTransform = null, t && (t.__corner = 0), o ? this.requestRenderAll() : a || this.renderTop()));
            this.fireRightClick && this._handleEvent(e, "up", 3, a);
          },
          _simpleEventHandler: function _simpleEventHandler(e, t) {
            var n = this.findTarget(t),
                i = this.targets,
                r = {
              e: t,
              target: n,
              subTargets: i
            };
            if (this.fire(e, r), n && n.fire(e, r), !i) return n;

            for (var o = 0; o < i.length; o++) {
              i[o].fire(e, r);
            }

            return n;
          },
          _handleEvent: function _handleEvent(e, t, n, i) {
            var r = this._target,
                o = this.targets || [],
                a = {
              e: e,
              target: r,
              subTargets: o,
              button: n || 1,
              isClick: i || !1,
              pointer: this._pointer,
              absolutePointer: this._absolutePointer,
              transform: this._currentTransform
            };
            this.fire("mouse:" + t, a), r && r.fire("mouse" + t, a);

            for (var s = 0; s < o.length; s++) {
              o[s].fire("mouse" + t, a);
            }
          },
          _finalizeCurrentTransform: function _finalizeCurrentTransform(e) {
            var t,
                n = this._currentTransform,
                i = n.target,
                r = {
              e: e,
              target: i,
              transform: n
            };
            i._scaling && (i._scaling = !1), i.setCoords(), (n.actionPerformed || this.stateful && i.hasStateChanged()) && (n.actionPerformed && (t = this._addEventOptions(r, n), this._fire(t, r)), this._fire("modified", r));
          },
          _addEventOptions: function _addEventOptions(e, t) {
            var n, i;

            switch (t.action) {
              case "scaleX":
                n = "scaled", i = "x";
                break;

              case "scaleY":
                n = "scaled", i = "y";
                break;

              case "skewX":
                n = "skewed", i = "x";
                break;

              case "skewY":
                n = "skewed", i = "y";
                break;

              case "scale":
                n = "scaled", i = "equally";
                break;

              case "rotate":
                n = "rotated";
                break;

              case "drag":
                n = "moved";
            }

            return e.by = i, n;
          },
          _onMouseDownInDrawingMode: function _onMouseDownInDrawingMode(e) {
            this._isCurrentlyDrawing = !0, this.getActiveObject() && this.discardActiveObject(e).requestRenderAll(), this.clipTo && T.util.clipContext(this, this.contextTop);
            var t = this.getPointer(e);
            this.freeDrawingBrush.onMouseDown(t, {
              e: e,
              pointer: t
            }), this._handleEvent(e, "down");
          },
          _onMouseMoveInDrawingMode: function _onMouseMoveInDrawingMode(e) {
            if (this._isCurrentlyDrawing) {
              var t = this.getPointer(e);
              this.freeDrawingBrush.onMouseMove(t, {
                e: e,
                pointer: t
              });
            }

            this.setCursor(this.freeDrawingCursor), this._handleEvent(e, "move");
          },
          _onMouseUpInDrawingMode: function _onMouseUpInDrawingMode(e) {
            this.clipTo && this.contextTop.restore();
            var t = this.getPointer(e);
            this._isCurrentlyDrawing = this.freeDrawingBrush.onMouseUp({
              e: e,
              pointer: t
            }), this._handleEvent(e, "up");
          },
          __onMouseDown: function __onMouseDown(e) {
            this._cacheTransformEventData(e), this._handleEvent(e, "down:before");
            var t = this._target;
            if (r(e, 3)) this.fireRightClick && this._handleEvent(e, "down", 3);else if (r(e, 2)) this.fireMiddleClick && this._handleEvent(e, "down", 2);else if (this.isDrawingMode) this._onMouseDownInDrawingMode(e);else if (this._isMainEvent(e) && !this._currentTransform) {
              var n = this._pointer;
              this._previousPointer = n;

              var i = this._shouldRender(t),
                  o = this._shouldGroup(e, t);

              if (this._shouldClearSelection(e, t) ? this.discardActiveObject(e) : o && (this._handleGrouping(e, t), t = this._activeObject), !this.selection || t && (t.selectable || t.isEditing || t === this._activeObject) || (this._groupSelector = {
                ex: n.x,
                ey: n.y,
                top: 0,
                left: 0
              }), t) {
                var a = t === this._activeObject;
                t.selectable && this.setActiveObject(t, e), t !== this._activeObject || !t.__corner && o || this._setupCurrentTransform(e, t, a);
              }

              this._handleEvent(e, "down"), (i || o) && this.requestRenderAll();
            }
          },
          _resetTransformEventData: function _resetTransformEventData() {
            this._target = null, this._pointer = null, this._absolutePointer = null;
          },
          _cacheTransformEventData: function _cacheTransformEventData(e) {
            this._resetTransformEventData(), this._pointer = this.getPointer(e, !0), this._absolutePointer = this.restorePointerVpt(this._pointer), this._target = this._currentTransform ? this._currentTransform.target : this.findTarget(e) || null;
          },
          _beforeTransform: function _beforeTransform(e) {
            var t = this._currentTransform;
            this.stateful && t.target.saveState(), this.fire("before:transform", {
              e: e,
              transform: t
            }), t.corner && this.onBeforeScaleRotate(t.target);
          },
          __onMouseMove: function __onMouseMove(e) {
            var t, n;
            if (this._handleEvent(e, "move:before"), this._cacheTransformEventData(e), this.isDrawingMode) this._onMouseMoveInDrawingMode(e);else if (this._isMainEvent(e)) {
              var i = this._groupSelector;
              i ? (n = this._pointer, i.left = n.x - i.ex, i.top = n.y - i.ey, this.renderTop()) : this._currentTransform ? this._transformObject(e) : (t = this.findTarget(e) || null, this._setCursorFromEvent(e, t), this._fireOverOutEvents(t, e)), this._handleEvent(e, "move"), this._resetTransformEventData();
            }
          },
          _fireOverOutEvents: function _fireOverOutEvents(e, t) {
            var n = this._hoveredTarget,
                i = this._hoveredTargets,
                r = this.targets,
                o = Math.max(i.length, r.length);
            this.fireSyntheticInOutEvents(e, t, {
              oldTarget: n,
              evtOut: "mouseout",
              canvasEvtOut: "mouse:out",
              evtIn: "mouseover",
              canvasEvtIn: "mouse:over"
            });

            for (var a = 0; a < o; a++) {
              this.fireSyntheticInOutEvents(r[a], t, {
                oldTarget: i[a],
                evtOut: "mouseout",
                evtIn: "mouseover"
              });
            }

            this._hoveredTarget = e, this._hoveredTargets = this.targets.concat();
          },
          _fireEnterLeaveEvents: function _fireEnterLeaveEvents(e, t) {
            var n = this._draggedoverTarget,
                i = this._hoveredTargets,
                r = this.targets,
                o = Math.max(i.length, r.length);
            this.fireSyntheticInOutEvents(e, t, {
              oldTarget: n,
              evtOut: "dragleave",
              evtIn: "dragenter"
            });

            for (var a = 0; a < o; a++) {
              this.fireSyntheticInOutEvents(r[a], t, {
                oldTarget: i[a],
                evtOut: "dragleave",
                evtIn: "dragenter"
              });
            }

            this._draggedoverTarget = e;
          },
          fireSyntheticInOutEvents: function fireSyntheticInOutEvents(e, t, n) {
            var i,
                r,
                o,
                a = n.oldTarget,
                s = a !== e,
                l = n.canvasEvtIn,
                u = n.canvasEvtOut;
            s && (i = {
              e: t,
              target: e,
              previousTarget: a
            }, r = {
              e: t,
              target: a,
              nextTarget: e
            }), o = e && s, a && s && (u && this.fire(u, r), a.fire(n.evtOut, r)), o && (l && this.fire(l, i), e.fire(n.evtIn, i));
          },
          __onMouseWheel: function __onMouseWheel(e) {
            this._cacheTransformEventData(e), this._handleEvent(e, "wheel"), this._resetTransformEventData();
          },
          _transformObject: function _transformObject(e) {
            var t = this.getPointer(e),
                n = this._currentTransform;
            n.reset = !1, n.target.isMoving = !0, n.shiftKey = e.shiftKey, n.altKey = e[this.centeredKey], this._beforeScaleTransform(e, n), this._performTransformAction(e, n, t), n.actionPerformed && this.requestRenderAll();
          },
          _performTransformAction: function _performTransformAction(e, t, n) {
            var i = n.x,
                r = n.y,
                o = t.action,
                a = !1,
                s = {
              target: t.target,
              e: e,
              transform: t,
              pointer: n
            };
            "rotate" === o ? (a = this._rotateObject(i, r)) && this._fire("rotating", s) : "scale" === o ? (a = this._onScale(e, t, i, r)) && this._fire("scaling", s) : "scaleX" === o ? (a = this._scaleObject(i, r, "x")) && this._fire("scaling", s) : "scaleY" === o ? (a = this._scaleObject(i, r, "y")) && this._fire("scaling", s) : "skewX" === o ? (a = this._skewObject(i, r, "x")) && this._fire("skewing", s) : "skewY" === o ? (a = this._skewObject(i, r, "y")) && this._fire("skewing", s) : (a = this._translateObject(i, r)) && (this._fire("moving", s), this.setCursor(s.target.moveCursor || this.moveCursor)), t.actionPerformed = t.actionPerformed || a;
          },
          _fire: function _fire(e, t) {
            this.fire("object:" + e, t), t.target.fire(e, t);
          },
          _beforeScaleTransform: function _beforeScaleTransform(e, t) {
            if ("scale" === t.action || "scaleX" === t.action || "scaleY" === t.action) {
              var n = this._shouldCenterTransform(t.target);

              (n && ("center" !== t.originX || "center" !== t.originY) || !n && "center" === t.originX && "center" === t.originY) && (this._resetCurrentTransform(), t.reset = !0);
            }
          },
          _onScale: function _onScale(e, t, n, i) {
            return this._isUniscalePossible(e, t.target) ? (t.currentAction = "scale", this._scaleObject(n, i)) : (t.reset || "scale" !== t.currentAction || this._resetCurrentTransform(), t.currentAction = "scaleEqually", this._scaleObject(n, i, "equally"));
          },
          _isUniscalePossible: function _isUniscalePossible(e, t) {
            return (e[this.uniScaleKey] || this.uniScaleTransform) && !t.get("lockUniScaling");
          },
          _setCursorFromEvent: function _setCursorFromEvent(e, t) {
            if (!t) return this.setCursor(this.defaultCursor), !1;

            var n = t.hoverCursor || this.hoverCursor,
                i = this._activeObject && "activeSelection" === this._activeObject.type ? this._activeObject : null,
                r = (!i || !i.contains(t)) && t._findTargetCorner(this.getPointer(e, !0));

            r ? this.setCursor(this.getCornerCursor(r, t, e)) : (t.subTargetCheck && this.targets.concat().reverse().map(function (e) {
              n = e.hoverCursor || n;
            }), this.setCursor(n));
          },
          getCornerCursor: function getCornerCursor(t, n, i) {
            return this.actionIsDisabled(t, n, i) ? this.notAllowedCursor : t in e ? this._getRotatedCornerCursor(t, n, i) : "mtr" === t && n.hasRotatingPoint ? this.rotationCursor : this.defaultCursor;
          },
          actionIsDisabled: function actionIsDisabled(e, t, n) {
            return "mt" === e || "mb" === e ? n[this.altActionKey] ? t.lockSkewingX : t.lockScalingY : "ml" === e || "mr" === e ? n[this.altActionKey] ? t.lockSkewingY : t.lockScalingX : "mtr" === e ? t.lockRotation : this._isUniscalePossible(n, t) ? t.lockScalingX && t.lockScalingY : t.lockScalingX || t.lockScalingY;
          },
          _getRotatedCornerCursor: function _getRotatedCornerCursor(t, n, i) {
            var r = Math.round(n.angle % 360 / 45);
            return r < 0 && (r += 8), r += e[t], i[this.altActionKey] && e[t] % 2 == 0 && (r += 2), r %= 8, this.cursorMap[r];
          }
        });
      }(), v = Math.min, m = Math.max, T.util.object.extend(T.Canvas.prototype, {
        _shouldGroup: function _shouldGroup(e, t) {
          var n = this._activeObject;
          return n && this._isSelectionKeyPressed(e) && t && t.selectable && this.selection && (n !== t || "activeSelection" === n.type) && !t.onSelect({
            e: e
          });
        },
        _handleGrouping: function _handleGrouping(e, t) {
          var n = this._activeObject;
          n.__corner || (t !== n || (t = this.findTarget(e, !0)) && t.selectable) && (n && "activeSelection" === n.type ? this._updateActiveSelection(t, e) : this._createActiveSelection(t, e));
        },
        _updateActiveSelection: function _updateActiveSelection(e, t) {
          var n = this._activeObject,
              i = n._objects.slice(0);

          n.contains(e) ? (n.removeWithUpdate(e), this._hoveredTarget = e, this._hoveredTargets = this.targets.concat(), 1 === n.size() && this._setActiveObject(n.item(0), t)) : (n.addWithUpdate(e), this._hoveredTarget = n, this._hoveredTargets = this.targets.concat()), this._fireSelectionEvents(i, t);
        },
        _createActiveSelection: function _createActiveSelection(e, t) {
          var n = this.getActiveObjects(),
              i = this._createGroup(e);

          this._hoveredTarget = i, this._setActiveObject(i, t), this._fireSelectionEvents(n, t);
        },
        _createGroup: function _createGroup(e) {
          var t = this._objects,
              n = t.indexOf(this._activeObject) < t.indexOf(e) ? [this._activeObject, e] : [e, this._activeObject];
          return this._activeObject.isEditing && this._activeObject.exitEditing(), new T.ActiveSelection(n, {
            canvas: this
          });
        },
        _groupSelectedObjects: function _groupSelectedObjects(e) {
          var t,
              n = this._collectObjects(e);

          1 === n.length ? this.setActiveObject(n[0], e) : n.length > 1 && (t = new T.ActiveSelection(n.reverse(), {
            canvas: this
          }), this.setActiveObject(t, e));
        },
        _collectObjects: function _collectObjects(e) {
          for (var t, n = [], i = this._groupSelector.ex, r = this._groupSelector.ey, o = i + this._groupSelector.left, a = r + this._groupSelector.top, s = new T.Point(v(i, o), v(r, a)), l = new T.Point(m(i, o), m(r, a)), u = !this.selectionFullyContained, c = i === o && r === a, h = this._objects.length; h-- && !((t = this._objects[h]) && t.selectable && t.visible && (u && t.intersectsWithRect(s, l) || t.isContainedWithinRect(s, l) || u && t.containsPoint(s) || u && t.containsPoint(l)) && (n.push(t), c));) {
            ;
          }

          return n.length > 1 && (n = n.filter(function (t) {
            return !t.onSelect({
              e: e
            });
          })), n;
        },
        _maybeGroupObjects: function _maybeGroupObjects(e) {
          this.selection && this._groupSelector && this._groupSelectedObjects(e), this.setCursor(this.defaultCursor), this._groupSelector = null;
        }
      }), T.util.object.extend(T.StaticCanvas.prototype, {
        toDataURL: function toDataURL(e) {
          e || (e = {});
          var t = e.format || "png",
              n = e.quality || 1,
              i = (e.multiplier || 1) * (e.enableRetinaScaling ? this.getRetinaScaling() : 1),
              r = this.toCanvasElement(i, e);
          return T.util.toDataURL(r, t, n);
        },
        toCanvasElement: function toCanvasElement(e, t) {
          e = e || 1;
          var n = ((t = t || {}).width || this.width) * e,
              i = (t.height || this.height) * e,
              r = this.getZoom(),
              o = this.width,
              a = this.height,
              s = r * e,
              l = this.viewportTransform,
              u = (l[4] - (t.left || 0)) * e,
              c = (l[5] - (t.top || 0)) * e,
              h = this.interactive,
              d = [s, 0, 0, s, u, c],
              f = this.enableRetinaScaling,
              p = T.util.createCanvasElement(),
              g = this.contextTop;
          return p.width = n, p.height = i, this.contextTop = null, this.enableRetinaScaling = !1, this.interactive = !1, this.viewportTransform = d, this.width = n, this.height = i, this.calcViewportBoundaries(), this.renderCanvas(p.getContext("2d"), this._objects), this.viewportTransform = l, this.width = o, this.height = a, this.calcViewportBoundaries(), this.interactive = h, this.enableRetinaScaling = f, this.contextTop = g, p;
        }
      }), T.util.object.extend(T.StaticCanvas.prototype, {
        loadFromDatalessJSON: function loadFromDatalessJSON(e, t, n) {
          return this.loadFromJSON(e, t, n);
        },
        loadFromJSON: function loadFromJSON(e, t, n) {
          if (e) {
            var i = "string" == typeof e ? JSON.parse(e) : T.util.object.clone(e),
                r = this,
                o = i.clipPath,
                a = this.renderOnAddRemove;
            return this.renderOnAddRemove = !1, delete i.clipPath, this._enlivenObjects(i.objects, function (e) {
              r.clear(), r._setBgOverlay(i, function () {
                o ? r._enlivenObjects([o], function (n) {
                  r.clipPath = n[0], r.__setupCanvas.call(r, i, e, a, t);
                }) : r.__setupCanvas.call(r, i, e, a, t);
              });
            }, n), this;
          }
        },
        __setupCanvas: function __setupCanvas(e, t, n, i) {
          var r = this;
          t.forEach(function (e, t) {
            r.insertAt(e, t);
          }), this.renderOnAddRemove = n, delete e.objects, delete e.backgroundImage, delete e.overlayImage, delete e.background, delete e.overlay, this._setOptions(e), this.renderAll(), i && i();
        },
        _setBgOverlay: function _setBgOverlay(e, t) {
          var n = {
            backgroundColor: !1,
            overlayColor: !1,
            backgroundImage: !1,
            overlayImage: !1
          };

          if (e.backgroundImage || e.overlayImage || e.background || e.overlay) {
            var i = function i() {
              n.backgroundImage && n.overlayImage && n.backgroundColor && n.overlayColor && t && t();
            };

            this.__setBgOverlay("backgroundImage", e.backgroundImage, n, i), this.__setBgOverlay("overlayImage", e.overlayImage, n, i), this.__setBgOverlay("backgroundColor", e.background, n, i), this.__setBgOverlay("overlayColor", e.overlay, n, i);
          } else t && t();
        },
        __setBgOverlay: function __setBgOverlay(e, t, n, i) {
          var r = this;
          if (!t) return n[e] = !0, void (i && i());
          "backgroundImage" === e || "overlayImage" === e ? T.util.enlivenObjects([t], function (t) {
            r[e] = t[0], n[e] = !0, i && i();
          }) : this["set" + T.util.string.capitalize(e, !0)](t, function () {
            n[e] = !0, i && i();
          });
        },
        _enlivenObjects: function _enlivenObjects(e, t, n) {
          e && 0 !== e.length ? T.util.enlivenObjects(e, function (e) {
            t && t(e);
          }, null, n) : t && t([]);
        },
        _toDataURL: function _toDataURL(e, t) {
          this.clone(function (n) {
            t(n.toDataURL(e));
          });
        },
        _toDataURLWithMultiplier: function _toDataURLWithMultiplier(e, t, n) {
          this.clone(function (i) {
            n(i.toDataURLWithMultiplier(e, t));
          });
        },
        clone: function clone(e, t) {
          var n = JSON.stringify(this.toJSON(t));
          this.cloneWithoutData(function (t) {
            t.loadFromJSON(n, function () {
              e && e(t);
            });
          });
        },
        cloneWithoutData: function cloneWithoutData(e) {
          var t = T.util.createCanvasElement();
          t.width = this.width, t.height = this.height;
          var n = new T.Canvas(t);
          n.clipTo = this.clipTo, this.backgroundImage ? (n.setBackgroundImage(this.backgroundImage.src, function () {
            n.renderAll(), e && e(n);
          }), n.backgroundImageOpacity = this.backgroundImageOpacity, n.backgroundImageStretch = this.backgroundImageStretch) : e && e(n);
        }
      }), function (e) {
        "use strict";

        var t = e.fabric || (e.fabric = {}),
            n = t.util.object.extend,
            i = t.util.object.clone,
            r = t.util.toFixed,
            o = t.util.string.capitalize,
            a = t.util.degreesToRadians,
            s = t.StaticCanvas.supports("setLineDash"),
            l = !t.isLikelyNode;
        t.Object || (t.Object = t.util.createClass(t.CommonMethods, {
          type: "object",
          originX: "left",
          originY: "top",
          top: 0,
          left: 0,
          width: 0,
          height: 0,
          scaleX: 1,
          scaleY: 1,
          flipX: !1,
          flipY: !1,
          opacity: 1,
          angle: 0,
          skewX: 0,
          skewY: 0,
          cornerSize: 13,
          transparentCorners: !0,
          hoverCursor: null,
          moveCursor: null,
          padding: 0,
          borderColor: "rgba(102,153,255,0.75)",
          borderDashArray: null,
          cornerColor: "rgba(102,153,255,0.5)",
          cornerStrokeColor: null,
          cornerStyle: "rect",
          cornerDashArray: null,
          centeredScaling: !1,
          centeredRotation: !0,
          fill: "rgb(0,0,0)",
          fillRule: "nonzero",
          globalCompositeOperation: "source-over",
          backgroundColor: "",
          selectionBackgroundColor: "",
          stroke: null,
          strokeWidth: 1,
          strokeDashArray: null,
          strokeDashOffset: 0,
          strokeLineCap: "butt",
          strokeLineJoin: "miter",
          strokeMiterLimit: 4,
          shadow: null,
          borderOpacityWhenMoving: .4,
          borderScaleFactor: 1,
          transformMatrix: null,
          minScaleLimit: 0,
          selectable: !0,
          evented: !0,
          visible: !0,
          hasControls: !0,
          hasBorders: !0,
          hasRotatingPoint: !0,
          rotatingPointOffset: 40,
          perPixelTargetFind: !1,
          includeDefaultValues: !0,
          clipTo: null,
          lockMovementX: !1,
          lockMovementY: !1,
          lockRotation: !1,
          lockScalingX: !1,
          lockScalingY: !1,
          lockUniScaling: !1,
          lockSkewingX: !1,
          lockSkewingY: !1,
          lockScalingFlip: !1,
          excludeFromExport: !1,
          objectCaching: l,
          statefullCache: !1,
          noScaleCache: !0,
          strokeUniform: !1,
          dirty: !0,
          __corner: 0,
          paintFirst: "fill",
          stateProperties: "top left width height scaleX scaleY flipX flipY originX originY transformMatrix stroke strokeWidth strokeDashArray strokeLineCap strokeDashOffset strokeLineJoin strokeMiterLimit angle opacity fill globalCompositeOperation shadow clipTo visible backgroundColor skewX skewY fillRule paintFirst clipPath strokeUniform".split(" "),
          cacheProperties: "fill stroke strokeWidth strokeDashArray width height paintFirst strokeUniform strokeLineCap strokeDashOffset strokeLineJoin strokeMiterLimit backgroundColor clipPath".split(" "),
          clipPath: void 0,
          inverted: !1,
          absolutePositioned: !1,
          initialize: function initialize(e) {
            e && this.setOptions(e);
          },
          _createCacheCanvas: function _createCacheCanvas() {
            this._cacheProperties = {}, this._cacheCanvas = t.util.createCanvasElement(), this._cacheContext = this._cacheCanvas.getContext("2d"), this._updateCacheCanvas(), this.dirty = !0;
          },
          _limitCacheSize: function _limitCacheSize(e) {
            var n = t.perfLimitSizeTotal,
                i = e.width,
                r = e.height,
                o = t.maxCacheSideLimit,
                a = t.minCacheSideLimit;
            if (i <= o && r <= o && i * r <= n) return i < a && (e.width = a), r < a && (e.height = a), e;
            var s = i / r,
                l = t.util.limitDimsByArea(s, n),
                u = t.util.capValue,
                c = u(a, l.x, o),
                h = u(a, l.y, o);
            return i > c && (e.zoomX /= i / c, e.width = c, e.capped = !0), r > h && (e.zoomY /= r / h, e.height = h, e.capped = !0), e;
          },
          _getCacheCanvasDimensions: function _getCacheCanvasDimensions() {
            var e = this.getTotalObjectScaling(),
                t = this._getTransformedDimensions(0, 0),
                n = t.x * e.scaleX / this.scaleX,
                i = t.y * e.scaleY / this.scaleY;

            return {
              width: n + 2,
              height: i + 2,
              zoomX: e.scaleX,
              zoomY: e.scaleY,
              x: n,
              y: i
            };
          },
          _updateCacheCanvas: function _updateCacheCanvas() {
            var e = this.canvas;

            if (this.noScaleCache && e && e._currentTransform) {
              var n = e._currentTransform.target,
                  i = e._currentTransform.action;
              if (this === n && i.slice && "scale" === i.slice(0, 5)) return !1;
            }

            var r,
                o,
                a = this._cacheCanvas,
                s = this._limitCacheSize(this._getCacheCanvasDimensions()),
                l = t.minCacheSideLimit,
                u = s.width,
                c = s.height,
                h = s.zoomX,
                d = s.zoomY,
                f = u !== this.cacheWidth || c !== this.cacheHeight,
                p = this.zoomX !== h || this.zoomY !== d,
                g = f || p,
                v = 0,
                m = 0,
                y = !1;

            if (f) {
              var x = this._cacheCanvas.width,
                  _ = this._cacheCanvas.height,
                  b = u > x || c > _;
              y = b || (u < .9 * x || c < .9 * _) && x > l && _ > l, b && !s.capped && (u > l || c > l) && (v = .1 * u, m = .1 * c);
            }

            return !!g && (y ? (a.width = Math.ceil(u + v), a.height = Math.ceil(c + m)) : (this._cacheContext.setTransform(1, 0, 0, 1, 0, 0), this._cacheContext.clearRect(0, 0, a.width, a.height)), r = s.x / 2, o = s.y / 2, this.cacheTranslationX = Math.round(a.width / 2 - r) + r, this.cacheTranslationY = Math.round(a.height / 2 - o) + o, this.cacheWidth = u, this.cacheHeight = c, this._cacheContext.translate(this.cacheTranslationX, this.cacheTranslationY), this._cacheContext.scale(h, d), this.zoomX = h, this.zoomY = d, !0);
          },
          setOptions: function setOptions(e) {
            this._setOptions(e), this._initGradient(e.fill, "fill"), this._initGradient(e.stroke, "stroke"), this._initClipping(e), this._initPattern(e.fill, "fill"), this._initPattern(e.stroke, "stroke");
          },
          transform: function transform(e) {
            var t;
            t = this.group && !this.group._transformDone ? this.calcTransformMatrix() : this.calcOwnMatrix(), e.transform(t[0], t[1], t[2], t[3], t[4], t[5]);
          },
          toObject: function toObject(e) {
            var n = t.Object.NUM_FRACTION_DIGITS,
                i = {
              type: this.type,
              version: t.version,
              originX: this.originX,
              originY: this.originY,
              left: r(this.left, n),
              top: r(this.top, n),
              width: r(this.width, n),
              height: r(this.height, n),
              fill: this.fill && this.fill.toObject ? this.fill.toObject() : this.fill,
              stroke: this.stroke && this.stroke.toObject ? this.stroke.toObject() : this.stroke,
              strokeWidth: r(this.strokeWidth, n),
              strokeDashArray: this.strokeDashArray ? this.strokeDashArray.concat() : this.strokeDashArray,
              strokeLineCap: this.strokeLineCap,
              strokeDashOffset: this.strokeDashOffset,
              strokeLineJoin: this.strokeLineJoin,
              strokeMiterLimit: r(this.strokeMiterLimit, n),
              scaleX: r(this.scaleX, n),
              scaleY: r(this.scaleY, n),
              angle: r(this.angle, n),
              flipX: this.flipX,
              flipY: this.flipY,
              opacity: r(this.opacity, n),
              shadow: this.shadow && this.shadow.toObject ? this.shadow.toObject() : this.shadow,
              visible: this.visible,
              clipTo: this.clipTo && String(this.clipTo),
              backgroundColor: this.backgroundColor,
              fillRule: this.fillRule,
              paintFirst: this.paintFirst,
              globalCompositeOperation: this.globalCompositeOperation,
              transformMatrix: this.transformMatrix ? this.transformMatrix.concat() : null,
              skewX: r(this.skewX, n),
              skewY: r(this.skewY, n)
            };
            return this.clipPath && (i.clipPath = this.clipPath.toObject(e), i.clipPath.inverted = this.clipPath.inverted, i.clipPath.absolutePositioned = this.clipPath.absolutePositioned), t.util.populateWithProperties(this, i, e), this.includeDefaultValues || (i = this._removeDefaultValues(i)), i;
          },
          toDatalessObject: function toDatalessObject(e) {
            return this.toObject(e);
          },
          _removeDefaultValues: function _removeDefaultValues(e) {
            var n = t.util.getKlass(e.type).prototype;
            return n.stateProperties.forEach(function (t) {
              "left" !== t && "top" !== t && (e[t] === n[t] && delete e[t], "[object Array]" === Object.prototype.toString.call(e[t]) && "[object Array]" === Object.prototype.toString.call(n[t]) && 0 === e[t].length && 0 === n[t].length && delete e[t]);
            }), e;
          },
          toString: function toString() {
            return "#<fabric." + o(this.type) + ">";
          },
          getObjectScaling: function getObjectScaling() {
            var e = t.util.qrDecompose(this.calcTransformMatrix());
            return {
              scaleX: Math.abs(e.scaleX),
              scaleY: Math.abs(e.scaleY)
            };
          },
          getTotalObjectScaling: function getTotalObjectScaling() {
            var e = this.getObjectScaling(),
                t = e.scaleX,
                n = e.scaleY;

            if (this.canvas) {
              var i = this.canvas.getZoom(),
                  r = this.canvas.getRetinaScaling();
              t *= i * r, n *= i * r;
            }

            return {
              scaleX: t,
              scaleY: n
            };
          },
          getObjectOpacity: function getObjectOpacity() {
            var e = this.opacity;
            return this.group && (e *= this.group.getObjectOpacity()), e;
          },
          _set: function _set(e, n) {
            var i = "scaleX" === e || "scaleY" === e,
                r = this[e] !== n,
                o = !1;
            return i && (n = this._constrainScale(n)), "scaleX" === e && n < 0 ? (this.flipX = !this.flipX, n *= -1) : "scaleY" === e && n < 0 ? (this.flipY = !this.flipY, n *= -1) : "shadow" !== e || !n || n instanceof t.Shadow ? "dirty" === e && this.group && this.group.set("dirty", n) : n = new t.Shadow(n), this[e] = n, r && (o = this.group && this.group.isOnACache(), this.cacheProperties.indexOf(e) > -1 ? (this.dirty = !0, o && this.group.set("dirty", !0)) : o && this.stateProperties.indexOf(e) > -1 && this.group.set("dirty", !0)), this;
          },
          setOnGroup: function setOnGroup() {},
          getViewportTransform: function getViewportTransform() {
            return this.canvas && this.canvas.viewportTransform ? this.canvas.viewportTransform : t.iMatrix.concat();
          },
          isNotVisible: function isNotVisible() {
            return 0 === this.opacity || 0 === this.width && 0 === this.height && 0 === this.strokeWidth || !this.visible;
          },
          render: function render(e) {
            this.isNotVisible() || this.canvas && this.canvas.skipOffscreen && !this.group && !this.isOnScreen() || (e.save(), this._setupCompositeOperation(e), this.drawSelectionBackground(e), this.transform(e), this._setOpacity(e), this._setShadow(e, this), this.transformMatrix && e.transform.apply(e, this.transformMatrix), this.clipTo && t.util.clipContext(this, e), this.shouldCache() ? (this.renderCache(), this.drawCacheOnCanvas(e)) : (this._removeCacheCanvas(), this.dirty = !1, this.drawObject(e), this.objectCaching && this.statefullCache && this.saveState({
              propertySet: "cacheProperties"
            })), this.clipTo && e.restore(), e.restore());
          },
          renderCache: function renderCache(e) {
            e = e || {}, this._cacheCanvas || this._createCacheCanvas(), this.isCacheDirty() && (this.statefullCache && this.saveState({
              propertySet: "cacheProperties"
            }), this.drawObject(this._cacheContext, e.forClipping), this.dirty = !1);
          },
          _removeCacheCanvas: function _removeCacheCanvas() {
            this._cacheCanvas = null, this.cacheWidth = 0, this.cacheHeight = 0;
          },
          hasStroke: function hasStroke() {
            return this.stroke && "transparent" !== this.stroke && 0 !== this.strokeWidth;
          },
          hasFill: function hasFill() {
            return this.fill && "transparent" !== this.fill;
          },
          needsItsOwnCache: function needsItsOwnCache() {
            return !("stroke" !== this.paintFirst || !this.hasFill() || !this.hasStroke() || "object" != typeof this.shadow) || !!this.clipPath;
          },
          shouldCache: function shouldCache() {
            return this.ownCaching = this.needsItsOwnCache() || this.objectCaching && (!this.group || !this.group.isOnACache()), this.ownCaching;
          },
          willDrawShadow: function willDrawShadow() {
            return !!this.shadow && (0 !== this.shadow.offsetX || 0 !== this.shadow.offsetY);
          },
          drawClipPathOnCache: function drawClipPathOnCache(e) {
            var n = this.clipPath;

            if (e.save(), n.inverted ? e.globalCompositeOperation = "destination-out" : e.globalCompositeOperation = "destination-in", n.absolutePositioned) {
              var i = t.util.invertTransform(this.calcTransformMatrix());
              e.transform(i[0], i[1], i[2], i[3], i[4], i[5]);
            }

            n.transform(e), e.scale(1 / n.zoomX, 1 / n.zoomY), e.drawImage(n._cacheCanvas, -n.cacheTranslationX, -n.cacheTranslationY), e.restore();
          },
          drawObject: function drawObject(e, t) {
            var n = this.fill,
                i = this.stroke;
            t ? (this.fill = "black", this.stroke = "", this._setClippingProperties(e)) : (this._renderBackground(e), this._setStrokeStyles(e, this), this._setFillStyles(e, this)), this._render(e), this._drawClipPath(e), this.fill = n, this.stroke = i;
          },
          _drawClipPath: function _drawClipPath(e) {
            var t = this.clipPath;
            t && (t.canvas = this.canvas, t.shouldCache(), t._transformDone = !0, t.renderCache({
              forClipping: !0
            }), this.drawClipPathOnCache(e));
          },
          drawCacheOnCanvas: function drawCacheOnCanvas(e) {
            e.scale(1 / this.zoomX, 1 / this.zoomY), e.drawImage(this._cacheCanvas, -this.cacheTranslationX, -this.cacheTranslationY);
          },
          isCacheDirty: function isCacheDirty(e) {
            if (this.isNotVisible()) return !1;
            if (this._cacheCanvas && !e && this._updateCacheCanvas()) return !0;

            if (this.dirty || this.clipPath && this.clipPath.absolutePositioned || this.statefullCache && this.hasStateChanged("cacheProperties")) {
              if (this._cacheCanvas && !e) {
                var t = this.cacheWidth / this.zoomX,
                    n = this.cacheHeight / this.zoomY;

                this._cacheContext.clearRect(-t / 2, -n / 2, t, n);
              }

              return !0;
            }

            return !1;
          },
          _renderBackground: function _renderBackground(e) {
            if (this.backgroundColor) {
              var t = this._getNonTransformedDimensions();

              e.fillStyle = this.backgroundColor, e.fillRect(-t.x / 2, -t.y / 2, t.x, t.y), this._removeShadow(e);
            }
          },
          _setOpacity: function _setOpacity(e) {
            this.group && !this.group._transformDone ? e.globalAlpha = this.getObjectOpacity() : e.globalAlpha *= this.opacity;
          },
          _setStrokeStyles: function _setStrokeStyles(e, t) {
            t.stroke && (e.lineWidth = t.strokeWidth, e.lineCap = t.strokeLineCap, e.lineDashOffset = t.strokeDashOffset, e.lineJoin = t.strokeLineJoin, e.miterLimit = t.strokeMiterLimit, e.strokeStyle = t.stroke.toLive ? t.stroke.toLive(e, this) : t.stroke);
          },
          _setFillStyles: function _setFillStyles(e, t) {
            t.fill && (e.fillStyle = t.fill.toLive ? t.fill.toLive(e, this) : t.fill);
          },
          _setClippingProperties: function _setClippingProperties(e) {
            e.globalAlpha = 1, e.strokeStyle = "transparent", e.fillStyle = "#000000";
          },
          _setLineDash: function _setLineDash(e, t, n) {
            t && 0 !== t.length && (1 & t.length && t.push.apply(t, t), s ? e.setLineDash(t) : n && n(e));
          },
          _renderControls: function _renderControls(e, n) {
            var i,
                r,
                o,
                s = this.getViewportTransform(),
                l = this.calcTransformMatrix();
            r = void 0 !== (n = n || {}).hasBorders ? n.hasBorders : this.hasBorders, o = void 0 !== n.hasControls ? n.hasControls : this.hasControls, l = t.util.multiplyTransformMatrices(s, l), i = t.util.qrDecompose(l), e.save(), e.translate(i.translateX, i.translateY), e.lineWidth = 1 * this.borderScaleFactor, this.group || (e.globalAlpha = this.isMoving ? this.borderOpacityWhenMoving : 1), n.forActiveSelection ? (e.rotate(a(i.angle)), r && this.drawBordersInGroup(e, i, n)) : (e.rotate(a(this.angle)), r && this.drawBorders(e, n)), o && this.drawControls(e, n), e.restore();
          },
          _setShadow: function _setShadow(e) {
            if (this.shadow) {
              var n,
                  i = this.shadow,
                  r = this.canvas,
                  o = r && r.viewportTransform[0] || 1,
                  a = r && r.viewportTransform[3] || 1;
              n = i.nonScaling ? {
                scaleX: 1,
                scaleY: 1
              } : this.getObjectScaling(), r && r._isRetinaScaling() && (o *= t.devicePixelRatio, a *= t.devicePixelRatio), e.shadowColor = i.color, e.shadowBlur = i.blur * t.browserShadowBlurConstant * (o + a) * (n.scaleX + n.scaleY) / 4, e.shadowOffsetX = i.offsetX * o * n.scaleX, e.shadowOffsetY = i.offsetY * a * n.scaleY;
            }
          },
          _removeShadow: function _removeShadow(e) {
            this.shadow && (e.shadowColor = "", e.shadowBlur = e.shadowOffsetX = e.shadowOffsetY = 0);
          },
          _applyPatternGradientTransform: function _applyPatternGradientTransform(e, t) {
            if (!t || !t.toLive) return {
              offsetX: 0,
              offsetY: 0
            };
            var n = t.gradientTransform || t.patternTransform,
                i = -this.width / 2 + t.offsetX || 0,
                r = -this.height / 2 + t.offsetY || 0;
            return "percentage" === t.gradientUnits ? e.transform(this.width, 0, 0, this.height, i, r) : e.transform(1, 0, 0, 1, i, r), n && e.transform(n[0], n[1], n[2], n[3], n[4], n[5]), {
              offsetX: i,
              offsetY: r
            };
          },
          _renderPaintInOrder: function _renderPaintInOrder(e) {
            "stroke" === this.paintFirst ? (this._renderStroke(e), this._renderFill(e)) : (this._renderFill(e), this._renderStroke(e));
          },
          _render: function _render() {},
          _renderFill: function _renderFill(e) {
            this.fill && (e.save(), this._applyPatternGradientTransform(e, this.fill), "evenodd" === this.fillRule ? e.fill("evenodd") : e.fill(), e.restore());
          },
          _renderStroke: function _renderStroke(e) {
            if (this.stroke && 0 !== this.strokeWidth) {
              if (this.shadow && !this.shadow.affectStroke && this._removeShadow(e), e.save(), this.strokeUniform && this.group) {
                var t = this.getObjectScaling();
                e.scale(1 / t.scaleX, 1 / t.scaleY);
              } else this.strokeUniform && e.scale(1 / this.scaleX, 1 / this.scaleY);

              this._setLineDash(e, this.strokeDashArray, this._renderDashedStroke), this.stroke.toLive && "percentage" === this.stroke.gradientUnits ? this._applyPatternForTransformedGradient(e, this.stroke) : this._applyPatternGradientTransform(e, this.stroke), e.stroke(), e.restore();
            }
          },
          _applyPatternForTransformedGradient: function _applyPatternForTransformedGradient(e, n) {
            var i,
                r = this._limitCacheSize(this._getCacheCanvasDimensions()),
                o = t.util.createCanvasElement(),
                a = this.canvas.getRetinaScaling(),
                s = r.x / this.scaleX / a,
                l = r.y / this.scaleY / a;

            o.width = s, o.height = l, (i = o.getContext("2d")).beginPath(), i.moveTo(0, 0), i.lineTo(s, 0), i.lineTo(s, l), i.lineTo(0, l), i.closePath(), i.translate(s / 2, l / 2), i.scale(r.zoomX / this.scaleX / a, r.zoomY / this.scaleY / a), this._applyPatternGradientTransform(i, n), i.fillStyle = n.toLive(e), i.fill(), e.translate(-this.width / 2 - this.strokeWidth / 2, -this.height / 2 - this.strokeWidth / 2), e.scale(a * this.scaleX / r.zoomX, a * this.scaleY / r.zoomY), e.strokeStyle = i.createPattern(o, "no-repeat");
          },
          _findCenterFromElement: function _findCenterFromElement() {
            return {
              x: this.left + this.width / 2,
              y: this.top + this.height / 2
            };
          },
          _assignTransformMatrixProps: function _assignTransformMatrixProps() {
            if (this.transformMatrix) {
              var e = t.util.qrDecompose(this.transformMatrix);
              this.flipX = !1, this.flipY = !1, this.set("scaleX", e.scaleX), this.set("scaleY", e.scaleY), this.angle = e.angle, this.skewX = e.skewX, this.skewY = 0;
            }
          },
          _removeTransformMatrix: function _removeTransformMatrix(e) {
            var n = this._findCenterFromElement();

            this.transformMatrix && (this._assignTransformMatrixProps(), n = t.util.transformPoint(n, this.transformMatrix)), this.transformMatrix = null, e && (this.scaleX *= e.scaleX, this.scaleY *= e.scaleY, this.cropX = e.cropX, this.cropY = e.cropY, n.x += e.offsetLeft, n.y += e.offsetTop, this.width = e.width, this.height = e.height), this.setPositionByOrigin(n, "center", "center");
          },
          clone: function clone(e, n) {
            var i = this.toObject(n);
            this.constructor.fromObject ? this.constructor.fromObject(i, e) : t.Object._fromObject("Object", i, e);
          },
          cloneAsImage: function cloneAsImage(e, n) {
            var i = this.toCanvasElement(n);
            return e && e(new t.Image(i)), this;
          },
          toCanvasElement: function toCanvasElement(e) {
            e || (e = {});
            var n = t.util,
                i = n.saveObjectTransform(this),
                r = this.group,
                o = this.shadow,
                a = Math.abs,
                s = (e.multiplier || 1) * (e.enableRetinaScaling ? t.devicePixelRatio : 1);
            delete this.group, e.withoutTransform && n.resetObjectTransform(this), e.withoutShadow && (this.shadow = null);
            var l,
                u,
                c,
                h,
                d = t.util.createCanvasElement(),
                f = this.getBoundingRect(!0, !0),
                p = this.shadow,
                g = {
              x: 0,
              y: 0
            };
            p && (u = p.blur, l = p.nonScaling ? {
              scaleX: 1,
              scaleY: 1
            } : this.getObjectScaling(), g.x = 2 * Math.round(a(p.offsetX) + u) * a(l.scaleX), g.y = 2 * Math.round(a(p.offsetY) + u) * a(l.scaleY)), c = f.width + g.x, h = f.height + g.y, d.width = Math.ceil(c), d.height = Math.ceil(h);
            var v = new t.StaticCanvas(d, {
              enableRetinaScaling: !1,
              renderOnAddRemove: !1,
              skipOffscreen: !1
            });
            "jpeg" === e.format && (v.backgroundColor = "#fff"), this.setPositionByOrigin(new t.Point(v.width / 2, v.height / 2), "center", "center");
            var m = this.canvas;
            v.add(this);
            var y = v.toCanvasElement(s || 1, e);
            return this.shadow = o, this.set("canvas", m), r && (this.group = r), this.set(i).setCoords(), v._objects = [], v.dispose(), v = null, y;
          },
          toDataURL: function toDataURL(e) {
            return e || (e = {}), t.util.toDataURL(this.toCanvasElement(e), e.format || "png", e.quality || 1);
          },
          isType: function isType(e) {
            return this.type === e;
          },
          complexity: function complexity() {
            return 1;
          },
          toJSON: function toJSON(e) {
            return this.toObject(e);
          },
          setGradient: function setGradient(e, n) {
            n || (n = {});
            var i = {
              colorStops: []
            };
            return i.type = n.type || (n.r1 || n.r2 ? "radial" : "linear"), i.coords = {
              x1: n.x1,
              y1: n.y1,
              x2: n.x2,
              y2: n.y2
            }, i.gradientUnits = n.gradientUnits || "pixels", (n.r1 || n.r2) && (i.coords.r1 = n.r1, i.coords.r2 = n.r2), i.gradientTransform = n.gradientTransform, t.Gradient.prototype.addColorStop.call(i, n.colorStops), this.set(e, t.Gradient.forObject(this, i));
          },
          setPatternFill: function setPatternFill(e, n) {
            return this.set("fill", new t.Pattern(e, n));
          },
          setShadow: function setShadow(e) {
            return this.set("shadow", e ? new t.Shadow(e) : null);
          },
          setColor: function setColor(e) {
            return this.set("fill", e), this;
          },
          rotate: function rotate(e) {
            var t = ("center" !== this.originX || "center" !== this.originY) && this.centeredRotation;
            return t && this._setOriginToCenter(), this.set("angle", e), t && this._resetOrigin(), this;
          },
          centerH: function centerH() {
            return this.canvas && this.canvas.centerObjectH(this), this;
          },
          viewportCenterH: function viewportCenterH() {
            return this.canvas && this.canvas.viewportCenterObjectH(this), this;
          },
          centerV: function centerV() {
            return this.canvas && this.canvas.centerObjectV(this), this;
          },
          viewportCenterV: function viewportCenterV() {
            return this.canvas && this.canvas.viewportCenterObjectV(this), this;
          },
          center: function center() {
            return this.canvas && this.canvas.centerObject(this), this;
          },
          viewportCenter: function viewportCenter() {
            return this.canvas && this.canvas.viewportCenterObject(this), this;
          },
          getLocalPointer: function getLocalPointer(e, n) {
            n = n || this.canvas.getPointer(e);

            var i = new t.Point(n.x, n.y),
                r = this._getLeftTopCoords();

            return this.angle && (i = t.util.rotatePoint(i, r, a(-this.angle))), {
              x: i.x - r.x,
              y: i.y - r.y
            };
          },
          _setupCompositeOperation: function _setupCompositeOperation(e) {
            this.globalCompositeOperation && (e.globalCompositeOperation = this.globalCompositeOperation);
          }
        }), t.util.createAccessors && t.util.createAccessors(t.Object), n(t.Object.prototype, t.Observable), t.Object.NUM_FRACTION_DIGITS = 2, t.Object._fromObject = function (e, n, r, o) {
          var a = t[e];
          n = i(n, !0), t.util.enlivenPatterns([n.fill, n.stroke], function (e) {
            void 0 !== e[0] && (n.fill = e[0]), void 0 !== e[1] && (n.stroke = e[1]), t.util.enlivenObjects([n.clipPath], function (e) {
              n.clipPath = e[0];
              var t = o ? new a(n[o], n) : new a(n);
              r && r(t);
            });
          });
        }, t.Object.__uid = 0);
      }(t), y = T.util.degreesToRadians, x = {
        left: -.5,
        center: 0,
        right: .5
      }, _ = {
        top: -.5,
        center: 0,
        bottom: .5
      }, T.util.object.extend(T.Object.prototype, {
        translateToGivenOrigin: function translateToGivenOrigin(e, t, n, i, r) {
          var o,
              a,
              s,
              l = e.x,
              u = e.y;
          return "string" == typeof t ? t = x[t] : t -= .5, "string" == typeof i ? i = x[i] : i -= .5, "string" == typeof n ? n = _[n] : n -= .5, "string" == typeof r ? r = _[r] : r -= .5, a = r - n, ((o = i - t) || a) && (s = this._getTransformedDimensions(), l = e.x + o * s.x, u = e.y + a * s.y), new T.Point(l, u);
        },
        translateToCenterPoint: function translateToCenterPoint(e, t, n) {
          var i = this.translateToGivenOrigin(e, t, n, "center", "center");
          return this.angle ? T.util.rotatePoint(i, e, y(this.angle)) : i;
        },
        translateToOriginPoint: function translateToOriginPoint(e, t, n) {
          var i = this.translateToGivenOrigin(e, "center", "center", t, n);
          return this.angle ? T.util.rotatePoint(i, e, y(this.angle)) : i;
        },
        getCenterPoint: function getCenterPoint() {
          var e = new T.Point(this.left, this.top);
          return this.translateToCenterPoint(e, this.originX, this.originY);
        },
        getPointByOrigin: function getPointByOrigin(e, t) {
          var n = this.getCenterPoint();
          return this.translateToOriginPoint(n, e, t);
        },
        toLocalPoint: function toLocalPoint(e, t, n) {
          var i,
              r,
              o = this.getCenterPoint();
          return i = void 0 !== t && void 0 !== n ? this.translateToGivenOrigin(o, "center", "center", t, n) : new T.Point(this.left, this.top), r = new T.Point(e.x, e.y), this.angle && (r = T.util.rotatePoint(r, o, -y(this.angle))), r.subtractEquals(i);
        },
        setPositionByOrigin: function setPositionByOrigin(e, t, n) {
          var i = this.translateToCenterPoint(e, t, n),
              r = this.translateToOriginPoint(i, this.originX, this.originY);
          this.set("left", r.x), this.set("top", r.y);
        },
        adjustPosition: function adjustPosition(e) {
          var t,
              n,
              i = y(this.angle),
              r = this.getScaledWidth(),
              o = T.util.cos(i) * r,
              a = T.util.sin(i) * r;
          t = "string" == typeof this.originX ? x[this.originX] : this.originX - .5, n = "string" == typeof e ? x[e] : e - .5, this.left += o * (n - t), this.top += a * (n - t), this.setCoords(), this.originX = e;
        },
        _setOriginToCenter: function _setOriginToCenter() {
          this._originalOriginX = this.originX, this._originalOriginY = this.originY;
          var e = this.getCenterPoint();
          this.originX = "center", this.originY = "center", this.left = e.x, this.top = e.y;
        },
        _resetOrigin: function _resetOrigin() {
          var e = this.translateToOriginPoint(this.getCenterPoint(), this._originalOriginX, this._originalOriginY);
          this.originX = this._originalOriginX, this.originY = this._originalOriginY, this.left = e.x, this.top = e.y, this._originalOriginX = null, this._originalOriginY = null;
        },
        _getLeftTopCoords: function _getLeftTopCoords() {
          return this.translateToOriginPoint(this.getCenterPoint(), "left", "top");
        }
      }), function () {
        var e = T.util.degreesToRadians,
            t = T.util.multiplyTransformMatrices,
            n = T.util.transformPoint;
        T.util.object.extend(T.Object.prototype, {
          oCoords: null,
          aCoords: null,
          ownMatrixCache: null,
          matrixCache: null,
          getCoords: function getCoords(e, t) {
            this.oCoords || this.setCoords();
            var n = e ? this.aCoords : this.oCoords;
            return function (e) {
              return [new T.Point(e.tl.x, e.tl.y), new T.Point(e.tr.x, e.tr.y), new T.Point(e.br.x, e.br.y), new T.Point(e.bl.x, e.bl.y)];
            }(t ? this.calcCoords(e) : n);
          },
          intersectsWithRect: function intersectsWithRect(e, t, n, i) {
            var r = this.getCoords(n, i);
            return "Intersection" === T.Intersection.intersectPolygonRectangle(r, e, t).status;
          },
          intersectsWithObject: function intersectsWithObject(e, t, n) {
            return "Intersection" === T.Intersection.intersectPolygonPolygon(this.getCoords(t, n), e.getCoords(t, n)).status || e.isContainedWithinObject(this, t, n) || this.isContainedWithinObject(e, t, n);
          },
          isContainedWithinObject: function isContainedWithinObject(e, t, n) {
            for (var i = this.getCoords(t, n), r = 0, o = e._getImageLines(n ? e.calcCoords(t) : t ? e.aCoords : e.oCoords); r < 4; r++) {
              if (!e.containsPoint(i[r], o)) return !1;
            }

            return !0;
          },
          isContainedWithinRect: function isContainedWithinRect(e, t, n, i) {
            var r = this.getBoundingRect(n, i);
            return r.left >= e.x && r.left + r.width <= t.x && r.top >= e.y && r.top + r.height <= t.y;
          },
          containsPoint: function containsPoint(e, t, n, i) {
            t = t || this._getImageLines(i ? this.calcCoords(n) : n ? this.aCoords : this.oCoords);

            var r = this._findCrossPoints(e, t);

            return 0 !== r && r % 2 == 1;
          },
          isOnScreen: function isOnScreen(e) {
            if (!this.canvas) return !1;

            for (var t, n = this.canvas.vptCoords.tl, i = this.canvas.vptCoords.br, r = this.getCoords(!0, e), o = 0; o < 4; o++) {
              if ((t = r[o]).x <= i.x && t.x >= n.x && t.y <= i.y && t.y >= n.y) return !0;
            }

            return !!this.intersectsWithRect(n, i, !0, e) || this._containsCenterOfCanvas(n, i, e);
          },
          _containsCenterOfCanvas: function _containsCenterOfCanvas(e, t, n) {
            var i = {
              x: (e.x + t.x) / 2,
              y: (e.y + t.y) / 2
            };
            return !!this.containsPoint(i, null, !0, n);
          },
          isPartiallyOnScreen: function isPartiallyOnScreen(e) {
            if (!this.canvas) return !1;
            var t = this.canvas.vptCoords.tl,
                n = this.canvas.vptCoords.br;
            return !!this.intersectsWithRect(t, n, !0, e) || this._containsCenterOfCanvas(t, n, e);
          },
          _getImageLines: function _getImageLines(e) {
            return {
              topline: {
                o: e.tl,
                d: e.tr
              },
              rightline: {
                o: e.tr,
                d: e.br
              },
              bottomline: {
                o: e.br,
                d: e.bl
              },
              leftline: {
                o: e.bl,
                d: e.tl
              }
            };
          },
          _findCrossPoints: function _findCrossPoints(e, t) {
            var n,
                i,
                r,
                o = 0;

            for (var a in t) {
              if (!((r = t[a]).o.y < e.y && r.d.y < e.y || r.o.y >= e.y && r.d.y >= e.y || (r.o.x === r.d.x && r.o.x >= e.x ? i = r.o.x : (0, n = (r.d.y - r.o.y) / (r.d.x - r.o.x), i = -(e.y - 0 * e.x - (r.o.y - n * r.o.x)) / (0 - n)), i >= e.x && (o += 1), 2 !== o))) break;
            }

            return o;
          },
          getBoundingRect: function getBoundingRect(e, t) {
            var n = this.getCoords(e, t);
            return T.util.makeBoundingBoxFromPoints(n);
          },
          getScaledWidth: function getScaledWidth() {
            return this._getTransformedDimensions().x;
          },
          getScaledHeight: function getScaledHeight() {
            return this._getTransformedDimensions().y;
          },
          _constrainScale: function _constrainScale(e) {
            return Math.abs(e) < this.minScaleLimit ? e < 0 ? -this.minScaleLimit : this.minScaleLimit : 0 === e ? 1e-4 : e;
          },
          scale: function scale(e) {
            return this._set("scaleX", e), this._set("scaleY", e), this.setCoords();
          },
          scaleToWidth: function scaleToWidth(e, t) {
            var n = this.getBoundingRect(t).width / this.getScaledWidth();
            return this.scale(e / this.width / n);
          },
          scaleToHeight: function scaleToHeight(e, t) {
            var n = this.getBoundingRect(t).height / this.getScaledHeight();
            return this.scale(e / this.height / n);
          },
          calcCoords: function calcCoords(i) {
            var r = this._calcRotateMatrix(),
                o = this._calcTranslateMatrix(),
                a = t(o, r),
                s = this.getViewportTransform(),
                l = i ? a : t(s, a),
                u = this._getTransformedDimensions(),
                c = u.x / 2,
                h = u.y / 2,
                d = n({
              x: -c,
              y: -h
            }, l),
                f = n({
              x: c,
              y: -h
            }, l),
                p = n({
              x: -c,
              y: h
            }, l),
                g = n({
              x: c,
              y: h
            }, l);

            if (!i) {
              var v = this.padding,
                  m = e(this.angle),
                  y = T.util.cos(m),
                  x = T.util.sin(m),
                  _ = y * v,
                  b = x * v,
                  w = _ + b,
                  S = _ - b;

              v && (d.x -= S, d.y -= w, f.x += w, f.y -= S, p.x -= w, p.y += S, g.x += S, g.y += w);
              var C = new T.Point((d.x + p.x) / 2, (d.y + p.y) / 2),
                  k = new T.Point((f.x + d.x) / 2, (f.y + d.y) / 2),
                  M = new T.Point((g.x + f.x) / 2, (g.y + f.y) / 2),
                  E = new T.Point((g.x + p.x) / 2, (g.y + p.y) / 2),
                  A = new T.Point(k.x + x * this.rotatingPointOffset, k.y - y * this.rotatingPointOffset);
            }

            var I = {
              tl: d,
              tr: f,
              br: g,
              bl: p
            };
            return i || (I.ml = C, I.mt = k, I.mr = M, I.mb = E, I.mtr = A), I;
          },
          setCoords: function setCoords(e, t) {
            return this.oCoords = this.calcCoords(e), t || (this.aCoords = this.calcCoords(!0)), e || this._setCornerCoords && this._setCornerCoords(), this;
          },
          _calcRotateMatrix: function _calcRotateMatrix() {
            return T.util.calcRotateMatrix(this);
          },
          _calcTranslateMatrix: function _calcTranslateMatrix() {
            var e = this.getCenterPoint();
            return [1, 0, 0, 1, e.x, e.y];
          },
          transformMatrixKey: function transformMatrixKey(e) {
            var t = "";
            return !e && this.group && (t = this.group.transformMatrixKey(e) + "_"), t + this.top + "_" + this.left + "_" + this.scaleX + "_" + this.scaleY + "_" + this.skewX + "_" + this.skewY + "_" + this.angle + "_" + this.originX + "_" + this.originY + "_" + this.width + "_" + this.height + "_" + this.strokeWidth + this.flipX + this.flipY;
          },
          calcTransformMatrix: function calcTransformMatrix(e) {
            if (e) return this.calcOwnMatrix();
            var n = this.transformMatrixKey(),
                i = this.matrixCache || (this.matrixCache = {});
            if (i.key === n) return i.value;
            var r = this.calcOwnMatrix();
            return this.group && (r = t(this.group.calcTransformMatrix(), r)), i.key = n, i.value = r, r;
          },
          calcOwnMatrix: function calcOwnMatrix() {
            var e = this.transformMatrixKey(!0),
                t = this.ownMatrixCache || (this.ownMatrixCache = {});
            if (t.key === e) return t.value;

            var n = this._calcTranslateMatrix();

            return this.translateX = n[4], this.translateY = n[5], t.key = e, t.value = T.util.composeMatrix(this), t.value;
          },
          _calcDimensionsTransformMatrix: function _calcDimensionsTransformMatrix(e, t, n) {
            return T.util.calcDimensionsMatrix({
              skewX: e,
              skewY: t,
              scaleX: this.scaleX * (n && this.flipX ? -1 : 1),
              scaleY: this.scaleY * (n && this.flipY ? -1 : 1)
            });
          },
          _getNonTransformedDimensions: function _getNonTransformedDimensions() {
            var e = this.strokeWidth;
            return {
              x: this.width + e,
              y: this.height + e
            };
          },
          _getTransformedDimensions: function _getTransformedDimensions(e, t) {
            void 0 === e && (e = this.skewX), void 0 === t && (t = this.skewY);

            var n,
                i,
                r = this._getNonTransformedDimensions(),
                o = 0 === e && 0 === t;

            if (this.strokeUniform ? (n = this.width, i = this.height) : (n = r.x, i = r.y), o) return this._finalizeDimensions(n * this.scaleX, i * this.scaleY);
            var a = [{
              x: -(n /= 2),
              y: -(i /= 2)
            }, {
              x: n,
              y: -i
            }, {
              x: -n,
              y: i
            }, {
              x: n,
              y: i
            }],
                s = T.util.calcDimensionsMatrix({
              scaleX: this.scaleX,
              scaleY: this.scaleY,
              skewX: e,
              skewY: t
            }),
                l = T.util.makeBoundingBoxFromPoints(a, s);
            return this._finalizeDimensions(l.width, l.height);
          },
          _finalizeDimensions: function _finalizeDimensions(e, t) {
            return this.strokeUniform ? {
              x: e + this.strokeWidth,
              y: t + this.strokeWidth
            } : {
              x: e,
              y: t
            };
          },
          _calculateCurrentDimensions: function _calculateCurrentDimensions() {
            var e = this.getViewportTransform(),
                t = this._getTransformedDimensions();

            return T.util.transformPoint(t, e, !0).scalarAdd(2 * this.padding);
          }
        });
      }(), T.util.object.extend(T.Object.prototype, {
        sendToBack: function sendToBack() {
          return this.group ? T.StaticCanvas.prototype.sendToBack.call(this.group, this) : this.canvas && this.canvas.sendToBack(this), this;
        },
        bringToFront: function bringToFront() {
          return this.group ? T.StaticCanvas.prototype.bringToFront.call(this.group, this) : this.canvas && this.canvas.bringToFront(this), this;
        },
        sendBackwards: function sendBackwards(e) {
          return this.group ? T.StaticCanvas.prototype.sendBackwards.call(this.group, this, e) : this.canvas && this.canvas.sendBackwards(this, e), this;
        },
        bringForward: function bringForward(e) {
          return this.group ? T.StaticCanvas.prototype.bringForward.call(this.group, this, e) : this.canvas && this.canvas.bringForward(this, e), this;
        },
        moveTo: function moveTo(e) {
          return this.group && "activeSelection" !== this.group.type ? T.StaticCanvas.prototype.moveTo.call(this.group, this, e) : this.canvas && this.canvas.moveTo(this, e), this;
        }
      }), function () {
        function e(e, t) {
          if (t) {
            if (t.toLive) return e + ": url(#SVGID_" + t.id + "); ";
            var n = new T.Color(t),
                i = e + ": " + n.toRgb() + "; ",
                r = n.getAlpha();
            return 1 !== r && (i += e + "-opacity: " + r.toString() + "; "), i;
          }

          return e + ": none; ";
        }

        var t = T.util.toFixed;
        T.util.object.extend(T.Object.prototype, {
          getSvgStyles: function getSvgStyles(t) {
            var n = this.fillRule ? this.fillRule : "nonzero",
                i = this.strokeWidth ? this.strokeWidth : "0",
                r = this.strokeDashArray ? this.strokeDashArray.join(" ") : "none",
                o = this.strokeDashOffset ? this.strokeDashOffset : "0",
                a = this.strokeLineCap ? this.strokeLineCap : "butt",
                s = this.strokeLineJoin ? this.strokeLineJoin : "miter",
                l = this.strokeMiterLimit ? this.strokeMiterLimit : "4",
                u = void 0 !== this.opacity ? this.opacity : "1",
                c = this.visible ? "" : " visibility: hidden;",
                h = t ? "" : this.getSvgFilter(),
                d = e("fill", this.fill);
            return [e("stroke", this.stroke), "stroke-width: ", i, "; ", "stroke-dasharray: ", r, "; ", "stroke-linecap: ", a, "; ", "stroke-dashoffset: ", o, "; ", "stroke-linejoin: ", s, "; ", "stroke-miterlimit: ", l, "; ", d, "fill-rule: ", n, "; ", "opacity: ", u, ";", h, c].join("");
          },
          getSvgSpanStyles: function getSvgSpanStyles(t, n) {
            var i = t.fontFamily ? "font-family: " + (-1 === t.fontFamily.indexOf("'") && -1 === t.fontFamily.indexOf('"') ? "'" + t.fontFamily + "'" : t.fontFamily) + "; " : "",
                r = t.strokeWidth ? "stroke-width: " + t.strokeWidth + "; " : "",
                o = (i = i, t.fontSize ? "font-size: " + t.fontSize + "px; " : ""),
                a = t.fontStyle ? "font-style: " + t.fontStyle + "; " : "",
                s = t.fontWeight ? "font-weight: " + t.fontWeight + "; " : "",
                l = t.fill ? e("fill", t.fill) : "",
                u = t.stroke ? e("stroke", t.stroke) : "",
                c = this.getSvgTextDecoration(t);
            return c && (c = "text-decoration: " + c + "; "), [u, r, i, o, a, s, c, l, t.deltaY ? "baseline-shift: " + -t.deltaY + "; " : "", n ? "white-space: pre; " : ""].join("");
          },
          getSvgTextDecoration: function getSvgTextDecoration(e) {
            return ["overline", "underline", "line-through"].filter(function (t) {
              return e[t.replace("-", "")];
            }).join(" ");
          },
          getSvgFilter: function getSvgFilter() {
            return this.shadow ? "filter: url(#SVGID_" + this.shadow.id + ");" : "";
          },
          getSvgCommons: function getSvgCommons() {
            return [this.id ? 'id="' + this.id + '" ' : "", this.clipPath ? 'clip-path="url(#' + this.clipPath.clipPathId + ')" ' : ""].join("");
          },
          getSvgTransform: function getSvgTransform(e, t) {
            var n = e ? this.calcTransformMatrix() : this.calcOwnMatrix();
            return 'transform="' + T.util.matrixToSVG(n) + (t || "") + this.getSvgTransformMatrix() + '" ';
          },
          getSvgTransformMatrix: function getSvgTransformMatrix() {
            return this.transformMatrix ? " " + T.util.matrixToSVG(this.transformMatrix) : "";
          },
          _setSVGBg: function _setSVGBg(e) {
            if (this.backgroundColor) {
              var n = T.Object.NUM_FRACTION_DIGITS;
              e.push("\t\t<rect ", this._getFillAttributes(this.backgroundColor), ' x="', t(-this.width / 2, n), '" y="', t(-this.height / 2, n), '" width="', t(this.width, n), '" height="', t(this.height, n), '"></rect>\n');
            }
          },
          toSVG: function toSVG(e) {
            return this._createBaseSVGMarkup(this._toSVG(e), {
              reviver: e
            });
          },
          toClipPathSVG: function toClipPathSVG(e) {
            return "\t" + this._createBaseClipPathSVGMarkup(this._toSVG(e), {
              reviver: e
            });
          },
          _createBaseClipPathSVGMarkup: function _createBaseClipPathSVGMarkup(e, t) {
            var n = (t = t || {}).reviver,
                i = t.additionalTransform || "",
                r = [this.getSvgTransform(!0, i), this.getSvgCommons()].join(""),
                o = e.indexOf("COMMON_PARTS");
            return e[o] = r, n ? n(e.join("")) : e.join("");
          },
          _createBaseSVGMarkup: function _createBaseSVGMarkup(e, t) {
            var n,
                i,
                r = (t = t || {}).noStyle,
                o = t.reviver,
                a = r ? "" : 'style="' + this.getSvgStyles() + '" ',
                s = t.withShadow ? 'style="' + this.getSvgFilter() + '" ' : "",
                l = this.clipPath,
                u = this.strokeUniform ? 'vector-effect="non-scaling-stroke" ' : "",
                c = l && l.absolutePositioned,
                h = this.stroke,
                d = this.fill,
                f = this.shadow,
                p = [],
                g = e.indexOf("COMMON_PARTS"),
                v = t.additionalTransform;
            return l && (l.clipPathId = "CLIPPATH_" + T.Object.__uid++, i = '<clipPath id="' + l.clipPathId + '" >\n' + l.toClipPathSVG(o) + "</clipPath>\n"), c && p.push("<g ", s, this.getSvgCommons(), " >\n"), p.push("<g ", this.getSvgTransform(!1), c ? "" : s + this.getSvgCommons(), " >\n"), n = [a, u, r ? "" : this.addPaintOrder(), " ", v ? 'transform="' + v + '" ' : ""].join(""), e[g] = n, d && d.toLive && p.push(d.toSVG(this)), h && h.toLive && p.push(h.toSVG(this)), f && p.push(f.toSVG(this)), l && p.push(i), p.push(e.join("")), p.push("</g>\n"), c && p.push("</g>\n"), o ? o(p.join("")) : p.join("");
          },
          addPaintOrder: function addPaintOrder() {
            return "fill" !== this.paintFirst ? ' paint-order="' + this.paintFirst + '" ' : "";
          }
        });
      }(), function () {
        var e = T.util.object.extend;

        function t(t, n, i) {
          var r = {};
          i.forEach(function (e) {
            r[e] = t[e];
          }), e(t[n], r, !0);
        }

        T.util.object.extend(T.Object.prototype, {
          hasStateChanged: function hasStateChanged(e) {
            var t = "_" + (e = e || "stateProperties");
            return Object.keys(this[t]).length < this[e].length || !function e(t, n, i) {
              if (t === n) return !0;

              if (Array.isArray(t)) {
                if (!Array.isArray(n) || t.length !== n.length) return !1;

                for (var r = 0, o = t.length; r < o; r++) {
                  if (!e(t[r], n[r])) return !1;
                }

                return !0;
              }

              if (t && "object" == typeof t) {
                var a,
                    s = Object.keys(t);
                if (!n || "object" != typeof n || !i && s.length !== Object.keys(n).length) return !1;

                for (r = 0, o = s.length; r < o; r++) {
                  if ("canvas" !== (a = s[r]) && !e(t[a], n[a])) return !1;
                }

                return !0;
              }
            }(this[t], this, !0);
          },
          saveState: function saveState(e) {
            var n = e && e.propertySet || "stateProperties",
                i = "_" + n;
            return this[i] ? (t(this, i, this[n]), e && e.stateProperties && t(this, i, e.stateProperties), this) : this.setupState(e);
          },
          setupState: function setupState(e) {
            var t = (e = e || {}).propertySet || "stateProperties";
            return e.propertySet = t, this["_" + t] = {}, this.saveState(e), this;
          }
        });
      }(), function () {
        var e = T.util.degreesToRadians;
        T.util.object.extend(T.Object.prototype, {
          _controlsVisibility: null,
          _findTargetCorner: function _findTargetCorner(e) {
            if (!this.hasControls || this.group || !this.canvas || this.canvas._activeObject !== this) return !1;
            var t,
                n,
                i = e.x,
                r = e.y;

            for (var o in this.__corner = 0, this.oCoords) {
              if (this.isControlVisible(o) && ("mtr" !== o || this.hasRotatingPoint) && (!this.get("lockUniScaling") || "mt" !== o && "mr" !== o && "mb" !== o && "ml" !== o) && (n = this._getImageLines(this.oCoords[o].corner), 0 !== (t = this._findCrossPoints({
                x: i,
                y: r
              }, n)) && t % 2 == 1)) return this.__corner = o, o;
            }

            return !1;
          },
          _setCornerCoords: function _setCornerCoords() {
            var t,
                n,
                i = this.oCoords,
                r = e(45 - this.angle),
                o = .707106 * this.cornerSize,
                a = o * T.util.cos(r),
                s = o * T.util.sin(r);

            for (var l in i) {
              t = i[l].x, n = i[l].y, i[l].corner = {
                tl: {
                  x: t - s,
                  y: n - a
                },
                tr: {
                  x: t + a,
                  y: n - s
                },
                bl: {
                  x: t - a,
                  y: n + s
                },
                br: {
                  x: t + s,
                  y: n + a
                }
              };
            }
          },
          drawSelectionBackground: function drawSelectionBackground(t) {
            if (!this.selectionBackgroundColor || this.canvas && !this.canvas.interactive || this.canvas && this.canvas._activeObject !== this) return this;
            t.save();

            var n = this.getCenterPoint(),
                i = this._calculateCurrentDimensions(),
                r = this.canvas.viewportTransform;

            return t.translate(n.x, n.y), t.scale(1 / r[0], 1 / r[3]), t.rotate(e(this.angle)), t.fillStyle = this.selectionBackgroundColor, t.fillRect(-i.x / 2, -i.y / 2, i.x, i.y), t.restore(), this;
          },
          drawBorders: function drawBorders(e, t) {
            t = t || {};

            var n = this._calculateCurrentDimensions(),
                i = this.borderScaleFactor,
                r = n.x + i,
                o = n.y + i,
                a = void 0 !== t.hasRotatingPoint ? t.hasRotatingPoint : this.hasRotatingPoint,
                s = void 0 !== t.hasControls ? t.hasControls : this.hasControls,
                l = void 0 !== t.rotatingPointOffset ? t.rotatingPointOffset : this.rotatingPointOffset;

            if (e.save(), e.strokeStyle = t.borderColor || this.borderColor, this._setLineDash(e, t.borderDashArray || this.borderDashArray, null), e.strokeRect(-r / 2, -o / 2, r, o), a && this.isControlVisible("mtr") && s) {
              var u = -o / 2;
              e.beginPath(), e.moveTo(0, u), e.lineTo(0, u - l), e.stroke();
            }

            return e.restore(), this;
          },
          drawBordersInGroup: function drawBordersInGroup(e, t, n) {
            n = n || {};
            var i = {
              x: this.width,
              y: this.height
            },
                r = T.util.composeMatrix({
              scaleX: t.scaleX,
              scaleY: t.scaleY,
              skewX: t.skewX
            }),
                o = T.util.transformPoint(i, r),
                a = this.strokeWidth,
                s = this.borderScaleFactor,
                l = o.x + a * (this.strokeUniform ? this.canvas.getZoom() : t.scaleX) + s,
                u = o.y + a * (this.strokeUniform ? this.canvas.getZoom() : t.scaleY) + s;
            return e.save(), this._setLineDash(e, n.borderDashArray || this.borderDashArray, null), e.strokeStyle = n.borderColor || this.borderColor, e.strokeRect(-l / 2, -u / 2, l, u), e.restore(), this;
          },
          drawControls: function drawControls(e, t) {
            t = t || {};

            var n = this._calculateCurrentDimensions(),
                i = n.x,
                r = n.y,
                o = t.cornerSize || this.cornerSize,
                a = -(i + o) / 2,
                s = -(r + o) / 2,
                l = void 0 !== t.transparentCorners ? t.transparentCorners : this.transparentCorners,
                u = void 0 !== t.hasRotatingPoint ? t.hasRotatingPoint : this.hasRotatingPoint,
                c = l ? "stroke" : "fill";

            return e.save(), e.strokeStyle = e.fillStyle = t.cornerColor || this.cornerColor, this.transparentCorners || (e.strokeStyle = t.cornerStrokeColor || this.cornerStrokeColor), this._setLineDash(e, t.cornerDashArray || this.cornerDashArray, null), this._drawControl("tl", e, c, a, s, t), this._drawControl("tr", e, c, a + i, s, t), this._drawControl("bl", e, c, a, s + r, t), this._drawControl("br", e, c, a + i, s + r, t), this.get("lockUniScaling") || (this._drawControl("mt", e, c, a + i / 2, s, t), this._drawControl("mb", e, c, a + i / 2, s + r, t), this._drawControl("mr", e, c, a + i, s + r / 2, t), this._drawControl("ml", e, c, a, s + r / 2, t)), u && this._drawControl("mtr", e, c, a + i / 2, s - this.rotatingPointOffset, t), e.restore(), this;
          },
          _drawControl: function _drawControl(e, t, n, i, r, o) {
            if (o = o || {}, this.isControlVisible(e)) {
              var a = this.cornerSize,
                  s = !this.transparentCorners && this.cornerStrokeColor;

              switch (o.cornerStyle || this.cornerStyle) {
                case "circle":
                  t.beginPath(), t.arc(i + a / 2, r + a / 2, a / 2, 0, 2 * Math.PI, !1), t[n](), s && t.stroke();
                  break;

                default:
                  this.transparentCorners || t.clearRect(i, r, a, a), t[n + "Rect"](i, r, a, a), s && t.strokeRect(i, r, a, a);
              }
            }
          },
          isControlVisible: function isControlVisible(e) {
            return this._getControlsVisibility()[e];
          },
          setControlVisible: function setControlVisible(e, t) {
            return this._getControlsVisibility()[e] = t, this;
          },
          setControlsVisibility: function setControlsVisibility(e) {
            for (var t in e || (e = {}), e) {
              this.setControlVisible(t, e[t]);
            }

            return this;
          },
          _getControlsVisibility: function _getControlsVisibility() {
            return this._controlsVisibility || (this._controlsVisibility = {
              tl: !0,
              tr: !0,
              br: !0,
              bl: !0,
              ml: !0,
              mt: !0,
              mr: !0,
              mb: !0,
              mtr: !0
            }), this._controlsVisibility;
          },
          onDeselect: function onDeselect() {},
          onSelect: function onSelect() {}
        });
      }(), T.util.object.extend(T.StaticCanvas.prototype, {
        FX_DURATION: 500,
        fxCenterObjectH: function fxCenterObjectH(e, t) {
          var n = function n() {},
              i = (t = t || {}).onComplete || n,
              r = t.onChange || n,
              o = this;

          return T.util.animate({
            startValue: e.left,
            endValue: this.getCenter().left,
            duration: this.FX_DURATION,
            onChange: function onChange(t) {
              e.set("left", t), o.requestRenderAll(), r();
            },
            onComplete: function onComplete() {
              e.setCoords(), i();
            }
          }), this;
        },
        fxCenterObjectV: function fxCenterObjectV(e, t) {
          var n = function n() {},
              i = (t = t || {}).onComplete || n,
              r = t.onChange || n,
              o = this;

          return T.util.animate({
            startValue: e.top,
            endValue: this.getCenter().top,
            duration: this.FX_DURATION,
            onChange: function onChange(t) {
              e.set("top", t), o.requestRenderAll(), r();
            },
            onComplete: function onComplete() {
              e.setCoords(), i();
            }
          }), this;
        },
        fxRemove: function fxRemove(e, t) {
          var n = function n() {},
              i = (t = t || {}).onComplete || n,
              r = t.onChange || n,
              o = this;

          return T.util.animate({
            startValue: e.opacity,
            endValue: 0,
            duration: this.FX_DURATION,
            onChange: function onChange(t) {
              e.set("opacity", t), o.requestRenderAll(), r();
            },
            onComplete: function onComplete() {
              o.remove(e), i();
            }
          }), this;
        }
      }), T.util.object.extend(T.Object.prototype, {
        animate: function animate() {
          if (arguments[0] && "object" == typeof arguments[0]) {
            var e,
                t,
                n = [];

            for (e in arguments[0]) {
              n.push(e);
            }

            for (var i = 0, r = n.length; i < r; i++) {
              e = n[i], t = i !== r - 1, this._animate(e, arguments[0][e], arguments[1], t);
            }
          } else this._animate.apply(this, arguments);

          return this;
        },
        _animate: function _animate(e, t, n, i) {
          var r,
              o = this;
          t = t.toString(), n = n ? T.util.object.clone(n) : {}, ~e.indexOf(".") && (r = e.split("."));
          var a = r ? this.get(r[0])[r[1]] : this.get(e);
          "from" in n || (n.from = a), t = ~t.indexOf("=") ? a + parseFloat(t.replace("=", "")) : parseFloat(t), T.util.animate({
            startValue: n.from,
            endValue: t,
            byValue: n.by,
            easing: n.easing,
            duration: n.duration,
            abort: n.abort && function () {
              return n.abort.call(o);
            },
            onChange: function onChange(t, a, s) {
              r ? o[r[0]][r[1]] = t : o.set(e, t), i || n.onChange && n.onChange(t, a, s);
            },
            onComplete: function onComplete(e, t, r) {
              i || (o.setCoords(), n.onComplete && n.onComplete(e, t, r));
            }
          });
        }
      }), function (e) {
        "use strict";

        var t = e.fabric || (e.fabric = {}),
            n = t.util.object.extend,
            i = t.util.object.clone,
            r = {
          x1: 1,
          x2: 1,
          y1: 1,
          y2: 1
        },
            o = t.StaticCanvas.supports("setLineDash");

        function a(e, t) {
          var n = e.origin,
              i = e.axis1,
              r = e.axis2,
              o = e.dimension,
              a = t.nearest,
              s = t.center,
              l = t.farthest;
          return function () {
            switch (this.get(n)) {
              case a:
                return Math.min(this.get(i), this.get(r));

              case s:
                return Math.min(this.get(i), this.get(r)) + .5 * this.get(o);

              case l:
                return Math.max(this.get(i), this.get(r));
            }
          };
        }

        t.Line ? t.warn("fabric.Line is already defined") : (t.Line = t.util.createClass(t.Object, {
          type: "line",
          x1: 0,
          y1: 0,
          x2: 0,
          y2: 0,
          cacheProperties: t.Object.prototype.cacheProperties.concat("x1", "x2", "y1", "y2"),
          initialize: function initialize(e, t) {
            e || (e = [0, 0, 0, 0]), this.callSuper("initialize", t), this.set("x1", e[0]), this.set("y1", e[1]), this.set("x2", e[2]), this.set("y2", e[3]), this._setWidthHeight(t);
          },
          _setWidthHeight: function _setWidthHeight(e) {
            e || (e = {}), this.width = Math.abs(this.x2 - this.x1), this.height = Math.abs(this.y2 - this.y1), this.left = "left" in e ? e.left : this._getLeftToOriginX(), this.top = "top" in e ? e.top : this._getTopToOriginY();
          },
          _set: function _set(e, t) {
            return this.callSuper("_set", e, t), void 0 !== r[e] && this._setWidthHeight(), this;
          },
          _getLeftToOriginX: a({
            origin: "originX",
            axis1: "x1",
            axis2: "x2",
            dimension: "width"
          }, {
            nearest: "left",
            center: "center",
            farthest: "right"
          }),
          _getTopToOriginY: a({
            origin: "originY",
            axis1: "y1",
            axis2: "y2",
            dimension: "height"
          }, {
            nearest: "top",
            center: "center",
            farthest: "bottom"
          }),
          _render: function _render(e) {
            if (e.beginPath(), !this.strokeDashArray || this.strokeDashArray && o) {
              var t = this.calcLinePoints();
              e.moveTo(t.x1, t.y1), e.lineTo(t.x2, t.y2);
            }

            e.lineWidth = this.strokeWidth;
            var n = e.strokeStyle;
            e.strokeStyle = this.stroke || e.fillStyle, this.stroke && this._renderStroke(e), e.strokeStyle = n;
          },
          _renderDashedStroke: function _renderDashedStroke(e) {
            var n = this.calcLinePoints();
            e.beginPath(), t.util.drawDashedLine(e, n.x1, n.y1, n.x2, n.y2, this.strokeDashArray), e.closePath();
          },
          _findCenterFromElement: function _findCenterFromElement() {
            return {
              x: (this.x1 + this.x2) / 2,
              y: (this.y1 + this.y2) / 2
            };
          },
          toObject: function toObject(e) {
            return n(this.callSuper("toObject", e), this.calcLinePoints());
          },
          _getNonTransformedDimensions: function _getNonTransformedDimensions() {
            var e = this.callSuper("_getNonTransformedDimensions");
            return "butt" === this.strokeLineCap && (0 === this.width && (e.y -= this.strokeWidth), 0 === this.height && (e.x -= this.strokeWidth)), e;
          },
          calcLinePoints: function calcLinePoints() {
            var e = this.x1 <= this.x2 ? -1 : 1,
                t = this.y1 <= this.y2 ? -1 : 1,
                n = e * this.width * .5,
                i = t * this.height * .5;
            return {
              x1: n,
              x2: e * this.width * -.5,
              y1: i,
              y2: t * this.height * -.5
            };
          },
          _toSVG: function _toSVG() {
            var e = this.calcLinePoints();
            return ["<line ", "COMMON_PARTS", 'x1="', e.x1, '" y1="', e.y1, '" x2="', e.x2, '" y2="', e.y2, '" />\n'];
          }
        }), t.Line.ATTRIBUTE_NAMES = t.SHARED_ATTRIBUTES.concat("x1 y1 x2 y2".split(" ")), t.Line.fromElement = function (e, i, r) {
          r = r || {};
          var o = t.parseAttributes(e, t.Line.ATTRIBUTE_NAMES),
              a = [o.x1 || 0, o.y1 || 0, o.x2 || 0, o.y2 || 0];
          i(new t.Line(a, n(o, r)));
        }, t.Line.fromObject = function (e, n) {
          var r = i(e, !0);
          r.points = [e.x1, e.y1, e.x2, e.y2], t.Object._fromObject("Line", r, function (e) {
            delete e.points, n && n(e);
          }, "points");
        });
      }(t), function (e) {
        "use strict";

        var t = e.fabric || (e.fabric = {}),
            n = Math.PI;
        t.Circle ? t.warn("fabric.Circle is already defined.") : (t.Circle = t.util.createClass(t.Object, {
          type: "circle",
          radius: 0,
          startAngle: 0,
          endAngle: 2 * n,
          cacheProperties: t.Object.prototype.cacheProperties.concat("radius", "startAngle", "endAngle"),
          _set: function _set(e, t) {
            return this.callSuper("_set", e, t), "radius" === e && this.setRadius(t), this;
          },
          toObject: function toObject(e) {
            return this.callSuper("toObject", ["radius", "startAngle", "endAngle"].concat(e));
          },
          _toSVG: function _toSVG() {
            var e,
                i = (this.endAngle - this.startAngle) % (2 * n);
            if (0 === i) e = ["<circle ", "COMMON_PARTS", 'cx="0" cy="0" ', 'r="', this.radius, '" />\n'];else {
              var r = t.util.cos(this.startAngle) * this.radius,
                  o = t.util.sin(this.startAngle) * this.radius,
                  a = t.util.cos(this.endAngle) * this.radius,
                  s = t.util.sin(this.endAngle) * this.radius,
                  l = i > n ? "1" : "0";
              e = ['<path d="M ' + r + " " + o, " A " + this.radius + " " + this.radius, " 0 ", +l + " 1", " " + a + " " + s, '" ', "COMMON_PARTS", " />\n"];
            }
            return e;
          },
          _render: function _render(e) {
            e.beginPath(), e.arc(0, 0, this.radius, this.startAngle, this.endAngle, !1), this._renderPaintInOrder(e);
          },
          getRadiusX: function getRadiusX() {
            return this.get("radius") * this.get("scaleX");
          },
          getRadiusY: function getRadiusY() {
            return this.get("radius") * this.get("scaleY");
          },
          setRadius: function setRadius(e) {
            return this.radius = e, this.set("width", 2 * e).set("height", 2 * e);
          }
        }), t.Circle.ATTRIBUTE_NAMES = t.SHARED_ATTRIBUTES.concat("cx cy r".split(" ")), t.Circle.fromElement = function (e, n) {
          var i,
              r = t.parseAttributes(e, t.Circle.ATTRIBUTE_NAMES);
          if (!("radius" in (i = r) && i.radius >= 0)) throw new Error("value of `r` attribute is required and can not be negative");
          r.left = (r.left || 0) - r.radius, r.top = (r.top || 0) - r.radius, n(new t.Circle(r));
        }, t.Circle.fromObject = function (e, n) {
          return t.Object._fromObject("Circle", e, n);
        });
      }(t), function (e) {
        "use strict";

        var t = e.fabric || (e.fabric = {});
        t.Triangle ? t.warn("fabric.Triangle is already defined") : (t.Triangle = t.util.createClass(t.Object, {
          type: "triangle",
          width: 100,
          height: 100,
          _render: function _render(e) {
            var t = this.width / 2,
                n = this.height / 2;
            e.beginPath(), e.moveTo(-t, n), e.lineTo(0, -n), e.lineTo(t, n), e.closePath(), this._renderPaintInOrder(e);
          },
          _renderDashedStroke: function _renderDashedStroke(e) {
            var n = this.width / 2,
                i = this.height / 2;
            e.beginPath(), t.util.drawDashedLine(e, -n, i, 0, -i, this.strokeDashArray), t.util.drawDashedLine(e, 0, -i, n, i, this.strokeDashArray), t.util.drawDashedLine(e, n, i, -n, i, this.strokeDashArray), e.closePath();
          },
          _toSVG: function _toSVG() {
            var e = this.width / 2,
                t = this.height / 2;
            return ["<polygon ", "COMMON_PARTS", 'points="', [-e + " " + t, "0 " + -t, e + " " + t].join(","), '" />'];
          }
        }), t.Triangle.fromObject = function (e, n) {
          return t.Object._fromObject("Triangle", e, n);
        });
      }(t), function (e) {
        "use strict";

        var t = e.fabric || (e.fabric = {}),
            n = 2 * Math.PI;
        t.Ellipse ? t.warn("fabric.Ellipse is already defined.") : (t.Ellipse = t.util.createClass(t.Object, {
          type: "ellipse",
          rx: 0,
          ry: 0,
          cacheProperties: t.Object.prototype.cacheProperties.concat("rx", "ry"),
          initialize: function initialize(e) {
            this.callSuper("initialize", e), this.set("rx", e && e.rx || 0), this.set("ry", e && e.ry || 0);
          },
          _set: function _set(e, t) {
            switch (this.callSuper("_set", e, t), e) {
              case "rx":
                this.rx = t, this.set("width", 2 * t);
                break;

              case "ry":
                this.ry = t, this.set("height", 2 * t);
            }

            return this;
          },
          getRx: function getRx() {
            return this.get("rx") * this.get("scaleX");
          },
          getRy: function getRy() {
            return this.get("ry") * this.get("scaleY");
          },
          toObject: function toObject(e) {
            return this.callSuper("toObject", ["rx", "ry"].concat(e));
          },
          _toSVG: function _toSVG() {
            return ["<ellipse ", "COMMON_PARTS", 'cx="0" cy="0" ', 'rx="', this.rx, '" ry="', this.ry, '" />\n'];
          },
          _render: function _render(e) {
            e.beginPath(), e.save(), e.transform(1, 0, 0, this.ry / this.rx, 0, 0), e.arc(0, 0, this.rx, 0, n, !1), e.restore(), this._renderPaintInOrder(e);
          }
        }), t.Ellipse.ATTRIBUTE_NAMES = t.SHARED_ATTRIBUTES.concat("cx cy rx ry".split(" ")), t.Ellipse.fromElement = function (e, n) {
          var i = t.parseAttributes(e, t.Ellipse.ATTRIBUTE_NAMES);
          i.left = (i.left || 0) - i.rx, i.top = (i.top || 0) - i.ry, n(new t.Ellipse(i));
        }, t.Ellipse.fromObject = function (e, n) {
          return t.Object._fromObject("Ellipse", e, n);
        });
      }(t), function (e) {
        "use strict";

        var t = e.fabric || (e.fabric = {}),
            n = t.util.object.extend;
        t.Rect ? t.warn("fabric.Rect is already defined") : (t.Rect = t.util.createClass(t.Object, {
          stateProperties: t.Object.prototype.stateProperties.concat("rx", "ry"),
          type: "rect",
          rx: 0,
          ry: 0,
          cacheProperties: t.Object.prototype.cacheProperties.concat("rx", "ry"),
          initialize: function initialize(e) {
            this.callSuper("initialize", e), this._initRxRy();
          },
          _initRxRy: function _initRxRy() {
            this.rx && !this.ry ? this.ry = this.rx : this.ry && !this.rx && (this.rx = this.ry);
          },
          _render: function _render(e) {
            var t = this.rx ? Math.min(this.rx, this.width / 2) : 0,
                n = this.ry ? Math.min(this.ry, this.height / 2) : 0,
                i = this.width,
                r = this.height,
                o = -this.width / 2,
                a = -this.height / 2,
                s = 0 !== t || 0 !== n,
                l = .4477152502;
            e.beginPath(), e.moveTo(o + t, a), e.lineTo(o + i - t, a), s && e.bezierCurveTo(o + i - l * t, a, o + i, a + l * n, o + i, a + n), e.lineTo(o + i, a + r - n), s && e.bezierCurveTo(o + i, a + r - l * n, o + i - l * t, a + r, o + i - t, a + r), e.lineTo(o + t, a + r), s && e.bezierCurveTo(o + l * t, a + r, o, a + r - l * n, o, a + r - n), e.lineTo(o, a + n), s && e.bezierCurveTo(o, a + l * n, o + l * t, a, o + t, a), e.closePath(), this._renderPaintInOrder(e);
          },
          _renderDashedStroke: function _renderDashedStroke(e) {
            var n = -this.width / 2,
                i = -this.height / 2,
                r = this.width,
                o = this.height;
            e.beginPath(), t.util.drawDashedLine(e, n, i, n + r, i, this.strokeDashArray), t.util.drawDashedLine(e, n + r, i, n + r, i + o, this.strokeDashArray), t.util.drawDashedLine(e, n + r, i + o, n, i + o, this.strokeDashArray), t.util.drawDashedLine(e, n, i + o, n, i, this.strokeDashArray), e.closePath();
          },
          toObject: function toObject(e) {
            return this.callSuper("toObject", ["rx", "ry"].concat(e));
          },
          _toSVG: function _toSVG() {
            return ["<rect ", "COMMON_PARTS", 'x="', -this.width / 2, '" y="', -this.height / 2, '" rx="', this.rx, '" ry="', this.ry, '" width="', this.width, '" height="', this.height, '" />\n'];
          }
        }), t.Rect.ATTRIBUTE_NAMES = t.SHARED_ATTRIBUTES.concat("x y rx ry width height".split(" ")), t.Rect.fromElement = function (e, i, r) {
          if (!e) return i(null);
          r = r || {};
          var o = t.parseAttributes(e, t.Rect.ATTRIBUTE_NAMES);
          o.left = o.left || 0, o.top = o.top || 0, o.height = o.height || 0, o.width = o.width || 0;
          var a = new t.Rect(n(r ? t.util.object.clone(r) : {}, o));
          a.visible = a.visible && a.width > 0 && a.height > 0, i(a);
        }, t.Rect.fromObject = function (e, n) {
          return t.Object._fromObject("Rect", e, n);
        });
      }(t), function (e) {
        "use strict";

        var t = e.fabric || (e.fabric = {}),
            n = t.util.object.extend,
            i = t.util.array.min,
            r = t.util.array.max,
            o = t.util.toFixed;
        t.Polyline ? t.warn("fabric.Polyline is already defined") : (t.Polyline = t.util.createClass(t.Object, {
          type: "polyline",
          points: null,
          cacheProperties: t.Object.prototype.cacheProperties.concat("points"),
          initialize: function initialize(e, t) {
            t = t || {}, this.points = e || [], this.callSuper("initialize", t), this._setPositionDimensions(t);
          },
          _setPositionDimensions: function _setPositionDimensions(e) {
            var t,
                n = this._calcDimensions(e);

            this.width = n.width, this.height = n.height, e.fromSVG || (t = this.translateToGivenOrigin({
              x: n.left - this.strokeWidth / 2,
              y: n.top - this.strokeWidth / 2
            }, "left", "top", this.originX, this.originY)), void 0 === e.left && (this.left = e.fromSVG ? n.left : t.x), void 0 === e.top && (this.top = e.fromSVG ? n.top : t.y), this.pathOffset = {
              x: n.left + this.width / 2,
              y: n.top + this.height / 2
            };
          },
          _calcDimensions: function _calcDimensions() {
            var e = this.points,
                t = i(e, "x") || 0,
                n = i(e, "y") || 0;
            return {
              left: t,
              top: n,
              width: (r(e, "x") || 0) - t,
              height: (r(e, "y") || 0) - n
            };
          },
          toObject: function toObject(e) {
            return n(this.callSuper("toObject", e), {
              points: this.points.concat()
            });
          },
          _toSVG: function _toSVG() {
            for (var e = [], n = this.pathOffset.x, i = this.pathOffset.y, r = t.Object.NUM_FRACTION_DIGITS, a = 0, s = this.points.length; a < s; a++) {
              e.push(o(this.points[a].x - n, r), ",", o(this.points[a].y - i, r), " ");
            }

            return ["<" + this.type + " ", "COMMON_PARTS", 'points="', e.join(""), '" />\n'];
          },
          commonRender: function commonRender(e) {
            var t,
                n = this.points.length,
                i = this.pathOffset.x,
                r = this.pathOffset.y;
            if (!n || isNaN(this.points[n - 1].y)) return !1;
            e.beginPath(), e.moveTo(this.points[0].x - i, this.points[0].y - r);

            for (var o = 0; o < n; o++) {
              t = this.points[o], e.lineTo(t.x - i, t.y - r);
            }

            return !0;
          },
          _render: function _render(e) {
            this.commonRender(e) && this._renderPaintInOrder(e);
          },
          _renderDashedStroke: function _renderDashedStroke(e) {
            var n, i;
            e.beginPath();

            for (var r = 0, o = this.points.length; r < o; r++) {
              n = this.points[r], i = this.points[r + 1] || n, t.util.drawDashedLine(e, n.x, n.y, i.x, i.y, this.strokeDashArray);
            }
          },
          complexity: function complexity() {
            return this.get("points").length;
          }
        }), t.Polyline.ATTRIBUTE_NAMES = t.SHARED_ATTRIBUTES.concat(), t.Polyline.fromElementGenerator = function (e) {
          return function (i, r, o) {
            if (!i) return r(null);
            o || (o = {});
            var a = t.parsePointsAttribute(i.getAttribute("points")),
                s = t.parseAttributes(i, t[e].ATTRIBUTE_NAMES);
            s.fromSVG = !0, r(new t[e](a, n(s, o)));
          };
        }, t.Polyline.fromElement = t.Polyline.fromElementGenerator("Polyline"), t.Polyline.fromObject = function (e, n) {
          return t.Object._fromObject("Polyline", e, n, "points");
        });
      }(t), function (e) {
        "use strict";

        var t = e.fabric || (e.fabric = {});
        t.Polygon ? t.warn("fabric.Polygon is already defined") : (t.Polygon = t.util.createClass(t.Polyline, {
          type: "polygon",
          _render: function _render(e) {
            this.commonRender(e) && (e.closePath(), this._renderPaintInOrder(e));
          },
          _renderDashedStroke: function _renderDashedStroke(e) {
            this.callSuper("_renderDashedStroke", e), e.closePath();
          }
        }), t.Polygon.ATTRIBUTE_NAMES = t.SHARED_ATTRIBUTES.concat(), t.Polygon.fromElement = t.Polyline.fromElementGenerator("Polygon"), t.Polygon.fromObject = function (e, n) {
          return t.Object._fromObject("Polygon", e, n, "points");
        });
      }(t), function (e) {
        "use strict";

        var t = e.fabric || (e.fabric = {}),
            n = t.util.array.min,
            i = t.util.array.max,
            r = t.util.object.extend,
            o = Object.prototype.toString,
            a = t.util.drawArc,
            s = t.util.toFixed,
            l = {
          m: 2,
          l: 2,
          h: 1,
          v: 1,
          c: 6,
          s: 4,
          q: 4,
          t: 2,
          a: 7
        },
            u = {
          m: "l",
          M: "L"
        };
        t.Path ? t.warn("fabric.Path is already defined") : (t.Path = t.util.createClass(t.Object, {
          type: "path",
          path: null,
          cacheProperties: t.Object.prototype.cacheProperties.concat("path", "fillRule"),
          stateProperties: t.Object.prototype.stateProperties.concat("path"),
          initialize: function initialize(e, n) {
            n = n || {}, this.callSuper("initialize", n), e || (e = []);
            var i = "[object Array]" === o.call(e);
            this.path = i ? e : e.match && e.match(/[mzlhvcsqta][^mzlhvcsqta]*/gi), this.path && (i || (this.path = this._parsePath()), t.Polyline.prototype._setPositionDimensions.call(this, n));
          },
          _renderPathCommands: function _renderPathCommands(e) {
            var t,
                n,
                i,
                r = null,
                o = 0,
                s = 0,
                l = 0,
                u = 0,
                c = 0,
                h = 0,
                d = -this.pathOffset.x,
                f = -this.pathOffset.y;
            e.beginPath();

            for (var p = 0, g = this.path.length; p < g; ++p) {
              switch ((t = this.path[p])[0]) {
                case "l":
                  l += t[1], u += t[2], e.lineTo(l + d, u + f);
                  break;

                case "L":
                  l = t[1], u = t[2], e.lineTo(l + d, u + f);
                  break;

                case "h":
                  l += t[1], e.lineTo(l + d, u + f);
                  break;

                case "H":
                  l = t[1], e.lineTo(l + d, u + f);
                  break;

                case "v":
                  u += t[1], e.lineTo(l + d, u + f);
                  break;

                case "V":
                  u = t[1], e.lineTo(l + d, u + f);
                  break;

                case "m":
                  o = l += t[1], s = u += t[2], e.moveTo(l + d, u + f);
                  break;

                case "M":
                  o = l = t[1], s = u = t[2], e.moveTo(l + d, u + f);
                  break;

                case "c":
                  n = l + t[5], i = u + t[6], c = l + t[3], h = u + t[4], e.bezierCurveTo(l + t[1] + d, u + t[2] + f, c + d, h + f, n + d, i + f), l = n, u = i;
                  break;

                case "C":
                  l = t[5], u = t[6], c = t[3], h = t[4], e.bezierCurveTo(t[1] + d, t[2] + f, c + d, h + f, l + d, u + f);
                  break;

                case "s":
                  n = l + t[3], i = u + t[4], null === r[0].match(/[CcSs]/) ? (c = l, h = u) : (c = 2 * l - c, h = 2 * u - h), e.bezierCurveTo(c + d, h + f, l + t[1] + d, u + t[2] + f, n + d, i + f), c = l + t[1], h = u + t[2], l = n, u = i;
                  break;

                case "S":
                  n = t[3], i = t[4], null === r[0].match(/[CcSs]/) ? (c = l, h = u) : (c = 2 * l - c, h = 2 * u - h), e.bezierCurveTo(c + d, h + f, t[1] + d, t[2] + f, n + d, i + f), l = n, u = i, c = t[1], h = t[2];
                  break;

                case "q":
                  n = l + t[3], i = u + t[4], c = l + t[1], h = u + t[2], e.quadraticCurveTo(c + d, h + f, n + d, i + f), l = n, u = i;
                  break;

                case "Q":
                  n = t[3], i = t[4], e.quadraticCurveTo(t[1] + d, t[2] + f, n + d, i + f), l = n, u = i, c = t[1], h = t[2];
                  break;

                case "t":
                  n = l + t[1], i = u + t[2], null === r[0].match(/[QqTt]/) ? (c = l, h = u) : (c = 2 * l - c, h = 2 * u - h), e.quadraticCurveTo(c + d, h + f, n + d, i + f), l = n, u = i;
                  break;

                case "T":
                  n = t[1], i = t[2], null === r[0].match(/[QqTt]/) ? (c = l, h = u) : (c = 2 * l - c, h = 2 * u - h), e.quadraticCurveTo(c + d, h + f, n + d, i + f), l = n, u = i;
                  break;

                case "a":
                  a(e, l + d, u + f, [t[1], t[2], t[3], t[4], t[5], t[6] + l + d, t[7] + u + f]), l += t[6], u += t[7];
                  break;

                case "A":
                  a(e, l + d, u + f, [t[1], t[2], t[3], t[4], t[5], t[6] + d, t[7] + f]), l = t[6], u = t[7];
                  break;

                case "z":
                case "Z":
                  l = o, u = s, e.closePath();
              }

              r = t;
            }
          },
          _render: function _render(e) {
            this._renderPathCommands(e), this._renderPaintInOrder(e);
          },
          toString: function toString() {
            return "#<fabric.Path (" + this.complexity() + '): { "top": ' + this.top + ', "left": ' + this.left + " }>";
          },
          toObject: function toObject(e) {
            return r(this.callSuper("toObject", e), {
              path: this.path.map(function (e) {
                return e.slice();
              })
            });
          },
          toDatalessObject: function toDatalessObject(e) {
            var t = this.toObject(["sourcePath"].concat(e));
            return t.sourcePath && delete t.path, t;
          },
          _toSVG: function _toSVG() {
            return ["<path ", "COMMON_PARTS", 'd="', this.path.map(function (e) {
              return e.join(" ");
            }).join(" "), '" stroke-linecap="round" ', "/>\n"];
          },
          _getOffsetTransform: function _getOffsetTransform() {
            var e = t.Object.NUM_FRACTION_DIGITS;
            return " translate(" + s(-this.pathOffset.x, e) + ", " + s(-this.pathOffset.y, e) + ")";
          },
          toClipPathSVG: function toClipPathSVG(e) {
            var t = this._getOffsetTransform();

            return "\t" + this._createBaseClipPathSVGMarkup(this._toSVG(), {
              reviver: e,
              additionalTransform: t
            });
          },
          toSVG: function toSVG(e) {
            var t = this._getOffsetTransform();

            return this._createBaseSVGMarkup(this._toSVG(), {
              reviver: e,
              additionalTransform: t
            });
          },
          complexity: function complexity() {
            return this.path.length;
          },
          _parsePath: function _parsePath() {
            for (var e, n, i, r, o, a = [], s = [], c = t.rePathCommand, h = 0, d = this.path.length; h < d; h++) {
              for (r = (e = this.path[h]).slice(1).trim(), s.length = 0; i = c.exec(r);) {
                s.push(i[0]);
              }

              o = [e.charAt(0)];

              for (var f = 0, p = s.length; f < p; f++) {
                n = parseFloat(s[f]), isNaN(n) || o.push(n);
              }

              var g = o[0],
                  v = l[g.toLowerCase()],
                  m = u[g] || g;
              if (o.length - 1 > v) for (var y = 1, x = o.length; y < x; y += v) {
                a.push([g].concat(o.slice(y, y + v))), g = m;
              } else a.push(o);
            }

            return a;
          },
          _calcDimensions: function _calcDimensions() {
            for (var e, r, o, a, s = [], l = [], u = null, c = 0, h = 0, d = 0, f = 0, p = 0, g = 0, v = 0, m = this.path.length; v < m; ++v) {
              switch ((e = this.path[v])[0]) {
                case "l":
                  d += e[1], f += e[2], a = [];
                  break;

                case "L":
                  d = e[1], f = e[2], a = [];
                  break;

                case "h":
                  d += e[1], a = [];
                  break;

                case "H":
                  d = e[1], a = [];
                  break;

                case "v":
                  f += e[1], a = [];
                  break;

                case "V":
                  f = e[1], a = [];
                  break;

                case "m":
                  c = d += e[1], h = f += e[2], a = [];
                  break;

                case "M":
                  c = d = e[1], h = f = e[2], a = [];
                  break;

                case "c":
                  r = d + e[5], o = f + e[6], p = d + e[3], g = f + e[4], a = t.util.getBoundsOfCurve(d, f, d + e[1], f + e[2], p, g, r, o), d = r, f = o;
                  break;

                case "C":
                  p = e[3], g = e[4], a = t.util.getBoundsOfCurve(d, f, e[1], e[2], p, g, e[5], e[6]), d = e[5], f = e[6];
                  break;

                case "s":
                  r = d + e[3], o = f + e[4], null === u[0].match(/[CcSs]/) ? (p = d, g = f) : (p = 2 * d - p, g = 2 * f - g), a = t.util.getBoundsOfCurve(d, f, p, g, d + e[1], f + e[2], r, o), p = d + e[1], g = f + e[2], d = r, f = o;
                  break;

                case "S":
                  r = e[3], o = e[4], null === u[0].match(/[CcSs]/) ? (p = d, g = f) : (p = 2 * d - p, g = 2 * f - g), a = t.util.getBoundsOfCurve(d, f, p, g, e[1], e[2], r, o), d = r, f = o, p = e[1], g = e[2];
                  break;

                case "q":
                  r = d + e[3], o = f + e[4], p = d + e[1], g = f + e[2], a = t.util.getBoundsOfCurve(d, f, p, g, p, g, r, o), d = r, f = o;
                  break;

                case "Q":
                  p = e[1], g = e[2], a = t.util.getBoundsOfCurve(d, f, p, g, p, g, e[3], e[4]), d = e[3], f = e[4];
                  break;

                case "t":
                  r = d + e[1], o = f + e[2], null === u[0].match(/[QqTt]/) ? (p = d, g = f) : (p = 2 * d - p, g = 2 * f - g), a = t.util.getBoundsOfCurve(d, f, p, g, p, g, r, o), d = r, f = o;
                  break;

                case "T":
                  r = e[1], o = e[2], null === u[0].match(/[QqTt]/) ? (p = d, g = f) : (p = 2 * d - p, g = 2 * f - g), a = t.util.getBoundsOfCurve(d, f, p, g, p, g, r, o), d = r, f = o;
                  break;

                case "a":
                  a = t.util.getBoundsOfArc(d, f, e[1], e[2], e[3], e[4], e[5], e[6] + d, e[7] + f), d += e[6], f += e[7];
                  break;

                case "A":
                  a = t.util.getBoundsOfArc(d, f, e[1], e[2], e[3], e[4], e[5], e[6], e[7]), d = e[6], f = e[7];
                  break;

                case "z":
                case "Z":
                  d = c, f = h;
              }

              u = e, a.forEach(function (e) {
                s.push(e.x), l.push(e.y);
              }), s.push(d), l.push(f);
            }

            var y = n(s) || 0,
                x = n(l) || 0;
            return {
              left: y,
              top: x,
              width: (i(s) || 0) - y,
              height: (i(l) || 0) - x
            };
          }
        }), t.Path.fromObject = function (e, n) {
          if ("string" == typeof e.sourcePath) {
            var i = e.sourcePath;
            t.loadSVGFromURL(i, function (t) {
              var i = t[0];
              i.setOptions(e), n && n(i);
            });
          } else t.Object._fromObject("Path", e, n, "path");
        }, t.Path.ATTRIBUTE_NAMES = t.SHARED_ATTRIBUTES.concat(["d"]), t.Path.fromElement = function (e, n, i) {
          var o = t.parseAttributes(e, t.Path.ATTRIBUTE_NAMES);
          o.fromSVG = !0, n(new t.Path(o.d, r(o, i)));
        });
      }(t), function (e) {
        "use strict";

        var t = e.fabric || (e.fabric = {}),
            n = t.util.array.min,
            i = t.util.array.max;
        t.Group || (t.Group = t.util.createClass(t.Object, t.Collection, {
          type: "group",
          strokeWidth: 0,
          subTargetCheck: !1,
          cacheProperties: [],
          useSetOnGroup: !1,
          initialize: function initialize(e, t, n) {
            t = t || {}, this._objects = [], n && this.callSuper("initialize", t), this._objects = e || [];

            for (var i = this._objects.length; i--;) {
              this._objects[i].group = this;
            }

            if (n) this._updateObjectsACoords();else {
              var r = t && t.centerPoint;
              void 0 !== t.originX && (this.originX = t.originX), void 0 !== t.originY && (this.originY = t.originY), r || this._calcBounds(), this._updateObjectsCoords(r), delete t.centerPoint, this.callSuper("initialize", t);
            }
            this.setCoords();
          },
          _updateObjectsACoords: function _updateObjectsACoords() {
            for (var e = this._objects.length; e--;) {
              this._objects[e].setCoords(!0, !0);
            }
          },
          _updateObjectsCoords: function _updateObjectsCoords(e) {
            e = e || this.getCenterPoint();

            for (var t = this._objects.length; t--;) {
              this._updateObjectCoords(this._objects[t], e);
            }
          },
          _updateObjectCoords: function _updateObjectCoords(e, t) {
            var n = e.left,
                i = e.top;
            e.set({
              left: n - t.x,
              top: i - t.y
            }), e.group = this, e.setCoords(!0, !0);
          },
          toString: function toString() {
            return "#<fabric.Group: (" + this.complexity() + ")>";
          },
          addWithUpdate: function addWithUpdate(e) {
            return this._restoreObjectsState(), t.util.resetObjectTransform(this), e && (this._objects.push(e), e.group = this, e._set("canvas", this.canvas)), this._calcBounds(), this._updateObjectsCoords(), this.setCoords(), this.dirty = !0, this;
          },
          removeWithUpdate: function removeWithUpdate(e) {
            return this._restoreObjectsState(), t.util.resetObjectTransform(this), this.remove(e), this._calcBounds(), this._updateObjectsCoords(), this.setCoords(), this.dirty = !0, this;
          },
          _onObjectAdded: function _onObjectAdded(e) {
            this.dirty = !0, e.group = this, e._set("canvas", this.canvas);
          },
          _onObjectRemoved: function _onObjectRemoved(e) {
            this.dirty = !0, delete e.group;
          },
          _set: function _set(e, n) {
            var i = this._objects.length;
            if (this.useSetOnGroup) for (; i--;) {
              this._objects[i].setOnGroup(e, n);
            }
            if ("canvas" === e) for (; i--;) {
              this._objects[i]._set(e, n);
            }

            t.Object.prototype._set.call(this, e, n);
          },
          toObject: function toObject(e) {
            var n = this.includeDefaultValues,
                i = this._objects.map(function (t) {
              var i = t.includeDefaultValues;
              t.includeDefaultValues = n;
              var r = t.toObject(e);
              return t.includeDefaultValues = i, r;
            }),
                r = t.Object.prototype.toObject.call(this, e);

            return r.objects = i, r;
          },
          toDatalessObject: function toDatalessObject(e) {
            var n,
                i = this.sourcePath;
            if (i) n = i;else {
              var r = this.includeDefaultValues;
              n = this._objects.map(function (t) {
                var n = t.includeDefaultValues;
                t.includeDefaultValues = r;
                var i = t.toDatalessObject(e);
                return t.includeDefaultValues = n, i;
              });
            }
            var o = t.Object.prototype.toDatalessObject.call(this, e);
            return o.objects = n, o;
          },
          render: function render(e) {
            this._transformDone = !0, this.callSuper("render", e), this._transformDone = !1;
          },
          shouldCache: function shouldCache() {
            var e = t.Object.prototype.shouldCache.call(this);
            if (e) for (var n = 0, i = this._objects.length; n < i; n++) {
              if (this._objects[n].willDrawShadow()) return this.ownCaching = !1, !1;
            }
            return e;
          },
          willDrawShadow: function willDrawShadow() {
            if (t.Object.prototype.willDrawShadow.call(this)) return !0;

            for (var e = 0, n = this._objects.length; e < n; e++) {
              if (this._objects[e].willDrawShadow()) return !0;
            }

            return !1;
          },
          isOnACache: function isOnACache() {
            return this.ownCaching || this.group && this.group.isOnACache();
          },
          drawObject: function drawObject(e) {
            for (var t = 0, n = this._objects.length; t < n; t++) {
              this._objects[t].render(e);
            }

            this._drawClipPath(e);
          },
          isCacheDirty: function isCacheDirty(e) {
            if (this.callSuper("isCacheDirty", e)) return !0;
            if (!this.statefullCache) return !1;

            for (var t = 0, n = this._objects.length; t < n; t++) {
              if (this._objects[t].isCacheDirty(!0)) {
                if (this._cacheCanvas) {
                  var i = this.cacheWidth / this.zoomX,
                      r = this.cacheHeight / this.zoomY;

                  this._cacheContext.clearRect(-i / 2, -r / 2, i, r);
                }

                return !0;
              }
            }

            return !1;
          },
          _restoreObjectsState: function _restoreObjectsState() {
            return this._objects.forEach(this._restoreObjectState, this), this;
          },
          realizeTransform: function realizeTransform(e) {
            var n = e.calcTransformMatrix(),
                i = t.util.qrDecompose(n),
                r = new t.Point(i.translateX, i.translateY);
            return e.flipX = !1, e.flipY = !1, e.set("scaleX", i.scaleX), e.set("scaleY", i.scaleY), e.skewX = i.skewX, e.skewY = i.skewY, e.angle = i.angle, e.setPositionByOrigin(r, "center", "center"), e;
          },
          _restoreObjectState: function _restoreObjectState(e) {
            return this.realizeTransform(e), e.setCoords(), delete e.group, this;
          },
          destroy: function destroy() {
            return this._objects.forEach(function (e) {
              e.set("dirty", !0);
            }), this._restoreObjectsState();
          },
          toActiveSelection: function toActiveSelection() {
            if (this.canvas) {
              var e = this._objects,
                  n = this.canvas;
              this._objects = [];
              var i = this.toObject();
              delete i.objects;
              var r = new t.ActiveSelection([]);
              return r.set(i), r.type = "activeSelection", n.remove(this), e.forEach(function (e) {
                e.group = r, e.dirty = !0, n.add(e);
              }), r.canvas = n, r._objects = e, n._activeObject = r, r.setCoords(), r;
            }
          },
          ungroupOnCanvas: function ungroupOnCanvas() {
            return this._restoreObjectsState();
          },
          setObjectsCoords: function setObjectsCoords() {
            return this.forEachObject(function (e) {
              e.setCoords(!0, !0);
            }), this;
          },
          _calcBounds: function _calcBounds(e) {
            for (var t, n, i, r = [], o = [], a = ["tr", "br", "bl", "tl"], s = 0, l = this._objects.length, u = a.length; s < l; ++s) {
              for ((t = this._objects[s]).setCoords(!0), i = 0; i < u; i++) {
                n = a[i], r.push(t.oCoords[n].x), o.push(t.oCoords[n].y);
              }
            }

            this._getBounds(r, o, e);
          },
          _getBounds: function _getBounds(e, r, o) {
            var a = new t.Point(n(e), n(r)),
                s = new t.Point(i(e), i(r)),
                l = a.y || 0,
                u = a.x || 0,
                c = s.x - a.x || 0,
                h = s.y - a.y || 0;
            this.width = c, this.height = h, o || this.setPositionByOrigin({
              x: u,
              y: l
            }, "left", "top");
          },
          _toSVG: function _toSVG(e) {
            for (var t = ["<g ", "COMMON_PARTS", " >\n"], n = 0, i = this._objects.length; n < i; n++) {
              t.push("\t\t", this._objects[n].toSVG(e));
            }

            return t.push("</g>\n"), t;
          },
          getSvgStyles: function getSvgStyles() {
            var e = void 0 !== this.opacity && 1 !== this.opacity ? "opacity: " + this.opacity + ";" : "",
                t = this.visible ? "" : " visibility: hidden;";
            return [e, this.getSvgFilter(), t].join("");
          },
          toClipPathSVG: function toClipPathSVG(e) {
            for (var t = [], n = 0, i = this._objects.length; n < i; n++) {
              t.push("\t", this._objects[n].toClipPathSVG(e));
            }

            return this._createBaseClipPathSVGMarkup(t, {
              reviver: e
            });
          }
        }), t.Group.fromObject = function (e, n) {
          var i = e.objects,
              r = t.util.object.clone(e, !0);
          delete r.objects, "string" != typeof i ? t.util.enlivenObjects(i, function (i) {
            t.util.enlivenObjects([e.clipPath], function (r) {
              var o = t.util.object.clone(e, !0);
              o.clipPath = r[0], delete o.objects, n && n(new t.Group(i, o, !0));
            });
          }) : t.loadSVGFromURL(i, function (o) {
            var a = t.util.groupSVGElements(o, e, i);
            a.set(r), n && n(a);
          });
        });
      }(t), function (e) {
        "use strict";

        var t = e.fabric || (e.fabric = {});
        t.ActiveSelection || (t.ActiveSelection = t.util.createClass(t.Group, {
          type: "activeSelection",
          initialize: function initialize(e, n) {
            n = n || {}, this._objects = e || [];

            for (var i = this._objects.length; i--;) {
              this._objects[i].group = this;
            }

            n.originX && (this.originX = n.originX), n.originY && (this.originY = n.originY), this._calcBounds(), this._updateObjectsCoords(), t.Object.prototype.initialize.call(this, n), this.setCoords();
          },
          toGroup: function toGroup() {
            var e = this._objects.concat();

            this._objects = [];
            var n = t.Object.prototype.toObject.call(this),
                i = new t.Group([]);
            if (delete n.type, i.set(n), e.forEach(function (e) {
              e.canvas.remove(e), e.group = i;
            }), i._objects = e, !this.canvas) return i;
            var r = this.canvas;
            return r.add(i), r._activeObject = i, i.setCoords(), i;
          },
          onDeselect: function onDeselect() {
            return this.destroy(), !1;
          },
          toString: function toString() {
            return "#<fabric.ActiveSelection: (" + this.complexity() + ")>";
          },
          shouldCache: function shouldCache() {
            return !1;
          },
          isOnACache: function isOnACache() {
            return !1;
          },
          _renderControls: function _renderControls(e, t, n) {
            e.save(), e.globalAlpha = this.isMoving ? this.borderOpacityWhenMoving : 1, this.callSuper("_renderControls", e, t), void 0 === (n = n || {}).hasControls && (n.hasControls = !1), void 0 === n.hasRotatingPoint && (n.hasRotatingPoint = !1), n.forActiveSelection = !0;

            for (var i = 0, r = this._objects.length; i < r; i++) {
              this._objects[i]._renderControls(e, n);
            }

            e.restore();
          }
        }), t.ActiveSelection.fromObject = function (e, n) {
          t.util.enlivenObjects(e.objects, function (i) {
            delete e.objects, n && n(new t.ActiveSelection(i, e, !0));
          });
        });
      }(t), function (e) {
        "use strict";

        var t = T.util.object.extend;
        e.fabric || (e.fabric = {}), e.fabric.Image ? T.warn("fabric.Image is already defined.") : (T.Image = T.util.createClass(T.Object, {
          type: "image",
          crossOrigin: "",
          strokeWidth: 0,
          srcFromAttribute: !1,
          _lastScaleX: 1,
          _lastScaleY: 1,
          _filterScalingX: 1,
          _filterScalingY: 1,
          minimumScaleTrigger: .5,
          stateProperties: T.Object.prototype.stateProperties.concat("cropX", "cropY"),
          cacheKey: "",
          cropX: 0,
          cropY: 0,
          initialize: function initialize(e, t) {
            t || (t = {}), this.filters = [], this.cacheKey = "texture" + T.Object.__uid++, this.callSuper("initialize", t), this._initElement(e, t);
          },
          getElement: function getElement() {
            return this._element || {};
          },
          setElement: function setElement(e, t) {
            return this.removeTexture(this.cacheKey), this.removeTexture(this.cacheKey + "_filtered"), this._element = e, this._originalElement = e, this._initConfig(t), 0 !== this.filters.length && this.applyFilters(), this.resizeFilter && this.applyResizeFilters(), this;
          },
          removeTexture: function removeTexture(e) {
            var t = T.filterBackend;
            t && t.evictCachesForKey && t.evictCachesForKey(e);
          },
          dispose: function dispose() {
            this.removeTexture(this.cacheKey), this.removeTexture(this.cacheKey + "_filtered"), this._cacheContext = void 0, ["_originalElement", "_element", "_filteredEl", "_cacheCanvas"].forEach(function (e) {
              T.util.cleanUpJsdomNode(this[e]), this[e] = void 0;
            }.bind(this));
          },
          setCrossOrigin: function setCrossOrigin(e) {
            return this.crossOrigin = e, this._element.crossOrigin = e, this;
          },
          getOriginalSize: function getOriginalSize() {
            var e = this.getElement();
            return {
              width: e.naturalWidth || e.width,
              height: e.naturalHeight || e.height
            };
          },
          _stroke: function _stroke(e) {
            if (this.stroke && 0 !== this.strokeWidth) {
              var t = this.width / 2,
                  n = this.height / 2;
              e.beginPath(), e.moveTo(-t, -n), e.lineTo(t, -n), e.lineTo(t, n), e.lineTo(-t, n), e.lineTo(-t, -n), e.closePath();
            }
          },
          _renderDashedStroke: function _renderDashedStroke(e) {
            var t = -this.width / 2,
                n = -this.height / 2,
                i = this.width,
                r = this.height;
            e.save(), this._setStrokeStyles(e, this), e.beginPath(), T.util.drawDashedLine(e, t, n, t + i, n, this.strokeDashArray), T.util.drawDashedLine(e, t + i, n, t + i, n + r, this.strokeDashArray), T.util.drawDashedLine(e, t + i, n + r, t, n + r, this.strokeDashArray), T.util.drawDashedLine(e, t, n + r, t, n, this.strokeDashArray), e.closePath(), e.restore();
          },
          toObject: function toObject(e) {
            var n = [];
            this.filters.forEach(function (e) {
              e && n.push(e.toObject());
            });
            var i = t(this.callSuper("toObject", ["crossOrigin", "cropX", "cropY"].concat(e)), {
              src: this.getSrc(),
              filters: n
            });
            return this.resizeFilter && (i.resizeFilter = this.resizeFilter.toObject()), i;
          },
          hasCrop: function hasCrop() {
            return this.cropX || this.cropY || this.width < this._element.width || this.height < this._element.height;
          },
          _toSVG: function _toSVG() {
            var e,
                t = [],
                n = [],
                i = -this.width / 2,
                r = -this.height / 2,
                o = "";

            if (this.hasCrop()) {
              var a = T.Object.__uid++;
              t.push('<clipPath id="imageCrop_' + a + '">\n', '\t<rect x="' + i + '" y="' + r + '" width="' + this.width + '" height="' + this.height + '" />\n', "</clipPath>\n"), o = ' clip-path="url(#imageCrop_' + a + ')" ';
            }

            if (n.push("\t<image ", "COMMON_PARTS", 'xlink:href="', this.getSvgSrc(!0), '" x="', i - this.cropX, '" y="', r - this.cropY, '" width="', this._element.width || this._element.naturalWidth, '" height="', this._element.height || this._element.height, '"', o, "></image>\n"), this.stroke || this.strokeDashArray) {
              var s = this.fill;
              this.fill = null, e = ["\t<rect ", 'x="', i, '" y="', r, '" width="', this.width, '" height="', this.height, '" style="', this.getSvgStyles(), '"/>\n'], this.fill = s;
            }

            return t = "fill" !== this.paintFirst ? t.concat(e, n) : t.concat(n, e);
          },
          getSrc: function getSrc(e) {
            var t = e ? this._element : this._originalElement;
            return t ? t.toDataURL ? t.toDataURL() : this.srcFromAttribute ? t.getAttribute("src") : t.src : this.src || "";
          },
          setSrc: function setSrc(e, t, n) {
            return T.util.loadImage(e, function (e) {
              this.setElement(e, n), this._setWidthHeight(), t && t(this);
            }, this, n && n.crossOrigin), this;
          },
          toString: function toString() {
            return '#<fabric.Image: { src: "' + this.getSrc() + '" }>';
          },
          applyResizeFilters: function applyResizeFilters() {
            var e = this.resizeFilter,
                t = this.minimumScaleTrigger,
                n = this.getTotalObjectScaling(),
                i = n.scaleX,
                r = n.scaleY,
                o = this._filteredEl || this._originalElement;
            if (this.group && this.set("dirty", !0), !e || i > t && r > t) return this._element = o, this._filterScalingX = 1, this._filterScalingY = 1, this._lastScaleX = i, void (this._lastScaleY = r);
            T.filterBackend || (T.filterBackend = T.initFilterBackend());
            var a = T.util.createCanvasElement(),
                s = this._filteredEl ? this.cacheKey + "_filtered" : this.cacheKey,
                l = o.width,
                u = o.height;
            a.width = l, a.height = u, this._element = a, this._lastScaleX = e.scaleX = i, this._lastScaleY = e.scaleY = r, T.filterBackend.applyFilters([e], o, l, u, this._element, s), this._filterScalingX = a.width / this._originalElement.width, this._filterScalingY = a.height / this._originalElement.height;
          },
          applyFilters: function applyFilters(e) {
            if (e = (e = e || this.filters || []).filter(function (e) {
              return e && !e.isNeutralState();
            }), this.set("dirty", !0), this.removeTexture(this.cacheKey + "_filtered"), 0 === e.length) return this._element = this._originalElement, this._filteredEl = null, this._filterScalingX = 1, this._filterScalingY = 1, this;
            var t = this._originalElement,
                n = t.naturalWidth || t.width,
                i = t.naturalHeight || t.height;

            if (this._element === this._originalElement) {
              var r = T.util.createCanvasElement();
              r.width = n, r.height = i, this._element = r, this._filteredEl = r;
            } else this._element = this._filteredEl, this._filteredEl.getContext("2d").clearRect(0, 0, n, i), this._lastScaleX = 1, this._lastScaleY = 1;

            return T.filterBackend || (T.filterBackend = T.initFilterBackend()), T.filterBackend.applyFilters(e, this._originalElement, n, i, this._element, this.cacheKey), this._originalElement.width === this._element.width && this._originalElement.height === this._element.height || (this._filterScalingX = this._element.width / this._originalElement.width, this._filterScalingY = this._element.height / this._originalElement.height), this;
          },
          _render: function _render(e) {
            !0 !== this.isMoving && this.resizeFilter && this._needsResize() && this.applyResizeFilters(), this._stroke(e), this._renderPaintInOrder(e);
          },
          shouldCache: function shouldCache() {
            return this.needsItsOwnCache();
          },
          _renderFill: function _renderFill(e) {
            var t = this._element,
                n = this.width,
                i = this.height,
                r = Math.min(t.naturalWidth || t.width, n * this._filterScalingX),
                o = Math.min(t.naturalHeight || t.height, i * this._filterScalingY),
                a = -n / 2,
                s = -i / 2,
                l = Math.max(0, this.cropX * this._filterScalingX),
                u = Math.max(0, this.cropY * this._filterScalingY);
            t && e.drawImage(t, l, u, r, o, a, s, n, i);
          },
          _needsResize: function _needsResize() {
            var e = this.getTotalObjectScaling();
            return e.scaleX !== this._lastScaleX || e.scaleY !== this._lastScaleY;
          },
          _resetWidthHeight: function _resetWidthHeight() {
            this.set(this.getOriginalSize());
          },
          _initElement: function _initElement(e, t) {
            this.setElement(T.util.getById(e), t), T.util.addClass(this.getElement(), T.Image.CSS_CANVAS);
          },
          _initConfig: function _initConfig(e) {
            e || (e = {}), this.setOptions(e), this._setWidthHeight(e), this._element && this.crossOrigin && (this._element.crossOrigin = this.crossOrigin);
          },
          _initFilters: function _initFilters(e, t) {
            e && e.length ? T.util.enlivenObjects(e, function (e) {
              t && t(e);
            }, "fabric.Image.filters") : t && t();
          },
          _setWidthHeight: function _setWidthHeight(e) {
            e || (e = {});
            var t = this.getElement();
            this.width = e.width || t.naturalWidth || t.width || 0, this.height = e.height || t.naturalHeight || t.height || 0;
          },
          parsePreserveAspectRatioAttribute: function parsePreserveAspectRatioAttribute() {
            var e,
                t = T.util.parsePreserveAspectRatioAttribute(this.preserveAspectRatio || ""),
                n = this._element.width,
                i = this._element.height,
                r = 1,
                o = 1,
                a = 0,
                s = 0,
                l = 0,
                u = 0,
                c = this.width,
                h = this.height,
                d = {
              width: c,
              height: h
            };
            return !t || "none" === t.alignX && "none" === t.alignY ? (r = c / n, o = h / i) : ("meet" === t.meetOrSlice && (e = (c - n * (r = o = T.util.findScaleToFit(this._element, d))) / 2, "Min" === t.alignX && (a = -e), "Max" === t.alignX && (a = e), e = (h - i * o) / 2, "Min" === t.alignY && (s = -e), "Max" === t.alignY && (s = e)), "slice" === t.meetOrSlice && (e = n - c / (r = o = T.util.findScaleToCover(this._element, d)), "Mid" === t.alignX && (l = e / 2), "Max" === t.alignX && (l = e), e = i - h / o, "Mid" === t.alignY && (u = e / 2), "Max" === t.alignY && (u = e), n = c / r, i = h / o)), {
              width: n,
              height: i,
              scaleX: r,
              scaleY: o,
              offsetLeft: a,
              offsetTop: s,
              cropX: l,
              cropY: u
            };
          }
        }), T.Image.CSS_CANVAS = "canvas-img", T.Image.prototype.getSvgSrc = T.Image.prototype.getSrc, T.Image.fromObject = function (e, t) {
          var n = T.util.object.clone(e);
          T.util.loadImage(n.src, function (e, i) {
            i ? t && t(null, i) : T.Image.prototype._initFilters.call(n, n.filters, function (i) {
              n.filters = i || [], T.Image.prototype._initFilters.call(n, [n.resizeFilter], function (i) {
                n.resizeFilter = i[0], T.util.enlivenObjects([n.clipPath], function (i) {
                  n.clipPath = i[0];
                  var r = new T.Image(e, n);
                  t(r);
                });
              });
            });
          }, null, n.crossOrigin);
        }, T.Image.fromURL = function (e, t, n) {
          T.util.loadImage(e, function (e) {
            t && t(new T.Image(e, n));
          }, null, n && n.crossOrigin);
        }, T.Image.ATTRIBUTE_NAMES = T.SHARED_ATTRIBUTES.concat("x y width height preserveAspectRatio xlink:href crossOrigin".split(" ")), T.Image.fromElement = function (e, n, i) {
          var r = T.parseAttributes(e, T.Image.ATTRIBUTE_NAMES);
          T.Image.fromURL(r["xlink:href"], n, t(i ? T.util.object.clone(i) : {}, r));
        });
      }(t), T.util.object.extend(T.Object.prototype, {
        _getAngleValueForStraighten: function _getAngleValueForStraighten() {
          var e = this.angle % 360;
          return e > 0 ? 90 * Math.round((e - 1) / 90) : 90 * Math.round(e / 90);
        },
        straighten: function straighten() {
          return this.rotate(this._getAngleValueForStraighten()), this;
        },
        fxStraighten: function fxStraighten(e) {
          var t = function t() {},
              n = (e = e || {}).onComplete || t,
              i = e.onChange || t,
              r = this;

          return T.util.animate({
            startValue: this.get("angle"),
            endValue: this._getAngleValueForStraighten(),
            duration: this.FX_DURATION,
            onChange: function onChange(e) {
              r.rotate(e), i();
            },
            onComplete: function onComplete() {
              r.setCoords(), n();
            }
          }), this;
        }
      }), T.util.object.extend(T.StaticCanvas.prototype, {
        straightenObject: function straightenObject(e) {
          return e.straighten(), this.requestRenderAll(), this;
        },
        fxStraightenObject: function fxStraightenObject(e) {
          return e.fxStraighten({
            onChange: this.requestRenderAllBound
          }), this;
        }
      }), function () {
        "use strict";

        function e(e, t) {
          var n = "precision " + t + " float;\nvoid main(){}",
              i = e.createShader(e.FRAGMENT_SHADER);
          return e.shaderSource(i, n), e.compileShader(i), !!e.getShaderParameter(i, e.COMPILE_STATUS);
        }

        function t(e) {
          e && e.tileSize && (this.tileSize = e.tileSize), this.setupGLContext(this.tileSize, this.tileSize), this.captureGPUInfo();
        }

        T.isWebglSupported = function (t) {
          if (T.isLikelyNode) return !1;
          t = t || T.WebglFilterBackend.prototype.tileSize;
          var n = document.createElement("canvas"),
              i = n.getContext("webgl") || n.getContext("experimental-webgl"),
              r = !1;

          if (i) {
            T.maxTextureSize = i.getParameter(i.MAX_TEXTURE_SIZE), r = T.maxTextureSize >= t;

            for (var o = ["highp", "mediump", "lowp"], a = 0; a < 3; a++) {
              if (e(i, o[a])) {
                T.webGlPrecision = o[a];
                break;
              }
            }
          }

          return this.isSupported = r, r;
        }, T.WebglFilterBackend = t, t.prototype = {
          tileSize: 2048,
          resources: {},
          setupGLContext: function setupGLContext(e, t) {
            this.dispose(), this.createWebGLCanvas(e, t), this.aPosition = new Float32Array([0, 0, 0, 1, 1, 0, 1, 1]), this.chooseFastestCopyGLTo2DMethod(e, t);
          },
          chooseFastestCopyGLTo2DMethod: function chooseFastestCopyGLTo2DMethod(e, t) {
            var n,
                i = void 0 !== window.performance;

            try {
              new ImageData(1, 1), n = !0;
            } catch (e) {
              n = !1;
            }

            var r = "undefined" != typeof ArrayBuffer,
                o = "undefined" != typeof Uint8ClampedArray;

            if (i && n && r && o) {
              var a = T.util.createCanvasElement(),
                  s = new ArrayBuffer(e * t * 4);
              if (T.forceGLPutImageData) return this.imageBuffer = s, void (this.copyGLTo2D = M);
              var l,
                  u,
                  c = {
                imageBuffer: s,
                destinationWidth: e,
                destinationHeight: t,
                targetCanvas: a
              };
              a.width = e, a.height = t, l = window.performance.now(), k.call(c, this.gl, c), u = window.performance.now() - l, l = window.performance.now(), M.call(c, this.gl, c), u > window.performance.now() - l ? (this.imageBuffer = s, this.copyGLTo2D = M) : this.copyGLTo2D = k;
            }
          },
          createWebGLCanvas: function createWebGLCanvas(e, t) {
            var n = T.util.createCanvasElement();
            n.width = e, n.height = t;
            var i = {
              alpha: !0,
              premultipliedAlpha: !1,
              depth: !1,
              stencil: !1,
              antialias: !1
            },
                r = n.getContext("webgl", i);
            r || (r = n.getContext("experimental-webgl", i)), r && (r.clearColor(0, 0, 0, 0), this.canvas = n, this.gl = r);
          },
          applyFilters: function applyFilters(e, t, n, i, r, o) {
            var a,
                s = this.gl;
            o && (a = this.getCachedTexture(o, t));
            var l = {
              originalWidth: t.width || t.originalWidth,
              originalHeight: t.height || t.originalHeight,
              sourceWidth: n,
              sourceHeight: i,
              destinationWidth: n,
              destinationHeight: i,
              context: s,
              sourceTexture: this.createTexture(s, n, i, !a && t),
              targetTexture: this.createTexture(s, n, i),
              originalTexture: a || this.createTexture(s, n, i, !a && t),
              passes: e.length,
              webgl: !0,
              aPosition: this.aPosition,
              programCache: this.programCache,
              pass: 0,
              filterBackend: this,
              targetCanvas: r
            },
                u = s.createFramebuffer();
            return s.bindFramebuffer(s.FRAMEBUFFER, u), e.forEach(function (e) {
              e && e.applyTo(l);
            }), function (e) {
              var t = e.targetCanvas,
                  n = t.width,
                  i = t.height,
                  r = e.destinationWidth,
                  o = e.destinationHeight;
              n === r && i === o || (t.width = r, t.height = o);
            }(l), this.copyGLTo2D(s, l), s.bindTexture(s.TEXTURE_2D, null), s.deleteTexture(l.sourceTexture), s.deleteTexture(l.targetTexture), s.deleteFramebuffer(u), r.getContext("2d").setTransform(1, 0, 0, 1, 0, 0), l;
          },
          dispose: function dispose() {
            this.canvas && (this.canvas = null, this.gl = null), this.clearWebGLCaches();
          },
          clearWebGLCaches: function clearWebGLCaches() {
            this.programCache = {}, this.textureCache = {};
          },
          createTexture: function createTexture(e, t, n, i) {
            var r = e.createTexture();
            return e.bindTexture(e.TEXTURE_2D, r), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MAG_FILTER, e.NEAREST), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MIN_FILTER, e.NEAREST), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_S, e.CLAMP_TO_EDGE), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_T, e.CLAMP_TO_EDGE), i ? e.texImage2D(e.TEXTURE_2D, 0, e.RGBA, e.RGBA, e.UNSIGNED_BYTE, i) : e.texImage2D(e.TEXTURE_2D, 0, e.RGBA, t, n, 0, e.RGBA, e.UNSIGNED_BYTE, null), r;
          },
          getCachedTexture: function getCachedTexture(e, t) {
            if (this.textureCache[e]) return this.textureCache[e];
            var n = this.createTexture(this.gl, t.width, t.height, t);
            return this.textureCache[e] = n, n;
          },
          evictCachesForKey: function evictCachesForKey(e) {
            this.textureCache[e] && (this.gl.deleteTexture(this.textureCache[e]), delete this.textureCache[e]);
          },
          copyGLTo2D: k,
          captureGPUInfo: function captureGPUInfo() {
            if (this.gpuInfo) return this.gpuInfo;
            var e = this.gl,
                t = {
              renderer: "",
              vendor: ""
            };
            if (!e) return t;
            var n = e.getExtension("WEBGL_debug_renderer_info");

            if (n) {
              var i = e.getParameter(n.UNMASKED_RENDERER_WEBGL),
                  r = e.getParameter(n.UNMASKED_VENDOR_WEBGL);
              i && (t.renderer = i.toLowerCase()), r && (t.vendor = r.toLowerCase());
            }

            return this.gpuInfo = t, t;
          }
        };
      }(), function () {
        "use strict";

        var e = function e() {};

        function t() {}

        T.Canvas2dFilterBackend = t, t.prototype = {
          evictCachesForKey: e,
          dispose: e,
          clearWebGLCaches: e,
          resources: {},
          applyFilters: function applyFilters(e, t, n, i, r) {
            var o = r.getContext("2d");
            o.drawImage(t, 0, 0, n, i);
            var a = {
              sourceWidth: n,
              sourceHeight: i,
              imageData: o.getImageData(0, 0, n, i),
              originalEl: t,
              originalImageData: o.getImageData(0, 0, n, i),
              canvasEl: r,
              ctx: o,
              filterBackend: this
            };
            return e.forEach(function (e) {
              e.applyTo(a);
            }), a.imageData.width === n && a.imageData.height === i || (r.width = a.imageData.width, r.height = a.imageData.height), o.putImageData(a.imageData, 0, 0), a;
          }
        };
      }(), T.Image = T.Image || {}, T.Image.filters = T.Image.filters || {}, T.Image.filters.BaseFilter = T.util.createClass({
        type: "BaseFilter",
        vertexSource: "attribute vec2 aPosition;\nvarying vec2 vTexCoord;\nvoid main() {\nvTexCoord = aPosition;\ngl_Position = vec4(aPosition * 2.0 - 1.0, 0.0, 1.0);\n}",
        fragmentSource: "precision highp float;\nvarying vec2 vTexCoord;\nuniform sampler2D uTexture;\nvoid main() {\ngl_FragColor = texture2D(uTexture, vTexCoord);\n}",
        initialize: function initialize(e) {
          e && this.setOptions(e);
        },
        setOptions: function setOptions(e) {
          for (var t in e) {
            this[t] = e[t];
          }
        },
        createProgram: function createProgram(e, t, n) {
          t = t || this.fragmentSource, n = n || this.vertexSource, "highp" !== T.webGlPrecision && (t = t.replace(/precision highp float/g, "precision " + T.webGlPrecision + " float"));
          var i = e.createShader(e.VERTEX_SHADER);
          if (e.shaderSource(i, n), e.compileShader(i), !e.getShaderParameter(i, e.COMPILE_STATUS)) throw new Error("Vertex shader compile error for " + this.type + ": " + e.getShaderInfoLog(i));
          var r = e.createShader(e.FRAGMENT_SHADER);
          if (e.shaderSource(r, t), e.compileShader(r), !e.getShaderParameter(r, e.COMPILE_STATUS)) throw new Error("Fragment shader compile error for " + this.type + ": " + e.getShaderInfoLog(r));
          var o = e.createProgram();
          if (e.attachShader(o, i), e.attachShader(o, r), e.linkProgram(o), !e.getProgramParameter(o, e.LINK_STATUS)) throw new Error('Shader link error for "${this.type}" ' + e.getProgramInfoLog(o));
          var a = this.getAttributeLocations(e, o),
              s = this.getUniformLocations(e, o) || {};
          return s.uStepW = e.getUniformLocation(o, "uStepW"), s.uStepH = e.getUniformLocation(o, "uStepH"), {
            program: o,
            attributeLocations: a,
            uniformLocations: s
          };
        },
        getAttributeLocations: function getAttributeLocations(e, t) {
          return {
            aPosition: e.getAttribLocation(t, "aPosition")
          };
        },
        getUniformLocations: function getUniformLocations() {
          return {};
        },
        sendAttributeData: function sendAttributeData(e, t, n) {
          var i = t.aPosition,
              r = e.createBuffer();
          e.bindBuffer(e.ARRAY_BUFFER, r), e.enableVertexAttribArray(i), e.vertexAttribPointer(i, 2, e.FLOAT, !1, 0, 0), e.bufferData(e.ARRAY_BUFFER, n, e.STATIC_DRAW);
        },
        _setupFrameBuffer: function _setupFrameBuffer(e) {
          var t,
              n,
              i = e.context;
          e.passes > 1 ? (t = e.destinationWidth, n = e.destinationHeight, e.sourceWidth === t && e.sourceHeight === n || (i.deleteTexture(e.targetTexture), e.targetTexture = e.filterBackend.createTexture(i, t, n)), i.framebufferTexture2D(i.FRAMEBUFFER, i.COLOR_ATTACHMENT0, i.TEXTURE_2D, e.targetTexture, 0)) : (i.bindFramebuffer(i.FRAMEBUFFER, null), i.finish());
        },
        _swapTextures: function _swapTextures(e) {
          e.passes--, e.pass++;
          var t = e.targetTexture;
          e.targetTexture = e.sourceTexture, e.sourceTexture = t;
        },
        isNeutralState: function isNeutralState() {
          var e = this.mainParameter,
              t = T.Image.filters[this.type].prototype;

          if (e) {
            if (Array.isArray(t[e])) {
              for (var n = t[e].length; n--;) {
                if (this[e][n] !== t[e][n]) return !1;
              }

              return !0;
            }

            return t[e] === this[e];
          }

          return !1;
        },
        applyTo: function applyTo(e) {
          e.webgl ? (this._setupFrameBuffer(e), this.applyToWebGL(e), this._swapTextures(e)) : this.applyTo2d(e);
        },
        retrieveShader: function retrieveShader(e) {
          return e.programCache.hasOwnProperty(this.type) || (e.programCache[this.type] = this.createProgram(e.context)), e.programCache[this.type];
        },
        applyToWebGL: function applyToWebGL(e) {
          var t = e.context,
              n = this.retrieveShader(e);
          0 === e.pass && e.originalTexture ? t.bindTexture(t.TEXTURE_2D, e.originalTexture) : t.bindTexture(t.TEXTURE_2D, e.sourceTexture), t.useProgram(n.program), this.sendAttributeData(t, n.attributeLocations, e.aPosition), t.uniform1f(n.uniformLocations.uStepW, 1 / e.sourceWidth), t.uniform1f(n.uniformLocations.uStepH, 1 / e.sourceHeight), this.sendUniformData(t, n.uniformLocations), t.viewport(0, 0, e.destinationWidth, e.destinationHeight), t.drawArrays(t.TRIANGLE_STRIP, 0, 4);
        },
        bindAdditionalTexture: function bindAdditionalTexture(e, t, n) {
          e.activeTexture(n), e.bindTexture(e.TEXTURE_2D, t), e.activeTexture(e.TEXTURE0);
        },
        unbindAdditionalTexture: function unbindAdditionalTexture(e, t) {
          e.activeTexture(t), e.bindTexture(e.TEXTURE_2D, null), e.activeTexture(e.TEXTURE0);
        },
        getMainParameter: function getMainParameter() {
          return this[this.mainParameter];
        },
        setMainParameter: function setMainParameter(e) {
          this[this.mainParameter] = e;
        },
        sendUniformData: function sendUniformData() {},
        createHelpLayer: function createHelpLayer(e) {
          if (!e.helpLayer) {
            var t = document.createElement("canvas");
            t.width = e.sourceWidth, t.height = e.sourceHeight, e.helpLayer = t;
          }
        },
        toObject: function toObject() {
          var e = {
            type: this.type
          },
              t = this.mainParameter;
          return t && (e[t] = this[t]), e;
        },
        toJSON: function toJSON() {
          return this.toObject();
        }
      }), T.Image.filters.BaseFilter.fromObject = function (e, t) {
        var n = new T.Image.filters[e.type](e);
        return t && t(n), n;
      }, function (e) {
        "use strict";

        var t = e.fabric || (e.fabric = {}),
            n = t.Image.filters,
            i = t.util.createClass;
        n.ColorMatrix = i(n.BaseFilter, {
          type: "ColorMatrix",
          fragmentSource: "precision highp float;\nuniform sampler2D uTexture;\nvarying vec2 vTexCoord;\nuniform mat4 uColorMatrix;\nuniform vec4 uConstants;\nvoid main() {\nvec4 color = texture2D(uTexture, vTexCoord);\ncolor *= uColorMatrix;\ncolor += uConstants;\ngl_FragColor = color;\n}",
          matrix: [1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0],
          mainParameter: "matrix",
          colorsOnly: !0,
          initialize: function initialize(e) {
            this.callSuper("initialize", e), this.matrix = this.matrix.slice(0);
          },
          applyTo2d: function applyTo2d(e) {
            var t,
                n,
                i,
                r,
                o,
                a = e.imageData.data,
                s = a.length,
                l = this.matrix,
                u = this.colorsOnly;

            for (o = 0; o < s; o += 4) {
              t = a[o], n = a[o + 1], i = a[o + 2], u ? (a[o] = t * l[0] + n * l[1] + i * l[2] + 255 * l[4], a[o + 1] = t * l[5] + n * l[6] + i * l[7] + 255 * l[9], a[o + 2] = t * l[10] + n * l[11] + i * l[12] + 255 * l[14]) : (r = a[o + 3], a[o] = t * l[0] + n * l[1] + i * l[2] + r * l[3] + 255 * l[4], a[o + 1] = t * l[5] + n * l[6] + i * l[7] + r * l[8] + 255 * l[9], a[o + 2] = t * l[10] + n * l[11] + i * l[12] + r * l[13] + 255 * l[14], a[o + 3] = t * l[15] + n * l[16] + i * l[17] + r * l[18] + 255 * l[19]);
            }
          },
          getUniformLocations: function getUniformLocations(e, t) {
            return {
              uColorMatrix: e.getUniformLocation(t, "uColorMatrix"),
              uConstants: e.getUniformLocation(t, "uConstants")
            };
          },
          sendUniformData: function sendUniformData(e, t) {
            var n = this.matrix,
                i = [n[0], n[1], n[2], n[3], n[5], n[6], n[7], n[8], n[10], n[11], n[12], n[13], n[15], n[16], n[17], n[18]],
                r = [n[4], n[9], n[14], n[19]];
            e.uniformMatrix4fv(t.uColorMatrix, !1, i), e.uniform4fv(t.uConstants, r);
          }
        }), t.Image.filters.ColorMatrix.fromObject = t.Image.filters.BaseFilter.fromObject;
      }(t), function (e) {
        "use strict";

        var t = e.fabric || (e.fabric = {}),
            n = t.Image.filters,
            i = t.util.createClass;
        n.Brightness = i(n.BaseFilter, {
          type: "Brightness",
          fragmentSource: "precision highp float;\nuniform sampler2D uTexture;\nuniform float uBrightness;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = texture2D(uTexture, vTexCoord);\ncolor.rgb += uBrightness;\ngl_FragColor = color;\n}",
          brightness: 0,
          mainParameter: "brightness",
          applyTo2d: function applyTo2d(e) {
            if (0 !== this.brightness) {
              var t,
                  n = e.imageData.data,
                  i = n.length,
                  r = Math.round(255 * this.brightness);

              for (t = 0; t < i; t += 4) {
                n[t] = n[t] + r, n[t + 1] = n[t + 1] + r, n[t + 2] = n[t + 2] + r;
              }
            }
          },
          getUniformLocations: function getUniformLocations(e, t) {
            return {
              uBrightness: e.getUniformLocation(t, "uBrightness")
            };
          },
          sendUniformData: function sendUniformData(e, t) {
            e.uniform1f(t.uBrightness, this.brightness);
          }
        }), t.Image.filters.Brightness.fromObject = t.Image.filters.BaseFilter.fromObject;
      }(t), function (e) {
        "use strict";

        var t = e.fabric || (e.fabric = {}),
            n = t.util.object.extend,
            i = t.Image.filters,
            r = t.util.createClass;
        i.Convolute = r(i.BaseFilter, {
          type: "Convolute",
          opaque: !1,
          matrix: [0, 0, 0, 0, 1, 0, 0, 0, 0],
          fragmentSource: {
            Convolute_3_1: "precision highp float;\nuniform sampler2D uTexture;\nuniform float uMatrix[9];\nuniform float uStepW;\nuniform float uStepH;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = vec4(0, 0, 0, 0);\nfor (float h = 0.0; h < 3.0; h+=1.0) {\nfor (float w = 0.0; w < 3.0; w+=1.0) {\nvec2 matrixPos = vec2(uStepW * (w - 1), uStepH * (h - 1));\ncolor += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 3.0 + w)];\n}\n}\ngl_FragColor = color;\n}",
            Convolute_3_0: "precision highp float;\nuniform sampler2D uTexture;\nuniform float uMatrix[9];\nuniform float uStepW;\nuniform float uStepH;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = vec4(0, 0, 0, 1);\nfor (float h = 0.0; h < 3.0; h+=1.0) {\nfor (float w = 0.0; w < 3.0; w+=1.0) {\nvec2 matrixPos = vec2(uStepW * (w - 1.0), uStepH * (h - 1.0));\ncolor.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 3.0 + w)];\n}\n}\nfloat alpha = texture2D(uTexture, vTexCoord).a;\ngl_FragColor = color;\ngl_FragColor.a = alpha;\n}",
            Convolute_5_1: "precision highp float;\nuniform sampler2D uTexture;\nuniform float uMatrix[25];\nuniform float uStepW;\nuniform float uStepH;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = vec4(0, 0, 0, 0);\nfor (float h = 0.0; h < 5.0; h+=1.0) {\nfor (float w = 0.0; w < 5.0; w+=1.0) {\nvec2 matrixPos = vec2(uStepW * (w - 2.0), uStepH * (h - 2.0));\ncolor += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 5.0 + w)];\n}\n}\ngl_FragColor = color;\n}",
            Convolute_5_0: "precision highp float;\nuniform sampler2D uTexture;\nuniform float uMatrix[25];\nuniform float uStepW;\nuniform float uStepH;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = vec4(0, 0, 0, 1);\nfor (float h = 0.0; h < 5.0; h+=1.0) {\nfor (float w = 0.0; w < 5.0; w+=1.0) {\nvec2 matrixPos = vec2(uStepW * (w - 2.0), uStepH * (h - 2.0));\ncolor.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 5.0 + w)];\n}\n}\nfloat alpha = texture2D(uTexture, vTexCoord).a;\ngl_FragColor = color;\ngl_FragColor.a = alpha;\n}",
            Convolute_7_1: "precision highp float;\nuniform sampler2D uTexture;\nuniform float uMatrix[49];\nuniform float uStepW;\nuniform float uStepH;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = vec4(0, 0, 0, 0);\nfor (float h = 0.0; h < 7.0; h+=1.0) {\nfor (float w = 0.0; w < 7.0; w+=1.0) {\nvec2 matrixPos = vec2(uStepW * (w - 3.0), uStepH * (h - 3.0));\ncolor += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 7.0 + w)];\n}\n}\ngl_FragColor = color;\n}",
            Convolute_7_0: "precision highp float;\nuniform sampler2D uTexture;\nuniform float uMatrix[49];\nuniform float uStepW;\nuniform float uStepH;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = vec4(0, 0, 0, 1);\nfor (float h = 0.0; h < 7.0; h+=1.0) {\nfor (float w = 0.0; w < 7.0; w+=1.0) {\nvec2 matrixPos = vec2(uStepW * (w - 3.0), uStepH * (h - 3.0));\ncolor.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 7.0 + w)];\n}\n}\nfloat alpha = texture2D(uTexture, vTexCoord).a;\ngl_FragColor = color;\ngl_FragColor.a = alpha;\n}",
            Convolute_9_1: "precision highp float;\nuniform sampler2D uTexture;\nuniform float uMatrix[81];\nuniform float uStepW;\nuniform float uStepH;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = vec4(0, 0, 0, 0);\nfor (float h = 0.0; h < 9.0; h+=1.0) {\nfor (float w = 0.0; w < 9.0; w+=1.0) {\nvec2 matrixPos = vec2(uStepW * (w - 4.0), uStepH * (h - 4.0));\ncolor += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 9.0 + w)];\n}\n}\ngl_FragColor = color;\n}",
            Convolute_9_0: "precision highp float;\nuniform sampler2D uTexture;\nuniform float uMatrix[81];\nuniform float uStepW;\nuniform float uStepH;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = vec4(0, 0, 0, 1);\nfor (float h = 0.0; h < 9.0; h+=1.0) {\nfor (float w = 0.0; w < 9.0; w+=1.0) {\nvec2 matrixPos = vec2(uStepW * (w - 4.0), uStepH * (h - 4.0));\ncolor.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 9.0 + w)];\n}\n}\nfloat alpha = texture2D(uTexture, vTexCoord).a;\ngl_FragColor = color;\ngl_FragColor.a = alpha;\n}"
          },
          retrieveShader: function retrieveShader(e) {
            var t = Math.sqrt(this.matrix.length),
                n = this.type + "_" + t + "_" + (this.opaque ? 1 : 0),
                i = this.fragmentSource[n];
            return e.programCache.hasOwnProperty(n) || (e.programCache[n] = this.createProgram(e.context, i)), e.programCache[n];
          },
          applyTo2d: function applyTo2d(e) {
            var t,
                n,
                i,
                r,
                o,
                a,
                s,
                l,
                u,
                c,
                h,
                d,
                f,
                p = e.imageData,
                g = p.data,
                v = this.matrix,
                m = Math.round(Math.sqrt(v.length)),
                y = Math.floor(m / 2),
                x = p.width,
                _ = p.height,
                b = e.ctx.createImageData(x, _),
                w = b.data,
                S = this.opaque ? 1 : 0;

            for (h = 0; h < _; h++) {
              for (c = 0; c < x; c++) {
                for (o = 4 * (h * x + c), t = 0, n = 0, i = 0, r = 0, f = 0; f < m; f++) {
                  for (d = 0; d < m; d++) {
                    a = c + d - y, (s = h + f - y) < 0 || s >= _ || a < 0 || a >= x || (l = 4 * (s * x + a), u = v[f * m + d], t += g[l] * u, n += g[l + 1] * u, i += g[l + 2] * u, S || (r += g[l + 3] * u));
                  }
                }

                w[o] = t, w[o + 1] = n, w[o + 2] = i, w[o + 3] = S ? g[o + 3] : r;
              }
            }

            e.imageData = b;
          },
          getUniformLocations: function getUniformLocations(e, t) {
            return {
              uMatrix: e.getUniformLocation(t, "uMatrix"),
              uOpaque: e.getUniformLocation(t, "uOpaque"),
              uHalfSize: e.getUniformLocation(t, "uHalfSize"),
              uSize: e.getUniformLocation(t, "uSize")
            };
          },
          sendUniformData: function sendUniformData(e, t) {
            e.uniform1fv(t.uMatrix, this.matrix);
          },
          toObject: function toObject() {
            return n(this.callSuper("toObject"), {
              opaque: this.opaque,
              matrix: this.matrix
            });
          }
        }), t.Image.filters.Convolute.fromObject = t.Image.filters.BaseFilter.fromObject;
      }(t), function (e) {
        "use strict";

        var t = e.fabric || (e.fabric = {}),
            n = t.Image.filters,
            i = t.util.createClass;
        n.Grayscale = i(n.BaseFilter, {
          type: "Grayscale",
          fragmentSource: {
            average: "precision highp float;\nuniform sampler2D uTexture;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = texture2D(uTexture, vTexCoord);\nfloat average = (color.r + color.b + color.g) / 3.0;\ngl_FragColor = vec4(average, average, average, color.a);\n}",
            lightness: "precision highp float;\nuniform sampler2D uTexture;\nuniform int uMode;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 col = texture2D(uTexture, vTexCoord);\nfloat average = (max(max(col.r, col.g),col.b) + min(min(col.r, col.g),col.b)) / 2.0;\ngl_FragColor = vec4(average, average, average, col.a);\n}",
            luminosity: "precision highp float;\nuniform sampler2D uTexture;\nuniform int uMode;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 col = texture2D(uTexture, vTexCoord);\nfloat average = 0.21 * col.r + 0.72 * col.g + 0.07 * col.b;\ngl_FragColor = vec4(average, average, average, col.a);\n}"
          },
          mode: "average",
          mainParameter: "mode",
          applyTo2d: function applyTo2d(e) {
            var t,
                n,
                i = e.imageData.data,
                r = i.length,
                o = this.mode;

            for (t = 0; t < r; t += 4) {
              "average" === o ? n = (i[t] + i[t + 1] + i[t + 2]) / 3 : "lightness" === o ? n = (Math.min(i[t], i[t + 1], i[t + 2]) + Math.max(i[t], i[t + 1], i[t + 2])) / 2 : "luminosity" === o && (n = .21 * i[t] + .72 * i[t + 1] + .07 * i[t + 2]), i[t] = n, i[t + 1] = n, i[t + 2] = n;
            }
          },
          retrieveShader: function retrieveShader(e) {
            var t = this.type + "_" + this.mode;

            if (!e.programCache.hasOwnProperty(t)) {
              var n = this.fragmentSource[this.mode];
              e.programCache[t] = this.createProgram(e.context, n);
            }

            return e.programCache[t];
          },
          getUniformLocations: function getUniformLocations(e, t) {
            return {
              uMode: e.getUniformLocation(t, "uMode")
            };
          },
          sendUniformData: function sendUniformData(e, t) {
            e.uniform1i(t.uMode, 1);
          },
          isNeutralState: function isNeutralState() {
            return !1;
          }
        }), t.Image.filters.Grayscale.fromObject = t.Image.filters.BaseFilter.fromObject;
      }(t), function (e) {
        "use strict";

        var t = e.fabric || (e.fabric = {}),
            n = t.Image.filters,
            i = t.util.createClass;
        n.Invert = i(n.BaseFilter, {
          type: "Invert",
          fragmentSource: "precision highp float;\nuniform sampler2D uTexture;\nuniform int uInvert;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = texture2D(uTexture, vTexCoord);\nif (uInvert == 1) {\ngl_FragColor = vec4(1.0 - color.r,1.0 -color.g,1.0 -color.b,color.a);\n} else {\ngl_FragColor = color;\n}\n}",
          invert: !0,
          mainParameter: "invert",
          applyTo2d: function applyTo2d(e) {
            var t,
                n = e.imageData.data,
                i = n.length;

            for (t = 0; t < i; t += 4) {
              n[t] = 255 - n[t], n[t + 1] = 255 - n[t + 1], n[t + 2] = 255 - n[t + 2];
            }
          },
          isNeutralState: function isNeutralState() {
            return !this.invert;
          },
          getUniformLocations: function getUniformLocations(e, t) {
            return {
              uInvert: e.getUniformLocation(t, "uInvert")
            };
          },
          sendUniformData: function sendUniformData(e, t) {
            e.uniform1i(t.uInvert, this.invert);
          }
        }), t.Image.filters.Invert.fromObject = t.Image.filters.BaseFilter.fromObject;
      }(t), function (e) {
        "use strict";

        var t = e.fabric || (e.fabric = {}),
            n = t.util.object.extend,
            i = t.Image.filters,
            r = t.util.createClass;
        i.Noise = r(i.BaseFilter, {
          type: "Noise",
          fragmentSource: "precision highp float;\nuniform sampler2D uTexture;\nuniform float uStepH;\nuniform float uNoise;\nuniform float uSeed;\nvarying vec2 vTexCoord;\nfloat rand(vec2 co, float seed, float vScale) {\nreturn fract(sin(dot(co.xy * vScale ,vec2(12.9898 , 78.233))) * 43758.5453 * (seed + 0.01) / 2.0);\n}\nvoid main() {\nvec4 color = texture2D(uTexture, vTexCoord);\ncolor.rgb += (0.5 - rand(vTexCoord, uSeed, 0.1 / uStepH)) * uNoise;\ngl_FragColor = color;\n}",
          mainParameter: "noise",
          noise: 0,
          applyTo2d: function applyTo2d(e) {
            if (0 !== this.noise) {
              var t,
                  n,
                  i = e.imageData.data,
                  r = i.length,
                  o = this.noise;

              for (t = 0, r = i.length; t < r; t += 4) {
                n = (.5 - Math.random()) * o, i[t] += n, i[t + 1] += n, i[t + 2] += n;
              }
            }
          },
          getUniformLocations: function getUniformLocations(e, t) {
            return {
              uNoise: e.getUniformLocation(t, "uNoise"),
              uSeed: e.getUniformLocation(t, "uSeed")
            };
          },
          sendUniformData: function sendUniformData(e, t) {
            e.uniform1f(t.uNoise, this.noise / 255), e.uniform1f(t.uSeed, Math.random());
          },
          toObject: function toObject() {
            return n(this.callSuper("toObject"), {
              noise: this.noise
            });
          }
        }), t.Image.filters.Noise.fromObject = t.Image.filters.BaseFilter.fromObject;
      }(t), function (e) {
        "use strict";

        var t = e.fabric || (e.fabric = {}),
            n = t.Image.filters,
            i = t.util.createClass;
        n.Pixelate = i(n.BaseFilter, {
          type: "Pixelate",
          blocksize: 4,
          mainParameter: "blocksize",
          fragmentSource: "precision highp float;\nuniform sampler2D uTexture;\nuniform float uBlocksize;\nuniform float uStepW;\nuniform float uStepH;\nvarying vec2 vTexCoord;\nvoid main() {\nfloat blockW = uBlocksize * uStepW;\nfloat blockH = uBlocksize * uStepW;\nint posX = int(vTexCoord.x / blockW);\nint posY = int(vTexCoord.y / blockH);\nfloat fposX = float(posX);\nfloat fposY = float(posY);\nvec2 squareCoords = vec2(fposX * blockW, fposY * blockH);\nvec4 color = texture2D(uTexture, squareCoords);\ngl_FragColor = color;\n}",
          applyTo2d: function applyTo2d(e) {
            var t,
                n,
                i,
                r,
                o,
                a,
                s,
                l,
                u,
                c,
                h,
                d = e.imageData,
                f = d.data,
                p = d.height,
                g = d.width;

            for (n = 0; n < p; n += this.blocksize) {
              for (i = 0; i < g; i += this.blocksize) {
                for (r = f[t = 4 * n * g + 4 * i], o = f[t + 1], a = f[t + 2], s = f[t + 3], c = Math.min(n + this.blocksize, p), h = Math.min(i + this.blocksize, g), l = n; l < c; l++) {
                  for (u = i; u < h; u++) {
                    f[t = 4 * l * g + 4 * u] = r, f[t + 1] = o, f[t + 2] = a, f[t + 3] = s;
                  }
                }
              }
            }
          },
          isNeutralState: function isNeutralState() {
            return 1 === this.blocksize;
          },
          getUniformLocations: function getUniformLocations(e, t) {
            return {
              uBlocksize: e.getUniformLocation(t, "uBlocksize"),
              uStepW: e.getUniformLocation(t, "uStepW"),
              uStepH: e.getUniformLocation(t, "uStepH")
            };
          },
          sendUniformData: function sendUniformData(e, t) {
            e.uniform1f(t.uBlocksize, this.blocksize);
          }
        }), t.Image.filters.Pixelate.fromObject = t.Image.filters.BaseFilter.fromObject;
      }(t), function (e) {
        "use strict";

        var t = e.fabric || (e.fabric = {}),
            n = t.util.object.extend,
            i = t.Image.filters,
            r = t.util.createClass;
        i.RemoveColor = r(i.BaseFilter, {
          type: "RemoveColor",
          color: "#FFFFFF",
          fragmentSource: "precision highp float;\nuniform sampler2D uTexture;\nuniform vec4 uLow;\nuniform vec4 uHigh;\nvarying vec2 vTexCoord;\nvoid main() {\ngl_FragColor = texture2D(uTexture, vTexCoord);\nif(all(greaterThan(gl_FragColor.rgb,uLow.rgb)) && all(greaterThan(uHigh.rgb,gl_FragColor.rgb))) {\ngl_FragColor.a = 0.0;\n}\n}",
          distance: .02,
          useAlpha: !1,
          applyTo2d: function applyTo2d(e) {
            var n,
                i,
                r,
                o,
                a = e.imageData.data,
                s = 255 * this.distance,
                l = new t.Color(this.color).getSource(),
                u = [l[0] - s, l[1] - s, l[2] - s],
                c = [l[0] + s, l[1] + s, l[2] + s];

            for (n = 0; n < a.length; n += 4) {
              i = a[n], r = a[n + 1], o = a[n + 2], i > u[0] && r > u[1] && o > u[2] && i < c[0] && r < c[1] && o < c[2] && (a[n + 3] = 0);
            }
          },
          getUniformLocations: function getUniformLocations(e, t) {
            return {
              uLow: e.getUniformLocation(t, "uLow"),
              uHigh: e.getUniformLocation(t, "uHigh")
            };
          },
          sendUniformData: function sendUniformData(e, n) {
            var i = new t.Color(this.color).getSource(),
                r = parseFloat(this.distance),
                o = [0 + i[0] / 255 - r, 0 + i[1] / 255 - r, 0 + i[2] / 255 - r, 1],
                a = [i[0] / 255 + r, i[1] / 255 + r, i[2] / 255 + r, 1];
            e.uniform4fv(n.uLow, o), e.uniform4fv(n.uHigh, a);
          },
          toObject: function toObject() {
            return n(this.callSuper("toObject"), {
              color: this.color,
              distance: this.distance
            });
          }
        }), t.Image.filters.RemoveColor.fromObject = t.Image.filters.BaseFilter.fromObject;
      }(t), function (e) {
        "use strict";

        var t = e.fabric || (e.fabric = {}),
            n = t.Image.filters,
            i = t.util.createClass,
            r = {
          Brownie: [.5997, .34553, -.27082, 0, .186, -.0377, .86095, .15059, 0, -.1449, .24113, -.07441, .44972, 0, -.02965, 0, 0, 0, 1, 0],
          Vintage: [.62793, .32021, -.03965, 0, .03784, .02578, .64411, .03259, 0, .02926, .0466, -.08512, .52416, 0, .02023, 0, 0, 0, 1, 0],
          Kodachrome: [1.12855, -.39673, -.03992, 0, .24991, -.16404, 1.08352, -.05498, 0, .09698, -.16786, -.56034, 1.60148, 0, .13972, 0, 0, 0, 1, 0],
          Technicolor: [1.91252, -.85453, -.09155, 0, .04624, -.30878, 1.76589, -.10601, 0, -.27589, -.2311, -.75018, 1.84759, 0, .12137, 0, 0, 0, 1, 0],
          Polaroid: [1.438, -.062, -.062, 0, 0, -.122, 1.378, -.122, 0, 0, -.016, -.016, 1.483, 0, 0, 0, 0, 0, 1, 0],
          Sepia: [.393, .769, .189, 0, 0, .349, .686, .168, 0, 0, .272, .534, .131, 0, 0, 0, 0, 0, 1, 0],
          BlackWhite: [1.5, 1.5, 1.5, 0, -1, 1.5, 1.5, 1.5, 0, -1, 1.5, 1.5, 1.5, 0, -1, 0, 0, 0, 1, 0]
        };

        for (var o in r) {
          n[o] = i(n.ColorMatrix, {
            type: o,
            matrix: r[o],
            mainParameter: !1,
            colorsOnly: !0
          }), t.Image.filters[o].fromObject = t.Image.filters.BaseFilter.fromObject;
        }
      }(t), function (e) {
        "use strict";

        var t = e.fabric,
            n = t.Image.filters,
            i = t.util.createClass;
        n.BlendColor = i(n.BaseFilter, {
          type: "BlendColor",
          color: "#F95C63",
          mode: "multiply",
          alpha: 1,
          fragmentSource: {
            multiply: "gl_FragColor.rgb *= uColor.rgb;\n",
            screen: "gl_FragColor.rgb = 1.0 - (1.0 - gl_FragColor.rgb) * (1.0 - uColor.rgb);\n",
            add: "gl_FragColor.rgb += uColor.rgb;\n",
            diff: "gl_FragColor.rgb = abs(gl_FragColor.rgb - uColor.rgb);\n",
            subtract: "gl_FragColor.rgb -= uColor.rgb;\n",
            lighten: "gl_FragColor.rgb = max(gl_FragColor.rgb, uColor.rgb);\n",
            darken: "gl_FragColor.rgb = min(gl_FragColor.rgb, uColor.rgb);\n",
            exclusion: "gl_FragColor.rgb += uColor.rgb - 2.0 * (uColor.rgb * gl_FragColor.rgb);\n",
            overlay: "if (uColor.r < 0.5) {\ngl_FragColor.r *= 2.0 * uColor.r;\n} else {\ngl_FragColor.r = 1.0 - 2.0 * (1.0 - gl_FragColor.r) * (1.0 - uColor.r);\n}\nif (uColor.g < 0.5) {\ngl_FragColor.g *= 2.0 * uColor.g;\n} else {\ngl_FragColor.g = 1.0 - 2.0 * (1.0 - gl_FragColor.g) * (1.0 - uColor.g);\n}\nif (uColor.b < 0.5) {\ngl_FragColor.b *= 2.0 * uColor.b;\n} else {\ngl_FragColor.b = 1.0 - 2.0 * (1.0 - gl_FragColor.b) * (1.0 - uColor.b);\n}\n",
            tint: "gl_FragColor.rgb *= (1.0 - uColor.a);\ngl_FragColor.rgb += uColor.rgb;\n"
          },
          buildSource: function buildSource(e) {
            return "precision highp float;\nuniform sampler2D uTexture;\nuniform vec4 uColor;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = texture2D(uTexture, vTexCoord);\ngl_FragColor = color;\nif (color.a > 0.0) {\n" + this.fragmentSource[e] + "}\n}";
          },
          retrieveShader: function retrieveShader(e) {
            var t,
                n = this.type + "_" + this.mode;
            return e.programCache.hasOwnProperty(n) || (t = this.buildSource(this.mode), e.programCache[n] = this.createProgram(e.context, t)), e.programCache[n];
          },
          applyTo2d: function applyTo2d(e) {
            var n,
                i,
                r,
                o,
                a,
                s,
                l,
                u = e.imageData.data,
                c = u.length,
                h = 1 - this.alpha;
            n = (l = new t.Color(this.color).getSource())[0] * this.alpha, i = l[1] * this.alpha, r = l[2] * this.alpha;

            for (var d = 0; d < c; d += 4) {
              switch (o = u[d], a = u[d + 1], s = u[d + 2], this.mode) {
                case "multiply":
                  u[d] = o * n / 255, u[d + 1] = a * i / 255, u[d + 2] = s * r / 255;
                  break;

                case "screen":
                  u[d] = 255 - (255 - o) * (255 - n) / 255, u[d + 1] = 255 - (255 - a) * (255 - i) / 255, u[d + 2] = 255 - (255 - s) * (255 - r) / 255;
                  break;

                case "add":
                  u[d] = o + n, u[d + 1] = a + i, u[d + 2] = s + r;
                  break;

                case "diff":
                case "difference":
                  u[d] = Math.abs(o - n), u[d + 1] = Math.abs(a - i), u[d + 2] = Math.abs(s - r);
                  break;

                case "subtract":
                  u[d] = o - n, u[d + 1] = a - i, u[d + 2] = s - r;
                  break;

                case "darken":
                  u[d] = Math.min(o, n), u[d + 1] = Math.min(a, i), u[d + 2] = Math.min(s, r);
                  break;

                case "lighten":
                  u[d] = Math.max(o, n), u[d + 1] = Math.max(a, i), u[d + 2] = Math.max(s, r);
                  break;

                case "overlay":
                  u[d] = n < 128 ? 2 * o * n / 255 : 255 - 2 * (255 - o) * (255 - n) / 255, u[d + 1] = i < 128 ? 2 * a * i / 255 : 255 - 2 * (255 - a) * (255 - i) / 255, u[d + 2] = r < 128 ? 2 * s * r / 255 : 255 - 2 * (255 - s) * (255 - r) / 255;
                  break;

                case "exclusion":
                  u[d] = n + o - 2 * n * o / 255, u[d + 1] = i + a - 2 * i * a / 255, u[d + 2] = r + s - 2 * r * s / 255;
                  break;

                case "tint":
                  u[d] = n + o * h, u[d + 1] = i + a * h, u[d + 2] = r + s * h;
              }
            }
          },
          getUniformLocations: function getUniformLocations(e, t) {
            return {
              uColor: e.getUniformLocation(t, "uColor")
            };
          },
          sendUniformData: function sendUniformData(e, n) {
            var i = new t.Color(this.color).getSource();
            i[0] = this.alpha * i[0] / 255, i[1] = this.alpha * i[1] / 255, i[2] = this.alpha * i[2] / 255, i[3] = this.alpha, e.uniform4fv(n.uColor, i);
          },
          toObject: function toObject() {
            return {
              type: this.type,
              color: this.color,
              mode: this.mode,
              alpha: this.alpha
            };
          }
        }), t.Image.filters.BlendColor.fromObject = t.Image.filters.BaseFilter.fromObject;
      }(t), function (e) {
        "use strict";

        var t = e.fabric,
            n = t.Image.filters,
            i = t.util.createClass;
        n.BlendImage = i(n.BaseFilter, {
          type: "BlendImage",
          image: null,
          mode: "multiply",
          alpha: 1,
          vertexSource: "attribute vec2 aPosition;\nvarying vec2 vTexCoord;\nvarying vec2 vTexCoord2;\nuniform mat3 uTransformMatrix;\nvoid main() {\nvTexCoord = aPosition;\nvTexCoord2 = (uTransformMatrix * vec3(aPosition, 1.0)).xy;\ngl_Position = vec4(aPosition * 2.0 - 1.0, 0.0, 1.0);\n}",
          fragmentSource: {
            multiply: "precision highp float;\nuniform sampler2D uTexture;\nuniform sampler2D uImage;\nuniform vec4 uColor;\nvarying vec2 vTexCoord;\nvarying vec2 vTexCoord2;\nvoid main() {\nvec4 color = texture2D(uTexture, vTexCoord);\nvec4 color2 = texture2D(uImage, vTexCoord2);\ncolor.rgba *= color2.rgba;\ngl_FragColor = color;\n}",
            mask: "precision highp float;\nuniform sampler2D uTexture;\nuniform sampler2D uImage;\nuniform vec4 uColor;\nvarying vec2 vTexCoord;\nvarying vec2 vTexCoord2;\nvoid main() {\nvec4 color = texture2D(uTexture, vTexCoord);\nvec4 color2 = texture2D(uImage, vTexCoord2);\ncolor.a = color2.a;\ngl_FragColor = color;\n}"
          },
          retrieveShader: function retrieveShader(e) {
            var t = this.type + "_" + this.mode,
                n = this.fragmentSource[this.mode];
            return e.programCache.hasOwnProperty(t) || (e.programCache[t] = this.createProgram(e.context, n)), e.programCache[t];
          },
          applyToWebGL: function applyToWebGL(e) {
            var t = e.context,
                n = this.createTexture(e.filterBackend, this.image);
            this.bindAdditionalTexture(t, n, t.TEXTURE1), this.callSuper("applyToWebGL", e), this.unbindAdditionalTexture(t, t.TEXTURE1);
          },
          createTexture: function createTexture(e, t) {
            return e.getCachedTexture(t.cacheKey, t._element);
          },
          calculateMatrix: function calculateMatrix() {
            var e = this.image,
                t = e._element.width,
                n = e._element.height;
            return [1 / e.scaleX, 0, 0, 0, 1 / e.scaleY, 0, -e.left / t, -e.top / n, 1];
          },
          applyTo2d: function applyTo2d(e) {
            var n,
                i,
                r,
                o,
                a,
                s,
                l,
                u,
                c,
                h,
                d,
                f = e.imageData,
                p = e.filterBackend.resources,
                g = f.data,
                v = g.length,
                m = f.width,
                y = f.height,
                x = this.image;
            p.blendImage || (p.blendImage = t.util.createCanvasElement()), h = (c = p.blendImage).getContext("2d"), c.width !== m || c.height !== y ? (c.width = m, c.height = y) : h.clearRect(0, 0, m, y), h.setTransform(x.scaleX, 0, 0, x.scaleY, x.left, x.top), h.drawImage(x._element, 0, 0, m, y), d = h.getImageData(0, 0, m, y).data;

            for (var _ = 0; _ < v; _ += 4) {
              switch (a = g[_], s = g[_ + 1], l = g[_ + 2], u = g[_ + 3], n = d[_], i = d[_ + 1], r = d[_ + 2], o = d[_ + 3], this.mode) {
                case "multiply":
                  g[_] = a * n / 255, g[_ + 1] = s * i / 255, g[_ + 2] = l * r / 255, g[_ + 3] = u * o / 255;
                  break;

                case "mask":
                  g[_ + 3] = o;
              }
            }
          },
          getUniformLocations: function getUniformLocations(e, t) {
            return {
              uTransformMatrix: e.getUniformLocation(t, "uTransformMatrix"),
              uImage: e.getUniformLocation(t, "uImage")
            };
          },
          sendUniformData: function sendUniformData(e, t) {
            var n = this.calculateMatrix();
            e.uniform1i(t.uImage, 1), e.uniformMatrix3fv(t.uTransformMatrix, !1, n);
          },
          toObject: function toObject() {
            return {
              type: this.type,
              image: this.image && this.image.toObject(),
              mode: this.mode,
              alpha: this.alpha
            };
          }
        }), t.Image.filters.BlendImage.fromObject = function (e, n) {
          t.Image.fromObject(e.image, function (i) {
            var r = t.util.object.clone(e);
            r.image = i, n(new t.Image.filters.BlendImage(r));
          });
        };
      }(t), function (e) {
        "use strict";

        var t = e.fabric || (e.fabric = {}),
            n = Math.pow,
            i = Math.floor,
            r = Math.sqrt,
            o = Math.abs,
            a = Math.round,
            s = Math.sin,
            l = Math.ceil,
            u = t.Image.filters,
            c = t.util.createClass;
        u.Resize = c(u.BaseFilter, {
          type: "Resize",
          resizeType: "hermite",
          scaleX: 1,
          scaleY: 1,
          lanczosLobes: 3,
          getUniformLocations: function getUniformLocations(e, t) {
            return {
              uDelta: e.getUniformLocation(t, "uDelta"),
              uTaps: e.getUniformLocation(t, "uTaps")
            };
          },
          sendUniformData: function sendUniformData(e, t) {
            e.uniform2fv(t.uDelta, this.horizontal ? [1 / this.width, 0] : [0, 1 / this.height]), e.uniform1fv(t.uTaps, this.taps);
          },
          retrieveShader: function retrieveShader(e) {
            var t = this.getFilterWindow(),
                n = this.type + "_" + t;

            if (!e.programCache.hasOwnProperty(n)) {
              var i = this.generateShader(t);
              e.programCache[n] = this.createProgram(e.context, i);
            }

            return e.programCache[n];
          },
          getFilterWindow: function getFilterWindow() {
            var e = this.tempScale;
            return Math.ceil(this.lanczosLobes / e);
          },
          getTaps: function getTaps() {
            for (var e = this.lanczosCreate(this.lanczosLobes), t = this.tempScale, n = this.getFilterWindow(), i = new Array(n), r = 1; r <= n; r++) {
              i[r - 1] = e(r * t);
            }

            return i;
          },
          generateShader: function generateShader(e) {
            for (var t = new Array(e), n = this.fragmentSourceTOP, i = 1; i <= e; i++) {
              t[i - 1] = i + ".0 * uDelta";
            }

            return n += "uniform float uTaps[" + e + "];\n", n += "void main() {\n", n += "  vec4 color = texture2D(uTexture, vTexCoord);\n", n += "  float sum = 1.0;\n", t.forEach(function (e, t) {
              n += "  color += texture2D(uTexture, vTexCoord + " + e + ") * uTaps[" + t + "];\n", n += "  color += texture2D(uTexture, vTexCoord - " + e + ") * uTaps[" + t + "];\n", n += "  sum += 2.0 * uTaps[" + t + "];\n";
            }), n += "  gl_FragColor = color / sum;\n", n += "}";
          },
          fragmentSourceTOP: "precision highp float;\nuniform sampler2D uTexture;\nuniform vec2 uDelta;\nvarying vec2 vTexCoord;\n",
          applyTo: function applyTo(e) {
            e.webgl ? (e.passes++, this.width = e.sourceWidth, this.horizontal = !0, this.dW = Math.round(this.width * this.scaleX), this.dH = e.sourceHeight, this.tempScale = this.dW / this.width, this.taps = this.getTaps(), e.destinationWidth = this.dW, this._setupFrameBuffer(e), this.applyToWebGL(e), this._swapTextures(e), e.sourceWidth = e.destinationWidth, this.height = e.sourceHeight, this.horizontal = !1, this.dH = Math.round(this.height * this.scaleY), this.tempScale = this.dH / this.height, this.taps = this.getTaps(), e.destinationHeight = this.dH, this._setupFrameBuffer(e), this.applyToWebGL(e), this._swapTextures(e), e.sourceHeight = e.destinationHeight) : this.applyTo2d(e);
          },
          isNeutralState: function isNeutralState() {
            return 1 === this.scaleX && 1 === this.scaleY;
          },
          lanczosCreate: function lanczosCreate(e) {
            return function (t) {
              if (t >= e || t <= -e) return 0;
              if (t < 1.1920929e-7 && t > -1.1920929e-7) return 1;
              var n = (t *= Math.PI) / e;
              return s(t) / t * s(n) / n;
            };
          },
          applyTo2d: function applyTo2d(e) {
            var t = e.imageData,
                n = this.scaleX,
                i = this.scaleY;
            this.rcpScaleX = 1 / n, this.rcpScaleY = 1 / i;
            var r,
                o = t.width,
                s = t.height,
                l = a(o * n),
                u = a(s * i);
            "sliceHack" === this.resizeType ? r = this.sliceByTwo(e, o, s, l, u) : "hermite" === this.resizeType ? r = this.hermiteFastResize(e, o, s, l, u) : "bilinear" === this.resizeType ? r = this.bilinearFiltering(e, o, s, l, u) : "lanczos" === this.resizeType && (r = this.lanczosResize(e, o, s, l, u)), e.imageData = r;
          },
          sliceByTwo: function sliceByTwo(e, n, r, o, a) {
            var s,
                l,
                u = e.imageData,
                c = !1,
                h = !1,
                d = .5 * n,
                f = .5 * r,
                p = t.filterBackend.resources,
                g = 0,
                v = 0,
                m = n,
                y = 0;

            for (p.sliceByTwo || (p.sliceByTwo = document.createElement("canvas")), ((s = p.sliceByTwo).width < 1.5 * n || s.height < r) && (s.width = 1.5 * n, s.height = r), (l = s.getContext("2d")).clearRect(0, 0, 1.5 * n, r), l.putImageData(u, 0, 0), o = i(o), a = i(a); !c || !h;) {
              n = d, r = f, o < i(.5 * d) ? d = i(.5 * d) : (d = o, c = !0), a < i(.5 * f) ? f = i(.5 * f) : (f = a, h = !0), l.drawImage(s, g, v, n, r, m, y, d, f), g = m, v = y, y += f;
            }

            return l.getImageData(g, v, o, a);
          },
          lanczosResize: function lanczosResize(e, t, a, s, u) {
            var c = e.imageData.data,
                h = e.ctx.createImageData(s, u),
                d = h.data,
                f = this.lanczosCreate(this.lanczosLobes),
                p = this.rcpScaleX,
                g = this.rcpScaleY,
                v = 2 / this.rcpScaleX,
                m = 2 / this.rcpScaleY,
                y = l(p * this.lanczosLobes / 2),
                x = l(g * this.lanczosLobes / 2),
                _ = {},
                b = {},
                w = {};
            return function e(l) {
              var S, T, C, k, M, E, A, I, P, O, L;

              for (b.x = (l + .5) * p, w.x = i(b.x), S = 0; S < u; S++) {
                for (b.y = (S + .5) * g, w.y = i(b.y), M = 0, E = 0, A = 0, I = 0, P = 0, T = w.x - y; T <= w.x + y; T++) {
                  if (!(T < 0 || T >= t)) {
                    O = i(1e3 * o(T - b.x)), _[O] || (_[O] = {});

                    for (var D = w.y - x; D <= w.y + x; D++) {
                      D < 0 || D >= a || (L = i(1e3 * o(D - b.y)), _[O][L] || (_[O][L] = f(r(n(O * v, 2) + n(L * m, 2)) / 1e3)), (C = _[O][L]) > 0 && (M += C, E += C * c[k = 4 * (D * t + T)], A += C * c[k + 1], I += C * c[k + 2], P += C * c[k + 3]));
                    }
                  }
                }

                d[k = 4 * (S * s + l)] = E / M, d[k + 1] = A / M, d[k + 2] = I / M, d[k + 3] = P / M;
              }

              return ++l < s ? e(l) : h;
            }(0);
          },
          bilinearFiltering: function bilinearFiltering(e, t, n, r, o) {
            var a,
                s,
                l,
                u,
                c,
                h,
                d,
                f,
                p,
                g = 0,
                v = this.rcpScaleX,
                m = this.rcpScaleY,
                y = 4 * (t - 1),
                x = e.imageData.data,
                _ = e.ctx.createImageData(r, o),
                b = _.data;

            for (l = 0; l < o; l++) {
              for (u = 0; u < r; u++) {
                for (c = v * u - (a = i(v * u)), h = m * l - (s = i(m * l)), p = 4 * (s * t + a), d = 0; d < 4; d++) {
                  f = x[p + d] * (1 - c) * (1 - h) + x[p + 4 + d] * c * (1 - h) + x[p + y + d] * h * (1 - c) + x[p + y + 4 + d] * c * h, b[g++] = f;
                }
              }
            }

            return _;
          },
          hermiteFastResize: function hermiteFastResize(e, t, n, a, s) {
            for (var u = this.rcpScaleX, c = this.rcpScaleY, h = l(u / 2), d = l(c / 2), f = e.imageData.data, p = e.ctx.createImageData(a, s), g = p.data, v = 0; v < s; v++) {
              for (var m = 0; m < a; m++) {
                for (var y = 4 * (m + v * a), x = 0, _ = 0, b = 0, w = 0, S = 0, T = 0, C = 0, k = (v + .5) * c, M = i(v * c); M < (v + 1) * c; M++) {
                  for (var E = o(k - (M + .5)) / d, A = (m + .5) * u, I = E * E, P = i(m * u); P < (m + 1) * u; P++) {
                    var O = o(A - (P + .5)) / h,
                        L = r(I + O * O);
                    L > 1 && L < -1 || (x = 2 * L * L * L - 3 * L * L + 1) > 0 && (C += x * f[(O = 4 * (P + M * t)) + 3], b += x, f[O + 3] < 255 && (x = x * f[O + 3] / 250), w += x * f[O], S += x * f[O + 1], T += x * f[O + 2], _ += x);
                  }
                }

                g[y] = w / _, g[y + 1] = S / _, g[y + 2] = T / _, g[y + 3] = C / b;
              }
            }

            return p;
          },
          toObject: function toObject() {
            return {
              type: this.type,
              scaleX: this.scaleX,
              scaleY: this.scaleY,
              resizeType: this.resizeType,
              lanczosLobes: this.lanczosLobes
            };
          }
        }), t.Image.filters.Resize.fromObject = t.Image.filters.BaseFilter.fromObject;
      }(t), function (e) {
        "use strict";

        var t = e.fabric || (e.fabric = {}),
            n = t.Image.filters,
            i = t.util.createClass;
        n.Contrast = i(n.BaseFilter, {
          type: "Contrast",
          fragmentSource: "precision highp float;\nuniform sampler2D uTexture;\nuniform float uContrast;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = texture2D(uTexture, vTexCoord);\nfloat contrastF = 1.015 * (uContrast + 1.0) / (1.0 * (1.015 - uContrast));\ncolor.rgb = contrastF * (color.rgb - 0.5) + 0.5;\ngl_FragColor = color;\n}",
          contrast: 0,
          mainParameter: "contrast",
          applyTo2d: function applyTo2d(e) {
            if (0 !== this.contrast) {
              var t,
                  n = e.imageData.data,
                  i = n.length,
                  r = Math.floor(255 * this.contrast),
                  o = 259 * (r + 255) / (255 * (259 - r));

              for (t = 0; t < i; t += 4) {
                n[t] = o * (n[t] - 128) + 128, n[t + 1] = o * (n[t + 1] - 128) + 128, n[t + 2] = o * (n[t + 2] - 128) + 128;
              }
            }
          },
          getUniformLocations: function getUniformLocations(e, t) {
            return {
              uContrast: e.getUniformLocation(t, "uContrast")
            };
          },
          sendUniformData: function sendUniformData(e, t) {
            e.uniform1f(t.uContrast, this.contrast);
          }
        }), t.Image.filters.Contrast.fromObject = t.Image.filters.BaseFilter.fromObject;
      }(t), function (e) {
        "use strict";

        var t = e.fabric || (e.fabric = {}),
            n = t.Image.filters,
            i = t.util.createClass;
        n.Saturation = i(n.BaseFilter, {
          type: "Saturation",
          fragmentSource: "precision highp float;\nuniform sampler2D uTexture;\nuniform float uSaturation;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = texture2D(uTexture, vTexCoord);\nfloat rgMax = max(color.r, color.g);\nfloat rgbMax = max(rgMax, color.b);\ncolor.r += rgbMax != color.r ? (rgbMax - color.r) * uSaturation : 0.00;\ncolor.g += rgbMax != color.g ? (rgbMax - color.g) * uSaturation : 0.00;\ncolor.b += rgbMax != color.b ? (rgbMax - color.b) * uSaturation : 0.00;\ngl_FragColor = color;\n}",
          saturation: 0,
          mainParameter: "saturation",
          applyTo2d: function applyTo2d(e) {
            if (0 !== this.saturation) {
              var t,
                  n,
                  i = e.imageData.data,
                  r = i.length,
                  o = -this.saturation;

              for (t = 0; t < r; t += 4) {
                n = Math.max(i[t], i[t + 1], i[t + 2]), i[t] += n !== i[t] ? (n - i[t]) * o : 0, i[t + 1] += n !== i[t + 1] ? (n - i[t + 1]) * o : 0, i[t + 2] += n !== i[t + 2] ? (n - i[t + 2]) * o : 0;
              }
            }
          },
          getUniformLocations: function getUniformLocations(e, t) {
            return {
              uSaturation: e.getUniformLocation(t, "uSaturation")
            };
          },
          sendUniformData: function sendUniformData(e, t) {
            e.uniform1f(t.uSaturation, -this.saturation);
          }
        }), t.Image.filters.Saturation.fromObject = t.Image.filters.BaseFilter.fromObject;
      }(t), function (e) {
        "use strict";

        var t = e.fabric || (e.fabric = {}),
            n = t.Image.filters,
            i = t.util.createClass;
        n.Blur = i(n.BaseFilter, {
          type: "Blur",
          fragmentSource: "precision highp float;\nuniform sampler2D uTexture;\nuniform vec2 uDelta;\nvarying vec2 vTexCoord;\nconst float nSamples = 15.0;\nvec3 v3offset = vec3(12.9898, 78.233, 151.7182);\nfloat random(vec3 scale) {\nreturn fract(sin(dot(gl_FragCoord.xyz, scale)) * 43758.5453);\n}\nvoid main() {\nvec4 color = vec4(0.0);\nfloat total = 0.0;\nfloat offset = random(v3offset);\nfor (float t = -nSamples; t <= nSamples; t++) {\nfloat percent = (t + offset - 0.5) / nSamples;\nfloat weight = 1.0 - abs(percent);\ncolor += texture2D(uTexture, vTexCoord + uDelta * percent) * weight;\ntotal += weight;\n}\ngl_FragColor = color / total;\n}",
          blur: 0,
          mainParameter: "blur",
          applyTo: function applyTo(e) {
            e.webgl ? (this.aspectRatio = e.sourceWidth / e.sourceHeight, e.passes++, this._setupFrameBuffer(e), this.horizontal = !0, this.applyToWebGL(e), this._swapTextures(e), this._setupFrameBuffer(e), this.horizontal = !1, this.applyToWebGL(e), this._swapTextures(e)) : this.applyTo2d(e);
          },
          applyTo2d: function applyTo2d(e) {
            e.imageData = this.simpleBlur(e);
          },
          simpleBlur: function simpleBlur(e) {
            var n,
                i,
                r = e.filterBackend.resources,
                o = e.imageData.width,
                a = e.imageData.height;
            r.blurLayer1 || (r.blurLayer1 = t.util.createCanvasElement(), r.blurLayer2 = t.util.createCanvasElement()), n = r.blurLayer1, i = r.blurLayer2, n.width === o && n.height === a || (i.width = n.width = o, i.height = n.height = a);
            var s,
                l,
                u,
                c,
                h = n.getContext("2d"),
                d = i.getContext("2d"),
                f = .06 * this.blur * .5;

            for (h.putImageData(e.imageData, 0, 0), d.clearRect(0, 0, o, a), c = -15; c <= 15; c++) {
              u = f * (l = c / 15) * o + (s = (Math.random() - .5) / 4), d.globalAlpha = 1 - Math.abs(l), d.drawImage(n, u, s), h.drawImage(i, 0, 0), d.globalAlpha = 1, d.clearRect(0, 0, i.width, i.height);
            }

            for (c = -15; c <= 15; c++) {
              u = f * (l = c / 15) * a + (s = (Math.random() - .5) / 4), d.globalAlpha = 1 - Math.abs(l), d.drawImage(n, s, u), h.drawImage(i, 0, 0), d.globalAlpha = 1, d.clearRect(0, 0, i.width, i.height);
            }

            e.ctx.drawImage(n, 0, 0);
            var p = e.ctx.getImageData(0, 0, n.width, n.height);
            return h.globalAlpha = 1, h.clearRect(0, 0, n.width, n.height), p;
          },
          getUniformLocations: function getUniformLocations(e, t) {
            return {
              delta: e.getUniformLocation(t, "uDelta")
            };
          },
          sendUniformData: function sendUniformData(e, t) {
            var n = this.chooseRightDelta();
            e.uniform2fv(t.delta, n);
          },
          chooseRightDelta: function chooseRightDelta() {
            var e,
                t = 1,
                n = [0, 0];
            return this.horizontal ? this.aspectRatio > 1 && (t = 1 / this.aspectRatio) : this.aspectRatio < 1 && (t = this.aspectRatio), e = t * this.blur * .12, this.horizontal ? n[0] = e : n[1] = e, n;
          }
        }), n.Blur.fromObject = t.Image.filters.BaseFilter.fromObject;
      }(t), function (e) {
        "use strict";

        var t = e.fabric || (e.fabric = {}),
            n = t.Image.filters,
            i = t.util.createClass;
        n.Gamma = i(n.BaseFilter, {
          type: "Gamma",
          fragmentSource: "precision highp float;\nuniform sampler2D uTexture;\nuniform vec3 uGamma;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = texture2D(uTexture, vTexCoord);\nvec3 correction = (1.0 / uGamma);\ncolor.r = pow(color.r, correction.r);\ncolor.g = pow(color.g, correction.g);\ncolor.b = pow(color.b, correction.b);\ngl_FragColor = color;\ngl_FragColor.rgb *= color.a;\n}",
          gamma: [1, 1, 1],
          mainParameter: "gamma",
          initialize: function initialize(e) {
            this.gamma = [1, 1, 1], n.BaseFilter.prototype.initialize.call(this, e);
          },
          applyTo2d: function applyTo2d(e) {
            var t,
                n = e.imageData.data,
                i = this.gamma,
                r = n.length,
                o = 1 / i[0],
                a = 1 / i[1],
                s = 1 / i[2];

            for (this.rVals || (this.rVals = new Uint8Array(256), this.gVals = new Uint8Array(256), this.bVals = new Uint8Array(256)), t = 0, r = 256; t < r; t++) {
              this.rVals[t] = 255 * Math.pow(t / 255, o), this.gVals[t] = 255 * Math.pow(t / 255, a), this.bVals[t] = 255 * Math.pow(t / 255, s);
            }

            for (t = 0, r = n.length; t < r; t += 4) {
              n[t] = this.rVals[n[t]], n[t + 1] = this.gVals[n[t + 1]], n[t + 2] = this.bVals[n[t + 2]];
            }
          },
          getUniformLocations: function getUniformLocations(e, t) {
            return {
              uGamma: e.getUniformLocation(t, "uGamma")
            };
          },
          sendUniformData: function sendUniformData(e, t) {
            e.uniform3fv(t.uGamma, this.gamma);
          }
        }), t.Image.filters.Gamma.fromObject = t.Image.filters.BaseFilter.fromObject;
      }(t), function (e) {
        "use strict";

        var t = e.fabric || (e.fabric = {}),
            n = t.Image.filters,
            i = t.util.createClass;
        n.Composed = i(n.BaseFilter, {
          type: "Composed",
          subFilters: [],
          initialize: function initialize(e) {
            this.callSuper("initialize", e), this.subFilters = this.subFilters.slice(0);
          },
          applyTo: function applyTo(e) {
            e.passes += this.subFilters.length - 1, this.subFilters.forEach(function (t) {
              t.applyTo(e);
            });
          },
          toObject: function toObject() {
            return t.util.object.extend(this.callSuper("toObject"), {
              subFilters: this.subFilters.map(function (e) {
                return e.toObject();
              })
            });
          },
          isNeutralState: function isNeutralState() {
            return !this.subFilters.some(function (e) {
              return !e.isNeutralState();
            });
          }
        }), t.Image.filters.Composed.fromObject = function (e, n) {
          var i = (e.subFilters || []).map(function (e) {
            return new t.Image.filters[e.type](e);
          }),
              r = new t.Image.filters.Composed({
            subFilters: i
          });
          return n && n(r), r;
        };
      }(t), function (e) {
        "use strict";

        var t = e.fabric || (e.fabric = {}),
            n = t.Image.filters,
            i = t.util.createClass;
        n.HueRotation = i(n.ColorMatrix, {
          type: "HueRotation",
          rotation: 0,
          mainParameter: "rotation",
          calculateMatrix: function calculateMatrix() {
            var e = this.rotation * Math.PI,
                n = t.util.cos(e),
                i = t.util.sin(e),
                r = Math.sqrt(1 / 3) * i,
                o = 1 - n;
            this.matrix = [1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0], this.matrix[0] = n + o / 3, this.matrix[1] = 1 / 3 * o - r, this.matrix[2] = 1 / 3 * o + r, this.matrix[5] = 1 / 3 * o + r, this.matrix[6] = n + 1 / 3 * o, this.matrix[7] = 1 / 3 * o - r, this.matrix[10] = 1 / 3 * o - r, this.matrix[11] = 1 / 3 * o + r, this.matrix[12] = n + 1 / 3 * o;
          },
          isNeutralState: function isNeutralState(e) {
            return this.calculateMatrix(), n.BaseFilter.prototype.isNeutralState.call(this, e);
          },
          applyTo: function applyTo(e) {
            this.calculateMatrix(), n.BaseFilter.prototype.applyTo.call(this, e);
          }
        }), t.Image.filters.HueRotation.fromObject = t.Image.filters.BaseFilter.fromObject;
      }(t), function (e) {
        "use strict";

        var t = e.fabric || (e.fabric = {}),
            n = t.util.object.clone;
        t.Text ? t.warn("fabric.Text is already defined") : (t.Text = t.util.createClass(t.Object, {
          _dimensionAffectingProps: ["fontSize", "fontWeight", "fontFamily", "fontStyle", "lineHeight", "text", "charSpacing", "textAlign", "styles"],
          _reNewline: /\r?\n/,
          _reSpacesAndTabs: /[ \t\r]/g,
          _reSpaceAndTab: /[ \t\r]/,
          _reWords: /\S+/g,
          type: "text",
          fontSize: 40,
          fontWeight: "normal",
          fontFamily: "Times New Roman",
          underline: !1,
          overline: !1,
          linethrough: !1,
          textAlign: "left",
          fontStyle: "normal",
          lineHeight: 1.16,
          superscript: {
            size: .6,
            baseline: -.35
          },
          subscript: {
            size: .6,
            baseline: .11
          },
          textBackgroundColor: "",
          stateProperties: t.Object.prototype.stateProperties.concat("fontFamily", "fontWeight", "fontSize", "text", "underline", "overline", "linethrough", "textAlign", "fontStyle", "lineHeight", "textBackgroundColor", "charSpacing", "styles"),
          cacheProperties: t.Object.prototype.cacheProperties.concat("fontFamily", "fontWeight", "fontSize", "text", "underline", "overline", "linethrough", "textAlign", "fontStyle", "lineHeight", "textBackgroundColor", "charSpacing", "styles"),
          stroke: null,
          shadow: null,
          _fontSizeFraction: .222,
          offsets: {
            underline: .1,
            linethrough: -.315,
            overline: -.88
          },
          _fontSizeMult: 1.13,
          charSpacing: 0,
          styles: null,
          _measuringContext: null,
          deltaY: 0,
          _styleProperties: ["stroke", "strokeWidth", "fill", "fontFamily", "fontSize", "fontWeight", "fontStyle", "underline", "overline", "linethrough", "deltaY", "textBackgroundColor"],
          __charBounds: [],
          CACHE_FONT_SIZE: 400,
          MIN_TEXT_WIDTH: 2,
          initialize: function initialize(e, t) {
            this.styles = t && t.styles || {}, this.text = e, this.__skipDimension = !0, this.callSuper("initialize", t), this.__skipDimension = !1, this.initDimensions(), this.setCoords(), this.setupState({
              propertySet: "_dimensionAffectingProps"
            });
          },
          getMeasuringContext: function getMeasuringContext() {
            return t._measuringContext || (t._measuringContext = this.canvas && this.canvas.contextCache || t.util.createCanvasElement().getContext("2d")), t._measuringContext;
          },
          _splitText: function _splitText() {
            var e = this._splitTextIntoLines(this.text);

            return this.textLines = e.lines, this._textLines = e.graphemeLines, this._unwrappedTextLines = e._unwrappedLines, this._text = e.graphemeText, e;
          },
          initDimensions: function initDimensions() {
            this.__skipDimension || (this._splitText(), this._clearCache(), this.width = this.calcTextWidth() || this.cursorWidth || this.MIN_TEXT_WIDTH, -1 !== this.textAlign.indexOf("justify") && this.enlargeSpaces(), this.height = this.calcTextHeight(), this.saveState({
              propertySet: "_dimensionAffectingProps"
            }));
          },
          enlargeSpaces: function enlargeSpaces() {
            for (var e, t, n, i, r, o, a, s = 0, l = this._textLines.length; s < l; s++) {
              if (("justify" === this.textAlign || s !== l - 1 && !this.isEndOfWrapping(s)) && (i = 0, r = this._textLines[s], (t = this.getLineWidth(s)) < this.width && (a = this.textLines[s].match(this._reSpacesAndTabs)))) {
                n = a.length, e = (this.width - t) / n;

                for (var u = 0, c = r.length; u <= c; u++) {
                  o = this.__charBounds[s][u], this._reSpaceAndTab.test(r[u]) ? (o.width += e, o.kernedWidth += e, o.left += i, i += e) : o.left += i;
                }
              }
            }
          },
          isEndOfWrapping: function isEndOfWrapping(e) {
            return e === this._textLines.length - 1;
          },
          missingNewlineOffset: function missingNewlineOffset() {
            return 1;
          },
          toString: function toString() {
            return "#<fabric.Text (" + this.complexity() + '): { "text": "' + this.text + '", "fontFamily": "' + this.fontFamily + '" }>';
          },
          _getCacheCanvasDimensions: function _getCacheCanvasDimensions() {
            var e = this.callSuper("_getCacheCanvasDimensions"),
                t = this.fontSize;
            return e.width += t * e.zoomX, e.height += t * e.zoomY, e;
          },
          _render: function _render(e) {
            this._setTextStyles(e), this._renderTextLinesBackground(e), this._renderTextDecoration(e, "underline"), this._renderText(e), this._renderTextDecoration(e, "overline"), this._renderTextDecoration(e, "linethrough");
          },
          _renderText: function _renderText(e) {
            "stroke" === this.paintFirst ? (this._renderTextStroke(e), this._renderTextFill(e)) : (this._renderTextFill(e), this._renderTextStroke(e));
          },
          _setTextStyles: function _setTextStyles(e, t, n) {
            e.textBaseline = "alphabetic", e.font = this._getFontDeclaration(t, n);
          },
          calcTextWidth: function calcTextWidth() {
            for (var e = this.getLineWidth(0), t = 1, n = this._textLines.length; t < n; t++) {
              var i = this.getLineWidth(t);
              i > e && (e = i);
            }

            return e;
          },
          _renderTextLine: function _renderTextLine(e, t, n, i, r, o) {
            this._renderChars(e, t, n, i, r, o);
          },
          _renderTextLinesBackground: function _renderTextLinesBackground(e) {
            if (this.textBackgroundColor || this.styleHas("textBackgroundColor")) {
              for (var t, n, i, r, o, a, s = 0, l = e.fillStyle, u = this._getLeftOffset(), c = this._getTopOffset(), h = 0, d = 0, f = 0, p = this._textLines.length; f < p; f++) {
                if (t = this.getHeightOfLine(f), this.textBackgroundColor || this.styleHas("textBackgroundColor", f)) {
                  i = this._textLines[f], n = this._getLineLeftOffset(f), d = 0, h = 0, r = this.getValueOfPropertyAt(f, 0, "textBackgroundColor");

                  for (var g = 0, v = i.length; g < v; g++) {
                    o = this.__charBounds[f][g], (a = this.getValueOfPropertyAt(f, g, "textBackgroundColor")) !== r ? (e.fillStyle = r, r && e.fillRect(u + n + h, c + s, d, t / this.lineHeight), h = o.left, d = o.width, r = a) : d += o.kernedWidth;
                  }

                  a && (e.fillStyle = a, e.fillRect(u + n + h, c + s, d, t / this.lineHeight)), s += t;
                } else s += t;
              }

              e.fillStyle = l, this._removeShadow(e);
            }
          },
          getFontCache: function getFontCache(e) {
            var n = e.fontFamily.toLowerCase();
            t.charWidthsCache[n] || (t.charWidthsCache[n] = {});
            var i = t.charWidthsCache[n],
                r = e.fontStyle.toLowerCase() + "_" + (e.fontWeight + "").toLowerCase();
            return i[r] || (i[r] = {}), i[r];
          },
          _applyCharStyles: function _applyCharStyles(e, t, n, i, r) {
            this._setFillStyles(t, r), this._setStrokeStyles(t, r), t.font = this._getFontDeclaration(r);
          },
          _measureChar: function _measureChar(e, t, n, i) {
            var r,
                o,
                a,
                s,
                l = this.getFontCache(t),
                u = n + e,
                c = this._getFontDeclaration(t) === this._getFontDeclaration(i),
                h = t.fontSize / this.CACHE_FONT_SIZE;

            if (n && void 0 !== l[n] && (a = l[n]), void 0 !== l[e] && (s = r = l[e]), c && void 0 !== l[u] && (s = (o = l[u]) - a), void 0 === r || void 0 === a || void 0 === o) {
              var d = this.getMeasuringContext();

              this._setTextStyles(d, t, !0);
            }

            return void 0 === r && (s = r = d.measureText(e).width, l[e] = r), void 0 === a && c && n && (a = d.measureText(n).width, l[n] = a), c && void 0 === o && (o = d.measureText(u).width, l[u] = o, s = o - a), {
              width: r * h,
              kernedWidth: s * h
            };
          },
          getHeightOfChar: function getHeightOfChar(e, t) {
            return this.getValueOfPropertyAt(e, t, "fontSize");
          },
          measureLine: function measureLine(e) {
            var t = this._measureLine(e);

            return 0 !== this.charSpacing && (t.width -= this._getWidthOfCharSpacing()), t.width < 0 && (t.width = 0), t;
          },
          _measureLine: function _measureLine(e) {
            var t,
                n,
                i,
                r,
                o = 0,
                a = this._textLines[e],
                s = new Array(a.length);

            for (this.__charBounds[e] = s, t = 0; t < a.length; t++) {
              n = a[t], r = this._getGraphemeBox(n, e, t, i), s[t] = r, o += r.kernedWidth, i = n;
            }

            return s[t] = {
              left: r ? r.left + r.width : 0,
              width: 0,
              kernedWidth: 0,
              height: this.fontSize
            }, {
              width: o,
              numOfSpaces: 0
            };
          },
          _getGraphemeBox: function _getGraphemeBox(e, t, n, i, r) {
            var o,
                a = this.getCompleteStyleDeclaration(t, n),
                s = i ? this.getCompleteStyleDeclaration(t, n - 1) : {},
                l = this._measureChar(e, a, i, s),
                u = l.kernedWidth,
                c = l.width;

            0 !== this.charSpacing && (c += o = this._getWidthOfCharSpacing(), u += o);
            var h = {
              width: c,
              left: 0,
              height: a.fontSize,
              kernedWidth: u,
              deltaY: a.deltaY
            };

            if (n > 0 && !r) {
              var d = this.__charBounds[t][n - 1];
              h.left = d.left + d.width + l.kernedWidth - l.width;
            }

            return h;
          },
          getHeightOfLine: function getHeightOfLine(e) {
            if (this.__lineHeights[e]) return this.__lineHeights[e];

            for (var t = this._textLines[e], n = this.getHeightOfChar(e, 0), i = 1, r = t.length; i < r; i++) {
              n = Math.max(this.getHeightOfChar(e, i), n);
            }

            return this.__lineHeights[e] = n * this.lineHeight * this._fontSizeMult;
          },
          calcTextHeight: function calcTextHeight() {
            for (var e, t = 0, n = 0, i = this._textLines.length; n < i; n++) {
              e = this.getHeightOfLine(n), t += n === i - 1 ? e / this.lineHeight : e;
            }

            return t;
          },
          _getLeftOffset: function _getLeftOffset() {
            return -this.width / 2;
          },
          _getTopOffset: function _getTopOffset() {
            return -this.height / 2;
          },
          _applyPatternGradientTransform: function _applyPatternGradientTransform(e, t) {
            if (!t || !t.toLive) return {
              offsetX: 0,
              offsetY: 0
            };
            var n = -this.width / 2 + t.offsetX || 0,
                i = -this.height / 2 + t.offsetY || 0;
            return e.transform(1, 0, 0, 1, n, i), {
              offsetX: n,
              offsetY: i
            };
          },
          _renderTextCommon: function _renderTextCommon(e, t) {
            e.save();

            for (var n = 0, i = this._getLeftOffset(), r = this._getTopOffset(), o = this._applyPatternGradientTransform(e, "fillText" === t ? this.fill : this.stroke), a = 0, s = this._textLines.length; a < s; a++) {
              var l = this.getHeightOfLine(a),
                  u = l / this.lineHeight,
                  c = this._getLineLeftOffset(a);

              this._renderTextLine(t, e, this._textLines[a], i + c - o.offsetX, r + n + u - o.offsetY, a), n += l;
            }

            e.restore();
          },
          _renderTextFill: function _renderTextFill(e) {
            (this.fill || this.styleHas("fill")) && this._renderTextCommon(e, "fillText");
          },
          _renderTextStroke: function _renderTextStroke(e) {
            (this.stroke && 0 !== this.strokeWidth || !this.isEmptyStyles()) && (this.shadow && !this.shadow.affectStroke && this._removeShadow(e), e.save(), this._setLineDash(e, this.strokeDashArray), e.beginPath(), this._renderTextCommon(e, "strokeText"), e.closePath(), e.restore());
          },
          _renderChars: function _renderChars(e, t, n, i, r, o) {
            var a,
                s,
                l,
                u,
                c = this.getHeightOfLine(o),
                h = -1 !== this.textAlign.indexOf("justify"),
                d = "",
                f = 0,
                p = !h && 0 === this.charSpacing && this.isEmptyStyles(o);
            if (t.save(), r -= c * this._fontSizeFraction / this.lineHeight, p) return this._renderChar(e, t, o, 0, this.textLines[o], i, r, c), void t.restore();

            for (var g = 0, v = n.length - 1; g <= v; g++) {
              u = g === v || this.charSpacing, d += n[g], l = this.__charBounds[o][g], 0 === f ? (i += l.kernedWidth - l.width, f += l.width) : f += l.kernedWidth, h && !u && this._reSpaceAndTab.test(n[g]) && (u = !0), u || (a = a || this.getCompleteStyleDeclaration(o, g), s = this.getCompleteStyleDeclaration(o, g + 1), u = this._hasStyleChanged(a, s)), u && (this._renderChar(e, t, o, g, d, i, r, c), d = "", a = s, i += f, f = 0);
            }

            t.restore();
          },
          _renderChar: function _renderChar(e, t, n, i, r, o, a) {
            var s = this._getStyleDeclaration(n, i),
                l = this.getCompleteStyleDeclaration(n, i),
                u = "fillText" === e && l.fill,
                c = "strokeText" === e && l.stroke && l.strokeWidth;

            (c || u) && (s && t.save(), this._applyCharStyles(e, t, n, i, l), s && s.textBackgroundColor && this._removeShadow(t), s && s.deltaY && (a += s.deltaY), u && t.fillText(r, o, a), c && t.strokeText(r, o, a), s && t.restore());
          },
          setSuperscript: function setSuperscript(e, t) {
            return this._setScript(e, t, this.superscript);
          },
          setSubscript: function setSubscript(e, t) {
            return this._setScript(e, t, this.subscript);
          },
          _setScript: function _setScript(e, t, n) {
            var i = this.get2DCursorLocation(e, !0),
                r = this.getValueOfPropertyAt(i.lineIndex, i.charIndex, "fontSize"),
                o = this.getValueOfPropertyAt(i.lineIndex, i.charIndex, "deltaY"),
                a = {
              fontSize: r * n.size,
              deltaY: o + r * n.baseline
            };
            return this.setSelectionStyles(a, e, t), this;
          },
          _hasStyleChanged: function _hasStyleChanged(e, t) {
            return e.fill !== t.fill || e.stroke !== t.stroke || e.strokeWidth !== t.strokeWidth || e.fontSize !== t.fontSize || e.fontFamily !== t.fontFamily || e.fontWeight !== t.fontWeight || e.fontStyle !== t.fontStyle || e.deltaY !== t.deltaY;
          },
          _hasStyleChangedForSvg: function _hasStyleChangedForSvg(e, t) {
            return this._hasStyleChanged(e, t) || e.overline !== t.overline || e.underline !== t.underline || e.linethrough !== t.linethrough;
          },
          _getLineLeftOffset: function _getLineLeftOffset(e) {
            var t = this.getLineWidth(e);
            return "center" === this.textAlign ? (this.width - t) / 2 : "right" === this.textAlign ? this.width - t : "justify-center" === this.textAlign && this.isEndOfWrapping(e) ? (this.width - t) / 2 : "justify-right" === this.textAlign && this.isEndOfWrapping(e) ? this.width - t : 0;
          },
          _clearCache: function _clearCache() {
            this.__lineWidths = [], this.__lineHeights = [], this.__charBounds = [];
          },
          _shouldClearDimensionCache: function _shouldClearDimensionCache() {
            var e = this._forceClearCache;
            return e || (e = this.hasStateChanged("_dimensionAffectingProps")), e && (this.dirty = !0, this._forceClearCache = !1), e;
          },
          getLineWidth: function getLineWidth(e) {
            return this.__lineWidths[e] ? this.__lineWidths[e] : (t = "" === this._textLines[e] ? 0 : this.measureLine(e).width, this.__lineWidths[e] = t, t);
            var t;
          },
          _getWidthOfCharSpacing: function _getWidthOfCharSpacing() {
            return 0 !== this.charSpacing ? this.fontSize * this.charSpacing / 1e3 : 0;
          },
          getValueOfPropertyAt: function getValueOfPropertyAt(e, t, n) {
            var i = this._getStyleDeclaration(e, t);

            return i && void 0 !== i[n] ? i[n] : this[n];
          },
          _renderTextDecoration: function _renderTextDecoration(e, t) {
            if (this[t] || this.styleHas(t)) {
              for (var n, i, r, o, a, s, l, u, c, h, d, f, p, g, v, m, y = this._getLeftOffset(), x = this._getTopOffset(), _ = this._getWidthOfCharSpacing(), b = 0, w = this._textLines.length; b < w; b++) {
                if (n = this.getHeightOfLine(b), this[t] || this.styleHas(t, b)) {
                  l = this._textLines[b], g = n / this.lineHeight, o = this._getLineLeftOffset(b), h = 0, d = 0, u = this.getValueOfPropertyAt(b, 0, t), m = this.getValueOfPropertyAt(b, 0, "fill"), c = x + g * (1 - this._fontSizeFraction), i = this.getHeightOfChar(b, 0), a = this.getValueOfPropertyAt(b, 0, "deltaY");

                  for (var S = 0, T = l.length; S < T; S++) {
                    f = this.__charBounds[b][S], p = this.getValueOfPropertyAt(b, S, t), v = this.getValueOfPropertyAt(b, S, "fill"), r = this.getHeightOfChar(b, S), s = this.getValueOfPropertyAt(b, S, "deltaY"), (p !== u || v !== m || r !== i || s !== a) && d > 0 ? (e.fillStyle = m, u && m && e.fillRect(y + o + h, c + this.offsets[t] * i + a, d, this.fontSize / 15), h = f.left, d = f.width, u = p, m = v, i = r, a = s) : d += f.kernedWidth;
                  }

                  e.fillStyle = v, p && v && e.fillRect(y + o + h, c + this.offsets[t] * i + a, d - _, this.fontSize / 15), x += n;
                } else x += n;
              }

              this._removeShadow(e);
            }
          },
          _getFontDeclaration: function _getFontDeclaration(e, n) {
            var i = e || this,
                r = this.fontFamily,
                o = t.Text.genericFonts.indexOf(r.toLowerCase()) > -1,
                a = void 0 === r || r.indexOf("'") > -1 || r.indexOf(",") > -1 || r.indexOf('"') > -1 || o ? i.fontFamily : '"' + i.fontFamily + '"';
            return [t.isLikelyNode ? i.fontWeight : i.fontStyle, t.isLikelyNode ? i.fontStyle : i.fontWeight, n ? this.CACHE_FONT_SIZE + "px" : i.fontSize + "px", a].join(" ");
          },
          render: function render(e) {
            this.visible && (this.canvas && this.canvas.skipOffscreen && !this.group && !this.isOnScreen() || (this._shouldClearDimensionCache() && this.initDimensions(), this.callSuper("render", e)));
          },
          _splitTextIntoLines: function _splitTextIntoLines(e) {
            for (var n = e.split(this._reNewline), i = new Array(n.length), r = ["\n"], o = [], a = 0; a < n.length; a++) {
              i[a] = t.util.string.graphemeSplit(n[a]), o = o.concat(i[a], r);
            }

            return o.pop(), {
              _unwrappedLines: i,
              lines: n,
              graphemeText: o,
              graphemeLines: i
            };
          },
          toObject: function toObject(e) {
            var t = ["text", "fontSize", "fontWeight", "fontFamily", "fontStyle", "lineHeight", "underline", "overline", "linethrough", "textAlign", "textBackgroundColor", "charSpacing"].concat(e),
                i = this.callSuper("toObject", t);
            return i.styles = n(this.styles, !0), i;
          },
          set: function set(e, t) {
            this.callSuper("set", e, t);
            var n = !1;
            if ("object" == typeof e) for (var i in e) {
              n = n || -1 !== this._dimensionAffectingProps.indexOf(i);
            } else n = -1 !== this._dimensionAffectingProps.indexOf(e);
            return n && (this.initDimensions(), this.setCoords()), this;
          },
          complexity: function complexity() {
            return 1;
          }
        }), t.Text.ATTRIBUTE_NAMES = t.SHARED_ATTRIBUTES.concat("x y dx dy font-family font-style font-weight font-size letter-spacing text-decoration text-anchor".split(" ")), t.Text.DEFAULT_SVG_FONT_SIZE = 16, t.Text.fromElement = function (e, i, r) {
          if (!e) return i(null);
          var o = t.parseAttributes(e, t.Text.ATTRIBUTE_NAMES),
              a = o.textAnchor || "left";

          if ((r = t.util.object.extend(r ? n(r) : {}, o)).top = r.top || 0, r.left = r.left || 0, o.textDecoration) {
            var s = o.textDecoration;
            -1 !== s.indexOf("underline") && (r.underline = !0), -1 !== s.indexOf("overline") && (r.overline = !0), -1 !== s.indexOf("line-through") && (r.linethrough = !0), delete r.textDecoration;
          }

          "dx" in o && (r.left += o.dx), "dy" in o && (r.top += o.dy), "fontSize" in r || (r.fontSize = t.Text.DEFAULT_SVG_FONT_SIZE);
          var l = "";
          "textContent" in e ? l = e.textContent : "firstChild" in e && null !== e.firstChild && "data" in e.firstChild && null !== e.firstChild.data && (l = e.firstChild.data), l = l.replace(/^\s+|\s+$|\n+/g, "").replace(/\s+/g, " ");
          var u = r.strokeWidth;
          r.strokeWidth = 0;
          var c = new t.Text(l, r),
              h = c.getScaledHeight() / c.height,
              d = ((c.height + c.strokeWidth) * c.lineHeight - c.height) * h,
              f = c.getScaledHeight() + d,
              p = 0;
          "center" === a && (p = c.getScaledWidth() / 2), "right" === a && (p = c.getScaledWidth()), c.set({
            left: c.left - p,
            top: c.top - (f - c.fontSize * (.07 + c._fontSizeFraction)) / c.lineHeight,
            strokeWidth: void 0 !== u ? u : 1
          }), i(c);
        }, t.Text.fromObject = function (e, n) {
          return t.Object._fromObject("Text", e, n, "text");
        }, t.Text.genericFonts = ["sans-serif", "serif", "cursive", "fantasy", "monospace"], t.util.createAccessors && t.util.createAccessors(t.Text));
      }(t), T.util.object.extend(T.Text.prototype, {
        isEmptyStyles: function isEmptyStyles(e) {
          if (!this.styles) return !0;
          if (void 0 !== e && !this.styles[e]) return !0;
          var t = void 0 === e ? this.styles : {
            line: this.styles[e]
          };

          for (var n in t) {
            for (var i in t[n]) {
              for (var r in t[n][i]) {
                return !1;
              }
            }
          }

          return !0;
        },
        styleHas: function styleHas(e, t) {
          if (!this.styles || !e || "" === e) return !1;
          if (void 0 !== t && !this.styles[t]) return !1;
          var n = void 0 === t ? this.styles : {
            0: this.styles[t]
          };

          for (var i in n) {
            for (var r in n[i]) {
              if (void 0 !== n[i][r][e]) return !0;
            }
          }

          return !1;
        },
        cleanStyle: function cleanStyle(e) {
          if (!this.styles || !e || "" === e) return !1;
          var t,
              n,
              i = this.styles,
              r = 0,
              o = !0,
              a = 0;

          for (var s in i) {
            for (var l in t = 0, i[s]) {
              var u;
              r++, (u = i[s][l]).hasOwnProperty(e) ? (n ? u[e] !== n && (o = !1) : n = u[e], u[e] === this[e] && delete u[e]) : o = !1, 0 !== Object.keys(u).length ? t++ : delete i[s][l];
            }

            0 === t && delete i[s];
          }

          for (var c = 0; c < this._textLines.length; c++) {
            a += this._textLines[c].length;
          }

          o && r === a && (this[e] = n, this.removeStyle(e));
        },
        removeStyle: function removeStyle(e) {
          if (this.styles && e && "" !== e) {
            var t,
                n,
                i,
                r = this.styles;

            for (n in r) {
              for (i in t = r[n]) {
                delete t[i][e], 0 === Object.keys(t[i]).length && delete t[i];
              }

              0 === Object.keys(t).length && delete r[n];
            }
          }
        },
        _extendStyles: function _extendStyles(e, t) {
          var n = this.get2DCursorLocation(e);
          this._getLineStyle(n.lineIndex) || this._setLineStyle(n.lineIndex), this._getStyleDeclaration(n.lineIndex, n.charIndex) || this._setStyleDeclaration(n.lineIndex, n.charIndex, {}), T.util.object.extend(this._getStyleDeclaration(n.lineIndex, n.charIndex), t);
        },
        get2DCursorLocation: function get2DCursorLocation(e, t) {
          void 0 === e && (e = this.selectionStart);

          for (var n = t ? this._unwrappedTextLines : this._textLines, i = n.length, r = 0; r < i; r++) {
            if (e <= n[r].length) return {
              lineIndex: r,
              charIndex: e
            };
            e -= n[r].length + this.missingNewlineOffset(r);
          }

          return {
            lineIndex: r - 1,
            charIndex: n[r - 1].length < e ? n[r - 1].length : e
          };
        },
        getSelectionStyles: function getSelectionStyles(e, t, n) {
          void 0 === e && (e = this.selectionStart || 0), void 0 === t && (t = this.selectionEnd || e);

          for (var i = [], r = e; r < t; r++) {
            i.push(this.getStyleAtPosition(r, n));
          }

          return i;
        },
        getStyleAtPosition: function getStyleAtPosition(e, t) {
          var n = this.get2DCursorLocation(e);
          return (t ? this.getCompleteStyleDeclaration(n.lineIndex, n.charIndex) : this._getStyleDeclaration(n.lineIndex, n.charIndex)) || {};
        },
        setSelectionStyles: function setSelectionStyles(e, t, n) {
          void 0 === t && (t = this.selectionStart || 0), void 0 === n && (n = this.selectionEnd || t);

          for (var i = t; i < n; i++) {
            this._extendStyles(i, e);
          }

          return this._forceClearCache = !0, this;
        },
        _getStyleDeclaration: function _getStyleDeclaration(e, t) {
          var n = this.styles && this.styles[e];
          return n ? n[t] : null;
        },
        getCompleteStyleDeclaration: function getCompleteStyleDeclaration(e, t) {
          for (var n, i = this._getStyleDeclaration(e, t) || {}, r = {}, o = 0; o < this._styleProperties.length; o++) {
            r[n = this._styleProperties[o]] = void 0 === i[n] ? this[n] : i[n];
          }

          return r;
        },
        _setStyleDeclaration: function _setStyleDeclaration(e, t, n) {
          this.styles[e][t] = n;
        },
        _deleteStyleDeclaration: function _deleteStyleDeclaration(e, t) {
          delete this.styles[e][t];
        },
        _getLineStyle: function _getLineStyle(e) {
          return !!this.styles[e];
        },
        _setLineStyle: function _setLineStyle(e) {
          this.styles[e] = {};
        },
        _deleteLineStyle: function _deleteLineStyle(e) {
          delete this.styles[e];
        }
      }), function () {
        function e(e) {
          e.textDecoration && (e.textDecoration.indexOf("underline") > -1 && (e.underline = !0), e.textDecoration.indexOf("line-through") > -1 && (e.linethrough = !0), e.textDecoration.indexOf("overline") > -1 && (e.overline = !0), delete e.textDecoration);
        }

        T.IText = T.util.createClass(T.Text, T.Observable, {
          type: "i-text",
          selectionStart: 0,
          selectionEnd: 0,
          selectionColor: "rgba(17,119,255,0.3)",
          isEditing: !1,
          editable: !0,
          editingBorderColor: "rgba(102,153,255,0.25)",
          cursorWidth: 2,
          cursorColor: "#333",
          cursorDelay: 1e3,
          cursorDuration: 600,
          caching: !0,
          _reSpace: /\s|\n/,
          _currentCursorOpacity: 0,
          _selectionDirection: null,
          _abortCursorAnimation: !1,
          __widthOfSpace: [],
          inCompositionMode: !1,
          initialize: function initialize(e, t) {
            this.callSuper("initialize", e, t), this.initBehavior();
          },
          setSelectionStart: function setSelectionStart(e) {
            e = Math.max(e, 0), this._updateAndFire("selectionStart", e);
          },
          setSelectionEnd: function setSelectionEnd(e) {
            e = Math.min(e, this.text.length), this._updateAndFire("selectionEnd", e);
          },
          _updateAndFire: function _updateAndFire(e, t) {
            this[e] !== t && (this._fireSelectionChanged(), this[e] = t), this._updateTextarea();
          },
          _fireSelectionChanged: function _fireSelectionChanged() {
            this.fire("selection:changed"), this.canvas && this.canvas.fire("text:selection:changed", {
              target: this
            });
          },
          initDimensions: function initDimensions() {
            this.isEditing && this.initDelayedCursor(), this.clearContextTop(), this.callSuper("initDimensions");
          },
          render: function render(e) {
            this.clearContextTop(), this.callSuper("render", e), this.cursorOffsetCache = {}, this.renderCursorOrSelection();
          },
          _render: function _render(e) {
            this.callSuper("_render", e);
          },
          clearContextTop: function clearContextTop(e) {
            if (this.isEditing && this.canvas && this.canvas.contextTop) {
              var t = this.canvas.contextTop,
                  n = this.canvas.viewportTransform;
              t.save(), t.transform(n[0], n[1], n[2], n[3], n[4], n[5]), this.transform(t), this.transformMatrix && t.transform.apply(t, this.transformMatrix), this._clearTextArea(t), e || t.restore();
            }
          },
          renderCursorOrSelection: function renderCursorOrSelection() {
            if (this.isEditing && this.canvas && this.canvas.contextTop) {
              var e = this._getCursorBoundaries(),
                  t = this.canvas.contextTop;

              this.clearContextTop(!0), this.selectionStart === this.selectionEnd ? this.renderCursor(e, t) : this.renderSelection(e, t), t.restore();
            }
          },
          _clearTextArea: function _clearTextArea(e) {
            var t = this.width + 4,
                n = this.height + 4;
            e.clearRect(-t / 2, -n / 2, t, n);
          },
          _getCursorBoundaries: function _getCursorBoundaries(e) {
            void 0 === e && (e = this.selectionStart);

            var t = this._getLeftOffset(),
                n = this._getTopOffset(),
                i = this._getCursorBoundariesOffsets(e);

            return {
              left: t,
              top: n,
              leftOffset: i.left,
              topOffset: i.top
            };
          },
          _getCursorBoundariesOffsets: function _getCursorBoundariesOffsets(e) {
            if (this.cursorOffsetCache && "top" in this.cursorOffsetCache) return this.cursorOffsetCache;
            var t,
                n,
                i,
                r,
                o = 0,
                a = 0,
                s = this.get2DCursorLocation(e);
            i = s.charIndex, n = s.lineIndex;

            for (var l = 0; l < n; l++) {
              o += this.getHeightOfLine(l);
            }

            t = this._getLineLeftOffset(n);
            var u = this.__charBounds[n][i];
            return u && (a = u.left), 0 !== this.charSpacing && i === this._textLines[n].length && (a -= this._getWidthOfCharSpacing()), r = {
              top: o,
              left: t + (a > 0 ? a : 0)
            }, this.cursorOffsetCache = r, this.cursorOffsetCache;
          },
          renderCursor: function renderCursor(e, t) {
            var n = this.get2DCursorLocation(),
                i = n.lineIndex,
                r = n.charIndex > 0 ? n.charIndex - 1 : 0,
                o = this.getValueOfPropertyAt(i, r, "fontSize"),
                a = this.scaleX * this.canvas.getZoom(),
                s = this.cursorWidth / a,
                l = e.topOffset,
                u = this.getValueOfPropertyAt(i, r, "deltaY");
            l += (1 - this._fontSizeFraction) * this.getHeightOfLine(i) / this.lineHeight - o * (1 - this._fontSizeFraction), this.inCompositionMode && this.renderSelection(e, t), t.fillStyle = this.getValueOfPropertyAt(i, r, "fill"), t.globalAlpha = this.__isMousedown ? 1 : this._currentCursorOpacity, t.fillRect(e.left + e.leftOffset - s / 2, l + e.top + u, s, o);
          },
          renderSelection: function renderSelection(e, t) {
            for (var n = this.inCompositionMode ? this.hiddenTextarea.selectionStart : this.selectionStart, i = this.inCompositionMode ? this.hiddenTextarea.selectionEnd : this.selectionEnd, r = -1 !== this.textAlign.indexOf("justify"), o = this.get2DCursorLocation(n), a = this.get2DCursorLocation(i), s = o.lineIndex, l = a.lineIndex, u = o.charIndex < 0 ? 0 : o.charIndex, c = a.charIndex < 0 ? 0 : a.charIndex, h = s; h <= l; h++) {
              var d,
                  f = this._getLineLeftOffset(h) || 0,
                  p = this.getHeightOfLine(h),
                  g = 0,
                  v = 0;
              if (h === s && (g = this.__charBounds[s][u].left), h >= s && h < l) v = r && !this.isEndOfWrapping(h) ? this.width : this.getLineWidth(h) || 5;else if (h === l) if (0 === c) v = this.__charBounds[l][c].left;else {
                var m = this._getWidthOfCharSpacing();

                v = this.__charBounds[l][c - 1].left + this.__charBounds[l][c - 1].width - m;
              }
              d = p, (this.lineHeight < 1 || h === l && this.lineHeight > 1) && (p /= this.lineHeight), this.inCompositionMode ? (t.fillStyle = this.compositionColor || "black", t.fillRect(e.left + f + g, e.top + e.topOffset + p, v - g, 1)) : (t.fillStyle = this.selectionColor, t.fillRect(e.left + f + g, e.top + e.topOffset, v - g, p)), e.topOffset += d;
            }
          },
          getCurrentCharFontSize: function getCurrentCharFontSize() {
            var e = this._getCurrentCharIndex();

            return this.getValueOfPropertyAt(e.l, e.c, "fontSize");
          },
          getCurrentCharColor: function getCurrentCharColor() {
            var e = this._getCurrentCharIndex();

            return this.getValueOfPropertyAt(e.l, e.c, "fill");
          },
          _getCurrentCharIndex: function _getCurrentCharIndex() {
            var e = this.get2DCursorLocation(this.selectionStart, !0),
                t = e.charIndex > 0 ? e.charIndex - 1 : 0;
            return {
              l: e.lineIndex,
              c: t
            };
          }
        }), T.IText.fromObject = function (t, n) {
          if (e(t), t.styles) for (var i in t.styles) {
            for (var r in t.styles[i]) {
              e(t.styles[i][r]);
            }
          }

          T.Object._fromObject("IText", t, n, "text");
        };
      }(), b = T.util.object.clone, T.util.object.extend(T.IText.prototype, {
        initBehavior: function initBehavior() {
          this.initAddedHandler(), this.initRemovedHandler(), this.initCursorSelectionHandlers(), this.initDoubleClickSimulation(), this.mouseMoveHandler = this.mouseMoveHandler.bind(this);
        },
        onDeselect: function onDeselect() {
          this.isEditing && this.exitEditing(), this.selected = !1;
        },
        initAddedHandler: function initAddedHandler() {
          var e = this;
          this.on("added", function () {
            var t = e.canvas;
            t && (t._hasITextHandlers || (t._hasITextHandlers = !0, e._initCanvasHandlers(t)), t._iTextInstances = t._iTextInstances || [], t._iTextInstances.push(e));
          });
        },
        initRemovedHandler: function initRemovedHandler() {
          var e = this;
          this.on("removed", function () {
            var t = e.canvas;
            t && (t._iTextInstances = t._iTextInstances || [], T.util.removeFromArray(t._iTextInstances, e), 0 === t._iTextInstances.length && (t._hasITextHandlers = !1, e._removeCanvasHandlers(t)));
          });
        },
        _initCanvasHandlers: function _initCanvasHandlers(e) {
          e._mouseUpITextHandler = function () {
            e._iTextInstances && e._iTextInstances.forEach(function (e) {
              e.__isMousedown = !1;
            });
          }, e.on("mouse:up", e._mouseUpITextHandler);
        },
        _removeCanvasHandlers: function _removeCanvasHandlers(e) {
          e.off("mouse:up", e._mouseUpITextHandler);
        },
        _tick: function _tick() {
          this._currentTickState = this._animateCursor(this, 1, this.cursorDuration, "_onTickComplete");
        },
        _animateCursor: function _animateCursor(e, t, n, i) {
          var r;
          return r = {
            isAborted: !1,
            abort: function abort() {
              this.isAborted = !0;
            }
          }, e.animate("_currentCursorOpacity", t, {
            duration: n,
            onComplete: function onComplete() {
              r.isAborted || e[i]();
            },
            onChange: function onChange() {
              e.canvas && e.selectionStart === e.selectionEnd && e.renderCursorOrSelection();
            },
            abort: function abort() {
              return r.isAborted;
            }
          }), r;
        },
        _onTickComplete: function _onTickComplete() {
          var e = this;
          this._cursorTimeout1 && clearTimeout(this._cursorTimeout1), this._cursorTimeout1 = setTimeout(function () {
            e._currentTickCompleteState = e._animateCursor(e, 0, this.cursorDuration / 2, "_tick");
          }, 100);
        },
        initDelayedCursor: function initDelayedCursor(e) {
          var t = this,
              n = e ? 0 : this.cursorDelay;
          this.abortCursorAnimation(), this._currentCursorOpacity = 1, this._cursorTimeout2 = setTimeout(function () {
            t._tick();
          }, n);
        },
        abortCursorAnimation: function abortCursorAnimation() {
          var e = this._currentTickState || this._currentTickCompleteState,
              t = this.canvas;
          this._currentTickState && this._currentTickState.abort(), this._currentTickCompleteState && this._currentTickCompleteState.abort(), clearTimeout(this._cursorTimeout1), clearTimeout(this._cursorTimeout2), this._currentCursorOpacity = 0, e && t && t.clearContext(t.contextTop || t.contextContainer);
        },
        selectAll: function selectAll() {
          return this.selectionStart = 0, this.selectionEnd = this._text.length, this._fireSelectionChanged(), this._updateTextarea(), this;
        },
        getSelectedText: function getSelectedText() {
          return this._text.slice(this.selectionStart, this.selectionEnd).join("");
        },
        findWordBoundaryLeft: function findWordBoundaryLeft(e) {
          var t = 0,
              n = e - 1;
          if (this._reSpace.test(this._text[n])) for (; this._reSpace.test(this._text[n]);) {
            t++, n--;
          }

          for (; /\S/.test(this._text[n]) && n > -1;) {
            t++, n--;
          }

          return e - t;
        },
        findWordBoundaryRight: function findWordBoundaryRight(e) {
          var t = 0,
              n = e;
          if (this._reSpace.test(this._text[n])) for (; this._reSpace.test(this._text[n]);) {
            t++, n++;
          }

          for (; /\S/.test(this._text[n]) && n < this._text.length;) {
            t++, n++;
          }

          return e + t;
        },
        findLineBoundaryLeft: function findLineBoundaryLeft(e) {
          for (var t = 0, n = e - 1; !/\n/.test(this._text[n]) && n > -1;) {
            t++, n--;
          }

          return e - t;
        },
        findLineBoundaryRight: function findLineBoundaryRight(e) {
          for (var t = 0, n = e; !/\n/.test(this._text[n]) && n < this._text.length;) {
            t++, n++;
          }

          return e + t;
        },
        searchWordBoundary: function searchWordBoundary(e, t) {
          for (var n = this._text, i = this._reSpace.test(n[e]) ? e - 1 : e, r = n[i], o = T.reNonWord; !o.test(r) && i > 0 && i < n.length;) {
            r = n[i += t];
          }

          return o.test(r) && (i += 1 === t ? 0 : 1), i;
        },
        selectWord: function selectWord(e) {
          e = e || this.selectionStart;
          var t = this.searchWordBoundary(e, -1),
              n = this.searchWordBoundary(e, 1);
          this.selectionStart = t, this.selectionEnd = n, this._fireSelectionChanged(), this._updateTextarea(), this.renderCursorOrSelection();
        },
        selectLine: function selectLine(e) {
          e = e || this.selectionStart;
          var t = this.findLineBoundaryLeft(e),
              n = this.findLineBoundaryRight(e);
          return this.selectionStart = t, this.selectionEnd = n, this._fireSelectionChanged(), this._updateTextarea(), this;
        },
        enterEditing: function enterEditing(e) {
          if (!this.isEditing && this.editable) return this.canvas && (this.canvas.calcOffset(), this.exitEditingOnOthers(this.canvas)), this.isEditing = !0, this.initHiddenTextarea(e), this.hiddenTextarea.focus(), this.hiddenTextarea.value = this.text, this._updateTextarea(), this._saveEditingProps(), this._setEditingProps(), this._textBeforeEdit = this.text, this._tick(), this.fire("editing:entered"), this._fireSelectionChanged(), this.canvas ? (this.canvas.fire("text:editing:entered", {
            target: this
          }), this.initMouseMoveHandler(), this.canvas.requestRenderAll(), this) : this;
        },
        exitEditingOnOthers: function exitEditingOnOthers(e) {
          e._iTextInstances && e._iTextInstances.forEach(function (e) {
            e.selected = !1, e.isEditing && e.exitEditing();
          });
        },
        initMouseMoveHandler: function initMouseMoveHandler() {
          this.canvas.on("mouse:move", this.mouseMoveHandler);
        },
        mouseMoveHandler: function mouseMoveHandler(e) {
          if (this.__isMousedown && this.isEditing) {
            var t = this.getSelectionStartFromPointer(e.e),
                n = this.selectionStart,
                i = this.selectionEnd;
            (t === this.__selectionStartOnMouseDown && n !== i || n !== t && i !== t) && (t > this.__selectionStartOnMouseDown ? (this.selectionStart = this.__selectionStartOnMouseDown, this.selectionEnd = t) : (this.selectionStart = t, this.selectionEnd = this.__selectionStartOnMouseDown), this.selectionStart === n && this.selectionEnd === i || (this.restartCursorIfNeeded(), this._fireSelectionChanged(), this._updateTextarea(), this.renderCursorOrSelection()));
          }
        },
        _setEditingProps: function _setEditingProps() {
          this.hoverCursor = "text", this.canvas && (this.canvas.defaultCursor = this.canvas.moveCursor = "text"), this.borderColor = this.editingBorderColor, this.hasControls = this.selectable = !1, this.lockMovementX = this.lockMovementY = !0;
        },
        fromStringToGraphemeSelection: function fromStringToGraphemeSelection(e, t, n) {
          var i = n.slice(0, e),
              r = T.util.string.graphemeSplit(i).length;
          if (e === t) return {
            selectionStart: r,
            selectionEnd: r
          };
          var o = n.slice(e, t);
          return {
            selectionStart: r,
            selectionEnd: r + T.util.string.graphemeSplit(o).length
          };
        },
        fromGraphemeToStringSelection: function fromGraphemeToStringSelection(e, t, n) {
          var i = n.slice(0, e).join("").length;
          return e === t ? {
            selectionStart: i,
            selectionEnd: i
          } : {
            selectionStart: i,
            selectionEnd: i + n.slice(e, t).join("").length
          };
        },
        _updateTextarea: function _updateTextarea() {
          if (this.cursorOffsetCache = {}, this.hiddenTextarea) {
            if (!this.inCompositionMode) {
              var e = this.fromGraphemeToStringSelection(this.selectionStart, this.selectionEnd, this._text);
              this.hiddenTextarea.selectionStart = e.selectionStart, this.hiddenTextarea.selectionEnd = e.selectionEnd;
            }

            this.updateTextareaPosition();
          }
        },
        updateFromTextArea: function updateFromTextArea() {
          if (this.hiddenTextarea) {
            this.cursorOffsetCache = {}, this.text = this.hiddenTextarea.value, this._shouldClearDimensionCache() && (this.initDimensions(), this.setCoords());
            var e = this.fromStringToGraphemeSelection(this.hiddenTextarea.selectionStart, this.hiddenTextarea.selectionEnd, this.hiddenTextarea.value);
            this.selectionEnd = this.selectionStart = e.selectionEnd, this.inCompositionMode || (this.selectionStart = e.selectionStart), this.updateTextareaPosition();
          }
        },
        updateTextareaPosition: function updateTextareaPosition() {
          if (this.selectionStart === this.selectionEnd) {
            var e = this._calcTextareaPosition();

            this.hiddenTextarea.style.left = e.left, this.hiddenTextarea.style.top = e.top;
          }
        },
        _calcTextareaPosition: function _calcTextareaPosition() {
          if (!this.canvas) return {
            x: 1,
            y: 1
          };

          var e = this.inCompositionMode ? this.compositionStart : this.selectionStart,
              t = this._getCursorBoundaries(e),
              n = this.get2DCursorLocation(e),
              i = n.lineIndex,
              r = n.charIndex,
              o = this.getValueOfPropertyAt(i, r, "fontSize") * this.lineHeight,
              a = t.leftOffset,
              s = this.calcTransformMatrix(),
              l = {
            x: t.left + a,
            y: t.top + t.topOffset + o
          },
              u = this.canvas.getRetinaScaling(),
              c = this.canvas.upperCanvasEl,
              h = c.width / u,
              d = c.height / u,
              f = h - o,
              p = d - o,
              g = c.clientWidth / h,
              v = c.clientHeight / d;

          return l = T.util.transformPoint(l, s), (l = T.util.transformPoint(l, this.canvas.viewportTransform)).x *= g, l.y *= v, l.x < 0 && (l.x = 0), l.x > f && (l.x = f), l.y < 0 && (l.y = 0), l.y > p && (l.y = p), l.x += this.canvas._offset.left, l.y += this.canvas._offset.top, {
            left: l.x + "px",
            top: l.y + "px",
            fontSize: o + "px",
            charHeight: o
          };
        },
        _saveEditingProps: function _saveEditingProps() {
          this._savedProps = {
            hasControls: this.hasControls,
            borderColor: this.borderColor,
            lockMovementX: this.lockMovementX,
            lockMovementY: this.lockMovementY,
            hoverCursor: this.hoverCursor,
            selectable: this.selectable,
            defaultCursor: this.canvas && this.canvas.defaultCursor,
            moveCursor: this.canvas && this.canvas.moveCursor
          };
        },
        _restoreEditingProps: function _restoreEditingProps() {
          this._savedProps && (this.hoverCursor = this._savedProps.hoverCursor, this.hasControls = this._savedProps.hasControls, this.borderColor = this._savedProps.borderColor, this.selectable = this._savedProps.selectable, this.lockMovementX = this._savedProps.lockMovementX, this.lockMovementY = this._savedProps.lockMovementY, this.canvas && (this.canvas.defaultCursor = this._savedProps.defaultCursor, this.canvas.moveCursor = this._savedProps.moveCursor));
        },
        exitEditing: function exitEditing() {
          var e = this._textBeforeEdit !== this.text,
              t = this.hiddenTextarea;
          return this.selected = !1, this.isEditing = !1, this.selectionEnd = this.selectionStart, t && (t.blur && t.blur(), t.parentNode && t.parentNode.removeChild(t)), this.hiddenTextarea = null, this.abortCursorAnimation(), this._restoreEditingProps(), this._currentCursorOpacity = 0, this._shouldClearDimensionCache() && (this.initDimensions(), this.setCoords()), this.fire("editing:exited"), e && this.fire("modified"), this.canvas && (this.canvas.off("mouse:move", this.mouseMoveHandler), this.canvas.fire("text:editing:exited", {
            target: this
          }), e && this.canvas.fire("object:modified", {
            target: this
          })), this;
        },
        _removeExtraneousStyles: function _removeExtraneousStyles() {
          for (var e in this.styles) {
            this._textLines[e] || delete this.styles[e];
          }
        },
        removeStyleFromTo: function removeStyleFromTo(e, t) {
          var n,
              i,
              r = this.get2DCursorLocation(e, !0),
              o = this.get2DCursorLocation(t, !0),
              a = r.lineIndex,
              s = r.charIndex,
              l = o.lineIndex,
              u = o.charIndex;

          if (a !== l) {
            if (this.styles[a]) for (n = s; n < this._unwrappedTextLines[a].length; n++) {
              delete this.styles[a][n];
            }
            if (this.styles[l]) for (n = u; n < this._unwrappedTextLines[l].length; n++) {
              (i = this.styles[l][n]) && (this.styles[a] || (this.styles[a] = {}), this.styles[a][s + n - u] = i);
            }

            for (n = a + 1; n <= l; n++) {
              delete this.styles[n];
            }

            this.shiftLineStyles(l, a - l);
          } else if (this.styles[a]) {
            i = this.styles[a];
            var c,
                h,
                d = u - s;

            for (n = s; n < u; n++) {
              delete i[n];
            }

            for (h in this.styles[a]) {
              (c = parseInt(h, 10)) >= u && (i[c - d] = i[h], delete i[h]);
            }
          }
        },
        shiftLineStyles: function shiftLineStyles(e, t) {
          var n = b(this.styles);

          for (var i in this.styles) {
            var r = parseInt(i, 10);
            r > e && (this.styles[r + t] = n[r], n[r - t] || delete this.styles[r]);
          }
        },
        restartCursorIfNeeded: function restartCursorIfNeeded() {
          this._currentTickState && !this._currentTickState.isAborted && this._currentTickCompleteState && !this._currentTickCompleteState.isAborted || this.initDelayedCursor();
        },
        insertNewlineStyleObject: function insertNewlineStyleObject(e, t, n, i) {
          var r,
              o = {},
              a = !1;

          for (var s in n || (n = 1), this.shiftLineStyles(e, n), this.styles[e] && (r = this.styles[e][0 === t ? t : t - 1]), this.styles[e]) {
            var l = parseInt(s, 10);
            l >= t && (a = !0, o[l - t] = this.styles[e][s], delete this.styles[e][s]);
          }

          for (a ? this.styles[e + n] = o : delete this.styles[e + n]; n > 1;) {
            n--, i && i[n] ? this.styles[e + n] = {
              0: b(i[n])
            } : r ? this.styles[e + n] = {
              0: b(r)
            } : delete this.styles[e + n];
          }

          this._forceClearCache = !0;
        },
        insertCharStyleObject: function insertCharStyleObject(e, t, n, i) {
          this.styles || (this.styles = {});
          var r = this.styles[e],
              o = r ? b(r) : {};

          for (var a in n || (n = 1), o) {
            var s = parseInt(a, 10);
            s >= t && (r[s + n] = o[s], o[s - n] || delete r[s]);
          }

          if (this._forceClearCache = !0, i) for (; n--;) {
            Object.keys(i[n]).length && (this.styles[e] || (this.styles[e] = {}), this.styles[e][t + n] = b(i[n]));
          } else if (r) for (var l = r[t ? t - 1 : 1]; l && n--;) {
            this.styles[e][t + n] = b(l);
          }
        },
        insertNewStyleBlock: function insertNewStyleBlock(e, t, n) {
          for (var i = this.get2DCursorLocation(t, !0), r = [0], o = 0, a = 0; a < e.length; a++) {
            "\n" === e[a] ? r[++o] = 0 : r[o]++;
          }

          for (r[0] > 0 && (this.insertCharStyleObject(i.lineIndex, i.charIndex, r[0], n), n = n && n.slice(r[0] + 1)), o && this.insertNewlineStyleObject(i.lineIndex, i.charIndex + r[0], o), a = 1; a < o; a++) {
            r[a] > 0 ? this.insertCharStyleObject(i.lineIndex + a, 0, r[a], n) : n && (this.styles[i.lineIndex + a][0] = n[0]), n = n && n.slice(r[a] + 1);
          }

          r[a] > 0 && this.insertCharStyleObject(i.lineIndex + a, 0, r[a], n);
        },
        setSelectionStartEndWithShift: function setSelectionStartEndWithShift(e, t, n) {
          n <= e ? (t === e ? this._selectionDirection = "left" : "right" === this._selectionDirection && (this._selectionDirection = "left", this.selectionEnd = e), this.selectionStart = n) : n > e && n < t ? "right" === this._selectionDirection ? this.selectionEnd = n : this.selectionStart = n : (t === e ? this._selectionDirection = "right" : "left" === this._selectionDirection && (this._selectionDirection = "right", this.selectionStart = t), this.selectionEnd = n);
        },
        setSelectionInBoundaries: function setSelectionInBoundaries() {
          var e = this.text.length;
          this.selectionStart > e ? this.selectionStart = e : this.selectionStart < 0 && (this.selectionStart = 0), this.selectionEnd > e ? this.selectionEnd = e : this.selectionEnd < 0 && (this.selectionEnd = 0);
        }
      }), T.util.object.extend(T.IText.prototype, {
        initDoubleClickSimulation: function initDoubleClickSimulation() {
          this.__lastClickTime = +new Date(), this.__lastLastClickTime = +new Date(), this.__lastPointer = {}, this.on("mousedown", this.onMouseDown);
        },
        onMouseDown: function onMouseDown(e) {
          if (this.canvas) {
            this.__newClickTime = +new Date();
            var t = e.pointer;
            this.isTripleClick(t) && (this.fire("tripleclick", e), this._stopEvent(e.e)), this.__lastLastClickTime = this.__lastClickTime, this.__lastClickTime = this.__newClickTime, this.__lastPointer = t, this.__lastIsEditing = this.isEditing, this.__lastSelected = this.selected;
          }
        },
        isTripleClick: function isTripleClick(e) {
          return this.__newClickTime - this.__lastClickTime < 500 && this.__lastClickTime - this.__lastLastClickTime < 500 && this.__lastPointer.x === e.x && this.__lastPointer.y === e.y;
        },
        _stopEvent: function _stopEvent(e) {
          e.preventDefault && e.preventDefault(), e.stopPropagation && e.stopPropagation();
        },
        initCursorSelectionHandlers: function initCursorSelectionHandlers() {
          this.initMousedownHandler(), this.initMouseupHandler(), this.initClicks();
        },
        doubleClickHandler: function doubleClickHandler(e) {
          this.isEditing && this.selectWord(this.getSelectionStartFromPointer(e.e));
        },
        tripleClickHandler: function tripleClickHandler(e) {
          this.isEditing && this.selectLine(this.getSelectionStartFromPointer(e.e));
        },
        initClicks: function initClicks() {
          this.on("mousedblclick", this.doubleClickHandler), this.on("tripleclick", this.tripleClickHandler);
        },
        _mouseDownHandler: function _mouseDownHandler(e) {
          !this.canvas || !this.editable || e.e.button && 1 !== e.e.button || (this.__isMousedown = !0, this.selected && this.setCursorByClick(e.e), this.isEditing && (this.__selectionStartOnMouseDown = this.selectionStart, this.selectionStart === this.selectionEnd && this.abortCursorAnimation(), this.renderCursorOrSelection()));
        },
        _mouseDownHandlerBefore: function _mouseDownHandlerBefore(e) {
          !this.canvas || !this.editable || e.e.button && 1 !== e.e.button || (this.selected = this === this.canvas._activeObject);
        },
        initMousedownHandler: function initMousedownHandler() {
          this.on("mousedown", this._mouseDownHandler), this.on("mousedown:before", this._mouseDownHandlerBefore);
        },
        initMouseupHandler: function initMouseupHandler() {
          this.on("mouseup", this.mouseUpHandler);
        },
        mouseUpHandler: function mouseUpHandler(e) {
          if (this.__isMousedown = !1, !(!this.editable || this.group || e.transform && e.transform.actionPerformed || e.e.button && 1 !== e.e.button)) {
            if (this.canvas) {
              var t = this.canvas._activeObject;
              if (t && t !== this) return;
            }

            this.__lastSelected && !this.__corner ? (this.selected = !1, this.__lastSelected = !1, this.enterEditing(e.e), this.selectionStart === this.selectionEnd ? this.initDelayedCursor(!0) : this.renderCursorOrSelection()) : this.selected = !0;
          }
        },
        setCursorByClick: function setCursorByClick(e) {
          var t = this.getSelectionStartFromPointer(e),
              n = this.selectionStart,
              i = this.selectionEnd;
          e.shiftKey ? this.setSelectionStartEndWithShift(n, i, t) : (this.selectionStart = t, this.selectionEnd = t), this.isEditing && (this._fireSelectionChanged(), this._updateTextarea());
        },
        getSelectionStartFromPointer: function getSelectionStartFromPointer(e) {
          for (var t = this.getLocalPointer(e), n = 0, i = 0, r = 0, o = 0, a = 0, s = 0, l = this._textLines.length; s < l && r <= t.y; s++) {
            r += this.getHeightOfLine(s) * this.scaleY, a = s, s > 0 && (o += this._textLines[s - 1].length + this.missingNewlineOffset(s - 1));
          }

          i = this._getLineLeftOffset(a) * this.scaleX;

          for (var u = 0, c = this._textLines[a].length; u < c && (n = i, (i += this.__charBounds[a][u].kernedWidth * this.scaleX) <= t.x); u++) {
            o++;
          }

          return this._getNewSelectionStartFromOffset(t, n, i, o, c);
        },
        _getNewSelectionStartFromOffset: function _getNewSelectionStartFromOffset(e, t, n, i, r) {
          var o = e.x - t,
              a = n - e.x,
              s = i + (a > o || a < 0 ? 0 : 1);
          return this.flipX && (s = r - s), s > this._text.length && (s = this._text.length), s;
        }
      }), T.util.object.extend(T.IText.prototype, {
        initHiddenTextarea: function initHiddenTextarea() {
          this.hiddenTextarea = T.document.createElement("textarea"), this.hiddenTextarea.setAttribute("autocapitalize", "off"), this.hiddenTextarea.setAttribute("autocorrect", "off"), this.hiddenTextarea.setAttribute("autocomplete", "off"), this.hiddenTextarea.setAttribute("spellcheck", "false"), this.hiddenTextarea.setAttribute("data-fabric-hiddentextarea", ""), this.hiddenTextarea.setAttribute("wrap", "off");

          var e = this._calcTextareaPosition();

          this.hiddenTextarea.style.cssText = "position: absolute; top: " + e.top + "; left: " + e.left + "; z-index: -999; opacity: 0; width: 1px; height: 1px; font-size: 1px; paddingｰtop: " + e.fontSize + ";", T.document.body.appendChild(this.hiddenTextarea), T.util.addListener(this.hiddenTextarea, "keydown", this.onKeyDown.bind(this)), T.util.addListener(this.hiddenTextarea, "keyup", this.onKeyUp.bind(this)), T.util.addListener(this.hiddenTextarea, "input", this.onInput.bind(this)), T.util.addListener(this.hiddenTextarea, "copy", this.copy.bind(this)), T.util.addListener(this.hiddenTextarea, "cut", this.copy.bind(this)), T.util.addListener(this.hiddenTextarea, "paste", this.paste.bind(this)), T.util.addListener(this.hiddenTextarea, "compositionstart", this.onCompositionStart.bind(this)), T.util.addListener(this.hiddenTextarea, "compositionupdate", this.onCompositionUpdate.bind(this)), T.util.addListener(this.hiddenTextarea, "compositionend", this.onCompositionEnd.bind(this)), !this._clickHandlerInitialized && this.canvas && (T.util.addListener(this.canvas.upperCanvasEl, "click", this.onClick.bind(this)), this._clickHandlerInitialized = !0);
        },
        keysMap: {
          9: "exitEditing",
          27: "exitEditing",
          33: "moveCursorUp",
          34: "moveCursorDown",
          35: "moveCursorRight",
          36: "moveCursorLeft",
          37: "moveCursorLeft",
          38: "moveCursorUp",
          39: "moveCursorRight",
          40: "moveCursorDown"
        },
        ctrlKeysMapUp: {
          67: "copy",
          88: "cut"
        },
        ctrlKeysMapDown: {
          65: "selectAll"
        },
        onClick: function onClick() {
          this.hiddenTextarea && this.hiddenTextarea.focus();
        },
        onKeyDown: function onKeyDown(e) {
          if (this.isEditing && !this.inCompositionMode) {
            if (e.keyCode in this.keysMap) this[this.keysMap[e.keyCode]](e);else {
              if (!(e.keyCode in this.ctrlKeysMapDown) || !e.ctrlKey && !e.metaKey) return;
              this[this.ctrlKeysMapDown[e.keyCode]](e);
            }
            e.stopImmediatePropagation(), e.preventDefault(), e.keyCode >= 33 && e.keyCode <= 40 ? (this.clearContextTop(), this.renderCursorOrSelection()) : this.canvas && this.canvas.requestRenderAll();
          }
        },
        onKeyUp: function onKeyUp(e) {
          !this.isEditing || this._copyDone || this.inCompositionMode ? this._copyDone = !1 : e.keyCode in this.ctrlKeysMapUp && (e.ctrlKey || e.metaKey) && (this[this.ctrlKeysMapUp[e.keyCode]](e), e.stopImmediatePropagation(), e.preventDefault(), this.canvas && this.canvas.requestRenderAll());
        },
        onInput: function onInput(e) {
          var t = this.fromPaste;

          if (this.fromPaste = !1, e && e.stopPropagation(), this.isEditing) {
            var n,
                i,
                r = this._splitTextIntoLines(this.hiddenTextarea.value).graphemeText,
                o = this._text.length,
                a = r.length,
                s = a - o;

            if ("" === this.hiddenTextarea.value) return this.styles = {}, this.updateFromTextArea(), this.fire("changed"), void (this.canvas && (this.canvas.fire("text:changed", {
              target: this
            }), this.canvas.requestRenderAll()));
            var l = this.fromStringToGraphemeSelection(this.hiddenTextarea.selectionStart, this.hiddenTextarea.selectionEnd, this.hiddenTextarea.value),
                u = this.selectionStart > l.selectionStart;
            this.selectionStart !== this.selectionEnd ? (n = this._text.slice(this.selectionStart, this.selectionEnd), s += this.selectionEnd - this.selectionStart) : a < o && (n = u ? this._text.slice(this.selectionEnd + s, this.selectionEnd) : this._text.slice(this.selectionStart, this.selectionStart - s)), i = r.slice(l.selectionEnd - s, l.selectionEnd), n && n.length && (this.selectionStart !== this.selectionEnd ? this.removeStyleFromTo(this.selectionStart, this.selectionEnd) : u ? this.removeStyleFromTo(this.selectionEnd - n.length, this.selectionEnd) : this.removeStyleFromTo(this.selectionEnd, this.selectionEnd + n.length)), i.length && (t && i.join("") === T.copiedText && !T.disableStyleCopyPaste ? this.insertNewStyleBlock(i, this.selectionStart, T.copiedTextStyle) : this.insertNewStyleBlock(i, this.selectionStart)), this.updateFromTextArea(), this.fire("changed"), this.canvas && (this.canvas.fire("text:changed", {
              target: this
            }), this.canvas.requestRenderAll());
          }
        },
        onCompositionStart: function onCompositionStart() {
          this.inCompositionMode = !0;
        },
        onCompositionEnd: function onCompositionEnd() {
          this.inCompositionMode = !1;
        },
        onCompositionUpdate: function onCompositionUpdate(e) {
          this.compositionStart = e.target.selectionStart, this.compositionEnd = e.target.selectionEnd, this.updateTextareaPosition();
        },
        copy: function copy() {
          this.selectionStart !== this.selectionEnd && (T.copiedText = this.getSelectedText(), T.disableStyleCopyPaste ? T.copiedTextStyle = null : T.copiedTextStyle = this.getSelectionStyles(this.selectionStart, this.selectionEnd, !0), this._copyDone = !0);
        },
        paste: function paste() {
          this.fromPaste = !0;
        },
        _getClipboardData: function _getClipboardData(e) {
          return e && e.clipboardData || T.window.clipboardData;
        },
        _getWidthBeforeCursor: function _getWidthBeforeCursor(e, t) {
          var n,
              i = this._getLineLeftOffset(e);

          return t > 0 && (i += (n = this.__charBounds[e][t - 1]).left + n.width), i;
        },
        getDownCursorOffset: function getDownCursorOffset(e, t) {
          var n = this._getSelectionForOffset(e, t),
              i = this.get2DCursorLocation(n),
              r = i.lineIndex;

          if (r === this._textLines.length - 1 || e.metaKey || 34 === e.keyCode) return this._text.length - n;

          var o = i.charIndex,
              a = this._getWidthBeforeCursor(r, o),
              s = this._getIndexOnLine(r + 1, a);

          return this._textLines[r].slice(o).length + s + 1 + this.missingNewlineOffset(r);
        },
        _getSelectionForOffset: function _getSelectionForOffset(e, t) {
          return e.shiftKey && this.selectionStart !== this.selectionEnd && t ? this.selectionEnd : this.selectionStart;
        },
        getUpCursorOffset: function getUpCursorOffset(e, t) {
          var n = this._getSelectionForOffset(e, t),
              i = this.get2DCursorLocation(n),
              r = i.lineIndex;

          if (0 === r || e.metaKey || 33 === e.keyCode) return -n;

          var o = i.charIndex,
              a = this._getWidthBeforeCursor(r, o),
              s = this._getIndexOnLine(r - 1, a),
              l = this._textLines[r].slice(0, o),
              u = this.missingNewlineOffset(r - 1);

          return -this._textLines[r - 1].length + s - l.length + (1 - u);
        },
        _getIndexOnLine: function _getIndexOnLine(e, t) {
          for (var n, i, r = this._textLines[e], o = this._getLineLeftOffset(e), a = 0, s = 0, l = r.length; s < l; s++) {
            if ((o += n = this.__charBounds[e][s].width) > t) {
              i = !0;
              var u = o - n,
                  c = o,
                  h = Math.abs(u - t);
              a = Math.abs(c - t) < h ? s : s - 1;
              break;
            }
          }

          return i || (a = r.length - 1), a;
        },
        moveCursorDown: function moveCursorDown(e) {
          this.selectionStart >= this._text.length && this.selectionEnd >= this._text.length || this._moveCursorUpOrDown("Down", e);
        },
        moveCursorUp: function moveCursorUp(e) {
          0 === this.selectionStart && 0 === this.selectionEnd || this._moveCursorUpOrDown("Up", e);
        },
        _moveCursorUpOrDown: function _moveCursorUpOrDown(e, t) {
          var n = this["get" + e + "CursorOffset"](t, "right" === this._selectionDirection);
          t.shiftKey ? this.moveCursorWithShift(n) : this.moveCursorWithoutShift(n), 0 !== n && (this.setSelectionInBoundaries(), this.abortCursorAnimation(), this._currentCursorOpacity = 1, this.initDelayedCursor(), this._fireSelectionChanged(), this._updateTextarea());
        },
        moveCursorWithShift: function moveCursorWithShift(e) {
          var t = "left" === this._selectionDirection ? this.selectionStart + e : this.selectionEnd + e;
          return this.setSelectionStartEndWithShift(this.selectionStart, this.selectionEnd, t), 0 !== e;
        },
        moveCursorWithoutShift: function moveCursorWithoutShift(e) {
          return e < 0 ? (this.selectionStart += e, this.selectionEnd = this.selectionStart) : (this.selectionEnd += e, this.selectionStart = this.selectionEnd), 0 !== e;
        },
        moveCursorLeft: function moveCursorLeft(e) {
          0 === this.selectionStart && 0 === this.selectionEnd || this._moveCursorLeftOrRight("Left", e);
        },
        _move: function _move(e, t, n) {
          var i;
          if (e.altKey) i = this["findWordBoundary" + n](this[t]);else {
            if (!e.metaKey && 35 !== e.keyCode && 36 !== e.keyCode) return this[t] += "Left" === n ? -1 : 1, !0;
            i = this["findLineBoundary" + n](this[t]);
          }
          if (void 0 !== typeof i && this[t] !== i) return this[t] = i, !0;
        },
        _moveLeft: function _moveLeft(e, t) {
          return this._move(e, t, "Left");
        },
        _moveRight: function _moveRight(e, t) {
          return this._move(e, t, "Right");
        },
        moveCursorLeftWithoutShift: function moveCursorLeftWithoutShift(e) {
          var t = !0;
          return this._selectionDirection = "left", this.selectionEnd === this.selectionStart && 0 !== this.selectionStart && (t = this._moveLeft(e, "selectionStart")), this.selectionEnd = this.selectionStart, t;
        },
        moveCursorLeftWithShift: function moveCursorLeftWithShift(e) {
          return "right" === this._selectionDirection && this.selectionStart !== this.selectionEnd ? this._moveLeft(e, "selectionEnd") : 0 !== this.selectionStart ? (this._selectionDirection = "left", this._moveLeft(e, "selectionStart")) : void 0;
        },
        moveCursorRight: function moveCursorRight(e) {
          this.selectionStart >= this._text.length && this.selectionEnd >= this._text.length || this._moveCursorLeftOrRight("Right", e);
        },
        _moveCursorLeftOrRight: function _moveCursorLeftOrRight(e, t) {
          var n = "moveCursor" + e + "With";
          this._currentCursorOpacity = 1, t.shiftKey ? n += "Shift" : n += "outShift", this[n](t) && (this.abortCursorAnimation(), this.initDelayedCursor(), this._fireSelectionChanged(), this._updateTextarea());
        },
        moveCursorRightWithShift: function moveCursorRightWithShift(e) {
          return "left" === this._selectionDirection && this.selectionStart !== this.selectionEnd ? this._moveRight(e, "selectionStart") : this.selectionEnd !== this._text.length ? (this._selectionDirection = "right", this._moveRight(e, "selectionEnd")) : void 0;
        },
        moveCursorRightWithoutShift: function moveCursorRightWithoutShift(e) {
          var t = !0;
          return this._selectionDirection = "right", this.selectionStart === this.selectionEnd ? (t = this._moveRight(e, "selectionStart"), this.selectionEnd = this.selectionStart) : this.selectionStart = this.selectionEnd, t;
        },
        removeChars: function removeChars(e, t) {
          void 0 === t && (t = e + 1), this.removeStyleFromTo(e, t), this._text.splice(e, t - e), this.text = this._text.join(""), this.set("dirty", !0), this._shouldClearDimensionCache() && (this.initDimensions(), this.setCoords()), this._removeExtraneousStyles();
        },
        insertChars: function insertChars(e, t, n, i) {
          void 0 === i && (i = n), i > n && this.removeStyleFromTo(n, i);
          var r = T.util.string.graphemeSplit(e);
          this.insertNewStyleBlock(r, n, t), this._text = [].concat(this._text.slice(0, n), r, this._text.slice(i)), this.text = this._text.join(""), this.set("dirty", !0), this._shouldClearDimensionCache() && (this.initDimensions(), this.setCoords()), this._removeExtraneousStyles();
        }
      }), w = T.util.toFixed, S = /  +/g, T.util.object.extend(T.Text.prototype, {
        _toSVG: function _toSVG() {
          var e = this._getSVGLeftTopOffsets(),
              t = this._getSVGTextAndBg(e.textTop, e.textLeft);

          return this._wrapSVGTextAndBg(t);
        },
        toSVG: function toSVG(e) {
          return this._createBaseSVGMarkup(this._toSVG(), {
            reviver: e,
            noStyle: !0,
            withShadow: !0
          });
        },
        _getSVGLeftTopOffsets: function _getSVGLeftTopOffsets() {
          return {
            textLeft: -this.width / 2,
            textTop: -this.height / 2,
            lineTop: this.getHeightOfLine(0)
          };
        },
        _wrapSVGTextAndBg: function _wrapSVGTextAndBg(e) {
          var t = this.getSvgTextDecoration(this);
          return [e.textBgRects.join(""), '\t\t<text xml:space="preserve" ', this.fontFamily ? 'font-family="' + this.fontFamily.replace(/"/g, "'") + '" ' : "", this.fontSize ? 'font-size="' + this.fontSize + '" ' : "", this.fontStyle ? 'font-style="' + this.fontStyle + '" ' : "", this.fontWeight ? 'font-weight="' + this.fontWeight + '" ' : "", t ? 'text-decoration="' + t + '" ' : "", 'style="', this.getSvgStyles(!0), '"', this.addPaintOrder(), " >", e.textSpans.join(""), "</text>\n"];
        },
        _getSVGTextAndBg: function _getSVGTextAndBg(e, t) {
          var n,
              i = [],
              r = [],
              o = e;

          this._setSVGBg(r);

          for (var a = 0, s = this._textLines.length; a < s; a++) {
            n = this._getLineLeftOffset(a), (this.textBackgroundColor || this.styleHas("textBackgroundColor", a)) && this._setSVGTextLineBg(r, a, t + n, o), this._setSVGTextLineText(i, a, t + n, o), o += this.getHeightOfLine(a);
          }

          return {
            textSpans: i,
            textBgRects: r
          };
        },
        _createTextCharSpan: function _createTextCharSpan(e, t, n, i) {
          var r = e !== e.trim() || e.match(S),
              o = this.getSvgSpanStyles(t, r),
              a = o ? 'style="' + o + '"' : "",
              s = t.deltaY,
              l = "",
              u = T.Object.NUM_FRACTION_DIGITS;
          return s && (l = ' dy="' + w(s, u) + '" '), ['<tspan x="', w(n, u), '" y="', w(i, u), '" ', l, a, ">", T.util.string.escapeXml(e), "</tspan>"].join("");
        },
        _setSVGTextLineText: function _setSVGTextLineText(e, t, n, i) {
          var r,
              o,
              a,
              s,
              l,
              u = this.getHeightOfLine(t),
              c = -1 !== this.textAlign.indexOf("justify"),
              h = "",
              d = 0,
              f = this._textLines[t];
          i += u * (1 - this._fontSizeFraction) / this.lineHeight;

          for (var p = 0, g = f.length - 1; p <= g; p++) {
            l = p === g || this.charSpacing, h += f[p], a = this.__charBounds[t][p], 0 === d ? (n += a.kernedWidth - a.width, d += a.width) : d += a.kernedWidth, c && !l && this._reSpaceAndTab.test(f[p]) && (l = !0), l || (r = r || this.getCompleteStyleDeclaration(t, p), o = this.getCompleteStyleDeclaration(t, p + 1), l = this._hasStyleChangedForSvg(r, o)), l && (s = this._getStyleDeclaration(t, p) || {}, e.push(this._createTextCharSpan(h, s, n, i)), h = "", r = o, n += d, d = 0);
          }
        },
        _pushTextBgRect: function _pushTextBgRect(e, t, n, i, r, o) {
          var a = T.Object.NUM_FRACTION_DIGITS;
          e.push("\t\t<rect ", this._getFillAttributes(t), ' x="', w(n, a), '" y="', w(i, a), '" width="', w(r, a), '" height="', w(o, a), '"></rect>\n');
        },
        _setSVGTextLineBg: function _setSVGTextLineBg(e, t, n, i) {
          for (var r, o, a = this._textLines[t], s = this.getHeightOfLine(t) / this.lineHeight, l = 0, u = 0, c = this.getValueOfPropertyAt(t, 0, "textBackgroundColor"), h = 0, d = a.length; h < d; h++) {
            r = this.__charBounds[t][h], (o = this.getValueOfPropertyAt(t, h, "textBackgroundColor")) !== c ? (c && this._pushTextBgRect(e, c, n + u, i, l, s), u = r.left, l = r.width, c = o) : l += r.kernedWidth;
          }

          o && this._pushTextBgRect(e, o, n + u, i, l, s);
        },
        _getFillAttributes: function _getFillAttributes(e) {
          var t = e && "string" == typeof e ? new T.Color(e) : "";
          return t && t.getSource() && 1 !== t.getAlpha() ? 'opacity="' + t.getAlpha() + '" fill="' + t.setAlpha(1).toRgb() + '"' : 'fill="' + e + '"';
        },
        _getSVGLineTopOffset: function _getSVGLineTopOffset(e) {
          for (var t, n = 0, i = 0; i < e; i++) {
            n += this.getHeightOfLine(i);
          }

          return t = this.getHeightOfLine(i), {
            lineTop: n,
            offset: (this._fontSizeMult - this._fontSizeFraction) * t / (this.lineHeight * this._fontSizeMult)
          };
        },
        getSvgStyles: function getSvgStyles(e) {
          return T.Object.prototype.getSvgStyles.call(this, e) + " white-space: pre;";
        }
      }), function (e) {
        "use strict";

        var t = e.fabric || (e.fabric = {});
        t.Textbox = t.util.createClass(t.IText, t.Observable, {
          type: "textbox",
          minWidth: 20,
          dynamicMinWidth: 2,
          __cachedLines: null,
          lockScalingFlip: !0,
          noScaleCache: !1,
          _dimensionAffectingProps: t.Text.prototype._dimensionAffectingProps.concat("width"),
          _wordJoiners: /[ \t\r]/,
          splitByGrapheme: !1,
          initDimensions: function initDimensions() {
            this.__skipDimension || (this.isEditing && this.initDelayedCursor(), this.clearContextTop(), this._clearCache(), this.dynamicMinWidth = 0, this._styleMap = this._generateStyleMap(this._splitText()), this.dynamicMinWidth > this.width && this._set("width", this.dynamicMinWidth), -1 !== this.textAlign.indexOf("justify") && this.enlargeSpaces(), this.height = this.calcTextHeight(), this.saveState({
              propertySet: "_dimensionAffectingProps"
            }));
          },
          _generateStyleMap: function _generateStyleMap(e) {
            for (var t = 0, n = 0, i = 0, r = {}, o = 0; o < e.graphemeLines.length; o++) {
              "\n" === e.graphemeText[i] && o > 0 ? (n = 0, i++, t++) : !this.splitByGrapheme && this._reSpaceAndTab.test(e.graphemeText[i]) && o > 0 && (n++, i++), r[o] = {
                line: t,
                offset: n
              }, i += e.graphemeLines[o].length, n += e.graphemeLines[o].length;
            }

            return r;
          },
          styleHas: function styleHas(e, n) {
            if (this._styleMap && !this.isWrapping) {
              var i = this._styleMap[n];
              i && (n = i.line);
            }

            return t.Text.prototype.styleHas.call(this, e, n);
          },
          isEmptyStyles: function isEmptyStyles(e) {
            if (!this.styles) return !0;
            var t,
                n,
                i = 0,
                r = !1,
                o = this._styleMap[e],
                a = this._styleMap[e + 1];

            for (var s in o && (e = o.line, i = o.offset), a && (r = a.line === e, t = a.offset), n = void 0 === e ? this.styles : {
              line: this.styles[e]
            }) {
              for (var l in n[s]) {
                if (l >= i && (!r || l < t)) for (var u in n[s][l]) {
                  return !1;
                }
              }
            }

            return !0;
          },
          _getStyleDeclaration: function _getStyleDeclaration(e, t) {
            if (this._styleMap && !this.isWrapping) {
              var n = this._styleMap[e];
              if (!n) return null;
              e = n.line, t = n.offset + t;
            }

            return this.callSuper("_getStyleDeclaration", e, t);
          },
          _setStyleDeclaration: function _setStyleDeclaration(e, t, n) {
            var i = this._styleMap[e];
            e = i.line, t = i.offset + t, this.styles[e][t] = n;
          },
          _deleteStyleDeclaration: function _deleteStyleDeclaration(e, t) {
            var n = this._styleMap[e];
            e = n.line, t = n.offset + t, delete this.styles[e][t];
          },
          _getLineStyle: function _getLineStyle(e) {
            var t = this._styleMap[e];
            return !!this.styles[t.line];
          },
          _setLineStyle: function _setLineStyle(e) {
            var t = this._styleMap[e];
            this.styles[t.line] = {};
          },
          _wrapText: function _wrapText(e, t) {
            var n,
                i = [];

            for (this.isWrapping = !0, n = 0; n < e.length; n++) {
              i = i.concat(this._wrapLine(e[n], n, t));
            }

            return this.isWrapping = !1, i;
          },
          _measureWord: function _measureWord(e, t, n) {
            var i,
                r = 0;
            n = n || 0;

            for (var o = 0, a = e.length; o < a; o++) {
              r += this._getGraphemeBox(e[o], t, o + n, i, !0).kernedWidth, i = e[o];
            }

            return r;
          },
          _wrapLine: function _wrapLine(e, n, i, r) {
            var o = 0,
                a = this.splitByGrapheme,
                s = [],
                l = [],
                u = a ? t.util.string.graphemeSplit(e) : e.split(this._wordJoiners),
                c = "",
                h = 0,
                d = a ? "" : " ",
                f = 0,
                p = 0,
                g = 0,
                v = !0,
                m = a ? 0 : this._getWidthOfCharSpacing();
            r = r || 0;
            0 === u.length && u.push([]), i -= r;

            for (var y = 0; y < u.length; y++) {
              c = a ? u[y] : t.util.string.graphemeSplit(u[y]), f = this._measureWord(c, n, h), h += c.length, (o += p + f - m) >= i && !v ? (s.push(l), l = [], o = f, v = !0) : o += m, v || a || l.push(d), l = l.concat(c), p = this._measureWord([d], n, h), h++, v = !1, f > g && (g = f);
            }

            return y && s.push(l), g + r > this.dynamicMinWidth && (this.dynamicMinWidth = g - m + r), s;
          },
          isEndOfWrapping: function isEndOfWrapping(e) {
            return !this._styleMap[e + 1] || this._styleMap[e + 1].line !== this._styleMap[e].line;
          },
          missingNewlineOffset: function missingNewlineOffset(e) {
            return this.splitByGrapheme ? this.isEndOfWrapping(e) ? 1 : 0 : 1;
          },
          _splitTextIntoLines: function _splitTextIntoLines(e) {
            for (var n = t.Text.prototype._splitTextIntoLines.call(this, e), i = this._wrapText(n.lines, this.width), r = new Array(i.length), o = 0; o < i.length; o++) {
              r[o] = i[o].join("");
            }

            return n.lines = r, n.graphemeLines = i, n;
          },
          getMinWidth: function getMinWidth() {
            return Math.max(this.minWidth, this.dynamicMinWidth);
          },
          _removeExtraneousStyles: function _removeExtraneousStyles() {
            var e = {};

            for (var t in this._styleMap) {
              this._textLines[t] && (e[this._styleMap[t].line] = 1);
            }

            for (var t in this.styles) {
              e[t] || delete this.styles[t];
            }
          },
          toObject: function toObject(e) {
            return this.callSuper("toObject", ["minWidth", "splitByGrapheme"].concat(e));
          }
        }), t.Textbox.fromObject = function (e, n) {
          return t.Object._fromObject("Textbox", e, n, "text");
        };
      }(t);
    }).call(this, n(564).Buffer);
  }, function (e, t, n) {
    var i = n(10),
        r = n(23),
        o = n(37),
        a = n(33),
        s = n(45),
        l = function l(e, t, n) {
      var u,
          c,
          h,
          d,
          f = e & l.F,
          p = e & l.G,
          g = e & l.S,
          v = e & l.P,
          m = e & l.B,
          y = p ? i : g ? i[t] || (i[t] = {}) : (i[t] || {}).prototype,
          x = p ? r : r[t] || (r[t] = {}),
          _ = x.prototype || (x.prototype = {});

      for (u in p && (n = t), n) {
        h = ((c = !f && y && void 0 !== y[u]) ? y : n)[u], d = m && c ? s(h, i) : v && "function" == typeof h ? s(Function.call, h) : h, y && a(y, u, h, e & l.U), x[u] != h && o(x, u, d), v && _[u] != h && (_[u] = h);
      }
    };

    i.core = r, l.F = 1, l.G = 2, l.S = 4, l.P = 8, l.B = 16, l.W = 32, l.U = 64, l.R = 128, e.exports = l;
  }, function (e, t, n) {
    n(9).__DEV__;

    var i = n(152),
        r = n(1),
        o = n(53),
        a = n(21),
        s = n(203),
        l = n(83),
        u = n(294),
        c = n(307),
        h = n(42),
        d = n(675),
        f = n(676),
        p = n(678),
        g = n(26),
        v = n(27),
        m = n(158),
        y = n(54),
        x = n(5),
        _ = n(8),
        b = n(67).throttle,
        w = n(679),
        S = n(680),
        T = n(681),
        C = n(682),
        k = n(683),
        M = n(684);

    n(308);
    var E = n(212),
        A = r.assert,
        I = r.each,
        P = r.isFunction,
        O = r.isObject,
        L = g.parseClassType,
        D = {
      PROCESSOR: {
        FILTER: 1e3,
        SERIES_FILTER: 800,
        STATISTIC: 5e3
      },
      VISUAL: {
        LAYOUT: 1e3,
        PROGRESSIVE_LAYOUT: 1100,
        GLOBAL: 2e3,
        CHART: 3e3,
        POST_CHART_LAYOUT: 3500,
        COMPONENT: 4e3,
        BRUSH: 5e3
      }
    },
        N = "__flagInMainProcess",
        j = /^[a-zA-Z0-9_]+$/;

    function R(e, t) {
      return function (n, i, r) {
        t || !this._disposed ? (n = n && n.toLowerCase(), l.prototype[e].call(this, n, i, r)) : this.id;
      };
    }

    function F() {
      l.call(this);
    }

    function z(e, t, n) {
      n = n || {}, "string" == typeof t && (t = ue[t]), this.id, this.group, this._dom = e;
      var o = this._zr = i.init(e, {
        renderer: n.renderer || "canvas",
        devicePixelRatio: n.devicePixelRatio,
        width: n.width,
        height: n.height
      });
      this._throttledZrFlush = b(r.bind(o.flush, o), 17), (t = r.clone(t)) && f(t, !0), this._theme = t, this._chartsViews = [], this._chartsMap = {}, this._componentsViews = [], this._componentsMap = {}, this._coordSysMgr = new h();
      var a,
          u,
          d = this._api = (u = (a = this)._coordSysMgr, r.extend(new c(a), {
        getCoordinateSystems: r.bind(u.getCoordinateSystems, u),
        getComponentByElement: function getComponentByElement(e) {
          for (; e;) {
            var t = e.__ecComponentInfo;
            if (null != t) return a._model.getComponent(t.mainType, t.index);
            e = e.parent;
          }
        }
      }));

      function p(e, t) {
        return e.__prio - t.__prio;
      }

      s(le, p), s(oe, p), this._scheduler = new C(this, d, oe, le), l.call(this, this._ecEventProcessor = new ne()), this._messageCenter = new F(), this._initEvents(), this.resize = r.bind(this.resize, this), this._pendingActions = [], o.animation.on("frame", this._onframe, this), function (e, t) {
        e.on("rendered", function () {
          t.trigger("rendered"), !e.animation.isFinished() || t.__optionUpdated || t._scheduler.unfinished || t._pendingActions.length || t.trigger("finished");
        });
      }(o, this), r.setAsPrimitive(this);
    }

    F.prototype.on = R("on", !0), F.prototype.off = R("off", !0), F.prototype.one = R("one", !0), r.mixin(F, l);
    var B = z.prototype;

    function V(e, t, n) {
      if (this._disposed) this.id;else {
        var i,
            r = this._model,
            o = this._coordSysMgr.getCoordinateSystems();

        t = _.parseFinder(r, t);

        for (var a = 0; a < o.length; a++) {
          var s = o[a];
          if (s[e] && null != (i = s[e](r, t, n))) return i;
        }
      }
    }

    B._onframe = function () {
      if (!this._disposed) {
        var e = this._scheduler;

        if (this.__optionUpdated) {
          var t = this.__optionUpdated.silent;
          this[N] = !0, W(this), H.update.call(this), this[N] = !1, this.__optionUpdated = !1, X.call(this, t), q.call(this, t);
        } else if (e.unfinished) {
          var n = 1,
              i = this._model,
              r = this._api;
          e.unfinished = !1;

          do {
            var o = +new Date();
            e.performSeriesTasks(i), e.performDataProcessorTasks(i), U(this, i), e.performVisualTasks(i), Q(this, this._model, r, "remain"), n -= +new Date() - o;
          } while (n > 0 && e.unfinished);

          e.unfinished || this._zr.flush();
        }
      }
    }, B.getDom = function () {
      return this._dom;
    }, B.getZr = function () {
      return this._zr;
    }, B.setOption = function (e, t, n) {
      if (this._disposed) this.id;else {
        var i;

        if (O(t) && (n = t.lazyUpdate, i = t.silent, t = t.notMerge), this[N] = !0, !this._model || t) {
          var r = new d(this._api),
              o = this._theme,
              a = this._model = new u();
          a.scheduler = this._scheduler, a.init(null, null, o, r);
        }

        this._model.setOption(e, ae), n ? (this.__optionUpdated = {
          silent: i
        }, this[N] = !1) : (W(this), H.update.call(this), this._zr.flush(), this.__optionUpdated = !1, this[N] = !1, X.call(this, i), q.call(this, i));
      }
    }, B.setTheme = function () {
      console.error("ECharts#setTheme() is DEPRECATED in ECharts 3.0");
    }, B.getModel = function () {
      return this._model;
    }, B.getOption = function () {
      return this._model && this._model.getOption();
    }, B.getWidth = function () {
      return this._zr.getWidth();
    }, B.getHeight = function () {
      return this._zr.getHeight();
    }, B.getDevicePixelRatio = function () {
      return this._zr.painter.dpr || window.devicePixelRatio || 1;
    }, B.getRenderedCanvas = function (e) {
      if (a.canvasSupported) return (e = e || {}).pixelRatio = e.pixelRatio || 1, e.backgroundColor = e.backgroundColor || this._model.get("backgroundColor"), this._zr.painter.getRenderedCanvas(e);
    }, B.getSvgDataURL = function () {
      if (a.svgSupported) {
        var e = this._zr,
            t = e.storage.getDisplayList();
        return r.each(t, function (e) {
          e.stopAnimation(!0);
        }), e.painter.toDataURL();
      }
    }, B.getDataURL = function (e) {
      if (!this._disposed) {
        var t = (e = e || {}).excludeComponents,
            n = this._model,
            i = [],
            r = this;
        I(t, function (e) {
          n.eachComponent({
            mainType: e
          }, function (e) {
            var t = r._componentsMap[e.__viewId];
            t.group.ignore || (i.push(t), t.group.ignore = !0);
          });
        });
        var o = "svg" === this._zr.painter.getType() ? this.getSvgDataURL() : this.getRenderedCanvas(e).toDataURL("image/" + (e && e.type || "png"));
        return I(i, function (e) {
          e.group.ignore = !1;
        }), o;
      }

      this.id;
    }, B.getConnectedDataURL = function (e) {
      if (this._disposed) this.id;else if (a.canvasSupported) {
        var t = "svg" === e.type,
            n = this.group,
            o = Math.min,
            s = Math.max;

        if (de[n]) {
          var l = 1 / 0,
              u = 1 / 0,
              c = -1 / 0,
              h = -1 / 0,
              d = [],
              f = e && e.pixelRatio || 1;
          r.each(he, function (i, a) {
            if (i.group === n) {
              var f = t ? i.getZr().painter.getSvgDom().innerHTML : i.getRenderedCanvas(r.clone(e)),
                  p = i.getDom().getBoundingClientRect();
              l = o(p.left, l), u = o(p.top, u), c = s(p.right, c), h = s(p.bottom, h), d.push({
                dom: f,
                left: p.left,
                top: p.top
              });
            }
          });
          var p = (c *= f) - (l *= f),
              g = (h *= f) - (u *= f),
              v = r.createCanvas(),
              m = i.init(v, {
            renderer: t ? "svg" : "canvas"
          });

          if (m.resize({
            width: p,
            height: g
          }), t) {
            var y = "";
            return I(d, function (e) {
              var t = e.left - l,
                  n = e.top - u;
              y += '<g transform="translate(' + t + "," + n + ')">' + e.dom + "</g>";
            }), m.painter.getSvgRoot().innerHTML = y, e.connectedBackgroundColor && m.painter.setBackgroundColor(e.connectedBackgroundColor), m.refreshImmediately(), m.painter.toDataURL();
          }

          return e.connectedBackgroundColor && m.add(new x.Rect({
            shape: {
              x: 0,
              y: 0,
              width: p,
              height: g
            },
            style: {
              fill: e.connectedBackgroundColor
            }
          })), I(d, function (e) {
            var t = new x.Image({
              style: {
                x: e.left * f - l,
                y: e.top * f - u,
                image: e.dom
              }
            });
            m.add(t);
          }), m.refreshImmediately(), v.toDataURL("image/" + (e && e.type || "png"));
        }

        return this.getDataURL(e);
      }
    }, B.convertToPixel = r.curry(V, "convertToPixel"), B.convertFromPixel = r.curry(V, "convertFromPixel"), B.containPixel = function (e, t) {
      if (!this._disposed) {
        var n,
            i = this._model;
        return e = _.parseFinder(i, e), r.each(e, function (e, i) {
          i.indexOf("Models") >= 0 && r.each(e, function (e) {
            var r = e.coordinateSystem;
            if (r && r.containPoint) n |= !!r.containPoint(t);else if ("seriesModels" === i) {
              var o = this._chartsMap[e.__viewId];
              o && o.containPoint && (n |= o.containPoint(t, e));
            }
          }, this);
        }, this), !!n;
      }

      this.id;
    }, B.getVisual = function (e, t) {
      var n = this._model,
          i = (e = _.parseFinder(n, e, {
        defaultMainType: "series"
      })).seriesModel.getData(),
          r = e.hasOwnProperty("dataIndexInside") ? e.dataIndexInside : e.hasOwnProperty("dataIndex") ? i.indexOfRawIndex(e.dataIndex) : null;

      return null != r ? i.getItemVisual(r, t) : i.getVisual(t);
    }, B.getViewOfComponentModel = function (e) {
      return this._componentsMap[e.__viewId];
    }, B.getViewOfSeriesModel = function (e) {
      return this._chartsMap[e.__viewId];
    };
    var H = {
      prepareAndUpdate: function prepareAndUpdate(e) {
        W(this), H.update.call(this, e);
      },
      update: function update(e) {
        var t = this._model,
            n = this._api,
            i = this._zr,
            r = this._coordSysMgr,
            s = this._scheduler;

        if (t) {
          s.restoreData(t, e), s.performSeriesTasks(t), r.create(t, n), s.performDataProcessorTasks(t, e), U(this, t), r.update(t, n), K(t), s.performVisualTasks(t, e), $(this, t, n, e);
          var l = t.get("backgroundColor") || "transparent";
          if (a.canvasSupported) i.setBackgroundColor(l);else {
            var u = o.parse(l);
            l = o.stringify(u, "rgb"), 0 === u[3] && (l = "transparent");
          }
          J(t, n);
        }
      },
      updateTransform: function updateTransform(e) {
        var t = this._model,
            n = this,
            i = this._api;

        if (t) {
          var o = [];
          t.eachComponent(function (r, a) {
            var s = n.getViewOfComponentModel(a);
            if (s && s.__alive) if (s.updateTransform) {
              var l = s.updateTransform(a, t, i, e);
              l && l.update && o.push(s);
            } else o.push(s);
          });
          var a = r.createHashMap();
          t.eachSeries(function (r) {
            var o = n._chartsMap[r.__viewId];

            if (o.updateTransform) {
              var s = o.updateTransform(r, t, i, e);
              s && s.update && a.set(r.uid, 1);
            } else a.set(r.uid, 1);
          }), K(t), this._scheduler.performVisualTasks(t, e, {
            setDirty: !0,
            dirtyMap: a
          }), Q(n, t, i, e, a), J(t, this._api);
        }
      },
      updateView: function updateView(e) {
        var t = this._model;
        t && (y.markUpdateMethod(e, "updateView"), K(t), this._scheduler.performVisualTasks(t, e, {
          setDirty: !0
        }), $(this, this._model, this._api, e), J(t, this._api));
      },
      updateVisual: function updateVisual(e) {
        H.update.call(this, e);
      },
      updateLayout: function updateLayout(e) {
        H.update.call(this, e);
      }
    };

    function W(e) {
      var t = e._model,
          n = e._scheduler;
      n.restorePipelines(t), n.prepareStageTasks(), Z(e, "component", t, n), Z(e, "chart", t, n), n.plan();
    }

    function G(e, t, n, i, o) {
      var a = e._model;

      if (i) {
        var s = {};
        s[i + "Id"] = n[i + "Id"], s[i + "Index"] = n[i + "Index"], s[i + "Name"] = n[i + "Name"];
        var l = {
          mainType: i,
          query: s
        };
        o && (l.subType = o);
        var u = n.excludeSeriesId;
        null != u && (u = r.createHashMap(_.normalizeToArray(u))), a && a.eachComponent(l, function (t) {
          u && null != u.get(t.id) || c(e["series" === i ? "_chartsMap" : "_componentsMap"][t.__viewId]);
        }, e);
      } else I(e._componentsViews.concat(e._chartsViews), c);

      function c(i) {
        i && i.__alive && i[t] && i[t](i.__model, a, e._api, n);
      }
    }

    function U(e, t) {
      var n = e._chartsMap,
          i = e._scheduler;
      t.eachSeries(function (e) {
        i.updateStreamModes(e, n[e.__viewId]);
      });
    }

    function Y(e, t) {
      var n = e.type,
          i = e.escapeConnect,
          o = ie[n],
          a = o.actionInfo,
          s = (a.update || "update").split(":"),
          l = s.pop();
      s = null != s[0] && L(s[0]), this[N] = !0;
      var u = [e],
          c = !1;
      e.batch && (c = !0, u = r.map(e.batch, function (t) {
        return (t = r.defaults(r.extend({}, t), e)).batch = null, t;
      }));
      var h,
          d = [],
          f = "highlight" === n || "downplay" === n;
      I(u, function (e) {
        (h = (h = o.action(e, this._model, this._api)) || r.extend({}, e)).type = a.event || h.type, d.push(h), f ? G(this, l, e, "series") : s && G(this, l, e, s.main, s.sub);
      }, this), "none" === l || f || s || (this.__optionUpdated ? (W(this), H.update.call(this, e), this.__optionUpdated = !1) : H[l].call(this, e)), h = c ? {
        type: a.event || n,
        escapeConnect: i,
        batch: d
      } : d[0], this[N] = !1, !t && this._messageCenter.trigger(h.type, h);
    }

    function X(e) {
      for (var t = this._pendingActions; t.length;) {
        var n = t.shift();
        Y.call(this, n, e);
      }
    }

    function q(e) {
      !e && this.trigger("updated");
    }

    function Z(e, t, n, i) {
      for (var r = "component" === t, o = r ? e._componentsViews : e._chartsViews, a = r ? e._componentsMap : e._chartsMap, s = e._zr, l = e._api, u = 0; u < o.length; u++) {
        o[u].__alive = !1;
      }

      function c(e) {
        var t = "_ec_" + e.id + "_" + e.type,
            u = a[t];

        if (!u) {
          var c = L(e.type);
          (u = new (r ? m.getClass(c.main, c.sub) : y.getClass(c.sub))()).init(n, l), a[t] = u, o.push(u), s.add(u.group);
        }

        e.__viewId = u.__id = t, u.__alive = !0, u.__model = e, u.group.__ecComponentInfo = {
          mainType: e.mainType,
          index: e.componentIndex
        }, !r && i.prepareView(u, e, n, l);
      }

      r ? n.eachComponent(function (e, t) {
        "series" !== e && c(t);
      }) : n.eachSeries(c);

      for (u = 0; u < o.length;) {
        var h = o[u];
        h.__alive ? u++ : (!r && h.renderTask.dispose(), s.remove(h.group), h.dispose(n, l), o.splice(u, 1), delete a[h.__id], h.__id = h.group.__ecComponentInfo = null);
      }
    }

    function K(e) {
      e.clearColorPalette(), e.eachSeries(function (e) {
        e.clearColorPalette();
      });
    }

    function $(e, t, n, i) {
      !function (e, t, n, i, r) {
        I(r || e._componentsViews, function (e) {
          var r = e.__model;
          e.render(r, t, n, i), te(r, e);
        });
      }(e, t, n, i), I(e._chartsViews, function (e) {
        e.__alive = !1;
      }), Q(e, t, n, i), I(e._chartsViews, function (e) {
        e.__alive || e.remove(t, n);
      });
    }

    function Q(e, t, n, i, r) {
      var o,
          s = e._scheduler;
      t.eachSeries(function (t) {
        var n = e._chartsMap[t.__viewId];
        n.__alive = !0;
        var a = n.renderTask;
        s.updatePayload(a, i), r && r.get(t.uid) && a.dirty(), o |= a.perform(s.getPerformArgs(a)), n.group.silent = !!t.get("silent"), te(t, n), function (e, t) {
          var n = e.get("blendMode") || null;
          t.group.traverse(function (e) {
            e.isGroup || e.style.blend !== n && e.setStyle("blend", n), e.eachPendingDisplayable && e.eachPendingDisplayable(function (e) {
              e.setStyle("blend", n);
            });
          });
        }(t, n);
      }), s.unfinished |= o, function (e, t) {
        var n = e._zr.storage,
            i = 0;
        n.traverse(function (e) {
          i++;
        }), i > t.get("hoverLayerThreshold") && !a.node && t.eachSeries(function (t) {
          if (!t.preventUsingHoverLayer) {
            var n = e._chartsMap[t.__viewId];
            n.__alive && n.group.traverse(function (e) {
              e.useHoverLayer = !0;
            });
          }
        });
      }(e, t), S(e._zr.dom, t);
    }

    function J(e, t) {
      I(se, function (n) {
        n(e, t);
      });
    }

    B.resize = function (e) {
      if (this._disposed) this.id;else {
        this._zr.resize(e);

        var t = this._model;

        if (this._loadingFX && this._loadingFX.resize(), t) {
          var n = t.resetOption("media"),
              i = e && e.silent;
          this[N] = !0, n && W(this), H.update.call(this), this[N] = !1, X.call(this, i), q.call(this, i);
        }
      }
    }, B.showLoading = function (e, t) {
      if (this._disposed) this.id;else if (O(e) && (t = e, e = ""), e = e || "default", this.hideLoading(), ce[e]) {
        var n = ce[e](this._api, t),
            i = this._zr;
        this._loadingFX = n, i.add(n);
      }
    }, B.hideLoading = function () {
      this._disposed ? this.id : (this._loadingFX && this._zr.remove(this._loadingFX), this._loadingFX = null);
    }, B.makeActionFromEvent = function (e) {
      var t = r.extend({}, e);
      return t.type = re[e.type], t;
    }, B.dispatchAction = function (e, t) {
      this._disposed ? this.id : (O(t) || (t = {
        silent: !!t
      }), ie[e.type] && this._model && (this[N] ? this._pendingActions.push(e) : (Y.call(this, e, t.silent), t.flush ? this._zr.flush(!0) : !1 !== t.flush && a.browser.weChat && this._throttledZrFlush(), X.call(this, t.silent), q.call(this, t.silent))));
    }, B.appendData = function (e) {
      if (this._disposed) this.id;else {
        var t = e.seriesIndex;
        this.getModel().getSeriesByIndex(t).appendData(e), this._scheduler.unfinished = !0;
      }
    }, B.on = R("on", !1), B.off = R("off", !1), B.one = R("one", !1);
    var ee = ["click", "dblclick", "mouseover", "mouseout", "mousemove", "mousedown", "mouseup", "globalout", "contextmenu"];

    function te(e, t) {
      var n = e.get("z"),
          i = e.get("zlevel");
      t.group.traverse(function (e) {
        "group" !== e.type && (null != n && (e.z = n), null != i && (e.zlevel = i));
      });
    }

    function ne() {
      this.eventInfo;
    }

    B._initEvents = function () {
      I(ee, function (e) {
        var t = function t(_t2) {
          var n,
              i = this.getModel(),
              o = _t2.target;
          if ("globalout" === e) n = {};else if (o && null != o.dataIndex) {
            var a = o.dataModel || i.getSeriesByIndex(o.seriesIndex);
            n = a && a.getDataParams(o.dataIndex, o.dataType, o) || {};
          } else o && o.eventData && (n = r.extend({}, o.eventData));

          if (n) {
            var s = n.componentType,
                l = n.componentIndex;
            "markLine" !== s && "markPoint" !== s && "markArea" !== s || (s = "series", l = n.seriesIndex);
            var u = s && null != l && i.getComponent(s, l),
                c = u && this["series" === u.mainType ? "_chartsMap" : "_componentsMap"][u.__viewId];
            n.event = _t2, n.type = e, this._ecEventProcessor.eventInfo = {
              targetEl: o,
              packedEvent: n,
              model: u,
              view: c
            }, this.trigger(e, n);
          }
        };

        t.zrEventfulCallAtLast = !0, this._zr.on(e, t, this);
      }, this), I(re, function (e, t) {
        this._messageCenter.on(t, function (e) {
          this.trigger(t, e);
        }, this);
      }, this);
    }, B.isDisposed = function () {
      return this._disposed;
    }, B.clear = function () {
      this._disposed ? this.id : this.setOption({
        series: []
      }, !0);
    }, B.dispose = function () {
      if (this._disposed) this.id;else {
        this._disposed = !0, _.setAttribute(this.getDom(), ge, "");
        var e = this._api,
            t = this._model;
        I(this._componentsViews, function (n) {
          n.dispose(t, e);
        }), I(this._chartsViews, function (n) {
          n.dispose(t, e);
        }), this._zr.dispose(), delete he[this.id];
      }
    }, r.mixin(z, l), ne.prototype = {
      constructor: ne,
      normalizeQuery: function normalizeQuery(e) {
        var t = {},
            n = {},
            i = {};

        if (r.isString(e)) {
          var o = L(e);
          t.mainType = o.main || null, t.subType = o.sub || null;
        } else {
          var a = ["Index", "Name", "Id"],
              s = {
            name: 1,
            dataIndex: 1,
            dataType: 1
          };
          r.each(e, function (e, r) {
            for (var o = !1, l = 0; l < a.length; l++) {
              var u = a[l],
                  c = r.lastIndexOf(u);

              if (c > 0 && c === r.length - u.length) {
                var h = r.slice(0, c);
                "data" !== h && (t.mainType = h, t[u.toLowerCase()] = e, o = !0);
              }
            }

            s.hasOwnProperty(r) && (n[r] = e, o = !0), o || (i[r] = e);
          });
        }

        return {
          cptQuery: t,
          dataQuery: n,
          otherQuery: i
        };
      },
      filter: function filter(e, t, n) {
        var i = this.eventInfo;
        if (!i) return !0;
        var r = i.targetEl,
            o = i.packedEvent,
            a = i.model,
            s = i.view;
        if (!a || !s) return !0;
        var l = t.cptQuery,
            u = t.dataQuery;
        return c(l, a, "mainType") && c(l, a, "subType") && c(l, a, "index", "componentIndex") && c(l, a, "name") && c(l, a, "id") && c(u, o, "name") && c(u, o, "dataIndex") && c(u, o, "dataType") && (!s.filterForExposedEvent || s.filterForExposedEvent(e, t.otherQuery, r, o));

        function c(e, t, n, i) {
          return null == e[n] || t[i || n] === e[n];
        }
      },
      afterTrigger: function afterTrigger() {
        this.eventInfo = null;
      }
    };
    var ie = {},
        re = {},
        oe = [],
        ae = [],
        se = [],
        le = [],
        ue = {},
        ce = {},
        he = {},
        de = {},
        fe = new Date() - 0,
        pe = new Date() - 0,
        ge = "_echarts_instance_";

    function ve(e) {
      de[e] = !1;
    }

    var me = ve;

    function ye(e) {
      return he[_.getAttribute(e, ge)];
    }

    function xe(e, t) {
      ue[e] = t;
    }

    function _e(e) {
      ae.push(e);
    }

    function be(e, t) {
      Te(oe, e, t, 1e3);
    }

    function we(e, t, n) {
      "function" == typeof t && (n = t, t = "");
      var i = O(e) ? e.type : [e, e = {
        event: t
      }][0];
      e.event = (e.event || i).toLowerCase(), t = e.event, A(j.test(i) && j.test(t)), ie[i] || (ie[i] = {
        action: n,
        actionInfo: e
      }), re[t] = i;
    }

    function Se(e, t) {
      Te(le, e, t, 3e3, "visual");
    }

    function Te(e, t, n, i, r) {
      (P(t) || O(t)) && (n = t, t = i);
      var o = C.wrapStageHandler(n, r);
      return o.__prio = t, o.__raw = n, e.push(o), o;
    }

    function Ce(e, t) {
      ce[e] = t;
    }

    Se(2e3, w), _e(f), be(900, p), Ce("default", T), we({
      type: "highlight",
      event: "highlight",
      update: "highlight"
    }, r.noop), we({
      type: "downplay",
      event: "downplay",
      update: "downplay"
    }, r.noop), xe("light", k), xe("dark", M);
    t.version = "4.8.0", t.dependencies = {
      zrender: "4.3.1"
    }, t.PRIORITY = D, t.init = function (e, t, n) {
      var i = ye(e);
      if (i) return i;
      var r = new z(e, t, n);
      return r.id = "ec_" + fe++, he[r.id] = r, _.setAttribute(e, ge, r.id), function (e) {
        var t = "__connectUpdateStatus";

        function n(e, n) {
          for (var i = 0; i < e.length; i++) {
            e[i][t] = n;
          }
        }

        I(re, function (i, r) {
          e._messageCenter.on(r, function (i) {
            if (de[e.group] && 0 !== e[t]) {
              if (i && i.escapeConnect) return;
              var r = e.makeActionFromEvent(i),
                  o = [];
              I(he, function (t) {
                t !== e && t.group === e.group && o.push(t);
              }), n(o, 0), I(o, function (e) {
                1 !== e[t] && e.dispatchAction(r);
              }), n(o, 2);
            }
          });
        });
      }(r), r;
    }, t.connect = function (e) {
      if (r.isArray(e)) {
        var t = e;
        e = null, I(t, function (t) {
          null != t.group && (e = t.group);
        }), e = e || "g_" + pe++, I(t, function (t) {
          t.group = e;
        });
      }

      return de[e] = !0, e;
    }, t.disConnect = ve, t.disconnect = me, t.dispose = function (e) {
      "string" == typeof e ? e = he[e] : e instanceof z || (e = ye(e)), e instanceof z && !e.isDisposed() && e.dispose();
    }, t.getInstanceByDom = ye, t.getInstanceById = function (e) {
      return he[e];
    }, t.registerTheme = xe, t.registerPreprocessor = _e, t.registerProcessor = be, t.registerPostUpdate = function (e) {
      se.push(e);
    }, t.registerAction = we, t.registerCoordinateSystem = function (e, t) {
      h.register(e, t);
    }, t.getCoordinateSystemDimensions = function (e) {
      var t = h.get(e);
      if (t) return t.getDimensionsInfo ? t.getDimensionsInfo() : t.dimensions.slice();
    }, t.registerLayout = function (e, t) {
      Te(le, e, t, 1e3, "layout");
    }, t.registerVisual = Se, t.registerLoading = Ce, t.extendComponentModel = function (e) {
      return g.extend(e);
    }, t.extendComponentView = function (e) {
      return m.extend(e);
    }, t.extendSeriesModel = function (e) {
      return v.extend(e);
    }, t.extendChartView = function (e) {
      return y.extend(e);
    }, t.setCanvasCreator = function (e) {
      r.$override("createCanvas", e);
    }, t.registerMap = function (e, t, n) {
      E.registerMap(e, t, n);
    }, t.getMap = function (e) {
      var t = E.retrieveMap(e);
      return t && t[0] && {
        geoJson: t[0].geoJSON,
        specialAreas: t[0].specialAreas
      };
    }, t.dataTool = {};
    var ke = n(310);
    !function () {
      for (var e in ke) {
        ke.hasOwnProperty(e) && (t[e] = ke[e]);
      }
    }();
  }, function (e, t, n) {
    var i = n(1),
        r = n(295),
        o = n(53),
        a = n(31),
        s = n(16),
        l = n(20),
        u = n(153),
        c = n(100);
    t.Image = c;
    var h = n(84);
    t.Group = h;
    var d = n(85);
    t.Text = d;
    var f = n(300);
    t.Circle = f;
    var p = n(664);
    t.Sector = p;
    var g = n(665);
    t.Ring = g;
    var v = n(302);
    t.Polygon = v;
    var m = n(304);
    t.Polyline = m;
    var y = n(206);
    t.Rect = y;
    var x = n(305);
    t.Line = x;

    var _ = n(668);

    t.BezierCurve = _;
    var b = n(669);
    t.Arc = b;
    var w = n(670);
    t.CompoundPath = w;
    var S = n(208);
    t.LinearGradient = S;
    var T = n(671);
    t.RadialGradient = T;
    var C = n(17);
    t.BoundingRect = C;
    var k = n(209);
    t.IncrementalDisplayable = k;
    var M = n(207),
        E = Math.max,
        A = Math.min,
        I = {},
        P = 1,
        O = {},
        L = {};

    function D(e, t) {
      L[e] = t;
    }

    function N(e, t, n, i) {
      var o = r.createFromString(e, t);
      return n && ("center" === i && (n = j(n, o.getBoundingRect())), F(o, n)), o;
    }

    function j(e, t) {
      var n,
          i = t.width / t.height,
          r = e.height * i;
      return n = r <= e.width ? e.height : (r = e.width) / i, {
        x: e.x + e.width / 2 - r / 2,
        y: e.y + e.height / 2 - n / 2,
        width: r,
        height: n
      };
    }

    var R = r.mergePath;

    function F(e, t) {
      if (e.applyTransform) {
        var n = e.getBoundingRect().calculateTransform(t);
        e.applyTransform(n);
      }
    }

    var z = M.subPixelOptimize;

    function B(e) {
      return null != e && "none" !== e;
    }

    var V = i.createHashMap(),
        H = 0;

    function W(e) {
      var t = e.__hoverStl;

      if (t && !e.__highlighted) {
        var n = e.__zr,
            i = e.useHoverLayer && n && "canvas" === n.painter.type;

        if (e.__highlighted = i ? "layer" : "plain", !(e.isGroup || !n && e.useHoverLayer)) {
          var r = e,
              o = e.style;
          i && (o = (r = n.addHover(e)).style), oe(o), i || function (e) {
            if (e.__hoverStlDirty) {
              e.__hoverStlDirty = !1;
              var t = e.__hoverStl;

              if (t) {
                var n = e.__cachedNormalStl = {};
                e.__cachedNormalZ2 = e.z2;
                var i = e.style;

                for (var r in t) {
                  null != t[r] && (n[r] = i[r]);
                }

                n.fill = i.fill, n.stroke = i.stroke;
              } else e.__cachedNormalStl = e.__cachedNormalZ2 = null;
            }
          }(r), o.extendFrom(t), G(o, t, "fill"), G(o, t, "stroke"), re(o), i || (e.dirty(!1), e.z2 += 1);
        }
      }
    }

    function G(e, t, n) {
      !B(t[n]) && B(e[n]) && (e[n] = function (e) {
        if ("string" != typeof e) return e;
        var t = V.get(e);
        return t || (t = o.lift(e, -.1), H < 1e4 && (V.set(e, t), H++)), t;
      }(e[n]));
    }

    function U(e) {
      var t = e.__highlighted;
      if (t && (e.__highlighted = !1, !e.isGroup)) if ("layer" === t) e.__zr && e.__zr.removeHover(e);else {
        var n = e.style,
            i = e.__cachedNormalStl;
        i && (oe(n), e.setStyle(i), re(n));
        var r = e.__cachedNormalZ2;
        null != r && e.z2 - r == 1 && (e.z2 = r);
      }
    }

    function Y(e, t, n) {
      var i,
          r = "normal",
          o = "normal";
      e.__highlighted && (r = "emphasis", i = !0), t(e, n), e.__highlighted && (o = "emphasis", i = !0), e.isGroup && e.traverse(function (e) {
        !e.isGroup && t(e, n);
      }), i && e.__highDownOnUpdate && e.__highDownOnUpdate(r, o);
    }

    function X(e, t) {
      t = e.__hoverStl = !1 !== t && (e.hoverStyle || t || {}), e.__hoverStlDirty = !0, e.__highlighted && (e.__cachedNormalStl = null, U(e), W(e));
    }

    function q(e) {
      !Q(this, e) && !this.__highByOuter && Y(this, W);
    }

    function Z(e) {
      !Q(this, e) && !this.__highByOuter && Y(this, U);
    }

    function K(e) {
      this.__highByOuter |= 1 << (e || 0), Y(this, W);
    }

    function $(e) {
      !(this.__highByOuter &= ~(1 << (e || 0))) && Y(this, U);
    }

    function Q(e, t) {
      return e.__highDownSilentOnTouch && t.zrByTouch;
    }

    function J(e, t) {
      var n = !1 === t;

      if (e.__highDownSilentOnTouch = e.highDownSilentOnTouch, e.__highDownOnUpdate = e.highDownOnUpdate, !n || e.__highDownDispatcher) {
        var i = n ? "off" : "on";
        e[i]("mouseover", q)[i]("mouseout", Z), e[i]("emphasis", K)[i]("normal", $), e.__highByOuter = e.__highByOuter || 0, e.__highDownDispatcher = !n;
      }
    }

    function ee(e, t, n, r, o) {
      return te(e, t, r, o), n && i.extend(e, n), e;
    }

    function te(e, t, n, r) {
      if ((n = n || I).isRectText) {
        var o;
        n.getTextPosition ? o = n.getTextPosition(t, r) : "outside" === (o = t.getShallow("position") || (r ? null : "inside")) && (o = "top"), e.textPosition = o, e.textOffset = t.getShallow("offset");
        var a = t.getShallow("rotate");
        null != a && (a *= Math.PI / 180), e.textRotation = a, e.textDistance = i.retrieve2(t.getShallow("distance"), r ? null : 5);
      }

      var s,
          l = t.ecModel,
          u = l && l.option.textStyle,
          c = function (e) {
        var t;

        for (; e && e !== e.ecModel;) {
          var n = (e.option || I).rich;
          if (n) for (var i in t = t || {}, n) {
            n.hasOwnProperty(i) && (t[i] = 1);
          }
          e = e.parentModel;
        }

        return t;
      }(t);

      if (c) for (var h in s = {}, c) {
        if (c.hasOwnProperty(h)) {
          var d = t.getModel(["rich", h]);
          ne(s[h] = {}, d, u, n, r);
        }
      }
      return e.rich = s, ne(e, t, u, n, r, !0), n.forceRich && !n.textStyle && (n.textStyle = {}), e;
    }

    function ne(e, t, n, r, o, a) {
      n = !o && n || I, e.textFill = ie(t.getShallow("color"), r) || n.color, e.textStroke = ie(t.getShallow("textBorderColor"), r) || n.textBorderColor, e.textStrokeWidth = i.retrieve2(t.getShallow("textBorderWidth"), n.textBorderWidth), o || (a && (e.insideRollbackOpt = r, re(e)), null == e.textFill && (e.textFill = r.autoColor)), e.fontStyle = t.getShallow("fontStyle") || n.fontStyle, e.fontWeight = t.getShallow("fontWeight") || n.fontWeight, e.fontSize = t.getShallow("fontSize") || n.fontSize, e.fontFamily = t.getShallow("fontFamily") || n.fontFamily, e.textAlign = t.getShallow("align"), e.textVerticalAlign = t.getShallow("verticalAlign") || t.getShallow("baseline"), e.textLineHeight = t.getShallow("lineHeight"), e.textWidth = t.getShallow("width"), e.textHeight = t.getShallow("height"), e.textTag = t.getShallow("tag"), a && r.disableBox || (e.textBackgroundColor = ie(t.getShallow("backgroundColor"), r), e.textPadding = t.getShallow("padding"), e.textBorderColor = ie(t.getShallow("borderColor"), r), e.textBorderWidth = t.getShallow("borderWidth"), e.textBorderRadius = t.getShallow("borderRadius"), e.textBoxShadowColor = t.getShallow("shadowColor"), e.textBoxShadowBlur = t.getShallow("shadowBlur"), e.textBoxShadowOffsetX = t.getShallow("shadowOffsetX"), e.textBoxShadowOffsetY = t.getShallow("shadowOffsetY")), e.textShadowColor = t.getShallow("textShadowColor") || n.textShadowColor, e.textShadowBlur = t.getShallow("textShadowBlur") || n.textShadowBlur, e.textShadowOffsetX = t.getShallow("textShadowOffsetX") || n.textShadowOffsetX, e.textShadowOffsetY = t.getShallow("textShadowOffsetY") || n.textShadowOffsetY;
    }

    function ie(e, t) {
      return "auto" !== e ? e : t && t.autoColor ? t.autoColor : null;
    }

    function re(e) {
      var t,
          n = e.textPosition,
          i = e.insideRollbackOpt;

      if (i && null == e.textFill) {
        var r = i.autoColor,
            o = i.isRectText,
            a = i.useInsideStyle,
            s = !1 !== a && (!0 === a || o && n && "string" == typeof n && n.indexOf("inside") >= 0),
            l = !s && null != r;
        (s || l) && (t = {
          textFill: e.textFill,
          textStroke: e.textStroke,
          textStrokeWidth: e.textStrokeWidth
        }), s && (e.textFill = "#fff", null == e.textStroke && (e.textStroke = r, null == e.textStrokeWidth && (e.textStrokeWidth = 2))), l && (e.textFill = r);
      }

      e.insideRollback = t;
    }

    function oe(e) {
      var t = e.insideRollback;
      t && (e.textFill = t.textFill, e.textStroke = t.textStroke, e.textStrokeWidth = t.textStrokeWidth, e.insideRollback = null);
    }

    function ae(e, t, n, i, r, o) {
      if ("function" == typeof r && (o = r, r = null), i && i.isAnimationEnabled()) {
        var a = e ? "Update" : "",
            s = i.getShallow("animationDuration" + a),
            l = i.getShallow("animationEasing" + a),
            u = i.getShallow("animationDelay" + a);
        "function" == typeof u && (u = u(r, i.getAnimationDelayParams ? i.getAnimationDelayParams(t, r) : null)), "function" == typeof s && (s = s(r)), s > 0 ? t.animateTo(n, s, u || 0, l, o, !!o) : (t.stopAnimation(), t.attr(n), o && o());
      } else t.stopAnimation(), t.attr(n), o && o();
    }

    function se(e, t, n, i, r) {
      ae(!0, e, t, n, i, r);
    }

    function le(e, t, n) {
      return t && !i.isArrayLike(t) && (t = u.getLocalTransform(t)), n && (t = a.invert([], t)), s.applyTransform([], e, t);
    }

    function ue(e, t, n, i, r, o, a, s) {
      var l,
          u = n - e,
          c = i - t,
          h = a - r,
          d = s - o,
          f = ce(h, d, u, c);
      if ((l = f) <= 1e-6 && l >= -1e-6) return !1;
      var p = e - r,
          g = t - o,
          v = ce(p, g, u, c) / f;
      if (v < 0 || v > 1) return !1;
      var m = ce(p, g, h, d) / f;
      return !(m < 0 || m > 1);
    }

    function ce(e, t, n, i) {
      return e * i - n * t;
    }

    D("circle", f), D("sector", p), D("ring", g), D("polygon", v), D("polyline", m), D("rect", y), D("line", x), D("bezierCurve", _), D("arc", b), t.Z2_EMPHASIS_LIFT = 1, t.CACHED_LABEL_STYLE_PROPERTIES = {
      color: "textFill",
      textBorderColor: "textStroke",
      textBorderWidth: "textStrokeWidth"
    }, t.extendShape = function (e) {
      return l.extend(e);
    }, t.extendPath = function (e, t) {
      return r.extendFromString(e, t);
    }, t.registerShape = D, t.getShapeClass = function (e) {
      if (L.hasOwnProperty(e)) return L[e];
    }, t.makePath = N, t.makeImage = function (e, t, n) {
      var i = new c({
        style: {
          image: e,
          x: t.x,
          y: t.y,
          width: t.width,
          height: t.height
        },
        onload: function onload(e) {
          if ("center" === n) {
            var r = {
              width: e.width,
              height: e.height
            };
            i.setStyle(j(t, r));
          }
        }
      });
      return i;
    }, t.mergePath = R, t.resizePath = F, t.subPixelOptimizeLine = function (e) {
      return M.subPixelOptimizeLine(e.shape, e.shape, e.style), e;
    }, t.subPixelOptimizeRect = function (e) {
      return M.subPixelOptimizeRect(e.shape, e.shape, e.style), e;
    }, t.subPixelOptimize = z, t.setElementHoverStyle = X, t.setHoverStyle = function (e, t) {
      J(e, !0), Y(e, X, t);
    }, t.setAsHighDownDispatcher = J, t.isHighDownDispatcher = function (e) {
      return !(!e || !e.__highDownDispatcher);
    }, t.getHighlightDigit = function (e) {
      var t = O[e];
      return null == t && P <= 32 && (t = O[e] = P++), t;
    }, t.setLabelStyle = function (e, t, n, r, o, a, s) {
      var l,
          u = (o = o || I).labelFetcher,
          c = o.labelDataIndex,
          h = o.labelDimIndex,
          d = o.labelProp,
          f = n.getShallow("show"),
          p = r.getShallow("show");
      (f || p) && (u && (l = u.getFormattedLabel(c, "normal", null, h, d)), null == l && (l = i.isFunction(o.defaultText) ? o.defaultText(c, o) : o.defaultText));
      var g = f ? l : null,
          v = p ? i.retrieve2(u ? u.getFormattedLabel(c, "emphasis", null, h, d) : null, l) : null;
      null == g && null == v || (ee(e, n, a, o), ee(t, r, s, o, !0)), e.text = g, t.text = v;
    }, t.modifyLabelStyle = function (e, t, n) {
      var r = e.style;
      t && (oe(r), e.setStyle(t), re(r)), r = e.__hoverStl, n && r && (oe(r), i.extend(r, n), re(r));
    }, t.setTextStyle = ee, t.setText = function (e, t, n) {
      var i,
          r = {
        isRectText: !0
      };
      !1 === n ? i = !0 : r.autoColor = n, te(e, t, r, i);
    }, t.getFont = function (e, t) {
      var n = t && t.getModel("textStyle");
      return i.trim([e.fontStyle || n && n.getShallow("fontStyle") || "", e.fontWeight || n && n.getShallow("fontWeight") || "", (e.fontSize || n && n.getShallow("fontSize") || 12) + "px", e.fontFamily || n && n.getShallow("fontFamily") || "sans-serif"].join(" "));
    }, t.updateProps = se, t.initProps = function (e, t, n, i, r) {
      ae(!1, e, t, n, i, r);
    }, t.getTransform = function (e, t) {
      for (var n = a.identity([]); e && e !== t;) {
        a.mul(n, e.getLocalTransform(), n), e = e.parent;
      }

      return n;
    }, t.applyTransform = le, t.transformDirection = function (e, t, n) {
      var i = 0 === t[4] || 0 === t[5] || 0 === t[0] ? 1 : Math.abs(2 * t[4] / t[0]),
          r = 0 === t[4] || 0 === t[5] || 0 === t[2] ? 1 : Math.abs(2 * t[4] / t[2]),
          o = ["left" === e ? -i : "right" === e ? i : 0, "top" === e ? -r : "bottom" === e ? r : 0];
      return o = le(o, t, n), Math.abs(o[0]) > Math.abs(o[1]) ? o[0] > 0 ? "right" : "left" : o[1] > 0 ? "bottom" : "top";
    }, t.groupTransition = function (e, t, n, r) {
      if (e && t) {
        var o,
            a = (o = {}, e.traverse(function (e) {
          !e.isGroup && e.anid && (o[e.anid] = e);
        }), o);
        t.traverse(function (e) {
          if (!e.isGroup && e.anid) {
            var t = a[e.anid];

            if (t) {
              var i = l(e);
              e.attr(l(t)), se(e, i, n, e.dataIndex);
            }
          }
        });
      }

      function l(e) {
        var t = {
          position: s.clone(e.position),
          rotation: e.rotation
        };
        return e.shape && (t.shape = i.extend({}, e.shape)), t;
      }
    }, t.clipPointsByRect = function (e, t) {
      return i.map(e, function (e) {
        var n = e[0];
        n = E(n, t.x), n = A(n, t.x + t.width);
        var i = e[1];
        return i = E(i, t.y), [n, i = A(i, t.y + t.height)];
      });
    }, t.clipRectByRect = function (e, t) {
      var n = E(e.x, t.x),
          i = A(e.x + e.width, t.x + t.width),
          r = E(e.y, t.y),
          o = A(e.y + e.height, t.y + t.height);
      if (i >= n && o >= r) return {
        x: n,
        y: r,
        width: i - n,
        height: o - r
      };
    }, t.createIcon = function (e, t, n) {
      var r = (t = i.extend({
        rectHover: !0
      }, t)).style = {
        strokeNoScale: !0
      };
      if (n = n || {
        x: -1,
        y: -1,
        width: 2,
        height: 2
      }, e) return 0 === e.indexOf("image://") ? (r.image = e.slice(8), i.defaults(r, n), new c(t)) : N(e.replace("path://", ""), t, n, "center");
    }, t.linePolygonIntersect = function (e, t, n, i, r) {
      for (var o = 0, a = r[r.length - 1]; o < r.length; o++) {
        var s = r[o];
        if (ue(e, t, n, i, s[0], s[1], a[0], a[1])) return !0;
        a = s;
      }
    }, t.lineLineIntersect = ue;
  }, function (e, t, n) {
    var i = n(1);
    var r = /^(?:(\d{4})(?:[-\/](\d{1,2})(?:[-\/](\d{1,2})(?:[T ](\d{1,2})(?::(\d\d)(?::(\d\d)(?:[.,](\d+))?)?)?(Z|[\+\-]\d\d:?\d\d)?)?)?)?)?$/;

    function o(e) {
      if (0 === e) return 0;
      var t = Math.floor(Math.log(e) / Math.LN10);
      return e / Math.pow(10, t) >= 10 && t++, t;
    }

    t.linearMap = function (e, t, n, i) {
      var r = t[1] - t[0],
          o = n[1] - n[0];
      if (0 === r) return 0 === o ? n[0] : (n[0] + n[1]) / 2;
      if (i) {
        if (r > 0) {
          if (e <= t[0]) return n[0];
          if (e >= t[1]) return n[1];
        } else {
          if (e >= t[0]) return n[0];
          if (e <= t[1]) return n[1];
        }
      } else {
        if (e === t[0]) return n[0];
        if (e === t[1]) return n[1];
      }
      return (e - t[0]) / r * o + n[0];
    }, t.parsePercent = function (e, t) {
      switch (e) {
        case "center":
        case "middle":
          e = "50%";
          break;

        case "left":
        case "top":
          e = "0%";
          break;

        case "right":
        case "bottom":
          e = "100%";
      }

      return "string" == typeof e ? (n = e, n.replace(/^\s+|\s+$/g, "")).match(/%$/) ? parseFloat(e) / 100 * t : parseFloat(e) : null == e ? NaN : +e;
      var n;
    }, t.round = function (e, t, n) {
      return null == t && (t = 10), t = Math.min(Math.max(0, t), 20), e = (+e).toFixed(t), n ? e : +e;
    }, t.asc = function (e) {
      return e.sort(function (e, t) {
        return e - t;
      }), e;
    }, t.getPrecision = function (e) {
      if (e = +e, isNaN(e)) return 0;

      for (var t = 1, n = 0; Math.round(e * t) / t !== e;) {
        t *= 10, n++;
      }

      return n;
    }, t.getPrecisionSafe = function (e) {
      var t = e.toString(),
          n = t.indexOf("e");

      if (n > 0) {
        var i = +t.slice(n + 1);
        return i < 0 ? -i : 0;
      }

      var r = t.indexOf(".");
      return r < 0 ? 0 : t.length - 1 - r;
    }, t.getPixelPrecision = function (e, t) {
      var n = Math.log,
          i = Math.LN10,
          r = Math.floor(n(e[1] - e[0]) / i),
          o = Math.round(n(Math.abs(t[1] - t[0])) / i),
          a = Math.min(Math.max(-r + o, 0), 20);
      return isFinite(a) ? a : 20;
    }, t.getPercentWithPrecision = function (e, t, n) {
      if (!e[t]) return 0;
      var r = i.reduce(e, function (e, t) {
        return e + (isNaN(t) ? 0 : t);
      }, 0);
      if (0 === r) return 0;

      for (var o = Math.pow(10, n), a = i.map(e, function (e) {
        return (isNaN(e) ? 0 : e) / r * o * 100;
      }), s = 100 * o, l = i.map(a, function (e) {
        return Math.floor(e);
      }), u = i.reduce(l, function (e, t) {
        return e + t;
      }, 0), c = i.map(a, function (e, t) {
        return e - l[t];
      }); u < s;) {
        for (var h = Number.NEGATIVE_INFINITY, d = null, f = 0, p = c.length; f < p; ++f) {
          c[f] > h && (h = c[f], d = f);
        }

        ++l[d], c[d] = 0, ++u;
      }

      return l[t] / o;
    }, t.MAX_SAFE_INTEGER = 9007199254740991, t.remRadian = function (e) {
      var t = 2 * Math.PI;
      return (e % t + t) % t;
    }, t.isRadianAroundZero = function (e) {
      return e > -1e-4 && e < 1e-4;
    }, t.parseDate = function (e) {
      if (e instanceof Date) return e;

      if ("string" == typeof e) {
        var t = r.exec(e);
        if (!t) return new Date(NaN);

        if (t[8]) {
          var n = +t[4] || 0;
          return "Z" !== t[8].toUpperCase() && (n -= t[8].slice(0, 3)), new Date(Date.UTC(+t[1], +(t[2] || 1) - 1, +t[3] || 1, n, +(t[5] || 0), +t[6] || 0, +t[7] || 0));
        }

        return new Date(+t[1], +(t[2] || 1) - 1, +t[3] || 1, +t[4] || 0, +(t[5] || 0), +t[6] || 0, +t[7] || 0);
      }

      return null == e ? new Date(NaN) : new Date(Math.round(e));
    }, t.quantity = function (e) {
      return Math.pow(10, o(e));
    }, t.quantityExponent = o, t.nice = function (e, t) {
      var n = o(e),
          i = Math.pow(10, n),
          r = e / i;
      return e = (t ? r < 1.5 ? 1 : r < 2.5 ? 2 : r < 4 ? 3 : r < 7 ? 5 : 10 : r < 1 ? 1 : r < 2 ? 2 : r < 3 ? 3 : r < 5 ? 5 : 10) * i, n >= -20 ? +e.toFixed(n < 0 ? -n : 0) : e;
    }, t.quantile = function (e, t) {
      var n = (e.length - 1) * t + 1,
          i = Math.floor(n),
          r = +e[i - 1],
          o = n - i;
      return o ? r + o * (e[i] - r) : r;
    }, t.reformIntervals = function (e) {
      e.sort(function (e, t) {
        return function e(t, n, i) {
          return t.interval[i] < n.interval[i] || t.interval[i] === n.interval[i] && (t.close[i] - n.close[i] == (i ? -1 : 1) || !i && e(t, n, 1));
        }(e, t, 0) ? -1 : 1;
      });

      for (var t = -1 / 0, n = 1, i = 0; i < e.length;) {
        for (var r = e[i].interval, o = e[i].close, a = 0; a < 2; a++) {
          r[a] <= t && (r[a] = t, o[a] = a ? 1 : 1 - n), t = r[a], n = o[a];
        }

        r[0] === r[1] && o[0] * o[1] != 1 ? e.splice(i, 1) : i++;
      }

      return e;
    }, t.isNumeric = function (e) {
      return e - parseFloat(e) >= 0;
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    };
  }, function (e, t, n) {
    var i = n(1),
        r = n(21),
        o = i.each,
        a = i.isObject,
        s = i.isArray;

    function l(e) {
      return e instanceof Array ? e : null == e ? [] : [e];
    }

    function u(e) {
      return a(e) && e.id && 0 === (e.id + "").indexOf("\0_ec_\0");
    }

    var c = 0;

    function h(e, t) {
      return e && e.hasOwnProperty(t);
    }

    t.normalizeToArray = l, t.defaultEmphasis = function (e, t, n) {
      if (e) {
        e[t] = e[t] || {}, e.emphasis = e.emphasis || {}, e.emphasis[t] = e.emphasis[t] || {};

        for (var i = 0, r = n.length; i < r; i++) {
          var o = n[i];
          !e.emphasis[t].hasOwnProperty(o) && e[t].hasOwnProperty(o) && (e.emphasis[t][o] = e[t][o]);
        }
      }
    }, t.TEXT_STYLE_OPTIONS = ["fontStyle", "fontWeight", "fontSize", "fontFamily", "rich", "tag", "color", "textBorderColor", "textBorderWidth", "width", "height", "lineHeight", "align", "verticalAlign", "baseline", "shadowColor", "shadowBlur", "shadowOffsetX", "shadowOffsetY", "textShadowColor", "textShadowBlur", "textShadowOffsetX", "textShadowOffsetY", "backgroundColor", "borderColor", "borderWidth", "borderRadius", "padding"], t.getDataItemValue = function (e) {
      return !a(e) || s(e) || e instanceof Date ? e : e.value;
    }, t.isDataItemOption = function (e) {
      return a(e) && !(e instanceof Array);
    }, t.mappingToExists = function (e, t) {
      t = (t || []).slice();
      var n = i.map(e || [], function (e, t) {
        return {
          exist: e
        };
      });
      return o(t, function (e, i) {
        if (a(e)) {
          for (var r = 0; r < n.length; r++) {
            if (!n[r].option && null != e.id && n[r].exist.id === e.id + "") return n[r].option = e, void (t[i] = null);
          }

          for (r = 0; r < n.length; r++) {
            var o = n[r].exist;
            if (!(n[r].option || null != o.id && null != e.id || null == e.name || u(e) || u(o) || o.name !== e.name + "")) return n[r].option = e, void (t[i] = null);
          }
        }
      }), o(t, function (e, t) {
        if (a(e)) {
          for (var i = 0; i < n.length; i++) {
            var r = n[i].exist;

            if (!n[i].option && !u(r) && null == e.id) {
              n[i].option = e;
              break;
            }
          }

          i >= n.length && n.push({
            option: e
          });
        }
      }), n;
    }, t.makeIdAndName = function (e) {
      var t = i.createHashMap();
      o(e, function (e, n) {
        var i = e.exist;
        i && t.set(i.id, e);
      }), o(e, function (e, n) {
        var r = e.option;
        i.assert(!r || null == r.id || !t.get(r.id) || t.get(r.id) === e, "id duplicates: " + (r && r.id)), r && null != r.id && t.set(r.id, e), !e.keyInfo && (e.keyInfo = {});
      }), o(e, function (e, n) {
        var i = e.exist,
            r = e.option,
            o = e.keyInfo;

        if (a(r)) {
          if (o.name = null != r.name ? r.name + "" : i ? i.name : "series\0" + n, i) o.id = i.id;else if (null != r.id) o.id = r.id + "";else {
            var s = 0;

            do {
              o.id = "\0" + o.name + "\0" + s++;
            } while (t.get(o.id));
          }
          t.set(o.id, e);
        }
      });
    }, t.isNameSpecified = function (e) {
      var t = e.name;
      return !(!t || !t.indexOf("series\0"));
    }, t.isIdInner = u, t.compressBatches = function (e, t) {
      var n = {},
          i = {};
      return r(e || [], n), r(t || [], i, n), [o(n), o(i)];

      function r(e, t, n) {
        for (var i = 0, r = e.length; i < r; i++) {
          for (var o = e[i].seriesId, a = l(e[i].dataIndex), s = n && n[o], u = 0, c = a.length; u < c; u++) {
            var h = a[u];
            s && s[h] ? s[h] = null : (t[o] || (t[o] = {}))[h] = 1;
          }
        }
      }

      function o(e, t) {
        var n = [];

        for (var i in e) {
          if (e.hasOwnProperty(i) && null != e[i]) if (t) n.push(+i);else {
            var r = o(e[i], !0);
            r.length && n.push({
              seriesId: i,
              dataIndex: r
            });
          }
        }

        return n;
      }
    }, t.queryDataIndex = function (e, t) {
      return null != t.dataIndexInside ? t.dataIndexInside : null != t.dataIndex ? i.isArray(t.dataIndex) ? i.map(t.dataIndex, function (t) {
        return e.indexOfRawIndex(t);
      }) : e.indexOfRawIndex(t.dataIndex) : null != t.name ? i.isArray(t.name) ? i.map(t.name, function (t) {
        return e.indexOfName(t);
      }) : e.indexOfName(t.name) : void 0;
    }, t.makeInner = function () {
      var e = "__\0ec_inner_" + c++ + "_" + Math.random().toFixed(5);
      return function (t) {
        return t[e] || (t[e] = {});
      };
    }, t.parseFinder = function (e, t, n) {
      if (i.isString(t)) {
        var r = {};
        r[t + "Index"] = 0, t = r;
      }

      var a = n && n.defaultMainType;
      !a || h(t, a + "Index") || h(t, a + "Id") || h(t, a + "Name") || (t[a + "Index"] = 0);
      var s = {};
      return o(t, function (r, o) {
        r = t[o];

        if ("dataIndex" !== o && "dataIndexInside" !== o) {
          var a = o.match(/^(\w+)(Index|Id|Name)$/) || [],
              l = a[1],
              u = (a[2] || "").toLowerCase();

          if (!(!l || !u || null == r || "index" === u && "none" === r || n && n.includeMainTypes && i.indexOf(n.includeMainTypes, l) < 0)) {
            var c = {
              mainType: l
            };
            "index" === u && "all" === r || (c[u] = r);
            var h = e.queryComponents(c);
            s[l + "Models"] = h, s[l + "Model"] = h[0];
          }
        } else s[o] = r;
      }), s;
    }, t.setAttribute = function (e, t, n) {
      e.setAttribute ? e.setAttribute(t, n) : e[t] = n;
    }, t.getAttribute = function (e, t) {
      return e.getAttribute ? e.getAttribute(t) : e[t];
    }, t.getTooltipRenderMode = function (e) {
      return "auto" === e ? r.domSupported ? "html" : "richText" : e || "html";
    }, t.groupData = function (e, t) {
      var n = i.createHashMap(),
          r = [];
      return i.each(e, function (e) {
        var i = t(e);
        (n.get(i) || (r.push(i), n.set(i, []))).push(e);
      }), {
        keys: r,
        buckets: n
      };
    };
  }, function (e, t, n) {
    (function (e) {
      var n;
      "undefined" != typeof window ? n = window.__DEV__ : void 0 !== e && (n = e.__DEV__), void 0 === n && (n = !0);
      var i = n;
      t.__DEV__ = i;
    }).call(this, n(65));
  }, function (e, t) {
    var n = e.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
    "number" == typeof __g && (__g = n);
  }, function (e, t) {
    e.exports = function (e) {
      try {
        return !!e();
      } catch (e) {
        return !0;
      }
    };
  }, function (e, t, n) {
    var i = n(13);

    e.exports = function (e) {
      if (!i(e)) throw TypeError(e + " is not an object!");
      return e;
    };
  }, function (e, t) {
    e.exports = function (e) {
      return "object" == typeof e ? null !== e : "function" == typeof e;
    };
  }, function (e, t, n) {
    var i = n(1),
        r = n(17),
        o = n(6).parsePercent,
        a = n(15),
        s = i.each,
        l = ["left", "right", "top", "bottom", "width", "height"],
        u = [["width", "left", "right"], ["height", "top", "bottom"]];

    function c(e, t, n, i, r) {
      var o = 0,
          a = 0;
      null == i && (i = 1 / 0), null == r && (r = 1 / 0);
      var s = 0;
      t.eachChild(function (l, u) {
        var c,
            h,
            d = l.position,
            f = l.getBoundingRect(),
            p = t.childAt(u + 1),
            g = p && p.getBoundingRect();

        if ("horizontal" === e) {
          var v = f.width + (g ? -g.x + f.x : 0);
          (c = o + v) > i || l.newline ? (o = 0, c = v, a += s + n, s = f.height) : s = Math.max(s, f.height);
        } else {
          var m = f.height + (g ? -g.y + f.y : 0);
          (h = a + m) > r || l.newline ? (o += s + n, a = 0, h = m, s = f.width) : s = Math.max(s, f.width);
        }

        l.newline || (d[0] = o, d[1] = a, "horizontal" === e ? o = c + n : a = h + n);
      });
    }

    var h = c,
        d = i.curry(c, "vertical"),
        f = i.curry(c, "horizontal");

    function p(e, t, n) {
      n = a.normalizeCssArray(n || 0);
      var i = t.width,
          s = t.height,
          l = o(e.left, i),
          u = o(e.top, s),
          c = o(e.right, i),
          h = o(e.bottom, s),
          d = o(e.width, i),
          f = o(e.height, s),
          p = n[2] + n[0],
          g = n[1] + n[3],
          v = e.aspect;

      switch (isNaN(d) && (d = i - c - g - l), isNaN(f) && (f = s - h - p - u), null != v && (isNaN(d) && isNaN(f) && (v > i / s ? d = .8 * i : f = .8 * s), isNaN(d) && (d = v * f), isNaN(f) && (f = d / v)), isNaN(l) && (l = i - c - d - g), isNaN(u) && (u = s - h - f - p), e.left || e.right) {
        case "center":
          l = i / 2 - d / 2 - n[3];
          break;

        case "right":
          l = i - d - g;
      }

      switch (e.top || e.bottom) {
        case "middle":
        case "center":
          u = s / 2 - f / 2 - n[0];
          break;

        case "bottom":
          u = s - f - p;
      }

      l = l || 0, u = u || 0, isNaN(d) && (d = i - g - l - (c || 0)), isNaN(f) && (f = s - p - u - (h || 0));
      var m = new r(l + n[3], u + n[0], d, f);
      return m.margin = n, m;
    }

    function g(e, t) {
      return t && e && s(l, function (n) {
        t.hasOwnProperty(n) && (e[n] = t[n]);
      }), e;
    }

    t.LOCATION_PARAMS = l, t.HV_NAMES = u, t.box = h, t.vbox = d, t.hbox = f, t.getAvailableSize = function (e, t, n) {
      var i = t.width,
          r = t.height,
          s = o(e.x, i),
          l = o(e.y, r),
          u = o(e.x2, i),
          c = o(e.y2, r);
      return (isNaN(s) || isNaN(parseFloat(e.x))) && (s = 0), (isNaN(u) || isNaN(parseFloat(e.x2))) && (u = i), (isNaN(l) || isNaN(parseFloat(e.y))) && (l = 0), (isNaN(c) || isNaN(parseFloat(e.y2))) && (c = r), n = a.normalizeCssArray(n || 0), {
        width: Math.max(u - s - n[1] - n[3], 0),
        height: Math.max(c - l - n[0] - n[2], 0)
      };
    }, t.getLayoutRect = p, t.positionElement = function (e, t, n, o, a) {
      var s = !a || !a.hv || a.hv[0],
          l = !a || !a.hv || a.hv[1],
          u = a && a.boundingMode || "all";

      if (s || l) {
        var c;
        if ("raw" === u) c = "group" === e.type ? new r(0, 0, +t.width || 0, +t.height || 0) : e.getBoundingRect();else if (c = e.getBoundingRect(), e.needLocalTransform()) {
          var h = e.getLocalTransform();
          (c = c.clone()).applyTransform(h);
        }
        t = p(i.defaults({
          width: c.width,
          height: c.height
        }, t), n, o);
        var d = e.position,
            f = s ? t.x - c.x : 0,
            g = l ? t.y - c.y : 0;
        e.attr("position", "raw" === u ? [f, g] : [d[0] + f, d[1] + g]);
      }
    }, t.sizeCalculable = function (e, t) {
      return null != e[u[t][0]] || null != e[u[t][1]] && null != e[u[t][2]];
    }, t.mergeLayoutParam = function (e, t, n) {
      !i.isObject(n) && (n = {});
      var r = n.ignoreSize;
      !i.isArray(r) && (r = [r, r]);
      var o = l(u[0], 0),
          a = l(u[1], 1);

      function l(n, i) {
        var o = {},
            a = 0,
            l = {},
            u = 0;
        if (s(n, function (t) {
          l[t] = e[t];
        }), s(n, function (e) {
          c(t, e) && (o[e] = l[e] = t[e]), h(o, e) && a++, h(l, e) && u++;
        }), r[i]) return h(t, n[1]) ? l[n[2]] = null : h(t, n[2]) && (l[n[1]] = null), l;

        if (2 !== u && a) {
          if (a >= 2) return o;

          for (var d = 0; d < n.length; d++) {
            var f = n[d];

            if (!c(o, f) && c(e, f)) {
              o[f] = e[f];
              break;
            }
          }

          return o;
        }

        return l;
      }

      function c(e, t) {
        return e.hasOwnProperty(t);
      }

      function h(e, t) {
        return null != e[t] && "auto" !== e[t];
      }

      function d(e, t, n) {
        s(e, function (e) {
          t[e] = n[e];
        });
      }

      d(u[0], e, o), d(u[1], e, a);
    }, t.getLayoutParams = function (e) {
      return g({}, e);
    }, t.copyLayoutParams = g;
  }, function (e, t, n) {
    var i = n(1),
        r = n(35),
        o = n(6);
    var a = i.normalizeCssArray,
        s = /([&<>"'])/g,
        l = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    };

    function u(e) {
      return null == e ? "" : (e + "").replace(s, function (e, t) {
        return l[t];
      });
    }

    var c = ["a", "b", "c", "d", "e", "f", "g"],
        h = function h(e, t) {
      return "{" + e + (null == t ? "" : t) + "}";
    };

    function d(e, t) {
      return "0000".substr(0, t - (e += "").length) + e;
    }

    var f = r.truncateText;
    t.addCommas = function (e) {
      return isNaN(e) ? "-" : (e = (e + "").split("."))[0].replace(/(\d{1,3})(?=(?:\d{3})+(?!\d))/g, "$1,") + (e.length > 1 ? "." + e[1] : "");
    }, t.toCamelCase = function (e, t) {
      return e = (e || "").toLowerCase().replace(/-(.)/g, function (e, t) {
        return t.toUpperCase();
      }), t && e && (e = e.charAt(0).toUpperCase() + e.slice(1)), e;
    }, t.normalizeCssArray = a, t.encodeHTML = u, t.formatTpl = function (e, t, n) {
      i.isArray(t) || (t = [t]);
      var r = t.length;
      if (!r) return "";

      for (var o = t[0].$vars || [], a = 0; a < o.length; a++) {
        var s = c[a];
        e = e.replace(h(s), h(s, 0));
      }

      for (var l = 0; l < r; l++) {
        for (var d = 0; d < o.length; d++) {
          var f = t[l][o[d]];
          e = e.replace(h(c[d], l), n ? u(f) : f);
        }
      }

      return e;
    }, t.formatTplSimple = function (e, t, n) {
      return i.each(t, function (t, i) {
        e = e.replace("{" + i + "}", n ? u(t) : t);
      }), e;
    }, t.getTooltipMarker = function (e, t) {
      var n = (e = i.isString(e) ? {
        color: e,
        extraCssText: t
      } : e || {}).color,
          r = e.type,
          o = (t = e.extraCssText, e.renderMode || "html"),
          a = e.markerId || "X";
      return n ? "html" === o ? "subItem" === r ? '<span style="display:inline-block;vertical-align:middle;margin-right:8px;margin-left:3px;border-radius:4px;width:4px;height:4px;background-color:' + u(n) + ";" + (t || "") + '"></span>' : '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:' + u(n) + ";" + (t || "") + '"></span>' : {
        renderMode: o,
        content: "{marker" + a + "|}  ",
        style: {
          color: n
        }
      } : "";
    }, t.formatTime = function (e, t, n) {
      "week" !== e && "month" !== e && "quarter" !== e && "half-year" !== e && "year" !== e || (e = "MM-dd\nyyyy");
      var i = o.parseDate(t),
          r = n ? "UTC" : "",
          a = i["get" + r + "FullYear"](),
          s = i["get" + r + "Month"]() + 1,
          l = i["get" + r + "Date"](),
          u = i["get" + r + "Hours"](),
          c = i["get" + r + "Minutes"](),
          h = i["get" + r + "Seconds"](),
          f = i["get" + r + "Milliseconds"]();
      return e = e.replace("MM", d(s, 2)).replace("M", s).replace("yyyy", a).replace("yy", a % 100).replace("dd", d(l, 2)).replace("d", l).replace("hh", d(u, 2)).replace("h", u).replace("mm", d(c, 2)).replace("m", c).replace("ss", d(h, 2)).replace("s", h).replace("SSS", d(f, 3));
    }, t.capitalFirst = function (e) {
      return e ? e.charAt(0).toUpperCase() + e.substr(1) : e;
    }, t.truncateText = f, t.getTextBoundingRect = function (e) {
      return r.getBoundingRect(e.text, e.font, e.textAlign, e.textVerticalAlign, e.textPadding, e.textLineHeight, e.rich, e.truncate);
    }, t.getTextRect = function (e, t, n, i, o, a, s, l) {
      return r.getBoundingRect(e, t, n, i, o, l, a, s);
    }, t.windowOpen = function (e, t) {
      if ("_blank" === t || "blank" === t) {
        var n = window.open();
        n.opener = null, n.location = e;
      } else window.open(e, t);
    };
  }, function (e, t) {
    var n = "undefined" == typeof Float32Array ? Array : Float32Array;

    function i(e) {
      return Math.sqrt(o(e));
    }

    var r = i;

    function o(e) {
      return e[0] * e[0] + e[1] * e[1];
    }

    var a = o;

    function s(e, t) {
      return Math.sqrt((e[0] - t[0]) * (e[0] - t[0]) + (e[1] - t[1]) * (e[1] - t[1]));
    }

    var l = s;

    function u(e, t) {
      return (e[0] - t[0]) * (e[0] - t[0]) + (e[1] - t[1]) * (e[1] - t[1]);
    }

    var c = u;
    t.create = function (e, t) {
      var i = new n(2);
      return null == e && (e = 0), null == t && (t = 0), i[0] = e, i[1] = t, i;
    }, t.copy = function (e, t) {
      return e[0] = t[0], e[1] = t[1], e;
    }, t.clone = function (e) {
      var t = new n(2);
      return t[0] = e[0], t[1] = e[1], t;
    }, t.set = function (e, t, n) {
      return e[0] = t, e[1] = n, e;
    }, t.add = function (e, t, n) {
      return e[0] = t[0] + n[0], e[1] = t[1] + n[1], e;
    }, t.scaleAndAdd = function (e, t, n, i) {
      return e[0] = t[0] + n[0] * i, e[1] = t[1] + n[1] * i, e;
    }, t.sub = function (e, t, n) {
      return e[0] = t[0] - n[0], e[1] = t[1] - n[1], e;
    }, t.len = i, t.length = r, t.lenSquare = o, t.lengthSquare = a, t.mul = function (e, t, n) {
      return e[0] = t[0] * n[0], e[1] = t[1] * n[1], e;
    }, t.div = function (e, t, n) {
      return e[0] = t[0] / n[0], e[1] = t[1] / n[1], e;
    }, t.dot = function (e, t) {
      return e[0] * t[0] + e[1] * t[1];
    }, t.scale = function (e, t, n) {
      return e[0] = t[0] * n, e[1] = t[1] * n, e;
    }, t.normalize = function (e, t) {
      var n = i(t);
      return 0 === n ? (e[0] = 0, e[1] = 0) : (e[0] = t[0] / n, e[1] = t[1] / n), e;
    }, t.distance = s, t.dist = l, t.distanceSquare = u, t.distSquare = c, t.negate = function (e, t) {
      return e[0] = -t[0], e[1] = -t[1], e;
    }, t.lerp = function (e, t, n, i) {
      return e[0] = t[0] + i * (n[0] - t[0]), e[1] = t[1] + i * (n[1] - t[1]), e;
    }, t.applyTransform = function (e, t, n) {
      var i = t[0],
          r = t[1];
      return e[0] = n[0] * i + n[2] * r + n[4], e[1] = n[1] * i + n[3] * r + n[5], e;
    }, t.min = function (e, t, n) {
      return e[0] = Math.min(t[0], n[0]), e[1] = Math.min(t[1], n[1]), e;
    }, t.max = function (e, t, n) {
      return e[0] = Math.max(t[0], n[0]), e[1] = Math.max(t[1], n[1]), e;
    };
  }, function (e, t, n) {
    var i,
        r,
        o,
        a,
        s = n(16),
        l = n(31),
        u = s.applyTransform,
        c = Math.min,
        h = Math.max;

    function d(e, t, n, i) {
      n < 0 && (e += n, n = -n), i < 0 && (t += i, i = -i), this.x = e, this.y = t, this.width = n, this.height = i;
    }

    d.prototype = {
      constructor: d,
      union: function union(e) {
        var t = c(e.x, this.x),
            n = c(e.y, this.y);
        this.width = h(e.x + e.width, this.x + this.width) - t, this.height = h(e.y + e.height, this.y + this.height) - n, this.x = t, this.y = n;
      },
      applyTransform: (i = [], r = [], o = [], a = [], function (e) {
        if (e) {
          i[0] = o[0] = this.x, i[1] = a[1] = this.y, r[0] = a[0] = this.x + this.width, r[1] = o[1] = this.y + this.height, u(i, i, e), u(r, r, e), u(o, o, e), u(a, a, e), this.x = c(i[0], r[0], o[0], a[0]), this.y = c(i[1], r[1], o[1], a[1]);
          var t = h(i[0], r[0], o[0], a[0]),
              n = h(i[1], r[1], o[1], a[1]);
          this.width = t - this.x, this.height = n - this.y;
        }
      }),
      calculateTransform: function calculateTransform(e) {
        var t = this,
            n = e.width / t.width,
            i = e.height / t.height,
            r = l.create();
        return l.translate(r, r, [-t.x, -t.y]), l.scale(r, r, [n, i]), l.translate(r, r, [e.x, e.y]), r;
      },
      intersect: function intersect(e) {
        if (!e) return !1;
        e instanceof d || (e = d.create(e));
        var t = this,
            n = t.x,
            i = t.x + t.width,
            r = t.y,
            o = t.y + t.height,
            a = e.x,
            s = e.x + e.width,
            l = e.y,
            u = e.y + e.height;
        return !(i < a || s < n || o < l || u < r);
      },
      contain: function contain(e, t) {
        return e >= this.x && e <= this.x + this.width && t >= this.y && t <= this.y + this.height;
      },
      clone: function clone() {
        return new d(this.x, this.y, this.width, this.height);
      },
      copy: function copy(e) {
        this.x = e.x, this.y = e.y, this.width = e.width, this.height = e.height;
      },
      plain: function plain() {
        return {
          x: this.x,
          y: this.y,
          width: this.width,
          height: this.height
        };
      }
    }, d.create = function (e) {
      return new d(e.x, e.y, e.width, e.height);
    };
    var f = d;
    e.exports = f;
  }, function (e, t, n) {
    var i = n(136)("wks"),
        r = n(74),
        o = n(10).Symbol,
        a = "function" == typeof o;
    (e.exports = function (e) {
      return i[e] || (i[e] = a && o[e] || (a ? o : r)("Symbol." + e));
    }).store = i;
  }, function (e, t, n) {
    var i = n(47),
        r = Math.min;

    e.exports = function (e) {
      return e > 0 ? r(i(e), 9007199254740991) : 0;
    };
  }, function (e, t, n) {
    var i = n(119),
        r = n(1),
        o = n(102),
        a = n(660),
        s = n(290).prototype.getCanvasPattern,
        l = Math.abs,
        u = new o(!0);

    function c(e) {
      i.call(this, e), this.path = null;
    }

    c.prototype = {
      constructor: c,
      type: "path",
      __dirtyPath: !0,
      strokeContainThreshold: 5,
      segmentIgnoreThreshold: 0,
      subPixelOptimize: !1,
      brush: function brush(e, t) {
        var n,
            i = this.style,
            r = this.path || u,
            o = i.hasStroke(),
            a = i.hasFill(),
            l = i.fill,
            c = i.stroke,
            h = a && !!l.colorStops,
            d = o && !!c.colorStops,
            f = a && !!l.image,
            p = o && !!c.image;
        (i.bind(e, this, t), this.setTransform(e), this.__dirty) && (h && (n = n || this.getBoundingRect(), this._fillGradient = i.getGradient(e, l, n)), d && (n = n || this.getBoundingRect(), this._strokeGradient = i.getGradient(e, c, n)));
        h ? e.fillStyle = this._fillGradient : f && (e.fillStyle = s.call(l, e)), d ? e.strokeStyle = this._strokeGradient : p && (e.strokeStyle = s.call(c, e));
        var g = i.lineDash,
            v = i.lineDashOffset,
            m = !!e.setLineDash,
            y = this.getGlobalScale();
        if (r.setScale(y[0], y[1], this.segmentIgnoreThreshold), this.__dirtyPath || g && !m && o ? (r.beginPath(e), g && !m && (r.setLineDash(g), r.setLineDashOffset(v)), this.buildPath(r, this.shape, !1), this.path && (this.__dirtyPath = !1)) : (e.beginPath(), this.path.rebuildPath(e)), a) if (null != i.fillOpacity) {
          var x = e.globalAlpha;
          e.globalAlpha = i.fillOpacity * i.opacity, r.fill(e), e.globalAlpha = x;
        } else r.fill(e);
        if (g && m && (e.setLineDash(g), e.lineDashOffset = v), o) if (null != i.strokeOpacity) {
          x = e.globalAlpha;
          e.globalAlpha = i.strokeOpacity * i.opacity, r.stroke(e), e.globalAlpha = x;
        } else r.stroke(e);
        g && m && e.setLineDash([]), null != i.text && (this.restoreTransform(e), this.drawRectText(e, this.getBoundingRect()));
      },
      buildPath: function buildPath(e, t, n) {},
      createPathProxy: function createPathProxy() {
        this.path = new o();
      },
      getBoundingRect: function getBoundingRect() {
        var e = this._rect,
            t = this.style,
            n = !e;

        if (n) {
          var i = this.path;
          i || (i = this.path = new o()), this.__dirtyPath && (i.beginPath(), this.buildPath(i, this.shape, !1)), e = i.getBoundingRect();
        }

        if (this._rect = e, t.hasStroke()) {
          var r = this._rectWithStroke || (this._rectWithStroke = e.clone());

          if (this.__dirty || n) {
            r.copy(e);
            var a = t.lineWidth,
                s = t.strokeNoScale ? this.getLineScale() : 1;
            t.hasFill() || (a = Math.max(a, this.strokeContainThreshold || 4)), s > 1e-10 && (r.width += a / s, r.height += a / s, r.x -= a / s / 2, r.y -= a / s / 2);
          }

          return r;
        }

        return e;
      },
      contain: function contain(e, t) {
        var n = this.transformCoordToLocal(e, t),
            i = this.getBoundingRect(),
            r = this.style;

        if (e = n[0], t = n[1], i.contain(e, t)) {
          var o = this.path.data;

          if (r.hasStroke()) {
            var s = r.lineWidth,
                l = r.strokeNoScale ? this.getLineScale() : 1;
            if (l > 1e-10 && (r.hasFill() || (s = Math.max(s, this.strokeContainThreshold)), a.containStroke(o, s / l, e, t))) return !0;
          }

          if (r.hasFill()) return a.contain(o, e, t);
        }

        return !1;
      },
      dirty: function dirty(e) {
        null == e && (e = !0), e && (this.__dirtyPath = e, this._rect = null), this.__dirty = this.__dirtyText = !0, this.__zr && this.__zr.refresh(), this.__clipTarget && this.__clipTarget.dirty();
      },
      animateShape: function animateShape(e) {
        return this.animate("shape", e);
      },
      attrKV: function attrKV(e, t) {
        "shape" === e ? (this.setShape(t), this.__dirtyPath = !0, this._rect = null) : i.prototype.attrKV.call(this, e, t);
      },
      setShape: function setShape(e, t) {
        var n = this.shape;

        if (n) {
          if (r.isObject(e)) for (var i in e) {
            e.hasOwnProperty(i) && (n[i] = e[i]);
          } else n[e] = t;
          this.dirty(!0);
        }

        return this;
      },
      getLineScale: function getLineScale() {
        var e = this.transform;
        return e && l(e[0] - 1) > 1e-10 && l(e[3] - 1) > 1e-10 ? Math.sqrt(l(e[0] * e[3] - e[2] * e[1])) : 1;
      }
    }, c.extend = function (e) {
      var t = function t(_t3) {
        c.call(this, _t3), e.style && this.style.extendFrom(e.style, !1);
        var n = e.shape;

        if (n) {
          this.shape = this.shape || {};
          var i = this.shape;

          for (var r in n) {
            !i.hasOwnProperty(r) && n.hasOwnProperty(r) && (i[r] = n[r]);
          }
        }

        e.init && e.init.call(this, _t3);
      };

      for (var n in r.inherits(t, c), e) {
        "style" !== n && "shape" !== n && (t.prototype[n] = e[n]);
      }

      return t;
    }, r.inherits(c, i);
    var h = c;
    e.exports = h;
  }, function (e, t) {
    var n = "object" == typeof wx && "function" == typeof wx.getSystemInfoSync ? {
      browser: {},
      os: {},
      node: !1,
      wxa: !0,
      canvasSupported: !0,
      svgSupported: !1,
      touchEventsSupported: !0,
      domSupported: !1
    } : "undefined" == typeof document && "undefined" != typeof self ? {
      browser: {},
      os: {},
      node: !1,
      worker: !0,
      canvasSupported: !0,
      domSupported: !1
    } : "undefined" == typeof navigator ? {
      browser: {},
      os: {},
      node: !0,
      worker: !1,
      canvasSupported: !0,
      svgSupported: !0,
      domSupported: !1
    } : function (e) {
      var t = {},
          n = e.match(/Firefox\/([\d.]+)/),
          i = e.match(/MSIE\s([\d.]+)/) || e.match(/Trident\/.+?rv:(([\d.]+))/),
          r = e.match(/Edge\/([\d.]+)/),
          o = /micromessenger/i.test(e);
      n && (t.firefox = !0, t.version = n[1]);
      i && (t.ie = !0, t.version = i[1]);
      r && (t.edge = !0, t.version = r[1]);
      o && (t.weChat = !0);
      return {
        browser: t,
        os: {},
        node: !1,
        canvasSupported: !!document.createElement("canvas").getContext,
        svgSupported: "undefined" != typeof SVGRect,
        touchEventsSupported: "ontouchstart" in window && !t.ie && !t.edge,
        pointerEventsSupported: "onpointerdown" in window && (t.edge || t.ie && t.version >= 11),
        domSupported: "undefined" != typeof document
      };
    }(navigator.userAgent);
    e.exports = n;
  }, function (e, t, n) {
    var i = n(1),
        r = n(21),
        o = n(8).makeInner,
        a = n(60),
        s = a.enableClassExtend,
        l = a.enableClassCheck,
        u = n(657),
        c = n(658),
        h = n(659),
        d = n(672),
        f = i.mixin,
        p = o();

    function g(e, t, n) {
      this.parentModel = t, this.ecModel = n, this.option = e;
    }

    function v(e, t, n) {
      for (var i = 0; i < t.length && (!t[i] || null != (e = e && "object" == typeof e ? e[t[i]] : null)); i++) {
        ;
      }

      return null == e && n && (e = n.get(t)), e;
    }

    function m(e, t) {
      var n = p(e).getParent;
      return n ? n.call(e, t) : e.parentModel;
    }

    g.prototype = {
      constructor: g,
      init: null,
      mergeOption: function mergeOption(e) {
        i.merge(this.option, e, !0);
      },
      get: function get(e, t) {
        return null == e ? this.option : v(this.option, this.parsePath(e), !t && m(this, e));
      },
      getShallow: function getShallow(e, t) {
        var n = this.option,
            i = null == n ? n : n[e],
            r = !t && m(this, e);
        return null == i && r && (i = r.getShallow(e)), i;
      },
      getModel: function getModel(e, t) {
        var n;
        return new g(null == e ? this.option : v(this.option, e = this.parsePath(e)), t = t || (n = m(this, e)) && n.getModel(e), this.ecModel);
      },
      isEmpty: function isEmpty() {
        return null == this.option;
      },
      restoreData: function restoreData() {},
      clone: function clone() {
        return new (0, this.constructor)(i.clone(this.option));
      },
      setReadOnly: function setReadOnly(e) {},
      parsePath: function parsePath(e) {
        return "string" == typeof e && (e = e.split(".")), e;
      },
      customizeGetParent: function customizeGetParent(e) {
        p(this).getParent = e;
      },
      isAnimationEnabled: function isAnimationEnabled() {
        if (!r.node) {
          if (null != this.option.animation) return !!this.option.animation;
          if (this.parentModel) return this.parentModel.isAnimationEnabled();
        }
      }
    }, s(g), l(g), f(g, u), f(g, c), f(g, h), f(g, d);
    var y = g;
    e.exports = y;
  }, function (e, t) {
    var n = e.exports = {
      version: "2.6.11"
    };
    "number" == typeof __e && (__e = n);
  }, function (e, t, n) {
    e.exports = !n(11)(function () {
      return 7 != Object.defineProperty({}, "a", {
        get: function get() {
          return 7;
        }
      }).a;
    });
  }, function (e, t, n) {
    var i = n(12),
        r = n(240),
        o = n(63),
        a = Object.defineProperty;
    t.f = n(24) ? Object.defineProperty : function (e, t, n) {
      if (i(e), t = o(t, !0), i(n), r) try {
        return a(e, t, n);
      } catch (e) {}
      if ("get" in n || "set" in n) throw TypeError("Accessors not supported!");
      return "value" in n && (e[t] = n.value), e;
    };
  }, function (e, t, n) {
    var i = n(1),
        r = n(22),
        o = n(121),
        a = n(60),
        s = a.enableClassManagement,
        l = a.parseClassType,
        u = n(8).makeInner,
        c = n(14),
        h = n(673),
        d = u(),
        f = r.extend({
      type: "component",
      id: "",
      name: "",
      mainType: "",
      subType: "",
      componentIndex: 0,
      defaultOption: null,
      ecModel: null,
      dependentModels: [],
      uid: null,
      layoutMode: null,
      $constructor: function $constructor(e, t, n, i) {
        r.call(this, e, t, n, i), this.uid = o.getUID("ec_cpt_model");
      },
      init: function init(e, t, n, i) {
        this.mergeDefaultAndTheme(e, n);
      },
      mergeDefaultAndTheme: function mergeDefaultAndTheme(e, t) {
        var n = this.layoutMode,
            r = n ? c.getLayoutParams(e) : {},
            o = t.getTheme();
        i.merge(e, o.get(this.mainType)), i.merge(e, this.getDefaultOption()), n && c.mergeLayoutParam(e, r, n);
      },
      mergeOption: function mergeOption(e, t) {
        i.merge(this.option, e, !0);
        var n = this.layoutMode;
        n && c.mergeLayoutParam(this.option, e, n);
      },
      optionUpdated: function optionUpdated(e, t) {},
      getDefaultOption: function getDefaultOption() {
        var e = d(this);

        if (!e.defaultOption) {
          for (var t = [], n = this.constructor; n;) {
            var r = n.prototype.defaultOption;
            r && t.push(r), n = n.superClass;
          }

          for (var o = {}, a = t.length - 1; a >= 0; a--) {
            o = i.merge(o, t[a], !0);
          }

          e.defaultOption = o;
        }

        return e.defaultOption;
      },
      getReferringComponents: function getReferringComponents(e) {
        return this.ecModel.queryComponents({
          mainType: e,
          index: this.get(e + "Index", !0),
          id: this.get(e + "Id", !0)
        });
      }
    });
    s(f, {
      registerWhenExtend: !0
    }), o.enableSubTypeDefaulter(f), o.enableTopologicalTravel(f, function (e) {
      var t = [];
      i.each(f.getClassesByMainType(e), function (e) {
        t = t.concat(e.prototype.dependencies || []);
      }), t = i.map(t, function (e) {
        return l(e).main;
      }), "dataset" !== e && i.indexOf(t, "dataset") <= 0 && t.unshift("dataset");
      return t;
    }), i.mixin(f, h);
    var p = f;
    e.exports = p;
  }, function (e, t, n) {
    n(9).__DEV__;
    var i = n(1),
        r = n(21),
        o = n(15),
        a = o.formatTime,
        s = o.encodeHTML,
        l = o.addCommas,
        u = o.getTooltipMarker,
        c = n(8),
        h = n(26),
        d = n(306),
        f = n(210),
        p = n(14),
        g = p.getLayoutParams,
        v = p.mergeLayoutParam,
        m = n(211).createTask,
        y = n(61),
        x = y.prepareSource,
        _ = y.getSource,
        b = n(86).retrieveRawValue,
        w = c.makeInner(),
        S = h.extend({
      type: "series.__base__",
      seriesIndex: 0,
      coordinateSystem: null,
      defaultOption: null,
      legendVisualProvider: null,
      visualColorAccessPath: "itemStyle.color",
      visualBorderColorAccessPath: "itemStyle.borderColor",
      layoutMode: null,
      init: function init(e, t, n, i) {
        this.seriesIndex = this.componentIndex, this.dataTask = m({
          count: C,
          reset: k
        }), this.dataTask.context = {
          model: this
        }, this.mergeDefaultAndTheme(e, n), x(this);
        var r = this.getInitialData(e, n);
        E(r, this), this.dataTask.context.data = r, w(this).dataBeforeProcessed = r, T(this);
      },
      mergeDefaultAndTheme: function mergeDefaultAndTheme(e, t) {
        var n = this.layoutMode,
            r = n ? g(e) : {},
            o = this.subType;
        h.hasClass(o) && (o += "Series"), i.merge(e, t.getTheme().get(this.subType)), i.merge(e, this.getDefaultOption()), c.defaultEmphasis(e, "label", ["show"]), this.fillDataTextStyle(e.data), n && v(e, r, n);
      },
      mergeOption: function mergeOption(e, t) {
        e = i.merge(this.option, e, !0), this.fillDataTextStyle(e.data);
        var n = this.layoutMode;
        n && v(this.option, e, n), x(this);
        var r = this.getInitialData(e, t);
        E(r, this), this.dataTask.dirty(), this.dataTask.context.data = r, w(this).dataBeforeProcessed = r, T(this);
      },
      fillDataTextStyle: function fillDataTextStyle(e) {
        if (e && !i.isTypedArray(e)) for (var t = ["show"], n = 0; n < e.length; n++) {
          e[n] && e[n].label && c.defaultEmphasis(e[n], "label", t);
        }
      },
      getInitialData: function getInitialData() {},
      appendData: function appendData(e) {
        this.getRawData().appendData(e.data);
      },
      getData: function getData(e) {
        var t = I(this);

        if (t) {
          var n = t.context.data;
          return null == e ? n : n.getLinkedData(e);
        }

        return w(this).data;
      },
      setData: function setData(e) {
        var t = I(this);

        if (t) {
          var n = t.context;
          n.data !== e && t.modifyOutputEnd && t.setOutputEnd(e.count()), n.outputData = e, t !== this.dataTask && (n.data = e);
        }

        w(this).data = e;
      },
      getSource: function getSource() {
        return _(this);
      },
      getRawData: function getRawData() {
        return w(this).dataBeforeProcessed;
      },
      getBaseAxis: function getBaseAxis() {
        var e = this.coordinateSystem;
        return e && e.getBaseAxis && e.getBaseAxis();
      },
      formatTooltip: function formatTooltip(e, t, n, r) {
        var o = this,
            h = "html" === (r = r || "html") ? "<br/>" : "\n",
            d = "richText" === r,
            f = {},
            p = 0;

        function g(e) {
          return {
            renderMode: r,
            content: s(l(e)),
            style: f
          };
        }

        var v = this.getData(),
            m = v.mapDimension("defaultedTooltip", !0),
            y = m.length,
            x = this.getRawValue(e),
            _ = i.isArray(x),
            w = v.getItemVisual(e, "color");

        i.isObject(w) && w.colorStops && (w = (w.colorStops[0] || {}).color), w = w || "transparent";
        var S = (y > 1 || _ && !y ? function (n) {
          var c = i.reduce(n, function (e, t, n) {
            var i = v.getDimensionInfo(n);
            return e | (i && !1 !== i.tooltip && null != i.displayName);
          }, 0),
              h = [];

          function g(e, n) {
            var i = v.getDimensionInfo(n);

            if (i && !1 !== i.otherDims.tooltip) {
              var g = i.type,
                  m = "sub" + o.seriesIndex + "at" + p,
                  y = u({
                color: w,
                type: "subItem",
                renderMode: r,
                markerId: m
              }),
                  x = "string" == typeof y ? y : y.content,
                  _ = (c ? x + s(i.displayName || "-") + ": " : "") + s("ordinal" === g ? e + "" : "time" === g ? t ? "" : a("yyyy/MM/dd hh:mm:ss", e) : l(e));

              _ && h.push(_), d && (f[m] = w, ++p);
            }
          }

          m.length ? i.each(m, function (t) {
            g(b(v, e, t), t);
          }) : i.each(n, g);
          var y = c ? d ? "\n" : "<br/>" : "",
              x = y + h.join(y || ", ");
          return {
            renderMode: r,
            content: x,
            style: f
          };
        }(x) : g(y ? b(v, e, m[0]) : _ ? x[0] : x)).content,
            T = o.seriesIndex + "at" + p,
            C = u({
          color: w,
          type: "item",
          renderMode: r,
          markerId: T
        });
        f[T] = w, ++p;
        var k = v.getName(e),
            M = this.name;
        c.isNameSpecified(this) || (M = ""), M = M ? s(M) + (t ? ": " : h) : "";
        var E = "string" == typeof C ? C : C.content;
        return {
          html: t ? E + M + S : M + E + (k ? s(k) + ": " + S : S),
          markers: f
        };
      },
      isAnimationEnabled: function isAnimationEnabled() {
        if (r.node) return !1;
        var e = this.getShallow("animation");
        return e && this.getData().count() > this.getShallow("animationThreshold") && (e = !1), e;
      },
      restoreData: function restoreData() {
        this.dataTask.dirty();
      },
      getColorFromPalette: function getColorFromPalette(e, t, n) {
        var i = this.ecModel,
            r = d.getColorFromPalette.call(this, e, t, n);
        return r || (r = i.getColorFromPalette(e, t, n)), r;
      },
      coordDimToDataDim: function coordDimToDataDim(e) {
        return this.getRawData().mapDimension(e, !0);
      },
      getProgressive: function getProgressive() {
        return this.get("progressive");
      },
      getProgressiveThreshold: function getProgressiveThreshold() {
        return this.get("progressiveThreshold");
      },
      getAxisTooltipData: null,
      getTooltipPosition: null,
      pipeTask: null,
      preventIncremental: null,
      pipelineContext: null
    });

    function T(e) {
      var t = e.name;
      c.isNameSpecified(e) || (e.name = function (e) {
        var t = e.getRawData(),
            n = t.mapDimension("seriesName", !0),
            r = [];
        return i.each(n, function (e) {
          var n = t.getDimensionInfo(e);
          n.displayName && r.push(n.displayName);
        }), r.join(" ");
      }(e) || t);
    }

    function C(e) {
      return e.model.getRawData().count();
    }

    function k(e) {
      var t = e.model;
      return t.setData(t.getRawData().cloneShallow()), M;
    }

    function M(e, t) {
      t.outputData && e.end > t.outputData.count() && t.model.getRawData().cloneShallow(t.outputData);
    }

    function E(e, t) {
      i.each(e.CHANGABLE_METHODS, function (n) {
        e.wrapMethod(n, i.curry(A, t));
      });
    }

    function A(e) {
      var t = I(e);
      t && t.setOutputEnd(this.count());
    }

    function I(e) {
      var t = (e.ecModel || {}).scheduler,
          n = t && t.getPipeline(e.uid);

      if (n) {
        var i = n.currentTask;

        if (i) {
          var r = i.agentStubMap;
          r && (i = r.get(e.uid));
        }

        return i;
      }
    }

    i.mixin(S, f), i.mixin(S, d);
    var P = S;
    e.exports = P;
  }, function (e, t, n) {
    var i = n(560);

    e.exports = function (e, t) {
      if (null == e) return {};
      var n,
          r,
          o = i(e, t);

      if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(e);

        for (r = 0; r < a.length; r++) {
          n = a[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
        }
      }

      return o;
    };
  }, function (e, t, n) {
    e.exports = n(271);
  }, function (e, t, n) {
    var i = n(58);

    e.exports = function (e) {
      return Object(i(e));
    };
  }, function (e, t) {
    var n = "undefined" == typeof Float32Array ? Array : Float32Array;

    function i() {
      var e = new n(6);
      return r(e), e;
    }

    function r(e) {
      return e[0] = 1, e[1] = 0, e[2] = 0, e[3] = 1, e[4] = 0, e[5] = 0, e;
    }

    function o(e, t) {
      return e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e[4] = t[4], e[5] = t[5], e;
    }

    t.create = i, t.identity = r, t.copy = o, t.mul = function (e, t, n) {
      var i = t[0] * n[0] + t[2] * n[1],
          r = t[1] * n[0] + t[3] * n[1],
          o = t[0] * n[2] + t[2] * n[3],
          a = t[1] * n[2] + t[3] * n[3],
          s = t[0] * n[4] + t[2] * n[5] + t[4],
          l = t[1] * n[4] + t[3] * n[5] + t[5];
      return e[0] = i, e[1] = r, e[2] = o, e[3] = a, e[4] = s, e[5] = l, e;
    }, t.translate = function (e, t, n) {
      return e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e[4] = t[4] + n[0], e[5] = t[5] + n[1], e;
    }, t.rotate = function (e, t, n) {
      var i = t[0],
          r = t[2],
          o = t[4],
          a = t[1],
          s = t[3],
          l = t[5],
          u = Math.sin(n),
          c = Math.cos(n);
      return e[0] = i * c + a * u, e[1] = -i * u + a * c, e[2] = r * c + s * u, e[3] = -r * u + c * s, e[4] = c * o + u * l, e[5] = c * l - u * o, e;
    }, t.scale = function (e, t, n) {
      var i = n[0],
          r = n[1];
      return e[0] = t[0] * i, e[1] = t[1] * r, e[2] = t[2] * i, e[3] = t[3] * r, e[4] = t[4] * i, e[5] = t[5] * r, e;
    }, t.invert = function (e, t) {
      var n = t[0],
          i = t[2],
          r = t[4],
          o = t[1],
          a = t[3],
          s = t[5],
          l = n * a - o * i;
      return l ? (l = 1 / l, e[0] = a * l, e[1] = -o * l, e[2] = -i * l, e[3] = n * l, e[4] = (i * s - a * r) * l, e[5] = (o * r - n * s) * l, e) : null;
    }, t.clone = function (e) {
      var t = i();
      return o(t, e), t;
    };
  }, function (e, t) {
    function n(e, t) {
      for (var n = 0; n < t.length; n++) {
        var i = t[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
      }
    }

    e.exports = function (e, t, i) {
      return t && n(e.prototype, t), i && n(e, i), e;
    };
  }, function (e, t, n) {
    var i = n(10),
        r = n(37),
        o = n(36),
        a = n(74)("src"),
        s = n(379),
        l = ("" + s).split("toString");
    n(23).inspectSource = function (e) {
      return s.call(e);
    }, (e.exports = function (e, t, n, s) {
      var u = "function" == typeof n;
      u && (o(n, "name") || r(n, "name", t)), e[t] !== n && (u && (o(n, a) || r(n, a, e[t] ? "" + e[t] : l.join(String(t)))), e === i ? e[t] = n : s ? e[t] ? e[t] = n : r(e, t, n) : (delete e[t], r(e, t, n)));
    })(Function.prototype, "toString", function () {
      return "function" == typeof this && this[a] || s.call(this);
    });
  }, function (e, t, n) {
    var i = n(3),
        r = n(11),
        o = n(58),
        a = /"/g,
        s = function s(e, t, n, i) {
      var r = String(o(e)),
          s = "<" + t;
      return "" !== n && (s += " " + n + '="' + String(i).replace(a, "&quot;") + '"'), s + ">" + r + "</" + t + ">";
    };

    e.exports = function (e, t) {
      var n = {};
      n[e] = t(s), i(i.P + i.F * r(function () {
        var t = ""[e]('"');
        return t !== t.toLowerCase() || t.split('"').length > 3;
      }), "String", n);
    };
  }, function (e, t, n) {
    var i = n(17),
        r = n(205),
        o = n(1),
        a = o.getContext,
        s = o.extend,
        l = o.retrieve2,
        u = o.retrieve3,
        c = o.trim,
        h = {},
        d = 0,
        f = /\{([a-zA-Z0-9_]+)\|([^}]*)\}/g,
        p = {};

    function g(e, t) {
      var n = e + ":" + (t = t || "12px sans-serif");
      if (h[n]) return h[n];

      for (var i = (e + "").split("\n"), r = 0, o = 0, a = i.length; o < a; o++) {
        r = Math.max(T(i[o], t).width, r);
      }

      return d > 5e3 && (d = 0, h = {}), d++, h[n] = r, r;
    }

    function v(e, t, n) {
      return "right" === n ? e -= t : "center" === n && (e -= t / 2), e;
    }

    function m(e, t, n) {
      return "middle" === n ? e -= t / 2 : "bottom" === n && (e -= t), e;
    }

    function y(e, t, n) {
      var i = t.textPosition,
          r = t.textDistance,
          o = n.x,
          a = n.y;
      r = r || 0;
      var s = n.height,
          l = n.width,
          u = s / 2,
          c = "left",
          h = "top";

      switch (i) {
        case "left":
          o -= r, a += u, c = "right", h = "middle";
          break;

        case "right":
          o += r + l, a += u, h = "middle";
          break;

        case "top":
          o += l / 2, a -= r, c = "center", h = "bottom";
          break;

        case "bottom":
          o += l / 2, a += s + r, c = "center";
          break;

        case "inside":
          o += l / 2, a += u, c = "center", h = "middle";
          break;

        case "insideLeft":
          o += r, a += u, h = "middle";
          break;

        case "insideRight":
          o += l - r, a += u, c = "right", h = "middle";
          break;

        case "insideTop":
          o += l / 2, a += r, c = "center";
          break;

        case "insideBottom":
          o += l / 2, a += s - r, c = "center", h = "bottom";
          break;

        case "insideTopLeft":
          o += r, a += r;
          break;

        case "insideTopRight":
          o += l - r, a += r, c = "right";
          break;

        case "insideBottomLeft":
          o += r, a += s - r, h = "bottom";
          break;

        case "insideBottomRight":
          o += l - r, a += s - r, c = "right", h = "bottom";
      }

      return (e = e || {}).x = o, e.y = a, e.textAlign = c, e.textVerticalAlign = h, e;
    }

    function x(e, t, n, i, r) {
      if (!t) return "";
      var o = (e + "").split("\n");
      r = _(t, n, i, r);

      for (var a = 0, s = o.length; a < s; a++) {
        o[a] = b(o[a], r);
      }

      return o.join("\n");
    }

    function _(e, t, n, i) {
      (i = s({}, i)).font = t;
      n = l(n, "...");
      i.maxIterations = l(i.maxIterations, 2);
      var r = i.minChar = l(i.minChar, 0);
      i.cnCharWidth = g("国", t);
      var o = i.ascCharWidth = g("a", t);
      i.placeholder = l(i.placeholder, "");

      for (var a = e = Math.max(0, e - 1), u = 0; u < r && a >= o; u++) {
        a -= o;
      }

      var c = g(n, t);
      return c > a && (n = "", c = 0), a = e - c, i.ellipsis = n, i.ellipsisWidth = c, i.contentWidth = a, i.containerWidth = e, i;
    }

    function b(e, t) {
      var n = t.containerWidth,
          i = t.font,
          r = t.contentWidth;
      if (!n) return "";
      var o = g(e, i);
      if (o <= n) return e;

      for (var a = 0;; a++) {
        if (o <= r || a >= t.maxIterations) {
          e += t.ellipsis;
          break;
        }

        var s = 0 === a ? w(e, r, t.ascCharWidth, t.cnCharWidth) : o > 0 ? Math.floor(e.length * r / o) : 0;
        o = g(e = e.substr(0, s), i);
      }

      return "" === e && (e = t.placeholder), e;
    }

    function w(e, t, n, i) {
      for (var r = 0, o = 0, a = e.length; o < a && r < t; o++) {
        var s = e.charCodeAt(o);
        r += 0 <= s && s <= 127 ? n : i;
      }

      return o;
    }

    function S(e) {
      return g("国", e);
    }

    function T(e, t) {
      return p.measureText(e, t);
    }

    function C(e, t, n, i, r) {
      null != e && (e += "");
      var o = l(i, S(t)),
          a = e ? e.split("\n") : [],
          s = a.length * o,
          u = s,
          c = !0;

      if (n && (u += n[0] + n[2]), e && r) {
        c = !1;
        var h = r.outerHeight,
            d = r.outerWidth;
        if (null != h && u > h) e = "", a = [];else if (null != d) for (var f = _(d - (n ? n[1] + n[3] : 0), t, r.ellipsis, {
          minChar: r.minChar,
          placeholder: r.placeholder
        }), p = 0, g = a.length; p < g; p++) {
          a[p] = b(a[p], f);
        }
      }

      return {
        lines: a,
        height: s,
        outerHeight: u,
        lineHeight: o,
        canCacheByTextString: c
      };
    }

    function k(e, t) {
      var n = {
        lines: [],
        width: 0,
        height: 0
      };
      if (null != e && (e += ""), !e) return n;

      for (var i, o = f.lastIndex = 0; null != (i = f.exec(e));) {
        var a = i.index;
        a > o && M(n, e.substring(o, a)), M(n, i[2], i[1]), o = f.lastIndex;
      }

      o < e.length && M(n, e.substring(o, e.length));
      var s = n.lines,
          c = 0,
          h = 0,
          d = [],
          p = t.textPadding,
          v = t.truncate,
          m = v && v.outerWidth,
          y = v && v.outerHeight;
      p && (null != m && (m -= p[1] + p[3]), null != y && (y -= p[0] + p[2]));

      for (var _ = 0; _ < s.length; _++) {
        for (var b = s[_], w = 0, T = 0, C = 0; C < b.tokens.length; C++) {
          var k = (R = b.tokens[C]).styleName && t.rich[R.styleName] || {},
              E = R.textPadding = k.textPadding,
              A = R.font = k.font || t.font,
              I = R.textHeight = l(k.textHeight, S(A));
          if (E && (I += E[0] + E[2]), R.height = I, R.lineHeight = u(k.textLineHeight, t.textLineHeight, I), R.textAlign = k && k.textAlign || t.textAlign, R.textVerticalAlign = k && k.textVerticalAlign || "middle", null != y && c + R.lineHeight > y) return {
            lines: [],
            width: 0,
            height: 0
          };
          R.textWidth = g(R.text, A);
          var P = k.textWidth,
              O = null == P || "auto" === P;
          if ("string" == typeof P && "%" === P.charAt(P.length - 1)) R.percentWidth = P, d.push(R), P = 0;else {
            if (O) {
              P = R.textWidth;
              var L = k.textBackgroundColor,
                  D = L && L.image;
              D && (D = r.findExistImage(D), r.isImageReady(D) && (P = Math.max(P, D.width * I / D.height)));
            }

            var N = E ? E[1] + E[3] : 0;
            P += N;
            var j = null != m ? m - T : null;
            null != j && j < P && (!O || j < N ? (R.text = "", R.textWidth = P = 0) : (R.text = x(R.text, j - N, A, v.ellipsis, {
              minChar: v.minChar
            }), R.textWidth = g(R.text, A), P = R.textWidth + N));
          }
          T += R.width = P, k && (w = Math.max(w, R.lineHeight));
        }

        b.width = T, b.lineHeight = w, c += w, h = Math.max(h, T);
      }

      n.outerWidth = n.width = l(t.textWidth, h), n.outerHeight = n.height = l(t.textHeight, c), p && (n.outerWidth += p[1] + p[3], n.outerHeight += p[0] + p[2]);

      for (_ = 0; _ < d.length; _++) {
        var R,
            F = (R = d[_]).percentWidth;
        R.width = parseInt(F, 10) / 100 * h;
      }

      return n;
    }

    function M(e, t, n) {
      for (var i = "" === t, r = t.split("\n"), o = e.lines, a = 0; a < r.length; a++) {
        var s = r[a],
            l = {
          styleName: n,
          text: s,
          isLineHolder: !s && !i
        };
        if (a) o.push({
          tokens: [l]
        });else {
          var u = (o[o.length - 1] || (o[0] = {
            tokens: []
          })).tokens,
              c = u.length;
          1 === c && u[0].isLineHolder ? u[0] = l : (s || !c || i) && u.push(l);
        }
      }
    }

    p.measureText = function (e, t) {
      var n = a();
      return n.font = t || "12px sans-serif", n.measureText(e);
    }, t.DEFAULT_FONT = "12px sans-serif", t.$override = function (e, t) {
      p[e] = t;
    }, t.getWidth = g, t.getBoundingRect = function (e, t, n, r, o, a, s, l) {
      return s ? function (e, t, n, r, o, a, s, l) {
        var u = k(e, {
          rich: s,
          truncate: l,
          font: t,
          textAlign: n,
          textPadding: o,
          textLineHeight: a
        }),
            c = u.outerWidth,
            h = u.outerHeight,
            d = v(0, c, n),
            f = m(0, h, r);
        return new i(d, f, c, h);
      }(e, t, n, r, o, a, s, l) : function (e, t, n, r, o, a, s) {
        var l = C(e, t, o, a, s),
            u = g(e, t);
        o && (u += o[1] + o[3]);
        var c = l.outerHeight,
            h = v(0, u, n),
            d = m(0, c, r),
            f = new i(h, d, u, c);
        return f.lineHeight = l.lineHeight, f;
      }(e, t, n, r, o, a, l);
    }, t.adjustTextX = v, t.adjustTextY = m, t.calculateTextPosition = y, t.adjustTextPositionOnRect = function (e, t, n) {
      return y({}, {
        textPosition: e,
        textDistance: n
      }, t);
    }, t.truncateText = x, t.getLineHeight = S, t.measureText = T, t.parsePlainText = C, t.parseRichText = k, t.makeFont = function (e) {
      var t = (e.fontSize || e.fontFamily) && [e.fontStyle, e.fontWeight, (e.fontSize || 12) + "px", e.fontFamily || "sans-serif"].join(" ");
      return t && c(t) || e.textFont || e.font;
    };
  }, function (e, t) {
    var n = {}.hasOwnProperty;

    e.exports = function (e, t) {
      return n.call(e, t);
    };
  }, function (e, t, n) {
    var i = n(25),
        r = n(73);
    e.exports = n(24) ? function (e, t, n) {
      return i.f(e, t, r(1, n));
    } : function (e, t, n) {
      return e[t] = n, e;
    };
  }, function (e, t, n) {
    var i = n(111),
        r = n(58);

    e.exports = function (e) {
      return i(r(e));
    };
  }, function (e, t, n) {
    n(9).__DEV__;
    var i = n(1),
        r = n(22),
        o = n(87),
        a = n(122),
        s = n(86),
        l = s.defaultDimValueGetters,
        u = s.DefaultDataProvider,
        c = n(124).summarizeDimensions,
        h = n(311),
        d = i.isObject,
        f = {
      float: "undefined" == typeof Float64Array ? Array : Float64Array,
      int: "undefined" == typeof Int32Array ? Array : Int32Array,
      ordinal: Array,
      number: Array,
      time: Array
    },
        p = "undefined" == typeof Uint32Array ? Array : Uint32Array,
        g = "undefined" == typeof Int32Array ? Array : Int32Array,
        v = "undefined" == typeof Uint16Array ? Array : Uint16Array;

    function m(e) {
      return e._rawCount > 65535 ? p : v;
    }

    var y = ["hasItemOption", "_nameList", "_idList", "_invertedIndicesMap", "_rawData", "_chunkSize", "_chunkCount", "_dimValueGetter", "_count", "_rawCount", "_nameDimIdx", "_idDimIdx"],
        x = ["_extent", "_approximateExtent", "_rawExtent"];

    function _(e, t) {
      i.each(y.concat(t.__wrappedMethods || []), function (n) {
        t.hasOwnProperty(n) && (e[n] = t[n]);
      }), e.__wrappedMethods = t.__wrappedMethods, i.each(x, function (n) {
        e[n] = i.clone(t[n]);
      }), e._calculationInfo = i.extend(t._calculationInfo);
    }

    var b = function b(e, t) {
      e = e || ["x", "y"];

      for (var n = {}, r = [], o = {}, a = 0; a < e.length; a++) {
        var s = e[a];
        i.isString(s) ? s = new h({
          name: s
        }) : s instanceof h || (s = new h(s));
        var l = s.name;
        s.type = s.type || "float", s.coordDim || (s.coordDim = l, s.coordDimIndex = 0), s.otherDims = s.otherDims || {}, r.push(l), n[l] = s, s.index = a, s.createInvertedIndices && (o[l] = []);
      }

      this.dimensions = r, this._dimensionInfos = n, this.hostModel = t, this.dataType, this._indices = null, this._count = 0, this._rawCount = 0, this._storage = {}, this._nameList = [], this._idList = [], this._optionModels = [], this._visual = {}, this._layout = {}, this._itemVisuals = [], this.hasItemVisual = {}, this._itemLayouts = [], this._graphicEls = [], this._chunkSize = 1e5, this._chunkCount = 0, this._rawData, this._rawExtent = {}, this._extent = {}, this._approximateExtent = {}, this._dimensionsSummary = c(this), this._invertedIndicesMap = o, this._calculationInfo = {}, this.userOutput = this._dimensionsSummary.userOutput;
    },
        w = b.prototype;

    function S(e, t, n, i, r) {
      var o = f[t.type],
          a = i - 1,
          s = t.name,
          l = e[s][a];

      if (l && l.length < n) {
        for (var u = new o(Math.min(r - a * n, n)), c = 0; c < l.length; c++) {
          u[c] = l[c];
        }

        e[s][a] = u;
      }

      for (var h = i * n; h < r; h += n) {
        e[s].push(new o(Math.min(r - h, n)));
      }
    }

    function T(e) {
      var t = e._invertedIndicesMap;
      i.each(t, function (n, i) {
        var r = e._dimensionInfos[i].ordinalMeta;

        if (r) {
          n = t[i] = new g(r.categories.length);

          for (var o = 0; o < n.length; o++) {
            n[o] = -1;
          }

          for (o = 0; o < e._count; o++) {
            n[e.get(i, o)] = o;
          }
        }
      });
    }

    function C(e, t, n) {
      var i;

      if (null != t) {
        var r = e._chunkSize,
            o = Math.floor(n / r),
            a = n % r,
            s = e.dimensions[t],
            l = e._storage[s][o];

        if (l) {
          i = l[a];
          var u = e._dimensionInfos[s].ordinalMeta;
          u && u.categories.length && (i = u.categories[i]);
        }
      }

      return i;
    }

    function k(e) {
      return e;
    }

    function M(e) {
      return e < this._count && e >= 0 ? this._indices[e] : -1;
    }

    function E(e, t) {
      var n = e._idList[t];
      return null == n && (n = C(e, e._idDimIdx, t)), null == n && (n = "e\0\0" + t), n;
    }

    function A(e) {
      return i.isArray(e) || (e = [e]), e;
    }

    function I(e, t) {
      var n = e.dimensions,
          r = new b(i.map(n, e.getDimensionInfo, e), e.hostModel);

      _(r, e);

      for (var o = r._storage = {}, a = e._storage, s = 0; s < n.length; s++) {
        var l = n[s];
        a[l] && (i.indexOf(t, l) >= 0 ? (o[l] = P(a[l]), r._rawExtent[l] = O(), r._extent[l] = null) : o[l] = a[l]);
      }

      return r;
    }

    function P(e) {
      for (var t, n, i = new Array(e.length), r = 0; r < e.length; r++) {
        i[r] = (t = e[r], n = void 0, (n = t.constructor) === Array ? t.slice() : new n(t));
      }

      return i;
    }

    function O() {
      return [1 / 0, -1 / 0];
    }

    w.type = "list", w.hasItemOption = !0, w.getDimension = function (e) {
      return "number" != typeof e && (isNaN(e) || this._dimensionInfos.hasOwnProperty(e)) || (e = this.dimensions[e]), e;
    }, w.getDimensionInfo = function (e) {
      return this._dimensionInfos[this.getDimension(e)];
    }, w.getDimensionsOnCoord = function () {
      return this._dimensionsSummary.dataDimsOnCoord.slice();
    }, w.mapDimension = function (e, t) {
      var n = this._dimensionsSummary;
      if (null == t) return n.encodeFirstDimNotExtra[e];
      var i = n.encode[e];
      return !0 === t ? (i || []).slice() : i && i[t];
    }, w.initData = function (e, t, n) {
      (a.isInstance(e) || i.isArrayLike(e)) && (e = new u(e, this.dimensions.length)), this._rawData = e, this._storage = {}, this._indices = null, this._nameList = t || [], this._idList = [], this._nameRepeatCount = {}, n || (this.hasItemOption = !1), this.defaultDimValueGetter = l[this._rawData.getSource().sourceFormat], this._dimValueGetter = n = n || this.defaultDimValueGetter, this._dimValueGetterArrayRows = l.arrayRows, this._rawExtent = {}, this._initDataFromProvider(0, e.count()), e.pure && (this.hasItemOption = !1);
    }, w.getProvider = function () {
      return this._rawData;
    }, w.appendData = function (e) {
      var t = this._rawData,
          n = this.count();
      t.appendData(e);
      var i = t.count();
      t.persistent || (i += n), this._initDataFromProvider(n, i);
    }, w.appendValues = function (e, t) {
      for (var n = this._chunkSize, i = this._storage, r = this.dimensions, o = r.length, a = this._rawExtent, s = this.count(), l = s + Math.max(e.length, t ? t.length : 0), u = this._chunkCount, c = 0; c < o; c++) {
        a[m = r[c]] || (a[m] = O()), i[m] || (i[m] = []), S(i, this._dimensionInfos[m], n, u, l), this._chunkCount = i[m].length;
      }

      for (var h = new Array(o), d = s; d < l; d++) {
        for (var f = d - s, p = Math.floor(d / n), g = d % n, v = 0; v < o; v++) {
          var m = r[v],
              y = this._dimValueGetterArrayRows(e[f] || h, m, f, v);

          i[m][p][g] = y;
          var x = a[m];
          y < x[0] && (x[0] = y), y > x[1] && (x[1] = y);
        }

        t && (this._nameList[d] = t[f]);
      }

      this._rawCount = this._count = l, this._extent = {}, T(this);
    }, w._initDataFromProvider = function (e, t) {
      if (!(e >= t)) {
        for (var n, i = this._chunkSize, r = this._rawData, o = this._storage, a = this.dimensions, s = a.length, l = this._dimensionInfos, u = this._nameList, c = this._idList, h = this._rawExtent, d = this._nameRepeatCount = {}, f = this._chunkCount, p = 0; p < s; p++) {
          h[b = a[p]] || (h[b] = O());
          var g = l[b];
          0 === g.otherDims.itemName && (n = this._nameDimIdx = p), 0 === g.otherDims.itemId && (this._idDimIdx = p), o[b] || (o[b] = []), S(o, g, i, f, t), this._chunkCount = o[b].length;
        }

        for (var v = new Array(s), m = e; m < t; m++) {
          v = r.getItem(m, v);

          for (var y = Math.floor(m / i), x = m % i, _ = 0; _ < s; _++) {
            var b,
                w = o[b = a[_]][y],
                C = this._dimValueGetter(v, b, m, _);

            w[x] = C;
            var k = h[b];
            C < k[0] && (k[0] = C), C > k[1] && (k[1] = C);
          }

          if (!r.pure) {
            var M = u[m];
            if (v && null == M) if (null != v.name) u[m] = M = v.name;else if (null != n) {
              var E = a[n],
                  A = o[E][y];

              if (A) {
                M = A[x];
                var I = l[E].ordinalMeta;
                I && I.categories.length && (M = I.categories[M]);
              }
            }
            var P = null == v ? null : v.id;
            null == P && null != M && (d[M] = d[M] || 0, P = M, d[M] > 0 && (P += "__ec__" + d[M]), d[M]++), null != P && (c[m] = P);
          }
        }

        !r.persistent && r.clean && r.clean(), this._rawCount = this._count = t, this._extent = {}, T(this);
      }
    }, w.count = function () {
      return this._count;
    }, w.getIndices = function () {
      var e = this._indices;

      if (e) {
        var t = e.constructor,
            n = this._count;

        if (t === Array) {
          r = new t(n);

          for (var i = 0; i < n; i++) {
            r[i] = e[i];
          }
        } else r = new t(e.buffer, 0, n);
      } else {
        var r = new (t = m(this))(this.count());

        for (i = 0; i < r.length; i++) {
          r[i] = i;
        }
      }

      return r;
    }, w.get = function (e, t) {
      if (!(t >= 0 && t < this._count)) return NaN;
      var n = this._storage;
      if (!n[e]) return NaN;
      t = this.getRawIndex(t);
      var i = Math.floor(t / this._chunkSize),
          r = t % this._chunkSize;
      return n[e][i][r];
    }, w.getByRawIndex = function (e, t) {
      if (!(t >= 0 && t < this._rawCount)) return NaN;
      var n = this._storage[e];
      if (!n) return NaN;
      var i = Math.floor(t / this._chunkSize),
          r = t % this._chunkSize;
      return n[i][r];
    }, w._getFast = function (e, t) {
      var n = Math.floor(t / this._chunkSize),
          i = t % this._chunkSize;
      return this._storage[e][n][i];
    }, w.getValues = function (e, t) {
      var n = [];
      i.isArray(e) || (t = e, e = this.dimensions);

      for (var r = 0, o = e.length; r < o; r++) {
        n.push(this.get(e[r], t));
      }

      return n;
    }, w.hasValue = function (e) {
      for (var t = this._dimensionsSummary.dataDimsOnCoord, n = 0, i = t.length; n < i; n++) {
        if (isNaN(this.get(t[n], e))) return !1;
      }

      return !0;
    }, w.getDataExtent = function (e) {
      e = this.getDimension(e);
      var t = this._storage[e],
          n = O();
      if (!t) return n;
      var i,
          r = this.count();
      if (!this._indices) return this._rawExtent[e].slice();
      if (i = this._extent[e]) return i.slice();

      for (var o = (i = n)[0], a = i[1], s = 0; s < r; s++) {
        var l = this._getFast(e, this.getRawIndex(s));

        l < o && (o = l), l > a && (a = l);
      }

      return i = [o, a], this._extent[e] = i, i;
    }, w.getApproximateExtent = function (e) {
      return e = this.getDimension(e), this._approximateExtent[e] || this.getDataExtent(e);
    }, w.setApproximateExtent = function (e, t) {
      t = this.getDimension(t), this._approximateExtent[t] = e.slice();
    }, w.getCalculationInfo = function (e) {
      return this._calculationInfo[e];
    }, w.setCalculationInfo = function (e, t) {
      d(e) ? i.extend(this._calculationInfo, e) : this._calculationInfo[e] = t;
    }, w.getSum = function (e) {
      var t = 0;
      if (this._storage[e]) for (var n = 0, i = this.count(); n < i; n++) {
        var r = this.get(e, n);
        isNaN(r) || (t += r);
      }
      return t;
    }, w.getMedian = function (e) {
      var t = [];
      this.each(e, function (e, n) {
        isNaN(e) || t.push(e);
      });
      var n = [].concat(t).sort(function (e, t) {
        return e - t;
      }),
          i = this.count();
      return 0 === i ? 0 : i % 2 == 1 ? n[(i - 1) / 2] : (n[i / 2] + n[i / 2 - 1]) / 2;
    }, w.rawIndexOf = function (e, t) {
      var n = (e && this._invertedIndicesMap[e])[t];
      return null == n || isNaN(n) ? -1 : n;
    }, w.indexOfName = function (e) {
      for (var t = 0, n = this.count(); t < n; t++) {
        if (this.getName(t) === e) return t;
      }

      return -1;
    }, w.indexOfRawIndex = function (e) {
      if (e >= this._rawCount || e < 0) return -1;
      if (!this._indices) return e;
      var t = this._indices,
          n = t[e];
      if (null != n && n < this._count && n === e) return e;

      for (var i = 0, r = this._count - 1; i <= r;) {
        var o = (i + r) / 2 | 0;
        if (t[o] < e) i = o + 1;else {
          if (!(t[o] > e)) return o;
          r = o - 1;
        }
      }

      return -1;
    }, w.indicesOfNearest = function (e, t, n) {
      var i = [];
      if (!this._storage[e]) return i;
      null == n && (n = 1 / 0);

      for (var r = 1 / 0, o = -1, a = 0, s = 0, l = this.count(); s < l; s++) {
        var u = t - this.get(e, s),
            c = Math.abs(u);
        c <= n && ((c < r || c === r && u >= 0 && o < 0) && (r = c, o = u, a = 0), u === o && (i[a++] = s));
      }

      return i.length = a, i;
    }, w.getRawIndex = k, w.getRawDataItem = function (e) {
      if (this._rawData.persistent) return this._rawData.getItem(this.getRawIndex(e));

      for (var t = [], n = 0; n < this.dimensions.length; n++) {
        var i = this.dimensions[n];
        t.push(this.get(i, e));
      }

      return t;
    }, w.getName = function (e) {
      var t = this.getRawIndex(e);
      return this._nameList[t] || C(this, this._nameDimIdx, t) || "";
    }, w.getId = function (e) {
      return E(this, this.getRawIndex(e));
    }, w.each = function (e, t, n, r) {
      "use strict";

      if (this._count) {
        "function" == typeof e && (r = n, n = t, t = e, e = []), n = n || r || this;

        for (var o = (e = i.map(A(e), this.getDimension, this)).length, a = 0; a < this.count(); a++) {
          switch (o) {
            case 0:
              t.call(n, a);
              break;

            case 1:
              t.call(n, this.get(e[0], a), a);
              break;

            case 2:
              t.call(n, this.get(e[0], a), this.get(e[1], a), a);
              break;

            default:
              for (var s = 0, l = []; s < o; s++) {
                l[s] = this.get(e[s], a);
              }

              l[s] = a, t.apply(n, l);
          }
        }
      }
    }, w.filterSelf = function (e, t, n, r) {
      "use strict";

      if (this._count) {
        "function" == typeof e && (r = n, n = t, t = e, e = []), n = n || r || this, e = i.map(A(e), this.getDimension, this);

        for (var o = this.count(), a = new (m(this))(o), s = [], l = e.length, u = 0, c = e[0], h = 0; h < o; h++) {
          var d,
              f = this.getRawIndex(h);
          if (0 === l) d = t.call(n, h);else if (1 === l) {
            var p = this._getFast(c, f);

            d = t.call(n, p, h);
          } else {
            for (var g = 0; g < l; g++) {
              s[g] = this._getFast(c, f);
            }

            s[g] = h, d = t.apply(n, s);
          }
          d && (a[u++] = f);
        }

        return u < o && (this._indices = a), this._count = u, this._extent = {}, this.getRawIndex = this._indices ? M : k, this;
      }
    }, w.selectRange = function (e) {
      "use strict";

      if (this._count) {
        var t = [];

        for (var n in e) {
          e.hasOwnProperty(n) && t.push(n);
        }

        var i = t.length;

        if (i) {
          var r = this.count(),
              o = new (m(this))(r),
              a = 0,
              s = t[0],
              l = e[s][0],
              u = e[s][1],
              c = !1;

          if (!this._indices) {
            var h = 0;

            if (1 === i) {
              for (var d = this._storage[t[0]], f = 0; f < this._chunkCount; f++) {
                for (var p = d[f], g = Math.min(this._count - f * this._chunkSize, this._chunkSize), v = 0; v < g; v++) {
                  ((w = p[v]) >= l && w <= u || isNaN(w)) && (o[a++] = h), h++;
                }
              }

              c = !0;
            } else if (2 === i) {
              d = this._storage[s];
              var y = this._storage[t[1]],
                  x = e[t[1]][0],
                  _ = e[t[1]][1];

              for (f = 0; f < this._chunkCount; f++) {
                p = d[f];
                var b = y[f];

                for (g = Math.min(this._count - f * this._chunkSize, this._chunkSize), v = 0; v < g; v++) {
                  var w = p[v],
                      S = b[v];
                  (w >= l && w <= u || isNaN(w)) && (S >= x && S <= _ || isNaN(S)) && (o[a++] = h), h++;
                }
              }

              c = !0;
            }
          }

          if (!c) if (1 === i) for (v = 0; v < r; v++) {
            var T = this.getRawIndex(v);
            ((w = this._getFast(s, T)) >= l && w <= u || isNaN(w)) && (o[a++] = T);
          } else for (v = 0; v < r; v++) {
            var C = !0;

            for (T = this.getRawIndex(v), f = 0; f < i; f++) {
              var E = t[f];
              ((w = this._getFast(n, T)) < e[E][0] || w > e[E][1]) && (C = !1);
            }

            C && (o[a++] = this.getRawIndex(v));
          }
          return a < r && (this._indices = o), this._count = a, this._extent = {}, this.getRawIndex = this._indices ? M : k, this;
        }
      }
    }, w.mapArray = function (e, t, n, i) {
      "use strict";

      "function" == typeof e && (i = n, n = t, t = e, e = []), n = n || i || this;
      var r = [];
      return this.each(e, function () {
        r.push(t && t.apply(this, arguments));
      }, n), r;
    }, w.map = function (e, t, n, r) {
      "use strict";

      n = n || r || this;
      var o = I(this, e = i.map(A(e), this.getDimension, this));
      o._indices = this._indices, o.getRawIndex = o._indices ? M : k;

      for (var a = o._storage, s = [], l = this._chunkSize, u = e.length, c = this.count(), h = [], d = o._rawExtent, f = 0; f < c; f++) {
        for (var p = 0; p < u; p++) {
          h[p] = this.get(e[p], f);
        }

        h[u] = f;
        var g = t && t.apply(n, h);

        if (null != g) {
          "object" != typeof g && (s[0] = g, g = s);

          for (var v = this.getRawIndex(f), m = Math.floor(v / l), y = v % l, x = 0; x < g.length; x++) {
            var _ = e[x],
                b = g[x],
                w = d[_],
                S = a[_];
            S && (S[m][y] = b), b < w[0] && (w[0] = b), b > w[1] && (w[1] = b);
          }
        }
      }

      return o;
    }, w.downSample = function (e, t, n, i) {
      for (var r = I(this, [e]), o = r._storage, a = [], s = Math.floor(1 / t), l = o[e], u = this.count(), c = this._chunkSize, h = r._rawExtent[e], d = new (m(this))(u), f = 0, p = 0; p < u; p += s) {
        s > u - p && (s = u - p, a.length = s);

        for (var g = 0; g < s; g++) {
          var v = this.getRawIndex(p + g),
              y = Math.floor(v / c),
              x = v % c;
          a[g] = l[y][x];
        }

        var _ = n(a),
            b = this.getRawIndex(Math.min(p + i(a, _) || 0, u - 1)),
            w = b % c;

        l[Math.floor(b / c)][w] = _, _ < h[0] && (h[0] = _), _ > h[1] && (h[1] = _), d[f++] = b;
      }

      return r._count = f, r._indices = d, r.getRawIndex = M, r;
    }, w.getItemModel = function (e) {
      var t = this.hostModel;
      return new r(this.getRawDataItem(e), t, t && t.ecModel);
    }, w.diff = function (e) {
      var t = this;
      return new o(e ? e.getIndices() : [], this.getIndices(), function (t) {
        return E(e, t);
      }, function (e) {
        return E(t, e);
      });
    }, w.getVisual = function (e) {
      var t = this._visual;
      return t && t[e];
    }, w.setVisual = function (e, t) {
      if (d(e)) for (var n in e) {
        e.hasOwnProperty(n) && this.setVisual(n, e[n]);
      } else this._visual = this._visual || {}, this._visual[e] = t;
    }, w.setLayout = function (e, t) {
      if (d(e)) for (var n in e) {
        e.hasOwnProperty(n) && this.setLayout(n, e[n]);
      } else this._layout[e] = t;
    }, w.getLayout = function (e) {
      return this._layout[e];
    }, w.getItemLayout = function (e) {
      return this._itemLayouts[e];
    }, w.setItemLayout = function (e, t, n) {
      this._itemLayouts[e] = n ? i.extend(this._itemLayouts[e] || {}, t) : t;
    }, w.clearItemLayouts = function () {
      this._itemLayouts.length = 0;
    }, w.getItemVisual = function (e, t, n) {
      var i = this._itemVisuals[e],
          r = i && i[t];
      return null != r || n ? r : this.getVisual(t);
    }, w.setItemVisual = function (e, t, n) {
      var i = this._itemVisuals[e] || {},
          r = this.hasItemVisual;
      if (this._itemVisuals[e] = i, d(t)) for (var o in t) {
        t.hasOwnProperty(o) && (i[o] = t[o], r[o] = !0);
      } else i[t] = n, r[t] = !0;
    }, w.clearAllVisual = function () {
      this._visual = {}, this._itemVisuals = [], this.hasItemVisual = {};
    };

    var L = function L(e) {
      e.seriesIndex = this.seriesIndex, e.dataIndex = this.dataIndex, e.dataType = this.dataType;
    };

    w.setItemGraphicEl = function (e, t) {
      var n = this.hostModel;
      t && (t.dataIndex = e, t.dataType = this.dataType, t.seriesIndex = n && n.seriesIndex, "group" === t.type && t.traverse(L, t)), this._graphicEls[e] = t;
    }, w.getItemGraphicEl = function (e) {
      return this._graphicEls[e];
    }, w.eachItemGraphicEl = function (e, t) {
      i.each(this._graphicEls, function (n, i) {
        n && e && e.call(t, n, i);
      });
    }, w.cloneShallow = function (e) {
      if (!e) {
        var t = i.map(this.dimensions, this.getDimensionInfo, this);
        e = new b(t, this.hostModel);
      }

      if (e._storage = this._storage, _(e, this), this._indices) {
        var n = this._indices.constructor;
        e._indices = new n(this._indices);
      } else e._indices = null;

      return e.getRawIndex = e._indices ? M : k, e;
    }, w.wrapMethod = function (e, t) {
      var n = this[e];
      "function" == typeof n && (this.__wrappedMethods = this.__wrappedMethods || [], this.__wrappedMethods.push(e), this[e] = function () {
        var e = n.apply(this, arguments);
        return t.apply(this, [e].concat(i.slice(arguments)));
      });
    }, w.TRANSFERABLE_METHODS = ["cloneShallow", "downSample", "map"], w.CHANGABLE_METHODS = ["filterSelf", "selectRange"];
    var D = b;
    e.exports = D;
  }, function (e, t, n) {
    var i = n(1),
        r = n(5),
        o = n(17),
        a = n(35).calculateTextPosition,
        s = r.extendShape({
      type: "triangle",
      shape: {
        cx: 0,
        cy: 0,
        width: 0,
        height: 0
      },
      buildPath: function buildPath(e, t) {
        var n = t.cx,
            i = t.cy,
            r = t.width / 2,
            o = t.height / 2;
        e.moveTo(n, i - o), e.lineTo(n + r, i + o), e.lineTo(n - r, i + o), e.closePath();
      }
    }),
        l = r.extendShape({
      type: "diamond",
      shape: {
        cx: 0,
        cy: 0,
        width: 0,
        height: 0
      },
      buildPath: function buildPath(e, t) {
        var n = t.cx,
            i = t.cy,
            r = t.width / 2,
            o = t.height / 2;
        e.moveTo(n, i - o), e.lineTo(n + r, i), e.lineTo(n, i + o), e.lineTo(n - r, i), e.closePath();
      }
    }),
        u = r.extendShape({
      type: "pin",
      shape: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      },
      buildPath: function buildPath(e, t) {
        var n = t.x,
            i = t.y,
            r = t.width / 5 * 3,
            o = Math.max(r, t.height),
            a = r / 2,
            s = a * a / (o - a),
            l = i - o + a + s,
            u = Math.asin(s / a),
            c = Math.cos(u) * a,
            h = Math.sin(u),
            d = Math.cos(u),
            f = .6 * a,
            p = .7 * a;
        e.moveTo(n - c, l + s), e.arc(n, l, a, Math.PI - u, 2 * Math.PI + u), e.bezierCurveTo(n + c - h * f, l + s + d * f, n, i - p, n, i), e.bezierCurveTo(n, i - p, n - c + h * f, l + s + d * f, n - c, l + s), e.closePath();
      }
    }),
        c = r.extendShape({
      type: "arrow",
      shape: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      },
      buildPath: function buildPath(e, t) {
        var n = t.height,
            i = t.width,
            r = t.x,
            o = t.y,
            a = i / 3 * 2;
        e.moveTo(r, o), e.lineTo(r + a, o + n), e.lineTo(r, o + n / 4 * 3), e.lineTo(r - a, o + n), e.lineTo(r, o), e.closePath();
      }
    }),
        h = {
      line: r.Line,
      rect: r.Rect,
      roundRect: r.Rect,
      square: r.Rect,
      circle: r.Circle,
      diamond: l,
      pin: u,
      arrow: c,
      triangle: s
    },
        d = {
      line: function line(e, t, n, i, r) {
        r.x1 = e, r.y1 = t + i / 2, r.x2 = e + n, r.y2 = t + i / 2;
      },
      rect: function rect(e, t, n, i, r) {
        r.x = e, r.y = t, r.width = n, r.height = i;
      },
      roundRect: function roundRect(e, t, n, i, r) {
        r.x = e, r.y = t, r.width = n, r.height = i, r.r = Math.min(n, i) / 4;
      },
      square: function square(e, t, n, i, r) {
        var o = Math.min(n, i);
        r.x = e, r.y = t, r.width = o, r.height = o;
      },
      circle: function circle(e, t, n, i, r) {
        r.cx = e + n / 2, r.cy = t + i / 2, r.r = Math.min(n, i) / 2;
      },
      diamond: function diamond(e, t, n, i, r) {
        r.cx = e + n / 2, r.cy = t + i / 2, r.width = n, r.height = i;
      },
      pin: function pin(e, t, n, i, r) {
        r.x = e + n / 2, r.y = t + i / 2, r.width = n, r.height = i;
      },
      arrow: function arrow(e, t, n, i, r) {
        r.x = e + n / 2, r.y = t + i / 2, r.width = n, r.height = i;
      },
      triangle: function triangle(e, t, n, i, r) {
        r.cx = e + n / 2, r.cy = t + i / 2, r.width = n, r.height = i;
      }
    },
        f = {};
    i.each(h, function (e, t) {
      f[t] = new e();
    });
    var p = r.extendShape({
      type: "symbol",
      shape: {
        symbolType: "",
        x: 0,
        y: 0,
        width: 0,
        height: 0
      },
      calculateTextPosition: function calculateTextPosition(e, t, n) {
        var i = a(e, t, n),
            r = this.shape;
        return r && "pin" === r.symbolType && "inside" === t.textPosition && (i.y = n.y + .4 * n.height), i;
      },
      buildPath: function buildPath(e, t, n) {
        var i = t.symbolType;

        if ("none" !== i) {
          var r = f[i];
          r || (r = f[i = "rect"]), d[i](t.x, t.y, t.width, t.height, r.shape), r.buildPath(e, r.shape, n);
        }
      }
    });

    function g(e, t) {
      if ("image" !== this.type) {
        var n = this.style,
            i = this.shape;
        i && "line" === i.symbolType ? n.stroke = e : this.__isEmptyBrush ? (n.stroke = e, n.fill = t || "#fff") : (n.fill && (n.fill = e), n.stroke && (n.stroke = e)), this.dirty(!1);
      }
    }

    t.createSymbol = function (e, t, n, i, a, s, l) {
      var u,
          c = 0 === e.indexOf("empty");
      return c && (e = e.substr(5, 1).toLowerCase() + e.substr(6)), (u = 0 === e.indexOf("image://") ? r.makeImage(e.slice(8), new o(t, n, i, a), l ? "center" : "cover") : 0 === e.indexOf("path://") ? r.makePath(e.slice(7), {}, new o(t, n, i, a), l ? "center" : "cover") : new p({
        shape: {
          symbolType: e,
          x: t,
          y: n,
          width: i,
          height: a
        }
      })).__isEmptyBrush = c, u.setColor = g, u.setColor(s), u;
    };
  }, function (e, t, n) {
    "use strict";

    var i = n(11);

    e.exports = function (e, t) {
      return !!e && i(function () {
        t ? e.call(null, function () {}, 1) : e.call(null);
      });
    };
  }, function (e, t, n) {
    var i = n(1),
        r = {};

    function o() {
      this._coordinateSystems = [];
    }

    o.prototype = {
      constructor: o,
      create: function create(e, t) {
        var n = [];
        i.each(r, function (i, r) {
          var o = i.create(e, t);
          n = n.concat(o || []);
        }), this._coordinateSystems = n;
      },
      update: function update(e, t) {
        i.each(this._coordinateSystems, function (n) {
          n.update && n.update(e, t);
        });
      },
      getCoordinateSystems: function getCoordinateSystems() {
        return this._coordinateSystems.slice();
      }
    }, o.register = function (e, t) {
      r[e] = t;
    }, o.get = function (e) {
      return r[e];
    };
    var a = o;
    e.exports = a;
  }, function (e, t, n) {
    n(9).__DEV__;
    var i = n(1),
        r = n(688),
        o = n(160),
        a = n(159),
        s = n(6),
        l = n(161),
        u = l.prepareLayoutBarSeries,
        c = l.makeColumnLayout,
        h = l.retrieveColumnLayout,
        d = n(17);

    function f(e, t) {
      var n,
          r,
          o,
          a = e.type,
          l = t.getMin(),
          d = t.getMax(),
          f = e.getExtent();
      "ordinal" === a ? n = t.getCategories().length : (r = t.get("boundaryGap"), i.isArray(r) || (r = [r || 0, r || 0]), "boolean" == typeof r[0] && (r = [0, 0]), r[0] = s.parsePercent(r[0], 1), r[1] = s.parsePercent(r[1], 1), o = f[1] - f[0] || Math.abs(f[0])), "dataMin" === l ? l = f[0] : "function" == typeof l && (l = l({
        min: f[0],
        max: f[1]
      })), "dataMax" === d ? d = f[1] : "function" == typeof d && (d = d({
        min: f[0],
        max: f[1]
      }));
      var p = null != l,
          g = null != d;
      null == l && (l = "ordinal" === a ? n ? 0 : NaN : f[0] - r[0] * o), null == d && (d = "ordinal" === a ? n ? n - 1 : NaN : f[1] + r[1] * o), (null == l || !isFinite(l)) && (l = NaN), (null == d || !isFinite(d)) && (d = NaN), e.setBlank(i.eqNaN(l) || i.eqNaN(d) || "ordinal" === a && !e.getOrdinalMeta().categories.length), t.getNeedCrossZero() && (l > 0 && d > 0 && !p && (l = 0), l < 0 && d < 0 && !g && (d = 0));
      var v = t.ecModel;

      if (v && "time" === a) {
        var m,
            y = u("bar", v);

        if (i.each(y, function (e) {
          m |= e.getBaseAxis() === t.axis;
        }), m) {
          var x = c(y),
              _ = function (e, t, n, r) {
            var o = n.axis.getExtent(),
                a = o[1] - o[0],
                s = h(r, n.axis);
            if (void 0 === s) return {
              min: e,
              max: t
            };
            var l = 1 / 0;
            i.each(s, function (e) {
              l = Math.min(e.offset, l);
            });
            var u = -1 / 0;
            i.each(s, function (e) {
              u = Math.max(e.offset + e.width, u);
            }), l = Math.abs(l), u = Math.abs(u);
            var c = l + u,
                d = t - e,
                f = d / (1 - (l + u) / a) - d;
            return {
              min: e -= f * (l / c),
              max: t += f * (u / c)
            };
          }(l, d, t, x);

          l = _.min, d = _.max;
        }
      }

      return {
        extent: [l, d],
        fixMin: p,
        fixMax: g
      };
    }

    function p(e) {
      var t,
          n = e.getLabelModel().get("formatter"),
          i = "category" === e.type ? e.scale.getExtent()[0] : null;
      return "string" == typeof n ? (t = n, n = function n(_n2) {
        return _n2 = e.scale.getLabel(_n2), t.replace("{value}", null != _n2 ? _n2 : "");
      }) : "function" == typeof n ? function (t, r) {
        return null != i && (r = t - i), n(g(e, t), r);
      } : function (t) {
        return e.scale.getLabel(t);
      };
    }

    function g(e, t) {
      return "category" === e.type ? e.scale.getLabel(t) : t;
    }

    function v(e) {
      var t = e.get("interval");
      return null == t ? "auto" : t;
    }

    n(689), n(315), t.getScaleExtent = f, t.niceScaleExtent = function (e, t) {
      var n = f(e, t),
          i = n.extent,
          r = t.get("splitNumber");
      "log" === e.type && (e.base = t.get("logBase"));
      var o = e.type;
      e.setExtent(i[0], i[1]), e.niceExtent({
        splitNumber: r,
        fixMin: n.fixMin,
        fixMax: n.fixMax,
        minInterval: "interval" === o || "time" === o ? t.get("minInterval") : null,
        maxInterval: "interval" === o || "time" === o ? t.get("maxInterval") : null
      });
      var a = t.get("interval");
      null != a && e.setInterval && e.setInterval(a);
    }, t.createScaleByModel = function (e, t) {
      if (t = t || e.get("type")) switch (t) {
        case "category":
          return new r(e.getOrdinalMeta ? e.getOrdinalMeta() : e.getCategories(), [1 / 0, -1 / 0]);

        case "value":
          return new o();

        default:
          return (a.getClass(t) || o).create(e);
      }
    }, t.ifAxisCrossZero = function (e) {
      var t = e.scale.getExtent(),
          n = t[0],
          i = t[1];
      return !(n > 0 && i > 0 || n < 0 && i < 0);
    }, t.makeLabelFormatter = p, t.getAxisRawValue = g, t.estimateLabelUnionRect = function (e) {
      var t = e.model,
          n = e.scale;

      if (t.get("axisLabel.show") && !n.isBlank()) {
        var i,
            r,
            o = "category" === e.type,
            a = n.getExtent();
        r = o ? n.count() : (i = n.getTicks()).length;
        var s,
            l,
            u,
            c,
            h,
            f,
            g,
            v,
            m,
            y = e.getLabelModel(),
            x = p(e),
            _ = 1;
        r > 40 && (_ = Math.ceil(r / 40));

        for (var b = 0; b < r; b += _) {
          var w = x(i ? i[b] : a[0] + b),
              S = y.getTextRect(w),
              T = (l = S, u = y.get("rotate") || 0, c = void 0, h = void 0, f = void 0, g = void 0, v = void 0, m = void 0, void 0, c = u * Math.PI / 180, h = l.plain(), f = h.width, g = h.height, v = f * Math.cos(c) + g * Math.sin(c), m = f * Math.sin(c) + g * Math.cos(c), new d(h.x, h.y, v, m));
          s ? s.union(T) : s = T;
        }

        return s;
      }
    }, t.getOptionCategoryInterval = v, t.shouldShowAllLabels = function (e) {
      return "category" === e.type && 0 === v(e.getLabelModel());
    };
  }, function (e, t) {
    function n(e, t, n, i, r, o, a) {
      try {
        var s = e[o](a),
            l = s.value;
      } catch (e) {
        return void n(e);
      }

      s.done ? t(l) : Promise.resolve(l).then(i, r);
    }

    e.exports = function (e) {
      return function () {
        var t = this,
            i = arguments;
        return new Promise(function (r, o) {
          var a = e.apply(t, i);

          function s(e) {
            n(a, r, o, s, l, "next", e);
          }

          function l(e) {
            n(a, r, o, s, l, "throw", e);
          }

          s(void 0);
        });
      };
    };
  }, function (e, t, n) {
    var i = n(46);

    e.exports = function (e, t, n) {
      if (i(e), void 0 === t) return e;

      switch (n) {
        case 1:
          return function (n) {
            return e.call(t, n);
          };

        case 2:
          return function (n, i) {
            return e.call(t, n, i);
          };

        case 3:
          return function (n, i, r) {
            return e.call(t, n, i, r);
          };
      }

      return function () {
        return e.apply(t, arguments);
      };
    };
  }, function (e, t) {
    e.exports = function (e) {
      if ("function" != typeof e) throw TypeError(e + " is not a function!");
      return e;
    };
  }, function (e, t) {
    var n = Math.ceil,
        i = Math.floor;

    e.exports = function (e) {
      return isNaN(e = +e) ? 0 : (e > 0 ? i : n)(e);
    };
  }, function (e, t, n) {
    var i = n(112),
        r = n(73),
        o = n(38),
        a = n(63),
        s = n(36),
        l = n(240),
        u = Object.getOwnPropertyDescriptor;
    t.f = n(24) ? u : function (e, t) {
      if (e = o(e), t = a(t, !0), l) try {
        return u(e, t);
      } catch (e) {}
      if (s(e, t)) return r(!i.f.call(e, t), e[t]);
    };
  }, function (e, t, n) {
    var i = n(3),
        r = n(23),
        o = n(11);

    e.exports = function (e, t) {
      var n = (r.Object || {})[e] || Object[e],
          a = {};
      a[e] = t(n), i(i.S + i.F * o(function () {
        n(1);
      }), "Object", a);
    };
  }, function (e, t, n) {
    var i = n(45),
        r = n(111),
        o = n(30),
        a = n(19),
        s = n(256);

    e.exports = function (e, t) {
      var n = 1 == e,
          l = 2 == e,
          u = 3 == e,
          c = 4 == e,
          h = 6 == e,
          d = 5 == e || h,
          f = t || s;
      return function (t, s, p) {
        for (var g, v, m = o(t), y = r(m), x = i(s, p, 3), _ = a(y.length), b = 0, w = n ? f(t, _) : l ? f(t, 0) : void 0; _ > b; b++) {
          if ((d || b in y) && (v = x(g = y[b], b, m), e)) if (n) w[b] = v;else if (v) switch (e) {
            case 3:
              return !0;

            case 5:
              return g;

            case 6:
              return b;

            case 2:
              w.push(g);
          } else if (c) return !1;
        }

        return h ? -1 : u || c ? c : w;
      };
    };
  }, function (e, t, n) {
    var i = n(277),
        r = "object" == typeof self && self && self.Object === Object && self,
        o = i || r || Function("return this")();
    e.exports = o;
  }, function (e, t, n) {
    var i = n(83);
    t.Dispatcher = i;
    var r = n(21),
        o = n(285),
        a = o.isCanvasEl,
        s = o.transformCoordWithViewport,
        l = "undefined" != typeof window && !!window.addEventListener,
        u = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
        c = [];

    function h(e, t, n, i) {
      return n = n || {}, i || !r.canvasSupported ? d(e, t, n) : r.browser.firefox && null != t.layerX && t.layerX !== t.offsetX ? (n.zrX = t.layerX, n.zrY = t.layerY) : null != t.offsetX ? (n.zrX = t.offsetX, n.zrY = t.offsetY) : d(e, t, n), n;
    }

    function d(e, t, n) {
      if (r.domSupported && e.getBoundingClientRect) {
        var i = t.clientX,
            o = t.clientY;

        if (a(e)) {
          var l = e.getBoundingClientRect();
          return n.zrX = i - l.left, void (n.zrY = o - l.top);
        }

        if (s(c, e, i, o)) return n.zrX = c[0], void (n.zrY = c[1]);
      }

      n.zrX = n.zrY = 0;
    }

    function f(e) {
      return e || window.event;
    }

    var p = l ? function (e) {
      e.preventDefault(), e.stopPropagation(), e.cancelBubble = !0;
    } : function (e) {
      e.returnValue = !1, e.cancelBubble = !0;
    };
    t.clientToLocal = h, t.getNativeEvent = f, t.normalizeEvent = function (e, t, n) {
      if (null != (t = f(t)).zrX) return t;
      var i = t.type;

      if (i && i.indexOf("touch") >= 0) {
        var r = "touchend" !== i ? t.targetTouches[0] : t.changedTouches[0];
        r && h(e, r, t, n);
      } else h(e, t, t, n), t.zrDelta = t.wheelDelta ? t.wheelDelta / 120 : -(t.detail || 0) / 3;

      var o = t.button;
      return null == t.which && void 0 !== o && u.test(t.type) && (t.which = 1 & o ? 1 : 2 & o ? 3 : 4 & o ? 2 : 0), t;
    }, t.addEventListener = function (e, t, n, i) {
      l ? e.addEventListener(t, n, i) : e.attachEvent("on" + t, n);
    }, t.removeEventListener = function (e, t, n, i) {
      l ? e.removeEventListener(t, n, i) : e.detachEvent("on" + t, n);
    }, t.stop = p, t.isMiddleOrRightButtonOnMouseUpDown = function (e) {
      return 2 === e.which || 3 === e.which;
    }, t.notLeftMouse = function (e) {
      return e.which > 1;
    };
  }, function (e, t, n) {
    var i = n(288),
        r = {
      transparent: [0, 0, 0, 0],
      aliceblue: [240, 248, 255, 1],
      antiquewhite: [250, 235, 215, 1],
      aqua: [0, 255, 255, 1],
      aquamarine: [127, 255, 212, 1],
      azure: [240, 255, 255, 1],
      beige: [245, 245, 220, 1],
      bisque: [255, 228, 196, 1],
      black: [0, 0, 0, 1],
      blanchedalmond: [255, 235, 205, 1],
      blue: [0, 0, 255, 1],
      blueviolet: [138, 43, 226, 1],
      brown: [165, 42, 42, 1],
      burlywood: [222, 184, 135, 1],
      cadetblue: [95, 158, 160, 1],
      chartreuse: [127, 255, 0, 1],
      chocolate: [210, 105, 30, 1],
      coral: [255, 127, 80, 1],
      cornflowerblue: [100, 149, 237, 1],
      cornsilk: [255, 248, 220, 1],
      crimson: [220, 20, 60, 1],
      cyan: [0, 255, 255, 1],
      darkblue: [0, 0, 139, 1],
      darkcyan: [0, 139, 139, 1],
      darkgoldenrod: [184, 134, 11, 1],
      darkgray: [169, 169, 169, 1],
      darkgreen: [0, 100, 0, 1],
      darkgrey: [169, 169, 169, 1],
      darkkhaki: [189, 183, 107, 1],
      darkmagenta: [139, 0, 139, 1],
      darkolivegreen: [85, 107, 47, 1],
      darkorange: [255, 140, 0, 1],
      darkorchid: [153, 50, 204, 1],
      darkred: [139, 0, 0, 1],
      darksalmon: [233, 150, 122, 1],
      darkseagreen: [143, 188, 143, 1],
      darkslateblue: [72, 61, 139, 1],
      darkslategray: [47, 79, 79, 1],
      darkslategrey: [47, 79, 79, 1],
      darkturquoise: [0, 206, 209, 1],
      darkviolet: [148, 0, 211, 1],
      deeppink: [255, 20, 147, 1],
      deepskyblue: [0, 191, 255, 1],
      dimgray: [105, 105, 105, 1],
      dimgrey: [105, 105, 105, 1],
      dodgerblue: [30, 144, 255, 1],
      firebrick: [178, 34, 34, 1],
      floralwhite: [255, 250, 240, 1],
      forestgreen: [34, 139, 34, 1],
      fuchsia: [255, 0, 255, 1],
      gainsboro: [220, 220, 220, 1],
      ghostwhite: [248, 248, 255, 1],
      gold: [255, 215, 0, 1],
      goldenrod: [218, 165, 32, 1],
      gray: [128, 128, 128, 1],
      green: [0, 128, 0, 1],
      greenyellow: [173, 255, 47, 1],
      grey: [128, 128, 128, 1],
      honeydew: [240, 255, 240, 1],
      hotpink: [255, 105, 180, 1],
      indianred: [205, 92, 92, 1],
      indigo: [75, 0, 130, 1],
      ivory: [255, 255, 240, 1],
      khaki: [240, 230, 140, 1],
      lavender: [230, 230, 250, 1],
      lavenderblush: [255, 240, 245, 1],
      lawngreen: [124, 252, 0, 1],
      lemonchiffon: [255, 250, 205, 1],
      lightblue: [173, 216, 230, 1],
      lightcoral: [240, 128, 128, 1],
      lightcyan: [224, 255, 255, 1],
      lightgoldenrodyellow: [250, 250, 210, 1],
      lightgray: [211, 211, 211, 1],
      lightgreen: [144, 238, 144, 1],
      lightgrey: [211, 211, 211, 1],
      lightpink: [255, 182, 193, 1],
      lightsalmon: [255, 160, 122, 1],
      lightseagreen: [32, 178, 170, 1],
      lightskyblue: [135, 206, 250, 1],
      lightslategray: [119, 136, 153, 1],
      lightslategrey: [119, 136, 153, 1],
      lightsteelblue: [176, 196, 222, 1],
      lightyellow: [255, 255, 224, 1],
      lime: [0, 255, 0, 1],
      limegreen: [50, 205, 50, 1],
      linen: [250, 240, 230, 1],
      magenta: [255, 0, 255, 1],
      maroon: [128, 0, 0, 1],
      mediumaquamarine: [102, 205, 170, 1],
      mediumblue: [0, 0, 205, 1],
      mediumorchid: [186, 85, 211, 1],
      mediumpurple: [147, 112, 219, 1],
      mediumseagreen: [60, 179, 113, 1],
      mediumslateblue: [123, 104, 238, 1],
      mediumspringgreen: [0, 250, 154, 1],
      mediumturquoise: [72, 209, 204, 1],
      mediumvioletred: [199, 21, 133, 1],
      midnightblue: [25, 25, 112, 1],
      mintcream: [245, 255, 250, 1],
      mistyrose: [255, 228, 225, 1],
      moccasin: [255, 228, 181, 1],
      navajowhite: [255, 222, 173, 1],
      navy: [0, 0, 128, 1],
      oldlace: [253, 245, 230, 1],
      olive: [128, 128, 0, 1],
      olivedrab: [107, 142, 35, 1],
      orange: [255, 165, 0, 1],
      orangered: [255, 69, 0, 1],
      orchid: [218, 112, 214, 1],
      palegoldenrod: [238, 232, 170, 1],
      palegreen: [152, 251, 152, 1],
      paleturquoise: [175, 238, 238, 1],
      palevioletred: [219, 112, 147, 1],
      papayawhip: [255, 239, 213, 1],
      peachpuff: [255, 218, 185, 1],
      peru: [205, 133, 63, 1],
      pink: [255, 192, 203, 1],
      plum: [221, 160, 221, 1],
      powderblue: [176, 224, 230, 1],
      purple: [128, 0, 128, 1],
      red: [255, 0, 0, 1],
      rosybrown: [188, 143, 143, 1],
      royalblue: [65, 105, 225, 1],
      saddlebrown: [139, 69, 19, 1],
      salmon: [250, 128, 114, 1],
      sandybrown: [244, 164, 96, 1],
      seagreen: [46, 139, 87, 1],
      seashell: [255, 245, 238, 1],
      sienna: [160, 82, 45, 1],
      silver: [192, 192, 192, 1],
      skyblue: [135, 206, 235, 1],
      slateblue: [106, 90, 205, 1],
      slategray: [112, 128, 144, 1],
      slategrey: [112, 128, 144, 1],
      snow: [255, 250, 250, 1],
      springgreen: [0, 255, 127, 1],
      steelblue: [70, 130, 180, 1],
      tan: [210, 180, 140, 1],
      teal: [0, 128, 128, 1],
      thistle: [216, 191, 216, 1],
      tomato: [255, 99, 71, 1],
      turquoise: [64, 224, 208, 1],
      violet: [238, 130, 238, 1],
      wheat: [245, 222, 179, 1],
      white: [255, 255, 255, 1],
      whitesmoke: [245, 245, 245, 1],
      yellow: [255, 255, 0, 1],
      yellowgreen: [154, 205, 50, 1]
    };

    function o(e) {
      return (e = Math.round(e)) < 0 ? 0 : e > 255 ? 255 : e;
    }

    function a(e) {
      return e < 0 ? 0 : e > 1 ? 1 : e;
    }

    function s(e) {
      return e.length && "%" === e.charAt(e.length - 1) ? o(parseFloat(e) / 100 * 255) : o(parseInt(e, 10));
    }

    function l(e) {
      return e.length && "%" === e.charAt(e.length - 1) ? a(parseFloat(e) / 100) : a(parseFloat(e));
    }

    function u(e, t, n) {
      return n < 0 ? n += 1 : n > 1 && (n -= 1), 6 * n < 1 ? e + (t - e) * n * 6 : 2 * n < 1 ? t : 3 * n < 2 ? e + (t - e) * (2 / 3 - n) * 6 : e;
    }

    function c(e, t, n) {
      return e + (t - e) * n;
    }

    function h(e, t, n, i, r) {
      return e[0] = t, e[1] = n, e[2] = i, e[3] = r, e;
    }

    function d(e, t) {
      return e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e;
    }

    var f = new i(20),
        p = null;

    function g(e, t) {
      p && d(p, t), p = f.put(e, p || t.slice());
    }

    function v(e, t) {
      if (e) {
        t = t || [];
        var n = f.get(e);
        if (n) return d(t, n);
        var i,
            o = (e += "").replace(/ /g, "").toLowerCase();
        if (o in r) return d(t, r[o]), g(e, t), t;
        if ("#" === o.charAt(0)) return 4 === o.length ? (i = parseInt(o.substr(1), 16)) >= 0 && i <= 4095 ? (h(t, (3840 & i) >> 4 | (3840 & i) >> 8, 240 & i | (240 & i) >> 4, 15 & i | (15 & i) << 4, 1), g(e, t), t) : void h(t, 0, 0, 0, 1) : 7 === o.length ? (i = parseInt(o.substr(1), 16)) >= 0 && i <= 16777215 ? (h(t, (16711680 & i) >> 16, (65280 & i) >> 8, 255 & i, 1), g(e, t), t) : void h(t, 0, 0, 0, 1) : void 0;
        var a = o.indexOf("("),
            u = o.indexOf(")");

        if (-1 !== a && u + 1 === o.length) {
          var c = o.substr(0, a),
              p = o.substr(a + 1, u - (a + 1)).split(","),
              v = 1;

          switch (c) {
            case "rgba":
              if (4 !== p.length) return void h(t, 0, 0, 0, 1);
              v = l(p.pop());

            case "rgb":
              return 3 !== p.length ? void h(t, 0, 0, 0, 1) : (h(t, s(p[0]), s(p[1]), s(p[2]), v), g(e, t), t);

            case "hsla":
              return 4 !== p.length ? void h(t, 0, 0, 0, 1) : (p[3] = l(p[3]), m(p, t), g(e, t), t);

            case "hsl":
              return 3 !== p.length ? void h(t, 0, 0, 0, 1) : (m(p, t), g(e, t), t);

            default:
              return;
          }
        }

        h(t, 0, 0, 0, 1);
      }
    }

    function m(e, t) {
      var n = (parseFloat(e[0]) % 360 + 360) % 360 / 360,
          i = l(e[1]),
          r = l(e[2]),
          a = r <= .5 ? r * (i + 1) : r + i - r * i,
          s = 2 * r - a;
      return h(t = t || [], o(255 * u(s, a, n + 1 / 3)), o(255 * u(s, a, n)), o(255 * u(s, a, n - 1 / 3)), 1), 4 === e.length && (t[3] = e[3]), t;
    }

    function y(e, t, n) {
      if (t && t.length && e >= 0 && e <= 1) {
        n = n || [];
        var i = e * (t.length - 1),
            r = Math.floor(i),
            s = Math.ceil(i),
            l = t[r],
            u = t[s],
            h = i - r;
        return n[0] = o(c(l[0], u[0], h)), n[1] = o(c(l[1], u[1], h)), n[2] = o(c(l[2], u[2], h)), n[3] = a(c(l[3], u[3], h)), n;
      }
    }

    var x = y;

    function _(e, t, n) {
      if (t && t.length && e >= 0 && e <= 1) {
        var i = e * (t.length - 1),
            r = Math.floor(i),
            s = Math.ceil(i),
            l = v(t[r]),
            u = v(t[s]),
            h = i - r,
            d = w([o(c(l[0], u[0], h)), o(c(l[1], u[1], h)), o(c(l[2], u[2], h)), a(c(l[3], u[3], h))], "rgba");
        return n ? {
          color: d,
          leftIndex: r,
          rightIndex: s,
          value: i
        } : d;
      }
    }

    var b = _;

    function w(e, t) {
      if (e && e.length) {
        var n = e[0] + "," + e[1] + "," + e[2];
        return "rgba" !== t && "hsva" !== t && "hsla" !== t || (n += "," + e[3]), t + "(" + n + ")";
      }
    }

    t.parse = v, t.lift = function (e, t) {
      var n = v(e);

      if (n) {
        for (var i = 0; i < 3; i++) {
          n[i] = t < 0 ? n[i] * (1 - t) | 0 : (255 - n[i]) * t + n[i] | 0, n[i] > 255 ? n[i] = 255 : e[i] < 0 && (n[i] = 0);
        }

        return w(n, 4 === n.length ? "rgba" : "rgb");
      }
    }, t.toHex = function (e) {
      var t = v(e);
      if (t) return ((1 << 24) + (t[0] << 16) + (t[1] << 8) + +t[2]).toString(16).slice(1);
    }, t.fastLerp = y, t.fastMapToColor = x, t.lerp = _, t.mapToColor = b, t.modifyHSL = function (e, t, n, i) {
      if (e = v(e)) return e = function (e) {
        if (e) {
          var t,
              n,
              i = e[0] / 255,
              r = e[1] / 255,
              o = e[2] / 255,
              a = Math.min(i, r, o),
              s = Math.max(i, r, o),
              l = s - a,
              u = (s + a) / 2;
          if (0 === l) t = 0, n = 0;else {
            n = u < .5 ? l / (s + a) : l / (2 - s - a);
            var c = ((s - i) / 6 + l / 2) / l,
                h = ((s - r) / 6 + l / 2) / l,
                d = ((s - o) / 6 + l / 2) / l;
            i === s ? t = d - h : r === s ? t = 1 / 3 + c - d : o === s && (t = 2 / 3 + h - c), t < 0 && (t += 1), t > 1 && (t -= 1);
          }
          var f = [360 * t, n, u];
          return null != e[3] && f.push(e[3]), f;
        }
      }(e), null != t && (e[0] = (r = t, (r = Math.round(r)) < 0 ? 0 : r > 360 ? 360 : r)), null != n && (e[1] = l(n)), null != i && (e[2] = l(i)), w(m(e), "rgba");
      var r;
    }, t.modifyAlpha = function (e, t) {
      if ((e = v(e)) && null != t) return e[3] = a(t), w(e, "rgba");
    }, t.stringify = w;
  }, function (e, t, n) {
    var i = n(1).each,
        r = n(84),
        o = n(121),
        a = n(60),
        s = n(8),
        l = n(5),
        u = n(211).createTask,
        c = n(103),
        h = s.makeInner(),
        d = c();

    function f() {
      this.group = new r(), this.uid = o.getUID("viewChart"), this.renderTask = u({
        plan: m,
        reset: y
      }), this.renderTask.context = {
        view: this
      };
    }

    f.prototype = {
      type: "chart",
      init: function init(e, t) {},
      render: function render(e, t, n, i) {},
      highlight: function highlight(e, t, n, i) {
        v(e.getData(), i, "emphasis");
      },
      downplay: function downplay(e, t, n, i) {
        v(e.getData(), i, "normal");
      },
      remove: function remove(e, t) {
        this.group.removeAll();
      },
      dispose: function dispose() {},
      incrementalPrepareRender: null,
      incrementalRender: null,
      updateTransform: null,
      filterForExposedEvent: null
    };
    var p = f.prototype;

    function g(e, t, n) {
      if (e && (e.trigger(t, n), e.isGroup && !l.isHighDownDispatcher(e))) for (var i = 0, r = e.childCount(); i < r; i++) {
        g(e.childAt(i), t, n);
      }
    }

    function v(e, t, n) {
      var r = s.queryDataIndex(e, t),
          o = t && null != t.highlightKey ? l.getHighlightDigit(t.highlightKey) : null;
      null != r ? i(s.normalizeToArray(r), function (t) {
        g(e.getItemGraphicEl(t), n, o);
      }) : e.eachItemGraphicEl(function (e) {
        g(e, n, o);
      });
    }

    function m(e) {
      return d(e.model);
    }

    function y(e) {
      var t = e.model,
          n = e.ecModel,
          i = e.api,
          r = e.payload,
          o = t.pipelineContext.progressiveRender,
          a = e.view,
          s = r && h(r).updateMethod,
          l = o ? "incrementalPrepareRender" : s && a[s] ? s : "render";
      return "render" !== l && a[l](t, n, i, r), x[l];
    }

    p.updateView = p.updateLayout = p.updateVisual = function (e, t, n, i) {
      this.render(e, t, n, i);
    }, a.enableClassExtend(f, ["dispose"]), a.enableClassManagement(f, {
      registerWhenExtend: !0
    }), f.markUpdateMethod = function (e, t) {
      h(e).updateMethod = t;
    };
    var x = {
      incrementalPrepareRender: {
        progress: function progress(e, t) {
          t.view.incrementalRender(e, t.model, t.ecModel, t.api, t.payload);
        }
      },
      render: {
        forceFirstProgress: !0,
        progress: function progress(e, t) {
          t.view.render(t.model, t.ecModel, t.api, t.payload);
        }
      }
    },
        _ = f;
    e.exports = _;
  }, function (e, t, n) {
    var i = n(1),
        r = i.each,
        o = i.isString;

    function a(e, t) {
      return !!t && t === e.getCalculationInfo("stackedDimension");
    }

    t.enableDataStack = function (e, t, n) {
      var i,
          a,
          s,
          l,
          u = (n = n || {}).byIndex,
          c = n.stackedCoordDimension,
          h = !(!e || !e.get("stack"));

      if (r(t, function (e, n) {
        o(e) && (t[n] = e = {
          name: e
        }), h && !e.isExtraCoord && (u || i || !e.ordinalMeta || (i = e), a || "ordinal" === e.type || "time" === e.type || c && c !== e.coordDim || (a = e));
      }), !a || u || i || (u = !0), a) {
        s = "__\0ecstackresult", l = "__\0ecstackedover", i && (i.createInvertedIndices = !0);
        var d = a.coordDim,
            f = a.type,
            p = 0;
        r(t, function (e) {
          e.coordDim === d && p++;
        }), t.push({
          name: s,
          coordDim: d,
          coordDimIndex: p,
          type: f,
          isExtraCoord: !0,
          isCalculationCoord: !0
        }), p++, t.push({
          name: l,
          coordDim: l,
          coordDimIndex: p,
          type: f,
          isExtraCoord: !0,
          isCalculationCoord: !0
        });
      }

      return {
        stackedDimension: a && a.name,
        stackedByDimension: i && i.name,
        isStackedByIndex: u,
        stackedOverDimension: l,
        stackResultDimension: s
      };
    }, t.isDimensionStacked = a, t.getStackedDimension = function (e, t) {
      return a(e, t) ? e.getCalculationInfo("stackResultDimension") : t;
    };
  }, function (e, t) {
    e.exports = function (e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    };
  }, function (e, t) {
    var n = {}.toString;

    e.exports = function (e) {
      return n.call(e).slice(8, -1);
    };
  }, function (e, t) {
    e.exports = function (e) {
      if (null == e) throw TypeError("Can't call method on  " + e);
      return e;
    };
  }, function (e, t, n) {
    "use strict";

    if (n(24)) {
      var i = n(75),
          r = n(10),
          o = n(11),
          a = n(3),
          s = n(147),
          l = n(195),
          u = n(45),
          c = n(97),
          h = n(73),
          d = n(37),
          f = n(98),
          p = n(47),
          g = n(19),
          v = n(267),
          m = n(77),
          y = n(63),
          x = n(36),
          _ = n(113),
          b = n(13),
          w = n(30),
          S = n(187),
          T = n(78),
          C = n(80),
          k = n(79).f,
          M = n(189),
          E = n(74),
          A = n(18),
          I = n(50),
          P = n(137),
          O = n(114),
          L = n(191),
          D = n(95),
          N = n(140),
          j = n(96),
          R = n(190),
          F = n(258),
          z = n(25),
          B = n(48),
          V = z.f,
          H = B.f,
          W = r.RangeError,
          G = r.TypeError,
          U = r.Uint8Array,
          Y = Array.prototype,
          X = l.ArrayBuffer,
          q = l.DataView,
          Z = I(0),
          K = I(2),
          $ = I(3),
          Q = I(4),
          J = I(5),
          ee = I(6),
          te = P(!0),
          ne = P(!1),
          ie = L.values,
          re = L.keys,
          oe = L.entries,
          ae = Y.lastIndexOf,
          se = Y.reduce,
          le = Y.reduceRight,
          ue = Y.join,
          ce = Y.sort,
          he = Y.slice,
          de = Y.toString,
          fe = Y.toLocaleString,
          pe = A("iterator"),
          ge = A("toStringTag"),
          ve = E("typed_constructor"),
          me = E("def_constructor"),
          ye = s.CONSTR,
          xe = s.TYPED,
          _e = s.VIEW,
          be = I(1, function (e, t) {
        return ke(O(e, e[me]), t);
      }),
          we = o(function () {
        return 1 === new U(new Uint16Array([1]).buffer)[0];
      }),
          Se = !!U && !!U.prototype.set && o(function () {
        new U(1).set({});
      }),
          Te = function Te(e, t) {
        var n = p(e);
        if (n < 0 || n % t) throw W("Wrong offset!");
        return n;
      },
          Ce = function Ce(e) {
        if (b(e) && xe in e) return e;
        throw G(e + " is not a typed array!");
      },
          ke = function ke(e, t) {
        if (!b(e) || !(ve in e)) throw G("It is not a typed array constructor!");
        return new e(t);
      },
          Me = function Me(e, t) {
        return Ee(O(e, e[me]), t);
      },
          Ee = function Ee(e, t) {
        for (var n = 0, i = t.length, r = ke(e, i); i > n;) {
          r[n] = t[n++];
        }

        return r;
      },
          Ae = function Ae(e, t, n) {
        V(e, t, {
          get: function get() {
            return this._d[n];
          }
        });
      },
          Ie = function Ie(e) {
        var t,
            n,
            i,
            r,
            o,
            a,
            s = w(e),
            l = arguments.length,
            c = l > 1 ? arguments[1] : void 0,
            h = void 0 !== c,
            d = M(s);

        if (null != d && !S(d)) {
          for (a = d.call(s), i = [], t = 0; !(o = a.next()).done; t++) {
            i.push(o.value);
          }

          s = i;
        }

        for (h && l > 2 && (c = u(c, arguments[2], 2)), t = 0, n = g(s.length), r = ke(this, n); n > t; t++) {
          r[t] = h ? c(s[t], t) : s[t];
        }

        return r;
      },
          Pe = function Pe() {
        for (var e = 0, t = arguments.length, n = ke(this, t); t > e;) {
          n[e] = arguments[e++];
        }

        return n;
      },
          Oe = !!U && o(function () {
        fe.call(new U(1));
      }),
          Le = function Le() {
        return fe.apply(Oe ? he.call(Ce(this)) : Ce(this), arguments);
      },
          De = {
        copyWithin: function copyWithin(e, t) {
          return F.call(Ce(this), e, t, arguments.length > 2 ? arguments[2] : void 0);
        },
        every: function every(e) {
          return Q(Ce(this), e, arguments.length > 1 ? arguments[1] : void 0);
        },
        fill: function fill(e) {
          return R.apply(Ce(this), arguments);
        },
        filter: function filter(e) {
          return Me(this, K(Ce(this), e, arguments.length > 1 ? arguments[1] : void 0));
        },
        find: function find(e) {
          return J(Ce(this), e, arguments.length > 1 ? arguments[1] : void 0);
        },
        findIndex: function findIndex(e) {
          return ee(Ce(this), e, arguments.length > 1 ? arguments[1] : void 0);
        },
        forEach: function forEach(e) {
          Z(Ce(this), e, arguments.length > 1 ? arguments[1] : void 0);
        },
        indexOf: function indexOf(e) {
          return ne(Ce(this), e, arguments.length > 1 ? arguments[1] : void 0);
        },
        includes: function includes(e) {
          return te(Ce(this), e, arguments.length > 1 ? arguments[1] : void 0);
        },
        join: function join(e) {
          return ue.apply(Ce(this), arguments);
        },
        lastIndexOf: function lastIndexOf(e) {
          return ae.apply(Ce(this), arguments);
        },
        map: function map(e) {
          return be(Ce(this), e, arguments.length > 1 ? arguments[1] : void 0);
        },
        reduce: function reduce(e) {
          return se.apply(Ce(this), arguments);
        },
        reduceRight: function reduceRight(e) {
          return le.apply(Ce(this), arguments);
        },
        reverse: function reverse() {
          for (var e, t = Ce(this).length, n = Math.floor(t / 2), i = 0; i < n;) {
            e = this[i], this[i++] = this[--t], this[t] = e;
          }

          return this;
        },
        some: function some(e) {
          return $(Ce(this), e, arguments.length > 1 ? arguments[1] : void 0);
        },
        sort: function sort(e) {
          return ce.call(Ce(this), e);
        },
        subarray: function subarray(e, t) {
          var n = Ce(this),
              i = n.length,
              r = m(e, i);
          return new (O(n, n[me]))(n.buffer, n.byteOffset + r * n.BYTES_PER_ELEMENT, g((void 0 === t ? i : m(t, i)) - r));
        }
      },
          Ne = function Ne(e, t) {
        return Me(this, he.call(Ce(this), e, t));
      },
          je = function je(e) {
        Ce(this);
        var t = Te(arguments[1], 1),
            n = this.length,
            i = w(e),
            r = g(i.length),
            o = 0;
        if (r + t > n) throw W("Wrong length!");

        for (; o < r;) {
          this[t + o] = i[o++];
        }
      },
          Re = {
        entries: function entries() {
          return oe.call(Ce(this));
        },
        keys: function keys() {
          return re.call(Ce(this));
        },
        values: function values() {
          return ie.call(Ce(this));
        }
      },
          Fe = function Fe(e, t) {
        return b(e) && e[xe] && "symbol" != typeof t && t in e && String(+t) == String(t);
      },
          ze = function ze(e, t) {
        return Fe(e, t = y(t, !0)) ? h(2, e[t]) : H(e, t);
      },
          Be = function Be(e, t, n) {
        return !(Fe(e, t = y(t, !0)) && b(n) && x(n, "value")) || x(n, "get") || x(n, "set") || n.configurable || x(n, "writable") && !n.writable || x(n, "enumerable") && !n.enumerable ? V(e, t, n) : (e[t] = n.value, e);
      };

      ye || (B.f = ze, z.f = Be), a(a.S + a.F * !ye, "Object", {
        getOwnPropertyDescriptor: ze,
        defineProperty: Be
      }), o(function () {
        de.call({});
      }) && (de = fe = function fe() {
        return ue.call(this);
      });
      var Ve = f({}, De);
      f(Ve, Re), d(Ve, pe, Re.values), f(Ve, {
        slice: Ne,
        set: je,
        constructor: function constructor() {},
        toString: de,
        toLocaleString: Le
      }), Ae(Ve, "buffer", "b"), Ae(Ve, "byteOffset", "o"), Ae(Ve, "byteLength", "l"), Ae(Ve, "length", "e"), V(Ve, ge, {
        get: function get() {
          return this[xe];
        }
      }), e.exports = function (e, t, n, l) {
        var u = e + ((l = !!l) ? "Clamped" : "") + "Array",
            h = "get" + e,
            f = "set" + e,
            p = r[u],
            m = p || {},
            y = p && C(p),
            x = !p || !s.ABV,
            w = {},
            S = p && p.prototype,
            M = function M(e, n) {
          V(e, n, {
            get: function get() {
              return function (e, n) {
                var i = e._d;
                return i.v[h](n * t + i.o, we);
              }(this, n);
            },
            set: function set(e) {
              return function (e, n, i) {
                var r = e._d;
                l && (i = (i = Math.round(i)) < 0 ? 0 : i > 255 ? 255 : 255 & i), r.v[f](n * t + r.o, i, we);
              }(this, n, e);
            },
            enumerable: !0
          });
        };

        x ? (p = n(function (e, n, i, r) {
          c(e, p, u, "_d");
          var o,
              a,
              s,
              l,
              h = 0,
              f = 0;

          if (b(n)) {
            if (!(n instanceof X || "ArrayBuffer" == (l = _(n)) || "SharedArrayBuffer" == l)) return xe in n ? Ee(p, n) : Ie.call(p, n);
            o = n, f = Te(i, t);
            var m = n.byteLength;

            if (void 0 === r) {
              if (m % t) throw W("Wrong length!");
              if ((a = m - f) < 0) throw W("Wrong length!");
            } else if ((a = g(r) * t) + f > m) throw W("Wrong length!");

            s = a / t;
          } else s = v(n), o = new X(a = s * t);

          for (d(e, "_d", {
            b: o,
            o: f,
            l: a,
            e: s,
            v: new q(o)
          }); h < s;) {
            M(e, h++);
          }
        }), S = p.prototype = T(Ve), d(S, "constructor", p)) : o(function () {
          p(1);
        }) && o(function () {
          new p(-1);
        }) && N(function (e) {
          new p(), new p(null), new p(1.5), new p(e);
        }, !0) || (p = n(function (e, n, i, r) {
          var o;
          return c(e, p, u), b(n) ? n instanceof X || "ArrayBuffer" == (o = _(n)) || "SharedArrayBuffer" == o ? void 0 !== r ? new m(n, Te(i, t), r) : void 0 !== i ? new m(n, Te(i, t)) : new m(n) : xe in n ? Ee(p, n) : Ie.call(p, n) : new m(v(n));
        }), Z(y !== Function.prototype ? k(m).concat(k(y)) : k(m), function (e) {
          e in p || d(p, e, m[e]);
        }), p.prototype = S, i || (S.constructor = p));
        var E = S[pe],
            A = !!E && ("values" == E.name || null == E.name),
            I = Re.values;
        d(p, ve, !0), d(S, xe, u), d(S, _e, !0), d(S, me, p), (l ? new p(1)[ge] == u : ge in S) || V(S, ge, {
          get: function get() {
            return u;
          }
        }), w[u] = p, a(a.G + a.W + a.F * (p != m), w), a(a.S, u, {
          BYTES_PER_ELEMENT: t
        }), a(a.S + a.F * o(function () {
          m.of.call(p, 1);
        }), u, {
          from: Ie,
          of: Pe
        }), "BYTES_PER_ELEMENT" in S || d(S, "BYTES_PER_ELEMENT", t), a(a.P, u, De), j(u), a(a.P + a.F * Se, u, {
          set: je
        }), a(a.P + a.F * !A, u, Re), i || S.toString == de || (S.toString = de), a(a.P + a.F * o(function () {
          new p(1).slice();
        }), u, {
          slice: Ne
        }), a(a.P + a.F * (o(function () {
          return [1, 2].toLocaleString() != new p([1, 2]).toLocaleString();
        }) || !o(function () {
          S.toLocaleString.call([1, 2]);
        })), u, {
          toLocaleString: Le
        }), D[u] = A ? E : I, i || A || d(S, pe, I);
      };
    } else e.exports = function () {};
  }, function (e, t, n) {
    n(9).__DEV__;
    var i = n(1),
        r = "___EC__COMPONENT__CONTAINER___";

    function o(e) {
      var t = {
        main: "",
        sub: ""
      };
      return e && (e = e.split("."), t.main = e[0] || "", t.sub = e[1] || ""), t;
    }

    var a = 0;

    function s(e, t) {
      var n = i.slice(arguments, 2);
      return this.superClass.prototype[t].apply(e, n);
    }

    function l(e, t, n) {
      return this.superClass.prototype[t].apply(e, n);
    }

    t.parseClassType = o, t.enableClassExtend = function (e, t) {
      e.$constructor = e, e.extend = function (e) {
        var t = this,
            n = function n() {
          e.$constructor ? e.$constructor.apply(this, arguments) : t.apply(this, arguments);
        };

        return i.extend(n.prototype, e), n.extend = this.extend, n.superCall = s, n.superApply = l, i.inherits(n, this), n.superClass = t, n;
      };
    }, t.enableClassCheck = function (e) {
      var t = ["__\0is_clz", a++, Math.random().toFixed(3)].join("_");
      e.prototype[t] = !0, e.isInstance = function (e) {
        return !(!e || !e[t]);
      };
    }, t.enableClassManagement = function (e, t) {
      t = t || {};
      var n = {};

      if (e.registerClass = function (e, t) {
        if (t) if (function (e) {
          i.assert(/^[a-zA-Z0-9_]+([.][a-zA-Z0-9_]+)?$/.test(e), 'componentType "' + e + '" illegal');
        }(t), (t = o(t)).sub) {
          if (t.sub !== r) {
            (function (e) {
              var t = n[e.main];
              t && t[r] || ((t = n[e.main] = {})[r] = !0);
              return t;
            })(t)[t.sub] = e;
          }
        } else n[t.main] = e;
        return e;
      }, e.getClass = function (e, t, i) {
        var o = n[e];
        if (o && o[r] && (o = t ? o[t] : null), i && !o) throw new Error(t ? "Component " + e + "." + (t || "") + " not exists. Load it first." : e + ".type should be specified.");
        return o;
      }, e.getClassesByMainType = function (e) {
        e = o(e);
        var t = [],
            a = n[e.main];
        return a && a[r] ? i.each(a, function (e, n) {
          n !== r && t.push(e);
        }) : t.push(a), t;
      }, e.hasClass = function (e) {
        return e = o(e), !!n[e.main];
      }, e.getAllClassMainTypes = function () {
        var e = [];
        return i.each(n, function (t, n) {
          e.push(n);
        }), e;
      }, e.hasSubTypes = function (e) {
        e = o(e);
        var t = n[e.main];
        return t && t[r];
      }, e.parseClassType = o, t.registerWhenExtend) {
        var a = e.extend;
        a && (e.extend = function (t) {
          var n = a.call(this, t);
          return e.registerClass(n, t.type);
        });
      }

      return e;
    }, t.setReadOnly = function (e, t) {};
  }, function (e, t, n) {
    n(9).__DEV__;
    var i = n(8),
        r = i.makeInner,
        o = i.getDataItemValue,
        a = n(1),
        s = a.createHashMap,
        l = a.each,
        u = a.map,
        c = a.isArray,
        h = a.isString,
        d = a.isObject,
        f = a.isTypedArray,
        p = a.isArrayLike,
        g = a.extend,
        v = (a.assert, n(122)),
        m = n(123),
        y = m.SOURCE_FORMAT_ORIGINAL,
        x = m.SOURCE_FORMAT_ARRAY_ROWS,
        _ = m.SOURCE_FORMAT_OBJECT_ROWS,
        b = m.SOURCE_FORMAT_KEYED_COLUMNS,
        w = m.SOURCE_FORMAT_UNKNOWN,
        S = m.SOURCE_FORMAT_TYPED_ARRAY,
        T = m.SERIES_LAYOUT_BY_ROW,
        C = {
      Must: 1,
      Might: 2,
      Not: 3
    },
        k = r();

    function M(e) {
      if (e) {
        var t = s();
        return u(e, function (e, n) {
          if (null == (e = g({}, d(e) ? e : {
            name: e
          })).name) return e;
          e.name += "", null == e.displayName && (e.displayName = e.name);
          var i = t.get(e.name);
          return i ? e.name += "-" + i.count++ : t.set(e.name, {
            count: 1
          }), e;
        });
      }
    }

    function E(e, t, n, i) {
      if (null == i && (i = 1 / 0), t === T) for (var r = 0; r < n.length && r < i; r++) {
        e(n[r] ? n[r][0] : null, r);
      } else {
        var o = n[0] || [];

        for (r = 0; r < o.length && r < i; r++) {
          e(o[r], r);
        }
      }
    }

    function A(e) {
      var t = e.option;
      if (!t.data) return e.ecModel.getComponent("dataset", t.datasetIndex || 0);
    }

    function I(e, t, n, i, r, a) {
      var s, l, u;
      if (f(e)) return C.Not;

      if (i) {
        var p = i[a];
        d(p) ? (l = p.name, u = p.type) : h(p) && (l = p);
      }

      if (null != u) return "ordinal" === u ? C.Must : C.Not;
      if (t === x) {
        if (n === T) {
          for (var g = e[a], v = 0; v < (g || []).length && v < 5; v++) {
            if (null != (s = k(g[r + v]))) return s;
          }
        } else for (v = 0; v < e.length && v < 5; v++) {
          var m = e[r + v];
          if (m && null != (s = k(m[a]))) return s;
        }
      } else if (t === _) {
        if (!l) return C.Not;

        for (v = 0; v < e.length && v < 5; v++) {
          if ((w = e[v]) && null != (s = k(w[l]))) return s;
        }
      } else if (t === b) {
        if (!l) return C.Not;
        if (!(g = e[l]) || f(g)) return C.Not;

        for (v = 0; v < g.length && v < 5; v++) {
          if (null != (s = k(g[v]))) return s;
        }
      } else if (t === y) for (v = 0; v < e.length && v < 5; v++) {
        var w = e[v],
            S = o(w);
        if (!c(S)) return C.Not;
        if (null != (s = k(S[a]))) return s;
      }

      function k(e) {
        var t = h(e);
        return null != e && isFinite(e) && "" !== e ? t ? C.Might : C.Not : t && "-" !== e ? C.Must : void 0;
      }

      return C.Not;
    }

    t.BE_ORDINAL = C, t.detectSourceFormat = function (e) {
      var t = e.option.source,
          n = w;
      if (f(t)) n = S;else if (c(t)) {
        0 === t.length && (n = x);

        for (var i = 0, r = t.length; i < r; i++) {
          var o = t[i];

          if (null != o) {
            if (c(o)) {
              n = x;
              break;
            }

            if (d(o)) {
              n = _;
              break;
            }
          }
        }
      } else if (d(t)) {
        for (var a in t) {
          if (t.hasOwnProperty(a) && p(t[a])) {
            n = b;
            break;
          }
        }
      } else if (null != t) throw new Error("Invalid data");
      k(e).sourceFormat = n;
    }, t.getSource = function (e) {
      return k(e).source;
    }, t.resetSourceDefaulter = function (e) {
      k(e).datasetMap = s();
    }, t.prepareSource = function (e) {
      var t = e.option,
          n = t.data,
          i = f(n) ? S : y,
          r = !1,
          a = t.seriesLayoutBy,
          s = t.sourceHeader,
          u = t.dimensions,
          d = A(e);

      if (d) {
        var p = d.option;
        n = p.source, i = k(d).sourceFormat, r = !0, a = a || p.seriesLayoutBy, null == s && (s = p.sourceHeader), u = u || p.dimensions;
      }

      var g = function (e, t, n, i, r) {
        if (!e) return {
          dimensionsDefine: M(r)
        };
        var a, s;
        if (t === x) "auto" === i || null == i ? E(function (e) {
          null != e && "-" !== e && (h(e) ? null == s && (s = 1) : s = 0);
        }, n, e, 10) : s = i ? 1 : 0, r || 1 !== s || (r = [], E(function (e, t) {
          r[t] = null != e ? e : "";
        }, n, e)), a = r ? r.length : n === T ? e.length : e[0] ? e[0].length : null;else if (t === _) r || (r = function (e) {
          var t,
              n = 0;

          for (; n < e.length && !(t = e[n++]);) {
            ;
          }

          if (t) {
            var i = [];
            return l(t, function (e, t) {
              i.push(t);
            }), i;
          }
        }(e));else if (t === b) r || (r = [], l(e, function (e, t) {
          r.push(t);
        }));else if (t === y) {
          var u = o(e[0]);
          a = c(u) && u.length || 1;
        }
        return {
          startIndex: s,
          dimensionsDefine: M(r),
          dimensionsDetectCount: a
        };
      }(n, i, a, s, u);

      k(e).source = new v({
        data: n,
        fromDataset: r,
        seriesLayoutBy: a,
        sourceFormat: i,
        dimensionsDefine: g.dimensionsDefine,
        startIndex: g.startIndex,
        dimensionsDetectCount: g.dimensionsDetectCount,
        encodeDefine: t.encode
      });
    }, t.makeSeriesEncodeForAxisCoordSys = function (e, t, n) {
      var i = {},
          r = A(t);
      if (!r || !e) return i;
      var o,
          a,
          s = [],
          u = [],
          c = t.ecModel,
          h = k(c).datasetMap,
          f = r.uid + "_" + n.seriesLayoutBy;
      e = e.slice(), l(e, function (t, n) {
        !d(t) && (e[n] = {
          name: t
        }), "ordinal" === t.type && null == o && (o = n, a = v(e[n])), i[t.name] = [];
      });
      var p = h.get(f) || h.set(f, {
        categoryWayDim: a,
        valueWayDim: 0
      });

      function g(e, t, n) {
        for (var i = 0; i < n; i++) {
          e.push(t + i);
        }
      }

      function v(e) {
        var t = e.dimsDef;
        return t ? t.length : 1;
      }

      return l(e, function (e, t) {
        var n = e.name,
            r = v(e);

        if (null == o) {
          var a = p.valueWayDim;
          g(i[n], a, r), g(u, a, r), p.valueWayDim += r;
        } else if (o === t) g(i[n], 0, r), g(s, 0, r);else {
          a = p.categoryWayDim;
          g(i[n], a, r), g(u, a, r), p.categoryWayDim += r;
        }
      }), s.length && (i.itemName = s), u.length && (i.seriesName = u), i;
    }, t.makeSeriesEncodeForNameBased = function (e, t, n) {
      var i = {};
      if (!A(e)) return i;
      var r,
          o = t.sourceFormat,
          a = t.dimensionsDefine;
      o !== _ && o !== b || l(a, function (e, t) {
        "name" === (d(e) ? e.name : e) && (r = t);
      });

      var s = function () {
        for (var e = {}, i = {}, s = [], l = 0, u = Math.min(5, n); l < u; l++) {
          var c = I(t.data, o, t.seriesLayoutBy, a, t.startIndex, l);
          s.push(c);
          var h = c === C.Not;
          if (h && null == e.v && l !== r && (e.v = l), (null == e.n || e.n === e.v || !h && s[e.n] === C.Not) && (e.n = l), d(e) && s[e.n] !== C.Not) return e;
          h || (c === C.Might && null == i.v && l !== r && (i.v = l), null != i.n && i.n !== i.v || (i.n = l));
        }

        function d(e) {
          return null != e.v && null != e.n;
        }

        return d(e) ? e : d(i) ? i : null;
      }();

      if (s) {
        i.value = s.v;
        var u = null != r ? r : s.n;
        i.itemName = [u], i.seriesName = [u];
      }

      return i;
    }, t.guessOrdinal = function (e, t) {
      return I(e.data, e.sourceFormat, e.seriesLayoutBy, e.dimensionsDefine, e.startIndex, t);
    };
  }, function (e, t, n) {
    var i = n(1),
        r = n(39),
        o = n(104),
        a = n(123).SOURCE_FORMAT_ORIGINAL,
        s = n(124).getDimensionTypeByAxis,
        l = n(8).getDataItemValue,
        u = n(42),
        c = n(687).getCoordSysInfoBySeries,
        h = n(122),
        d = n(55).enableDataStack,
        f = n(61).makeSeriesEncodeForAxisCoordSys;

    var p = function p(e, t, n) {
      n = n || {}, h.isInstance(e) || (e = h.seriesDataToSource(e));
      var p,
          g = t.get("coordinateSystem"),
          v = u.get(g),
          m = c(t);
      m && (p = i.map(m.coordSysDims, function (e) {
        var t = {
          name: e
        },
            n = m.axisMap.get(e);

        if (n) {
          var i = n.get("type");
          t.type = s(i);
        }

        return t;
      })), p || (p = v && (v.getDimensionsInfo ? v.getDimensionsInfo() : v.dimensions.slice()) || ["x", "y"]);

      var y,
          x,
          _ = o(e, {
        coordDimensions: p,
        generateCoord: n.generateCoord,
        encodeDefaulter: n.useEncodeDefaulter ? i.curry(f, p, t) : null
      });

      m && i.each(_, function (e, t) {
        var n = e.coordDim,
            i = m.categoryAxisMap.get(n);
        i && (null == y && (y = t), e.ordinalMeta = i.getOrdinalMeta()), null != e.otherDims.itemName && (x = !0);
      }), x || null == y || (_[y].otherDims.itemName = 0);
      var b = d(t, _),
          w = new r(_, t);
      w.setCalculationInfo(b);
      var S = null != y && function (e) {
        if (e.sourceFormat === a) {
          var t = function (e) {
            var t = 0;

            for (; t < e.length && null == e[t];) {
              t++;
            }

            return e[t];
          }(e.data || []);

          return null != t && !i.isArray(l(t));
        }
      }(e) ? function (e, t, n, i) {
        return i === y ? n : this.defaultDimValueGetter(e, t, n, i);
      } : null;
      return w.hasItemOption = !1, w.initData(e, null, S), w;
    };

    e.exports = p;
  }, function (e, t, n) {
    var i = n(13);

    e.exports = function (e, t) {
      if (!i(e)) return e;
      var n, r;
      if (t && "function" == typeof (n = e.toString) && !i(r = n.call(e))) return r;
      if ("function" == typeof (n = e.valueOf) && !i(r = n.call(e))) return r;
      if (!t && "function" == typeof (n = e.toString) && !i(r = n.call(e))) return r;
      throw TypeError("Can't convert object to primitive value");
    };
  }, function (e, t, n) {
    var i = n(74)("meta"),
        r = n(13),
        o = n(36),
        a = n(25).f,
        s = 0,
        l = Object.isExtensible || function () {
      return !0;
    },
        u = !n(11)(function () {
      return l(Object.preventExtensions({}));
    }),
        c = function c(e) {
      a(e, i, {
        value: {
          i: "O" + ++s,
          w: {}
        }
      });
    },
        h = e.exports = {
      KEY: i,
      NEED: !1,
      fastKey: function fastKey(e, t) {
        if (!r(e)) return "symbol" == typeof e ? e : ("string" == typeof e ? "S" : "P") + e;

        if (!o(e, i)) {
          if (!l(e)) return "F";
          if (!t) return "E";
          c(e);
        }

        return e[i].i;
      },
      getWeak: function getWeak(e, t) {
        if (!o(e, i)) {
          if (!l(e)) return !0;
          if (!t) return !1;
          c(e);
        }

        return e[i].w;
      },
      onFreeze: function onFreeze(e) {
        return u && h.NEED && l(e) && !o(e, i) && c(e), e;
      }
    };
  }, function (e, t) {
    var n;

    n = function () {
      return this;
    }();

    try {
      n = n || new Function("return this")();
    } catch (e) {
      "object" == typeof window && (n = window);
    }

    e.exports = n;
  }, function (e, t, n) {
    var i = n(16),
        r = i.create,
        o = i.distSquare,
        a = Math.pow,
        s = Math.sqrt,
        l = s(3),
        u = r(),
        c = r(),
        h = r();

    function d(e) {
      return e > -1e-8 && e < 1e-8;
    }

    function f(e) {
      return e > 1e-8 || e < -1e-8;
    }

    function p(e, t, n, i, r) {
      var o = 1 - r;
      return o * o * (o * e + 3 * r * t) + r * r * (r * i + 3 * o * n);
    }

    function g(e, t, n, i) {
      var r = 1 - i;
      return r * (r * e + 2 * i * t) + i * i * n;
    }

    t.cubicAt = p, t.cubicDerivativeAt = function (e, t, n, i, r) {
      var o = 1 - r;
      return 3 * (((t - e) * o + 2 * (n - t) * r) * o + (i - n) * r * r);
    }, t.cubicRootAt = function (e, t, n, i, r, o) {
      var u = i + 3 * (t - n) - e,
          c = 3 * (n - 2 * t + e),
          h = 3 * (t - e),
          f = e - r,
          p = c * c - 3 * u * h,
          g = c * h - 9 * u * f,
          v = h * h - 3 * c * f,
          m = 0;

      if (d(p) && d(g)) {
        if (d(c)) o[0] = 0;else (E = -h / c) >= 0 && E <= 1 && (o[m++] = E);
      } else {
        var y = g * g - 4 * p * v;

        if (d(y)) {
          var x = g / p,
              _ = -x / 2;

          (E = -c / u + x) >= 0 && E <= 1 && (o[m++] = E), _ >= 0 && _ <= 1 && (o[m++] = _);
        } else if (y > 0) {
          var b = s(y),
              w = p * c + 1.5 * u * (-g + b),
              S = p * c + 1.5 * u * (-g - b);
          (E = (-c - ((w = w < 0 ? -a(-w, 1 / 3) : a(w, 1 / 3)) + (S = S < 0 ? -a(-S, 1 / 3) : a(S, 1 / 3)))) / (3 * u)) >= 0 && E <= 1 && (o[m++] = E);
        } else {
          var T = (2 * p * c - 3 * u * g) / (2 * s(p * p * p)),
              C = Math.acos(T) / 3,
              k = s(p),
              M = Math.cos(C),
              E = (-c - 2 * k * M) / (3 * u),
              A = (_ = (-c + k * (M + l * Math.sin(C))) / (3 * u), (-c + k * (M - l * Math.sin(C))) / (3 * u));
          E >= 0 && E <= 1 && (o[m++] = E), _ >= 0 && _ <= 1 && (o[m++] = _), A >= 0 && A <= 1 && (o[m++] = A);
        }
      }

      return m;
    }, t.cubicExtrema = function (e, t, n, i, r) {
      var o = 6 * n - 12 * t + 6 * e,
          a = 9 * t + 3 * i - 3 * e - 9 * n,
          l = 3 * t - 3 * e,
          u = 0;

      if (d(a)) {
        if (f(o)) (h = -l / o) >= 0 && h <= 1 && (r[u++] = h);
      } else {
        var c = o * o - 4 * a * l;
        if (d(c)) r[0] = -o / (2 * a);else if (c > 0) {
          var h,
              p = s(c),
              g = (-o - p) / (2 * a);
          (h = (-o + p) / (2 * a)) >= 0 && h <= 1 && (r[u++] = h), g >= 0 && g <= 1 && (r[u++] = g);
        }
      }

      return u;
    }, t.cubicSubdivide = function (e, t, n, i, r, o) {
      var a = (t - e) * r + e,
          s = (n - t) * r + t,
          l = (i - n) * r + n,
          u = (s - a) * r + a,
          c = (l - s) * r + s,
          h = (c - u) * r + u;
      o[0] = e, o[1] = a, o[2] = u, o[3] = h, o[4] = h, o[5] = c, o[6] = l, o[7] = i;
    }, t.cubicProjectPoint = function (e, t, n, i, r, a, l, d, f, g, v) {
      var m,
          y,
          x,
          _,
          b,
          w = .005,
          S = 1 / 0;

      u[0] = f, u[1] = g;

      for (var T = 0; T < 1; T += .05) {
        c[0] = p(e, n, r, l, T), c[1] = p(t, i, a, d, T), (_ = o(u, c)) < S && (m = T, S = _);
      }

      S = 1 / 0;

      for (var C = 0; C < 32 && !(w < 1e-4); C++) {
        y = m - w, x = m + w, c[0] = p(e, n, r, l, y), c[1] = p(t, i, a, d, y), _ = o(c, u), y >= 0 && _ < S ? (m = y, S = _) : (h[0] = p(e, n, r, l, x), h[1] = p(t, i, a, d, x), b = o(h, u), x <= 1 && b < S ? (m = x, S = b) : w *= .5);
      }

      return v && (v[0] = p(e, n, r, l, m), v[1] = p(t, i, a, d, m)), s(S);
    }, t.quadraticAt = g, t.quadraticDerivativeAt = function (e, t, n, i) {
      return 2 * ((1 - i) * (t - e) + i * (n - t));
    }, t.quadraticRootAt = function (e, t, n, i, r) {
      var o = e - 2 * t + n,
          a = 2 * (t - e),
          l = e - i,
          u = 0;

      if (d(o)) {
        if (f(a)) (h = -l / a) >= 0 && h <= 1 && (r[u++] = h);
      } else {
        var c = a * a - 4 * o * l;
        if (d(c)) (h = -a / (2 * o)) >= 0 && h <= 1 && (r[u++] = h);else if (c > 0) {
          var h,
              p = s(c),
              g = (-a - p) / (2 * o);
          (h = (-a + p) / (2 * o)) >= 0 && h <= 1 && (r[u++] = h), g >= 0 && g <= 1 && (r[u++] = g);
        }
      }

      return u;
    }, t.quadraticExtremum = function (e, t, n) {
      var i = e + n - 2 * t;
      return 0 === i ? .5 : (e - t) / i;
    }, t.quadraticSubdivide = function (e, t, n, i, r) {
      var o = (t - e) * i + e,
          a = (n - t) * i + t,
          s = (a - o) * i + o;
      r[0] = e, r[1] = o, r[2] = s, r[3] = s, r[4] = a, r[5] = n;
    }, t.quadraticProjectPoint = function (e, t, n, i, r, a, l, d, f) {
      var p,
          v = .005,
          m = 1 / 0;
      u[0] = l, u[1] = d;

      for (var y = 0; y < 1; y += .05) {
        c[0] = g(e, n, r, y), c[1] = g(t, i, a, y), (w = o(u, c)) < m && (p = y, m = w);
      }

      m = 1 / 0;

      for (var x = 0; x < 32 && !(v < 1e-4); x++) {
        var _ = p - v,
            b = p + v;

        c[0] = g(e, n, r, _), c[1] = g(t, i, a, _);
        var w = o(c, u);
        if (_ >= 0 && w < m) p = _, m = w;else {
          h[0] = g(e, n, r, b), h[1] = g(t, i, a, b);
          var S = o(h, u);
          b <= 1 && S < m ? (p = b, m = S) : v *= .5;
        }
      }

      return f && (f[0] = g(e, n, r, p), f[1] = g(t, i, a, p)), s(m);
    };
  }, function (e, t) {
    var n = "\0__throttleOriginMethod",
        i = "\0__throttleRate";

    function r(e, t, n) {
      var i,
          r,
          o,
          a,
          s,
          l = 0,
          u = 0,
          c = null;

      function h() {
        u = new Date().getTime(), c = null, e.apply(o, a || []);
      }

      t = t || 0;

      var d = function d() {
        i = new Date().getTime(), o = this, a = arguments;
        var e = s || t,
            d = s || n;
        s = null, r = i - (d ? l : u) - e, clearTimeout(c), d ? c = setTimeout(h, e) : r >= 0 ? h() : c = setTimeout(h, -r), l = i;
      };

      return d.clear = function () {
        c && (clearTimeout(c), c = null);
      }, d.debounceNextCall = function (e) {
        s = e;
      }, d;
    }

    t.throttle = r, t.createOrUpdate = function (e, t, o, a) {
      var s = e[t];

      if (s) {
        var l = s[n] || s,
            u = s["\0__throttleType"];

        if (s[i] !== o || u !== a) {
          if (null == o || !a) return e[t] = l;
          (s = e[t] = r(l, o, "debounce" === a))[n] = l, s["\0__throttleType"] = a, s[i] = o;
        }

        return s;
      }
    }, t.clear = function (e, t) {
      var i = e[t];
      i && i[n] && (e[t] = i[n]);
    };
  }, function (e, t) {
    e.exports = {
      legend: {
        selector: {
          all: "全选",
          inverse: "反选"
        }
      },
      toolbox: {
        brush: {
          title: {
            rect: "矩形选择",
            polygon: "圈选",
            lineX: "横向选择",
            lineY: "纵向选择",
            keep: "保持选择",
            clear: "清除选择"
          }
        },
        dataView: {
          title: "数据视图",
          lang: ["数据视图", "关闭", "刷新"]
        },
        dataZoom: {
          title: {
            zoom: "区域缩放",
            back: "区域缩放还原"
          }
        },
        magicType: {
          title: {
            line: "切换为折线图",
            bar: "切换为柱状图",
            stack: "切换为堆叠",
            tiled: "切换为平铺"
          }
        },
        restore: {
          title: "还原"
        },
        saveAsImage: {
          title: "保存为图片",
          lang: ["右键另存为图片"]
        }
      },
      series: {
        typeNames: {
          pie: "饼图",
          bar: "柱状图",
          line: "折线图",
          scatter: "散点图",
          effectScatter: "涟漪散点图",
          radar: "雷达图",
          tree: "树图",
          treemap: "矩形树图",
          boxplot: "箱型图",
          candlestick: "K线图",
          k: "K线图",
          heatmap: "热力图",
          map: "地图",
          parallel: "平行坐标图",
          lines: "线图",
          graph: "关系图",
          sankey: "桑基图",
          funnel: "漏斗图",
          gauge: "仪表盘图",
          pictorialBar: "象形柱图",
          themeRiver: "主题河流图",
          sunburst: "旭日图"
        }
      },
      aria: {
        general: {
          withTitle: "这是一个关于“{title}”的图表。",
          withoutTitle: "这是一个图表，"
        },
        series: {
          single: {
            prefix: "",
            withName: "图表类型是{seriesType}，表示{seriesName}。",
            withoutName: "图表类型是{seriesType}。"
          },
          multiple: {
            prefix: "它由{seriesCount}个图表系列组成。",
            withName: "第{seriesId}个系列是一个表示{seriesName}的{seriesType}，",
            withoutName: "第{seriesId}个系列是一个{seriesType}，",
            separator: {
              middle: "；",
              end: "。"
            }
          }
        },
        data: {
          allData: "其数据是——",
          partialData: "其中，前{displayCnt}项是——",
          withName: "{name}的数据是{value}",
          withoutName: "{value}",
          separator: {
            middle: "，",
            end: ""
          }
        }
      }
    };
  }, function (e, t, n) {
    var i = n(1),
        r = i.each,
        o = i.map,
        a = n(6),
        s = a.linearMap,
        l = a.getPixelPrecision,
        u = a.round,
        c = n(690),
        h = c.createAxisTicks,
        d = c.createAxisLabels,
        f = c.calculateCategoryInterval,
        p = [0, 1],
        g = function g(e, t, n) {
      this.dim = e, this.scale = t, this._extent = n || [0, 0], this.inverse = !1, this.onBand = !1;
    };

    function v(e, t) {
      var n = (e[1] - e[0]) / t / 2;
      e[0] += n, e[1] -= n;
    }

    g.prototype = {
      constructor: g,
      contain: function contain(e) {
        var t = this._extent,
            n = Math.min(t[0], t[1]),
            i = Math.max(t[0], t[1]);
        return e >= n && e <= i;
      },
      containData: function containData(e) {
        return this.scale.contain(e);
      },
      getExtent: function getExtent() {
        return this._extent.slice();
      },
      getPixelPrecision: function getPixelPrecision(e) {
        return l(e || this.scale.getExtent(), this._extent);
      },
      setExtent: function setExtent(e, t) {
        var n = this._extent;
        n[0] = e, n[1] = t;
      },
      dataToCoord: function dataToCoord(e, t) {
        var n = this._extent,
            i = this.scale;
        return e = i.normalize(e), this.onBand && "ordinal" === i.type && v(n = n.slice(), i.count()), s(e, p, n, t);
      },
      coordToData: function coordToData(e, t) {
        var n = this._extent,
            i = this.scale;
        this.onBand && "ordinal" === i.type && v(n = n.slice(), i.count());
        var r = s(e, n, p, t);
        return this.scale.scale(r);
      },
      pointToData: function pointToData(e, t) {},
      getTicksCoords: function getTicksCoords(e) {
        var t = (e = e || {}).tickModel || this.getTickModel(),
            n = h(this, t).ticks,
            i = o(n, function (e) {
          return {
            coord: this.dataToCoord(e),
            tickValue: e
          };
        }, this);
        return function (e, t, n, i) {
          var o = t.length;
          if (!e.onBand || n || !o) return;
          var a,
              s,
              l = e.getExtent();
          if (1 === o) t[0].coord = l[0], a = t[1] = {
            coord: l[0]
          };else {
            var c = t[o - 1].tickValue - t[0].tickValue,
                h = (t[o - 1].coord - t[0].coord) / c;
            r(t, function (e) {
              e.coord -= h / 2;
            });
            var d = e.scale.getExtent();
            s = 1 + d[1] - t[o - 1].tickValue, a = {
              coord: t[o - 1].coord + h * s
            }, t.push(a);
          }
          var f = l[0] > l[1];
          p(t[0].coord, l[0]) && (i ? t[0].coord = l[0] : t.shift());
          i && p(l[0], t[0].coord) && t.unshift({
            coord: l[0]
          });
          p(l[1], a.coord) && (i ? a.coord = l[1] : t.pop());
          i && p(a.coord, l[1]) && t.push({
            coord: l[1]
          });

          function p(e, t) {
            return e = u(e), t = u(t), f ? e > t : e < t;
          }
        }(this, i, t.get("alignWithLabel"), e.clamp), i;
      },
      getMinorTicksCoords: function getMinorTicksCoords() {
        if ("ordinal" === this.scale.type) return [];
        var e = this.model.getModel("minorTick").get("splitNumber");
        e > 0 && e < 100 || (e = 5);
        var t = this.scale.getMinorTicks(e);
        return o(t, function (e) {
          return o(e, function (e) {
            return {
              coord: this.dataToCoord(e),
              tickValue: e
            };
          }, this);
        }, this);
      },
      getViewLabels: function getViewLabels() {
        return d(this).labels;
      },
      getLabelModel: function getLabelModel() {
        return this.model.getModel("axisLabel");
      },
      getTickModel: function getTickModel() {
        return this.model.getModel("axisTick");
      },
      getBandWidth: function getBandWidth() {
        var e = this._extent,
            t = this.scale.getExtent(),
            n = t[1] - t[0] + (this.onBand ? 1 : 0);
        0 === n && (n = 1);
        var i = Math.abs(e[1] - e[0]);
        return Math.abs(i) / n;
      },
      isHorizontal: null,
      getRotate: null,
      calculateCategoryInterval: function calculateCategoryInterval() {
        return f(this);
      }
    };
    var m = g;
    e.exports = m;
  }, function (e, t, n) {
    var i = n(1),
        r = i.retrieve,
        o = i.defaults,
        a = i.extend,
        s = i.each,
        l = n(15),
        u = n(5),
        c = n(22),
        h = n(6),
        d = h.isRadianAroundZero,
        f = h.remRadian,
        p = n(40).createSymbol,
        g = n(31),
        v = n(16).applyTransform,
        m = n(43).shouldShowAllLabels,
        y = Math.PI,
        x = function x(e, t) {
      this.opt = t, this.axisModel = e, o(t, {
        labelOffset: 0,
        nameDirection: 1,
        tickDirection: 1,
        labelDirection: 1,
        silent: !0
      }), this.group = new u.Group();
      var n = new u.Group({
        position: t.position.slice(),
        rotation: t.rotation
      });
      n.updateTransform(), this._transform = n.transform, this._dumbGroup = n;
    };

    x.prototype = {
      constructor: x,
      hasBuilder: function hasBuilder(e) {
        return !!_[e];
      },
      add: function add(e) {
        _[e].call(this);
      },
      getGroup: function getGroup() {
        return this.group;
      }
    };

    var _ = {
      axisLine: function axisLine() {
        var e = this.opt,
            t = this.axisModel;

        if (t.get("axisLine.show")) {
          var n = this.axisModel.axis.getExtent(),
              i = this._transform,
              r = [n[0], 0],
              o = [n[1], 0];
          i && (v(r, r, i), v(o, o, i));
          var l = a({
            lineCap: "round"
          }, t.getModel("axisLine.lineStyle").getLineStyle());
          this.group.add(new u.Line({
            anid: "line",
            subPixelOptimize: !0,
            shape: {
              x1: r[0],
              y1: r[1],
              x2: o[0],
              y2: o[1]
            },
            style: l,
            strokeContainThreshold: e.strokeContainThreshold || 5,
            silent: !0,
            z2: 1
          }));
          var c = t.get("axisLine.symbol"),
              h = t.get("axisLine.symbolSize"),
              d = t.get("axisLine.symbolOffset") || 0;

          if ("number" == typeof d && (d = [d, d]), null != c) {
            "string" == typeof c && (c = [c, c]), "string" != typeof h && "number" != typeof h || (h = [h, h]);
            var f = h[0],
                g = h[1];
            s([{
              rotate: e.rotation + Math.PI / 2,
              offset: d[0],
              r: 0
            }, {
              rotate: e.rotation - Math.PI / 2,
              offset: d[1],
              r: Math.sqrt((r[0] - o[0]) * (r[0] - o[0]) + (r[1] - o[1]) * (r[1] - o[1]))
            }], function (t, n) {
              if ("none" !== c[n] && null != c[n]) {
                var i = p(c[n], -f / 2, -g / 2, f, g, l.stroke, !0),
                    o = t.r + t.offset,
                    a = [r[0] + o * Math.cos(e.rotation), r[1] - o * Math.sin(e.rotation)];
                i.attr({
                  rotation: t.rotate,
                  position: a,
                  silent: !0,
                  z2: 11
                }), this.group.add(i);
              }
            }, this);
          }
        }
      },
      axisTickLabel: function axisTickLabel() {
        var e = this.axisModel,
            t = this.opt,
            n = function (e, t, n) {
          var i = t.axis,
              r = t.getModel("axisTick");
          if (!r.get("show") || i.scale.isBlank()) return;

          for (var a = r.getModel("lineStyle"), s = n.tickDirection * r.get("length"), l = M(i.getTicksCoords(), e._transform, s, o(a.getLineStyle(), {
            stroke: t.get("axisLine.lineStyle.color")
          }), "ticks"), u = 0; u < l.length; u++) {
            e.group.add(l[u]);
          }

          return l;
        }(this, e, t),
            i = function (e, t, n) {
          var i = t.axis;
          if (!r(n.axisLabelShow, t.get("axisLabel.show")) || i.scale.isBlank()) return;
          var o = t.getModel("axisLabel"),
              a = o.get("margin"),
              l = i.getViewLabels(),
              h = (r(n.labelRotate, o.get("rotate")) || 0) * y / 180,
              d = w(n.rotation, h, n.labelDirection),
              f = t.getCategories && t.getCategories(!0),
              p = [],
              g = S(t),
              v = t.get("triggerEvent");
          return s(l, function (r, s) {
            var l = r.tickValue,
                h = r.formattedLabel,
                m = r.rawLabel,
                y = o;
            f && f[l] && f[l].textStyle && (y = new c(f[l].textStyle, o, t.ecModel));
            var x = y.getTextColor() || t.get("axisLine.lineStyle.color"),
                _ = [i.dataToCoord(l), n.labelOffset + n.labelDirection * a],
                w = new u.Text({
              anid: "label_" + l,
              position: _,
              rotation: d.rotation,
              silent: g,
              z2: 10
            });
            u.setTextStyle(w.style, y, {
              text: h,
              textAlign: y.getShallow("align", !0) || d.textAlign,
              textVerticalAlign: y.getShallow("verticalAlign", !0) || y.getShallow("baseline", !0) || d.textVerticalAlign,
              textFill: "function" == typeof x ? x("category" === i.type ? m : "value" === i.type ? l + "" : l, s) : x
            }), v && (w.eventData = b(t), w.eventData.targetType = "axisLabel", w.eventData.value = m), e._dumbGroup.add(w), w.updateTransform(), p.push(w), e.group.add(w), w.decomposeTransform();
          }), p;
        }(this, e, t);

        !function (e, t, n) {
          if (m(e.axis)) return;
          var i = e.get("axisLabel.showMinLabel"),
              r = e.get("axisLabel.showMaxLabel");
          n = n || [];
          var o = (t = t || [])[0],
              a = t[1],
              s = t[t.length - 1],
              l = t[t.length - 2],
              u = n[0],
              c = n[1],
              h = n[n.length - 1],
              d = n[n.length - 2];
          !1 === i ? (T(o), T(u)) : C(o, a) && (i ? (T(a), T(c)) : (T(o), T(u)));
          !1 === r ? (T(s), T(h)) : C(l, s) && (r ? (T(l), T(d)) : (T(s), T(h)));
        }(e, i, n), function (e, t, n) {
          var i = t.axis,
              r = t.getModel("minorTick");
          if (!r.get("show") || i.scale.isBlank()) return;
          var a = i.getMinorTicksCoords();
          if (!a.length) return;

          for (var s = r.getModel("lineStyle"), l = n.tickDirection * r.get("length"), u = o(s.getLineStyle(), o(t.getModel("axisTick").getLineStyle(), {
            stroke: t.get("axisLine.lineStyle.color")
          })), c = 0; c < a.length; c++) {
            for (var h = M(a[c], e._transform, l, u, "minorticks_" + c), d = 0; d < h.length; d++) {
              e.group.add(h[d]);
            }
          }
        }(this, e, t);
      },
      axisName: function axisName() {
        var e = this.opt,
            t = this.axisModel,
            n = r(e.axisName, t.get("name"));

        if (n) {
          var i,
              o,
              s = t.get("nameLocation"),
              c = e.nameDirection,
              h = t.getModel("nameTextStyle"),
              p = t.get("nameGap") || 0,
              g = this.axisModel.axis.getExtent(),
              v = g[0] > g[1] ? -1 : 1,
              m = ["start" === s ? g[0] - v * p : "end" === s ? g[1] + v * p : (g[0] + g[1]) / 2, k(s) ? e.labelOffset + c * p : 0],
              x = t.get("nameRotate");
          null != x && (x = x * y / 180), k(s) ? i = w(e.rotation, null != x ? x : e.rotation, c) : (i = function (e, t, n, i) {
            var r,
                o,
                a = f(n - e.rotation),
                s = i[0] > i[1],
                l = "start" === t && !s || "start" !== t && s;
            d(a - y / 2) ? (o = l ? "bottom" : "top", r = "center") : d(a - 1.5 * y) ? (o = l ? "top" : "bottom", r = "center") : (o = "middle", r = a < 1.5 * y && a > y / 2 ? l ? "left" : "right" : l ? "right" : "left");
            return {
              rotation: a,
              textAlign: r,
              textVerticalAlign: o
            };
          }(e, s, x || 0, g), null != (o = e.axisNameAvailableWidth) && (o = Math.abs(o / Math.sin(i.rotation)), !isFinite(o) && (o = null)));

          var _ = h.getFont(),
              T = t.get("nameTruncate", !0) || {},
              C = T.ellipsis,
              M = r(e.nameTruncateMaxWidth, T.maxWidth, o),
              E = null != C && null != M ? l.truncateText(n, M, _, C, {
            minChar: 2,
            placeholder: T.placeholder
          }) : n,
              A = t.get("tooltip", !0),
              I = t.mainType,
              P = {
            componentType: I,
            name: n,
            $vars: ["name"]
          };

          P[I + "Index"] = t.componentIndex;
          var O = new u.Text({
            anid: "name",
            __fullText: n,
            __truncatedText: E,
            position: m,
            rotation: i.rotation,
            silent: S(t),
            z2: 1,
            tooltip: A && A.show ? a({
              content: n,
              formatter: function formatter() {
                return n;
              },
              formatterParams: P
            }, A) : null
          });
          u.setTextStyle(O.style, h, {
            text: E,
            textFont: _,
            textFill: h.getTextColor() || t.get("axisLine.lineStyle.color"),
            textAlign: h.get("align") || i.textAlign,
            textVerticalAlign: h.get("verticalAlign") || i.textVerticalAlign
          }), t.get("triggerEvent") && (O.eventData = b(t), O.eventData.targetType = "axisName", O.eventData.name = n), this._dumbGroup.add(O), O.updateTransform(), this.group.add(O), O.decomposeTransform();
        }
      }
    },
        b = x.makeAxisEventDataBase = function (e) {
      var t = {
        componentType: e.mainType,
        componentIndex: e.componentIndex
      };
      return t[e.mainType + "Index"] = e.componentIndex, t;
    },
        w = x.innerTextLayout = function (e, t, n) {
      var i,
          r,
          o = f(t - e);
      return d(o) ? (r = n > 0 ? "top" : "bottom", i = "center") : d(o - y) ? (r = n > 0 ? "bottom" : "top", i = "center") : (r = "middle", i = o > 0 && o < y ? n > 0 ? "right" : "left" : n > 0 ? "left" : "right"), {
        rotation: o,
        textAlign: i,
        textVerticalAlign: r
      };
    };

    var S = x.isLabelSilent = function (e) {
      var t = e.get("tooltip");
      return e.get("silent") || !(e.get("triggerEvent") || t && t.show);
    };

    function T(e) {
      e && (e.ignore = !0);
    }

    function C(e, t, n) {
      var i = e && e.getBoundingRect().clone(),
          r = t && t.getBoundingRect().clone();

      if (i && r) {
        var o = g.identity([]);
        return g.rotate(o, o, -e.rotation), i.applyTransform(g.mul([], o, e.getLocalTransform())), r.applyTransform(g.mul([], o, t.getLocalTransform())), i.intersect(r);
      }
    }

    function k(e) {
      return "middle" === e || "center" === e;
    }

    function M(e, t, n, i, r) {
      for (var o = [], a = [], s = [], l = 0; l < e.length; l++) {
        var c = e[l].coord;
        a[0] = c, a[1] = 0, s[0] = c, s[1] = n, t && (v(a, a, t), v(s, s, t));
        var h = new u.Line({
          anid: r + "_" + e[l].tickValue,
          subPixelOptimize: !0,
          shape: {
            x1: a[0],
            y1: a[1],
            x2: s[0],
            y2: s[1]
          },
          style: i,
          z2: 2,
          silent: !0
        });
        o.push(h);
      }

      return o;
    }

    var E = x;
    e.exports = E;
  }, function (e, t) {
    var n = {};
    t.register = function (e, t) {
      n[e] = t;
    }, t.get = function (e) {
      return n[e];
    };
  }, function (e, t, n) {
    "use strict";

    var i = function i() {};

    e.exports = i;
  }, function (e, t) {
    e.exports = function (e, t) {
      return {
        enumerable: !(1 & e),
        configurable: !(2 & e),
        writable: !(4 & e),
        value: t
      };
    };
  }, function (e, t) {
    var n = 0,
        i = Math.random();

    e.exports = function (e) {
      return "Symbol(".concat(void 0 === e ? "" : e, ")_", (++n + i).toString(36));
    };
  }, function (e, t) {
    e.exports = !1;
  }, function (e, t, n) {
    var i = n(242),
        r = n(174);

    e.exports = Object.keys || function (e) {
      return i(e, r);
    };
  }, function (e, t, n) {
    var i = n(47),
        r = Math.max,
        o = Math.min;

    e.exports = function (e, t) {
      return (e = i(e)) < 0 ? r(e + t, 0) : o(e, t);
    };
  }, function (e, t, n) {
    var i = n(12),
        r = n(243),
        o = n(174),
        a = n(173)("IE_PROTO"),
        s = function s() {},
        _l2 = function l() {
      var e,
          t = n(171)("iframe"),
          i = o.length;

      for (t.style.display = "none", n(175).appendChild(t), t.src = "javascript:", (e = t.contentWindow.document).open(), e.write("<script>document.F=Object<\/script>"), e.close(), _l2 = e.F; i--;) {
        delete _l2.prototype[o[i]];
      }

      return _l2();
    };

    e.exports = Object.create || function (e, t) {
      var n;
      return null !== e ? (s.prototype = i(e), n = new s(), s.prototype = null, n[a] = e) : n = _l2(), void 0 === t ? n : r(n, t);
    };
  }, function (e, t, n) {
    var i = n(242),
        r = n(174).concat("length", "prototype");

    t.f = Object.getOwnPropertyNames || function (e) {
      return i(e, r);
    };
  }, function (e, t, n) {
    var i = n(36),
        r = n(30),
        o = n(173)("IE_PROTO"),
        a = Object.prototype;

    e.exports = Object.getPrototypeOf || function (e) {
      return e = r(e), i(e, o) ? e[o] : "function" == typeof e.constructor && e instanceof e.constructor ? e.constructor.prototype : e instanceof Object ? a : null;
    };
  }, function (e, t, n) {
    var i = n(18)("unscopables"),
        r = Array.prototype;
    null == r[i] && n(37)(r, i, {}), e.exports = function (e) {
      r[i][e] = !0;
    };
  }, function (e, t, n) {
    var i = n(13);

    e.exports = function (e, t) {
      if (!i(e) || e._t !== t) throw TypeError("Incompatible receiver, " + t + " required!");
      return e;
    };
  }, function (e, t) {
    var n = Array.prototype.slice,
        i = function i(e) {
      this._$handlers = {}, this._$eventProcessor = e;
    };

    function r(e, t, n, i, r, o) {
      var a = e._$handlers;
      if ("function" == typeof n && (r = i, i = n, n = null), !i || !t) return e;
      n = function (e, t) {
        var n = e._$eventProcessor;
        return null != t && n && n.normalizeQuery && (t = n.normalizeQuery(t)), t;
      }(e, n), a[t] || (a[t] = []);

      for (var s = 0; s < a[t].length; s++) {
        if (a[t][s].h === i) return e;
      }

      var l = {
        h: i,
        one: o,
        query: n,
        ctx: r || e,
        callAtLast: i.zrEventfulCallAtLast
      },
          u = a[t].length - 1,
          c = a[t][u];
      return c && c.callAtLast ? a[t].splice(u, 0, l) : a[t].push(l), e;
    }

    i.prototype = {
      constructor: i,
      one: function one(e, t, n, i) {
        return r(this, e, t, n, i, !0);
      },
      on: function on(e, t, n, i) {
        return r(this, e, t, n, i, !1);
      },
      isSilent: function isSilent(e) {
        var t = this._$handlers;
        return !t[e] || !t[e].length;
      },
      off: function off(e, t) {
        var n = this._$handlers;
        if (!e) return this._$handlers = {}, this;

        if (t) {
          if (n[e]) {
            for (var i = [], r = 0, o = n[e].length; r < o; r++) {
              n[e][r].h !== t && i.push(n[e][r]);
            }

            n[e] = i;
          }

          n[e] && 0 === n[e].length && delete n[e];
        } else delete n[e];

        return this;
      },
      trigger: function trigger(e) {
        var t = this._$handlers[e],
            i = this._$eventProcessor;

        if (t) {
          var r = arguments,
              o = r.length;
          o > 3 && (r = n.call(r, 1));

          for (var a = t.length, s = 0; s < a;) {
            var l = t[s];
            if (i && i.filter && null != l.query && !i.filter(e, l.query)) s++;else {
              switch (o) {
                case 1:
                  l.h.call(l.ctx);
                  break;

                case 2:
                  l.h.call(l.ctx, r[1]);
                  break;

                case 3:
                  l.h.call(l.ctx, r[1], r[2]);
                  break;

                default:
                  l.h.apply(l.ctx, r);
              }

              l.one ? (t.splice(s, 1), a--) : s++;
            }
          }
        }

        return i && i.afterTrigger && i.afterTrigger(e), this;
      },
      triggerWithContext: function triggerWithContext(e) {
        var t = this._$handlers[e],
            i = this._$eventProcessor;

        if (t) {
          var r = arguments,
              o = r.length;
          o > 4 && (r = n.call(r, 1, r.length - 1));

          for (var a = r[r.length - 1], s = t.length, l = 0; l < s;) {
            var u = t[l];
            if (i && i.filter && null != u.query && !i.filter(e, u.query)) l++;else {
              switch (o) {
                case 1:
                  u.h.call(a);
                  break;

                case 2:
                  u.h.call(a, r[1]);
                  break;

                case 3:
                  u.h.call(a, r[1], r[2]);
                  break;

                default:
                  u.h.apply(a, r);
              }

              u.one ? (t.splice(l, 1), s--) : l++;
            }
          }
        }

        return i && i.afterTrigger && i.afterTrigger(e), this;
      }
    };
    var o = i;
    e.exports = o;
  }, function (e, t, n) {
    var i = n(1),
        r = n(286),
        o = n(17),
        a = function a(e) {
      for (var t in e = e || {}, r.call(this, e), e) {
        e.hasOwnProperty(t) && (this[t] = e[t]);
      }

      this._children = [], this.__storage = null, this.__dirty = !0;
    };

    a.prototype = {
      constructor: a,
      isGroup: !0,
      type: "group",
      silent: !1,
      children: function children() {
        return this._children.slice();
      },
      childAt: function childAt(e) {
        return this._children[e];
      },
      childOfName: function childOfName(e) {
        for (var t = this._children, n = 0; n < t.length; n++) {
          if (t[n].name === e) return t[n];
        }
      },
      childCount: function childCount() {
        return this._children.length;
      },
      add: function add(e) {
        return e && e !== this && e.parent !== this && (this._children.push(e), this._doAdd(e)), this;
      },
      addBefore: function addBefore(e, t) {
        if (e && e !== this && e.parent !== this && t && t.parent === this) {
          var n = this._children,
              i = n.indexOf(t);
          i >= 0 && (n.splice(i, 0, e), this._doAdd(e));
        }

        return this;
      },
      _doAdd: function _doAdd(e) {
        e.parent && e.parent.remove(e), e.parent = this;
        var t = this.__storage,
            n = this.__zr;
        t && t !== e.__storage && (t.addToStorage(e), e instanceof a && e.addChildrenToStorage(t)), n && n.refresh();
      },
      remove: function remove(e) {
        var t = this.__zr,
            n = this.__storage,
            r = this._children,
            o = i.indexOf(r, e);
        return o < 0 || (r.splice(o, 1), e.parent = null, n && (n.delFromStorage(e), e instanceof a && e.delChildrenFromStorage(n)), t && t.refresh()), this;
      },
      removeAll: function removeAll() {
        var e,
            t,
            n = this._children,
            i = this.__storage;

        for (t = 0; t < n.length; t++) {
          e = n[t], i && (i.delFromStorage(e), e instanceof a && e.delChildrenFromStorage(i)), e.parent = null;
        }

        return n.length = 0, this;
      },
      eachChild: function eachChild(e, t) {
        for (var n = this._children, i = 0; i < n.length; i++) {
          var r = n[i];
          e.call(t, r, i);
        }

        return this;
      },
      traverse: function traverse(e, t) {
        for (var n = 0; n < this._children.length; n++) {
          var i = this._children[n];
          e.call(t, i), "group" === i.type && i.traverse(e, t);
        }

        return this;
      },
      addChildrenToStorage: function addChildrenToStorage(e) {
        for (var t = 0; t < this._children.length; t++) {
          var n = this._children[t];
          e.addToStorage(n), n instanceof a && n.addChildrenToStorage(e);
        }
      },
      delChildrenFromStorage: function delChildrenFromStorage(e) {
        for (var t = 0; t < this._children.length; t++) {
          var n = this._children[t];
          e.delFromStorage(n), n instanceof a && n.delChildrenFromStorage(e);
        }
      },
      dirty: function dirty() {
        return this.__dirty = !0, this.__zr && this.__zr.refresh(), this;
      },
      getBoundingRect: function getBoundingRect(e) {
        for (var t = null, n = new o(0, 0, 0, 0), i = e || this._children, r = [], a = 0; a < i.length; a++) {
          var s = i[a];

          if (!s.ignore && !s.invisible) {
            var l = s.getBoundingRect(),
                u = s.getLocalTransform(r);
            u ? (n.copy(l), n.applyTransform(u), (t = t || n.clone()).union(n)) : (t = t || l.clone()).union(l);
          }
        }

        return t || n;
      }
    }, i.inherits(a, r);
    var s = a;
    e.exports = s;
  }, function (e, t, n) {
    var i = n(119),
        r = n(1),
        o = n(35),
        a = n(156),
        s = n(155).ContextCachedBy,
        l = function l(e) {
      i.call(this, e);
    };

    l.prototype = {
      constructor: l,
      type: "text",
      brush: function brush(e, t) {
        var n = this.style;
        this.__dirty && a.normalizeTextStyle(n, !0), n.fill = n.stroke = n.shadowBlur = n.shadowColor = n.shadowOffsetX = n.shadowOffsetY = null;
        var i = n.text;
        null != i && (i += ""), a.needDrawText(i, n) ? (this.setTransform(e), a.renderText(this, e, i, n, null, t), this.restoreTransform(e)) : e.__attrCachedBy = s.NONE;
      },
      getBoundingRect: function getBoundingRect() {
        var e = this.style;

        if (this.__dirty && a.normalizeTextStyle(e, !0), !this._rect) {
          var t = e.text;
          null != t ? t += "" : t = "";
          var n = o.getBoundingRect(e.text + "", e.font, e.textAlign, e.textVerticalAlign, e.textPadding, e.textLineHeight, e.rich);

          if (n.x += e.x || 0, n.y += e.y || 0, a.getStroke(e.textStroke, e.textStrokeWidth)) {
            var i = e.textStrokeWidth;
            n.x -= i / 2, n.y -= i / 2, n.width += i, n.height += i;
          }

          this._rect = n;
        }

        return this._rect;
      }
    }, r.inherits(l, i);
    var u = l;
    e.exports = u;
  }, function (e, t, n) {
    n(9).__DEV__;
    var i = n(1),
        r = (i.isTypedArray, i.extend),
        o = (i.assert, i.each),
        a = i.isObject,
        s = n(8),
        l = s.getDataItemValue,
        u = s.isDataItemOption,
        c = n(6).parseDate,
        h = n(122),
        d = n(123),
        f = d.SOURCE_FORMAT_TYPED_ARRAY,
        p = d.SOURCE_FORMAT_ARRAY_ROWS,
        g = d.SOURCE_FORMAT_ORIGINAL,
        v = d.SOURCE_FORMAT_OBJECT_ROWS;

    function m(e, t) {
      h.isInstance(e) || (e = h.seriesDataToSource(e)), this._source = e;
      var n = this._data = e.data,
          i = e.sourceFormat;
      i === f && (this._offset = 0, this._dimSize = t, this._data = n);
      var o = x[i === p ? i + "_" + e.seriesLayoutBy : i];
      r(this, o);
    }

    var y = m.prototype;
    y.pure = !1, y.persistent = !0, y.getSource = function () {
      return this._source;
    };
    var x = {
      arrayRows_column: {
        pure: !0,
        count: function count() {
          return Math.max(0, this._data.length - this._source.startIndex);
        },
        getItem: function getItem(e) {
          return this._data[e + this._source.startIndex];
        },
        appendData: w
      },
      arrayRows_row: {
        pure: !0,
        count: function count() {
          var e = this._data[0];
          return e ? Math.max(0, e.length - this._source.startIndex) : 0;
        },
        getItem: function getItem(e) {
          e += this._source.startIndex;

          for (var t = [], n = this._data, i = 0; i < n.length; i++) {
            var r = n[i];
            t.push(r ? r[e] : null);
          }

          return t;
        },
        appendData: function appendData() {
          throw new Error('Do not support appendData when set seriesLayoutBy: "row".');
        }
      },
      objectRows: {
        pure: !0,
        count: _,
        getItem: b,
        appendData: w
      },
      keyedColumns: {
        pure: !0,
        count: function count() {
          var e = this._source.dimensionsDefine[0].name,
              t = this._data[e];
          return t ? t.length : 0;
        },
        getItem: function getItem(e) {
          for (var t = [], n = this._source.dimensionsDefine, i = 0; i < n.length; i++) {
            var r = this._data[n[i].name];
            t.push(r ? r[e] : null);
          }

          return t;
        },
        appendData: function appendData(e) {
          var t = this._data;
          o(e, function (e, n) {
            for (var i = t[n] || (t[n] = []), r = 0; r < (e || []).length; r++) {
              i.push(e[r]);
            }
          });
        }
      },
      original: {
        count: _,
        getItem: b,
        appendData: w
      },
      typedArray: {
        persistent: !1,
        pure: !0,
        count: function count() {
          return this._data ? this._data.length / this._dimSize : 0;
        },
        getItem: function getItem(e, t) {
          e -= this._offset, t = t || [];

          for (var n = this._dimSize * e, i = 0; i < this._dimSize; i++) {
            t[i] = this._data[n + i];
          }

          return t;
        },
        appendData: function appendData(e) {
          this._data = e;
        },
        clean: function clean() {
          this._offset += this.count(), this._data = null;
        }
      }
    };

    function _() {
      return this._data.length;
    }

    function b(e) {
      return this._data[e];
    }

    function w(e) {
      for (var t = 0; t < e.length; t++) {
        this._data.push(e[t]);
      }
    }

    var S = {
      arrayRows: T,
      objectRows: function objectRows(e, t, n, i) {
        return null != n ? e[i] : e;
      },
      keyedColumns: T,
      original: function original(e, t, n, i) {
        var r = l(e);
        return null != n && r instanceof Array ? r[n] : r;
      },
      typedArray: T
    };

    function T(e, t, n, i) {
      return null != n ? e[n] : e;
    }

    var C = {
      arrayRows: k,
      objectRows: function objectRows(e, t, n, i) {
        return M(e[t], this._dimensionInfos[t]);
      },
      keyedColumns: k,
      original: function original(e, t, n, i) {
        var r = e && (null == e.value ? e : e.value);
        return !this._rawData.pure && u(e) && (this.hasItemOption = !0), M(r instanceof Array ? r[i] : r, this._dimensionInfos[t]);
      },
      typedArray: function typedArray(e, t, n, i) {
        return e[i];
      }
    };

    function k(e, t, n, i) {
      return M(e[i], this._dimensionInfos[t]);
    }

    function M(e, t) {
      var n = t && t.type;

      if ("ordinal" === n) {
        var i = t && t.ordinalMeta;
        return i ? i.parseAndCollect(e) : e;
      }

      return "time" === n && "number" != typeof e && null != e && "-" !== e && (e = +c(e)), null == e || "" === e ? NaN : +e;
    }

    t.DefaultDataProvider = m, t.defaultDimValueGetters = C, t.retrieveRawValue = function (e, t, n) {
      if (e) {
        var i = e.getRawDataItem(t);

        if (null != i) {
          var r,
              o,
              a = e.getProvider().getSource().sourceFormat,
              s = e.getDimensionInfo(n);
          return s && (r = s.name, o = s.index), S[a](i, t, o, r);
        }
      }
    }, t.retrieveRawAttr = function (e, t, n) {
      if (e) {
        var i = e.getProvider().getSource().sourceFormat;

        if (i === g || i === v) {
          var r = e.getRawDataItem(t);
          return i !== g || a(r) || (r = null), r ? r[n] : void 0;
        }
      }
    };
  }, function (e, t) {
    function n(e) {
      return e;
    }

    function i(e, t, i, r, o) {
      this._old = e, this._new = t, this._oldKeyGetter = i || n, this._newKeyGetter = r || n, this.context = o;
    }

    function r(e, t, n, i, r) {
      for (var o = 0; o < e.length; o++) {
        var a = "_ec_" + r[i](e[o], o),
            s = t[a];
        null == s ? (n.push(a), t[a] = o) : (s.length || (t[a] = s = [s]), s.push(o));
      }
    }

    i.prototype = {
      constructor: i,
      add: function add(e) {
        return this._add = e, this;
      },
      update: function update(e) {
        return this._update = e, this;
      },
      remove: function remove(e) {
        return this._remove = e, this;
      },
      execute: function execute() {
        var e = this._old,
            t = this._new,
            n = {},
            i = [],
            o = [];

        for (r(e, {}, i, "_oldKeyGetter", this), r(t, n, o, "_newKeyGetter", this), a = 0; a < e.length; a++) {
          if (null != (l = n[s = i[a]])) (c = l.length) ? (1 === c && (n[s] = null), l = l.shift()) : n[s] = null, this._update && this._update(l, a);else this._remove && this._remove(a);
        }

        for (var a = 0; a < o.length; a++) {
          var s = o[a];

          if (n.hasOwnProperty(s)) {
            var l;
            if (null == (l = n[s])) continue;
            if (l.length) for (var u = 0, c = l.length; u < c; u++) {
              this._add && this._add(l[u]);
            } else this._add && this._add(l);
          }
        }
      }
    };
    var o = i;
    e.exports = o;
  }, function (e, t, n) {
    var i = n(1).isFunction;

    e.exports = function (e, t, n) {
      return {
        seriesType: e,
        performRawSeries: !0,
        reset: function reset(e, r, o) {
          var a = e.getData(),
              s = e.get("symbol"),
              l = e.get("symbolSize"),
              u = e.get("symbolKeepAspect"),
              c = e.get("symbolRotate"),
              h = i(s),
              d = i(l),
              f = i(c),
              p = h || d || f,
              g = !h && s ? s : t,
              v = d ? null : l;
          if (a.setVisual({
            legendSymbol: n || g,
            symbol: g,
            symbolSize: v,
            symbolKeepAspect: u,
            symbolRotate: c
          }), !r.isSeriesFiltered(e)) return {
            dataEach: a.hasItemOption || p ? function (t, n) {
              if (p) {
                var i = e.getRawValue(n),
                    r = e.getDataParams(n);
                h && t.setItemVisual(n, "symbol", s(i, r)), d && t.setItemVisual(n, "symbolSize", l(i, r)), f && t.setItemVisual(n, "symbolRotate", c(i, r));
              }

              if (t.hasItemOption) {
                var o = t.getItemModel(n),
                    a = o.getShallow("symbol", !0),
                    u = o.getShallow("symbolSize", !0),
                    g = o.getShallow("symbolRotate", !0),
                    v = o.getShallow("symbolKeepAspect", !0);
                null != a && t.setItemVisual(n, "symbol", a), null != u && t.setItemVisual(n, "symbolSize", u), null != g && t.setItemVisual(n, "symbolRotate", g), null != v && t.setItemVisual(n, "symbolKeepAspect", v);
              }
            } : null
          };
        }
      };
    };
  }, function (e, t, n) {
    n(9).__DEV__;
    var i = n(4),
        r = n(164),
        o = i.extendComponentView({
      type: "axis",
      _axisPointer: null,
      axisPointerClass: null,
      render: function render(e, t, n, i) {
        this.axisPointerClass && r.fixValue(e), o.superApply(this, "render", arguments), a(this, e, t, n, i, !0);
      },
      updateAxisPointer: function updateAxisPointer(e, t, n, i, r) {
        a(this, e, t, n, i, !1);
      },
      remove: function remove(e, t) {
        var n = this._axisPointer;
        n && n.remove(t), o.superApply(this, "remove", arguments);
      },
      dispose: function dispose(e, t) {
        s(this, t), o.superApply(this, "dispose", arguments);
      }
    });

    function a(e, t, n, i, a, l) {
      var u = o.getAxisPointerClass(e.axisPointerClass);

      if (u) {
        var c = r.getAxisPointerModel(t);
        c ? (e._axisPointer || (e._axisPointer = new u())).render(t, c, i, l) : s(e, i);
      }
    }

    function s(e, t, n) {
      var i = e._axisPointer;
      i && i.dispose(t, n), e._axisPointer = null;
    }

    var l = [];
    o.registerAxisPointerClass = function (e, t) {
      l[e] = t;
    }, o.getAxisPointerClass = function (e) {
      return e && l[e];
    };
    var u = o;
    e.exports = u;
  }, function (e, t, n) {
    var i = n(1);

    function r(e) {
      for (var t = []; e;) {
        (e = e.parentNode) && t.push(e);
      }

      return t.reverse();
    }

    t.retrieveTargetInfo = function (e, t, n) {
      if (e && i.indexOf(t, e.type) >= 0) {
        var r = n.getData().tree.root,
            o = e.targetNode;
        if ("string" == typeof o && (o = r.getNodeById(o)), o && r.contains(o)) return {
          node: o
        };
        var a = e.targetNodeId;
        if (null != a && (o = r.getNodeById(a))) return {
          node: o
        };
      }
    }, t.getPathToRoot = r, t.aboveViewRoot = function (e, t) {
      var n = r(e);
      return i.indexOf(n, t) >= 0;
    }, t.wrapTreePathInfo = function (e, t) {
      for (var n = []; e;) {
        var i = e.dataIndex;
        n.push({
          name: e.name,
          dataIndex: i,
          value: t.getRawValue(i)
        }), e = e.parentNode;
      }

      return n.reverse(), n;
    };
  }, function (e, t, n) {
    var i = n(1),
        r = n(53),
        o = n(6).linearMap,
        a = i.each,
        s = i.isObject,
        l = function l(e) {
      var t = e.mappingMethod,
          n = e.type,
          r = this.option = i.clone(e);
      this.type = n, this.mappingMethod = t, this._normalizeData = x[t];
      var o = u[n];
      this.applyVisual = o.applyVisual, this.getColorMapper = o.getColorMapper, this._doMap = o._doMap[t], "piecewise" === t ? (c(r), function (e) {
        var t = e.pieceList;
        e.hasSpecialVisual = !1, i.each(t, function (t, n) {
          t.originIndex = n, null != t.visual && (e.hasSpecialVisual = !0);
        });
      }(r)) : "category" === t ? r.categories ? function (e) {
        var t = e.categories,
            n = e.visual,
            r = e.categoryMap = {};

        if (a(t, function (e, t) {
          r[e] = t;
        }), !i.isArray(n)) {
          var o = [];
          i.isObject(n) ? a(n, function (e, t) {
            var n = r[t];
            o[null != n ? n : -1] = e;
          }) : o[-1] = n, n = y(e, o);
        }

        for (var s = t.length - 1; s >= 0; s--) {
          null == n[s] && (delete r[t[s]], t.pop());
        }
      }(r) : c(r, !0) : (i.assert("linear" !== t || r.dataExtent), c(r));
    };

    l.prototype = {
      constructor: l,
      mapValueToVisual: function mapValueToVisual(e) {
        var t = this._normalizeData(e);

        return this._doMap(t, e);
      },
      getNormalizer: function getNormalizer() {
        return i.bind(this._normalizeData, this);
      }
    };
    var u = l.visualHandlers = {
      color: {
        applyVisual: f("color"),
        getColorMapper: function getColorMapper() {
          var e = this.option;
          return i.bind("category" === e.mappingMethod ? function (e, t) {
            return !t && (e = this._normalizeData(e)), p.call(this, e);
          } : function (t, n, i) {
            var o = !!i;
            return !n && (t = this._normalizeData(t)), i = r.fastLerp(t, e.parsedVisual, i), o ? i : r.stringify(i, "rgba");
          }, this);
        },
        _doMap: {
          linear: function linear(e) {
            return r.stringify(r.fastLerp(e, this.option.parsedVisual), "rgba");
          },
          category: p,
          piecewise: function piecewise(e, t) {
            var n = m.call(this, t);
            return null == n && (n = r.stringify(r.fastLerp(e, this.option.parsedVisual), "rgba")), n;
          },
          fixed: g
        }
      },
      colorHue: h(function (e, t) {
        return r.modifyHSL(e, t);
      }),
      colorSaturation: h(function (e, t) {
        return r.modifyHSL(e, null, t);
      }),
      colorLightness: h(function (e, t) {
        return r.modifyHSL(e, null, null, t);
      }),
      colorAlpha: h(function (e, t) {
        return r.modifyAlpha(e, t);
      }),
      opacity: {
        applyVisual: f("opacity"),
        _doMap: v([0, 1])
      },
      liftZ: {
        applyVisual: f("liftZ"),
        _doMap: {
          linear: g,
          category: g,
          piecewise: g,
          fixed: g
        }
      },
      symbol: {
        applyVisual: function applyVisual(e, t, n) {
          var r = this.mapValueToVisual(e);
          if (i.isString(r)) n("symbol", r);else if (s(r)) for (var o in r) {
            r.hasOwnProperty(o) && n(o, r[o]);
          }
        },
        _doMap: {
          linear: d,
          category: p,
          piecewise: function piecewise(e, t) {
            var n = m.call(this, t);
            return null == n && (n = d.call(this, e)), n;
          },
          fixed: g
        }
      },
      symbolSize: {
        applyVisual: f("symbolSize"),
        _doMap: v([0, 1])
      }
    };

    function c(e, t) {
      var n = e.visual,
          r = [];
      i.isObject(n) ? a(n, function (e) {
        r.push(e);
      }) : null != n && r.push(n);
      t || 1 !== r.length || {
        color: 1,
        symbol: 1
      }.hasOwnProperty(e.type) || (r[1] = r[0]), y(e, r);
    }

    function h(e) {
      return {
        applyVisual: function applyVisual(t, n, i) {
          t = this.mapValueToVisual(t), i("color", e(n("color"), t));
        },
        _doMap: v([0, 1])
      };
    }

    function d(e) {
      var t = this.option.visual;
      return t[Math.round(o(e, [0, 1], [0, t.length - 1], !0))] || {};
    }

    function f(e) {
      return function (t, n, i) {
        i(e, this.mapValueToVisual(t));
      };
    }

    function p(e) {
      var t = this.option.visual;
      return t[this.option.loop && -1 !== e ? e % t.length : e];
    }

    function g() {
      return this.option.visual[0];
    }

    function v(e) {
      return {
        linear: function linear(t) {
          return o(t, e, this.option.visual, !0);
        },
        category: p,
        piecewise: function piecewise(t, n) {
          var i = m.call(this, n);
          return null == i && (i = o(t, e, this.option.visual, !0)), i;
        },
        fixed: g
      };
    }

    function m(e) {
      var t = this.option,
          n = t.pieceList;

      if (t.hasSpecialVisual) {
        var i = n[l.findPieceIndex(e, n)];
        if (i && i.visual) return i.visual[this.type];
      }
    }

    function y(e, t) {
      return e.visual = t, "color" === e.type && (e.parsedVisual = i.map(t, function (e) {
        return r.parse(e);
      })), t;
    }

    var x = {
      linear: function linear(e) {
        return o(e, this.option.dataExtent, [0, 1], !0);
      },
      piecewise: function piecewise(e) {
        var t = this.option.pieceList,
            n = l.findPieceIndex(e, t, !0);
        if (null != n) return o(n, [0, t.length - 1], [0, 1], !0);
      },
      category: function category(e) {
        var t = this.option.categories ? this.option.categoryMap[e] : e;
        return null == t ? -1 : t;
      },
      fixed: i.noop
    };

    function _(e, t, n) {
      return e ? t <= n : t < n;
    }

    l.listVisualTypes = function () {
      var e = [];
      return i.each(u, function (t, n) {
        e.push(n);
      }), e;
    }, l.addVisualHandler = function (e, t) {
      u[e] = t;
    }, l.isValidType = function (e) {
      return u.hasOwnProperty(e);
    }, l.eachVisual = function (e, t, n) {
      i.isObject(e) ? i.each(e, t, n) : t.call(n, e);
    }, l.mapVisual = function (e, t, n) {
      var r,
          o = i.isArray(e) ? [] : i.isObject(e) ? {} : (r = !0, null);
      return l.eachVisual(e, function (e, i) {
        var a = t.call(n, e, i);
        r ? o = a : o[i] = a;
      }), o;
    }, l.retrieveVisuals = function (e) {
      var t,
          n = {};
      return e && a(u, function (i, r) {
        e.hasOwnProperty(r) && (n[r] = e[r], t = !0);
      }), t ? n : null;
    }, l.prepareVisualTypes = function (e) {
      if (s(e)) {
        var t = [];
        a(e, function (e, n) {
          t.push(n);
        }), e = t;
      } else {
        if (!i.isArray(e)) return [];
        e = e.slice();
      }

      return e.sort(function (e, t) {
        return "color" === t && "color" !== e && 0 === e.indexOf("color") ? 1 : -1;
      }), e;
    }, l.dependsOn = function (e, t) {
      return "color" === t ? !(!e || 0 !== e.indexOf(t)) : e === t;
    }, l.findPieceIndex = function (e, t, n) {
      for (var i, r = 1 / 0, o = 0, a = t.length; o < a; o++) {
        var s = t[o].value;

        if (null != s) {
          if (s === e || "string" == typeof s && s === e + "") return o;
          n && h(s, o);
        }
      }

      for (o = 0, a = t.length; o < a; o++) {
        var l = t[o],
            u = l.interval,
            c = l.close;

        if (u) {
          if (u[0] === -1 / 0) {
            if (_(c[1], e, u[1])) return o;
          } else if (u[1] === 1 / 0) {
            if (_(c[0], u[0], e)) return o;
          } else if (_(c[0], u[0], e) && _(c[1], e, u[1])) return o;

          n && h(u[0], o), n && h(u[1], o);
        }
      }

      if (n) return e === 1 / 0 ? t.length - 1 : e === -1 / 0 ? 0 : i;

      function h(t, n) {
        var o = Math.abs(t - e);
        o < r && (r = o, i = n);
      }
    };
    var b = l;
    e.exports = b;
  }, function (e, t, n) {
    var i = n(116),
        r = n(641),
        o = n(642),
        a = Math.max,
        s = Math.min;

    e.exports = function (e, t, n) {
      var l,
          u,
          c,
          h,
          d,
          f,
          p = 0,
          g = !1,
          v = !1,
          m = !0;
      if ("function" != typeof e) throw new TypeError("Expected a function");

      function y(t) {
        var n = l,
            i = u;
        return l = u = void 0, p = t, h = e.apply(i, n);
      }

      function x(e) {
        return p = e, d = setTimeout(b, t), g ? y(e) : h;
      }

      function _(e) {
        var n = e - f;
        return void 0 === f || n >= t || n < 0 || v && e - p >= c;
      }

      function b() {
        var e = r();
        if (_(e)) return w(e);
        d = setTimeout(b, function (e) {
          var n = t - (e - f);
          return v ? s(n, c - (e - p)) : n;
        }(e));
      }

      function w(e) {
        return d = void 0, m && l ? y(e) : (l = u = void 0, h);
      }

      function S() {
        var e = r(),
            n = _(e);

        if (l = arguments, u = this, f = e, n) {
          if (void 0 === d) return x(f);
          if (v) return clearTimeout(d), d = setTimeout(b, t), y(f);
        }

        return void 0 === d && (d = setTimeout(b, t)), h;
      }

      return t = o(t) || 0, i(n) && (g = !!n.leading, c = (v = "maxWait" in n) ? a(o(n.maxWait) || 0, t) : c, m = "trailing" in n ? !!n.trailing : m), S.cancel = function () {
        void 0 !== d && clearTimeout(d), p = 0, l = f = u = d = void 0;
      }, S.flush = function () {
        return void 0 === d ? h : w(r());
      }, S;
    };
  }, function (e, t, n) {
    var i = n(25).f,
        r = n(36),
        o = n(18)("toStringTag");

    e.exports = function (e, t, n) {
      e && !r(e = n ? e : e.prototype, o) && i(e, o, {
        configurable: !0,
        value: t
      });
    };
  }, function (e, t, n) {
    var i = n(3),
        r = n(58),
        o = n(11),
        a = n(177),
        s = "[" + a + "]",
        l = RegExp("^" + s + s + "*"),
        u = RegExp(s + s + "*$"),
        c = function c(e, t, n) {
      var r = {},
          s = o(function () {
        return !!a[e]() || "​" != "​"[e]();
      }),
          l = r[e] = s ? t(h) : a[e];
      n && (r[n] = l), i(i.P + i.F * s, "String", r);
    },
        h = c.trim = function (e, t) {
      return e = String(r(e)), 1 & t && (e = e.replace(l, "")), 2 & t && (e = e.replace(u, "")), e;
    };

    e.exports = c;
  }, function (e, t) {
    e.exports = {};
  }, function (e, t, n) {
    "use strict";

    var i = n(10),
        r = n(25),
        o = n(24),
        a = n(18)("species");

    e.exports = function (e) {
      var t = i[e];
      o && t && !t[a] && r.f(t, a, {
        configurable: !0,
        get: function get() {
          return this;
        }
      });
    };
  }, function (e, t) {
    e.exports = function (e, t, n, i) {
      if (!(e instanceof t) || void 0 !== i && i in e) throw TypeError(n + ": incorrect invocation!");
      return e;
    };
  }, function (e, t, n) {
    var i = n(33);

    e.exports = function (e, t, n) {
      for (var r in t) {
        i(e, r, t[r], n);
      }

      return e;
    };
  }, function (e, t, n) {
    var i = n(584),
        r = n(589);

    e.exports = function (e, t) {
      var n = r(e, t);
      return i(n) ? n : void 0;
    };
  }, function (e, t, n) {
    var i = n(119),
        r = n(17),
        o = n(1),
        a = n(205);

    function s(e) {
      i.call(this, e);
    }

    s.prototype = {
      constructor: s,
      type: "image",
      brush: function brush(e, t) {
        var n = this.style,
            i = n.image;
        n.bind(e, this, t);
        var r = this._image = a.createOrUpdateImage(i, this._image, this, this.onload);

        if (r && a.isImageReady(r)) {
          var o = n.x || 0,
              s = n.y || 0,
              l = n.width,
              u = n.height,
              c = r.width / r.height;

          if (null == l && null != u ? l = u * c : null == u && null != l ? u = l / c : null == l && null == u && (l = r.width, u = r.height), this.setTransform(e), n.sWidth && n.sHeight) {
            var h = n.sx || 0,
                d = n.sy || 0;
            e.drawImage(r, h, d, n.sWidth, n.sHeight, o, s, l, u);
          } else if (n.sx && n.sy) {
            var f = l - (h = n.sx),
                p = u - (d = n.sy);
            e.drawImage(r, h, d, f, p, o, s, l, u);
          } else e.drawImage(r, o, s, l, u);

          null != n.text && (this.restoreTransform(e), this.drawRectText(e, this.getBoundingRect()));
        }
      },
      getBoundingRect: function getBoundingRect() {
        var e = this.style;
        return this._rect || (this._rect = new r(e.x || 0, e.y || 0, e.width || 0, e.height || 0)), this._rect;
      }
    }, o.inherits(s, i);
    var l = s;
    e.exports = l;
  }, function (e, t, n) {
    var i = n(1);

    e.exports = function (e) {
      for (var t = 0; t < e.length; t++) {
        e[t][1] || (e[t][1] = e[t][0]);
      }

      return function (t, n, r) {
        for (var o = {}, a = 0; a < e.length; a++) {
          var s = e[a][1];

          if (!(n && i.indexOf(n, s) >= 0 || r && i.indexOf(r, s) < 0)) {
            var l = t.getShallow(s);
            null != l && (o[e[a][0]] = l);
          }
        }

        return o;
      };
    };
  }, function (e, t, n) {
    var i = n(66),
        r = n(16),
        o = n(120),
        a = n(17),
        s = n(154).devicePixelRatio,
        l = {
      M: 1,
      L: 2,
      C: 3,
      Q: 4,
      A: 5,
      Z: 6,
      R: 7
    },
        u = [],
        c = [],
        h = [],
        d = [],
        f = Math.min,
        p = Math.max,
        g = Math.cos,
        v = Math.sin,
        m = Math.sqrt,
        y = Math.abs,
        x = "undefined" != typeof Float32Array,
        _ = function _(e) {
      this._saveData = !e, this._saveData && (this.data = []), this._ctx = null;
    };

    _.prototype = {
      constructor: _,
      _xi: 0,
      _yi: 0,
      _x0: 0,
      _y0: 0,
      _ux: 0,
      _uy: 0,
      _len: 0,
      _lineDash: null,
      _dashOffset: 0,
      _dashIdx: 0,
      _dashSum: 0,
      setScale: function setScale(e, t, n) {
        n = n || 0, this._ux = y(n / s / e) || 0, this._uy = y(n / s / t) || 0;
      },
      getContext: function getContext() {
        return this._ctx;
      },
      beginPath: function beginPath(e) {
        return this._ctx = e, e && e.beginPath(), e && (this.dpr = e.dpr), this._saveData && (this._len = 0), this._lineDash && (this._lineDash = null, this._dashOffset = 0), this;
      },
      moveTo: function moveTo(e, t) {
        return this.addData(l.M, e, t), this._ctx && this._ctx.moveTo(e, t), this._x0 = e, this._y0 = t, this._xi = e, this._yi = t, this;
      },
      lineTo: function lineTo(e, t) {
        var n = y(e - this._xi) > this._ux || y(t - this._yi) > this._uy || this._len < 5;
        return this.addData(l.L, e, t), this._ctx && n && (this._needsDash() ? this._dashedLineTo(e, t) : this._ctx.lineTo(e, t)), n && (this._xi = e, this._yi = t), this;
      },
      bezierCurveTo: function bezierCurveTo(e, t, n, i, r, o) {
        return this.addData(l.C, e, t, n, i, r, o), this._ctx && (this._needsDash() ? this._dashedBezierTo(e, t, n, i, r, o) : this._ctx.bezierCurveTo(e, t, n, i, r, o)), this._xi = r, this._yi = o, this;
      },
      quadraticCurveTo: function quadraticCurveTo(e, t, n, i) {
        return this.addData(l.Q, e, t, n, i), this._ctx && (this._needsDash() ? this._dashedQuadraticTo(e, t, n, i) : this._ctx.quadraticCurveTo(e, t, n, i)), this._xi = n, this._yi = i, this;
      },
      arc: function arc(e, t, n, i, r, o) {
        return this.addData(l.A, e, t, n, n, i, r - i, 0, o ? 0 : 1), this._ctx && this._ctx.arc(e, t, n, i, r, o), this._xi = g(r) * n + e, this._yi = v(r) * n + t, this;
      },
      arcTo: function arcTo(e, t, n, i, r) {
        return this._ctx && this._ctx.arcTo(e, t, n, i, r), this;
      },
      rect: function rect(e, t, n, i) {
        return this._ctx && this._ctx.rect(e, t, n, i), this.addData(l.R, e, t, n, i), this;
      },
      closePath: function closePath() {
        this.addData(l.Z);
        var e = this._ctx,
            t = this._x0,
            n = this._y0;
        return e && (this._needsDash() && this._dashedLineTo(t, n), e.closePath()), this._xi = t, this._yi = n, this;
      },
      fill: function fill(e) {
        e && e.fill(), this.toStatic();
      },
      stroke: function stroke(e) {
        e && e.stroke(), this.toStatic();
      },
      setLineDash: function setLineDash(e) {
        if (e instanceof Array) {
          this._lineDash = e, this._dashIdx = 0;

          for (var t = 0, n = 0; n < e.length; n++) {
            t += e[n];
          }

          this._dashSum = t;
        }

        return this;
      },
      setLineDashOffset: function setLineDashOffset(e) {
        return this._dashOffset = e, this;
      },
      len: function len() {
        return this._len;
      },
      setData: function setData(e) {
        var t = e.length;
        this.data && this.data.length === t || !x || (this.data = new Float32Array(t));

        for (var n = 0; n < t; n++) {
          this.data[n] = e[n];
        }

        this._len = t;
      },
      appendPath: function appendPath(e) {
        e instanceof Array || (e = [e]);

        for (var t = e.length, n = 0, i = this._len, r = 0; r < t; r++) {
          n += e[r].len();
        }

        x && this.data instanceof Float32Array && (this.data = new Float32Array(i + n));

        for (r = 0; r < t; r++) {
          for (var o = e[r].data, a = 0; a < o.length; a++) {
            this.data[i++] = o[a];
          }
        }

        this._len = i;
      },
      addData: function addData(e) {
        if (this._saveData) {
          var t = this.data;
          this._len + arguments.length > t.length && (this._expandData(), t = this.data);

          for (var n = 0; n < arguments.length; n++) {
            t[this._len++] = arguments[n];
          }

          this._prevCmd = e;
        }
      },
      _expandData: function _expandData() {
        if (!(this.data instanceof Array)) {
          for (var e = [], t = 0; t < this._len; t++) {
            e[t] = this.data[t];
          }

          this.data = e;
        }
      },
      _needsDash: function _needsDash() {
        return this._lineDash;
      },
      _dashedLineTo: function _dashedLineTo(e, t) {
        var n,
            i,
            r = this._dashSum,
            o = this._dashOffset,
            a = this._lineDash,
            s = this._ctx,
            l = this._xi,
            u = this._yi,
            c = e - l,
            h = t - u,
            d = m(c * c + h * h),
            g = l,
            v = u,
            y = a.length;

        for (o < 0 && (o = r + o), g -= (o %= r) * (c /= d), v -= o * (h /= d); c > 0 && g <= e || c < 0 && g >= e || 0 === c && (h > 0 && v <= t || h < 0 && v >= t);) {
          g += c * (n = a[i = this._dashIdx]), v += h * n, this._dashIdx = (i + 1) % y, c > 0 && g < l || c < 0 && g > l || h > 0 && v < u || h < 0 && v > u || s[i % 2 ? "moveTo" : "lineTo"](c >= 0 ? f(g, e) : p(g, e), h >= 0 ? f(v, t) : p(v, t));
        }

        c = g - e, h = v - t, this._dashOffset = -m(c * c + h * h);
      },
      _dashedBezierTo: function _dashedBezierTo(e, t, n, r, o, a) {
        var s,
            l,
            u,
            c,
            h,
            d = this._dashSum,
            f = this._dashOffset,
            p = this._lineDash,
            g = this._ctx,
            v = this._xi,
            y = this._yi,
            x = i.cubicAt,
            _ = 0,
            b = this._dashIdx,
            w = p.length,
            S = 0;

        for (f < 0 && (f = d + f), f %= d, s = 0; s < 1; s += .1) {
          l = x(v, e, n, o, s + .1) - x(v, e, n, o, s), u = x(y, t, r, a, s + .1) - x(y, t, r, a, s), _ += m(l * l + u * u);
        }

        for (; b < w && !((S += p[b]) > f); b++) {
          ;
        }

        for (s = (S - f) / _; s <= 1;) {
          c = x(v, e, n, o, s), h = x(y, t, r, a, s), b % 2 ? g.moveTo(c, h) : g.lineTo(c, h), s += p[b] / _, b = (b + 1) % w;
        }

        b % 2 != 0 && g.lineTo(o, a), l = o - c, u = a - h, this._dashOffset = -m(l * l + u * u);
      },
      _dashedQuadraticTo: function _dashedQuadraticTo(e, t, n, i) {
        var r = n,
            o = i;
        n = (n + 2 * e) / 3, i = (i + 2 * t) / 3, e = (this._xi + 2 * e) / 3, t = (this._yi + 2 * t) / 3, this._dashedBezierTo(e, t, n, i, r, o);
      },
      toStatic: function toStatic() {
        var e = this.data;
        e instanceof Array && (e.length = this._len, x && (this.data = new Float32Array(e)));
      },
      getBoundingRect: function getBoundingRect() {
        u[0] = u[1] = h[0] = h[1] = Number.MAX_VALUE, c[0] = c[1] = d[0] = d[1] = -Number.MAX_VALUE;

        for (var e = this.data, t = 0, n = 0, i = 0, s = 0, f = 0; f < e.length;) {
          var p = e[f++];

          switch (1 === f && (i = t = e[f], s = n = e[f + 1]), p) {
            case l.M:
              t = i = e[f++], n = s = e[f++], h[0] = i, h[1] = s, d[0] = i, d[1] = s;
              break;

            case l.L:
              o.fromLine(t, n, e[f], e[f + 1], h, d), t = e[f++], n = e[f++];
              break;

            case l.C:
              o.fromCubic(t, n, e[f++], e[f++], e[f++], e[f++], e[f], e[f + 1], h, d), t = e[f++], n = e[f++];
              break;

            case l.Q:
              o.fromQuadratic(t, n, e[f++], e[f++], e[f], e[f + 1], h, d), t = e[f++], n = e[f++];
              break;

            case l.A:
              var m = e[f++],
                  y = e[f++],
                  x = e[f++],
                  _ = e[f++],
                  b = e[f++],
                  w = e[f++] + b;
              f += 1;
              var S = 1 - e[f++];
              1 === f && (i = g(b) * x + m, s = v(b) * _ + y), o.fromArc(m, y, x, _, b, w, S, h, d), t = g(w) * x + m, n = v(w) * _ + y;
              break;

            case l.R:
              i = t = e[f++], s = n = e[f++];
              var T = e[f++],
                  C = e[f++];
              o.fromLine(i, s, i + T, s + C, h, d);
              break;

            case l.Z:
              t = i, n = s;
          }

          r.min(u, u, h), r.max(c, c, d);
        }

        return 0 === f && (u[0] = u[1] = c[0] = c[1] = 0), new a(u[0], u[1], c[0] - u[0], c[1] - u[1]);
      },
      rebuildPath: function rebuildPath(e) {
        for (var t, n, i, r, o, a, s = this.data, u = this._ux, c = this._uy, h = this._len, d = 0; d < h;) {
          var f = s[d++];

          switch (1 === d && (t = i = s[d], n = r = s[d + 1]), f) {
            case l.M:
              t = i = s[d++], n = r = s[d++], e.moveTo(i, r);
              break;

            case l.L:
              o = s[d++], a = s[d++], (y(o - i) > u || y(a - r) > c || d === h - 1) && (e.lineTo(o, a), i = o, r = a);
              break;

            case l.C:
              e.bezierCurveTo(s[d++], s[d++], s[d++], s[d++], s[d++], s[d++]), i = s[d - 2], r = s[d - 1];
              break;

            case l.Q:
              e.quadraticCurveTo(s[d++], s[d++], s[d++], s[d++]), i = s[d - 2], r = s[d - 1];
              break;

            case l.A:
              var p = s[d++],
                  m = s[d++],
                  x = s[d++],
                  _ = s[d++],
                  b = s[d++],
                  w = s[d++],
                  S = s[d++],
                  T = s[d++],
                  C = x > _ ? x : _,
                  k = x > _ ? 1 : x / _,
                  M = x > _ ? _ / x : 1,
                  E = b + w;
              Math.abs(x - _) > .001 ? (e.translate(p, m), e.rotate(S), e.scale(k, M), e.arc(0, 0, C, b, E, 1 - T), e.scale(1 / k, 1 / M), e.rotate(-S), e.translate(-p, -m)) : e.arc(p, m, C, b, E, 1 - T), 1 === d && (t = g(b) * x + p, n = v(b) * _ + m), i = g(E) * x + p, r = v(E) * _ + m;
              break;

            case l.R:
              t = i = s[d], n = r = s[d + 1], e.rect(s[d++], s[d++], s[d++], s[d++]);
              break;

            case l.Z:
              e.closePath(), i = t, r = n;
          }
        }
      }
    }, _.CMD = l;
    var b = _;
    e.exports = b;
  }, function (e, t, n) {
    var i = n(8).makeInner;

    e.exports = function () {
      var e = i();
      return function (t) {
        var n = e(t),
            i = t.pipelineContext,
            r = n.large,
            o = n.progressiveRender,
            a = n.large = i && i.large,
            s = n.progressiveRender = i && i.progressiveRender;
        return !!(r ^ a || o ^ s) && "reset";
      };
    };
  }, function (e, t, n) {
    var i = n(312);

    e.exports = function (e, t) {
      return i((t = t || {}).coordDimensions || [], e, {
        dimsDef: t.dimensionsDefine || e.dimensionsDefine,
        encodeDef: t.encodeDefine || e.encodeDefine,
        dimCount: t.dimensionsCount,
        encodeDefaulter: t.encodeDefaulter,
        generateCoord: t.generateCoord,
        generateCoordCount: t.generateCoordCount
      });
    };
  }, function (e, t, n) {
    var i = n(1),
        r = {
      getMin: function getMin(e) {
        var t = this.option,
            n = e || null == t.rangeStart ? t.min : t.rangeStart;
        return this.axis && null != n && "dataMin" !== n && "function" != typeof n && !i.eqNaN(n) && (n = this.axis.scale.parse(n)), n;
      },
      getMax: function getMax(e) {
        var t = this.option,
            n = e || null == t.rangeEnd ? t.max : t.rangeEnd;
        return this.axis && null != n && "dataMax" !== n && "function" != typeof n && !i.eqNaN(n) && (n = this.axis.scale.parse(n)), n;
      },
      getNeedCrossZero: function getNeedCrossZero() {
        var e = this.option;
        return null == e.rangeStart && null == e.rangeEnd && !e.scale;
      },
      getCoordSysModel: i.noop,
      setRange: function setRange(e, t) {
        this.option.rangeStart = e, this.option.rangeEnd = t;
      },
      resetRange: function resetRange() {
        this.option.rangeStart = this.option.rangeEnd = null;
      }
    };
    e.exports = r;
  }, function (e, t, n) {
    var i = n(104),
        r = n(39),
        o = n(1),
        a = o.extend,
        s = o.isArray;

    e.exports = function (e, t, n) {
      t = s(t) && {
        coordDimensions: t
      } || a({}, t);
      var o = e.getSource(),
          l = i(o, t),
          u = new r(l, e);
      return u.initData(o, n), u;
    };
  }, function (e, t) {
    function n(e, t) {
      var n = e[t] - e[1 - t];
      return {
        span: Math.abs(n),
        sign: n > 0 ? -1 : n < 0 ? 1 : t ? -1 : 1
      };
    }

    function i(e, t) {
      return Math.min(null != t[1] ? t[1] : 1 / 0, Math.max(null != t[0] ? t[0] : -1 / 0, e));
    }

    e.exports = function (e, t, r, o, a, s) {
      e = e || 0;
      var l = r[1] - r[0];

      if (null != a && (a = i(a, [0, l])), null != s && (s = Math.max(s, null != a ? a : 0)), "all" === o) {
        var u = Math.abs(t[1] - t[0]);
        u = i(u, [0, l]), a = s = i(u, [a, s]), o = 0;
      }

      t[0] = i(t[0], r), t[1] = i(t[1], r);
      var c = n(t, o);
      t[o] += e;
      var h = a || 0,
          d = r.slice();
      c.sign < 0 ? d[0] += h : d[1] -= h, t[o] = i(t[o], d);
      var f = n(t, o);
      return null != a && (f.sign !== c.sign || f.span < a) && (t[1 - o] = t[o] + c.sign * a), f = n(t, o), null != s && f.span > s && (t[1 - o] = t[o] + f.sign * s), t;
    };
  }, function (e, t, n) {
    n(9).__DEV__;
    var i = n(4),
        r = n(1),
        o = n(21),
        a = n(8),
        s = n(228),
        l = n(878),
        u = r.each,
        c = s.eachAxisDim;

    function h(e) {
      var t = {};
      return u(["start", "end", "startValue", "endValue", "throttle"], function (n) {
        e.hasOwnProperty(n) && (t[n] = e[n]);
      }), t;
    }

    function d(e, t) {
      var n = e._rangePropMode,
          i = e.get("rangeMode");
      u([["start", "startValue"], ["end", "endValue"]], function (e, r) {
        var o = null != t[e[0]],
            a = null != t[e[1]];
        o && !a ? n[r] = "percent" : !o && a ? n[r] = "value" : i ? n[r] = i[r] : o && (n[r] = "percent");
      });
    }

    var f = i.extendComponentModel({
      type: "dataZoom",
      dependencies: ["xAxis", "yAxis", "zAxis", "radiusAxis", "angleAxis", "singleAxis", "series"],
      defaultOption: {
        zlevel: 0,
        z: 4,
        orient: null,
        xAxisIndex: null,
        yAxisIndex: null,
        filterMode: "filter",
        throttle: null,
        start: 0,
        end: 100,
        startValue: null,
        endValue: null,
        minSpan: null,
        maxSpan: null,
        minValueSpan: null,
        maxValueSpan: null,
        rangeMode: null
      },
      init: function init(e, t, n) {
        this._dataIntervalByAxis = {}, this._dataInfo = {}, this._axisProxies = {}, this.textStyleModel, this._autoThrottle = !0, this._rangePropMode = ["percent", "percent"];
        var i = h(e);
        this.settledOption = i, this.mergeDefaultAndTheme(e, n), this.doInit(i);
      },
      mergeOption: function mergeOption(e) {
        var t = h(e);
        r.merge(this.option, e, !0), r.merge(this.settledOption, t, !0), this.doInit(t);
      },
      doInit: function doInit(e) {
        var t = this.option;
        o.canvasSupported || (t.realtime = !1), this._setDefaultThrottle(e), d(this, e);
        var n = this.settledOption;
        u([["start", "startValue"], ["end", "endValue"]], function (e, i) {
          "value" === this._rangePropMode[i] && (t[e[0]] = n[e[0]] = null);
        }, this), this.textStyleModel = this.getModel("textStyle"), this._resetTarget(), this._giveAxisProxies();
      },
      _giveAxisProxies: function _giveAxisProxies() {
        var e = this._axisProxies;
        this.eachTargetAxis(function (t, n, i, r) {
          var o = this.dependentModels[t.axis][n],
              a = o.__dzAxisProxy || (o.__dzAxisProxy = new l(t.name, n, this, r));
          e[t.name + "_" + n] = a;
        }, this);
      },
      _resetTarget: function _resetTarget() {
        var e = this.option,
            t = this._judgeAutoMode();

        c(function (t) {
          var n = t.axisIndex;
          e[n] = a.normalizeToArray(e[n]);
        }, this), "axisIndex" === t ? this._autoSetAxisIndex() : "orient" === t && this._autoSetOrient();
      },
      _judgeAutoMode: function _judgeAutoMode() {
        var e = this.option,
            t = !1;
        c(function (n) {
          null != e[n.axisIndex] && (t = !0);
        }, this);
        var n = e.orient;
        return null == n && t ? "orient" : t ? void 0 : (null == n && (e.orient = "horizontal"), "axisIndex");
      },
      _autoSetAxisIndex: function _autoSetAxisIndex() {
        var e = !0,
            t = this.get("orient", !0),
            n = this.option,
            i = this.dependentModels;

        if (e) {
          var o = "vertical" === t ? "y" : "x";
          i[o + "Axis"].length ? (n[o + "AxisIndex"] = [0], e = !1) : u(i.singleAxis, function (i) {
            e && i.get("orient", !0) === t && (n.singleAxisIndex = [i.componentIndex], e = !1);
          });
        }

        e && c(function (t) {
          if (e) {
            var i = [],
                r = this.dependentModels[t.axis];
            if (r.length && !i.length) for (var o = 0, a = r.length; o < a; o++) {
              "category" === r[o].get("type") && i.push(o);
            }
            n[t.axisIndex] = i, i.length && (e = !1);
          }
        }, this), e && this.ecModel.eachSeries(function (e) {
          this._isSeriesHasAllAxesTypeOf(e, "value") && c(function (t) {
            var i = n[t.axisIndex],
                o = e.get(t.axisIndex),
                a = e.get(t.axisId);
            o = e.ecModel.queryComponents({
              mainType: t.axis,
              index: o,
              id: a
            })[0].componentIndex, r.indexOf(i, o) < 0 && i.push(o);
          });
        }, this);
      },
      _autoSetOrient: function _autoSetOrient() {
        var e;
        this.eachTargetAxis(function (t) {
          !e && (e = t.name);
        }, this), this.option.orient = "y" === e ? "vertical" : "horizontal";
      },
      _isSeriesHasAllAxesTypeOf: function _isSeriesHasAllAxesTypeOf(e, t) {
        var n = !0;
        return c(function (i) {
          var r = e.get(i.axisIndex),
              o = this.dependentModels[i.axis][r];
          o && o.get("type") === t || (n = !1);
        }, this), n;
      },
      _setDefaultThrottle: function _setDefaultThrottle(e) {
        if (e.hasOwnProperty("throttle") && (this._autoThrottle = !1), this._autoThrottle) {
          var t = this.ecModel.option;
          this.option.throttle = t.animation && t.animationDurationUpdate > 0 ? 100 : 20;
        }
      },
      getFirstTargetAxisModel: function getFirstTargetAxisModel() {
        var e;
        return c(function (t) {
          if (null == e) {
            var n = this.get(t.axisIndex);
            n.length && (e = this.dependentModels[t.axis][n[0]]);
          }
        }, this), e;
      },
      eachTargetAxis: function eachTargetAxis(e, t) {
        var n = this.ecModel;
        c(function (i) {
          u(this.get(i.axisIndex), function (r) {
            e.call(t, i, r, this, n);
          }, this);
        }, this);
      },
      getAxisProxy: function getAxisProxy(e, t) {
        return this._axisProxies[e + "_" + t];
      },
      getAxisModel: function getAxisModel(e, t) {
        var n = this.getAxisProxy(e, t);
        return n && n.getAxisModel();
      },
      setRawRange: function setRawRange(e) {
        var t = this.option,
            n = this.settledOption;
        u([["start", "startValue"], ["end", "endValue"]], function (i) {
          null == e[i[0]] && null == e[i[1]] || (t[i[0]] = n[i[0]] = e[i[0]], t[i[1]] = n[i[1]] = e[i[1]]);
        }, this), d(this, e);
      },
      setCalculatedRange: function setCalculatedRange(e) {
        var t = this.option;
        u(["start", "startValue", "end", "endValue"], function (n) {
          t[n] = e[n];
        });
      },
      getPercentRange: function getPercentRange() {
        var e = this.findRepresentativeAxisProxy();
        if (e) return e.getDataPercentWindow();
      },
      getValueRange: function getValueRange(e, t) {
        if (null != e || null != t) return this.getAxisProxy(e, t).getDataValueWindow();
        var n = this.findRepresentativeAxisProxy();
        return n ? n.getDataValueWindow() : void 0;
      },
      findRepresentativeAxisProxy: function findRepresentativeAxisProxy(e) {
        if (e) return e.__dzAxisProxy;
        var t = this._axisProxies;

        for (var n in t) {
          if (t.hasOwnProperty(n) && t[n].hostedBy(this)) return t[n];
        }

        for (var n in t) {
          if (t.hasOwnProperty(n) && !t[n].hostedBy(this)) return t[n];
        }
      },
      getRangePropMode: function getRangePropMode() {
        return this._rangePropMode.slice();
      }
    });
    e.exports = f;
  }, function (e, t, n) {
    var i = n(158).extend({
      type: "dataZoom",
      render: function render(e, t, n, i) {
        this.dataZoomModel = e, this.ecModel = t, this.api = n;
      },
      getTargetCoordInfo: function getTargetCoordInfo() {
        var e = this.dataZoomModel,
            t = this.ecModel,
            n = {};
        return e.eachTargetAxis(function (e, i) {
          var r = t.getComponent(e.axis, i);

          if (r) {
            var o = r.getCoordSysModel();
            o && function (e, t, n, i) {
              for (var r, o = 0; o < n.length; o++) {
                if (n[o].model === e) {
                  r = n[o];
                  break;
                }
              }

              r || n.push(r = {
                model: e,
                axisModels: [],
                coordIndex: i
              });
              r.axisModels.push(t);
            }(o, r, n[o.mainType] || (n[o.mainType] = []), o.componentIndex);
          }
        }, this), n;
      }
    });
    e.exports = i;
  }, function (e, t, n) {
    "use strict";

    e.exports = n(563);
  }, function (e, t, n) {
    var i = n(57);
    e.exports = Object("z").propertyIsEnumerable(0) ? Object : function (e) {
      return "String" == i(e) ? e.split("") : Object(e);
    };
  }, function (e, t) {
    t.f = {}.propertyIsEnumerable;
  }, function (e, t, n) {
    var i = n(57),
        r = n(18)("toStringTag"),
        o = "Arguments" == i(function () {
      return arguments;
    }());

    e.exports = function (e) {
      var t, n, a;
      return void 0 === e ? "Undefined" : null === e ? "Null" : "string" == typeof (n = function (e, t) {
        try {
          return e[t];
        } catch (e) {}
      }(t = Object(e), r)) ? n : o ? i(t) : "Object" == (a = i(t)) && "function" == typeof t.callee ? "Arguments" : a;
    };
  }, function (e, t, n) {
    var i = n(12),
        r = n(46),
        o = n(18)("species");

    e.exports = function (e, t) {
      var n,
          a = i(e).constructor;
      return void 0 === a || null == (n = i(a)[o]) ? t : r(n);
    };
  }, function (e, t, n) {
    var i = n(201),
        r = n(585),
        o = n(586),
        a = i ? i.toStringTag : void 0;

    e.exports = function (e) {
      return null == e ? void 0 === e ? "[object Undefined]" : "[object Null]" : a && a in Object(e) ? r(e) : o(e);
    };
  }, function (e, t) {
    e.exports = function (e) {
      var t = typeof e;
      return null != e && ("object" == t || "function" == t);
    };
  }, function (e, t) {
    e.exports = function (e) {
      return null != e && "object" == typeof e;
    };
  }, function (e, t, n) {
    var i = function i() {};

    1 === n(154).debugMode && (i = console.error);
    var r = i;
    e.exports = r;
  }, function (e, t, n) {
    var i = n(1),
        r = n(204),
        o = n(286),
        a = n(292);

    function s(e) {
      for (var t in e = e || {}, o.call(this, e), e) {
        e.hasOwnProperty(t) && "style" !== t && (this[t] = e[t]);
      }

      this.style = new r(e.style, this), this._rect = null, this.__clipPaths = null;
    }

    s.prototype = {
      constructor: s,
      type: "displayable",
      __dirty: !0,
      invisible: !1,
      z: 0,
      z2: 0,
      zlevel: 0,
      draggable: !1,
      dragging: !1,
      silent: !1,
      culling: !1,
      cursor: "pointer",
      rectHover: !1,
      progressive: !1,
      incremental: !1,
      globalScaleRatio: 1,
      beforeBrush: function beforeBrush(e) {},
      afterBrush: function afterBrush(e) {},
      brush: function brush(e, t) {},
      getBoundingRect: function getBoundingRect() {},
      contain: function contain(e, t) {
        return this.rectContain(e, t);
      },
      traverse: function traverse(e, t) {
        e.call(t, this);
      },
      rectContain: function rectContain(e, t) {
        var n = this.transformCoordToLocal(e, t);
        return this.getBoundingRect().contain(n[0], n[1]);
      },
      dirty: function dirty() {
        this.__dirty = this.__dirtyText = !0, this._rect = null, this.__zr && this.__zr.refresh();
      },
      animateStyle: function animateStyle(e) {
        return this.animate("style", e);
      },
      attrKV: function attrKV(e, t) {
        "style" !== e ? o.prototype.attrKV.call(this, e, t) : this.style.set(t);
      },
      setStyle: function setStyle(e, t) {
        return this.style.set(e, t), this.dirty(!1), this;
      },
      useStyle: function useStyle(e) {
        return this.style = new r(e, this), this.dirty(!1), this;
      },
      calculateTextPosition: null
    }, i.inherits(s, o), i.mixin(s, a);
    var l = s;
    e.exports = l;
  }, function (e, t, n) {
    var i = n(16),
        r = n(66),
        o = Math.min,
        a = Math.max,
        s = Math.sin,
        l = Math.cos,
        u = 2 * Math.PI,
        c = i.create(),
        h = i.create(),
        d = i.create();
    var f = [],
        p = [];
    t.fromPoints = function (e, t, n) {
      if (0 !== e.length) {
        var i,
            r = e[0],
            s = r[0],
            l = r[0],
            u = r[1],
            c = r[1];

        for (i = 1; i < e.length; i++) {
          r = e[i], s = o(s, r[0]), l = a(l, r[0]), u = o(u, r[1]), c = a(c, r[1]);
        }

        t[0] = s, t[1] = u, n[0] = l, n[1] = c;
      }
    }, t.fromLine = function (e, t, n, i, r, s) {
      r[0] = o(e, n), r[1] = o(t, i), s[0] = a(e, n), s[1] = a(t, i);
    }, t.fromCubic = function (e, t, n, i, s, l, u, c, h, d) {
      var g,
          v = r.cubicExtrema,
          m = r.cubicAt,
          y = v(e, n, s, u, f);

      for (h[0] = 1 / 0, h[1] = 1 / 0, d[0] = -1 / 0, d[1] = -1 / 0, g = 0; g < y; g++) {
        var x = m(e, n, s, u, f[g]);
        h[0] = o(x, h[0]), d[0] = a(x, d[0]);
      }

      for (y = v(t, i, l, c, p), g = 0; g < y; g++) {
        var _ = m(t, i, l, c, p[g]);

        h[1] = o(_, h[1]), d[1] = a(_, d[1]);
      }

      h[0] = o(e, h[0]), d[0] = a(e, d[0]), h[0] = o(u, h[0]), d[0] = a(u, d[0]), h[1] = o(t, h[1]), d[1] = a(t, d[1]), h[1] = o(c, h[1]), d[1] = a(c, d[1]);
    }, t.fromQuadratic = function (e, t, n, i, s, l, u, c) {
      var h = r.quadraticExtremum,
          d = r.quadraticAt,
          f = a(o(h(e, n, s), 1), 0),
          p = a(o(h(t, i, l), 1), 0),
          g = d(e, n, s, f),
          v = d(t, i, l, p);
      u[0] = o(e, s, g), u[1] = o(t, l, v), c[0] = a(e, s, g), c[1] = a(t, l, v);
    }, t.fromArc = function (e, t, n, r, o, a, f, p, g) {
      var v = i.min,
          m = i.max,
          y = Math.abs(o - a);
      if (y % u < 1e-4 && y > 1e-4) return p[0] = e - n, p[1] = t - r, g[0] = e + n, void (g[1] = t + r);

      if (c[0] = l(o) * n + e, c[1] = s(o) * r + t, h[0] = l(a) * n + e, h[1] = s(a) * r + t, v(p, c, h), m(g, c, h), (o %= u) < 0 && (o += u), (a %= u) < 0 && (a += u), o > a && !f ? a += u : o < a && f && (o += u), f) {
        var x = a;
        a = o, o = x;
      }

      for (var _ = 0; _ < a; _ += Math.PI / 2) {
        _ > o && (d[0] = l(_) * n + e, d[1] = s(_) * r + t, v(p, d, p), m(g, d, g));
      }
    };
  }, function (e, t, n) {
    var i = n(1),
        r = n(60).parseClassType,
        o = 0;
    t.getUID = function (e) {
      return [e || "", o++, Math.random().toFixed(5)].join("_");
    }, t.enableSubTypeDefaulter = function (e) {
      var t = {};
      return e.registerSubTypeDefaulter = function (e, n) {
        e = r(e), t[e.main] = n;
      }, e.determineSubType = function (n, i) {
        var o = i.type;

        if (!o) {
          var a = r(n).main;
          e.hasSubTypes(n) && t[a] && (o = t[a](i));
        }

        return o;
      }, e;
    }, t.enableTopologicalTravel = function (e, t) {
      function n(e, t) {
        return e[t] || (e[t] = {
          predecessor: [],
          successor: []
        }), e[t];
      }

      e.topologicalTravel = function (e, r, o, a) {
        if (e.length) {
          var s = function (e) {
            var r = {},
                o = [];
            return i.each(e, function (a) {
              var s = n(r, a),
                  l = function (e, t) {
                var n = [];
                return i.each(e, function (e) {
                  i.indexOf(t, e) >= 0 && n.push(e);
                }), n;
              }(s.originalDeps = t(a), e);

              s.entryCount = l.length, 0 === s.entryCount && o.push(a), i.each(l, function (e) {
                i.indexOf(s.predecessor, e) < 0 && s.predecessor.push(e);
                var t = n(r, e);
                i.indexOf(t.successor, e) < 0 && t.successor.push(a);
              });
            }), {
              graph: r,
              noEntryList: o
            };
          }(r),
              l = s.graph,
              u = s.noEntryList,
              c = {};

          for (i.each(e, function (e) {
            c[e] = !0;
          }); u.length;) {
            var h = u.pop(),
                d = l[h],
                f = !!c[h];
            f && (o.call(a, h, d.originalDeps.slice()), delete c[h]), i.each(d.successor, f ? g : p);
          }

          i.each(c, function () {
            throw new Error("Circle dependency may exists");
          });
        }

        function p(e) {
          l[e].entryCount--, 0 === l[e].entryCount && u.push(e);
        }

        function g(e) {
          c[e] = !0, p(e);
        }
      };
    };
  }, function (e, t, n) {
    var i = n(1),
        r = i.createHashMap,
        o = i.isTypedArray,
        a = n(60).enableClassCheck,
        s = n(123),
        l = s.SOURCE_FORMAT_ORIGINAL,
        u = s.SERIES_LAYOUT_BY_COLUMN,
        c = s.SOURCE_FORMAT_UNKNOWN,
        h = s.SOURCE_FORMAT_TYPED_ARRAY,
        d = s.SOURCE_FORMAT_KEYED_COLUMNS;

    function f(e) {
      this.fromDataset = e.fromDataset, this.data = e.data || (e.sourceFormat === d ? {} : []), this.sourceFormat = e.sourceFormat || c, this.seriesLayoutBy = e.seriesLayoutBy || u, this.dimensionsDefine = e.dimensionsDefine, this.encodeDefine = e.encodeDefine && r(e.encodeDefine), this.startIndex = e.startIndex || 0, this.dimensionsDetectCount = e.dimensionsDetectCount;
    }

    f.seriesDataToSource = function (e) {
      return new f({
        data: e,
        sourceFormat: o(e) ? h : l,
        fromDataset: !1
      });
    }, a(f);
    var p = f;
    e.exports = p;
  }, function (e, t) {
    t.SOURCE_FORMAT_ORIGINAL = "original", t.SOURCE_FORMAT_ARRAY_ROWS = "arrayRows", t.SOURCE_FORMAT_OBJECT_ROWS = "objectRows", t.SOURCE_FORMAT_KEYED_COLUMNS = "keyedColumns", t.SOURCE_FORMAT_UNKNOWN = "unknown", t.SOURCE_FORMAT_TYPED_ARRAY = "typedArray", t.SERIES_LAYOUT_BY_COLUMN = "column", t.SERIES_LAYOUT_BY_ROW = "row";
  }, function (e, t, n) {
    var i = n(1),
        r = i.each,
        o = i.createHashMap,
        a = (i.assert, n(9).__DEV__, o(["tooltip", "label", "itemName", "itemId", "seriesName"]));

    function s(e, t) {
      return e.hasOwnProperty(t) || (e[t] = []), e[t];
    }

    t.OTHER_DIMENSIONS = a, t.summarizeDimensions = function (e) {
      var t = {},
          n = t.encode = {},
          i = o(),
          l = [],
          u = [],
          c = t.userOutput = {
        dimensionNames: e.dimensions.slice(),
        encode: {}
      };
      r(e.dimensions, function (t) {
        var r,
            o = e.getDimensionInfo(t),
            h = o.coordDim;

        if (h) {
          var d = o.coordDimIndex;
          s(n, h)[d] = t, o.isExtraCoord || (i.set(h, 1), "ordinal" !== (r = o.type) && "time" !== r && (l[0] = t), s(c.encode, h)[d] = o.index), o.defaultTooltip && u.push(t);
        }

        a.each(function (e, t) {
          var i = s(n, t),
              r = o.otherDims[t];
          null != r && !1 !== r && (i[r] = o.name);
        });
      });
      var h = [],
          d = {};
      i.each(function (e, t) {
        var i = n[t];
        d[t] = i[0], h = h.concat(i);
      }), t.dataDimsOnCoord = h, t.encodeFirstDimNotExtra = d;
      var f = n.label;
      f && f.length && (l = f.slice());
      var p = n.tooltip;
      return p && p.length ? u = p.slice() : u.length || (u = l.slice()), n.defaultedLabel = l, n.defaultedTooltip = u, t;
    }, t.getDimensionTypeByAxis = function (e) {
      return "category" === e ? "ordinal" : "time" === e ? "time" : "float";
    };
  }, function (e, t, n) {
    var i = n(5),
        r = n(162),
        o = n(1).isObject;

    function a(e) {
      this.group = new i.Group(), this._symbolCtor = e || r;
    }

    var s = a.prototype;

    function l(e, t, n, i) {
      return t && !isNaN(t[0]) && !isNaN(t[1]) && !(i.isIgnore && i.isIgnore(n)) && !(i.clipShape && !i.clipShape.contain(t[0], t[1])) && "none" !== e.getItemVisual(n, "symbol");
    }

    function u(e) {
      return null == e || o(e) || (e = {
        isIgnore: e
      }), e || {};
    }

    function c(e) {
      var t = e.hostModel;
      return {
        itemStyle: t.getModel("itemStyle").getItemStyle(["color"]),
        hoverItemStyle: t.getModel("emphasis.itemStyle").getItemStyle(),
        symbolRotate: t.get("symbolRotate"),
        symbolOffset: t.get("symbolOffset"),
        hoverAnimation: t.get("hoverAnimation"),
        labelModel: t.getModel("label"),
        hoverLabelModel: t.getModel("emphasis.label"),
        cursorStyle: t.get("cursor")
      };
    }

    s.updateData = function (e, t) {
      t = u(t);
      var n = this.group,
          r = e.hostModel,
          o = this._data,
          a = this._symbolCtor,
          s = c(e);
      o || n.removeAll(), e.diff(o).add(function (i) {
        var r = e.getItemLayout(i);

        if (l(e, r, i, t)) {
          var o = new a(e, i, s);
          o.attr("position", r), e.setItemGraphicEl(i, o), n.add(o);
        }
      }).update(function (u, c) {
        var h = o.getItemGraphicEl(c),
            d = e.getItemLayout(u);
        l(e, d, u, t) ? (h ? (h.updateData(e, u, s), i.updateProps(h, {
          position: d
        }, r)) : (h = new a(e, u)).attr("position", d), n.add(h), e.setItemGraphicEl(u, h)) : n.remove(h);
      }).remove(function (e) {
        var t = o.getItemGraphicEl(e);
        t && t.fadeOut(function () {
          n.remove(t);
        });
      }).execute(), this._data = e;
    }, s.isPersistent = function () {
      return !0;
    }, s.updateLayout = function () {
      var e = this._data;
      e && e.eachItemGraphicEl(function (t, n) {
        var i = e.getItemLayout(n);
        t.attr("position", i);
      });
    }, s.incrementalPrepareUpdate = function (e) {
      this._seriesScope = c(e), this._data = null, this.group.removeAll();
    }, s.incrementalUpdate = function (e, t, n) {
      function i(e) {
        e.isGroup || (e.incremental = e.useHoverLayer = !0);
      }

      n = u(n);

      for (var r = e.start; r < e.end; r++) {
        var o = t.getItemLayout(r);

        if (l(t, o, r, n)) {
          var a = new this._symbolCtor(t, r, this._seriesScope);
          a.traverse(i), a.attr("position", o), this.group.add(a), t.setItemGraphicEl(r, a);
        }
      }
    }, s.remove = function (e) {
      var t = this.group,
          n = this._data;
      n && e ? n.eachItemGraphicEl(function (e) {
        e.fadeOut(function () {
          t.remove(e);
        });
      }) : t.removeAll();
    };
    var h = a;
    e.exports = h;
  }, function (e, t, n) {
    var i = n(5),
        r = n(6).round;

    function o(e, t, n) {
      var r = e.getArea(),
          o = e.getBaseAxis().isHorizontal(),
          a = r.x,
          s = r.y,
          l = r.width,
          u = r.height,
          c = n.get("lineStyle.width") || 2;
      a -= c / 2, s -= c / 2, l += c, u += c, a = Math.floor(a), l = Math.round(l);
      var h = new i.Rect({
        shape: {
          x: a,
          y: s,
          width: l,
          height: u
        }
      });
      return t && (h.shape[o ? "width" : "height"] = 0, i.initProps(h, {
        shape: {
          width: l,
          height: u
        }
      }, n)), h;
    }

    function a(e, t, n) {
      var o = e.getArea(),
          a = new i.Sector({
        shape: {
          cx: r(e.cx, 1),
          cy: r(e.cy, 1),
          r0: r(o.r0, 1),
          r: r(o.r, 1),
          startAngle: o.startAngle,
          endAngle: o.endAngle,
          clockwise: o.clockwise
        }
      });
      return t && (a.shape.endAngle = o.startAngle, i.initProps(a, {
        shape: {
          endAngle: o.endAngle
        }
      }, n)), a;
    }

    t.createGridClipPath = o, t.createPolarClipPath = a, t.createClipPath = function (e, t, n) {
      return e ? "polar" === e.type ? a(e, t, n) : "cartesian2d" === e.type ? o(e, t, n) : null : null;
    };
  }, function (e, t, n) {
    var i = n(1).map,
        r = n(103),
        o = n(55).isDimensionStacked;

    e.exports = function (e) {
      return {
        seriesType: e,
        plan: r(),
        reset: function reset(e) {
          var t = e.getData(),
              n = e.coordinateSystem,
              r = e.pipelineContext.large;

          if (n) {
            var a = i(n.dimensions, function (e) {
              return t.mapDimension(e);
            }).slice(0, 2),
                s = a.length,
                l = t.getCalculationInfo("stackResultDimension");
            return o(t, a[0]) && (a[0] = l), o(t, a[1]) && (a[1] = l), s && {
              progress: function progress(e, t) {
                for (var i = e.end - e.start, o = r && new Float32Array(i * s), l = e.start, u = 0, c = [], h = []; l < e.end; l++) {
                  var d;

                  if (1 === s) {
                    var f = t.get(a[0], l);
                    d = !isNaN(f) && n.dataToPoint(f, null, h);
                  } else {
                    f = c[0] = t.get(a[0], l);
                    var p = c[1] = t.get(a[1], l);
                    d = !isNaN(f) && !isNaN(p) && n.dataToPoint(c, null, h);
                  }

                  r ? (o[u++] = d ? d[0] : NaN, o[u++] = d ? d[1] : NaN) : t.setItemLayout(l, d && d.slice() || [NaN, NaN]);
                }

                r && t.setLayout("symbolPoints", o);
              }
            };
          }
        }
      };
    };
  }, function (e, t, n) {
    var i = n(4),
        r = n(1),
        o = n(5);
    n(214), n(700), i.extendComponentView({
      type: "grid",
      render: function render(e, t) {
        this.group.removeAll(), e.get("show") && this.group.add(new o.Rect({
          shape: e.coordinateSystem.getRect(),
          style: r.defaults({
            fill: e.get("backgroundColor")
          }, e.getItemStyle()),
          silent: !0,
          z2: -1
        }));
      }
    }), i.registerPreprocessor(function (e) {
      e.xAxis && e.yAxis && !e.grid && (e.grid = {});
    });
  }, function (e, t) {
    var n = function n(e, t) {
      this.getAllNames = function () {
        var e = t();
        return e.mapArray(e.getName);
      }, this.containName = function (e) {
        return t().indexOfName(e) >= 0;
      }, this.indexOfName = function (t) {
        return e().indexOfName(t);
      }, this.getItemVisual = function (t, n) {
        return e().getItemVisual(t, n);
      };
    };

    e.exports = n;
  }, function (e, t) {
    e.exports = function (e) {
      return {
        seriesType: e,
        reset: function reset(e, t) {
          var n = t.findComponents({
            mainType: "legend"
          });

          if (n && n.length) {
            var i = e.getData();
            i.filterSelf(function (e) {
              for (var t = i.getName(e), r = 0; r < n.length; r++) {
                if (!n[r].isSelected(t)) return !1;
              }

              return !0;
            });
          }
        }
      };
    };
  }, function (e, t, n) {
    var i = n(1),
        r = n(83),
        o = n(52),
        a = n(329);

    function s(e) {
      this.pointerChecker, this._zr = e, this._opt = {};
      var t = i.bind,
          n = t(l, this),
          o = t(u, this),
          a = t(c, this),
          s = t(h, this),
          f = t(d, this);
      r.call(this), this.setPointerChecker = function (e) {
        this.pointerChecker = e;
      }, this.enable = function (t, r) {
        this.disable(), this._opt = i.defaults(i.clone(r) || {}, {
          zoomOnMouseWheel: !0,
          moveOnMouseMove: !0,
          moveOnMouseWheel: !1,
          preventDefaultMouseMove: !0
        }), null == t && (t = !0), !0 !== t && "move" !== t && "pan" !== t || (e.on("mousedown", n), e.on("mousemove", o), e.on("mouseup", a)), !0 !== t && "scale" !== t && "zoom" !== t || (e.on("mousewheel", s), e.on("pinch", f));
      }, this.disable = function () {
        e.off("mousedown", n), e.off("mousemove", o), e.off("mouseup", a), e.off("mousewheel", s), e.off("pinch", f);
      }, this.dispose = this.disable, this.isDragging = function () {
        return this._dragging;
      }, this.isPinching = function () {
        return this._pinching;
      };
    }

    function l(e) {
      if (!(o.isMiddleOrRightButtonOnMouseUpDown(e) || e.target && e.target.draggable)) {
        var t = e.offsetX,
            n = e.offsetY;
        this.pointerChecker && this.pointerChecker(e, t, n) && (this._x = t, this._y = n, this._dragging = !0);
      }
    }

    function u(e) {
      if (this._dragging && g("moveOnMouseMove", e, this._opt) && "pinch" !== e.gestureEvent && !a.isTaken(this._zr, "globalPan")) {
        var t = e.offsetX,
            n = e.offsetY,
            i = this._x,
            r = this._y,
            s = t - i,
            l = n - r;
        this._x = t, this._y = n, this._opt.preventDefaultMouseMove && o.stop(e.event), p(this, "pan", "moveOnMouseMove", e, {
          dx: s,
          dy: l,
          oldX: i,
          oldY: r,
          newX: t,
          newY: n
        });
      }
    }

    function c(e) {
      o.isMiddleOrRightButtonOnMouseUpDown(e) || (this._dragging = !1);
    }

    function h(e) {
      var t = g("zoomOnMouseWheel", e, this._opt),
          n = g("moveOnMouseWheel", e, this._opt),
          i = e.wheelDelta,
          r = Math.abs(i),
          o = e.offsetX,
          a = e.offsetY;

      if (0 !== i && (t || n)) {
        if (t) {
          var s = r > 3 ? 1.4 : r > 1 ? 1.2 : 1.1;
          f(this, "zoom", "zoomOnMouseWheel", e, {
            scale: i > 0 ? s : 1 / s,
            originX: o,
            originY: a
          });
        }

        if (n) {
          var l = Math.abs(i);
          f(this, "scrollMove", "moveOnMouseWheel", e, {
            scrollDelta: (i > 0 ? 1 : -1) * (l > 3 ? .4 : l > 1 ? .15 : .05),
            originX: o,
            originY: a
          });
        }
      }
    }

    function d(e) {
      a.isTaken(this._zr, "globalPan") || f(this, "zoom", null, e, {
        scale: e.pinchScale > 1 ? 1.1 : 1 / 1.1,
        originX: e.pinchX,
        originY: e.pinchY
      });
    }

    function f(e, t, n, i, r) {
      e.pointerChecker && e.pointerChecker(i, r.originX, r.originY) && (o.stop(i.event), p(e, t, n, i, r));
    }

    function p(e, t, n, r, o) {
      o.isAvailableBehavior = i.bind(g, null, n, r), e.trigger(t, o);
    }

    function g(e, t, n) {
      var r = n[e];
      return !e || r && (!i.isString(r) || t.event[r + "Key"]);
    }

    i.mixin(s, r);
    var v = s;
    e.exports = v;
  }, function (e, t, n) {
    var i = n(4),
        r = n(1),
        o = n(164),
        a = n(829);
    n(830), n(831), n(348), i.registerPreprocessor(function (e) {
      if (e) {
        (!e.axisPointer || 0 === e.axisPointer.length) && (e.axisPointer = {});
        var t = e.axisPointer.link;
        t && !r.isArray(t) && (e.axisPointer.link = [t]);
      }
    }), i.registerProcessor(i.PRIORITY.PROCESSOR.STATISTIC, function (e, t) {
      e.getComponent("axisPointer").coordSysAxesInfo = o.collect(e, t);
    }), i.registerAction({
      type: "updateAxisPointer",
      event: "updateAxisPointer",
      update: ":updateAxisPointer"
    }, a);
  }, function (e, t, n) {
    "use strict";

    var i,
        r = function r() {
      return void 0 === i && (i = Boolean(window && document && document.all && !window.atob)), i;
    },
        o = function () {
      var e = {};
      return function (t) {
        if (void 0 === e[t]) {
          var n = document.querySelector(t);
          if (window.HTMLIFrameElement && n instanceof window.HTMLIFrameElement) try {
            n = n.contentDocument.head;
          } catch (e) {
            n = null;
          }
          e[t] = n;
        }

        return e[t];
      };
    }(),
        a = [];

    function s(e) {
      for (var t = -1, n = 0; n < a.length; n++) {
        if (a[n].identifier === e) {
          t = n;
          break;
        }
      }

      return t;
    }

    function l(e, t) {
      for (var n = {}, i = [], r = 0; r < e.length; r++) {
        var o = e[r],
            l = t.base ? o[0] + t.base : o[0],
            u = n[l] || 0,
            c = "".concat(l, " ").concat(u);
        n[l] = u + 1;
        var h = s(c),
            d = {
          css: o[1],
          media: o[2],
          sourceMap: o[3]
        };
        -1 !== h ? (a[h].references++, a[h].updater(d)) : a.push({
          identifier: c,
          updater: v(d, t),
          references: 1
        }), i.push(c);
      }

      return i;
    }

    function u(e) {
      var t = document.createElement("style"),
          i = e.attributes || {};

      if (void 0 === i.nonce) {
        var r = n.nc;
        r && (i.nonce = r);
      }

      if (Object.keys(i).forEach(function (e) {
        t.setAttribute(e, i[e]);
      }), "function" == typeof e.insert) e.insert(t);else {
        var a = o(e.insert || "head");
        if (!a) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
        a.appendChild(t);
      }
      return t;
    }

    var c,
        h = (c = [], function (e, t) {
      return c[e] = t, c.filter(Boolean).join("\n");
    });

    function d(e, t, n, i) {
      var r = n ? "" : i.media ? "@media ".concat(i.media, " {").concat(i.css, "}") : i.css;
      if (e.styleSheet) e.styleSheet.cssText = h(t, r);else {
        var o = document.createTextNode(r),
            a = e.childNodes;
        a[t] && e.removeChild(a[t]), a.length ? e.insertBefore(o, a[t]) : e.appendChild(o);
      }
    }

    function f(e, t, n) {
      var i = n.css,
          r = n.media,
          o = n.sourceMap;
      if (r ? e.setAttribute("media", r) : e.removeAttribute("media"), o && btoa && (i += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(o)))), " */")), e.styleSheet) e.styleSheet.cssText = i;else {
        for (; e.firstChild;) {
          e.removeChild(e.firstChild);
        }

        e.appendChild(document.createTextNode(i));
      }
    }

    var p = null,
        g = 0;

    function v(e, t) {
      var n, i, r;

      if (t.singleton) {
        var o = g++;
        n = p || (p = u(t)), i = d.bind(null, n, o, !1), r = d.bind(null, n, o, !0);
      } else n = u(t), i = f.bind(null, n, t), r = function r() {
        !function (e) {
          if (null === e.parentNode) return !1;
          e.parentNode.removeChild(e);
        }(n);
      };

      return i(e), function (t) {
        if (t) {
          if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;
          i(e = t);
        } else r();
      };
    }

    e.exports = function (e, t) {
      (t = t || {}).singleton || "boolean" == typeof t.singleton || (t.singleton = r());
      var n = l(e = e || [], t);
      return function (e) {
        if (e = e || [], "[object Array]" === Object.prototype.toString.call(e)) {
          for (var i = 0; i < n.length; i++) {
            var r = s(n[i]);
            a[r].references--;
          }

          for (var o = l(e, t), u = 0; u < n.length; u++) {
            var c = s(n[u]);
            0 === a[c].references && (a[c].updater(), a.splice(c, 1));
          }

          n = o;
        }
      };
    };
  }, function (e, t, n) {
    "use strict";

    e.exports = function (e) {
      var t = [];
      return t.toString = function () {
        return this.map(function (t) {
          var n = function (e, t) {
            var n = e[1] || "",
                i = e[3];
            if (!i) return n;

            if (t && "function" == typeof btoa) {
              var r = (a = i, s = btoa(unescape(encodeURIComponent(JSON.stringify(a)))), l = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(s), "/*# ".concat(l, " */")),
                  o = i.sources.map(function (e) {
                return "/*# sourceURL=".concat(i.sourceRoot || "").concat(e, " */");
              });
              return [n].concat(o).concat([r]).join("\n");
            }

            var a, s, l;
            return [n].join("\n");
          }(t, e);

          return t[2] ? "@media ".concat(t[2], " {").concat(n, "}") : n;
        }).join("");
      }, t.i = function (e, n, i) {
        "string" == typeof e && (e = [[null, e, ""]]);
        var r = {};
        if (i) for (var o = 0; o < this.length; o++) {
          var a = this[o][0];
          null != a && (r[a] = !0);
        }

        for (var s = 0; s < e.length; s++) {
          var l = [].concat(e[s]);
          i && r[l[0]] || (n && (l[2] ? l[2] = "".concat(n, " and ").concat(l[2]) : l[2] = n), t.push(l));
        }
      }, t;
    };
  },, function (e, t, n) {
    var i = n(23),
        r = n(10),
        o = r["__core-js_shared__"] || (r["__core-js_shared__"] = {});
    (e.exports = function (e, t) {
      return o[e] || (o[e] = void 0 !== t ? t : {});
    })("versions", []).push({
      version: i.version,
      mode: n(75) ? "pure" : "global",
      copyright: "© 2019 Denis Pushkarev (zloirock.ru)"
    });
  }, function (e, t, n) {
    var i = n(38),
        r = n(19),
        o = n(77);

    e.exports = function (e) {
      return function (t, n, a) {
        var s,
            l = i(t),
            u = r(l.length),
            c = o(a, u);

        if (e && n != n) {
          for (; u > c;) {
            if ((s = l[c++]) != s) return !0;
          }
        } else for (; u > c; c++) {
          if ((e || c in l) && l[c] === n) return e || c || 0;
        }

        return !e && -1;
      };
    };
  }, function (e, t) {
    t.f = Object.getOwnPropertySymbols;
  }, function (e, t, n) {
    var i = n(57);

    e.exports = Array.isArray || function (e) {
      return "Array" == i(e);
    };
  }, function (e, t, n) {
    var i = n(18)("iterator"),
        r = !1;

    try {
      var o = [7][i]();
      o.return = function () {
        r = !0;
      }, Array.from(o, function () {
        throw 2;
      });
    } catch (e) {}

    e.exports = function (e, t) {
      if (!t && !r) return !1;
      var n = !1;

      try {
        var o = [7],
            a = o[i]();
        a.next = function () {
          return {
            done: n = !0
          };
        }, o[i] = function () {
          return a;
        }, e(o);
      } catch (e) {}

      return n;
    };
  }, function (e, t, n) {
    "use strict";

    var i = n(12);

    e.exports = function () {
      var e = i(this),
          t = "";
      return e.global && (t += "g"), e.ignoreCase && (t += "i"), e.multiline && (t += "m"), e.unicode && (t += "u"), e.sticky && (t += "y"), t;
    };
  }, function (e, t, n) {
    "use strict";

    var i = n(113),
        r = RegExp.prototype.exec;

    e.exports = function (e, t) {
      var n = e.exec;

      if ("function" == typeof n) {
        var o = n.call(e, t);
        if ("object" != typeof o) throw new TypeError("RegExp exec method returned something other than an Object or null");
        return o;
      }

      if ("RegExp" !== i(e)) throw new TypeError("RegExp#exec called on incompatible receiver");
      return r.call(e, t);
    };
  }, function (e, t, n) {
    "use strict";

    n(260);

    var i = n(33),
        r = n(37),
        o = n(11),
        a = n(58),
        s = n(18),
        l = n(192),
        u = s("species"),
        c = !o(function () {
      var e = /./;
      return e.exec = function () {
        var e = [];
        return e.groups = {
          a: "7"
        }, e;
      }, "7" !== "".replace(e, "$<a>");
    }),
        h = function () {
      var e = /(?:)/,
          t = e.exec;

      e.exec = function () {
        return t.apply(this, arguments);
      };

      var n = "ab".split(e);
      return 2 === n.length && "a" === n[0] && "b" === n[1];
    }();

    e.exports = function (e, t, n) {
      var d = s(e),
          f = !o(function () {
        var t = {};
        return t[d] = function () {
          return 7;
        }, 7 != ""[e](t);
      }),
          p = f ? !o(function () {
        var t = !1,
            n = /a/;
        return n.exec = function () {
          return t = !0, null;
        }, "split" === e && (n.constructor = {}, n.constructor[u] = function () {
          return n;
        }), n[d](""), !t;
      }) : void 0;

      if (!f || !p || "replace" === e && !c || "split" === e && !h) {
        var g = /./[d],
            v = n(a, d, ""[e], function (e, t, n, i, r) {
          return t.exec === l ? f && !r ? {
            done: !0,
            value: g.call(t, n, i)
          } : {
            done: !0,
            value: e.call(n, t, i)
          } : {
            done: !1
          };
        }),
            m = v[0],
            y = v[1];
        i(String.prototype, e, m), r(RegExp.prototype, d, 2 == t ? function (e, t) {
          return y.call(e, this, t);
        } : function (e) {
          return y.call(e, this);
        });
      }
    };
  }, function (e, t, n) {
    var i = n(45),
        r = n(255),
        o = n(187),
        a = n(12),
        s = n(19),
        l = n(189),
        u = {},
        c = {};
    (t = e.exports = function (e, t, n, h, d) {
      var f,
          p,
          g,
          v,
          m = d ? function () {
        return e;
      } : l(e),
          y = i(n, h, t ? 2 : 1),
          x = 0;
      if ("function" != typeof m) throw TypeError(e + " is not iterable!");

      if (o(m)) {
        for (f = s(e.length); f > x; x++) {
          if ((v = t ? y(a(p = e[x])[0], p[1]) : y(e[x])) === u || v === c) return v;
        }
      } else for (g = m.call(e); !(p = g.next()).done;) {
        if ((v = r(g, y, p.value, t)) === u || v === c) return v;
      }
    }).BREAK = u, t.RETURN = c;
  }, function (e, t, n) {
    var i = n(10).navigator;
    e.exports = i && i.userAgent || "";
  }, function (e, t, n) {
    "use strict";

    var i = n(10),
        r = n(3),
        o = n(33),
        a = n(98),
        s = n(64),
        l = n(144),
        u = n(97),
        c = n(13),
        h = n(11),
        d = n(140),
        f = n(93),
        p = n(178);

    e.exports = function (e, t, n, g, v, m) {
      var y = i[e],
          x = y,
          _ = v ? "set" : "add",
          b = x && x.prototype,
          w = {},
          S = function S(e) {
        var t = b[e];
        o(b, e, "delete" == e || "has" == e ? function (e) {
          return !(m && !c(e)) && t.call(this, 0 === e ? 0 : e);
        } : "get" == e ? function (e) {
          return m && !c(e) ? void 0 : t.call(this, 0 === e ? 0 : e);
        } : "add" == e ? function (e) {
          return t.call(this, 0 === e ? 0 : e), this;
        } : function (e, n) {
          return t.call(this, 0 === e ? 0 : e, n), this;
        });
      };

      if ("function" == typeof x && (m || b.forEach && !h(function () {
        new x().entries().next();
      }))) {
        var T = new x(),
            C = T[_](m ? {} : -0, 1) != T,
            k = h(function () {
          T.has(1);
        }),
            M = d(function (e) {
          new x(e);
        }),
            E = !m && h(function () {
          for (var e = new x(), t = 5; t--;) {
            e[_](t, t);
          }

          return !e.has(-0);
        });
        M || ((x = t(function (t, n) {
          u(t, x, e);
          var i = p(new y(), t, x);
          return null != n && l(n, v, i[_], i), i;
        })).prototype = b, b.constructor = x), (k || E) && (S("delete"), S("has"), v && S("get")), (E || C) && S(_), m && b.clear && delete b.clear;
      } else x = g.getConstructor(t, e, v, _), a(x.prototype, n), s.NEED = !0;

      return f(x, e), w[e] = x, r(r.G + r.W + r.F * (x != y), w), m || g.setStrong(x, e, v), x;
    };
  }, function (e, t, n) {
    for (var i, r = n(10), o = n(37), a = n(74), s = a("typed_array"), l = a("view"), u = !(!r.ArrayBuffer || !r.DataView), c = u, h = 0, d = "Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array".split(","); h < 9;) {
      (i = r[d[h++]]) ? (o(i.prototype, s, !0), o(i.prototype, l, !0)) : c = !1;
    }

    e.exports = {
      ABV: u,
      CONSTR: c,
      TYPED: s,
      VIEW: l
    };
  }, function (e, t, n) {
    var i = n(574),
        r = n(575),
        o = n(576),
        a = n(577),
        s = n(578);

    function l(e) {
      var t = -1,
          n = null == e ? 0 : e.length;

      for (this.clear(); ++t < n;) {
        var i = e[t];
        this.set(i[0], i[1]);
      }
    }

    l.prototype.clear = i, l.prototype.delete = r, l.prototype.get = o, l.prototype.has = a, l.prototype.set = s, e.exports = l;
  }, function (e, t, n) {
    var i = n(275);

    e.exports = function (e, t) {
      for (var n = e.length; n--;) {
        if (i(e[n][0], t)) return n;
      }

      return -1;
    };
  }, function (e, t, n) {
    var i = n(99)(Object, "create");
    e.exports = i;
  }, function (e, t, n) {
    var i = n(598);

    e.exports = function (e, t) {
      var n = e.__data__;
      return i(t) ? n["string" == typeof t ? "string" : "hash"] : n.map;
    };
  }, function (e, t, n) {
    var i = n(284),
        r = n(21),
        o = n(1),
        a = n(645),
        s = n(649),
        l = n(653),
        u = n(655),
        c = n(656),
        h = !r.canvasSupported,
        d = {
      canvas: l
    },
        f = {};

    var p = function p(e, t, n) {
      n = n || {}, this.dom = t, this.id = e;
      var i = this,
          l = new s(),
          f = n.renderer;

      if (h) {
        if (!d.vml) throw new Error("You need to require 'zrender/vml/vml' to support IE8");
        f = "vml";
      } else f && d[f] || (f = "canvas");

      var p = new d[f](t, l, n, e);
      this.storage = l, this.painter = p;
      var g = r.node || r.worker ? null : new c(p.getViewportRoot(), p.root);
      this.handler = new a(l, p, g, p.root), this.animation = new u({
        stage: {
          update: o.bind(this.flush, this)
        }
      }), this.animation.start(), this._needsRefresh;
      var v = l.delFromStorage,
          m = l.addToStorage;
      l.delFromStorage = function (e) {
        v.call(l, e), e && e.removeSelfFromZr(i);
      }, l.addToStorage = function (e) {
        m.call(l, e), e.addSelfToZr(i);
      };
    };

    p.prototype = {
      constructor: p,
      getId: function getId() {
        return this.id;
      },
      add: function add(e) {
        this.storage.addRoot(e), this._needsRefresh = !0;
      },
      remove: function remove(e) {
        this.storage.delRoot(e), this._needsRefresh = !0;
      },
      configLayer: function configLayer(e, t) {
        this.painter.configLayer && this.painter.configLayer(e, t), this._needsRefresh = !0;
      },
      setBackgroundColor: function setBackgroundColor(e) {
        this.painter.setBackgroundColor && this.painter.setBackgroundColor(e), this._needsRefresh = !0;
      },
      refreshImmediately: function refreshImmediately() {
        this._needsRefresh = this._needsRefreshHover = !1, this.painter.refresh(), this._needsRefresh = this._needsRefreshHover = !1;
      },
      refresh: function refresh() {
        this._needsRefresh = !0;
      },
      flush: function flush() {
        var e;
        this._needsRefresh && (e = !0, this.refreshImmediately()), this._needsRefreshHover && (e = !0, this.refreshHoverImmediately()), e && this.trigger("rendered");
      },
      addHover: function addHover(e, t) {
        if (this.painter.addHover) {
          var n = this.painter.addHover(e, t);
          return this.refreshHover(), n;
        }
      },
      removeHover: function removeHover(e) {
        this.painter.removeHover && (this.painter.removeHover(e), this.refreshHover());
      },
      clearHover: function clearHover() {
        this.painter.clearHover && (this.painter.clearHover(), this.refreshHover());
      },
      refreshHover: function refreshHover() {
        this._needsRefreshHover = !0;
      },
      refreshHoverImmediately: function refreshHoverImmediately() {
        this._needsRefreshHover = !1, this.painter.refreshHover && this.painter.refreshHover();
      },
      resize: function resize(e) {
        e = e || {}, this.painter.resize(e.width, e.height), this.handler.resize();
      },
      clearAnimation: function clearAnimation() {
        this.animation.clear();
      },
      getWidth: function getWidth() {
        return this.painter.getWidth();
      },
      getHeight: function getHeight() {
        return this.painter.getHeight();
      },
      pathToImage: function pathToImage(e, t) {
        return this.painter.pathToImage(e, t);
      },
      setCursorStyle: function setCursorStyle(e) {
        this.handler.setCursorStyle(e);
      },
      findHover: function findHover(e, t) {
        return this.handler.findHover(e, t);
      },
      on: function on(e, t, n) {
        this.handler.on(e, t, n);
      },
      off: function off(e, t) {
        this.handler.off(e, t);
      },
      trigger: function trigger(e, t) {
        this.handler.trigger(e, t);
      },
      clear: function clear() {
        this.storage.delRoot(), this.painter.clear();
      },
      dispose: function dispose() {
        var e;
        this.animation.stop(), this.clear(), this.storage.dispose(), this.painter.dispose(), this.handler.dispose(), this.animation = this.storage = this.painter = this.handler = null, e = this.id, delete f[e];
      }
    }, t.version = "4.3.1", t.init = function (e, t) {
      var n = new p(i(), e, t);
      return f[n.id] = n, n;
    }, t.dispose = function (e) {
      if (e) e.dispose();else {
        for (var t in f) {
          f.hasOwnProperty(t) && f[t].dispose();
        }

        f = {};
      }
      return this;
    }, t.getInstance = function (e) {
      return f[e];
    }, t.registerPainter = function (e, t) {
      d[e] = t;
    };
  }, function (e, t, n) {
    var i = n(31),
        r = n(16),
        o = i.identity;

    function a(e) {
      return e > 5e-5 || e < -5e-5;
    }

    var s = function s(e) {
      (e = e || {}).position || (this.position = [0, 0]), null == e.rotation && (this.rotation = 0), e.scale || (this.scale = [1, 1]), this.origin = this.origin || null;
    },
        l = s.prototype;

    l.transform = null, l.needLocalTransform = function () {
      return a(this.rotation) || a(this.position[0]) || a(this.position[1]) || a(this.scale[0] - 1) || a(this.scale[1] - 1);
    };
    var u = [];
    l.updateTransform = function () {
      var e = this.parent,
          t = e && e.transform,
          n = this.needLocalTransform(),
          r = this.transform;

      if (n || t) {
        r = r || i.create(), n ? this.getLocalTransform(r) : o(r), t && (n ? i.mul(r, e.transform, r) : i.copy(r, e.transform)), this.transform = r;
        var a = this.globalScaleRatio;

        if (null != a && 1 !== a) {
          this.getGlobalScale(u);
          var s = u[0] < 0 ? -1 : 1,
              l = u[1] < 0 ? -1 : 1,
              c = ((u[0] - s) * a + s) / u[0] || 0,
              h = ((u[1] - l) * a + l) / u[1] || 0;
          r[0] *= c, r[1] *= c, r[2] *= h, r[3] *= h;
        }

        this.invTransform = this.invTransform || i.create(), i.invert(this.invTransform, r);
      } else r && o(r);
    }, l.getLocalTransform = function (e) {
      return s.getLocalTransform(this, e);
    }, l.setTransform = function (e) {
      var t = this.transform,
          n = e.dpr || 1;
      t ? e.setTransform(n * t[0], n * t[1], n * t[2], n * t[3], n * t[4], n * t[5]) : e.setTransform(n, 0, 0, n, 0, 0);
    }, l.restoreTransform = function (e) {
      var t = e.dpr || 1;
      e.setTransform(t, 0, 0, t, 0, 0);
    };
    var c = [],
        h = i.create();
    l.setLocalTransform = function (e) {
      if (e) {
        var t = e[0] * e[0] + e[1] * e[1],
            n = e[2] * e[2] + e[3] * e[3],
            i = this.position,
            r = this.scale;
        a(t - 1) && (t = Math.sqrt(t)), a(n - 1) && (n = Math.sqrt(n)), e[0] < 0 && (t = -t), e[3] < 0 && (n = -n), i[0] = e[4], i[1] = e[5], r[0] = t, r[1] = n, this.rotation = Math.atan2(-e[1] / n, e[0] / t);
      }
    }, l.decomposeTransform = function () {
      if (this.transform) {
        var e = this.parent,
            t = this.transform;
        e && e.transform && (i.mul(c, e.invTransform, t), t = c);
        var n = this.origin;
        n && (n[0] || n[1]) && (h[4] = n[0], h[5] = n[1], i.mul(c, t, h), c[4] -= n[0], c[5] -= n[1], t = c), this.setLocalTransform(t);
      }
    }, l.getGlobalScale = function (e) {
      var t = this.transform;
      return e = e || [], t ? (e[0] = Math.sqrt(t[0] * t[0] + t[1] * t[1]), e[1] = Math.sqrt(t[2] * t[2] + t[3] * t[3]), t[0] < 0 && (e[0] = -e[0]), t[3] < 0 && (e[1] = -e[1]), e) : (e[0] = 1, e[1] = 1, e);
    }, l.transformCoordToLocal = function (e, t) {
      var n = [e, t],
          i = this.invTransform;
      return i && r.applyTransform(n, n, i), n;
    }, l.transformCoordToGlobal = function (e, t) {
      var n = [e, t],
          i = this.transform;
      return i && r.applyTransform(n, n, i), n;
    }, s.getLocalTransform = function (e, t) {
      o(t = t || []);
      var n = e.origin,
          r = e.scale || [1, 1],
          a = e.rotation || 0,
          s = e.position || [0, 0];
      return n && (t[4] -= n[0], t[5] -= n[1]), i.scale(t, t, r), a && i.rotate(t, t, a), n && (t[4] += n[0], t[5] += n[1]), t[4] += s[0], t[5] += s[1], t;
    };
    var d = s;
    e.exports = d;
  }, function (e, t) {
    var n = 1;
    "undefined" != typeof window && (n = Math.max(window.devicePixelRatio || 1, 1));
    var i = n;
    t.debugMode = 0, t.devicePixelRatio = i;
  }, function (e, t) {
    t.ContextCachedBy = {
      NONE: 0,
      STYLE_BIND: 1,
      PLAIN_TEXT: 2
    }, t.WILL_BE_RESTORED = 9;
  }, function (e, t, n) {
    var i = n(1),
        r = i.retrieve2,
        o = i.retrieve3,
        a = i.each,
        s = i.normalizeCssArray,
        l = i.isString,
        u = i.isObject,
        c = n(35),
        h = n(293),
        d = n(205),
        f = n(289),
        p = n(155),
        g = p.ContextCachedBy,
        v = p.WILL_BE_RESTORED,
        m = c.DEFAULT_FONT,
        y = {
      left: 1,
      right: 1,
      center: 1
    },
        x = {
      top: 1,
      bottom: 1,
      middle: 1
    },
        _ = [["textShadowBlur", "shadowBlur", 0], ["textShadowOffsetX", "shadowOffsetX", 0], ["textShadowOffsetY", "shadowOffsetY", 0], ["textShadowColor", "shadowColor", "transparent"]],
        b = {},
        w = {};

    function S(e) {
      if (e) {
        e.font = c.makeFont(e);
        var t = e.textAlign;
        "middle" === t && (t = "center"), e.textAlign = null == t || y[t] ? t : "left";
        var n = e.textVerticalAlign || e.textBaseline;
        "center" === n && (n = "middle"), e.textVerticalAlign = null == n || x[n] ? n : "top", e.textPadding && (e.textPadding = s(e.textPadding));
      }
    }

    function T(e, t, n, i, r) {
      if (n && t.textRotation) {
        var o = t.textOrigin;
        "center" === o ? (i = n.width / 2 + n.x, r = n.height / 2 + n.y) : o && (i = o[0] + n.x, r = o[1] + n.y), e.translate(i, r), e.rotate(-t.textRotation), e.translate(-i, -r);
      }
    }

    function C(e, t, n, i, a, s, l, u) {
      var c = i.rich[n.styleName] || {};
      c.text = n.text;
      var h = n.textVerticalAlign,
          d = s + a / 2;
      "top" === h ? d = s + n.height / 2 : "bottom" === h && (d = s + a - n.height / 2), !n.isLineHolder && k(c) && M(e, t, c, "right" === u ? l - n.width : "center" === u ? l - n.width / 2 : l, d - n.height / 2, n.width, n.height);
      var f = n.textPadding;
      f && (l = D(l, u, f), d -= n.height / 2 - f[2] - n.textHeight / 2), I(t, "shadowBlur", o(c.textShadowBlur, i.textShadowBlur, 0)), I(t, "shadowColor", c.textShadowColor || i.textShadowColor || "transparent"), I(t, "shadowOffsetX", o(c.textShadowOffsetX, i.textShadowOffsetX, 0)), I(t, "shadowOffsetY", o(c.textShadowOffsetY, i.textShadowOffsetY, 0)), I(t, "textAlign", u), I(t, "textBaseline", "middle"), I(t, "font", n.font || m);
      var p = P(c.textStroke || i.textStroke, v),
          g = O(c.textFill || i.textFill),
          v = r(c.textStrokeWidth, i.textStrokeWidth);
      p && (I(t, "lineWidth", v), I(t, "strokeStyle", p), t.strokeText(n.text, l, d)), g && (I(t, "fillStyle", g), t.fillText(n.text, l, d));
    }

    function k(e) {
      return !!(e.textBackgroundColor || e.textBorderWidth && e.textBorderColor);
    }

    function M(e, t, n, i, r, o, a) {
      var s = n.textBackgroundColor,
          c = n.textBorderWidth,
          f = n.textBorderColor,
          p = l(s);

      if (I(t, "shadowBlur", n.textBoxShadowBlur || 0), I(t, "shadowColor", n.textBoxShadowColor || "transparent"), I(t, "shadowOffsetX", n.textBoxShadowOffsetX || 0), I(t, "shadowOffsetY", n.textBoxShadowOffsetY || 0), p || c && f) {
        t.beginPath();
        var g = n.textBorderRadius;
        g ? h.buildPath(t, {
          x: i,
          y: r,
          width: o,
          height: a,
          r: g
        }) : t.rect(i, r, o, a), t.closePath();
      }

      if (p) {
        if (I(t, "fillStyle", s), null != n.fillOpacity) {
          var v = t.globalAlpha;
          t.globalAlpha = n.fillOpacity * n.opacity, t.fill(), t.globalAlpha = v;
        } else t.fill();
      } else if (u(s)) {
        var m = s.image;
        (m = d.createOrUpdateImage(m, null, e, E, s)) && d.isImageReady(m) && t.drawImage(m, i, r, o, a);
      }
      if (c && f) if (I(t, "lineWidth", c), I(t, "strokeStyle", f), null != n.strokeOpacity) {
        v = t.globalAlpha;
        t.globalAlpha = n.strokeOpacity * n.opacity, t.stroke(), t.globalAlpha = v;
      } else t.stroke();
    }

    function E(e, t) {
      t.image = e;
    }

    function A(e, t, n, i) {
      var r = n.x || 0,
          o = n.y || 0,
          a = n.textAlign,
          s = n.textVerticalAlign;

      if (i) {
        var l = n.textPosition;
        if (l instanceof Array) r = i.x + L(l[0], i.width), o = i.y + L(l[1], i.height);else {
          var u = t && t.calculateTextPosition ? t.calculateTextPosition(b, n, i) : c.calculateTextPosition(b, n, i);
          r = u.x, o = u.y, a = a || u.textAlign, s = s || u.textVerticalAlign;
        }
        var h = n.textOffset;
        h && (r += h[0], o += h[1]);
      }

      return (e = e || {}).baseX = r, e.baseY = o, e.textAlign = a, e.textVerticalAlign = s, e;
    }

    function I(e, t, n) {
      return e[t] = f(e, t, n), e[t];
    }

    function P(e, t) {
      return null == e || t <= 0 || "transparent" === e || "none" === e ? null : e.image || e.colorStops ? "#000" : e;
    }

    function O(e) {
      return null == e || "none" === e ? null : e.image || e.colorStops ? "#000" : e;
    }

    function L(e, t) {
      return "string" == typeof e ? e.lastIndexOf("%") >= 0 ? parseFloat(e) / 100 * t : parseFloat(e) : e;
    }

    function D(e, t, n) {
      return "right" === t ? e - n[1] : "center" === t ? e + n[3] / 2 - n[1] / 2 : e + n[3];
    }

    t.normalizeTextStyle = function (e) {
      return S(e), a(e.rich, S), e;
    }, t.renderText = function (e, t, n, i, r, o) {
      i.rich ? function (e, t, n, i, r, o) {
        o !== v && (t.__attrCachedBy = g.NONE);
        var a = e.__textCotentBlock;
        a && !e.__dirtyText || (a = e.__textCotentBlock = c.parseRichText(n, i));
        !function (e, t, n, i, r) {
          var o = n.width,
              a = n.outerWidth,
              s = n.outerHeight,
              l = i.textPadding,
              u = A(w, e, i, r),
              h = u.baseX,
              d = u.baseY,
              f = u.textAlign,
              p = u.textVerticalAlign;
          T(t, i, r, h, d);
          var g = c.adjustTextX(h, a, f),
              v = c.adjustTextY(d, s, p),
              m = g,
              y = v;
          l && (m += l[3], y += l[0]);
          var x = m + o;
          k(i) && M(e, t, i, g, v, a, s);

          for (var _ = 0; _ < n.lines.length; _++) {
            for (var b, S = n.lines[_], E = S.tokens, I = E.length, P = S.lineHeight, O = S.width, L = 0, D = m, N = x, j = I - 1; L < I && (!(b = E[L]).textAlign || "left" === b.textAlign);) {
              C(e, t, b, i, P, y, D, "left"), O -= b.width, D += b.width, L++;
            }

            for (; j >= 0 && "right" === (b = E[j]).textAlign;) {
              C(e, t, b, i, P, y, N, "right"), O -= b.width, N -= b.width, j--;
            }

            for (D += (o - (D - m) - (x - N) - O) / 2; L <= j;) {
              b = E[L], C(e, t, b, i, P, y, D + b.width / 2, "center"), D += b.width, L++;
            }

            y += P;
          }
        }(e, t, a, i, r);
      }(e, t, n, i, r, o) : function (e, t, n, i, r, o) {
        "use strict";

        var a,
            s = k(i),
            l = !1,
            u = t.__attrCachedBy === g.PLAIN_TEXT;
        o !== v ? (o && (a = o.style, l = !s && u && a), t.__attrCachedBy = s ? g.NONE : g.PLAIN_TEXT) : u && (t.__attrCachedBy = g.NONE);
        var h = i.font || m;
        l && h === (a.font || m) || (t.font = h);
        var d = e.__computedFont;
        e.__styleFont !== h && (e.__styleFont = h, d = e.__computedFont = t.font);
        var p = i.textPadding,
            y = i.textLineHeight,
            x = e.__textCotentBlock;
        x && !e.__dirtyText || (x = e.__textCotentBlock = c.parsePlainText(n, d, p, y, i.truncate));
        var b = x.outerHeight,
            S = x.lines,
            C = x.lineHeight,
            E = A(w, e, i, r),
            I = E.baseX,
            L = E.baseY,
            N = E.textAlign || "left",
            j = E.textVerticalAlign;
        T(t, i, r, I, L);
        var R = c.adjustTextY(L, b, j),
            F = I,
            z = R;

        if (s || p) {
          var B = c.getWidth(n, d);
          p && (B += p[1] + p[3]);
          var V = c.adjustTextX(I, B, N);
          s && M(e, t, i, V, R, B, b), p && (F = D(I, N, p), z += p[0]);
        }

        t.textAlign = N, t.textBaseline = "middle", t.globalAlpha = i.opacity || 1;

        for (var H = 0; H < _.length; H++) {
          var W = _[H],
              G = W[0],
              U = W[1],
              Y = i[G];
          l && Y === a[G] || (t[U] = f(t, U, Y || W[2]));
        }

        z += C / 2;
        var X = i.textStrokeWidth,
            q = l ? a.textStrokeWidth : null,
            Z = !l || X !== q,
            K = !l || Z || i.textStroke !== a.textStroke,
            $ = P(i.textStroke, X),
            Q = O(i.textFill);
        $ && (Z && (t.lineWidth = X), K && (t.strokeStyle = $));
        Q && (l && i.textFill === a.textFill || (t.fillStyle = Q));
        if (1 === S.length) $ && t.strokeText(S[0], F, z), Q && t.fillText(S[0], F, z);else for (H = 0; H < S.length; H++) {
          $ && t.strokeText(S[H], F, z), Q && t.fillText(S[H], F, z), z += C;
        }
      }(e, t, n, i, r, o);
    }, t.getBoxPosition = A, t.getStroke = P, t.getFill = O, t.parsePercent = L, t.needDrawText = function (e, t) {
      return null != e && (e || t.textBackgroundColor || t.textBorderWidth && t.textBorderColor || t.textPadding);
    };
  }, function (e, t) {
    var n = function n(e) {
      this.colorStops = e || [];
    };

    n.prototype = {
      constructor: n,
      addColorStop: function addColorStop(e, t) {
        this.colorStops.push({
          offset: e,
          color: t
        });
      }
    };
    var i = n;
    e.exports = i;
  }, function (e, t, n) {
    var i = n(84),
        r = n(121),
        o = n(60),
        a = function a() {
      this.group = new i(), this.uid = r.getUID("viewComponent");
    },
        s = a.prototype = {
      constructor: a,
      init: function init(e, t) {},
      render: function render(e, t, n, i) {},
      dispose: function dispose() {},
      filterForExposedEvent: null
    };

    s.updateView = s.updateLayout = s.updateVisual = function (e, t, n, i) {}, o.enableClassExtend(a), o.enableClassManagement(a, {
      registerWhenExtend: !0
    });
    var l = a;
    e.exports = l;
  }, function (e, t, n) {
    var i = n(60);

    function r(e) {
      this._setting = e || {}, this._extent = [1 / 0, -1 / 0], this._interval = 0, this.init && this.init.apply(this, arguments);
    }

    r.prototype.parse = function (e) {
      return e;
    }, r.prototype.getSetting = function (e) {
      return this._setting[e];
    }, r.prototype.contain = function (e) {
      var t = this._extent;
      return e >= t[0] && e <= t[1];
    }, r.prototype.normalize = function (e) {
      var t = this._extent;
      return t[1] === t[0] ? .5 : (e - t[0]) / (t[1] - t[0]);
    }, r.prototype.scale = function (e) {
      var t = this._extent;
      return e * (t[1] - t[0]) + t[0];
    }, r.prototype.unionExtent = function (e) {
      var t = this._extent;
      e[0] < t[0] && (t[0] = e[0]), e[1] > t[1] && (t[1] = e[1]);
    }, r.prototype.unionExtentFromData = function (e, t) {
      this.unionExtent(e.getApproximateExtent(t));
    }, r.prototype.getExtent = function () {
      return this._extent.slice();
    }, r.prototype.setExtent = function (e, t) {
      var n = this._extent;
      isNaN(e) || (n[0] = e), isNaN(t) || (n[1] = t);
    }, r.prototype.isBlank = function () {
      return this._isBlank;
    }, r.prototype.setBlank = function (e) {
      this._isBlank = e;
    }, r.prototype.getLabel = null, i.enableClassExtend(r), i.enableClassManagement(r, {
      registerWhenExtend: !0
    });
    var o = r;
    e.exports = o;
  }, function (e, t, n) {
    var i = n(6),
        r = n(15),
        o = n(159),
        a = n(314),
        s = i.round,
        l = o.extend({
      type: "interval",
      _interval: 0,
      _intervalPrecision: 2,
      setExtent: function setExtent(e, t) {
        var n = this._extent;
        isNaN(e) || (n[0] = parseFloat(e)), isNaN(t) || (n[1] = parseFloat(t));
      },
      unionExtent: function unionExtent(e) {
        var t = this._extent;
        e[0] < t[0] && (t[0] = e[0]), e[1] > t[1] && (t[1] = e[1]), l.prototype.setExtent.call(this, t[0], t[1]);
      },
      getInterval: function getInterval() {
        return this._interval;
      },
      setInterval: function setInterval(e) {
        this._interval = e, this._niceExtent = this._extent.slice(), this._intervalPrecision = a.getIntervalPrecision(e);
      },
      getTicks: function getTicks(e) {
        var t = this._interval,
            n = this._extent,
            i = this._niceExtent,
            r = this._intervalPrecision,
            o = [];
        if (!t) return o;
        n[0] < i[0] && (e ? o.push(s(i[0] - t, r)) : o.push(n[0]));

        for (var a = i[0]; a <= i[1] && (o.push(a), (a = s(a + t, r)) !== o[o.length - 1]);) {
          if (o.length > 1e4) return [];
        }

        var l = o.length ? o[o.length - 1] : i[1];
        return n[1] > l && (e ? o.push(s(l + t, r)) : o.push(n[1])), o;
      },
      getMinorTicks: function getMinorTicks(e) {
        for (var t = this.getTicks(!0), n = [], r = this.getExtent(), o = 1; o < t.length; o++) {
          for (var a = t[o], s = t[o - 1], l = 0, u = [], c = (a - s) / e; l < e - 1;) {
            var h = i.round(s + (l + 1) * c);
            h > r[0] && h < r[1] && u.push(h), l++;
          }

          n.push(u);
        }

        return n;
      },
      getLabel: function getLabel(e, t) {
        if (null == e) return "";
        var n = t && t.precision;
        return null == n ? n = i.getPrecisionSafe(e) || 0 : "auto" === n && (n = this._intervalPrecision), e = s(e, n, !0), r.addCommas(e);
      },
      niceTicks: function niceTicks(e, t, n) {
        e = e || 5;
        var i = this._extent,
            r = i[1] - i[0];

        if (isFinite(r)) {
          r < 0 && (r = -r, i.reverse());
          var o = a.intervalScaleNiceTicks(i, e, t, n);
          this._intervalPrecision = o.intervalPrecision, this._interval = o.interval, this._niceExtent = o.niceTickExtent;
        }
      },
      niceExtent: function niceExtent(e) {
        var t = this._extent;
        if (t[0] === t[1]) if (0 !== t[0]) {
          var n = t[0];
          e.fixMax || (t[1] += n / 2), t[0] -= n / 2;
        } else t[1] = 1;
        var i = t[1] - t[0];
        isFinite(i) || (t[0] = 0, t[1] = 1), this.niceTicks(e.splitNumber, e.minInterval, e.maxInterval);
        var r = this._interval;
        e.fixMin || (t[0] = s(Math.floor(t[0] / r) * r)), e.fixMax || (t[1] = s(Math.ceil(t[1] / r) * r));
      }
    });

    l.create = function () {
      return new l();
    };

    var u = l;
    e.exports = u;
  }, function (e, t, n) {
    var i = n(1),
        r = n(6).parsePercent,
        o = n(55).isDimensionStacked,
        a = n(103),
        s = "undefined" != typeof Float32Array ? Float32Array : Array;

    function l(e) {
      return e.get("stack") || "__ec_stack_" + e.seriesIndex;
    }

    function u(e) {
      return e.dim + e.index;
    }

    function c(e, t) {
      var n = [];
      return t.eachSeriesByType(e, function (e) {
        g(e) && !v(e) && n.push(e);
      }), n;
    }

    function h(e) {
      var t = function (e) {
        var t = {};
        i.each(e, function (e) {
          var n = e.coordinateSystem.getBaseAxis();
          if ("time" === n.type || "value" === n.type) for (var i = e.getData(), r = n.dim + "_" + n.index, o = i.mapDimension(n.dim), a = 0, s = i.count(); a < s; ++a) {
            var l = i.get(o, a);
            t[r] ? t[r].push(l) : t[r] = [l];
          }
        });
        var n = [];

        for (var r in t) {
          if (t.hasOwnProperty(r)) {
            var o = t[r];

            if (o) {
              o.sort(function (e, t) {
                return e - t;
              });

              for (var a = null, s = 1; s < o.length; ++s) {
                var l = o[s] - o[s - 1];
                l > 0 && (a = null === a ? l : Math.min(a, l));
              }

              n[r] = a;
            }
          }
        }

        return n;
      }(e),
          n = [];

      return i.each(e, function (e) {
        var i,
            o = e.coordinateSystem.getBaseAxis(),
            a = o.getExtent();
        if ("category" === o.type) i = o.getBandWidth();else if ("value" === o.type || "time" === o.type) {
          var s = o.dim + "_" + o.index,
              c = t[s],
              h = Math.abs(a[1] - a[0]),
              d = o.scale.getExtent(),
              f = Math.abs(d[1] - d[0]);
          i = c ? h / f * c : h;
        } else {
          var p = e.getData();
          i = Math.abs(a[1] - a[0]) / p.count();
        }
        var g = r(e.get("barWidth"), i),
            v = r(e.get("barMaxWidth"), i),
            m = r(e.get("barMinWidth") || 1, i),
            y = e.get("barGap"),
            x = e.get("barCategoryGap");
        n.push({
          bandWidth: i,
          barWidth: g,
          barMaxWidth: v,
          barMinWidth: m,
          barGap: y,
          barCategoryGap: x,
          axisKey: u(o),
          stackId: l(e)
        });
      }), d(n);
    }

    function d(e) {
      var t = {};
      i.each(e, function (e, n) {
        var i = e.axisKey,
            r = e.bandWidth,
            o = t[i] || {
          bandWidth: r,
          remainedWidth: r,
          autoWidthCount: 0,
          categoryGap: "20%",
          gap: "30%",
          stacks: {}
        },
            a = o.stacks;
        t[i] = o;
        var s = e.stackId;
        a[s] || o.autoWidthCount++, a[s] = a[s] || {
          width: 0,
          maxWidth: 0
        };
        var l = e.barWidth;
        l && !a[s].width && (a[s].width = l, l = Math.min(o.remainedWidth, l), o.remainedWidth -= l);
        var u = e.barMaxWidth;
        u && (a[s].maxWidth = u);
        var c = e.barMinWidth;
        c && (a[s].minWidth = c);
        var h = e.barGap;
        null != h && (o.gap = h);
        var d = e.barCategoryGap;
        null != d && (o.categoryGap = d);
      });
      var n = {};
      return i.each(t, function (e, t) {
        n[t] = {};
        var o = e.stacks,
            a = e.bandWidth,
            s = r(e.categoryGap, a),
            l = r(e.gap, 1),
            u = e.remainedWidth,
            c = e.autoWidthCount,
            h = (u - s) / (c + (c - 1) * l);
        h = Math.max(h, 0), i.each(o, function (e) {
          var t = e.maxWidth,
              n = e.minWidth;

          if (e.width) {
            i = e.width;
            t && (i = Math.min(i, t)), n && (i = Math.max(i, n)), e.width = i, u -= i + l * i, c--;
          } else {
            var i = h;
            t && t < i && (i = Math.min(t, u)), n && n > i && (i = n), i !== h && (e.width = i, u -= i + l * i, c--);
          }
        }), h = (u - s) / (c + (c - 1) * l), h = Math.max(h, 0);
        var d,
            f = 0;
        i.each(o, function (e, t) {
          e.width || (e.width = h), d = e, f += e.width * (1 + l);
        }), d && (f -= d.width * l);
        var p = -f / 2;
        i.each(o, function (e, i) {
          n[t][i] = n[t][i] || {
            bandWidth: a,
            offset: p,
            width: e.width
          }, p += e.width * (1 + l);
        });
      }), n;
    }

    function f(e, t, n) {
      if (e && t) {
        var i = e[u(t)];
        return null != i && null != n && (i = i[l(n)]), i;
      }
    }

    var p = {
      seriesType: "bar",
      plan: a(),
      reset: function reset(e) {
        if (g(e) && v(e)) {
          var t = e.getData(),
              n = e.coordinateSystem,
              i = n.grid.getRect(),
              r = n.getBaseAxis(),
              o = n.getOtherAxis(r),
              a = t.mapDimension(o.dim),
              l = t.mapDimension(r.dim),
              u = o.isHorizontal(),
              c = u ? 0 : 1,
              d = f(h([e]), r, e).width;
          return d > .5 || (d = .5), {
            progress: function progress(e, t) {
              var h,
                  f = e.count,
                  p = new s(2 * f),
                  g = new s(2 * f),
                  v = new s(f),
                  y = [],
                  x = [],
                  _ = 0,
                  b = 0;

              for (; null != (h = e.next());) {
                x[c] = t.get(a, h), x[1 - c] = t.get(l, h), y = n.dataToPoint(x, null, y), g[_] = u ? i.x + i.width : y[0], p[_++] = y[0], g[_] = u ? y[1] : i.y + i.height, p[_++] = y[1], v[b++] = h;
              }

              t.setLayout({
                largePoints: p,
                largeDataIndices: v,
                largeBackgroundPoints: g,
                barWidth: d,
                valueAxisStart: m(r, o, !1),
                backgroundStart: u ? i.x : i.y,
                valueAxisHorizontal: u
              });
            }
          };
        }
      }
    };

    function g(e) {
      return e.coordinateSystem && "cartesian2d" === e.coordinateSystem.type;
    }

    function v(e) {
      return e.pipelineContext && e.pipelineContext.large;
    }

    function m(e, t, n) {
      return t.toGlobalCoord(t.dataToCoord("log" === t.type ? 1 : 0));
    }

    t.getLayoutOnAxis = function (e) {
      var t = [],
          n = e.axis;

      if ("category" === n.type) {
        for (var r = n.getBandWidth(), o = 0; o < e.count; o++) {
          t.push(i.defaults({
            bandWidth: r,
            axisKey: "axis0",
            stackId: "__ec_stack_" + o
          }, e));
        }

        var a = d(t),
            s = [];

        for (o = 0; o < e.count; o++) {
          var l = a.axis0["__ec_stack_" + o];
          l.offsetCenter = l.offset + l.width / 2, s.push(l);
        }

        return s;
      }
    }, t.prepareLayoutBarSeries = c, t.makeColumnLayout = h, t.retrieveColumnLayout = f, t.layout = function (e, t) {
      var n = c(e, t),
          r = h(n),
          a = {},
          s = {};
      i.each(n, function (e) {
        var t = e.getData(),
            n = e.coordinateSystem,
            i = n.getBaseAxis(),
            c = l(e),
            h = r[u(i)][c],
            d = h.offset,
            f = h.width,
            p = n.getOtherAxis(i),
            g = e.get("barMinHeight") || 0;
        a[c] = a[c] || [], s[c] = s[c] || [], t.setLayout({
          bandWidth: h.bandWidth,
          offset: d,
          size: f
        });

        for (var v = t.mapDimension(p.dim), y = t.mapDimension(i.dim), x = o(t, v), _ = p.isHorizontal(), b = m(i, p, x), w = 0, S = t.count(); w < S; w++) {
          var T,
              C,
              k,
              M,
              E,
              A = t.get(v, w),
              I = t.get(y, w),
              P = A >= 0 ? "p" : "n",
              O = b;
          if (x && (a[c][I] || (a[c][I] = {
            p: b,
            n: b
          }), O = a[c][I][P]), _) T = O, C = (E = n.dataToPoint([A, I]))[1] + d, k = E[0] - b, M = f, Math.abs(k) < g && (k = (k < 0 ? -1 : 1) * g), isNaN(k) || x && (a[c][I][P] += k);else T = (E = n.dataToPoint([I, A]))[0] + d, C = O, k = f, M = E[1] - b, Math.abs(M) < g && (M = (M <= 0 ? -1 : 1) * g), isNaN(M) || x && (a[c][I][P] += M);
          t.setItemLayout(w, {
            x: T,
            y: C,
            width: k,
            height: M
          });
        }
      }, this);
    }, t.largeLayout = p;
  }, function (e, t, n) {
    var i = n(1),
        r = n(40).createSymbol,
        o = n(5),
        a = n(6).parsePercent,
        s = n(213).getDefaultLabel;

    function l(e, t, n) {
      o.Group.call(this), this.updateData(e, t, n);
    }

    var u = l.prototype,
        c = l.getSymbolSize = function (e, t) {
      var n = e.getItemVisual(t, "symbolSize");
      return n instanceof Array ? n.slice() : [+n, +n];
    };

    function h(e) {
      return [e[0] / 2, e[1] / 2];
    }

    function d(e, t) {
      this.parent.drift(e, t);
    }

    u._createSymbol = function (e, t, n, i, o) {
      this.removeAll();
      var a = t.getItemVisual(n, "color"),
          s = r(e, -1, -1, 2, 2, a, o);
      s.attr({
        z2: 100,
        culling: !0,
        scale: h(i)
      }), s.drift = d, this._symbolType = e, this.add(s);
    }, u.stopSymbolAnimation = function (e) {
      this.childAt(0).stopAnimation(e);
    }, u.getSymbolPath = function () {
      return this.childAt(0);
    }, u.getScale = function () {
      return this.childAt(0).scale;
    }, u.highlight = function () {
      this.childAt(0).trigger("emphasis");
    }, u.downplay = function () {
      this.childAt(0).trigger("normal");
    }, u.setZ = function (e, t) {
      var n = this.childAt(0);
      n.zlevel = e, n.z = t;
    }, u.setDraggable = function (e) {
      var t = this.childAt(0);
      t.draggable = e, t.cursor = e ? "move" : t.cursor;
    }, u.updateData = function (e, t, n) {
      this.silent = !1;
      var i = e.getItemVisual(t, "symbol") || "circle",
          r = e.hostModel,
          a = c(e, t),
          s = i !== this._symbolType;

      if (s) {
        var l = e.getItemVisual(t, "symbolKeepAspect");

        this._createSymbol(i, e, t, a, l);
      } else {
        (u = this.childAt(0)).silent = !1, o.updateProps(u, {
          scale: h(a)
        }, r, t);
      }

      if (this._updateCommon(e, t, a, n), s) {
        var u = this.childAt(0),
            d = n && n.fadeIn,
            f = {
          scale: u.scale.slice()
        };
        d && (f.style = {
          opacity: u.style.opacity
        }), u.scale = [0, 0], d && (u.style.opacity = 0), o.initProps(u, f, r, t);
      }

      this._seriesModel = r;
    };
    var f = ["itemStyle"],
        p = ["emphasis", "itemStyle"],
        g = ["label"],
        v = ["emphasis", "label"];

    function m(e, t) {
      if (!this.incremental && !this.useHoverLayer) if ("emphasis" === t) {
        var n = this.__symbolOriginalScale,
            i = n[1] / n[0],
            r = {
          scale: [Math.max(1.1 * n[0], n[0] + 3), Math.max(1.1 * n[1], n[1] + 3 * i)]
        };
        this.animateTo(r, 400, "elasticOut");
      } else "normal" === t && this.animateTo({
        scale: this.__symbolOriginalScale
      }, 400, "elasticOut");
    }

    u._updateCommon = function (e, t, n, r) {
      var l = this.childAt(0),
          u = e.hostModel,
          c = e.getItemVisual(t, "color");
      "image" !== l.type ? l.useStyle({
        strokeNoScale: !0
      }) : l.setStyle({
        opacity: null,
        shadowBlur: null,
        shadowOffsetX: null,
        shadowOffsetY: null,
        shadowColor: null
      });

      var d = r && r.itemStyle,
          y = r && r.hoverItemStyle,
          x = r && r.symbolOffset,
          _ = r && r.labelModel,
          b = r && r.hoverLabelModel,
          w = r && r.hoverAnimation,
          S = r && r.cursorStyle;

      if (!r || e.hasItemOption) {
        var T = r && r.itemModel ? r.itemModel : e.getItemModel(t);
        d = T.getModel(f).getItemStyle(["color"]), y = T.getModel(p).getItemStyle(), x = T.getShallow("symbolOffset"), _ = T.getModel(g), b = T.getModel(v), w = T.getShallow("hoverAnimation"), S = T.getShallow("cursor");
      } else y = i.extend({}, y);

      var C = l.style,
          k = e.getItemVisual(t, "symbolRotate");
      l.attr("rotation", (k || 0) * Math.PI / 180 || 0), x && l.attr("position", [a(x[0], n[0]), a(x[1], n[1])]), S && l.attr("cursor", S), l.setColor(c, r && r.symbolInnerColor), l.setStyle(d);
      var M = e.getItemVisual(t, "opacity");
      null != M && (C.opacity = M);
      var E = e.getItemVisual(t, "liftZ"),
          A = l.__z2Origin;
      null != E ? null == A && (l.__z2Origin = l.z2, l.z2 += E) : null != A && (l.z2 = A, l.__z2Origin = null);
      var I = r && r.useNameLabel;
      o.setLabelStyle(C, y, _, b, {
        labelFetcher: u,
        labelDataIndex: t,
        defaultText: function defaultText(t, n) {
          return I ? e.getName(t) : s(e, t);
        },
        isRectText: !0,
        autoColor: c
      }), l.__symbolOriginalScale = h(n), l.hoverStyle = y, l.highDownOnUpdate = w && u.isAnimationEnabled() ? m : null, o.setHoverStyle(l);
    }, u.fadeOut = function (e, t) {
      var n = this.childAt(0);
      this.silent = n.silent = !0, (!t || !t.keepLabel) && (n.style.text = null), o.updateProps(n, {
        style: {
          opacity: 0
        },
        scale: [0, 0]
      }, this._seriesModel, this.dataIndex, e);
    }, i.inherits(l, o.Group);
    var y = l;
    e.exports = y;
  }, function (e, t, n) {
    var i = n(1),
        r = n(322),
        o = n(26),
        a = n(14),
        s = a.getLayoutParams,
        l = a.mergeLayoutParam,
        u = n(313),
        c = ["value", "category", "time", "log"];

    e.exports = function (e, t, n, a) {
      i.each(c, function (o) {
        t.extend({
          type: e + "Axis." + o,
          mergeDefaultAndTheme: function mergeDefaultAndTheme(t, r) {
            var a = this.layoutMode,
                u = a ? s(t) : {},
                c = r.getTheme();
            i.merge(t, c.get(o + "Axis")), i.merge(t, this.getDefaultOption()), t.type = n(e, t), a && l(t, u, a);
          },
          optionUpdated: function optionUpdated() {
            "category" === this.option.type && (this.__ordinalMeta = u.createByAxisModel(this));
          },
          getCategories: function getCategories(e) {
            var t = this.option;
            if ("category" === t.type) return e ? t.data : this.__ordinalMeta.categories;
          },
          getOrdinalMeta: function getOrdinalMeta() {
            return this.__ordinalMeta;
          },
          defaultOption: i.mergeAll([{}, r[o + "Axis"], a], !0)
        });
      }), o.registerSubTypeDefaulter(e + "Axis", i.curry(n, e));
    };
  }, function (e, t, n) {
    var i = n(1),
        r = n(22),
        o = i.each,
        a = i.curry;

    function s(e, t) {
      return "all" === e || i.isArray(e) && i.indexOf(e, t) >= 0 || e === t;
    }

    function l(e) {
      var t = (e.ecModel.getComponent("axisPointer") || {}).coordSysAxesInfo;
      return t && t.axesInfo[c(e)];
    }

    function u(e) {
      return !!e.get("handle.show");
    }

    function c(e) {
      return e.type + "||" + e.id;
    }

    t.collect = function (e, t) {
      var n = {
        axesInfo: {},
        seriesInvolved: !1,
        coordSysAxesInfo: {},
        coordSysMap: {}
      };
      return function (e, t, n) {
        var l = t.getComponent("tooltip"),
            h = t.getComponent("axisPointer"),
            d = h.get("link", !0) || [],
            f = [];
        o(n.getCoordinateSystems(), function (n) {
          if (n.axisPointerEnabled) {
            var p = c(n.model),
                g = e.coordSysAxesInfo[p] = {};
            e.coordSysMap[p] = n;
            var v = n.model.getModel("tooltip", l);

            if (o(n.getAxes(), a(_, !1, null)), n.getTooltipAxes && l && v.get("show")) {
              var m = "axis" === v.get("trigger"),
                  y = "cross" === v.get("axisPointer.type"),
                  x = n.getTooltipAxes(v.get("axisPointer.axis"));
              (m || y) && o(x.baseAxes, a(_, !y || "cross", m)), y && o(x.otherAxes, a(_, "cross", !1));
            }
          }

          function _(a, l, p) {
            var m = p.model.getModel("axisPointer", h),
                y = m.get("show");

            if (y && ("auto" !== y || a || u(m))) {
              null == l && (l = m.get("triggerTooltip"));

              var x = (m = a ? function (e, t, n, a, s, l) {
                var u = t.getModel("axisPointer"),
                    c = {};
                o(["type", "snap", "lineStyle", "shadowStyle", "label", "animation", "animationDurationUpdate", "animationEasingUpdate", "z"], function (e) {
                  c[e] = i.clone(u.get(e));
                }), c.snap = "category" !== e.type && !!l, "cross" === u.get("type") && (c.type = "line");
                var h = c.label || (c.label = {});

                if (null == h.show && (h.show = !1), "cross" === s) {
                  var d = u.get("label.show");

                  if (h.show = null == d || d, !l) {
                    var f = c.lineStyle = u.get("crossStyle");
                    f && i.defaults(h, f.textStyle);
                  }
                }

                return e.model.getModel("axisPointer", new r(c, n, a));
              }(p, v, h, t, a, l) : m).get("snap"),
                  _ = c(p.model),
                  b = l || x || "category" === p.type,
                  w = e.axesInfo[_] = {
                key: _,
                axis: p,
                coordSys: n,
                axisPointerModel: m,
                triggerTooltip: l,
                involveSeries: b,
                snap: x,
                useHandle: u(m),
                seriesModels: []
              };

              g[_] = w, e.seriesInvolved |= b;

              var S = function (e, t) {
                for (var n = t.model, i = t.dim, r = 0; r < e.length; r++) {
                  var o = e[r] || {};
                  if (s(o[i + "AxisId"], n.id) || s(o[i + "AxisIndex"], n.componentIndex) || s(o[i + "AxisName"], n.name)) return r;
                }
              }(d, p);

              if (null != S) {
                var T = f[S] || (f[S] = {
                  axesInfo: {}
                });
                T.axesInfo[_] = w, T.mapper = d[S].mapper, w.linkGroup = T;
              }
            }
          }
        });
      }(n, e, t), n.seriesInvolved && function (e, t) {
        t.eachSeries(function (t) {
          var n = t.coordinateSystem,
              i = t.get("tooltip.trigger", !0),
              r = t.get("tooltip.show", !0);
          n && "none" !== i && !1 !== i && "item" !== i && !1 !== r && !1 !== t.get("axisPointer.show", !0) && o(e.coordSysAxesInfo[c(n.model)], function (e) {
            var i = e.axis;
            n.getAxis(i.dim) === i && (e.seriesModels.push(t), null == e.seriesDataCount && (e.seriesDataCount = 0), e.seriesDataCount += t.getData().count());
          });
        }, this);
      }(n, e), n;
    }, t.fixValue = function (e) {
      var t = l(e);

      if (t) {
        var n = t.axisPointerModel,
            i = t.axis.scale,
            r = n.option,
            o = n.get("status"),
            a = n.get("value");
        null != a && (a = i.parse(a));
        var s = u(n);
        null == o && (r.status = s ? "show" : "hide");
        var c = i.getExtent().slice();
        c[0] > c[1] && c.reverse(), (null == a || a > c[1]) && (a = c[1]), a < c[0] && (a = c[0]), r.value = a, s && (r.status = t.axis.scale.isBlank() ? "hide" : "show");
      }
    }, t.getAxisInfo = l, t.getAxisPointerModel = function (e) {
      var t = l(e);
      return t && t.axisPointerModel;
    }, t.makeKey = c;
  }, function (e, t, n) {
    var i = n(1).createHashMap;

    e.exports = function (e) {
      return {
        getTargetSeries: function getTargetSeries(t) {
          var n = {},
              r = i();
          return t.eachSeriesByType(e, function (e) {
            e.__paletteScope = n, r.set(e.uid, e);
          }), r;
        },
        reset: function reset(e, t) {
          var n = e.getRawData(),
              i = {},
              r = e.getData();
          r.each(function (e) {
            var t = r.getRawIndex(e);
            i[t] = e;
          }), n.each(function (t) {
            var o,
                a = i[t],
                s = null != a && r.getItemVisual(a, "color", !0),
                l = null != a && r.getItemVisual(a, "borderColor", !0);

            if (s && l || (o = n.getItemModel(t)), !s) {
              var u = o.get("itemStyle.color") || e.getColorFromPalette(n.getName(t) || t + "", e.__paletteScope, n.count());
              null != a && r.setItemVisual(a, "color", u);
            }

            if (!l) {
              var c = o.get("itemStyle.borderColor");
              null != a && r.setItemVisual(a, "borderColor", c);
            }
          });
        }
      };
    };
  }, function (e, t, n) {
    n(9).__DEV__;
    var i = n(1),
        r = i.each,
        o = i.createHashMap,
        a = n(212),
        s = n(728),
        l = n(733),
        u = n(17),
        c = {
      geoJSON: s,
      svg: l
    },
        h = {
      load: function load(e, t, n) {
        var i,
            a = [],
            s = o(),
            l = o(),
            h = f(e);
        return r(h, function (o) {
          var u = c[o.type].load(e, o, n);
          r(u.regions, function (e) {
            var n = e.name;
            t && t.hasOwnProperty(n) && (e = e.cloneShallow(n = t[n])), a.push(e), s.set(n, e), l.set(n, e.center);
          });
          var h = u.boundingRect;
          h && (i ? i.union(h) : i = h.clone());
        }), {
          regions: a,
          regionsMap: s,
          nameCoordMap: l,
          boundingRect: i || new u(0, 0, 0, 0)
        };
      },
      makeGraphic: d("makeGraphic"),
      removeGraphic: d("removeGraphic")
    };

    function d(e) {
      return function (t, n) {
        var i = f(t),
            o = [];
        return r(i, function (i) {
          var r = c[i.type][e];
          r && o.push(r(t, i, n));
        }), o;
      };
    }

    function f(e) {
      return a.retrieveMap(e) || [];
    }

    e.exports = h;
  }, function (e, t) {
    var n = {
      axisPointer: 1,
      tooltip: 1,
      brush: 1
    };

    t.onIrrelevantElement = function (e, t, i) {
      var r = t.getComponentByElement(e.topTarget),
          o = r && r.coordinateSystem;
      return r && r !== i && !n[r.mainType] && o && o.model !== i;
    };
  }, function (e, t, n) {
    var i = n(1),
        r = n(5),
        o = n(35),
        a = n(15),
        s = n(31),
        l = n(43),
        u = n(70);

    function c(e, t, n, i, r) {
      var s = h(n.get("value"), t.axis, t.ecModel, n.get("seriesDataIndices"), {
        precision: n.get("label.precision"),
        formatter: n.get("label.formatter")
      }),
          l = n.getModel("label"),
          u = a.normalizeCssArray(l.get("padding") || 0),
          c = l.getFont(),
          d = o.getBoundingRect(s, c),
          f = r.position,
          p = d.width + u[1] + u[3],
          g = d.height + u[0] + u[2],
          v = r.align;
      "right" === v && (f[0] -= p), "center" === v && (f[0] -= p / 2);
      var m = r.verticalAlign;
      "bottom" === m && (f[1] -= g), "middle" === m && (f[1] -= g / 2), function (e, t, n, i) {
        var r = i.getWidth(),
            o = i.getHeight();
        e[0] = Math.min(e[0] + t, r) - t, e[1] = Math.min(e[1] + n, o) - n, e[0] = Math.max(e[0], 0), e[1] = Math.max(e[1], 0);
      }(f, p, g, i);
      var y = l.get("backgroundColor");
      y && "auto" !== y || (y = t.get("axisLine.lineStyle.color")), e.label = {
        shape: {
          x: 0,
          y: 0,
          width: p,
          height: g,
          r: l.get("borderRadius")
        },
        position: f.slice(),
        style: {
          text: s,
          textFont: c,
          textFill: l.getTextColor(),
          textPosition: "inside",
          textPadding: u,
          fill: y,
          stroke: l.get("borderColor") || "transparent",
          lineWidth: l.get("borderWidth") || 0,
          shadowBlur: l.get("shadowBlur"),
          shadowColor: l.get("shadowColor"),
          shadowOffsetX: l.get("shadowOffsetX"),
          shadowOffsetY: l.get("shadowOffsetY")
        },
        z2: 10
      };
    }

    function h(e, t, n, r, o) {
      e = t.scale.parse(e);
      var a = t.scale.getLabel(e, {
        precision: o.precision
      }),
          s = o.formatter;

      if (s) {
        var u = {
          value: l.getAxisRawValue(t, e),
          axisDimension: t.dim,
          axisIndex: t.index,
          seriesData: []
        };
        i.each(r, function (e) {
          var t = n.getSeriesByIndex(e.seriesIndex),
              i = e.dataIndexInside,
              r = t && t.getDataParams(i);
          r && u.seriesData.push(r);
        }), i.isString(s) ? a = s.replace("{value}", a) : i.isFunction(s) && (a = s(u));
      }

      return a;
    }

    function d(e, t, n) {
      var i = s.create();
      return s.rotate(i, i, n.rotation), s.translate(i, i, n.position), r.applyTransform([e.dataToCoord(t), (n.labelOffset || 0) + (n.labelDirection || 1) * (n.labelMargin || 0)], i);
    }

    t.buildElStyle = function (e) {
      var t,
          n = e.get("type"),
          i = e.getModel(n + "Style");
      return "line" === n ? (t = i.getLineStyle()).fill = null : "shadow" === n && ((t = i.getAreaStyle()).stroke = null), t;
    }, t.buildLabelElOption = c, t.getValueLabel = h, t.getTransformedPosition = d, t.buildCartesianSingleLabelElOption = function (e, t, n, i, r, o) {
      var a = u.innerTextLayout(n.rotation, 0, n.labelDirection);
      n.labelMargin = r.get("label.margin"), c(t, i, r, o, {
        position: d(i.axis, e, n),
        align: a.textAlign,
        verticalAlign: a.textVerticalAlign
      });
    }, t.makeLineShape = function (e, t, n) {
      return {
        x1: e[n = n || 0],
        y1: e[1 - n],
        x2: t[n],
        y2: t[1 - n]
      };
    }, t.makeRectShape = function (e, t, n) {
      return {
        x: e[n = n || 0],
        y: e[1 - n],
        width: t[n],
        height: t[1 - n]
      };
    }, t.makeSectorShape = function (e, t, n, i, r, o) {
      return {
        cx: e,
        cy: t,
        r0: n,
        r: i,
        startAngle: r,
        endAngle: o,
        clockwise: !0
      };
    };
  }, function (e, t, n) {
    var i = n(1),
        r = n(91),
        o = i.each;

    function a(e) {
      if (e) for (var t in e) {
        if (e.hasOwnProperty(t)) return !0;
      }
    }

    t.createVisualMappings = function (e, t, n) {
      var a = {};
      return o(t, function (t) {
        var s,
            l = a[t] = ((s = function s() {}).prototype.__hidden = s.prototype, new s());
        o(e[t], function (e, o) {
          if (r.isValidType(o)) {
            var a = {
              type: o,
              visual: e
            };
            n && n(a, t), l[o] = new r(a), "opacity" === o && ((a = i.clone(a)).type = "colorAlpha", l.__hidden.__alphaForOpacity = new r(a));
          }
        });
      }), a;
    }, t.replaceVisualOption = function (e, t, n) {
      var r;
      i.each(n, function (e) {
        t.hasOwnProperty(e) && a(t[e]) && (r = !0);
      }), r && i.each(n, function (n) {
        t.hasOwnProperty(n) && a(t[n]) ? e[n] = i.clone(t[n]) : delete e[n];
      });
    }, t.applyVisual = function (e, t, n, o, a, s) {
      var l,
          u = {};

      function c(e) {
        return n.getItemVisual(l, e);
      }

      function h(e, t) {
        n.setItemVisual(l, e, t);
      }

      function d(e, i) {
        l = null == s ? e : i;
        var r = n.getRawDataItem(l);
        if (!r || !1 !== r.visualMap) for (var d = o.call(a, e), f = t[d], p = u[d], g = 0, v = p.length; g < v; g++) {
          var m = p[g];
          f[m] && f[m].applyVisual(e, c, h);
        }
      }

      i.each(e, function (e) {
        var n = r.prepareVisualTypes(t[e]);
        u[e] = n;
      }), null == s ? n.each(d) : n.each([s], d);
    }, t.incrementalApplyVisual = function (e, t, n, o) {
      var a = {};
      return i.each(e, function (e) {
        var n = r.prepareVisualTypes(t[e]);
        a[e] = n;
      }), {
        progress: function progress(e, i) {
          function r(e) {
            return i.getItemVisual(l, e);
          }

          function s(e, t) {
            i.setItemVisual(l, e, t);
          }

          var l;

          for (null != o && (o = i.getDimension(o)); null != (l = e.next());) {
            var u = i.getRawDataItem(l);
            if (!u || !1 !== u.visualMap) for (var c = null != o ? i.get(o, l, !0) : l, h = n(c), d = t[h], f = a[h], p = 0, g = f.length; p < g; p++) {
              var v = f[p];
              d[v] && d[v].applyVisual(c, r, s);
            }
          }
        }
      };
    };
  }, function (e, t, n) {
    "use strict";

    !function e() {
      if ("undefined" != typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" == typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE) {
        0;

        try {
          __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(e);
        } catch (e) {
          console.error(e);
        }
      }
    }(), e.exports = n(638);
  }, function (e, t, n) {
    var i = n(13),
        r = n(10).document,
        o = i(r) && i(r.createElement);

    e.exports = function (e) {
      return o ? r.createElement(e) : {};
    };
  }, function (e, t, n) {
    t.f = n(18);
  }, function (e, t, n) {
    var i = n(136)("keys"),
        r = n(74);

    e.exports = function (e) {
      return i[e] || (i[e] = r(e));
    };
  }, function (e, t) {
    e.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
  }, function (e, t, n) {
    var i = n(10).document;
    e.exports = i && i.documentElement;
  }, function (e, t, n) {
    var i = n(13),
        r = n(12),
        o = function o(e, t) {
      if (r(e), !i(t) && null !== t) throw TypeError(t + ": can't set as prototype!");
    };

    e.exports = {
      set: Object.setPrototypeOf || ("__proto__" in {} ? function (e, t, i) {
        try {
          (i = n(45)(Function.call, n(48).f(Object.prototype, "__proto__").set, 2))(e, []), t = !(e instanceof Array);
        } catch (e) {
          t = !0;
        }

        return function (e, n) {
          return o(e, n), t ? e.__proto__ = n : i(e, n), e;
        };
      }({}, !1) : void 0),
      check: o
    };
  }, function (e, t) {
    e.exports = "\t\n\x0B\f\r \xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";
  }, function (e, t, n) {
    var i = n(13),
        r = n(176).set;

    e.exports = function (e, t, n) {
      var o,
          a = t.constructor;
      return a !== n && "function" == typeof a && (o = a.prototype) !== n.prototype && i(o) && r && r(e, o), e;
    };
  }, function (e, t, n) {
    "use strict";

    var i = n(47),
        r = n(58);

    e.exports = function (e) {
      var t = String(r(this)),
          n = "",
          o = i(e);
      if (o < 0 || o == 1 / 0) throw RangeError("Count can't be negative");

      for (; o > 0; (o >>>= 1) && (t += t)) {
        1 & o && (n += t);
      }

      return n;
    };
  }, function (e, t) {
    e.exports = Math.sign || function (e) {
      return 0 == (e = +e) || e != e ? e : e < 0 ? -1 : 1;
    };
  }, function (e, t) {
    var n = Math.expm1;
    e.exports = !n || n(10) > 22025.465794806718 || n(10) < 22025.465794806718 || -2e-17 != n(-2e-17) ? function (e) {
      return 0 == (e = +e) ? e : e > -1e-6 && e < 1e-6 ? e + e * e / 2 : Math.exp(e) - 1;
    } : n;
  }, function (e, t, n) {
    var i = n(47),
        r = n(58);

    e.exports = function (e) {
      return function (t, n) {
        var o,
            a,
            s = String(r(t)),
            l = i(n),
            u = s.length;
        return l < 0 || l >= u ? e ? "" : void 0 : (o = s.charCodeAt(l)) < 55296 || o > 56319 || l + 1 === u || (a = s.charCodeAt(l + 1)) < 56320 || a > 57343 ? e ? s.charAt(l) : o : e ? s.slice(l, l + 2) : a - 56320 + (o - 55296 << 10) + 65536;
      };
    };
  }, function (e, t, n) {
    "use strict";

    var i = n(75),
        r = n(3),
        o = n(33),
        a = n(37),
        s = n(95),
        l = n(254),
        u = n(93),
        c = n(80),
        h = n(18)("iterator"),
        d = !([].keys && "next" in [].keys()),
        f = function f() {
      return this;
    };

    e.exports = function (e, t, n, p, g, v, m) {
      l(n, t, p);

      var y,
          x,
          _,
          b = function b(e) {
        if (!d && e in C) return C[e];

        switch (e) {
          case "keys":
          case "values":
            return function () {
              return new n(this, e);
            };
        }

        return function () {
          return new n(this, e);
        };
      },
          w = t + " Iterator",
          S = "values" == g,
          T = !1,
          C = e.prototype,
          k = C[h] || C["@@iterator"] || g && C[g],
          M = k || b(g),
          E = g ? S ? b("entries") : M : void 0,
          A = "Array" == t && C.entries || k;

      if (A && (_ = c(A.call(new e()))) !== Object.prototype && _.next && (u(_, w, !0), i || "function" == typeof _[h] || a(_, h, f)), S && k && "values" !== k.name && (T = !0, M = function M() {
        return k.call(this);
      }), i && !m || !d && !T && C[h] || a(C, h, M), s[t] = M, s[w] = f, g) if (y = {
        values: S ? M : b("values"),
        keys: v ? M : b("keys"),
        entries: E
      }, m) for (x in y) {
        x in C || o(C, x, y[x]);
      } else r(r.P + r.F * (d || T), t, y);
      return y;
    };
  }, function (e, t, n) {
    var i = n(185),
        r = n(58);

    e.exports = function (e, t, n) {
      if (i(t)) throw TypeError("String#" + n + " doesn't accept regex!");
      return String(r(e));
    };
  }, function (e, t, n) {
    var i = n(13),
        r = n(57),
        o = n(18)("match");

    e.exports = function (e) {
      var t;
      return i(e) && (void 0 !== (t = e[o]) ? !!t : "RegExp" == r(e));
    };
  }, function (e, t, n) {
    var i = n(18)("match");

    e.exports = function (e) {
      var t = /./;

      try {
        "/./"[e](t);
      } catch (n) {
        try {
          return t[i] = !1, !"/./"[e](t);
        } catch (e) {}
      }

      return !0;
    };
  }, function (e, t, n) {
    var i = n(95),
        r = n(18)("iterator"),
        o = Array.prototype;

    e.exports = function (e) {
      return void 0 !== e && (i.Array === e || o[r] === e);
    };
  }, function (e, t, n) {
    "use strict";

    var i = n(25),
        r = n(73);

    e.exports = function (e, t, n) {
      t in e ? i.f(e, t, r(0, n)) : e[t] = n;
    };
  }, function (e, t, n) {
    var i = n(113),
        r = n(18)("iterator"),
        o = n(95);

    e.exports = n(23).getIteratorMethod = function (e) {
      if (null != e) return e[r] || e["@@iterator"] || o[i(e)];
    };
  }, function (e, t, n) {
    "use strict";

    var i = n(30),
        r = n(77),
        o = n(19);

    e.exports = function (e) {
      for (var t = i(this), n = o(t.length), a = arguments.length, s = r(a > 1 ? arguments[1] : void 0, n), l = a > 2 ? arguments[2] : void 0, u = void 0 === l ? n : r(l, n); u > s;) {
        t[s++] = e;
      }

      return t;
    };
  }, function (e, t, n) {
    "use strict";

    var i = n(81),
        r = n(259),
        o = n(95),
        a = n(38);
    e.exports = n(183)(Array, "Array", function (e, t) {
      this._t = a(e), this._i = 0, this._k = t;
    }, function () {
      var e = this._t,
          t = this._k,
          n = this._i++;
      return !e || n >= e.length ? (this._t = void 0, r(1)) : r(0, "keys" == t ? n : "values" == t ? e[n] : [n, e[n]]);
    }, "values"), o.Arguments = o.Array, i("keys"), i("values"), i("entries");
  }, function (e, t, n) {
    "use strict";

    var i,
        r,
        o = n(141),
        a = RegExp.prototype.exec,
        s = String.prototype.replace,
        l = a,
        u = (i = /a/, r = /b*/g, a.call(i, "a"), a.call(r, "a"), 0 !== i.lastIndex || 0 !== r.lastIndex),
        c = void 0 !== /()??/.exec("")[1];
    (u || c) && (l = function l(e) {
      var t,
          n,
          i,
          r,
          l = this;
      return c && (n = new RegExp("^" + l.source + "$(?!\\s)", o.call(l))), u && (t = l.lastIndex), i = a.call(l, e), u && i && (l.lastIndex = l.global ? i.index + i[0].length : t), c && i && i.length > 1 && s.call(i[0], n, function () {
        for (r = 1; r < arguments.length - 2; r++) {
          void 0 === arguments[r] && (i[r] = void 0);
        }
      }), i;
    }), e.exports = l;
  }, function (e, t, n) {
    "use strict";

    var i = n(182)(!0);

    e.exports = function (e, t, n) {
      return t + (n ? i(e, t).length : 1);
    };
  }, function (e, t, n) {
    var i,
        r,
        o,
        a = n(45),
        s = n(248),
        l = n(175),
        u = n(171),
        c = n(10),
        h = c.process,
        d = c.setImmediate,
        f = c.clearImmediate,
        p = c.MessageChannel,
        g = c.Dispatch,
        v = 0,
        m = {},
        y = function y() {
      var e = +this;

      if (m.hasOwnProperty(e)) {
        var t = m[e];
        delete m[e], t();
      }
    },
        x = function x(e) {
      y.call(e.data);
    };

    d && f || (d = function d(e) {
      for (var t = [], n = 1; arguments.length > n;) {
        t.push(arguments[n++]);
      }

      return m[++v] = function () {
        s("function" == typeof e ? e : Function(e), t);
      }, i(v), v;
    }, f = function f(e) {
      delete m[e];
    }, "process" == n(57)(h) ? i = function i(e) {
      h.nextTick(a(y, e, 1));
    } : g && g.now ? i = function i(e) {
      g.now(a(y, e, 1));
    } : p ? (o = (r = new p()).port2, r.port1.onmessage = x, i = a(o.postMessage, o, 1)) : c.addEventListener && "function" == typeof postMessage && !c.importScripts ? (i = function i(e) {
      c.postMessage(e + "", "*");
    }, c.addEventListener("message", x, !1)) : i = "onreadystatechange" in u("script") ? function (e) {
      l.appendChild(u("script")).onreadystatechange = function () {
        l.removeChild(this), y.call(e);
      };
    } : function (e) {
      setTimeout(a(y, e, 1), 0);
    }), e.exports = {
      set: d,
      clear: f
    };
  }, function (e, t, n) {
    "use strict";

    var i = n(10),
        r = n(24),
        o = n(75),
        a = n(147),
        s = n(37),
        l = n(98),
        u = n(11),
        c = n(97),
        h = n(47),
        d = n(19),
        f = n(267),
        p = n(79).f,
        g = n(25).f,
        v = n(190),
        m = n(93),
        _y2 = i.ArrayBuffer,
        _x = i.DataView,
        _ = i.Math,
        b = i.RangeError,
        w = i.Infinity,
        S = _y2,
        T = _.abs,
        C = _.pow,
        k = _.floor,
        M = _.log,
        E = _.LN2,
        A = r ? "_b" : "buffer",
        I = r ? "_l" : "byteLength",
        P = r ? "_o" : "byteOffset";

    function O(e, t, n) {
      var i,
          r,
          o,
          a = new Array(n),
          s = 8 * n - t - 1,
          l = (1 << s) - 1,
          u = l >> 1,
          c = 23 === t ? C(2, -24) - C(2, -77) : 0,
          h = 0,
          d = e < 0 || 0 === e && 1 / e < 0 ? 1 : 0;

      for ((e = T(e)) != e || e === w ? (r = e != e ? 1 : 0, i = l) : (i = k(M(e) / E), e * (o = C(2, -i)) < 1 && (i--, o *= 2), (e += i + u >= 1 ? c / o : c * C(2, 1 - u)) * o >= 2 && (i++, o /= 2), i + u >= l ? (r = 0, i = l) : i + u >= 1 ? (r = (e * o - 1) * C(2, t), i += u) : (r = e * C(2, u - 1) * C(2, t), i = 0)); t >= 8; a[h++] = 255 & r, r /= 256, t -= 8) {
        ;
      }

      for (i = i << t | r, s += t; s > 0; a[h++] = 255 & i, i /= 256, s -= 8) {
        ;
      }

      return a[--h] |= 128 * d, a;
    }

    function L(e, t, n) {
      var i,
          r = 8 * n - t - 1,
          o = (1 << r) - 1,
          a = o >> 1,
          s = r - 7,
          l = n - 1,
          u = e[l--],
          c = 127 & u;

      for (u >>= 7; s > 0; c = 256 * c + e[l], l--, s -= 8) {
        ;
      }

      for (i = c & (1 << -s) - 1, c >>= -s, s += t; s > 0; i = 256 * i + e[l], l--, s -= 8) {
        ;
      }

      if (0 === c) c = 1 - a;else {
        if (c === o) return i ? NaN : u ? -w : w;
        i += C(2, t), c -= a;
      }
      return (u ? -1 : 1) * i * C(2, c - t);
    }

    function D(e) {
      return e[3] << 24 | e[2] << 16 | e[1] << 8 | e[0];
    }

    function N(e) {
      return [255 & e];
    }

    function j(e) {
      return [255 & e, e >> 8 & 255];
    }

    function R(e) {
      return [255 & e, e >> 8 & 255, e >> 16 & 255, e >> 24 & 255];
    }

    function F(e) {
      return O(e, 52, 8);
    }

    function z(e) {
      return O(e, 23, 4);
    }

    function B(e, t, n) {
      g(e.prototype, t, {
        get: function get() {
          return this[n];
        }
      });
    }

    function V(e, t, n, i) {
      var r = f(+n);
      if (r + t > e[I]) throw b("Wrong index!");
      var o = e[A]._b,
          a = r + e[P],
          s = o.slice(a, a + t);
      return i ? s : s.reverse();
    }

    function H(e, t, n, i, r, o) {
      var a = f(+n);
      if (a + t > e[I]) throw b("Wrong index!");

      for (var s = e[A]._b, l = a + e[P], u = i(+r), c = 0; c < t; c++) {
        s[l + c] = u[o ? c : t - c - 1];
      }
    }

    if (a.ABV) {
      if (!u(function () {
        _y2(1);
      }) || !u(function () {
        new _y2(-1);
      }) || u(function () {
        return new _y2(), new _y2(1.5), new _y2(NaN), "ArrayBuffer" != _y2.name;
      })) {
        for (var W, G = (_y2 = function y(e) {
          return c(this, _y2), new S(f(e));
        }).prototype = S.prototype, U = p(S), Y = 0; U.length > Y;) {
          (W = U[Y++]) in _y2 || s(_y2, W, S[W]);
        }

        o || (G.constructor = _y2);
      }

      var X = new _x(new _y2(2)),
          q = _x.prototype.setInt8;
      X.setInt8(0, 2147483648), X.setInt8(1, 2147483649), !X.getInt8(0) && X.getInt8(1) || l(_x.prototype, {
        setInt8: function setInt8(e, t) {
          q.call(this, e, t << 24 >> 24);
        },
        setUint8: function setUint8(e, t) {
          q.call(this, e, t << 24 >> 24);
        }
      }, !0);
    } else _y2 = function _y(e) {
      c(this, _y2, "ArrayBuffer");
      var t = f(e);
      this._b = v.call(new Array(t), 0), this[I] = t;
    }, _x = function x(e, t, n) {
      c(this, _x, "DataView"), c(e, _y2, "DataView");
      var i = e[I],
          r = h(t);
      if (r < 0 || r > i) throw b("Wrong offset!");
      if (r + (n = void 0 === n ? i - r : d(n)) > i) throw b("Wrong length!");
      this[A] = e, this[P] = r, this[I] = n;
    }, r && (B(_y2, "byteLength", "_l"), B(_x, "buffer", "_b"), B(_x, "byteLength", "_l"), B(_x, "byteOffset", "_o")), l(_x.prototype, {
      getInt8: function getInt8(e) {
        return V(this, 1, e)[0] << 24 >> 24;
      },
      getUint8: function getUint8(e) {
        return V(this, 1, e)[0];
      },
      getInt16: function getInt16(e) {
        var t = V(this, 2, e, arguments[1]);
        return (t[1] << 8 | t[0]) << 16 >> 16;
      },
      getUint16: function getUint16(e) {
        var t = V(this, 2, e, arguments[1]);
        return t[1] << 8 | t[0];
      },
      getInt32: function getInt32(e) {
        return D(V(this, 4, e, arguments[1]));
      },
      getUint32: function getUint32(e) {
        return D(V(this, 4, e, arguments[1])) >>> 0;
      },
      getFloat32: function getFloat32(e) {
        return L(V(this, 4, e, arguments[1]), 23, 4);
      },
      getFloat64: function getFloat64(e) {
        return L(V(this, 8, e, arguments[1]), 52, 8);
      },
      setInt8: function setInt8(e, t) {
        H(this, 1, e, N, t);
      },
      setUint8: function setUint8(e, t) {
        H(this, 1, e, N, t);
      },
      setInt16: function setInt16(e, t) {
        H(this, 2, e, j, t, arguments[2]);
      },
      setUint16: function setUint16(e, t) {
        H(this, 2, e, j, t, arguments[2]);
      },
      setInt32: function setInt32(e, t) {
        H(this, 4, e, R, t, arguments[2]);
      },
      setUint32: function setUint32(e, t) {
        H(this, 4, e, R, t, arguments[2]);
      },
      setFloat32: function setFloat32(e, t) {
        H(this, 4, e, z, t, arguments[2]);
      },
      setFloat64: function setFloat64(e, t) {
        H(this, 8, e, F, t, arguments[2]);
      }
    });

    m(_y2, "ArrayBuffer"), m(_x, "DataView"), s(_x.prototype, a.VIEW, !0), t.ArrayBuffer = _y2, t.DataView = _x;
  }, function (e, t) {
    var n = e.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
    "number" == typeof __g && (__g = n);
  }, function (e, t) {
    e.exports = function (e) {
      return "object" == typeof e ? null !== e : "function" == typeof e;
    };
  }, function (e, t, n) {
    e.exports = !n(273)(function () {
      return 7 != Object.defineProperty({}, "a", {
        get: function get() {
          return 7;
        }
      }).a;
    });
  }, function (e, t) {
    e.exports = function (e) {
      return e.webpackPolyfill || (e.deprecate = function () {}, e.paths = [], e.children || (e.children = []), Object.defineProperty(e, "loaded", {
        enumerable: !0,
        get: function get() {
          return e.l;
        }
      }), Object.defineProperty(e, "id", {
        enumerable: !0,
        get: function get() {
          return e.i;
        }
      }), e.webpackPolyfill = 1), e;
    };
  }, function (e, t, n) {
    var i = n(99)(n(51), "Map");
    e.exports = i;
  }, function (e, t, n) {
    var i = n(51).Symbol;
    e.exports = i;
  }, function (e, t) {
    var n = Array.isArray;
    e.exports = n;
  }, function (e, t) {
    function n(e, t, n, i) {
      var r = t + 1;
      if (r === n) return 1;

      if (i(e[r++], e[t]) < 0) {
        for (; r < n && i(e[r], e[r - 1]) < 0;) {
          r++;
        }

        !function (e, t, n) {
          n--;

          for (; t < n;) {
            var i = e[t];
            e[t++] = e[n], e[n--] = i;
          }
        }(e, t, r);
      } else for (; r < n && i(e[r], e[r - 1]) >= 0;) {
        r++;
      }

      return r - t;
    }

    function i(e, t, n, i, r) {
      for (i === t && i++; i < n; i++) {
        for (var o, a = e[i], s = t, l = i; s < l;) {
          r(a, e[o = s + l >>> 1]) < 0 ? l = o : s = o + 1;
        }

        var u = i - s;

        switch (u) {
          case 3:
            e[s + 3] = e[s + 2];

          case 2:
            e[s + 2] = e[s + 1];

          case 1:
            e[s + 1] = e[s];
            break;

          default:
            for (; u > 0;) {
              e[s + u] = e[s + u - 1], u--;
            }

        }

        e[s] = a;
      }
    }

    function r(e, t, n, i, r, o) {
      var a = 0,
          s = 0,
          l = 1;

      if (o(e, t[n + r]) > 0) {
        for (s = i - r; l < s && o(e, t[n + r + l]) > 0;) {
          a = l, (l = 1 + (l << 1)) <= 0 && (l = s);
        }

        l > s && (l = s), a += r, l += r;
      } else {
        for (s = r + 1; l < s && o(e, t[n + r - l]) <= 0;) {
          a = l, (l = 1 + (l << 1)) <= 0 && (l = s);
        }

        l > s && (l = s);
        var u = a;
        a = r - l, l = r - u;
      }

      for (a++; a < l;) {
        var c = a + (l - a >>> 1);
        o(e, t[n + c]) > 0 ? a = c + 1 : l = c;
      }

      return l;
    }

    function o(e, t, n, i, r, o) {
      var a = 0,
          s = 0,
          l = 1;

      if (o(e, t[n + r]) < 0) {
        for (s = r + 1; l < s && o(e, t[n + r - l]) < 0;) {
          a = l, (l = 1 + (l << 1)) <= 0 && (l = s);
        }

        l > s && (l = s);
        var u = a;
        a = r - l, l = r - u;
      } else {
        for (s = i - r; l < s && o(e, t[n + r + l]) >= 0;) {
          a = l, (l = 1 + (l << 1)) <= 0 && (l = s);
        }

        l > s && (l = s), a += r, l += r;
      }

      for (a++; a < l;) {
        var c = a + (l - a >>> 1);
        o(e, t[n + c]) < 0 ? l = c : a = c + 1;
      }

      return l;
    }

    function a(e, t) {
      var n,
          i,
          a,
          s = 7,
          l = 0;
      n = e.length;
      var u = [];

      function c(n) {
        var c = i[n],
            h = a[n],
            d = i[n + 1],
            f = a[n + 1];
        a[n] = h + f, n === l - 3 && (i[n + 1] = i[n + 2], a[n + 1] = a[n + 2]), l--;
        var p = o(e[d], e, c, h, 0, t);
        c += p, 0 !== (h -= p) && 0 !== (f = r(e[c + h - 1], e, d, f, f - 1, t)) && (h <= f ? function (n, i, a, l) {
          var c = 0;

          for (c = 0; c < i; c++) {
            u[c] = e[n + c];
          }

          var h = 0,
              d = a,
              f = n;

          if (e[f++] = e[d++], 0 == --l) {
            for (c = 0; c < i; c++) {
              e[f + c] = u[h + c];
            }

            return;
          }

          if (1 === i) {
            for (c = 0; c < l; c++) {
              e[f + c] = e[d + c];
            }

            return void (e[f + l] = u[h]);
          }

          var p,
              g,
              v,
              m = s;

          for (;;) {
            p = 0, g = 0, v = !1;

            do {
              if (t(e[d], u[h]) < 0) {
                if (e[f++] = e[d++], g++, p = 0, 0 == --l) {
                  v = !0;
                  break;
                }
              } else if (e[f++] = u[h++], p++, g = 0, 1 == --i) {
                v = !0;
                break;
              }
            } while ((p | g) < m);

            if (v) break;

            do {
              if (0 !== (p = o(e[d], u, h, i, 0, t))) {
                for (c = 0; c < p; c++) {
                  e[f + c] = u[h + c];
                }

                if (f += p, h += p, (i -= p) <= 1) {
                  v = !0;
                  break;
                }
              }

              if (e[f++] = e[d++], 0 == --l) {
                v = !0;
                break;
              }

              if (0 !== (g = r(u[h], e, d, l, 0, t))) {
                for (c = 0; c < g; c++) {
                  e[f + c] = e[d + c];
                }

                if (f += g, d += g, 0 === (l -= g)) {
                  v = !0;
                  break;
                }
              }

              if (e[f++] = u[h++], 1 == --i) {
                v = !0;
                break;
              }

              m--;
            } while (p >= 7 || g >= 7);

            if (v) break;
            m < 0 && (m = 0), m += 2;
          }

          if ((s = m) < 1 && (s = 1), 1 === i) {
            for (c = 0; c < l; c++) {
              e[f + c] = e[d + c];
            }

            e[f + l] = u[h];
          } else {
            if (0 === i) throw new Error();

            for (c = 0; c < i; c++) {
              e[f + c] = u[h + c];
            }
          }
        }(c, h, d, f) : function (n, i, a, l) {
          var c = 0;

          for (c = 0; c < l; c++) {
            u[c] = e[a + c];
          }

          var h = n + i - 1,
              d = l - 1,
              f = a + l - 1,
              p = 0,
              g = 0;

          if (e[f--] = e[h--], 0 == --i) {
            for (p = f - (l - 1), c = 0; c < l; c++) {
              e[p + c] = u[c];
            }

            return;
          }

          if (1 === l) {
            for (g = (f -= i) + 1, p = (h -= i) + 1, c = i - 1; c >= 0; c--) {
              e[g + c] = e[p + c];
            }

            return void (e[f] = u[d]);
          }

          var v = s;

          for (;;) {
            var m = 0,
                y = 0,
                x = !1;

            do {
              if (t(u[d], e[h]) < 0) {
                if (e[f--] = e[h--], m++, y = 0, 0 == --i) {
                  x = !0;
                  break;
                }
              } else if (e[f--] = u[d--], y++, m = 0, 1 == --l) {
                x = !0;
                break;
              }
            } while ((m | y) < v);

            if (x) break;

            do {
              if (0 !== (m = i - o(u[d], e, n, i, i - 1, t))) {
                for (i -= m, g = (f -= m) + 1, p = (h -= m) + 1, c = m - 1; c >= 0; c--) {
                  e[g + c] = e[p + c];
                }

                if (0 === i) {
                  x = !0;
                  break;
                }
              }

              if (e[f--] = u[d--], 1 == --l) {
                x = !0;
                break;
              }

              if (0 !== (y = l - r(e[h], u, 0, l, l - 1, t))) {
                for (l -= y, g = (f -= y) + 1, p = (d -= y) + 1, c = 0; c < y; c++) {
                  e[g + c] = u[p + c];
                }

                if (l <= 1) {
                  x = !0;
                  break;
                }
              }

              if (e[f--] = e[h--], 0 == --i) {
                x = !0;
                break;
              }

              v--;
            } while (m >= 7 || y >= 7);

            if (x) break;
            v < 0 && (v = 0), v += 2;
          }

          (s = v) < 1 && (s = 1);

          if (1 === l) {
            for (g = (f -= i) + 1, p = (h -= i) + 1, c = i - 1; c >= 0; c--) {
              e[g + c] = e[p + c];
            }

            e[f] = u[d];
          } else {
            if (0 === l) throw new Error();

            for (p = f - (l - 1), c = 0; c < l; c++) {
              e[p + c] = u[c];
            }
          }
        }(c, h, d, f));
      }

      i = [], a = [], this.mergeRuns = function () {
        for (; l > 1;) {
          var e = l - 2;
          if (e >= 1 && a[e - 1] <= a[e] + a[e + 1] || e >= 2 && a[e - 2] <= a[e] + a[e - 1]) a[e - 1] < a[e + 1] && e--;else if (a[e] > a[e + 1]) break;
          c(e);
        }
      }, this.forceMergeRuns = function () {
        for (; l > 1;) {
          var e = l - 2;
          e > 0 && a[e - 1] < a[e + 1] && e--, c(e);
        }
      }, this.pushRun = function (e, t) {
        i[l] = e, a[l] = t, l += 1;
      };
    }

    e.exports = function (e, t, r, o) {
      r || (r = 0), o || (o = e.length);
      var s = o - r;

      if (!(s < 2)) {
        var l = 0;
        if (s < 32) i(e, r, o, r + (l = n(e, r, o, t)), t);else {
          var u = new a(e, t),
              c = function (e) {
            for (var t = 0; e >= 32;) {
              t |= 1 & e, e >>= 1;
            }

            return e + t;
          }(s);

          do {
            if ((l = n(e, r, o, t)) < c) {
              var h = s;
              h > c && (h = c), i(e, r, r + h, r + l, t), l = h;
            }

            u.pushRun(r, l), u.mergeRuns(), s -= l, r += l;
          } while (0 !== s);

          u.forceMergeRuns();
        }
      }
    };
  }, function (e, t, n) {
    var i = n(289),
        r = n(155).ContextCachedBy,
        o = [["shadowBlur", 0], ["shadowOffsetX", 0], ["shadowOffsetY", 0], ["shadowColor", "#000"], ["lineCap", "butt"], ["lineJoin", "miter"], ["miterLimit", 10]],
        a = function a(e) {
      this.extendFrom(e, !1);
    };

    function s(e, t, n) {
      var i = null == t.x ? 0 : t.x,
          r = null == t.x2 ? 1 : t.x2,
          o = null == t.y ? 0 : t.y,
          a = null == t.y2 ? 0 : t.y2;
      return t.global || (i = i * n.width + n.x, r = r * n.width + n.x, o = o * n.height + n.y, a = a * n.height + n.y), i = isNaN(i) ? 0 : i, r = isNaN(r) ? 1 : r, o = isNaN(o) ? 0 : o, a = isNaN(a) ? 0 : a, e.createLinearGradient(i, o, r, a);
    }

    function l(e, t, n) {
      var i = n.width,
          r = n.height,
          o = Math.min(i, r),
          a = null == t.x ? .5 : t.x,
          s = null == t.y ? .5 : t.y,
          l = null == t.r ? .5 : t.r;
      return t.global || (a = a * i + n.x, s = s * r + n.y, l *= o), e.createRadialGradient(a, s, 0, a, s, l);
    }

    for (var u = a.prototype = {
      constructor: a,
      fill: "#000",
      stroke: null,
      opacity: 1,
      fillOpacity: null,
      strokeOpacity: null,
      lineDash: null,
      lineDashOffset: 0,
      shadowBlur: 0,
      shadowOffsetX: 0,
      shadowOffsetY: 0,
      lineWidth: 1,
      strokeNoScale: !1,
      text: null,
      font: null,
      textFont: null,
      fontStyle: null,
      fontWeight: null,
      fontSize: null,
      fontFamily: null,
      textTag: null,
      textFill: "#000",
      textStroke: null,
      textWidth: null,
      textHeight: null,
      textStrokeWidth: 0,
      textLineHeight: null,
      textPosition: "inside",
      textRect: null,
      textOffset: null,
      textAlign: null,
      textVerticalAlign: null,
      textDistance: 5,
      textShadowColor: "transparent",
      textShadowBlur: 0,
      textShadowOffsetX: 0,
      textShadowOffsetY: 0,
      textBoxShadowColor: "transparent",
      textBoxShadowBlur: 0,
      textBoxShadowOffsetX: 0,
      textBoxShadowOffsetY: 0,
      transformText: !1,
      textRotation: 0,
      textOrigin: null,
      textBackgroundColor: null,
      textBorderColor: null,
      textBorderWidth: 0,
      textBorderRadius: 0,
      textPadding: null,
      rich: null,
      truncate: null,
      blend: null,
      bind: function bind(e, t, n) {
        var a = n && n.style,
            s = !a || e.__attrCachedBy !== r.STYLE_BIND;
        e.__attrCachedBy = r.STYLE_BIND;

        for (var l = 0; l < o.length; l++) {
          var u = o[l],
              c = u[0];
          (s || this[c] !== a[c]) && (e[c] = i(e, c, this[c] || u[1]));
        }

        if ((s || this.fill !== a.fill) && (e.fillStyle = this.fill), (s || this.stroke !== a.stroke) && (e.strokeStyle = this.stroke), (s || this.opacity !== a.opacity) && (e.globalAlpha = null == this.opacity ? 1 : this.opacity), (s || this.blend !== a.blend) && (e.globalCompositeOperation = this.blend || "source-over"), this.hasStroke()) {
          var h = this.lineWidth;
          e.lineWidth = h / (this.strokeNoScale && t && t.getLineScale ? t.getLineScale() : 1);
        }
      },
      hasFill: function hasFill() {
        var e = this.fill;
        return null != e && "none" !== e;
      },
      hasStroke: function hasStroke() {
        var e = this.stroke;
        return null != e && "none" !== e && this.lineWidth > 0;
      },
      extendFrom: function extendFrom(e, t) {
        if (e) for (var n in e) {
          !e.hasOwnProperty(n) || !0 !== t && (!1 === t ? this.hasOwnProperty(n) : null == e[n]) || (this[n] = e[n]);
        }
      },
      set: function set(e, t) {
        "string" == typeof e ? this[e] = t : this.extendFrom(e, !0);
      },
      clone: function clone() {
        var e = new this.constructor();
        return e.extendFrom(this, !0), e;
      },
      getGradient: function getGradient(e, t, n) {
        for (var i = ("radial" === t.type ? l : s)(e, t, n), r = t.colorStops, o = 0; o < r.length; o++) {
          i.addColorStop(r[o].offset, r[o].color);
        }

        return i;
      }
    }, c = 0; c < o.length; c++) {
      var h = o[c];
      h[0] in u || (u[h[0]] = h[1]);
    }

    a.getGradient = u.getGradient;
    var d = a;
    e.exports = d;
  }, function (e, t, n) {
    var i = new (n(288))(50);

    function r() {
      var e = this.__cachedImgObj;
      this.onload = this.onerror = this.__cachedImgObj = null;

      for (var t = 0; t < e.pending.length; t++) {
        var n = e.pending[t],
            i = n.cb;
        i && i(this, n.cbPayload), n.hostEl.dirty();
      }

      e.pending.length = 0;
    }

    function o(e) {
      return e && e.width && e.height;
    }

    t.findExistImage = function (e) {
      if ("string" == typeof e) {
        var t = i.get(e);
        return t && t.image;
      }

      return e;
    }, t.createOrUpdateImage = function (e, t, n, a, s) {
      if (e) {
        if ("string" == typeof e) {
          if (t && t.__zrImageSrc === e || !n) return t;
          var l = i.get(e),
              u = {
            hostEl: n,
            cb: a,
            cbPayload: s
          };
          return l ? !o(t = l.image) && l.pending.push(u) : ((t = new Image()).onload = t.onerror = r, i.put(e, t.__cachedImgObj = {
            image: t,
            pending: [u]
          }), t.src = t.__zrImageSrc = e), t;
        }

        return e;
      }

      return t;
    }, t.isImageReady = o;
  }, function (e, t, n) {
    var i = n(20),
        r = n(293),
        o = n(207).subPixelOptimizeRect,
        a = {},
        s = i.extend({
      type: "rect",
      shape: {
        r: 0,
        x: 0,
        y: 0,
        width: 0,
        height: 0
      },
      buildPath: function buildPath(e, t) {
        var n, i, s, l;
        this.subPixelOptimize ? (o(a, t, this.style), n = a.x, i = a.y, s = a.width, l = a.height, a.r = t.r, t = a) : (n = t.x, i = t.y, s = t.width, l = t.height), t.r ? r.buildPath(e, t) : e.rect(n, i, s, l), e.closePath();
      }
    });
    e.exports = s;
  }, function (e, t) {
    var n = Math.round;

    function i(e, t, i) {
      if (!t) return e;
      var r = n(2 * e);
      return (r + n(t)) % 2 == 0 ? r / 2 : (r + (i ? 1 : -1)) / 2;
    }

    t.subPixelOptimizeLine = function (e, t, r) {
      if (t) {
        var o = t.x1,
            a = t.x2,
            s = t.y1,
            l = t.y2;
        e.x1 = o, e.x2 = a, e.y1 = s, e.y2 = l;
        var u = r && r.lineWidth;
        u && (n(2 * o) === n(2 * a) && (e.x1 = e.x2 = i(o, u, !0)), n(2 * s) === n(2 * l) && (e.y1 = e.y2 = i(s, u, !0)));
      }
    }, t.subPixelOptimizeRect = function (e, t, n) {
      if (t) {
        var r = t.x,
            o = t.y,
            a = t.width,
            s = t.height;
        e.x = r, e.y = o, e.width = a, e.height = s;
        var l = n && n.lineWidth;
        l && (e.x = i(r, l, !0), e.y = i(o, l, !0), e.width = Math.max(i(r + a, l, !1) - e.x, 0 === a ? 0 : 1), e.height = Math.max(i(o + s, l, !1) - e.y, 0 === s ? 0 : 1));
      }
    }, t.subPixelOptimize = i;
  }, function (e, t, n) {
    var i = n(1),
        r = n(157),
        o = function o(e, t, n, i, _o2, a) {
      this.x = null == e ? 0 : e, this.y = null == t ? 0 : t, this.x2 = null == n ? 1 : n, this.y2 = null == i ? 0 : i, this.type = "linear", this.global = a || !1, r.call(this, _o2);
    };

    o.prototype = {
      constructor: o
    }, i.inherits(o, r);
    var a = o;
    e.exports = a;
  }, function (e, t, n) {
    var i = n(1).inherits,
        r = n(119),
        o = n(17);

    function a(e) {
      r.call(this, e), this._displayables = [], this._temporaryDisplayables = [], this._cursor = 0, this.notClear = !0;
    }

    a.prototype.incremental = !0, a.prototype.clearDisplaybles = function () {
      this._displayables = [], this._temporaryDisplayables = [], this._cursor = 0, this.dirty(), this.notClear = !1;
    }, a.prototype.addDisplayable = function (e, t) {
      t ? this._temporaryDisplayables.push(e) : this._displayables.push(e), this.dirty();
    }, a.prototype.addDisplayables = function (e, t) {
      t = t || !1;

      for (var n = 0; n < e.length; n++) {
        this.addDisplayable(e[n], t);
      }
    }, a.prototype.eachPendingDisplayable = function (e) {
      for (var t = this._cursor; t < this._displayables.length; t++) {
        e && e(this._displayables[t]);
      }

      for (t = 0; t < this._temporaryDisplayables.length; t++) {
        e && e(this._temporaryDisplayables[t]);
      }
    }, a.prototype.update = function () {
      this.updateTransform();

      for (var e = this._cursor; e < this._displayables.length; e++) {
        (t = this._displayables[e]).parent = this, t.update(), t.parent = null;
      }

      for (e = 0; e < this._temporaryDisplayables.length; e++) {
        var t;
        (t = this._temporaryDisplayables[e]).parent = this, t.update(), t.parent = null;
      }
    }, a.prototype.brush = function (e, t) {
      for (var n = this._cursor; n < this._displayables.length; n++) {
        (i = this._displayables[n]).beforeBrush && i.beforeBrush(e), i.brush(e, n === this._cursor ? null : this._displayables[n - 1]), i.afterBrush && i.afterBrush(e);
      }

      this._cursor = n;

      for (n = 0; n < this._temporaryDisplayables.length; n++) {
        var i;
        (i = this._temporaryDisplayables[n]).beforeBrush && i.beforeBrush(e), i.brush(e, 0 === n ? null : this._temporaryDisplayables[n - 1]), i.afterBrush && i.afterBrush(e);
      }

      this._temporaryDisplayables = [], this.notClear = !0;
    };
    var s = [];
    a.prototype.getBoundingRect = function () {
      if (!this._rect) {
        for (var e = new o(1 / 0, 1 / 0, -1 / 0, -1 / 0), t = 0; t < this._displayables.length; t++) {
          var n = this._displayables[t],
              i = n.getBoundingRect().clone();
          n.needLocalTransform() && i.applyTransform(n.getLocalTransform(s)), e.union(i);
        }

        this._rect = e;
      }

      return this._rect;
    }, a.prototype.contain = function (e, t) {
      var n = this.transformCoordToLocal(e, t);
      if (this.getBoundingRect().contain(n[0], n[1])) for (var i = 0; i < this._displayables.length; i++) {
        if (this._displayables[i].contain(e, t)) return !0;
      }
      return !1;
    }, i(a, r);
    var l = a;
    e.exports = l;
  }, function (e, t, n) {
    var i = n(86).retrieveRawValue,
        r = n(15),
        o = r.getTooltipMarker,
        a = r.formatTpl,
        s = n(8).getTooltipRenderMode,
        l = /\{@(.+?)\}/g,
        u = {
      getDataParams: function getDataParams(e, t) {
        var n = this.getData(t),
            i = this.getRawValue(e, t),
            r = n.getRawIndex(e),
            a = n.getName(e),
            l = n.getRawDataItem(e),
            u = n.getItemVisual(e, "color"),
            c = n.getItemVisual(e, "borderColor"),
            h = this.ecModel.getComponent("tooltip"),
            d = h && h.get("renderMode"),
            f = s(d),
            p = this.mainType,
            g = "series" === p,
            v = n.userOutput;
        return {
          componentType: p,
          componentSubType: this.subType,
          componentIndex: this.componentIndex,
          seriesType: g ? this.subType : null,
          seriesIndex: this.seriesIndex,
          seriesId: g ? this.id : null,
          seriesName: g ? this.name : null,
          name: a,
          dataIndex: r,
          data: l,
          dataType: t,
          value: i,
          color: u,
          borderColor: c,
          dimensionNames: v ? v.dimensionNames : null,
          encode: v ? v.encode : null,
          marker: o({
            color: u,
            renderMode: f
          }),
          $vars: ["seriesName", "name", "value"]
        };
      },
      getFormattedLabel: function getFormattedLabel(e, t, n, r, o) {
        t = t || "normal";
        var s = this.getData(n),
            u = s.getItemModel(e),
            c = this.getDataParams(e, n);
        null != r && c.value instanceof Array && (c.value = c.value[r]);
        var h = u.get("normal" === t ? [o || "label", "formatter"] : [t, o || "label", "formatter"]);
        return "function" == typeof h ? (c.status = t, c.dimensionIndex = r, h(c)) : "string" == typeof h ? a(h, c).replace(l, function (t, n) {
          var r = n.length;
          return "[" === n.charAt(0) && "]" === n.charAt(r - 1) && (n = +n.slice(1, r - 1)), i(s, e, n);
        }) : void 0;
      },
      getRawValue: function getRawValue(e, t) {
        return i(this.getData(t), e);
      },
      formatTooltip: function formatTooltip() {}
    };
    e.exports = u;
  }, function (e, t, n) {
    var i = n(1),
        r = (i.assert, i.isArray);
    n(9).__DEV__;

    function o(e) {
      e = e || {}, this._reset = e.reset, this._plan = e.plan, this._count = e.count, this._onDirty = e.onDirty, this._dirty = !0, this.context;
    }

    var a = o.prototype;

    a.perform = function (e) {
      var t,
          n = this._upstream,
          i = e && e.skip;

      if (this._dirty && n) {
        var o = this.context;
        o.data = o.outputData = n.context.outputData;
      }

      this.__pipeline && (this.__pipeline.currentTask = this), this._plan && !i && (t = this._plan(this.context));
      var a,
          s = d(this._modBy),
          u = this._modDataCount || 0,
          c = d(e && e.modBy),
          h = e && e.modDataCount || 0;

      function d(e) {
        return !(e >= 1) && (e = 1), e;
      }

      s === c && u === h || (t = "reset"), (this._dirty || "reset" === t) && (this._dirty = !1, a = function (e, t) {
        var n, i;
        e._dueIndex = e._outputDueEnd = e._dueEnd = 0, e._settedOutputEnd = null, !t && e._reset && ((n = e._reset(e.context)) && n.progress && (i = n.forceFirstProgress, n = n.progress), r(n) && !n.length && (n = null));
        e._progress = n, e._modBy = e._modDataCount = null;
        var o = e._downstream;
        return o && o.dirty(), i;
      }(this, i)), this._modBy = c, this._modDataCount = h;
      var f = e && e.step;

      if (this._dueEnd = n ? n._outputDueEnd : this._count ? this._count(this.context) : 1 / 0, this._progress) {
        var p = this._dueIndex,
            g = Math.min(null != f ? this._dueIndex + f : 1 / 0, this._dueEnd);

        if (!i && (a || p < g)) {
          var v = this._progress;
          if (r(v)) for (var m = 0; m < v.length; m++) {
            l(this, v[m], p, g, c, h);
          } else l(this, v, p, g, c, h);
        }

        this._dueIndex = g;
        var y = null != this._settedOutputEnd ? this._settedOutputEnd : g;
        this._outputDueEnd = y;
      } else this._dueIndex = this._outputDueEnd = null != this._settedOutputEnd ? this._settedOutputEnd : this._dueEnd;

      return this.unfinished();
    };

    var s = function () {
      var e,
          t,
          n,
          i,
          r,
          o = {
        reset: function reset(l, u, c, h) {
          t = l, e = u, n = c, i = h, r = Math.ceil(i / n), o.next = n > 1 && i > 0 ? s : a;
        }
      };
      return o;

      function a() {
        return t < e ? t++ : null;
      }

      function s() {
        var o = t % r * n + Math.ceil(t / r),
            a = t >= e ? null : o < i ? o : t;
        return t++, a;
      }
    }();

    function l(e, t, n, i, r, o) {
      s.reset(n, i, r, o), e._callingProgress = t, e._callingProgress({
        start: n,
        end: i,
        count: i - n,
        next: s.next
      }, e.context);
    }

    a.dirty = function () {
      this._dirty = !0, this._onDirty && this._onDirty(this.context);
    }, a.unfinished = function () {
      return this._progress && this._dueIndex < this._dueEnd;
    }, a.pipe = function (e) {
      (this._downstream !== e || this._dirty) && (this._downstream = e, e._upstream = this, e.dirty());
    }, a.dispose = function () {
      this._disposed || (this._upstream && (this._upstream._downstream = null), this._downstream && (this._downstream._upstream = null), this._dirty = !1, this._disposed = !0);
    }, a.getUpstream = function () {
      return this._upstream;
    }, a.getDownstream = function () {
      return this._downstream;
    }, a.setOutputEnd = function (e) {
      this._outputDueEnd = this._settedOutputEnd = e;
    }, t.createTask = function (e) {
      return new o(e);
    };
  }, function (e, t, n) {
    n(9).__DEV__;
    var i = n(1),
        r = i.createHashMap,
        o = i.isString,
        a = i.isArray,
        s = i.each,
        l = (i.assert, n(309).parseXML),
        u = r(),
        c = {
      registerMap: function registerMap(e, t, n) {
        var i;
        return a(t) ? i = t : t.svg ? i = [{
          type: "svg",
          source: t.svg,
          specialAreas: t.specialAreas
        }] : (t.geoJson && !t.features && (n = t.specialAreas, t = t.geoJson), i = [{
          type: "geoJSON",
          source: t,
          specialAreas: n
        }]), s(i, function (e) {
          var t = e.type;
          "geoJson" === t && (t = e.type = "geoJSON"), (0, h[t])(e);
        }), u.set(e, i);
      },
      retrieveMap: function retrieveMap(e) {
        return u.get(e);
      }
    },
        h = {
      geoJSON: function geoJSON(e) {
        var t = e.source;
        e.geoJSON = o(t) ? "undefined" != typeof JSON && JSON.parse ? JSON.parse(t) : new Function("return (" + t + ");")() : t;
      },
      svg: function svg(e) {
        e.svgXML = l(e.source);
      }
    };
    e.exports = c;
  }, function (e, t, n) {
    var i = n(86).retrieveRawValue;

    t.getDefaultLabel = function (e, t) {
      var n = e.mapDimension("defaultedLabel", !0),
          r = n.length;
      if (1 === r) return i(e, t, n[0]);

      if (r) {
        for (var o = [], a = 0; a < n.length; a++) {
          var s = i(e, t, n[a]);
          o.push(s);
        }

        return o.join(" ");
      }
    };
  }, function (e, t, n) {
    n(9).__DEV__;
    var i = n(1),
        r = i.isObject,
        o = i.each,
        a = i.map,
        s = i.indexOf,
        l = (i.retrieve, n(14).getLayoutRect),
        u = n(43),
        c = u.createScaleByModel,
        h = u.ifAxisCrossZero,
        d = u.niceScaleExtent,
        f = u.estimateLabelUnionRect,
        p = n(696),
        g = n(698),
        v = n(42),
        m = n(55).getStackedDimension;

    function y(e, t, n) {
      return e.getCoordSysModel() === t;
    }

    function x(e, t, n) {
      this._coordsMap = {}, this._coordsList = [], this._axesMap = {}, this._axesList = [], this._initCartesian(e, t, n), this.model = e;
    }

    n(699);
    var _ = x.prototype;

    function b(e, t, n, i) {
      n.getAxesOnZeroOf = function () {
        return r ? [r] : [];
      };

      var r,
          o = e[t],
          a = n.model,
          s = a.get("axisLine.onZero"),
          l = a.get("axisLine.onZeroAxisIndex");

      if (s) {
        if (null != l) w(o[l]) && (r = o[l]);else for (var u in o) {
          if (o.hasOwnProperty(u) && w(o[u]) && !i[c(o[u])]) {
            r = o[u];
            break;
          }
        }
        r && (i[c(r)] = !0);
      }

      function c(e) {
        return e.dim + "_" + e.index;
      }
    }

    function w(e) {
      return e && "category" !== e.type && "time" !== e.type && h(e);
    }

    _.type = "grid", _.axisPointerEnabled = !0, _.getRect = function () {
      return this._rect;
    }, _.update = function (e, t) {
      var n = this._axesMap;
      this._updateScale(e, this.model), o(n.x, function (e) {
        d(e.scale, e.model);
      }), o(n.y, function (e) {
        d(e.scale, e.model);
      });
      var i = {};
      o(n.x, function (e) {
        b(n, "y", e, i);
      }), o(n.y, function (e) {
        b(n, "x", e, i);
      }), this.resize(this.model, t);
    }, _.resize = function (e, t, n) {
      var i = l(e.getBoxLayoutParams(), {
        width: t.getWidth(),
        height: t.getHeight()
      });
      this._rect = i;
      var r = this._axesList;

      function a() {
        o(r, function (e) {
          var t = e.isHorizontal(),
              n = t ? [0, i.width] : [0, i.height],
              r = e.inverse ? 1 : 0;
          e.setExtent(n[r], n[1 - r]), function (e, t) {
            var n = e.getExtent(),
                i = n[0] + n[1];
            e.toGlobalCoord = "x" === e.dim ? function (e) {
              return e + t;
            } : function (e) {
              return i - e + t;
            }, e.toLocalCoord = "x" === e.dim ? function (e) {
              return e - t;
            } : function (e) {
              return i - e + t;
            };
          }(e, t ? i.x : i.y);
        });
      }

      a(), !n && e.get("containLabel") && (o(r, function (e) {
        if (!e.model.get("axisLabel.inside")) {
          var t = f(e);

          if (t) {
            var n = e.isHorizontal() ? "height" : "width",
                r = e.model.get("axisLabel.margin");
            i[n] -= t[n] + r, "top" === e.position ? i.y += t.height + r : "left" === e.position && (i.x += t.width + r);
          }
        }
      }), a());
    }, _.getAxis = function (e, t) {
      var n = this._axesMap[e];

      if (null != n) {
        if (null == t) for (var i in n) {
          if (n.hasOwnProperty(i)) return n[i];
        }
        return n[t];
      }
    }, _.getAxes = function () {
      return this._axesList.slice();
    }, _.getCartesian = function (e, t) {
      if (null != e && null != t) {
        var n = "x" + e + "y" + t;
        return this._coordsMap[n];
      }

      r(e) && (t = e.yAxisIndex, e = e.xAxisIndex);

      for (var i = 0, o = this._coordsList; i < o.length; i++) {
        if (o[i].getAxis("x").index === e || o[i].getAxis("y").index === t) return o[i];
      }
    }, _.getCartesians = function () {
      return this._coordsList.slice();
    }, _.convertToPixel = function (e, t, n) {
      var i = this._findConvertTarget(e, t);

      return i.cartesian ? i.cartesian.dataToPoint(n) : i.axis ? i.axis.toGlobalCoord(i.axis.dataToCoord(n)) : null;
    }, _.convertFromPixel = function (e, t, n) {
      var i = this._findConvertTarget(e, t);

      return i.cartesian ? i.cartesian.pointToData(n) : i.axis ? i.axis.coordToData(i.axis.toLocalCoord(n)) : null;
    }, _._findConvertTarget = function (e, t) {
      var n,
          i,
          r = t.seriesModel,
          o = t.xAxisModel || r && r.getReferringComponents("xAxis")[0],
          a = t.yAxisModel || r && r.getReferringComponents("yAxis")[0],
          l = t.gridModel,
          u = this._coordsList;
      if (r) n = r.coordinateSystem, s(u, n) < 0 && (n = null);else if (o && a) n = this.getCartesian(o.componentIndex, a.componentIndex);else if (o) i = this.getAxis("x", o.componentIndex);else if (a) i = this.getAxis("y", a.componentIndex);else if (l) {
        l.coordinateSystem === this && (n = this._coordsList[0]);
      }
      return {
        cartesian: n,
        axis: i
      };
    }, _.containPoint = function (e) {
      var t = this._coordsList[0];
      if (t) return t.containPoint(e);
    }, _._initCartesian = function (e, t, n) {
      var i = {
        left: !1,
        right: !1,
        top: !1,
        bottom: !1
      },
          r = {
        x: {},
        y: {}
      },
          a = {
        x: 0,
        y: 0
      };
      if (t.eachComponent("xAxis", s("x"), this), t.eachComponent("yAxis", s("y"), this), !a.x || !a.y) return this._axesMap = {}, void (this._axesList = []);

      function s(t) {
        return function (n, o) {
          if (y(n, e)) {
            var s = n.get("position");
            "x" === t ? "top" !== s && "bottom" !== s && (s = i.bottom ? "top" : "bottom") : "left" !== s && "right" !== s && (s = i.left ? "right" : "left"), i[s] = !0;
            var l = new g(t, c(n), [0, 0], n.get("type"), s),
                u = "category" === l.type;
            l.onBand = u && n.get("boundaryGap"), l.inverse = n.get("inverse"), n.axis = l, l.model = n, l.grid = this, l.index = o, this._axesList.push(l), r[t][o] = l, a[t]++;
          }
        };
      }

      this._axesMap = r, o(r.x, function (t, n) {
        o(r.y, function (i, r) {
          var o = "x" + n + "y" + r,
              a = new p(o);
          a.grid = this, a.model = e, this._coordsMap[o] = a, this._coordsList.push(a), a.addAxis(t), a.addAxis(i);
        }, this);
      }, this);
    }, _._updateScale = function (e, t) {
      function n(e, t, n) {
        o(e.mapDimension(t.dim, !0), function (n) {
          t.scale.unionExtentFromData(e, m(e, n));
        });
      }

      o(this._axesList, function (e) {
        e.scale.setExtent(1 / 0, -1 / 0);
      }), e.eachSeries(function (i) {
        if (C(i)) {
          var r = T(i, e),
              o = r[0],
              a = r[1];
          if (!y(o, t) || !y(a, t)) return;
          var s = this.getCartesian(o.componentIndex, a.componentIndex),
              l = i.getData(),
              u = s.getAxis("x"),
              c = s.getAxis("y");
          "list" === l.type && (n(l, u, i), n(l, c, i));
        }
      }, this);
    }, _.getTooltipAxes = function (e) {
      var t = [],
          n = [];
      return o(this.getCartesians(), function (i) {
        var r = null != e && "auto" !== e ? i.getAxis(e) : i.getBaseAxis(),
            o = i.getOtherAxis(r);
        s(t, r) < 0 && t.push(r), s(n, o) < 0 && n.push(o);
      }), {
        baseAxes: t,
        otherAxes: n
      };
    };
    var S = ["xAxis", "yAxis"];

    function T(e, t) {
      return a(S, function (t) {
        return e.getReferringComponents(t)[0];
      });
    }

    function C(e) {
      return "cartesian2d" === e.get("coordinateSystem");
    }

    x.create = function (e, t) {
      var n = [];
      return e.eachComponent("grid", function (i, r) {
        var o = new x(i, e, t);
        o.name = "grid_" + r, o.resize(i, t, !0), i.coordinateSystem = o, n.push(o);
      }), e.eachSeries(function (e) {
        if (C(e)) {
          var t = T(e),
              n = t[0],
              i = t[1],
              r = n.getCoordSysModel().coordinateSystem;
          e.coordinateSystem = r.getCartesian(n.componentIndex, i.componentIndex);
        }
      }), n;
    }, x.dimensions = x.prototype.dimensions = p.prototype.dimensions, v.register("cartesian2d", x);
    var k = x;
    e.exports = k;
  }, function (e, t, n) {
    var i = n(1),
        r = {
      updateSelectedMap: function updateSelectedMap(e) {
        this._targetList = i.isArray(e) ? e.slice() : [], this._selectTargetMap = i.reduce(e || [], function (e, t) {
          return e.set(t.name, t), e;
        }, i.createHashMap());
      },
      select: function select(e, t) {
        var n = null != t ? this._targetList[t] : this._selectTargetMap.get(e);
        "single" === this.get("selectedMode") && this._selectTargetMap.each(function (e) {
          e.selected = !1;
        }), n && (n.selected = !0);
      },
      unSelect: function unSelect(e, t) {
        var n = null != t ? this._targetList[t] : this._selectTargetMap.get(e);
        n && (n.selected = !1);
      },
      toggleSelected: function toggleSelected(e, t) {
        var n = null != t ? this._targetList[t] : this._selectTargetMap.get(e);
        if (null != n) return this[n.selected ? "unSelect" : "select"](e, t), n.selected;
      },
      isSelected: function isSelected(e, t) {
        var n = null != t ? this._targetList[t] : this._selectTargetMap.get(e);
        return n && n.selected;
      }
    };
    e.exports = r;
  }, function (e, t) {
    t.updateViewOnPan = function (e, t, n) {
      var i = e.target,
          r = i.position;
      r[0] += t, r[1] += n, i.dirty();
    }, t.updateViewOnZoom = function (e, t, n, i) {
      var r = e.target,
          o = e.zoomLimit,
          a = r.position,
          s = r.scale,
          l = e.zoom = e.zoom || 1;

      if (l *= t, o) {
        var u = o.min || 0,
            c = o.max || 1 / 0;
        l = Math.max(Math.min(c, l), u);
      }

      var h = l / e.zoom;
      e.zoom = l, a[0] -= (n - a[0]) * (h - 1), a[1] -= (i - a[1]) * (h - 1), s[0] *= h, s[1] *= h, r.dirty();
    };
  }, function (e, t) {
    t.updateCenterAndZoom = function (e, t, n) {
      var i = e.getZoom(),
          r = e.getCenter(),
          o = t.zoom,
          a = e.dataToPoint(r);

      if (null != t.dx && null != t.dy) {
        a[0] -= t.dx, a[1] -= t.dy;
        r = e.pointToData(a);
        e.setCenter(r);
      }

      if (null != o) {
        if (n) {
          var s = n.min || 0,
              l = n.max || 1 / 0;
          o = Math.max(Math.min(i * o, l), s) / i;
        }

        e.scale[0] *= o, e.scale[1] *= o;
        var u = e.position,
            c = (t.originX - u[0]) * (o - 1),
            h = (t.originY - u[1]) * (o - 1);
        u[0] -= c, u[1] -= h, e.updateTransform();
        r = e.pointToData(a);
        e.setCenter(r), e.setZoom(o * i);
      }

      return {
        center: e.getCenter(),
        zoom: e.getZoom()
      };
    };
  }, function (e, t, n) {
    n(9).__DEV__;
    var i = n(4),
        r = n(1),
        o = n(735),
        a = n(14),
        s = n(6),
        l = n(166),
        u = n(212);

    function c(e, t) {
      var n = e.get("boundingCoords");

      if (null != n) {
        var i = n[0],
            r = n[1];
        isNaN(i[0]) || isNaN(i[1]) || isNaN(r[0]) || isNaN(r[1]) || this.setBoundingRect(i[0], i[1], r[0] - i[0], r[1] - i[1]);
      }

      var o,
          l = this.getBoundingRect(),
          u = e.get("layoutCenter"),
          c = e.get("layoutSize"),
          h = t.getWidth(),
          d = t.getHeight(),
          f = l.width / l.height * this.aspectScale,
          p = !1;

      if (u && c && (u = [s.parsePercent(u[0], h), s.parsePercent(u[1], d)], c = s.parsePercent(c, Math.min(h, d)), isNaN(u[0]) || isNaN(u[1]) || isNaN(c) || (p = !0)), p) {
        var g = {};
        f > 1 ? (g.width = c, g.height = c / f) : (g.height = c, g.width = c * f), g.y = u[1] - g.height / 2, g.x = u[0] - g.width / 2;
      } else (o = e.getBoxLayoutParams()).aspect = f, g = a.getLayoutRect(o, {
        width: h,
        height: d
      });

      this.setViewRect(g.x, g.y, g.width, g.height), this.setCenter(e.get("center")), this.setZoom(e.get("zoom"));
    }

    function h(e, t) {
      r.each(t.get("geoCoord"), function (t, n) {
        e.addGeoCoord(n, t);
      });
    }

    var d = {
      dimensions: o.prototype.dimensions,
      create: function create(e, t) {
        var n = [];
        e.eachComponent("geo", function (e, i) {
          var r = e.get("map"),
              a = e.get("aspectScale"),
              s = !0,
              l = u.retrieveMap(r);
          l && l[0] && "svg" === l[0].type ? (null == a && (a = 1), s = !1) : null == a && (a = .75);
          var d = new o(r + i, r, e.get("nameMap"), s);
          d.aspectScale = a, d.zoomLimit = e.get("scaleLimit"), n.push(d), h(d, e), e.coordinateSystem = d, d.model = e, d.resize = c, d.resize(e, t);
        }), e.eachSeries(function (e) {
          if ("geo" === e.get("coordinateSystem")) {
            var t = e.get("geoIndex") || 0;
            e.coordinateSystem = n[t];
          }
        });
        var i = {};
        return e.eachSeriesByType("map", function (e) {
          if (!e.getHostGeoModel()) {
            var t = e.getMapType();
            i[t] = i[t] || [], i[t].push(e);
          }
        }), r.each(i, function (e, i) {
          var a = r.map(e, function (e) {
            return e.get("nameMap");
          }),
              s = new o(i, i, r.mergeAll(a));
          s.zoomLimit = r.retrieve.apply(null, r.map(e, function (e) {
            return e.get("scaleLimit");
          })), n.push(s), s.resize = c, s.aspectScale = e[0].get("aspectScale"), s.resize(e[0], t), r.each(e, function (e) {
            e.coordinateSystem = s, h(s, e);
          });
        }), n;
      },
      getFilledRegions: function getFilledRegions(e, t, n) {
        for (var i = (e || []).slice(), o = r.createHashMap(), a = 0; a < i.length; a++) {
          o.set(i[a].name, i[a]);
        }

        var s = l.load(t, n);
        return r.each(s.regions, function (e) {
          var t = e.name;
          !o.get(t) && i.push({
            name: t
          });
        }), i;
      }
    };
    i.registerCoordinateSystem("geo", d);
    var f = d;
    e.exports = f;
  }, function (e, t, n) {
    var i = n(1),
        r = n(16),
        o = n(31),
        a = n(17),
        s = n(153),
        l = r.applyTransform;

    function u() {
      s.call(this);
    }

    function c(e) {
      this.name = e, this.zoomLimit, s.call(this), this._roamTransformable = new u(), this._rawTransformable = new u(), this._center, this._zoom;
    }

    function h(e, t, n, i) {
      var r = n.seriesModel,
          o = r ? r.coordinateSystem : null;
      return o === this ? o[e](i) : null;
    }

    i.mixin(u, s), c.prototype = {
      constructor: c,
      type: "view",
      dimensions: ["x", "y"],
      setBoundingRect: function setBoundingRect(e, t, n, i) {
        return this._rect = new a(e, t, n, i), this._rect;
      },
      getBoundingRect: function getBoundingRect() {
        return this._rect;
      },
      setViewRect: function setViewRect(e, t, n, i) {
        this.transformTo(e, t, n, i), this._viewRect = new a(e, t, n, i);
      },
      transformTo: function transformTo(e, t, n, i) {
        var r = this.getBoundingRect(),
            o = this._rawTransformable;
        o.transform = r.calculateTransform(new a(e, t, n, i)), o.decomposeTransform(), this._updateTransform();
      },
      setCenter: function setCenter(e) {
        e && (this._center = e, this._updateCenterAndZoom());
      },
      setZoom: function setZoom(e) {
        e = e || 1;
        var t = this.zoomLimit;
        t && (null != t.max && (e = Math.min(t.max, e)), null != t.min && (e = Math.max(t.min, e))), this._zoom = e, this._updateCenterAndZoom();
      },
      getDefaultCenter: function getDefaultCenter() {
        var e = this.getBoundingRect();
        return [e.x + e.width / 2, e.y + e.height / 2];
      },
      getCenter: function getCenter() {
        return this._center || this.getDefaultCenter();
      },
      getZoom: function getZoom() {
        return this._zoom || 1;
      },
      getRoamTransform: function getRoamTransform() {
        return this._roamTransformable.getLocalTransform();
      },
      _updateCenterAndZoom: function _updateCenterAndZoom() {
        var e = this._rawTransformable.getLocalTransform(),
            t = this._roamTransformable,
            n = this.getDefaultCenter(),
            i = this.getCenter(),
            o = this.getZoom();

        i = r.applyTransform([], i, e), n = r.applyTransform([], n, e), t.origin = i, t.position = [n[0] - i[0], n[1] - i[1]], t.scale = [o, o], this._updateTransform();
      },
      _updateTransform: function _updateTransform() {
        var e = this._roamTransformable,
            t = this._rawTransformable;
        t.parent = e, e.updateTransform(), t.updateTransform(), o.copy(this.transform || (this.transform = []), t.transform || o.create()), this._rawTransform = t.getLocalTransform(), this.invTransform = this.invTransform || [], o.invert(this.invTransform, this.transform), this.decomposeTransform();
      },
      getTransformInfo: function getTransformInfo() {
        var e = this._roamTransformable.transform,
            t = this._rawTransformable;
        return {
          roamTransform: e ? i.slice(e) : o.create(),
          rawScale: i.slice(t.scale),
          rawPosition: i.slice(t.position)
        };
      },
      getViewRect: function getViewRect() {
        return this._viewRect;
      },
      getViewRectAfterRoam: function getViewRectAfterRoam() {
        var e = this.getBoundingRect().clone();
        return e.applyTransform(this.transform), e;
      },
      dataToPoint: function dataToPoint(e, t, n) {
        var i = t ? this._rawTransform : this.transform;
        return n = n || [], i ? l(n, e, i) : r.copy(n, e);
      },
      pointToData: function pointToData(e) {
        var t = this.invTransform;
        return t ? l([], e, t) : [e[0], e[1]];
      },
      convertToPixel: i.curry(h, "dataToPoint"),
      convertFromPixel: i.curry(h, "pointToData"),
      containPoint: function containPoint(e) {
        return this.getViewRectAfterRoam().contain(e[0], e[1]);
      }
    }, i.mixin(c, s);
    var d = c;
    e.exports = d;
  }, function (e, t, n) {
    var i = n(1),
        r = n(22),
        o = n(331),
        a = n(39),
        s = n(104),
        l = function l(e, t) {
      this.name = e || "", this.depth = 0, this.height = 0, this.parentNode = null, this.dataIndex = -1, this.children = [], this.viewChildren = [], this.hostTree = t;
    };

    function u(e, t) {
      this.root, this.data, this._nodes = [], this.hostModel = e, this.levelModels = i.map(t || [], function (t) {
        return new r(t, e, e.ecModel);
      });
    }

    l.prototype = {
      constructor: l,
      isRemoved: function isRemoved() {
        return this.dataIndex < 0;
      },
      eachNode: function eachNode(e, t, n) {
        "function" == typeof e && (n = t, t = e, e = null), e = e || {}, i.isString(e) && (e = {
          order: e
        });
        var r,
            o = e.order || "preorder",
            a = this[e.attr || "children"];
        "preorder" === o && (r = t.call(n, this));

        for (var s = 0; !r && s < a.length; s++) {
          a[s].eachNode(e, t, n);
        }

        "postorder" === o && t.call(n, this);
      },
      updateDepthAndHeight: function updateDepthAndHeight(e) {
        var t = 0;
        this.depth = e;

        for (var n = 0; n < this.children.length; n++) {
          var i = this.children[n];
          i.updateDepthAndHeight(e + 1), i.height > t && (t = i.height);
        }

        this.height = t + 1;
      },
      getNodeById: function getNodeById(e) {
        if (this.getId() === e) return this;

        for (var t = 0, n = this.children, i = n.length; t < i; t++) {
          var r = n[t].getNodeById(e);
          if (r) return r;
        }
      },
      contains: function contains(e) {
        if (e === this) return !0;

        for (var t = 0, n = this.children, i = n.length; t < i; t++) {
          var r = n[t].contains(e);
          if (r) return r;
        }
      },
      getAncestors: function getAncestors(e) {
        for (var t = [], n = e ? this : this.parentNode; n;) {
          t.push(n), n = n.parentNode;
        }

        return t.reverse(), t;
      },
      getValue: function getValue(e) {
        var t = this.hostTree.data;
        return t.get(t.getDimension(e || "value"), this.dataIndex);
      },
      setLayout: function setLayout(e, t) {
        this.dataIndex >= 0 && this.hostTree.data.setItemLayout(this.dataIndex, e, t);
      },
      getLayout: function getLayout() {
        return this.hostTree.data.getItemLayout(this.dataIndex);
      },
      getModel: function getModel(e) {
        if (!(this.dataIndex < 0)) {
          var t = this.hostTree.data.getItemModel(this.dataIndex),
              n = this.getLevelModel();
          return n ? t.getModel(e, n.getModel(e)) : t.getModel(e);
        }
      },
      getLevelModel: function getLevelModel() {
        return (this.hostTree.levelModels || [])[this.depth];
      },
      setVisual: function setVisual(e, t) {
        this.dataIndex >= 0 && this.hostTree.data.setItemVisual(this.dataIndex, e, t);
      },
      getVisual: function getVisual(e, t) {
        return this.hostTree.data.getItemVisual(this.dataIndex, e, t);
      },
      getRawIndex: function getRawIndex() {
        return this.hostTree.data.getRawIndex(this.dataIndex);
      },
      getId: function getId() {
        return this.hostTree.data.getId(this.dataIndex);
      },
      isAncestorOf: function isAncestorOf(e) {
        for (var t = e.parentNode; t;) {
          if (t === this) return !0;
          t = t.parentNode;
        }

        return !1;
      },
      isDescendantOf: function isDescendantOf(e) {
        return e !== this && e.isAncestorOf(this);
      }
    }, u.prototype = {
      constructor: u,
      type: "tree",
      eachNode: function eachNode(e, t, n) {
        this.root.eachNode(e, t, n);
      },
      getNodeByDataIndex: function getNodeByDataIndex(e) {
        var t = this.data.getRawIndex(e);
        return this._nodes[t];
      },
      getNodeByName: function getNodeByName(e) {
        return this.root.getNodeByName(e);
      },
      update: function update() {
        for (var e = this.data, t = this._nodes, n = 0, i = t.length; n < i; n++) {
          t[n].dataIndex = -1;
        }

        for (n = 0, i = e.count(); n < i; n++) {
          t[e.getRawIndex(n)].dataIndex = n;
        }
      },
      clearLayouts: function clearLayouts() {
        this.data.clearItemLayouts();
      }
    }, u.createTree = function (e, t, n, r) {
      var c = new u(t, n && n.levels),
          h = [],
          d = 1;
      !function e(t, n) {
        var r = t.value;
        d = Math.max(d, i.isArray(r) ? r.length : 1), h.push(t);
        var o = new l(t.name, c);
        n ? function (e, t) {
          var n = t.children;
          if (e.parentNode === t) return;
          n.push(e), e.parentNode = t;
        }(o, n) : c.root = o, c._nodes.push(o);
        var a = t.children;
        if (a) for (var s = 0; s < a.length; s++) {
          e(a[s], o);
        }
      }(e), c.root.updateDepthAndHeight(0);
      var f = s(h, {
        coordDimensions: ["value"],
        dimensionsCount: d
      }),
          p = new a(f, t);
      return p.initData(h), r && r(p), o({
        mainData: p,
        struct: c,
        structAttr: "tree"
      }), c.update(), c;
    };
    var c = u;
    e.exports = c;
  }, function (e, t, n) {
    var i = n(5),
        r = n(222);

    function o(e) {
      this._ctor = e || r, this.group = new i.Group();
    }

    var a = o.prototype;

    function s(e) {
      var t = e.hostModel;
      return {
        lineStyle: t.getModel("lineStyle").getLineStyle(),
        hoverLineStyle: t.getModel("emphasis.lineStyle").getLineStyle(),
        labelModel: t.getModel("label"),
        hoverLabelModel: t.getModel("emphasis.label")
      };
    }

    function l(e) {
      return isNaN(e[0]) || isNaN(e[1]);
    }

    function u(e) {
      return !l(e[0]) && !l(e[1]);
    }

    a.isPersistent = function () {
      return !0;
    }, a.updateData = function (e) {
      var t = this,
          n = t.group,
          i = t._lineData;
      t._lineData = e, i || n.removeAll();
      var r = s(e);
      e.diff(i).add(function (n) {
        !function (e, t, n, i) {
          if (!u(t.getItemLayout(n))) return;
          var r = new e._ctor(t, n, i);
          t.setItemGraphicEl(n, r), e.group.add(r);
        }(t, e, n, r);
      }).update(function (n, o) {
        !function (e, t, n, i, r, o) {
          var a = t.getItemGraphicEl(i);
          if (!u(n.getItemLayout(r))) return void e.group.remove(a);
          a ? a.updateData(n, r, o) : a = new e._ctor(n, r, o);
          n.setItemGraphicEl(r, a), e.group.add(a);
        }(t, i, e, o, n, r);
      }).remove(function (e) {
        n.remove(i.getItemGraphicEl(e));
      }).execute();
    }, a.updateLayout = function () {
      var e = this._lineData;
      e && e.eachItemGraphicEl(function (t, n) {
        t.updateLayout(e, n);
      }, this);
    }, a.incrementalPrepareUpdate = function (e) {
      this._seriesScope = s(e), this._lineData = null, this.group.removeAll();
    }, a.incrementalUpdate = function (e, t) {
      function n(e) {
        e.isGroup || function (e) {
          return e.animators && e.animators.length > 0;
        }(e) || (e.incremental = e.useHoverLayer = !0);
      }

      for (var i = e.start; i < e.end; i++) {
        if (u(t.getItemLayout(i))) {
          var r = new this._ctor(t, i, this._seriesScope);
          r.traverse(n), this.group.add(r), t.setItemGraphicEl(i, r);
        }
      }
    }, a.remove = function () {
      this._clearIncremental(), this._incremental = null, this.group.removeAll();
    }, a._clearIncremental = function () {
      var e = this._incremental;
      e && e.clearDisplaybles();
    };
    var c = o;
    e.exports = c;
  }, function (e, t, n) {
    var i = n(1),
        r = n(16),
        o = n(40),
        a = n(758),
        s = n(5),
        l = n(6).round,
        u = ["fromSymbol", "toSymbol"];

    function c(e) {
      return "_" + e + "Type";
    }

    function h(e, t, n) {
      var r = t.getItemVisual(n, "color"),
          a = t.getItemVisual(n, e),
          s = t.getItemVisual(n, e + "Size");

      if (a && "none" !== a) {
        i.isArray(s) || (s = [s, s]);
        var l = o.createSymbol(a, -s[0] / 2, -s[1] / 2, s[0], s[1], r);
        return l.name = e, l;
      }
    }

    function d(e, t) {
      e.x1 = t[0][0], e.y1 = t[0][1], e.x2 = t[1][0], e.y2 = t[1][1], e.percent = 1;
      var n = t[2];
      n ? (e.cpx1 = n[0], e.cpy1 = n[1]) : (e.cpx1 = NaN, e.cpy1 = NaN);
    }

    function f(e, t, n) {
      s.Group.call(this), this._createLine(e, t, n);
    }

    var p = f.prototype;
    p.beforeUpdate = function () {
      var e = this.childOfName("fromSymbol"),
          t = this.childOfName("toSymbol"),
          n = this.childOfName("label");

      if (e || t || !n.ignore) {
        for (var i = 1, o = this.parent; o;) {
          o.scale && (i /= o.scale[0]), o = o.parent;
        }

        var a = this.childOfName("line");

        if (this.__dirty || a.__dirty) {
          var s = a.shape.percent,
              l = a.pointAt(0),
              u = a.pointAt(s),
              c = r.sub([], u, l);

          if (r.normalize(c, c), e) {
            e.attr("position", l);
            var h = a.tangentAt(0);
            e.attr("rotation", Math.PI / 2 - Math.atan2(h[1], h[0])), e.attr("scale", [i * s, i * s]);
          }

          if (t) {
            t.attr("position", u);
            h = a.tangentAt(1);
            t.attr("rotation", -Math.PI / 2 - Math.atan2(h[1], h[0])), t.attr("scale", [i * s, i * s]);
          }

          if (!n.ignore) {
            var d, f, p, g;
            n.attr("position", u);
            var v = n.__labelDistance,
                m = v[0] * i,
                y = v[1] * i,
                x = s / 2,
                _ = [(h = a.tangentAt(x))[1], -h[0]],
                b = a.pointAt(x);
            _[1] > 0 && (_[0] = -_[0], _[1] = -_[1]);
            var w,
                S = h[0] < 0 ? -1 : 1;

            if ("start" !== n.__position && "end" !== n.__position) {
              var T = -Math.atan2(h[1], h[0]);
              u[0] < l[0] && (T = Math.PI + T), n.attr("rotation", T);
            }

            switch (n.__position) {
              case "insideStartTop":
              case "insideMiddleTop":
              case "insideEndTop":
              case "middle":
                w = -y, p = "bottom";
                break;

              case "insideStartBottom":
              case "insideMiddleBottom":
              case "insideEndBottom":
                w = y, p = "top";
                break;

              default:
                w = 0, p = "middle";
            }

            switch (n.__position) {
              case "end":
                d = [c[0] * m + u[0], c[1] * y + u[1]], f = c[0] > .8 ? "left" : c[0] < -.8 ? "right" : "center", p = c[1] > .8 ? "top" : c[1] < -.8 ? "bottom" : "middle";
                break;

              case "start":
                d = [-c[0] * m + l[0], -c[1] * y + l[1]], f = c[0] > .8 ? "right" : c[0] < -.8 ? "left" : "center", p = c[1] > .8 ? "bottom" : c[1] < -.8 ? "top" : "middle";
                break;

              case "insideStartTop":
              case "insideStart":
              case "insideStartBottom":
                d = [m * S + l[0], l[1] + w], f = h[0] < 0 ? "right" : "left", g = [-m * S, -w];
                break;

              case "insideMiddleTop":
              case "insideMiddle":
              case "insideMiddleBottom":
              case "middle":
                d = [b[0], b[1] + w], f = "center", g = [0, -w];
                break;

              case "insideEndTop":
              case "insideEnd":
              case "insideEndBottom":
                d = [-m * S + u[0], u[1] + w], f = h[0] >= 0 ? "right" : "left", g = [m * S, -w];
            }

            n.attr({
              style: {
                textVerticalAlign: n.__verticalAlign || p,
                textAlign: n.__textAlign || f
              },
              position: d,
              scale: [i, i],
              origin: g
            });
          }
        }
      }
    }, p._createLine = function (e, t, n) {
      var r = e.hostModel,
          o = function (e) {
        var t = new a({
          name: "line",
          subPixelOptimize: !0
        });
        return d(t.shape, e), t;
      }(e.getItemLayout(t));

      o.shape.percent = 0, s.initProps(o, {
        shape: {
          percent: 1
        }
      }, r, t), this.add(o);
      var l = new s.Text({
        name: "label",
        lineLabelOriginalOpacity: 1
      });
      this.add(l), i.each(u, function (n) {
        var i = h(n, e, t);
        this.add(i), this[c(n)] = e.getItemVisual(t, n);
      }, this), this._updateCommonStl(e, t, n);
    }, p.updateData = function (e, t, n) {
      var r = e.hostModel,
          o = this.childOfName("line"),
          a = e.getItemLayout(t),
          l = {
        shape: {}
      };
      d(l.shape, a), s.updateProps(o, l, r, t), i.each(u, function (n) {
        var i = e.getItemVisual(t, n),
            r = c(n);

        if (this[r] !== i) {
          this.remove(this.childOfName(n));
          var o = h(n, e, t);
          this.add(o);
        }

        this[r] = i;
      }, this), this._updateCommonStl(e, t, n);
    }, p._updateCommonStl = function (e, t, n) {
      var r = e.hostModel,
          o = this.childOfName("line"),
          a = n && n.lineStyle,
          c = n && n.hoverLineStyle,
          h = n && n.labelModel,
          d = n && n.hoverLabelModel;

      if (!n || e.hasItemOption) {
        var f = e.getItemModel(t);
        a = f.getModel("lineStyle").getLineStyle(), c = f.getModel("emphasis.lineStyle").getLineStyle(), h = f.getModel("label"), d = f.getModel("emphasis.label");
      }

      var p = e.getItemVisual(t, "color"),
          g = i.retrieve3(e.getItemVisual(t, "opacity"), a.opacity, 1);
      o.useStyle(i.defaults({
        strokeNoScale: !0,
        fill: "none",
        stroke: p,
        opacity: g
      }, a)), o.hoverStyle = c, i.each(u, function (e) {
        var t = this.childOfName(e);
        t && (t.setColor(p), t.setStyle({
          opacity: g
        }));
      }, this);

      var v,
          m,
          y = h.getShallow("show"),
          x = d.getShallow("show"),
          _ = this.childOfName("label");

      if ((y || x) && (v = p || "#000", null == (m = r.getFormattedLabel(t, "normal", e.dataType)))) {
        var b = r.getRawValue(t);
        m = null == b ? e.getName(t) : isFinite(b) ? l(b) : b;
      }

      var w = y ? m : null,
          S = x ? i.retrieve2(r.getFormattedLabel(t, "emphasis", e.dataType), m) : null,
          T = _.style;

      if (null != w || null != S) {
        s.setTextStyle(_.style, h, {
          text: w
        }, {
          autoColor: v
        }), _.__textAlign = T.textAlign, _.__verticalAlign = T.textVerticalAlign, _.__position = h.get("position") || "middle";
        var C = h.get("distance");
        i.isArray(C) || (C = [C, C]), _.__labelDistance = C;
      }

      _.hoverStyle = null != S ? {
        text: S,
        textFill: d.getTextColor(!0),
        fontStyle: d.getShallow("fontStyle"),
        fontWeight: d.getShallow("fontWeight"),
        fontSize: d.getShallow("fontSize"),
        fontFamily: d.getShallow("fontFamily")
      } : {
        text: null
      }, _.ignore = !y && !x, s.setHoverStyle(this);
    }, p.highlight = function () {
      this.trigger("emphasis");
    }, p.downplay = function () {
      this.trigger("normal");
    }, p.updateLayout = function (e, t) {
      this.setLinePoints(e.getItemLayout(t));
    }, p.setLinePoints = function (e) {
      var t = this.childOfName("line");
      d(t.shape, e), t.dirty();
    }, i.inherits(f, s.Group);
    var g = f;
    e.exports = g;
  }, function (e, t) {
    t.getNodeGlobalScale = function (e) {
      var t = e.coordinateSystem;
      if ("view" !== t.type) return 1;
      var n = e.option.nodeScaleRatio,
          i = t.scale,
          r = i && i[0] || 1;
      return ((t.getZoom() - 1) * n + 1) / r;
    }, t.getSymbolSize = function (e) {
      var t = e.getVisual("symbolSize");
      return t instanceof Array && (t = (t[0] + t[1]) / 2), +t;
    };
  }, function (e, t, n) {
    n(9).__DEV__;
    var i = n(1),
        r = n(83),
        o = n(5),
        a = n(329),
        s = n(87),
        l = i.curry,
        u = i.each,
        c = i.map,
        h = Math.min,
        d = Math.max,
        f = Math.pow,
        p = {
      w: [0, 0],
      e: [0, 1],
      n: [1, 0],
      s: [1, 1]
    },
        g = {
      w: "ew",
      e: "ew",
      n: "ns",
      s: "ns",
      ne: "nesw",
      sw: "nesw",
      nw: "nwse",
      se: "nwse"
    },
        v = {
      brushStyle: {
        lineWidth: 2,
        stroke: "rgba(0,0,0,0.3)",
        fill: "rgba(0,0,0,0.1)"
      },
      transformable: !0,
      brushMode: "single",
      removeOnClick: !1
    },
        m = 0;

    function y(e) {
      r.call(this), this._zr = e, this.group = new o.Group(), this._brushType, this._brushOption, this._panels, this._track = [], this._dragging, this._covers = [], this._creatingCover, this._creatingPanel, this._enableGlobalPan, this._uid = "brushController_" + m++, this._handlers = {}, u(G, function (e, t) {
        this._handlers[t] = i.bind(e, this);
      }, this);
    }

    function x(e, t) {
      var n = Y[t.brushType].createCover(e, t);
      return n.__brushOption = t, w(n, t), e.group.add(n), n;
    }

    function _(e, t) {
      var n = T(t);
      return n.endCreating && (n.endCreating(e, t), w(t, t.__brushOption)), t;
    }

    function b(e, t) {
      var n = t.__brushOption;
      T(t).updateCoverShape(e, t, n.range, n);
    }

    function w(e, t) {
      var n = t.z;
      null == n && (n = 1e4), e.traverse(function (e) {
        e.z = n, e.z2 = n;
      });
    }

    function S(e, t) {
      T(t).updateCommon(e, t), b(e, t);
    }

    function T(e) {
      return Y[e.__brushOption.brushType];
    }

    function C(e, t, n) {
      var i,
          r = e._panels;
      if (!r) return !0;
      var o = e._transform;
      return u(r, function (e) {
        e.isTargetByCursor(t, n, o) && (i = e);
      }), i;
    }

    function k(e, t) {
      var n = e._panels;
      if (!n) return !0;
      var i = t.__brushOption.panelId;
      return null == i || n[i];
    }

    function M(e) {
      var t = e._covers,
          n = t.length;
      return u(t, function (t) {
        e.group.remove(t);
      }, e), t.length = 0, !!n;
    }

    function E(e, t) {
      var n = c(e._covers, function (e) {
        var t = e.__brushOption,
            n = i.clone(t.range);
        return {
          brushType: t.brushType,
          panelId: t.panelId,
          range: n
        };
      });
      e.trigger("brush", n, {
        isEnd: !!t.isEnd,
        removeOnClick: !!t.removeOnClick
      });
    }

    function A(e) {
      var t = e.length - 1;
      return t < 0 && (t = 0), [e[0], e[t]];
    }

    function I(e, t, n, i) {
      var r = new o.Group();
      return r.add(new o.Rect({
        name: "main",
        style: D(n),
        silent: !0,
        draggable: !0,
        cursor: "move",
        drift: l(e, t, r, "nswe"),
        ondragend: l(E, t, {
          isEnd: !0
        })
      })), u(i, function (n) {
        r.add(new o.Rect({
          name: n,
          style: {
            opacity: 0
          },
          draggable: !0,
          silent: !0,
          invisible: !0,
          drift: l(e, t, r, n),
          ondragend: l(E, t, {
            isEnd: !0
          })
        }));
      }), r;
    }

    function P(e, t, n, i) {
      var r = i.brushStyle.lineWidth || 0,
          o = d(r, 6),
          a = n[0][0],
          s = n[1][0],
          l = a - r / 2,
          u = s - r / 2,
          c = n[0][1],
          h = n[1][1],
          f = c - o + r / 2,
          p = h - o + r / 2,
          g = c - a,
          v = h - s,
          m = g + r,
          y = v + r;
      L(e, t, "main", a, s, g, v), i.transformable && (L(e, t, "w", l, u, o, y), L(e, t, "e", f, u, o, y), L(e, t, "n", l, u, m, o), L(e, t, "s", l, p, m, o), L(e, t, "nw", l, u, o, o), L(e, t, "ne", f, u, o, o), L(e, t, "sw", l, p, o, o), L(e, t, "se", f, p, o, o));
    }

    function O(e, t) {
      var n = t.__brushOption,
          i = n.transformable,
          r = t.childAt(0);
      r.useStyle(D(n)), r.attr({
        silent: !i,
        cursor: i ? "move" : "default"
      }), u(["w", "e", "n", "s", "se", "sw", "ne", "nw"], function (n) {
        var r = t.childOfName(n),
            a = function e(t, n) {
          if (n.length > 1) return n = n.split(""), ("e" === (i = [e(t, n[0]), e(t, n[1])])[0] || "w" === i[0]) && i.reverse(), i.join("");
          var i;
          return {
            left: "w",
            right: "e",
            top: "n",
            bottom: "s"
          }[i = o.transformDirection({
            w: "left",
            e: "right",
            n: "top",
            s: "bottom"
          }[n], function (e) {
            return o.getTransform(e.group);
          }(t))];
        }(e, n);

        r && r.attr({
          silent: !i,
          invisible: !i,
          cursor: i ? g[a] + "-resize" : null
        });
      });
    }

    function L(e, t, n, i, r, o, a) {
      var s,
          l,
          u,
          c,
          f,
          p = t.childOfName(n);
      p && p.setShape((s = z(e, t, [[i, r], [i + o, r + a]]), l = h(s[0][0], s[1][0]), u = h(s[0][1], s[1][1]), c = d(s[0][0], s[1][0]), f = d(s[0][1], s[1][1]), {
        x: l,
        y: u,
        width: c - l,
        height: f - u
      }));
    }

    function D(e) {
      return i.defaults({
        strokeNoScale: !0
      }, e.brushStyle);
    }

    function N(e, t, n, i) {
      var r = [h(e, n), h(t, i)],
          o = [d(e, n), d(t, i)];
      return [[r[0], o[0]], [r[1], o[1]]];
    }

    function j(e, t, n, i, r, o, a, s) {
      var l = i.__brushOption,
          c = e(l.range),
          h = F(n, o, a);
      u(r.split(""), function (e) {
        var t = p[e];
        c[t[0]][t[1]] += h[t[0]];
      }), l.range = t(N(c[0][0], c[1][0], c[0][1], c[1][1])), S(n, i), E(n, {
        isEnd: !1
      });
    }

    function R(e, t, n, i, r) {
      var o = t.__brushOption.range,
          a = F(e, n, i);
      u(o, function (e) {
        e[0] += a[0], e[1] += a[1];
      }), S(e, t), E(e, {
        isEnd: !1
      });
    }

    function F(e, t, n) {
      var i = e.group,
          r = i.transformCoordToLocal(t, n),
          o = i.transformCoordToLocal(0, 0);
      return [r[0] - o[0], r[1] - o[1]];
    }

    function z(e, t, n) {
      var r = k(e, t);
      return r && !0 !== r ? r.clipPath(n, e._transform) : i.clone(n);
    }

    function B(e) {
      var t = e.event;
      t.preventDefault && t.preventDefault();
    }

    function V(e, t, n) {
      return e.childOfName("main").contain(t, n);
    }

    function H(e, t, n, r) {
      var o,
          a = e._creatingCover,
          s = e._creatingPanel,
          l = e._brushOption;

      if (e._track.push(n.slice()), function (e) {
        var t = e._track;
        if (!t.length) return !1;
        var n = t[t.length - 1],
            i = t[0],
            r = n[0] - i[0],
            o = n[1] - i[1];
        return f(r * r + o * o, .5) > 6;
      }(e) || a) {
        if (s && !a) {
          "single" === l.brushMode && M(e);
          var u = i.clone(l);
          u.brushType = W(u.brushType, s), u.panelId = !0 === s ? null : s.panelId, a = e._creatingCover = x(e, u), e._covers.push(a);
        }

        if (a) {
          var c = Y[W(e._brushType, s)];
          a.__brushOption.range = c.getCreatingRange(z(e, a, e._track)), r && (_(e, a), c.updateCommon(e, a)), b(e, a), o = {
            isEnd: r
          };
        }
      } else r && "single" === l.brushMode && l.removeOnClick && C(e, t, n) && M(e) && (o = {
        isEnd: r,
        removeOnClick: !0
      });

      return o;
    }

    function W(e, t) {
      return "auto" === e ? t.defaultBrushType : e;
    }

    y.prototype = {
      constructor: y,
      enableBrush: function enableBrush(e) {
        var t, n;
        return this._brushType && (n = (t = this)._zr, a.release(n, "globalPan", t._uid), function (e, t) {
          u(t, function (t, n) {
            e.off(n, t);
          });
        }(n, t._handlers), t._brushType = t._brushOption = null), e.brushType && function (e, t) {
          var n = e._zr;
          e._enableGlobalPan || a.take(n, "globalPan", e._uid);
          (function (e, t) {
            u(t, function (t, n) {
              e.on(n, t);
            });
          })(n, e._handlers), e._brushType = t.brushType, e._brushOption = i.merge(i.clone(v), t, !0);
        }(this, e), this;
      },
      setPanels: function setPanels(e) {
        if (e && e.length) {
          var t = this._panels = {};
          i.each(e, function (e) {
            t[e.panelId] = i.clone(e);
          });
        } else this._panels = null;

        return this;
      },
      mount: function mount(e) {
        e = e || {}, this._enableGlobalPan = e.enableGlobalPan;
        var t = this.group;
        return this._zr.add(t), t.attr({
          position: e.position || [0, 0],
          rotation: e.rotation || 0,
          scale: e.scale || [1, 1]
        }), this._transform = t.getLocalTransform(), this;
      },
      eachCover: function eachCover(e, t) {
        u(this._covers, e, t);
      },
      updateCovers: function updateCovers(e) {
        e = i.map(e, function (e) {
          return i.merge(i.clone(v), e, !0);
        });
        var t = this._covers,
            n = this._covers = [],
            r = this,
            o = this._creatingCover;
        return new s(t, e, function (e, t) {
          return a(e.__brushOption, t);
        }, a).add(l).update(l).remove(function (e) {
          t[e] !== o && r.group.remove(t[e]);
        }).execute(), this;

        function a(e, t) {
          return (null != e.id ? e.id : "\0-brush-index-" + t) + "-" + e.brushType;
        }

        function l(i, a) {
          var s = e[i];
          if (null != a && t[a] === o) n[i] = t[a];else {
            var l = n[i] = null != a ? (t[a].__brushOption = s, t[a]) : _(r, x(r, s));
            S(r, l);
          }
        }
      },
      unmount: function unmount() {
        return this.enableBrush(!1), M(this), this._zr.remove(this.group), this;
      },
      dispose: function dispose() {
        this.unmount(), this.off();
      }
    }, i.mixin(y, r);
    var G = {
      mousedown: function mousedown(e) {
        if (this._dragging) U(this, e);else if (!e.target || !e.target.draggable) {
          B(e);
          var t = this.group.transformCoordToLocal(e.offsetX, e.offsetY);
          this._creatingCover = null, (this._creatingPanel = C(this, e, t)) && (this._dragging = !0, this._track = [t.slice()]);
        }
      },
      mousemove: function mousemove(e) {
        var t = e.offsetX,
            n = e.offsetY,
            i = this.group.transformCoordToLocal(t, n);

        if (function (e, t, n) {
          if (e._brushType && !function (e, t, n) {
            var i = e._zr;
            return t < 0 || t > i.getWidth() || n < 0 || n > i.getHeight();
          }(e, t)) {
            var i = e._zr,
                r = e._covers,
                o = C(e, t, n);
            if (!e._dragging) for (var a = 0; a < r.length; a++) {
              var s = r[a].__brushOption;
              if (o && (!0 === o || s.panelId === o.panelId) && Y[s.brushType].contain(r[a], n[0], n[1])) return;
            }
            o && i.setCursorStyle("crosshair");
          }
        }(this, e, i), this._dragging) {
          B(e);
          var r = H(this, e, i, !1);
          r && E(this, r);
        }
      },
      mouseup: function mouseup(e) {
        U(this, e);
      }
    };

    function U(e, t) {
      if (e._dragging) {
        B(t);
        var n = t.offsetX,
            i = t.offsetY,
            r = e.group.transformCoordToLocal(n, i),
            o = H(e, t, r, !0);
        e._dragging = !1, e._track = [], e._creatingCover = null, o && E(e, o);
      }
    }

    var Y = {
      lineX: X(0),
      lineY: X(1),
      rect: {
        createCover: function createCover(e, t) {
          return I(l(j, function (e) {
            return e;
          }, function (e) {
            return e;
          }), e, t, ["w", "e", "n", "s", "se", "sw", "ne", "nw"]);
        },
        getCreatingRange: function getCreatingRange(e) {
          var t = A(e);
          return N(t[1][0], t[1][1], t[0][0], t[0][1]);
        },
        updateCoverShape: function updateCoverShape(e, t, n, i) {
          P(e, t, n, i);
        },
        updateCommon: O,
        contain: V
      },
      polygon: {
        createCover: function createCover(e, t) {
          var n = new o.Group();
          return n.add(new o.Polyline({
            name: "main",
            style: D(t),
            silent: !0
          })), n;
        },
        getCreatingRange: function getCreatingRange(e) {
          return e;
        },
        endCreating: function endCreating(e, t) {
          t.remove(t.childAt(0)), t.add(new o.Polygon({
            name: "main",
            draggable: !0,
            drift: l(R, e, t),
            ondragend: l(E, e, {
              isEnd: !0
            })
          }));
        },
        updateCoverShape: function updateCoverShape(e, t, n, i) {
          t.childAt(0).setShape({
            points: z(e, t, n)
          });
        },
        updateCommon: O,
        contain: V
      }
    };

    function X(e) {
      return {
        createCover: function createCover(t, n) {
          return I(l(j, function (t) {
            var n = [t, [0, 100]];
            return e && n.reverse(), n;
          }, function (t) {
            return t[e];
          }), t, n, [["w", "e"], ["n", "s"]][e]);
        },
        getCreatingRange: function getCreatingRange(t) {
          var n = A(t);
          return [h(n[0][e], n[1][e]), d(n[0][e], n[1][e])];
        },
        updateCoverShape: function updateCoverShape(t, n, i, r) {
          var o,
              a = k(t, n);
          if (!0 !== a && a.getLinearBrushOtherExtent) o = a.getLinearBrushOtherExtent(e, t._transform);else {
            var s = t._zr;
            o = [0, [s.getWidth(), s.getHeight()][1 - e]];
          }
          var l = [i, o];
          e && l.reverse(), P(t, n, l, r);
        },
        updateCommon: O,
        contain: V
      };
    }

    var q = y;
    e.exports = q;
  }, function (e, t, n) {
    var i = n(1),
        r = n(60),
        o = n(5),
        a = n(164),
        s = n(52),
        l = n(67),
        u = (0, n(8).makeInner)(),
        c = i.clone,
        h = i.bind;

    function d() {}

    function f(e, t, n, r) {
      (function e(t, n) {
        if (i.isObject(t) && i.isObject(n)) {
          var r = !0;
          return i.each(n, function (n, i) {
            r = r && e(t[i], n);
          }), !!r;
        }

        return t === n;
      })(u(n).lastProp, r) || (u(n).lastProp = r, t ? o.updateProps(n, r, e) : (n.stopAnimation(), n.attr(r)));
    }

    function p(e, t) {
      e[t.get("label.show") ? "show" : "hide"]();
    }

    function g(e) {
      return {
        position: e.position.slice(),
        rotation: e.rotation || 0
      };
    }

    function v(e, t, n) {
      var i = t.get("z"),
          r = t.get("zlevel");
      e && e.traverse(function (e) {
        "group" !== e.type && (null != i && (e.z = i), null != r && (e.zlevel = r), e.silent = n);
      });
    }

    d.prototype = {
      _group: null,
      _lastGraphicKey: null,
      _handle: null,
      _dragging: !1,
      _lastValue: null,
      _lastStatus: null,
      _payloadInfo: null,
      animationThreshold: 15,
      render: function render(e, t, n, r) {
        var a = t.get("value"),
            s = t.get("status");

        if (this._axisModel = e, this._axisPointerModel = t, this._api = n, r || this._lastValue !== a || this._lastStatus !== s) {
          this._lastValue = a, this._lastStatus = s;
          var l = this._group,
              u = this._handle;
          if (!s || "hide" === s) return l && l.hide(), void (u && u.hide());
          l && l.show(), u && u.show();
          var c = {};
          this.makeElOption(c, a, e, t, n);
          var h = c.graphicKey;
          h !== this._lastGraphicKey && this.clear(n), this._lastGraphicKey = h;
          var d = this._moveAnimation = this.determineAnimation(e, t);

          if (l) {
            var p = i.curry(f, t, d);
            this.updatePointerEl(l, c, p, t), this.updateLabelEl(l, c, p, t);
          } else l = this._group = new o.Group(), this.createPointerEl(l, c, e, t), this.createLabelEl(l, c, e, t), n.getZr().add(l);

          v(l, t, !0), this._renderHandle(a);
        }
      },
      remove: function remove(e) {
        this.clear(e);
      },
      dispose: function dispose(e) {
        this.clear(e);
      },
      determineAnimation: function determineAnimation(e, t) {
        var n = t.get("animation"),
            i = e.axis,
            r = "category" === i.type,
            o = t.get("snap");
        if (!o && !r) return !1;

        if ("auto" === n || null == n) {
          var s = this.animationThreshold;
          if (r && i.getBandWidth() > s) return !0;

          if (o) {
            var l = a.getAxisInfo(e).seriesDataCount,
                u = i.getExtent();
            return Math.abs(u[0] - u[1]) / l > s;
          }

          return !1;
        }

        return !0 === n;
      },
      makeElOption: function makeElOption(e, t, n, i, r) {},
      createPointerEl: function createPointerEl(e, t, n, i) {
        var r = t.pointer;

        if (r) {
          var a = u(e).pointerEl = new o[r.type](c(t.pointer));
          e.add(a);
        }
      },
      createLabelEl: function createLabelEl(e, t, n, i) {
        if (t.label) {
          var r = u(e).labelEl = new o.Rect(c(t.label));
          e.add(r), p(r, i);
        }
      },
      updatePointerEl: function updatePointerEl(e, t, n) {
        var i = u(e).pointerEl;
        i && t.pointer && (i.setStyle(t.pointer.style), n(i, {
          shape: t.pointer.shape
        }));
      },
      updateLabelEl: function updateLabelEl(e, t, n, i) {
        var r = u(e).labelEl;
        r && (r.setStyle(t.label.style), n(r, {
          shape: t.label.shape,
          position: t.label.position
        }), p(r, i));
      },
      _renderHandle: function _renderHandle(e) {
        if (!this._dragging && this.updateHandleTransform) {
          var t,
              n = this._axisPointerModel,
              r = this._api.getZr(),
              a = this._handle,
              u = n.getModel("handle"),
              c = n.get("status");

          if (!u.get("show") || !c || "hide" === c) return a && r.remove(a), void (this._handle = null);
          this._handle || (t = !0, a = this._handle = o.createIcon(u.get("icon"), {
            cursor: "move",
            draggable: !0,
            onmousemove: function onmousemove(e) {
              s.stop(e.event);
            },
            onmousedown: h(this._onHandleDragMove, this, 0, 0),
            drift: h(this._onHandleDragMove, this),
            ondragend: h(this._onHandleDragEnd, this)
          }), r.add(a)), v(a, n, !1);
          a.setStyle(u.getItemStyle(null, ["color", "borderColor", "borderWidth", "opacity", "shadowColor", "shadowBlur", "shadowOffsetX", "shadowOffsetY"]));
          var d = u.get("size");
          i.isArray(d) || (d = [d, d]), a.attr("scale", [d[0] / 2, d[1] / 2]), l.createOrUpdate(this, "_doDispatchAxisPointer", u.get("throttle") || 0, "fixRate"), this._moveHandleToValue(e, t);
        }
      },
      _moveHandleToValue: function _moveHandleToValue(e, t) {
        f(this._axisPointerModel, !t && this._moveAnimation, this._handle, g(this.getHandleTransform(e, this._axisModel, this._axisPointerModel)));
      },
      _onHandleDragMove: function _onHandleDragMove(e, t) {
        var n = this._handle;

        if (n) {
          this._dragging = !0;
          var i = this.updateHandleTransform(g(n), [e, t], this._axisModel, this._axisPointerModel);
          this._payloadInfo = i, n.stopAnimation(), n.attr(g(i)), u(n).lastProp = null, this._doDispatchAxisPointer();
        }
      },
      _doDispatchAxisPointer: function _doDispatchAxisPointer() {
        if (this._handle) {
          var e = this._payloadInfo,
              t = this._axisModel;

          this._api.dispatchAction({
            type: "updateAxisPointer",
            x: e.cursorPoint[0],
            y: e.cursorPoint[1],
            tooltipOption: e.tooltipOption,
            axesInfo: [{
              axisDim: t.axis.dim,
              axisIndex: t.componentIndex
            }]
          });
        }
      },
      _onHandleDragEnd: function _onHandleDragEnd(e) {
        if (this._dragging = !1, this._handle) {
          var t = this._axisPointerModel.get("value");

          this._moveHandleToValue(t), this._api.dispatchAction({
            type: "hideTip"
          });
        }
      },
      getHandleTransform: null,
      updateHandleTransform: null,
      clear: function clear(e) {
        this._lastValue = null, this._lastStatus = null;
        var t = e.getZr(),
            n = this._group,
            i = this._handle;
        t && n && (this._lastGraphicKey = null, n && t.remove(n), i && t.remove(i), this._group = null, this._handle = null, this._payloadInfo = null);
      },
      doClear: function doClear() {},
      buildLabel: function buildLabel(e, t, n) {
        return {
          x: e[n = n || 0],
          y: e[1 - n],
          width: t[n],
          height: t[1 - n]
        };
      }
    }, d.prototype.constructor = d, r.enableClassExtend(d);
    var m = d;
    e.exports = m;
  }, function (e, t, n) {
    n(9).__DEV__;
    var i = n(1),
        r = n(852),
        o = n(6).parsePercent,
        a = n(43),
        s = a.createScaleByModel,
        l = a.niceScaleExtent,
        u = n(42),
        c = n(55).getStackedDimension;

    function h(e, t) {
      var n = this,
          r = n.getAngleAxis(),
          o = n.getRadiusAxis();

      if (r.scale.setExtent(1 / 0, -1 / 0), o.scale.setExtent(1 / 0, -1 / 0), e.eachSeries(function (e) {
        if (e.coordinateSystem === n) {
          var t = e.getData();
          i.each(t.mapDimension("radius", !0), function (e) {
            o.scale.unionExtentFromData(t, c(t, e));
          }), i.each(t.mapDimension("angle", !0), function (e) {
            r.scale.unionExtentFromData(t, c(t, e));
          });
        }
      }), l(r.scale, r.model), l(o.scale, o.model), "category" === r.type && !r.onBand) {
        var a = r.getExtent(),
            s = 360 / r.scale.count();
        r.inverse ? a[1] += s : a[1] -= s, r.setExtent(a[0], a[1]);
      }
    }

    function d(e, t) {
      if (e.type = t.get("type"), e.scale = s(t), e.onBand = t.get("boundaryGap") && "category" === e.type, e.inverse = t.get("inverse"), "angleAxis" === t.mainType) {
        e.inverse ^= t.get("clockwise");
        var n = t.get("startAngle");
        e.setExtent(n, n + (e.inverse ? -360 : 360));
      }

      t.axis = e, e.model = t;
    }

    n(855);
    var f = {
      dimensions: r.prototype.dimensions,
      create: function create(e, t) {
        var n = [];
        return e.eachComponent("polar", function (e, a) {
          var s = new r(a);
          s.update = h;
          var l = s.getRadiusAxis(),
              u = s.getAngleAxis(),
              c = e.findAxisModel("radiusAxis"),
              f = e.findAxisModel("angleAxis");
          d(l, c), d(u, f), function (e, t, n) {
            var r = t.get("center"),
                a = n.getWidth(),
                s = n.getHeight();
            e.cx = o(r[0], a), e.cy = o(r[1], s);
            var l = e.getRadiusAxis(),
                u = Math.min(a, s) / 2,
                c = t.get("radius");
            null == c ? c = [0, "100%"] : i.isArray(c) || (c = [0, c]), c = [o(c[0], u), o(c[1], u)], l.inverse ? l.setExtent(c[1], c[0]) : l.setExtent(c[0], c[1]);
          }(s, e, t), n.push(s), e.coordinateSystem = s, s.model = e;
        }), e.eachSeries(function (t) {
          if ("polar" === t.get("coordinateSystem")) {
            var n = e.queryComponents({
              mainType: "polar",
              index: t.get("polarIndex"),
              id: t.get("polarId")
            })[0];
            t.coordinateSystem = n.coordinateSystem;
          }
        }), n;
      }
    };
    u.register("polar", f);
  }, function (e, t, n) {
    n(26).registerSubTypeDefaulter("dataZoom", function () {
      return "slider";
    });
  }, function (e, t, n) {
    var i = n(1),
        r = n(15),
        o = ["cartesian2d", "polar", "singleAxis"];

    function a(e, t) {
      e = e.slice();
      var n = i.map(e, r.capitalFirst);
      t = (t || []).slice();
      var o = i.map(t, r.capitalFirst);
      return function (r, a) {
        i.each(e, function (e, i) {
          for (var s = {
            name: e,
            capital: n[i]
          }, l = 0; l < t.length; l++) {
            s[t[l]] = e + o[l];
          }

          r.call(a, s);
        });
      };
    }

    var s = a(["x", "y", "z", "radius", "angle", "single"], ["axisIndex", "axis", "index", "id"]);
    t.isCoordSupported = function (e) {
      return i.indexOf(o, e) >= 0;
    }, t.createNameEach = a, t.eachAxisDim = s, t.createLinkedNodesFinder = function (e, t, n) {
      return function (o) {
        var a,
            s = {
          nodes: [],
          records: {}
        };
        if (t(function (e) {
          s.records[e.name] = {};
        }), !o) return s;
        r(o, s);

        do {
          a = !1, e(l);
        } while (a);

        function l(e) {
          !function (e, t) {
            return i.indexOf(t.nodes, e) >= 0;
          }(e, s) && function (e, r) {
            var o = !1;
            return t(function (t) {
              i.each(n(e, t) || [], function (e) {
                r.records[t.name][e] && (o = !0);
              });
            }), o;
          }(e, s) && (r(e, s), a = !0);
        }

        return s;
      };

      function r(e, r) {
        r.nodes.push(e), t(function (t) {
          i.each(n(e, t) || [], function (e) {
            r.records[t.name][e] = !0;
          });
        });
      }
    };
  }, function (e, t, n) {
    var i = n(4),
        r = n(1),
        o = r.createHashMap,
        a = r.each;
    i.registerProcessor({
      getTargetSeries: function getTargetSeries(e) {
        var t = o();
        return e.eachComponent("dataZoom", function (e) {
          e.eachTargetAxis(function (e, n, i) {
            var r = i.getAxisProxy(e.name, n);
            a(r.getTargetSeriesModels(), function (e) {
              t.set(e.uid, e);
            });
          });
        }), t;
      },
      modifyOutputEnd: !0,
      overallReset: function overallReset(e, t) {
        e.eachComponent("dataZoom", function (e) {
          e.eachTargetAxis(function (e, n, i) {
            i.getAxisProxy(e.name, n).reset(i, t);
          }), e.eachTargetAxis(function (e, n, i) {
            i.getAxisProxy(e.name, n).filterData(i, t);
          });
        }), e.eachComponent("dataZoom", function (e) {
          var t = e.findRepresentativeAxisProxy(),
              n = t.getDataPercentWindow(),
              i = t.getDataValueWindow();
          e.setCalculatedRange({
            start: n[0],
            end: n[1],
            startValue: i[0],
            endValue: i[1]
          });
        });
      }
    });
  }, function (e, t, n) {
    var i = n(4),
        r = n(1),
        o = n(228);
    i.registerAction("dataZoom", function (e, t) {
      var n = o.createLinkedNodesFinder(r.bind(t.eachComponent, t, "dataZoom"), o.eachAxisDim, function (e, t) {
        return e.get(t.axisIndex);
      }),
          i = [];
      t.eachComponent({
        mainType: "dataZoom",
        query: e
      }, function (e, t) {
        i.push.apply(i, n(e).nodes);
      }), r.each(i, function (t, n) {
        t.setRawRange({
          start: e.start,
          end: e.end,
          startValue: e.startValue,
          endValue: e.endValue
        });
      });
    });
  }, function (e, t, n) {
    n(9).__DEV__;
    var i = n(4),
        r = n(1),
        o = n(21),
        a = n(8),
        s = n(15),
        l = n(210),
        u = s.addCommas,
        c = s.encodeHTML;

    function h(e) {
      a.defaultEmphasis(e, "label", ["show"]);
    }

    var d = i.extendComponentModel({
      type: "marker",
      dependencies: ["series", "grid", "polar", "geo"],
      init: function init(e, t, n) {
        this.mergeDefaultAndTheme(e, n), this._mergeOption(e, n, !1, !0);
      },
      isAnimationEnabled: function isAnimationEnabled() {
        if (o.node) return !1;
        var e = this.__hostSeries;
        return this.getShallow("animation") && e && e.isAnimationEnabled();
      },
      mergeOption: function mergeOption(e, t) {
        this._mergeOption(e, t, !1, !1);
      },
      _mergeOption: function _mergeOption(e, t, n, i) {
        var o = this.constructor,
            a = this.mainType + "Model";
        n || t.eachSeries(function (e) {
          var n = e.get(this.mainType, !0),
              s = e[a];
          n && n.data ? (s ? s._mergeOption(n, t, !0) : (i && h(n), r.each(n.data, function (e) {
            e instanceof Array ? (h(e[0]), h(e[1])) : h(e);
          }), s = new o(n, this, t), r.extend(s, {
            mainType: this.mainType,
            seriesIndex: e.seriesIndex,
            name: e.name,
            createdBySelf: !0
          }), s.__hostSeries = e), e[a] = s) : e[a] = null;
        }, this);
      },
      formatTooltip: function formatTooltip(e) {
        var t = this.getData(),
            n = this.getRawValue(e),
            i = r.isArray(n) ? r.map(n, u).join(", ") : u(n),
            o = t.getName(e),
            a = c(this.name);
        return (null != n || o) && (a += "<br />"), o && (a += c(o), null != n && (a += " : ")), null != n && (a += c(i)), a;
      },
      getData: function getData() {
        return this._data;
      },
      setData: function setData(e) {
        this._data = e;
      }
    });
    r.mixin(d, l);
    var f = d;
    e.exports = f;
  }, function (e, t, n) {
    var i = n(1),
        r = n(6),
        o = n(55).isDimensionStacked,
        a = i.indexOf;

    function s(e, t, n, i, a, s) {
      var l = [],
          u = o(t, i) ? t.getCalculationInfo("stackResultDimension") : i,
          c = h(t, u, e),
          d = t.indicesOfNearest(u, c)[0];
      l[a] = t.get(n, d), l[s] = t.get(u, d);
      var f = t.get(i, d),
          p = r.getPrecision(t.get(i, d));
      return (p = Math.min(p, 20)) >= 0 && (l[s] = +l[s].toFixed(p)), [l, f];
    }

    var l = i.curry,
        u = {
      min: l(s, "min"),
      max: l(s, "max"),
      average: l(s, "average")
    };

    function c(e, t, n, i) {
      var r = {};
      return null != e.valueIndex || null != e.valueDim ? (r.valueDataDim = null != e.valueIndex ? t.getDimension(e.valueIndex) : e.valueDim, r.valueAxis = n.getAxis(function (e, t) {
        var n = e.getData(),
            i = n.dimensions;
        t = n.getDimension(t);

        for (var r = 0; r < i.length; r++) {
          var o = n.getDimensionInfo(i[r]);
          if (o.name === t) return o.coordDim;
        }
      }(i, r.valueDataDim)), r.baseAxis = n.getOtherAxis(r.valueAxis), r.baseDataDim = t.mapDimension(r.baseAxis.dim)) : (r.baseAxis = i.getBaseAxis(), r.valueAxis = n.getOtherAxis(r.baseAxis), r.baseDataDim = t.mapDimension(r.baseAxis.dim), r.valueDataDim = t.mapDimension(r.valueAxis.dim)), r;
    }

    function h(e, t, n) {
      if ("average" === n) {
        var i = 0,
            r = 0;
        return e.each(t, function (e, t) {
          isNaN(e) || (i += e, r++);
        }), i / r;
      }

      return "median" === n ? e.getMedian(t) : e.getDataExtent(t, !0)["max" === n ? 1 : 0];
    }

    t.dataTransform = function (e, t) {
      var n = e.getData(),
          r = e.coordinateSystem;

      if (t && !function (e) {
        return !isNaN(parseFloat(e.x)) && !isNaN(parseFloat(e.y));
      }(t) && !i.isArray(t.coord) && r) {
        var o = r.dimensions,
            s = c(t, n, r, e);

        if ((t = i.clone(t)).type && u[t.type] && s.baseAxis && s.valueAxis) {
          var l = a(o, s.baseAxis.dim),
              d = a(o, s.valueAxis.dim),
              f = u[t.type](n, s.baseDataDim, s.valueDataDim, l, d);
          t.coord = f[0], t.value = f[1];
        } else {
          for (var p = [null != t.xAxis ? t.xAxis : t.radiusAxis, null != t.yAxis ? t.yAxis : t.angleAxis], g = 0; g < 2; g++) {
            u[p[g]] && (p[g] = h(n, n.mapDimension(o[g]), p[g]));
          }

          t.coord = p;
        }
      }

      return t;
    }, t.getAxisInfo = c, t.dataFilter = function (e, t) {
      return !(e && e.containData && t.coord && !function (e) {
        return !(isNaN(parseFloat(e.x)) && isNaN(parseFloat(e.y)));
      }(t)) || e.containData(t.coord);
    }, t.dimValueGetter = function (e, t, n, i) {
      return i < 2 ? e.coord && e.coord[i] : e.value;
    }, t.numCalculate = h;
  }, function (e, t, n) {
    var i = n(4),
        r = n(1),
        o = i.extendComponentView({
      type: "marker",
      init: function init() {
        this.markerGroupMap = r.createHashMap();
      },
      render: function render(e, t, n) {
        var i = this.markerGroupMap;
        i.each(function (e) {
          e.__keep = !1;
        });
        var r = this.type + "Model";
        t.eachSeries(function (e) {
          var i = e[r];
          i && this.renderSeries(e, i, t, n);
        }, this), i.each(function (e) {
          !e.__keep && this.group.remove(e.group);
        }, this);
      },
      renderSeries: function renderSeries() {}
    });
    e.exports = o;
  }, function (e, t, n) {
    var i = n(235).createElement,
        r = n(102),
        o = n(17),
        a = n(31),
        s = n(35),
        l = n(156),
        u = n(85),
        c = r.CMD,
        h = Array.prototype.join,
        d = Math.round,
        f = Math.sin,
        p = Math.cos,
        g = Math.PI,
        v = 2 * Math.PI,
        m = 180 / g;

    function y(e) {
      return d(1e4 * e) / 1e4;
    }

    function x(e) {
      return e < 1e-4 && e > -1e-4;
    }

    function _(e, t) {
      t && b(e, "transform", "matrix(" + h.call(t, ",") + ")");
    }

    function b(e, t, n) {
      (!n || "linear" !== n.type && "radial" !== n.type) && e.setAttribute(t, n);
    }

    function w(e, t, n, i) {
      if (function (e, t) {
        var n = t ? e.textFill : e.fill;
        return null != n && "none" !== n;
      }(t, n)) {
        var r = n ? t.textFill : t.fill;
        b(e, "fill", r = "transparent" === r ? "none" : r), b(e, "fill-opacity", null != t.fillOpacity ? t.fillOpacity * t.opacity : t.opacity);
      } else b(e, "fill", "none");

      if (function (e, t) {
        var n = t ? e.textStroke : e.stroke;
        return null != n && "none" !== n;
      }(t, n)) {
        var o = n ? t.textStroke : t.stroke;
        b(e, "stroke", o = "transparent" === o ? "none" : o), b(e, "stroke-width", (n ? t.textStrokeWidth : t.lineWidth) / (!n && t.strokeNoScale ? i.getLineScale() : 1)), b(e, "paint-order", n ? "stroke" : "fill"), b(e, "stroke-opacity", null != t.strokeOpacity ? t.strokeOpacity : t.opacity), t.lineDash ? (b(e, "stroke-dasharray", t.lineDash.join(",")), b(e, "stroke-dashoffset", d(t.lineDashOffset || 0))) : b(e, "stroke-dasharray", ""), t.lineCap && b(e, "stroke-linecap", t.lineCap), t.lineJoin && b(e, "stroke-linejoin", t.lineJoin), t.miterLimit && b(e, "stroke-miterlimit", t.miterLimit);
      } else b(e, "stroke", "none");
    }

    var S = {};

    S.brush = function (e) {
      var t = e.style,
          n = e.__svgEl;
      n || (n = i("path"), e.__svgEl = n), e.path || e.createPathProxy();
      var r = e.path;

      if (e.__dirtyPath) {
        r.beginPath(), r.subPixelOptimize = !1, e.buildPath(r, e.shape), e.__dirtyPath = !1;

        var o = function (e) {
          for (var t = [], n = e.data, i = e.len(), r = 0; r < i;) {
            var o = "",
                a = 0;

            switch (n[r++]) {
              case c.M:
                o = "M", a = 2;
                break;

              case c.L:
                o = "L", a = 2;
                break;

              case c.Q:
                o = "Q", a = 4;
                break;

              case c.C:
                o = "C", a = 6;
                break;

              case c.A:
                var s = n[r++],
                    l = n[r++],
                    u = n[r++],
                    h = n[r++],
                    _ = n[r++],
                    b = n[r++],
                    w = n[r++],
                    S = n[r++],
                    T = Math.abs(b),
                    C = x(T - v) || (S ? b >= v : -b >= v),
                    k = b > 0 ? b % v : b % v + v,
                    M = !1;
                M = !!C || !x(T) && k >= g == !!S;
                var E = y(s + u * p(_)),
                    A = y(l + h * f(_));
                C && (b = S ? v - 1e-4 : 1e-4 - v, M = !0, 9 === r && t.push("M", E, A));
                var I = y(s + u * p(_ + b)),
                    P = y(l + h * f(_ + b));
                t.push("A", y(u), y(h), d(w * m), +M, +S, I, P);
                break;

              case c.Z:
                o = "Z";
                break;

              case c.R:
                I = y(n[r++]), P = y(n[r++]);
                var O = y(n[r++]),
                    L = y(n[r++]);
                t.push("M", I, P, "L", I + O, P, "L", I + O, P + L, "L", I, P + L, "L", I, P);
            }

            o && t.push(o);

            for (var D = 0; D < a; D++) {
              t.push(y(n[r++]));
            }
          }

          return t.join(" ");
        }(r);

        o.indexOf("NaN") < 0 && b(n, "d", o);
      }

      w(n, t, !1, e), _(n, e.transform), null != t.text ? I(e, e.getBoundingRect()) : O(e);
    };

    var T = {
      brush: function brush(e) {
        var t = e.style,
            n = t.image;
        n instanceof HTMLImageElement && (n = n.src);

        if (n) {
          var r = t.x || 0,
              o = t.y || 0,
              a = t.width,
              s = t.height,
              l = e.__svgEl;
          l || (l = i("image"), e.__svgEl = l), n !== e.__imageSrc && (!function (e, t, n) {
            e.setAttributeNS("http://www.w3.org/1999/xlink", t, n);
          }(l, "href", n), e.__imageSrc = n), b(l, "width", a), b(l, "height", s), b(l, "x", r), b(l, "y", o), _(l, e.transform), null != t.text ? I(e, e.getBoundingRect()) : O(e);
        }
      }
    },
        C = {},
        k = new o(),
        M = {},
        E = [],
        A = {
      left: "start",
      right: "end",
      center: "middle",
      middle: "middle"
    },
        I = function I(e, t) {
      var n = e.style,
          r = e.transform,
          o = e instanceof u || n.transformText;
      e.__dirty && l.normalizeTextStyle(n, !0);
      var c = n.text;

      if (null != c && (c += ""), l.needDrawText(c, n)) {
        null == c && (c = ""), !o && r && (k.copy(t), k.applyTransform(r), t = k);
        var h = e.__textSvgEl;
        h || (h = i("text"), e.__textSvgEl = h);
        var d = h.style,
            f = n.font || s.DEFAULT_FONT,
            p = h.__computedFont;
        f !== h.__styleFont && (d.font = h.__styleFont = f, p = h.__computedFont = d.font);
        var g = n.textPadding,
            v = n.textLineHeight,
            m = e.__textCotentBlock;
        m && !e.__dirtyText || (m = e.__textCotentBlock = s.parsePlainText(c, p, g, v, n.truncate));
        var y = m.outerHeight,
            x = m.lineHeight;
        l.getBoxPosition(M, e, n, t);
        var b = M.baseX,
            S = M.baseY,
            T = M.textAlign || "left",
            C = M.textVerticalAlign;
        !function (e, t, n, i, r, o, s) {
          a.identity(E), t && n && a.copy(E, n);
          var l = i.textRotation;

          if (r && l) {
            var u = i.textOrigin;
            "center" === u ? (o = r.width / 2 + r.x, s = r.height / 2 + r.y) : u && (o = u[0] + r.x, s = u[1] + r.y), E[4] -= o, E[5] -= s, a.rotate(E, E, l), E[4] += o, E[5] += s;
          }

          _(e, E);
        }(h, o, r, n, t, b, S);
        var A = b,
            I = s.adjustTextY(S, y, C);
        g && (A = function (e, t, n) {
          return "right" === t ? e - n[1] : "center" === t ? e + n[3] / 2 - n[1] / 2 : e + n[3];
        }(b, T, g), I += g[0]), I += x / 2, w(h, n, !0, e);
        var O = m.canCacheByTextString,
            L = e.__tspanList || (e.__tspanList = []),
            D = L.length;

        if (O && e.__canCacheByTextString && e.__text === c) {
          if (e.__dirtyText && D) for (var N = 0; N < D; ++N) {
            P(L[N], T, A, I + N * x);
          }
        } else {
          e.__text = c, e.__canCacheByTextString = O;
          var j = m.lines,
              R = j.length;

          for (N = 0; N < R; N++) {
            var F = L[N],
                z = j[N];
            F ? F.__zrText !== z && (F.innerHTML = "", F.appendChild(document.createTextNode(z))) : (F = L[N] = i("tspan"), h.appendChild(F), F.appendChild(document.createTextNode(z))), P(F, T, A, I + N * x);
          }

          if (D > R) {
            for (; N < D; N++) {
              h.removeChild(L[N]);
            }

            L.length = R;
          }
        }
      }
    };

    function P(e, t, n, i) {
      b(e, "dominant-baseline", "middle"), b(e, "text-anchor", A[t]), b(e, "x", n), b(e, "y", i);
    }

    function O(e) {
      e && e.__textSvgEl && (e.__textSvgEl.parentNode && e.__textSvgEl.parentNode.removeChild(e.__textSvgEl), e.__textSvgEl = null, e.__tspanList = [], e.__text = null);
    }

    C.drawRectText = I, C.brush = function (e) {
      null != e.style.text ? I(e, !1) : O(e);
    }, t.path = S, t.image = T, t.text = C;
  }, function (e, t) {
    t.createElement = function (e) {
      return document.createElementNS("http://www.w3.org/2000/svg", e);
    };
  }, function (e, t, n) {
    var i = n(235).createElement,
        r = n(1),
        o = n(20),
        a = n(100),
        s = n(85),
        l = n(234),
        u = l.path,
        c = l.image,
        h = l.text;

    function d(e, t, n, i, r) {
      this._zrId = e, this._svgRoot = t, this._tagNames = "string" == typeof n ? [n] : n, this._markLabel = i, this._domName = r || "_dom", this.nextId = 0;
    }

    d.prototype.createElement = i, d.prototype.getDefs = function (e) {
      var t = this._svgRoot,
          n = this._svgRoot.getElementsByTagName("defs");

      return 0 === n.length ? e ? ((n = t.insertBefore(this.createElement("defs"), t.firstChild)).contains || (n.contains = function (e) {
        var t = n.children;
        if (!t) return !1;

        for (var i = t.length - 1; i >= 0; --i) {
          if (t[i] === e) return !0;
        }

        return !1;
      }), n) : null : n[0];
    }, d.prototype.update = function (e, t) {
      if (e) {
        var n = this.getDefs(!1);
        if (e[this._domName] && n.contains(e[this._domName])) "function" == typeof t && t(e);else {
          var i = this.add(e);
          i && (e[this._domName] = i);
        }
      }
    }, d.prototype.addDom = function (e) {
      this.getDefs(!0).appendChild(e);
    }, d.prototype.removeDom = function (e) {
      var t = this.getDefs(!1);
      t && e[this._domName] && (t.removeChild(e[this._domName]), e[this._domName] = null);
    }, d.prototype.getDoms = function () {
      var e = this.getDefs(!1);
      if (!e) return [];
      var t = [];
      return r.each(this._tagNames, function (n) {
        var i = e.getElementsByTagName(n);
        t = t.concat([].slice.call(i));
      }), t;
    }, d.prototype.markAllUnused = function () {
      var e = this.getDoms(),
          t = this;
      r.each(e, function (e) {
        e[t._markLabel] = "0";
      });
    }, d.prototype.markUsed = function (e) {
      e && (e[this._markLabel] = "1");
    }, d.prototype.removeUnused = function () {
      var e = this.getDefs(!1);

      if (e) {
        var t = this.getDoms(),
            n = this;
        r.each(t, function (t) {
          "1" !== t[n._markLabel] && e.removeChild(t);
        });
      }
    }, d.prototype.getSvgProxy = function (e) {
      return e instanceof o ? u : e instanceof a ? c : e instanceof s ? h : u;
    }, d.prototype.getTextSvgElement = function (e) {
      return e.__textSvgEl;
    }, d.prototype.getSvgElement = function (e) {
      return e.__svgEl;
    };
    var f = d;
    e.exports = f;
  }, function (e, t) {
    function n(t) {
      return e.exports = n = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      }, n(t);
    }

    e.exports = n;
  }, function (e, t, n) {
    var i = n(571);

    e.exports = function (e, t) {
      return i(e, t);
    };
  }, function (e, t, n) {
    var i = n(92),
        r = n(116);

    e.exports = function (e, t, n) {
      var o = !0,
          a = !0;
      if ("function" != typeof e) throw new TypeError("Expected a function");
      return r(n) && (o = "leading" in n ? !!n.leading : o, a = "trailing" in n ? !!n.trailing : a), i(e, t, {
        leading: o,
        maxWait: t,
        trailing: a
      });
    };
  }, function (e, t, n) {
    e.exports = !n(24) && !n(11)(function () {
      return 7 != Object.defineProperty(n(171)("div"), "a", {
        get: function get() {
          return 7;
        }
      }).a;
    });
  }, function (e, t, n) {
    var i = n(10),
        r = n(23),
        o = n(75),
        a = n(172),
        s = n(25).f;

    e.exports = function (e) {
      var t = r.Symbol || (r.Symbol = o ? {} : i.Symbol || {});
      "_" == e.charAt(0) || e in t || s(t, e, {
        value: a.f(e)
      });
    };
  }, function (e, t, n) {
    var i = n(36),
        r = n(38),
        o = n(137)(!1),
        a = n(173)("IE_PROTO");

    e.exports = function (e, t) {
      var n,
          s = r(e),
          l = 0,
          u = [];

      for (n in s) {
        n != a && i(s, n) && u.push(n);
      }

      for (; t.length > l;) {
        i(s, n = t[l++]) && (~o(u, n) || u.push(n));
      }

      return u;
    };
  }, function (e, t, n) {
    var i = n(25),
        r = n(12),
        o = n(76);
    e.exports = n(24) ? Object.defineProperties : function (e, t) {
      r(e);

      for (var n, a = o(t), s = a.length, l = 0; s > l;) {
        i.f(e, n = a[l++], t[n]);
      }

      return e;
    };
  }, function (e, t, n) {
    var i = n(38),
        r = n(79).f,
        o = {}.toString,
        a = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];

    e.exports.f = function (e) {
      return a && "[object Window]" == o.call(e) ? function (e) {
        try {
          return r(e);
        } catch (e) {
          return a.slice();
        }
      }(e) : r(i(e));
    };
  }, function (e, t, n) {
    "use strict";

    var i = n(24),
        r = n(76),
        o = n(138),
        a = n(112),
        s = n(30),
        l = n(111),
        u = Object.assign;
    e.exports = !u || n(11)(function () {
      var e = {},
          t = {},
          n = Symbol(),
          i = "abcdefghijklmnopqrst";
      return e[n] = 7, i.split("").forEach(function (e) {
        t[e] = e;
      }), 7 != u({}, e)[n] || Object.keys(u({}, t)).join("") != i;
    }) ? function (e, t) {
      for (var n = s(e), u = arguments.length, c = 1, h = o.f, d = a.f; u > c;) {
        for (var f, p = l(arguments[c++]), g = h ? r(p).concat(h(p)) : r(p), v = g.length, m = 0; v > m;) {
          f = g[m++], i && !d.call(p, f) || (n[f] = p[f]);
        }
      }

      return n;
    } : u;
  }, function (e, t) {
    e.exports = Object.is || function (e, t) {
      return e === t ? 0 !== e || 1 / e == 1 / t : e != e && t != t;
    };
  }, function (e, t, n) {
    "use strict";

    var i = n(46),
        r = n(13),
        o = n(248),
        a = [].slice,
        s = {},
        l = function l(e, t, n) {
      if (!(t in s)) {
        for (var i = [], r = 0; r < t; r++) {
          i[r] = "a[" + r + "]";
        }

        s[t] = Function("F,a", "return new F(" + i.join(",") + ")");
      }

      return s[t](e, n);
    };

    e.exports = Function.bind || function (e) {
      var t = i(this),
          n = a.call(arguments, 1),
          s = function s() {
        var i = n.concat(a.call(arguments));
        return this instanceof s ? l(t, i.length, i) : o(t, i, e);
      };

      return r(t.prototype) && (s.prototype = t.prototype), s;
    };
  }, function (e, t) {
    e.exports = function (e, t, n) {
      var i = void 0 === n;

      switch (t.length) {
        case 0:
          return i ? e() : e.call(n);

        case 1:
          return i ? e(t[0]) : e.call(n, t[0]);

        case 2:
          return i ? e(t[0], t[1]) : e.call(n, t[0], t[1]);

        case 3:
          return i ? e(t[0], t[1], t[2]) : e.call(n, t[0], t[1], t[2]);

        case 4:
          return i ? e(t[0], t[1], t[2], t[3]) : e.call(n, t[0], t[1], t[2], t[3]);
      }

      return e.apply(n, t);
    };
  }, function (e, t, n) {
    var i = n(10).parseInt,
        r = n(94).trim,
        o = n(177),
        a = /^[-+]?0[xX]/;
    e.exports = 8 !== i(o + "08") || 22 !== i(o + "0x16") ? function (e, t) {
      var n = r(String(e), 3);
      return i(n, t >>> 0 || (a.test(n) ? 16 : 10));
    } : i;
  }, function (e, t, n) {
    var i = n(10).parseFloat,
        r = n(94).trim;
    e.exports = 1 / i(n(177) + "-0") != -1 / 0 ? function (e) {
      var t = r(String(e), 3),
          n = i(t);
      return 0 === n && "-" == t.charAt(0) ? -0 : n;
    } : i;
  }, function (e, t, n) {
    var i = n(57);

    e.exports = function (e, t) {
      if ("number" != typeof e && "Number" != i(e)) throw TypeError(t);
      return +e;
    };
  }, function (e, t, n) {
    var i = n(13),
        r = Math.floor;

    e.exports = function (e) {
      return !i(e) && isFinite(e) && r(e) === e;
    };
  }, function (e, t) {
    e.exports = Math.log1p || function (e) {
      return (e = +e) > -1e-8 && e < 1e-8 ? e - e * e / 2 : Math.log(1 + e);
    };
  }, function (e, t, n) {
    "use strict";

    var i = n(78),
        r = n(73),
        o = n(93),
        a = {};
    n(37)(a, n(18)("iterator"), function () {
      return this;
    }), e.exports = function (e, t, n) {
      e.prototype = i(a, {
        next: r(1, n)
      }), o(e, t + " Iterator");
    };
  }, function (e, t, n) {
    var i = n(12);

    e.exports = function (e, t, n, r) {
      try {
        return r ? t(i(n)[0], n[1]) : t(n);
      } catch (t) {
        var o = e.return;
        throw void 0 !== o && i(o.call(e)), t;
      }
    };
  }, function (e, t, n) {
    var i = n(469);

    e.exports = function (e, t) {
      return new (i(e))(t);
    };
  }, function (e, t, n) {
    var i = n(46),
        r = n(30),
        o = n(111),
        a = n(19);

    e.exports = function (e, t, n, s, l) {
      i(t);
      var u = r(e),
          c = o(u),
          h = a(u.length),
          d = l ? h - 1 : 0,
          f = l ? -1 : 1;
      if (n < 2) for (;;) {
        if (d in c) {
          s = c[d], d += f;
          break;
        }

        if (d += f, l ? d < 0 : h <= d) throw TypeError("Reduce of empty array with no initial value");
      }

      for (; l ? d >= 0 : h > d; d += f) {
        d in c && (s = t(s, c[d], d, u));
      }

      return s;
    };
  }, function (e, t, n) {
    "use strict";

    var i = n(30),
        r = n(77),
        o = n(19);

    e.exports = [].copyWithin || function (e, t) {
      var n = i(this),
          a = o(n.length),
          s = r(e, a),
          l = r(t, a),
          u = arguments.length > 2 ? arguments[2] : void 0,
          c = Math.min((void 0 === u ? a : r(u, a)) - l, a - s),
          h = 1;

      for (l < s && s < l + c && (h = -1, l += c - 1, s += c - 1); c-- > 0;) {
        l in n ? n[s] = n[l] : delete n[s], s += h, l += h;
      }

      return n;
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      return {
        value: t,
        done: !!e
      };
    };
  }, function (e, t, n) {
    "use strict";

    var i = n(192);
    n(3)({
      target: "RegExp",
      proto: !0,
      forced: i !== /./.exec
    }, {
      exec: i
    });
  }, function (e, t, n) {
    n(24) && "g" != /./g.flags && n(25).f(RegExp.prototype, "flags", {
      configurable: !0,
      get: n(141)
    });
  }, function (e, t, n) {
    "use strict";

    var i,
        r,
        o,
        a,
        s = n(75),
        l = n(10),
        u = n(45),
        c = n(113),
        h = n(3),
        d = n(13),
        f = n(46),
        p = n(97),
        g = n(144),
        v = n(114),
        m = n(194).set,
        y = n(489)(),
        x = n(263),
        _ = n(490),
        b = n(145),
        w = n(264),
        S = l.TypeError,
        T = l.process,
        C = T && T.versions,
        k = C && C.v8 || "",
        _M = l.Promise,
        E = "process" == c(T),
        A = function A() {},
        I = r = x.f,
        P = !!function () {
      try {
        var e = _M.resolve(1),
            t = (e.constructor = {})[n(18)("species")] = function (e) {
          e(A, A);
        };

        return (E || "function" == typeof PromiseRejectionEvent) && e.then(A) instanceof t && 0 !== k.indexOf("6.6") && -1 === b.indexOf("Chrome/66");
      } catch (e) {}
    }(),
        O = function O(e) {
      var t;
      return !(!d(e) || "function" != typeof (t = e.then)) && t;
    },
        L = function L(e, t) {
      if (!e._n) {
        e._n = !0;
        var n = e._c;
        y(function () {
          for (var i = e._v, r = 1 == e._s, o = 0, a = function a(t) {
            var n,
                o,
                a,
                s = r ? t.ok : t.fail,
                l = t.resolve,
                u = t.reject,
                c = t.domain;

            try {
              s ? (r || (2 == e._h && j(e), e._h = 1), !0 === s ? n = i : (c && c.enter(), n = s(i), c && (c.exit(), a = !0)), n === t.promise ? u(S("Promise-chain cycle")) : (o = O(n)) ? o.call(n, l, u) : l(n)) : u(i);
            } catch (e) {
              c && !a && c.exit(), u(e);
            }
          }; n.length > o;) {
            a(n[o++]);
          }

          e._c = [], e._n = !1, t && !e._h && D(e);
        });
      }
    },
        D = function D(e) {
      m.call(l, function () {
        var t,
            n,
            i,
            r = e._v,
            o = N(e);
        if (o && (t = _(function () {
          E ? T.emit("unhandledRejection", r, e) : (n = l.onunhandledrejection) ? n({
            promise: e,
            reason: r
          }) : (i = l.console) && i.error && i.error("Unhandled promise rejection", r);
        }), e._h = E || N(e) ? 2 : 1), e._a = void 0, o && t.e) throw t.v;
      });
    },
        N = function N(e) {
      return 1 !== e._h && 0 === (e._a || e._c).length;
    },
        j = function j(e) {
      m.call(l, function () {
        var t;
        E ? T.emit("rejectionHandled", e) : (t = l.onrejectionhandled) && t({
          promise: e,
          reason: e._v
        });
      });
    },
        R = function R(e) {
      var t = this;
      t._d || (t._d = !0, (t = t._w || t)._v = e, t._s = 2, t._a || (t._a = t._c.slice()), L(t, !0));
    },
        F = function F(e) {
      var t,
          n = this;

      if (!n._d) {
        n._d = !0, n = n._w || n;

        try {
          if (n === e) throw S("Promise can't be resolved itself");
          (t = O(e)) ? y(function () {
            var i = {
              _w: n,
              _d: !1
            };

            try {
              t.call(e, u(F, i, 1), u(R, i, 1));
            } catch (e) {
              R.call(i, e);
            }
          }) : (n._v = e, n._s = 1, L(n, !1));
        } catch (e) {
          R.call({
            _w: n,
            _d: !1
          }, e);
        }
      }
    };

    P || (_M = function M(e) {
      p(this, _M, "Promise", "_h"), f(e), i.call(this);

      try {
        e(u(F, this, 1), u(R, this, 1));
      } catch (e) {
        R.call(this, e);
      }
    }, (i = function i(e) {
      this._c = [], this._a = void 0, this._s = 0, this._d = !1, this._v = void 0, this._h = 0, this._n = !1;
    }).prototype = n(98)(_M.prototype, {
      then: function then(e, t) {
        var n = I(v(this, _M));
        return n.ok = "function" != typeof e || e, n.fail = "function" == typeof t && t, n.domain = E ? T.domain : void 0, this._c.push(n), this._a && this._a.push(n), this._s && L(this, !1), n.promise;
      },
      catch: function _catch(e) {
        return this.then(void 0, e);
      }
    }), o = function o() {
      var e = new i();
      this.promise = e, this.resolve = u(F, e, 1), this.reject = u(R, e, 1);
    }, x.f = I = function I(e) {
      return e === _M || e === a ? new o(e) : r(e);
    }), h(h.G + h.W + h.F * !P, {
      Promise: _M
    }), n(93)(_M, "Promise"), n(96)("Promise"), a = n(23).Promise, h(h.S + h.F * !P, "Promise", {
      reject: function reject(e) {
        var t = I(this);
        return (0, t.reject)(e), t.promise;
      }
    }), h(h.S + h.F * (s || !P), "Promise", {
      resolve: function resolve(e) {
        return w(s && this === a ? _M : this, e);
      }
    }), h(h.S + h.F * !(P && n(140)(function (e) {
      _M.all(e).catch(A);
    })), "Promise", {
      all: function all(e) {
        var t = this,
            n = I(t),
            i = n.resolve,
            r = n.reject,
            o = _(function () {
          var n = [],
              o = 0,
              a = 1;
          g(e, !1, function (e) {
            var s = o++,
                l = !1;
            n.push(void 0), a++, t.resolve(e).then(function (e) {
              l || (l = !0, n[s] = e, --a || i(n));
            }, r);
          }), --a || i(n);
        });

        return o.e && r(o.v), n.promise;
      },
      race: function race(e) {
        var t = this,
            n = I(t),
            i = n.reject,
            r = _(function () {
          g(e, !1, function (e) {
            t.resolve(e).then(n.resolve, i);
          });
        });

        return r.e && i(r.v), n.promise;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var i = n(46);

    function r(e) {
      var t, n;
      this.promise = new e(function (e, i) {
        if (void 0 !== t || void 0 !== n) throw TypeError("Bad Promise constructor");
        t = e, n = i;
      }), this.resolve = i(t), this.reject = i(n);
    }

    e.exports.f = function (e) {
      return new r(e);
    };
  }, function (e, t, n) {
    var i = n(12),
        r = n(13),
        o = n(263);

    e.exports = function (e, t) {
      if (i(e), r(t) && t.constructor === e) return t;
      var n = o.f(e);
      return (0, n.resolve)(t), n.promise;
    };
  }, function (e, t, n) {
    "use strict";

    var i = n(25).f,
        r = n(78),
        o = n(98),
        a = n(45),
        s = n(97),
        l = n(144),
        u = n(183),
        c = n(259),
        h = n(96),
        d = n(24),
        f = n(64).fastKey,
        p = n(82),
        g = d ? "_s" : "size",
        v = function v(e, t) {
      var n,
          i = f(t);
      if ("F" !== i) return e._i[i];

      for (n = e._f; n; n = n.n) {
        if (n.k == t) return n;
      }
    };

    e.exports = {
      getConstructor: function getConstructor(e, t, n, u) {
        var c = e(function (e, i) {
          s(e, c, t, "_i"), e._t = t, e._i = r(null), e._f = void 0, e._l = void 0, e[g] = 0, null != i && l(i, n, e[u], e);
        });
        return o(c.prototype, {
          clear: function clear() {
            for (var e = p(this, t), n = e._i, i = e._f; i; i = i.n) {
              i.r = !0, i.p && (i.p = i.p.n = void 0), delete n[i.i];
            }

            e._f = e._l = void 0, e[g] = 0;
          },
          delete: function _delete(e) {
            var n = p(this, t),
                i = v(n, e);

            if (i) {
              var r = i.n,
                  o = i.p;
              delete n._i[i.i], i.r = !0, o && (o.n = r), r && (r.p = o), n._f == i && (n._f = r), n._l == i && (n._l = o), n[g]--;
            }

            return !!i;
          },
          forEach: function forEach(e) {
            p(this, t);

            for (var n, i = a(e, arguments.length > 1 ? arguments[1] : void 0, 3); n = n ? n.n : this._f;) {
              for (i(n.v, n.k, this); n && n.r;) {
                n = n.p;
              }
            }
          },
          has: function has(e) {
            return !!v(p(this, t), e);
          }
        }), d && i(c.prototype, "size", {
          get: function get() {
            return p(this, t)[g];
          }
        }), c;
      },
      def: function def(e, t, n) {
        var i,
            r,
            o = v(e, t);
        return o ? o.v = n : (e._l = o = {
          i: r = f(t, !0),
          k: t,
          v: n,
          p: i = e._l,
          n: void 0,
          r: !1
        }, e._f || (e._f = o), i && (i.n = o), e[g]++, "F" !== r && (e._i[r] = o)), e;
      },
      getEntry: v,
      setStrong: function setStrong(e, t, n) {
        u(e, t, function (e, n) {
          this._t = p(e, t), this._k = n, this._l = void 0;
        }, function () {
          for (var e = this._k, t = this._l; t && t.r;) {
            t = t.p;
          }

          return this._t && (this._l = t = t ? t.n : this._t._f) ? c(0, "keys" == e ? t.k : "values" == e ? t.v : [t.k, t.v]) : (this._t = void 0, c(1));
        }, n ? "entries" : "values", !n, !0), h(t);
      }
    };
  }, function (e, t, n) {
    "use strict";

    var i = n(98),
        r = n(64).getWeak,
        o = n(12),
        a = n(13),
        s = n(97),
        l = n(144),
        u = n(50),
        c = n(36),
        h = n(82),
        d = u(5),
        f = u(6),
        p = 0,
        g = function g(e) {
      return e._l || (e._l = new v());
    },
        v = function v() {
      this.a = [];
    },
        m = function m(e, t) {
      return d(e.a, function (e) {
        return e[0] === t;
      });
    };

    v.prototype = {
      get: function get(e) {
        var t = m(this, e);
        if (t) return t[1];
      },
      has: function has(e) {
        return !!m(this, e);
      },
      set: function set(e, t) {
        var n = m(this, e);
        n ? n[1] = t : this.a.push([e, t]);
      },
      delete: function _delete(e) {
        var t = f(this.a, function (t) {
          return t[0] === e;
        });
        return ~t && this.a.splice(t, 1), !!~t;
      }
    }, e.exports = {
      getConstructor: function getConstructor(e, t, n, o) {
        var u = e(function (e, i) {
          s(e, u, t, "_i"), e._t = t, e._i = p++, e._l = void 0, null != i && l(i, n, e[o], e);
        });
        return i(u.prototype, {
          delete: function _delete(e) {
            if (!a(e)) return !1;
            var n = r(e);
            return !0 === n ? g(h(this, t)).delete(e) : n && c(n, this._i) && delete n[this._i];
          },
          has: function has(e) {
            if (!a(e)) return !1;
            var n = r(e);
            return !0 === n ? g(h(this, t)).has(e) : n && c(n, this._i);
          }
        }), u;
      },
      def: function def(e, t, n) {
        var i = r(o(t), !0);
        return !0 === i ? g(e).set(t, n) : i[e._i] = n, e;
      },
      ufstore: g
    };
  }, function (e, t, n) {
    var i = n(47),
        r = n(19);

    e.exports = function (e) {
      if (void 0 === e) return 0;
      var t = i(e),
          n = r(t);
      if (t !== n) throw RangeError("Wrong length!");
      return n;
    };
  }, function (e, t, n) {
    var i = n(79),
        r = n(138),
        o = n(12),
        a = n(10).Reflect;

    e.exports = a && a.ownKeys || function (e) {
      var t = i.f(o(e)),
          n = r.f;
      return n ? t.concat(n(e)) : t;
    };
  }, function (e, t, n) {
    var i = n(19),
        r = n(179),
        o = n(58);

    e.exports = function (e, t, n, a) {
      var s = String(o(e)),
          l = s.length,
          u = void 0 === n ? " " : String(n),
          c = i(t);
      if (c <= l || "" == u) return s;
      var h = c - l,
          d = r.call(u, Math.ceil(h / u.length));
      return d.length > h && (d = d.slice(0, h)), a ? d + s : s + d;
    };
  }, function (e, t, n) {
    var i = n(24),
        r = n(76),
        o = n(38),
        a = n(112).f;

    e.exports = function (e) {
      return function (t) {
        for (var n, s = o(t), l = r(s), u = l.length, c = 0, h = []; u > c;) {
          n = l[c++], i && !a.call(s, n) || h.push(e ? [n, s[n]] : s[n]);
        }

        return h;
      };
    };
  }, function (e, t, n) {
    var i = function (e) {
      "use strict";

      var t = Object.prototype,
          n = t.hasOwnProperty,
          i = "function" == typeof Symbol ? Symbol : {},
          r = i.iterator || "@@iterator",
          o = i.asyncIterator || "@@asyncIterator",
          a = i.toStringTag || "@@toStringTag";

      function s(e, t, n) {
        return Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }), e[t];
      }

      try {
        s({}, "");
      } catch (e) {
        s = function s(e, t, n) {
          return e[t] = n;
        };
      }

      function l(e, t, n, i) {
        var r = t && t.prototype instanceof h ? t : h,
            o = Object.create(r.prototype),
            a = new S(i || []);
        return o._invoke = function (e, t, n) {
          var i = "suspendedStart";
          return function (r, o) {
            if ("executing" === i) throw new Error("Generator is already running");

            if ("completed" === i) {
              if ("throw" === r) throw o;
              return C();
            }

            for (n.method = r, n.arg = o;;) {
              var a = n.delegate;

              if (a) {
                var s = _(a, n);

                if (s) {
                  if (s === c) continue;
                  return s;
                }
              }

              if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
                if ("suspendedStart" === i) throw i = "completed", n.arg;
                n.dispatchException(n.arg);
              } else "return" === n.method && n.abrupt("return", n.arg);
              i = "executing";
              var l = u(e, t, n);

              if ("normal" === l.type) {
                if (i = n.done ? "completed" : "suspendedYield", l.arg === c) continue;
                return {
                  value: l.arg,
                  done: n.done
                };
              }

              "throw" === l.type && (i = "completed", n.method = "throw", n.arg = l.arg);
            }
          };
        }(e, n, a), o;
      }

      function u(e, t, n) {
        try {
          return {
            type: "normal",
            arg: e.call(t, n)
          };
        } catch (e) {
          return {
            type: "throw",
            arg: e
          };
        }
      }

      e.wrap = l;
      var c = {};

      function h() {}

      function d() {}

      function f() {}

      var p = {};

      p[r] = function () {
        return this;
      };

      var g = Object.getPrototypeOf,
          v = g && g(g(T([])));
      v && v !== t && n.call(v, r) && (p = v);
      var m = f.prototype = h.prototype = Object.create(p);

      function y(e) {
        ["next", "throw", "return"].forEach(function (t) {
          s(e, t, function (e) {
            return this._invoke(t, e);
          });
        });
      }

      function x(e, t) {
        var i;

        this._invoke = function (r, o) {
          function a() {
            return new t(function (i, a) {
              !function i(r, o, a, s) {
                var l = u(e[r], e, o);

                if ("throw" !== l.type) {
                  var c = l.arg,
                      h = c.value;
                  return h && "object" == typeof h && n.call(h, "__await") ? t.resolve(h.__await).then(function (e) {
                    i("next", e, a, s);
                  }, function (e) {
                    i("throw", e, a, s);
                  }) : t.resolve(h).then(function (e) {
                    c.value = e, a(c);
                  }, function (e) {
                    return i("throw", e, a, s);
                  });
                }

                s(l.arg);
              }(r, o, i, a);
            });
          }

          return i = i ? i.then(a, a) : a();
        };
      }

      function _(e, t) {
        var n = e.iterator[t.method];

        if (void 0 === n) {
          if (t.delegate = null, "throw" === t.method) {
            if (e.iterator.return && (t.method = "return", t.arg = void 0, _(e, t), "throw" === t.method)) return c;
            t.method = "throw", t.arg = new TypeError("The iterator does not provide a 'throw' method");
          }

          return c;
        }

        var i = u(n, e.iterator, t.arg);
        if ("throw" === i.type) return t.method = "throw", t.arg = i.arg, t.delegate = null, c;
        var r = i.arg;
        return r ? r.done ? (t[e.resultName] = r.value, t.next = e.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, c) : r : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, c);
      }

      function b(e) {
        var t = {
          tryLoc: e[0]
        };
        1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
      }

      function w(e) {
        var t = e.completion || {};
        t.type = "normal", delete t.arg, e.completion = t;
      }

      function S(e) {
        this.tryEntries = [{
          tryLoc: "root"
        }], e.forEach(b, this), this.reset(!0);
      }

      function T(e) {
        if (e) {
          var t = e[r];
          if (t) return t.call(e);
          if ("function" == typeof e.next) return e;

          if (!isNaN(e.length)) {
            var i = -1,
                o = function t() {
              for (; ++i < e.length;) {
                if (n.call(e, i)) return t.value = e[i], t.done = !1, t;
              }

              return t.value = void 0, t.done = !0, t;
            };

            return o.next = o;
          }
        }

        return {
          next: C
        };
      }

      function C() {
        return {
          value: void 0,
          done: !0
        };
      }

      return d.prototype = m.constructor = f, f.constructor = d, d.displayName = s(f, a, "GeneratorFunction"), e.isGeneratorFunction = function (e) {
        var t = "function" == typeof e && e.constructor;
        return !!t && (t === d || "GeneratorFunction" === (t.displayName || t.name));
      }, e.mark = function (e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, f) : (e.__proto__ = f, s(e, a, "GeneratorFunction")), e.prototype = Object.create(m), e;
      }, e.awrap = function (e) {
        return {
          __await: e
        };
      }, y(x.prototype), x.prototype[o] = function () {
        return this;
      }, e.AsyncIterator = x, e.async = function (t, n, i, r, o) {
        void 0 === o && (o = Promise);
        var a = new x(l(t, n, i, r), o);
        return e.isGeneratorFunction(n) ? a : a.next().then(function (e) {
          return e.done ? e.value : a.next();
        });
      }, y(m), s(m, a, "Generator"), m[r] = function () {
        return this;
      }, m.toString = function () {
        return "[object Generator]";
      }, e.keys = function (e) {
        var t = [];

        for (var n in e) {
          t.push(n);
        }

        return t.reverse(), function n() {
          for (; t.length;) {
            var i = t.pop();
            if (i in e) return n.value = i, n.done = !1, n;
          }

          return n.done = !0, n;
        };
      }, e.values = T, S.prototype = {
        constructor: S,
        reset: function reset(e) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(w), !e) for (var t in this) {
            "t" === t.charAt(0) && n.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
          }
        },
        stop: function stop() {
          this.done = !0;
          var e = this.tryEntries[0].completion;
          if ("throw" === e.type) throw e.arg;
          return this.rval;
        },
        dispatchException: function dispatchException(e) {
          if (this.done) throw e;
          var t = this;

          function i(n, i) {
            return a.type = "throw", a.arg = e, t.next = n, i && (t.method = "next", t.arg = void 0), !!i;
          }

          for (var r = this.tryEntries.length - 1; r >= 0; --r) {
            var o = this.tryEntries[r],
                a = o.completion;
            if ("root" === o.tryLoc) return i("end");

            if (o.tryLoc <= this.prev) {
              var s = n.call(o, "catchLoc"),
                  l = n.call(o, "finallyLoc");

              if (s && l) {
                if (this.prev < o.catchLoc) return i(o.catchLoc, !0);
                if (this.prev < o.finallyLoc) return i(o.finallyLoc);
              } else if (s) {
                if (this.prev < o.catchLoc) return i(o.catchLoc, !0);
              } else {
                if (!l) throw new Error("try statement without catch or finally");
                if (this.prev < o.finallyLoc) return i(o.finallyLoc);
              }
            }
          }
        },
        abrupt: function abrupt(e, t) {
          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var r = this.tryEntries[i];

            if (r.tryLoc <= this.prev && n.call(r, "finallyLoc") && this.prev < r.finallyLoc) {
              var o = r;
              break;
            }
          }

          o && ("break" === e || "continue" === e) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
          var a = o ? o.completion : {};
          return a.type = e, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, c) : this.complete(a);
        },
        complete: function complete(e, t) {
          if ("throw" === e.type) throw e.arg;
          return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), c;
        },
        finish: function finish(e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var n = this.tryEntries[t];
            if (n.finallyLoc === e) return this.complete(n.completion, n.afterLoc), w(n), c;
          }
        },
        catch: function _catch(e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var n = this.tryEntries[t];

            if (n.tryLoc === e) {
              var i = n.completion;

              if ("throw" === i.type) {
                var r = i.arg;
                w(n);
              }

              return r;
            }
          }

          throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, t, n) {
          return this.delegate = {
            iterator: T(e),
            resultName: t,
            nextLoc: n
          }, "next" === this.method && (this.arg = void 0), c;
        }
      }, e;
    }(e.exports);

    try {
      regeneratorRuntime = i;
    } catch (e) {
      Function("r", "regeneratorRuntime = r")(i);
    }
  }, function (e, t) {
    var n = e.exports = {
      version: "2.6.11"
    };
    "number" == typeof __e && (__e = n);
  }, function (e, t) {
    e.exports = function (e) {
      try {
        return !!e();
      } catch (e) {
        return !0;
      }
    };
  }, function (e, t, n) {
    "use strict";

    var i = Object.getOwnPropertySymbols,
        r = Object.prototype.hasOwnProperty,
        o = Object.prototype.propertyIsEnumerable;

    function a(e) {
      if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
      return Object(e);
    }

    e.exports = function () {
      try {
        if (!Object.assign) return !1;
        var e = new String("abc");
        if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;

        for (var t = {}, n = 0; n < 10; n++) {
          t["_" + String.fromCharCode(n)] = n;
        }

        if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (e) {
          return t[e];
        }).join("")) return !1;
        var i = {};
        return "abcdefghijklmnopqrst".split("").forEach(function (e) {
          i[e] = e;
        }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, i)).join("");
      } catch (e) {
        return !1;
      }
    }() ? Object.assign : function (e, t) {
      for (var n, s, l = a(e), u = 1; u < arguments.length; u++) {
        for (var c in n = Object(arguments[u])) {
          r.call(n, c) && (l[c] = n[c]);
        }

        if (i) {
          s = i(n);

          for (var h = 0; h < s.length; h++) {
            o.call(n, s[h]) && (l[s[h]] = n[s[h]]);
          }
        }
      }

      return l;
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      return e === t || e != e && t != t;
    };
  }, function (e, t, n) {
    var i = n(115),
        r = n(116);

    e.exports = function (e) {
      if (!r(e)) return !1;
      var t = i(e);
      return "[object Function]" == t || "[object GeneratorFunction]" == t || "[object AsyncFunction]" == t || "[object Proxy]" == t;
    };
  }, function (e, t, n) {
    (function (t) {
      var n = "object" == typeof t && t && t.Object === Object && t;
      e.exports = n;
    }).call(this, n(65));
  }, function (e, t) {
    var n = Function.prototype.toString;

    e.exports = function (e) {
      if (null != e) {
        try {
          return n.call(e);
        } catch (e) {}

        try {
          return e + "";
        } catch (e) {}
      }

      return "";
    };
  }, function (e, t, n) {
    var i = n(590),
        r = n(597),
        o = n(599),
        a = n(600),
        s = n(601);

    function l(e) {
      var t = -1,
          n = null == e ? 0 : e.length;

      for (this.clear(); ++t < n;) {
        var i = e[t];
        this.set(i[0], i[1]);
      }
    }

    l.prototype.clear = i, l.prototype.delete = r, l.prototype.get = o, l.prototype.has = a, l.prototype.set = s, e.exports = l;
  }, function (e, t, n) {
    var i = n(602),
        r = n(605),
        o = n(606);

    e.exports = function (e, t, n, a, s, l) {
      var u = 1 & n,
          c = e.length,
          h = t.length;
      if (c != h && !(u && h > c)) return !1;
      var d = l.get(e);
      if (d && l.get(t)) return d == t;
      var f = -1,
          p = !0,
          g = 2 & n ? new i() : void 0;

      for (l.set(e, t), l.set(t, e); ++f < c;) {
        var v = e[f],
            m = t[f];
        if (a) var y = u ? a(m, v, f, t, e, l) : a(v, m, f, e, t, l);

        if (void 0 !== y) {
          if (y) continue;
          p = !1;
          break;
        }

        if (g) {
          if (!r(t, function (e, t) {
            if (!o(g, t) && (v === e || s(v, e, n, a, l))) return g.push(t);
          })) {
            p = !1;
            break;
          }
        } else if (v !== m && !s(v, m, n, a, l)) {
          p = !1;
          break;
        }
      }

      return l.delete(e), l.delete(t), p;
    };
  }, function (e, t, n) {
    (function (e) {
      var i = n(51),
          r = n(623),
          o = t && !t.nodeType && t,
          a = o && "object" == typeof e && e && !e.nodeType && e,
          s = a && a.exports === o ? i.Buffer : void 0,
          l = (s ? s.isBuffer : void 0) || r;
      e.exports = l;
    }).call(this, n(199)(e));
  }, function (e, t, n) {
    var i = n(625),
        r = n(626),
        o = n(627),
        a = o && o.isTypedArray,
        s = a ? r(a) : i;
    e.exports = s;
  }, function (e, t) {
    e.exports = function (e) {
      return "number" == typeof e && e > -1 && e % 1 == 0 && e <= 9007199254740991;
    };
  }, function (e, t) {
    var n = 2311;

    e.exports = function () {
      return n++;
    };
  }, function (e, t, n) {
    var i = n(21),
        r = n(647).buildTransformer,
        o = [];

    function a(e, t, n, o, a) {
      if (t.getBoundingClientRect && i.domSupported && !s(t)) {
        var l = t.___zrEVENTSAVED || (t.___zrEVENTSAVED = {}),
            u = function (e, t, n) {
          for (var i = n ? "invTrans" : "trans", o = t[i], a = t.srcCoords, s = !0, l = [], u = [], c = 0; c < 4; c++) {
            var h = e[c].getBoundingClientRect(),
                d = 2 * c,
                f = h.left,
                p = h.top;
            l.push(f, p), s = s && a && f === a[d] && p === a[d + 1], u.push(e[c].offsetLeft, e[c].offsetTop);
          }

          return s && o ? o : (t.srcCoords = l, t[i] = n ? r(u, l) : r(l, u));
        }(function (e, t) {
          var n = t.markers;
          if (n) return n;
          n = t.markers = [];

          for (var i = ["left", "right"], r = ["top", "bottom"], o = 0; o < 4; o++) {
            var a = document.createElement("div"),
                s = a.style,
                l = o % 2,
                u = (o >> 1) % 2;
            s.cssText = ["position: absolute", "visibility: hidden", "padding: 0", "margin: 0", "border-width: 0", "user-select: none", "width:0", "height:0", i[l] + ":0", r[u] + ":0", i[1 - l] + ":auto", r[1 - u] + ":auto", ""].join("!important;"), e.appendChild(a), n.push(a);
          }

          return n;
        }(t, l), l, a);

        if (u) return u(e, n, o), !0;
      }

      return !1;
    }

    function s(e) {
      return "CANVAS" === e.nodeName.toUpperCase();
    }

    t.transformLocalCoord = function (e, t, n, i, r) {
      return a(o, t, i, r, !0) && a(e, n, o[0], o[1]);
    }, t.transformCoordWithViewport = a, t.isCanvasEl = s;
  }, function (e, t, n) {
    var i = n(284),
        r = n(83),
        o = n(153),
        a = n(650),
        s = n(1),
        l = function l(e) {
      o.call(this, e), r.call(this, e), a.call(this, e), this.id = e.id || i();
    };

    l.prototype = {
      type: "element",
      name: "",
      __zr: null,
      ignore: !1,
      clipPath: null,
      isGroup: !1,
      drift: function drift(e, t) {
        switch (this.draggable) {
          case "horizontal":
            t = 0;
            break;

          case "vertical":
            e = 0;
        }

        var n = this.transform;
        n || (n = this.transform = [1, 0, 0, 1, 0, 0]), n[4] += e, n[5] += t, this.decomposeTransform(), this.dirty(!1);
      },
      beforeUpdate: function beforeUpdate() {},
      afterUpdate: function afterUpdate() {},
      update: function update() {
        this.updateTransform();
      },
      traverse: function traverse(e, t) {},
      attrKV: function attrKV(e, t) {
        if ("position" === e || "scale" === e || "origin" === e) {
          if (t) {
            var n = this[e];
            n || (n = this[e] = []), n[0] = t[0], n[1] = t[1];
          }
        } else this[e] = t;
      },
      hide: function hide() {
        this.ignore = !0, this.__zr && this.__zr.refresh();
      },
      show: function show() {
        this.ignore = !1, this.__zr && this.__zr.refresh();
      },
      attr: function attr(e, t) {
        if ("string" == typeof e) this.attrKV(e, t);else if (s.isObject(e)) for (var n in e) {
          e.hasOwnProperty(n) && this.attrKV(n, e[n]);
        }
        return this.dirty(!1), this;
      },
      setClipPath: function setClipPath(e) {
        var t = this.__zr;
        t && e.addSelfToZr(t), this.clipPath && this.clipPath !== e && this.removeClipPath(), this.clipPath = e, e.__zr = t, e.__clipTarget = this, this.dirty(!1);
      },
      removeClipPath: function removeClipPath() {
        var e = this.clipPath;
        e && (e.__zr && e.removeSelfFromZr(e.__zr), e.__zr = null, e.__clipTarget = null, this.clipPath = null, this.dirty(!1));
      },
      addSelfToZr: function addSelfToZr(e) {
        this.__zr = e;
        var t = this.animators;
        if (t) for (var n = 0; n < t.length; n++) {
          e.animation.addAnimator(t[n]);
        }
        this.clipPath && this.clipPath.addSelfToZr(e);
      },
      removeSelfFromZr: function removeSelfFromZr(e) {
        this.__zr = null;
        var t = this.animators;
        if (t) for (var n = 0; n < t.length; n++) {
          e.animation.removeAnimator(t[n]);
        }
        this.clipPath && this.clipPath.removeSelfFromZr(e);
      }
    }, s.mixin(l, a), s.mixin(l, o), s.mixin(l, r);
    var u = l;
    e.exports = u;
  }, function (e, t, n) {
    var i = n(651),
        r = n(53),
        o = n(1).isArrayLike,
        a = Array.prototype.slice;

    function s(e, t) {
      return e[t];
    }

    function l(e, t, n) {
      e[t] = n;
    }

    function u(e, t, n) {
      return (t - e) * n + e;
    }

    function c(e, t, n) {
      return n > .5 ? t : e;
    }

    function h(e, t, n, i, r) {
      var o = e.length;
      if (1 === r) for (var a = 0; a < o; a++) {
        i[a] = u(e[a], t[a], n);
      } else {
        var s = o && e[0].length;

        for (a = 0; a < o; a++) {
          for (var l = 0; l < s; l++) {
            i[a][l] = u(e[a][l], t[a][l], n);
          }
        }
      }
    }

    function d(e, t, n) {
      var i = e.length,
          r = t.length;
      if (i !== r) if (i > r) e.length = r;else for (var o = i; o < r; o++) {
        e.push(1 === n ? t[o] : a.call(t[o]));
      }
      var s = e[0] && e[0].length;

      for (o = 0; o < e.length; o++) {
        if (1 === n) isNaN(e[o]) && (e[o] = t[o]);else for (var l = 0; l < s; l++) {
          isNaN(e[o][l]) && (e[o][l] = t[o][l]);
        }
      }
    }

    function f(e, t, n) {
      if (e === t) return !0;
      var i = e.length;
      if (i !== t.length) return !1;

      if (1 === n) {
        for (var r = 0; r < i; r++) {
          if (e[r] !== t[r]) return !1;
        }
      } else {
        var o = e[0].length;

        for (r = 0; r < i; r++) {
          for (var a = 0; a < o; a++) {
            if (e[r][a] !== t[r][a]) return !1;
          }
        }
      }

      return !0;
    }

    function p(e, t, n, i, r, o, a, s, l) {
      var u = e.length;
      if (1 === l) for (var c = 0; c < u; c++) {
        s[c] = g(e[c], t[c], n[c], i[c], r, o, a);
      } else {
        var h = e[0].length;

        for (c = 0; c < u; c++) {
          for (var d = 0; d < h; d++) {
            s[c][d] = g(e[c][d], t[c][d], n[c][d], i[c][d], r, o, a);
          }
        }
      }
    }

    function g(e, t, n, i, r, o, a) {
      var s = .5 * (n - e),
          l = .5 * (i - t);
      return (2 * (t - n) + s + l) * a + (-3 * (t - n) - 2 * s - l) * o + s * r + t;
    }

    function v(e) {
      if (o(e)) {
        var t = e.length;

        if (o(e[0])) {
          for (var n = [], i = 0; i < t; i++) {
            n.push(a.call(e[i]));
          }

          return n;
        }

        return a.call(e);
      }

      return e;
    }

    function m(e) {
      return e[0] = Math.floor(e[0]), e[1] = Math.floor(e[1]), e[2] = Math.floor(e[2]), "rgba(" + e.join(",") + ")";
    }

    function y(e, t, n, a, s, l) {
      var v = e._getter,
          y = e._setter,
          x = "spline" === t,
          _ = a.length;

      if (_) {
        var b,
            w = a[0].value,
            S = o(w),
            T = !1,
            C = !1,
            k = S ? function (e) {
          var t = e[e.length - 1].value;
          return o(t && t[0]) ? 2 : 1;
        }(a) : 0;
        a.sort(function (e, t) {
          return e.time - t.time;
        }), b = a[_ - 1].time;

        for (var M = [], E = [], A = a[0].value, I = !0, P = 0; P < _; P++) {
          M.push(a[P].time / b);
          var O = a[P].value;

          if (S && f(O, A, k) || !S && O === A || (I = !1), A = O, "string" == typeof O) {
            var L = r.parse(O);
            L ? (O = L, T = !0) : C = !0;
          }

          E.push(O);
        }

        if (l || !I) {
          var D = E[_ - 1];

          for (P = 0; P < _ - 1; P++) {
            S ? d(E[P], D, k) : !isNaN(E[P]) || isNaN(D) || C || T || (E[P] = D);
          }

          S && d(v(e._target, s), D, k);
          var N,
              j,
              R,
              F,
              z,
              B = 0,
              V = 0;
          if (T) var H = [0, 0, 0, 0];
          var W = new i({
            target: e._target,
            life: b,
            loop: e._loop,
            delay: e._delay,
            onframe: function onframe(e, t) {
              var n;
              if (t < 0) n = 0;else if (t < V) {
                for (n = Math.min(B + 1, _ - 1); n >= 0 && !(M[n] <= t); n--) {
                  ;
                }

                n = Math.min(n, _ - 2);
              } else {
                for (n = B; n < _ && !(M[n] > t); n++) {
                  ;
                }

                n = Math.min(n - 1, _ - 2);
              }
              B = n, V = t;
              var i = M[n + 1] - M[n];
              if (0 !== i) if (N = (t - M[n]) / i, x) {
                if (R = E[n], j = E[0 === n ? n : n - 1], F = E[n > _ - 2 ? _ - 1 : n + 1], z = E[n > _ - 3 ? _ - 1 : n + 2], S) p(j, R, F, z, N, N * N, N * N * N, v(e, s), k);else {
                  if (T) r = p(j, R, F, z, N, N * N, N * N * N, H, 1), r = m(H);else {
                    if (C) return c(R, F, N);
                    r = g(j, R, F, z, N, N * N, N * N * N);
                  }
                  y(e, s, r);
                }
              } else if (S) h(E[n], E[n + 1], N, v(e, s), k);else {
                var r;
                if (T) h(E[n], E[n + 1], N, H, 1), r = m(H);else {
                  if (C) return c(E[n], E[n + 1], N);
                  r = u(E[n], E[n + 1], N);
                }
                y(e, s, r);
              }
            },
            ondestroy: n
          });
          return t && "spline" !== t && (W.easing = t), W;
        }
      }
    }

    var x = function x(e, t, n, i) {
      this._tracks = {}, this._target = e, this._loop = t || !1, this._getter = n || s, this._setter = i || l, this._clipCount = 0, this._delay = 0, this._doneList = [], this._onframeList = [], this._clipList = [];
    };

    x.prototype = {
      when: function when(e, t) {
        var n = this._tracks;

        for (var i in t) {
          if (t.hasOwnProperty(i)) {
            if (!n[i]) {
              n[i] = [];

              var r = this._getter(this._target, i);

              if (null == r) continue;
              0 !== e && n[i].push({
                time: 0,
                value: v(r)
              });
            }

            n[i].push({
              time: e,
              value: t[i]
            });
          }
        }

        return this;
      },
      during: function during(e) {
        return this._onframeList.push(e), this;
      },
      pause: function pause() {
        for (var e = 0; e < this._clipList.length; e++) {
          this._clipList[e].pause();
        }

        this._paused = !0;
      },
      resume: function resume() {
        for (var e = 0; e < this._clipList.length; e++) {
          this._clipList[e].resume();
        }

        this._paused = !1;
      },
      isPaused: function isPaused() {
        return !!this._paused;
      },
      _doneCallback: function _doneCallback() {
        this._tracks = {}, this._clipList.length = 0;

        for (var e = this._doneList, t = e.length, n = 0; n < t; n++) {
          e[n].call(this);
        }
      },
      start: function start(e, t) {
        var n,
            i = this,
            r = 0,
            o = function o() {
          --r || i._doneCallback();
        };

        for (var a in this._tracks) {
          if (this._tracks.hasOwnProperty(a)) {
            var s = y(this, e, o, this._tracks[a], a, t);
            s && (this._clipList.push(s), r++, this.animation && this.animation.addClip(s), n = s);
          }
        }

        if (n) {
          var l = n.onframe;

          n.onframe = function (e, t) {
            l(e, t);

            for (var n = 0; n < i._onframeList.length; n++) {
              i._onframeList[n](e, t);
            }
          };
        }

        return r || this._doneCallback(), this;
      },
      stop: function stop(e) {
        for (var t = this._clipList, n = this.animation, i = 0; i < t.length; i++) {
          var r = t[i];
          e && r.onframe(this._target, 1), n && n.removeClip(r);
        }

        t.length = 0;
      },
      delay: function delay(e) {
        return this._delay = e, this;
      },
      done: function done(e) {
        return e && this._doneList.push(e), this;
      },
      getClips: function getClips() {
        return this._clipList;
      }
    };
    var _ = x;
    e.exports = _;
  }, function (e, t) {
    var n = function n() {
      this.head = null, this.tail = null, this._len = 0;
    },
        i = n.prototype;

    i.insert = function (e) {
      var t = new r(e);
      return this.insertEntry(t), t;
    }, i.insertEntry = function (e) {
      this.head ? (this.tail.next = e, e.prev = this.tail, e.next = null, this.tail = e) : this.head = this.tail = e, this._len++;
    }, i.remove = function (e) {
      var t = e.prev,
          n = e.next;
      t ? t.next = n : this.head = n, n ? n.prev = t : this.tail = t, e.next = e.prev = null, this._len--;
    }, i.len = function () {
      return this._len;
    }, i.clear = function () {
      this.head = this.tail = null, this._len = 0;
    };

    var r = function r(e) {
      this.value = e, this.next, this.prev;
    },
        o = function o(e) {
      this._list = new n(), this._map = {}, this._maxSize = e || 10, this._lastRemovedEntry = null;
    },
        a = o.prototype;

    a.put = function (e, t) {
      var n = this._list,
          i = this._map,
          o = null;

      if (null == i[e]) {
        var a = n.len(),
            s = this._lastRemovedEntry;

        if (a >= this._maxSize && a > 0) {
          var l = n.head;
          n.remove(l), delete i[l.key], o = l.value, this._lastRemovedEntry = l;
        }

        s ? s.value = t : s = new r(t), s.key = e, n.insertEntry(s), i[e] = s;
      }

      return o;
    }, a.get = function (e) {
      var t = this._map[e],
          n = this._list;
      if (null != t) return t !== n.tail && (n.remove(t), n.insertEntry(t)), t.value;
    }, a.clear = function () {
      this._list.clear(), this._map = {};
    };
    var s = o;
    e.exports = s;
  }, function (e, t) {
    var n = {
      shadowBlur: 1,
      shadowOffsetX: 1,
      shadowOffsetY: 1,
      textShadowBlur: 1,
      textShadowOffsetX: 1,
      textShadowOffsetY: 1,
      textBoxShadowBlur: 1,
      textBoxShadowOffsetX: 1,
      textBoxShadowOffsetY: 1
    };

    e.exports = function (e, t, i) {
      return n.hasOwnProperty(t) ? i * e.dpr : i;
    };
  }, function (e, t) {
    var n = function n(e, t) {
      this.image = e, this.repeat = t, this.type = "pattern";
    };

    n.prototype.getCanvasPattern = function (e) {
      return e.createPattern(this.image, this.repeat || "repeat");
    };

    var i = n;
    e.exports = i;
  }, function (e, t) {
    var n = "undefined" != typeof window && (window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.msRequestAnimationFrame && window.msRequestAnimationFrame.bind(window) || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame) || function (e) {
      setTimeout(e, 16);
    };

    e.exports = n;
  }, function (e, t, n) {
    var i = n(156),
        r = n(17),
        o = n(155).WILL_BE_RESTORED,
        a = new r(),
        s = function s() {};

    s.prototype = {
      constructor: s,
      drawRectText: function drawRectText(e, t) {
        var n = this.style;
        t = n.textRect || t, this.__dirty && i.normalizeTextStyle(n, !0);
        var r = n.text;

        if (null != r && (r += ""), i.needDrawText(r, n)) {
          e.save();
          var s = this.transform;
          n.transformText ? this.setTransform(e) : s && (a.copy(t), a.applyTransform(s), t = a), i.renderText(this, e, r, n, t, o), e.restore();
        }
      }
    };
    var l = s;
    e.exports = l;
  }, function (e, t) {
    t.buildPath = function (e, t) {
      var n,
          i,
          r,
          o,
          a,
          s = t.x,
          l = t.y,
          u = t.width,
          c = t.height,
          h = t.r;
      u < 0 && (s += u, u = -u), c < 0 && (l += c, c = -c), "number" == typeof h ? n = i = r = o = h : h instanceof Array ? 1 === h.length ? n = i = r = o = h[0] : 2 === h.length ? (n = r = h[0], i = o = h[1]) : 3 === h.length ? (n = h[0], i = o = h[1], r = h[2]) : (n = h[0], i = h[1], r = h[2], o = h[3]) : n = i = r = o = 0, n + i > u && (n *= u / (a = n + i), i *= u / a), r + o > u && (r *= u / (a = r + o), o *= u / a), i + r > c && (i *= c / (a = i + r), r *= c / a), n + o > c && (n *= c / (a = n + o), o *= c / a), e.moveTo(s + n, l), e.lineTo(s + u - i, l), 0 !== i && e.arc(s + u - i, l + i, i, -Math.PI / 2, 0), e.lineTo(s + u, l + c - r), 0 !== r && e.arc(s + u - r, l + c - r, r, 0, Math.PI / 2), e.lineTo(s + o, l + c), 0 !== o && e.arc(s + o, l + c - o, o, Math.PI / 2, Math.PI), e.lineTo(s, l + n), 0 !== n && e.arc(s + n, l + n, n, Math.PI, 1.5 * Math.PI);
    };
  }, function (e, t, n) {
    n(9).__DEV__;

    var i = n(1),
        r = i.each,
        o = i.filter,
        a = i.map,
        s = i.isArray,
        l = i.indexOf,
        u = i.isObject,
        c = i.isString,
        h = i.createHashMap,
        d = i.assert,
        f = i.clone,
        p = i.merge,
        g = i.extend,
        v = i.mixin,
        m = n(8),
        y = n(22),
        x = n(26),
        _ = n(674),
        b = n(306),
        w = n(61).resetSourceDefaulter,
        S = y.extend({
      init: function init(e, t, n, i) {
        n = n || {}, this.option = null, this._theme = new y(n), this._optionManager = i;
      },
      setOption: function setOption(e, t) {
        d(!("\0_ec_inner" in e), "please use chart.getOption()"), this._optionManager.setOption(e, t), this.resetOption(null);
      },
      resetOption: function resetOption(e) {
        var t = !1,
            n = this._optionManager;

        if (!e || "recreate" === e) {
          var i = n.mountOption("recreate" === e);
          this.option && "recreate" !== e ? (this.restoreData(), this.mergeOption(i)) : T.call(this, i), t = !0;
        }

        if ("timeline" !== e && "media" !== e || this.restoreData(), !e || "recreate" === e || "timeline" === e) {
          var o = n.getTimelineOption(this);
          o && (this.mergeOption(o), t = !0);
        }

        if (!e || "recreate" === e || "media" === e) {
          var a = n.getMediaOption(this, this._api);
          a.length && r(a, function (e) {
            this.mergeOption(e, t = !0);
          }, this);
        }

        return t;
      },
      mergeOption: function mergeOption(e) {
        var t = this.option,
            n = this._componentsMap,
            i = [];
        w(this), r(e, function (e, n) {
          null != e && (x.hasClass(n) ? n && i.push(n) : t[n] = null == t[n] ? f(e) : p(t[n], e, !0));
        }), x.topologicalTravel(i, x.getAllClassMainTypes(), function (i, o) {
          var a = m.normalizeToArray(e[i]),
              l = m.mappingToExists(n.get(i), a);
          m.makeIdAndName(l), r(l, function (e, t) {
            var n = e.option;
            u(n) && (e.keyInfo.mainType = i, e.keyInfo.subType = function (e, t, n) {
              return t.type ? t.type : n ? n.subType : x.determineSubType(e, t);
            }(i, n, e.exist));
          });

          var c = function (e, t) {
            s(t) || (t = t ? [t] : []);
            var n = {};
            return r(t, function (t) {
              n[t] = (e.get(t) || []).slice();
            }), n;
          }(n, o);

          t[i] = [], n.set(i, []), r(l, function (e, r) {
            var o = e.exist,
                a = e.option;

            if (d(u(a) || o, "Empty component definition"), a) {
              var s = x.getClass(i, e.keyInfo.subType, !0);
              if (o && o.constructor === s) o.name = e.keyInfo.name, o.mergeOption(a, this), o.optionUpdated(a, !1);else {
                var l = g({
                  dependentModels: c,
                  componentIndex: r
                }, e.keyInfo);
                o = new s(a, this, this, l), g(o, l), o.init(a, this, this, l), o.optionUpdated(null, !0);
              }
            } else o.mergeOption({}, this), o.optionUpdated({}, !1);

            n.get(i)[r] = o, t[i][r] = o.option;
          }, this), "series" === i && C(this, n.get("series"));
        }, this), this._seriesIndicesMap = h(this._seriesIndices = this._seriesIndices || []);
      },
      getOption: function getOption() {
        var e = f(this.option);
        return r(e, function (t, n) {
          if (x.hasClass(n)) {
            for (var i = (t = m.normalizeToArray(t)).length - 1; i >= 0; i--) {
              m.isIdInner(t[i]) && t.splice(i, 1);
            }

            e[n] = t;
          }
        }), delete e["\0_ec_inner"], e;
      },
      getTheme: function getTheme() {
        return this._theme;
      },
      getComponent: function getComponent(e, t) {
        var n = this._componentsMap.get(e);

        if (n) return n[t || 0];
      },
      queryComponents: function queryComponents(e) {
        var t = e.mainType;
        if (!t) return [];

        var n,
            i = e.index,
            r = e.id,
            u = e.name,
            c = this._componentsMap.get(t);

        if (!c || !c.length) return [];
        if (null != i) s(i) || (i = [i]), n = o(a(i, function (e) {
          return c[e];
        }), function (e) {
          return !!e;
        });else if (null != r) {
          var h = s(r);
          n = o(c, function (e) {
            return h && l(r, e.id) >= 0 || !h && e.id === r;
          });
        } else if (null != u) {
          var d = s(u);
          n = o(c, function (e) {
            return d && l(u, e.name) >= 0 || !d && e.name === u;
          });
        } else n = c.slice();
        return k(n, e);
      },
      findComponents: function findComponents(e) {
        var t,
            n,
            i,
            r,
            a,
            s = e.query,
            l = e.mainType,
            u = (n = l + "Index", i = l + "Id", r = l + "Name", !(t = s) || null == t[n] && null == t[i] && null == t[r] ? null : {
          mainType: l,
          index: t[n],
          id: t[i],
          name: t[r]
        }),
            c = u ? this.queryComponents(u) : this._componentsMap.get(l);
        return a = k(c, e), e.filter ? o(a, e.filter) : a;
      },
      eachComponent: function eachComponent(e, t, n) {
        var i = this._componentsMap;
        if ("function" == typeof e) n = t, t = e, i.each(function (e, i) {
          r(e, function (e, r) {
            t.call(n, i, e, r);
          });
        });else if (c(e)) r(i.get(e), t, n);else if (u(e)) {
          var o = this.findComponents(e);
          r(o, t, n);
        }
      },
      getSeriesByName: function getSeriesByName(e) {
        var t = this._componentsMap.get("series");

        return o(t, function (t) {
          return t.name === e;
        });
      },
      getSeriesByIndex: function getSeriesByIndex(e) {
        return this._componentsMap.get("series")[e];
      },
      getSeriesByType: function getSeriesByType(e) {
        var t = this._componentsMap.get("series");

        return o(t, function (t) {
          return t.subType === e;
        });
      },
      getSeries: function getSeries() {
        return this._componentsMap.get("series").slice();
      },
      getSeriesCount: function getSeriesCount() {
        return this._componentsMap.get("series").length;
      },
      eachSeries: function eachSeries(e, t) {
        r(this._seriesIndices, function (n) {
          var i = this._componentsMap.get("series")[n];

          e.call(t, i, n);
        }, this);
      },
      eachRawSeries: function eachRawSeries(e, t) {
        r(this._componentsMap.get("series"), e, t);
      },
      eachSeriesByType: function eachSeriesByType(e, t, n) {
        r(this._seriesIndices, function (i) {
          var r = this._componentsMap.get("series")[i];

          r.subType === e && t.call(n, r, i);
        }, this);
      },
      eachRawSeriesByType: function eachRawSeriesByType(e, t, n) {
        return r(this.getSeriesByType(e), t, n);
      },
      isSeriesFiltered: function isSeriesFiltered(e) {
        return null == this._seriesIndicesMap.get(e.componentIndex);
      },
      getCurrentSeriesIndices: function getCurrentSeriesIndices() {
        return (this._seriesIndices || []).slice();
      },
      filterSeries: function filterSeries(e, t) {
        C(this, o(this._componentsMap.get("series"), e, t));
      },
      restoreData: function restoreData(e) {
        var t = this._componentsMap;
        C(this, t.get("series"));
        var n = [];
        t.each(function (e, t) {
          n.push(t);
        }), x.topologicalTravel(n, x.getAllClassMainTypes(), function (n, i) {
          r(t.get(n), function (t) {
            ("series" !== n || !function (e, t) {
              if (t) {
                var n = t.seiresIndex,
                    i = t.seriesId,
                    r = t.seriesName;
                return null != n && e.componentIndex !== n || null != i && e.id !== i || null != r && e.name !== r;
              }
            }(t, e)) && t.restoreData();
          });
        });
      }
    });

    function T(e) {
      var t, n, i;
      e = e, this.option = {}, this.option["\0_ec_inner"] = 1, this._componentsMap = h({
        series: []
      }), this._seriesIndices, this._seriesIndicesMap, t = e, n = this._theme.option, i = t.color && !t.colorLayer, r(n, function (e, n) {
        "colorLayer" === n && i || x.hasClass(n) || ("object" == typeof e ? t[n] = t[n] ? p(t[n], e, !1) : f(e) : null == t[n] && (t[n] = e));
      }), p(e, _, !1), this.mergeOption(e);
    }

    function C(e, t) {
      e._seriesIndicesMap = h(e._seriesIndices = a(t, function (e) {
        return e.componentIndex;
      }) || []);
    }

    function k(e, t) {
      return t.hasOwnProperty("subType") ? o(e, function (e) {
        return e.subType === t.subType;
      }) : e;
    }

    v(S, b);
    var M = S;
    e.exports = M;
  }, function (e, t, n) {
    var i = n(20),
        r = n(102),
        o = n(663),
        a = Math.sqrt,
        s = Math.sin,
        l = Math.cos,
        u = Math.PI,
        c = function c(e) {
      return Math.sqrt(e[0] * e[0] + e[1] * e[1]);
    },
        h = function h(e, t) {
      return (e[0] * t[0] + e[1] * t[1]) / (c(e) * c(t));
    },
        d = function d(e, t) {
      return (e[0] * t[1] < e[1] * t[0] ? -1 : 1) * Math.acos(h(e, t));
    };

    function f(e, t, n, i, r, o, c, f, p, g, v) {
      var m = p * (u / 180),
          y = l(m) * (e - n) / 2 + s(m) * (t - i) / 2,
          x = -1 * s(m) * (e - n) / 2 + l(m) * (t - i) / 2,
          _ = y * y / (c * c) + x * x / (f * f);

      _ > 1 && (c *= a(_), f *= a(_));
      var b = (r === o ? -1 : 1) * a((c * c * (f * f) - c * c * (x * x) - f * f * (y * y)) / (c * c * (x * x) + f * f * (y * y))) || 0,
          w = b * c * x / f,
          S = b * -f * y / c,
          T = (e + n) / 2 + l(m) * w - s(m) * S,
          C = (t + i) / 2 + s(m) * w + l(m) * S,
          k = d([1, 0], [(y - w) / c, (x - S) / f]),
          M = [(y - w) / c, (x - S) / f],
          E = [(-1 * y - w) / c, (-1 * x - S) / f],
          A = d(M, E);
      h(M, E) <= -1 && (A = u), h(M, E) >= 1 && (A = 0), 0 === o && A > 0 && (A -= 2 * u), 1 === o && A < 0 && (A += 2 * u), v.addData(g, T, C, c, f, k, A, m, o);
    }

    var p = /([mlvhzcqtsa])([^mlvhzcqtsa]*)/gi,
        g = /-?([0-9]*\.)?[0-9]+([eE]-?[0-9]+)?/g;

    function v(e, t) {
      var n = function (e) {
        if (!e) return new r();

        for (var t, n = 0, i = 0, o = n, a = i, s = new r(), l = r.CMD, u = e.match(p), c = 0; c < u.length; c++) {
          for (var h, d = u[c], v = d.charAt(0), m = d.match(g) || [], y = m.length, x = 0; x < y; x++) {
            m[x] = parseFloat(m[x]);
          }

          for (var _ = 0; _ < y;) {
            var b,
                w,
                S,
                T,
                C,
                k,
                M,
                E = n,
                A = i;

            switch (v) {
              case "l":
                n += m[_++], i += m[_++], h = l.L, s.addData(h, n, i);
                break;

              case "L":
                n = m[_++], i = m[_++], h = l.L, s.addData(h, n, i);
                break;

              case "m":
                n += m[_++], i += m[_++], h = l.M, s.addData(h, n, i), o = n, a = i, v = "l";
                break;

              case "M":
                n = m[_++], i = m[_++], h = l.M, s.addData(h, n, i), o = n, a = i, v = "L";
                break;

              case "h":
                n += m[_++], h = l.L, s.addData(h, n, i);
                break;

              case "H":
                n = m[_++], h = l.L, s.addData(h, n, i);
                break;

              case "v":
                i += m[_++], h = l.L, s.addData(h, n, i);
                break;

              case "V":
                i = m[_++], h = l.L, s.addData(h, n, i);
                break;

              case "C":
                h = l.C, s.addData(h, m[_++], m[_++], m[_++], m[_++], m[_++], m[_++]), n = m[_ - 2], i = m[_ - 1];
                break;

              case "c":
                h = l.C, s.addData(h, m[_++] + n, m[_++] + i, m[_++] + n, m[_++] + i, m[_++] + n, m[_++] + i), n += m[_ - 2], i += m[_ - 1];
                break;

              case "S":
                b = n, w = i;
                var I = s.len(),
                    P = s.data;
                t === l.C && (b += n - P[I - 4], w += i - P[I - 3]), h = l.C, E = m[_++], A = m[_++], n = m[_++], i = m[_++], s.addData(h, b, w, E, A, n, i);
                break;

              case "s":
                b = n, w = i;
                I = s.len(), P = s.data;
                t === l.C && (b += n - P[I - 4], w += i - P[I - 3]), h = l.C, E = n + m[_++], A = i + m[_++], n += m[_++], i += m[_++], s.addData(h, b, w, E, A, n, i);
                break;

              case "Q":
                E = m[_++], A = m[_++], n = m[_++], i = m[_++], h = l.Q, s.addData(h, E, A, n, i);
                break;

              case "q":
                E = m[_++] + n, A = m[_++] + i, n += m[_++], i += m[_++], h = l.Q, s.addData(h, E, A, n, i);
                break;

              case "T":
                b = n, w = i;
                I = s.len(), P = s.data;
                t === l.Q && (b += n - P[I - 4], w += i - P[I - 3]), n = m[_++], i = m[_++], h = l.Q, s.addData(h, b, w, n, i);
                break;

              case "t":
                b = n, w = i;
                I = s.len(), P = s.data;
                t === l.Q && (b += n - P[I - 4], w += i - P[I - 3]), n += m[_++], i += m[_++], h = l.Q, s.addData(h, b, w, n, i);
                break;

              case "A":
                S = m[_++], T = m[_++], C = m[_++], k = m[_++], M = m[_++], f(E = n, A = i, n = m[_++], i = m[_++], k, M, S, T, C, h = l.A, s);
                break;

              case "a":
                S = m[_++], T = m[_++], C = m[_++], k = m[_++], M = m[_++], f(E = n, A = i, n += m[_++], i += m[_++], k, M, S, T, C, h = l.A, s);
            }
          }

          "z" !== v && "Z" !== v || (h = l.Z, s.addData(h), n = o, i = a), t = h;
        }

        return s.toStatic(), s;
      }(e);

      return (t = t || {}).buildPath = function (e) {
        if (e.setData) {
          e.setData(n.data), (t = e.getContext()) && e.rebuildPath(t);
        } else {
          var t = e;
          n.rebuildPath(t);
        }
      }, t.applyTransform = function (e) {
        o(n, e), this.dirty(!0);
      }, t;
    }

    t.createFromString = function (e, t) {
      return new i(v(e, t));
    }, t.extendFromString = function (e, t) {
      return i.extend(v(e, t));
    }, t.mergePath = function (e, t) {
      for (var n = [], r = e.length, o = 0; o < r; o++) {
        var a = e[o];
        a.path || a.createPathProxy(), a.__dirtyPath && a.buildPath(a.path, a.shape, !0), n.push(a.path);
      }

      var s = new i(t);
      return s.createPathProxy(), s.buildPath = function (e) {
        e.appendPath(n);
        var t = e.getContext();
        t && e.rebuildPath(t);
      }, s;
    };
  }, function (e, t) {
    t.containStroke = function (e, t, n, i, r, o, a) {
      if (0 === r) return !1;
      var s = r,
          l = 0;
      if (a > t + s && a > i + s || a < t - s && a < i - s || o > e + s && o > n + s || o < e - s && o < n - s) return !1;
      if (e === n) return Math.abs(o - e) <= s / 2;
      var u = (l = (t - i) / (e - n)) * o - a + (e * i - n * t) / (e - n);
      return u * u / (l * l + 1) <= s / 2 * s / 2;
    };
  }, function (e, t, n) {
    var i = n(66).quadraticProjectPoint;

    t.containStroke = function (e, t, n, r, o, a, s, l, u) {
      if (0 === s) return !1;
      var c = s;
      return !(u > t + c && u > r + c && u > a + c || u < t - c && u < r - c && u < a - c || l > e + c && l > n + c && l > o + c || l < e - c && l < n - c && l < o - c) && i(e, t, n, r, o, a, l, u, null) <= c / 2;
    };
  }, function (e, t) {
    var n = 2 * Math.PI;

    t.normalizeRadian = function (e) {
      return (e %= n) < 0 && (e += n), e;
    };
  }, function (e, t) {
    e.exports = function (e, t, n, i, r, o) {
      if (o > t && o > i || o < t && o < i) return 0;
      if (i === t) return 0;
      var a = i < t ? 1 : -1,
          s = (o - t) / (i - t);
      1 !== s && 0 !== s || (a = i < t ? .5 : -.5);
      var l = s * (n - e) + e;
      return l === r ? 1 / 0 : l > r ? a : 0;
    };
  }, function (e, t, n) {
    var i = n(20).extend({
      type: "circle",
      shape: {
        cx: 0,
        cy: 0,
        r: 0
      },
      buildPath: function buildPath(e, t, n) {
        n && e.moveTo(t.cx + t.r, t.cy), e.arc(t.cx, t.cy, t.r, 0, 2 * Math.PI, !0);
      }
    });
    e.exports = i;
  }, function (e, t, n) {
    var i = n(21),
        r = [["shadowBlur", 0], ["shadowColor", "#000"], ["shadowOffsetX", 0], ["shadowOffsetY", 0]];

    e.exports = function (e) {
      return i.browser.ie && i.browser.version >= 11 ? function () {
        var t,
            n = this.__clipPaths,
            i = this.style;
        if (n) for (var o = 0; o < n.length; o++) {
          var a = n[o],
              s = a && a.shape,
              l = a && a.type;

          if (s && ("sector" === l && s.startAngle === s.endAngle || "rect" === l && (!s.width || !s.height))) {
            for (var u = 0; u < r.length; u++) {
              r[u][2] = i[r[u][0]], i[r[u][0]] = r[u][1];
            }

            t = !0;
            break;
          }
        }
        if (e.apply(this, arguments), t) for (u = 0; u < r.length; u++) {
          i[r[u][0]] = r[u][2];
        }
      } : e;
    };
  }, function (e, t, n) {
    var i = n(20),
        r = n(303),
        o = i.extend({
      type: "polygon",
      shape: {
        points: null,
        smooth: !1,
        smoothConstraint: null
      },
      buildPath: function buildPath(e, t) {
        r.buildPath(e, t, !0);
      }
    });
    e.exports = o;
  }, function (e, t, n) {
    var i = n(666),
        r = n(667);

    t.buildPath = function (e, t, n) {
      var o = t.points,
          a = t.smooth;

      if (o && o.length >= 2) {
        if (a && "spline" !== a) {
          var s = r(o, a, n, t.smoothConstraint);
          e.moveTo(o[0][0], o[0][1]);

          for (var l = o.length, u = 0; u < (n ? l : l - 1); u++) {
            var c = s[2 * u],
                h = s[2 * u + 1],
                d = o[(u + 1) % l];
            e.bezierCurveTo(c[0], c[1], h[0], h[1], d[0], d[1]);
          }
        } else {
          "spline" === a && (o = i(o, n)), e.moveTo(o[0][0], o[0][1]);
          u = 1;

          for (var f = o.length; u < f; u++) {
            e.lineTo(o[u][0], o[u][1]);
          }
        }

        n && e.closePath();
      }
    };
  }, function (e, t, n) {
    var i = n(20),
        r = n(303),
        o = i.extend({
      type: "polyline",
      shape: {
        points: null,
        smooth: !1,
        smoothConstraint: null
      },
      style: {
        stroke: "#000",
        fill: null
      },
      buildPath: function buildPath(e, t) {
        r.buildPath(e, t, !1);
      }
    });
    e.exports = o;
  }, function (e, t, n) {
    var i = n(20),
        r = n(207).subPixelOptimizeLine,
        o = {},
        a = i.extend({
      type: "line",
      shape: {
        x1: 0,
        y1: 0,
        x2: 0,
        y2: 0,
        percent: 1
      },
      style: {
        stroke: "#000",
        fill: null
      },
      buildPath: function buildPath(e, t) {
        var n, i, a, s;
        this.subPixelOptimize ? (r(o, t, this.style), n = o.x1, i = o.y1, a = o.x2, s = o.y2) : (n = t.x1, i = t.y1, a = t.x2, s = t.y2);
        var l = t.percent;
        0 !== l && (e.moveTo(n, i), l < 1 && (a = n * (1 - l) + a * l, s = i * (1 - l) + s * l), e.lineTo(a, s));
      },
      pointAt: function pointAt(e) {
        var t = this.shape;
        return [t.x1 * (1 - e) + t.x2 * e, t.y1 * (1 - e) + t.y2 * e];
      }
    });
    e.exports = a;
  }, function (e, t, n) {
    var i = n(8),
        r = i.makeInner,
        o = i.normalizeToArray,
        a = r();
    var s = {
      clearColorPalette: function clearColorPalette() {
        a(this).colorIdx = 0, a(this).colorNameMap = {};
      },
      getColorFromPalette: function getColorFromPalette(e, t, n) {
        var i = a(t = t || this),
            r = i.colorIdx || 0,
            s = i.colorNameMap = i.colorNameMap || {};
        if (s.hasOwnProperty(e)) return s[e];
        var l = o(this.get("color", !0)),
            u = this.get("colorLayer", !0),
            c = null != n && u ? function (e, t) {
          for (var n = e.length, i = 0; i < n; i++) {
            if (e[i].length > t) return e[i];
          }

          return e[n - 1];
        }(u, n) : l;

        if ((c = c || l) && c.length) {
          var h = c[r];
          return e && (s[e] = h), i.colorIdx = (r + 1) % c.length, h;
        }
      }
    };
    e.exports = s;
  }, function (e, t, n) {
    var i = n(1),
        r = ["getDom", "getZr", "getWidth", "getHeight", "getDevicePixelRatio", "dispatchAction", "isDisposed", "on", "off", "getDataURL", "getConnectedDataURL", "getModel", "getOption", "getViewOfComponentModel", "getViewOfSeriesModel"];

    var o = function o(e) {
      i.each(r, function (t) {
        this[t] = i.bind(e[t], e);
      }, this);
    };

    e.exports = o;
  }, function (e, t, n) {
    var i = n(26),
        r = n(158),
        o = n(61).detectSourceFormat,
        a = n(123).SERIES_LAYOUT_BY_COLUMN;
    i.extend({
      type: "dataset",
      defaultOption: {
        seriesLayoutBy: a,
        sourceHeader: null,
        dimensions: null,
        source: null
      },
      optionUpdated: function optionUpdated() {
        o(this);
      }
    }), r.extend({
      type: "dataset"
    });
  }, function (e, t, n) {
    var i = n(84),
        r = n(100),
        o = n(85),
        a = n(300),
        s = n(206),
        l = n(685),
        u = n(305),
        c = n(20),
        h = n(302),
        d = n(304),
        f = n(208),
        p = n(204),
        g = n(31),
        v = n(295).createFromString,
        m = n(1),
        y = m.isString,
        x = m.extend,
        _ = m.defaults,
        b = m.trim,
        w = m.each,
        S = /[\s,]+/;

    function T(e) {
      y(e) && (e = new DOMParser().parseFromString(e, "text/xml"));

      for (9 === e.nodeType && (e = e.firstChild); "svg" !== e.nodeName.toLowerCase() || 1 !== e.nodeType;) {
        e = e.nextSibling;
      }

      return e;
    }

    function C() {
      this._defs = {}, this._root = null, this._isDefine = !1, this._isText = !1;
    }

    C.prototype.parse = function (e, t) {
      t = t || {};
      var n = T(e);
      if (!n) throw new Error("Illegal svg");
      var r = new i();
      this._root = r;
      var o = n.getAttribute("viewBox") || "",
          a = parseFloat(n.getAttribute("width") || t.width),
          l = parseFloat(n.getAttribute("height") || t.height);
      isNaN(a) && (a = null), isNaN(l) && (l = null), P(n, r, null, !0);

      for (var u, c, h = n.firstChild; h;) {
        this._parseNode(h, r), h = h.nextSibling;
      }

      if (o) {
        var d = b(o).split(S);
        d.length >= 4 && (u = {
          x: parseFloat(d[0] || 0),
          y: parseFloat(d[1] || 0),
          width: parseFloat(d[2]),
          height: parseFloat(d[3])
        });
      }

      if (u && null != a && null != l && (c = j(u, a, l), !t.ignoreViewBox)) {
        var f = r;
        (r = new i()).add(f), f.scale = c.scale.slice(), f.position = c.position.slice();
      }

      return t.ignoreRootClip || null == a || null == l || r.setClipPath(new s({
        shape: {
          x: 0,
          y: 0,
          width: a,
          height: l
        }
      })), {
        root: r,
        width: a,
        height: l,
        viewBoxRect: u,
        viewBoxTransform: c
      };
    }, C.prototype._parseNode = function (e, t) {
      var n,
          i,
          r = e.nodeName.toLowerCase();

      if ("defs" === r ? this._isDefine = !0 : "text" === r && (this._isText = !0), this._isDefine) {
        if (i = M[r]) {
          var o = i.call(this, e),
              a = e.getAttribute("id");
          a && (this._defs[a] = o);
        }
      } else (i = k[r]) && (n = i.call(this, e, t), t.add(n));

      for (var s = e.firstChild; s;) {
        1 === s.nodeType && this._parseNode(s, n), 3 === s.nodeType && this._isText && this._parseText(s, n), s = s.nextSibling;
      }

      "defs" === r ? this._isDefine = !1 : "text" === r && (this._isText = !1);
    }, C.prototype._parseText = function (e, t) {
      if (1 === e.nodeType) {
        var n = e.getAttribute("dx") || 0,
            i = e.getAttribute("dy") || 0;
        this._textX += parseFloat(n), this._textY += parseFloat(i);
      }

      var r = new o({
        style: {
          text: e.textContent,
          transformText: !0
        },
        position: [this._textX || 0, this._textY || 0]
      });
      E(t, r), P(e, r, this._defs);
      var a = r.style.fontSize;
      a && a < 9 && (r.style.fontSize = 9, r.scale = r.scale || [1, 1], r.scale[0] *= a / 9, r.scale[1] *= a / 9);
      var s = r.getBoundingRect();
      return this._textX += s.width, t.add(r), r;
    };
    var k = {
      g: function g(e, t) {
        var n = new i();
        return E(t, n), P(e, n, this._defs), n;
      },
      rect: function rect(e, t) {
        var n = new s();
        return E(t, n), P(e, n, this._defs), n.setShape({
          x: parseFloat(e.getAttribute("x") || 0),
          y: parseFloat(e.getAttribute("y") || 0),
          width: parseFloat(e.getAttribute("width") || 0),
          height: parseFloat(e.getAttribute("height") || 0)
        }), n;
      },
      circle: function circle(e, t) {
        var n = new a();
        return E(t, n), P(e, n, this._defs), n.setShape({
          cx: parseFloat(e.getAttribute("cx") || 0),
          cy: parseFloat(e.getAttribute("cy") || 0),
          r: parseFloat(e.getAttribute("r") || 0)
        }), n;
      },
      line: function line(e, t) {
        var n = new u();
        return E(t, n), P(e, n, this._defs), n.setShape({
          x1: parseFloat(e.getAttribute("x1") || 0),
          y1: parseFloat(e.getAttribute("y1") || 0),
          x2: parseFloat(e.getAttribute("x2") || 0),
          y2: parseFloat(e.getAttribute("y2") || 0)
        }), n;
      },
      ellipse: function ellipse(e, t) {
        var n = new l();
        return E(t, n), P(e, n, this._defs), n.setShape({
          cx: parseFloat(e.getAttribute("cx") || 0),
          cy: parseFloat(e.getAttribute("cy") || 0),
          rx: parseFloat(e.getAttribute("rx") || 0),
          ry: parseFloat(e.getAttribute("ry") || 0)
        }), n;
      },
      polygon: function polygon(e, t) {
        var n = e.getAttribute("points");
        n && (n = A(n));
        var i = new h({
          shape: {
            points: n || []
          }
        });
        return E(t, i), P(e, i, this._defs), i;
      },
      polyline: function polyline(e, t) {
        var n = new c();
        E(t, n), P(e, n, this._defs);
        var i = e.getAttribute("points");
        return i && (i = A(i)), new d({
          shape: {
            points: i || []
          }
        });
      },
      image: function image(e, t) {
        var n = new r();
        return E(t, n), P(e, n, this._defs), n.setStyle({
          image: e.getAttribute("xlink:href"),
          x: e.getAttribute("x"),
          y: e.getAttribute("y"),
          width: e.getAttribute("width"),
          height: e.getAttribute("height")
        }), n;
      },
      text: function text(e, t) {
        var n = e.getAttribute("x") || 0,
            r = e.getAttribute("y") || 0,
            o = e.getAttribute("dx") || 0,
            a = e.getAttribute("dy") || 0;
        this._textX = parseFloat(n) + parseFloat(o), this._textY = parseFloat(r) + parseFloat(a);
        var s = new i();
        return E(t, s), P(e, s, this._defs), s;
      },
      tspan: function tspan(e, t) {
        var n = e.getAttribute("x"),
            r = e.getAttribute("y");
        null != n && (this._textX = parseFloat(n)), null != r && (this._textY = parseFloat(r));
        var o = e.getAttribute("dx") || 0,
            a = e.getAttribute("dy") || 0,
            s = new i();
        return E(t, s), P(e, s, this._defs), this._textX += o, this._textY += a, s;
      },
      path: function path(e, t) {
        var n = e.getAttribute("d") || "",
            i = v(n);
        return E(t, i), P(e, i, this._defs), i;
      }
    },
        M = {
      lineargradient: function lineargradient(e) {
        var t = parseInt(e.getAttribute("x1") || 0, 10),
            n = parseInt(e.getAttribute("y1") || 0, 10),
            i = parseInt(e.getAttribute("x2") || 10, 10),
            r = parseInt(e.getAttribute("y2") || 0, 10),
            o = new f(t, n, i, r);
        return function (e, t) {
          var n = e.firstChild;

          for (; n;) {
            if (1 === n.nodeType) {
              var i = n.getAttribute("offset");
              i = i.indexOf("%") > 0 ? parseInt(i, 10) / 100 : i ? parseFloat(i) : 0;
              var r = n.getAttribute("stop-color") || "#000000";
              t.addColorStop(i, r);
            }

            n = n.nextSibling;
          }
        }(e, o), o;
      },
      radialgradient: function radialgradient(e) {}
    };

    function E(e, t) {
      e && e.__inheritedStyle && (t.__inheritedStyle || (t.__inheritedStyle = {}), _(t.__inheritedStyle, e.__inheritedStyle));
    }

    function A(e) {
      for (var t = b(e).split(S), n = [], i = 0; i < t.length; i += 2) {
        var r = parseFloat(t[i]),
            o = parseFloat(t[i + 1]);
        n.push([r, o]);
      }

      return n;
    }

    var I = {
      fill: "fill",
      stroke: "stroke",
      "stroke-width": "lineWidth",
      opacity: "opacity",
      "fill-opacity": "fillOpacity",
      "stroke-opacity": "strokeOpacity",
      "stroke-dasharray": "lineDash",
      "stroke-dashoffset": "lineDashOffset",
      "stroke-linecap": "lineCap",
      "stroke-linejoin": "lineJoin",
      "stroke-miterlimit": "miterLimit",
      "font-family": "fontFamily",
      "font-size": "fontSize",
      "font-style": "fontStyle",
      "font-weight": "fontWeight",
      "text-align": "textAlign",
      "alignment-baseline": "textBaseline"
    };

    function P(e, t, n, i) {
      var r = t.__inheritedStyle || {},
          o = "text" === t.type;
      if (1 === e.nodeType && (function (e, t) {
        var n = e.getAttribute("transform");

        if (n) {
          n = n.replace(/,/g, " ");
          var i = null,
              r = [];
          n.replace(D, function (e, t, n) {
            r.push(t, n);
          });

          for (var o = r.length - 1; o > 0; o -= 2) {
            var a = r[o],
                s = r[o - 1];

            switch (i = i || g.create(), s) {
              case "translate":
                a = b(a).split(S), g.translate(i, i, [parseFloat(a[0]), parseFloat(a[1] || 0)]);
                break;

              case "scale":
                a = b(a).split(S), g.scale(i, i, [parseFloat(a[0]), parseFloat(a[1] || a[0])]);
                break;

              case "rotate":
                a = b(a).split(S), g.rotate(i, i, parseFloat(a[0]));
                break;

              case "skew":
                a = b(a).split(S), console.warn("Skew transform is not supported yet");
                break;

              case "matrix":
                a = b(a).split(S);
                i[0] = parseFloat(a[0]), i[1] = parseFloat(a[1]), i[2] = parseFloat(a[2]), i[3] = parseFloat(a[3]), i[4] = parseFloat(a[4]), i[5] = parseFloat(a[5]);
            }
          }

          t.setLocalTransform(i);
        }
      }(e, t), x(r, function (e) {
        var t = e.getAttribute("style"),
            n = {};
        if (!t) return n;
        var i,
            r = {};
        N.lastIndex = 0;

        for (; null != (i = N.exec(t));) {
          r[i[1]] = i[2];
        }

        for (var o in I) {
          I.hasOwnProperty(o) && null != r[o] && (n[I[o]] = r[o]);
        }

        return n;
      }(e)), !i)) for (var a in I) {
        if (I.hasOwnProperty(a)) {
          var s = e.getAttribute(a);
          null != s && (r[I[a]] = s);
        }
      }
      var l = o ? "textFill" : "fill",
          u = o ? "textStroke" : "stroke";
      t.style = t.style || new p();
      var c = t.style;
      null != r.fill && c.set(l, L(r.fill, n)), null != r.stroke && c.set(u, L(r.stroke, n)), w(["lineWidth", "opacity", "fillOpacity", "strokeOpacity", "miterLimit", "fontSize"], function (e) {
        var t = "lineWidth" === e && o ? "textStrokeWidth" : e;
        null != r[e] && c.set(t, parseFloat(r[e]));
      }), r.textBaseline && "auto" !== r.textBaseline || (r.textBaseline = "alphabetic"), "alphabetic" === r.textBaseline && (r.textBaseline = "bottom"), "start" === r.textAlign && (r.textAlign = "left"), "end" === r.textAlign && (r.textAlign = "right"), w(["lineDashOffset", "lineCap", "lineJoin", "fontWeight", "fontFamily", "fontStyle", "textAlign", "textBaseline"], function (e) {
        null != r[e] && c.set(e, r[e]);
      }), r.lineDash && (t.style.lineDash = b(r.lineDash).split(S)), c[u] && "none" !== c[u] && (t[u] = !0), t.__inheritedStyle = r;
    }

    var O = /url\(\s*#(.*?)\)/;

    function L(e, t) {
      var n = t && e && e.match(O);
      return n ? t[b(n[1])] : e;
    }

    var D = /(translate|scale|rotate|skewX|skewY|matrix)\(([\-\s0-9\.e,]*)\)/g;
    var N = /([^\s:;]+)\s*:\s*([^:;]+)/g;

    function j(e, t, n) {
      var i = t / e.width,
          r = n / e.height,
          o = Math.min(i, r);
      return {
        scale: [o, o],
        position: [-(e.x + e.width / 2) * o + t / 2, -(e.y + e.height / 2) * o + n / 2]
      };
    }

    t.parseXML = T, t.makeViewBoxTransform = j, t.parseSVG = function (e, t) {
      return new C().parse(e, t);
    };
  }, function (e, t, n) {
    var i = n(152);
    t.zrender = i;
    var r = n(31);
    t.matrix = r;
    var o = n(16);
    t.vector = o;
    var a = n(1),
        s = n(53);
    t.color = s;
    var l = n(5),
        u = n(6);
    t.number = u;
    var c = n(15);
    t.format = c;
    var h = n(67);
    h.throttle;
    t.throttle = h.throttle;
    var d = n(686);
    t.helper = d;
    var f = n(316);
    t.parseGeoJSON = f;
    var p = n(39);
    t.List = p;
    var g = n(22);
    t.Model = g;
    var v = n(69);
    t.Axis = v;
    var m = n(21);
    t.env = m;
    var y = f,
        x = {};
    a.each(["map", "each", "filter", "indexOf", "inherits", "reduce", "filter", "bind", "curry", "isArray", "isString", "isObject", "isFunction", "extend", "defaults", "clone", "merge"], function (e) {
      x[e] = a[e];
    });
    var _ = {};
    a.each(["extendShape", "extendPath", "makePath", "makeImage", "mergePath", "resizePath", "createIcon", "setHoverStyle", "setLabelStyle", "setTextStyle", "setText", "getFont", "updateProps", "initProps", "getTransform", "clipPointsByRect", "clipRectByRect", "registerShape", "getShapeClass", "Group", "Image", "Text", "Circle", "Sector", "Ring", "Polygon", "Polyline", "Rect", "Line", "BezierCurve", "Arc", "IncrementalDisplayable", "CompoundPath", "LinearGradient", "RadialGradient", "BoundingRect"], function (e) {
      _[e] = l[e];
    }), t.parseGeoJson = y, t.util = x, t.graphic = _;
  }, function (e, t, n) {
    var i = n(1);

    var r = function r(e) {
      null != e && i.extend(this, e), this.otherDims = {};
    };

    e.exports = r;
  }, function (e, t, n) {
    var i = n(1),
        r = i.createHashMap,
        o = i.each,
        a = i.isString,
        s = i.defaults,
        l = i.extend,
        u = i.isObject,
        c = i.clone,
        h = n(8).normalizeToArray,
        d = n(61),
        f = d.guessOrdinal,
        p = d.BE_ORDINAL,
        g = n(122),
        v = n(124).OTHER_DIMENSIONS,
        m = n(311);

    function y(e, t, n) {
      if (n || null != t.get(e)) {
        for (var i = 0; null != t.get(e + i);) {
          i++;
        }

        e += i;
      }

      return t.set(e, !0), e;
    }

    var x = function x(e, t, n) {
      g.isInstance(t) || (t = g.seriesDataToSource(t)), n = n || {}, e = (e || []).slice();

      for (var i = (n.dimsDef || []).slice(), d = r(), x = r(), _ = [], b = function (e, t, n, i) {
        var r = Math.max(e.dimensionsDetectCount || 1, t.length, n.length, i || 0);
        return o(t, function (e) {
          var t = e.dimsDef;
          t && (r = Math.max(r, t.length));
        }), r;
      }(t, e, i, n.dimCount), w = 0; w < b; w++) {
        var S = i[w] = l({}, u(i[w]) ? i[w] : {
          name: i[w]
        }),
            T = S.name,
            C = _[w] = new m();
        null != T && null == d.get(T) && (C.name = C.displayName = T, d.set(T, w)), null != S.type && (C.type = S.type), null != S.displayName && (C.displayName = S.displayName);
      }

      var k = n.encodeDef;
      !k && n.encodeDefaulter && (k = n.encodeDefaulter(t, b)), (k = r(k)).each(function (e, t) {
        if (1 === (e = h(e).slice()).length && !a(e[0]) && e[0] < 0) k.set(t, !1);else {
          var n = k.set(t, []);
          o(e, function (e, i) {
            a(e) && (e = d.get(e)), null != e && e < b && (n[i] = e, E(_[e], t, i));
          });
        }
      });
      var M = 0;

      function E(e, t, n) {
        null != v.get(t) ? e.otherDims[t] = n : (e.coordDim = t, e.coordDimIndex = n, x.set(t, !0));
      }

      o(e, function (e, t) {
        var n, i, r;
        if (a(e)) n = e, e = {};else {
          n = e.name;
          var l = e.ordinalMeta;
          e.ordinalMeta = null, (e = c(e)).ordinalMeta = l, i = e.dimsDef, r = e.otherDims, e.name = e.coordDim = e.coordDimIndex = e.dimsDef = e.otherDims = null;
        }

        if (!1 !== (d = k.get(n))) {
          var d;
          if (!(d = h(d)).length) for (var f = 0; f < (i && i.length || 1); f++) {
            for (; M < _.length && null != _[M].coordDim;) {
              M++;
            }

            M < _.length && d.push(M++);
          }
          o(d, function (t, o) {
            var a = _[t];

            if (E(s(a, e), n, o), null == a.name && i) {
              var l = i[o];
              !u(l) && (l = {
                name: l
              }), a.name = a.displayName = l.name, a.defaultTooltip = l.defaultTooltip;
            }

            r && s(a.otherDims, r);
          });
        }
      });
      var A = n.generateCoord,
          I = n.generateCoordCount,
          P = null != I;
      I = A ? I || 1 : 0;

      for (var O = A || "value", L = 0; L < b; L++) {
        null == (C = _[L] = _[L] || new m()).coordDim && (C.coordDim = y(O, x, P), C.coordDimIndex = 0, (!A || I <= 0) && (C.isExtraCoord = !0), I--), null == C.name && (C.name = y(C.coordDim, d)), null != C.type || f(t, L, C.name) !== p.Must && (!C.isExtraCoord || null == C.otherDims.itemName && null == C.otherDims.seriesName) || (C.type = "ordinal");
      }

      return _;
    };

    e.exports = x;
  }, function (e, t, n) {
    var i = n(1),
        r = i.createHashMap,
        o = i.isObject,
        a = i.map;

    function s(e) {
      this.categories = e.categories || [], this._needCollect = e.needCollect, this._deduplication = e.deduplication, this._map;
    }

    s.createByAxisModel = function (e) {
      var t = e.option,
          n = t.data,
          i = n && a(n, c);
      return new s({
        categories: i,
        needCollect: !i,
        deduplication: !1 !== t.dedplication
      });
    };

    var l = s.prototype;

    function u(e) {
      return e._map || (e._map = r(e.categories));
    }

    function c(e) {
      return o(e) && null != e.value ? e.value : e + "";
    }

    l.getOrdinal = function (e) {
      return u(this).get(e);
    }, l.parseAndCollect = function (e) {
      var t,
          n = this._needCollect;
      if ("string" != typeof e && !n) return e;
      if (n && !this._deduplication) return t = this.categories.length, this.categories[t] = e, t;
      var i = u(this);
      return null == (t = i.get(e)) && (n ? (t = this.categories.length, this.categories[t] = e, i.set(e, t)) : t = NaN), t;
    };
    var h = s;
    e.exports = h;
  }, function (e, t, n) {
    var i = n(6),
        r = i.round;

    function o(e) {
      return i.getPrecisionSafe(e) + 2;
    }

    function a(e, t, n) {
      e[t] = Math.max(Math.min(e[t], n[1]), n[0]);
    }

    function s(e, t) {
      !isFinite(e[0]) && (e[0] = t[0]), !isFinite(e[1]) && (e[1] = t[1]), a(e, 0, t), a(e, 1, t), e[0] > e[1] && (e[0] = e[1]);
    }

    t.intervalScaleNiceTicks = function (e, t, n, a) {
      var l = {},
          u = e[1] - e[0],
          c = l.interval = i.nice(u / t, !0);
      null != n && c < n && (c = l.interval = n), null != a && c > a && (c = l.interval = a);
      var h = l.intervalPrecision = o(c);
      return s(l.niceTickExtent = [r(Math.ceil(e[0] / c) * c, h), r(Math.floor(e[1] / c) * c, h)], e), l;
    }, t.getIntervalPrecision = o, t.fixExtent = s;
  }, function (e, t, n) {
    var i = n(1),
        r = n(159),
        o = n(6),
        a = n(160),
        s = r.prototype,
        l = a.prototype,
        u = o.getPrecisionSafe,
        c = o.round,
        h = Math.floor,
        d = Math.ceil,
        f = Math.pow,
        p = Math.log,
        g = r.extend({
      type: "log",
      base: 10,
      $constructor: function $constructor() {
        r.apply(this, arguments), this._originalScale = new a();
      },
      getTicks: function getTicks(e) {
        var t = this._originalScale,
            n = this._extent,
            r = t.getExtent();
        return i.map(l.getTicks.call(this, e), function (e) {
          var i = o.round(f(this.base, e));
          return i = e === n[0] && t.__fixMin ? v(i, r[0]) : i, i = e === n[1] && t.__fixMax ? v(i, r[1]) : i;
        }, this);
      },
      getMinorTicks: l.getMinorTicks,
      getLabel: l.getLabel,
      scale: function scale(e) {
        return e = s.scale.call(this, e), f(this.base, e);
      },
      setExtent: function setExtent(e, t) {
        var n = this.base;
        e = p(e) / p(n), t = p(t) / p(n), l.setExtent.call(this, e, t);
      },
      getExtent: function getExtent() {
        var e = this.base,
            t = s.getExtent.call(this);
        t[0] = f(e, t[0]), t[1] = f(e, t[1]);
        var n = this._originalScale,
            i = n.getExtent();
        return n.__fixMin && (t[0] = v(t[0], i[0])), n.__fixMax && (t[1] = v(t[1], i[1])), t;
      },
      unionExtent: function unionExtent(e) {
        this._originalScale.unionExtent(e);

        var t = this.base;
        e[0] = p(e[0]) / p(t), e[1] = p(e[1]) / p(t), s.unionExtent.call(this, e);
      },
      unionExtentFromData: function unionExtentFromData(e, t) {
        this.unionExtent(e.getApproximateExtent(t));
      },
      niceTicks: function niceTicks(e) {
        e = e || 10;
        var t = this._extent,
            n = t[1] - t[0];

        if (!(n === 1 / 0 || n <= 0)) {
          var i = o.quantity(n);

          for (e / n * i <= .5 && (i *= 10); !isNaN(i) && Math.abs(i) < 1 && Math.abs(i) > 0;) {
            i *= 10;
          }

          var r = [o.round(d(t[0] / i) * i), o.round(h(t[1] / i) * i)];
          this._interval = i, this._niceExtent = r;
        }
      },
      niceExtent: function niceExtent(e) {
        l.niceExtent.call(this, e);
        var t = this._originalScale;
        t.__fixMin = e.fixMin, t.__fixMax = e.fixMax;
      }
    });

    function v(e, t) {
      return c(e, u(t));
    }

    i.each(["contain", "normalize"], function (e) {
      g.prototype[e] = function (t) {
        return t = p(t) / p(this.base), s[e].call(this, t);
      };
    }), g.create = function () {
      return new g();
    };
    var m = g;
    e.exports = m;
  }, function (e, t, n) {
    var i = n(1),
        r = n(317);

    function o(e, t, n) {
      for (var i = [], r = t[0], o = t[1], a = 0; a < e.length; a += 2) {
        var s = e.charCodeAt(a) - 64,
            l = e.charCodeAt(a + 1) - 64;
        s = s >> 1 ^ -(1 & s), l = l >> 1 ^ -(1 & l), r = s += r, o = l += o, i.push([s / n, l / n]);
      }

      return i;
    }

    e.exports = function (e, t) {
      return function (e) {
        if (!e.UTF8Encoding) return e;
        var t = e.UTF8Scale;
        null == t && (t = 1024);

        for (var n = e.features, i = 0; i < n.length; i++) {
          for (var r = n[i].geometry, a = r.coordinates, s = r.encodeOffsets, l = 0; l < a.length; l++) {
            var u = a[l];
            if ("Polygon" === r.type) a[l] = o(u, s[l], t);else if ("MultiPolygon" === r.type) for (var c = 0; c < u.length; c++) {
              var h = u[c];
              u[c] = o(h, s[l][c], t);
            }
          }
        }

        e.UTF8Encoding = !1;
      }(e), i.map(i.filter(e.features, function (e) {
        return e.geometry && e.properties && e.geometry.coordinates.length > 0;
      }), function (e) {
        var n = e.properties,
            o = e.geometry,
            a = o.coordinates,
            s = [];
        "Polygon" === o.type && s.push({
          type: "polygon",
          exterior: a[0],
          interiors: a.slice(1)
        }), "MultiPolygon" === o.type && i.each(a, function (e) {
          e[0] && s.push({
            type: "polygon",
            exterior: e[0],
            interiors: e.slice(1)
          });
        });
        var l = new r(n[t || "name"], s, n.cp);
        return l.properties = n, l;
      });
    };
  }, function (e, t, n) {
    var i = n(17),
        r = n(120),
        o = n(16),
        a = n(318);

    function s(e, t, n) {
      if (this.name = e, this.geometries = t, n) n = [n[0], n[1]];else {
        var i = this.getBoundingRect();
        n = [i.x + i.width / 2, i.y + i.height / 2];
      }
      this.center = n;
    }

    s.prototype = {
      constructor: s,
      properties: null,
      getBoundingRect: function getBoundingRect() {
        var e = this._rect;
        if (e) return e;

        for (var t = Number.MAX_VALUE, n = [t, t], a = [-t, -t], s = [], l = [], u = this.geometries, c = 0; c < u.length; c++) {
          if ("polygon" === u[c].type) {
            var h = u[c].exterior;
            r.fromPoints(h, s, l), o.min(n, n, s), o.max(a, a, l);
          }
        }

        return 0 === c && (n[0] = n[1] = a[0] = a[1] = 0), this._rect = new i(n[0], n[1], a[0] - n[0], a[1] - n[1]);
      },
      contain: function contain(e) {
        var t = this.getBoundingRect(),
            n = this.geometries;
        if (!t.contain(e[0], e[1])) return !1;

        e: for (var i = 0, r = n.length; i < r; i++) {
          if ("polygon" === n[i].type) {
            var o = n[i].exterior,
                s = n[i].interiors;

            if (a.contain(o, e[0], e[1])) {
              for (var l = 0; l < (s ? s.length : 0); l++) {
                if (a.contain(s[l])) continue e;
              }

              return !0;
            }
          }
        }

        return !1;
      },
      transformTo: function transformTo(e, t, n, r) {
        var a = this.getBoundingRect(),
            s = a.width / a.height;
        n ? r || (r = n / s) : n = s * r;

        for (var l = new i(e, t, n, r), u = a.calculateTransform(l), c = this.geometries, h = 0; h < c.length; h++) {
          if ("polygon" === c[h].type) {
            for (var d = c[h].exterior, f = c[h].interiors, p = 0; p < d.length; p++) {
              o.applyTransform(d[p], d[p], u);
            }

            for (var g = 0; g < (f ? f.length : 0); g++) {
              for (p = 0; p < f[g].length; p++) {
                o.applyTransform(f[g][p], f[g][p], u);
              }
            }
          }
        }

        (a = this._rect).copy(l), this.center = [a.x + a.width / 2, a.y + a.height / 2];
      },
      cloneShallow: function cloneShallow(e) {
        null == e && (e = this.name);
        var t = new s(e, this.geometries, this.center);
        return t._rect = this._rect, t.transformTo = null, t;
      }
    };
    var l = s;
    e.exports = l;
  }, function (e, t, n) {
    var i = n(299);

    function r(e, t) {
      return Math.abs(e - t) < 1e-8;
    }

    t.contain = function (e, t, n) {
      var o = 0,
          a = e[0];
      if (!a) return !1;

      for (var s = 1; s < e.length; s++) {
        var l = e[s];
        o += i(a[0], a[1], l[0], l[1], t, n), a = l;
      }

      var u = e[0];
      return r(a[0], u[0]) && r(a[1], u[1]) || (o += i(a[0], a[1], u[0], u[1], t, n)), 0 !== o;
    };
  }, function (e, t, n) {
    var i = n(55).isDimensionStacked,
        r = n(1).map;
    t.prepareDataCoordInfo = function (e, t, n) {
      var o,
          a = e.getBaseAxis(),
          s = e.getOtherAxis(a),
          l = function (e, t) {
        var n = 0,
            i = e.scale.getExtent();
        "start" === t ? n = i[0] : "end" === t ? n = i[1] : i[0] > 0 ? n = i[0] : i[1] < 0 && (n = i[1]);
        return n;
      }(s, n),
          u = a.dim,
          c = s.dim,
          h = t.mapDimension(c),
          d = t.mapDimension(u),
          f = "x" === c || "radius" === c ? 1 : 0,
          p = r(e.dimensions, function (e) {
        return t.mapDimension(e);
      }),
          g = t.getCalculationInfo("stackResultDimension");

      return (o |= i(t, p[0])) && (p[0] = g), (o |= i(t, p[1])) && (p[1] = g), {
        dataDimsForPoint: p,
        valueStart: l,
        valueAxisDim: c,
        baseAxisDim: u,
        stacked: !!o,
        valueDim: h,
        baseDim: d,
        baseDataOffset: f,
        stackedOverDimension: t.getCalculationInfo("stackedOverDimension")
      };
    }, t.getStackedOnPoint = function (e, t, n, i) {
      var r = NaN;
      e.stacked && (r = n.get(n.getCalculationInfo("stackedOverDimension"), i)), isNaN(r) && (r = e.valueStart);
      var o = e.baseDataOffset,
          a = [];
      return a[o] = n.get(e.baseDim, i), a[1 - o] = r, t.dataToPoint(a);
    };
  }, function (e, t, n) {
    var i = n(20),
        r = n(16),
        o = n(301),
        a = r.min,
        s = r.max,
        l = r.scaleAndAdd,
        u = r.copy,
        c = [],
        h = [],
        d = [];

    function f(e) {
      return isNaN(e[0]) || isNaN(e[1]);
    }

    function p(e, t, n, i, r, o, a, s, l, u, c) {
      return "none" !== u && u ? g.apply(this, arguments) : v.apply(this, arguments);
    }

    function g(e, t, n, i, r, o, a, s, l, c, p) {
      for (var g = 0, v = n, m = 0; m < i; m++) {
        var y = t[v];
        if (v >= r || v < 0) break;

        if (f(y)) {
          if (p) {
            v += o;
            continue;
          }

          break;
        }

        if (v === n) e[o > 0 ? "moveTo" : "lineTo"](y[0], y[1]);else if (l > 0) {
          var x = t[g],
              _ = "y" === c ? 1 : 0,
              b = (y[_] - x[_]) * l;

          u(h, x), h[_] = x[_] + b, u(d, y), d[_] = y[_] - b, e.bezierCurveTo(h[0], h[1], d[0], d[1], y[0], y[1]);
        } else e.lineTo(y[0], y[1]);
        g = v, v += o;
      }

      return m;
    }

    function v(e, t, n, i, o, p, g, v, m, y, x) {
      for (var _ = 0, b = n, w = 0; w < i; w++) {
        var S = t[b];
        if (b >= o || b < 0) break;

        if (f(S)) {
          if (x) {
            b += p;
            continue;
          }

          break;
        }

        if (b === n) e[p > 0 ? "moveTo" : "lineTo"](S[0], S[1]), u(h, S);else if (m > 0) {
          var T = b + p,
              C = t[T];
          if (x) for (; C && f(t[T]);) {
            C = t[T += p];
          }
          var k = .5,
              M = t[_];
          if (!(C = t[T]) || f(C)) u(d, S);else {
            var E, A;

            if (f(C) && !x && (C = S), r.sub(c, C, M), "x" === y || "y" === y) {
              var I = "x" === y ? 0 : 1;
              E = Math.abs(S[I] - M[I]), A = Math.abs(S[I] - C[I]);
            } else E = r.dist(S, M), A = r.dist(S, C);

            l(d, S, c, -m * (1 - (k = A / (A + E))));
          }
          a(h, h, v), s(h, h, g), a(d, d, v), s(d, d, g), e.bezierCurveTo(h[0], h[1], d[0], d[1], S[0], S[1]), l(h, S, c, m * k);
        } else e.lineTo(S[0], S[1]);
        _ = b, b += p;
      }

      return w;
    }

    function m(e, t) {
      var n = [1 / 0, 1 / 0],
          i = [-1 / 0, -1 / 0];
      if (t) for (var r = 0; r < e.length; r++) {
        var o = e[r];
        o[0] < n[0] && (n[0] = o[0]), o[1] < n[1] && (n[1] = o[1]), o[0] > i[0] && (i[0] = o[0]), o[1] > i[1] && (i[1] = o[1]);
      }
      return {
        min: t ? n : i,
        max: t ? i : n
      };
    }

    var y = i.extend({
      type: "ec-polyline",
      shape: {
        points: [],
        smooth: 0,
        smoothConstraint: !0,
        smoothMonotone: null,
        connectNulls: !1
      },
      style: {
        fill: null,
        stroke: "#000"
      },
      brush: o(i.prototype.brush),
      buildPath: function buildPath(e, t) {
        var n = t.points,
            i = 0,
            r = n.length,
            o = m(n, t.smoothConstraint);

        if (t.connectNulls) {
          for (; r > 0 && f(n[r - 1]); r--) {
            ;
          }

          for (; i < r && f(n[i]); i++) {
            ;
          }
        }

        for (; i < r;) {
          i += p(e, n, i, r, r, 1, o.min, o.max, t.smooth, t.smoothMonotone, t.connectNulls) + 1;
        }
      }
    }),
        x = i.extend({
      type: "ec-polygon",
      shape: {
        points: [],
        stackedOnPoints: [],
        smooth: 0,
        stackedOnSmooth: 0,
        smoothConstraint: !0,
        smoothMonotone: null,
        connectNulls: !1
      },
      brush: o(i.prototype.brush),
      buildPath: function buildPath(e, t) {
        var n = t.points,
            i = t.stackedOnPoints,
            r = 0,
            o = n.length,
            a = t.smoothMonotone,
            s = m(n, t.smoothConstraint),
            l = m(i, t.smoothConstraint);

        if (t.connectNulls) {
          for (; o > 0 && f(n[o - 1]); o--) {
            ;
          }

          for (; r < o && f(n[r]); r++) {
            ;
          }
        }

        for (; r < o;) {
          var u = p(e, n, r, o, o, 1, s.min, s.max, t.smooth, a, t.connectNulls);
          p(e, i, r + u - 1, u, o, -1, l.min, l.max, t.stackedOnSmooth, a, t.connectNulls), r += u + 1, e.closePath();
        }
      }
    });
    t.Polyline = y, t.Polygon = x;
  }, function (e, t, n) {
    var i = n(1),
        r = n(26),
        o = n(163),
        a = n(105),
        s = r.extend({
      type: "cartesian2dAxis",
      axis: null,
      init: function init() {
        s.superApply(this, "init", arguments), this.resetRange();
      },
      mergeOption: function mergeOption() {
        s.superApply(this, "mergeOption", arguments), this.resetRange();
      },
      restoreData: function restoreData() {
        s.superApply(this, "restoreData", arguments), this.resetRange();
      },
      getCoordSysModel: function getCoordSysModel() {
        return this.ecModel.queryComponents({
          mainType: "grid",
          index: this.option.gridIndex,
          id: this.option.gridId
        })[0];
      }
    });

    function l(e, t) {
      return t.type || (t.data ? "category" : "value");
    }

    i.merge(s.prototype, a);
    var u = {
      offset: 0
    };
    o("x", s, l, u), o("y", s, l, u);
    var c = s;
    e.exports = c;
  }, function (e, t, n) {
    var i = n(1),
        r = {
      show: !0,
      zlevel: 0,
      z: 0,
      inverse: !1,
      name: "",
      nameLocation: "end",
      nameRotate: null,
      nameTruncate: {
        maxWidth: null,
        ellipsis: "...",
        placeholder: "."
      },
      nameTextStyle: {},
      nameGap: 15,
      silent: !1,
      triggerEvent: !1,
      tooltip: {
        show: !1
      },
      axisPointer: {},
      axisLine: {
        show: !0,
        onZero: !0,
        onZeroAxisIndex: null,
        lineStyle: {
          color: "#333",
          width: 1,
          type: "solid"
        },
        symbol: ["none", "none"],
        symbolSize: [10, 15]
      },
      axisTick: {
        show: !0,
        inside: !1,
        length: 5,
        lineStyle: {
          width: 1
        }
      },
      axisLabel: {
        show: !0,
        inside: !1,
        rotate: 0,
        showMinLabel: null,
        showMaxLabel: null,
        margin: 8,
        fontSize: 12
      },
      splitLine: {
        show: !0,
        lineStyle: {
          color: ["#ccc"],
          width: 1,
          type: "solid"
        }
      },
      splitArea: {
        show: !1,
        areaStyle: {
          color: ["rgba(250,250,250,0.3)", "rgba(200,200,200,0.3)"]
        }
      }
    },
        o = {};
    o.categoryAxis = i.merge({
      boundaryGap: !0,
      deduplication: null,
      splitLine: {
        show: !1
      },
      axisTick: {
        alignWithLabel: !1,
        interval: "auto"
      },
      axisLabel: {
        interval: "auto"
      }
    }, r), o.valueAxis = i.merge({
      boundaryGap: [0, 0],
      splitNumber: 5,
      minorTick: {
        show: !1,
        splitNumber: 5,
        length: 3,
        lineStyle: {}
      },
      minorSplitLine: {
        show: !1,
        lineStyle: {
          color: "#eee",
          width: 1
        }
      }
    }, r), o.timeAxis = i.defaults({
      scale: !0,
      min: "dataMin",
      max: "dataMax"
    }, o.valueAxis), o.logAxis = i.defaults({
      scale: !0,
      logBase: 10
    }, o.valueAxis);
    var a = o;
    e.exports = a;
  }, function (e, t, n) {
    var i = n(1);

    t.layout = function (e, t, n) {
      n = n || {};
      var r = e.coordinateSystem,
          o = t.axis,
          a = {},
          s = o.getAxesOnZeroOf()[0],
          l = o.position,
          u = s ? "onZero" : l,
          c = o.dim,
          h = r.getRect(),
          d = [h.x, h.x + h.width, h.y, h.y + h.height],
          f = {
        left: 0,
        right: 1,
        top: 0,
        bottom: 1,
        onZero: 2
      },
          p = t.get("offset") || 0,
          g = "x" === c ? [d[2] - p, d[3] + p] : [d[0] - p, d[1] + p];

      if (s) {
        var v = s.toGlobalCoord(s.dataToCoord(0));
        g[f.onZero] = Math.max(Math.min(v, g[1]), g[0]);
      }

      a.position = ["y" === c ? g[f[u]] : d[0], "x" === c ? g[f[u]] : d[3]], a.rotation = Math.PI / 2 * ("x" === c ? 0 : 1), a.labelDirection = a.tickDirection = a.nameDirection = {
        top: -1,
        bottom: 1,
        left: -1,
        right: 1
      }[l], a.labelOffset = s ? g[f[l]] - g[f.onZero] : 0, t.get("axisTick.inside") && (a.tickDirection = -a.tickDirection), i.retrieve(n.labelInside, t.get("axisLabel.inside")) && (a.labelDirection = -a.labelDirection);
      var m = t.get("axisLabel.rotate");
      return a.labelRotate = "top" === u ? -m : m, a.z2 = 1, a;
    };
  }, function (e, t, n) {
    var i = n(1),
        r = n(5);
    t.rectCoordAxisBuildSplitArea = function (e, t, n, o) {
      var a = n.axis;

      if (!a.scale.isBlank()) {
        var s = n.getModel("splitArea"),
            l = s.getModel("areaStyle"),
            u = l.get("color"),
            c = o.coordinateSystem.getRect(),
            h = a.getTicksCoords({
          tickModel: s,
          clamp: !0
        });

        if (h.length) {
          var d = u.length,
              f = e.__splitAreaColors,
              p = i.createHashMap(),
              g = 0;
          if (f) for (var v = 0; v < h.length; v++) {
            var m = f.get(h[v].tickValue);

            if (null != m) {
              g = (m + (d - 1) * v) % d;
              break;
            }
          }
          var y = a.toGlobalCoord(h[0].coord),
              x = l.getAreaStyle();
          u = i.isArray(u) ? u : [u];

          for (v = 1; v < h.length; v++) {
            var _,
                b,
                w,
                S,
                T = a.toGlobalCoord(h[v].coord);

            a.isHorizontal() ? (_ = y, b = c.y, w = T - _, S = c.height, y = _ + w) : (_ = c.x, b = y, w = c.width, y = b + (S = T - b));
            var C = h[v - 1].tickValue;
            null != C && p.set(C, g), t.add(new r.Rect({
              anid: null != C ? "area_" + C : null,
              shape: {
                x: _,
                y: b,
                width: w,
                height: S
              },
              style: i.defaults({
                fill: u[g]
              }, x),
              silent: !0
            })), g = (g + 1) % d;
          }

          e.__splitAreaColors = p;
        }
      }
    }, t.rectCoordAxisHandleRemove = function (e) {
      e.__splitAreaColors = null;
    };
  }, function (e, t, n) {
    var i = n(27),
        r = n(62),
        o = i.extend({
      type: "series.__base_bar__",
      getInitialData: function getInitialData(e, t) {
        return r(this.getSource(), this, {
          useEncodeDefaulter: !0
        });
      },
      getMarkerPosition: function getMarkerPosition(e) {
        var t = this.coordinateSystem;

        if (t) {
          var n = t.dataToPoint(t.clampData(e)),
              i = this.getData(),
              r = i.getLayout("offset"),
              o = i.getLayout("size");
          return n[t.getBaseAxis().isHorizontal() ? 0 : 1] += r + o / 2, n;
        }

        return [NaN, NaN];
      },
      defaultOption: {
        zlevel: 0,
        z: 2,
        coordinateSystem: "cartesian2d",
        legendHoverLink: !0,
        barMinHeight: 0,
        barMinAngle: 0,
        large: !1,
        largeThreshold: 400,
        progressive: 3e3,
        progressiveChunkMode: "mod",
        itemStyle: {},
        emphasis: {}
      }
    });
    e.exports = o;
  }, function (e, t, n) {
    var i = n(5),
        r = n(213).getDefaultLabel;

    function o(e, t) {
      "outside" === e.textPosition && (e.textPosition = t);
    }

    t.setLabel = function (e, t, n, a, s, l, u) {
      var c = n.getModel("label"),
          h = n.getModel("emphasis.label");
      i.setLabelStyle(e, t, c, h, {
        labelFetcher: s,
        labelDataIndex: l,
        defaultText: r(s.getData(), l),
        isRectText: !0,
        autoColor: a
      }), o(e), o(t);
    };
  }, function (e, t, n) {
    var i = n(4),
        r = n(1);

    e.exports = function (e, t) {
      r.each(t, function (t) {
        t.update = "updateView", i.registerAction(t, function (n, i) {
          var r = {};
          return i.eachComponent({
            mainType: "series",
            subType: e,
            query: n
          }, function (e) {
            e[t.method] && e[t.method](n.name, n.dataIndex);
            var i = e.getData();
            i.each(function (t) {
              var n = i.getName(t);
              r[n] = e.isSelected(n) || !1;
            });
          }), {
            name: n.name,
            selected: r,
            seriesId: n.seriesId
          };
        });
      });
    };
  }, function (e, t, n) {
    var i = n(1),
        r = n(131),
        o = n(216),
        a = n(167).onIrrelevantElement,
        s = n(5),
        l = n(166),
        u = n(121).getUID,
        c = n(153);

    function h(e) {
      var t = e.getItemStyle(),
          n = e.get("areaColor");
      return null != n && (t.fill = n), t;
    }

    function d(e, t) {
      t.eachChild(function (t) {
        i.each(t.__regions, function (n) {
          t.trigger(e.isSelected(n.name) ? "emphasis" : "normal");
        });
      });
    }

    function f(e, t) {
      var n = new s.Group();
      this.uid = u("ec_map_draw"), this._controller = new r(e.getZr()), this._controllerHost = {
        target: t ? n : null
      }, this.group = n, this._updateGroup = t, this._mouseDownFlag, this._mapName, this._initialized, n.add(this._regionsGroup = new s.Group()), n.add(this._backgroundGroup = new s.Group());
    }

    f.prototype = {
      constructor: f,
      draw: function draw(e, t, n, r, o) {
        var a = "geo" === e.mainType,
            l = e.getData && e.getData();
        a && t.eachComponent({
          mainType: "series",
          subType: "map"
        }, function (t) {
          l || t.getHostGeoModel() !== e || (l = t.getData());
        });
        var u = e.coordinateSystem;

        this._updateBackground(u);

        var f,
            p = this._regionsGroup,
            g = this.group,
            v = u.getTransformInfo(),
            m = !p.childAt(0) || o;
        if (m) g.transform = v.roamTransform, g.decomposeTransform(), g.dirty();else {
          var y = new c();
          y.transform = v.roamTransform, y.decomposeTransform();
          var x = {
            scale: y.scale,
            position: y.position
          };
          f = y.scale, s.updateProps(g, x, e);
        }
        var _ = v.rawScale,
            b = v.rawPosition;
        p.removeAll();
        var w = ["itemStyle"],
            S = ["emphasis", "itemStyle"],
            T = ["label"],
            C = ["emphasis", "label"],
            k = i.createHashMap();
        i.each(u.regions, function (t) {
          var n = k.get(t.name) || k.set(t.name, new s.Group()),
              r = new s.CompoundPath({
            segmentIgnoreThreshold: 1,
            shape: {
              paths: []
            }
          });
          n.add(r);
          var o,
              u = (R = e.getRegionModel(t.name) || e).getModel(w),
              c = R.getModel(S),
              d = h(u),
              v = h(c),
              y = R.getModel(T),
              x = R.getModel(C);

          if (l) {
            o = l.indexOfName(t.name);
            var M = l.getItemVisual(o, "color", !0);
            M && (d.fill = M);
          }

          var E = function E(e) {
            return [e[0] * _[0] + b[0], e[1] * _[1] + b[1]];
          };

          i.each(t.geometries, function (e) {
            if ("polygon" === e.type) {
              for (var t = [], n = 0; n < e.exterior.length; ++n) {
                t.push(E(e.exterior[n]));
              }

              r.shape.paths.push(new s.Polygon({
                segmentIgnoreThreshold: 1,
                shape: {
                  points: t
                }
              }));

              for (n = 0; n < (e.interiors ? e.interiors.length : 0); ++n) {
                for (var i = e.interiors[n], o = (t = [], 0); o < i.length; ++o) {
                  t.push(E(i[o]));
                }

                r.shape.paths.push(new s.Polygon({
                  segmentIgnoreThreshold: 1,
                  shape: {
                    points: t
                  }
                }));
              }
            }
          }), r.setStyle(d), r.style.strokeNoScale = !0, r.culling = !0;
          var A = y.get("show"),
              I = x.get("show"),
              P = l && isNaN(l.get(l.mapDimension("value"), o)),
              O = l && l.getItemLayout(o);

          if (a || P && (A || I) || O && O.showLabel) {
            var L,
                D = a ? t.name : o;
            (!l || o >= 0) && (L = e);
            var N = new s.Text({
              position: E(t.center.slice()),
              scale: [1 / g.scale[0], 1 / g.scale[1]],
              z2: 10,
              silent: !0
            });

            if (s.setLabelStyle(N.style, N.hoverStyle = {}, y, x, {
              labelFetcher: L,
              labelDataIndex: D,
              defaultText: t.name,
              useInsideStyle: !1
            }, {
              textAlign: "center",
              textVerticalAlign: "middle"
            }), !m) {
              var j = [1 / f[0], 1 / f[1]];
              s.updateProps(N, {
                scale: j
              }, e);
            }

            n.add(N);
          }

          if (l) l.setItemGraphicEl(o, n);else {
            var R = e.getRegionModel(t.name);
            r.eventData = {
              componentType: "geo",
              componentIndex: e.componentIndex,
              geoIndex: e.componentIndex,
              name: t.name,
              region: R && R.option || {}
            };
          }
          (n.__regions || (n.__regions = [])).push(t), n.highDownSilentOnTouch = !!e.get("selectedMode"), s.setHoverStyle(n, v), p.add(n);
        }), this._updateController(e, t, n), function (e, t, n, r, o) {
          n.off("click"), n.off("mousedown"), t.get("selectedMode") && (n.on("mousedown", function () {
            e._mouseDownFlag = !0;
          }), n.on("click", function (a) {
            if (e._mouseDownFlag) {
              e._mouseDownFlag = !1;

              for (var s = a.target; !s.__regions;) {
                s = s.parent;
              }

              if (s) {
                var l = {
                  type: ("geo" === t.mainType ? "geo" : "map") + "ToggleSelect",
                  batch: i.map(s.__regions, function (e) {
                    return {
                      name: e.name,
                      from: o.uid
                    };
                  })
                };
                l[t.mainType + "Id"] = t.id, r.dispatchAction(l), d(t, n);
              }
            }
          }));
        }(this, e, p, n, r), d(e, p);
      },
      remove: function remove() {
        this._regionsGroup.removeAll(), this._backgroundGroup.removeAll(), this._controller.dispose(), this._mapName && l.removeGraphic(this._mapName, this.uid), this._mapName = null, this._controllerHost = {};
      },
      _updateBackground: function _updateBackground(e) {
        var t = e.map;
        this._mapName !== t && i.each(l.makeGraphic(t, this.uid), function (e) {
          this._backgroundGroup.add(e);
        }, this), this._mapName = t;
      },
      _updateController: function _updateController(e, t, n) {
        var r = e.coordinateSystem,
            s = this._controller,
            l = this._controllerHost;
        l.zoomLimit = e.get("scaleLimit"), l.zoom = r.getZoom(), s.enable(e.get("roam") || !1);
        var u = e.mainType;

        function c() {
          var t = {
            type: "geoRoam",
            componentType: u
          };
          return t[u + "Id"] = e.id, t;
        }

        s.off("pan").on("pan", function (e) {
          this._mouseDownFlag = !1, o.updateViewOnPan(l, e.dx, e.dy), n.dispatchAction(i.extend(c(), {
            dx: e.dx,
            dy: e.dy
          }));
        }, this), s.off("zoom").on("zoom", function (e) {
          if (this._mouseDownFlag = !1, o.updateViewOnZoom(l, e.scale, e.originX, e.originY), n.dispatchAction(i.extend(c(), {
            zoom: e.scale,
            originX: e.originX,
            originY: e.originY
          })), this._updateGroup) {
            var t = this.group.scale;

            this._regionsGroup.traverse(function (e) {
              "text" === e.type && e.attr("scale", [1 / t[0], 1 / t[1]]);
            });
          }
        }, this), s.setPointerChecker(function (t, i, o) {
          return r.getViewRectAfterRoam().contain(i, o) && !a(t, n, e);
        });
      }
    };
    var p = f;
    e.exports = p;
  }, function (e, t, n) {
    var i = n(4),
        r = "\0_ec_interaction_mutex";

    function o(e) {
      return e[r] || (e[r] = {});
    }

    i.registerAction({
      type: "takeGlobalCursor",
      event: "globalCursorTaken",
      update: "update"
    }, function () {}), t.take = function (e, t, n) {
      o(e)[t] = n;
    }, t.release = function (e, t, n) {
      var i = o(e);
      i[t] === n && (i[t] = null);
    }, t.isTaken = function (e, t) {
      return !!o(e)[t];
    };
  }, function (e, t, n) {
    var i = n(4),
        r = n(1),
        o = n(217).updateCenterAndZoom;
    i.registerAction({
      type: "geoRoam",
      event: "geoRoam",
      update: "updateTransform"
    }, function (e, t) {
      var n = e.componentType || "series";
      t.eachComponent({
        mainType: n,
        query: e
      }, function (t) {
        var i = t.coordinateSystem;

        if ("geo" === i.type) {
          var a = o(i, e, t.get("scaleLimit"));
          t.setCenter && t.setCenter(a.center), t.setZoom && t.setZoom(a.zoom), "series" === n && r.each(t.seriesGroup, function (e) {
            e.setCenter(a.center), e.setZoom(a.zoom);
          });
        }
      });
    });
  }, function (e, t, n) {
    var i = n(1),
        r = i.each,
        o = "\0__link_datas",
        a = "\0__link_mainData";

    function s(e, t) {
      if ((r = this)[a] === r) {
        var n = i.extend({}, this[o]);
        n[this.dataType] = t, h(t, n, e);
      } else d(t, this.dataType, this[a], e);

      var r;
      return t;
    }

    function l(e, t) {
      return e.struct && e.struct.update(this), t;
    }

    function u(e, t) {
      return r(t[o], function (n, i) {
        n !== t && d(n.cloneShallow(), i, t, e);
      }), t;
    }

    function c(e) {
      var t = this[a];
      return null == e || null == t ? t : t[o][e];
    }

    function h(e, t, n) {
      e[o] = {}, r(t, function (t, i) {
        d(t, i, e, n);
      });
    }

    function d(e, t, n, i) {
      n[o][t] = e, e[a] = n, e.dataType = t, i.struct && (e[i.structAttr] = i.struct, i.struct[i.datasAttr[t]] = e), e.getLinkedData = c;
    }

    var f = function f(e) {
      var t = e.mainData,
          n = e.datas;
      n || (n = {
        main: t
      }, e.datasAttr = {
        main: "data"
      }), e.datas = e.mainData = null, h(t, n, e), r(n, function (n) {
        r(t.TRANSFERABLE_METHODS, function (t) {
          n.wrapMethod(t, i.curry(s, e));
        });
      }), t.wrapMethod("cloneShallow", i.curry(u, e)), r(t.CHANGABLE_METHODS, function (n) {
        t.wrapMethod(n, i.curry(l, e));
      }), i.assert(n[t.dataType] === t);
    };

    e.exports = f;
  }, function (e, t, n) {
    var i = n(14);

    function r(e) {
      var t = e.children;
      return t.length && e.isExpand ? t[t.length - 1] : e.hierNode.thread;
    }

    function o(e) {
      var t = e.children;
      return t.length && e.isExpand ? t[0] : e.hierNode.thread;
    }

    function a(e, t, n) {
      return e.hierNode.ancestor.parentNode === t.parentNode ? e.hierNode.ancestor : n;
    }

    function s(e, t, n) {
      var i = n / (t.hierNode.i - e.hierNode.i);
      t.hierNode.change -= i, t.hierNode.shift += n, t.hierNode.modifier += n, t.hierNode.prelim += n, e.hierNode.change += i;
    }

    function l(e, t) {
      return e.parentNode === t.parentNode ? 1 : 2;
    }

    t.init = function (e) {
      e.hierNode = {
        defaultAncestor: null,
        ancestor: e,
        prelim: 0,
        modifier: 0,
        change: 0,
        shift: 0,
        i: 0,
        thread: null
      };

      for (var t, n, i = [e]; t = i.pop();) {
        if (n = t.children, t.isExpand && n.length) for (var r = n.length - 1; r >= 0; r--) {
          var o = n[r];
          o.hierNode = {
            defaultAncestor: null,
            ancestor: o,
            prelim: 0,
            modifier: 0,
            change: 0,
            shift: 0,
            i: r,
            thread: null
          }, i.push(o);
        }
      }
    }, t.firstWalk = function (e, t) {
      var n = e.isExpand ? e.children : [],
          i = e.parentNode.children,
          l = e.hierNode.i ? i[e.hierNode.i - 1] : null;

      if (n.length) {
        !function (e) {
          var t = e.children,
              n = t.length,
              i = 0,
              r = 0;

          for (; --n >= 0;) {
            var o = t[n];
            o.hierNode.prelim += i, o.hierNode.modifier += i, r += o.hierNode.change, i += o.hierNode.shift + r;
          }
        }(e);
        var u = (n[0].hierNode.prelim + n[n.length - 1].hierNode.prelim) / 2;
        l ? (e.hierNode.prelim = l.hierNode.prelim + t(e, l), e.hierNode.modifier = e.hierNode.prelim - u) : e.hierNode.prelim = u;
      } else l && (e.hierNode.prelim = l.hierNode.prelim + t(e, l));

      e.parentNode.hierNode.defaultAncestor = function (e, t, n, i) {
        if (t) {
          for (var l = e, u = e, c = u.parentNode.children[0], h = t, d = l.hierNode.modifier, f = u.hierNode.modifier, p = c.hierNode.modifier, g = h.hierNode.modifier; h = r(h), u = o(u), h && u;) {
            l = r(l), c = o(c), l.hierNode.ancestor = e;
            var v = h.hierNode.prelim + g - u.hierNode.prelim - f + i(h, u);
            v > 0 && (s(a(h, e, n), e, v), f += v, d += v), g += h.hierNode.modifier, f += u.hierNode.modifier, d += l.hierNode.modifier, p += c.hierNode.modifier;
          }

          h && !r(l) && (l.hierNode.thread = h, l.hierNode.modifier += g - d), u && !o(c) && (c.hierNode.thread = u, c.hierNode.modifier += f - p, n = e);
        }

        return n;
      }(e, l, e.parentNode.hierNode.defaultAncestor || i[0], t);
    }, t.secondWalk = function (e) {
      var t = e.hierNode.prelim + e.parentNode.hierNode.modifier;
      e.setLayout({
        x: t
      }, !0), e.hierNode.modifier += e.parentNode.hierNode.modifier;
    }, t.separation = function (e) {
      return arguments.length ? e : l;
    }, t.radialCoordinate = function (e, t) {
      var n = {};
      return e -= Math.PI / 2, n.x = t * Math.cos(e), n.y = t * Math.sin(e), n;
    }, t.getViewRect = function (e, t) {
      return i.getLayoutRect(e.getBoxLayoutParams(), {
        width: t.getWidth(),
        height: t.getHeight()
      });
    };
  }, function (e, t, n) {
    var i = n(1),
        r = n(39),
        o = n(756),
        a = n(331),
        s = n(104),
        l = n(42),
        u = n(62);

    e.exports = function (e, t, n, c, h) {
      for (var d = new o(c), f = 0; f < e.length; f++) {
        d.addNode(i.retrieve(e[f].id, e[f].name, f), f);
      }

      var p = [],
          g = [],
          v = 0;

      for (f = 0; f < t.length; f++) {
        var m = t[f],
            y = m.source,
            x = m.target;
        d.addEdge(y, x, v) && (g.push(m), p.push(i.retrieve(m.id, y + " > " + x)), v++);
      }

      var _,
          b = n.get("coordinateSystem");

      if ("cartesian2d" === b || "polar" === b) _ = u(e, n);else {
        var w = l.get(b),
            S = w && "view" !== w.type && w.dimensions || [];
        i.indexOf(S, "value") < 0 && S.concat(["value"]);
        var T = s(e, {
          coordDimensions: S
        });

        (_ = new r(T, n)).initData(e);
      }
      var C = new r(["value"], n);
      return C.initData(g, p), h && h(_, C), a({
        mainData: _,
        struct: d,
        structAttr: "graph",
        datas: {
          node: _,
          edge: C
        },
        datasAttr: {
          node: "data",
          edge: "edgeData"
        }
      }), d.update(), d;
    };
  }, function (e, t, n) {
    var i = n(4);
    i.registerAction({
      type: "focusNodeAdjacency",
      event: "focusNodeAdjacency",
      update: "series:focusNodeAdjacency"
    }, function () {}), i.registerAction({
      type: "unfocusNodeAdjacency",
      event: "unfocusNodeAdjacency",
      update: "series:unfocusNodeAdjacency"
    }, function () {});
  }, function (e, t, n) {
    var i = n(16);

    function r(e) {
      e.eachEdge(function (e) {
        var t = e.getModel().get("lineStyle.curveness") || 0,
            n = i.clone(e.node1.getLayout()),
            r = i.clone(e.node2.getLayout()),
            o = [n, r];
        +t && o.push([(n[0] + r[0]) / 2 - (n[1] - r[1]) * t, (n[1] + r[1]) / 2 - (r[0] - n[0]) * t]), e.setLayout(o);
      });
    }

    t.simpleLayout = function (e) {
      var t = e.coordinateSystem;

      if (!t || "view" === t.type) {
        var n = e.getGraph();
        n.eachNode(function (e) {
          var t = e.getModel();
          e.setLayout([+t.get("x"), +t.get("y")]);
        }), r(n);
      }
    }, t.simpleLayoutEdge = r;
  }, function (e, t, n) {
    var i = n(16),
        r = n(223),
        o = r.getSymbolSize,
        a = r.getNodeGlobalScale,
        s = Math.PI,
        l = [];
    var u = {
      value: function value(e, t, n, i, r, o, a, s) {
        var l = 0,
            u = i.getSum("value"),
            c = 2 * Math.PI / (u || s);
        n.eachNode(function (e) {
          var t = e.getValue("value"),
              n = c * (u ? t : 1) / 2;
          l += n, e.setLayout([r * Math.cos(l) + o, r * Math.sin(l) + a]), l += n;
        });
      },
      symbolSize: function symbolSize(e, t, n, i, r, u, c, h) {
        var d = 0;
        l.length = h;
        var f = a(e);
        n.eachNode(function (e) {
          var t = o(e);
          isNaN(t) && (t = 2), t < 0 && (t = 0), t *= f;
          var n = Math.asin(t / 2 / r);
          isNaN(n) && (n = s / 2), l[e.dataIndex] = n, d += 2 * n;
        });
        var p = (2 * s - d) / h / 2,
            g = 0;
        n.eachNode(function (e) {
          var t = p + l[e.dataIndex];
          g += t, e.setLayout([r * Math.cos(g) + u, r * Math.sin(g) + c]), g += t;
        });
      }
    };

    t.circularLayout = function (e, t) {
      var n = e.coordinateSystem;

      if (!n || "view" === n.type) {
        var r = n.getBoundingRect(),
            o = e.getData(),
            a = o.graph,
            s = r.width / 2 + r.x,
            l = r.height / 2 + r.y,
            c = Math.min(r.width, r.height) / 2,
            h = o.count();
        o.setLayout({
          cx: s,
          cy: l
        }), h && (u[t](e, n, a, o, c, s, l, h), a.eachEdge(function (e) {
          var t,
              n = e.getModel().get("lineStyle.curveness") || 0,
              r = i.clone(e.node1.getLayout()),
              o = i.clone(e.node2.getLayout()),
              a = (r[0] + o[0]) / 2,
              u = (r[1] + o[1]) / 2;
          +n && (t = [s * (n *= 3) + a * (1 - n), l * n + u * (1 - n)]), e.setLayout([r, o, t]);
        }));
      }
    };
  }, function (e, t, n) {
    var i = n(4),
        r = n(1),
        o = n(67),
        a = n(778);
    n(338), n(781), n(783);
    i.extendComponentView({
      type: "parallel",
      render: function render(e, t, n) {
        this._model = e, this._api = n, this._handlers || (this._handlers = {}, r.each(s, function (e, t) {
          n.getZr().on(t, this._handlers[t] = r.bind(e, this));
        }, this)), o.createOrUpdate(this, "_throttledDispatchExpand", e.get("axisExpandRate"), "fixRate");
      },
      dispose: function dispose(e, t) {
        r.each(this._handlers, function (e, n) {
          t.getZr().off(n, e);
        }), this._handlers = null;
      },
      _throttledDispatchExpand: function _throttledDispatchExpand(e) {
        this._dispatchExpand(e);
      },
      _dispatchExpand: function _dispatchExpand(e) {
        e && this._api.dispatchAction(r.extend({
          type: "parallelAxisExpand"
        }, e));
      }
    });
    var s = {
      mousedown: function mousedown(e) {
        l(this, "click") && (this._mouseDownPoint = [e.offsetX, e.offsetY]);
      },
      mouseup: function mouseup(e) {
        var t = this._mouseDownPoint;

        if (l(this, "click") && t) {
          var n = [e.offsetX, e.offsetY];
          if (Math.pow(t[0] - n[0], 2) + Math.pow(t[1] - n[1], 2) > 5) return;

          var i = this._model.coordinateSystem.getSlidedAxisExpandWindow([e.offsetX, e.offsetY]);

          "none" !== i.behavior && this._dispatchExpand({
            axisExpandWindow: i.axisExpandWindow
          });
        }

        this._mouseDownPoint = null;
      },
      mousemove: function mousemove(e) {
        if (!this._mouseDownPoint && l(this, "mousemove")) {
          var t = this._model,
              n = t.coordinateSystem.getSlidedAxisExpandWindow([e.offsetX, e.offsetY]),
              i = n.behavior;
          "jump" === i && this._throttledDispatchExpand.debounceNextCall(t.get("axisExpandDebounce")), this._throttledDispatchExpand("none" === i ? null : {
            axisExpandWindow: n.axisExpandWindow,
            animation: "jump" === i && null
          });
        }
      }
    };

    function l(e, t) {
      var n = e._model;
      return n.get("axisExpandable") && n.get("axisExpandTriggerOn") === t;
    }

    i.registerPreprocessor(a);
  }, function (e, t, n) {
    var i = n(779);
    n(42).register("parallel", {
      create: function create(e, t) {
        var n = [];
        return e.eachComponent("parallel", function (r, o) {
          var a = new i(r, e, t);
          a.name = "parallel_" + o, a.resize(r, t), r.coordinateSystem = a, a.model = r, n.push(a);
        }), e.eachSeries(function (t) {
          if ("parallel" === t.get("coordinateSystem")) {
            var n = e.queryComponents({
              mainType: "parallel",
              index: t.get("parallelIndex"),
              id: t.get("parallelId")
            })[0];
            t.coordinateSystem = n.coordinateSystem;
          }
        }), n;
      }
    });
  }, function (e, t, n) {
    var i = n(17),
        r = n(167).onIrrelevantElement,
        o = n(5);

    function a(e) {
      return i.create(e);
    }

    t.makeRectPanelClipPath = function (e) {
      return e = a(e), function (t, n) {
        return o.clipPointsByRect(t, e);
      };
    }, t.makeLinearBrushOtherExtent = function (e, t) {
      return e = a(e), function (n) {
        var i = null != t ? t : n,
            r = i ? e.width : e.height,
            o = i ? e.x : e.y;
        return [o, o + (r || 0)];
      };
    }, t.makeRectIsTargetByCursor = function (e, t, n) {
      return e = a(e), function (i, o, a) {
        return e.contain(o[0], o[1]) && !r(i, t, n);
      };
    };
  }, function (e, t, n) {
    var i = n(106),
        r = n(1),
        o = n(124).getDimensionTypeByAxis,
        a = n(61).makeSeriesEncodeForAxisCoordSys,
        s = {
      _baseAxisDim: null,
      getInitialData: function getInitialData(e, t) {
        var n,
            s,
            l = t.getComponent("xAxis", this.get("xAxisIndex")),
            u = t.getComponent("yAxis", this.get("yAxisIndex")),
            c = l.get("type"),
            h = u.get("type");
        "category" === c ? (e.layout = "horizontal", n = l.getOrdinalMeta(), s = !0) : "category" === h ? (e.layout = "vertical", n = u.getOrdinalMeta(), s = !0) : e.layout = e.layout || "horizontal";
        var d = ["x", "y"],
            f = "horizontal" === e.layout ? 0 : 1,
            p = this._baseAxisDim = d[f],
            g = d[1 - f],
            v = [l, u],
            m = v[f].get("type"),
            y = v[1 - f].get("type"),
            x = e.data;

        if (x && s) {
          var _ = [];
          r.each(x, function (e, t) {
            var n;
            e.value && r.isArray(e.value) ? (n = e.value.slice(), e.value.unshift(t)) : r.isArray(e) ? (n = e.slice(), e.unshift(t)) : n = e, _.push(n);
          }), e.data = _;
        }

        var b = this.defaultValueDimensions,
            w = [{
          name: p,
          type: o(m),
          ordinalMeta: n,
          otherDims: {
            tooltip: !1,
            itemName: 0
          },
          dimsDef: ["base"]
        }, {
          name: g,
          type: o(y),
          dimsDef: b.slice()
        }];
        return i(this, {
          coordDimensions: w,
          dimensionsCount: b.length + 1,
          encodeDefaulter: r.curry(a, w, this)
        });
      },
      getBaseAxis: function getBaseAxis() {
        var e = this._baseAxisDim;
        return this.ecModel.getComponent(e + "Axis", this.get(e + "AxisIndex")).axis;
      }
    };
    t.seriesModelMixin = s;
  }, function (e, t, n) {
    var i = n(5),
        r = n(222),
        o = n(1),
        a = n(40).createSymbol,
        s = n(16),
        l = n(66);

    function u(e, t, n) {
      i.Group.call(this), this.add(this.createLine(e, t, n)), this._updateEffectSymbol(e, t);
    }

    var c = u.prototype;
    c.createLine = function (e, t, n) {
      return new r(e, t, n);
    }, c._updateEffectSymbol = function (e, t) {
      var n = e.getItemModel(t).getModel("effect"),
          i = n.get("symbolSize"),
          r = n.get("symbol");
      o.isArray(i) || (i = [i, i]);
      var s = n.get("color") || e.getItemVisual(t, "color"),
          l = this.childAt(1);
      this._symbolType !== r && (this.remove(l), (l = a(r, -.5, -.5, 1, 1, s)).z2 = 100, l.culling = !0, this.add(l)), l && (l.setStyle("shadowColor", s), l.setStyle(n.getItemStyle(["color"])), l.attr("scale", i), l.setColor(s), l.attr("scale", i), this._symbolType = r, this._symbolScale = i, this._updateEffectAnimation(e, n, t));
    }, c._updateEffectAnimation = function (e, t, n) {
      var i = this.childAt(1);

      if (i) {
        var r = this,
            a = e.getItemLayout(n),
            s = 1e3 * t.get("period"),
            l = t.get("loop"),
            u = t.get("constantSpeed"),
            c = o.retrieve(t.get("delay"), function (t) {
          return t / e.count() * s / 3;
        }),
            h = "function" == typeof c;

        if (i.ignore = !0, this.updateAnimationPoints(i, a), u > 0 && (s = this.getLineLength(i) / u * 1e3), s !== this._period || l !== this._loop) {
          i.stopAnimation();
          var d = c;
          h && (d = c(n)), i.__t > 0 && (d = -s * i.__t), i.__t = 0;
          var f = i.animate("", l).when(s, {
            __t: 1
          }).delay(d).during(function () {
            r.updateSymbolPosition(i);
          });
          l || f.done(function () {
            r.remove(i);
          }), f.start();
        }

        this._period = s, this._loop = l;
      }
    }, c.getLineLength = function (e) {
      return s.dist(e.__p1, e.__cp1) + s.dist(e.__cp1, e.__p2);
    }, c.updateAnimationPoints = function (e, t) {
      e.__p1 = t[0], e.__p2 = t[1], e.__cp1 = t[2] || [(t[0][0] + t[1][0]) / 2, (t[0][1] + t[1][1]) / 2];
    }, c.updateData = function (e, t, n) {
      this.childAt(0).updateData(e, t, n), this._updateEffectSymbol(e, t);
    }, c.updateSymbolPosition = function (e) {
      var t = e.__p1,
          n = e.__p2,
          i = e.__cp1,
          r = e.__t,
          o = e.position,
          a = [o[0], o[1]],
          u = l.quadraticAt,
          c = l.quadraticDerivativeAt;
      o[0] = u(t[0], i[0], n[0], r), o[1] = u(t[1], i[1], n[1], r);
      var h = c(t[0], i[0], n[0], r),
          d = c(t[1], i[1], n[1], r);
      if (e.rotation = -Math.atan2(d, h) - Math.PI / 2, "line" === this._symbolType || "rect" === this._symbolType || "roundRect" === this._symbolType) if (void 0 !== e.__lastT && e.__lastT < e.__t) {
        var f = 1.05 * s.dist(a, o);
        e.attr("scale", [e.scale[0], f]), 1 === r && (o[0] = a[0] + (o[0] - a[0]) / 2, o[1] = a[1] + (o[1] - a[1]) / 2);
      } else if (1 === e.__lastT) {
        f = 2 * s.dist(t, o);
        e.attr("scale", [e.scale[0], f]);
      } else e.attr("scale", this._symbolScale);
      e.__lastT = e.__t, e.ignore = !1;
    }, c.updateLayout = function (e, t) {
      this.childAt(0).updateLayout(e, t);
      var n = e.getItemModel(t).getModel("effect");

      this._updateEffectAnimation(e, n, t);
    }, o.inherits(u, i.Group);
    var h = u;
    e.exports = h;
  }, function (e, t, n) {
    var i = n(5),
        r = n(1);

    function o(e, t, n) {
      i.Group.call(this), this._createPolyline(e, t, n);
    }

    var a = o.prototype;
    a._createPolyline = function (e, t, n) {
      var r = e.getItemLayout(t),
          o = new i.Polyline({
        shape: {
          points: r
        }
      });
      this.add(o), this._updateCommonStl(e, t, n);
    }, a.updateData = function (e, t, n) {
      var r = e.hostModel,
          o = this.childAt(0),
          a = {
        shape: {
          points: e.getItemLayout(t)
        }
      };
      i.updateProps(o, a, r, t), this._updateCommonStl(e, t, n);
    }, a._updateCommonStl = function (e, t, n) {
      var o = this.childAt(0),
          a = e.getItemModel(t),
          s = e.getItemVisual(t, "color"),
          l = n && n.lineStyle,
          u = n && n.hoverLineStyle;
      n && !e.hasItemOption || (l = a.getModel("lineStyle").getLineStyle(), u = a.getModel("emphasis.lineStyle").getLineStyle()), o.useStyle(r.defaults({
        strokeNoScale: !0,
        fill: "none",
        stroke: s
      }, l)), o.hoverStyle = u, i.setHoverStyle(this);
    }, a.updateLayout = function (e, t) {
      this.childAt(0).setShape("points", e.getItemLayout(t));
    }, r.inherits(o, i.Group);
    var s = o;
    e.exports = s;
  }, function (e, t, n) {
    var i = {
      seriesType: "lines",
      plan: n(103)(),
      reset: function reset(e) {
        var t = e.coordinateSystem,
            n = e.get("polyline"),
            i = e.pipelineContext.large;
        return {
          progress: function progress(r, o) {
            var a = [];

            if (i) {
              var s,
                  l = r.end - r.start;

              if (n) {
                for (var u = 0, c = r.start; c < r.end; c++) {
                  u += e.getLineCoordsCount(c);
                }

                s = new Float32Array(l + 2 * u);
              } else s = new Float32Array(4 * l);

              var h = 0,
                  d = [];

              for (c = r.start; c < r.end; c++) {
                var f = e.getLineCoords(c, a);
                n && (s[h++] = f);

                for (var p = 0; p < f; p++) {
                  d = t.dataToPoint(a[p], !1, d), s[h++] = d[0], s[h++] = d[1];
                }
              }

              o.setLayout("linesPoints", s);
            } else for (c = r.start; c < r.end; c++) {
              var g = o.getItemModel(c),
                  v = (f = e.getLineCoords(c, a), []);
              if (n) for (var m = 0; m < f; m++) {
                v.push(t.dataToPoint(a[m]));
              } else {
                v[0] = t.dataToPoint(a[0]), v[1] = t.dataToPoint(a[1]);
                var y = g.get("lineStyle.curveness");
                +y && (v[2] = [(v[0][0] + v[1][0]) / 2 - (v[0][1] - v[1][1]) * y, (v[0][1] + v[1][1]) / 2 - (v[1][0] - v[0][0]) * y]);
              }
              o.setItemLayout(c, v);
            }
          }
        };
      }
    };
    e.exports = i;
  }, function (e, t, n) {
    var i = n(4);
    n(824), n(827), n(828), n(132), n(832), i.extendComponentView({
      type: "single"
    });
  }, function (e, t, n) {
    var i = n(1);

    t.layout = function (e, t) {
      t = t || {};
      var n = e.coordinateSystem,
          r = e.axis,
          o = {},
          a = r.position,
          s = r.orient,
          l = n.getRect(),
          u = [l.x, l.x + l.width, l.y, l.y + l.height],
          c = {
        horizontal: {
          top: u[2],
          bottom: u[3]
        },
        vertical: {
          left: u[0],
          right: u[1]
        }
      };
      o.position = ["vertical" === s ? c.vertical[a] : u[0], "horizontal" === s ? c.horizontal[a] : u[3]], o.rotation = Math.PI / 2 * {
        horizontal: 0,
        vertical: 1
      }[s], o.labelDirection = o.tickDirection = o.nameDirection = {
        top: -1,
        bottom: 1,
        right: 1,
        left: -1
      }[a], e.get("axisTick.inside") && (o.tickDirection = -o.tickDirection), i.retrieve(t.labelInside, e.get("axisLabel.inside")) && (o.labelDirection = -o.labelDirection);
      var h = t.rotate;
      return null == h && (h = e.get("axisLabel.rotate")), o.labelRotation = "top" === a ? -h : h, o.z2 = 1, o;
    };
  }, function (e, t, n) {
    var i = n(1),
        r = n(8);

    e.exports = function (e, t) {
      var n,
          o = [],
          a = e.seriesIndex;
      if (null == a || !(n = t.getSeriesByIndex(a))) return {
        point: []
      };
      var s = n.getData(),
          l = r.queryDataIndex(s, e);
      if (null == l || l < 0 || i.isArray(l)) return {
        point: []
      };
      var u = s.getItemGraphicEl(l),
          c = n.coordinateSystem;
      if (n.getTooltipPosition) o = n.getTooltipPosition(l) || [];else if (c && c.dataToPoint) o = c.dataToPoint(s.getValues(i.map(c.dimensions, function (e) {
        return s.mapDimension(e);
      }), l, !0)) || [];else if (u) {
        var h = u.getBoundingRect().clone();
        h.applyTransform(u.transform), o = [h.x + h.width / 2, h.y + h.height / 2];
      }
      return {
        point: o,
        el: u
      };
    };
  }, function (e, t, n) {
    var i = n(1),
        r = n(21),
        o = (0, n(8).makeInner)(),
        a = i.each;

    function s(e, t, n) {
      e.handler("leave", null, n);
    }

    function l(e, t, n, i) {
      t.handler(e, n, i);
    }

    t.register = function (e, t, n) {
      if (!r.node) {
        var u = t.getZr();
        o(u).records || (o(u).records = {}), function (e, t) {
          if (o(e).initialized) return;

          function n(n, i) {
            e.on(n, function (n) {
              var r = function (e) {
                var t = {
                  showTip: [],
                  hideTip: []
                },
                    n = function n(i) {
                  var r = t[i.type];
                  r ? r.push(i) : (i.dispatchAction = n, e.dispatchAction(i));
                };

                return {
                  dispatchAction: n,
                  pendings: t
                };
              }(t);

              a(o(e).records, function (e) {
                e && i(e, n, r.dispatchAction);
              }), function (e, t) {
                var n,
                    i = e.showTip.length,
                    r = e.hideTip.length;
                i ? n = e.showTip[i - 1] : r && (n = e.hideTip[r - 1]);
                n && (n.dispatchAction = null, t.dispatchAction(n));
              }(r.pendings, t);
            });
          }

          o(e).initialized = !0, n("click", i.curry(l, "click")), n("mousemove", i.curry(l, "mousemove")), n("globalout", s);
        }(u, t), (o(u).records[e] || (o(u).records[e] = {})).handler = n;
      }
    }, t.unregister = function (e, t) {
      if (!r.node) {
        var n = t.getZr();
        (o(n).records || {})[e] && (o(n).records[e] = null);
      }
    };
  }, function (e, t, n) {
    var i = n(225),
        r = n(168),
        o = n(323),
        a = n(89),
        s = i.extend({
      makeElOption: function makeElOption(e, t, n, i, a) {
        var s = n.axis,
            c = s.grid,
            h = i.get("type"),
            d = l(c, s).getOtherAxis(s).getGlobalExtent(),
            f = s.toGlobalCoord(s.dataToCoord(t, !0));

        if (h && "none" !== h) {
          var p = r.buildElStyle(i),
              g = u[h](s, f, d);
          g.style = p, e.graphicKey = g.type, e.pointer = g;
        }

        var v = o.layout(c.model, n);
        r.buildCartesianSingleLabelElOption(t, e, v, n, i, a);
      },
      getHandleTransform: function getHandleTransform(e, t, n) {
        var i = o.layout(t.axis.grid.model, t, {
          labelInside: !1
        });
        return i.labelMargin = n.get("handle.margin"), {
          position: r.getTransformedPosition(t.axis, e, i),
          rotation: i.rotation + (i.labelDirection < 0 ? Math.PI : 0)
        };
      },
      updateHandleTransform: function updateHandleTransform(e, t, n, i) {
        var r = n.axis,
            o = r.grid,
            a = r.getGlobalExtent(!0),
            s = l(o, r).getOtherAxis(r).getGlobalExtent(),
            u = "x" === r.dim ? 0 : 1,
            c = e.position;
        c[u] += t[u], c[u] = Math.min(a[1], c[u]), c[u] = Math.max(a[0], c[u]);
        var h = (s[1] + s[0]) / 2,
            d = [h, h];
        d[u] = c[u];
        return {
          position: c,
          rotation: e.rotation,
          cursorPoint: d,
          tooltipOption: [{
            verticalAlign: "middle"
          }, {
            align: "center"
          }][u]
        };
      }
    });

    function l(e, t) {
      var n = {};
      return n[t.dim + "AxisIndex"] = t.index, e.getCartesian(n);
    }

    var u = {
      line: function line(e, t, n) {
        return {
          type: "Line",
          subPixelOptimize: !0,
          shape: r.makeLineShape([t, n[0]], [t, n[1]], c(e))
        };
      },
      shadow: function shadow(e, t, n) {
        var i = Math.max(1, e.getBandWidth()),
            o = n[1] - n[0];
        return {
          type: "Rect",
          shape: r.makeRectShape([t - i / 2, n[0]], [i, o], c(e))
        };
      }
    };

    function c(e) {
      return "x" === e.dim ? 0 : 1;
    }

    a.registerAxisPointerClass("CartesianAxisPointer", s);
    var h = s;
    e.exports = h;
  }, function (e, t, n) {
    var i = n(14),
        r = i.getLayoutRect,
        o = i.box,
        a = i.positionElement,
        s = n(15),
        l = n(5);
    t.layout = function (e, t, n) {
      var i = t.getBoxLayoutParams(),
          s = t.get("padding"),
          l = {
        width: n.getWidth(),
        height: n.getHeight()
      },
          u = r(i, l, s);
      o(t.get("orient"), e, t.get("itemGap"), u.width, u.height), a(e, i, l, s);
    }, t.makeBackground = function (e, t) {
      var n = s.normalizeCssArray(t.get("padding")),
          i = t.getItemStyle(["color", "opacity"]);
      return i.fill = t.get("backgroundColor"), e = new l.Rect({
        shape: {
          x: e.x - n[3],
          y: e.y - n[0],
          width: e.width + n[1] + n[3],
          height: e.height + n[0] + n[2],
          r: t.get("borderRadius")
        },
        style: i,
        silent: !0,
        z2: -1
      });
    };
  }, function (e, t, n) {
    n(9).__DEV__;
    var i = n(1),
        r = n(5),
        o = n(8),
        a = n(339),
        s = i.each,
        l = i.indexOf,
        u = i.curry,
        c = ["dataToPoint", "pointToData"],
        h = ["grid", "xAxis", "yAxis", "geo", "graph", "polar", "radiusAxis", "angleAxis", "bmap"];

    function d(e, t, n) {
      var i = this._targetInfoList = [],
          r = {},
          o = g(t, e);
      s(v, function (e, t) {
        (!n || !n.include || l(n.include, t) >= 0) && e(o, i, r);
      });
    }

    var f = d.prototype;

    function p(e) {
      return e[0] > e[1] && e.reverse(), e;
    }

    function g(e, t) {
      return o.parseFinder(e, t, {
        includeMainTypes: h
      });
    }

    f.setOutputRanges = function (e, t) {
      this.matchOutputRanges(e, t, function (e, t, n) {
        if ((e.coordRanges || (e.coordRanges = [])).push(t), !e.coordRange) {
          e.coordRange = t;
          var i = x[e.brushType](0, n, t);
          e.__rangeOffset = {
            offset: b[e.brushType](i.values, e.range, [1, 1]),
            xyMinMax: i.xyMinMax
          };
        }
      });
    }, f.matchOutputRanges = function (e, t, n) {
      s(e, function (e) {
        var r = this.findTargetInfo(e, t);
        r && !0 !== r && i.each(r.coordSyses, function (i) {
          var r = x[e.brushType](1, i, e.range);
          n(e, r.values, i, t);
        });
      }, this);
    }, f.setInputRanges = function (e, t) {
      s(e, function (e) {
        var n,
            i,
            r,
            o,
            a,
            s = this.findTargetInfo(e, t);

        if (e.range = e.range || [], s && !0 !== s) {
          e.panelId = s.panelId;
          var l = x[e.brushType](0, s.coordSys, e.coordRange),
              u = e.__rangeOffset;
          e.range = u ? b[e.brushType](l.values, u.offset, (n = l.xyMinMax, i = u.xyMinMax, r = S(n), o = S(i), a = [r[0] / o[0], r[1] / o[1]], isNaN(a[0]) && (a[0] = 1), isNaN(a[1]) && (a[1] = 1), a)) : l.values;
        }
      }, this);
    }, f.makePanelOpts = function (e, t) {
      return i.map(this._targetInfoList, function (n) {
        var i = n.getPanelRect();
        return {
          panelId: n.panelId,
          defaultBrushType: t && t(n),
          clipPath: a.makeRectPanelClipPath(i),
          isTargetByCursor: a.makeRectIsTargetByCursor(i, e, n.coordSysModel),
          getLinearBrushOtherExtent: a.makeLinearBrushOtherExtent(i)
        };
      });
    }, f.controlSeries = function (e, t, n) {
      var i = this.findTargetInfo(e, n);
      return !0 === i || i && l(i.coordSyses, t.coordinateSystem) >= 0;
    }, f.findTargetInfo = function (e, t) {
      for (var n = this._targetInfoList, i = g(t, e), r = 0; r < n.length; r++) {
        var o = n[r],
            a = e.panelId;

        if (a) {
          if (o.panelId === a) return o;
        } else for (r = 0; r < m.length; r++) {
          if (m[r](i, o)) return o;
        }
      }

      return !0;
    };
    var v = {
      grid: function grid(e, t) {
        var n = e.xAxisModels,
            r = e.yAxisModels,
            o = e.gridModels,
            a = i.createHashMap(),
            u = {},
            c = {};
        (n || r || o) && (s(n, function (e) {
          var t = e.axis.grid.model;
          a.set(t.id, t), u[t.id] = !0;
        }), s(r, function (e) {
          var t = e.axis.grid.model;
          a.set(t.id, t), c[t.id] = !0;
        }), s(o, function (e) {
          a.set(e.id, e), u[e.id] = !0, c[e.id] = !0;
        }), a.each(function (e) {
          var i = e.coordinateSystem,
              o = [];
          s(i.getCartesians(), function (e, t) {
            (l(n, e.getAxis("x").model) >= 0 || l(r, e.getAxis("y").model) >= 0) && o.push(e);
          }), t.push({
            panelId: "grid--" + e.id,
            gridModel: e,
            coordSysModel: e,
            coordSys: o[0],
            coordSyses: o,
            getPanelRect: y.grid,
            xAxisDeclared: u[e.id],
            yAxisDeclared: c[e.id]
          });
        }));
      },
      geo: function geo(e, t) {
        s(e.geoModels, function (e) {
          var n = e.coordinateSystem;
          t.push({
            panelId: "geo--" + e.id,
            geoModel: e,
            coordSysModel: e,
            coordSys: n,
            coordSyses: [n],
            getPanelRect: y.geo
          });
        });
      }
    },
        m = [function (e, t) {
      var n = e.xAxisModel,
          i = e.yAxisModel,
          r = e.gridModel;
      return !r && n && (r = n.axis.grid.model), !r && i && (r = i.axis.grid.model), r && r === t.gridModel;
    }, function (e, t) {
      var n = e.geoModel;
      return n && n === t.geoModel;
    }],
        y = {
      grid: function grid() {
        return this.coordSys.grid.getRect().clone();
      },
      geo: function geo() {
        var e = this.coordSys,
            t = e.getBoundingRect().clone();
        return t.applyTransform(r.getTransform(e)), t;
      }
    },
        x = {
      lineX: u(_, 0),
      lineY: u(_, 1),
      rect: function rect(e, t, n) {
        var i = t[c[e]]([n[0][0], n[1][0]]),
            r = t[c[e]]([n[0][1], n[1][1]]),
            o = [p([i[0], r[0]]), p([i[1], r[1]])];
        return {
          values: o,
          xyMinMax: o
        };
      },
      polygon: function polygon(e, t, n) {
        var r = [[1 / 0, -1 / 0], [1 / 0, -1 / 0]];
        return {
          values: i.map(n, function (n) {
            var i = t[c[e]](n);
            return r[0][0] = Math.min(r[0][0], i[0]), r[1][0] = Math.min(r[1][0], i[1]), r[0][1] = Math.max(r[0][1], i[0]), r[1][1] = Math.max(r[1][1], i[1]), i;
          }),
          xyMinMax: r
        };
      }
    };

    function _(e, t, n, r) {
      var o = n.getAxis(["x", "y"][e]),
          a = p(i.map([0, 1], function (e) {
        return t ? o.coordToData(o.toLocalCoord(r[e])) : o.toGlobalCoord(o.dataToCoord(r[e]));
      })),
          s = [];
      return s[e] = a, s[1 - e] = [NaN, NaN], {
        values: a,
        xyMinMax: s
      };
    }

    var b = {
      lineX: u(w, 0),
      lineY: u(w, 1),
      rect: function rect(e, t, n) {
        return [[e[0][0] - n[0] * t[0][0], e[0][1] - n[0] * t[0][1]], [e[1][0] - n[1] * t[1][0], e[1][1] - n[1] * t[1][1]]];
      },
      polygon: function polygon(e, t, n) {
        return i.map(e, function (e, i) {
          return [e[0] - n[0] * t[i][0], e[1] - n[1] * t[i][1]];
        });
      }
    };

    function w(e, t, n, i) {
      return [t[0] - i[e] * n[0], t[1] - i[e] * n[1]];
    }

    function S(e) {
      return e ? [e[0][1] - e[0][0], e[1][1] - e[1][0]] : [NaN, NaN];
    }

    var T = d;
    e.exports = T;
  }, function (e, t, n) {
    var i = n(1).each,
        r = "\0_ec_hist_store";

    function o(e) {
      var t = e[r];
      return t || (t = e[r] = [{}]), t;
    }

    t.push = function (e, t) {
      var n = o(e);
      i(t, function (t, i) {
        for (var r = n.length - 1; r >= 0; r--) {
          if (n[r][i]) break;
        }

        if (r < 0) {
          var o = e.queryComponents({
            mainType: "dataZoom",
            subType: "select",
            id: i
          })[0];

          if (o) {
            var a = o.getPercentRange();
            n[0][i] = {
              dataZoomId: i,
              start: a[0],
              end: a[1]
            };
          }
        }
      }), n.push(t);
    }, t.pop = function (e) {
      var t = o(e),
          n = t[t.length - 1];
      t.length > 1 && t.pop();
      var r = {};
      return i(n, function (e, n) {
        for (var i = t.length - 1; i >= 0; i--) {
          if (e = t[i][n]) {
            r[n] = e;
            break;
          }
        }
      }), r;
    }, t.clear = function (e) {
      e[r] = null;
    }, t.count = function (e) {
      return o(e).length;
    };
  }, function (e, t, n) {
    var i = n(4),
        r = n(1),
        o = n(17),
        a = n(169),
        s = n(889),
        l = n(67),
        u = n(350),
        c = ["inBrush", "outOfBrush"],
        h = i.PRIORITY.VISUAL.BRUSH;

    function d(e) {
      e.eachComponent({
        mainType: "brush"
      }, function (t) {
        (t.brushTargetManager = new u(t.option, e)).setInputRanges(t.areas, e);
      });
    }

    function f(e, t) {
      if (!e.isDisposed()) {
        var n = e.getZr();
        n.__ecInBrushSelectEvent = !0, e.dispatchAction({
          type: "brushSelect",
          batch: t
        }), n.__ecInBrushSelectEvent = !1;
      }
    }

    function p(e, t, n, i) {
      for (var r = 0, o = t.length; r < o; r++) {
        var a = t[r];
        if (e[a.brushType](i, n, a.selectors, a)) return !0;
      }
    }

    function g(e) {
      var t = e.brushSelector;

      if (r.isString(t)) {
        var n = [];
        return r.each(s, function (e, i) {
          n[i] = function (n, i, r, o) {
            var a = i.getItemLayout(n);
            return e[t](a, r, o);
          };
        }), n;
      }

      if (r.isFunction(t)) {
        var i = {};
        return r.each(s, function (e, n) {
          i[n] = t;
        }), i;
      }

      return t;
    }

    i.registerLayout(h, function (e, t, n) {
      e.eachComponent({
        mainType: "brush"
      }, function (e) {
        n && "takeGlobalCursor" === n.type && e.setBrushOption("brush" === n.key ? n.brushOption : {
          brushType: !1
        });
      }), d(e);
    }), i.registerVisual(h, function (e, t, n) {
      var i,
          o,
          u = [];
      e.eachComponent({
        mainType: "brush"
      }, function (t, n) {
        var l = {
          brushId: t.id,
          brushIndex: n,
          brushName: t.name,
          areas: r.clone(t.areas),
          selected: []
        };
        u.push(l);
        var h = t.option,
            d = h.brushLink,
            f = [],
            m = [],
            y = [],
            x = 0;
        n || (i = h.throttleType, o = h.throttleDelay);

        var _ = r.map(t.areas, function (e) {
          return function (e) {
            var t = e.selectors = {};
            return r.each(s[e.brushType], function (n, i) {
              t[i] = function (i) {
                return n(i, t, e);
              };
            }), e;
          }(r.defaults({
            boundingRect: v[e.brushType](e)
          }, e));
        }),
            b = a.createVisualMappings(t.option, c, function (e) {
          e.mappingMethod = "fixed";
        });

        function w(e) {
          return "all" === d || f[e];
        }

        function S(e) {
          return !!e.length;
        }

        r.isArray(d) && r.each(d, function (e) {
          f[e] = 1;
        }), e.eachSeries(function (n, i) {
          var o = y[i] = [];
          "parallel" === n.subType ? function (e, t) {
            var n = e.coordinateSystem;
            x |= n.hasAxisBrushed(), w(t) && n.eachActiveState(e.getData(), function (e, t) {
              "active" === e && (m[t] = 1);
            });
          }(n, i) : function (n, i, o) {
            var a = g(n);
            if (!a || function (e, t) {
              var n = e.option.seriesIndex;
              return null != n && "all" !== n && (r.isArray(n) ? r.indexOf(n, t) < 0 : t !== n);
            }(t, i)) return;

            if (r.each(_, function (i) {
              a[i.brushType] && t.brushTargetManager.controlSeries(i, n, e) && o.push(i), x |= S(o);
            }), w(i) && S(o)) {
              var s = n.getData();
              s.each(function (e) {
                p(a, o, s, e) && (m[e] = 1);
              });
            }
          }(n, i, o);
        }), e.eachSeries(function (e, t) {
          var n = {
            seriesId: e.id,
            seriesIndex: t,
            seriesName: e.name,
            dataIndex: []
          };
          l.selected.push(n);
          var i = g(e),
              r = y[t],
              o = e.getData(),
              s = w(t) ? function (e) {
            return m[e] ? (n.dataIndex.push(o.getRawIndex(e)), "inBrush") : "outOfBrush";
          } : function (e) {
            return p(i, r, o, e) ? (n.dataIndex.push(o.getRawIndex(e)), "inBrush") : "outOfBrush";
          };
          (w(t) ? x : S(r)) && a.applyVisual(c, b, o, s);
        });
      }), function (e, t, n, i, r) {
        if (!r) return;
        var o = e.getZr();
        if (o.__ecInBrushSelectEvent) return;
        o.__ecBrushSelect || (o.__ecBrushSelect = f);
        l.createOrUpdate(o, "__ecBrushSelect", n, t)(e, i);
      }(t, i, o, u, n);
    });
    var v = {
      lineX: r.noop,
      lineY: r.noop,
      rect: function rect(e) {
        return m(e.range);
      },
      polygon: function polygon(e) {
        for (var t, n = e.range, i = 0, r = n.length; i < r; i++) {
          t = t || [[1 / 0, -1 / 0], [1 / 0, -1 / 0]];
          var o = n[i];
          o[0] < t[0][0] && (t[0][0] = o[0]), o[0] > t[0][1] && (t[0][1] = o[0]), o[1] < t[1][0] && (t[1][0] = o[1]), o[1] > t[1][1] && (t[1][1] = o[1]);
        }

        return t && m(t);
      }
    };

    function m(e) {
      return new o(e[0][0], e[1][0], e[0][1] - e[0][0], e[1][1] - e[1][0]);
    }

    t.layoutCovers = d;
  }, function (e, t, n) {
    var i = n(4);
    n(354), n(914), n(355);
    var r = n(915),
        o = n(26);
    i.registerProcessor(i.PRIORITY.PROCESSOR.SERIES_FILTER, r), o.registerSubTypeDefaulter("legend", function () {
      return "plain";
    });
  }, function (e, t, n) {
    var i = n(4),
        r = n(1),
        o = n(22),
        a = n(8).isNameSpecified,
        s = n(68).legend.selector,
        l = {
      all: {
        type: "all",
        title: r.clone(s.all)
      },
      inverse: {
        type: "inverse",
        title: r.clone(s.inverse)
      }
    },
        u = i.extendComponentModel({
      type: "legend.plain",
      dependencies: ["series"],
      layoutMode: {
        type: "box",
        ignoreSize: !0
      },
      init: function init(e, t, n) {
        this.mergeDefaultAndTheme(e, n), e.selected = e.selected || {}, this._updateSelector(e);
      },
      mergeOption: function mergeOption(e) {
        u.superCall(this, "mergeOption", e), this._updateSelector(e);
      },
      _updateSelector: function _updateSelector(e) {
        var t = e.selector;
        !0 === t && (t = e.selector = ["all", "inverse"]), r.isArray(t) && r.each(t, function (e, n) {
          r.isString(e) && (e = {
            type: e
          }), t[n] = r.merge(e, l[e.type]);
        });
      },
      optionUpdated: function optionUpdated() {
        this._updateData(this.ecModel);

        var e = this._data;

        if (e[0] && "single" === this.get("selectedMode")) {
          for (var t = !1, n = 0; n < e.length; n++) {
            var i = e[n].get("name");

            if (this.isSelected(i)) {
              this.select(i), t = !0;
              break;
            }
          }

          !t && this.select(e[0].get("name"));
        }
      },
      _updateData: function _updateData(e) {
        var t = [],
            n = [];
        e.eachRawSeries(function (i) {
          var r,
              o = i.name;

          if (n.push(o), i.legendVisualProvider) {
            var s = i.legendVisualProvider.getAllNames();
            e.isSeriesFiltered(i) || (n = n.concat(s)), s.length ? t = t.concat(s) : r = !0;
          } else r = !0;

          r && a(i) && t.push(i.name);
        }), this._availableNames = n;
        var i = this.get("data") || t,
            s = r.map(i, function (e) {
          return "string" != typeof e && "number" != typeof e || (e = {
            name: e
          }), new o(e, this, this.ecModel);
        }, this);
        this._data = s;
      },
      getData: function getData() {
        return this._data;
      },
      select: function select(e) {
        var t = this.option.selected;

        if ("single" === this.get("selectedMode")) {
          var n = this._data;
          r.each(n, function (e) {
            t[e.get("name")] = !1;
          });
        }

        t[e] = !0;
      },
      unSelect: function unSelect(e) {
        "single" !== this.get("selectedMode") && (this.option.selected[e] = !1);
      },
      toggleSelected: function toggleSelected(e) {
        var t = this.option.selected;
        t.hasOwnProperty(e) || (t[e] = !0), this[t[e] ? "unSelect" : "select"](e);
      },
      allSelect: function allSelect() {
        var e = this._data,
            t = this.option.selected;
        r.each(e, function (e) {
          t[e.get("name", !0)] = !0;
        });
      },
      inverseSelect: function inverseSelect() {
        var e = this._data,
            t = this.option.selected;
        r.each(e, function (e) {
          var n = e.get("name", !0);
          t.hasOwnProperty(n) || (t[n] = !0), t[n] = !t[n];
        });
      },
      isSelected: function isSelected(e) {
        var t = this.option.selected;
        return !(t.hasOwnProperty(e) && !t[e]) && r.indexOf(this._availableNames, e) >= 0;
      },
      getOrient: function getOrient() {
        return "vertical" === this.get("orient") ? {
          index: 1,
          name: "vertical"
        } : {
          index: 0,
          name: "horizontal"
        };
      },
      defaultOption: {
        zlevel: 0,
        z: 4,
        show: !0,
        orient: "horizontal",
        left: "center",
        top: 0,
        align: "auto",
        backgroundColor: "rgba(0,0,0,0)",
        borderColor: "#ccc",
        borderRadius: 0,
        borderWidth: 0,
        padding: 5,
        itemGap: 10,
        itemWidth: 25,
        itemHeight: 14,
        inactiveColor: "#ccc",
        inactiveBorderColor: "#ccc",
        itemStyle: {
          borderWidth: 0
        },
        textStyle: {
          color: "#333"
        },
        selectedMode: !0,
        selector: !1,
        selectorLabel: {
          show: !0,
          borderRadius: 10,
          padding: [3, 5, 3, 5],
          fontSize: 12,
          fontFamily: " sans-serif",
          color: "#666",
          borderWidth: 1,
          borderColor: "#666"
        },
        emphasis: {
          selectorLabel: {
            show: !0,
            color: "#eee",
            backgroundColor: "#666"
          }
        },
        selectorPosition: "auto",
        selectorItemGap: 7,
        selectorButtonGap: 10,
        tooltip: {
          show: !1
        }
      }
    }),
        c = u;
    e.exports = c;
  }, function (e, t, n) {
    n(9).__DEV__;
    var i = n(4),
        r = n(1),
        o = n(40).createSymbol,
        a = n(5),
        s = n(349).makeBackground,
        l = n(14),
        u = r.curry,
        c = r.each,
        h = a.Group,
        d = i.extendComponentView({
      type: "legend.plain",
      newlineDisabled: !1,
      init: function init() {
        this.group.add(this._contentGroup = new h()), this._backgroundEl, this.group.add(this._selectorGroup = new h()), this._isFirstRender = !0;
      },
      getContentGroup: function getContentGroup() {
        return this._contentGroup;
      },
      getSelectorGroup: function getSelectorGroup() {
        return this._selectorGroup;
      },
      render: function render(e, t, n) {
        var i = this._isFirstRender;

        if (this._isFirstRender = !1, this.resetInner(), e.get("show", !0)) {
          var o = e.get("align"),
              a = e.get("orient");
          o && "auto" !== o || (o = "right" === e.get("left") && "vertical" === a ? "right" : "left");
          var u = e.get("selector", !0),
              c = e.get("selectorPosition", !0);
          !u || c && "auto" !== c || (c = "horizontal" === a ? "end" : "start"), this.renderInner(o, e, t, n, u, a, c);
          var h = e.getBoxLayoutParams(),
              d = {
            width: n.getWidth(),
            height: n.getHeight()
          },
              f = e.get("padding"),
              p = l.getLayoutRect(h, d, f),
              g = this.layoutInner(e, o, p, i, u, c),
              v = l.getLayoutRect(r.defaults({
            width: g.width,
            height: g.height
          }, h), d, f);
          this.group.attr("position", [v.x - g.x, v.y - g.y]), this.group.add(this._backgroundEl = s(g, e));
        }
      },
      resetInner: function resetInner() {
        this.getContentGroup().removeAll(), this._backgroundEl && this.group.remove(this._backgroundEl), this.getSelectorGroup().removeAll();
      },
      renderInner: function renderInner(e, t, n, i, o, a, s) {
        var l = this.getContentGroup(),
            d = r.createHashMap(),
            f = t.get("selectedMode"),
            m = [];
        n.eachRawSeries(function (e) {
          !e.get("legendHoverLink") && m.push(e.id);
        }), c(t.getData(), function (r, o) {
          var a = r.get("name");

          if (this.newlineDisabled || "" !== a && "\n" !== a) {
            var s = n.getSeriesByName(a)[0];
            if (!d.get(a)) if (s) {
              var c = s.getData(),
                  y = c.getVisual("color"),
                  x = c.getVisual("borderColor");
              "function" == typeof y && (y = y(s.getDataParams(0))), "function" == typeof x && (x = x(s.getDataParams(0)));

              var _ = c.getVisual("legendSymbol") || "roundRect",
                  b = c.getVisual("symbol");

              this._createItem(a, o, r, t, _, b, e, y, x, f).on("click", u(p, a, null, i, m)).on("mouseover", u(g, s.name, null, i, m)).on("mouseout", u(v, s.name, null, i, m)), d.set(a, !0);
            } else n.eachRawSeries(function (n) {
              if (!d.get(a) && n.legendVisualProvider) {
                var s = n.legendVisualProvider;
                if (!s.containName(a)) return;
                var l = s.indexOfName(a),
                    c = s.getItemVisual(l, "color"),
                    h = s.getItemVisual(l, "borderColor");
                this._createItem(a, o, r, t, "roundRect", null, e, c, h, f).on("click", u(p, null, a, i, m)).on("mouseover", u(g, null, a, i, m)).on("mouseout", u(v, null, a, i, m)), d.set(a, !0);
              }
            }, this);
          } else l.add(new h({
            newline: !0
          }));
        }, this), o && this._createSelector(o, t, i, a, s);
      },
      _createSelector: function _createSelector(e, t, n, i, r) {
        var o = this.getSelectorGroup();
        c(e, function (e) {
          !function (e) {
            var i = e.type,
                r = new a.Text({
              style: {
                x: 0,
                y: 0,
                align: "center",
                verticalAlign: "middle"
              },
              onclick: function onclick() {
                n.dispatchAction({
                  type: "all" === i ? "legendAllSelect" : "legendInverseSelect"
                });
              }
            });
            o.add(r);
            var s = t.getModel("selectorLabel"),
                l = t.getModel("emphasis.selectorLabel");
            a.setLabelStyle(r.style, r.hoverStyle = {}, s, l, {
              defaultText: e.title,
              isRectText: !1
            }), a.setHoverStyle(r);
          }(e);
        });
      },
      _createItem: function _createItem(e, t, n, i, s, l, u, c, d, p) {
        var g = i.get("itemWidth"),
            v = i.get("itemHeight"),
            m = i.get("inactiveColor"),
            y = i.get("inactiveBorderColor"),
            x = i.get("symbolKeepAspect"),
            _ = i.getModel("itemStyle"),
            b = i.isSelected(e),
            w = new h(),
            S = n.getModel("textStyle"),
            T = n.get("icon"),
            C = n.getModel("tooltip"),
            k = C.parentModel,
            M = o(s = T || s, 0, 0, g, v, b ? c : m, null == x || x);

        if (w.add(f(M, s, _, d, y, b)), !T && l && (l !== s || "none" === l)) {
          var E = .8 * v;
          "none" === l && (l = "circle");
          var A = o(l, (g - E) / 2, (v - E) / 2, E, E, b ? c : m, null == x || x);
          w.add(f(A, l, _, d, y, b));
        }

        var I = "left" === u ? g + 5 : -5,
            P = u,
            O = i.get("formatter"),
            L = e;
        "string" == typeof O && O ? L = O.replace("{name}", null != e ? e : "") : "function" == typeof O && (L = O(e)), w.add(new a.Text({
          style: a.setTextStyle({}, S, {
            text: L,
            x: I,
            y: v / 2,
            textFill: b ? S.getTextColor() : m,
            textAlign: P,
            textVerticalAlign: "middle"
          })
        }));
        var D = new a.Rect({
          shape: w.getBoundingRect(),
          invisible: !0,
          tooltip: C.get("show") ? r.extend({
            content: e,
            formatter: k.get("formatter", !0) || function () {
              return e;
            },
            formatterParams: {
              componentType: "legend",
              legendIndex: i.componentIndex,
              name: e,
              $vars: ["name"]
            }
          }, C.option) : null
        });
        return w.add(D), w.eachChild(function (e) {
          e.silent = !0;
        }), D.silent = !p, this.getContentGroup().add(w), a.setHoverStyle(w), w.__legendDataIndex = t, w;
      },
      layoutInner: function layoutInner(e, t, n, i, r, o) {
        var a = this.getContentGroup(),
            s = this.getSelectorGroup();
        l.box(e.get("orient"), a, e.get("itemGap"), n.width, n.height);
        var u = a.getBoundingRect(),
            c = [-u.x, -u.y];

        if (r) {
          l.box("horizontal", s, e.get("selectorItemGap", !0));
          var h = s.getBoundingRect(),
              d = [-h.x, -h.y],
              f = e.get("selectorButtonGap", !0),
              p = e.getOrient().index,
              g = 0 === p ? "width" : "height",
              v = 0 === p ? "height" : "width",
              m = 0 === p ? "y" : "x";
          "end" === o ? d[p] += u[g] + f : c[p] += h[g] + f, d[1 - p] += u[v] / 2 - h[v] / 2, s.attr("position", d), a.attr("position", c);
          var y = {
            x: 0,
            y: 0
          };
          return y[g] = u[g] + f + h[g], y[v] = Math.max(u[v], h[v]), y[m] = Math.min(0, h[m] + d[1 - p]), y;
        }

        return a.attr("position", c), this.group.getBoundingRect();
      },
      remove: function remove() {
        this.getContentGroup().removeAll(), this._isFirstRender = !0;
      }
    });

    function f(e, t, n, i, r, o) {
      var a;
      return "line" !== t && t.indexOf("empty") < 0 ? (a = n.getItemStyle(), e.style.stroke = i, o || (a.stroke = r)) : a = n.getItemStyle(["borderWidth", "borderColor"]), e.setStyle(a);
    }

    function p(e, t, n, i) {
      v(e, t, n, i), n.dispatchAction({
        type: "legendToggleSelect",
        name: null != e ? e : t
      }), g(e, t, n, i);
    }

    function g(e, t, n, i) {
      var r = n.getZr().storage.getDisplayList()[0];
      r && r.useHoverLayer || n.dispatchAction({
        type: "highlight",
        seriesName: e,
        name: t,
        excludeSeriesId: i
      });
    }

    function v(e, t, n, i) {
      var r = n.getZr().storage.getDisplayList()[0];
      r && r.useHoverLayer || n.dispatchAction({
        type: "downplay",
        seriesName: e,
        name: t,
        excludeSeriesId: i
      });
    }

    e.exports = d;
  }, function (e, t, n) {
    n(227), n(108), n(109), n(920), n(921), n(229), n(230);
  }, function (e, t, n) {
    n(227), n(108), n(109), n(922), n(923), n(229), n(230);
  }, function (e, t, n) {
    var i = n(4),
        r = n(359);
    n(360), n(361), n(926), n(927), n(366), i.registerPreprocessor(r);
  }, function (e, t, n) {
    var i = n(1),
        r = i.each;

    function o(e, t) {
      return e && e.hasOwnProperty && e.hasOwnProperty(t);
    }

    e.exports = function (e) {
      var t = e && e.visualMap;
      i.isArray(t) || (t = t ? [t] : []), r(t, function (e) {
        if (e) {
          o(e, "splitList") && !o(e, "pieces") && (e.pieces = e.splitList, delete e.splitList);
          var t = e.pieces;
          t && i.isArray(t) && r(t, function (e) {
            i.isObject(e) && (o(e, "start") && !o(e, "min") && (e.min = e.start), o(e, "end") && !o(e, "max") && (e.max = e.end));
          });
        }
      });
    };
  }, function (e, t, n) {
    n(26).registerSubTypeDefaulter("visualMap", function (e) {
      return e.categories || (e.pieces ? e.pieces.length > 0 : e.splitNumber > 0) && !e.calculable ? "piecewise" : "continuous";
    });
  }, function (e, t, n) {
    var i = n(4),
        r = n(1),
        o = n(169),
        a = n(91),
        s = i.PRIORITY.VISUAL.COMPONENT;

    function l(e, t, n, i) {
      for (var r = t.targetVisuals[i], o = a.prepareVisualTypes(r), s = {
        color: e.getData().getVisual("color")
      }, l = 0, u = o.length; l < u; l++) {
        var c = o[l],
            h = r["opacity" === c ? "__alphaForOpacity" : c];
        h && h.applyVisual(n, d, f);
      }

      return s.color;

      function d(e) {
        return s[e];
      }

      function f(e, t) {
        s[e] = t;
      }
    }

    i.registerVisual(s, {
      createOnAllSeries: !0,
      reset: function reset(e, t) {
        var n = [];
        return t.eachComponent("visualMap", function (t) {
          var i = e.pipelineContext;
          !t.isTargetSeries(e) || i && i.large || n.push(o.incrementalApplyVisual(t.stateList, t.targetVisuals, r.bind(t.getValueState, t), t.getDataDimension(e.getData())));
        }), n;
      }
    }), i.registerVisual(s, {
      createOnAllSeries: !0,
      reset: function reset(e, t) {
        var n = e.getData(),
            i = [];
        t.eachComponent("visualMap", function (t) {
          if (t.isTargetSeries(e)) {
            var o = t.getVisualMeta(r.bind(l, null, e, t)) || {
              stops: [],
              outerColors: []
            },
                a = t.getDataDimension(n),
                s = n.getDimensionInfo(a);
            null != s && (o.dimension = s.index, i.push(o));
          }
        }), e.getData().setVisual("visualMeta", i);
      }
    });
  }, function (e, t, n) {
    var i = n(4),
        r = n(1),
        o = n(21),
        a = n(363),
        s = n(91),
        l = n(169),
        u = n(8),
        c = n(6),
        h = s.mapVisual,
        d = s.eachVisual,
        f = r.isArray,
        p = r.each,
        g = c.asc,
        v = c.linearMap,
        m = r.noop,
        y = i.extendComponentModel({
      type: "visualMap",
      dependencies: ["series"],
      stateList: ["inRange", "outOfRange"],
      replacableOptionKeys: ["inRange", "outOfRange", "target", "controller", "color"],
      dataBound: [-1 / 0, 1 / 0],
      layoutMode: {
        type: "box",
        ignoreSize: !0
      },
      defaultOption: {
        show: !0,
        zlevel: 0,
        z: 4,
        seriesIndex: "all",
        min: 0,
        max: 200,
        dimension: null,
        inRange: null,
        outOfRange: null,
        left: 0,
        right: null,
        top: null,
        bottom: 0,
        itemWidth: null,
        itemHeight: null,
        inverse: !1,
        orient: "vertical",
        backgroundColor: "rgba(0,0,0,0)",
        borderColor: "#ccc",
        contentColor: "#5793f3",
        inactiveColor: "#aaa",
        borderWidth: 0,
        padding: 5,
        textGap: 10,
        precision: 0,
        color: null,
        formatter: null,
        text: null,
        textStyle: {
          color: "#333"
        }
      },
      init: function init(e, t, n) {
        this._dataExtent, this.targetVisuals = {}, this.controllerVisuals = {}, this.textStyleModel, this.itemSize, this.mergeDefaultAndTheme(e, n);
      },
      optionUpdated: function optionUpdated(e, t) {
        var n = this.option;
        o.canvasSupported || (n.realtime = !1), !t && l.replaceVisualOption(n, e, this.replacableOptionKeys), this.textStyleModel = this.getModel("textStyle"), this.resetItemSize(), this.completeVisualOption();
      },
      resetVisual: function resetVisual(e) {
        var t = this.stateList;
        e = r.bind(e, this), this.controllerVisuals = l.createVisualMappings(this.option.controller, t, e), this.targetVisuals = l.createVisualMappings(this.option.target, t, e);
      },
      getTargetSeriesIndices: function getTargetSeriesIndices() {
        var e = this.option.seriesIndex,
            t = [];
        return null == e || "all" === e ? this.ecModel.eachSeries(function (e, n) {
          t.push(n);
        }) : t = u.normalizeToArray(e), t;
      },
      eachTargetSeries: function eachTargetSeries(e, t) {
        r.each(this.getTargetSeriesIndices(), function (n) {
          e.call(t, this.ecModel.getSeriesByIndex(n));
        }, this);
      },
      isTargetSeries: function isTargetSeries(e) {
        var t = !1;
        return this.eachTargetSeries(function (n) {
          n === e && (t = !0);
        }), t;
      },
      formatValueText: function formatValueText(e, t, n) {
        var i,
            o,
            a = this.option,
            s = a.precision,
            l = this.dataBound,
            u = a.formatter;
        return n = n || ["<", ">"], r.isArray(e) && (e = e.slice(), i = !0), o = t ? e : i ? [c(e[0]), c(e[1])] : c(e), r.isString(u) ? u.replace("{value}", i ? o[0] : o).replace("{value2}", i ? o[1] : o) : r.isFunction(u) ? i ? u(e[0], e[1]) : u(e) : i ? e[0] === l[0] ? n[0] + " " + o[1] : e[1] === l[1] ? n[1] + " " + o[0] : o[0] + " - " + o[1] : o;

        function c(e) {
          return e === l[0] ? "min" : e === l[1] ? "max" : (+e).toFixed(Math.min(s, 20));
        }
      },
      resetExtent: function resetExtent() {
        var e = this.option,
            t = g([e.min, e.max]);
        this._dataExtent = t;
      },
      getDataDimension: function getDataDimension(e) {
        var t = this.option.dimension,
            n = e.dimensions;

        if (null != t || n.length) {
          if (null != t) return e.getDimension(t);

          for (var i = e.dimensions, r = i.length - 1; r >= 0; r--) {
            var o = i[r];
            if (!e.getDimensionInfo(o).isCalculationCoord) return o;
          }
        }
      },
      getExtent: function getExtent() {
        return this._dataExtent.slice();
      },
      completeVisualOption: function completeVisualOption() {
        var e = this.ecModel,
            t = this.option,
            n = {
          inRange: t.inRange,
          outOfRange: t.outOfRange
        },
            i = t.target || (t.target = {}),
            o = t.controller || (t.controller = {});
        r.merge(i, n), r.merge(o, n);
        var l = this.isCategory();

        function u(n) {
          f(t.color) && !n.inRange && (n.inRange = {
            color: t.color.slice().reverse()
          }), n.inRange = n.inRange || {
            color: e.get("gradientColor")
          }, p(this.stateList, function (e) {
            var t = n[e];

            if (r.isString(t)) {
              var i = a.get(t, "active", l);
              i ? (n[e] = {}, n[e][t] = i) : delete n[e];
            }
          }, this);
        }

        u.call(this, i), u.call(this, o), function (e, t, n) {
          var i = e[t],
              r = e[n];
          i && !r && (r = e[n] = {}, p(i, function (e, t) {
            if (s.isValidType(t)) {
              var n = a.get(t, "inactive", l);
              null != n && (r[t] = n, "color" !== t || r.hasOwnProperty("opacity") || r.hasOwnProperty("colorAlpha") || (r.opacity = [0, 0]));
            }
          }));
        }.call(this, i, "inRange", "outOfRange"), function (e) {
          var t = (e.inRange || {}).symbol || (e.outOfRange || {}).symbol,
              n = (e.inRange || {}).symbolSize || (e.outOfRange || {}).symbolSize,
              i = this.get("inactiveColor");
          p(this.stateList, function (o) {
            var a = this.itemSize,
                s = e[o];
            s || (s = e[o] = {
              color: l ? i : [i]
            }), null == s.symbol && (s.symbol = t && r.clone(t) || (l ? "roundRect" : ["roundRect"])), null == s.symbolSize && (s.symbolSize = n && r.clone(n) || (l ? a[0] : [a[0], a[0]])), s.symbol = h(s.symbol, function (e) {
              return "none" === e || "square" === e ? "roundRect" : e;
            });
            var u = s.symbolSize;

            if (null != u) {
              var c = -1 / 0;
              d(u, function (e) {
                e > c && (c = e);
              }), s.symbolSize = h(u, function (e) {
                return v(e, [0, c], [0, a[0]], !0);
              });
            }
          }, this);
        }.call(this, o);
      },
      resetItemSize: function resetItemSize() {
        this.itemSize = [parseFloat(this.get("itemWidth")), parseFloat(this.get("itemHeight"))];
      },
      isCategory: function isCategory() {
        return !!this.option.categories;
      },
      setSelected: m,
      getValueState: m,
      getVisualMeta: m
    });
    e.exports = y;
  }, function (e, t, n) {
    var i = n(1),
        r = {
      get: function get(e, t, n) {
        var r = i.clone((o[e] || {})[t]);
        return n && i.isArray(r) ? r[r.length - 1] : r;
      }
    },
        o = {
      color: {
        active: ["#006edd", "#e0ffff"],
        inactive: ["rgba(0,0,0,0)"]
      },
      colorHue: {
        active: [0, 360],
        inactive: [0, 0]
      },
      colorSaturation: {
        active: [.3, 1],
        inactive: [0, 0]
      },
      colorLightness: {
        active: [.9, .5],
        inactive: [0, 0]
      },
      colorAlpha: {
        active: [.3, 1],
        inactive: [0, 0]
      },
      opacity: {
        active: [.3, 1],
        inactive: [0, 0]
      },
      symbol: {
        active: ["circle", "roundRect", "diamond"],
        inactive: ["none"]
      },
      symbolSize: {
        active: [10, 50],
        inactive: [0, 0]
      }
    },
        a = r;
    e.exports = a;
  }, function (e, t, n) {
    var i = n(4),
        r = n(1),
        o = n(5),
        a = n(15),
        s = n(14),
        l = n(91),
        u = i.extendComponentView({
      type: "visualMap",
      autoPositionValues: {
        left: 1,
        right: 1,
        top: 1,
        bottom: 1
      },
      init: function init(e, t) {
        this.ecModel = e, this.api = t, this.visualMapModel;
      },
      render: function render(e, t, n, i) {
        this.visualMapModel = e, !1 !== e.get("show") ? this.doRender.apply(this, arguments) : this.group.removeAll();
      },
      renderBackground: function renderBackground(e) {
        var t = this.visualMapModel,
            n = a.normalizeCssArray(t.get("padding") || 0),
            i = e.getBoundingRect();
        e.add(new o.Rect({
          z2: -1,
          silent: !0,
          shape: {
            x: i.x - n[3],
            y: i.y - n[0],
            width: i.width + n[3] + n[1],
            height: i.height + n[0] + n[2]
          },
          style: {
            fill: t.get("backgroundColor"),
            stroke: t.get("borderColor"),
            lineWidth: t.get("borderWidth")
          }
        }));
      },
      getControllerVisual: function getControllerVisual(e, t, n) {
        var i = (n = n || {}).forceState,
            o = this.visualMapModel,
            a = {};

        if ("symbol" === t && (a.symbol = o.get("itemSymbol")), "color" === t) {
          var s = o.get("contentColor");
          a.color = s;
        }

        function u(e) {
          return a[e];
        }

        function c(e, t) {
          a[e] = t;
        }

        var h = o.controllerVisuals[i || o.getValueState(e)],
            d = l.prepareVisualTypes(h);
        return r.each(d, function (i) {
          var r = h[i];
          n.convertOpacityToAlpha && "opacity" === i && (i = "colorAlpha", r = h.__alphaForOpacity), l.dependsOn(i, t) && r && r.applyVisual(e, u, c);
        }), a[t];
      },
      positionGroup: function positionGroup(e) {
        var t = this.visualMapModel,
            n = this.api;
        s.positionElement(e, t.getBoxLayoutParams(), {
          width: n.getWidth(),
          height: n.getHeight()
        });
      },
      doRender: r.noop
    });
    e.exports = u;
  }, function (e, t, n) {
    var i = n(1),
        r = n(14).getLayoutRect;
    t.getItemAlign = function (e, t, n) {
      var i = e.option,
          o = i.align;
      if (null != o && "auto" !== o) return o;

      for (var a = {
        width: t.getWidth(),
        height: t.getHeight()
      }, s = "horizontal" === i.orient ? 1 : 0, l = [["left", "right", "width"], ["top", "bottom", "height"]], u = l[s], c = [0, null, 10], h = {}, d = 0; d < 3; d++) {
        h[l[1 - s][d]] = c[d], h[u[d]] = 2 === d ? n[0] : i[u[d]];
      }

      var f = [["x", "width", 3], ["y", "height", 0]][s],
          p = r(h, a, i.padding);
      return u[(p.margin[f[2]] || 0) + p[f[0]] + .5 * p[f[1]] < .5 * a[f[1]] ? 0 : 1];
    }, t.makeHighDownBatch = function (e, t) {
      return i.each(e || [], function (e) {
        null != e.dataIndex && (e.dataIndexInside = e.dataIndex, e.dataIndex = null), e.highlightKey = "visualMap" + (t ? t.componentIndex : "");
      }), e;
    };
  }, function (e, t, n) {
    n(4).registerAction({
      type: "selectDataRange",
      event: "dataRangeSelected",
      update: "update"
    }, function (e, t) {
      t.eachComponent({
        mainType: "visualMap",
        query: e
      }, function (t) {
        t.setSelected(e.selected);
      });
    });
  }, function (e, t, n) {
    var i = n(4),
        r = n(359);
    n(360), n(361), n(928), n(929), n(366), i.registerPreprocessor(r);
  }, function (e, t, n) {
    var i,
        r = n(21),
        o = "urn:schemas-microsoft-com:vml",
        a = "undefined" == typeof window ? null : window,
        s = !1,
        l = a && a.document;
    if (l && !r.canvasSupported) try {
      !l.namespaces.zrvml && l.namespaces.add("zrvml", o), i = function i(e) {
        return l.createElement("<zrvml:" + e + ' class="zrvml">');
      };
    } catch (e) {
      i = function i(e) {
        return l.createElement("<" + e + ' xmlns="' + o + '" class="zrvml">');
      };
    }
    t.doc = l, t.createNode = function (e) {
      return i(e);
    }, t.initVML = function () {
      if (!s && l) {
        s = !0;
        var e = l.styleSheets;
        e.length < 31 ? l.createStyleSheet().addRule(".zrvml", "behavior:url(#default#VML)") : e[0].addRule(".zrvml", "behavior:url(#default#VML)");
      }
    };
  }, function (e, t, n) {
    var i = n(561);

    e.exports = function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && i(e, t);
    };
  }, function (e, t, n) {
    var i = n(562),
        r = n(56);

    e.exports = function (e, t) {
      return !t || "object" !== i(t) && "function" != typeof t ? r(e) : t;
    };
  }, function (e, t, n) {
    "use strict";

    (function (e) {
      var n = function () {
        if ("undefined" != typeof Map) return Map;

        function e(e, t) {
          var n = -1;
          return e.some(function (e, i) {
            return e[0] === t && (n = i, !0);
          }), n;
        }

        return function () {
          function t() {
            this.__entries__ = [];
          }

          return Object.defineProperty(t.prototype, "size", {
            get: function get() {
              return this.__entries__.length;
            },
            enumerable: !0,
            configurable: !0
          }), t.prototype.get = function (t) {
            var n = e(this.__entries__, t),
                i = this.__entries__[n];
            return i && i[1];
          }, t.prototype.set = function (t, n) {
            var i = e(this.__entries__, t);
            ~i ? this.__entries__[i][1] = n : this.__entries__.push([t, n]);
          }, t.prototype.delete = function (t) {
            var n = this.__entries__,
                i = e(n, t);
            ~i && n.splice(i, 1);
          }, t.prototype.has = function (t) {
            return !!~e(this.__entries__, t);
          }, t.prototype.clear = function () {
            this.__entries__.splice(0);
          }, t.prototype.forEach = function (e, t) {
            void 0 === t && (t = null);

            for (var n = 0, i = this.__entries__; n < i.length; n++) {
              var r = i[n];
              e.call(t, r[1], r[0]);
            }
          }, t;
        }();
      }(),
          i = "undefined" != typeof window && "undefined" != typeof document && window.document === document,
          r = void 0 !== e && e.Math === Math ? e : "undefined" != typeof self && self.Math === Math ? self : "undefined" != typeof window && window.Math === Math ? window : Function("return this")(),
          o = "function" == typeof requestAnimationFrame ? requestAnimationFrame.bind(r) : function (e) {
        return setTimeout(function () {
          return e(Date.now());
        }, 1e3 / 60);
      };

      var a = ["top", "right", "bottom", "left", "width", "height", "size", "weight"],
          s = "undefined" != typeof MutationObserver,
          l = function () {
        function e() {
          this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = function (e, t) {
            var n = !1,
                i = !1,
                r = 0;

            function a() {
              n && (n = !1, e()), i && l();
            }

            function s() {
              o(a);
            }

            function l() {
              var e = Date.now();

              if (n) {
                if (e - r < 2) return;
                i = !0;
              } else n = !0, i = !1, setTimeout(s, t);

              r = e;
            }

            return l;
          }(this.refresh.bind(this), 20);
        }

        return e.prototype.addObserver = function (e) {
          ~this.observers_.indexOf(e) || this.observers_.push(e), this.connected_ || this.connect_();
        }, e.prototype.removeObserver = function (e) {
          var t = this.observers_,
              n = t.indexOf(e);
          ~n && t.splice(n, 1), !t.length && this.connected_ && this.disconnect_();
        }, e.prototype.refresh = function () {
          this.updateObservers_() && this.refresh();
        }, e.prototype.updateObservers_ = function () {
          var e = this.observers_.filter(function (e) {
            return e.gatherActive(), e.hasActive();
          });
          return e.forEach(function (e) {
            return e.broadcastActive();
          }), e.length > 0;
        }, e.prototype.connect_ = function () {
          i && !this.connected_ && (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), s ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
            attributes: !0,
            childList: !0,
            characterData: !0,
            subtree: !0
          })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
        }, e.prototype.disconnect_ = function () {
          i && this.connected_ && (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
        }, e.prototype.onTransitionEnd_ = function (e) {
          var t = e.propertyName,
              n = void 0 === t ? "" : t;
          a.some(function (e) {
            return !!~n.indexOf(e);
          }) && this.refresh();
        }, e.getInstance = function () {
          return this.instance_ || (this.instance_ = new e()), this.instance_;
        }, e.instance_ = null, e;
      }(),
          u = function u(e, t) {
        for (var n = 0, i = Object.keys(t); n < i.length; n++) {
          var r = i[n];
          Object.defineProperty(e, r, {
            value: t[r],
            enumerable: !1,
            writable: !1,
            configurable: !0
          });
        }

        return e;
      },
          c = function c(e) {
        return e && e.ownerDocument && e.ownerDocument.defaultView || r;
      },
          h = m(0, 0, 0, 0);

      function d(e) {
        return parseFloat(e) || 0;
      }

      function f(e) {
        for (var t = [], n = 1; n < arguments.length; n++) {
          t[n - 1] = arguments[n];
        }

        return t.reduce(function (t, n) {
          return t + d(e["border-" + n + "-width"]);
        }, 0);
      }

      function p(e) {
        var t = e.clientWidth,
            n = e.clientHeight;
        if (!t && !n) return h;

        var i = c(e).getComputedStyle(e),
            r = function (e) {
          for (var t = {}, n = 0, i = ["top", "right", "bottom", "left"]; n < i.length; n++) {
            var r = i[n],
                o = e["padding-" + r];
            t[r] = d(o);
          }

          return t;
        }(i),
            o = r.left + r.right,
            a = r.top + r.bottom,
            s = d(i.width),
            l = d(i.height);

        if ("border-box" === i.boxSizing && (Math.round(s + o) !== t && (s -= f(i, "left", "right") + o), Math.round(l + a) !== n && (l -= f(i, "top", "bottom") + a)), !function (e) {
          return e === c(e).document.documentElement;
        }(e)) {
          var u = Math.round(s + o) - t,
              p = Math.round(l + a) - n;
          1 !== Math.abs(u) && (s -= u), 1 !== Math.abs(p) && (l -= p);
        }

        return m(r.left, r.top, s, l);
      }

      var g = "undefined" != typeof SVGGraphicsElement ? function (e) {
        return e instanceof c(e).SVGGraphicsElement;
      } : function (e) {
        return e instanceof c(e).SVGElement && "function" == typeof e.getBBox;
      };

      function v(e) {
        return i ? g(e) ? function (e) {
          var t = e.getBBox();
          return m(0, 0, t.width, t.height);
        }(e) : p(e) : h;
      }

      function m(e, t, n, i) {
        return {
          x: e,
          y: t,
          width: n,
          height: i
        };
      }

      var y = function () {
        function e(e) {
          this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = m(0, 0, 0, 0), this.target = e;
        }

        return e.prototype.isActive = function () {
          var e = v(this.target);
          return this.contentRect_ = e, e.width !== this.broadcastWidth || e.height !== this.broadcastHeight;
        }, e.prototype.broadcastRect = function () {
          var e = this.contentRect_;
          return this.broadcastWidth = e.width, this.broadcastHeight = e.height, e;
        }, e;
      }(),
          x = function x(e, t) {
        var n,
            i,
            r,
            o,
            a,
            s,
            l,
            c = (i = (n = t).x, r = n.y, o = n.width, a = n.height, s = "undefined" != typeof DOMRectReadOnly ? DOMRectReadOnly : Object, l = Object.create(s.prototype), u(l, {
          x: i,
          y: r,
          width: o,
          height: a,
          top: r,
          right: i + o,
          bottom: a + r,
          left: i
        }), l);
        u(this, {
          target: e,
          contentRect: c
        });
      },
          _ = function () {
        function e(e, t, i) {
          if (this.activeObservations_ = [], this.observations_ = new n(), "function" != typeof e) throw new TypeError("The callback provided as parameter 1 is not a function.");
          this.callback_ = e, this.controller_ = t, this.callbackCtx_ = i;
        }

        return e.prototype.observe = function (e) {
          if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");

          if ("undefined" != typeof Element && Element instanceof Object) {
            if (!(e instanceof c(e).Element)) throw new TypeError('parameter 1 is not of type "Element".');
            var t = this.observations_;
            t.has(e) || (t.set(e, new y(e)), this.controller_.addObserver(this), this.controller_.refresh());
          }
        }, e.prototype.unobserve = function (e) {
          if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");

          if ("undefined" != typeof Element && Element instanceof Object) {
            if (!(e instanceof c(e).Element)) throw new TypeError('parameter 1 is not of type "Element".');
            var t = this.observations_;
            t.has(e) && (t.delete(e), t.size || this.controller_.removeObserver(this));
          }
        }, e.prototype.disconnect = function () {
          this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
        }, e.prototype.gatherActive = function () {
          var e = this;
          this.clearActive(), this.observations_.forEach(function (t) {
            t.isActive() && e.activeObservations_.push(t);
          });
        }, e.prototype.broadcastActive = function () {
          if (this.hasActive()) {
            var e = this.callbackCtx_,
                t = this.activeObservations_.map(function (e) {
              return new x(e.target, e.broadcastRect());
            });
            this.callback_.call(e, t, e), this.clearActive();
          }
        }, e.prototype.clearActive = function () {
          this.activeObservations_.splice(0);
        }, e.prototype.hasActive = function () {
          return this.activeObservations_.length > 0;
        }, e;
      }(),
          b = "undefined" != typeof WeakMap ? new WeakMap() : new n(),
          w = function e(t) {
        if (!(this instanceof e)) throw new TypeError("Cannot call a class as a function.");
        if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
        var n = l.getInstance(),
            i = new _(t, n, this);
        b.set(this, i);
      };

      ["observe", "unobserve", "disconnect"].forEach(function (e) {
        w.prototype[e] = function () {
          var t;
          return (t = b.get(this))[e].apply(t, arguments);
        };
      });
      var S = void 0 !== r.ResizeObserver ? r.ResizeObserver : w;
      t.a = S;
    }).call(this, n(65));
  }, function (e, t, n) {
    (function (e, i) {
      var r;
      (function () {
        var o = "Expected a function",
            a = "__lodash_placeholder__",
            s = [["ary", 128], ["bind", 1], ["bindKey", 2], ["curry", 8], ["curryRight", 16], ["flip", 512], ["partial", 32], ["partialRight", 64], ["rearg", 256]],
            l = "[object Arguments]",
            u = "[object Array]",
            c = "[object Boolean]",
            h = "[object Date]",
            d = "[object Error]",
            f = "[object Function]",
            p = "[object GeneratorFunction]",
            g = "[object Map]",
            v = "[object Number]",
            m = "[object Object]",
            y = "[object RegExp]",
            x = "[object Set]",
            _ = "[object String]",
            b = "[object Symbol]",
            w = "[object WeakMap]",
            S = "[object ArrayBuffer]",
            T = "[object DataView]",
            C = "[object Float32Array]",
            k = "[object Float64Array]",
            M = "[object Int8Array]",
            E = "[object Int16Array]",
            A = "[object Int32Array]",
            I = "[object Uint8Array]",
            P = "[object Uint16Array]",
            O = "[object Uint32Array]",
            L = /\b__p \+= '';/g,
            D = /\b(__p \+=) '' \+/g,
            N = /(__e\(.*?\)|\b__t\)) \+\n'';/g,
            j = /&(?:amp|lt|gt|quot|#39);/g,
            R = /[&<>"']/g,
            F = RegExp(j.source),
            z = RegExp(R.source),
            B = /<%-([\s\S]+?)%>/g,
            V = /<%([\s\S]+?)%>/g,
            H = /<%=([\s\S]+?)%>/g,
            W = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
            G = /^\w*$/,
            U = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
            Y = /[\\^$.*+?()[\]{}|]/g,
            X = RegExp(Y.source),
            q = /^\s+|\s+$/g,
            Z = /^\s+/,
            K = /\s+$/,
            $ = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
            Q = /\{\n\/\* \[wrapped with (.+)\] \*/,
            J = /,? & /,
            ee = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g,
            te = /\\(\\)?/g,
            ne = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g,
            ie = /\w*$/,
            re = /^[-+]0x[0-9a-f]+$/i,
            oe = /^0b[01]+$/i,
            ae = /^\[object .+?Constructor\]$/,
            se = /^0o[0-7]+$/i,
            le = /^(?:0|[1-9]\d*)$/,
            ue = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,
            ce = /($^)/,
            he = /['\n\r\u2028\u2029\\]/g,
            de = "\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff",
            fe = "\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",
            pe = "[\\ud800-\\udfff]",
            ge = "[" + fe + "]",
            ve = "[" + de + "]",
            me = "\\d+",
            ye = "[\\u2700-\\u27bf]",
            xe = "[a-z\\xdf-\\xf6\\xf8-\\xff]",
            _e = "[^\\ud800-\\udfff" + fe + me + "\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde]",
            be = "\\ud83c[\\udffb-\\udfff]",
            we = "[^\\ud800-\\udfff]",
            Se = "(?:\\ud83c[\\udde6-\\uddff]){2}",
            Te = "[\\ud800-\\udbff][\\udc00-\\udfff]",
            Ce = "[A-Z\\xc0-\\xd6\\xd8-\\xde]",
            ke = "(?:" + xe + "|" + _e + ")",
            Me = "(?:" + Ce + "|" + _e + ")",
            Ee = "(?:" + ve + "|" + be + ")" + "?",
            Ae = "[\\ufe0e\\ufe0f]?" + Ee + ("(?:\\u200d(?:" + [we, Se, Te].join("|") + ")[\\ufe0e\\ufe0f]?" + Ee + ")*"),
            Ie = "(?:" + [ye, Se, Te].join("|") + ")" + Ae,
            Pe = "(?:" + [we + ve + "?", ve, Se, Te, pe].join("|") + ")",
            Oe = RegExp("['’]", "g"),
            Le = RegExp(ve, "g"),
            De = RegExp(be + "(?=" + be + ")|" + Pe + Ae, "g"),
            Ne = RegExp([Ce + "?" + xe + "+(?:['’](?:d|ll|m|re|s|t|ve))?(?=" + [ge, Ce, "$"].join("|") + ")", Me + "+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=" + [ge, Ce + ke, "$"].join("|") + ")", Ce + "?" + ke + "+(?:['’](?:d|ll|m|re|s|t|ve))?", Ce + "+(?:['’](?:D|LL|M|RE|S|T|VE))?", "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", me, Ie].join("|"), "g"),
            je = RegExp("[\\u200d\\ud800-\\udfff" + de + "\\ufe0e\\ufe0f]"),
            Re = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/,
            Fe = ["Array", "Buffer", "DataView", "Date", "Error", "Float32Array", "Float64Array", "Function", "Int8Array", "Int16Array", "Int32Array", "Map", "Math", "Object", "Promise", "RegExp", "Set", "String", "Symbol", "TypeError", "Uint8Array", "Uint8ClampedArray", "Uint16Array", "Uint32Array", "WeakMap", "_", "clearTimeout", "isFinite", "parseInt", "setTimeout"],
            ze = -1,
            Be = {};

        Be[C] = Be[k] = Be[M] = Be[E] = Be[A] = Be[I] = Be["[object Uint8ClampedArray]"] = Be[P] = Be[O] = !0, Be[l] = Be[u] = Be[S] = Be[c] = Be[T] = Be[h] = Be[d] = Be[f] = Be[g] = Be[v] = Be[m] = Be[y] = Be[x] = Be[_] = Be[w] = !1;
        var Ve = {};
        Ve[l] = Ve[u] = Ve[S] = Ve[T] = Ve[c] = Ve[h] = Ve[C] = Ve[k] = Ve[M] = Ve[E] = Ve[A] = Ve[g] = Ve[v] = Ve[m] = Ve[y] = Ve[x] = Ve[_] = Ve[b] = Ve[I] = Ve["[object Uint8ClampedArray]"] = Ve[P] = Ve[O] = !0, Ve[d] = Ve[f] = Ve[w] = !1;

        var He = {
          "\\": "\\",
          "'": "'",
          "\n": "n",
          "\r": "r",
          "\u2028": "u2028",
          "\u2029": "u2029"
        },
            We = parseFloat,
            Ge = parseInt,
            Ue = "object" == typeof e && e && e.Object === Object && e,
            Ye = "object" == typeof self && self && self.Object === Object && self,
            Xe = Ue || Ye || Function("return this")(),
            qe = t && !t.nodeType && t,
            Ze = qe && "object" == typeof i && i && !i.nodeType && i,
            Ke = Ze && Ze.exports === qe,
            $e = Ke && Ue.process,
            Qe = function () {
          try {
            var e = Ze && Ze.require && Ze.require("util").types;

            return e || $e && $e.binding && $e.binding("util");
          } catch (e) {}
        }(),
            Je = Qe && Qe.isArrayBuffer,
            et = Qe && Qe.isDate,
            tt = Qe && Qe.isMap,
            nt = Qe && Qe.isRegExp,
            it = Qe && Qe.isSet,
            rt = Qe && Qe.isTypedArray;

        function ot(e, t, n) {
          switch (n.length) {
            case 0:
              return e.call(t);

            case 1:
              return e.call(t, n[0]);

            case 2:
              return e.call(t, n[0], n[1]);

            case 3:
              return e.call(t, n[0], n[1], n[2]);
          }

          return e.apply(t, n);
        }

        function at(e, t, n, i) {
          for (var r = -1, o = null == e ? 0 : e.length; ++r < o;) {
            var a = e[r];
            t(i, a, n(a), e);
          }

          return i;
        }

        function st(e, t) {
          for (var n = -1, i = null == e ? 0 : e.length; ++n < i && !1 !== t(e[n], n, e);) {
            ;
          }

          return e;
        }

        function lt(e, t) {
          for (var n = null == e ? 0 : e.length; n-- && !1 !== t(e[n], n, e);) {
            ;
          }

          return e;
        }

        function ut(e, t) {
          for (var n = -1, i = null == e ? 0 : e.length; ++n < i;) {
            if (!t(e[n], n, e)) return !1;
          }

          return !0;
        }

        function ct(e, t) {
          for (var n = -1, i = null == e ? 0 : e.length, r = 0, o = []; ++n < i;) {
            var a = e[n];
            t(a, n, e) && (o[r++] = a);
          }

          return o;
        }

        function ht(e, t) {
          return !!(null == e ? 0 : e.length) && bt(e, t, 0) > -1;
        }

        function dt(e, t, n) {
          for (var i = -1, r = null == e ? 0 : e.length; ++i < r;) {
            if (n(t, e[i])) return !0;
          }

          return !1;
        }

        function ft(e, t) {
          for (var n = -1, i = null == e ? 0 : e.length, r = Array(i); ++n < i;) {
            r[n] = t(e[n], n, e);
          }

          return r;
        }

        function pt(e, t) {
          for (var n = -1, i = t.length, r = e.length; ++n < i;) {
            e[r + n] = t[n];
          }

          return e;
        }

        function gt(e, t, n, i) {
          var r = -1,
              o = null == e ? 0 : e.length;

          for (i && o && (n = e[++r]); ++r < o;) {
            n = t(n, e[r], r, e);
          }

          return n;
        }

        function vt(e, t, n, i) {
          var r = null == e ? 0 : e.length;

          for (i && r && (n = e[--r]); r--;) {
            n = t(n, e[r], r, e);
          }

          return n;
        }

        function mt(e, t) {
          for (var n = -1, i = null == e ? 0 : e.length; ++n < i;) {
            if (t(e[n], n, e)) return !0;
          }

          return !1;
        }

        var yt = Ct("length");

        function xt(e, t, n) {
          var i;
          return n(e, function (e, n, r) {
            if (t(e, n, r)) return i = n, !1;
          }), i;
        }

        function _t(e, t, n, i) {
          for (var r = e.length, o = n + (i ? 1 : -1); i ? o-- : ++o < r;) {
            if (t(e[o], o, e)) return o;
          }

          return -1;
        }

        function bt(e, t, n) {
          return t == t ? function (e, t, n) {
            var i = n - 1,
                r = e.length;

            for (; ++i < r;) {
              if (e[i] === t) return i;
            }

            return -1;
          }(e, t, n) : _t(e, St, n);
        }

        function wt(e, t, n, i) {
          for (var r = n - 1, o = e.length; ++r < o;) {
            if (i(e[r], t)) return r;
          }

          return -1;
        }

        function St(e) {
          return e != e;
        }

        function Tt(e, t) {
          var n = null == e ? 0 : e.length;
          return n ? Et(e, t) / n : NaN;
        }

        function Ct(e) {
          return function (t) {
            return null == t ? void 0 : t[e];
          };
        }

        function kt(e) {
          return function (t) {
            return null == e ? void 0 : e[t];
          };
        }

        function Mt(e, t, n, i, r) {
          return r(e, function (e, r, o) {
            n = i ? (i = !1, e) : t(n, e, r, o);
          }), n;
        }

        function Et(e, t) {
          for (var n, i = -1, r = e.length; ++i < r;) {
            var o = t(e[i]);
            void 0 !== o && (n = void 0 === n ? o : n + o);
          }

          return n;
        }

        function At(e, t) {
          for (var n = -1, i = Array(e); ++n < e;) {
            i[n] = t(n);
          }

          return i;
        }

        function It(e) {
          return function (t) {
            return e(t);
          };
        }

        function Pt(e, t) {
          return ft(t, function (t) {
            return e[t];
          });
        }

        function Ot(e, t) {
          return e.has(t);
        }

        function Lt(e, t) {
          for (var n = -1, i = e.length; ++n < i && bt(t, e[n], 0) > -1;) {
            ;
          }

          return n;
        }

        function Dt(e, t) {
          for (var n = e.length; n-- && bt(t, e[n], 0) > -1;) {
            ;
          }

          return n;
        }

        function Nt(e, t) {
          for (var n = e.length, i = 0; n--;) {
            e[n] === t && ++i;
          }

          return i;
        }

        var jt = kt({
          À: "A",
          Á: "A",
          Â: "A",
          Ã: "A",
          Ä: "A",
          Å: "A",
          à: "a",
          á: "a",
          â: "a",
          ã: "a",
          ä: "a",
          å: "a",
          Ç: "C",
          ç: "c",
          Ð: "D",
          ð: "d",
          È: "E",
          É: "E",
          Ê: "E",
          Ë: "E",
          è: "e",
          é: "e",
          ê: "e",
          ë: "e",
          Ì: "I",
          Í: "I",
          Î: "I",
          Ï: "I",
          ì: "i",
          í: "i",
          î: "i",
          ï: "i",
          Ñ: "N",
          ñ: "n",
          Ò: "O",
          Ó: "O",
          Ô: "O",
          Õ: "O",
          Ö: "O",
          Ø: "O",
          ò: "o",
          ó: "o",
          ô: "o",
          õ: "o",
          ö: "o",
          ø: "o",
          Ù: "U",
          Ú: "U",
          Û: "U",
          Ü: "U",
          ù: "u",
          ú: "u",
          û: "u",
          ü: "u",
          Ý: "Y",
          ý: "y",
          ÿ: "y",
          Æ: "Ae",
          æ: "ae",
          Þ: "Th",
          þ: "th",
          ß: "ss",
          Ā: "A",
          Ă: "A",
          Ą: "A",
          ā: "a",
          ă: "a",
          ą: "a",
          Ć: "C",
          Ĉ: "C",
          Ċ: "C",
          Č: "C",
          ć: "c",
          ĉ: "c",
          ċ: "c",
          č: "c",
          Ď: "D",
          Đ: "D",
          ď: "d",
          đ: "d",
          Ē: "E",
          Ĕ: "E",
          Ė: "E",
          Ę: "E",
          Ě: "E",
          ē: "e",
          ĕ: "e",
          ė: "e",
          ę: "e",
          ě: "e",
          Ĝ: "G",
          Ğ: "G",
          Ġ: "G",
          Ģ: "G",
          ĝ: "g",
          ğ: "g",
          ġ: "g",
          ģ: "g",
          Ĥ: "H",
          Ħ: "H",
          ĥ: "h",
          ħ: "h",
          Ĩ: "I",
          Ī: "I",
          Ĭ: "I",
          Į: "I",
          İ: "I",
          ĩ: "i",
          ī: "i",
          ĭ: "i",
          į: "i",
          ı: "i",
          Ĵ: "J",
          ĵ: "j",
          Ķ: "K",
          ķ: "k",
          ĸ: "k",
          Ĺ: "L",
          Ļ: "L",
          Ľ: "L",
          Ŀ: "L",
          Ł: "L",
          ĺ: "l",
          ļ: "l",
          ľ: "l",
          ŀ: "l",
          ł: "l",
          Ń: "N",
          Ņ: "N",
          Ň: "N",
          Ŋ: "N",
          ń: "n",
          ņ: "n",
          ň: "n",
          ŋ: "n",
          Ō: "O",
          Ŏ: "O",
          Ő: "O",
          ō: "o",
          ŏ: "o",
          ő: "o",
          Ŕ: "R",
          Ŗ: "R",
          Ř: "R",
          ŕ: "r",
          ŗ: "r",
          ř: "r",
          Ś: "S",
          Ŝ: "S",
          Ş: "S",
          Š: "S",
          ś: "s",
          ŝ: "s",
          ş: "s",
          š: "s",
          Ţ: "T",
          Ť: "T",
          Ŧ: "T",
          ţ: "t",
          ť: "t",
          ŧ: "t",
          Ũ: "U",
          Ū: "U",
          Ŭ: "U",
          Ů: "U",
          Ű: "U",
          Ų: "U",
          ũ: "u",
          ū: "u",
          ŭ: "u",
          ů: "u",
          ű: "u",
          ų: "u",
          Ŵ: "W",
          ŵ: "w",
          Ŷ: "Y",
          ŷ: "y",
          Ÿ: "Y",
          Ź: "Z",
          Ż: "Z",
          Ž: "Z",
          ź: "z",
          ż: "z",
          ž: "z",
          Ĳ: "IJ",
          ĳ: "ij",
          Œ: "Oe",
          œ: "oe",
          ŉ: "'n",
          ſ: "s"
        }),
            Rt = kt({
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#39;"
        });

        function Ft(e) {
          return "\\" + He[e];
        }

        function zt(e) {
          return je.test(e);
        }

        function Bt(e) {
          var t = -1,
              n = Array(e.size);
          return e.forEach(function (e, i) {
            n[++t] = [i, e];
          }), n;
        }

        function Vt(e, t) {
          return function (n) {
            return e(t(n));
          };
        }

        function Ht(e, t) {
          for (var n = -1, i = e.length, r = 0, o = []; ++n < i;) {
            var s = e[n];
            s !== t && s !== a || (e[n] = a, o[r++] = n);
          }

          return o;
        }

        function Wt(e) {
          var t = -1,
              n = Array(e.size);
          return e.forEach(function (e) {
            n[++t] = e;
          }), n;
        }

        function Gt(e) {
          var t = -1,
              n = Array(e.size);
          return e.forEach(function (e) {
            n[++t] = [e, e];
          }), n;
        }

        function Ut(e) {
          return zt(e) ? function (e) {
            var t = De.lastIndex = 0;

            for (; De.test(e);) {
              ++t;
            }

            return t;
          }(e) : yt(e);
        }

        function Yt(e) {
          return zt(e) ? function (e) {
            return e.match(De) || [];
          }(e) : function (e) {
            return e.split("");
          }(e);
        }

        var Xt = kt({
          "&amp;": "&",
          "&lt;": "<",
          "&gt;": ">",
          "&quot;": '"',
          "&#39;": "'"
        });

        var qt = function e(t) {
          var n,
              i = (t = null == t ? Xe : qt.defaults(Xe.Object(), t, qt.pick(Xe, Fe))).Array,
              r = t.Date,
              de = t.Error,
              fe = t.Function,
              pe = t.Math,
              ge = t.Object,
              ve = t.RegExp,
              me = t.String,
              ye = t.TypeError,
              xe = i.prototype,
              _e = fe.prototype,
              be = ge.prototype,
              we = t["__core-js_shared__"],
              Se = _e.toString,
              Te = be.hasOwnProperty,
              Ce = 0,
              ke = (n = /[^.]+$/.exec(we && we.keys && we.keys.IE_PROTO || "")) ? "Symbol(src)_1." + n : "",
              Me = be.toString,
              Ee = Se.call(ge),
              Ae = Xe._,
              Ie = ve("^" + Se.call(Te).replace(Y, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"),
              Pe = Ke ? t.Buffer : void 0,
              De = t.Symbol,
              je = t.Uint8Array,
              He = Pe ? Pe.allocUnsafe : void 0,
              Ue = Vt(ge.getPrototypeOf, ge),
              Ye = ge.create,
              qe = be.propertyIsEnumerable,
              Ze = xe.splice,
              $e = De ? De.isConcatSpreadable : void 0,
              Qe = De ? De.iterator : void 0,
              yt = De ? De.toStringTag : void 0,
              kt = function () {
            try {
              var e = Jr(ge, "defineProperty");
              return e({}, "", {}), e;
            } catch (e) {}
          }(),
              Zt = t.clearTimeout !== Xe.clearTimeout && t.clearTimeout,
              Kt = r && r.now !== Xe.Date.now && r.now,
              $t = t.setTimeout !== Xe.setTimeout && t.setTimeout,
              Qt = pe.ceil,
              Jt = pe.floor,
              en = ge.getOwnPropertySymbols,
              tn = Pe ? Pe.isBuffer : void 0,
              nn = t.isFinite,
              rn = xe.join,
              on = Vt(ge.keys, ge),
              an = pe.max,
              sn = pe.min,
              ln = r.now,
              un = t.parseInt,
              cn = pe.random,
              hn = xe.reverse,
              dn = Jr(t, "DataView"),
              fn = Jr(t, "Map"),
              pn = Jr(t, "Promise"),
              gn = Jr(t, "Set"),
              vn = Jr(t, "WeakMap"),
              mn = Jr(ge, "create"),
              yn = vn && new vn(),
              xn = {},
              _n = Mo(dn),
              bn = Mo(fn),
              wn = Mo(pn),
              Sn = Mo(gn),
              Tn = Mo(vn),
              Cn = De ? De.prototype : void 0,
              kn = Cn ? Cn.valueOf : void 0,
              Mn = Cn ? Cn.toString : void 0;

          function En(e) {
            if (Ga(e) && !La(e) && !(e instanceof On)) {
              if (e instanceof Pn) return e;
              if (Te.call(e, "__wrapped__")) return Eo(e);
            }

            return new Pn(e);
          }

          var An = function () {
            function e() {}

            return function (t) {
              if (!Wa(t)) return {};
              if (Ye) return Ye(t);
              e.prototype = t;
              var n = new e();
              return e.prototype = void 0, n;
            };
          }();

          function In() {}

          function Pn(e, t) {
            this.__wrapped__ = e, this.__actions__ = [], this.__chain__ = !!t, this.__index__ = 0, this.__values__ = void 0;
          }

          function On(e) {
            this.__wrapped__ = e, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = 4294967295, this.__views__ = [];
          }

          function Ln(e) {
            var t = -1,
                n = null == e ? 0 : e.length;

            for (this.clear(); ++t < n;) {
              var i = e[t];
              this.set(i[0], i[1]);
            }
          }

          function Dn(e) {
            var t = -1,
                n = null == e ? 0 : e.length;

            for (this.clear(); ++t < n;) {
              var i = e[t];
              this.set(i[0], i[1]);
            }
          }

          function Nn(e) {
            var t = -1,
                n = null == e ? 0 : e.length;

            for (this.clear(); ++t < n;) {
              var i = e[t];
              this.set(i[0], i[1]);
            }
          }

          function jn(e) {
            var t = -1,
                n = null == e ? 0 : e.length;

            for (this.__data__ = new Nn(); ++t < n;) {
              this.add(e[t]);
            }
          }

          function Rn(e) {
            var t = this.__data__ = new Dn(e);
            this.size = t.size;
          }

          function Fn(e, t) {
            var n = La(e),
                i = !n && Oa(e),
                r = !n && !i && Ra(e),
                o = !n && !i && !r && Qa(e),
                a = n || i || r || o,
                s = a ? At(e.length, me) : [],
                l = s.length;

            for (var u in e) {
              !t && !Te.call(e, u) || a && ("length" == u || r && ("offset" == u || "parent" == u) || o && ("buffer" == u || "byteLength" == u || "byteOffset" == u) || ao(u, l)) || s.push(u);
            }

            return s;
          }

          function zn(e) {
            var t = e.length;
            return t ? e[ji(0, t - 1)] : void 0;
          }

          function Bn(e, t) {
            return To(mr(e), Zn(t, 0, e.length));
          }

          function Vn(e) {
            return To(mr(e));
          }

          function Hn(e, t, n) {
            (void 0 !== n && !Aa(e[t], n) || void 0 === n && !(t in e)) && Xn(e, t, n);
          }

          function Wn(e, t, n) {
            var i = e[t];
            Te.call(e, t) && Aa(i, n) && (void 0 !== n || t in e) || Xn(e, t, n);
          }

          function Gn(e, t) {
            for (var n = e.length; n--;) {
              if (Aa(e[n][0], t)) return n;
            }

            return -1;
          }

          function Un(e, t, n, i) {
            return ei(e, function (e, r, o) {
              t(i, e, n(e), o);
            }), i;
          }

          function Yn(e, t) {
            return e && yr(t, _s(t), e);
          }

          function Xn(e, t, n) {
            "__proto__" == t && kt ? kt(e, t, {
              configurable: !0,
              enumerable: !0,
              value: n,
              writable: !0
            }) : e[t] = n;
          }

          function qn(e, t) {
            for (var n = -1, r = t.length, o = i(r), a = null == e; ++n < r;) {
              o[n] = a ? void 0 : gs(e, t[n]);
            }

            return o;
          }

          function Zn(e, t, n) {
            return e == e && (void 0 !== n && (e = e <= n ? e : n), void 0 !== t && (e = e >= t ? e : t)), e;
          }

          function Kn(e, t, n, i, r, o) {
            var a,
                s = 1 & t,
                u = 2 & t,
                d = 4 & t;
            if (n && (a = r ? n(e, i, r, o) : n(e)), void 0 !== a) return a;
            if (!Wa(e)) return e;
            var w = La(e);

            if (w) {
              if (a = function (e) {
                var t = e.length,
                    n = new e.constructor(t);
                t && "string" == typeof e[0] && Te.call(e, "index") && (n.index = e.index, n.input = e.input);
                return n;
              }(e), !s) return mr(e, a);
            } else {
              var L = no(e),
                  D = L == f || L == p;
              if (Ra(e)) return hr(e, s);

              if (L == m || L == l || D && !r) {
                if (a = u || D ? {} : ro(e), !s) return u ? function (e, t) {
                  return yr(e, to(e), t);
                }(e, function (e, t) {
                  return e && yr(t, bs(t), e);
                }(a, e)) : function (e, t) {
                  return yr(e, eo(e), t);
                }(e, Yn(a, e));
              } else {
                if (!Ve[L]) return r ? e : {};

                a = function (e, t, n) {
                  var i = e.constructor;

                  switch (t) {
                    case S:
                      return dr(e);

                    case c:
                    case h:
                      return new i(+e);

                    case T:
                      return function (e, t) {
                        var n = t ? dr(e.buffer) : e.buffer;
                        return new e.constructor(n, e.byteOffset, e.byteLength);
                      }(e, n);

                    case C:
                    case k:
                    case M:
                    case E:
                    case A:
                    case I:
                    case "[object Uint8ClampedArray]":
                    case P:
                    case O:
                      return fr(e, n);

                    case g:
                      return new i();

                    case v:
                    case _:
                      return new i(e);

                    case y:
                      return function (e) {
                        var t = new e.constructor(e.source, ie.exec(e));
                        return t.lastIndex = e.lastIndex, t;
                      }(e);

                    case x:
                      return new i();

                    case b:
                      return r = e, kn ? ge(kn.call(r)) : {};
                  }

                  var r;
                }(e, L, s);
              }
            }

            o || (o = new Rn());
            var N = o.get(e);
            if (N) return N;
            o.set(e, a), Za(e) ? e.forEach(function (i) {
              a.add(Kn(i, t, n, i, e, o));
            }) : Ua(e) && e.forEach(function (i, r) {
              a.set(r, Kn(i, t, n, r, e, o));
            });
            var j = w ? void 0 : (d ? u ? Yr : Ur : u ? bs : _s)(e);
            return st(j || e, function (i, r) {
              j && (i = e[r = i]), Wn(a, r, Kn(i, t, n, r, e, o));
            }), a;
          }

          function $n(e, t, n) {
            var i = n.length;
            if (null == e) return !i;

            for (e = ge(e); i--;) {
              var r = n[i],
                  o = t[r],
                  a = e[r];
              if (void 0 === a && !(r in e) || !o(a)) return !1;
            }

            return !0;
          }

          function Qn(e, t, n) {
            if ("function" != typeof e) throw new ye(o);
            return _o(function () {
              e.apply(void 0, n);
            }, t);
          }

          function Jn(e, t, n, i) {
            var r = -1,
                o = ht,
                a = !0,
                s = e.length,
                l = [],
                u = t.length;
            if (!s) return l;
            n && (t = ft(t, It(n))), i ? (o = dt, a = !1) : t.length >= 200 && (o = Ot, a = !1, t = new jn(t));

            e: for (; ++r < s;) {
              var c = e[r],
                  h = null == n ? c : n(c);

              if (c = i || 0 !== c ? c : 0, a && h == h) {
                for (var d = u; d--;) {
                  if (t[d] === h) continue e;
                }

                l.push(c);
              } else o(t, h, i) || l.push(c);
            }

            return l;
          }

          En.templateSettings = {
            escape: B,
            evaluate: V,
            interpolate: H,
            variable: "",
            imports: {
              _: En
            }
          }, En.prototype = In.prototype, En.prototype.constructor = En, Pn.prototype = An(In.prototype), Pn.prototype.constructor = Pn, On.prototype = An(In.prototype), On.prototype.constructor = On, Ln.prototype.clear = function () {
            this.__data__ = mn ? mn(null) : {}, this.size = 0;
          }, Ln.prototype.delete = function (e) {
            var t = this.has(e) && delete this.__data__[e];
            return this.size -= t ? 1 : 0, t;
          }, Ln.prototype.get = function (e) {
            var t = this.__data__;

            if (mn) {
              var n = t[e];
              return "__lodash_hash_undefined__" === n ? void 0 : n;
            }

            return Te.call(t, e) ? t[e] : void 0;
          }, Ln.prototype.has = function (e) {
            var t = this.__data__;
            return mn ? void 0 !== t[e] : Te.call(t, e);
          }, Ln.prototype.set = function (e, t) {
            var n = this.__data__;
            return this.size += this.has(e) ? 0 : 1, n[e] = mn && void 0 === t ? "__lodash_hash_undefined__" : t, this;
          }, Dn.prototype.clear = function () {
            this.__data__ = [], this.size = 0;
          }, Dn.prototype.delete = function (e) {
            var t = this.__data__,
                n = Gn(t, e);
            return !(n < 0) && (n == t.length - 1 ? t.pop() : Ze.call(t, n, 1), --this.size, !0);
          }, Dn.prototype.get = function (e) {
            var t = this.__data__,
                n = Gn(t, e);
            return n < 0 ? void 0 : t[n][1];
          }, Dn.prototype.has = function (e) {
            return Gn(this.__data__, e) > -1;
          }, Dn.prototype.set = function (e, t) {
            var n = this.__data__,
                i = Gn(n, e);
            return i < 0 ? (++this.size, n.push([e, t])) : n[i][1] = t, this;
          }, Nn.prototype.clear = function () {
            this.size = 0, this.__data__ = {
              hash: new Ln(),
              map: new (fn || Dn)(),
              string: new Ln()
            };
          }, Nn.prototype.delete = function (e) {
            var t = $r(this, e).delete(e);
            return this.size -= t ? 1 : 0, t;
          }, Nn.prototype.get = function (e) {
            return $r(this, e).get(e);
          }, Nn.prototype.has = function (e) {
            return $r(this, e).has(e);
          }, Nn.prototype.set = function (e, t) {
            var n = $r(this, e),
                i = n.size;
            return n.set(e, t), this.size += n.size == i ? 0 : 1, this;
          }, jn.prototype.add = jn.prototype.push = function (e) {
            return this.__data__.set(e, "__lodash_hash_undefined__"), this;
          }, jn.prototype.has = function (e) {
            return this.__data__.has(e);
          }, Rn.prototype.clear = function () {
            this.__data__ = new Dn(), this.size = 0;
          }, Rn.prototype.delete = function (e) {
            var t = this.__data__,
                n = t.delete(e);
            return this.size = t.size, n;
          }, Rn.prototype.get = function (e) {
            return this.__data__.get(e);
          }, Rn.prototype.has = function (e) {
            return this.__data__.has(e);
          }, Rn.prototype.set = function (e, t) {
            var n = this.__data__;

            if (n instanceof Dn) {
              var i = n.__data__;
              if (!fn || i.length < 199) return i.push([e, t]), this.size = ++n.size, this;
              n = this.__data__ = new Nn(i);
            }

            return n.set(e, t), this.size = n.size, this;
          };
          var ei = br(li),
              ti = br(ui, !0);

          function ni(e, t) {
            var n = !0;
            return ei(e, function (e, i, r) {
              return n = !!t(e, i, r);
            }), n;
          }

          function ii(e, t, n) {
            for (var i = -1, r = e.length; ++i < r;) {
              var o = e[i],
                  a = t(o);
              if (null != a && (void 0 === s ? a == a && !$a(a) : n(a, s))) var s = a,
                  l = o;
            }

            return l;
          }

          function ri(e, t) {
            var n = [];
            return ei(e, function (e, i, r) {
              t(e, i, r) && n.push(e);
            }), n;
          }

          function oi(e, t, n, i, r) {
            var o = -1,
                a = e.length;

            for (n || (n = oo), r || (r = []); ++o < a;) {
              var s = e[o];
              t > 0 && n(s) ? t > 1 ? oi(s, t - 1, n, i, r) : pt(r, s) : i || (r[r.length] = s);
            }

            return r;
          }

          var ai = wr(),
              si = wr(!0);

          function li(e, t) {
            return e && ai(e, t, _s);
          }

          function ui(e, t) {
            return e && si(e, t, _s);
          }

          function ci(e, t) {
            return ct(t, function (t) {
              return Ba(e[t]);
            });
          }

          function hi(e, t) {
            for (var n = 0, i = (t = sr(t, e)).length; null != e && n < i;) {
              e = e[ko(t[n++])];
            }

            return n && n == i ? e : void 0;
          }

          function di(e, t, n) {
            var i = t(e);
            return La(e) ? i : pt(i, n(e));
          }

          function fi(e) {
            return null == e ? void 0 === e ? "[object Undefined]" : "[object Null]" : yt && yt in ge(e) ? function (e) {
              var t = Te.call(e, yt),
                  n = e[yt];

              try {
                e[yt] = void 0;
                var i = !0;
              } catch (e) {}

              var r = Me.call(e);
              i && (t ? e[yt] = n : delete e[yt]);
              return r;
            }(e) : function (e) {
              return Me.call(e);
            }(e);
          }

          function pi(e, t) {
            return e > t;
          }

          function gi(e, t) {
            return null != e && Te.call(e, t);
          }

          function vi(e, t) {
            return null != e && t in ge(e);
          }

          function mi(e, t, n) {
            for (var r = n ? dt : ht, o = e[0].length, a = e.length, s = a, l = i(a), u = 1 / 0, c = []; s--;) {
              var h = e[s];
              s && t && (h = ft(h, It(t))), u = sn(h.length, u), l[s] = !n && (t || o >= 120 && h.length >= 120) ? new jn(s && h) : void 0;
            }

            h = e[0];
            var d = -1,
                f = l[0];

            e: for (; ++d < o && c.length < u;) {
              var p = h[d],
                  g = t ? t(p) : p;

              if (p = n || 0 !== p ? p : 0, !(f ? Ot(f, g) : r(c, g, n))) {
                for (s = a; --s;) {
                  var v = l[s];
                  if (!(v ? Ot(v, g) : r(e[s], g, n))) continue e;
                }

                f && f.push(g), c.push(p);
              }
            }

            return c;
          }

          function yi(e, t, n) {
            var i = null == (e = vo(e, t = sr(t, e))) ? e : e[ko(zo(t))];
            return null == i ? void 0 : ot(i, e, n);
          }

          function xi(e) {
            return Ga(e) && fi(e) == l;
          }

          function _i(e, t, n, i, r) {
            return e === t || (null == e || null == t || !Ga(e) && !Ga(t) ? e != e && t != t : function (e, t, n, i, r, o) {
              var a = La(e),
                  s = La(t),
                  f = a ? u : no(e),
                  p = s ? u : no(t),
                  w = (f = f == l ? m : f) == m,
                  C = (p = p == l ? m : p) == m,
                  k = f == p;

              if (k && Ra(e)) {
                if (!Ra(t)) return !1;
                a = !0, w = !1;
              }

              if (k && !w) return o || (o = new Rn()), a || Qa(e) ? Wr(e, t, n, i, r, o) : function (e, t, n, i, r, o, a) {
                switch (n) {
                  case T:
                    if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
                    e = e.buffer, t = t.buffer;

                  case S:
                    return !(e.byteLength != t.byteLength || !o(new je(e), new je(t)));

                  case c:
                  case h:
                  case v:
                    return Aa(+e, +t);

                  case d:
                    return e.name == t.name && e.message == t.message;

                  case y:
                  case _:
                    return e == t + "";

                  case g:
                    var s = Bt;

                  case x:
                    var l = 1 & i;
                    if (s || (s = Wt), e.size != t.size && !l) return !1;
                    var u = a.get(e);
                    if (u) return u == t;
                    i |= 2, a.set(e, t);
                    var f = Wr(s(e), s(t), i, r, o, a);
                    return a.delete(e), f;

                  case b:
                    if (kn) return kn.call(e) == kn.call(t);
                }

                return !1;
              }(e, t, f, n, i, r, o);

              if (!(1 & n)) {
                var M = w && Te.call(e, "__wrapped__"),
                    E = C && Te.call(t, "__wrapped__");

                if (M || E) {
                  var A = M ? e.value() : e,
                      I = E ? t.value() : t;
                  return o || (o = new Rn()), r(A, I, n, i, o);
                }
              }

              if (!k) return !1;
              return o || (o = new Rn()), function (e, t, n, i, r, o) {
                var a = 1 & n,
                    s = Ur(e),
                    l = s.length,
                    u = Ur(t).length;
                if (l != u && !a) return !1;
                var c = l;

                for (; c--;) {
                  var h = s[c];
                  if (!(a ? h in t : Te.call(t, h))) return !1;
                }

                var d = o.get(e),
                    f = o.get(t);
                if (d && f) return d == t && f == e;
                var p = !0;
                o.set(e, t), o.set(t, e);
                var g = a;

                for (; ++c < l;) {
                  h = s[c];
                  var v = e[h],
                      m = t[h];
                  if (i) var y = a ? i(m, v, h, t, e, o) : i(v, m, h, e, t, o);

                  if (!(void 0 === y ? v === m || r(v, m, n, i, o) : y)) {
                    p = !1;
                    break;
                  }

                  g || (g = "constructor" == h);
                }

                if (p && !g) {
                  var x = e.constructor,
                      _ = t.constructor;
                  x == _ || !("constructor" in e) || !("constructor" in t) || "function" == typeof x && x instanceof x && "function" == typeof _ && _ instanceof _ || (p = !1);
                }

                return o.delete(e), o.delete(t), p;
              }(e, t, n, i, r, o);
            }(e, t, n, i, _i, r));
          }

          function bi(e, t, n, i) {
            var r = n.length,
                o = r,
                a = !i;
            if (null == e) return !o;

            for (e = ge(e); r--;) {
              var s = n[r];
              if (a && s[2] ? s[1] !== e[s[0]] : !(s[0] in e)) return !1;
            }

            for (; ++r < o;) {
              var l = (s = n[r])[0],
                  u = e[l],
                  c = s[1];

              if (a && s[2]) {
                if (void 0 === u && !(l in e)) return !1;
              } else {
                var h = new Rn();
                if (i) var d = i(u, c, l, e, t, h);
                if (!(void 0 === d ? _i(c, u, 3, i, h) : d)) return !1;
              }
            }

            return !0;
          }

          function wi(e) {
            return !(!Wa(e) || (t = e, ke && ke in t)) && (Ba(e) ? Ie : ae).test(Mo(e));
            var t;
          }

          function Si(e) {
            return "function" == typeof e ? e : null == e ? Ys : "object" == typeof e ? La(e) ? Ai(e[0], e[1]) : Ei(e) : tl(e);
          }

          function Ti(e) {
            if (!ho(e)) return on(e);
            var t = [];

            for (var n in ge(e)) {
              Te.call(e, n) && "constructor" != n && t.push(n);
            }

            return t;
          }

          function Ci(e) {
            if (!Wa(e)) return function (e) {
              var t = [];
              if (null != e) for (var n in ge(e)) {
                t.push(n);
              }
              return t;
            }(e);
            var t = ho(e),
                n = [];

            for (var i in e) {
              ("constructor" != i || !t && Te.call(e, i)) && n.push(i);
            }

            return n;
          }

          function ki(e, t) {
            return e < t;
          }

          function Mi(e, t) {
            var n = -1,
                r = Na(e) ? i(e.length) : [];
            return ei(e, function (e, i, o) {
              r[++n] = t(e, i, o);
            }), r;
          }

          function Ei(e) {
            var t = Qr(e);
            return 1 == t.length && t[0][2] ? po(t[0][0], t[0][1]) : function (n) {
              return n === e || bi(n, e, t);
            };
          }

          function Ai(e, t) {
            return lo(e) && fo(t) ? po(ko(e), t) : function (n) {
              var i = gs(n, e);
              return void 0 === i && i === t ? vs(n, e) : _i(t, i, 3);
            };
          }

          function Ii(e, t, n, i, r) {
            e !== t && ai(t, function (o, a) {
              if (r || (r = new Rn()), Wa(o)) !function (e, t, n, i, r, o, a) {
                var s = yo(e, n),
                    l = yo(t, n),
                    u = a.get(l);
                if (u) return void Hn(e, n, u);
                var c = o ? o(s, l, n + "", e, t, a) : void 0,
                    h = void 0 === c;

                if (h) {
                  var d = La(l),
                      f = !d && Ra(l),
                      p = !d && !f && Qa(l);
                  c = l, d || f || p ? La(s) ? c = s : ja(s) ? c = mr(s) : f ? (h = !1, c = hr(l, !0)) : p ? (h = !1, c = fr(l, !0)) : c = [] : Xa(l) || Oa(l) ? (c = s, Oa(s) ? c = as(s) : Wa(s) && !Ba(s) || (c = ro(l))) : h = !1;
                }

                h && (a.set(l, c), r(c, l, i, o, a), a.delete(l));
                Hn(e, n, c);
              }(e, t, a, n, Ii, i, r);else {
                var s = i ? i(yo(e, a), o, a + "", e, t, r) : void 0;
                void 0 === s && (s = o), Hn(e, a, s);
              }
            }, bs);
          }

          function Pi(e, t) {
            var n = e.length;
            if (n) return ao(t += t < 0 ? n : 0, n) ? e[t] : void 0;
          }

          function Oi(e, t, n) {
            t = t.length ? ft(t, function (e) {
              return La(e) ? function (t) {
                return hi(t, 1 === e.length ? e[0] : e);
              } : e;
            }) : [Ys];
            var i = -1;
            return t = ft(t, It(Kr())), function (e, t) {
              var n = e.length;

              for (e.sort(t); n--;) {
                e[n] = e[n].value;
              }

              return e;
            }(Mi(e, function (e, n, r) {
              return {
                criteria: ft(t, function (t) {
                  return t(e);
                }),
                index: ++i,
                value: e
              };
            }), function (e, t) {
              return function (e, t, n) {
                var i = -1,
                    r = e.criteria,
                    o = t.criteria,
                    a = r.length,
                    s = n.length;

                for (; ++i < a;) {
                  var l = pr(r[i], o[i]);

                  if (l) {
                    if (i >= s) return l;
                    var u = n[i];
                    return l * ("desc" == u ? -1 : 1);
                  }
                }

                return e.index - t.index;
              }(e, t, n);
            });
          }

          function Li(e, t, n) {
            for (var i = -1, r = t.length, o = {}; ++i < r;) {
              var a = t[i],
                  s = hi(e, a);
              n(s, a) && Vi(o, sr(a, e), s);
            }

            return o;
          }

          function Di(e, t, n, i) {
            var r = i ? wt : bt,
                o = -1,
                a = t.length,
                s = e;

            for (e === t && (t = mr(t)), n && (s = ft(e, It(n))); ++o < a;) {
              for (var l = 0, u = t[o], c = n ? n(u) : u; (l = r(s, c, l, i)) > -1;) {
                s !== e && Ze.call(s, l, 1), Ze.call(e, l, 1);
              }
            }

            return e;
          }

          function Ni(e, t) {
            for (var n = e ? t.length : 0, i = n - 1; n--;) {
              var r = t[n];

              if (n == i || r !== o) {
                var o = r;
                ao(r) ? Ze.call(e, r, 1) : Ji(e, r);
              }
            }

            return e;
          }

          function ji(e, t) {
            return e + Jt(cn() * (t - e + 1));
          }

          function Ri(e, t) {
            var n = "";
            if (!e || t < 1 || t > 9007199254740991) return n;

            do {
              t % 2 && (n += e), (t = Jt(t / 2)) && (e += e);
            } while (t);

            return n;
          }

          function Fi(e, t) {
            return bo(go(e, t, Ys), e + "");
          }

          function zi(e) {
            return zn(As(e));
          }

          function Bi(e, t) {
            var n = As(e);
            return To(n, Zn(t, 0, n.length));
          }

          function Vi(e, t, n, i) {
            if (!Wa(e)) return e;

            for (var r = -1, o = (t = sr(t, e)).length, a = o - 1, s = e; null != s && ++r < o;) {
              var l = ko(t[r]),
                  u = n;
              if ("__proto__" === l || "constructor" === l || "prototype" === l) return e;

              if (r != a) {
                var c = s[l];
                void 0 === (u = i ? i(c, l, s) : void 0) && (u = Wa(c) ? c : ao(t[r + 1]) ? [] : {});
              }

              Wn(s, l, u), s = s[l];
            }

            return e;
          }

          var Hi = yn ? function (e, t) {
            return yn.set(e, t), e;
          } : Ys,
              Wi = kt ? function (e, t) {
            return kt(e, "toString", {
              configurable: !0,
              enumerable: !1,
              value: Ws(t),
              writable: !0
            });
          } : Ys;

          function Gi(e) {
            return To(As(e));
          }

          function Ui(e, t, n) {
            var r = -1,
                o = e.length;
            t < 0 && (t = -t > o ? 0 : o + t), (n = n > o ? o : n) < 0 && (n += o), o = t > n ? 0 : n - t >>> 0, t >>>= 0;

            for (var a = i(o); ++r < o;) {
              a[r] = e[r + t];
            }

            return a;
          }

          function Yi(e, t) {
            var n;
            return ei(e, function (e, i, r) {
              return !(n = t(e, i, r));
            }), !!n;
          }

          function Xi(e, t, n) {
            var i = 0,
                r = null == e ? i : e.length;

            if ("number" == typeof t && t == t && r <= 2147483647) {
              for (; i < r;) {
                var o = i + r >>> 1,
                    a = e[o];
                null !== a && !$a(a) && (n ? a <= t : a < t) ? i = o + 1 : r = o;
              }

              return r;
            }

            return qi(e, t, Ys, n);
          }

          function qi(e, t, n, i) {
            var r = 0,
                o = null == e ? 0 : e.length;
            if (0 === o) return 0;

            for (var a = (t = n(t)) != t, s = null === t, l = $a(t), u = void 0 === t; r < o;) {
              var c = Jt((r + o) / 2),
                  h = n(e[c]),
                  d = void 0 !== h,
                  f = null === h,
                  p = h == h,
                  g = $a(h);
              if (a) var v = i || p;else v = u ? p && (i || d) : s ? p && d && (i || !f) : l ? p && d && !f && (i || !g) : !f && !g && (i ? h <= t : h < t);
              v ? r = c + 1 : o = c;
            }

            return sn(o, 4294967294);
          }

          function Zi(e, t) {
            for (var n = -1, i = e.length, r = 0, o = []; ++n < i;) {
              var a = e[n],
                  s = t ? t(a) : a;

              if (!n || !Aa(s, l)) {
                var l = s;
                o[r++] = 0 === a ? 0 : a;
              }
            }

            return o;
          }

          function Ki(e) {
            return "number" == typeof e ? e : $a(e) ? NaN : +e;
          }

          function $i(e) {
            if ("string" == typeof e) return e;
            if (La(e)) return ft(e, $i) + "";
            if ($a(e)) return Mn ? Mn.call(e) : "";
            var t = e + "";
            return "0" == t && 1 / e == -1 / 0 ? "-0" : t;
          }

          function Qi(e, t, n) {
            var i = -1,
                r = ht,
                o = e.length,
                a = !0,
                s = [],
                l = s;
            if (n) a = !1, r = dt;else if (o >= 200) {
              var u = t ? null : Rr(e);
              if (u) return Wt(u);
              a = !1, r = Ot, l = new jn();
            } else l = t ? [] : s;

            e: for (; ++i < o;) {
              var c = e[i],
                  h = t ? t(c) : c;

              if (c = n || 0 !== c ? c : 0, a && h == h) {
                for (var d = l.length; d--;) {
                  if (l[d] === h) continue e;
                }

                t && l.push(h), s.push(c);
              } else r(l, h, n) || (l !== s && l.push(h), s.push(c));
            }

            return s;
          }

          function Ji(e, t) {
            return null == (e = vo(e, t = sr(t, e))) || delete e[ko(zo(t))];
          }

          function er(e, t, n, i) {
            return Vi(e, t, n(hi(e, t)), i);
          }

          function tr(e, t, n, i) {
            for (var r = e.length, o = i ? r : -1; (i ? o-- : ++o < r) && t(e[o], o, e);) {
              ;
            }

            return n ? Ui(e, i ? 0 : o, i ? o + 1 : r) : Ui(e, i ? o + 1 : 0, i ? r : o);
          }

          function nr(e, t) {
            var n = e;
            return n instanceof On && (n = n.value()), gt(t, function (e, t) {
              return t.func.apply(t.thisArg, pt([e], t.args));
            }, n);
          }

          function ir(e, t, n) {
            var r = e.length;
            if (r < 2) return r ? Qi(e[0]) : [];

            for (var o = -1, a = i(r); ++o < r;) {
              for (var s = e[o], l = -1; ++l < r;) {
                l != o && (a[o] = Jn(a[o] || s, e[l], t, n));
              }
            }

            return Qi(oi(a, 1), t, n);
          }

          function rr(e, t, n) {
            for (var i = -1, r = e.length, o = t.length, a = {}; ++i < r;) {
              var s = i < o ? t[i] : void 0;
              n(a, e[i], s);
            }

            return a;
          }

          function or(e) {
            return ja(e) ? e : [];
          }

          function ar(e) {
            return "function" == typeof e ? e : Ys;
          }

          function sr(e, t) {
            return La(e) ? e : lo(e, t) ? [e] : Co(ss(e));
          }

          var lr = Fi;

          function ur(e, t, n) {
            var i = e.length;
            return n = void 0 === n ? i : n, !t && n >= i ? e : Ui(e, t, n);
          }

          var cr = Zt || function (e) {
            return Xe.clearTimeout(e);
          };

          function hr(e, t) {
            if (t) return e.slice();
            var n = e.length,
                i = He ? He(n) : new e.constructor(n);
            return e.copy(i), i;
          }

          function dr(e) {
            var t = new e.constructor(e.byteLength);
            return new je(t).set(new je(e)), t;
          }

          function fr(e, t) {
            var n = t ? dr(e.buffer) : e.buffer;
            return new e.constructor(n, e.byteOffset, e.length);
          }

          function pr(e, t) {
            if (e !== t) {
              var n = void 0 !== e,
                  i = null === e,
                  r = e == e,
                  o = $a(e),
                  a = void 0 !== t,
                  s = null === t,
                  l = t == t,
                  u = $a(t);
              if (!s && !u && !o && e > t || o && a && l && !s && !u || i && a && l || !n && l || !r) return 1;
              if (!i && !o && !u && e < t || u && n && r && !i && !o || s && n && r || !a && r || !l) return -1;
            }

            return 0;
          }

          function gr(e, t, n, r) {
            for (var o = -1, a = e.length, s = n.length, l = -1, u = t.length, c = an(a - s, 0), h = i(u + c), d = !r; ++l < u;) {
              h[l] = t[l];
            }

            for (; ++o < s;) {
              (d || o < a) && (h[n[o]] = e[o]);
            }

            for (; c--;) {
              h[l++] = e[o++];
            }

            return h;
          }

          function vr(e, t, n, r) {
            for (var o = -1, a = e.length, s = -1, l = n.length, u = -1, c = t.length, h = an(a - l, 0), d = i(h + c), f = !r; ++o < h;) {
              d[o] = e[o];
            }

            for (var p = o; ++u < c;) {
              d[p + u] = t[u];
            }

            for (; ++s < l;) {
              (f || o < a) && (d[p + n[s]] = e[o++]);
            }

            return d;
          }

          function mr(e, t) {
            var n = -1,
                r = e.length;

            for (t || (t = i(r)); ++n < r;) {
              t[n] = e[n];
            }

            return t;
          }

          function yr(e, t, n, i) {
            var r = !n;
            n || (n = {});

            for (var o = -1, a = t.length; ++o < a;) {
              var s = t[o],
                  l = i ? i(n[s], e[s], s, n, e) : void 0;
              void 0 === l && (l = e[s]), r ? Xn(n, s, l) : Wn(n, s, l);
            }

            return n;
          }

          function xr(e, t) {
            return function (n, i) {
              var r = La(n) ? at : Un,
                  o = t ? t() : {};
              return r(n, e, Kr(i, 2), o);
            };
          }

          function _r(e) {
            return Fi(function (t, n) {
              var i = -1,
                  r = n.length,
                  o = r > 1 ? n[r - 1] : void 0,
                  a = r > 2 ? n[2] : void 0;

              for (o = e.length > 3 && "function" == typeof o ? (r--, o) : void 0, a && so(n[0], n[1], a) && (o = r < 3 ? void 0 : o, r = 1), t = ge(t); ++i < r;) {
                var s = n[i];
                s && e(t, s, i, o);
              }

              return t;
            });
          }

          function br(e, t) {
            return function (n, i) {
              if (null == n) return n;
              if (!Na(n)) return e(n, i);

              for (var r = n.length, o = t ? r : -1, a = ge(n); (t ? o-- : ++o < r) && !1 !== i(a[o], o, a);) {
                ;
              }

              return n;
            };
          }

          function wr(e) {
            return function (t, n, i) {
              for (var r = -1, o = ge(t), a = i(t), s = a.length; s--;) {
                var l = a[e ? s : ++r];
                if (!1 === n(o[l], l, o)) break;
              }

              return t;
            };
          }

          function Sr(e) {
            return function (t) {
              var n = zt(t = ss(t)) ? Yt(t) : void 0,
                  i = n ? n[0] : t.charAt(0),
                  r = n ? ur(n, 1).join("") : t.slice(1);
              return i[e]() + r;
            };
          }

          function Tr(e) {
            return function (t) {
              return gt(Bs(Os(t).replace(Oe, "")), e, "");
            };
          }

          function Cr(e) {
            return function () {
              var t = arguments;

              switch (t.length) {
                case 0:
                  return new e();

                case 1:
                  return new e(t[0]);

                case 2:
                  return new e(t[0], t[1]);

                case 3:
                  return new e(t[0], t[1], t[2]);

                case 4:
                  return new e(t[0], t[1], t[2], t[3]);

                case 5:
                  return new e(t[0], t[1], t[2], t[3], t[4]);

                case 6:
                  return new e(t[0], t[1], t[2], t[3], t[4], t[5]);

                case 7:
                  return new e(t[0], t[1], t[2], t[3], t[4], t[5], t[6]);
              }

              var n = An(e.prototype),
                  i = e.apply(n, t);
              return Wa(i) ? i : n;
            };
          }

          function kr(e) {
            return function (t, n, i) {
              var r = ge(t);

              if (!Na(t)) {
                var o = Kr(n, 3);
                t = _s(t), n = function n(e) {
                  return o(r[e], e, r);
                };
              }

              var a = e(t, n, i);
              return a > -1 ? r[o ? t[a] : a] : void 0;
            };
          }

          function Mr(e) {
            return Gr(function (t) {
              var n = t.length,
                  i = n,
                  r = Pn.prototype.thru;

              for (e && t.reverse(); i--;) {
                var a = t[i];
                if ("function" != typeof a) throw new ye(o);
                if (r && !s && "wrapper" == qr(a)) var s = new Pn([], !0);
              }

              for (i = s ? i : n; ++i < n;) {
                var l = qr(a = t[i]),
                    u = "wrapper" == l ? Xr(a) : void 0;
                s = u && uo(u[0]) && 424 == u[1] && !u[4].length && 1 == u[9] ? s[qr(u[0])].apply(s, u[3]) : 1 == a.length && uo(a) ? s[l]() : s.thru(a);
              }

              return function () {
                var e = arguments,
                    i = e[0];
                if (s && 1 == e.length && La(i)) return s.plant(i).value();

                for (var r = 0, o = n ? t[r].apply(this, e) : i; ++r < n;) {
                  o = t[r].call(this, o);
                }

                return o;
              };
            });
          }

          function Er(e, t, n, r, o, a, s, l, u, c) {
            var h = 128 & t,
                d = 1 & t,
                f = 2 & t,
                p = 24 & t,
                g = 512 & t,
                v = f ? void 0 : Cr(e);
            return function m() {
              for (var y = arguments.length, x = i(y), _ = y; _--;) {
                x[_] = arguments[_];
              }

              if (p) var b = Zr(m),
                  w = Nt(x, b);

              if (r && (x = gr(x, r, o, p)), a && (x = vr(x, a, s, p)), y -= w, p && y < c) {
                var S = Ht(x, b);
                return Nr(e, t, Er, m.placeholder, n, x, S, l, u, c - y);
              }

              var T = d ? n : this,
                  C = f ? T[e] : e;
              return y = x.length, l ? x = mo(x, l) : g && y > 1 && x.reverse(), h && u < y && (x.length = u), this && this !== Xe && this instanceof m && (C = v || Cr(C)), C.apply(T, x);
            };
          }

          function Ar(e, t) {
            return function (n, i) {
              return function (e, t, n, i) {
                return li(e, function (e, r, o) {
                  t(i, n(e), r, o);
                }), i;
              }(n, e, t(i), {});
            };
          }

          function Ir(e, t) {
            return function (n, i) {
              var r;
              if (void 0 === n && void 0 === i) return t;

              if (void 0 !== n && (r = n), void 0 !== i) {
                if (void 0 === r) return i;
                "string" == typeof n || "string" == typeof i ? (n = $i(n), i = $i(i)) : (n = Ki(n), i = Ki(i)), r = e(n, i);
              }

              return r;
            };
          }

          function Pr(e) {
            return Gr(function (t) {
              return t = ft(t, It(Kr())), Fi(function (n) {
                var i = this;
                return e(t, function (e) {
                  return ot(e, i, n);
                });
              });
            });
          }

          function Or(e, t) {
            var n = (t = void 0 === t ? " " : $i(t)).length;
            if (n < 2) return n ? Ri(t, e) : t;
            var i = Ri(t, Qt(e / Ut(t)));
            return zt(t) ? ur(Yt(i), 0, e).join("") : i.slice(0, e);
          }

          function Lr(e) {
            return function (t, n, r) {
              return r && "number" != typeof r && so(t, n, r) && (n = r = void 0), t = ns(t), void 0 === n ? (n = t, t = 0) : n = ns(n), function (e, t, n, r) {
                for (var o = -1, a = an(Qt((t - e) / (n || 1)), 0), s = i(a); a--;) {
                  s[r ? a : ++o] = e, e += n;
                }

                return s;
              }(t, n, r = void 0 === r ? t < n ? 1 : -1 : ns(r), e);
            };
          }

          function Dr(e) {
            return function (t, n) {
              return "string" == typeof t && "string" == typeof n || (t = os(t), n = os(n)), e(t, n);
            };
          }

          function Nr(e, t, n, i, r, o, a, s, l, u) {
            var c = 8 & t;
            t |= c ? 32 : 64, 4 & (t &= ~(c ? 64 : 32)) || (t &= -4);
            var h = [e, t, r, c ? o : void 0, c ? a : void 0, c ? void 0 : o, c ? void 0 : a, s, l, u],
                d = n.apply(void 0, h);
            return uo(e) && xo(d, h), d.placeholder = i, wo(d, e, t);
          }

          function jr(e) {
            var t = pe[e];
            return function (e, n) {
              if (e = os(e), (n = null == n ? 0 : sn(is(n), 292)) && nn(e)) {
                var i = (ss(e) + "e").split("e");
                return +((i = (ss(t(i[0] + "e" + (+i[1] + n))) + "e").split("e"))[0] + "e" + (+i[1] - n));
              }

              return t(e);
            };
          }

          var Rr = gn && 1 / Wt(new gn([, -0]))[1] == 1 / 0 ? function (e) {
            return new gn(e);
          } : $s;

          function Fr(e) {
            return function (t) {
              var n = no(t);
              return n == g ? Bt(t) : n == x ? Gt(t) : function (e, t) {
                return ft(t, function (t) {
                  return [t, e[t]];
                });
              }(t, e(t));
            };
          }

          function zr(e, t, n, r, s, l, u, c) {
            var h = 2 & t;
            if (!h && "function" != typeof e) throw new ye(o);
            var d = r ? r.length : 0;

            if (d || (t &= -97, r = s = void 0), u = void 0 === u ? u : an(is(u), 0), c = void 0 === c ? c : is(c), d -= s ? s.length : 0, 64 & t) {
              var f = r,
                  p = s;
              r = s = void 0;
            }

            var g = h ? void 0 : Xr(e),
                v = [e, t, n, r, s, f, p, l, u, c];
            if (g && function (e, t) {
              var n = e[1],
                  i = t[1],
                  r = n | i,
                  o = r < 131,
                  s = 128 == i && 8 == n || 128 == i && 256 == n && e[7].length <= t[8] || 384 == i && t[7].length <= t[8] && 8 == n;
              if (!o && !s) return e;
              1 & i && (e[2] = t[2], r |= 1 & n ? 0 : 4);
              var l = t[3];

              if (l) {
                var u = e[3];
                e[3] = u ? gr(u, l, t[4]) : l, e[4] = u ? Ht(e[3], a) : t[4];
              }

              (l = t[5]) && (u = e[5], e[5] = u ? vr(u, l, t[6]) : l, e[6] = u ? Ht(e[5], a) : t[6]);
              (l = t[7]) && (e[7] = l);
              128 & i && (e[8] = null == e[8] ? t[8] : sn(e[8], t[8]));
              null == e[9] && (e[9] = t[9]);
              e[0] = t[0], e[1] = r;
            }(v, g), e = v[0], t = v[1], n = v[2], r = v[3], s = v[4], !(c = v[9] = void 0 === v[9] ? h ? 0 : e.length : an(v[9] - d, 0)) && 24 & t && (t &= -25), t && 1 != t) m = 8 == t || 16 == t ? function (e, t, n) {
              var r = Cr(e);
              return function o() {
                for (var a = arguments.length, s = i(a), l = a, u = Zr(o); l--;) {
                  s[l] = arguments[l];
                }

                var c = a < 3 && s[0] !== u && s[a - 1] !== u ? [] : Ht(s, u);
                if ((a -= c.length) < n) return Nr(e, t, Er, o.placeholder, void 0, s, c, void 0, void 0, n - a);
                var h = this && this !== Xe && this instanceof o ? r : e;
                return ot(h, this, s);
              };
            }(e, t, c) : 32 != t && 33 != t || s.length ? Er.apply(void 0, v) : function (e, t, n, r) {
              var o = 1 & t,
                  a = Cr(e);
              return function t() {
                for (var s = -1, l = arguments.length, u = -1, c = r.length, h = i(c + l), d = this && this !== Xe && this instanceof t ? a : e; ++u < c;) {
                  h[u] = r[u];
                }

                for (; l--;) {
                  h[u++] = arguments[++s];
                }

                return ot(d, o ? n : this, h);
              };
            }(e, t, n, r);else var m = function (e, t, n) {
              var i = 1 & t,
                  r = Cr(e);
              return function t() {
                var o = this && this !== Xe && this instanceof t ? r : e;
                return o.apply(i ? n : this, arguments);
              };
            }(e, t, n);
            return wo((g ? Hi : xo)(m, v), e, t);
          }

          function Br(e, t, n, i) {
            return void 0 === e || Aa(e, be[n]) && !Te.call(i, n) ? t : e;
          }

          function Vr(e, t, n, i, r, o) {
            return Wa(e) && Wa(t) && (o.set(t, e), Ii(e, t, void 0, Vr, o), o.delete(t)), e;
          }

          function Hr(e) {
            return Xa(e) ? void 0 : e;
          }

          function Wr(e, t, n, i, r, o) {
            var a = 1 & n,
                s = e.length,
                l = t.length;
            if (s != l && !(a && l > s)) return !1;
            var u = o.get(e),
                c = o.get(t);
            if (u && c) return u == t && c == e;
            var h = -1,
                d = !0,
                f = 2 & n ? new jn() : void 0;

            for (o.set(e, t), o.set(t, e); ++h < s;) {
              var p = e[h],
                  g = t[h];
              if (i) var v = a ? i(g, p, h, t, e, o) : i(p, g, h, e, t, o);

              if (void 0 !== v) {
                if (v) continue;
                d = !1;
                break;
              }

              if (f) {
                if (!mt(t, function (e, t) {
                  if (!Ot(f, t) && (p === e || r(p, e, n, i, o))) return f.push(t);
                })) {
                  d = !1;
                  break;
                }
              } else if (p !== g && !r(p, g, n, i, o)) {
                d = !1;
                break;
              }
            }

            return o.delete(e), o.delete(t), d;
          }

          function Gr(e) {
            return bo(go(e, void 0, Do), e + "");
          }

          function Ur(e) {
            return di(e, _s, eo);
          }

          function Yr(e) {
            return di(e, bs, to);
          }

          var Xr = yn ? function (e) {
            return yn.get(e);
          } : $s;

          function qr(e) {
            for (var t = e.name + "", n = xn[t], i = Te.call(xn, t) ? n.length : 0; i--;) {
              var r = n[i],
                  o = r.func;
              if (null == o || o == e) return r.name;
            }

            return t;
          }

          function Zr(e) {
            return (Te.call(En, "placeholder") ? En : e).placeholder;
          }

          function Kr() {
            var e = En.iteratee || Xs;
            return e = e === Xs ? Si : e, arguments.length ? e(arguments[0], arguments[1]) : e;
          }

          function $r(e, t) {
            var n,
                i,
                r = e.__data__;
            return ("string" == (i = typeof (n = t)) || "number" == i || "symbol" == i || "boolean" == i ? "__proto__" !== n : null === n) ? r["string" == typeof t ? "string" : "hash"] : r.map;
          }

          function Qr(e) {
            for (var t = _s(e), n = t.length; n--;) {
              var i = t[n],
                  r = e[i];
              t[n] = [i, r, fo(r)];
            }

            return t;
          }

          function Jr(e, t) {
            var n = function (e, t) {
              return null == e ? void 0 : e[t];
            }(e, t);

            return wi(n) ? n : void 0;
          }

          var eo = en ? function (e) {
            return null == e ? [] : (e = ge(e), ct(en(e), function (t) {
              return qe.call(e, t);
            }));
          } : rl,
              to = en ? function (e) {
            for (var t = []; e;) {
              pt(t, eo(e)), e = Ue(e);
            }

            return t;
          } : rl,
              no = fi;

          function io(e, t, n) {
            for (var i = -1, r = (t = sr(t, e)).length, o = !1; ++i < r;) {
              var a = ko(t[i]);
              if (!(o = null != e && n(e, a))) break;
              e = e[a];
            }

            return o || ++i != r ? o : !!(r = null == e ? 0 : e.length) && Ha(r) && ao(a, r) && (La(e) || Oa(e));
          }

          function ro(e) {
            return "function" != typeof e.constructor || ho(e) ? {} : An(Ue(e));
          }

          function oo(e) {
            return La(e) || Oa(e) || !!($e && e && e[$e]);
          }

          function ao(e, t) {
            var n = typeof e;
            return !!(t = null == t ? 9007199254740991 : t) && ("number" == n || "symbol" != n && le.test(e)) && e > -1 && e % 1 == 0 && e < t;
          }

          function so(e, t, n) {
            if (!Wa(n)) return !1;
            var i = typeof t;
            return !!("number" == i ? Na(n) && ao(t, n.length) : "string" == i && t in n) && Aa(n[t], e);
          }

          function lo(e, t) {
            if (La(e)) return !1;
            var n = typeof e;
            return !("number" != n && "symbol" != n && "boolean" != n && null != e && !$a(e)) || G.test(e) || !W.test(e) || null != t && e in ge(t);
          }

          function uo(e) {
            var t = qr(e),
                n = En[t];
            if ("function" != typeof n || !(t in On.prototype)) return !1;
            if (e === n) return !0;
            var i = Xr(n);
            return !!i && e === i[0];
          }

          (dn && no(new dn(new ArrayBuffer(1))) != T || fn && no(new fn()) != g || pn && "[object Promise]" != no(pn.resolve()) || gn && no(new gn()) != x || vn && no(new vn()) != w) && (no = function no(e) {
            var t = fi(e),
                n = t == m ? e.constructor : void 0,
                i = n ? Mo(n) : "";
            if (i) switch (i) {
              case _n:
                return T;

              case bn:
                return g;

              case wn:
                return "[object Promise]";

              case Sn:
                return x;

              case Tn:
                return w;
            }
            return t;
          });
          var co = we ? Ba : ol;

          function ho(e) {
            var t = e && e.constructor;
            return e === ("function" == typeof t && t.prototype || be);
          }

          function fo(e) {
            return e == e && !Wa(e);
          }

          function po(e, t) {
            return function (n) {
              return null != n && n[e] === t && (void 0 !== t || e in ge(n));
            };
          }

          function go(e, t, n) {
            return t = an(void 0 === t ? e.length - 1 : t, 0), function () {
              for (var r = arguments, o = -1, a = an(r.length - t, 0), s = i(a); ++o < a;) {
                s[o] = r[t + o];
              }

              o = -1;

              for (var l = i(t + 1); ++o < t;) {
                l[o] = r[o];
              }

              return l[t] = n(s), ot(e, this, l);
            };
          }

          function vo(e, t) {
            return t.length < 2 ? e : hi(e, Ui(t, 0, -1));
          }

          function mo(e, t) {
            for (var n = e.length, i = sn(t.length, n), r = mr(e); i--;) {
              var o = t[i];
              e[i] = ao(o, n) ? r[o] : void 0;
            }

            return e;
          }

          function yo(e, t) {
            if (("constructor" !== t || "function" != typeof e[t]) && "__proto__" != t) return e[t];
          }

          var xo = So(Hi),
              _o = $t || function (e, t) {
            return Xe.setTimeout(e, t);
          },
              bo = So(Wi);

          function wo(e, t, n) {
            var i = t + "";
            return bo(e, function (e, t) {
              var n = t.length;
              if (!n) return e;
              var i = n - 1;
              return t[i] = (n > 1 ? "& " : "") + t[i], t = t.join(n > 2 ? ", " : " "), e.replace($, "{\n/* [wrapped with " + t + "] */\n");
            }(i, function (e, t) {
              return st(s, function (n) {
                var i = "_." + n[0];
                t & n[1] && !ht(e, i) && e.push(i);
              }), e.sort();
            }(function (e) {
              var t = e.match(Q);
              return t ? t[1].split(J) : [];
            }(i), n)));
          }

          function So(e) {
            var t = 0,
                n = 0;
            return function () {
              var i = ln(),
                  r = 16 - (i - n);

              if (n = i, r > 0) {
                if (++t >= 800) return arguments[0];
              } else t = 0;

              return e.apply(void 0, arguments);
            };
          }

          function To(e, t) {
            var n = -1,
                i = e.length,
                r = i - 1;

            for (t = void 0 === t ? i : t; ++n < t;) {
              var o = ji(n, r),
                  a = e[o];
              e[o] = e[n], e[n] = a;
            }

            return e.length = t, e;
          }

          var Co = function (e) {
            var t = Sa(e, function (e) {
              return 500 === n.size && n.clear(), e;
            }),
                n = t.cache;
            return t;
          }(function (e) {
            var t = [];
            return 46 === e.charCodeAt(0) && t.push(""), e.replace(U, function (e, n, i, r) {
              t.push(i ? r.replace(te, "$1") : n || e);
            }), t;
          });

          function ko(e) {
            if ("string" == typeof e || $a(e)) return e;
            var t = e + "";
            return "0" == t && 1 / e == -1 / 0 ? "-0" : t;
          }

          function Mo(e) {
            if (null != e) {
              try {
                return Se.call(e);
              } catch (e) {}

              try {
                return e + "";
              } catch (e) {}
            }

            return "";
          }

          function Eo(e) {
            if (e instanceof On) return e.clone();
            var t = new Pn(e.__wrapped__, e.__chain__);
            return t.__actions__ = mr(e.__actions__), t.__index__ = e.__index__, t.__values__ = e.__values__, t;
          }

          var Ao = Fi(function (e, t) {
            return ja(e) ? Jn(e, oi(t, 1, ja, !0)) : [];
          }),
              Io = Fi(function (e, t) {
            var n = zo(t);
            return ja(n) && (n = void 0), ja(e) ? Jn(e, oi(t, 1, ja, !0), Kr(n, 2)) : [];
          }),
              Po = Fi(function (e, t) {
            var n = zo(t);
            return ja(n) && (n = void 0), ja(e) ? Jn(e, oi(t, 1, ja, !0), void 0, n) : [];
          });

          function Oo(e, t, n) {
            var i = null == e ? 0 : e.length;
            if (!i) return -1;
            var r = null == n ? 0 : is(n);
            return r < 0 && (r = an(i + r, 0)), _t(e, Kr(t, 3), r);
          }

          function Lo(e, t, n) {
            var i = null == e ? 0 : e.length;
            if (!i) return -1;
            var r = i - 1;
            return void 0 !== n && (r = is(n), r = n < 0 ? an(i + r, 0) : sn(r, i - 1)), _t(e, Kr(t, 3), r, !0);
          }

          function Do(e) {
            return (null == e ? 0 : e.length) ? oi(e, 1) : [];
          }

          function No(e) {
            return e && e.length ? e[0] : void 0;
          }

          var jo = Fi(function (e) {
            var t = ft(e, or);
            return t.length && t[0] === e[0] ? mi(t) : [];
          }),
              Ro = Fi(function (e) {
            var t = zo(e),
                n = ft(e, or);
            return t === zo(n) ? t = void 0 : n.pop(), n.length && n[0] === e[0] ? mi(n, Kr(t, 2)) : [];
          }),
              Fo = Fi(function (e) {
            var t = zo(e),
                n = ft(e, or);
            return (t = "function" == typeof t ? t : void 0) && n.pop(), n.length && n[0] === e[0] ? mi(n, void 0, t) : [];
          });

          function zo(e) {
            var t = null == e ? 0 : e.length;
            return t ? e[t - 1] : void 0;
          }

          var Bo = Fi(Vo);

          function Vo(e, t) {
            return e && e.length && t && t.length ? Di(e, t) : e;
          }

          var Ho = Gr(function (e, t) {
            var n = null == e ? 0 : e.length,
                i = qn(e, t);
            return Ni(e, ft(t, function (e) {
              return ao(e, n) ? +e : e;
            }).sort(pr)), i;
          });

          function Wo(e) {
            return null == e ? e : hn.call(e);
          }

          var Go = Fi(function (e) {
            return Qi(oi(e, 1, ja, !0));
          }),
              Uo = Fi(function (e) {
            var t = zo(e);
            return ja(t) && (t = void 0), Qi(oi(e, 1, ja, !0), Kr(t, 2));
          }),
              Yo = Fi(function (e) {
            var t = zo(e);
            return t = "function" == typeof t ? t : void 0, Qi(oi(e, 1, ja, !0), void 0, t);
          });

          function Xo(e) {
            if (!e || !e.length) return [];
            var t = 0;
            return e = ct(e, function (e) {
              if (ja(e)) return t = an(e.length, t), !0;
            }), At(t, function (t) {
              return ft(e, Ct(t));
            });
          }

          function qo(e, t) {
            if (!e || !e.length) return [];
            var n = Xo(e);
            return null == t ? n : ft(n, function (e) {
              return ot(t, void 0, e);
            });
          }

          var Zo = Fi(function (e, t) {
            return ja(e) ? Jn(e, t) : [];
          }),
              Ko = Fi(function (e) {
            return ir(ct(e, ja));
          }),
              $o = Fi(function (e) {
            var t = zo(e);
            return ja(t) && (t = void 0), ir(ct(e, ja), Kr(t, 2));
          }),
              Qo = Fi(function (e) {
            var t = zo(e);
            return t = "function" == typeof t ? t : void 0, ir(ct(e, ja), void 0, t);
          }),
              Jo = Fi(Xo);
          var ea = Fi(function (e) {
            var t = e.length,
                n = t > 1 ? e[t - 1] : void 0;
            return n = "function" == typeof n ? (e.pop(), n) : void 0, qo(e, n);
          });

          function ta(e) {
            var t = En(e);
            return t.__chain__ = !0, t;
          }

          function na(e, t) {
            return t(e);
          }

          var ia = Gr(function (e) {
            var t = e.length,
                n = t ? e[0] : 0,
                i = this.__wrapped__,
                r = function r(t) {
              return qn(t, e);
            };

            return !(t > 1 || this.__actions__.length) && i instanceof On && ao(n) ? ((i = i.slice(n, +n + (t ? 1 : 0))).__actions__.push({
              func: na,
              args: [r],
              thisArg: void 0
            }), new Pn(i, this.__chain__).thru(function (e) {
              return t && !e.length && e.push(void 0), e;
            })) : this.thru(r);
          });
          var ra = xr(function (e, t, n) {
            Te.call(e, n) ? ++e[n] : Xn(e, n, 1);
          });
          var oa = kr(Oo),
              aa = kr(Lo);

          function sa(e, t) {
            return (La(e) ? st : ei)(e, Kr(t, 3));
          }

          function la(e, t) {
            return (La(e) ? lt : ti)(e, Kr(t, 3));
          }

          var ua = xr(function (e, t, n) {
            Te.call(e, n) ? e[n].push(t) : Xn(e, n, [t]);
          });
          var ca = Fi(function (e, t, n) {
            var r = -1,
                o = "function" == typeof t,
                a = Na(e) ? i(e.length) : [];
            return ei(e, function (e) {
              a[++r] = o ? ot(t, e, n) : yi(e, t, n);
            }), a;
          }),
              ha = xr(function (e, t, n) {
            Xn(e, n, t);
          });

          function da(e, t) {
            return (La(e) ? ft : Mi)(e, Kr(t, 3));
          }

          var fa = xr(function (e, t, n) {
            e[n ? 0 : 1].push(t);
          }, function () {
            return [[], []];
          });

          var pa = Fi(function (e, t) {
            if (null == e) return [];
            var n = t.length;
            return n > 1 && so(e, t[0], t[1]) ? t = [] : n > 2 && so(t[0], t[1], t[2]) && (t = [t[0]]), Oi(e, oi(t, 1), []);
          }),
              ga = Kt || function () {
            return Xe.Date.now();
          };

          function va(e, t, n) {
            return t = n ? void 0 : t, zr(e, 128, void 0, void 0, void 0, void 0, t = e && null == t ? e.length : t);
          }

          function ma(e, t) {
            var n;
            if ("function" != typeof t) throw new ye(o);
            return e = is(e), function () {
              return --e > 0 && (n = t.apply(this, arguments)), e <= 1 && (t = void 0), n;
            };
          }

          var ya = Fi(function (e, t, n) {
            var i = 1;

            if (n.length) {
              var r = Ht(n, Zr(ya));
              i |= 32;
            }

            return zr(e, i, t, n, r);
          }),
              xa = Fi(function (e, t, n) {
            var i = 3;

            if (n.length) {
              var r = Ht(n, Zr(xa));
              i |= 32;
            }

            return zr(t, i, e, n, r);
          });

          function _a(e, t, n) {
            var i,
                r,
                a,
                s,
                l,
                u,
                c = 0,
                h = !1,
                d = !1,
                f = !0;
            if ("function" != typeof e) throw new ye(o);

            function p(t) {
              var n = i,
                  o = r;
              return i = r = void 0, c = t, s = e.apply(o, n);
            }

            function g(e) {
              return c = e, l = _o(m, t), h ? p(e) : s;
            }

            function v(e) {
              var n = e - u;
              return void 0 === u || n >= t || n < 0 || d && e - c >= a;
            }

            function m() {
              var e = ga();
              if (v(e)) return y(e);
              l = _o(m, function (e) {
                var n = t - (e - u);
                return d ? sn(n, a - (e - c)) : n;
              }(e));
            }

            function y(e) {
              return l = void 0, f && i ? p(e) : (i = r = void 0, s);
            }

            function x() {
              var e = ga(),
                  n = v(e);

              if (i = arguments, r = this, u = e, n) {
                if (void 0 === l) return g(u);
                if (d) return cr(l), l = _o(m, t), p(u);
              }

              return void 0 === l && (l = _o(m, t)), s;
            }

            return t = os(t) || 0, Wa(n) && (h = !!n.leading, a = (d = "maxWait" in n) ? an(os(n.maxWait) || 0, t) : a, f = "trailing" in n ? !!n.trailing : f), x.cancel = function () {
              void 0 !== l && cr(l), c = 0, i = u = r = l = void 0;
            }, x.flush = function () {
              return void 0 === l ? s : y(ga());
            }, x;
          }

          var ba = Fi(function (e, t) {
            return Qn(e, 1, t);
          }),
              wa = Fi(function (e, t, n) {
            return Qn(e, os(t) || 0, n);
          });

          function Sa(e, t) {
            if ("function" != typeof e || null != t && "function" != typeof t) throw new ye(o);

            var n = function n() {
              var i = arguments,
                  r = t ? t.apply(this, i) : i[0],
                  o = n.cache;
              if (o.has(r)) return o.get(r);
              var a = e.apply(this, i);
              return n.cache = o.set(r, a) || o, a;
            };

            return n.cache = new (Sa.Cache || Nn)(), n;
          }

          function Ta(e) {
            if ("function" != typeof e) throw new ye(o);
            return function () {
              var t = arguments;

              switch (t.length) {
                case 0:
                  return !e.call(this);

                case 1:
                  return !e.call(this, t[0]);

                case 2:
                  return !e.call(this, t[0], t[1]);

                case 3:
                  return !e.call(this, t[0], t[1], t[2]);
              }

              return !e.apply(this, t);
            };
          }

          Sa.Cache = Nn;
          var Ca = lr(function (e, t) {
            var n = (t = 1 == t.length && La(t[0]) ? ft(t[0], It(Kr())) : ft(oi(t, 1), It(Kr()))).length;
            return Fi(function (i) {
              for (var r = -1, o = sn(i.length, n); ++r < o;) {
                i[r] = t[r].call(this, i[r]);
              }

              return ot(e, this, i);
            });
          }),
              ka = Fi(function (e, t) {
            return zr(e, 32, void 0, t, Ht(t, Zr(ka)));
          }),
              Ma = Fi(function (e, t) {
            return zr(e, 64, void 0, t, Ht(t, Zr(Ma)));
          }),
              Ea = Gr(function (e, t) {
            return zr(e, 256, void 0, void 0, void 0, t);
          });

          function Aa(e, t) {
            return e === t || e != e && t != t;
          }

          var Ia = Dr(pi),
              Pa = Dr(function (e, t) {
            return e >= t;
          }),
              Oa = xi(function () {
            return arguments;
          }()) ? xi : function (e) {
            return Ga(e) && Te.call(e, "callee") && !qe.call(e, "callee");
          },
              La = i.isArray,
              Da = Je ? It(Je) : function (e) {
            return Ga(e) && fi(e) == S;
          };

          function Na(e) {
            return null != e && Ha(e.length) && !Ba(e);
          }

          function ja(e) {
            return Ga(e) && Na(e);
          }

          var Ra = tn || ol,
              Fa = et ? It(et) : function (e) {
            return Ga(e) && fi(e) == h;
          };

          function za(e) {
            if (!Ga(e)) return !1;
            var t = fi(e);
            return t == d || "[object DOMException]" == t || "string" == typeof e.message && "string" == typeof e.name && !Xa(e);
          }

          function Ba(e) {
            if (!Wa(e)) return !1;
            var t = fi(e);
            return t == f || t == p || "[object AsyncFunction]" == t || "[object Proxy]" == t;
          }

          function Va(e) {
            return "number" == typeof e && e == is(e);
          }

          function Ha(e) {
            return "number" == typeof e && e > -1 && e % 1 == 0 && e <= 9007199254740991;
          }

          function Wa(e) {
            var t = typeof e;
            return null != e && ("object" == t || "function" == t);
          }

          function Ga(e) {
            return null != e && "object" == typeof e;
          }

          var Ua = tt ? It(tt) : function (e) {
            return Ga(e) && no(e) == g;
          };

          function Ya(e) {
            return "number" == typeof e || Ga(e) && fi(e) == v;
          }

          function Xa(e) {
            if (!Ga(e) || fi(e) != m) return !1;
            var t = Ue(e);
            if (null === t) return !0;
            var n = Te.call(t, "constructor") && t.constructor;
            return "function" == typeof n && n instanceof n && Se.call(n) == Ee;
          }

          var qa = nt ? It(nt) : function (e) {
            return Ga(e) && fi(e) == y;
          };
          var Za = it ? It(it) : function (e) {
            return Ga(e) && no(e) == x;
          };

          function Ka(e) {
            return "string" == typeof e || !La(e) && Ga(e) && fi(e) == _;
          }

          function $a(e) {
            return "symbol" == typeof e || Ga(e) && fi(e) == b;
          }

          var Qa = rt ? It(rt) : function (e) {
            return Ga(e) && Ha(e.length) && !!Be[fi(e)];
          };
          var Ja = Dr(ki),
              es = Dr(function (e, t) {
            return e <= t;
          });

          function ts(e) {
            if (!e) return [];
            if (Na(e)) return Ka(e) ? Yt(e) : mr(e);
            if (Qe && e[Qe]) return function (e) {
              for (var t, n = []; !(t = e.next()).done;) {
                n.push(t.value);
              }

              return n;
            }(e[Qe]());
            var t = no(e);
            return (t == g ? Bt : t == x ? Wt : As)(e);
          }

          function ns(e) {
            return e ? (e = os(e)) === 1 / 0 || e === -1 / 0 ? 17976931348623157e292 * (e < 0 ? -1 : 1) : e == e ? e : 0 : 0 === e ? e : 0;
          }

          function is(e) {
            var t = ns(e),
                n = t % 1;
            return t == t ? n ? t - n : t : 0;
          }

          function rs(e) {
            return e ? Zn(is(e), 0, 4294967295) : 0;
          }

          function os(e) {
            if ("number" == typeof e) return e;
            if ($a(e)) return NaN;

            if (Wa(e)) {
              var t = "function" == typeof e.valueOf ? e.valueOf() : e;
              e = Wa(t) ? t + "" : t;
            }

            if ("string" != typeof e) return 0 === e ? e : +e;
            e = e.replace(q, "");
            var n = oe.test(e);
            return n || se.test(e) ? Ge(e.slice(2), n ? 2 : 8) : re.test(e) ? NaN : +e;
          }

          function as(e) {
            return yr(e, bs(e));
          }

          function ss(e) {
            return null == e ? "" : $i(e);
          }

          var ls = _r(function (e, t) {
            if (ho(t) || Na(t)) yr(t, _s(t), e);else for (var n in t) {
              Te.call(t, n) && Wn(e, n, t[n]);
            }
          }),
              us = _r(function (e, t) {
            yr(t, bs(t), e);
          }),
              cs = _r(function (e, t, n, i) {
            yr(t, bs(t), e, i);
          }),
              hs = _r(function (e, t, n, i) {
            yr(t, _s(t), e, i);
          }),
              ds = Gr(qn);

          var fs = Fi(function (e, t) {
            e = ge(e);
            var n = -1,
                i = t.length,
                r = i > 2 ? t[2] : void 0;

            for (r && so(t[0], t[1], r) && (i = 1); ++n < i;) {
              for (var o = t[n], a = bs(o), s = -1, l = a.length; ++s < l;) {
                var u = a[s],
                    c = e[u];
                (void 0 === c || Aa(c, be[u]) && !Te.call(e, u)) && (e[u] = o[u]);
              }
            }

            return e;
          }),
              ps = Fi(function (e) {
            return e.push(void 0, Vr), ot(Ss, void 0, e);
          });

          function gs(e, t, n) {
            var i = null == e ? void 0 : hi(e, t);
            return void 0 === i ? n : i;
          }

          function vs(e, t) {
            return null != e && io(e, t, vi);
          }

          var ms = Ar(function (e, t, n) {
            null != t && "function" != typeof t.toString && (t = Me.call(t)), e[t] = n;
          }, Ws(Ys)),
              ys = Ar(function (e, t, n) {
            null != t && "function" != typeof t.toString && (t = Me.call(t)), Te.call(e, t) ? e[t].push(n) : e[t] = [n];
          }, Kr),
              xs = Fi(yi);

          function _s(e) {
            return Na(e) ? Fn(e) : Ti(e);
          }

          function bs(e) {
            return Na(e) ? Fn(e, !0) : Ci(e);
          }

          var ws = _r(function (e, t, n) {
            Ii(e, t, n);
          }),
              Ss = _r(function (e, t, n, i) {
            Ii(e, t, n, i);
          }),
              Ts = Gr(function (e, t) {
            var n = {};
            if (null == e) return n;
            var i = !1;
            t = ft(t, function (t) {
              return t = sr(t, e), i || (i = t.length > 1), t;
            }), yr(e, Yr(e), n), i && (n = Kn(n, 7, Hr));

            for (var r = t.length; r--;) {
              Ji(n, t[r]);
            }

            return n;
          });

          var Cs = Gr(function (e, t) {
            return null == e ? {} : function (e, t) {
              return Li(e, t, function (t, n) {
                return vs(e, n);
              });
            }(e, t);
          });

          function ks(e, t) {
            if (null == e) return {};
            var n = ft(Yr(e), function (e) {
              return [e];
            });
            return t = Kr(t), Li(e, n, function (e, n) {
              return t(e, n[0]);
            });
          }

          var Ms = Fr(_s),
              Es = Fr(bs);

          function As(e) {
            return null == e ? [] : Pt(e, _s(e));
          }

          var Is = Tr(function (e, t, n) {
            return t = t.toLowerCase(), e + (n ? Ps(t) : t);
          });

          function Ps(e) {
            return zs(ss(e).toLowerCase());
          }

          function Os(e) {
            return (e = ss(e)) && e.replace(ue, jt).replace(Le, "");
          }

          var Ls = Tr(function (e, t, n) {
            return e + (n ? "-" : "") + t.toLowerCase();
          }),
              Ds = Tr(function (e, t, n) {
            return e + (n ? " " : "") + t.toLowerCase();
          }),
              Ns = Sr("toLowerCase");
          var js = Tr(function (e, t, n) {
            return e + (n ? "_" : "") + t.toLowerCase();
          });
          var Rs = Tr(function (e, t, n) {
            return e + (n ? " " : "") + zs(t);
          });
          var Fs = Tr(function (e, t, n) {
            return e + (n ? " " : "") + t.toUpperCase();
          }),
              zs = Sr("toUpperCase");

          function Bs(e, t, n) {
            return e = ss(e), void 0 === (t = n ? void 0 : t) ? function (e) {
              return Re.test(e);
            }(e) ? function (e) {
              return e.match(Ne) || [];
            }(e) : function (e) {
              return e.match(ee) || [];
            }(e) : e.match(t) || [];
          }

          var Vs = Fi(function (e, t) {
            try {
              return ot(e, void 0, t);
            } catch (e) {
              return za(e) ? e : new de(e);
            }
          }),
              Hs = Gr(function (e, t) {
            return st(t, function (t) {
              t = ko(t), Xn(e, t, ya(e[t], e));
            }), e;
          });

          function Ws(e) {
            return function () {
              return e;
            };
          }

          var Gs = Mr(),
              Us = Mr(!0);

          function Ys(e) {
            return e;
          }

          function Xs(e) {
            return Si("function" == typeof e ? e : Kn(e, 1));
          }

          var qs = Fi(function (e, t) {
            return function (n) {
              return yi(n, e, t);
            };
          }),
              Zs = Fi(function (e, t) {
            return function (n) {
              return yi(e, n, t);
            };
          });

          function Ks(e, t, n) {
            var i = _s(t),
                r = ci(t, i);

            null != n || Wa(t) && (r.length || !i.length) || (n = t, t = e, e = this, r = ci(t, _s(t)));
            var o = !(Wa(n) && "chain" in n && !n.chain),
                a = Ba(e);
            return st(r, function (n) {
              var i = t[n];
              e[n] = i, a && (e.prototype[n] = function () {
                var t = this.__chain__;

                if (o || t) {
                  var n = e(this.__wrapped__),
                      r = n.__actions__ = mr(this.__actions__);
                  return r.push({
                    func: i,
                    args: arguments,
                    thisArg: e
                  }), n.__chain__ = t, n;
                }

                return i.apply(e, pt([this.value()], arguments));
              });
            }), e;
          }

          function $s() {}

          var Qs = Pr(ft),
              Js = Pr(ut),
              el = Pr(mt);

          function tl(e) {
            return lo(e) ? Ct(ko(e)) : function (e) {
              return function (t) {
                return hi(t, e);
              };
            }(e);
          }

          var nl = Lr(),
              il = Lr(!0);

          function rl() {
            return [];
          }

          function ol() {
            return !1;
          }

          var al = Ir(function (e, t) {
            return e + t;
          }, 0),
              sl = jr("ceil"),
              ll = Ir(function (e, t) {
            return e / t;
          }, 1),
              ul = jr("floor");
          var cl,
              hl = Ir(function (e, t) {
            return e * t;
          }, 1),
              dl = jr("round"),
              fl = Ir(function (e, t) {
            return e - t;
          }, 0);
          return En.after = function (e, t) {
            if ("function" != typeof t) throw new ye(o);
            return e = is(e), function () {
              if (--e < 1) return t.apply(this, arguments);
            };
          }, En.ary = va, En.assign = ls, En.assignIn = us, En.assignInWith = cs, En.assignWith = hs, En.at = ds, En.before = ma, En.bind = ya, En.bindAll = Hs, En.bindKey = xa, En.castArray = function () {
            if (!arguments.length) return [];
            var e = arguments[0];
            return La(e) ? e : [e];
          }, En.chain = ta, En.chunk = function (e, t, n) {
            t = (n ? so(e, t, n) : void 0 === t) ? 1 : an(is(t), 0);
            var r = null == e ? 0 : e.length;
            if (!r || t < 1) return [];

            for (var o = 0, a = 0, s = i(Qt(r / t)); o < r;) {
              s[a++] = Ui(e, o, o += t);
            }

            return s;
          }, En.compact = function (e) {
            for (var t = -1, n = null == e ? 0 : e.length, i = 0, r = []; ++t < n;) {
              var o = e[t];
              o && (r[i++] = o);
            }

            return r;
          }, En.concat = function () {
            var e = arguments.length;
            if (!e) return [];

            for (var t = i(e - 1), n = arguments[0], r = e; r--;) {
              t[r - 1] = arguments[r];
            }

            return pt(La(n) ? mr(n) : [n], oi(t, 1));
          }, En.cond = function (e) {
            var t = null == e ? 0 : e.length,
                n = Kr();
            return e = t ? ft(e, function (e) {
              if ("function" != typeof e[1]) throw new ye(o);
              return [n(e[0]), e[1]];
            }) : [], Fi(function (n) {
              for (var i = -1; ++i < t;) {
                var r = e[i];
                if (ot(r[0], this, n)) return ot(r[1], this, n);
              }
            });
          }, En.conforms = function (e) {
            return function (e) {
              var t = _s(e);

              return function (n) {
                return $n(n, e, t);
              };
            }(Kn(e, 1));
          }, En.constant = Ws, En.countBy = ra, En.create = function (e, t) {
            var n = An(e);
            return null == t ? n : Yn(n, t);
          }, En.curry = function e(t, n, i) {
            var r = zr(t, 8, void 0, void 0, void 0, void 0, void 0, n = i ? void 0 : n);
            return r.placeholder = e.placeholder, r;
          }, En.curryRight = function e(t, n, i) {
            var r = zr(t, 16, void 0, void 0, void 0, void 0, void 0, n = i ? void 0 : n);
            return r.placeholder = e.placeholder, r;
          }, En.debounce = _a, En.defaults = fs, En.defaultsDeep = ps, En.defer = ba, En.delay = wa, En.difference = Ao, En.differenceBy = Io, En.differenceWith = Po, En.drop = function (e, t, n) {
            var i = null == e ? 0 : e.length;
            return i ? Ui(e, (t = n || void 0 === t ? 1 : is(t)) < 0 ? 0 : t, i) : [];
          }, En.dropRight = function (e, t, n) {
            var i = null == e ? 0 : e.length;
            return i ? Ui(e, 0, (t = i - (t = n || void 0 === t ? 1 : is(t))) < 0 ? 0 : t) : [];
          }, En.dropRightWhile = function (e, t) {
            return e && e.length ? tr(e, Kr(t, 3), !0, !0) : [];
          }, En.dropWhile = function (e, t) {
            return e && e.length ? tr(e, Kr(t, 3), !0) : [];
          }, En.fill = function (e, t, n, i) {
            var r = null == e ? 0 : e.length;
            return r ? (n && "number" != typeof n && so(e, t, n) && (n = 0, i = r), function (e, t, n, i) {
              var r = e.length;

              for ((n = is(n)) < 0 && (n = -n > r ? 0 : r + n), (i = void 0 === i || i > r ? r : is(i)) < 0 && (i += r), i = n > i ? 0 : rs(i); n < i;) {
                e[n++] = t;
              }

              return e;
            }(e, t, n, i)) : [];
          }, En.filter = function (e, t) {
            return (La(e) ? ct : ri)(e, Kr(t, 3));
          }, En.flatMap = function (e, t) {
            return oi(da(e, t), 1);
          }, En.flatMapDeep = function (e, t) {
            return oi(da(e, t), 1 / 0);
          }, En.flatMapDepth = function (e, t, n) {
            return n = void 0 === n ? 1 : is(n), oi(da(e, t), n);
          }, En.flatten = Do, En.flattenDeep = function (e) {
            return (null == e ? 0 : e.length) ? oi(e, 1 / 0) : [];
          }, En.flattenDepth = function (e, t) {
            return (null == e ? 0 : e.length) ? oi(e, t = void 0 === t ? 1 : is(t)) : [];
          }, En.flip = function (e) {
            return zr(e, 512);
          }, En.flow = Gs, En.flowRight = Us, En.fromPairs = function (e) {
            for (var t = -1, n = null == e ? 0 : e.length, i = {}; ++t < n;) {
              var r = e[t];
              i[r[0]] = r[1];
            }

            return i;
          }, En.functions = function (e) {
            return null == e ? [] : ci(e, _s(e));
          }, En.functionsIn = function (e) {
            return null == e ? [] : ci(e, bs(e));
          }, En.groupBy = ua, En.initial = function (e) {
            return (null == e ? 0 : e.length) ? Ui(e, 0, -1) : [];
          }, En.intersection = jo, En.intersectionBy = Ro, En.intersectionWith = Fo, En.invert = ms, En.invertBy = ys, En.invokeMap = ca, En.iteratee = Xs, En.keyBy = ha, En.keys = _s, En.keysIn = bs, En.map = da, En.mapKeys = function (e, t) {
            var n = {};
            return t = Kr(t, 3), li(e, function (e, i, r) {
              Xn(n, t(e, i, r), e);
            }), n;
          }, En.mapValues = function (e, t) {
            var n = {};
            return t = Kr(t, 3), li(e, function (e, i, r) {
              Xn(n, i, t(e, i, r));
            }), n;
          }, En.matches = function (e) {
            return Ei(Kn(e, 1));
          }, En.matchesProperty = function (e, t) {
            return Ai(e, Kn(t, 1));
          }, En.memoize = Sa, En.merge = ws, En.mergeWith = Ss, En.method = qs, En.methodOf = Zs, En.mixin = Ks, En.negate = Ta, En.nthArg = function (e) {
            return e = is(e), Fi(function (t) {
              return Pi(t, e);
            });
          }, En.omit = Ts, En.omitBy = function (e, t) {
            return ks(e, Ta(Kr(t)));
          }, En.once = function (e) {
            return ma(2, e);
          }, En.orderBy = function (e, t, n, i) {
            return null == e ? [] : (La(t) || (t = null == t ? [] : [t]), La(n = i ? void 0 : n) || (n = null == n ? [] : [n]), Oi(e, t, n));
          }, En.over = Qs, En.overArgs = Ca, En.overEvery = Js, En.overSome = el, En.partial = ka, En.partialRight = Ma, En.partition = fa, En.pick = Cs, En.pickBy = ks, En.property = tl, En.propertyOf = function (e) {
            return function (t) {
              return null == e ? void 0 : hi(e, t);
            };
          }, En.pull = Bo, En.pullAll = Vo, En.pullAllBy = function (e, t, n) {
            return e && e.length && t && t.length ? Di(e, t, Kr(n, 2)) : e;
          }, En.pullAllWith = function (e, t, n) {
            return e && e.length && t && t.length ? Di(e, t, void 0, n) : e;
          }, En.pullAt = Ho, En.range = nl, En.rangeRight = il, En.rearg = Ea, En.reject = function (e, t) {
            return (La(e) ? ct : ri)(e, Ta(Kr(t, 3)));
          }, En.remove = function (e, t) {
            var n = [];
            if (!e || !e.length) return n;
            var i = -1,
                r = [],
                o = e.length;

            for (t = Kr(t, 3); ++i < o;) {
              var a = e[i];
              t(a, i, e) && (n.push(a), r.push(i));
            }

            return Ni(e, r), n;
          }, En.rest = function (e, t) {
            if ("function" != typeof e) throw new ye(o);
            return Fi(e, t = void 0 === t ? t : is(t));
          }, En.reverse = Wo, En.sampleSize = function (e, t, n) {
            return t = (n ? so(e, t, n) : void 0 === t) ? 1 : is(t), (La(e) ? Bn : Bi)(e, t);
          }, En.set = function (e, t, n) {
            return null == e ? e : Vi(e, t, n);
          }, En.setWith = function (e, t, n, i) {
            return i = "function" == typeof i ? i : void 0, null == e ? e : Vi(e, t, n, i);
          }, En.shuffle = function (e) {
            return (La(e) ? Vn : Gi)(e);
          }, En.slice = function (e, t, n) {
            var i = null == e ? 0 : e.length;
            return i ? (n && "number" != typeof n && so(e, t, n) ? (t = 0, n = i) : (t = null == t ? 0 : is(t), n = void 0 === n ? i : is(n)), Ui(e, t, n)) : [];
          }, En.sortBy = pa, En.sortedUniq = function (e) {
            return e && e.length ? Zi(e) : [];
          }, En.sortedUniqBy = function (e, t) {
            return e && e.length ? Zi(e, Kr(t, 2)) : [];
          }, En.split = function (e, t, n) {
            return n && "number" != typeof n && so(e, t, n) && (t = n = void 0), (n = void 0 === n ? 4294967295 : n >>> 0) ? (e = ss(e)) && ("string" == typeof t || null != t && !qa(t)) && !(t = $i(t)) && zt(e) ? ur(Yt(e), 0, n) : e.split(t, n) : [];
          }, En.spread = function (e, t) {
            if ("function" != typeof e) throw new ye(o);
            return t = null == t ? 0 : an(is(t), 0), Fi(function (n) {
              var i = n[t],
                  r = ur(n, 0, t);
              return i && pt(r, i), ot(e, this, r);
            });
          }, En.tail = function (e) {
            var t = null == e ? 0 : e.length;
            return t ? Ui(e, 1, t) : [];
          }, En.take = function (e, t, n) {
            return e && e.length ? Ui(e, 0, (t = n || void 0 === t ? 1 : is(t)) < 0 ? 0 : t) : [];
          }, En.takeRight = function (e, t, n) {
            var i = null == e ? 0 : e.length;
            return i ? Ui(e, (t = i - (t = n || void 0 === t ? 1 : is(t))) < 0 ? 0 : t, i) : [];
          }, En.takeRightWhile = function (e, t) {
            return e && e.length ? tr(e, Kr(t, 3), !1, !0) : [];
          }, En.takeWhile = function (e, t) {
            return e && e.length ? tr(e, Kr(t, 3)) : [];
          }, En.tap = function (e, t) {
            return t(e), e;
          }, En.throttle = function (e, t, n) {
            var i = !0,
                r = !0;
            if ("function" != typeof e) throw new ye(o);
            return Wa(n) && (i = "leading" in n ? !!n.leading : i, r = "trailing" in n ? !!n.trailing : r), _a(e, t, {
              leading: i,
              maxWait: t,
              trailing: r
            });
          }, En.thru = na, En.toArray = ts, En.toPairs = Ms, En.toPairsIn = Es, En.toPath = function (e) {
            return La(e) ? ft(e, ko) : $a(e) ? [e] : mr(Co(ss(e)));
          }, En.toPlainObject = as, En.transform = function (e, t, n) {
            var i = La(e),
                r = i || Ra(e) || Qa(e);

            if (t = Kr(t, 4), null == n) {
              var o = e && e.constructor;
              n = r ? i ? new o() : [] : Wa(e) && Ba(o) ? An(Ue(e)) : {};
            }

            return (r ? st : li)(e, function (e, i, r) {
              return t(n, e, i, r);
            }), n;
          }, En.unary = function (e) {
            return va(e, 1);
          }, En.union = Go, En.unionBy = Uo, En.unionWith = Yo, En.uniq = function (e) {
            return e && e.length ? Qi(e) : [];
          }, En.uniqBy = function (e, t) {
            return e && e.length ? Qi(e, Kr(t, 2)) : [];
          }, En.uniqWith = function (e, t) {
            return t = "function" == typeof t ? t : void 0, e && e.length ? Qi(e, void 0, t) : [];
          }, En.unset = function (e, t) {
            return null == e || Ji(e, t);
          }, En.unzip = Xo, En.unzipWith = qo, En.update = function (e, t, n) {
            return null == e ? e : er(e, t, ar(n));
          }, En.updateWith = function (e, t, n, i) {
            return i = "function" == typeof i ? i : void 0, null == e ? e : er(e, t, ar(n), i);
          }, En.values = As, En.valuesIn = function (e) {
            return null == e ? [] : Pt(e, bs(e));
          }, En.without = Zo, En.words = Bs, En.wrap = function (e, t) {
            return ka(ar(t), e);
          }, En.xor = Ko, En.xorBy = $o, En.xorWith = Qo, En.zip = Jo, En.zipObject = function (e, t) {
            return rr(e || [], t || [], Wn);
          }, En.zipObjectDeep = function (e, t) {
            return rr(e || [], t || [], Vi);
          }, En.zipWith = ea, En.entries = Ms, En.entriesIn = Es, En.extend = us, En.extendWith = cs, Ks(En, En), En.add = al, En.attempt = Vs, En.camelCase = Is, En.capitalize = Ps, En.ceil = sl, En.clamp = function (e, t, n) {
            return void 0 === n && (n = t, t = void 0), void 0 !== n && (n = (n = os(n)) == n ? n : 0), void 0 !== t && (t = (t = os(t)) == t ? t : 0), Zn(os(e), t, n);
          }, En.clone = function (e) {
            return Kn(e, 4);
          }, En.cloneDeep = function (e) {
            return Kn(e, 5);
          }, En.cloneDeepWith = function (e, t) {
            return Kn(e, 5, t = "function" == typeof t ? t : void 0);
          }, En.cloneWith = function (e, t) {
            return Kn(e, 4, t = "function" == typeof t ? t : void 0);
          }, En.conformsTo = function (e, t) {
            return null == t || $n(e, t, _s(t));
          }, En.deburr = Os, En.defaultTo = function (e, t) {
            return null == e || e != e ? t : e;
          }, En.divide = ll, En.endsWith = function (e, t, n) {
            e = ss(e), t = $i(t);
            var i = e.length,
                r = n = void 0 === n ? i : Zn(is(n), 0, i);
            return (n -= t.length) >= 0 && e.slice(n, r) == t;
          }, En.eq = Aa, En.escape = function (e) {
            return (e = ss(e)) && z.test(e) ? e.replace(R, Rt) : e;
          }, En.escapeRegExp = function (e) {
            return (e = ss(e)) && X.test(e) ? e.replace(Y, "\\$&") : e;
          }, En.every = function (e, t, n) {
            var i = La(e) ? ut : ni;
            return n && so(e, t, n) && (t = void 0), i(e, Kr(t, 3));
          }, En.find = oa, En.findIndex = Oo, En.findKey = function (e, t) {
            return xt(e, Kr(t, 3), li);
          }, En.findLast = aa, En.findLastIndex = Lo, En.findLastKey = function (e, t) {
            return xt(e, Kr(t, 3), ui);
          }, En.floor = ul, En.forEach = sa, En.forEachRight = la, En.forIn = function (e, t) {
            return null == e ? e : ai(e, Kr(t, 3), bs);
          }, En.forInRight = function (e, t) {
            return null == e ? e : si(e, Kr(t, 3), bs);
          }, En.forOwn = function (e, t) {
            return e && li(e, Kr(t, 3));
          }, En.forOwnRight = function (e, t) {
            return e && ui(e, Kr(t, 3));
          }, En.get = gs, En.gt = Ia, En.gte = Pa, En.has = function (e, t) {
            return null != e && io(e, t, gi);
          }, En.hasIn = vs, En.head = No, En.identity = Ys, En.includes = function (e, t, n, i) {
            e = Na(e) ? e : As(e), n = n && !i ? is(n) : 0;
            var r = e.length;
            return n < 0 && (n = an(r + n, 0)), Ka(e) ? n <= r && e.indexOf(t, n) > -1 : !!r && bt(e, t, n) > -1;
          }, En.indexOf = function (e, t, n) {
            var i = null == e ? 0 : e.length;
            if (!i) return -1;
            var r = null == n ? 0 : is(n);
            return r < 0 && (r = an(i + r, 0)), bt(e, t, r);
          }, En.inRange = function (e, t, n) {
            return t = ns(t), void 0 === n ? (n = t, t = 0) : n = ns(n), function (e, t, n) {
              return e >= sn(t, n) && e < an(t, n);
            }(e = os(e), t, n);
          }, En.invoke = xs, En.isArguments = Oa, En.isArray = La, En.isArrayBuffer = Da, En.isArrayLike = Na, En.isArrayLikeObject = ja, En.isBoolean = function (e) {
            return !0 === e || !1 === e || Ga(e) && fi(e) == c;
          }, En.isBuffer = Ra, En.isDate = Fa, En.isElement = function (e) {
            return Ga(e) && 1 === e.nodeType && !Xa(e);
          }, En.isEmpty = function (e) {
            if (null == e) return !0;
            if (Na(e) && (La(e) || "string" == typeof e || "function" == typeof e.splice || Ra(e) || Qa(e) || Oa(e))) return !e.length;
            var t = no(e);
            if (t == g || t == x) return !e.size;
            if (ho(e)) return !Ti(e).length;

            for (var n in e) {
              if (Te.call(e, n)) return !1;
            }

            return !0;
          }, En.isEqual = function (e, t) {
            return _i(e, t);
          }, En.isEqualWith = function (e, t, n) {
            var i = (n = "function" == typeof n ? n : void 0) ? n(e, t) : void 0;
            return void 0 === i ? _i(e, t, void 0, n) : !!i;
          }, En.isError = za, En.isFinite = function (e) {
            return "number" == typeof e && nn(e);
          }, En.isFunction = Ba, En.isInteger = Va, En.isLength = Ha, En.isMap = Ua, En.isMatch = function (e, t) {
            return e === t || bi(e, t, Qr(t));
          }, En.isMatchWith = function (e, t, n) {
            return n = "function" == typeof n ? n : void 0, bi(e, t, Qr(t), n);
          }, En.isNaN = function (e) {
            return Ya(e) && e != +e;
          }, En.isNative = function (e) {
            if (co(e)) throw new de("Unsupported core-js use. Try https://npms.io/search?q=ponyfill.");
            return wi(e);
          }, En.isNil = function (e) {
            return null == e;
          }, En.isNull = function (e) {
            return null === e;
          }, En.isNumber = Ya, En.isObject = Wa, En.isObjectLike = Ga, En.isPlainObject = Xa, En.isRegExp = qa, En.isSafeInteger = function (e) {
            return Va(e) && e >= -9007199254740991 && e <= 9007199254740991;
          }, En.isSet = Za, En.isString = Ka, En.isSymbol = $a, En.isTypedArray = Qa, En.isUndefined = function (e) {
            return void 0 === e;
          }, En.isWeakMap = function (e) {
            return Ga(e) && no(e) == w;
          }, En.isWeakSet = function (e) {
            return Ga(e) && "[object WeakSet]" == fi(e);
          }, En.join = function (e, t) {
            return null == e ? "" : rn.call(e, t);
          }, En.kebabCase = Ls, En.last = zo, En.lastIndexOf = function (e, t, n) {
            var i = null == e ? 0 : e.length;
            if (!i) return -1;
            var r = i;
            return void 0 !== n && (r = (r = is(n)) < 0 ? an(i + r, 0) : sn(r, i - 1)), t == t ? function (e, t, n) {
              for (var i = n + 1; i--;) {
                if (e[i] === t) return i;
              }

              return i;
            }(e, t, r) : _t(e, St, r, !0);
          }, En.lowerCase = Ds, En.lowerFirst = Ns, En.lt = Ja, En.lte = es, En.max = function (e) {
            return e && e.length ? ii(e, Ys, pi) : void 0;
          }, En.maxBy = function (e, t) {
            return e && e.length ? ii(e, Kr(t, 2), pi) : void 0;
          }, En.mean = function (e) {
            return Tt(e, Ys);
          }, En.meanBy = function (e, t) {
            return Tt(e, Kr(t, 2));
          }, En.min = function (e) {
            return e && e.length ? ii(e, Ys, ki) : void 0;
          }, En.minBy = function (e, t) {
            return e && e.length ? ii(e, Kr(t, 2), ki) : void 0;
          }, En.stubArray = rl, En.stubFalse = ol, En.stubObject = function () {
            return {};
          }, En.stubString = function () {
            return "";
          }, En.stubTrue = function () {
            return !0;
          }, En.multiply = hl, En.nth = function (e, t) {
            return e && e.length ? Pi(e, is(t)) : void 0;
          }, En.noConflict = function () {
            return Xe._ === this && (Xe._ = Ae), this;
          }, En.noop = $s, En.now = ga, En.pad = function (e, t, n) {
            e = ss(e);
            var i = (t = is(t)) ? Ut(e) : 0;
            if (!t || i >= t) return e;
            var r = (t - i) / 2;
            return Or(Jt(r), n) + e + Or(Qt(r), n);
          }, En.padEnd = function (e, t, n) {
            e = ss(e);
            var i = (t = is(t)) ? Ut(e) : 0;
            return t && i < t ? e + Or(t - i, n) : e;
          }, En.padStart = function (e, t, n) {
            e = ss(e);
            var i = (t = is(t)) ? Ut(e) : 0;
            return t && i < t ? Or(t - i, n) + e : e;
          }, En.parseInt = function (e, t, n) {
            return n || null == t ? t = 0 : t && (t = +t), un(ss(e).replace(Z, ""), t || 0);
          }, En.random = function (e, t, n) {
            if (n && "boolean" != typeof n && so(e, t, n) && (t = n = void 0), void 0 === n && ("boolean" == typeof t ? (n = t, t = void 0) : "boolean" == typeof e && (n = e, e = void 0)), void 0 === e && void 0 === t ? (e = 0, t = 1) : (e = ns(e), void 0 === t ? (t = e, e = 0) : t = ns(t)), e > t) {
              var i = e;
              e = t, t = i;
            }

            if (n || e % 1 || t % 1) {
              var r = cn();
              return sn(e + r * (t - e + We("1e-" + ((r + "").length - 1))), t);
            }

            return ji(e, t);
          }, En.reduce = function (e, t, n) {
            var i = La(e) ? gt : Mt,
                r = arguments.length < 3;
            return i(e, Kr(t, 4), n, r, ei);
          }, En.reduceRight = function (e, t, n) {
            var i = La(e) ? vt : Mt,
                r = arguments.length < 3;
            return i(e, Kr(t, 4), n, r, ti);
          }, En.repeat = function (e, t, n) {
            return t = (n ? so(e, t, n) : void 0 === t) ? 1 : is(t), Ri(ss(e), t);
          }, En.replace = function () {
            var e = arguments,
                t = ss(e[0]);
            return e.length < 3 ? t : t.replace(e[1], e[2]);
          }, En.result = function (e, t, n) {
            var i = -1,
                r = (t = sr(t, e)).length;

            for (r || (r = 1, e = void 0); ++i < r;) {
              var o = null == e ? void 0 : e[ko(t[i])];
              void 0 === o && (i = r, o = n), e = Ba(o) ? o.call(e) : o;
            }

            return e;
          }, En.round = dl, En.runInContext = e, En.sample = function (e) {
            return (La(e) ? zn : zi)(e);
          }, En.size = function (e) {
            if (null == e) return 0;
            if (Na(e)) return Ka(e) ? Ut(e) : e.length;
            var t = no(e);
            return t == g || t == x ? e.size : Ti(e).length;
          }, En.snakeCase = js, En.some = function (e, t, n) {
            var i = La(e) ? mt : Yi;
            return n && so(e, t, n) && (t = void 0), i(e, Kr(t, 3));
          }, En.sortedIndex = function (e, t) {
            return Xi(e, t);
          }, En.sortedIndexBy = function (e, t, n) {
            return qi(e, t, Kr(n, 2));
          }, En.sortedIndexOf = function (e, t) {
            var n = null == e ? 0 : e.length;

            if (n) {
              var i = Xi(e, t);
              if (i < n && Aa(e[i], t)) return i;
            }

            return -1;
          }, En.sortedLastIndex = function (e, t) {
            return Xi(e, t, !0);
          }, En.sortedLastIndexBy = function (e, t, n) {
            return qi(e, t, Kr(n, 2), !0);
          }, En.sortedLastIndexOf = function (e, t) {
            if (null == e ? 0 : e.length) {
              var n = Xi(e, t, !0) - 1;
              if (Aa(e[n], t)) return n;
            }

            return -1;
          }, En.startCase = Rs, En.startsWith = function (e, t, n) {
            return e = ss(e), n = null == n ? 0 : Zn(is(n), 0, e.length), t = $i(t), e.slice(n, n + t.length) == t;
          }, En.subtract = fl, En.sum = function (e) {
            return e && e.length ? Et(e, Ys) : 0;
          }, En.sumBy = function (e, t) {
            return e && e.length ? Et(e, Kr(t, 2)) : 0;
          }, En.template = function (e, t, n) {
            var i = En.templateSettings;
            n && so(e, t, n) && (t = void 0), e = ss(e), t = cs({}, t, i, Br);

            var r,
                o,
                a = cs({}, t.imports, i.imports, Br),
                s = _s(a),
                l = Pt(a, s),
                u = 0,
                c = t.interpolate || ce,
                h = "__p += '",
                d = ve((t.escape || ce).source + "|" + c.source + "|" + (c === H ? ne : ce).source + "|" + (t.evaluate || ce).source + "|$", "g"),
                f = "//# sourceURL=" + (Te.call(t, "sourceURL") ? (t.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++ze + "]") + "\n";

            e.replace(d, function (t, n, i, a, s, l) {
              return i || (i = a), h += e.slice(u, l).replace(he, Ft), n && (r = !0, h += "' +\n__e(" + n + ") +\n'"), s && (o = !0, h += "';\n" + s + ";\n__p += '"), i && (h += "' +\n((__t = (" + i + ")) == null ? '' : __t) +\n'"), u = l + t.length, t;
            }), h += "';\n";
            var p = Te.call(t, "variable") && t.variable;
            p || (h = "with (obj) {\n" + h + "\n}\n"), h = (o ? h.replace(L, "") : h).replace(D, "$1").replace(N, "$1;"), h = "function(" + (p || "obj") + ") {\n" + (p ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (r ? ", __e = _.escape" : "") + (o ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + h + "return __p\n}";
            var g = Vs(function () {
              return fe(s, f + "return " + h).apply(void 0, l);
            });
            if (g.source = h, za(g)) throw g;
            return g;
          }, En.times = function (e, t) {
            if ((e = is(e)) < 1 || e > 9007199254740991) return [];
            var n = 4294967295,
                i = sn(e, 4294967295);
            e -= 4294967295;

            for (var r = At(i, t = Kr(t)); ++n < e;) {
              t(n);
            }

            return r;
          }, En.toFinite = ns, En.toInteger = is, En.toLength = rs, En.toLower = function (e) {
            return ss(e).toLowerCase();
          }, En.toNumber = os, En.toSafeInteger = function (e) {
            return e ? Zn(is(e), -9007199254740991, 9007199254740991) : 0 === e ? e : 0;
          }, En.toString = ss, En.toUpper = function (e) {
            return ss(e).toUpperCase();
          }, En.trim = function (e, t, n) {
            if ((e = ss(e)) && (n || void 0 === t)) return e.replace(q, "");
            if (!e || !(t = $i(t))) return e;
            var i = Yt(e),
                r = Yt(t);
            return ur(i, Lt(i, r), Dt(i, r) + 1).join("");
          }, En.trimEnd = function (e, t, n) {
            if ((e = ss(e)) && (n || void 0 === t)) return e.replace(K, "");
            if (!e || !(t = $i(t))) return e;
            var i = Yt(e);
            return ur(i, 0, Dt(i, Yt(t)) + 1).join("");
          }, En.trimStart = function (e, t, n) {
            if ((e = ss(e)) && (n || void 0 === t)) return e.replace(Z, "");
            if (!e || !(t = $i(t))) return e;
            var i = Yt(e);
            return ur(i, Lt(i, Yt(t))).join("");
          }, En.truncate = function (e, t) {
            var n = 30,
                i = "...";

            if (Wa(t)) {
              var r = "separator" in t ? t.separator : r;
              n = "length" in t ? is(t.length) : n, i = "omission" in t ? $i(t.omission) : i;
            }

            var o = (e = ss(e)).length;

            if (zt(e)) {
              var a = Yt(e);
              o = a.length;
            }

            if (n >= o) return e;
            var s = n - Ut(i);
            if (s < 1) return i;
            var l = a ? ur(a, 0, s).join("") : e.slice(0, s);
            if (void 0 === r) return l + i;

            if (a && (s += l.length - s), qa(r)) {
              if (e.slice(s).search(r)) {
                var u,
                    c = l;

                for (r.global || (r = ve(r.source, ss(ie.exec(r)) + "g")), r.lastIndex = 0; u = r.exec(c);) {
                  var h = u.index;
                }

                l = l.slice(0, void 0 === h ? s : h);
              }
            } else if (e.indexOf($i(r), s) != s) {
              var d = l.lastIndexOf(r);
              d > -1 && (l = l.slice(0, d));
            }

            return l + i;
          }, En.unescape = function (e) {
            return (e = ss(e)) && F.test(e) ? e.replace(j, Xt) : e;
          }, En.uniqueId = function (e) {
            var t = ++Ce;
            return ss(e) + t;
          }, En.upperCase = Fs, En.upperFirst = zs, En.each = sa, En.eachRight = la, En.first = No, Ks(En, (cl = {}, li(En, function (e, t) {
            Te.call(En.prototype, t) || (cl[t] = e);
          }), cl), {
            chain: !1
          }), En.VERSION = "4.17.19", st(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function (e) {
            En[e].placeholder = En;
          }), st(["drop", "take"], function (e, t) {
            On.prototype[e] = function (n) {
              n = void 0 === n ? 1 : an(is(n), 0);
              var i = this.__filtered__ && !t ? new On(this) : this.clone();
              return i.__filtered__ ? i.__takeCount__ = sn(n, i.__takeCount__) : i.__views__.push({
                size: sn(n, 4294967295),
                type: e + (i.__dir__ < 0 ? "Right" : "")
              }), i;
            }, On.prototype[e + "Right"] = function (t) {
              return this.reverse()[e](t).reverse();
            };
          }), st(["filter", "map", "takeWhile"], function (e, t) {
            var n = t + 1,
                i = 1 == n || 3 == n;

            On.prototype[e] = function (e) {
              var t = this.clone();
              return t.__iteratees__.push({
                iteratee: Kr(e, 3),
                type: n
              }), t.__filtered__ = t.__filtered__ || i, t;
            };
          }), st(["head", "last"], function (e, t) {
            var n = "take" + (t ? "Right" : "");

            On.prototype[e] = function () {
              return this[n](1).value()[0];
            };
          }), st(["initial", "tail"], function (e, t) {
            var n = "drop" + (t ? "" : "Right");

            On.prototype[e] = function () {
              return this.__filtered__ ? new On(this) : this[n](1);
            };
          }), On.prototype.compact = function () {
            return this.filter(Ys);
          }, On.prototype.find = function (e) {
            return this.filter(e).head();
          }, On.prototype.findLast = function (e) {
            return this.reverse().find(e);
          }, On.prototype.invokeMap = Fi(function (e, t) {
            return "function" == typeof e ? new On(this) : this.map(function (n) {
              return yi(n, e, t);
            });
          }), On.prototype.reject = function (e) {
            return this.filter(Ta(Kr(e)));
          }, On.prototype.slice = function (e, t) {
            e = is(e);
            var n = this;
            return n.__filtered__ && (e > 0 || t < 0) ? new On(n) : (e < 0 ? n = n.takeRight(-e) : e && (n = n.drop(e)), void 0 !== t && (n = (t = is(t)) < 0 ? n.dropRight(-t) : n.take(t - e)), n);
          }, On.prototype.takeRightWhile = function (e) {
            return this.reverse().takeWhile(e).reverse();
          }, On.prototype.toArray = function () {
            return this.take(4294967295);
          }, li(On.prototype, function (e, t) {
            var n = /^(?:filter|find|map|reject)|While$/.test(t),
                i = /^(?:head|last)$/.test(t),
                r = En[i ? "take" + ("last" == t ? "Right" : "") : t],
                o = i || /^find/.test(t);
            r && (En.prototype[t] = function () {
              var t = this.__wrapped__,
                  a = i ? [1] : arguments,
                  s = t instanceof On,
                  l = a[0],
                  u = s || La(t),
                  c = function c(e) {
                var t = r.apply(En, pt([e], a));
                return i && h ? t[0] : t;
              };

              u && n && "function" == typeof l && 1 != l.length && (s = u = !1);
              var h = this.__chain__,
                  d = !!this.__actions__.length,
                  f = o && !h,
                  p = s && !d;

              if (!o && u) {
                t = p ? t : new On(this);
                var g = e.apply(t, a);
                return g.__actions__.push({
                  func: na,
                  args: [c],
                  thisArg: void 0
                }), new Pn(g, h);
              }

              return f && p ? e.apply(this, a) : (g = this.thru(c), f ? i ? g.value()[0] : g.value() : g);
            });
          }), st(["pop", "push", "shift", "sort", "splice", "unshift"], function (e) {
            var t = xe[e],
                n = /^(?:push|sort|unshift)$/.test(e) ? "tap" : "thru",
                i = /^(?:pop|shift)$/.test(e);

            En.prototype[e] = function () {
              var e = arguments;

              if (i && !this.__chain__) {
                var r = this.value();
                return t.apply(La(r) ? r : [], e);
              }

              return this[n](function (n) {
                return t.apply(La(n) ? n : [], e);
              });
            };
          }), li(On.prototype, function (e, t) {
            var n = En[t];

            if (n) {
              var i = n.name + "";
              Te.call(xn, i) || (xn[i] = []), xn[i].push({
                name: t,
                func: n
              });
            }
          }), xn[Er(void 0, 2).name] = [{
            name: "wrapper",
            func: void 0
          }], On.prototype.clone = function () {
            var e = new On(this.__wrapped__);
            return e.__actions__ = mr(this.__actions__), e.__dir__ = this.__dir__, e.__filtered__ = this.__filtered__, e.__iteratees__ = mr(this.__iteratees__), e.__takeCount__ = this.__takeCount__, e.__views__ = mr(this.__views__), e;
          }, On.prototype.reverse = function () {
            if (this.__filtered__) {
              var e = new On(this);
              e.__dir__ = -1, e.__filtered__ = !0;
            } else (e = this.clone()).__dir__ *= -1;

            return e;
          }, On.prototype.value = function () {
            var e = this.__wrapped__.value(),
                t = this.__dir__,
                n = La(e),
                i = t < 0,
                r = n ? e.length : 0,
                o = function (e, t, n) {
              var i = -1,
                  r = n.length;

              for (; ++i < r;) {
                var o = n[i],
                    a = o.size;

                switch (o.type) {
                  case "drop":
                    e += a;
                    break;

                  case "dropRight":
                    t -= a;
                    break;

                  case "take":
                    t = sn(t, e + a);
                    break;

                  case "takeRight":
                    e = an(e, t - a);
                }
              }

              return {
                start: e,
                end: t
              };
            }(0, r, this.__views__),
                a = o.start,
                s = o.end,
                l = s - a,
                u = i ? s : a - 1,
                c = this.__iteratees__,
                h = c.length,
                d = 0,
                f = sn(l, this.__takeCount__);

            if (!n || !i && r == l && f == l) return nr(e, this.__actions__);
            var p = [];

            e: for (; l-- && d < f;) {
              for (var g = -1, v = e[u += t]; ++g < h;) {
                var m = c[g],
                    y = m.iteratee,
                    x = m.type,
                    _ = y(v);

                if (2 == x) v = _;else if (!_) {
                  if (1 == x) continue e;
                  break e;
                }
              }

              p[d++] = v;
            }

            return p;
          }, En.prototype.at = ia, En.prototype.chain = function () {
            return ta(this);
          }, En.prototype.commit = function () {
            return new Pn(this.value(), this.__chain__);
          }, En.prototype.next = function () {
            void 0 === this.__values__ && (this.__values__ = ts(this.value()));
            var e = this.__index__ >= this.__values__.length;
            return {
              done: e,
              value: e ? void 0 : this.__values__[this.__index__++]
            };
          }, En.prototype.plant = function (e) {
            for (var t, n = this; n instanceof In;) {
              var i = Eo(n);
              i.__index__ = 0, i.__values__ = void 0, t ? r.__wrapped__ = i : t = i;
              var r = i;
              n = n.__wrapped__;
            }

            return r.__wrapped__ = e, t;
          }, En.prototype.reverse = function () {
            var e = this.__wrapped__;

            if (e instanceof On) {
              var t = e;
              return this.__actions__.length && (t = new On(this)), (t = t.reverse()).__actions__.push({
                func: na,
                args: [Wo],
                thisArg: void 0
              }), new Pn(t, this.__chain__);
            }

            return this.thru(Wo);
          }, En.prototype.toJSON = En.prototype.valueOf = En.prototype.value = function () {
            return nr(this.__wrapped__, this.__actions__);
          }, En.prototype.first = En.prototype.head, Qe && (En.prototype[Qe] = function () {
            return this;
          }), En;
        }();

        Xe._ = qt, void 0 === (r = function () {
          return qt;
        }.call(t, n, t, i)) || (i.exports = r);
      }).call(this);
    }).call(this, n(65), n(199)(e));
  }, function (e, t, n) {
    var i = n(4);
    !function () {
      for (var e in i) {
        if (null == i || !i.hasOwnProperty(e) || "default" === e || "__esModule" === e) return;
        t[e] = i[e];
      }
    }();
    var r = n(310);
    !function () {
      for (var e in r) {
        if (null == r || !r.hasOwnProperty(e) || "default" === e || "__esModule" === e) return;
        t[e] = r[e];
      }
    }(), n(308), n(691), n(702), n(707), n(712), n(716), n(726), n(740), n(746), n(754), n(769), n(773), n(777), n(789), n(795), n(800), n(806), n(810), n(816), n(820), n(823), n(837), n(843), n(849), n(850), n(862), n(344), n(337), n(865), n(869), n(870), n(882), n(132), n(887), n(894), n(895), n(904), n(907), n(910), n(913), n(353), n(919), n(357), n(356), n(925), n(358), n(367), n(930), n(933);
  }, function (e, t, n) {
    n(375), e.exports = n(956);
  }, function (e, t, n) {
    "use strict";

    n(376);
    var i,
        r = (i = n(547)) && i.__esModule ? i : {
      default: i
    };
    r.default._babelPolyfill && "undefined" != typeof console && console.warn && console.warn("@babel/polyfill is loaded more than once on this page. This is probably not desirable/intended and may have consequences if different versions of the polyfills are applied sequentially. If you do need to load the polyfill more than once, use @babel/polyfill/noConflict instead to bypass the warning."), r.default._babelPolyfill = !0;
  }, function (e, t, n) {
    "use strict";

    n(377), n(520), n(522), n(525), n(527), n(529), n(531), n(533), n(535), n(537), n(539), n(541), n(543), n(271);
  }, function (e, t, n) {
    n(378), n(381), n(382), n(383), n(384), n(385), n(386), n(387), n(388), n(389), n(390), n(391), n(392), n(393), n(394), n(395), n(396), n(397), n(398), n(399), n(400), n(401), n(402), n(403), n(404), n(405), n(406), n(407), n(408), n(409), n(410), n(411), n(412), n(413), n(414), n(415), n(416), n(417), n(418), n(419), n(420), n(421), n(422), n(424), n(425), n(426), n(427), n(428), n(429), n(430), n(431), n(432), n(433), n(434), n(435), n(436), n(437), n(438), n(439), n(440), n(441), n(442), n(443), n(444), n(445), n(446), n(447), n(448), n(449), n(450), n(451), n(452), n(453), n(454), n(455), n(456), n(457), n(459), n(460), n(462), n(463), n(464), n(465), n(466), n(467), n(468), n(470), n(471), n(472), n(473), n(474), n(475), n(476), n(477), n(478), n(479), n(480), n(481), n(482), n(191), n(483), n(260), n(484), n(261), n(485), n(486), n(487), n(488), n(262), n(491), n(492), n(493), n(494), n(495), n(496), n(497), n(498), n(499), n(500), n(501), n(502), n(503), n(504), n(505), n(506), n(507), n(508), n(509), n(510), n(511), n(512), n(513), n(514), n(515), n(516), n(517), n(518), n(519), e.exports = n(23);
  }, function (e, t, n) {
    "use strict";

    var i = n(10),
        r = n(36),
        o = n(24),
        a = n(3),
        s = n(33),
        l = n(64).KEY,
        u = n(11),
        c = n(136),
        h = n(93),
        d = n(74),
        f = n(18),
        p = n(172),
        g = n(241),
        v = n(380),
        m = n(139),
        y = n(12),
        x = n(13),
        _ = n(30),
        b = n(38),
        w = n(63),
        S = n(73),
        T = n(78),
        C = n(244),
        k = n(48),
        M = n(138),
        E = n(25),
        A = n(76),
        I = k.f,
        P = E.f,
        O = C.f,
        _L = i.Symbol,
        D = i.JSON,
        N = D && D.stringify,
        j = f("_hidden"),
        R = f("toPrimitive"),
        F = {}.propertyIsEnumerable,
        z = c("symbol-registry"),
        B = c("symbols"),
        V = c("op-symbols"),
        H = Object.prototype,
        W = "function" == typeof _L && !!M.f,
        G = i.QObject,
        U = !G || !G.prototype || !G.prototype.findChild,
        Y = o && u(function () {
      return 7 != T(P({}, "a", {
        get: function get() {
          return P(this, "a", {
            value: 7
          }).a;
        }
      })).a;
    }) ? function (e, t, n) {
      var i = I(H, t);
      i && delete H[t], P(e, t, n), i && e !== H && P(H, t, i);
    } : P,
        X = function X(e) {
      var t = B[e] = T(_L.prototype);
      return t._k = e, t;
    },
        q = W && "symbol" == typeof _L.iterator ? function (e) {
      return "symbol" == typeof e;
    } : function (e) {
      return e instanceof _L;
    },
        Z = function Z(e, t, n) {
      return e === H && Z(V, t, n), y(e), t = w(t, !0), y(n), r(B, t) ? (n.enumerable ? (r(e, j) && e[j][t] && (e[j][t] = !1), n = T(n, {
        enumerable: S(0, !1)
      })) : (r(e, j) || P(e, j, S(1, {})), e[j][t] = !0), Y(e, t, n)) : P(e, t, n);
    },
        K = function K(e, t) {
      y(e);

      for (var n, i = v(t = b(t)), r = 0, o = i.length; o > r;) {
        Z(e, n = i[r++], t[n]);
      }

      return e;
    },
        $ = function $(e) {
      var t = F.call(this, e = w(e, !0));
      return !(this === H && r(B, e) && !r(V, e)) && (!(t || !r(this, e) || !r(B, e) || r(this, j) && this[j][e]) || t);
    },
        Q = function Q(e, t) {
      if (e = b(e), t = w(t, !0), e !== H || !r(B, t) || r(V, t)) {
        var n = I(e, t);
        return !n || !r(B, t) || r(e, j) && e[j][t] || (n.enumerable = !0), n;
      }
    },
        J = function J(e) {
      for (var t, n = O(b(e)), i = [], o = 0; n.length > o;) {
        r(B, t = n[o++]) || t == j || t == l || i.push(t);
      }

      return i;
    },
        ee = function ee(e) {
      for (var t, n = e === H, i = O(n ? V : b(e)), o = [], a = 0; i.length > a;) {
        !r(B, t = i[a++]) || n && !r(H, t) || o.push(B[t]);
      }

      return o;
    };

    W || (s((_L = function L() {
      if (this instanceof _L) throw TypeError("Symbol is not a constructor!");

      var e = d(arguments.length > 0 ? arguments[0] : void 0),
          t = function t(n) {
        this === H && t.call(V, n), r(this, j) && r(this[j], e) && (this[j][e] = !1), Y(this, e, S(1, n));
      };

      return o && U && Y(H, e, {
        configurable: !0,
        set: t
      }), X(e);
    }).prototype, "toString", function () {
      return this._k;
    }), k.f = Q, E.f = Z, n(79).f = C.f = J, n(112).f = $, M.f = ee, o && !n(75) && s(H, "propertyIsEnumerable", $, !0), p.f = function (e) {
      return X(f(e));
    }), a(a.G + a.W + a.F * !W, {
      Symbol: _L
    });

    for (var te = "hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","), ne = 0; te.length > ne;) {
      f(te[ne++]);
    }

    for (var ie = A(f.store), re = 0; ie.length > re;) {
      g(ie[re++]);
    }

    a(a.S + a.F * !W, "Symbol", {
      for: function _for(e) {
        return r(z, e += "") ? z[e] : z[e] = _L(e);
      },
      keyFor: function keyFor(e) {
        if (!q(e)) throw TypeError(e + " is not a symbol!");

        for (var t in z) {
          if (z[t] === e) return t;
        }
      },
      useSetter: function useSetter() {
        U = !0;
      },
      useSimple: function useSimple() {
        U = !1;
      }
    }), a(a.S + a.F * !W, "Object", {
      create: function create(e, t) {
        return void 0 === t ? T(e) : K(T(e), t);
      },
      defineProperty: Z,
      defineProperties: K,
      getOwnPropertyDescriptor: Q,
      getOwnPropertyNames: J,
      getOwnPropertySymbols: ee
    });
    var oe = u(function () {
      M.f(1);
    });
    a(a.S + a.F * oe, "Object", {
      getOwnPropertySymbols: function getOwnPropertySymbols(e) {
        return M.f(_(e));
      }
    }), D && a(a.S + a.F * (!W || u(function () {
      var e = _L();

      return "[null]" != N([e]) || "{}" != N({
        a: e
      }) || "{}" != N(Object(e));
    })), "JSON", {
      stringify: function stringify(e) {
        for (var t, n, i = [e], r = 1; arguments.length > r;) {
          i.push(arguments[r++]);
        }

        if (n = t = i[1], (x(t) || void 0 !== e) && !q(e)) return m(t) || (t = function t(e, _t4) {
          if ("function" == typeof n && (_t4 = n.call(this, e, _t4)), !q(_t4)) return _t4;
        }), i[1] = t, N.apply(D, i);
      }
    }), _L.prototype[R] || n(37)(_L.prototype, R, _L.prototype.valueOf), h(_L, "Symbol"), h(Math, "Math", !0), h(i.JSON, "JSON", !0);
  }, function (e, t, n) {
    e.exports = n(136)("native-function-to-string", Function.toString);
  }, function (e, t, n) {
    var i = n(76),
        r = n(138),
        o = n(112);

    e.exports = function (e) {
      var t = i(e),
          n = r.f;
      if (n) for (var a, s = n(e), l = o.f, u = 0; s.length > u;) {
        l.call(e, a = s[u++]) && t.push(a);
      }
      return t;
    };
  }, function (e, t, n) {
    var i = n(3);
    i(i.S, "Object", {
      create: n(78)
    });
  }, function (e, t, n) {
    var i = n(3);
    i(i.S + i.F * !n(24), "Object", {
      defineProperty: n(25).f
    });
  }, function (e, t, n) {
    var i = n(3);
    i(i.S + i.F * !n(24), "Object", {
      defineProperties: n(243)
    });
  }, function (e, t, n) {
    var i = n(38),
        r = n(48).f;
    n(49)("getOwnPropertyDescriptor", function () {
      return function (e, t) {
        return r(i(e), t);
      };
    });
  }, function (e, t, n) {
    var i = n(30),
        r = n(80);
    n(49)("getPrototypeOf", function () {
      return function (e) {
        return r(i(e));
      };
    });
  }, function (e, t, n) {
    var i = n(30),
        r = n(76);
    n(49)("keys", function () {
      return function (e) {
        return r(i(e));
      };
    });
  }, function (e, t, n) {
    n(49)("getOwnPropertyNames", function () {
      return n(244).f;
    });
  }, function (e, t, n) {
    var i = n(13),
        r = n(64).onFreeze;
    n(49)("freeze", function (e) {
      return function (t) {
        return e && i(t) ? e(r(t)) : t;
      };
    });
  }, function (e, t, n) {
    var i = n(13),
        r = n(64).onFreeze;
    n(49)("seal", function (e) {
      return function (t) {
        return e && i(t) ? e(r(t)) : t;
      };
    });
  }, function (e, t, n) {
    var i = n(13),
        r = n(64).onFreeze;
    n(49)("preventExtensions", function (e) {
      return function (t) {
        return e && i(t) ? e(r(t)) : t;
      };
    });
  }, function (e, t, n) {
    var i = n(13);
    n(49)("isFrozen", function (e) {
      return function (t) {
        return !i(t) || !!e && e(t);
      };
    });
  }, function (e, t, n) {
    var i = n(13);
    n(49)("isSealed", function (e) {
      return function (t) {
        return !i(t) || !!e && e(t);
      };
    });
  }, function (e, t, n) {
    var i = n(13);
    n(49)("isExtensible", function (e) {
      return function (t) {
        return !!i(t) && (!e || e(t));
      };
    });
  }, function (e, t, n) {
    var i = n(3);
    i(i.S + i.F, "Object", {
      assign: n(245)
    });
  }, function (e, t, n) {
    var i = n(3);
    i(i.S, "Object", {
      is: n(246)
    });
  }, function (e, t, n) {
    var i = n(3);
    i(i.S, "Object", {
      setPrototypeOf: n(176).set
    });
  }, function (e, t, n) {
    "use strict";

    var i = n(113),
        r = {};
    r[n(18)("toStringTag")] = "z", r + "" != "[object z]" && n(33)(Object.prototype, "toString", function () {
      return "[object " + i(this) + "]";
    }, !0);
  }, function (e, t, n) {
    var i = n(3);
    i(i.P, "Function", {
      bind: n(247)
    });
  }, function (e, t, n) {
    var i = n(25).f,
        r = Function.prototype,
        o = /^\s*function ([^ (]*)/;
    "name" in r || n(24) && i(r, "name", {
      configurable: !0,
      get: function get() {
        try {
          return ("" + this).match(o)[1];
        } catch (e) {
          return "";
        }
      }
    });
  }, function (e, t, n) {
    "use strict";

    var i = n(13),
        r = n(80),
        o = n(18)("hasInstance"),
        a = Function.prototype;
    o in a || n(25).f(a, o, {
      value: function value(e) {
        if ("function" != typeof this || !i(e)) return !1;
        if (!i(this.prototype)) return e instanceof this;

        for (; e = r(e);) {
          if (this.prototype === e) return !0;
        }

        return !1;
      }
    });
  }, function (e, t, n) {
    var i = n(3),
        r = n(249);
    i(i.G + i.F * (parseInt != r), {
      parseInt: r
    });
  }, function (e, t, n) {
    var i = n(3),
        r = n(250);
    i(i.G + i.F * (parseFloat != r), {
      parseFloat: r
    });
  }, function (e, t, n) {
    "use strict";

    var i = n(10),
        r = n(36),
        o = n(57),
        a = n(178),
        s = n(63),
        l = n(11),
        u = n(79).f,
        c = n(48).f,
        h = n(25).f,
        d = n(94).trim,
        _f = i.Number,
        p = _f,
        g = _f.prototype,
        v = "Number" == o(n(78)(g)),
        m = ("trim" in String.prototype),
        y = function y(e) {
      var t = s(e, !1);

      if ("string" == typeof t && t.length > 2) {
        var n,
            i,
            r,
            o = (t = m ? t.trim() : d(t, 3)).charCodeAt(0);

        if (43 === o || 45 === o) {
          if (88 === (n = t.charCodeAt(2)) || 120 === n) return NaN;
        } else if (48 === o) {
          switch (t.charCodeAt(1)) {
            case 66:
            case 98:
              i = 2, r = 49;
              break;

            case 79:
            case 111:
              i = 8, r = 55;
              break;

            default:
              return +t;
          }

          for (var a, l = t.slice(2), u = 0, c = l.length; u < c; u++) {
            if ((a = l.charCodeAt(u)) < 48 || a > r) return NaN;
          }

          return parseInt(l, i);
        }
      }

      return +t;
    };

    if (!_f(" 0o1") || !_f("0b1") || _f("+0x1")) {
      _f = function f(e) {
        var t = arguments.length < 1 ? 0 : e,
            n = this;
        return n instanceof _f && (v ? l(function () {
          g.valueOf.call(n);
        }) : "Number" != o(n)) ? a(new p(y(t)), n, _f) : y(t);
      };

      for (var x, _ = n(24) ? u(p) : "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger".split(","), b = 0; _.length > b; b++) {
        r(p, x = _[b]) && !r(_f, x) && h(_f, x, c(p, x));
      }

      _f.prototype = g, g.constructor = _f, n(33)(i, "Number", _f);
    }
  }, function (e, t, n) {
    "use strict";

    var i = n(3),
        r = n(47),
        o = n(251),
        a = n(179),
        s = 1..toFixed,
        l = Math.floor,
        u = [0, 0, 0, 0, 0, 0],
        c = "Number.toFixed: incorrect invocation!",
        h = function h(e, t) {
      for (var n = -1, i = t; ++n < 6;) {
        i += e * u[n], u[n] = i % 1e7, i = l(i / 1e7);
      }
    },
        d = function d(e) {
      for (var t = 6, n = 0; --t >= 0;) {
        n += u[t], u[t] = l(n / e), n = n % e * 1e7;
      }
    },
        f = function f() {
      for (var e = 6, t = ""; --e >= 0;) {
        if ("" !== t || 0 === e || 0 !== u[e]) {
          var n = String(u[e]);
          t = "" === t ? n : t + a.call("0", 7 - n.length) + n;
        }
      }

      return t;
    },
        p = function p(e, t, n) {
      return 0 === t ? n : t % 2 == 1 ? p(e, t - 1, n * e) : p(e * e, t / 2, n);
    };

    i(i.P + i.F * (!!s && ("0.000" !== 8e-5.toFixed(3) || "1" !== .9.toFixed(0) || "1.25" !== 1.255.toFixed(2) || "1000000000000000128" !== 0xde0b6b3a7640080.toFixed(0)) || !n(11)(function () {
      s.call({});
    })), "Number", {
      toFixed: function toFixed(e) {
        var t,
            n,
            i,
            s,
            l = o(this, c),
            u = r(e),
            g = "",
            v = "0";
        if (u < 0 || u > 20) throw RangeError(c);
        if (l != l) return "NaN";
        if (l <= -1e21 || l >= 1e21) return String(l);
        if (l < 0 && (g = "-", l = -l), l > 1e-21) if (n = (t = function (e) {
          for (var t = 0, n = e; n >= 4096;) {
            t += 12, n /= 4096;
          }

          for (; n >= 2;) {
            t += 1, n /= 2;
          }

          return t;
        }(l * p(2, 69, 1)) - 69) < 0 ? l * p(2, -t, 1) : l / p(2, t, 1), n *= 4503599627370496, (t = 52 - t) > 0) {
          for (h(0, n), i = u; i >= 7;) {
            h(1e7, 0), i -= 7;
          }

          for (h(p(10, i, 1), 0), i = t - 1; i >= 23;) {
            d(1 << 23), i -= 23;
          }

          d(1 << i), h(1, 1), d(2), v = f();
        } else h(0, n), h(1 << -t, 0), v = f() + a.call("0", u);
        return v = u > 0 ? g + ((s = v.length) <= u ? "0." + a.call("0", u - s) + v : v.slice(0, s - u) + "." + v.slice(s - u)) : g + v;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var i = n(3),
        r = n(11),
        o = n(251),
        a = 1..toPrecision;
    i(i.P + i.F * (r(function () {
      return "1" !== a.call(1, void 0);
    }) || !r(function () {
      a.call({});
    })), "Number", {
      toPrecision: function toPrecision(e) {
        var t = o(this, "Number#toPrecision: incorrect invocation!");
        return void 0 === e ? a.call(t) : a.call(t, e);
      }
    });
  }, function (e, t, n) {
    var i = n(3);
    i(i.S, "Number", {
      EPSILON: Math.pow(2, -52)
    });
  }, function (e, t, n) {
    var i = n(3),
        r = n(10).isFinite;
    i(i.S, "Number", {
      isFinite: function isFinite(e) {
        return "number" == typeof e && r(e);
      }
    });
  }, function (e, t, n) {
    var i = n(3);
    i(i.S, "Number", {
      isInteger: n(252)
    });
  }, function (e, t, n) {
    var i = n(3);
    i(i.S, "Number", {
      isNaN: function isNaN(e) {
        return e != e;
      }
    });
  }, function (e, t, n) {
    var i = n(3),
        r = n(252),
        o = Math.abs;
    i(i.S, "Number", {
      isSafeInteger: function isSafeInteger(e) {
        return r(e) && o(e) <= 9007199254740991;
      }
    });
  }, function (e, t, n) {
    var i = n(3);
    i(i.S, "Number", {
      MAX_SAFE_INTEGER: 9007199254740991
    });
  }, function (e, t, n) {
    var i = n(3);
    i(i.S, "Number", {
      MIN_SAFE_INTEGER: -9007199254740991
    });
  }, function (e, t, n) {
    var i = n(3),
        r = n(250);
    i(i.S + i.F * (Number.parseFloat != r), "Number", {
      parseFloat: r
    });
  }, function (e, t, n) {
    var i = n(3),
        r = n(249);
    i(i.S + i.F * (Number.parseInt != r), "Number", {
      parseInt: r
    });
  }, function (e, t, n) {
    var i = n(3),
        r = n(253),
        o = Math.sqrt,
        a = Math.acosh;
    i(i.S + i.F * !(a && 710 == Math.floor(a(Number.MAX_VALUE)) && a(1 / 0) == 1 / 0), "Math", {
      acosh: function acosh(e) {
        return (e = +e) < 1 ? NaN : e > 94906265.62425156 ? Math.log(e) + Math.LN2 : r(e - 1 + o(e - 1) * o(e + 1));
      }
    });
  }, function (e, t, n) {
    var i = n(3),
        r = Math.asinh;
    i(i.S + i.F * !(r && 1 / r(0) > 0), "Math", {
      asinh: function e(t) {
        return isFinite(t = +t) && 0 != t ? t < 0 ? -e(-t) : Math.log(t + Math.sqrt(t * t + 1)) : t;
      }
    });
  }, function (e, t, n) {
    var i = n(3),
        r = Math.atanh;
    i(i.S + i.F * !(r && 1 / r(-0) < 0), "Math", {
      atanh: function atanh(e) {
        return 0 == (e = +e) ? e : Math.log((1 + e) / (1 - e)) / 2;
      }
    });
  }, function (e, t, n) {
    var i = n(3),
        r = n(180);
    i(i.S, "Math", {
      cbrt: function cbrt(e) {
        return r(e = +e) * Math.pow(Math.abs(e), 1 / 3);
      }
    });
  }, function (e, t, n) {
    var i = n(3);
    i(i.S, "Math", {
      clz32: function clz32(e) {
        return (e >>>= 0) ? 31 - Math.floor(Math.log(e + .5) * Math.LOG2E) : 32;
      }
    });
  }, function (e, t, n) {
    var i = n(3),
        r = Math.exp;
    i(i.S, "Math", {
      cosh: function cosh(e) {
        return (r(e = +e) + r(-e)) / 2;
      }
    });
  }, function (e, t, n) {
    var i = n(3),
        r = n(181);
    i(i.S + i.F * (r != Math.expm1), "Math", {
      expm1: r
    });
  }, function (e, t, n) {
    var i = n(3);
    i(i.S, "Math", {
      fround: n(423)
    });
  }, function (e, t, n) {
    var i = n(180),
        r = Math.pow,
        o = r(2, -52),
        a = r(2, -23),
        s = r(2, 127) * (2 - a),
        l = r(2, -126);

    e.exports = Math.fround || function (e) {
      var t,
          n,
          r = Math.abs(e),
          u = i(e);
      return r < l ? u * (r / l / a + 1 / o - 1 / o) * l * a : (n = (t = (1 + a / o) * r) - (t - r)) > s || n != n ? u * (1 / 0) : u * n;
    };
  }, function (e, t, n) {
    var i = n(3),
        r = Math.abs;
    i(i.S, "Math", {
      hypot: function hypot(e, t) {
        for (var n, i, o = 0, a = 0, s = arguments.length, l = 0; a < s;) {
          l < (n = r(arguments[a++])) ? (o = o * (i = l / n) * i + 1, l = n) : o += n > 0 ? (i = n / l) * i : n;
        }

        return l === 1 / 0 ? 1 / 0 : l * Math.sqrt(o);
      }
    });
  }, function (e, t, n) {
    var i = n(3),
        r = Math.imul;
    i(i.S + i.F * n(11)(function () {
      return -5 != r(4294967295, 5) || 2 != r.length;
    }), "Math", {
      imul: function imul(e, t) {
        var n = +e,
            i = +t,
            r = 65535 & n,
            o = 65535 & i;
        return 0 | r * o + ((65535 & n >>> 16) * o + r * (65535 & i >>> 16) << 16 >>> 0);
      }
    });
  }, function (e, t, n) {
    var i = n(3);
    i(i.S, "Math", {
      log10: function log10(e) {
        return Math.log(e) * Math.LOG10E;
      }
    });
  }, function (e, t, n) {
    var i = n(3);
    i(i.S, "Math", {
      log1p: n(253)
    });
  }, function (e, t, n) {
    var i = n(3);
    i(i.S, "Math", {
      log2: function log2(e) {
        return Math.log(e) / Math.LN2;
      }
    });
  }, function (e, t, n) {
    var i = n(3);
    i(i.S, "Math", {
      sign: n(180)
    });
  }, function (e, t, n) {
    var i = n(3),
        r = n(181),
        o = Math.exp;
    i(i.S + i.F * n(11)(function () {
      return -2e-17 != !Math.sinh(-2e-17);
    }), "Math", {
      sinh: function sinh(e) {
        return Math.abs(e = +e) < 1 ? (r(e) - r(-e)) / 2 : (o(e - 1) - o(-e - 1)) * (Math.E / 2);
      }
    });
  }, function (e, t, n) {
    var i = n(3),
        r = n(181),
        o = Math.exp;
    i(i.S, "Math", {
      tanh: function tanh(e) {
        var t = r(e = +e),
            n = r(-e);
        return t == 1 / 0 ? 1 : n == 1 / 0 ? -1 : (t - n) / (o(e) + o(-e));
      }
    });
  }, function (e, t, n) {
    var i = n(3);
    i(i.S, "Math", {
      trunc: function trunc(e) {
        return (e > 0 ? Math.floor : Math.ceil)(e);
      }
    });
  }, function (e, t, n) {
    var i = n(3),
        r = n(77),
        o = String.fromCharCode,
        a = String.fromCodePoint;
    i(i.S + i.F * (!!a && 1 != a.length), "String", {
      fromCodePoint: function fromCodePoint(e) {
        for (var t, n = [], i = arguments.length, a = 0; i > a;) {
          if (t = +arguments[a++], r(t, 1114111) !== t) throw RangeError(t + " is not a valid code point");
          n.push(t < 65536 ? o(t) : o(55296 + ((t -= 65536) >> 10), t % 1024 + 56320));
        }

        return n.join("");
      }
    });
  }, function (e, t, n) {
    var i = n(3),
        r = n(38),
        o = n(19);
    i(i.S, "String", {
      raw: function raw(e) {
        for (var t = r(e.raw), n = o(t.length), i = arguments.length, a = [], s = 0; n > s;) {
          a.push(String(t[s++])), s < i && a.push(String(arguments[s]));
        }

        return a.join("");
      }
    });
  }, function (e, t, n) {
    "use strict";

    n(94)("trim", function (e) {
      return function () {
        return e(this, 3);
      };
    });
  }, function (e, t, n) {
    "use strict";

    var i = n(182)(!0);
    n(183)(String, "String", function (e) {
      this._t = String(e), this._i = 0;
    }, function () {
      var e,
          t = this._t,
          n = this._i;
      return n >= t.length ? {
        value: void 0,
        done: !0
      } : (e = i(t, n), this._i += e.length, {
        value: e,
        done: !1
      });
    });
  }, function (e, t, n) {
    "use strict";

    var i = n(3),
        r = n(182)(!1);
    i(i.P, "String", {
      codePointAt: function codePointAt(e) {
        return r(this, e);
      }
    });
  }, function (e, t, n) {
    "use strict";

    var i = n(3),
        r = n(19),
        o = n(184),
        a = "".endsWith;
    i(i.P + i.F * n(186)("endsWith"), "String", {
      endsWith: function endsWith(e) {
        var t = o(this, e, "endsWith"),
            n = arguments.length > 1 ? arguments[1] : void 0,
            i = r(t.length),
            s = void 0 === n ? i : Math.min(r(n), i),
            l = String(e);
        return a ? a.call(t, l, s) : t.slice(s - l.length, s) === l;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var i = n(3),
        r = n(184);
    i(i.P + i.F * n(186)("includes"), "String", {
      includes: function includes(e) {
        return !!~r(this, e, "includes").indexOf(e, arguments.length > 1 ? arguments[1] : void 0);
      }
    });
  }, function (e, t, n) {
    var i = n(3);
    i(i.P, "String", {
      repeat: n(179)
    });
  }, function (e, t, n) {
    "use strict";

    var i = n(3),
        r = n(19),
        o = n(184),
        a = "".startsWith;
    i(i.P + i.F * n(186)("startsWith"), "String", {
      startsWith: function startsWith(e) {
        var t = o(this, e, "startsWith"),
            n = r(Math.min(arguments.length > 1 ? arguments[1] : void 0, t.length)),
            i = String(e);
        return a ? a.call(t, i, n) : t.slice(n, n + i.length) === i;
      }
    });
  }, function (e, t, n) {
    "use strict";

    n(34)("anchor", function (e) {
      return function (t) {
        return e(this, "a", "name", t);
      };
    });
  }, function (e, t, n) {
    "use strict";

    n(34)("big", function (e) {
      return function () {
        return e(this, "big", "", "");
      };
    });
  }, function (e, t, n) {
    "use strict";

    n(34)("blink", function (e) {
      return function () {
        return e(this, "blink", "", "");
      };
    });
  }, function (e, t, n) {
    "use strict";

    n(34)("bold", function (e) {
      return function () {
        return e(this, "b", "", "");
      };
    });
  }, function (e, t, n) {
    "use strict";

    n(34)("fixed", function (e) {
      return function () {
        return e(this, "tt", "", "");
      };
    });
  }, function (e, t, n) {
    "use strict";

    n(34)("fontcolor", function (e) {
      return function (t) {
        return e(this, "font", "color", t);
      };
    });
  }, function (e, t, n) {
    "use strict";

    n(34)("fontsize", function (e) {
      return function (t) {
        return e(this, "font", "size", t);
      };
    });
  }, function (e, t, n) {
    "use strict";

    n(34)("italics", function (e) {
      return function () {
        return e(this, "i", "", "");
      };
    });
  }, function (e, t, n) {
    "use strict";

    n(34)("link", function (e) {
      return function (t) {
        return e(this, "a", "href", t);
      };
    });
  }, function (e, t, n) {
    "use strict";

    n(34)("small", function (e) {
      return function () {
        return e(this, "small", "", "");
      };
    });
  }, function (e, t, n) {
    "use strict";

    n(34)("strike", function (e) {
      return function () {
        return e(this, "strike", "", "");
      };
    });
  }, function (e, t, n) {
    "use strict";

    n(34)("sub", function (e) {
      return function () {
        return e(this, "sub", "", "");
      };
    });
  }, function (e, t, n) {
    "use strict";

    n(34)("sup", function (e) {
      return function () {
        return e(this, "sup", "", "");
      };
    });
  }, function (e, t, n) {
    var i = n(3);
    i(i.S, "Date", {
      now: function now() {
        return new Date().getTime();
      }
    });
  }, function (e, t, n) {
    "use strict";

    var i = n(3),
        r = n(30),
        o = n(63);
    i(i.P + i.F * n(11)(function () {
      return null !== new Date(NaN).toJSON() || 1 !== Date.prototype.toJSON.call({
        toISOString: function toISOString() {
          return 1;
        }
      });
    }), "Date", {
      toJSON: function toJSON(e) {
        var t = r(this),
            n = o(t);
        return "number" != typeof n || isFinite(n) ? t.toISOString() : null;
      }
    });
  }, function (e, t, n) {
    var i = n(3),
        r = n(458);
    i(i.P + i.F * (Date.prototype.toISOString !== r), "Date", {
      toISOString: r
    });
  }, function (e, t, n) {
    "use strict";

    var i = n(11),
        r = Date.prototype.getTime,
        o = Date.prototype.toISOString,
        a = function a(e) {
      return e > 9 ? e : "0" + e;
    };

    e.exports = i(function () {
      return "0385-07-25T07:06:39.999Z" != o.call(new Date(-50000000000001));
    }) || !i(function () {
      o.call(new Date(NaN));
    }) ? function () {
      if (!isFinite(r.call(this))) throw RangeError("Invalid time value");
      var e = this,
          t = e.getUTCFullYear(),
          n = e.getUTCMilliseconds(),
          i = t < 0 ? "-" : t > 9999 ? "+" : "";
      return i + ("00000" + Math.abs(t)).slice(i ? -6 : -4) + "-" + a(e.getUTCMonth() + 1) + "-" + a(e.getUTCDate()) + "T" + a(e.getUTCHours()) + ":" + a(e.getUTCMinutes()) + ":" + a(e.getUTCSeconds()) + "." + (n > 99 ? n : "0" + a(n)) + "Z";
    } : o;
  }, function (e, t, n) {
    var i = Date.prototype,
        r = i.toString,
        o = i.getTime;
    new Date(NaN) + "" != "Invalid Date" && n(33)(i, "toString", function () {
      var e = o.call(this);
      return e == e ? r.call(this) : "Invalid Date";
    });
  }, function (e, t, n) {
    var i = n(18)("toPrimitive"),
        r = Date.prototype;
    i in r || n(37)(r, i, n(461));
  }, function (e, t, n) {
    "use strict";

    var i = n(12),
        r = n(63);

    e.exports = function (e) {
      if ("string" !== e && "number" !== e && "default" !== e) throw TypeError("Incorrect hint");
      return r(i(this), "number" != e);
    };
  }, function (e, t, n) {
    var i = n(3);
    i(i.S, "Array", {
      isArray: n(139)
    });
  }, function (e, t, n) {
    "use strict";

    var i = n(45),
        r = n(3),
        o = n(30),
        a = n(255),
        s = n(187),
        l = n(19),
        u = n(188),
        c = n(189);
    r(r.S + r.F * !n(140)(function (e) {
      Array.from(e);
    }), "Array", {
      from: function from(e) {
        var t,
            n,
            r,
            h,
            d = o(e),
            f = "function" == typeof this ? this : Array,
            p = arguments.length,
            g = p > 1 ? arguments[1] : void 0,
            v = void 0 !== g,
            m = 0,
            y = c(d);
        if (v && (g = i(g, p > 2 ? arguments[2] : void 0, 2)), null == y || f == Array && s(y)) for (n = new f(t = l(d.length)); t > m; m++) {
          u(n, m, v ? g(d[m], m) : d[m]);
        } else for (h = y.call(d), n = new f(); !(r = h.next()).done; m++) {
          u(n, m, v ? a(h, g, [r.value, m], !0) : r.value);
        }
        return n.length = m, n;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var i = n(3),
        r = n(188);
    i(i.S + i.F * n(11)(function () {
      function e() {}

      return !(Array.of.call(e) instanceof e);
    }), "Array", {
      of: function of() {
        for (var e = 0, t = arguments.length, n = new ("function" == typeof this ? this : Array)(t); t > e;) {
          r(n, e, arguments[e++]);
        }

        return n.length = t, n;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var i = n(3),
        r = n(38),
        o = [].join;
    i(i.P + i.F * (n(111) != Object || !n(41)(o)), "Array", {
      join: function join(e) {
        return o.call(r(this), void 0 === e ? "," : e);
      }
    });
  }, function (e, t, n) {
    "use strict";

    var i = n(3),
        r = n(175),
        o = n(57),
        a = n(77),
        s = n(19),
        l = [].slice;
    i(i.P + i.F * n(11)(function () {
      r && l.call(r);
    }), "Array", {
      slice: function slice(e, t) {
        var n = s(this.length),
            i = o(this);
        if (t = void 0 === t ? n : t, "Array" == i) return l.call(this, e, t);

        for (var r = a(e, n), u = a(t, n), c = s(u - r), h = new Array(c), d = 0; d < c; d++) {
          h[d] = "String" == i ? this.charAt(r + d) : this[r + d];
        }

        return h;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var i = n(3),
        r = n(46),
        o = n(30),
        a = n(11),
        s = [].sort,
        l = [1, 2, 3];
    i(i.P + i.F * (a(function () {
      l.sort(void 0);
    }) || !a(function () {
      l.sort(null);
    }) || !n(41)(s)), "Array", {
      sort: function sort(e) {
        return void 0 === e ? s.call(o(this)) : s.call(o(this), r(e));
      }
    });
  }, function (e, t, n) {
    "use strict";

    var i = n(3),
        r = n(50)(0),
        o = n(41)([].forEach, !0);
    i(i.P + i.F * !o, "Array", {
      forEach: function forEach(e) {
        return r(this, e, arguments[1]);
      }
    });
  }, function (e, t, n) {
    var i = n(13),
        r = n(139),
        o = n(18)("species");

    e.exports = function (e) {
      var t;
      return r(e) && ("function" != typeof (t = e.constructor) || t !== Array && !r(t.prototype) || (t = void 0), i(t) && null === (t = t[o]) && (t = void 0)), void 0 === t ? Array : t;
    };
  }, function (e, t, n) {
    "use strict";

    var i = n(3),
        r = n(50)(1);
    i(i.P + i.F * !n(41)([].map, !0), "Array", {
      map: function map(e) {
        return r(this, e, arguments[1]);
      }
    });
  }, function (e, t, n) {
    "use strict";

    var i = n(3),
        r = n(50)(2);
    i(i.P + i.F * !n(41)([].filter, !0), "Array", {
      filter: function filter(e) {
        return r(this, e, arguments[1]);
      }
    });
  }, function (e, t, n) {
    "use strict";

    var i = n(3),
        r = n(50)(3);
    i(i.P + i.F * !n(41)([].some, !0), "Array", {
      some: function some(e) {
        return r(this, e, arguments[1]);
      }
    });
  }, function (e, t, n) {
    "use strict";

    var i = n(3),
        r = n(50)(4);
    i(i.P + i.F * !n(41)([].every, !0), "Array", {
      every: function every(e) {
        return r(this, e, arguments[1]);
      }
    });
  }, function (e, t, n) {
    "use strict";

    var i = n(3),
        r = n(257);
    i(i.P + i.F * !n(41)([].reduce, !0), "Array", {
      reduce: function reduce(e) {
        return r(this, e, arguments.length, arguments[1], !1);
      }
    });
  }, function (e, t, n) {
    "use strict";

    var i = n(3),
        r = n(257);
    i(i.P + i.F * !n(41)([].reduceRight, !0), "Array", {
      reduceRight: function reduceRight(e) {
        return r(this, e, arguments.length, arguments[1], !0);
      }
    });
  }, function (e, t, n) {
    "use strict";

    var i = n(3),
        r = n(137)(!1),
        o = [].indexOf,
        a = !!o && 1 / [1].indexOf(1, -0) < 0;
    i(i.P + i.F * (a || !n(41)(o)), "Array", {
      indexOf: function indexOf(e) {
        return a ? o.apply(this, arguments) || 0 : r(this, e, arguments[1]);
      }
    });
  }, function (e, t, n) {
    "use strict";

    var i = n(3),
        r = n(38),
        o = n(47),
        a = n(19),
        s = [].lastIndexOf,
        l = !!s && 1 / [1].lastIndexOf(1, -0) < 0;
    i(i.P + i.F * (l || !n(41)(s)), "Array", {
      lastIndexOf: function lastIndexOf(e) {
        if (l) return s.apply(this, arguments) || 0;
        var t = r(this),
            n = a(t.length),
            i = n - 1;

        for (arguments.length > 1 && (i = Math.min(i, o(arguments[1]))), i < 0 && (i = n + i); i >= 0; i--) {
          if (i in t && t[i] === e) return i || 0;
        }

        return -1;
      }
    });
  }, function (e, t, n) {
    var i = n(3);
    i(i.P, "Array", {
      copyWithin: n(258)
    }), n(81)("copyWithin");
  }, function (e, t, n) {
    var i = n(3);
    i(i.P, "Array", {
      fill: n(190)
    }), n(81)("fill");
  }, function (e, t, n) {
    "use strict";

    var i = n(3),
        r = n(50)(5),
        o = !0;
    "find" in [] && Array(1).find(function () {
      o = !1;
    }), i(i.P + i.F * o, "Array", {
      find: function find(e) {
        return r(this, e, arguments.length > 1 ? arguments[1] : void 0);
      }
    }), n(81)("find");
  }, function (e, t, n) {
    "use strict";

    var i = n(3),
        r = n(50)(6),
        o = "findIndex",
        a = !0;
    o in [] && Array(1)[o](function () {
      a = !1;
    }), i(i.P + i.F * a, "Array", {
      findIndex: function findIndex(e) {
        return r(this, e, arguments.length > 1 ? arguments[1] : void 0);
      }
    }), n(81)(o);
  }, function (e, t, n) {
    n(96)("Array");
  }, function (e, t, n) {
    var i = n(10),
        r = n(178),
        o = n(25).f,
        a = n(79).f,
        s = n(185),
        l = n(141),
        _u = i.RegExp,
        c = _u,
        h = _u.prototype,
        d = /a/g,
        f = /a/g,
        p = new _u(d) !== d;

    if (n(24) && (!p || n(11)(function () {
      return f[n(18)("match")] = !1, _u(d) != d || _u(f) == f || "/a/i" != _u(d, "i");
    }))) {
      _u = function u(e, t) {
        var n = this instanceof _u,
            i = s(e),
            o = void 0 === t;
        return !n && i && e.constructor === _u && o ? e : r(p ? new c(i && !o ? e.source : e, t) : c((i = e instanceof _u) ? e.source : e, i && o ? l.call(e) : t), n ? this : h, _u);
      };

      for (var g = function g(e) {
        (e in _u) || o(_u, e, {
          configurable: !0,
          get: function get() {
            return c[e];
          },
          set: function set(t) {
            c[e] = t;
          }
        });
      }, v = a(c), m = 0; v.length > m;) {
        g(v[m++]);
      }

      h.constructor = _u, _u.prototype = h, n(33)(i, "RegExp", _u);
    }

    n(96)("RegExp");
  }, function (e, t, n) {
    "use strict";

    n(261);

    var i = n(12),
        r = n(141),
        o = n(24),
        a = /./.toString,
        s = function s(e) {
      n(33)(RegExp.prototype, "toString", e, !0);
    };

    n(11)(function () {
      return "/a/b" != a.call({
        source: "a",
        flags: "b"
      });
    }) ? s(function () {
      var e = i(this);
      return "/".concat(e.source, "/", "flags" in e ? e.flags : !o && e instanceof RegExp ? r.call(e) : void 0);
    }) : "toString" != a.name && s(function () {
      return a.call(this);
    });
  }, function (e, t, n) {
    "use strict";

    var i = n(12),
        r = n(19),
        o = n(193),
        a = n(142);
    n(143)("match", 1, function (e, t, n, s) {
      return [function (n) {
        var i = e(this),
            r = null == n ? void 0 : n[t];
        return void 0 !== r ? r.call(n, i) : new RegExp(n)[t](String(i));
      }, function (e) {
        var t = s(n, e, this);
        if (t.done) return t.value;
        var l = i(e),
            u = String(this);
        if (!l.global) return a(l, u);
        var c = l.unicode;
        l.lastIndex = 0;

        for (var h, d = [], f = 0; null !== (h = a(l, u));) {
          var p = String(h[0]);
          d[f] = p, "" === p && (l.lastIndex = o(u, r(l.lastIndex), c)), f++;
        }

        return 0 === f ? null : d;
      }];
    });
  }, function (e, t, n) {
    "use strict";

    var i = n(12),
        r = n(30),
        o = n(19),
        a = n(47),
        s = n(193),
        l = n(142),
        u = Math.max,
        c = Math.min,
        h = Math.floor,
        d = /\$([$&`']|\d\d?|<[^>]*>)/g,
        f = /\$([$&`']|\d\d?)/g;
    n(143)("replace", 2, function (e, t, n, p) {
      return [function (i, r) {
        var o = e(this),
            a = null == i ? void 0 : i[t];
        return void 0 !== a ? a.call(i, o, r) : n.call(String(o), i, r);
      }, function (e, t) {
        var r = p(n, e, this, t);
        if (r.done) return r.value;
        var h = i(e),
            d = String(this),
            f = "function" == typeof t;
        f || (t = String(t));
        var v = h.global;

        if (v) {
          var m = h.unicode;
          h.lastIndex = 0;
        }

        for (var y = [];;) {
          var x = l(h, d);
          if (null === x) break;
          if (y.push(x), !v) break;
          "" === String(x[0]) && (h.lastIndex = s(d, o(h.lastIndex), m));
        }

        for (var _, b = "", w = 0, S = 0; S < y.length; S++) {
          x = y[S];

          for (var T = String(x[0]), C = u(c(a(x.index), d.length), 0), k = [], M = 1; M < x.length; M++) {
            k.push(void 0 === (_ = x[M]) ? _ : String(_));
          }

          var E = x.groups;

          if (f) {
            var A = [T].concat(k, C, d);
            void 0 !== E && A.push(E);
            var I = String(t.apply(void 0, A));
          } else I = g(T, d, C, k, E, t);

          C >= w && (b += d.slice(w, C) + I, w = C + T.length);
        }

        return b + d.slice(w);
      }];

      function g(e, t, i, o, a, s) {
        var l = i + e.length,
            u = o.length,
            c = f;
        return void 0 !== a && (a = r(a), c = d), n.call(s, c, function (n, r) {
          var s;

          switch (r.charAt(0)) {
            case "$":
              return "$";

            case "&":
              return e;

            case "`":
              return t.slice(0, i);

            case "'":
              return t.slice(l);

            case "<":
              s = a[r.slice(1, -1)];
              break;

            default:
              var c = +r;
              if (0 === c) return n;

              if (c > u) {
                var d = h(c / 10);
                return 0 === d ? n : d <= u ? void 0 === o[d - 1] ? r.charAt(1) : o[d - 1] + r.charAt(1) : n;
              }

              s = o[c - 1];
          }

          return void 0 === s ? "" : s;
        });
      }
    });
  }, function (e, t, n) {
    "use strict";

    var i = n(12),
        r = n(246),
        o = n(142);
    n(143)("search", 1, function (e, t, n, a) {
      return [function (n) {
        var i = e(this),
            r = null == n ? void 0 : n[t];
        return void 0 !== r ? r.call(n, i) : new RegExp(n)[t](String(i));
      }, function (e) {
        var t = a(n, e, this);
        if (t.done) return t.value;
        var s = i(e),
            l = String(this),
            u = s.lastIndex;
        r(u, 0) || (s.lastIndex = 0);
        var c = o(s, l);
        return r(s.lastIndex, u) || (s.lastIndex = u), null === c ? -1 : c.index;
      }];
    });
  }, function (e, t, n) {
    "use strict";

    var i = n(185),
        r = n(12),
        o = n(114),
        a = n(193),
        s = n(19),
        l = n(142),
        u = n(192),
        c = n(11),
        h = Math.min,
        d = [].push,
        f = "length",
        p = !c(function () {
      RegExp(4294967295, "y");
    });
    n(143)("split", 2, function (e, t, n, c) {
      var g;
      return g = "c" == "abbc".split(/(b)*/)[1] || 4 != "test".split(/(?:)/, -1)[f] || 2 != "ab".split(/(?:ab)*/)[f] || 4 != ".".split(/(.?)(.?)/)[f] || ".".split(/()()/)[f] > 1 || "".split(/.?/)[f] ? function (e, t) {
        var r = String(this);
        if (void 0 === e && 0 === t) return [];
        if (!i(e)) return n.call(r, e, t);

        for (var o, a, s, l = [], c = (e.ignoreCase ? "i" : "") + (e.multiline ? "m" : "") + (e.unicode ? "u" : "") + (e.sticky ? "y" : ""), h = 0, p = void 0 === t ? 4294967295 : t >>> 0, g = new RegExp(e.source, c + "g"); (o = u.call(g, r)) && !((a = g.lastIndex) > h && (l.push(r.slice(h, o.index)), o[f] > 1 && o.index < r[f] && d.apply(l, o.slice(1)), s = o[0][f], h = a, l[f] >= p));) {
          g.lastIndex === o.index && g.lastIndex++;
        }

        return h === r[f] ? !s && g.test("") || l.push("") : l.push(r.slice(h)), l[f] > p ? l.slice(0, p) : l;
      } : "0".split(void 0, 0)[f] ? function (e, t) {
        return void 0 === e && 0 === t ? [] : n.call(this, e, t);
      } : n, [function (n, i) {
        var r = e(this),
            o = null == n ? void 0 : n[t];
        return void 0 !== o ? o.call(n, r, i) : g.call(String(r), n, i);
      }, function (e, t) {
        var i = c(g, e, this, t, g !== n);
        if (i.done) return i.value;
        var u = r(e),
            d = String(this),
            f = o(u, RegExp),
            v = u.unicode,
            m = (u.ignoreCase ? "i" : "") + (u.multiline ? "m" : "") + (u.unicode ? "u" : "") + (p ? "y" : "g"),
            y = new f(p ? u : "^(?:" + u.source + ")", m),
            x = void 0 === t ? 4294967295 : t >>> 0;
        if (0 === x) return [];
        if (0 === d.length) return null === l(y, d) ? [d] : [];

        for (var _ = 0, b = 0, w = []; b < d.length;) {
          y.lastIndex = p ? b : 0;
          var S,
              T = l(y, p ? d : d.slice(b));
          if (null === T || (S = h(s(y.lastIndex + (p ? 0 : b)), d.length)) === _) b = a(d, b, v);else {
            if (w.push(d.slice(_, b)), w.length === x) return w;

            for (var C = 1; C <= T.length - 1; C++) {
              if (w.push(T[C]), w.length === x) return w;
            }

            b = _ = S;
          }
        }

        return w.push(d.slice(_)), w;
      }];
    });
  }, function (e, t, n) {
    var i = n(10),
        r = n(194).set,
        o = i.MutationObserver || i.WebKitMutationObserver,
        a = i.process,
        s = i.Promise,
        l = "process" == n(57)(a);

    e.exports = function () {
      var e,
          t,
          n,
          u = function u() {
        var i, r;

        for (l && (i = a.domain) && i.exit(); e;) {
          r = e.fn, e = e.next;

          try {
            r();
          } catch (i) {
            throw e ? n() : t = void 0, i;
          }
        }

        t = void 0, i && i.enter();
      };

      if (l) n = function n() {
        a.nextTick(u);
      };else if (!o || i.navigator && i.navigator.standalone) {
        if (s && s.resolve) {
          var c = s.resolve(void 0);

          n = function n() {
            c.then(u);
          };
        } else n = function n() {
          r.call(i, u);
        };
      } else {
        var h = !0,
            d = document.createTextNode("");
        new o(u).observe(d, {
          characterData: !0
        }), n = function n() {
          d.data = h = !h;
        };
      }
      return function (i) {
        var r = {
          fn: i,
          next: void 0
        };
        t && (t.next = r), e || (e = r, n()), t = r;
      };
    };
  }, function (e, t) {
    e.exports = function (e) {
      try {
        return {
          e: !1,
          v: e()
        };
      } catch (e) {
        return {
          e: !0,
          v: e
        };
      }
    };
  }, function (e, t, n) {
    "use strict";

    var i = n(265),
        r = n(82);
    e.exports = n(146)("Map", function (e) {
      return function () {
        return e(this, arguments.length > 0 ? arguments[0] : void 0);
      };
    }, {
      get: function get(e) {
        var t = i.getEntry(r(this, "Map"), e);
        return t && t.v;
      },
      set: function set(e, t) {
        return i.def(r(this, "Map"), 0 === e ? 0 : e, t);
      }
    }, i, !0);
  }, function (e, t, n) {
    "use strict";

    var i = n(265),
        r = n(82);
    e.exports = n(146)("Set", function (e) {
      return function () {
        return e(this, arguments.length > 0 ? arguments[0] : void 0);
      };
    }, {
      add: function add(e) {
        return i.def(r(this, "Set"), e = 0 === e ? 0 : e, e);
      }
    }, i);
  }, function (e, t, n) {
    "use strict";

    var i,
        r = n(10),
        o = n(50)(0),
        a = n(33),
        s = n(64),
        l = n(245),
        u = n(266),
        c = n(13),
        h = n(82),
        d = n(82),
        f = !r.ActiveXObject && "ActiveXObject" in r,
        p = s.getWeak,
        g = Object.isExtensible,
        v = u.ufstore,
        m = function m(e) {
      return function () {
        return e(this, arguments.length > 0 ? arguments[0] : void 0);
      };
    },
        y = {
      get: function get(e) {
        if (c(e)) {
          var t = p(e);
          return !0 === t ? v(h(this, "WeakMap")).get(e) : t ? t[this._i] : void 0;
        }
      },
      set: function set(e, t) {
        return u.def(h(this, "WeakMap"), e, t);
      }
    },
        x = e.exports = n(146)("WeakMap", m, y, u, !0, !0);

    d && f && (l((i = u.getConstructor(m, "WeakMap")).prototype, y), s.NEED = !0, o(["delete", "has", "get", "set"], function (e) {
      var t = x.prototype,
          n = t[e];
      a(t, e, function (t, r) {
        if (c(t) && !g(t)) {
          this._f || (this._f = new i());

          var o = this._f[e](t, r);

          return "set" == e ? this : o;
        }

        return n.call(this, t, r);
      });
    }));
  }, function (e, t, n) {
    "use strict";

    var i = n(266),
        r = n(82);
    n(146)("WeakSet", function (e) {
      return function () {
        return e(this, arguments.length > 0 ? arguments[0] : void 0);
      };
    }, {
      add: function add(e) {
        return i.def(r(this, "WeakSet"), e, !0);
      }
    }, i, !1, !0);
  }, function (e, t, n) {
    "use strict";

    var i = n(3),
        r = n(147),
        o = n(195),
        a = n(12),
        s = n(77),
        l = n(19),
        u = n(13),
        c = n(10).ArrayBuffer,
        h = n(114),
        d = o.ArrayBuffer,
        f = o.DataView,
        p = r.ABV && c.isView,
        g = d.prototype.slice,
        v = r.VIEW;
    i(i.G + i.W + i.F * (c !== d), {
      ArrayBuffer: d
    }), i(i.S + i.F * !r.CONSTR, "ArrayBuffer", {
      isView: function isView(e) {
        return p && p(e) || u(e) && v in e;
      }
    }), i(i.P + i.U + i.F * n(11)(function () {
      return !new d(2).slice(1, void 0).byteLength;
    }), "ArrayBuffer", {
      slice: function slice(e, t) {
        if (void 0 !== g && void 0 === t) return g.call(a(this), e);

        for (var n = a(this).byteLength, i = s(e, n), r = s(void 0 === t ? n : t, n), o = new (h(this, d))(l(r - i)), u = new f(this), c = new f(o), p = 0; i < r;) {
          c.setUint8(p++, u.getUint8(i++));
        }

        return o;
      }
    }), n(96)("ArrayBuffer");
  }, function (e, t, n) {
    var i = n(3);
    i(i.G + i.W + i.F * !n(147).ABV, {
      DataView: n(195).DataView
    });
  }, function (e, t, n) {
    n(59)("Int8", 1, function (e) {
      return function (t, n, i) {
        return e(this, t, n, i);
      };
    });
  }, function (e, t, n) {
    n(59)("Uint8", 1, function (e) {
      return function (t, n, i) {
        return e(this, t, n, i);
      };
    });
  }, function (e, t, n) {
    n(59)("Uint8", 1, function (e) {
      return function (t, n, i) {
        return e(this, t, n, i);
      };
    }, !0);
  }, function (e, t, n) {
    n(59)("Int16", 2, function (e) {
      return function (t, n, i) {
        return e(this, t, n, i);
      };
    });
  }, function (e, t, n) {
    n(59)("Uint16", 2, function (e) {
      return function (t, n, i) {
        return e(this, t, n, i);
      };
    });
  }, function (e, t, n) {
    n(59)("Int32", 4, function (e) {
      return function (t, n, i) {
        return e(this, t, n, i);
      };
    });
  }, function (e, t, n) {
    n(59)("Uint32", 4, function (e) {
      return function (t, n, i) {
        return e(this, t, n, i);
      };
    });
  }, function (e, t, n) {
    n(59)("Float32", 4, function (e) {
      return function (t, n, i) {
        return e(this, t, n, i);
      };
    });
  }, function (e, t, n) {
    n(59)("Float64", 8, function (e) {
      return function (t, n, i) {
        return e(this, t, n, i);
      };
    });
  }, function (e, t, n) {
    var i = n(3),
        r = n(46),
        o = n(12),
        a = (n(10).Reflect || {}).apply,
        s = Function.apply;
    i(i.S + i.F * !n(11)(function () {
      a(function () {});
    }), "Reflect", {
      apply: function apply(e, t, n) {
        var i = r(e),
            l = o(n);
        return a ? a(i, t, l) : s.call(i, t, l);
      }
    });
  }, function (e, t, n) {
    var i = n(3),
        r = n(78),
        o = n(46),
        a = n(12),
        s = n(13),
        l = n(11),
        u = n(247),
        c = (n(10).Reflect || {}).construct,
        h = l(function () {
      function e() {}

      return !(c(function () {}, [], e) instanceof e);
    }),
        d = !l(function () {
      c(function () {});
    });
    i(i.S + i.F * (h || d), "Reflect", {
      construct: function construct(e, t) {
        o(e), a(t);
        var n = arguments.length < 3 ? e : o(arguments[2]);
        if (d && !h) return c(e, t, n);

        if (e == n) {
          switch (t.length) {
            case 0:
              return new e();

            case 1:
              return new e(t[0]);

            case 2:
              return new e(t[0], t[1]);

            case 3:
              return new e(t[0], t[1], t[2]);

            case 4:
              return new e(t[0], t[1], t[2], t[3]);
          }

          var i = [null];
          return i.push.apply(i, t), new (u.apply(e, i))();
        }

        var l = n.prototype,
            f = r(s(l) ? l : Object.prototype),
            p = Function.apply.call(e, f, t);
        return s(p) ? p : f;
      }
    });
  }, function (e, t, n) {
    var i = n(25),
        r = n(3),
        o = n(12),
        a = n(63);
    r(r.S + r.F * n(11)(function () {
      Reflect.defineProperty(i.f({}, 1, {
        value: 1
      }), 1, {
        value: 2
      });
    }), "Reflect", {
      defineProperty: function defineProperty(e, t, n) {
        o(e), t = a(t, !0), o(n);

        try {
          return i.f(e, t, n), !0;
        } catch (e) {
          return !1;
        }
      }
    });
  }, function (e, t, n) {
    var i = n(3),
        r = n(48).f,
        o = n(12);
    i(i.S, "Reflect", {
      deleteProperty: function deleteProperty(e, t) {
        var n = r(o(e), t);
        return !(n && !n.configurable) && delete e[t];
      }
    });
  }, function (e, t, n) {
    "use strict";

    var i = n(3),
        r = n(12),
        o = function o(e) {
      this._t = r(e), this._i = 0;
      var t,
          n = this._k = [];

      for (t in e) {
        n.push(t);
      }
    };

    n(254)(o, "Object", function () {
      var e,
          t = this._k;

      do {
        if (this._i >= t.length) return {
          value: void 0,
          done: !0
        };
      } while (!((e = t[this._i++]) in this._t));

      return {
        value: e,
        done: !1
      };
    }), i(i.S, "Reflect", {
      enumerate: function enumerate(e) {
        return new o(e);
      }
    });
  }, function (e, t, n) {
    var i = n(48),
        r = n(80),
        o = n(36),
        a = n(3),
        s = n(13),
        l = n(12);
    a(a.S, "Reflect", {
      get: function e(t, n) {
        var a,
            u,
            c = arguments.length < 3 ? t : arguments[2];
        return l(t) === c ? t[n] : (a = i.f(t, n)) ? o(a, "value") ? a.value : void 0 !== a.get ? a.get.call(c) : void 0 : s(u = r(t)) ? e(u, n, c) : void 0;
      }
    });
  }, function (e, t, n) {
    var i = n(48),
        r = n(3),
        o = n(12);
    r(r.S, "Reflect", {
      getOwnPropertyDescriptor: function getOwnPropertyDescriptor(e, t) {
        return i.f(o(e), t);
      }
    });
  }, function (e, t, n) {
    var i = n(3),
        r = n(80),
        o = n(12);
    i(i.S, "Reflect", {
      getPrototypeOf: function getPrototypeOf(e) {
        return r(o(e));
      }
    });
  }, function (e, t, n) {
    var i = n(3);
    i(i.S, "Reflect", {
      has: function has(e, t) {
        return t in e;
      }
    });
  }, function (e, t, n) {
    var i = n(3),
        r = n(12),
        o = Object.isExtensible;
    i(i.S, "Reflect", {
      isExtensible: function isExtensible(e) {
        return r(e), !o || o(e);
      }
    });
  }, function (e, t, n) {
    var i = n(3);
    i(i.S, "Reflect", {
      ownKeys: n(268)
    });
  }, function (e, t, n) {
    var i = n(3),
        r = n(12),
        o = Object.preventExtensions;
    i(i.S, "Reflect", {
      preventExtensions: function preventExtensions(e) {
        r(e);

        try {
          return o && o(e), !0;
        } catch (e) {
          return !1;
        }
      }
    });
  }, function (e, t, n) {
    var i = n(25),
        r = n(48),
        o = n(80),
        a = n(36),
        s = n(3),
        l = n(73),
        u = n(12),
        c = n(13);
    s(s.S, "Reflect", {
      set: function e(t, n, s) {
        var h,
            d,
            f = arguments.length < 4 ? t : arguments[3],
            p = r.f(u(t), n);

        if (!p) {
          if (c(d = o(t))) return e(d, n, s, f);
          p = l(0);
        }

        if (a(p, "value")) {
          if (!1 === p.writable || !c(f)) return !1;

          if (h = r.f(f, n)) {
            if (h.get || h.set || !1 === h.writable) return !1;
            h.value = s, i.f(f, n, h);
          } else i.f(f, n, l(0, s));

          return !0;
        }

        return void 0 !== p.set && (p.set.call(f, s), !0);
      }
    });
  }, function (e, t, n) {
    var i = n(3),
        r = n(176);
    r && i(i.S, "Reflect", {
      setPrototypeOf: function setPrototypeOf(e, t) {
        r.check(e, t);

        try {
          return r.set(e, t), !0;
        } catch (e) {
          return !1;
        }
      }
    });
  }, function (e, t, n) {
    n(521), e.exports = n(23).Array.includes;
  }, function (e, t, n) {
    "use strict";

    var i = n(3),
        r = n(137)(!0);
    i(i.P, "Array", {
      includes: function includes(e) {
        return r(this, e, arguments.length > 1 ? arguments[1] : void 0);
      }
    }), n(81)("includes");
  }, function (e, t, n) {
    n(523), e.exports = n(23).Array.flatMap;
  }, function (e, t, n) {
    "use strict";

    var i = n(3),
        r = n(524),
        o = n(30),
        a = n(19),
        s = n(46),
        l = n(256);
    i(i.P, "Array", {
      flatMap: function flatMap(e) {
        var t,
            n,
            i = o(this);
        return s(e), t = a(i.length), n = l(i, 0), r(n, i, i, t, 0, 1, e, arguments[1]), n;
      }
    }), n(81)("flatMap");
  }, function (e, t, n) {
    "use strict";

    var i = n(139),
        r = n(13),
        o = n(19),
        a = n(45),
        s = n(18)("isConcatSpreadable");

    e.exports = function e(t, n, l, u, c, h, d, f) {
      for (var p, g, v = c, m = 0, y = !!d && a(d, f, 3); m < u;) {
        if (m in l) {
          if (p = y ? y(l[m], m, n) : l[m], g = !1, r(p) && (g = void 0 !== (g = p[s]) ? !!g : i(p)), g && h > 0) v = e(t, n, p, o(p.length), v, h - 1) - 1;else {
            if (v >= 9007199254740991) throw TypeError();
            t[v] = p;
          }
          v++;
        }

        m++;
      }

      return v;
    };
  }, function (e, t, n) {
    n(526), e.exports = n(23).String.padStart;
  }, function (e, t, n) {
    "use strict";

    var i = n(3),
        r = n(269),
        o = n(145),
        a = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(o);
    i(i.P + i.F * a, "String", {
      padStart: function padStart(e) {
        return r(this, e, arguments.length > 1 ? arguments[1] : void 0, !0);
      }
    });
  }, function (e, t, n) {
    n(528), e.exports = n(23).String.padEnd;
  }, function (e, t, n) {
    "use strict";

    var i = n(3),
        r = n(269),
        o = n(145),
        a = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(o);
    i(i.P + i.F * a, "String", {
      padEnd: function padEnd(e) {
        return r(this, e, arguments.length > 1 ? arguments[1] : void 0, !1);
      }
    });
  }, function (e, t, n) {
    n(530), e.exports = n(23).String.trimLeft;
  }, function (e, t, n) {
    "use strict";

    n(94)("trimLeft", function (e) {
      return function () {
        return e(this, 1);
      };
    }, "trimStart");
  }, function (e, t, n) {
    n(532), e.exports = n(23).String.trimRight;
  }, function (e, t, n) {
    "use strict";

    n(94)("trimRight", function (e) {
      return function () {
        return e(this, 2);
      };
    }, "trimEnd");
  }, function (e, t, n) {
    n(534), e.exports = n(172).f("asyncIterator");
  }, function (e, t, n) {
    n(241)("asyncIterator");
  }, function (e, t, n) {
    n(536), e.exports = n(23).Object.getOwnPropertyDescriptors;
  }, function (e, t, n) {
    var i = n(3),
        r = n(268),
        o = n(38),
        a = n(48),
        s = n(188);
    i(i.S, "Object", {
      getOwnPropertyDescriptors: function getOwnPropertyDescriptors(e) {
        for (var t, n, i = o(e), l = a.f, u = r(i), c = {}, h = 0; u.length > h;) {
          void 0 !== (n = l(i, t = u[h++])) && s(c, t, n);
        }

        return c;
      }
    });
  }, function (e, t, n) {
    n(538), e.exports = n(23).Object.values;
  }, function (e, t, n) {
    var i = n(3),
        r = n(270)(!1);
    i(i.S, "Object", {
      values: function values(e) {
        return r(e);
      }
    });
  }, function (e, t, n) {
    n(540), e.exports = n(23).Object.entries;
  }, function (e, t, n) {
    var i = n(3),
        r = n(270)(!0);
    i(i.S, "Object", {
      entries: function entries(e) {
        return r(e);
      }
    });
  }, function (e, t, n) {
    "use strict";

    n(262), n(542), e.exports = n(23).Promise.finally;
  }, function (e, t, n) {
    "use strict";

    var i = n(3),
        r = n(23),
        o = n(10),
        a = n(114),
        s = n(264);
    i(i.P + i.R, "Promise", {
      finally: function _finally(e) {
        var t = a(this, r.Promise || o.Promise),
            n = "function" == typeof e;
        return this.then(n ? function (n) {
          return s(t, e()).then(function () {
            return n;
          });
        } : e, n ? function (n) {
          return s(t, e()).then(function () {
            throw n;
          });
        } : e);
      }
    });
  }, function (e, t, n) {
    n(544), n(545), n(546), e.exports = n(23);
  }, function (e, t, n) {
    var i = n(10),
        r = n(3),
        o = n(145),
        a = [].slice,
        s = /MSIE .\./.test(o),
        l = function l(e) {
      return function (t, n) {
        var i = arguments.length > 2,
            r = !!i && a.call(arguments, 2);
        return e(i ? function () {
          ("function" == typeof t ? t : Function(t)).apply(this, r);
        } : t, n);
      };
    };

    r(r.G + r.B + r.F * s, {
      setTimeout: l(i.setTimeout),
      setInterval: l(i.setInterval)
    });
  }, function (e, t, n) {
    var i = n(3),
        r = n(194);
    i(i.G + i.B, {
      setImmediate: r.set,
      clearImmediate: r.clear
    });
  }, function (e, t, n) {
    for (var i = n(191), r = n(76), o = n(33), a = n(10), s = n(37), l = n(95), u = n(18), c = u("iterator"), h = u("toStringTag"), d = l.Array, f = {
      CSSRuleList: !0,
      CSSStyleDeclaration: !1,
      CSSValueList: !1,
      ClientRectList: !1,
      DOMRectList: !1,
      DOMStringList: !1,
      DOMTokenList: !0,
      DataTransferItemList: !1,
      FileList: !1,
      HTMLAllCollection: !1,
      HTMLCollection: !1,
      HTMLFormElement: !1,
      HTMLSelectElement: !1,
      MediaList: !0,
      MimeTypeArray: !1,
      NamedNodeMap: !1,
      NodeList: !0,
      PaintRequestList: !1,
      Plugin: !1,
      PluginArray: !1,
      SVGLengthList: !1,
      SVGNumberList: !1,
      SVGPathSegList: !1,
      SVGPointList: !1,
      SVGStringList: !1,
      SVGTransformList: !1,
      SourceBufferList: !1,
      StyleSheetList: !0,
      TextTrackCueList: !1,
      TextTrackList: !1,
      TouchList: !1
    }, p = r(f), g = 0; g < p.length; g++) {
      var v,
          m = p[g],
          y = f[m],
          x = a[m],
          _ = x && x.prototype;

      if (_ && (_[c] || s(_, c, d), _[h] || s(_, h, m), l[m] = d, y)) for (v in i) {
        _[v] || o(_, v, i[v], !0);
      }
    }
  }, function (e, t, n) {
    n(548), e.exports = n(272).global;
  }, function (e, t, n) {
    var i = n(549);
    i(i.G, {
      global: n(196)
    });
  }, function (e, t, n) {
    var i = n(196),
        r = n(272),
        o = n(550),
        a = n(552),
        s = n(559),
        l = function l(e, t, n) {
      var u,
          c,
          h,
          d = e & l.F,
          f = e & l.G,
          p = e & l.S,
          g = e & l.P,
          v = e & l.B,
          m = e & l.W,
          y = f ? r : r[t] || (r[t] = {}),
          x = y.prototype,
          _ = f ? i : p ? i[t] : (i[t] || {}).prototype;

      for (u in f && (n = t), n) {
        (c = !d && _ && void 0 !== _[u]) && s(y, u) || (h = c ? _[u] : n[u], y[u] = f && "function" != typeof _[u] ? n[u] : v && c ? o(h, i) : m && _[u] == h ? function (e) {
          var t = function t(_t5, n, i) {
            if (this instanceof e) {
              switch (arguments.length) {
                case 0:
                  return new e();

                case 1:
                  return new e(_t5);

                case 2:
                  return new e(_t5, n);
              }

              return new e(_t5, n, i);
            }

            return e.apply(this, arguments);
          };

          return t.prototype = e.prototype, t;
        }(h) : g && "function" == typeof h ? o(Function.call, h) : h, g && ((y.virtual || (y.virtual = {}))[u] = h, e & l.R && x && !x[u] && a(x, u, h)));
      }
    };

    l.F = 1, l.G = 2, l.S = 4, l.P = 8, l.B = 16, l.W = 32, l.U = 64, l.R = 128, e.exports = l;
  }, function (e, t, n) {
    var i = n(551);

    e.exports = function (e, t, n) {
      if (i(e), void 0 === t) return e;

      switch (n) {
        case 1:
          return function (n) {
            return e.call(t, n);
          };

        case 2:
          return function (n, i) {
            return e.call(t, n, i);
          };

        case 3:
          return function (n, i, r) {
            return e.call(t, n, i, r);
          };
      }

      return function () {
        return e.apply(t, arguments);
      };
    };
  }, function (e, t) {
    e.exports = function (e) {
      if ("function" != typeof e) throw TypeError(e + " is not a function!");
      return e;
    };
  }, function (e, t, n) {
    var i = n(553),
        r = n(558);
    e.exports = n(198) ? function (e, t, n) {
      return i.f(e, t, r(1, n));
    } : function (e, t, n) {
      return e[t] = n, e;
    };
  }, function (e, t, n) {
    var i = n(554),
        r = n(555),
        o = n(557),
        a = Object.defineProperty;
    t.f = n(198) ? Object.defineProperty : function (e, t, n) {
      if (i(e), t = o(t, !0), i(n), r) try {
        return a(e, t, n);
      } catch (e) {}
      if ("get" in n || "set" in n) throw TypeError("Accessors not supported!");
      return "value" in n && (e[t] = n.value), e;
    };
  }, function (e, t, n) {
    var i = n(197);

    e.exports = function (e) {
      if (!i(e)) throw TypeError(e + " is not an object!");
      return e;
    };
  }, function (e, t, n) {
    e.exports = !n(198) && !n(273)(function () {
      return 7 != Object.defineProperty(n(556)("div"), "a", {
        get: function get() {
          return 7;
        }
      }).a;
    });
  }, function (e, t, n) {
    var i = n(197),
        r = n(196).document,
        o = i(r) && i(r.createElement);

    e.exports = function (e) {
      return o ? r.createElement(e) : {};
    };
  }, function (e, t, n) {
    var i = n(197);

    e.exports = function (e, t) {
      if (!i(e)) return e;
      var n, r;
      if (t && "function" == typeof (n = e.toString) && !i(r = n.call(e))) return r;
      if ("function" == typeof (n = e.valueOf) && !i(r = n.call(e))) return r;
      if (!t && "function" == typeof (n = e.toString) && !i(r = n.call(e))) return r;
      throw TypeError("Can't convert object to primitive value");
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      return {
        enumerable: !(1 & e),
        configurable: !(2 & e),
        writable: !(4 & e),
        value: t
      };
    };
  }, function (e, t) {
    var n = {}.hasOwnProperty;

    e.exports = function (e, t) {
      return n.call(e, t);
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      if (null == e) return {};
      var n,
          i,
          r = {},
          o = Object.keys(e);

      for (i = 0; i < o.length; i++) {
        n = o[i], t.indexOf(n) >= 0 || (r[n] = e[n]);
      }

      return r;
    };
  }, function (e, t) {
    function n(t, i) {
      return e.exports = n = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      }, n(t, i);
    }

    e.exports = n;
  }, function (e, t) {
    function n(t) {
      return "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? e.exports = n = function n(e) {
        return typeof e;
      } : e.exports = n = function n(e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      }, n(t);
    }

    e.exports = n;
  }, function (e, t, n) {
    "use strict";

    var i = n(274),
        r = "function" == typeof Symbol && Symbol.for,
        o = r ? Symbol.for("react.element") : 60103,
        a = r ? Symbol.for("react.portal") : 60106,
        s = r ? Symbol.for("react.fragment") : 60107,
        l = r ? Symbol.for("react.strict_mode") : 60108,
        u = r ? Symbol.for("react.profiler") : 60114,
        c = r ? Symbol.for("react.provider") : 60109,
        h = r ? Symbol.for("react.context") : 60110,
        d = r ? Symbol.for("react.forward_ref") : 60112,
        f = r ? Symbol.for("react.suspense") : 60113,
        p = r ? Symbol.for("react.memo") : 60115,
        g = r ? Symbol.for("react.lazy") : 60116,
        v = "function" == typeof Symbol && Symbol.iterator;

    function m(e) {
      for (var t = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, n = 1; n < arguments.length; n++) {
        t += "&args[]=" + encodeURIComponent(arguments[n]);
      }

      return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
    }

    var y = {
      isMounted: function isMounted() {
        return !1;
      },
      enqueueForceUpdate: function enqueueForceUpdate() {},
      enqueueReplaceState: function enqueueReplaceState() {},
      enqueueSetState: function enqueueSetState() {}
    },
        x = {};

    function _(e, t, n) {
      this.props = e, this.context = t, this.refs = x, this.updater = n || y;
    }

    function b() {}

    function w(e, t, n) {
      this.props = e, this.context = t, this.refs = x, this.updater = n || y;
    }

    _.prototype.isReactComponent = {}, _.prototype.setState = function (e, t) {
      if ("object" != typeof e && "function" != typeof e && null != e) throw Error(m(85));
      this.updater.enqueueSetState(this, e, t, "setState");
    }, _.prototype.forceUpdate = function (e) {
      this.updater.enqueueForceUpdate(this, e, "forceUpdate");
    }, b.prototype = _.prototype;
    var S = w.prototype = new b();
    S.constructor = w, i(S, _.prototype), S.isPureReactComponent = !0;
    var T = {
      current: null
    },
        C = Object.prototype.hasOwnProperty,
        k = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    };

    function M(e, t, n) {
      var i,
          r = {},
          a = null,
          s = null;
      if (null != t) for (i in void 0 !== t.ref && (s = t.ref), void 0 !== t.key && (a = "" + t.key), t) {
        C.call(t, i) && !k.hasOwnProperty(i) && (r[i] = t[i]);
      }
      var l = arguments.length - 2;
      if (1 === l) r.children = n;else if (1 < l) {
        for (var u = Array(l), c = 0; c < l; c++) {
          u[c] = arguments[c + 2];
        }

        r.children = u;
      }
      if (e && e.defaultProps) for (i in l = e.defaultProps) {
        void 0 === r[i] && (r[i] = l[i]);
      }
      return {
        $$typeof: o,
        type: e,
        key: a,
        ref: s,
        props: r,
        _owner: T.current
      };
    }

    function E(e) {
      return "object" == typeof e && null !== e && e.$$typeof === o;
    }

    var A = /\/+/g,
        I = [];

    function P(e, t, n, i) {
      if (I.length) {
        var r = I.pop();
        return r.result = e, r.keyPrefix = t, r.func = n, r.context = i, r.count = 0, r;
      }

      return {
        result: e,
        keyPrefix: t,
        func: n,
        context: i,
        count: 0
      };
    }

    function O(e) {
      e.result = null, e.keyPrefix = null, e.func = null, e.context = null, e.count = 0, 10 > I.length && I.push(e);
    }

    function L(e, t, n) {
      return null == e ? 0 : function e(t, n, i, r) {
        var s = typeof t;
        "undefined" !== s && "boolean" !== s || (t = null);
        var l = !1;
        if (null === t) l = !0;else switch (s) {
          case "string":
          case "number":
            l = !0;
            break;

          case "object":
            switch (t.$$typeof) {
              case o:
              case a:
                l = !0;
            }

        }
        if (l) return i(r, t, "" === n ? "." + D(t, 0) : n), 1;
        if (l = 0, n = "" === n ? "." : n + ":", Array.isArray(t)) for (var u = 0; u < t.length; u++) {
          var c = n + D(s = t[u], u);
          l += e(s, c, i, r);
        } else if (null === t || "object" != typeof t ? c = null : c = "function" == typeof (c = v && t[v] || t["@@iterator"]) ? c : null, "function" == typeof c) for (t = c.call(t), u = 0; !(s = t.next()).done;) {
          l += e(s = s.value, c = n + D(s, u++), i, r);
        } else if ("object" === s) throw i = "" + t, Error(m(31, "[object Object]" === i ? "object with keys {" + Object.keys(t).join(", ") + "}" : i, ""));
        return l;
      }(e, "", t, n);
    }

    function D(e, t) {
      return "object" == typeof e && null !== e && null != e.key ? function (e) {
        var t = {
          "=": "=0",
          ":": "=2"
        };
        return "$" + ("" + e).replace(/[=:]/g, function (e) {
          return t[e];
        });
      }(e.key) : t.toString(36);
    }

    function N(e, t) {
      e.func.call(e.context, t, e.count++);
    }

    function j(e, t, n) {
      var i = e.result,
          r = e.keyPrefix;
      e = e.func.call(e.context, t, e.count++), Array.isArray(e) ? R(e, i, n, function (e) {
        return e;
      }) : null != e && (E(e) && (e = function (e, t) {
        return {
          $$typeof: o,
          type: e.type,
          key: t,
          ref: e.ref,
          props: e.props,
          _owner: e._owner
        };
      }(e, r + (!e.key || t && t.key === e.key ? "" : ("" + e.key).replace(A, "$&/") + "/") + n)), i.push(e));
    }

    function R(e, t, n, i, r) {
      var o = "";
      null != n && (o = ("" + n).replace(A, "$&/") + "/"), L(e, j, t = P(t, o, i, r)), O(t);
    }

    var F = {
      current: null
    };

    function z() {
      var e = F.current;
      if (null === e) throw Error(m(321));
      return e;
    }

    var B = {
      ReactCurrentDispatcher: F,
      ReactCurrentBatchConfig: {
        suspense: null
      },
      ReactCurrentOwner: T,
      IsSomeRendererActing: {
        current: !1
      },
      assign: i
    };
    t.Children = {
      map: function map(e, t, n) {
        if (null == e) return e;
        var i = [];
        return R(e, i, null, t, n), i;
      },
      forEach: function forEach(e, t, n) {
        if (null == e) return e;
        L(e, N, t = P(null, null, t, n)), O(t);
      },
      count: function count(e) {
        return L(e, function () {
          return null;
        }, null);
      },
      toArray: function toArray(e) {
        var t = [];
        return R(e, t, null, function (e) {
          return e;
        }), t;
      },
      only: function only(e) {
        if (!E(e)) throw Error(m(143));
        return e;
      }
    }, t.Component = _, t.Fragment = s, t.Profiler = u, t.PureComponent = w, t.StrictMode = l, t.Suspense = f, t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = B, t.cloneElement = function (e, t, n) {
      if (null == e) throw Error(m(267, e));
      var r = i({}, e.props),
          a = e.key,
          s = e.ref,
          l = e._owner;

      if (null != t) {
        if (void 0 !== t.ref && (s = t.ref, l = T.current), void 0 !== t.key && (a = "" + t.key), e.type && e.type.defaultProps) var u = e.type.defaultProps;

        for (c in t) {
          C.call(t, c) && !k.hasOwnProperty(c) && (r[c] = void 0 === t[c] && void 0 !== u ? u[c] : t[c]);
        }
      }

      var c = arguments.length - 2;
      if (1 === c) r.children = n;else if (1 < c) {
        u = Array(c);

        for (var h = 0; h < c; h++) {
          u[h] = arguments[h + 2];
        }

        r.children = u;
      }
      return {
        $$typeof: o,
        type: e.type,
        key: a,
        ref: s,
        props: r,
        _owner: l
      };
    }, t.createContext = function (e, t) {
      return void 0 === t && (t = null), (e = {
        $$typeof: h,
        _calculateChangedBits: t,
        _currentValue: e,
        _currentValue2: e,
        _threadCount: 0,
        Provider: null,
        Consumer: null
      }).Provider = {
        $$typeof: c,
        _context: e
      }, e.Consumer = e;
    }, t.createElement = M, t.createFactory = function (e) {
      var t = M.bind(null, e);
      return t.type = e, t;
    }, t.createRef = function () {
      return {
        current: null
      };
    }, t.forwardRef = function (e) {
      return {
        $$typeof: d,
        render: e
      };
    }, t.isValidElement = E, t.lazy = function (e) {
      return {
        $$typeof: g,
        _ctor: e,
        _status: -1,
        _result: null
      };
    }, t.memo = function (e, t) {
      return {
        $$typeof: p,
        type: e,
        compare: void 0 === t ? null : t
      };
    }, t.useCallback = function (e, t) {
      return z().useCallback(e, t);
    }, t.useContext = function (e, t) {
      return z().useContext(e, t);
    }, t.useDebugValue = function () {}, t.useEffect = function (e, t) {
      return z().useEffect(e, t);
    }, t.useImperativeHandle = function (e, t, n) {
      return z().useImperativeHandle(e, t, n);
    }, t.useLayoutEffect = function (e, t) {
      return z().useLayoutEffect(e, t);
    }, t.useMemo = function (e, t) {
      return z().useMemo(e, t);
    }, t.useReducer = function (e, t, n) {
      return z().useReducer(e, t, n);
    }, t.useRef = function (e) {
      return z().useRef(e);
    }, t.useState = function (e) {
      return z().useState(e);
    }, t.version = "16.13.1";
  }, function (e, t, n) {
    "use strict";

    (function (e) {
      var i = n(565),
          r = n(566),
          o = n(567);

      function a() {
        return l.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
      }

      function s(e, t) {
        if (a() < t) throw new RangeError("Invalid typed array length");
        return l.TYPED_ARRAY_SUPPORT ? (e = new Uint8Array(t)).__proto__ = l.prototype : (null === e && (e = new l(t)), e.length = t), e;
      }

      function l(e, t, n) {
        if (!(l.TYPED_ARRAY_SUPPORT || this instanceof l)) return new l(e, t, n);

        if ("number" == typeof e) {
          if ("string" == typeof t) throw new Error("If encoding is specified then the first argument must be a string");
          return h(this, e);
        }

        return u(this, e, t, n);
      }

      function u(e, t, n, i) {
        if ("number" == typeof t) throw new TypeError('"value" argument must not be a number');
        return "undefined" != typeof ArrayBuffer && t instanceof ArrayBuffer ? function (e, t, n, i) {
          if (t.byteLength, n < 0 || t.byteLength < n) throw new RangeError("'offset' is out of bounds");
          if (t.byteLength < n + (i || 0)) throw new RangeError("'length' is out of bounds");
          t = void 0 === n && void 0 === i ? new Uint8Array(t) : void 0 === i ? new Uint8Array(t, n) : new Uint8Array(t, n, i);
          l.TYPED_ARRAY_SUPPORT ? (e = t).__proto__ = l.prototype : e = d(e, t);
          return e;
        }(e, t, n, i) : "string" == typeof t ? function (e, t, n) {
          "string" == typeof n && "" !== n || (n = "utf8");
          if (!l.isEncoding(n)) throw new TypeError('"encoding" must be a valid string encoding');
          var i = 0 | p(t, n),
              r = (e = s(e, i)).write(t, n);
          r !== i && (e = e.slice(0, r));
          return e;
        }(e, t, n) : function (e, t) {
          if (l.isBuffer(t)) {
            var n = 0 | f(t.length);
            return 0 === (e = s(e, n)).length || t.copy(e, 0, 0, n), e;
          }

          if (t) {
            if ("undefined" != typeof ArrayBuffer && t.buffer instanceof ArrayBuffer || "length" in t) return "number" != typeof t.length || (i = t.length) != i ? s(e, 0) : d(e, t);
            if ("Buffer" === t.type && o(t.data)) return d(e, t.data);
          }

          var i;
          throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
        }(e, t);
      }

      function c(e) {
        if ("number" != typeof e) throw new TypeError('"size" argument must be a number');
        if (e < 0) throw new RangeError('"size" argument must not be negative');
      }

      function h(e, t) {
        if (c(t), e = s(e, t < 0 ? 0 : 0 | f(t)), !l.TYPED_ARRAY_SUPPORT) for (var n = 0; n < t; ++n) {
          e[n] = 0;
        }
        return e;
      }

      function d(e, t) {
        var n = t.length < 0 ? 0 : 0 | f(t.length);
        e = s(e, n);

        for (var i = 0; i < n; i += 1) {
          e[i] = 255 & t[i];
        }

        return e;
      }

      function f(e) {
        if (e >= a()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + a().toString(16) + " bytes");
        return 0 | e;
      }

      function p(e, t) {
        if (l.isBuffer(e)) return e.length;
        if ("undefined" != typeof ArrayBuffer && "function" == typeof ArrayBuffer.isView && (ArrayBuffer.isView(e) || e instanceof ArrayBuffer)) return e.byteLength;
        "string" != typeof e && (e = "" + e);
        var n = e.length;
        if (0 === n) return 0;

        for (var i = !1;;) {
          switch (t) {
            case "ascii":
            case "latin1":
            case "binary":
              return n;

            case "utf8":
            case "utf-8":
            case void 0:
              return B(e).length;

            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return 2 * n;

            case "hex":
              return n >>> 1;

            case "base64":
              return V(e).length;

            default:
              if (i) return B(e).length;
              t = ("" + t).toLowerCase(), i = !0;
          }
        }
      }

      function g(e, t, n) {
        var i = !1;
        if ((void 0 === t || t < 0) && (t = 0), t > this.length) return "";
        if ((void 0 === n || n > this.length) && (n = this.length), n <= 0) return "";
        if ((n >>>= 0) <= (t >>>= 0)) return "";

        for (e || (e = "utf8");;) {
          switch (e) {
            case "hex":
              return A(this, t, n);

            case "utf8":
            case "utf-8":
              return k(this, t, n);

            case "ascii":
              return M(this, t, n);

            case "latin1":
            case "binary":
              return E(this, t, n);

            case "base64":
              return C(this, t, n);

            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return I(this, t, n);

            default:
              if (i) throw new TypeError("Unknown encoding: " + e);
              e = (e + "").toLowerCase(), i = !0;
          }
        }
      }

      function v(e, t, n) {
        var i = e[t];
        e[t] = e[n], e[n] = i;
      }

      function m(e, t, n, i, r) {
        if (0 === e.length) return -1;

        if ("string" == typeof n ? (i = n, n = 0) : n > 2147483647 ? n = 2147483647 : n < -2147483648 && (n = -2147483648), n = +n, isNaN(n) && (n = r ? 0 : e.length - 1), n < 0 && (n = e.length + n), n >= e.length) {
          if (r) return -1;
          n = e.length - 1;
        } else if (n < 0) {
          if (!r) return -1;
          n = 0;
        }

        if ("string" == typeof t && (t = l.from(t, i)), l.isBuffer(t)) return 0 === t.length ? -1 : y(e, t, n, i, r);
        if ("number" == typeof t) return t &= 255, l.TYPED_ARRAY_SUPPORT && "function" == typeof Uint8Array.prototype.indexOf ? r ? Uint8Array.prototype.indexOf.call(e, t, n) : Uint8Array.prototype.lastIndexOf.call(e, t, n) : y(e, [t], n, i, r);
        throw new TypeError("val must be string, number or Buffer");
      }

      function y(e, t, n, i, r) {
        var o,
            a = 1,
            s = e.length,
            l = t.length;

        if (void 0 !== i && ("ucs2" === (i = String(i).toLowerCase()) || "ucs-2" === i || "utf16le" === i || "utf-16le" === i)) {
          if (e.length < 2 || t.length < 2) return -1;
          a = 2, s /= 2, l /= 2, n /= 2;
        }

        function u(e, t) {
          return 1 === a ? e[t] : e.readUInt16BE(t * a);
        }

        if (r) {
          var c = -1;

          for (o = n; o < s; o++) {
            if (u(e, o) === u(t, -1 === c ? 0 : o - c)) {
              if (-1 === c && (c = o), o - c + 1 === l) return c * a;
            } else -1 !== c && (o -= o - c), c = -1;
          }
        } else for (n + l > s && (n = s - l), o = n; o >= 0; o--) {
          for (var h = !0, d = 0; d < l; d++) {
            if (u(e, o + d) !== u(t, d)) {
              h = !1;
              break;
            }
          }

          if (h) return o;
        }

        return -1;
      }

      function x(e, t, n, i) {
        n = Number(n) || 0;
        var r = e.length - n;
        i ? (i = Number(i)) > r && (i = r) : i = r;
        var o = t.length;
        if (o % 2 != 0) throw new TypeError("Invalid hex string");
        i > o / 2 && (i = o / 2);

        for (var a = 0; a < i; ++a) {
          var s = parseInt(t.substr(2 * a, 2), 16);
          if (isNaN(s)) return a;
          e[n + a] = s;
        }

        return a;
      }

      function _(e, t, n, i) {
        return H(B(t, e.length - n), e, n, i);
      }

      function b(e, t, n, i) {
        return H(function (e) {
          for (var t = [], n = 0; n < e.length; ++n) {
            t.push(255 & e.charCodeAt(n));
          }

          return t;
        }(t), e, n, i);
      }

      function w(e, t, n, i) {
        return b(e, t, n, i);
      }

      function S(e, t, n, i) {
        return H(V(t), e, n, i);
      }

      function T(e, t, n, i) {
        return H(function (e, t) {
          for (var n, i, r, o = [], a = 0; a < e.length && !((t -= 2) < 0); ++a) {
            n = e.charCodeAt(a), i = n >> 8, r = n % 256, o.push(r), o.push(i);
          }

          return o;
        }(t, e.length - n), e, n, i);
      }

      function C(e, t, n) {
        return 0 === t && n === e.length ? i.fromByteArray(e) : i.fromByteArray(e.slice(t, n));
      }

      function k(e, t, n) {
        n = Math.min(e.length, n);

        for (var i = [], r = t; r < n;) {
          var o,
              a,
              s,
              l,
              u = e[r],
              c = null,
              h = u > 239 ? 4 : u > 223 ? 3 : u > 191 ? 2 : 1;
          if (r + h <= n) switch (h) {
            case 1:
              u < 128 && (c = u);
              break;

            case 2:
              128 == (192 & (o = e[r + 1])) && (l = (31 & u) << 6 | 63 & o) > 127 && (c = l);
              break;

            case 3:
              o = e[r + 1], a = e[r + 2], 128 == (192 & o) && 128 == (192 & a) && (l = (15 & u) << 12 | (63 & o) << 6 | 63 & a) > 2047 && (l < 55296 || l > 57343) && (c = l);
              break;

            case 4:
              o = e[r + 1], a = e[r + 2], s = e[r + 3], 128 == (192 & o) && 128 == (192 & a) && 128 == (192 & s) && (l = (15 & u) << 18 | (63 & o) << 12 | (63 & a) << 6 | 63 & s) > 65535 && l < 1114112 && (c = l);
          }
          null === c ? (c = 65533, h = 1) : c > 65535 && (c -= 65536, i.push(c >>> 10 & 1023 | 55296), c = 56320 | 1023 & c), i.push(c), r += h;
        }

        return function (e) {
          var t = e.length;
          if (t <= 4096) return String.fromCharCode.apply(String, e);
          var n = "",
              i = 0;

          for (; i < t;) {
            n += String.fromCharCode.apply(String, e.slice(i, i += 4096));
          }

          return n;
        }(i);
      }

      t.Buffer = l, t.SlowBuffer = function (e) {
        +e != e && (e = 0);
        return l.alloc(+e);
      }, t.INSPECT_MAX_BYTES = 50, l.TYPED_ARRAY_SUPPORT = void 0 !== e.TYPED_ARRAY_SUPPORT ? e.TYPED_ARRAY_SUPPORT : function () {
        try {
          var e = new Uint8Array(1);
          return e.__proto__ = {
            __proto__: Uint8Array.prototype,
            foo: function foo() {
              return 42;
            }
          }, 42 === e.foo() && "function" == typeof e.subarray && 0 === e.subarray(1, 1).byteLength;
        } catch (e) {
          return !1;
        }
      }(), t.kMaxLength = a(), l.poolSize = 8192, l._augment = function (e) {
        return e.__proto__ = l.prototype, e;
      }, l.from = function (e, t, n) {
        return u(null, e, t, n);
      }, l.TYPED_ARRAY_SUPPORT && (l.prototype.__proto__ = Uint8Array.prototype, l.__proto__ = Uint8Array, "undefined" != typeof Symbol && Symbol.species && l[Symbol.species] === l && Object.defineProperty(l, Symbol.species, {
        value: null,
        configurable: !0
      })), l.alloc = function (e, t, n) {
        return function (e, t, n, i) {
          return c(t), t <= 0 ? s(e, t) : void 0 !== n ? "string" == typeof i ? s(e, t).fill(n, i) : s(e, t).fill(n) : s(e, t);
        }(null, e, t, n);
      }, l.allocUnsafe = function (e) {
        return h(null, e);
      }, l.allocUnsafeSlow = function (e) {
        return h(null, e);
      }, l.isBuffer = function (e) {
        return !(null == e || !e._isBuffer);
      }, l.compare = function (e, t) {
        if (!l.isBuffer(e) || !l.isBuffer(t)) throw new TypeError("Arguments must be Buffers");
        if (e === t) return 0;

        for (var n = e.length, i = t.length, r = 0, o = Math.min(n, i); r < o; ++r) {
          if (e[r] !== t[r]) {
            n = e[r], i = t[r];
            break;
          }
        }

        return n < i ? -1 : i < n ? 1 : 0;
      }, l.isEncoding = function (e) {
        switch (String(e).toLowerCase()) {
          case "hex":
          case "utf8":
          case "utf-8":
          case "ascii":
          case "latin1":
          case "binary":
          case "base64":
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return !0;

          default:
            return !1;
        }
      }, l.concat = function (e, t) {
        if (!o(e)) throw new TypeError('"list" argument must be an Array of Buffers');
        if (0 === e.length) return l.alloc(0);
        var n;
        if (void 0 === t) for (t = 0, n = 0; n < e.length; ++n) {
          t += e[n].length;
        }
        var i = l.allocUnsafe(t),
            r = 0;

        for (n = 0; n < e.length; ++n) {
          var a = e[n];
          if (!l.isBuffer(a)) throw new TypeError('"list" argument must be an Array of Buffers');
          a.copy(i, r), r += a.length;
        }

        return i;
      }, l.byteLength = p, l.prototype._isBuffer = !0, l.prototype.swap16 = function () {
        var e = this.length;
        if (e % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");

        for (var t = 0; t < e; t += 2) {
          v(this, t, t + 1);
        }

        return this;
      }, l.prototype.swap32 = function () {
        var e = this.length;
        if (e % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");

        for (var t = 0; t < e; t += 4) {
          v(this, t, t + 3), v(this, t + 1, t + 2);
        }

        return this;
      }, l.prototype.swap64 = function () {
        var e = this.length;
        if (e % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");

        for (var t = 0; t < e; t += 8) {
          v(this, t, t + 7), v(this, t + 1, t + 6), v(this, t + 2, t + 5), v(this, t + 3, t + 4);
        }

        return this;
      }, l.prototype.toString = function () {
        var e = 0 | this.length;
        return 0 === e ? "" : 0 === arguments.length ? k(this, 0, e) : g.apply(this, arguments);
      }, l.prototype.equals = function (e) {
        if (!l.isBuffer(e)) throw new TypeError("Argument must be a Buffer");
        return this === e || 0 === l.compare(this, e);
      }, l.prototype.inspect = function () {
        var e = "",
            n = t.INSPECT_MAX_BYTES;
        return this.length > 0 && (e = this.toString("hex", 0, n).match(/.{2}/g).join(" "), this.length > n && (e += " ... ")), "<Buffer " + e + ">";
      }, l.prototype.compare = function (e, t, n, i, r) {
        if (!l.isBuffer(e)) throw new TypeError("Argument must be a Buffer");
        if (void 0 === t && (t = 0), void 0 === n && (n = e ? e.length : 0), void 0 === i && (i = 0), void 0 === r && (r = this.length), t < 0 || n > e.length || i < 0 || r > this.length) throw new RangeError("out of range index");
        if (i >= r && t >= n) return 0;
        if (i >= r) return -1;
        if (t >= n) return 1;
        if (this === e) return 0;

        for (var o = (r >>>= 0) - (i >>>= 0), a = (n >>>= 0) - (t >>>= 0), s = Math.min(o, a), u = this.slice(i, r), c = e.slice(t, n), h = 0; h < s; ++h) {
          if (u[h] !== c[h]) {
            o = u[h], a = c[h];
            break;
          }
        }

        return o < a ? -1 : a < o ? 1 : 0;
      }, l.prototype.includes = function (e, t, n) {
        return -1 !== this.indexOf(e, t, n);
      }, l.prototype.indexOf = function (e, t, n) {
        return m(this, e, t, n, !0);
      }, l.prototype.lastIndexOf = function (e, t, n) {
        return m(this, e, t, n, !1);
      }, l.prototype.write = function (e, t, n, i) {
        if (void 0 === t) i = "utf8", n = this.length, t = 0;else if (void 0 === n && "string" == typeof t) i = t, n = this.length, t = 0;else {
          if (!isFinite(t)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
          t |= 0, isFinite(n) ? (n |= 0, void 0 === i && (i = "utf8")) : (i = n, n = void 0);
        }
        var r = this.length - t;
        if ((void 0 === n || n > r) && (n = r), e.length > 0 && (n < 0 || t < 0) || t > this.length) throw new RangeError("Attempt to write outside buffer bounds");
        i || (i = "utf8");

        for (var o = !1;;) {
          switch (i) {
            case "hex":
              return x(this, e, t, n);

            case "utf8":
            case "utf-8":
              return _(this, e, t, n);

            case "ascii":
              return b(this, e, t, n);

            case "latin1":
            case "binary":
              return w(this, e, t, n);

            case "base64":
              return S(this, e, t, n);

            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return T(this, e, t, n);

            default:
              if (o) throw new TypeError("Unknown encoding: " + i);
              i = ("" + i).toLowerCase(), o = !0;
          }
        }
      }, l.prototype.toJSON = function () {
        return {
          type: "Buffer",
          data: Array.prototype.slice.call(this._arr || this, 0)
        };
      };

      function M(e, t, n) {
        var i = "";
        n = Math.min(e.length, n);

        for (var r = t; r < n; ++r) {
          i += String.fromCharCode(127 & e[r]);
        }

        return i;
      }

      function E(e, t, n) {
        var i = "";
        n = Math.min(e.length, n);

        for (var r = t; r < n; ++r) {
          i += String.fromCharCode(e[r]);
        }

        return i;
      }

      function A(e, t, n) {
        var i = e.length;
        (!t || t < 0) && (t = 0), (!n || n < 0 || n > i) && (n = i);

        for (var r = "", o = t; o < n; ++o) {
          r += z(e[o]);
        }

        return r;
      }

      function I(e, t, n) {
        for (var i = e.slice(t, n), r = "", o = 0; o < i.length; o += 2) {
          r += String.fromCharCode(i[o] + 256 * i[o + 1]);
        }

        return r;
      }

      function P(e, t, n) {
        if (e % 1 != 0 || e < 0) throw new RangeError("offset is not uint");
        if (e + t > n) throw new RangeError("Trying to access beyond buffer length");
      }

      function O(e, t, n, i, r, o) {
        if (!l.isBuffer(e)) throw new TypeError('"buffer" argument must be a Buffer instance');
        if (t > r || t < o) throw new RangeError('"value" argument is out of bounds');
        if (n + i > e.length) throw new RangeError("Index out of range");
      }

      function L(e, t, n, i) {
        t < 0 && (t = 65535 + t + 1);

        for (var r = 0, o = Math.min(e.length - n, 2); r < o; ++r) {
          e[n + r] = (t & 255 << 8 * (i ? r : 1 - r)) >>> 8 * (i ? r : 1 - r);
        }
      }

      function D(e, t, n, i) {
        t < 0 && (t = 4294967295 + t + 1);

        for (var r = 0, o = Math.min(e.length - n, 4); r < o; ++r) {
          e[n + r] = t >>> 8 * (i ? r : 3 - r) & 255;
        }
      }

      function N(e, t, n, i, r, o) {
        if (n + i > e.length) throw new RangeError("Index out of range");
        if (n < 0) throw new RangeError("Index out of range");
      }

      function j(e, t, n, i, o) {
        return o || N(e, 0, n, 4), r.write(e, t, n, i, 23, 4), n + 4;
      }

      function R(e, t, n, i, o) {
        return o || N(e, 0, n, 8), r.write(e, t, n, i, 52, 8), n + 8;
      }

      l.prototype.slice = function (e, t) {
        var n,
            i = this.length;
        if ((e = ~~e) < 0 ? (e += i) < 0 && (e = 0) : e > i && (e = i), (t = void 0 === t ? i : ~~t) < 0 ? (t += i) < 0 && (t = 0) : t > i && (t = i), t < e && (t = e), l.TYPED_ARRAY_SUPPORT) (n = this.subarray(e, t)).__proto__ = l.prototype;else {
          var r = t - e;
          n = new l(r, void 0);

          for (var o = 0; o < r; ++o) {
            n[o] = this[o + e];
          }
        }
        return n;
      }, l.prototype.readUIntLE = function (e, t, n) {
        e |= 0, t |= 0, n || P(e, t, this.length);

        for (var i = this[e], r = 1, o = 0; ++o < t && (r *= 256);) {
          i += this[e + o] * r;
        }

        return i;
      }, l.prototype.readUIntBE = function (e, t, n) {
        e |= 0, t |= 0, n || P(e, t, this.length);

        for (var i = this[e + --t], r = 1; t > 0 && (r *= 256);) {
          i += this[e + --t] * r;
        }

        return i;
      }, l.prototype.readUInt8 = function (e, t) {
        return t || P(e, 1, this.length), this[e];
      }, l.prototype.readUInt16LE = function (e, t) {
        return t || P(e, 2, this.length), this[e] | this[e + 1] << 8;
      }, l.prototype.readUInt16BE = function (e, t) {
        return t || P(e, 2, this.length), this[e] << 8 | this[e + 1];
      }, l.prototype.readUInt32LE = function (e, t) {
        return t || P(e, 4, this.length), (this[e] | this[e + 1] << 8 | this[e + 2] << 16) + 16777216 * this[e + 3];
      }, l.prototype.readUInt32BE = function (e, t) {
        return t || P(e, 4, this.length), 16777216 * this[e] + (this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3]);
      }, l.prototype.readIntLE = function (e, t, n) {
        e |= 0, t |= 0, n || P(e, t, this.length);

        for (var i = this[e], r = 1, o = 0; ++o < t && (r *= 256);) {
          i += this[e + o] * r;
        }

        return i >= (r *= 128) && (i -= Math.pow(2, 8 * t)), i;
      }, l.prototype.readIntBE = function (e, t, n) {
        e |= 0, t |= 0, n || P(e, t, this.length);

        for (var i = t, r = 1, o = this[e + --i]; i > 0 && (r *= 256);) {
          o += this[e + --i] * r;
        }

        return o >= (r *= 128) && (o -= Math.pow(2, 8 * t)), o;
      }, l.prototype.readInt8 = function (e, t) {
        return t || P(e, 1, this.length), 128 & this[e] ? -1 * (255 - this[e] + 1) : this[e];
      }, l.prototype.readInt16LE = function (e, t) {
        t || P(e, 2, this.length);
        var n = this[e] | this[e + 1] << 8;
        return 32768 & n ? 4294901760 | n : n;
      }, l.prototype.readInt16BE = function (e, t) {
        t || P(e, 2, this.length);
        var n = this[e + 1] | this[e] << 8;
        return 32768 & n ? 4294901760 | n : n;
      }, l.prototype.readInt32LE = function (e, t) {
        return t || P(e, 4, this.length), this[e] | this[e + 1] << 8 | this[e + 2] << 16 | this[e + 3] << 24;
      }, l.prototype.readInt32BE = function (e, t) {
        return t || P(e, 4, this.length), this[e] << 24 | this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3];
      }, l.prototype.readFloatLE = function (e, t) {
        return t || P(e, 4, this.length), r.read(this, e, !0, 23, 4);
      }, l.prototype.readFloatBE = function (e, t) {
        return t || P(e, 4, this.length), r.read(this, e, !1, 23, 4);
      }, l.prototype.readDoubleLE = function (e, t) {
        return t || P(e, 8, this.length), r.read(this, e, !0, 52, 8);
      }, l.prototype.readDoubleBE = function (e, t) {
        return t || P(e, 8, this.length), r.read(this, e, !1, 52, 8);
      }, l.prototype.writeUIntLE = function (e, t, n, i) {
        (e = +e, t |= 0, n |= 0, i) || O(this, e, t, n, Math.pow(2, 8 * n) - 1, 0);
        var r = 1,
            o = 0;

        for (this[t] = 255 & e; ++o < n && (r *= 256);) {
          this[t + o] = e / r & 255;
        }

        return t + n;
      }, l.prototype.writeUIntBE = function (e, t, n, i) {
        (e = +e, t |= 0, n |= 0, i) || O(this, e, t, n, Math.pow(2, 8 * n) - 1, 0);
        var r = n - 1,
            o = 1;

        for (this[t + r] = 255 & e; --r >= 0 && (o *= 256);) {
          this[t + r] = e / o & 255;
        }

        return t + n;
      }, l.prototype.writeUInt8 = function (e, t, n) {
        return e = +e, t |= 0, n || O(this, e, t, 1, 255, 0), l.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), this[t] = 255 & e, t + 1;
      }, l.prototype.writeUInt16LE = function (e, t, n) {
        return e = +e, t |= 0, n || O(this, e, t, 2, 65535, 0), l.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8) : L(this, e, t, !0), t + 2;
      }, l.prototype.writeUInt16BE = function (e, t, n) {
        return e = +e, t |= 0, n || O(this, e, t, 2, 65535, 0), l.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 8, this[t + 1] = 255 & e) : L(this, e, t, !1), t + 2;
      }, l.prototype.writeUInt32LE = function (e, t, n) {
        return e = +e, t |= 0, n || O(this, e, t, 4, 4294967295, 0), l.TYPED_ARRAY_SUPPORT ? (this[t + 3] = e >>> 24, this[t + 2] = e >>> 16, this[t + 1] = e >>> 8, this[t] = 255 & e) : D(this, e, t, !0), t + 4;
      }, l.prototype.writeUInt32BE = function (e, t, n) {
        return e = +e, t |= 0, n || O(this, e, t, 4, 4294967295, 0), l.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e) : D(this, e, t, !1), t + 4;
      }, l.prototype.writeIntLE = function (e, t, n, i) {
        if (e = +e, t |= 0, !i) {
          var r = Math.pow(2, 8 * n - 1);
          O(this, e, t, n, r - 1, -r);
        }

        var o = 0,
            a = 1,
            s = 0;

        for (this[t] = 255 & e; ++o < n && (a *= 256);) {
          e < 0 && 0 === s && 0 !== this[t + o - 1] && (s = 1), this[t + o] = (e / a >> 0) - s & 255;
        }

        return t + n;
      }, l.prototype.writeIntBE = function (e, t, n, i) {
        if (e = +e, t |= 0, !i) {
          var r = Math.pow(2, 8 * n - 1);
          O(this, e, t, n, r - 1, -r);
        }

        var o = n - 1,
            a = 1,
            s = 0;

        for (this[t + o] = 255 & e; --o >= 0 && (a *= 256);) {
          e < 0 && 0 === s && 0 !== this[t + o + 1] && (s = 1), this[t + o] = (e / a >> 0) - s & 255;
        }

        return t + n;
      }, l.prototype.writeInt8 = function (e, t, n) {
        return e = +e, t |= 0, n || O(this, e, t, 1, 127, -128), l.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), e < 0 && (e = 255 + e + 1), this[t] = 255 & e, t + 1;
      }, l.prototype.writeInt16LE = function (e, t, n) {
        return e = +e, t |= 0, n || O(this, e, t, 2, 32767, -32768), l.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8) : L(this, e, t, !0), t + 2;
      }, l.prototype.writeInt16BE = function (e, t, n) {
        return e = +e, t |= 0, n || O(this, e, t, 2, 32767, -32768), l.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 8, this[t + 1] = 255 & e) : L(this, e, t, !1), t + 2;
      }, l.prototype.writeInt32LE = function (e, t, n) {
        return e = +e, t |= 0, n || O(this, e, t, 4, 2147483647, -2147483648), l.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8, this[t + 2] = e >>> 16, this[t + 3] = e >>> 24) : D(this, e, t, !0), t + 4;
      }, l.prototype.writeInt32BE = function (e, t, n) {
        return e = +e, t |= 0, n || O(this, e, t, 4, 2147483647, -2147483648), e < 0 && (e = 4294967295 + e + 1), l.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e) : D(this, e, t, !1), t + 4;
      }, l.prototype.writeFloatLE = function (e, t, n) {
        return j(this, e, t, !0, n);
      }, l.prototype.writeFloatBE = function (e, t, n) {
        return j(this, e, t, !1, n);
      }, l.prototype.writeDoubleLE = function (e, t, n) {
        return R(this, e, t, !0, n);
      }, l.prototype.writeDoubleBE = function (e, t, n) {
        return R(this, e, t, !1, n);
      }, l.prototype.copy = function (e, t, n, i) {
        if (n || (n = 0), i || 0 === i || (i = this.length), t >= e.length && (t = e.length), t || (t = 0), i > 0 && i < n && (i = n), i === n) return 0;
        if (0 === e.length || 0 === this.length) return 0;
        if (t < 0) throw new RangeError("targetStart out of bounds");
        if (n < 0 || n >= this.length) throw new RangeError("sourceStart out of bounds");
        if (i < 0) throw new RangeError("sourceEnd out of bounds");
        i > this.length && (i = this.length), e.length - t < i - n && (i = e.length - t + n);
        var r,
            o = i - n;
        if (this === e && n < t && t < i) for (r = o - 1; r >= 0; --r) {
          e[r + t] = this[r + n];
        } else if (o < 1e3 || !l.TYPED_ARRAY_SUPPORT) for (r = 0; r < o; ++r) {
          e[r + t] = this[r + n];
        } else Uint8Array.prototype.set.call(e, this.subarray(n, n + o), t);
        return o;
      }, l.prototype.fill = function (e, t, n, i) {
        if ("string" == typeof e) {
          if ("string" == typeof t ? (i = t, t = 0, n = this.length) : "string" == typeof n && (i = n, n = this.length), 1 === e.length) {
            var r = e.charCodeAt(0);
            r < 256 && (e = r);
          }

          if (void 0 !== i && "string" != typeof i) throw new TypeError("encoding must be a string");
          if ("string" == typeof i && !l.isEncoding(i)) throw new TypeError("Unknown encoding: " + i);
        } else "number" == typeof e && (e &= 255);

        if (t < 0 || this.length < t || this.length < n) throw new RangeError("Out of range index");
        if (n <= t) return this;
        var o;
        if (t >>>= 0, n = void 0 === n ? this.length : n >>> 0, e || (e = 0), "number" == typeof e) for (o = t; o < n; ++o) {
          this[o] = e;
        } else {
          var a = l.isBuffer(e) ? e : B(new l(e, i).toString()),
              s = a.length;

          for (o = 0; o < n - t; ++o) {
            this[o + t] = a[o % s];
          }
        }
        return this;
      };
      var F = /[^+\/0-9A-Za-z-_]/g;

      function z(e) {
        return e < 16 ? "0" + e.toString(16) : e.toString(16);
      }

      function B(e, t) {
        var n;
        t = t || 1 / 0;

        for (var i = e.length, r = null, o = [], a = 0; a < i; ++a) {
          if ((n = e.charCodeAt(a)) > 55295 && n < 57344) {
            if (!r) {
              if (n > 56319) {
                (t -= 3) > -1 && o.push(239, 191, 189);
                continue;
              }

              if (a + 1 === i) {
                (t -= 3) > -1 && o.push(239, 191, 189);
                continue;
              }

              r = n;
              continue;
            }

            if (n < 56320) {
              (t -= 3) > -1 && o.push(239, 191, 189), r = n;
              continue;
            }

            n = 65536 + (r - 55296 << 10 | n - 56320);
          } else r && (t -= 3) > -1 && o.push(239, 191, 189);

          if (r = null, n < 128) {
            if ((t -= 1) < 0) break;
            o.push(n);
          } else if (n < 2048) {
            if ((t -= 2) < 0) break;
            o.push(n >> 6 | 192, 63 & n | 128);
          } else if (n < 65536) {
            if ((t -= 3) < 0) break;
            o.push(n >> 12 | 224, n >> 6 & 63 | 128, 63 & n | 128);
          } else {
            if (!(n < 1114112)) throw new Error("Invalid code point");
            if ((t -= 4) < 0) break;
            o.push(n >> 18 | 240, n >> 12 & 63 | 128, n >> 6 & 63 | 128, 63 & n | 128);
          }
        }

        return o;
      }

      function V(e) {
        return i.toByteArray(function (e) {
          if ((e = function (e) {
            return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "");
          }(e).replace(F, "")).length < 2) return "";

          for (; e.length % 4 != 0;) {
            e += "=";
          }

          return e;
        }(e));
      }

      function H(e, t, n, i) {
        for (var r = 0; r < i && !(r + n >= t.length || r >= e.length); ++r) {
          t[r + n] = e[r];
        }

        return r;
      }
    }).call(this, n(65));
  }, function (e, t, n) {
    "use strict";

    t.byteLength = function (e) {
      var t = u(e),
          n = t[0],
          i = t[1];
      return 3 * (n + i) / 4 - i;
    }, t.toByteArray = function (e) {
      var t,
          n,
          i = u(e),
          a = i[0],
          s = i[1],
          l = new o(function (e, t, n) {
        return 3 * (t + n) / 4 - n;
      }(0, a, s)),
          c = 0,
          h = s > 0 ? a - 4 : a;

      for (n = 0; n < h; n += 4) {
        t = r[e.charCodeAt(n)] << 18 | r[e.charCodeAt(n + 1)] << 12 | r[e.charCodeAt(n + 2)] << 6 | r[e.charCodeAt(n + 3)], l[c++] = t >> 16 & 255, l[c++] = t >> 8 & 255, l[c++] = 255 & t;
      }

      2 === s && (t = r[e.charCodeAt(n)] << 2 | r[e.charCodeAt(n + 1)] >> 4, l[c++] = 255 & t);
      1 === s && (t = r[e.charCodeAt(n)] << 10 | r[e.charCodeAt(n + 1)] << 4 | r[e.charCodeAt(n + 2)] >> 2, l[c++] = t >> 8 & 255, l[c++] = 255 & t);
      return l;
    }, t.fromByteArray = function (e) {
      for (var t, n = e.length, r = n % 3, o = [], a = 0, s = n - r; a < s; a += 16383) {
        o.push(c(e, a, a + 16383 > s ? s : a + 16383));
      }

      1 === r ? (t = e[n - 1], o.push(i[t >> 2] + i[t << 4 & 63] + "==")) : 2 === r && (t = (e[n - 2] << 8) + e[n - 1], o.push(i[t >> 10] + i[t >> 4 & 63] + i[t << 2 & 63] + "="));
      return o.join("");
    };

    for (var i = [], r = [], o = "undefined" != typeof Uint8Array ? Uint8Array : Array, a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", s = 0, l = a.length; s < l; ++s) {
      i[s] = a[s], r[a.charCodeAt(s)] = s;
    }

    function u(e) {
      var t = e.length;
      if (t % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
      var n = e.indexOf("=");
      return -1 === n && (n = t), [n, n === t ? 0 : 4 - n % 4];
    }

    function c(e, t, n) {
      for (var r, o, a = [], s = t; s < n; s += 3) {
        r = (e[s] << 16 & 16711680) + (e[s + 1] << 8 & 65280) + (255 & e[s + 2]), a.push(i[(o = r) >> 18 & 63] + i[o >> 12 & 63] + i[o >> 6 & 63] + i[63 & o]);
      }

      return a.join("");
    }

    r["-".charCodeAt(0)] = 62, r["_".charCodeAt(0)] = 63;
  }, function (e, t) {
    t.read = function (e, t, n, i, r) {
      var o,
          a,
          s = 8 * r - i - 1,
          l = (1 << s) - 1,
          u = l >> 1,
          c = -7,
          h = n ? r - 1 : 0,
          d = n ? -1 : 1,
          f = e[t + h];

      for (h += d, o = f & (1 << -c) - 1, f >>= -c, c += s; c > 0; o = 256 * o + e[t + h], h += d, c -= 8) {
        ;
      }

      for (a = o & (1 << -c) - 1, o >>= -c, c += i; c > 0; a = 256 * a + e[t + h], h += d, c -= 8) {
        ;
      }

      if (0 === o) o = 1 - u;else {
        if (o === l) return a ? NaN : 1 / 0 * (f ? -1 : 1);
        a += Math.pow(2, i), o -= u;
      }
      return (f ? -1 : 1) * a * Math.pow(2, o - i);
    }, t.write = function (e, t, n, i, r, o) {
      var a,
          s,
          l,
          u = 8 * o - r - 1,
          c = (1 << u) - 1,
          h = c >> 1,
          d = 23 === r ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
          f = i ? 0 : o - 1,
          p = i ? 1 : -1,
          g = t < 0 || 0 === t && 1 / t < 0 ? 1 : 0;

      for (t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (s = isNaN(t) ? 1 : 0, a = c) : (a = Math.floor(Math.log(t) / Math.LN2), t * (l = Math.pow(2, -a)) < 1 && (a--, l *= 2), (t += a + h >= 1 ? d / l : d * Math.pow(2, 1 - h)) * l >= 2 && (a++, l /= 2), a + h >= c ? (s = 0, a = c) : a + h >= 1 ? (s = (t * l - 1) * Math.pow(2, r), a += h) : (s = t * Math.pow(2, h - 1) * Math.pow(2, r), a = 0)); r >= 8; e[n + f] = 255 & s, f += p, s /= 256, r -= 8) {
        ;
      }

      for (a = a << r | s, u += r; u > 0; e[n + f] = 255 & a, f += p, a /= 256, u -= 8) {
        ;
      }

      e[n + f - p] |= 128 * g;
    };
  }, function (e, t) {
    var n = {}.toString;

    e.exports = Array.isArray || function (e) {
      return "[object Array]" == n.call(e);
    };
  }, function (e, t) {}, function (e, t) {}, function (e, t) {}, function (e, t, n) {
    var i = n(572),
        r = n(117);

    e.exports = function e(t, n, o, a, s) {
      return t === n || (null == t || null == n || !r(t) && !r(n) ? t != t && n != n : i(t, n, o, a, e, s));
    };
  }, function (e, t, n) {
    var i = n(573),
        r = n(280),
        o = n(607),
        a = n(611),
        s = n(633),
        l = n(202),
        u = n(281),
        c = n(282),
        h = "[object Object]",
        d = Object.prototype.hasOwnProperty;

    e.exports = function (e, t, n, f, p, g) {
      var v = l(e),
          m = l(t),
          y = v ? "[object Array]" : s(e),
          x = m ? "[object Array]" : s(t),
          _ = (y = "[object Arguments]" == y ? h : y) == h,
          b = (x = "[object Arguments]" == x ? h : x) == h,
          w = y == x;

      if (w && u(e)) {
        if (!u(t)) return !1;
        v = !0, _ = !1;
      }

      if (w && !_) return g || (g = new i()), v || c(e) ? r(e, t, n, f, p, g) : o(e, t, y, n, f, p, g);

      if (!(1 & n)) {
        var S = _ && d.call(e, "__wrapped__"),
            T = b && d.call(t, "__wrapped__");

        if (S || T) {
          var C = S ? e.value() : e,
              k = T ? t.value() : t;
          return g || (g = new i()), p(C, k, n, f, g);
        }
      }

      return !!w && (g || (g = new i()), a(e, t, n, f, p, g));
    };
  }, function (e, t, n) {
    var i = n(148),
        r = n(579),
        o = n(580),
        a = n(581),
        s = n(582),
        l = n(583);

    function u(e) {
      var t = this.__data__ = new i(e);
      this.size = t.size;
    }

    u.prototype.clear = r, u.prototype.delete = o, u.prototype.get = a, u.prototype.has = s, u.prototype.set = l, e.exports = u;
  }, function (e, t) {
    e.exports = function () {
      this.__data__ = [], this.size = 0;
    };
  }, function (e, t, n) {
    var i = n(149),
        r = Array.prototype.splice;

    e.exports = function (e) {
      var t = this.__data__,
          n = i(t, e);
      return !(n < 0) && (n == t.length - 1 ? t.pop() : r.call(t, n, 1), --this.size, !0);
    };
  }, function (e, t, n) {
    var i = n(149);

    e.exports = function (e) {
      var t = this.__data__,
          n = i(t, e);
      return n < 0 ? void 0 : t[n][1];
    };
  }, function (e, t, n) {
    var i = n(149);

    e.exports = function (e) {
      return i(this.__data__, e) > -1;
    };
  }, function (e, t, n) {
    var i = n(149);

    e.exports = function (e, t) {
      var n = this.__data__,
          r = i(n, e);
      return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
    };
  }, function (e, t, n) {
    var i = n(148);

    e.exports = function () {
      this.__data__ = new i(), this.size = 0;
    };
  }, function (e, t) {
    e.exports = function (e) {
      var t = this.__data__,
          n = t.delete(e);
      return this.size = t.size, n;
    };
  }, function (e, t) {
    e.exports = function (e) {
      return this.__data__.get(e);
    };
  }, function (e, t) {
    e.exports = function (e) {
      return this.__data__.has(e);
    };
  }, function (e, t, n) {
    var i = n(148),
        r = n(200),
        o = n(279);

    e.exports = function (e, t) {
      var n = this.__data__;

      if (n instanceof i) {
        var a = n.__data__;
        if (!r || a.length < 199) return a.push([e, t]), this.size = ++n.size, this;
        n = this.__data__ = new o(a);
      }

      return n.set(e, t), this.size = n.size, this;
    };
  }, function (e, t, n) {
    var i = n(276),
        r = n(587),
        o = n(116),
        a = n(278),
        s = /^\[object .+?Constructor\]$/,
        l = Function.prototype,
        u = Object.prototype,
        c = l.toString,
        h = u.hasOwnProperty,
        d = RegExp("^" + c.call(h).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");

    e.exports = function (e) {
      return !(!o(e) || r(e)) && (i(e) ? d : s).test(a(e));
    };
  }, function (e, t, n) {
    var i = n(201),
        r = Object.prototype,
        o = r.hasOwnProperty,
        a = r.toString,
        s = i ? i.toStringTag : void 0;

    e.exports = function (e) {
      var t = o.call(e, s),
          n = e[s];

      try {
        e[s] = void 0;
        var i = !0;
      } catch (e) {}

      var r = a.call(e);
      return i && (t ? e[s] = n : delete e[s]), r;
    };
  }, function (e, t) {
    var n = Object.prototype.toString;

    e.exports = function (e) {
      return n.call(e);
    };
  }, function (e, t, n) {
    var i,
        r = n(588),
        o = (i = /[^.]+$/.exec(r && r.keys && r.keys.IE_PROTO || "")) ? "Symbol(src)_1." + i : "";

    e.exports = function (e) {
      return !!o && o in e;
    };
  }, function (e, t, n) {
    var i = n(51)["__core-js_shared__"];
    e.exports = i;
  }, function (e, t) {
    e.exports = function (e, t) {
      return null == e ? void 0 : e[t];
    };
  }, function (e, t, n) {
    var i = n(591),
        r = n(148),
        o = n(200);

    e.exports = function () {
      this.size = 0, this.__data__ = {
        hash: new i(),
        map: new (o || r)(),
        string: new i()
      };
    };
  }, function (e, t, n) {
    var i = n(592),
        r = n(593),
        o = n(594),
        a = n(595),
        s = n(596);

    function l(e) {
      var t = -1,
          n = null == e ? 0 : e.length;

      for (this.clear(); ++t < n;) {
        var i = e[t];
        this.set(i[0], i[1]);
      }
    }

    l.prototype.clear = i, l.prototype.delete = r, l.prototype.get = o, l.prototype.has = a, l.prototype.set = s, e.exports = l;
  }, function (e, t, n) {
    var i = n(150);

    e.exports = function () {
      this.__data__ = i ? i(null) : {}, this.size = 0;
    };
  }, function (e, t) {
    e.exports = function (e) {
      var t = this.has(e) && delete this.__data__[e];
      return this.size -= t ? 1 : 0, t;
    };
  }, function (e, t, n) {
    var i = n(150),
        r = Object.prototype.hasOwnProperty;

    e.exports = function (e) {
      var t = this.__data__;

      if (i) {
        var n = t[e];
        return "__lodash_hash_undefined__" === n ? void 0 : n;
      }

      return r.call(t, e) ? t[e] : void 0;
    };
  }, function (e, t, n) {
    var i = n(150),
        r = Object.prototype.hasOwnProperty;

    e.exports = function (e) {
      var t = this.__data__;
      return i ? void 0 !== t[e] : r.call(t, e);
    };
  }, function (e, t, n) {
    var i = n(150);

    e.exports = function (e, t) {
      var n = this.__data__;
      return this.size += this.has(e) ? 0 : 1, n[e] = i && void 0 === t ? "__lodash_hash_undefined__" : t, this;
    };
  }, function (e, t, n) {
    var i = n(151);

    e.exports = function (e) {
      var t = i(this, e).delete(e);
      return this.size -= t ? 1 : 0, t;
    };
  }, function (e, t) {
    e.exports = function (e) {
      var t = typeof e;
      return "string" == t || "number" == t || "symbol" == t || "boolean" == t ? "__proto__" !== e : null === e;
    };
  }, function (e, t, n) {
    var i = n(151);

    e.exports = function (e) {
      return i(this, e).get(e);
    };
  }, function (e, t, n) {
    var i = n(151);

    e.exports = function (e) {
      return i(this, e).has(e);
    };
  }, function (e, t, n) {
    var i = n(151);

    e.exports = function (e, t) {
      var n = i(this, e),
          r = n.size;
      return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
    };
  }, function (e, t, n) {
    var i = n(279),
        r = n(603),
        o = n(604);

    function a(e) {
      var t = -1,
          n = null == e ? 0 : e.length;

      for (this.__data__ = new i(); ++t < n;) {
        this.add(e[t]);
      }
    }

    a.prototype.add = a.prototype.push = r, a.prototype.has = o, e.exports = a;
  }, function (e, t) {
    e.exports = function (e) {
      return this.__data__.set(e, "__lodash_hash_undefined__"), this;
    };
  }, function (e, t) {
    e.exports = function (e) {
      return this.__data__.has(e);
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      for (var n = -1, i = null == e ? 0 : e.length; ++n < i;) {
        if (t(e[n], n, e)) return !0;
      }

      return !1;
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      return e.has(t);
    };
  }, function (e, t, n) {
    var i = n(201),
        r = n(608),
        o = n(275),
        a = n(280),
        s = n(609),
        l = n(610),
        u = i ? i.prototype : void 0,
        c = u ? u.valueOf : void 0;

    e.exports = function (e, t, n, i, u, h, d) {
      switch (n) {
        case "[object DataView]":
          if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
          e = e.buffer, t = t.buffer;

        case "[object ArrayBuffer]":
          return !(e.byteLength != t.byteLength || !h(new r(e), new r(t)));

        case "[object Boolean]":
        case "[object Date]":
        case "[object Number]":
          return o(+e, +t);

        case "[object Error]":
          return e.name == t.name && e.message == t.message;

        case "[object RegExp]":
        case "[object String]":
          return e == t + "";

        case "[object Map]":
          var f = s;

        case "[object Set]":
          var p = 1 & i;
          if (f || (f = l), e.size != t.size && !p) return !1;
          var g = d.get(e);
          if (g) return g == t;
          i |= 2, d.set(e, t);
          var v = a(f(e), f(t), i, u, h, d);
          return d.delete(e), v;

        case "[object Symbol]":
          if (c) return c.call(e) == c.call(t);
      }

      return !1;
    };
  }, function (e, t, n) {
    var i = n(51).Uint8Array;
    e.exports = i;
  }, function (e, t) {
    e.exports = function (e) {
      var t = -1,
          n = Array(e.size);
      return e.forEach(function (e, i) {
        n[++t] = [i, e];
      }), n;
    };
  }, function (e, t) {
    e.exports = function (e) {
      var t = -1,
          n = Array(e.size);
      return e.forEach(function (e) {
        n[++t] = e;
      }), n;
    };
  }, function (e, t, n) {
    var i = n(612),
        r = Object.prototype.hasOwnProperty;

    e.exports = function (e, t, n, o, a, s) {
      var l = 1 & n,
          u = i(e),
          c = u.length;
      if (c != i(t).length && !l) return !1;

      for (var h = c; h--;) {
        var d = u[h];
        if (!(l ? d in t : r.call(t, d))) return !1;
      }

      var f = s.get(e);
      if (f && s.get(t)) return f == t;
      var p = !0;
      s.set(e, t), s.set(t, e);

      for (var g = l; ++h < c;) {
        var v = e[d = u[h]],
            m = t[d];
        if (o) var y = l ? o(m, v, d, t, e, s) : o(v, m, d, e, t, s);

        if (!(void 0 === y ? v === m || a(v, m, n, o, s) : y)) {
          p = !1;
          break;
        }

        g || (g = "constructor" == d);
      }

      if (p && !g) {
        var x = e.constructor,
            _ = t.constructor;
        x == _ || !("constructor" in e) || !("constructor" in t) || "function" == typeof x && x instanceof x && "function" == typeof _ && _ instanceof _ || (p = !1);
      }

      return s.delete(e), s.delete(t), p;
    };
  }, function (e, t, n) {
    var i = n(613),
        r = n(615),
        o = n(618);

    e.exports = function (e) {
      return i(e, o, r);
    };
  }, function (e, t, n) {
    var i = n(614),
        r = n(202);

    e.exports = function (e, t, n) {
      var o = t(e);
      return r(e) ? o : i(o, n(e));
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      for (var n = -1, i = t.length, r = e.length; ++n < i;) {
        e[r + n] = t[n];
      }

      return e;
    };
  }, function (e, t, n) {
    var i = n(616),
        r = n(617),
        o = Object.prototype.propertyIsEnumerable,
        a = Object.getOwnPropertySymbols,
        s = a ? function (e) {
      return null == e ? [] : (e = Object(e), i(a(e), function (t) {
        return o.call(e, t);
      }));
    } : r;
    e.exports = s;
  }, function (e, t) {
    e.exports = function (e, t) {
      for (var n = -1, i = null == e ? 0 : e.length, r = 0, o = []; ++n < i;) {
        var a = e[n];
        t(a, n, e) && (o[r++] = a);
      }

      return o;
    };
  }, function (e, t) {
    e.exports = function () {
      return [];
    };
  }, function (e, t, n) {
    var i = n(619),
        r = n(628),
        o = n(632);

    e.exports = function (e) {
      return o(e) ? i(e) : r(e);
    };
  }, function (e, t, n) {
    var i = n(620),
        r = n(621),
        o = n(202),
        a = n(281),
        s = n(624),
        l = n(282),
        u = Object.prototype.hasOwnProperty;

    e.exports = function (e, t) {
      var n = o(e),
          c = !n && r(e),
          h = !n && !c && a(e),
          d = !n && !c && !h && l(e),
          f = n || c || h || d,
          p = f ? i(e.length, String) : [],
          g = p.length;

      for (var v in e) {
        !t && !u.call(e, v) || f && ("length" == v || h && ("offset" == v || "parent" == v) || d && ("buffer" == v || "byteLength" == v || "byteOffset" == v) || s(v, g)) || p.push(v);
      }

      return p;
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      for (var n = -1, i = Array(e); ++n < e;) {
        i[n] = t(n);
      }

      return i;
    };
  }, function (e, t, n) {
    var i = n(622),
        r = n(117),
        o = Object.prototype,
        a = o.hasOwnProperty,
        s = o.propertyIsEnumerable,
        l = i(function () {
      return arguments;
    }()) ? i : function (e) {
      return r(e) && a.call(e, "callee") && !s.call(e, "callee");
    };
    e.exports = l;
  }, function (e, t, n) {
    var i = n(115),
        r = n(117);

    e.exports = function (e) {
      return r(e) && "[object Arguments]" == i(e);
    };
  }, function (e, t) {
    e.exports = function () {
      return !1;
    };
  }, function (e, t) {
    var n = /^(?:0|[1-9]\d*)$/;

    e.exports = function (e, t) {
      var i = typeof e;
      return !!(t = null == t ? 9007199254740991 : t) && ("number" == i || "symbol" != i && n.test(e)) && e > -1 && e % 1 == 0 && e < t;
    };
  }, function (e, t, n) {
    var i = n(115),
        r = n(283),
        o = n(117),
        a = {};
    a["[object Float32Array]"] = a["[object Float64Array]"] = a["[object Int8Array]"] = a["[object Int16Array]"] = a["[object Int32Array]"] = a["[object Uint8Array]"] = a["[object Uint8ClampedArray]"] = a["[object Uint16Array]"] = a["[object Uint32Array]"] = !0, a["[object Arguments]"] = a["[object Array]"] = a["[object ArrayBuffer]"] = a["[object Boolean]"] = a["[object DataView]"] = a["[object Date]"] = a["[object Error]"] = a["[object Function]"] = a["[object Map]"] = a["[object Number]"] = a["[object Object]"] = a["[object RegExp]"] = a["[object Set]"] = a["[object String]"] = a["[object WeakMap]"] = !1, e.exports = function (e) {
      return o(e) && r(e.length) && !!a[i(e)];
    };
  }, function (e, t) {
    e.exports = function (e) {
      return function (t) {
        return e(t);
      };
    };
  }, function (e, t, n) {
    (function (e) {
      var i = n(277),
          r = t && !t.nodeType && t,
          o = r && "object" == typeof e && e && !e.nodeType && e,
          a = o && o.exports === r && i.process,
          s = function () {
        try {
          var e = o && o.require && o.require("util").types;

          return e || a && a.binding && a.binding("util");
        } catch (e) {}
      }();

      e.exports = s;
    }).call(this, n(199)(e));
  }, function (e, t, n) {
    var i = n(629),
        r = n(630),
        o = Object.prototype.hasOwnProperty;

    e.exports = function (e) {
      if (!i(e)) return r(e);
      var t = [];

      for (var n in Object(e)) {
        o.call(e, n) && "constructor" != n && t.push(n);
      }

      return t;
    };
  }, function (e, t) {
    var n = Object.prototype;

    e.exports = function (e) {
      var t = e && e.constructor;
      return e === ("function" == typeof t && t.prototype || n);
    };
  }, function (e, t, n) {
    var i = n(631)(Object.keys, Object);
    e.exports = i;
  }, function (e, t) {
    e.exports = function (e, t) {
      return function (n) {
        return e(t(n));
      };
    };
  }, function (e, t, n) {
    var i = n(276),
        r = n(283);

    e.exports = function (e) {
      return null != e && r(e.length) && !i(e);
    };
  }, function (e, t, n) {
    var i = n(634),
        r = n(200),
        o = n(635),
        a = n(636),
        s = n(637),
        l = n(115),
        u = n(278),
        c = u(i),
        h = u(r),
        d = u(o),
        f = u(a),
        p = u(s),
        g = l;
    (i && "[object DataView]" != g(new i(new ArrayBuffer(1))) || r && "[object Map]" != g(new r()) || o && "[object Promise]" != g(o.resolve()) || a && "[object Set]" != g(new a()) || s && "[object WeakMap]" != g(new s())) && (g = function g(e) {
      var t = l(e),
          n = "[object Object]" == t ? e.constructor : void 0,
          i = n ? u(n) : "";
      if (i) switch (i) {
        case c:
          return "[object DataView]";

        case h:
          return "[object Map]";

        case d:
          return "[object Promise]";

        case f:
          return "[object Set]";

        case p:
          return "[object WeakMap]";
      }
      return t;
    }), e.exports = g;
  }, function (e, t, n) {
    var i = n(99)(n(51), "DataView");
    e.exports = i;
  }, function (e, t, n) {
    var i = n(99)(n(51), "Promise");
    e.exports = i;
  }, function (e, t, n) {
    var i = n(99)(n(51), "Set");
    e.exports = i;
  }, function (e, t, n) {
    var i = n(99)(n(51), "WeakMap");
    e.exports = i;
  }, function (e, t, n) {
    "use strict";

    var i = n(110),
        r = n(274),
        o = n(639);

    function a(e) {
      for (var t = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, n = 1; n < arguments.length; n++) {
        t += "&args[]=" + encodeURIComponent(arguments[n]);
      }

      return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
    }

    if (!i) throw Error(a(227));

    function s(e, t, n, i, r, o, a, s, l) {
      var u = Array.prototype.slice.call(arguments, 3);

      try {
        t.apply(n, u);
      } catch (e) {
        this.onError(e);
      }
    }

    var l = !1,
        u = null,
        c = !1,
        h = null,
        d = {
      onError: function onError(e) {
        l = !0, u = e;
      }
    };

    function f(e, t, n, i, r, o, a, c, h) {
      l = !1, u = null, s.apply(d, arguments);
    }

    var p = null,
        g = null,
        v = null;

    function m(e, t, n) {
      var i = e.type || "unknown-event";
      e.currentTarget = v(n), function (e, t, n, i, r, o, s, d, p) {
        if (f.apply(this, arguments), l) {
          if (!l) throw Error(a(198));
          var g = u;
          l = !1, u = null, c || (c = !0, h = g);
        }
      }(i, t, void 0, e), e.currentTarget = null;
    }

    var y = null,
        x = {};

    function _() {
      if (y) for (var e in x) {
        var t = x[e],
            n = y.indexOf(e);
        if (!(-1 < n)) throw Error(a(96, e));

        if (!w[n]) {
          if (!t.extractEvents) throw Error(a(97, e));

          for (var i in w[n] = t, n = t.eventTypes) {
            var r = void 0,
                o = n[i],
                s = t,
                l = i;
            if (S.hasOwnProperty(l)) throw Error(a(99, l));
            S[l] = o;
            var u = o.phasedRegistrationNames;

            if (u) {
              for (r in u) {
                u.hasOwnProperty(r) && b(u[r], s, l);
              }

              r = !0;
            } else o.registrationName ? (b(o.registrationName, s, l), r = !0) : r = !1;

            if (!r) throw Error(a(98, i, e));
          }
        }
      }
    }

    function b(e, t, n) {
      if (T[e]) throw Error(a(100, e));
      T[e] = t, C[e] = t.eventTypes[n].dependencies;
    }

    var w = [],
        S = {},
        T = {},
        C = {};

    function k(e) {
      var t,
          n = !1;

      for (t in e) {
        if (e.hasOwnProperty(t)) {
          var i = e[t];

          if (!x.hasOwnProperty(t) || x[t] !== i) {
            if (x[t]) throw Error(a(102, t));
            x[t] = i, n = !0;
          }
        }
      }

      n && _();
    }

    var M = !("undefined" == typeof window || void 0 === window.document || void 0 === window.document.createElement),
        E = null,
        A = null,
        I = null;

    function P(e) {
      if (e = g(e)) {
        if ("function" != typeof E) throw Error(a(280));
        var t = e.stateNode;
        t && (t = p(t), E(e.stateNode, e.type, t));
      }
    }

    function O(e) {
      A ? I ? I.push(e) : I = [e] : A = e;
    }

    function L() {
      if (A) {
        var e = A,
            t = I;
        if (I = A = null, P(e), t) for (e = 0; e < t.length; e++) {
          P(t[e]);
        }
      }
    }

    function D(e, t) {
      return e(t);
    }

    function N(e, t, n, i, r) {
      return e(t, n, i, r);
    }

    function j() {}

    var R = D,
        F = !1,
        z = !1;

    function B() {
      null === A && null === I || (j(), L());
    }

    function V(e, t, n) {
      if (z) return e(t, n);
      z = !0;

      try {
        return R(e, t, n);
      } finally {
        z = !1, B();
      }
    }

    var H = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
        W = Object.prototype.hasOwnProperty,
        G = {},
        U = {};

    function Y(e, t, n, i, r, o) {
      this.acceptsBooleans = 2 === t || 3 === t || 4 === t, this.attributeName = i, this.attributeNamespace = r, this.mustUseProperty = n, this.propertyName = e, this.type = t, this.sanitizeURL = o;
    }

    var X = {};
    "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function (e) {
      X[e] = new Y(e, 0, !1, e, null, !1);
    }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function (e) {
      var t = e[0];
      X[t] = new Y(t, 1, !1, e[1], null, !1);
    }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function (e) {
      X[e] = new Y(e, 2, !1, e.toLowerCase(), null, !1);
    }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function (e) {
      X[e] = new Y(e, 2, !1, e, null, !1);
    }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function (e) {
      X[e] = new Y(e, 3, !1, e.toLowerCase(), null, !1);
    }), ["checked", "multiple", "muted", "selected"].forEach(function (e) {
      X[e] = new Y(e, 3, !0, e, null, !1);
    }), ["capture", "download"].forEach(function (e) {
      X[e] = new Y(e, 4, !1, e, null, !1);
    }), ["cols", "rows", "size", "span"].forEach(function (e) {
      X[e] = new Y(e, 6, !1, e, null, !1);
    }), ["rowSpan", "start"].forEach(function (e) {
      X[e] = new Y(e, 5, !1, e.toLowerCase(), null, !1);
    });
    var q = /[\-:]([a-z])/g;

    function Z(e) {
      return e[1].toUpperCase();
    }

    "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function (e) {
      var t = e.replace(q, Z);
      X[t] = new Y(t, 1, !1, e, null, !1);
    }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function (e) {
      var t = e.replace(q, Z);
      X[t] = new Y(t, 1, !1, e, "http://www.w3.org/1999/xlink", !1);
    }), ["xml:base", "xml:lang", "xml:space"].forEach(function (e) {
      var t = e.replace(q, Z);
      X[t] = new Y(t, 1, !1, e, "http://www.w3.org/XML/1998/namespace", !1);
    }), ["tabIndex", "crossOrigin"].forEach(function (e) {
      X[e] = new Y(e, 1, !1, e.toLowerCase(), null, !1);
    }), X.xlinkHref = new Y("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0), ["src", "href", "action", "formAction"].forEach(function (e) {
      X[e] = new Y(e, 1, !1, e.toLowerCase(), null, !0);
    });
    var K = i.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

    function $(e, t, n, i) {
      var r = X.hasOwnProperty(t) ? X[t] : null;
      (null !== r ? 0 === r.type : !i && 2 < t.length && ("o" === t[0] || "O" === t[0]) && ("n" === t[1] || "N" === t[1])) || (function (e, t, n, i) {
        if (null == t || function (e, t, n, i) {
          if (null !== n && 0 === n.type) return !1;

          switch (typeof t) {
            case "function":
            case "symbol":
              return !0;

            case "boolean":
              return !i && (null !== n ? !n.acceptsBooleans : "data-" !== (e = e.toLowerCase().slice(0, 5)) && "aria-" !== e);

            default:
              return !1;
          }
        }(e, t, n, i)) return !0;
        if (i) return !1;
        if (null !== n) switch (n.type) {
          case 3:
            return !t;

          case 4:
            return !1 === t;

          case 5:
            return isNaN(t);

          case 6:
            return isNaN(t) || 1 > t;
        }
        return !1;
      }(t, n, r, i) && (n = null), i || null === r ? function (e) {
        return !!W.call(U, e) || !W.call(G, e) && (H.test(e) ? U[e] = !0 : (G[e] = !0, !1));
      }(t) && (null === n ? e.removeAttribute(t) : e.setAttribute(t, "" + n)) : r.mustUseProperty ? e[r.propertyName] = null === n ? 3 !== r.type && "" : n : (t = r.attributeName, i = r.attributeNamespace, null === n ? e.removeAttribute(t) : (n = 3 === (r = r.type) || 4 === r && !0 === n ? "" : "" + n, i ? e.setAttributeNS(i, t, n) : e.setAttribute(t, n))));
    }

    K.hasOwnProperty("ReactCurrentDispatcher") || (K.ReactCurrentDispatcher = {
      current: null
    }), K.hasOwnProperty("ReactCurrentBatchConfig") || (K.ReactCurrentBatchConfig = {
      suspense: null
    });
    var Q = /^(.*)[\\\/]/,
        J = "function" == typeof Symbol && Symbol.for,
        ee = J ? Symbol.for("react.element") : 60103,
        te = J ? Symbol.for("react.portal") : 60106,
        ne = J ? Symbol.for("react.fragment") : 60107,
        ie = J ? Symbol.for("react.strict_mode") : 60108,
        re = J ? Symbol.for("react.profiler") : 60114,
        oe = J ? Symbol.for("react.provider") : 60109,
        ae = J ? Symbol.for("react.context") : 60110,
        se = J ? Symbol.for("react.concurrent_mode") : 60111,
        le = J ? Symbol.for("react.forward_ref") : 60112,
        ue = J ? Symbol.for("react.suspense") : 60113,
        ce = J ? Symbol.for("react.suspense_list") : 60120,
        he = J ? Symbol.for("react.memo") : 60115,
        de = J ? Symbol.for("react.lazy") : 60116,
        fe = J ? Symbol.for("react.block") : 60121,
        pe = "function" == typeof Symbol && Symbol.iterator;

    function ge(e) {
      return null === e || "object" != typeof e ? null : "function" == typeof (e = pe && e[pe] || e["@@iterator"]) ? e : null;
    }

    function ve(e) {
      if (null == e) return null;
      if ("function" == typeof e) return e.displayName || e.name || null;
      if ("string" == typeof e) return e;

      switch (e) {
        case ne:
          return "Fragment";

        case te:
          return "Portal";

        case re:
          return "Profiler";

        case ie:
          return "StrictMode";

        case ue:
          return "Suspense";

        case ce:
          return "SuspenseList";
      }

      if ("object" == typeof e) switch (e.$$typeof) {
        case ae:
          return "Context.Consumer";

        case oe:
          return "Context.Provider";

        case le:
          var t = e.render;
          return t = t.displayName || t.name || "", e.displayName || ("" !== t ? "ForwardRef(" + t + ")" : "ForwardRef");

        case he:
          return ve(e.type);

        case fe:
          return ve(e.render);

        case de:
          if (e = 1 === e._status ? e._result : null) return ve(e);
      }
      return null;
    }

    function me(e) {
      var t = "";

      do {
        e: switch (e.tag) {
          case 3:
          case 4:
          case 6:
          case 7:
          case 10:
          case 9:
            var n = "";
            break e;

          default:
            var i = e._debugOwner,
                r = e._debugSource,
                o = ve(e.type);
            n = null, i && (n = ve(i.type)), i = o, o = "", r ? o = " (at " + r.fileName.replace(Q, "") + ":" + r.lineNumber + ")" : n && (o = " (created by " + n + ")"), n = "\n    in " + (i || "Unknown") + o;
        }

        t += n, e = e.return;
      } while (e);

      return t;
    }

    function ye(e) {
      switch (typeof e) {
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
          return e;

        default:
          return "";
      }
    }

    function xe(e) {
      var t = e.type;
      return (e = e.nodeName) && "input" === e.toLowerCase() && ("checkbox" === t || "radio" === t);
    }

    function _e(e) {
      e._valueTracker || (e._valueTracker = function (e) {
        var t = xe(e) ? "checked" : "value",
            n = Object.getOwnPropertyDescriptor(e.constructor.prototype, t),
            i = "" + e[t];

        if (!e.hasOwnProperty(t) && void 0 !== n && "function" == typeof n.get && "function" == typeof n.set) {
          var r = n.get,
              o = n.set;
          return Object.defineProperty(e, t, {
            configurable: !0,
            get: function get() {
              return r.call(this);
            },
            set: function set(e) {
              i = "" + e, o.call(this, e);
            }
          }), Object.defineProperty(e, t, {
            enumerable: n.enumerable
          }), {
            getValue: function getValue() {
              return i;
            },
            setValue: function setValue(e) {
              i = "" + e;
            },
            stopTracking: function stopTracking() {
              e._valueTracker = null, delete e[t];
            }
          };
        }
      }(e));
    }

    function be(e) {
      if (!e) return !1;
      var t = e._valueTracker;
      if (!t) return !0;
      var n = t.getValue(),
          i = "";
      return e && (i = xe(e) ? e.checked ? "true" : "false" : e.value), (e = i) !== n && (t.setValue(e), !0);
    }

    function we(e, t) {
      var n = t.checked;
      return r({}, t, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != n ? n : e._wrapperState.initialChecked
      });
    }

    function Se(e, t) {
      var n = null == t.defaultValue ? "" : t.defaultValue,
          i = null != t.checked ? t.checked : t.defaultChecked;
      n = ye(null != t.value ? t.value : n), e._wrapperState = {
        initialChecked: i,
        initialValue: n,
        controlled: "checkbox" === t.type || "radio" === t.type ? null != t.checked : null != t.value
      };
    }

    function Te(e, t) {
      null != (t = t.checked) && $(e, "checked", t, !1);
    }

    function Ce(e, t) {
      Te(e, t);
      var n = ye(t.value),
          i = t.type;
      if (null != n) "number" === i ? (0 === n && "" === e.value || e.value != n) && (e.value = "" + n) : e.value !== "" + n && (e.value = "" + n);else if ("submit" === i || "reset" === i) return void e.removeAttribute("value");
      t.hasOwnProperty("value") ? Me(e, t.type, n) : t.hasOwnProperty("defaultValue") && Me(e, t.type, ye(t.defaultValue)), null == t.checked && null != t.defaultChecked && (e.defaultChecked = !!t.defaultChecked);
    }

    function ke(e, t, n) {
      if (t.hasOwnProperty("value") || t.hasOwnProperty("defaultValue")) {
        var i = t.type;
        if (!("submit" !== i && "reset" !== i || void 0 !== t.value && null !== t.value)) return;
        t = "" + e._wrapperState.initialValue, n || t === e.value || (e.value = t), e.defaultValue = t;
      }

      "" !== (n = e.name) && (e.name = ""), e.defaultChecked = !!e._wrapperState.initialChecked, "" !== n && (e.name = n);
    }

    function Me(e, t, n) {
      "number" === t && e.ownerDocument.activeElement === e || (null == n ? e.defaultValue = "" + e._wrapperState.initialValue : e.defaultValue !== "" + n && (e.defaultValue = "" + n));
    }

    function Ee(e, t) {
      return e = r({
        children: void 0
      }, t), (t = function (e) {
        var t = "";
        return i.Children.forEach(e, function (e) {
          null != e && (t += e);
        }), t;
      }(t.children)) && (e.children = t), e;
    }

    function Ae(e, t, n, i) {
      if (e = e.options, t) {
        t = {};

        for (var r = 0; r < n.length; r++) {
          t["$" + n[r]] = !0;
        }

        for (n = 0; n < e.length; n++) {
          r = t.hasOwnProperty("$" + e[n].value), e[n].selected !== r && (e[n].selected = r), r && i && (e[n].defaultSelected = !0);
        }
      } else {
        for (n = "" + ye(n), t = null, r = 0; r < e.length; r++) {
          if (e[r].value === n) return e[r].selected = !0, void (i && (e[r].defaultSelected = !0));
          null !== t || e[r].disabled || (t = e[r]);
        }

        null !== t && (t.selected = !0);
      }
    }

    function Ie(e, t) {
      if (null != t.dangerouslySetInnerHTML) throw Error(a(91));
      return r({}, t, {
        value: void 0,
        defaultValue: void 0,
        children: "" + e._wrapperState.initialValue
      });
    }

    function Pe(e, t) {
      var n = t.value;

      if (null == n) {
        if (n = t.children, t = t.defaultValue, null != n) {
          if (null != t) throw Error(a(92));

          if (Array.isArray(n)) {
            if (!(1 >= n.length)) throw Error(a(93));
            n = n[0];
          }

          t = n;
        }

        null == t && (t = ""), n = t;
      }

      e._wrapperState = {
        initialValue: ye(n)
      };
    }

    function Oe(e, t) {
      var n = ye(t.value),
          i = ye(t.defaultValue);
      null != n && ((n = "" + n) !== e.value && (e.value = n), null == t.defaultValue && e.defaultValue !== n && (e.defaultValue = n)), null != i && (e.defaultValue = "" + i);
    }

    function Le(e) {
      var t = e.textContent;
      t === e._wrapperState.initialValue && "" !== t && null !== t && (e.value = t);
    }

    var De = "http://www.w3.org/1999/xhtml",
        Ne = "http://www.w3.org/2000/svg";

    function je(e) {
      switch (e) {
        case "svg":
          return "http://www.w3.org/2000/svg";

        case "math":
          return "http://www.w3.org/1998/Math/MathML";

        default:
          return "http://www.w3.org/1999/xhtml";
      }
    }

    function Re(e, t) {
      return null == e || "http://www.w3.org/1999/xhtml" === e ? je(t) : "http://www.w3.org/2000/svg" === e && "foreignObject" === t ? "http://www.w3.org/1999/xhtml" : e;
    }

    var Fe,
        ze = function (e) {
      return "undefined" != typeof MSApp && MSApp.execUnsafeLocalFunction ? function (t, n, i, r) {
        MSApp.execUnsafeLocalFunction(function () {
          return e(t, n);
        });
      } : e;
    }(function (e, t) {
      if (e.namespaceURI !== Ne || "innerHTML" in e) e.innerHTML = t;else {
        for ((Fe = Fe || document.createElement("div")).innerHTML = "<svg>" + t.valueOf().toString() + "</svg>", t = Fe.firstChild; e.firstChild;) {
          e.removeChild(e.firstChild);
        }

        for (; t.firstChild;) {
          e.appendChild(t.firstChild);
        }
      }
    });

    function Be(e, t) {
      if (t) {
        var n = e.firstChild;
        if (n && n === e.lastChild && 3 === n.nodeType) return void (n.nodeValue = t);
      }

      e.textContent = t;
    }

    function Ve(e, t) {
      var n = {};
      return n[e.toLowerCase()] = t.toLowerCase(), n["Webkit" + e] = "webkit" + t, n["Moz" + e] = "moz" + t, n;
    }

    var He = {
      animationend: Ve("Animation", "AnimationEnd"),
      animationiteration: Ve("Animation", "AnimationIteration"),
      animationstart: Ve("Animation", "AnimationStart"),
      transitionend: Ve("Transition", "TransitionEnd")
    },
        We = {},
        Ge = {};

    function Ue(e) {
      if (We[e]) return We[e];
      if (!He[e]) return e;
      var t,
          n = He[e];

      for (t in n) {
        if (n.hasOwnProperty(t) && t in Ge) return We[e] = n[t];
      }

      return e;
    }

    M && (Ge = document.createElement("div").style, "AnimationEvent" in window || (delete He.animationend.animation, delete He.animationiteration.animation, delete He.animationstart.animation), "TransitionEvent" in window || delete He.transitionend.transition);
    var Ye = Ue("animationend"),
        Xe = Ue("animationiteration"),
        qe = Ue("animationstart"),
        Ze = Ue("transitionend"),
        Ke = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),
        $e = new ("function" == typeof WeakMap ? WeakMap : Map)();

    function Qe(e) {
      var t = $e.get(e);
      return void 0 === t && (t = new Map(), $e.set(e, t)), t;
    }

    function Je(e) {
      var t = e,
          n = e;
      if (e.alternate) for (; t.return;) {
        t = t.return;
      } else {
        e = t;

        do {
          0 != (1026 & (t = e).effectTag) && (n = t.return), e = t.return;
        } while (e);
      }
      return 3 === t.tag ? n : null;
    }

    function et(e) {
      if (13 === e.tag) {
        var t = e.memoizedState;
        if (null === t && null !== (e = e.alternate) && (t = e.memoizedState), null !== t) return t.dehydrated;
      }

      return null;
    }

    function tt(e) {
      if (Je(e) !== e) throw Error(a(188));
    }

    function nt(e) {
      if (!(e = function (e) {
        var t = e.alternate;

        if (!t) {
          if (null === (t = Je(e))) throw Error(a(188));
          return t !== e ? null : e;
        }

        for (var n = e, i = t;;) {
          var r = n.return;
          if (null === r) break;
          var o = r.alternate;

          if (null === o) {
            if (null !== (i = r.return)) {
              n = i;
              continue;
            }

            break;
          }

          if (r.child === o.child) {
            for (o = r.child; o;) {
              if (o === n) return tt(r), e;
              if (o === i) return tt(r), t;
              o = o.sibling;
            }

            throw Error(a(188));
          }

          if (n.return !== i.return) n = r, i = o;else {
            for (var s = !1, l = r.child; l;) {
              if (l === n) {
                s = !0, n = r, i = o;
                break;
              }

              if (l === i) {
                s = !0, i = r, n = o;
                break;
              }

              l = l.sibling;
            }

            if (!s) {
              for (l = o.child; l;) {
                if (l === n) {
                  s = !0, n = o, i = r;
                  break;
                }

                if (l === i) {
                  s = !0, i = o, n = r;
                  break;
                }

                l = l.sibling;
              }

              if (!s) throw Error(a(189));
            }
          }
          if (n.alternate !== i) throw Error(a(190));
        }

        if (3 !== n.tag) throw Error(a(188));
        return n.stateNode.current === n ? e : t;
      }(e))) return null;

      for (var t = e;;) {
        if (5 === t.tag || 6 === t.tag) return t;
        if (t.child) t.child.return = t, t = t.child;else {
          if (t === e) break;

          for (; !t.sibling;) {
            if (!t.return || t.return === e) return null;
            t = t.return;
          }

          t.sibling.return = t.return, t = t.sibling;
        }
      }

      return null;
    }

    function it(e, t) {
      if (null == t) throw Error(a(30));
      return null == e ? t : Array.isArray(e) ? Array.isArray(t) ? (e.push.apply(e, t), e) : (e.push(t), e) : Array.isArray(t) ? [e].concat(t) : [e, t];
    }

    function rt(e, t, n) {
      Array.isArray(e) ? e.forEach(t, n) : e && t.call(n, e);
    }

    var ot = null;

    function at(e) {
      if (e) {
        var t = e._dispatchListeners,
            n = e._dispatchInstances;
        if (Array.isArray(t)) for (var i = 0; i < t.length && !e.isPropagationStopped(); i++) {
          m(e, t[i], n[i]);
        } else t && m(e, t, n);
        e._dispatchListeners = null, e._dispatchInstances = null, e.isPersistent() || e.constructor.release(e);
      }
    }

    function st(e) {
      if (null !== e && (ot = it(ot, e)), e = ot, ot = null, e) {
        if (rt(e, at), ot) throw Error(a(95));
        if (c) throw e = h, c = !1, h = null, e;
      }
    }

    function lt(e) {
      return (e = e.target || e.srcElement || window).correspondingUseElement && (e = e.correspondingUseElement), 3 === e.nodeType ? e.parentNode : e;
    }

    function ut(e) {
      if (!M) return !1;
      var t = ((e = "on" + e) in document);
      return t || ((t = document.createElement("div")).setAttribute(e, "return;"), t = "function" == typeof t[e]), t;
    }

    var ct = [];

    function ht(e) {
      e.topLevelType = null, e.nativeEvent = null, e.targetInst = null, e.ancestors.length = 0, 10 > ct.length && ct.push(e);
    }

    function dt(e, t, n, i) {
      if (ct.length) {
        var r = ct.pop();
        return r.topLevelType = e, r.eventSystemFlags = i, r.nativeEvent = t, r.targetInst = n, r;
      }

      return {
        topLevelType: e,
        eventSystemFlags: i,
        nativeEvent: t,
        targetInst: n,
        ancestors: []
      };
    }

    function ft(e) {
      var t = e.targetInst,
          n = t;

      do {
        if (!n) {
          e.ancestors.push(n);
          break;
        }

        var i = n;
        if (3 === i.tag) i = i.stateNode.containerInfo;else {
          for (; i.return;) {
            i = i.return;
          }

          i = 3 !== i.tag ? null : i.stateNode.containerInfo;
        }
        if (!i) break;
        5 !== (t = n.tag) && 6 !== t || e.ancestors.push(n), n = Mn(i);
      } while (n);

      for (n = 0; n < e.ancestors.length; n++) {
        t = e.ancestors[n];
        var r = lt(e.nativeEvent);
        i = e.topLevelType;
        var o = e.nativeEvent,
            a = e.eventSystemFlags;
        0 === n && (a |= 64);

        for (var s = null, l = 0; l < w.length; l++) {
          var u = w[l];
          u && (u = u.extractEvents(i, t, o, r, a)) && (s = it(s, u));
        }

        st(s);
      }
    }

    function pt(e, t, n) {
      if (!n.has(e)) {
        switch (e) {
          case "scroll":
            qt(t, "scroll", !0);
            break;

          case "focus":
          case "blur":
            qt(t, "focus", !0), qt(t, "blur", !0), n.set("blur", null), n.set("focus", null);
            break;

          case "cancel":
          case "close":
            ut(e) && qt(t, e, !0);
            break;

          case "invalid":
          case "submit":
          case "reset":
            break;

          default:
            -1 === Ke.indexOf(e) && Xt(e, t);
        }

        n.set(e, null);
      }
    }

    var gt,
        vt,
        mt,
        yt = !1,
        xt = [],
        _t = null,
        bt = null,
        wt = null,
        St = new Map(),
        Tt = new Map(),
        Ct = [],
        kt = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),
        Mt = "focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");

    function Et(e, t, n, i, r) {
      return {
        blockedOn: e,
        topLevelType: t,
        eventSystemFlags: 32 | n,
        nativeEvent: r,
        container: i
      };
    }

    function At(e, t) {
      switch (e) {
        case "focus":
        case "blur":
          _t = null;
          break;

        case "dragenter":
        case "dragleave":
          bt = null;
          break;

        case "mouseover":
        case "mouseout":
          wt = null;
          break;

        case "pointerover":
        case "pointerout":
          St.delete(t.pointerId);
          break;

        case "gotpointercapture":
        case "lostpointercapture":
          Tt.delete(t.pointerId);
      }
    }

    function It(e, t, n, i, r, o) {
      return null === e || e.nativeEvent !== o ? (e = Et(t, n, i, r, o), null !== t && null !== (t = En(t)) && vt(t), e) : (e.eventSystemFlags |= i, e);
    }

    function Pt(e) {
      var t = Mn(e.target);

      if (null !== t) {
        var n = Je(t);
        if (null !== n) if (13 === (t = n.tag)) {
          if (null !== (t = et(n))) return e.blockedOn = t, void o.unstable_runWithPriority(e.priority, function () {
            mt(n);
          });
        } else if (3 === t && n.stateNode.hydrate) return void (e.blockedOn = 3 === n.tag ? n.stateNode.containerInfo : null);
      }

      e.blockedOn = null;
    }

    function Ot(e) {
      if (null !== e.blockedOn) return !1;
      var t = Qt(e.topLevelType, e.eventSystemFlags, e.container, e.nativeEvent);

      if (null !== t) {
        var n = En(t);
        return null !== n && vt(n), e.blockedOn = t, !1;
      }

      return !0;
    }

    function Lt(e, t, n) {
      Ot(e) && n.delete(t);
    }

    function Dt() {
      for (yt = !1; 0 < xt.length;) {
        var e = xt[0];

        if (null !== e.blockedOn) {
          null !== (e = En(e.blockedOn)) && gt(e);
          break;
        }

        var t = Qt(e.topLevelType, e.eventSystemFlags, e.container, e.nativeEvent);
        null !== t ? e.blockedOn = t : xt.shift();
      }

      null !== _t && Ot(_t) && (_t = null), null !== bt && Ot(bt) && (bt = null), null !== wt && Ot(wt) && (wt = null), St.forEach(Lt), Tt.forEach(Lt);
    }

    function Nt(e, t) {
      e.blockedOn === t && (e.blockedOn = null, yt || (yt = !0, o.unstable_scheduleCallback(o.unstable_NormalPriority, Dt)));
    }

    function jt(e) {
      function t(t) {
        return Nt(t, e);
      }

      if (0 < xt.length) {
        Nt(xt[0], e);

        for (var n = 1; n < xt.length; n++) {
          var i = xt[n];
          i.blockedOn === e && (i.blockedOn = null);
        }
      }

      for (null !== _t && Nt(_t, e), null !== bt && Nt(bt, e), null !== wt && Nt(wt, e), St.forEach(t), Tt.forEach(t), n = 0; n < Ct.length; n++) {
        (i = Ct[n]).blockedOn === e && (i.blockedOn = null);
      }

      for (; 0 < Ct.length && null === (n = Ct[0]).blockedOn;) {
        Pt(n), null === n.blockedOn && Ct.shift();
      }
    }

    var Rt = {},
        Ft = new Map(),
        zt = new Map(),
        Bt = ["abort", "abort", Ye, "animationEnd", Xe, "animationIteration", qe, "animationStart", "canplay", "canPlay", "canplaythrough", "canPlayThrough", "durationchange", "durationChange", "emptied", "emptied", "encrypted", "encrypted", "ended", "ended", "error", "error", "gotpointercapture", "gotPointerCapture", "load", "load", "loadeddata", "loadedData", "loadedmetadata", "loadedMetadata", "loadstart", "loadStart", "lostpointercapture", "lostPointerCapture", "playing", "playing", "progress", "progress", "seeking", "seeking", "stalled", "stalled", "suspend", "suspend", "timeupdate", "timeUpdate", Ze, "transitionEnd", "waiting", "waiting"];

    function Vt(e, t) {
      for (var n = 0; n < e.length; n += 2) {
        var i = e[n],
            r = e[n + 1],
            o = "on" + (r[0].toUpperCase() + r.slice(1));
        o = {
          phasedRegistrationNames: {
            bubbled: o,
            captured: o + "Capture"
          },
          dependencies: [i],
          eventPriority: t
        }, zt.set(i, t), Ft.set(i, o), Rt[r] = o;
      }
    }

    Vt("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0), Vt("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1), Vt(Bt, 2);

    for (var Ht = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), Wt = 0; Wt < Ht.length; Wt++) {
      zt.set(Ht[Wt], 0);
    }

    var Gt = o.unstable_UserBlockingPriority,
        Ut = o.unstable_runWithPriority,
        Yt = !0;

    function Xt(e, t) {
      qt(t, e, !1);
    }

    function qt(e, t, n) {
      var i = zt.get(t);

      switch (void 0 === i ? 2 : i) {
        case 0:
          i = Zt.bind(null, t, 1, e);
          break;

        case 1:
          i = Kt.bind(null, t, 1, e);
          break;

        default:
          i = $t.bind(null, t, 1, e);
      }

      n ? e.addEventListener(t, i, !0) : e.addEventListener(t, i, !1);
    }

    function Zt(e, t, n, i) {
      F || j();
      var r = $t,
          o = F;
      F = !0;

      try {
        N(r, e, t, n, i);
      } finally {
        (F = o) || B();
      }
    }

    function Kt(e, t, n, i) {
      Ut(Gt, $t.bind(null, e, t, n, i));
    }

    function $t(e, t, n, i) {
      if (Yt) if (0 < xt.length && -1 < kt.indexOf(e)) e = Et(null, e, t, n, i), xt.push(e);else {
        var r = Qt(e, t, n, i);
        if (null === r) At(e, i);else if (-1 < kt.indexOf(e)) e = Et(r, e, t, n, i), xt.push(e);else if (!function (e, t, n, i, r) {
          switch (t) {
            case "focus":
              return _t = It(_t, e, t, n, i, r), !0;

            case "dragenter":
              return bt = It(bt, e, t, n, i, r), !0;

            case "mouseover":
              return wt = It(wt, e, t, n, i, r), !0;

            case "pointerover":
              var o = r.pointerId;
              return St.set(o, It(St.get(o) || null, e, t, n, i, r)), !0;

            case "gotpointercapture":
              return o = r.pointerId, Tt.set(o, It(Tt.get(o) || null, e, t, n, i, r)), !0;
          }

          return !1;
        }(r, e, t, n, i)) {
          At(e, i), e = dt(e, i, null, t);

          try {
            V(ft, e);
          } finally {
            ht(e);
          }
        }
      }
    }

    function Qt(e, t, n, i) {
      if (null !== (n = Mn(n = lt(i)))) {
        var r = Je(n);
        if (null === r) n = null;else {
          var o = r.tag;

          if (13 === o) {
            if (null !== (n = et(r))) return n;
            n = null;
          } else if (3 === o) {
            if (r.stateNode.hydrate) return 3 === r.tag ? r.stateNode.containerInfo : null;
            n = null;
          } else r !== n && (n = null);
        }
      }

      e = dt(e, i, n, t);

      try {
        V(ft, e);
      } finally {
        ht(e);
      }

      return null;
    }

    var Jt = {
      animationIterationCount: !0,
      borderImageOutset: !0,
      borderImageSlice: !0,
      borderImageWidth: !0,
      boxFlex: !0,
      boxFlexGroup: !0,
      boxOrdinalGroup: !0,
      columnCount: !0,
      columns: !0,
      flex: !0,
      flexGrow: !0,
      flexPositive: !0,
      flexShrink: !0,
      flexNegative: !0,
      flexOrder: !0,
      gridArea: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowSpan: !0,
      gridRowStart: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnSpan: !0,
      gridColumnStart: !0,
      fontWeight: !0,
      lineClamp: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      tabSize: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeDasharray: !0,
      strokeDashoffset: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
      strokeWidth: !0
    },
        en = ["Webkit", "ms", "Moz", "O"];

    function tn(e, t, n) {
      return null == t || "boolean" == typeof t || "" === t ? "" : n || "number" != typeof t || 0 === t || Jt.hasOwnProperty(e) && Jt[e] ? ("" + t).trim() : t + "px";
    }

    function nn(e, t) {
      for (var n in e = e.style, t) {
        if (t.hasOwnProperty(n)) {
          var i = 0 === n.indexOf("--"),
              r = tn(n, t[n], i);
          "float" === n && (n = "cssFloat"), i ? e.setProperty(n, r) : e[n] = r;
        }
      }
    }

    Object.keys(Jt).forEach(function (e) {
      en.forEach(function (t) {
        t = t + e.charAt(0).toUpperCase() + e.substring(1), Jt[t] = Jt[e];
      });
    });
    var rn = r({
      menuitem: !0
    }, {
      area: !0,
      base: !0,
      br: !0,
      col: !0,
      embed: !0,
      hr: !0,
      img: !0,
      input: !0,
      keygen: !0,
      link: !0,
      meta: !0,
      param: !0,
      source: !0,
      track: !0,
      wbr: !0
    });

    function on(e, t) {
      if (t) {
        if (rn[e] && (null != t.children || null != t.dangerouslySetInnerHTML)) throw Error(a(137, e, ""));

        if (null != t.dangerouslySetInnerHTML) {
          if (null != t.children) throw Error(a(60));
          if ("object" != typeof t.dangerouslySetInnerHTML || !("__html" in t.dangerouslySetInnerHTML)) throw Error(a(61));
        }

        if (null != t.style && "object" != typeof t.style) throw Error(a(62, ""));
      }
    }

    function an(e, t) {
      if (-1 === e.indexOf("-")) return "string" == typeof t.is;

      switch (e) {
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;

        default:
          return !0;
      }
    }

    var sn = De;

    function ln(e, t) {
      var n = Qe(e = 9 === e.nodeType || 11 === e.nodeType ? e : e.ownerDocument);
      t = C[t];

      for (var i = 0; i < t.length; i++) {
        pt(t[i], e, n);
      }
    }

    function un() {}

    function cn(e) {
      if (void 0 === (e = e || ("undefined" != typeof document ? document : void 0))) return null;

      try {
        return e.activeElement || e.body;
      } catch (t) {
        return e.body;
      }
    }

    function hn(e) {
      for (; e && e.firstChild;) {
        e = e.firstChild;
      }

      return e;
    }

    function dn(e, t) {
      var n,
          i = hn(e);

      for (e = 0; i;) {
        if (3 === i.nodeType) {
          if (n = e + i.textContent.length, e <= t && n >= t) return {
            node: i,
            offset: t - e
          };
          e = n;
        }

        e: {
          for (; i;) {
            if (i.nextSibling) {
              i = i.nextSibling;
              break e;
            }

            i = i.parentNode;
          }

          i = void 0;
        }

        i = hn(i);
      }
    }

    function fn() {
      for (var e = window, t = cn(); t instanceof e.HTMLIFrameElement;) {
        try {
          var n = "string" == typeof t.contentWindow.location.href;
        } catch (e) {
          n = !1;
        }

        if (!n) break;
        t = cn((e = t.contentWindow).document);
      }

      return t;
    }

    function pn(e) {
      var t = e && e.nodeName && e.nodeName.toLowerCase();
      return t && ("input" === t && ("text" === e.type || "search" === e.type || "tel" === e.type || "url" === e.type || "password" === e.type) || "textarea" === t || "true" === e.contentEditable);
    }

    var gn = null,
        vn = null;

    function mn(e, t) {
      switch (e) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          return !!t.autoFocus;
      }

      return !1;
    }

    function yn(e, t) {
      return "textarea" === e || "option" === e || "noscript" === e || "string" == typeof t.children || "number" == typeof t.children || "object" == typeof t.dangerouslySetInnerHTML && null !== t.dangerouslySetInnerHTML && null != t.dangerouslySetInnerHTML.__html;
    }

    var xn = "function" == typeof setTimeout ? setTimeout : void 0,
        _n = "function" == typeof clearTimeout ? clearTimeout : void 0;

    function bn(e) {
      for (; null != e; e = e.nextSibling) {
        var t = e.nodeType;
        if (1 === t || 3 === t) break;
      }

      return e;
    }

    function wn(e) {
      e = e.previousSibling;

      for (var t = 0; e;) {
        if (8 === e.nodeType) {
          var n = e.data;

          if ("$" === n || "$!" === n || "$?" === n) {
            if (0 === t) return e;
            t--;
          } else "/$" === n && t++;
        }

        e = e.previousSibling;
      }

      return null;
    }

    var Sn = Math.random().toString(36).slice(2),
        Tn = "__reactInternalInstance$" + Sn,
        Cn = "__reactEventHandlers$" + Sn,
        kn = "__reactContainere$" + Sn;

    function Mn(e) {
      var t = e[Tn];
      if (t) return t;

      for (var n = e.parentNode; n;) {
        if (t = n[kn] || n[Tn]) {
          if (n = t.alternate, null !== t.child || null !== n && null !== n.child) for (e = wn(e); null !== e;) {
            if (n = e[Tn]) return n;
            e = wn(e);
          }
          return t;
        }

        n = (e = n).parentNode;
      }

      return null;
    }

    function En(e) {
      return !(e = e[Tn] || e[kn]) || 5 !== e.tag && 6 !== e.tag && 13 !== e.tag && 3 !== e.tag ? null : e;
    }

    function An(e) {
      if (5 === e.tag || 6 === e.tag) return e.stateNode;
      throw Error(a(33));
    }

    function In(e) {
      return e[Cn] || null;
    }

    function Pn(e) {
      do {
        e = e.return;
      } while (e && 5 !== e.tag);

      return e || null;
    }

    function On(e, t) {
      var n = e.stateNode;
      if (!n) return null;
      var i = p(n);
      if (!i) return null;
      n = i[t];

      e: switch (t) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          (i = !i.disabled) || (i = !("button" === (e = e.type) || "input" === e || "select" === e || "textarea" === e)), e = !i;
          break e;

        default:
          e = !1;
      }

      if (e) return null;
      if (n && "function" != typeof n) throw Error(a(231, t, typeof n));
      return n;
    }

    function Ln(e, t, n) {
      (t = On(e, n.dispatchConfig.phasedRegistrationNames[t])) && (n._dispatchListeners = it(n._dispatchListeners, t), n._dispatchInstances = it(n._dispatchInstances, e));
    }

    function Dn(e) {
      if (e && e.dispatchConfig.phasedRegistrationNames) {
        for (var t = e._targetInst, n = []; t;) {
          n.push(t), t = Pn(t);
        }

        for (t = n.length; 0 < t--;) {
          Ln(n[t], "captured", e);
        }

        for (t = 0; t < n.length; t++) {
          Ln(n[t], "bubbled", e);
        }
      }
    }

    function Nn(e, t, n) {
      e && n && n.dispatchConfig.registrationName && (t = On(e, n.dispatchConfig.registrationName)) && (n._dispatchListeners = it(n._dispatchListeners, t), n._dispatchInstances = it(n._dispatchInstances, e));
    }

    function jn(e) {
      e && e.dispatchConfig.registrationName && Nn(e._targetInst, null, e);
    }

    function Rn(e) {
      rt(e, Dn);
    }

    var Fn = null,
        zn = null,
        Bn = null;

    function Vn() {
      if (Bn) return Bn;
      var e,
          t,
          n = zn,
          i = n.length,
          r = "value" in Fn ? Fn.value : Fn.textContent,
          o = r.length;

      for (e = 0; e < i && n[e] === r[e]; e++) {
        ;
      }

      var a = i - e;

      for (t = 1; t <= a && n[i - t] === r[o - t]; t++) {
        ;
      }

      return Bn = r.slice(e, 1 < t ? 1 - t : void 0);
    }

    function Hn() {
      return !0;
    }

    function Wn() {
      return !1;
    }

    function Gn(e, t, n, i) {
      for (var r in this.dispatchConfig = e, this._targetInst = t, this.nativeEvent = n, e = this.constructor.Interface) {
        e.hasOwnProperty(r) && ((t = e[r]) ? this[r] = t(n) : "target" === r ? this.target = i : this[r] = n[r]);
      }

      return this.isDefaultPrevented = (null != n.defaultPrevented ? n.defaultPrevented : !1 === n.returnValue) ? Hn : Wn, this.isPropagationStopped = Wn, this;
    }

    function Un(e, t, n, i) {
      if (this.eventPool.length) {
        var r = this.eventPool.pop();
        return this.call(r, e, t, n, i), r;
      }

      return new this(e, t, n, i);
    }

    function Yn(e) {
      if (!(e instanceof this)) throw Error(a(279));
      e.destructor(), 10 > this.eventPool.length && this.eventPool.push(e);
    }

    function Xn(e) {
      e.eventPool = [], e.getPooled = Un, e.release = Yn;
    }

    r(Gn.prototype, {
      preventDefault: function preventDefault() {
        this.defaultPrevented = !0;
        var e = this.nativeEvent;
        e && (e.preventDefault ? e.preventDefault() : "unknown" != typeof e.returnValue && (e.returnValue = !1), this.isDefaultPrevented = Hn);
      },
      stopPropagation: function stopPropagation() {
        var e = this.nativeEvent;
        e && (e.stopPropagation ? e.stopPropagation() : "unknown" != typeof e.cancelBubble && (e.cancelBubble = !0), this.isPropagationStopped = Hn);
      },
      persist: function persist() {
        this.isPersistent = Hn;
      },
      isPersistent: Wn,
      destructor: function destructor() {
        var e,
            t = this.constructor.Interface;

        for (e in t) {
          this[e] = null;
        }

        this.nativeEvent = this._targetInst = this.dispatchConfig = null, this.isPropagationStopped = this.isDefaultPrevented = Wn, this._dispatchInstances = this._dispatchListeners = null;
      }
    }), Gn.Interface = {
      type: null,
      target: null,
      currentTarget: function currentTarget() {
        return null;
      },
      eventPhase: null,
      bubbles: null,
      cancelable: null,
      timeStamp: function timeStamp(e) {
        return e.timeStamp || Date.now();
      },
      defaultPrevented: null,
      isTrusted: null
    }, Gn.extend = function (e) {
      function t() {}

      function n() {
        return i.apply(this, arguments);
      }

      var i = this;
      t.prototype = i.prototype;
      var o = new t();
      return r(o, n.prototype), n.prototype = o, n.prototype.constructor = n, n.Interface = r({}, i.Interface, e), n.extend = i.extend, Xn(n), n;
    }, Xn(Gn);
    var qn = Gn.extend({
      data: null
    }),
        Zn = Gn.extend({
      data: null
    }),
        Kn = [9, 13, 27, 32],
        $n = M && "CompositionEvent" in window,
        Qn = null;
    M && "documentMode" in document && (Qn = document.documentMode);
    var Jn = M && "TextEvent" in window && !Qn,
        ei = M && (!$n || Qn && 8 < Qn && 11 >= Qn),
        ti = String.fromCharCode(32),
        ni = {
      beforeInput: {
        phasedRegistrationNames: {
          bubbled: "onBeforeInput",
          captured: "onBeforeInputCapture"
        },
        dependencies: ["compositionend", "keypress", "textInput", "paste"]
      },
      compositionEnd: {
        phasedRegistrationNames: {
          bubbled: "onCompositionEnd",
          captured: "onCompositionEndCapture"
        },
        dependencies: "blur compositionend keydown keypress keyup mousedown".split(" ")
      },
      compositionStart: {
        phasedRegistrationNames: {
          bubbled: "onCompositionStart",
          captured: "onCompositionStartCapture"
        },
        dependencies: "blur compositionstart keydown keypress keyup mousedown".split(" ")
      },
      compositionUpdate: {
        phasedRegistrationNames: {
          bubbled: "onCompositionUpdate",
          captured: "onCompositionUpdateCapture"
        },
        dependencies: "blur compositionupdate keydown keypress keyup mousedown".split(" ")
      }
    },
        ii = !1;

    function ri(e, t) {
      switch (e) {
        case "keyup":
          return -1 !== Kn.indexOf(t.keyCode);

        case "keydown":
          return 229 !== t.keyCode;

        case "keypress":
        case "mousedown":
        case "blur":
          return !0;

        default:
          return !1;
      }
    }

    function oi(e) {
      return "object" == typeof (e = e.detail) && "data" in e ? e.data : null;
    }

    var ai = !1;
    var si = {
      eventTypes: ni,
      extractEvents: function extractEvents(e, t, n, i) {
        var r;
        if ($n) e: {
          switch (e) {
            case "compositionstart":
              var o = ni.compositionStart;
              break e;

            case "compositionend":
              o = ni.compositionEnd;
              break e;

            case "compositionupdate":
              o = ni.compositionUpdate;
              break e;
          }

          o = void 0;
        } else ai ? ri(e, n) && (o = ni.compositionEnd) : "keydown" === e && 229 === n.keyCode && (o = ni.compositionStart);
        return o ? (ei && "ko" !== n.locale && (ai || o !== ni.compositionStart ? o === ni.compositionEnd && ai && (r = Vn()) : (zn = "value" in (Fn = i) ? Fn.value : Fn.textContent, ai = !0)), o = qn.getPooled(o, t, n, i), r ? o.data = r : null !== (r = oi(n)) && (o.data = r), Rn(o), r = o) : r = null, (e = Jn ? function (e, t) {
          switch (e) {
            case "compositionend":
              return oi(t);

            case "keypress":
              return 32 !== t.which ? null : (ii = !0, ti);

            case "textInput":
              return (e = t.data) === ti && ii ? null : e;

            default:
              return null;
          }
        }(e, n) : function (e, t) {
          if (ai) return "compositionend" === e || !$n && ri(e, t) ? (e = Vn(), Bn = zn = Fn = null, ai = !1, e) : null;

          switch (e) {
            case "paste":
              return null;

            case "keypress":
              if (!(t.ctrlKey || t.altKey || t.metaKey) || t.ctrlKey && t.altKey) {
                if (t.char && 1 < t.char.length) return t.char;
                if (t.which) return String.fromCharCode(t.which);
              }

              return null;

            case "compositionend":
              return ei && "ko" !== t.locale ? null : t.data;

            default:
              return null;
          }
        }(e, n)) ? ((t = Zn.getPooled(ni.beforeInput, t, n, i)).data = e, Rn(t)) : t = null, null === r ? t : null === t ? r : [r, t];
      }
    },
        li = {
      color: !0,
      date: !0,
      datetime: !0,
      "datetime-local": !0,
      email: !0,
      month: !0,
      number: !0,
      password: !0,
      range: !0,
      search: !0,
      tel: !0,
      text: !0,
      time: !0,
      url: !0,
      week: !0
    };

    function ui(e) {
      var t = e && e.nodeName && e.nodeName.toLowerCase();
      return "input" === t ? !!li[e.type] : "textarea" === t;
    }

    var ci = {
      change: {
        phasedRegistrationNames: {
          bubbled: "onChange",
          captured: "onChangeCapture"
        },
        dependencies: "blur change click focus input keydown keyup selectionchange".split(" ")
      }
    };

    function hi(e, t, n) {
      return (e = Gn.getPooled(ci.change, e, t, n)).type = "change", O(n), Rn(e), e;
    }

    var di = null,
        fi = null;

    function pi(e) {
      st(e);
    }

    function gi(e) {
      if (be(An(e))) return e;
    }

    function vi(e, t) {
      if ("change" === e) return t;
    }

    var mi = !1;

    function yi() {
      di && (di.detachEvent("onpropertychange", xi), fi = di = null);
    }

    function xi(e) {
      if ("value" === e.propertyName && gi(fi)) if (e = hi(fi, e, lt(e)), F) st(e);else {
        F = !0;

        try {
          D(pi, e);
        } finally {
          F = !1, B();
        }
      }
    }

    function _i(e, t, n) {
      "focus" === e ? (yi(), fi = n, (di = t).attachEvent("onpropertychange", xi)) : "blur" === e && yi();
    }

    function bi(e) {
      if ("selectionchange" === e || "keyup" === e || "keydown" === e) return gi(fi);
    }

    function wi(e, t) {
      if ("click" === e) return gi(t);
    }

    function Si(e, t) {
      if ("input" === e || "change" === e) return gi(t);
    }

    M && (mi = ut("input") && (!document.documentMode || 9 < document.documentMode));
    var Ti = {
      eventTypes: ci,
      _isInputEventSupported: mi,
      extractEvents: function extractEvents(e, t, n, i) {
        var r = t ? An(t) : window,
            o = r.nodeName && r.nodeName.toLowerCase();
        if ("select" === o || "input" === o && "file" === r.type) var a = vi;else if (ui(r)) {
          if (mi) a = Si;else {
            a = bi;
            var s = _i;
          }
        } else (o = r.nodeName) && "input" === o.toLowerCase() && ("checkbox" === r.type || "radio" === r.type) && (a = wi);
        if (a && (a = a(e, t))) return hi(a, n, i);
        s && s(e, r, t), "blur" === e && (e = r._wrapperState) && e.controlled && "number" === r.type && Me(r, "number", r.value);
      }
    },
        Ci = Gn.extend({
      view: null,
      detail: null
    }),
        ki = {
      Alt: "altKey",
      Control: "ctrlKey",
      Meta: "metaKey",
      Shift: "shiftKey"
    };

    function Mi(e) {
      var t = this.nativeEvent;
      return t.getModifierState ? t.getModifierState(e) : !!(e = ki[e]) && !!t[e];
    }

    function Ei() {
      return Mi;
    }

    var Ai = 0,
        Ii = 0,
        Pi = !1,
        Oi = !1,
        Li = Ci.extend({
      screenX: null,
      screenY: null,
      clientX: null,
      clientY: null,
      pageX: null,
      pageY: null,
      ctrlKey: null,
      shiftKey: null,
      altKey: null,
      metaKey: null,
      getModifierState: Ei,
      button: null,
      buttons: null,
      relatedTarget: function relatedTarget(e) {
        return e.relatedTarget || (e.fromElement === e.srcElement ? e.toElement : e.fromElement);
      },
      movementX: function movementX(e) {
        if ("movementX" in e) return e.movementX;
        var t = Ai;
        return Ai = e.screenX, Pi ? "mousemove" === e.type ? e.screenX - t : 0 : (Pi = !0, 0);
      },
      movementY: function movementY(e) {
        if ("movementY" in e) return e.movementY;
        var t = Ii;
        return Ii = e.screenY, Oi ? "mousemove" === e.type ? e.screenY - t : 0 : (Oi = !0, 0);
      }
    }),
        Di = Li.extend({
      pointerId: null,
      width: null,
      height: null,
      pressure: null,
      tangentialPressure: null,
      tiltX: null,
      tiltY: null,
      twist: null,
      pointerType: null,
      isPrimary: null
    }),
        Ni = {
      mouseEnter: {
        registrationName: "onMouseEnter",
        dependencies: ["mouseout", "mouseover"]
      },
      mouseLeave: {
        registrationName: "onMouseLeave",
        dependencies: ["mouseout", "mouseover"]
      },
      pointerEnter: {
        registrationName: "onPointerEnter",
        dependencies: ["pointerout", "pointerover"]
      },
      pointerLeave: {
        registrationName: "onPointerLeave",
        dependencies: ["pointerout", "pointerover"]
      }
    },
        ji = {
      eventTypes: Ni,
      extractEvents: function extractEvents(e, t, n, i, r) {
        var o = "mouseover" === e || "pointerover" === e,
            a = "mouseout" === e || "pointerout" === e;
        if (o && 0 == (32 & r) && (n.relatedTarget || n.fromElement) || !a && !o) return null;
        (o = i.window === i ? i : (o = i.ownerDocument) ? o.defaultView || o.parentWindow : window, a) ? (a = t, null !== (t = (t = n.relatedTarget || n.toElement) ? Mn(t) : null) && (t !== Je(t) || 5 !== t.tag && 6 !== t.tag) && (t = null)) : a = null;
        if (a === t) return null;
        if ("mouseout" === e || "mouseover" === e) var s = Li,
            l = Ni.mouseLeave,
            u = Ni.mouseEnter,
            c = "mouse";else "pointerout" !== e && "pointerover" !== e || (s = Di, l = Ni.pointerLeave, u = Ni.pointerEnter, c = "pointer");
        if (e = null == a ? o : An(a), o = null == t ? o : An(t), (l = s.getPooled(l, a, n, i)).type = c + "leave", l.target = e, l.relatedTarget = o, (n = s.getPooled(u, t, n, i)).type = c + "enter", n.target = o, n.relatedTarget = e, c = t, (i = a) && c) e: {
          for (u = c, a = 0, e = s = i; e; e = Pn(e)) {
            a++;
          }

          for (e = 0, t = u; t; t = Pn(t)) {
            e++;
          }

          for (; 0 < a - e;) {
            s = Pn(s), a--;
          }

          for (; 0 < e - a;) {
            u = Pn(u), e--;
          }

          for (; a--;) {
            if (s === u || s === u.alternate) break e;
            s = Pn(s), u = Pn(u);
          }

          s = null;
        } else s = null;

        for (u = s, s = []; i && i !== u && (null === (a = i.alternate) || a !== u);) {
          s.push(i), i = Pn(i);
        }

        for (i = []; c && c !== u && (null === (a = c.alternate) || a !== u);) {
          i.push(c), c = Pn(c);
        }

        for (c = 0; c < s.length; c++) {
          Nn(s[c], "bubbled", l);
        }

        for (c = i.length; 0 < c--;) {
          Nn(i[c], "captured", n);
        }

        return 0 == (64 & r) ? [l] : [l, n];
      }
    };
    var Ri = "function" == typeof Object.is ? Object.is : function (e, t) {
      return e === t && (0 !== e || 1 / e == 1 / t) || e != e && t != t;
    },
        Fi = Object.prototype.hasOwnProperty;

    function zi(e, t) {
      if (Ri(e, t)) return !0;
      if ("object" != typeof e || null === e || "object" != typeof t || null === t) return !1;
      var n = Object.keys(e),
          i = Object.keys(t);
      if (n.length !== i.length) return !1;

      for (i = 0; i < n.length; i++) {
        if (!Fi.call(t, n[i]) || !Ri(e[n[i]], t[n[i]])) return !1;
      }

      return !0;
    }

    var Bi = M && "documentMode" in document && 11 >= document.documentMode,
        Vi = {
      select: {
        phasedRegistrationNames: {
          bubbled: "onSelect",
          captured: "onSelectCapture"
        },
        dependencies: "blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")
      }
    },
        Hi = null,
        Wi = null,
        Gi = null,
        Ui = !1;

    function Yi(e, t) {
      var n = t.window === t ? t.document : 9 === t.nodeType ? t : t.ownerDocument;
      return Ui || null == Hi || Hi !== cn(n) ? null : ("selectionStart" in (n = Hi) && pn(n) ? n = {
        start: n.selectionStart,
        end: n.selectionEnd
      } : n = {
        anchorNode: (n = (n.ownerDocument && n.ownerDocument.defaultView || window).getSelection()).anchorNode,
        anchorOffset: n.anchorOffset,
        focusNode: n.focusNode,
        focusOffset: n.focusOffset
      }, Gi && zi(Gi, n) ? null : (Gi = n, (e = Gn.getPooled(Vi.select, Wi, e, t)).type = "select", e.target = Hi, Rn(e), e));
    }

    var Xi = {
      eventTypes: Vi,
      extractEvents: function extractEvents(e, t, n, i, r, o) {
        if (!(o = !(r = o || (i.window === i ? i.document : 9 === i.nodeType ? i : i.ownerDocument)))) {
          e: {
            r = Qe(r), o = C.onSelect;

            for (var a = 0; a < o.length; a++) {
              if (!r.has(o[a])) {
                r = !1;
                break e;
              }
            }

            r = !0;
          }

          o = !r;
        }

        if (o) return null;

        switch (r = t ? An(t) : window, e) {
          case "focus":
            (ui(r) || "true" === r.contentEditable) && (Hi = r, Wi = t, Gi = null);
            break;

          case "blur":
            Gi = Wi = Hi = null;
            break;

          case "mousedown":
            Ui = !0;
            break;

          case "contextmenu":
          case "mouseup":
          case "dragend":
            return Ui = !1, Yi(n, i);

          case "selectionchange":
            if (Bi) break;

          case "keydown":
          case "keyup":
            return Yi(n, i);
        }

        return null;
      }
    },
        qi = Gn.extend({
      animationName: null,
      elapsedTime: null,
      pseudoElement: null
    }),
        Zi = Gn.extend({
      clipboardData: function clipboardData(e) {
        return "clipboardData" in e ? e.clipboardData : window.clipboardData;
      }
    }),
        Ki = Ci.extend({
      relatedTarget: null
    });

    function $i(e) {
      var t = e.keyCode;
      return "charCode" in e ? 0 === (e = e.charCode) && 13 === t && (e = 13) : e = t, 10 === e && (e = 13), 32 <= e || 13 === e ? e : 0;
    }

    var Qi = {
      Esc: "Escape",
      Spacebar: " ",
      Left: "ArrowLeft",
      Up: "ArrowUp",
      Right: "ArrowRight",
      Down: "ArrowDown",
      Del: "Delete",
      Win: "OS",
      Menu: "ContextMenu",
      Apps: "ContextMenu",
      Scroll: "ScrollLock",
      MozPrintableKey: "Unidentified"
    },
        Ji = {
      8: "Backspace",
      9: "Tab",
      12: "Clear",
      13: "Enter",
      16: "Shift",
      17: "Control",
      18: "Alt",
      19: "Pause",
      20: "CapsLock",
      27: "Escape",
      32: " ",
      33: "PageUp",
      34: "PageDown",
      35: "End",
      36: "Home",
      37: "ArrowLeft",
      38: "ArrowUp",
      39: "ArrowRight",
      40: "ArrowDown",
      45: "Insert",
      46: "Delete",
      112: "F1",
      113: "F2",
      114: "F3",
      115: "F4",
      116: "F5",
      117: "F6",
      118: "F7",
      119: "F8",
      120: "F9",
      121: "F10",
      122: "F11",
      123: "F12",
      144: "NumLock",
      145: "ScrollLock",
      224: "Meta"
    },
        er = Ci.extend({
      key: function key(e) {
        if (e.key) {
          var t = Qi[e.key] || e.key;
          if ("Unidentified" !== t) return t;
        }

        return "keypress" === e.type ? 13 === (e = $i(e)) ? "Enter" : String.fromCharCode(e) : "keydown" === e.type || "keyup" === e.type ? Ji[e.keyCode] || "Unidentified" : "";
      },
      location: null,
      ctrlKey: null,
      shiftKey: null,
      altKey: null,
      metaKey: null,
      repeat: null,
      locale: null,
      getModifierState: Ei,
      charCode: function charCode(e) {
        return "keypress" === e.type ? $i(e) : 0;
      },
      keyCode: function keyCode(e) {
        return "keydown" === e.type || "keyup" === e.type ? e.keyCode : 0;
      },
      which: function which(e) {
        return "keypress" === e.type ? $i(e) : "keydown" === e.type || "keyup" === e.type ? e.keyCode : 0;
      }
    }),
        tr = Li.extend({
      dataTransfer: null
    }),
        nr = Ci.extend({
      touches: null,
      targetTouches: null,
      changedTouches: null,
      altKey: null,
      metaKey: null,
      ctrlKey: null,
      shiftKey: null,
      getModifierState: Ei
    }),
        ir = Gn.extend({
      propertyName: null,
      elapsedTime: null,
      pseudoElement: null
    }),
        rr = Li.extend({
      deltaX: function deltaX(e) {
        return "deltaX" in e ? e.deltaX : "wheelDeltaX" in e ? -e.wheelDeltaX : 0;
      },
      deltaY: function deltaY(e) {
        return "deltaY" in e ? e.deltaY : "wheelDeltaY" in e ? -e.wheelDeltaY : "wheelDelta" in e ? -e.wheelDelta : 0;
      },
      deltaZ: null,
      deltaMode: null
    }),
        or = {
      eventTypes: Rt,
      extractEvents: function extractEvents(e, t, n, i) {
        var r = Ft.get(e);
        if (!r) return null;

        switch (e) {
          case "keypress":
            if (0 === $i(n)) return null;

          case "keydown":
          case "keyup":
            e = er;
            break;

          case "blur":
          case "focus":
            e = Ki;
            break;

          case "click":
            if (2 === n.button) return null;

          case "auxclick":
          case "dblclick":
          case "mousedown":
          case "mousemove":
          case "mouseup":
          case "mouseout":
          case "mouseover":
          case "contextmenu":
            e = Li;
            break;

          case "drag":
          case "dragend":
          case "dragenter":
          case "dragexit":
          case "dragleave":
          case "dragover":
          case "dragstart":
          case "drop":
            e = tr;
            break;

          case "touchcancel":
          case "touchend":
          case "touchmove":
          case "touchstart":
            e = nr;
            break;

          case Ye:
          case Xe:
          case qe:
            e = qi;
            break;

          case Ze:
            e = ir;
            break;

          case "scroll":
            e = Ci;
            break;

          case "wheel":
            e = rr;
            break;

          case "copy":
          case "cut":
          case "paste":
            e = Zi;
            break;

          case "gotpointercapture":
          case "lostpointercapture":
          case "pointercancel":
          case "pointerdown":
          case "pointermove":
          case "pointerout":
          case "pointerover":
          case "pointerup":
            e = Di;
            break;

          default:
            e = Gn;
        }

        return Rn(t = e.getPooled(r, t, n, i)), t;
      }
    };
    if (y) throw Error(a(101));
    y = Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" ")), _(), p = In, g = En, v = An, k({
      SimpleEventPlugin: or,
      EnterLeaveEventPlugin: ji,
      ChangeEventPlugin: Ti,
      SelectEventPlugin: Xi,
      BeforeInputEventPlugin: si
    });
    var ar = [],
        sr = -1;

    function lr(e) {
      0 > sr || (e.current = ar[sr], ar[sr] = null, sr--);
    }

    function ur(e, t) {
      sr++, ar[sr] = e.current, e.current = t;
    }

    var cr = {},
        hr = {
      current: cr
    },
        dr = {
      current: !1
    },
        fr = cr;

    function pr(e, t) {
      var n = e.type.contextTypes;
      if (!n) return cr;
      var i = e.stateNode;
      if (i && i.__reactInternalMemoizedUnmaskedChildContext === t) return i.__reactInternalMemoizedMaskedChildContext;
      var r,
          o = {};

      for (r in n) {
        o[r] = t[r];
      }

      return i && ((e = e.stateNode).__reactInternalMemoizedUnmaskedChildContext = t, e.__reactInternalMemoizedMaskedChildContext = o), o;
    }

    function gr(e) {
      return null != (e = e.childContextTypes);
    }

    function vr() {
      lr(dr), lr(hr);
    }

    function mr(e, t, n) {
      if (hr.current !== cr) throw Error(a(168));
      ur(hr, t), ur(dr, n);
    }

    function yr(e, t, n) {
      var i = e.stateNode;
      if (e = t.childContextTypes, "function" != typeof i.getChildContext) return n;

      for (var o in i = i.getChildContext()) {
        if (!(o in e)) throw Error(a(108, ve(t) || "Unknown", o));
      }

      return r({}, n, {}, i);
    }

    function xr(e) {
      return e = (e = e.stateNode) && e.__reactInternalMemoizedMergedChildContext || cr, fr = hr.current, ur(hr, e), ur(dr, dr.current), !0;
    }

    function _r(e, t, n) {
      var i = e.stateNode;
      if (!i) throw Error(a(169));
      n ? (e = yr(e, t, fr), i.__reactInternalMemoizedMergedChildContext = e, lr(dr), lr(hr), ur(hr, e)) : lr(dr), ur(dr, n);
    }

    var br = o.unstable_runWithPriority,
        wr = o.unstable_scheduleCallback,
        Sr = o.unstable_cancelCallback,
        Tr = o.unstable_requestPaint,
        Cr = o.unstable_now,
        kr = o.unstable_getCurrentPriorityLevel,
        Mr = o.unstable_ImmediatePriority,
        Er = o.unstable_UserBlockingPriority,
        Ar = o.unstable_NormalPriority,
        Ir = o.unstable_LowPriority,
        Pr = o.unstable_IdlePriority,
        Or = {},
        Lr = o.unstable_shouldYield,
        Dr = void 0 !== Tr ? Tr : function () {},
        Nr = null,
        jr = null,
        Rr = !1,
        Fr = Cr(),
        zr = 1e4 > Fr ? Cr : function () {
      return Cr() - Fr;
    };

    function Br() {
      switch (kr()) {
        case Mr:
          return 99;

        case Er:
          return 98;

        case Ar:
          return 97;

        case Ir:
          return 96;

        case Pr:
          return 95;

        default:
          throw Error(a(332));
      }
    }

    function Vr(e) {
      switch (e) {
        case 99:
          return Mr;

        case 98:
          return Er;

        case 97:
          return Ar;

        case 96:
          return Ir;

        case 95:
          return Pr;

        default:
          throw Error(a(332));
      }
    }

    function Hr(e, t) {
      return e = Vr(e), br(e, t);
    }

    function Wr(e, t, n) {
      return e = Vr(e), wr(e, t, n);
    }

    function Gr(e) {
      return null === Nr ? (Nr = [e], jr = wr(Mr, Yr)) : Nr.push(e), Or;
    }

    function Ur() {
      if (null !== jr) {
        var e = jr;
        jr = null, Sr(e);
      }

      Yr();
    }

    function Yr() {
      if (!Rr && null !== Nr) {
        Rr = !0;
        var e = 0;

        try {
          var t = Nr;
          Hr(99, function () {
            for (; e < t.length; e++) {
              var n = t[e];

              do {
                n = n(!0);
              } while (null !== n);
            }
          }), Nr = null;
        } catch (t) {
          throw null !== Nr && (Nr = Nr.slice(e + 1)), wr(Mr, Ur), t;
        } finally {
          Rr = !1;
        }
      }
    }

    function Xr(e, t, n) {
      return 1073741821 - (1 + ((1073741821 - e + t / 10) / (n /= 10) | 0)) * n;
    }

    function qr(e, t) {
      if (e && e.defaultProps) for (var n in t = r({}, t), e = e.defaultProps) {
        void 0 === t[n] && (t[n] = e[n]);
      }
      return t;
    }

    var Zr = {
      current: null
    },
        Kr = null,
        $r = null,
        Qr = null;

    function Jr() {
      Qr = $r = Kr = null;
    }

    function eo(e) {
      var t = Zr.current;
      lr(Zr), e.type._context._currentValue = t;
    }

    function to(e, t) {
      for (; null !== e;) {
        var n = e.alternate;
        if (e.childExpirationTime < t) e.childExpirationTime = t, null !== n && n.childExpirationTime < t && (n.childExpirationTime = t);else {
          if (!(null !== n && n.childExpirationTime < t)) break;
          n.childExpirationTime = t;
        }
        e = e.return;
      }
    }

    function no(e, t) {
      Kr = e, Qr = $r = null, null !== (e = e.dependencies) && null !== e.firstContext && (e.expirationTime >= t && (Ia = !0), e.firstContext = null);
    }

    function io(e, t) {
      if (Qr !== e && !1 !== t && 0 !== t) if ("number" == typeof t && 1073741823 !== t || (Qr = e, t = 1073741823), t = {
        context: e,
        observedBits: t,
        next: null
      }, null === $r) {
        if (null === Kr) throw Error(a(308));
        $r = t, Kr.dependencies = {
          expirationTime: 0,
          firstContext: t,
          responders: null
        };
      } else $r = $r.next = t;
      return e._currentValue;
    }

    var ro = !1;

    function oo(e) {
      e.updateQueue = {
        baseState: e.memoizedState,
        baseQueue: null,
        shared: {
          pending: null
        },
        effects: null
      };
    }

    function ao(e, t) {
      e = e.updateQueue, t.updateQueue === e && (t.updateQueue = {
        baseState: e.baseState,
        baseQueue: e.baseQueue,
        shared: e.shared,
        effects: e.effects
      });
    }

    function so(e, t) {
      return (e = {
        expirationTime: e,
        suspenseConfig: t,
        tag: 0,
        payload: null,
        callback: null,
        next: null
      }).next = e;
    }

    function lo(e, t) {
      if (null !== (e = e.updateQueue)) {
        var n = (e = e.shared).pending;
        null === n ? t.next = t : (t.next = n.next, n.next = t), e.pending = t;
      }
    }

    function uo(e, t) {
      var n = e.alternate;
      null !== n && ao(n, e), null === (n = (e = e.updateQueue).baseQueue) ? (e.baseQueue = t.next = t, t.next = t) : (t.next = n.next, n.next = t);
    }

    function co(e, t, n, i) {
      var o = e.updateQueue;
      ro = !1;
      var a = o.baseQueue,
          s = o.shared.pending;

      if (null !== s) {
        if (null !== a) {
          var l = a.next;
          a.next = s.next, s.next = l;
        }

        a = s, o.shared.pending = null, null !== (l = e.alternate) && null !== (l = l.updateQueue) && (l.baseQueue = s);
      }

      if (null !== a) {
        l = a.next;
        var u = o.baseState,
            c = 0,
            h = null,
            d = null,
            f = null;
        if (null !== l) for (var p = l;;) {
          if ((s = p.expirationTime) < i) {
            var g = {
              expirationTime: p.expirationTime,
              suspenseConfig: p.suspenseConfig,
              tag: p.tag,
              payload: p.payload,
              callback: p.callback,
              next: null
            };
            null === f ? (d = f = g, h = u) : f = f.next = g, s > c && (c = s);
          } else {
            null !== f && (f = f.next = {
              expirationTime: 1073741823,
              suspenseConfig: p.suspenseConfig,
              tag: p.tag,
              payload: p.payload,
              callback: p.callback,
              next: null
            }), ol(s, p.suspenseConfig);

            e: {
              var v = e,
                  m = p;

              switch (s = t, g = n, m.tag) {
                case 1:
                  if ("function" == typeof (v = m.payload)) {
                    u = v.call(g, u, s);
                    break e;
                  }

                  u = v;
                  break e;

                case 3:
                  v.effectTag = -4097 & v.effectTag | 64;

                case 0:
                  if (null == (s = "function" == typeof (v = m.payload) ? v.call(g, u, s) : v)) break e;
                  u = r({}, u, s);
                  break e;

                case 2:
                  ro = !0;
              }
            }

            null !== p.callback && (e.effectTag |= 32, null === (s = o.effects) ? o.effects = [p] : s.push(p));
          }

          if (null === (p = p.next) || p === l) {
            if (null === (s = o.shared.pending)) break;
            p = a.next = s.next, s.next = l, o.baseQueue = a = s, o.shared.pending = null;
          }
        }
        null === f ? h = u : f.next = d, o.baseState = h, o.baseQueue = f, al(c), e.expirationTime = c, e.memoizedState = u;
      }
    }

    function ho(e, t, n) {
      if (e = t.effects, t.effects = null, null !== e) for (t = 0; t < e.length; t++) {
        var i = e[t],
            r = i.callback;

        if (null !== r) {
          if (i.callback = null, i = r, r = n, "function" != typeof i) throw Error(a(191, i));
          i.call(r);
        }
      }
    }

    var fo = K.ReactCurrentBatchConfig,
        po = new i.Component().refs;

    function go(e, t, n, i) {
      n = null == (n = n(i, t = e.memoizedState)) ? t : r({}, t, n), e.memoizedState = n, 0 === e.expirationTime && (e.updateQueue.baseState = n);
    }

    var vo = {
      isMounted: function isMounted(e) {
        return !!(e = e._reactInternalFiber) && Je(e) === e;
      },
      enqueueSetState: function enqueueSetState(e, t, n) {
        e = e._reactInternalFiber;
        var i = Ys(),
            r = fo.suspense;
        (r = so(i = Xs(i, e, r), r)).payload = t, null != n && (r.callback = n), lo(e, r), qs(e, i);
      },
      enqueueReplaceState: function enqueueReplaceState(e, t, n) {
        e = e._reactInternalFiber;
        var i = Ys(),
            r = fo.suspense;
        (r = so(i = Xs(i, e, r), r)).tag = 1, r.payload = t, null != n && (r.callback = n), lo(e, r), qs(e, i);
      },
      enqueueForceUpdate: function enqueueForceUpdate(e, t) {
        e = e._reactInternalFiber;
        var n = Ys(),
            i = fo.suspense;
        (i = so(n = Xs(n, e, i), i)).tag = 2, null != t && (i.callback = t), lo(e, i), qs(e, n);
      }
    };

    function mo(e, t, n, i, r, o, a) {
      return "function" == typeof (e = e.stateNode).shouldComponentUpdate ? e.shouldComponentUpdate(i, o, a) : !t.prototype || !t.prototype.isPureReactComponent || !zi(n, i) || !zi(r, o);
    }

    function yo(e, t, n) {
      var i = !1,
          r = cr,
          o = t.contextType;
      return "object" == typeof o && null !== o ? o = io(o) : (r = gr(t) ? fr : hr.current, o = (i = null != (i = t.contextTypes)) ? pr(e, r) : cr), t = new t(n, o), e.memoizedState = null !== t.state && void 0 !== t.state ? t.state : null, t.updater = vo, e.stateNode = t, t._reactInternalFiber = e, i && ((e = e.stateNode).__reactInternalMemoizedUnmaskedChildContext = r, e.__reactInternalMemoizedMaskedChildContext = o), t;
    }

    function xo(e, t, n, i) {
      e = t.state, "function" == typeof t.componentWillReceiveProps && t.componentWillReceiveProps(n, i), "function" == typeof t.UNSAFE_componentWillReceiveProps && t.UNSAFE_componentWillReceiveProps(n, i), t.state !== e && vo.enqueueReplaceState(t, t.state, null);
    }

    function _o(e, t, n, i) {
      var r = e.stateNode;
      r.props = n, r.state = e.memoizedState, r.refs = po, oo(e);
      var o = t.contextType;
      "object" == typeof o && null !== o ? r.context = io(o) : (o = gr(t) ? fr : hr.current, r.context = pr(e, o)), co(e, n, r, i), r.state = e.memoizedState, "function" == typeof (o = t.getDerivedStateFromProps) && (go(e, t, o, n), r.state = e.memoizedState), "function" == typeof t.getDerivedStateFromProps || "function" == typeof r.getSnapshotBeforeUpdate || "function" != typeof r.UNSAFE_componentWillMount && "function" != typeof r.componentWillMount || (t = r.state, "function" == typeof r.componentWillMount && r.componentWillMount(), "function" == typeof r.UNSAFE_componentWillMount && r.UNSAFE_componentWillMount(), t !== r.state && vo.enqueueReplaceState(r, r.state, null), co(e, n, r, i), r.state = e.memoizedState), "function" == typeof r.componentDidMount && (e.effectTag |= 4);
    }

    var bo = Array.isArray;

    function wo(e, t, n) {
      if (null !== (e = n.ref) && "function" != typeof e && "object" != typeof e) {
        if (n._owner) {
          if (n = n._owner) {
            if (1 !== n.tag) throw Error(a(309));
            var i = n.stateNode;
          }

          if (!i) throw Error(a(147, e));
          var r = "" + e;
          return null !== t && null !== t.ref && "function" == typeof t.ref && t.ref._stringRef === r ? t.ref : ((t = function t(e) {
            var t = i.refs;
            t === po && (t = i.refs = {}), null === e ? delete t[r] : t[r] = e;
          })._stringRef = r, t);
        }

        if ("string" != typeof e) throw Error(a(284));
        if (!n._owner) throw Error(a(290, e));
      }

      return e;
    }

    function So(e, t) {
      if ("textarea" !== e.type) throw Error(a(31, "[object Object]" === Object.prototype.toString.call(t) ? "object with keys {" + Object.keys(t).join(", ") + "}" : t, ""));
    }

    function To(e) {
      function t(t, n) {
        if (e) {
          var i = t.lastEffect;
          null !== i ? (i.nextEffect = n, t.lastEffect = n) : t.firstEffect = t.lastEffect = n, n.nextEffect = null, n.effectTag = 8;
        }
      }

      function n(n, i) {
        if (!e) return null;

        for (; null !== i;) {
          t(n, i), i = i.sibling;
        }

        return null;
      }

      function i(e, t) {
        for (e = new Map(); null !== t;) {
          null !== t.key ? e.set(t.key, t) : e.set(t.index, t), t = t.sibling;
        }

        return e;
      }

      function r(e, t) {
        return (e = kl(e, t)).index = 0, e.sibling = null, e;
      }

      function o(t, n, i) {
        return t.index = i, e ? null !== (i = t.alternate) ? (i = i.index) < n ? (t.effectTag = 2, n) : i : (t.effectTag = 2, n) : n;
      }

      function s(t) {
        return e && null === t.alternate && (t.effectTag = 2), t;
      }

      function l(e, t, n, i) {
        return null === t || 6 !== t.tag ? ((t = Al(n, e.mode, i)).return = e, t) : ((t = r(t, n)).return = e, t);
      }

      function u(e, t, n, i) {
        return null !== t && t.elementType === n.type ? ((i = r(t, n.props)).ref = wo(e, t, n), i.return = e, i) : ((i = Ml(n.type, n.key, n.props, null, e.mode, i)).ref = wo(e, t, n), i.return = e, i);
      }

      function c(e, t, n, i) {
        return null === t || 4 !== t.tag || t.stateNode.containerInfo !== n.containerInfo || t.stateNode.implementation !== n.implementation ? ((t = Il(n, e.mode, i)).return = e, t) : ((t = r(t, n.children || [])).return = e, t);
      }

      function h(e, t, n, i, o) {
        return null === t || 7 !== t.tag ? ((t = El(n, e.mode, i, o)).return = e, t) : ((t = r(t, n)).return = e, t);
      }

      function d(e, t, n) {
        if ("string" == typeof t || "number" == typeof t) return (t = Al("" + t, e.mode, n)).return = e, t;

        if ("object" == typeof t && null !== t) {
          switch (t.$$typeof) {
            case ee:
              return (n = Ml(t.type, t.key, t.props, null, e.mode, n)).ref = wo(e, null, t), n.return = e, n;

            case te:
              return (t = Il(t, e.mode, n)).return = e, t;
          }

          if (bo(t) || ge(t)) return (t = El(t, e.mode, n, null)).return = e, t;
          So(e, t);
        }

        return null;
      }

      function f(e, t, n, i) {
        var r = null !== t ? t.key : null;
        if ("string" == typeof n || "number" == typeof n) return null !== r ? null : l(e, t, "" + n, i);

        if ("object" == typeof n && null !== n) {
          switch (n.$$typeof) {
            case ee:
              return n.key === r ? n.type === ne ? h(e, t, n.props.children, i, r) : u(e, t, n, i) : null;

            case te:
              return n.key === r ? c(e, t, n, i) : null;
          }

          if (bo(n) || ge(n)) return null !== r ? null : h(e, t, n, i, null);
          So(e, n);
        }

        return null;
      }

      function p(e, t, n, i, r) {
        if ("string" == typeof i || "number" == typeof i) return l(t, e = e.get(n) || null, "" + i, r);

        if ("object" == typeof i && null !== i) {
          switch (i.$$typeof) {
            case ee:
              return e = e.get(null === i.key ? n : i.key) || null, i.type === ne ? h(t, e, i.props.children, r, i.key) : u(t, e, i, r);

            case te:
              return c(t, e = e.get(null === i.key ? n : i.key) || null, i, r);
          }

          if (bo(i) || ge(i)) return h(t, e = e.get(n) || null, i, r, null);
          So(t, i);
        }

        return null;
      }

      function g(r, a, s, l) {
        for (var u = null, c = null, h = a, g = a = 0, v = null; null !== h && g < s.length; g++) {
          h.index > g ? (v = h, h = null) : v = h.sibling;
          var m = f(r, h, s[g], l);

          if (null === m) {
            null === h && (h = v);
            break;
          }

          e && h && null === m.alternate && t(r, h), a = o(m, a, g), null === c ? u = m : c.sibling = m, c = m, h = v;
        }

        if (g === s.length) return n(r, h), u;

        if (null === h) {
          for (; g < s.length; g++) {
            null !== (h = d(r, s[g], l)) && (a = o(h, a, g), null === c ? u = h : c.sibling = h, c = h);
          }

          return u;
        }

        for (h = i(r, h); g < s.length; g++) {
          null !== (v = p(h, r, g, s[g], l)) && (e && null !== v.alternate && h.delete(null === v.key ? g : v.key), a = o(v, a, g), null === c ? u = v : c.sibling = v, c = v);
        }

        return e && h.forEach(function (e) {
          return t(r, e);
        }), u;
      }

      function v(r, s, l, u) {
        var c = ge(l);
        if ("function" != typeof c) throw Error(a(150));
        if (null == (l = c.call(l))) throw Error(a(151));

        for (var h = c = null, g = s, v = s = 0, m = null, y = l.next(); null !== g && !y.done; v++, y = l.next()) {
          g.index > v ? (m = g, g = null) : m = g.sibling;
          var x = f(r, g, y.value, u);

          if (null === x) {
            null === g && (g = m);
            break;
          }

          e && g && null === x.alternate && t(r, g), s = o(x, s, v), null === h ? c = x : h.sibling = x, h = x, g = m;
        }

        if (y.done) return n(r, g), c;

        if (null === g) {
          for (; !y.done; v++, y = l.next()) {
            null !== (y = d(r, y.value, u)) && (s = o(y, s, v), null === h ? c = y : h.sibling = y, h = y);
          }

          return c;
        }

        for (g = i(r, g); !y.done; v++, y = l.next()) {
          null !== (y = p(g, r, v, y.value, u)) && (e && null !== y.alternate && g.delete(null === y.key ? v : y.key), s = o(y, s, v), null === h ? c = y : h.sibling = y, h = y);
        }

        return e && g.forEach(function (e) {
          return t(r, e);
        }), c;
      }

      return function (e, i, o, l) {
        var u = "object" == typeof o && null !== o && o.type === ne && null === o.key;
        u && (o = o.props.children);
        var c = "object" == typeof o && null !== o;
        if (c) switch (o.$$typeof) {
          case ee:
            e: {
              for (c = o.key, u = i; null !== u;) {
                if (u.key === c) {
                  switch (u.tag) {
                    case 7:
                      if (o.type === ne) {
                        n(e, u.sibling), (i = r(u, o.props.children)).return = e, e = i;
                        break e;
                      }

                      break;

                    default:
                      if (u.elementType === o.type) {
                        n(e, u.sibling), (i = r(u, o.props)).ref = wo(e, u, o), i.return = e, e = i;
                        break e;
                      }

                  }

                  n(e, u);
                  break;
                }

                t(e, u), u = u.sibling;
              }

              o.type === ne ? ((i = El(o.props.children, e.mode, l, o.key)).return = e, e = i) : ((l = Ml(o.type, o.key, o.props, null, e.mode, l)).ref = wo(e, i, o), l.return = e, e = l);
            }

            return s(e);

          case te:
            e: {
              for (u = o.key; null !== i;) {
                if (i.key === u) {
                  if (4 === i.tag && i.stateNode.containerInfo === o.containerInfo && i.stateNode.implementation === o.implementation) {
                    n(e, i.sibling), (i = r(i, o.children || [])).return = e, e = i;
                    break e;
                  }

                  n(e, i);
                  break;
                }

                t(e, i), i = i.sibling;
              }

              (i = Il(o, e.mode, l)).return = e, e = i;
            }

            return s(e);
        }
        if ("string" == typeof o || "number" == typeof o) return o = "" + o, null !== i && 6 === i.tag ? (n(e, i.sibling), (i = r(i, o)).return = e, e = i) : (n(e, i), (i = Al(o, e.mode, l)).return = e, e = i), s(e);
        if (bo(o)) return g(e, i, o, l);
        if (ge(o)) return v(e, i, o, l);
        if (c && So(e, o), void 0 === o && !u) switch (e.tag) {
          case 1:
          case 0:
            throw e = e.type, Error(a(152, e.displayName || e.name || "Component"));
        }
        return n(e, i);
      };
    }

    var Co = To(!0),
        ko = To(!1),
        Mo = {},
        Eo = {
      current: Mo
    },
        Ao = {
      current: Mo
    },
        Io = {
      current: Mo
    };

    function Po(e) {
      if (e === Mo) throw Error(a(174));
      return e;
    }

    function Oo(e, t) {
      switch (ur(Io, t), ur(Ao, e), ur(Eo, Mo), e = t.nodeType) {
        case 9:
        case 11:
          t = (t = t.documentElement) ? t.namespaceURI : Re(null, "");
          break;

        default:
          t = Re(t = (e = 8 === e ? t.parentNode : t).namespaceURI || null, e = e.tagName);
      }

      lr(Eo), ur(Eo, t);
    }

    function Lo() {
      lr(Eo), lr(Ao), lr(Io);
    }

    function Do(e) {
      Po(Io.current);
      var t = Po(Eo.current),
          n = Re(t, e.type);
      t !== n && (ur(Ao, e), ur(Eo, n));
    }

    function No(e) {
      Ao.current === e && (lr(Eo), lr(Ao));
    }

    var jo = {
      current: 0
    };

    function Ro(e) {
      for (var t = e; null !== t;) {
        if (13 === t.tag) {
          var n = t.memoizedState;
          if (null !== n && (null === (n = n.dehydrated) || "$?" === n.data || "$!" === n.data)) return t;
        } else if (19 === t.tag && void 0 !== t.memoizedProps.revealOrder) {
          if (0 != (64 & t.effectTag)) return t;
        } else if (null !== t.child) {
          t.child.return = t, t = t.child;
          continue;
        }

        if (t === e) break;

        for (; null === t.sibling;) {
          if (null === t.return || t.return === e) return null;
          t = t.return;
        }

        t.sibling.return = t.return, t = t.sibling;
      }

      return null;
    }

    function Fo(e, t) {
      return {
        responder: e,
        props: t
      };
    }

    var zo = K.ReactCurrentDispatcher,
        Bo = K.ReactCurrentBatchConfig,
        Vo = 0,
        Ho = null,
        Wo = null,
        Go = null,
        Uo = !1;

    function Yo() {
      throw Error(a(321));
    }

    function Xo(e, t) {
      if (null === t) return !1;

      for (var n = 0; n < t.length && n < e.length; n++) {
        if (!Ri(e[n], t[n])) return !1;
      }

      return !0;
    }

    function qo(e, t, n, i, r, o) {
      if (Vo = o, Ho = t, t.memoizedState = null, t.updateQueue = null, t.expirationTime = 0, zo.current = null === e || null === e.memoizedState ? ma : ya, e = n(i, r), t.expirationTime === Vo) {
        o = 0;

        do {
          if (t.expirationTime = 0, !(25 > o)) throw Error(a(301));
          o += 1, Go = Wo = null, t.updateQueue = null, zo.current = xa, e = n(i, r);
        } while (t.expirationTime === Vo);
      }

      if (zo.current = va, t = null !== Wo && null !== Wo.next, Vo = 0, Go = Wo = Ho = null, Uo = !1, t) throw Error(a(300));
      return e;
    }

    function Zo() {
      var e = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
      };
      return null === Go ? Ho.memoizedState = Go = e : Go = Go.next = e, Go;
    }

    function Ko() {
      if (null === Wo) {
        var e = Ho.alternate;
        e = null !== e ? e.memoizedState : null;
      } else e = Wo.next;

      var t = null === Go ? Ho.memoizedState : Go.next;
      if (null !== t) Go = t, Wo = e;else {
        if (null === e) throw Error(a(310));
        e = {
          memoizedState: (Wo = e).memoizedState,
          baseState: Wo.baseState,
          baseQueue: Wo.baseQueue,
          queue: Wo.queue,
          next: null
        }, null === Go ? Ho.memoizedState = Go = e : Go = Go.next = e;
      }
      return Go;
    }

    function $o(e, t) {
      return "function" == typeof t ? t(e) : t;
    }

    function Qo(e) {
      var t = Ko(),
          n = t.queue;
      if (null === n) throw Error(a(311));
      n.lastRenderedReducer = e;
      var i = Wo,
          r = i.baseQueue,
          o = n.pending;

      if (null !== o) {
        if (null !== r) {
          var s = r.next;
          r.next = o.next, o.next = s;
        }

        i.baseQueue = r = o, n.pending = null;
      }

      if (null !== r) {
        r = r.next, i = i.baseState;
        var l = s = o = null,
            u = r;

        do {
          var c = u.expirationTime;

          if (c < Vo) {
            var h = {
              expirationTime: u.expirationTime,
              suspenseConfig: u.suspenseConfig,
              action: u.action,
              eagerReducer: u.eagerReducer,
              eagerState: u.eagerState,
              next: null
            };
            null === l ? (s = l = h, o = i) : l = l.next = h, c > Ho.expirationTime && (Ho.expirationTime = c, al(c));
          } else null !== l && (l = l.next = {
            expirationTime: 1073741823,
            suspenseConfig: u.suspenseConfig,
            action: u.action,
            eagerReducer: u.eagerReducer,
            eagerState: u.eagerState,
            next: null
          }), ol(c, u.suspenseConfig), i = u.eagerReducer === e ? u.eagerState : e(i, u.action);

          u = u.next;
        } while (null !== u && u !== r);

        null === l ? o = i : l.next = s, Ri(i, t.memoizedState) || (Ia = !0), t.memoizedState = i, t.baseState = o, t.baseQueue = l, n.lastRenderedState = i;
      }

      return [t.memoizedState, n.dispatch];
    }

    function Jo(e) {
      var t = Ko(),
          n = t.queue;
      if (null === n) throw Error(a(311));
      n.lastRenderedReducer = e;
      var i = n.dispatch,
          r = n.pending,
          o = t.memoizedState;

      if (null !== r) {
        n.pending = null;
        var s = r = r.next;

        do {
          o = e(o, s.action), s = s.next;
        } while (s !== r);

        Ri(o, t.memoizedState) || (Ia = !0), t.memoizedState = o, null === t.baseQueue && (t.baseState = o), n.lastRenderedState = o;
      }

      return [o, i];
    }

    function ea(e) {
      var t = Zo();
      return "function" == typeof e && (e = e()), t.memoizedState = t.baseState = e, e = (e = t.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: $o,
        lastRenderedState: e
      }).dispatch = ga.bind(null, Ho, e), [t.memoizedState, e];
    }

    function ta(e, t, n, i) {
      return e = {
        tag: e,
        create: t,
        destroy: n,
        deps: i,
        next: null
      }, null === (t = Ho.updateQueue) ? (t = {
        lastEffect: null
      }, Ho.updateQueue = t, t.lastEffect = e.next = e) : null === (n = t.lastEffect) ? t.lastEffect = e.next = e : (i = n.next, n.next = e, e.next = i, t.lastEffect = e), e;
    }

    function na() {
      return Ko().memoizedState;
    }

    function ia(e, t, n, i) {
      var r = Zo();
      Ho.effectTag |= e, r.memoizedState = ta(1 | t, n, void 0, void 0 === i ? null : i);
    }

    function ra(e, t, n, i) {
      var r = Ko();
      i = void 0 === i ? null : i;
      var o = void 0;

      if (null !== Wo) {
        var a = Wo.memoizedState;
        if (o = a.destroy, null !== i && Xo(i, a.deps)) return void ta(t, n, o, i);
      }

      Ho.effectTag |= e, r.memoizedState = ta(1 | t, n, o, i);
    }

    function oa(e, t) {
      return ia(516, 4, e, t);
    }

    function aa(e, t) {
      return ra(516, 4, e, t);
    }

    function sa(e, t) {
      return ra(4, 2, e, t);
    }

    function la(e, t) {
      return "function" == typeof t ? (e = e(), t(e), function () {
        t(null);
      }) : null != t ? (e = e(), t.current = e, function () {
        t.current = null;
      }) : void 0;
    }

    function ua(e, t, n) {
      return n = null != n ? n.concat([e]) : null, ra(4, 2, la.bind(null, t, e), n);
    }

    function ca() {}

    function ha(e, t) {
      return Zo().memoizedState = [e, void 0 === t ? null : t], e;
    }

    function da(e, t) {
      var n = Ko();
      t = void 0 === t ? null : t;
      var i = n.memoizedState;
      return null !== i && null !== t && Xo(t, i[1]) ? i[0] : (n.memoizedState = [e, t], e);
    }

    function fa(e, t) {
      var n = Ko();
      t = void 0 === t ? null : t;
      var i = n.memoizedState;
      return null !== i && null !== t && Xo(t, i[1]) ? i[0] : (e = e(), n.memoizedState = [e, t], e);
    }

    function pa(e, t, n) {
      var i = Br();
      Hr(98 > i ? 98 : i, function () {
        e(!0);
      }), Hr(97 < i ? 97 : i, function () {
        var i = Bo.suspense;
        Bo.suspense = void 0 === t ? null : t;

        try {
          e(!1), n();
        } finally {
          Bo.suspense = i;
        }
      });
    }

    function ga(e, t, n) {
      var i = Ys(),
          r = fo.suspense;
      r = {
        expirationTime: i = Xs(i, e, r),
        suspenseConfig: r,
        action: n,
        eagerReducer: null,
        eagerState: null,
        next: null
      };
      var o = t.pending;
      if (null === o ? r.next = r : (r.next = o.next, o.next = r), t.pending = r, o = e.alternate, e === Ho || null !== o && o === Ho) Uo = !0, r.expirationTime = Vo, Ho.expirationTime = Vo;else {
        if (0 === e.expirationTime && (null === o || 0 === o.expirationTime) && null !== (o = t.lastRenderedReducer)) try {
          var a = t.lastRenderedState,
              s = o(a, n);
          if (r.eagerReducer = o, r.eagerState = s, Ri(s, a)) return;
        } catch (e) {}
        qs(e, i);
      }
    }

    var va = {
      readContext: io,
      useCallback: Yo,
      useContext: Yo,
      useEffect: Yo,
      useImperativeHandle: Yo,
      useLayoutEffect: Yo,
      useMemo: Yo,
      useReducer: Yo,
      useRef: Yo,
      useState: Yo,
      useDebugValue: Yo,
      useResponder: Yo,
      useDeferredValue: Yo,
      useTransition: Yo
    },
        ma = {
      readContext: io,
      useCallback: ha,
      useContext: io,
      useEffect: oa,
      useImperativeHandle: function useImperativeHandle(e, t, n) {
        return n = null != n ? n.concat([e]) : null, ia(4, 2, la.bind(null, t, e), n);
      },
      useLayoutEffect: function useLayoutEffect(e, t) {
        return ia(4, 2, e, t);
      },
      useMemo: function useMemo(e, t) {
        var n = Zo();
        return t = void 0 === t ? null : t, e = e(), n.memoizedState = [e, t], e;
      },
      useReducer: function useReducer(e, t, n) {
        var i = Zo();
        return t = void 0 !== n ? n(t) : t, i.memoizedState = i.baseState = t, e = (e = i.queue = {
          pending: null,
          dispatch: null,
          lastRenderedReducer: e,
          lastRenderedState: t
        }).dispatch = ga.bind(null, Ho, e), [i.memoizedState, e];
      },
      useRef: function useRef(e) {
        return e = {
          current: e
        }, Zo().memoizedState = e;
      },
      useState: ea,
      useDebugValue: ca,
      useResponder: Fo,
      useDeferredValue: function useDeferredValue(e, t) {
        var n = ea(e),
            i = n[0],
            r = n[1];
        return oa(function () {
          var n = Bo.suspense;
          Bo.suspense = void 0 === t ? null : t;

          try {
            r(e);
          } finally {
            Bo.suspense = n;
          }
        }, [e, t]), i;
      },
      useTransition: function useTransition(e) {
        var t = ea(!1),
            n = t[0];
        return t = t[1], [ha(pa.bind(null, t, e), [t, e]), n];
      }
    },
        ya = {
      readContext: io,
      useCallback: da,
      useContext: io,
      useEffect: aa,
      useImperativeHandle: ua,
      useLayoutEffect: sa,
      useMemo: fa,
      useReducer: Qo,
      useRef: na,
      useState: function useState() {
        return Qo($o);
      },
      useDebugValue: ca,
      useResponder: Fo,
      useDeferredValue: function useDeferredValue(e, t) {
        var n = Qo($o),
            i = n[0],
            r = n[1];
        return aa(function () {
          var n = Bo.suspense;
          Bo.suspense = void 0 === t ? null : t;

          try {
            r(e);
          } finally {
            Bo.suspense = n;
          }
        }, [e, t]), i;
      },
      useTransition: function useTransition(e) {
        var t = Qo($o),
            n = t[0];
        return t = t[1], [da(pa.bind(null, t, e), [t, e]), n];
      }
    },
        xa = {
      readContext: io,
      useCallback: da,
      useContext: io,
      useEffect: aa,
      useImperativeHandle: ua,
      useLayoutEffect: sa,
      useMemo: fa,
      useReducer: Jo,
      useRef: na,
      useState: function useState() {
        return Jo($o);
      },
      useDebugValue: ca,
      useResponder: Fo,
      useDeferredValue: function useDeferredValue(e, t) {
        var n = Jo($o),
            i = n[0],
            r = n[1];
        return aa(function () {
          var n = Bo.suspense;
          Bo.suspense = void 0 === t ? null : t;

          try {
            r(e);
          } finally {
            Bo.suspense = n;
          }
        }, [e, t]), i;
      },
      useTransition: function useTransition(e) {
        var t = Jo($o),
            n = t[0];
        return t = t[1], [da(pa.bind(null, t, e), [t, e]), n];
      }
    },
        _a = null,
        ba = null,
        wa = !1;

    function Sa(e, t) {
      var n = Tl(5, null, null, 0);
      n.elementType = "DELETED", n.type = "DELETED", n.stateNode = t, n.return = e, n.effectTag = 8, null !== e.lastEffect ? (e.lastEffect.nextEffect = n, e.lastEffect = n) : e.firstEffect = e.lastEffect = n;
    }

    function Ta(e, t) {
      switch (e.tag) {
        case 5:
          var n = e.type;
          return null !== (t = 1 !== t.nodeType || n.toLowerCase() !== t.nodeName.toLowerCase() ? null : t) && (e.stateNode = t, !0);

        case 6:
          return null !== (t = "" === e.pendingProps || 3 !== t.nodeType ? null : t) && (e.stateNode = t, !0);

        case 13:
        default:
          return !1;
      }
    }

    function Ca(e) {
      if (wa) {
        var t = ba;

        if (t) {
          var n = t;

          if (!Ta(e, t)) {
            if (!(t = bn(n.nextSibling)) || !Ta(e, t)) return e.effectTag = -1025 & e.effectTag | 2, wa = !1, void (_a = e);
            Sa(_a, n);
          }

          _a = e, ba = bn(t.firstChild);
        } else e.effectTag = -1025 & e.effectTag | 2, wa = !1, _a = e;
      }
    }

    function ka(e) {
      for (e = e.return; null !== e && 5 !== e.tag && 3 !== e.tag && 13 !== e.tag;) {
        e = e.return;
      }

      _a = e;
    }

    function Ma(e) {
      if (e !== _a) return !1;
      if (!wa) return ka(e), wa = !0, !1;
      var t = e.type;
      if (5 !== e.tag || "head" !== t && "body" !== t && !yn(t, e.memoizedProps)) for (t = ba; t;) {
        Sa(e, t), t = bn(t.nextSibling);
      }

      if (ka(e), 13 === e.tag) {
        if (!(e = null !== (e = e.memoizedState) ? e.dehydrated : null)) throw Error(a(317));

        e: {
          for (e = e.nextSibling, t = 0; e;) {
            if (8 === e.nodeType) {
              var n = e.data;

              if ("/$" === n) {
                if (0 === t) {
                  ba = bn(e.nextSibling);
                  break e;
                }

                t--;
              } else "$" !== n && "$!" !== n && "$?" !== n || t++;
            }

            e = e.nextSibling;
          }

          ba = null;
        }
      } else ba = _a ? bn(e.stateNode.nextSibling) : null;

      return !0;
    }

    function Ea() {
      ba = _a = null, wa = !1;
    }

    var Aa = K.ReactCurrentOwner,
        Ia = !1;

    function Pa(e, t, n, i) {
      t.child = null === e ? ko(t, null, n, i) : Co(t, e.child, n, i);
    }

    function Oa(e, t, n, i, r) {
      n = n.render;
      var o = t.ref;
      return no(t, r), i = qo(e, t, n, i, o, r), null === e || Ia ? (t.effectTag |= 1, Pa(e, t, i, r), t.child) : (t.updateQueue = e.updateQueue, t.effectTag &= -517, e.expirationTime <= r && (e.expirationTime = 0), qa(e, t, r));
    }

    function La(e, t, n, i, r, o) {
      if (null === e) {
        var a = n.type;
        return "function" != typeof a || Cl(a) || void 0 !== a.defaultProps || null !== n.compare || void 0 !== n.defaultProps ? ((e = Ml(n.type, null, i, null, t.mode, o)).ref = t.ref, e.return = t, t.child = e) : (t.tag = 15, t.type = a, Da(e, t, a, i, r, o));
      }

      return a = e.child, r < o && (r = a.memoizedProps, (n = null !== (n = n.compare) ? n : zi)(r, i) && e.ref === t.ref) ? qa(e, t, o) : (t.effectTag |= 1, (e = kl(a, i)).ref = t.ref, e.return = t, t.child = e);
    }

    function Da(e, t, n, i, r, o) {
      return null !== e && zi(e.memoizedProps, i) && e.ref === t.ref && (Ia = !1, r < o) ? (t.expirationTime = e.expirationTime, qa(e, t, o)) : ja(e, t, n, i, o);
    }

    function Na(e, t) {
      var n = t.ref;
      (null === e && null !== n || null !== e && e.ref !== n) && (t.effectTag |= 128);
    }

    function ja(e, t, n, i, r) {
      var o = gr(n) ? fr : hr.current;
      return o = pr(t, o), no(t, r), n = qo(e, t, n, i, o, r), null === e || Ia ? (t.effectTag |= 1, Pa(e, t, n, r), t.child) : (t.updateQueue = e.updateQueue, t.effectTag &= -517, e.expirationTime <= r && (e.expirationTime = 0), qa(e, t, r));
    }

    function Ra(e, t, n, i, r) {
      if (gr(n)) {
        var o = !0;
        xr(t);
      } else o = !1;

      if (no(t, r), null === t.stateNode) null !== e && (e.alternate = null, t.alternate = null, t.effectTag |= 2), yo(t, n, i), _o(t, n, i, r), i = !0;else if (null === e) {
        var a = t.stateNode,
            s = t.memoizedProps;
        a.props = s;
        var l = a.context,
            u = n.contextType;
        "object" == typeof u && null !== u ? u = io(u) : u = pr(t, u = gr(n) ? fr : hr.current);
        var c = n.getDerivedStateFromProps,
            h = "function" == typeof c || "function" == typeof a.getSnapshotBeforeUpdate;
        h || "function" != typeof a.UNSAFE_componentWillReceiveProps && "function" != typeof a.componentWillReceiveProps || (s !== i || l !== u) && xo(t, a, i, u), ro = !1;
        var d = t.memoizedState;
        a.state = d, co(t, i, a, r), l = t.memoizedState, s !== i || d !== l || dr.current || ro ? ("function" == typeof c && (go(t, n, c, i), l = t.memoizedState), (s = ro || mo(t, n, s, i, d, l, u)) ? (h || "function" != typeof a.UNSAFE_componentWillMount && "function" != typeof a.componentWillMount || ("function" == typeof a.componentWillMount && a.componentWillMount(), "function" == typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount()), "function" == typeof a.componentDidMount && (t.effectTag |= 4)) : ("function" == typeof a.componentDidMount && (t.effectTag |= 4), t.memoizedProps = i, t.memoizedState = l), a.props = i, a.state = l, a.context = u, i = s) : ("function" == typeof a.componentDidMount && (t.effectTag |= 4), i = !1);
      } else a = t.stateNode, ao(e, t), s = t.memoizedProps, a.props = t.type === t.elementType ? s : qr(t.type, s), l = a.context, "object" == typeof (u = n.contextType) && null !== u ? u = io(u) : u = pr(t, u = gr(n) ? fr : hr.current), (h = "function" == typeof (c = n.getDerivedStateFromProps) || "function" == typeof a.getSnapshotBeforeUpdate) || "function" != typeof a.UNSAFE_componentWillReceiveProps && "function" != typeof a.componentWillReceiveProps || (s !== i || l !== u) && xo(t, a, i, u), ro = !1, l = t.memoizedState, a.state = l, co(t, i, a, r), d = t.memoizedState, s !== i || l !== d || dr.current || ro ? ("function" == typeof c && (go(t, n, c, i), d = t.memoizedState), (c = ro || mo(t, n, s, i, l, d, u)) ? (h || "function" != typeof a.UNSAFE_componentWillUpdate && "function" != typeof a.componentWillUpdate || ("function" == typeof a.componentWillUpdate && a.componentWillUpdate(i, d, u), "function" == typeof a.UNSAFE_componentWillUpdate && a.UNSAFE_componentWillUpdate(i, d, u)), "function" == typeof a.componentDidUpdate && (t.effectTag |= 4), "function" == typeof a.getSnapshotBeforeUpdate && (t.effectTag |= 256)) : ("function" != typeof a.componentDidUpdate || s === e.memoizedProps && l === e.memoizedState || (t.effectTag |= 4), "function" != typeof a.getSnapshotBeforeUpdate || s === e.memoizedProps && l === e.memoizedState || (t.effectTag |= 256), t.memoizedProps = i, t.memoizedState = d), a.props = i, a.state = d, a.context = u, i = c) : ("function" != typeof a.componentDidUpdate || s === e.memoizedProps && l === e.memoizedState || (t.effectTag |= 4), "function" != typeof a.getSnapshotBeforeUpdate || s === e.memoizedProps && l === e.memoizedState || (t.effectTag |= 256), i = !1);
      return Fa(e, t, n, i, o, r);
    }

    function Fa(e, t, n, i, r, o) {
      Na(e, t);
      var a = 0 != (64 & t.effectTag);
      if (!i && !a) return r && _r(t, n, !1), qa(e, t, o);
      i = t.stateNode, Aa.current = t;
      var s = a && "function" != typeof n.getDerivedStateFromError ? null : i.render();
      return t.effectTag |= 1, null !== e && a ? (t.child = Co(t, e.child, null, o), t.child = Co(t, null, s, o)) : Pa(e, t, s, o), t.memoizedState = i.state, r && _r(t, n, !0), t.child;
    }

    function za(e) {
      var t = e.stateNode;
      t.pendingContext ? mr(0, t.pendingContext, t.pendingContext !== t.context) : t.context && mr(0, t.context, !1), Oo(e, t.containerInfo);
    }

    var Ba,
        Va,
        Ha,
        Wa = {
      dehydrated: null,
      retryTime: 0
    };

    function Ga(e, t, n) {
      var i,
          r = t.mode,
          o = t.pendingProps,
          a = jo.current,
          s = !1;

      if ((i = 0 != (64 & t.effectTag)) || (i = 0 != (2 & a) && (null === e || null !== e.memoizedState)), i ? (s = !0, t.effectTag &= -65) : null !== e && null === e.memoizedState || void 0 === o.fallback || !0 === o.unstable_avoidThisFallback || (a |= 1), ur(jo, 1 & a), null === e) {
        if (void 0 !== o.fallback && Ca(t), s) {
          if (s = o.fallback, (o = El(null, r, 0, null)).return = t, 0 == (2 & t.mode)) for (e = null !== t.memoizedState ? t.child.child : t.child, o.child = e; null !== e;) {
            e.return = o, e = e.sibling;
          }
          return (n = El(s, r, n, null)).return = t, o.sibling = n, t.memoizedState = Wa, t.child = o, n;
        }

        return r = o.children, t.memoizedState = null, t.child = ko(t, null, r, n);
      }

      if (null !== e.memoizedState) {
        if (r = (e = e.child).sibling, s) {
          if (o = o.fallback, (n = kl(e, e.pendingProps)).return = t, 0 == (2 & t.mode) && (s = null !== t.memoizedState ? t.child.child : t.child) !== e.child) for (n.child = s; null !== s;) {
            s.return = n, s = s.sibling;
          }
          return (r = kl(r, o)).return = t, n.sibling = r, n.childExpirationTime = 0, t.memoizedState = Wa, t.child = n, r;
        }

        return n = Co(t, e.child, o.children, n), t.memoizedState = null, t.child = n;
      }

      if (e = e.child, s) {
        if (s = o.fallback, (o = El(null, r, 0, null)).return = t, o.child = e, null !== e && (e.return = o), 0 == (2 & t.mode)) for (e = null !== t.memoizedState ? t.child.child : t.child, o.child = e; null !== e;) {
          e.return = o, e = e.sibling;
        }
        return (n = El(s, r, n, null)).return = t, o.sibling = n, n.effectTag |= 2, o.childExpirationTime = 0, t.memoizedState = Wa, t.child = o, n;
      }

      return t.memoizedState = null, t.child = Co(t, e, o.children, n);
    }

    function Ua(e, t) {
      e.expirationTime < t && (e.expirationTime = t);
      var n = e.alternate;
      null !== n && n.expirationTime < t && (n.expirationTime = t), to(e.return, t);
    }

    function Ya(e, t, n, i, r, o) {
      var a = e.memoizedState;
      null === a ? e.memoizedState = {
        isBackwards: t,
        rendering: null,
        renderingStartTime: 0,
        last: i,
        tail: n,
        tailExpiration: 0,
        tailMode: r,
        lastEffect: o
      } : (a.isBackwards = t, a.rendering = null, a.renderingStartTime = 0, a.last = i, a.tail = n, a.tailExpiration = 0, a.tailMode = r, a.lastEffect = o);
    }

    function Xa(e, t, n) {
      var i = t.pendingProps,
          r = i.revealOrder,
          o = i.tail;
      if (Pa(e, t, i.children, n), 0 != (2 & (i = jo.current))) i = 1 & i | 2, t.effectTag |= 64;else {
        if (null !== e && 0 != (64 & e.effectTag)) e: for (e = t.child; null !== e;) {
          if (13 === e.tag) null !== e.memoizedState && Ua(e, n);else if (19 === e.tag) Ua(e, n);else if (null !== e.child) {
            e.child.return = e, e = e.child;
            continue;
          }
          if (e === t) break e;

          for (; null === e.sibling;) {
            if (null === e.return || e.return === t) break e;
            e = e.return;
          }

          e.sibling.return = e.return, e = e.sibling;
        }
        i &= 1;
      }
      if (ur(jo, i), 0 == (2 & t.mode)) t.memoizedState = null;else switch (r) {
        case "forwards":
          for (n = t.child, r = null; null !== n;) {
            null !== (e = n.alternate) && null === Ro(e) && (r = n), n = n.sibling;
          }

          null === (n = r) ? (r = t.child, t.child = null) : (r = n.sibling, n.sibling = null), Ya(t, !1, r, n, o, t.lastEffect);
          break;

        case "backwards":
          for (n = null, r = t.child, t.child = null; null !== r;) {
            if (null !== (e = r.alternate) && null === Ro(e)) {
              t.child = r;
              break;
            }

            e = r.sibling, r.sibling = n, n = r, r = e;
          }

          Ya(t, !0, n, null, o, t.lastEffect);
          break;

        case "together":
          Ya(t, !1, null, null, void 0, t.lastEffect);
          break;

        default:
          t.memoizedState = null;
      }
      return t.child;
    }

    function qa(e, t, n) {
      null !== e && (t.dependencies = e.dependencies);
      var i = t.expirationTime;
      if (0 !== i && al(i), t.childExpirationTime < n) return null;
      if (null !== e && t.child !== e.child) throw Error(a(153));

      if (null !== t.child) {
        for (n = kl(e = t.child, e.pendingProps), t.child = n, n.return = t; null !== e.sibling;) {
          e = e.sibling, (n = n.sibling = kl(e, e.pendingProps)).return = t;
        }

        n.sibling = null;
      }

      return t.child;
    }

    function Za(e, t) {
      switch (e.tailMode) {
        case "hidden":
          t = e.tail;

          for (var n = null; null !== t;) {
            null !== t.alternate && (n = t), t = t.sibling;
          }

          null === n ? e.tail = null : n.sibling = null;
          break;

        case "collapsed":
          n = e.tail;

          for (var i = null; null !== n;) {
            null !== n.alternate && (i = n), n = n.sibling;
          }

          null === i ? t || null === e.tail ? e.tail = null : e.tail.sibling = null : i.sibling = null;
      }
    }

    function Ka(e, t, n) {
      var i = t.pendingProps;

      switch (t.tag) {
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
          return null;

        case 1:
          return gr(t.type) && vr(), null;

        case 3:
          return Lo(), lr(dr), lr(hr), (n = t.stateNode).pendingContext && (n.context = n.pendingContext, n.pendingContext = null), null !== e && null !== e.child || !Ma(t) || (t.effectTag |= 4), null;

        case 5:
          No(t), n = Po(Io.current);
          var o = t.type;
          if (null !== e && null != t.stateNode) Va(e, t, o, i, n), e.ref !== t.ref && (t.effectTag |= 128);else {
            if (!i) {
              if (null === t.stateNode) throw Error(a(166));
              return null;
            }

            if (e = Po(Eo.current), Ma(t)) {
              i = t.stateNode, o = t.type;
              var s = t.memoizedProps;

              switch (i[Tn] = t, i[Cn] = s, o) {
                case "iframe":
                case "object":
                case "embed":
                  Xt("load", i);
                  break;

                case "video":
                case "audio":
                  for (e = 0; e < Ke.length; e++) {
                    Xt(Ke[e], i);
                  }

                  break;

                case "source":
                  Xt("error", i);
                  break;

                case "img":
                case "image":
                case "link":
                  Xt("error", i), Xt("load", i);
                  break;

                case "form":
                  Xt("reset", i), Xt("submit", i);
                  break;

                case "details":
                  Xt("toggle", i);
                  break;

                case "input":
                  Se(i, s), Xt("invalid", i), ln(n, "onChange");
                  break;

                case "select":
                  i._wrapperState = {
                    wasMultiple: !!s.multiple
                  }, Xt("invalid", i), ln(n, "onChange");
                  break;

                case "textarea":
                  Pe(i, s), Xt("invalid", i), ln(n, "onChange");
              }

              for (var l in on(o, s), e = null, s) {
                if (s.hasOwnProperty(l)) {
                  var u = s[l];
                  "children" === l ? "string" == typeof u ? i.textContent !== u && (e = ["children", u]) : "number" == typeof u && i.textContent !== "" + u && (e = ["children", "" + u]) : T.hasOwnProperty(l) && null != u && ln(n, l);
                }
              }

              switch (o) {
                case "input":
                  _e(i), ke(i, s, !0);
                  break;

                case "textarea":
                  _e(i), Le(i);
                  break;

                case "select":
                case "option":
                  break;

                default:
                  "function" == typeof s.onClick && (i.onclick = un);
              }

              n = e, t.updateQueue = n, null !== n && (t.effectTag |= 4);
            } else {
              switch (l = 9 === n.nodeType ? n : n.ownerDocument, e === sn && (e = je(o)), e === sn ? "script" === o ? ((e = l.createElement("div")).innerHTML = "<script><\/script>", e = e.removeChild(e.firstChild)) : "string" == typeof i.is ? e = l.createElement(o, {
                is: i.is
              }) : (e = l.createElement(o), "select" === o && (l = e, i.multiple ? l.multiple = !0 : i.size && (l.size = i.size))) : e = l.createElementNS(e, o), e[Tn] = t, e[Cn] = i, Ba(e, t), t.stateNode = e, l = an(o, i), o) {
                case "iframe":
                case "object":
                case "embed":
                  Xt("load", e), u = i;
                  break;

                case "video":
                case "audio":
                  for (u = 0; u < Ke.length; u++) {
                    Xt(Ke[u], e);
                  }

                  u = i;
                  break;

                case "source":
                  Xt("error", e), u = i;
                  break;

                case "img":
                case "image":
                case "link":
                  Xt("error", e), Xt("load", e), u = i;
                  break;

                case "form":
                  Xt("reset", e), Xt("submit", e), u = i;
                  break;

                case "details":
                  Xt("toggle", e), u = i;
                  break;

                case "input":
                  Se(e, i), u = we(e, i), Xt("invalid", e), ln(n, "onChange");
                  break;

                case "option":
                  u = Ee(e, i);
                  break;

                case "select":
                  e._wrapperState = {
                    wasMultiple: !!i.multiple
                  }, u = r({}, i, {
                    value: void 0
                  }), Xt("invalid", e), ln(n, "onChange");
                  break;

                case "textarea":
                  Pe(e, i), u = Ie(e, i), Xt("invalid", e), ln(n, "onChange");
                  break;

                default:
                  u = i;
              }

              on(o, u);
              var c = u;

              for (s in c) {
                if (c.hasOwnProperty(s)) {
                  var h = c[s];
                  "style" === s ? nn(e, h) : "dangerouslySetInnerHTML" === s ? null != (h = h ? h.__html : void 0) && ze(e, h) : "children" === s ? "string" == typeof h ? ("textarea" !== o || "" !== h) && Be(e, h) : "number" == typeof h && Be(e, "" + h) : "suppressContentEditableWarning" !== s && "suppressHydrationWarning" !== s && "autoFocus" !== s && (T.hasOwnProperty(s) ? null != h && ln(n, s) : null != h && $(e, s, h, l));
                }
              }

              switch (o) {
                case "input":
                  _e(e), ke(e, i, !1);
                  break;

                case "textarea":
                  _e(e), Le(e);
                  break;

                case "option":
                  null != i.value && e.setAttribute("value", "" + ye(i.value));
                  break;

                case "select":
                  e.multiple = !!i.multiple, null != (n = i.value) ? Ae(e, !!i.multiple, n, !1) : null != i.defaultValue && Ae(e, !!i.multiple, i.defaultValue, !0);
                  break;

                default:
                  "function" == typeof u.onClick && (e.onclick = un);
              }

              mn(o, i) && (t.effectTag |= 4);
            }

            null !== t.ref && (t.effectTag |= 128);
          }
          return null;

        case 6:
          if (e && null != t.stateNode) Ha(0, t, e.memoizedProps, i);else {
            if ("string" != typeof i && null === t.stateNode) throw Error(a(166));
            n = Po(Io.current), Po(Eo.current), Ma(t) ? (n = t.stateNode, i = t.memoizedProps, n[Tn] = t, n.nodeValue !== i && (t.effectTag |= 4)) : ((n = (9 === n.nodeType ? n : n.ownerDocument).createTextNode(i))[Tn] = t, t.stateNode = n);
          }
          return null;

        case 13:
          return lr(jo), i = t.memoizedState, 0 != (64 & t.effectTag) ? (t.expirationTime = n, t) : (n = null !== i, i = !1, null === e ? void 0 !== t.memoizedProps.fallback && Ma(t) : (i = null !== (o = e.memoizedState), n || null === o || null !== (o = e.child.sibling) && (null !== (s = t.firstEffect) ? (t.firstEffect = o, o.nextEffect = s) : (t.firstEffect = t.lastEffect = o, o.nextEffect = null), o.effectTag = 8)), n && !i && 0 != (2 & t.mode) && (null === e && !0 !== t.memoizedProps.unstable_avoidThisFallback || 0 != (1 & jo.current) ? Ms === _s && (Ms = bs) : (Ms !== _s && Ms !== bs || (Ms = ws), 0 !== Os && null !== Ts && (Ll(Ts, ks), Dl(Ts, Os)))), (n || i) && (t.effectTag |= 4), null);

        case 4:
          return Lo(), null;

        case 10:
          return eo(t), null;

        case 17:
          return gr(t.type) && vr(), null;

        case 19:
          if (lr(jo), null === (i = t.memoizedState)) return null;

          if (o = 0 != (64 & t.effectTag), null === (s = i.rendering)) {
            if (o) Za(i, !1);else if (Ms !== _s || null !== e && 0 != (64 & e.effectTag)) for (s = t.child; null !== s;) {
              if (null !== (e = Ro(s))) {
                for (t.effectTag |= 64, Za(i, !1), null !== (o = e.updateQueue) && (t.updateQueue = o, t.effectTag |= 4), null === i.lastEffect && (t.firstEffect = null), t.lastEffect = i.lastEffect, i = t.child; null !== i;) {
                  s = n, (o = i).effectTag &= 2, o.nextEffect = null, o.firstEffect = null, o.lastEffect = null, null === (e = o.alternate) ? (o.childExpirationTime = 0, o.expirationTime = s, o.child = null, o.memoizedProps = null, o.memoizedState = null, o.updateQueue = null, o.dependencies = null) : (o.childExpirationTime = e.childExpirationTime, o.expirationTime = e.expirationTime, o.child = e.child, o.memoizedProps = e.memoizedProps, o.memoizedState = e.memoizedState, o.updateQueue = e.updateQueue, s = e.dependencies, o.dependencies = null === s ? null : {
                    expirationTime: s.expirationTime,
                    firstContext: s.firstContext,
                    responders: s.responders
                  }), i = i.sibling;
                }

                return ur(jo, 1 & jo.current | 2), t.child;
              }

              s = s.sibling;
            }
          } else {
            if (!o) if (null !== (e = Ro(s))) {
              if (t.effectTag |= 64, o = !0, null !== (n = e.updateQueue) && (t.updateQueue = n, t.effectTag |= 4), Za(i, !0), null === i.tail && "hidden" === i.tailMode && !s.alternate) return null !== (t = t.lastEffect = i.lastEffect) && (t.nextEffect = null), null;
            } else 2 * zr() - i.renderingStartTime > i.tailExpiration && 1 < n && (t.effectTag |= 64, o = !0, Za(i, !1), t.expirationTime = t.childExpirationTime = n - 1);
            i.isBackwards ? (s.sibling = t.child, t.child = s) : (null !== (n = i.last) ? n.sibling = s : t.child = s, i.last = s);
          }

          return null !== i.tail ? (0 === i.tailExpiration && (i.tailExpiration = zr() + 500), n = i.tail, i.rendering = n, i.tail = n.sibling, i.lastEffect = t.lastEffect, i.renderingStartTime = zr(), n.sibling = null, t = jo.current, ur(jo, o ? 1 & t | 2 : 1 & t), n) : null;
      }

      throw Error(a(156, t.tag));
    }

    function $a(e) {
      switch (e.tag) {
        case 1:
          gr(e.type) && vr();
          var t = e.effectTag;
          return 4096 & t ? (e.effectTag = -4097 & t | 64, e) : null;

        case 3:
          if (Lo(), lr(dr), lr(hr), 0 != (64 & (t = e.effectTag))) throw Error(a(285));
          return e.effectTag = -4097 & t | 64, e;

        case 5:
          return No(e), null;

        case 13:
          return lr(jo), 4096 & (t = e.effectTag) ? (e.effectTag = -4097 & t | 64, e) : null;

        case 19:
          return lr(jo), null;

        case 4:
          return Lo(), null;

        case 10:
          return eo(e), null;

        default:
          return null;
      }
    }

    function Qa(e, t) {
      return {
        value: e,
        source: t,
        stack: me(t)
      };
    }

    Ba = function Ba(e, t) {
      for (var n = t.child; null !== n;) {
        if (5 === n.tag || 6 === n.tag) e.appendChild(n.stateNode);else if (4 !== n.tag && null !== n.child) {
          n.child.return = n, n = n.child;
          continue;
        }
        if (n === t) break;

        for (; null === n.sibling;) {
          if (null === n.return || n.return === t) return;
          n = n.return;
        }

        n.sibling.return = n.return, n = n.sibling;
      }
    }, Va = function Va(e, t, n, i, o) {
      var a = e.memoizedProps;

      if (a !== i) {
        var s,
            l,
            u = t.stateNode;

        switch (Po(Eo.current), e = null, n) {
          case "input":
            a = we(u, a), i = we(u, i), e = [];
            break;

          case "option":
            a = Ee(u, a), i = Ee(u, i), e = [];
            break;

          case "select":
            a = r({}, a, {
              value: void 0
            }), i = r({}, i, {
              value: void 0
            }), e = [];
            break;

          case "textarea":
            a = Ie(u, a), i = Ie(u, i), e = [];
            break;

          default:
            "function" != typeof a.onClick && "function" == typeof i.onClick && (u.onclick = un);
        }

        for (s in on(n, i), n = null, a) {
          if (!i.hasOwnProperty(s) && a.hasOwnProperty(s) && null != a[s]) if ("style" === s) for (l in u = a[s]) {
            u.hasOwnProperty(l) && (n || (n = {}), n[l] = "");
          } else "dangerouslySetInnerHTML" !== s && "children" !== s && "suppressContentEditableWarning" !== s && "suppressHydrationWarning" !== s && "autoFocus" !== s && (T.hasOwnProperty(s) ? e || (e = []) : (e = e || []).push(s, null));
        }

        for (s in i) {
          var c = i[s];
          if (u = null != a ? a[s] : void 0, i.hasOwnProperty(s) && c !== u && (null != c || null != u)) if ("style" === s) {
            if (u) {
              for (l in u) {
                !u.hasOwnProperty(l) || c && c.hasOwnProperty(l) || (n || (n = {}), n[l] = "");
              }

              for (l in c) {
                c.hasOwnProperty(l) && u[l] !== c[l] && (n || (n = {}), n[l] = c[l]);
              }
            } else n || (e || (e = []), e.push(s, n)), n = c;
          } else "dangerouslySetInnerHTML" === s ? (c = c ? c.__html : void 0, u = u ? u.__html : void 0, null != c && u !== c && (e = e || []).push(s, c)) : "children" === s ? u === c || "string" != typeof c && "number" != typeof c || (e = e || []).push(s, "" + c) : "suppressContentEditableWarning" !== s && "suppressHydrationWarning" !== s && (T.hasOwnProperty(s) ? (null != c && ln(o, s), e || u === c || (e = [])) : (e = e || []).push(s, c));
        }

        n && (e = e || []).push("style", n), o = e, (t.updateQueue = o) && (t.effectTag |= 4);
      }
    }, Ha = function Ha(e, t, n, i) {
      n !== i && (t.effectTag |= 4);
    };
    var Ja = "function" == typeof WeakSet ? WeakSet : Set;

    function es(e, t) {
      var n = t.source,
          i = t.stack;
      null === i && null !== n && (i = me(n)), null !== n && ve(n.type), t = t.value, null !== e && 1 === e.tag && ve(e.type);

      try {
        console.error(t);
      } catch (e) {
        setTimeout(function () {
          throw e;
        });
      }
    }

    function ts(e) {
      var t = e.ref;
      if (null !== t) if ("function" == typeof t) try {
        t(null);
      } catch (t) {
        yl(e, t);
      } else t.current = null;
    }

    function ns(e, t) {
      switch (t.tag) {
        case 0:
        case 11:
        case 15:
        case 22:
          return;

        case 1:
          if (256 & t.effectTag && null !== e) {
            var n = e.memoizedProps,
                i = e.memoizedState;
            t = (e = t.stateNode).getSnapshotBeforeUpdate(t.elementType === t.type ? n : qr(t.type, n), i), e.__reactInternalSnapshotBeforeUpdate = t;
          }

          return;

        case 3:
        case 5:
        case 6:
        case 4:
        case 17:
          return;
      }

      throw Error(a(163));
    }

    function is(e, t) {
      if (null !== (t = null !== (t = t.updateQueue) ? t.lastEffect : null)) {
        var n = t = t.next;

        do {
          if ((n.tag & e) === e) {
            var i = n.destroy;
            n.destroy = void 0, void 0 !== i && i();
          }

          n = n.next;
        } while (n !== t);
      }
    }

    function rs(e, t) {
      if (null !== (t = null !== (t = t.updateQueue) ? t.lastEffect : null)) {
        var n = t = t.next;

        do {
          if ((n.tag & e) === e) {
            var i = n.create;
            n.destroy = i();
          }

          n = n.next;
        } while (n !== t);
      }
    }

    function os(e, t, n) {
      switch (n.tag) {
        case 0:
        case 11:
        case 15:
        case 22:
          return void rs(3, n);

        case 1:
          if (e = n.stateNode, 4 & n.effectTag) if (null === t) e.componentDidMount();else {
            var i = n.elementType === n.type ? t.memoizedProps : qr(n.type, t.memoizedProps);
            e.componentDidUpdate(i, t.memoizedState, e.__reactInternalSnapshotBeforeUpdate);
          }
          return void (null !== (t = n.updateQueue) && ho(n, t, e));

        case 3:
          if (null !== (t = n.updateQueue)) {
            if (e = null, null !== n.child) switch (n.child.tag) {
              case 5:
                e = n.child.stateNode;
                break;

              case 1:
                e = n.child.stateNode;
            }
            ho(n, t, e);
          }

          return;

        case 5:
          return e = n.stateNode, void (null === t && 4 & n.effectTag && mn(n.type, n.memoizedProps) && e.focus());

        case 6:
        case 4:
        case 12:
          return;

        case 13:
          return void (null === n.memoizedState && (n = n.alternate, null !== n && (n = n.memoizedState, null !== n && (n = n.dehydrated, null !== n && jt(n)))));

        case 19:
        case 17:
        case 20:
        case 21:
          return;
      }

      throw Error(a(163));
    }

    function as(e, t, n) {
      switch ("function" == typeof wl && wl(t), t.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
          if (null !== (e = t.updateQueue) && null !== (e = e.lastEffect)) {
            var i = e.next;
            Hr(97 < n ? 97 : n, function () {
              var e = i;

              do {
                var n = e.destroy;

                if (void 0 !== n) {
                  var r = t;

                  try {
                    n();
                  } catch (e) {
                    yl(r, e);
                  }
                }

                e = e.next;
              } while (e !== i);
            });
          }

          break;

        case 1:
          ts(t), "function" == typeof (n = t.stateNode).componentWillUnmount && function (e, t) {
            try {
              t.props = e.memoizedProps, t.state = e.memoizedState, t.componentWillUnmount();
            } catch (t) {
              yl(e, t);
            }
          }(t, n);
          break;

        case 5:
          ts(t);
          break;

        case 4:
          cs(e, t, n);
      }
    }

    function ss(e) {
      var t = e.alternate;
      e.return = null, e.child = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null, e.alternate = null, e.firstEffect = null, e.lastEffect = null, e.pendingProps = null, e.memoizedProps = null, e.stateNode = null, null !== t && ss(t);
    }

    function ls(e) {
      return 5 === e.tag || 3 === e.tag || 4 === e.tag;
    }

    function us(e) {
      e: {
        for (var t = e.return; null !== t;) {
          if (ls(t)) {
            var n = t;
            break e;
          }

          t = t.return;
        }

        throw Error(a(160));
      }

      switch (t = n.stateNode, n.tag) {
        case 5:
          var i = !1;
          break;

        case 3:
        case 4:
          t = t.containerInfo, i = !0;
          break;

        default:
          throw Error(a(161));
      }

      16 & n.effectTag && (Be(t, ""), n.effectTag &= -17);

      e: t: for (n = e;;) {
        for (; null === n.sibling;) {
          if (null === n.return || ls(n.return)) {
            n = null;
            break e;
          }

          n = n.return;
        }

        for (n.sibling.return = n.return, n = n.sibling; 5 !== n.tag && 6 !== n.tag && 18 !== n.tag;) {
          if (2 & n.effectTag) continue t;
          if (null === n.child || 4 === n.tag) continue t;
          n.child.return = n, n = n.child;
        }

        if (!(2 & n.effectTag)) {
          n = n.stateNode;
          break e;
        }
      }

      i ? function e(t, n, i) {
        var r = t.tag,
            o = 5 === r || 6 === r;
        if (o) t = o ? t.stateNode : t.stateNode.instance, n ? 8 === i.nodeType ? i.parentNode.insertBefore(t, n) : i.insertBefore(t, n) : (8 === i.nodeType ? (n = i.parentNode).insertBefore(t, i) : (n = i).appendChild(t), null !== (i = i._reactRootContainer) && void 0 !== i || null !== n.onclick || (n.onclick = un));else if (4 !== r && null !== (t = t.child)) for (e(t, n, i), t = t.sibling; null !== t;) {
          e(t, n, i), t = t.sibling;
        }
      }(e, n, t) : function e(t, n, i) {
        var r = t.tag,
            o = 5 === r || 6 === r;
        if (o) t = o ? t.stateNode : t.stateNode.instance, n ? i.insertBefore(t, n) : i.appendChild(t);else if (4 !== r && null !== (t = t.child)) for (e(t, n, i), t = t.sibling; null !== t;) {
          e(t, n, i), t = t.sibling;
        }
      }(e, n, t);
    }

    function cs(e, t, n) {
      for (var i, r, o = t, s = !1;;) {
        if (!s) {
          s = o.return;

          e: for (;;) {
            if (null === s) throw Error(a(160));

            switch (i = s.stateNode, s.tag) {
              case 5:
                r = !1;
                break e;

              case 3:
              case 4:
                i = i.containerInfo, r = !0;
                break e;
            }

            s = s.return;
          }

          s = !0;
        }

        if (5 === o.tag || 6 === o.tag) {
          e: for (var l = e, u = o, c = n, h = u;;) {
            if (as(l, h, c), null !== h.child && 4 !== h.tag) h.child.return = h, h = h.child;else {
              if (h === u) break e;

              for (; null === h.sibling;) {
                if (null === h.return || h.return === u) break e;
                h = h.return;
              }

              h.sibling.return = h.return, h = h.sibling;
            }
          }

          r ? (l = i, u = o.stateNode, 8 === l.nodeType ? l.parentNode.removeChild(u) : l.removeChild(u)) : i.removeChild(o.stateNode);
        } else if (4 === o.tag) {
          if (null !== o.child) {
            i = o.stateNode.containerInfo, r = !0, o.child.return = o, o = o.child;
            continue;
          }
        } else if (as(e, o, n), null !== o.child) {
          o.child.return = o, o = o.child;
          continue;
        }

        if (o === t) break;

        for (; null === o.sibling;) {
          if (null === o.return || o.return === t) return;
          4 === (o = o.return).tag && (s = !1);
        }

        o.sibling.return = o.return, o = o.sibling;
      }
    }

    function hs(e, t) {
      switch (t.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
          return void is(3, t);

        case 1:
          return;

        case 5:
          var n = t.stateNode;

          if (null != n) {
            var i = t.memoizedProps,
                r = null !== e ? e.memoizedProps : i;
            e = t.type;
            var o = t.updateQueue;

            if (t.updateQueue = null, null !== o) {
              for (n[Cn] = i, "input" === e && "radio" === i.type && null != i.name && Te(n, i), an(e, r), t = an(e, i), r = 0; r < o.length; r += 2) {
                var s = o[r],
                    l = o[r + 1];
                "style" === s ? nn(n, l) : "dangerouslySetInnerHTML" === s ? ze(n, l) : "children" === s ? Be(n, l) : $(n, s, l, t);
              }

              switch (e) {
                case "input":
                  Ce(n, i);
                  break;

                case "textarea":
                  Oe(n, i);
                  break;

                case "select":
                  t = n._wrapperState.wasMultiple, n._wrapperState.wasMultiple = !!i.multiple, null != (e = i.value) ? Ae(n, !!i.multiple, e, !1) : t !== !!i.multiple && (null != i.defaultValue ? Ae(n, !!i.multiple, i.defaultValue, !0) : Ae(n, !!i.multiple, i.multiple ? [] : "", !1));
              }
            }
          }

          return;

        case 6:
          if (null === t.stateNode) throw Error(a(162));
          return void (t.stateNode.nodeValue = t.memoizedProps);

        case 3:
          return void ((t = t.stateNode).hydrate && (t.hydrate = !1, jt(t.containerInfo)));

        case 12:
          return;

        case 13:
          if (n = t, null === t.memoizedState ? i = !1 : (i = !0, n = t.child, Ds = zr()), null !== n) e: for (e = n;;) {
            if (5 === e.tag) o = e.stateNode, i ? "function" == typeof (o = o.style).setProperty ? o.setProperty("display", "none", "important") : o.display = "none" : (o = e.stateNode, r = null != (r = e.memoizedProps.style) && r.hasOwnProperty("display") ? r.display : null, o.style.display = tn("display", r));else if (6 === e.tag) e.stateNode.nodeValue = i ? "" : e.memoizedProps;else {
              if (13 === e.tag && null !== e.memoizedState && null === e.memoizedState.dehydrated) {
                (o = e.child.sibling).return = e, e = o;
                continue;
              }

              if (null !== e.child) {
                e.child.return = e, e = e.child;
                continue;
              }
            }
            if (e === n) break;

            for (; null === e.sibling;) {
              if (null === e.return || e.return === n) break e;
              e = e.return;
            }

            e.sibling.return = e.return, e = e.sibling;
          }
          return void ds(t);

        case 19:
          return void ds(t);

        case 17:
          return;
      }

      throw Error(a(163));
    }

    function ds(e) {
      var t = e.updateQueue;

      if (null !== t) {
        e.updateQueue = null;
        var n = e.stateNode;
        null === n && (n = e.stateNode = new Ja()), t.forEach(function (t) {
          var i = _l.bind(null, e, t);

          n.has(t) || (n.add(t), t.then(i, i));
        });
      }
    }

    var fs = "function" == typeof WeakMap ? WeakMap : Map;

    function ps(e, t, n) {
      (n = so(n, null)).tag = 3, n.payload = {
        element: null
      };
      var i = t.value;
      return n.callback = function () {
        js || (js = !0, Rs = i), es(e, t);
      }, n;
    }

    function gs(e, t, n) {
      (n = so(n, null)).tag = 3;
      var i = e.type.getDerivedStateFromError;

      if ("function" == typeof i) {
        var r = t.value;

        n.payload = function () {
          return es(e, t), i(r);
        };
      }

      var o = e.stateNode;
      return null !== o && "function" == typeof o.componentDidCatch && (n.callback = function () {
        "function" != typeof i && (null === Fs ? Fs = new Set([this]) : Fs.add(this), es(e, t));
        var n = t.stack;
        this.componentDidCatch(t.value, {
          componentStack: null !== n ? n : ""
        });
      }), n;
    }

    var vs,
        ms = Math.ceil,
        ys = K.ReactCurrentDispatcher,
        xs = K.ReactCurrentOwner,
        _s = 0,
        bs = 3,
        ws = 4,
        Ss = 0,
        Ts = null,
        Cs = null,
        ks = 0,
        Ms = _s,
        Es = null,
        As = 1073741823,
        Is = 1073741823,
        Ps = null,
        Os = 0,
        Ls = !1,
        Ds = 0,
        Ns = null,
        js = !1,
        Rs = null,
        Fs = null,
        zs = !1,
        Bs = null,
        Vs = 90,
        Hs = null,
        Ws = 0,
        Gs = null,
        Us = 0;

    function Ys() {
      return 0 != (48 & Ss) ? 1073741821 - (zr() / 10 | 0) : 0 !== Us ? Us : Us = 1073741821 - (zr() / 10 | 0);
    }

    function Xs(e, t, n) {
      if (0 == (2 & (t = t.mode))) return 1073741823;
      var i = Br();
      if (0 == (4 & t)) return 99 === i ? 1073741823 : 1073741822;
      if (0 != (16 & Ss)) return ks;
      if (null !== n) e = Xr(e, 0 | n.timeoutMs || 5e3, 250);else switch (i) {
        case 99:
          e = 1073741823;
          break;

        case 98:
          e = Xr(e, 150, 100);
          break;

        case 97:
        case 96:
          e = Xr(e, 5e3, 250);
          break;

        case 95:
          e = 2;
          break;

        default:
          throw Error(a(326));
      }
      return null !== Ts && e === ks && --e, e;
    }

    function qs(e, t) {
      if (50 < Ws) throw Ws = 0, Gs = null, Error(a(185));

      if (null !== (e = Zs(e, t))) {
        var n = Br();
        1073741823 === t ? 0 != (8 & Ss) && 0 == (48 & Ss) ? Js(e) : ($s(e), 0 === Ss && Ur()) : $s(e), 0 == (4 & Ss) || 98 !== n && 99 !== n || (null === Hs ? Hs = new Map([[e, t]]) : (void 0 === (n = Hs.get(e)) || n > t) && Hs.set(e, t));
      }
    }

    function Zs(e, t) {
      e.expirationTime < t && (e.expirationTime = t);
      var n = e.alternate;
      null !== n && n.expirationTime < t && (n.expirationTime = t);
      var i = e.return,
          r = null;
      if (null === i && 3 === e.tag) r = e.stateNode;else for (; null !== i;) {
        if (n = i.alternate, i.childExpirationTime < t && (i.childExpirationTime = t), null !== n && n.childExpirationTime < t && (n.childExpirationTime = t), null === i.return && 3 === i.tag) {
          r = i.stateNode;
          break;
        }

        i = i.return;
      }
      return null !== r && (Ts === r && (al(t), Ms === ws && Ll(r, ks)), Dl(r, t)), r;
    }

    function Ks(e) {
      var t = e.lastExpiredTime;
      if (0 !== t) return t;
      if (!Ol(e, t = e.firstPendingTime)) return t;
      var n = e.lastPingedTime;
      return 2 >= (e = n > (e = e.nextKnownPendingLevel) ? n : e) && t !== e ? 0 : e;
    }

    function $s(e) {
      if (0 !== e.lastExpiredTime) e.callbackExpirationTime = 1073741823, e.callbackPriority = 99, e.callbackNode = Gr(Js.bind(null, e));else {
        var t = Ks(e),
            n = e.callbackNode;
        if (0 === t) null !== n && (e.callbackNode = null, e.callbackExpirationTime = 0, e.callbackPriority = 90);else {
          var i = Ys();

          if (1073741823 === t ? i = 99 : 1 === t || 2 === t ? i = 95 : i = 0 >= (i = 10 * (1073741821 - t) - 10 * (1073741821 - i)) ? 99 : 250 >= i ? 98 : 5250 >= i ? 97 : 95, null !== n) {
            var r = e.callbackPriority;
            if (e.callbackExpirationTime === t && r >= i) return;
            n !== Or && Sr(n);
          }

          e.callbackExpirationTime = t, e.callbackPriority = i, t = 1073741823 === t ? Gr(Js.bind(null, e)) : Wr(i, Qs.bind(null, e), {
            timeout: 10 * (1073741821 - t) - zr()
          }), e.callbackNode = t;
        }
      }
    }

    function Qs(e, t) {
      if (Us = 0, t) return Nl(e, t = Ys()), $s(e), null;
      var n = Ks(e);

      if (0 !== n) {
        if (t = e.callbackNode, 0 != (48 & Ss)) throw Error(a(327));

        if (gl(), e === Ts && n === ks || nl(e, n), null !== Cs) {
          var i = Ss;
          Ss |= 16;

          for (var r = rl();;) {
            try {
              ll();
              break;
            } catch (t) {
              il(e, t);
            }
          }

          if (Jr(), Ss = i, ys.current = r, 1 === Ms) throw t = Es, nl(e, n), Ll(e, n), $s(e), t;
          if (null === Cs) switch (r = e.finishedWork = e.current.alternate, e.finishedExpirationTime = n, i = Ms, Ts = null, i) {
            case _s:
            case 1:
              throw Error(a(345));

            case 2:
              Nl(e, 2 < n ? 2 : n);
              break;

            case bs:
              if (Ll(e, n), n === (i = e.lastSuspendedTime) && (e.nextKnownPendingLevel = hl(r)), 1073741823 === As && 10 < (r = Ds + 500 - zr())) {
                if (Ls) {
                  var o = e.lastPingedTime;

                  if (0 === o || o >= n) {
                    e.lastPingedTime = n, nl(e, n);
                    break;
                  }
                }

                if (0 !== (o = Ks(e)) && o !== n) break;

                if (0 !== i && i !== n) {
                  e.lastPingedTime = i;
                  break;
                }

                e.timeoutHandle = xn(dl.bind(null, e), r);
                break;
              }

              dl(e);
              break;

            case ws:
              if (Ll(e, n), n === (i = e.lastSuspendedTime) && (e.nextKnownPendingLevel = hl(r)), Ls && (0 === (r = e.lastPingedTime) || r >= n)) {
                e.lastPingedTime = n, nl(e, n);
                break;
              }

              if (0 !== (r = Ks(e)) && r !== n) break;

              if (0 !== i && i !== n) {
                e.lastPingedTime = i;
                break;
              }

              if (1073741823 !== Is ? i = 10 * (1073741821 - Is) - zr() : 1073741823 === As ? i = 0 : (i = 10 * (1073741821 - As) - 5e3, 0 > (i = (r = zr()) - i) && (i = 0), (n = 10 * (1073741821 - n) - r) < (i = (120 > i ? 120 : 480 > i ? 480 : 1080 > i ? 1080 : 1920 > i ? 1920 : 3e3 > i ? 3e3 : 4320 > i ? 4320 : 1960 * ms(i / 1960)) - i) && (i = n)), 10 < i) {
                e.timeoutHandle = xn(dl.bind(null, e), i);
                break;
              }

              dl(e);
              break;

            case 5:
              if (1073741823 !== As && null !== Ps) {
                o = As;
                var s = Ps;

                if (0 >= (i = 0 | s.busyMinDurationMs) ? i = 0 : (r = 0 | s.busyDelayMs, i = (o = zr() - (10 * (1073741821 - o) - (0 | s.timeoutMs || 5e3))) <= r ? 0 : r + i - o), 10 < i) {
                  Ll(e, n), e.timeoutHandle = xn(dl.bind(null, e), i);
                  break;
                }
              }

              dl(e);
              break;

            default:
              throw Error(a(329));
          }
          if ($s(e), e.callbackNode === t) return Qs.bind(null, e);
        }
      }

      return null;
    }

    function Js(e) {
      var t = e.lastExpiredTime;
      if (t = 0 !== t ? t : 1073741823, 0 != (48 & Ss)) throw Error(a(327));

      if (gl(), e === Ts && t === ks || nl(e, t), null !== Cs) {
        var n = Ss;
        Ss |= 16;

        for (var i = rl();;) {
          try {
            sl();
            break;
          } catch (t) {
            il(e, t);
          }
        }

        if (Jr(), Ss = n, ys.current = i, 1 === Ms) throw n = Es, nl(e, t), Ll(e, t), $s(e), n;
        if (null !== Cs) throw Error(a(261));
        e.finishedWork = e.current.alternate, e.finishedExpirationTime = t, Ts = null, dl(e), $s(e);
      }

      return null;
    }

    function el(e, t) {
      var n = Ss;
      Ss |= 1;

      try {
        return e(t);
      } finally {
        0 === (Ss = n) && Ur();
      }
    }

    function tl(e, t) {
      var n = Ss;
      Ss &= -2, Ss |= 8;

      try {
        return e(t);
      } finally {
        0 === (Ss = n) && Ur();
      }
    }

    function nl(e, t) {
      e.finishedWork = null, e.finishedExpirationTime = 0;
      var n = e.timeoutHandle;
      if (-1 !== n && (e.timeoutHandle = -1, _n(n)), null !== Cs) for (n = Cs.return; null !== n;) {
        var i = n;

        switch (i.tag) {
          case 1:
            null != (i = i.type.childContextTypes) && vr();
            break;

          case 3:
            Lo(), lr(dr), lr(hr);
            break;

          case 5:
            No(i);
            break;

          case 4:
            Lo();
            break;

          case 13:
          case 19:
            lr(jo);
            break;

          case 10:
            eo(i);
        }

        n = n.return;
      }
      Ts = e, Cs = kl(e.current, null), ks = t, Ms = _s, Es = null, Is = As = 1073741823, Ps = null, Os = 0, Ls = !1;
    }

    function il(e, t) {
      for (;;) {
        try {
          if (Jr(), zo.current = va, Uo) for (var n = Ho.memoizedState; null !== n;) {
            var i = n.queue;
            null !== i && (i.pending = null), n = n.next;
          }
          if (Vo = 0, Go = Wo = Ho = null, Uo = !1, null === Cs || null === Cs.return) return Ms = 1, Es = t, Cs = null;

          e: {
            var r = e,
                o = Cs.return,
                a = Cs,
                s = t;

            if (t = ks, a.effectTag |= 2048, a.firstEffect = a.lastEffect = null, null !== s && "object" == typeof s && "function" == typeof s.then) {
              var l = s;

              if (0 == (2 & a.mode)) {
                var u = a.alternate;
                u ? (a.updateQueue = u.updateQueue, a.memoizedState = u.memoizedState, a.expirationTime = u.expirationTime) : (a.updateQueue = null, a.memoizedState = null);
              }

              var c = 0 != (1 & jo.current),
                  h = o;

              do {
                var d;

                if (d = 13 === h.tag) {
                  var f = h.memoizedState;
                  if (null !== f) d = null !== f.dehydrated;else {
                    var p = h.memoizedProps;
                    d = void 0 !== p.fallback && (!0 !== p.unstable_avoidThisFallback || !c);
                  }
                }

                if (d) {
                  var g = h.updateQueue;

                  if (null === g) {
                    var v = new Set();
                    v.add(l), h.updateQueue = v;
                  } else g.add(l);

                  if (0 == (2 & h.mode)) {
                    if (h.effectTag |= 64, a.effectTag &= -2981, 1 === a.tag) if (null === a.alternate) a.tag = 17;else {
                      var m = so(1073741823, null);
                      m.tag = 2, lo(a, m);
                    }
                    a.expirationTime = 1073741823;
                    break e;
                  }

                  s = void 0, a = t;
                  var y = r.pingCache;

                  if (null === y ? (y = r.pingCache = new fs(), s = new Set(), y.set(l, s)) : void 0 === (s = y.get(l)) && (s = new Set(), y.set(l, s)), !s.has(a)) {
                    s.add(a);
                    var x = xl.bind(null, r, l, a);
                    l.then(x, x);
                  }

                  h.effectTag |= 4096, h.expirationTime = t;
                  break e;
                }

                h = h.return;
              } while (null !== h);

              s = Error((ve(a.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display." + me(a));
            }

            5 !== Ms && (Ms = 2), s = Qa(s, a), h = o;

            do {
              switch (h.tag) {
                case 3:
                  l = s, h.effectTag |= 4096, h.expirationTime = t, uo(h, ps(h, l, t));
                  break e;

                case 1:
                  l = s;
                  var _ = h.type,
                      b = h.stateNode;

                  if (0 == (64 & h.effectTag) && ("function" == typeof _.getDerivedStateFromError || null !== b && "function" == typeof b.componentDidCatch && (null === Fs || !Fs.has(b)))) {
                    h.effectTag |= 4096, h.expirationTime = t, uo(h, gs(h, l, t));
                    break e;
                  }

              }

              h = h.return;
            } while (null !== h);
          }

          Cs = cl(Cs);
        } catch (e) {
          t = e;
          continue;
        }

        break;
      }
    }

    function rl() {
      var e = ys.current;
      return ys.current = va, null === e ? va : e;
    }

    function ol(e, t) {
      e < As && 2 < e && (As = e), null !== t && e < Is && 2 < e && (Is = e, Ps = t);
    }

    function al(e) {
      e > Os && (Os = e);
    }

    function sl() {
      for (; null !== Cs;) {
        Cs = ul(Cs);
      }
    }

    function ll() {
      for (; null !== Cs && !Lr();) {
        Cs = ul(Cs);
      }
    }

    function ul(e) {
      var t = vs(e.alternate, e, ks);
      return e.memoizedProps = e.pendingProps, null === t && (t = cl(e)), xs.current = null, t;
    }

    function cl(e) {
      Cs = e;

      do {
        var t = Cs.alternate;

        if (e = Cs.return, 0 == (2048 & Cs.effectTag)) {
          if (t = Ka(t, Cs, ks), 1 === ks || 1 !== Cs.childExpirationTime) {
            for (var n = 0, i = Cs.child; null !== i;) {
              var r = i.expirationTime,
                  o = i.childExpirationTime;
              r > n && (n = r), o > n && (n = o), i = i.sibling;
            }

            Cs.childExpirationTime = n;
          }

          if (null !== t) return t;
          null !== e && 0 == (2048 & e.effectTag) && (null === e.firstEffect && (e.firstEffect = Cs.firstEffect), null !== Cs.lastEffect && (null !== e.lastEffect && (e.lastEffect.nextEffect = Cs.firstEffect), e.lastEffect = Cs.lastEffect), 1 < Cs.effectTag && (null !== e.lastEffect ? e.lastEffect.nextEffect = Cs : e.firstEffect = Cs, e.lastEffect = Cs));
        } else {
          if (null !== (t = $a(Cs))) return t.effectTag &= 2047, t;
          null !== e && (e.firstEffect = e.lastEffect = null, e.effectTag |= 2048);
        }

        if (null !== (t = Cs.sibling)) return t;
        Cs = e;
      } while (null !== Cs);

      return Ms === _s && (Ms = 5), null;
    }

    function hl(e) {
      var t = e.expirationTime;
      return t > (e = e.childExpirationTime) ? t : e;
    }

    function dl(e) {
      var t = Br();
      return Hr(99, fl.bind(null, e, t)), null;
    }

    function fl(e, t) {
      do {
        gl();
      } while (null !== Bs);

      if (0 != (48 & Ss)) throw Error(a(327));
      var n = e.finishedWork,
          i = e.finishedExpirationTime;
      if (null === n) return null;
      if (e.finishedWork = null, e.finishedExpirationTime = 0, n === e.current) throw Error(a(177));
      e.callbackNode = null, e.callbackExpirationTime = 0, e.callbackPriority = 90, e.nextKnownPendingLevel = 0;
      var r = hl(n);

      if (e.firstPendingTime = r, i <= e.lastSuspendedTime ? e.firstSuspendedTime = e.lastSuspendedTime = e.nextKnownPendingLevel = 0 : i <= e.firstSuspendedTime && (e.firstSuspendedTime = i - 1), i <= e.lastPingedTime && (e.lastPingedTime = 0), i <= e.lastExpiredTime && (e.lastExpiredTime = 0), e === Ts && (Cs = Ts = null, ks = 0), 1 < n.effectTag ? null !== n.lastEffect ? (n.lastEffect.nextEffect = n, r = n.firstEffect) : r = n : r = n.firstEffect, null !== r) {
        var o = Ss;
        Ss |= 32, xs.current = null, gn = Yt;
        var s = fn();

        if (pn(s)) {
          if ("selectionStart" in s) var l = {
            start: s.selectionStart,
            end: s.selectionEnd
          };else e: {
            var u = (l = (l = s.ownerDocument) && l.defaultView || window).getSelection && l.getSelection();

            if (u && 0 !== u.rangeCount) {
              l = u.anchorNode;
              var c = u.anchorOffset,
                  h = u.focusNode;
              u = u.focusOffset;

              try {
                l.nodeType, h.nodeType;
              } catch (e) {
                l = null;
                break e;
              }

              var d = 0,
                  f = -1,
                  p = -1,
                  g = 0,
                  v = 0,
                  m = s,
                  y = null;

              t: for (;;) {
                for (var x; m !== l || 0 !== c && 3 !== m.nodeType || (f = d + c), m !== h || 0 !== u && 3 !== m.nodeType || (p = d + u), 3 === m.nodeType && (d += m.nodeValue.length), null !== (x = m.firstChild);) {
                  y = m, m = x;
                }

                for (;;) {
                  if (m === s) break t;
                  if (y === l && ++g === c && (f = d), y === h && ++v === u && (p = d), null !== (x = m.nextSibling)) break;
                  y = (m = y).parentNode;
                }

                m = x;
              }

              l = -1 === f || -1 === p ? null : {
                start: f,
                end: p
              };
            } else l = null;
          }
          l = l || {
            start: 0,
            end: 0
          };
        } else l = null;

        vn = {
          activeElementDetached: null,
          focusedElem: s,
          selectionRange: l
        }, Yt = !1, Ns = r;

        do {
          try {
            pl();
          } catch (e) {
            if (null === Ns) throw Error(a(330));
            yl(Ns, e), Ns = Ns.nextEffect;
          }
        } while (null !== Ns);

        Ns = r;

        do {
          try {
            for (s = e, l = t; null !== Ns;) {
              var _ = Ns.effectTag;

              if (16 & _ && Be(Ns.stateNode, ""), 128 & _) {
                var b = Ns.alternate;

                if (null !== b) {
                  var w = b.ref;
                  null !== w && ("function" == typeof w ? w(null) : w.current = null);
                }
              }

              switch (1038 & _) {
                case 2:
                  us(Ns), Ns.effectTag &= -3;
                  break;

                case 6:
                  us(Ns), Ns.effectTag &= -3, hs(Ns.alternate, Ns);
                  break;

                case 1024:
                  Ns.effectTag &= -1025;
                  break;

                case 1028:
                  Ns.effectTag &= -1025, hs(Ns.alternate, Ns);
                  break;

                case 4:
                  hs(Ns.alternate, Ns);
                  break;

                case 8:
                  cs(s, c = Ns, l), ss(c);
              }

              Ns = Ns.nextEffect;
            }
          } catch (e) {
            if (null === Ns) throw Error(a(330));
            yl(Ns, e), Ns = Ns.nextEffect;
          }
        } while (null !== Ns);

        if (w = vn, b = fn(), _ = w.focusedElem, l = w.selectionRange, b !== _ && _ && _.ownerDocument && function e(t, n) {
          return !(!t || !n) && (t === n || (!t || 3 !== t.nodeType) && (n && 3 === n.nodeType ? e(t, n.parentNode) : "contains" in t ? t.contains(n) : !!t.compareDocumentPosition && !!(16 & t.compareDocumentPosition(n))));
        }(_.ownerDocument.documentElement, _)) {
          null !== l && pn(_) && (b = l.start, void 0 === (w = l.end) && (w = b), "selectionStart" in _ ? (_.selectionStart = b, _.selectionEnd = Math.min(w, _.value.length)) : (w = (b = _.ownerDocument || document) && b.defaultView || window).getSelection && (w = w.getSelection(), c = _.textContent.length, s = Math.min(l.start, c), l = void 0 === l.end ? s : Math.min(l.end, c), !w.extend && s > l && (c = l, l = s, s = c), c = dn(_, s), h = dn(_, l), c && h && (1 !== w.rangeCount || w.anchorNode !== c.node || w.anchorOffset !== c.offset || w.focusNode !== h.node || w.focusOffset !== h.offset) && ((b = b.createRange()).setStart(c.node, c.offset), w.removeAllRanges(), s > l ? (w.addRange(b), w.extend(h.node, h.offset)) : (b.setEnd(h.node, h.offset), w.addRange(b))))), b = [];

          for (w = _; w = w.parentNode;) {
            1 === w.nodeType && b.push({
              element: w,
              left: w.scrollLeft,
              top: w.scrollTop
            });
          }

          for ("function" == typeof _.focus && _.focus(), _ = 0; _ < b.length; _++) {
            (w = b[_]).element.scrollLeft = w.left, w.element.scrollTop = w.top;
          }
        }

        Yt = !!gn, vn = gn = null, e.current = n, Ns = r;

        do {
          try {
            for (_ = e; null !== Ns;) {
              var S = Ns.effectTag;

              if (36 & S && os(_, Ns.alternate, Ns), 128 & S) {
                b = void 0;
                var T = Ns.ref;

                if (null !== T) {
                  var C = Ns.stateNode;

                  switch (Ns.tag) {
                    case 5:
                      b = C;
                      break;

                    default:
                      b = C;
                  }

                  "function" == typeof T ? T(b) : T.current = b;
                }
              }

              Ns = Ns.nextEffect;
            }
          } catch (e) {
            if (null === Ns) throw Error(a(330));
            yl(Ns, e), Ns = Ns.nextEffect;
          }
        } while (null !== Ns);

        Ns = null, Dr(), Ss = o;
      } else e.current = n;

      if (zs) zs = !1, Bs = e, Vs = t;else for (Ns = r; null !== Ns;) {
        t = Ns.nextEffect, Ns.nextEffect = null, Ns = t;
      }
      if (0 === (t = e.firstPendingTime) && (Fs = null), 1073741823 === t ? e === Gs ? Ws++ : (Ws = 0, Gs = e) : Ws = 0, "function" == typeof bl && bl(n.stateNode, i), $s(e), js) throw js = !1, e = Rs, Rs = null, e;
      return 0 != (8 & Ss) || Ur(), null;
    }

    function pl() {
      for (; null !== Ns;) {
        var e = Ns.effectTag;
        0 != (256 & e) && ns(Ns.alternate, Ns), 0 == (512 & e) || zs || (zs = !0, Wr(97, function () {
          return gl(), null;
        })), Ns = Ns.nextEffect;
      }
    }

    function gl() {
      if (90 !== Vs) {
        var e = 97 < Vs ? 97 : Vs;
        return Vs = 90, Hr(e, vl);
      }
    }

    function vl() {
      if (null === Bs) return !1;
      var e = Bs;
      if (Bs = null, 0 != (48 & Ss)) throw Error(a(331));
      var t = Ss;

      for (Ss |= 32, e = e.current.firstEffect; null !== e;) {
        try {
          var n = e;
          if (0 != (512 & n.effectTag)) switch (n.tag) {
            case 0:
            case 11:
            case 15:
            case 22:
              is(5, n), rs(5, n);
          }
        } catch (t) {
          if (null === e) throw Error(a(330));
          yl(e, t);
        }

        n = e.nextEffect, e.nextEffect = null, e = n;
      }

      return Ss = t, Ur(), !0;
    }

    function ml(e, t, n) {
      lo(e, t = ps(e, t = Qa(n, t), 1073741823)), null !== (e = Zs(e, 1073741823)) && $s(e);
    }

    function yl(e, t) {
      if (3 === e.tag) ml(e, e, t);else for (var n = e.return; null !== n;) {
        if (3 === n.tag) {
          ml(n, e, t);
          break;
        }

        if (1 === n.tag) {
          var i = n.stateNode;

          if ("function" == typeof n.type.getDerivedStateFromError || "function" == typeof i.componentDidCatch && (null === Fs || !Fs.has(i))) {
            lo(n, e = gs(n, e = Qa(t, e), 1073741823)), null !== (n = Zs(n, 1073741823)) && $s(n);
            break;
          }
        }

        n = n.return;
      }
    }

    function xl(e, t, n) {
      var i = e.pingCache;
      null !== i && i.delete(t), Ts === e && ks === n ? Ms === ws || Ms === bs && 1073741823 === As && zr() - Ds < 500 ? nl(e, ks) : Ls = !0 : Ol(e, n) && (0 !== (t = e.lastPingedTime) && t < n || (e.lastPingedTime = n, $s(e)));
    }

    function _l(e, t) {
      var n = e.stateNode;
      null !== n && n.delete(t), 0 === (t = 0) && (t = Xs(t = Ys(), e, null)), null !== (e = Zs(e, t)) && $s(e);
    }

    vs = function vs(e, t, n) {
      var i = t.expirationTime;

      if (null !== e) {
        var r = t.pendingProps;
        if (e.memoizedProps !== r || dr.current) Ia = !0;else {
          if (i < n) {
            switch (Ia = !1, t.tag) {
              case 3:
                za(t), Ea();
                break;

              case 5:
                if (Do(t), 4 & t.mode && 1 !== n && r.hidden) return t.expirationTime = t.childExpirationTime = 1, null;
                break;

              case 1:
                gr(t.type) && xr(t);
                break;

              case 4:
                Oo(t, t.stateNode.containerInfo);
                break;

              case 10:
                i = t.memoizedProps.value, r = t.type._context, ur(Zr, r._currentValue), r._currentValue = i;
                break;

              case 13:
                if (null !== t.memoizedState) return 0 !== (i = t.child.childExpirationTime) && i >= n ? Ga(e, t, n) : (ur(jo, 1 & jo.current), null !== (t = qa(e, t, n)) ? t.sibling : null);
                ur(jo, 1 & jo.current);
                break;

              case 19:
                if (i = t.childExpirationTime >= n, 0 != (64 & e.effectTag)) {
                  if (i) return Xa(e, t, n);
                  t.effectTag |= 64;
                }

                if (null !== (r = t.memoizedState) && (r.rendering = null, r.tail = null), ur(jo, jo.current), !i) return null;
            }

            return qa(e, t, n);
          }

          Ia = !1;
        }
      } else Ia = !1;

      switch (t.expirationTime = 0, t.tag) {
        case 2:
          if (i = t.type, null !== e && (e.alternate = null, t.alternate = null, t.effectTag |= 2), e = t.pendingProps, r = pr(t, hr.current), no(t, n), r = qo(null, t, i, e, r, n), t.effectTag |= 1, "object" == typeof r && null !== r && "function" == typeof r.render && void 0 === r.$$typeof) {
            if (t.tag = 1, t.memoizedState = null, t.updateQueue = null, gr(i)) {
              var o = !0;
              xr(t);
            } else o = !1;

            t.memoizedState = null !== r.state && void 0 !== r.state ? r.state : null, oo(t);
            var s = i.getDerivedStateFromProps;
            "function" == typeof s && go(t, i, s, e), r.updater = vo, t.stateNode = r, r._reactInternalFiber = t, _o(t, i, e, n), t = Fa(null, t, i, !0, o, n);
          } else t.tag = 0, Pa(null, t, r, n), t = t.child;

          return t;

        case 16:
          e: {
            if (r = t.elementType, null !== e && (e.alternate = null, t.alternate = null, t.effectTag |= 2), e = t.pendingProps, function (e) {
              if (-1 === e._status) {
                e._status = 0;
                var t = e._ctor;
                t = t(), e._result = t, t.then(function (t) {
                  0 === e._status && (t = t.default, e._status = 1, e._result = t);
                }, function (t) {
                  0 === e._status && (e._status = 2, e._result = t);
                });
              }
            }(r), 1 !== r._status) throw r._result;

            switch (r = r._result, t.type = r, o = t.tag = function (e) {
              if ("function" == typeof e) return Cl(e) ? 1 : 0;

              if (null != e) {
                if ((e = e.$$typeof) === le) return 11;
                if (e === he) return 14;
              }

              return 2;
            }(r), e = qr(r, e), o) {
              case 0:
                t = ja(null, t, r, e, n);
                break e;

              case 1:
                t = Ra(null, t, r, e, n);
                break e;

              case 11:
                t = Oa(null, t, r, e, n);
                break e;

              case 14:
                t = La(null, t, r, qr(r.type, e), i, n);
                break e;
            }

            throw Error(a(306, r, ""));
          }

          return t;

        case 0:
          return i = t.type, r = t.pendingProps, ja(e, t, i, r = t.elementType === i ? r : qr(i, r), n);

        case 1:
          return i = t.type, r = t.pendingProps, Ra(e, t, i, r = t.elementType === i ? r : qr(i, r), n);

        case 3:
          if (za(t), i = t.updateQueue, null === e || null === i) throw Error(a(282));
          if (i = t.pendingProps, r = null !== (r = t.memoizedState) ? r.element : null, ao(e, t), co(t, i, null, n), (i = t.memoizedState.element) === r) Ea(), t = qa(e, t, n);else {
            if ((r = t.stateNode.hydrate) && (ba = bn(t.stateNode.containerInfo.firstChild), _a = t, r = wa = !0), r) for (n = ko(t, null, i, n), t.child = n; n;) {
              n.effectTag = -3 & n.effectTag | 1024, n = n.sibling;
            } else Pa(e, t, i, n), Ea();
            t = t.child;
          }
          return t;

        case 5:
          return Do(t), null === e && Ca(t), i = t.type, r = t.pendingProps, o = null !== e ? e.memoizedProps : null, s = r.children, yn(i, r) ? s = null : null !== o && yn(i, o) && (t.effectTag |= 16), Na(e, t), 4 & t.mode && 1 !== n && r.hidden ? (t.expirationTime = t.childExpirationTime = 1, t = null) : (Pa(e, t, s, n), t = t.child), t;

        case 6:
          return null === e && Ca(t), null;

        case 13:
          return Ga(e, t, n);

        case 4:
          return Oo(t, t.stateNode.containerInfo), i = t.pendingProps, null === e ? t.child = Co(t, null, i, n) : Pa(e, t, i, n), t.child;

        case 11:
          return i = t.type, r = t.pendingProps, Oa(e, t, i, r = t.elementType === i ? r : qr(i, r), n);

        case 7:
          return Pa(e, t, t.pendingProps, n), t.child;

        case 8:
        case 12:
          return Pa(e, t, t.pendingProps.children, n), t.child;

        case 10:
          e: {
            i = t.type._context, r = t.pendingProps, s = t.memoizedProps, o = r.value;
            var l = t.type._context;
            if (ur(Zr, l._currentValue), l._currentValue = o, null !== s) if (l = s.value, 0 === (o = Ri(l, o) ? 0 : 0 | ("function" == typeof i._calculateChangedBits ? i._calculateChangedBits(l, o) : 1073741823))) {
              if (s.children === r.children && !dr.current) {
                t = qa(e, t, n);
                break e;
              }
            } else for (null !== (l = t.child) && (l.return = t); null !== l;) {
              var u = l.dependencies;

              if (null !== u) {
                s = l.child;

                for (var c = u.firstContext; null !== c;) {
                  if (c.context === i && 0 != (c.observedBits & o)) {
                    1 === l.tag && ((c = so(n, null)).tag = 2, lo(l, c)), l.expirationTime < n && (l.expirationTime = n), null !== (c = l.alternate) && c.expirationTime < n && (c.expirationTime = n), to(l.return, n), u.expirationTime < n && (u.expirationTime = n);
                    break;
                  }

                  c = c.next;
                }
              } else s = 10 === l.tag && l.type === t.type ? null : l.child;

              if (null !== s) s.return = l;else for (s = l; null !== s;) {
                if (s === t) {
                  s = null;
                  break;
                }

                if (null !== (l = s.sibling)) {
                  l.return = s.return, s = l;
                  break;
                }

                s = s.return;
              }
              l = s;
            }
            Pa(e, t, r.children, n), t = t.child;
          }

          return t;

        case 9:
          return r = t.type, i = (o = t.pendingProps).children, no(t, n), i = i(r = io(r, o.unstable_observedBits)), t.effectTag |= 1, Pa(e, t, i, n), t.child;

        case 14:
          return o = qr(r = t.type, t.pendingProps), La(e, t, r, o = qr(r.type, o), i, n);

        case 15:
          return Da(e, t, t.type, t.pendingProps, i, n);

        case 17:
          return i = t.type, r = t.pendingProps, r = t.elementType === i ? r : qr(i, r), null !== e && (e.alternate = null, t.alternate = null, t.effectTag |= 2), t.tag = 1, gr(i) ? (e = !0, xr(t)) : e = !1, no(t, n), yo(t, i, r), _o(t, i, r, n), Fa(null, t, i, !0, e, n);

        case 19:
          return Xa(e, t, n);
      }

      throw Error(a(156, t.tag));
    };

    var bl = null,
        wl = null;

    function Sl(e, t, n, i) {
      this.tag = e, this.key = n, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = t, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = i, this.effectTag = 0, this.lastEffect = this.firstEffect = this.nextEffect = null, this.childExpirationTime = this.expirationTime = 0, this.alternate = null;
    }

    function Tl(e, t, n, i) {
      return new Sl(e, t, n, i);
    }

    function Cl(e) {
      return !(!(e = e.prototype) || !e.isReactComponent);
    }

    function kl(e, t) {
      var n = e.alternate;
      return null === n ? ((n = Tl(e.tag, t, e.key, e.mode)).elementType = e.elementType, n.type = e.type, n.stateNode = e.stateNode, n.alternate = e, e.alternate = n) : (n.pendingProps = t, n.effectTag = 0, n.nextEffect = null, n.firstEffect = null, n.lastEffect = null), n.childExpirationTime = e.childExpirationTime, n.expirationTime = e.expirationTime, n.child = e.child, n.memoizedProps = e.memoizedProps, n.memoizedState = e.memoizedState, n.updateQueue = e.updateQueue, t = e.dependencies, n.dependencies = null === t ? null : {
        expirationTime: t.expirationTime,
        firstContext: t.firstContext,
        responders: t.responders
      }, n.sibling = e.sibling, n.index = e.index, n.ref = e.ref, n;
    }

    function Ml(e, t, n, i, r, o) {
      var s = 2;
      if (i = e, "function" == typeof e) Cl(e) && (s = 1);else if ("string" == typeof e) s = 5;else e: switch (e) {
        case ne:
          return El(n.children, r, o, t);

        case se:
          s = 8, r |= 7;
          break;

        case ie:
          s = 8, r |= 1;
          break;

        case re:
          return (e = Tl(12, n, t, 8 | r)).elementType = re, e.type = re, e.expirationTime = o, e;

        case ue:
          return (e = Tl(13, n, t, r)).type = ue, e.elementType = ue, e.expirationTime = o, e;

        case ce:
          return (e = Tl(19, n, t, r)).elementType = ce, e.expirationTime = o, e;

        default:
          if ("object" == typeof e && null !== e) switch (e.$$typeof) {
            case oe:
              s = 10;
              break e;

            case ae:
              s = 9;
              break e;

            case le:
              s = 11;
              break e;

            case he:
              s = 14;
              break e;

            case de:
              s = 16, i = null;
              break e;

            case fe:
              s = 22;
              break e;
          }
          throw Error(a(130, null == e ? e : typeof e, ""));
      }
      return (t = Tl(s, n, t, r)).elementType = e, t.type = i, t.expirationTime = o, t;
    }

    function El(e, t, n, i) {
      return (e = Tl(7, e, i, t)).expirationTime = n, e;
    }

    function Al(e, t, n) {
      return (e = Tl(6, e, null, t)).expirationTime = n, e;
    }

    function Il(e, t, n) {
      return (t = Tl(4, null !== e.children ? e.children : [], e.key, t)).expirationTime = n, t.stateNode = {
        containerInfo: e.containerInfo,
        pendingChildren: null,
        implementation: e.implementation
      }, t;
    }

    function Pl(e, t, n) {
      this.tag = t, this.current = null, this.containerInfo = e, this.pingCache = this.pendingChildren = null, this.finishedExpirationTime = 0, this.finishedWork = null, this.timeoutHandle = -1, this.pendingContext = this.context = null, this.hydrate = n, this.callbackNode = null, this.callbackPriority = 90, this.lastExpiredTime = this.lastPingedTime = this.nextKnownPendingLevel = this.lastSuspendedTime = this.firstSuspendedTime = this.firstPendingTime = 0;
    }

    function Ol(e, t) {
      var n = e.firstSuspendedTime;
      return e = e.lastSuspendedTime, 0 !== n && n >= t && e <= t;
    }

    function Ll(e, t) {
      var n = e.firstSuspendedTime,
          i = e.lastSuspendedTime;
      n < t && (e.firstSuspendedTime = t), (i > t || 0 === n) && (e.lastSuspendedTime = t), t <= e.lastPingedTime && (e.lastPingedTime = 0), t <= e.lastExpiredTime && (e.lastExpiredTime = 0);
    }

    function Dl(e, t) {
      t > e.firstPendingTime && (e.firstPendingTime = t);
      var n = e.firstSuspendedTime;
      0 !== n && (t >= n ? e.firstSuspendedTime = e.lastSuspendedTime = e.nextKnownPendingLevel = 0 : t >= e.lastSuspendedTime && (e.lastSuspendedTime = t + 1), t > e.nextKnownPendingLevel && (e.nextKnownPendingLevel = t));
    }

    function Nl(e, t) {
      var n = e.lastExpiredTime;
      (0 === n || n > t) && (e.lastExpiredTime = t);
    }

    function jl(e, t, n, i) {
      var r = t.current,
          o = Ys(),
          s = fo.suspense;
      o = Xs(o, r, s);

      e: if (n) {
        t: {
          if (Je(n = n._reactInternalFiber) !== n || 1 !== n.tag) throw Error(a(170));
          var l = n;

          do {
            switch (l.tag) {
              case 3:
                l = l.stateNode.context;
                break t;

              case 1:
                if (gr(l.type)) {
                  l = l.stateNode.__reactInternalMemoizedMergedChildContext;
                  break t;
                }

            }

            l = l.return;
          } while (null !== l);

          throw Error(a(171));
        }

        if (1 === n.tag) {
          var u = n.type;

          if (gr(u)) {
            n = yr(n, u, l);
            break e;
          }
        }

        n = l;
      } else n = cr;

      return null === t.context ? t.context = n : t.pendingContext = n, (t = so(o, s)).payload = {
        element: e
      }, null !== (i = void 0 === i ? null : i) && (t.callback = i), lo(r, t), qs(r, o), o;
    }

    function Rl(e) {
      if (!(e = e.current).child) return null;

      switch (e.child.tag) {
        case 5:
        default:
          return e.child.stateNode;
      }
    }

    function Fl(e, t) {
      null !== (e = e.memoizedState) && null !== e.dehydrated && e.retryTime < t && (e.retryTime = t);
    }

    function zl(e, t) {
      Fl(e, t), (e = e.alternate) && Fl(e, t);
    }

    function Bl(e, t, n) {
      var i = new Pl(e, t, n = null != n && !0 === n.hydrate),
          r = Tl(3, null, null, 2 === t ? 7 : 1 === t ? 3 : 0);
      i.current = r, r.stateNode = i, oo(r), e[kn] = i.current, n && 0 !== t && function (e, t) {
        var n = Qe(t);
        kt.forEach(function (e) {
          pt(e, t, n);
        }), Mt.forEach(function (e) {
          pt(e, t, n);
        });
      }(0, 9 === e.nodeType ? e : e.ownerDocument), this._internalRoot = i;
    }

    function Vl(e) {
      return !(!e || 1 !== e.nodeType && 9 !== e.nodeType && 11 !== e.nodeType && (8 !== e.nodeType || " react-mount-point-unstable " !== e.nodeValue));
    }

    function Hl(e, t, n, i, r) {
      var o = n._reactRootContainer;

      if (o) {
        var a = o._internalRoot;

        if ("function" == typeof r) {
          var s = r;

          r = function r() {
            var e = Rl(a);
            s.call(e);
          };
        }

        jl(t, a, e, r);
      } else {
        if (o = n._reactRootContainer = function (e, t) {
          if (t || (t = !(!(t = e ? 9 === e.nodeType ? e.documentElement : e.firstChild : null) || 1 !== t.nodeType || !t.hasAttribute("data-reactroot"))), !t) for (var n; n = e.lastChild;) {
            e.removeChild(n);
          }
          return new Bl(e, 0, t ? {
            hydrate: !0
          } : void 0);
        }(n, i), a = o._internalRoot, "function" == typeof r) {
          var l = r;

          r = function r() {
            var e = Rl(a);
            l.call(e);
          };
        }

        tl(function () {
          jl(t, a, e, r);
        });
      }

      return Rl(a);
    }

    function Wl(e, t, n) {
      var i = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
      return {
        $$typeof: te,
        key: null == i ? null : "" + i,
        children: e,
        containerInfo: t,
        implementation: n
      };
    }

    function Gl(e, t) {
      var n = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
      if (!Vl(t)) throw Error(a(200));
      return Wl(e, t, null, n);
    }

    Bl.prototype.render = function (e) {
      jl(e, this._internalRoot, null, null);
    }, Bl.prototype.unmount = function () {
      var e = this._internalRoot,
          t = e.containerInfo;
      jl(null, e, null, function () {
        t[kn] = null;
      });
    }, gt = function gt(e) {
      if (13 === e.tag) {
        var t = Xr(Ys(), 150, 100);
        qs(e, t), zl(e, t);
      }
    }, vt = function vt(e) {
      13 === e.tag && (qs(e, 3), zl(e, 3));
    }, mt = function mt(e) {
      if (13 === e.tag) {
        var t = Ys();
        qs(e, t = Xs(t, e, null)), zl(e, t);
      }
    }, E = function E(e, t, n) {
      switch (t) {
        case "input":
          if (Ce(e, n), t = n.name, "radio" === n.type && null != t) {
            for (n = e; n.parentNode;) {
              n = n.parentNode;
            }

            for (n = n.querySelectorAll("input[name=" + JSON.stringify("" + t) + '][type="radio"]'), t = 0; t < n.length; t++) {
              var i = n[t];

              if (i !== e && i.form === e.form) {
                var r = In(i);
                if (!r) throw Error(a(90));
                be(i), Ce(i, r);
              }
            }
          }

          break;

        case "textarea":
          Oe(e, n);
          break;

        case "select":
          null != (t = n.value) && Ae(e, !!n.multiple, t, !1);
      }
    }, D = el, N = function N(e, t, n, i, r) {
      var o = Ss;
      Ss |= 4;

      try {
        return Hr(98, e.bind(null, t, n, i, r));
      } finally {
        0 === (Ss = o) && Ur();
      }
    }, j = function j() {
      0 == (49 & Ss) && (function () {
        if (null !== Hs) {
          var e = Hs;
          Hs = null, e.forEach(function (e, t) {
            Nl(t, e), $s(t);
          }), Ur();
        }
      }(), gl());
    }, R = function R(e, t) {
      var n = Ss;
      Ss |= 2;

      try {
        return e(t);
      } finally {
        0 === (Ss = n) && Ur();
      }
    };
    var Ul,
        Yl,
        Xl = {
      Events: [En, An, In, k, S, Rn, function (e) {
        rt(e, jn);
      }, O, L, $t, st, gl, {
        current: !1
      }]
    };
    Yl = (Ul = {
      findFiberByHostInstance: Mn,
      bundleType: 0,
      version: "16.13.1",
      rendererPackageName: "react-dom"
    }).findFiberByHostInstance, function (e) {
      if ("undefined" == typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
      var t = __REACT_DEVTOOLS_GLOBAL_HOOK__;
      if (t.isDisabled || !t.supportsFiber) return !0;

      try {
        var n = t.inject(e);
        bl = function bl(e) {
          try {
            t.onCommitFiberRoot(n, e, void 0, 64 == (64 & e.current.effectTag));
          } catch (e) {}
        }, wl = function wl(e) {
          try {
            t.onCommitFiberUnmount(n, e);
          } catch (e) {}
        };
      } catch (e) {}
    }(r({}, Ul, {
      overrideHookState: null,
      overrideProps: null,
      setSuspenseHandler: null,
      scheduleUpdate: null,
      currentDispatcherRef: K.ReactCurrentDispatcher,
      findHostInstanceByFiber: function findHostInstanceByFiber(e) {
        return null === (e = nt(e)) ? null : e.stateNode;
      },
      findFiberByHostInstance: function findFiberByHostInstance(e) {
        return Yl ? Yl(e) : null;
      },
      findHostInstancesForRefresh: null,
      scheduleRefresh: null,
      scheduleRoot: null,
      setRefreshHandler: null,
      getCurrentFiber: null
    })), t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Xl, t.createPortal = Gl, t.findDOMNode = function (e) {
      if (null == e) return null;
      if (1 === e.nodeType) return e;
      var t = e._reactInternalFiber;

      if (void 0 === t) {
        if ("function" == typeof e.render) throw Error(a(188));
        throw Error(a(268, Object.keys(e)));
      }

      return e = null === (e = nt(t)) ? null : e.stateNode;
    }, t.flushSync = function (e, t) {
      if (0 != (48 & Ss)) throw Error(a(187));
      var n = Ss;
      Ss |= 1;

      try {
        return Hr(99, e.bind(null, t));
      } finally {
        Ss = n, Ur();
      }
    }, t.hydrate = function (e, t, n) {
      if (!Vl(t)) throw Error(a(200));
      return Hl(null, e, t, !0, n);
    }, t.render = function (e, t, n) {
      if (!Vl(t)) throw Error(a(200));
      return Hl(null, e, t, !1, n);
    }, t.unmountComponentAtNode = function (e) {
      if (!Vl(e)) throw Error(a(40));
      return !!e._reactRootContainer && (tl(function () {
        Hl(null, null, e, !1, function () {
          e._reactRootContainer = null, e[kn] = null;
        });
      }), !0);
    }, t.unstable_batchedUpdates = el, t.unstable_createPortal = function (e, t) {
      return Gl(e, t, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
    }, t.unstable_renderSubtreeIntoContainer = function (e, t, n, i) {
      if (!Vl(n)) throw Error(a(200));
      if (null == e || void 0 === e._reactInternalFiber) throw Error(a(38));
      return Hl(e, t, n, !1, i);
    }, t.version = "16.13.1";
  }, function (e, t, n) {
    "use strict";

    e.exports = n(640);
  }, function (e, t, n) {
    "use strict";

    var _i3, r, o, a, s;

    if ("undefined" == typeof window || "function" != typeof MessageChannel) {
      var l = null,
          u = null,
          c = function c() {
        if (null !== l) try {
          var e = t.unstable_now();
          l(!0, e), l = null;
        } catch (e) {
          throw setTimeout(c, 0), e;
        }
      },
          h = Date.now();

      t.unstable_now = function () {
        return Date.now() - h;
      }, _i3 = function i(e) {
        null !== l ? setTimeout(_i3, 0, e) : (l = e, setTimeout(c, 0));
      }, r = function r(e, t) {
        u = setTimeout(e, t);
      }, o = function o() {
        clearTimeout(u);
      }, a = function a() {
        return !1;
      }, s = t.unstable_forceFrameRate = function () {};
    } else {
      var d = window.performance,
          f = window.Date,
          p = window.setTimeout,
          g = window.clearTimeout;

      if ("undefined" != typeof console) {
        var v = window.cancelAnimationFrame;
        "function" != typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"), "function" != typeof v && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
      }

      if ("object" == typeof d && "function" == typeof d.now) t.unstable_now = function () {
        return d.now();
      };else {
        var m = f.now();

        t.unstable_now = function () {
          return f.now() - m;
        };
      }

      var y = !1,
          x = null,
          _ = -1,
          b = 5,
          w = 0;

      a = function a() {
        return t.unstable_now() >= w;
      }, s = function s() {}, t.unstable_forceFrameRate = function (e) {
        0 > e || 125 < e ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported") : b = 0 < e ? Math.floor(1e3 / e) : 5;
      };
      var S = new MessageChannel(),
          T = S.port2;
      S.port1.onmessage = function () {
        if (null !== x) {
          var e = t.unstable_now();
          w = e + b;

          try {
            x(!0, e) ? T.postMessage(null) : (y = !1, x = null);
          } catch (e) {
            throw T.postMessage(null), e;
          }
        } else y = !1;
      }, _i3 = function _i3(e) {
        x = e, y || (y = !0, T.postMessage(null));
      }, r = function r(e, n) {
        _ = p(function () {
          e(t.unstable_now());
        }, n);
      }, o = function o() {
        g(_), _ = -1;
      };
    }

    function C(e, t) {
      var n = e.length;
      e.push(t);

      e: for (;;) {
        var i = n - 1 >>> 1,
            r = e[i];
        if (!(void 0 !== r && 0 < E(r, t))) break e;
        e[i] = t, e[n] = r, n = i;
      }
    }

    function k(e) {
      return void 0 === (e = e[0]) ? null : e;
    }

    function M(e) {
      var t = e[0];

      if (void 0 !== t) {
        var n = e.pop();

        if (n !== t) {
          e[0] = n;

          e: for (var i = 0, r = e.length; i < r;) {
            var o = 2 * (i + 1) - 1,
                a = e[o],
                s = o + 1,
                l = e[s];
            if (void 0 !== a && 0 > E(a, n)) void 0 !== l && 0 > E(l, a) ? (e[i] = l, e[s] = n, i = s) : (e[i] = a, e[o] = n, i = o);else {
              if (!(void 0 !== l && 0 > E(l, n))) break e;
              e[i] = l, e[s] = n, i = s;
            }
          }
        }

        return t;
      }

      return null;
    }

    function E(e, t) {
      var n = e.sortIndex - t.sortIndex;
      return 0 !== n ? n : e.id - t.id;
    }

    var A = [],
        I = [],
        P = 1,
        O = null,
        L = 3,
        D = !1,
        N = !1,
        j = !1;

    function R(e) {
      for (var t = k(I); null !== t;) {
        if (null === t.callback) M(I);else {
          if (!(t.startTime <= e)) break;
          M(I), t.sortIndex = t.expirationTime, C(A, t);
        }
        t = k(I);
      }
    }

    function F(e) {
      if (j = !1, R(e), !N) if (null !== k(A)) N = !0, _i3(z);else {
        var t = k(I);
        null !== t && r(F, t.startTime - e);
      }
    }

    function z(e, n) {
      N = !1, j && (j = !1, o()), D = !0;
      var i = L;

      try {
        for (R(n), O = k(A); null !== O && (!(O.expirationTime > n) || e && !a());) {
          var s = O.callback;

          if (null !== s) {
            O.callback = null, L = O.priorityLevel;
            var l = s(O.expirationTime <= n);
            n = t.unstable_now(), "function" == typeof l ? O.callback = l : O === k(A) && M(A), R(n);
          } else M(A);

          O = k(A);
        }

        if (null !== O) var u = !0;else {
          var c = k(I);
          null !== c && r(F, c.startTime - n), u = !1;
        }
        return u;
      } finally {
        O = null, L = i, D = !1;
      }
    }

    function B(e) {
      switch (e) {
        case 1:
          return -1;

        case 2:
          return 250;

        case 5:
          return 1073741823;

        case 4:
          return 1e4;

        default:
          return 5e3;
      }
    }

    var V = s;
    t.unstable_IdlePriority = 5, t.unstable_ImmediatePriority = 1, t.unstable_LowPriority = 4, t.unstable_NormalPriority = 3, t.unstable_Profiling = null, t.unstable_UserBlockingPriority = 2, t.unstable_cancelCallback = function (e) {
      e.callback = null;
    }, t.unstable_continueExecution = function () {
      N || D || (N = !0, _i3(z));
    }, t.unstable_getCurrentPriorityLevel = function () {
      return L;
    }, t.unstable_getFirstCallbackNode = function () {
      return k(A);
    }, t.unstable_next = function (e) {
      switch (L) {
        case 1:
        case 2:
        case 3:
          var t = 3;
          break;

        default:
          t = L;
      }

      var n = L;
      L = t;

      try {
        return e();
      } finally {
        L = n;
      }
    }, t.unstable_pauseExecution = function () {}, t.unstable_requestPaint = V, t.unstable_runWithPriority = function (e, t) {
      switch (e) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;

        default:
          e = 3;
      }

      var n = L;
      L = e;

      try {
        return t();
      } finally {
        L = n;
      }
    }, t.unstable_scheduleCallback = function (e, n, a) {
      var s = t.unstable_now();

      if ("object" == typeof a && null !== a) {
        var l = a.delay;
        l = "number" == typeof l && 0 < l ? s + l : s, a = "number" == typeof a.timeout ? a.timeout : B(e);
      } else a = B(e), l = s;

      return e = {
        id: P++,
        callback: n,
        priorityLevel: e,
        startTime: l,
        expirationTime: a = l + a,
        sortIndex: -1
      }, l > s ? (e.sortIndex = l, C(I, e), null === k(A) && e === k(I) && (j ? o() : j = !0, r(F, l - s))) : (e.sortIndex = a, C(A, e), N || D || (N = !0, _i3(z))), e;
    }, t.unstable_shouldYield = function () {
      var e = t.unstable_now();
      R(e);
      var n = k(A);
      return n !== O && null !== O && null !== n && null !== n.callback && n.startTime <= e && n.expirationTime < O.expirationTime || a();
    }, t.unstable_wrapCallback = function (e) {
      var t = L;
      return function () {
        var n = L;
        L = t;

        try {
          return e.apply(this, arguments);
        } finally {
          L = n;
        }
      };
    };
  }, function (e, t, n) {
    var i = n(51);

    e.exports = function () {
      return i.Date.now();
    };
  }, function (e, t, n) {
    var i = n(116),
        r = n(643),
        o = /^\s+|\s+$/g,
        a = /^[-+]0x[0-9a-f]+$/i,
        s = /^0b[01]+$/i,
        l = /^0o[0-7]+$/i,
        u = parseInt;

    e.exports = function (e) {
      if ("number" == typeof e) return e;
      if (r(e)) return NaN;

      if (i(e)) {
        var t = "function" == typeof e.valueOf ? e.valueOf() : e;
        e = i(t) ? t + "" : t;
      }

      if ("string" != typeof e) return 0 === e ? e : +e;
      e = e.replace(o, "");
      var n = s.test(e);
      return n || l.test(e) ? u(e.slice(2), n ? 2 : 8) : a.test(e) ? NaN : +e;
    };
  }, function (e, t, n) {
    var i = n(115),
        r = n(117);

    e.exports = function (e) {
      return "symbol" == typeof e || r(e) && "[object Symbol]" == i(e);
    };
  }, function (e, t, n) {
    !function e(t, n, i) {
      function r(a, s) {
        if (!n[a]) {
          if (!t[a]) {
            if (o) return o(a, !0);
            var l = new Error("Cannot find module '" + a + "'");
            throw l.code = "MODULE_NOT_FOUND", l;
          }

          var u = n[a] = {
            exports: {}
          };
          t[a][0].call(u.exports, function (e) {
            var n = t[a][1][e];
            return r(n || e);
          }, u, u.exports, e, t, n, i);
        }

        return n[a].exports;
      }

      for (var o = !1, a = 0; a < i.length; a++) {
        r(i[a]);
      }

      return r;
    }({
      1: [function (e, t, n) {
        function i(e, t, n, i) {
          for (var r = e[t++], o = 1 << r, a = o + 1, s = a + 1, l = r + 1, u = (1 << l) - 1, c = 0, h = 0, d = 0, f = e[t++], p = new Int32Array(4096), g = null;;) {
            for (; c < 16 && 0 !== f;) {
              h |= e[t++] << c, c += 8, 1 === f ? f = e[t++] : --f;
            }

            if (c < l) break;
            var v = h & u;

            if (h >>= l, c -= l, v !== o) {
              if (v === a) break;

              for (var m = v < s ? v : g, y = 0, x = m; x > o;) {
                x = p[x] >> 8, ++y;
              }

              var _ = x;
              if (d + y + (m !== v ? 1 : 0) > i) return void console.log("Warning, gif stream longer than expected.");
              n[d++] = _;
              var b = d += y;

              for (m !== v && (n[d++] = _), x = m; y--;) {
                x = p[x], n[--b] = 255 & x, x >>= 8;
              }

              null !== g && s < 4096 && (p[s++] = g << 8 | _, s >= u + 1 && l < 12 && (++l, u = u << 1 | 1)), g = v;
            } else s = a + 1, u = (1 << (l = r + 1)) - 1, g = null;
          }

          return d !== i && console.log("Warning, gif stream shorter than expected."), n;
        }

        try {
          n.GifWriter = function (e, t, n, i) {
            var r = 0,
                o = void 0 === (i = void 0 === i ? {} : i).loop ? null : i.loop,
                a = void 0 === i.palette ? null : i.palette;
            if (t <= 0 || n <= 0 || t > 65535 || n > 65535) throw "Width/Height invalid.";

            function s(e) {
              var t = e.length;
              if (t < 2 || t > 256 || t & t - 1) throw "Invalid code/color length, must be power of 2 and 2 .. 256.";
              return t;
            }

            e[r++] = 71, e[r++] = 73, e[r++] = 70, e[r++] = 56, e[r++] = 57, e[r++] = 97;
            var l = 0,
                u = 0;

            if (null !== a) {
              for (var c = s(a); c >>= 1;) {
                ++l;
              }

              if (c = 1 << l, --l, void 0 !== i.background) {
                if ((u = i.background) >= c) throw "Background index out of range.";
                if (0 === u) throw "Background index explicitly passed as 0.";
              }
            }

            if (e[r++] = 255 & t, e[r++] = t >> 8 & 255, e[r++] = 255 & n, e[r++] = n >> 8 & 255, e[r++] = (null !== a ? 128 : 0) | l, e[r++] = u, e[r++] = 0, null !== a) for (var h = 0, d = a.length; h < d; ++h) {
              var f = a[h];
              e[r++] = f >> 16 & 255, e[r++] = f >> 8 & 255, e[r++] = 255 & f;
            }

            if (null !== o) {
              if (o < 0 || o > 65535) throw "Loop count invalid.";
              e[r++] = 33, e[r++] = 255, e[r++] = 11, e[r++] = 78, e[r++] = 69, e[r++] = 84, e[r++] = 83, e[r++] = 67, e[r++] = 65, e[r++] = 80, e[r++] = 69, e[r++] = 50, e[r++] = 46, e[r++] = 48, e[r++] = 3, e[r++] = 1, e[r++] = 255 & o, e[r++] = o >> 8 & 255, e[r++] = 0;
            }

            var p = !1;
            this.addFrame = function (t, n, i, o, l, u) {
              if (!0 === p && (--r, p = !1), u = void 0 === u ? {} : u, t < 0 || n < 0 || t > 65535 || n > 65535) throw "x/y invalid.";
              if (i <= 0 || o <= 0 || i > 65535 || o > 65535) throw "Width/Height invalid.";
              if (l.length < i * o) throw "Not enough pixels for the frame size.";
              var c = !0,
                  h = u.palette;
              if (null == h && (c = !1, h = a), null == h) throw "Must supply either a local or global palette.";

              for (var d = s(h), f = 0; d >>= 1;) {
                ++f;
              }

              d = 1 << f;
              var g = void 0 === u.delay ? 0 : u.delay,
                  v = void 0 === u.disposal ? 0 : u.disposal;
              if (v < 0 || v > 3) throw "Disposal out of range.";
              var m = !1,
                  y = 0;
              if (void 0 !== u.transparent && null !== u.transparent && (m = !0, (y = u.transparent) < 0 || y >= d)) throw "Transparent color index.";
              if ((0 !== v || m || 0 !== g) && (e[r++] = 33, e[r++] = 249, e[r++] = 4, e[r++] = v << 2 | (!0 === m ? 1 : 0), e[r++] = 255 & g, e[r++] = g >> 8 & 255, e[r++] = y, e[r++] = 0), e[r++] = 44, e[r++] = 255 & t, e[r++] = t >> 8 & 255, e[r++] = 255 & n, e[r++] = n >> 8 & 255, e[r++] = 255 & i, e[r++] = i >> 8 & 255, e[r++] = 255 & o, e[r++] = o >> 8 & 255, e[r++] = !0 === c ? 128 | f - 1 : 0, !0 === c) for (var x = 0, _ = h.length; x < _; ++x) {
                var b = h[x];
                e[r++] = b >> 16 & 255, e[r++] = b >> 8 & 255, e[r++] = 255 & b;
              }

              r = function (e, t, n, i) {
                e[t++] = n;
                var r = t++,
                    o = 1 << n,
                    a = o - 1,
                    s = o + 1,
                    l = s + 1,
                    u = n + 1,
                    c = 0,
                    h = 0;

                function d(n) {
                  for (; c >= n;) {
                    e[t++] = 255 & h, h >>= 8, c -= 8, t === r + 256 && (e[r] = 255, r = t++);
                  }
                }

                function f(e) {
                  h |= e << c, c += u, d(8);
                }

                var p = i[0] & a,
                    g = {};
                f(o);

                for (var v = 1, m = i.length; v < m; ++v) {
                  var y = i[v] & a,
                      x = p << 8 | y,
                      _ = g[x];

                  if (void 0 === _) {
                    for (h |= p << c, c += u; c >= 8;) {
                      e[t++] = 255 & h, h >>= 8, c -= 8, t === r + 256 && (e[r] = 255, r = t++);
                    }

                    4096 === l ? (f(o), l = s + 1, u = n + 1, g = {}) : (l >= 1 << u && ++u, g[x] = l++), p = y;
                  } else p = _;
                }

                f(p), f(s), d(1), r + 1 === t ? e[r] = 0 : (e[r] = t - r - 1, e[t++] = 0);
                return t;
              }(e, r, f < 2 ? 2 : f, l);
            }, this.end = function () {
              return !1 === p && (e[r++] = 59, p = !0), r;
            };
          }, n.GifReader = function (e) {
            var t = 0;
            if (71 !== e[t++] || 73 !== e[t++] || 70 !== e[t++] || 56 !== e[t++] || 56 != (e[t++] + 1 & 253) || 97 !== e[t++]) throw "Invalid GIF 87a/89a header.";
            var n = e[t++] | e[t++] << 8,
                r = e[t++] | e[t++] << 8,
                o = e[t++],
                a = o >> 7,
                s = 1 << (7 & o) + 1;
            e[t++], e[t++];
            var l = null;
            a && (l = t, t += 3 * s);
            var u = !0,
                c = [],
                h = 0,
                d = null,
                f = 0,
                p = null;

            for (this.width = n, this.height = r; u && t < e.length;) {
              switch (e[t++]) {
                case 33:
                  switch (e[t++]) {
                    case 255:
                      if (11 !== e[t] || 78 == e[t + 1] && 69 == e[t + 2] && 84 == e[t + 3] && 83 == e[t + 4] && 67 == e[t + 5] && 65 == e[t + 6] && 80 == e[t + 7] && 69 == e[t + 8] && 50 == e[t + 9] && 46 == e[t + 10] && 48 == e[t + 11] && 3 == e[t + 12] && 1 == e[t + 13] && 0 == e[t + 16]) t += 14, p = e[t++] | e[t++] << 8, t++;else for (t += 12;;) {
                        if (0 === (C = e[t++])) break;
                        t += C;
                      }
                      break;

                    case 249:
                      if (4 !== e[t++] || 0 !== e[t + 4]) throw "Invalid graphics extension block.";
                      var g = e[t++];
                      h = e[t++] | e[t++] << 8, d = e[t++], 0 == (1 & g) && (d = null), f = g >> 2 & 7, t++;
                      break;

                    case 254:
                      for (;;) {
                        if (0 === (C = e[t++])) break;
                        t += C;
                      }

                      break;

                    default:
                      throw "Unknown graphic control label: 0x" + e[t - 1].toString(16);
                  }

                  break;

                case 44:
                  var v = e[t++] | e[t++] << 8,
                      m = e[t++] | e[t++] << 8,
                      y = e[t++] | e[t++] << 8,
                      x = e[t++] | e[t++] << 8,
                      _ = e[t++],
                      b = _ >> 6 & 1,
                      w = l,
                      S = !1;

                  if (_ >> 7) {
                    S = !0;
                    w = t, t += 3 * (1 << (7 & _) + 1);
                  }

                  var T = t;

                  for (t++;;) {
                    var C;
                    if (0 === (C = e[t++])) break;
                    t += C;
                  }

                  c.push({
                    x: v,
                    y: m,
                    width: y,
                    height: x,
                    has_local_palette: S,
                    palette_offset: w,
                    data_offset: T,
                    data_length: t - T,
                    transparent_index: d,
                    interlaced: !!b,
                    delay: h,
                    disposal: f
                  });
                  break;

                case 59:
                  u = !1;
                  break;

                default:
                  throw "Unknown gif block: 0x" + e[t - 1].toString(16);
              }
            }

            this.numFrames = function () {
              return c.length;
            }, this.loopCount = function () {
              return p;
            }, this.frameInfo = function (e) {
              if (e < 0 || e >= c.length) throw "Frame index out of range.";
              return c[e];
            }, this.decodeAndBlitFrameBGRA = function (t, r) {
              var o = this.frameInfo(t),
                  a = o.width * o.height,
                  s = new Uint8Array(a);
              i(e, o.data_offset, s, a);
              var l = o.palette_offset,
                  u = o.transparent_index;
              null === u && (u = 256);
              var c = o.width,
                  h = n - c,
                  d = c,
                  f = 4 * (o.y * n + o.x),
                  p = 4 * ((o.y + o.height) * n + o.x),
                  g = f,
                  v = 4 * h;
              !0 === o.interlaced && (v += 4 * n * 7);

              for (var m = 8, y = 0, x = s.length; y < x; ++y) {
                var _ = s[y];
                if (0 === d && (d = c, (g += v) >= p && (v = 4 * h + 4 * n * (m - 1), g = f + (c + h) * (m << 1), m >>= 1)), _ === u) g += 4;else {
                  var b = e[l + 3 * _],
                      w = e[l + 3 * _ + 1],
                      S = e[l + 3 * _ + 2];
                  r[g++] = S, r[g++] = w, r[g++] = b, r[g++] = 255;
                }
                --d;
              }
            }, this.decodeAndBlitFrameRGBA = function (t, r) {
              var o = this.frameInfo(t),
                  a = o.width * o.height,
                  s = new Uint8Array(a);
              i(e, o.data_offset, s, a);
              var l = o.palette_offset,
                  u = o.transparent_index;
              null === u && (u = 256);
              var c = o.width,
                  h = n - c,
                  d = c,
                  f = 4 * (o.y * n + o.x),
                  p = 4 * ((o.y + o.height) * n + o.x),
                  g = f,
                  v = 4 * h;
              !0 === o.interlaced && (v += 4 * n * 7);

              for (var m = 8, y = 0, x = s.length; y < x; ++y) {
                var _ = s[y];
                if (0 === d && (d = c, (g += v) >= p && (v = 4 * h + 4 * n * (m - 1), g = f + (c + h) * (m << 1), m >>= 1)), _ === u) g += 4;else {
                  var b = e[l + 3 * _],
                      w = e[l + 3 * _ + 1],
                      S = e[l + 3 * _ + 2];
                  r[g++] = b, r[g++] = w, r[g++] = S, r[g++] = 255;
                }
                --d;
              }
            };
          };
        } catch (e) {}
      }, {}],
      2: [function (e, t, n) {
        var i,
            r,
            o,
            a,
            s,
            l,
            u,
            c = function c(e, t) {
          return function () {
            return e.apply(t, arguments);
          };
        };

        r = e("omggif").GifReader, l = function l(e) {
          var t;
          return (t = new XMLHttpRequest()).open("GET", e, !0), t.responseType = "arraybuffer", {
            xhr: t,
            get: function get(e) {
              return t.onload = u(e), t.send(), this;
            },
            animate: function animate(e) {
              var n;
              return n = s(e), t.onload = u(function (e) {
                return e.animateInCanvas(n);
              }), t.send(), this;
            },
            frames: function frames(e, n, i) {
              var r;
              return null == i && (i = !1), r = s(e), t.onload = u(function (e) {
                return e.onDrawFrame = n, e.animateInCanvas(r, i);
              }), t.send(), this;
            }
          };
        }, u = function u(e) {
          return function (t) {
            return e(new i(new r(new Uint8Array(this.response))));
          };
        }, s = function s(e) {
          var t, n;
          if ("string" == typeof e && "CANVAS" === (null != (n = t = document.querySelector(e)) ? n.tagName : void 0)) return t;
          if ("CANVAS" === (null != e ? e.tagName : void 0)) return e;
          throw new Error("Unexpected selector type. Valid types are query-selector-string/canvas-element");
        }, o = function o(e, t, n) {
          var i, r, o;
          return r = (i = document.createElement("canvas")).getContext("2d"), i.width = e.width, i.height = e.height, (o = r.createImageData(t, n)).data.set(e.pixels), r.putImageData(o, -e.x, -e.y), i;
        }, a = function a(e, t) {
          var n;
          return function () {
            n = [];

            for (var t = 0, i = e.numFrames(); 0 <= i ? t < i : t > i; 0 <= i ? t++ : t--) {
              n.push(t);
            }

            return n;
          }.apply(this).map(function (t) {
            var n;
            return (n = e.frameInfo(t)).pixels = new Uint8ClampedArray(e.width * e.height * 4), e.decodeAndBlitFrameRGBA(t, n.pixels), n;
          });
        }, i = function () {
          function e(e) {
            var t;
            this._reader = e, this._advanceFrame = c(this._advanceFrame, this), this._nextFrameRender = c(this._nextFrameRender, this), this._nextFrame = c(this._nextFrame, this), t = this._reader, this.width = t.width, this.height = t.height, this._frames = a(this._reader), this._loopCount = this._reader.loopCount(), this._loops = 0, this._frameIndex = 0, this._running = !1;
          }

          return e.prototype.start = function () {
            return this._lastTime = new Date().valueOf(), this._delayCompensation = 0, this._running = !0, setTimeout(this._nextFrame, 0), this;
          }, e.prototype.stop = function () {
            return this._running = !1, this;
          }, e.prototype.reset = function () {
            return this._frameIndex = 0, this._loops = 0, this;
          }, e.prototype._nextFrame = function () {
            requestAnimationFrame(this._nextFrameRender);
          }, e.prototype._nextFrameRender = function () {
            var e, t;
            if (this._running) return e = this._frames[this._frameIndex], null != (t = this.onFrame) && t.apply(this, [e, this._frameIndex]), this._enqueueNextFrame();
          }, e.prototype._advanceFrame = function () {
            this._frameIndex += 1, this._frameIndex >= this._frames.length && (0 !== this._loopCount && this._loopCount === this._loops ? this.stop() : (this._frameIndex = 0, this._loops += 1));
          }, e.prototype._enqueueNextFrame = function () {
            var e, t, n, i;

            for (this._advanceFrame(); this._running;) {
              if (n = this._frames[this._frameIndex], t = new Date().valueOf() - this._lastTime, this._lastTime += t, this._delayCompensation += t, e = (i = 10 * n.delay) - this._delayCompensation, this._delayCompensation -= i, !(e < 0)) {
                setTimeout(this._nextFrame, e);
                break;
              }

              this._advanceFrame();
            }
          }, e.prototype.animateInCanvas = function (e, t) {
            var n, i;
            return null == t && (t = !0), t && (e.width = this.width, e.height = this.height), n = e.getContext("2d"), null == this.onDrawFrame && (this.onDrawFrame = function (e, t, n) {
              return e.drawImage(t.buffer, t.x, t.y);
            }), null == this.onFrame && (this.onFrame = (i = this, function (t, r) {
              var a, s;

              switch (null == t.buffer && (t.buffer = o(t, i.width, i.height)), "function" == typeof i.disposeFrame && i.disposeFrame(), t.disposal) {
                case 2:
                  i.disposeFrame = function () {
                    return n.clearRect(0, 0, e.width, e.height);
                  };

                  break;

                case 3:
                  s = n.getImageData(0, 0, e.width, e.height), i.disposeFrame = function () {
                    return n.putImageData(s, 0, 0);
                  };
                  break;

                default:
                  i.disposeFrame = null;
              }

              return null != (a = i.onDrawFrame) ? a.apply(i, [n, t, r]) : void 0;
            })), this.start(), this;
          }, e;
        }(), l.Animator = i, l.decodeFrames = a, l.createBufferCanvas = o, "undefined" != typeof window && null !== window && (window.gifler = l), null != t && (t.exports = l);
      }, {
        omggif: 1
      }]
    }, {}, [2]);
  }, function (e, t, n) {
    var i = n(1),
        r = n(16),
        o = n(646),
        a = n(83),
        s = n(52),
        l = n(648);

    function u() {
      s.stop(this.event);
    }

    function c() {}

    c.prototype.dispose = function () {};

    var h = ["click", "dblclick", "mousewheel", "mouseout", "mouseup", "mousedown", "mousemove", "contextmenu"],
        d = function d(e, t, n, i) {
      a.call(this), this.storage = e, this.painter = t, this.painterRoot = i, n = n || new c(), this.proxy = null, this._hovered = {}, this._lastTouchMoment, this._lastX, this._lastY, this._gestureMgr, o.call(this), this.setHandlerProxy(n);
    };

    function f(e, t, n) {
      if (e[e.rectHover ? "rectContain" : "contain"](t, n)) {
        for (var i, r = e; r;) {
          if (r.clipPath && !r.clipPath.contain(t, n)) return !1;
          r.silent && (i = !0), r = r.parent;
        }

        return !i || "silent";
      }

      return !1;
    }

    function p(e, t, n) {
      var i = e.painter;
      return t < 0 || t > i.getWidth() || n < 0 || n > i.getHeight();
    }

    d.prototype = {
      constructor: d,
      setHandlerProxy: function setHandlerProxy(e) {
        this.proxy && this.proxy.dispose(), e && (i.each(h, function (t) {
          e.on && e.on(t, this[t], this);
        }, this), e.handler = this), this.proxy = e;
      },
      mousemove: function mousemove(e) {
        var t = e.zrX,
            n = e.zrY,
            i = p(this, t, n),
            r = this._hovered,
            o = r.target;
        o && !o.__zr && (o = (r = this.findHover(r.x, r.y)).target);
        var a = this._hovered = i ? {
          x: t,
          y: n
        } : this.findHover(t, n),
            s = a.target,
            l = this.proxy;
        l.setCursor && l.setCursor(s ? s.cursor : "default"), o && s !== o && this.dispatchToElement(r, "mouseout", e), this.dispatchToElement(a, "mousemove", e), s && s !== o && this.dispatchToElement(a, "mouseover", e);
      },
      mouseout: function mouseout(e) {
        var t = e.zrEventControl,
            n = e.zrIsToLocalDOM;
        "only_globalout" !== t && this.dispatchToElement(this._hovered, "mouseout", e), "no_globalout" !== t && !n && this.trigger("globalout", {
          type: "globalout",
          event: e
        });
      },
      resize: function resize(e) {
        this._hovered = {};
      },
      dispatch: function dispatch(e, t) {
        var n = this[e];
        n && n.call(this, t);
      },
      dispose: function dispose() {
        this.proxy.dispose(), this.storage = this.proxy = this.painter = null;
      },
      setCursorStyle: function setCursorStyle(e) {
        var t = this.proxy;
        t.setCursor && t.setCursor(e);
      },
      dispatchToElement: function dispatchToElement(e, t, n) {
        var i = (e = e || {}).target;

        if (!i || !i.silent) {
          for (var r = "on" + t, o = function (e, t, n) {
            return {
              type: e,
              event: n,
              target: t.target,
              topTarget: t.topTarget,
              cancelBubble: !1,
              offsetX: n.zrX,
              offsetY: n.zrY,
              gestureEvent: n.gestureEvent,
              pinchX: n.pinchX,
              pinchY: n.pinchY,
              pinchScale: n.pinchScale,
              wheelDelta: n.zrDelta,
              zrByTouch: n.zrByTouch,
              which: n.which,
              stop: u
            };
          }(t, e, n); i && (i[r] && (o.cancelBubble = i[r].call(i, o)), i.trigger(t, o), i = i.parent, !o.cancelBubble);) {
            ;
          }

          o.cancelBubble || (this.trigger(t, o), this.painter && this.painter.eachOtherLayer(function (e) {
            "function" == typeof e[r] && e[r].call(e, o), e.trigger && e.trigger(t, o);
          }));
        }
      },
      findHover: function findHover(e, t, n) {
        for (var i = this.storage.getDisplayList(), r = {
          x: e,
          y: t
        }, o = i.length - 1; o >= 0; o--) {
          var a;

          if (i[o] !== n && !i[o].ignore && (a = f(i[o], e, t)) && (!r.topTarget && (r.topTarget = i[o]), "silent" !== a)) {
            r.target = i[o];
            break;
          }
        }

        return r;
      },
      processGesture: function processGesture(e, t) {
        this._gestureMgr || (this._gestureMgr = new l());
        var n = this._gestureMgr;
        "start" === t && n.clear();
        var i = n.recognize(e, this.findHover(e.zrX, e.zrY, null).target, this.proxy.dom);

        if ("end" === t && n.clear(), i) {
          var r = i.type;
          e.gestureEvent = r, this.dispatchToElement({
            target: i.target
          }, r, i.event);
        }
      }
    }, i.each(["click", "mousedown", "mouseup", "mousewheel", "dblclick", "contextmenu"], function (e) {
      d.prototype[e] = function (t) {
        var n,
            i,
            o = t.zrX,
            a = t.zrY,
            s = p(this, o, a);
        if ("mouseup" === e && s || (i = (n = this.findHover(o, a)).target), "mousedown" === e) this._downEl = i, this._downPoint = [t.zrX, t.zrY], this._upEl = i;else if ("mouseup" === e) this._upEl = i;else if ("click" === e) {
          if (this._downEl !== this._upEl || !this._downPoint || r.dist(this._downPoint, [t.zrX, t.zrY]) > 4) return;
          this._downPoint = null;
        }
        this.dispatchToElement(n, e, t);
      };
    }), i.mixin(d, a), i.mixin(d, o);
    var g = d;
    e.exports = g;
  }, function (e, t) {
    function n() {
      this.on("mousedown", this._dragStart, this), this.on("mousemove", this._drag, this), this.on("mouseup", this._dragEnd, this);
    }

    function i(e, t) {
      return {
        target: e,
        topTarget: t && t.topTarget
      };
    }

    n.prototype = {
      constructor: n,
      _dragStart: function _dragStart(e) {
        for (var t = e.target; t && !t.draggable;) {
          t = t.parent;
        }

        t && (this._draggingTarget = t, t.dragging = !0, this._x = e.offsetX, this._y = e.offsetY, this.dispatchToElement(i(t, e), "dragstart", e.event));
      },
      _drag: function _drag(e) {
        var t = this._draggingTarget;

        if (t) {
          var n = e.offsetX,
              r = e.offsetY,
              o = n - this._x,
              a = r - this._y;
          this._x = n, this._y = r, t.drift(o, a, e), this.dispatchToElement(i(t, e), "drag", e.event);
          var s = this.findHover(n, r, t).target,
              l = this._dropTarget;
          this._dropTarget = s, t !== s && (l && s !== l && this.dispatchToElement(i(l, e), "dragleave", e.event), s && s !== l && this.dispatchToElement(i(s, e), "dragenter", e.event));
        }
      },
      _dragEnd: function _dragEnd(e) {
        var t = this._draggingTarget;
        t && (t.dragging = !1), this.dispatchToElement(i(t, e), "dragend", e.event), this._dropTarget && this.dispatchToElement(i(this._dropTarget, e), "drop", e.event), this._draggingTarget = null, this._dropTarget = null;
      }
    };
    var r = n;
    e.exports = r;
  }, function (e, t) {
    var n = Math.log(2);

    function i(e, t, r, o, a, s) {
      var l = o + "-" + a,
          u = e.length;
      if (s.hasOwnProperty(l)) return s[l];

      if (1 === t) {
        var c = Math.round(Math.log((1 << u) - 1 & ~a) / n);
        return e[r][c];
      }

      for (var h = o | 1 << r, d = r + 1; o & 1 << d;) {
        d++;
      }

      for (var f = 0, p = 0, g = 0; p < u; p++) {
        var v = 1 << p;
        v & a || (f += (g % 2 ? -1 : 1) * e[r][p] * i(e, t - 1, d, h, a | v, s), g++);
      }

      return s[l] = f, f;
    }

    t.buildTransformer = function (e, t) {
      var n = [[e[0], e[1], 1, 0, 0, 0, -t[0] * e[0], -t[0] * e[1]], [0, 0, 0, e[0], e[1], 1, -t[1] * e[0], -t[1] * e[1]], [e[2], e[3], 1, 0, 0, 0, -t[2] * e[2], -t[2] * e[3]], [0, 0, 0, e[2], e[3], 1, -t[3] * e[2], -t[3] * e[3]], [e[4], e[5], 1, 0, 0, 0, -t[4] * e[4], -t[4] * e[5]], [0, 0, 0, e[4], e[5], 1, -t[5] * e[4], -t[5] * e[5]], [e[6], e[7], 1, 0, 0, 0, -t[6] * e[6], -t[6] * e[7]], [0, 0, 0, e[6], e[7], 1, -t[7] * e[6], -t[7] * e[7]]],
          r = {},
          o = i(n, 8, 0, 0, 0, r);

      if (0 !== o) {
        for (var a = [], s = 0; s < 8; s++) {
          for (var l = 0; l < 8; l++) {
            null == a[l] && (a[l] = 0), a[l] += ((s + l) % 2 ? -1 : 1) * i(n, 7, 0 === s ? 1 : 0, 1 << s, 1 << l, r) / o * t[s];
          }
        }

        return function (e, t, n) {
          var i = t * a[6] + n * a[7] + 1;
          e[0] = (t * a[0] + n * a[1] + a[2]) / i, e[1] = (t * a[3] + n * a[4] + a[5]) / i;
        };
      }
    };
  }, function (e, t, n) {
    var i = n(52),
        r = function r() {
      this._track = [];
    };

    function o(e) {
      var t = e[1][0] - e[0][0],
          n = e[1][1] - e[0][1];
      return Math.sqrt(t * t + n * n);
    }

    r.prototype = {
      constructor: r,
      recognize: function recognize(e, t, n) {
        return this._doTrack(e, t, n), this._recognize(e);
      },
      clear: function clear() {
        return this._track.length = 0, this;
      },
      _doTrack: function _doTrack(e, t, n) {
        var r = e.touches;

        if (r) {
          for (var o = {
            points: [],
            touches: [],
            target: t,
            event: e
          }, a = 0, s = r.length; a < s; a++) {
            var l = r[a],
                u = i.clientToLocal(n, l, {});
            o.points.push([u.zrX, u.zrY]), o.touches.push(l);
          }

          this._track.push(o);
        }
      },
      _recognize: function _recognize(e) {
        for (var t in a) {
          if (a.hasOwnProperty(t)) {
            var n = a[t](this._track, e);
            if (n) return n;
          }
        }
      }
    };
    var a = {
      pinch: function pinch(e, t) {
        var n = e.length;

        if (n) {
          var i,
              r = (e[n - 1] || {}).points,
              a = (e[n - 2] || {}).points || r;

          if (a && a.length > 1 && r && r.length > 1) {
            var s = o(r) / o(a);
            !isFinite(s) && (s = 1), t.pinchScale = s;
            var l = [((i = r)[0][0] + i[1][0]) / 2, (i[0][1] + i[1][1]) / 2];
            return t.pinchX = l[0], t.pinchY = l[1], {
              type: "pinch",
              target: e[0].target,
              event: t
            };
          }
        }
      }
    },
        s = r;
    e.exports = s;
  }, function (e, t, n) {
    var i = n(1),
        r = n(21),
        o = n(84),
        a = n(203);

    function s(e, t) {
      return e.zlevel === t.zlevel ? e.z === t.z ? e.z2 - t.z2 : e.z - t.z : e.zlevel - t.zlevel;
    }

    var l = function l() {
      this._roots = [], this._displayList = [], this._displayListLen = 0;
    };

    l.prototype = {
      constructor: l,
      traverse: function traverse(e, t) {
        for (var n = 0; n < this._roots.length; n++) {
          this._roots[n].traverse(e, t);
        }
      },
      getDisplayList: function getDisplayList(e, t) {
        return t = t || !1, e && this.updateDisplayList(t), this._displayList;
      },
      updateDisplayList: function updateDisplayList(e) {
        this._displayListLen = 0;

        for (var t = this._roots, n = this._displayList, i = 0, o = t.length; i < o; i++) {
          this._updateAndAddDisplayable(t[i], null, e);
        }

        n.length = this._displayListLen, r.canvasSupported && a(n, s);
      },
      _updateAndAddDisplayable: function _updateAndAddDisplayable(e, t, n) {
        if (!e.ignore || n) {
          e.beforeUpdate(), e.__dirty && e.update(), e.afterUpdate();
          var i = e.clipPath;

          if (i) {
            t = t ? t.slice() : [];

            for (var r = i, o = e; r;) {
              r.parent = o, r.updateTransform(), t.push(r), o = r, r = r.clipPath;
            }
          }

          if (e.isGroup) {
            for (var a = e._children, s = 0; s < a.length; s++) {
              var l = a[s];
              e.__dirty && (l.__dirty = !0), this._updateAndAddDisplayable(l, t, n);
            }

            e.__dirty = !1;
          } else e.__clipPaths = t, this._displayList[this._displayListLen++] = e;
        }
      },
      addRoot: function addRoot(e) {
        e.__storage !== this && (e instanceof o && e.addChildrenToStorage(this), this.addToStorage(e), this._roots.push(e));
      },
      delRoot: function delRoot(e) {
        if (null == e) {
          for (var t = 0; t < this._roots.length; t++) {
            var n = this._roots[t];
            n instanceof o && n.delChildrenFromStorage(this);
          }

          return this._roots = [], this._displayList = [], void (this._displayListLen = 0);
        }

        if (e instanceof Array) {
          t = 0;

          for (var r = e.length; t < r; t++) {
            this.delRoot(e[t]);
          }
        } else {
          var a = i.indexOf(this._roots, e);
          a >= 0 && (this.delFromStorage(e), this._roots.splice(a, 1), e instanceof o && e.delChildrenFromStorage(this));
        }
      },
      addToStorage: function addToStorage(e) {
        return e && (e.__storage = this, e.dirty(!1)), this;
      },
      delFromStorage: function delFromStorage(e) {
        return e && (e.__storage = null), this;
      },
      dispose: function dispose() {
        this._renderList = this._roots = null;
      },
      displayableSortFunc: s
    };
    var u = l;
    e.exports = u;
  }, function (e, t, n) {
    var i = n(287),
        r = n(118),
        o = n(1),
        a = o.isString,
        s = o.isFunction,
        l = o.isObject,
        u = o.isArrayLike,
        c = o.indexOf,
        h = function h() {
      this.animators = [];
    };

    function d(e, t, n, i, r, o, c, h) {
      a(i) ? (o = r, r = i, i = 0) : s(r) ? (o = r, r = "linear", i = 0) : s(i) ? (o = i, i = 0) : s(n) ? (o = n, n = 500) : n || (n = 500), e.stopAnimation(), function e(t, n, i, r, o, a, s) {
        var c = {},
            h = 0;

        for (var d in r) {
          r.hasOwnProperty(d) && (null != i[d] ? l(r[d]) && !u(r[d]) ? e(t, n ? n + "." + d : d, i[d], r[d], o, a, s) : (s ? (c[d] = i[d], f(t, n, d, r[d])) : c[d] = r[d], h++) : null == r[d] || s || f(t, n, d, r[d]));
        }

        h > 0 && t.animate(n, !1).when(null == o ? 500 : o, c).delay(a || 0);
      }(e, "", e, t, n, i, h);
      var d = e.animators.slice(),
          p = d.length;

      function g() {
        --p || o && o();
      }

      p || o && o();

      for (var v = 0; v < d.length; v++) {
        d[v].done(g).start(r, c);
      }
    }

    function f(e, t, n, i) {
      if (t) {
        var r = {};
        r[t] = {}, r[t][n] = i, e.attr(r);
      } else e.attr(n, i);
    }

    h.prototype = {
      constructor: h,
      animate: function animate(e, t) {
        var n,
            o = !1,
            a = this,
            s = this.__zr;

        if (e) {
          var l = e.split("."),
              u = a;
          o = "shape" === l[0];

          for (var h = 0, d = l.length; h < d; h++) {
            u && (u = u[l[h]]);
          }

          u && (n = u);
        } else n = a;

        if (n) {
          var f = a.animators,
              p = new i(n, t);
          return p.during(function (e) {
            a.dirty(o);
          }).done(function () {
            f.splice(c(f, p), 1);
          }), f.push(p), s && s.animation.addAnimator(p), p;
        }

        r('Property "' + e + '" is not existed in element ' + a.id);
      },
      stopAnimation: function stopAnimation(e) {
        for (var t = this.animators, n = t.length, i = 0; i < n; i++) {
          t[i].stop(e);
        }

        return t.length = 0, this;
      },
      animateTo: function animateTo(e, t, n, i, r, o) {
        d(this, e, t, n, i, r, o);
      },
      animateFrom: function animateFrom(e, t, n, i, r, o) {
        d(this, e, t, n, i, r, o, !0);
      }
    };
    var p = h;
    e.exports = p;
  }, function (e, t, n) {
    var i = n(652);

    function r(e) {
      this._target = e.target, this._life = e.life || 1e3, this._delay = e.delay || 0, this._initialized = !1, this.loop = null != e.loop && e.loop, this.gap = e.gap || 0, this.easing = e.easing || "Linear", this.onframe = e.onframe, this.ondestroy = e.ondestroy, this.onrestart = e.onrestart, this._pausedTime = 0, this._paused = !1;
    }

    r.prototype = {
      constructor: r,
      step: function step(e, t) {
        if (this._initialized || (this._startTime = e + this._delay, this._initialized = !0), this._paused) this._pausedTime += t;else {
          var n = (e - this._startTime - this._pausedTime) / this._life;

          if (!(n < 0)) {
            n = Math.min(n, 1);
            var r = this.easing,
                o = "string" == typeof r ? i[r] : r,
                a = "function" == typeof o ? o(n) : n;
            return this.fire("frame", a), 1 === n ? this.loop ? (this.restart(e), "restart") : (this._needsRemove = !0, "destroy") : null;
          }
        }
      },
      restart: function restart(e) {
        var t = (e - this._startTime - this._pausedTime) % this._life;
        this._startTime = e - t + this.gap, this._pausedTime = 0, this._needsRemove = !1;
      },
      fire: function fire(e, t) {
        this[e = "on" + e] && this[e](this._target, t);
      },
      pause: function pause() {
        this._paused = !0;
      },
      resume: function resume() {
        this._paused = !1;
      }
    };
    var o = r;
    e.exports = o;
  }, function (e, t) {
    var n = {
      linear: function linear(e) {
        return e;
      },
      quadraticIn: function quadraticIn(e) {
        return e * e;
      },
      quadraticOut: function quadraticOut(e) {
        return e * (2 - e);
      },
      quadraticInOut: function quadraticInOut(e) {
        return (e *= 2) < 1 ? .5 * e * e : -.5 * (--e * (e - 2) - 1);
      },
      cubicIn: function cubicIn(e) {
        return e * e * e;
      },
      cubicOut: function cubicOut(e) {
        return --e * e * e + 1;
      },
      cubicInOut: function cubicInOut(e) {
        return (e *= 2) < 1 ? .5 * e * e * e : .5 * ((e -= 2) * e * e + 2);
      },
      quarticIn: function quarticIn(e) {
        return e * e * e * e;
      },
      quarticOut: function quarticOut(e) {
        return 1 - --e * e * e * e;
      },
      quarticInOut: function quarticInOut(e) {
        return (e *= 2) < 1 ? .5 * e * e * e * e : -.5 * ((e -= 2) * e * e * e - 2);
      },
      quinticIn: function quinticIn(e) {
        return e * e * e * e * e;
      },
      quinticOut: function quinticOut(e) {
        return --e * e * e * e * e + 1;
      },
      quinticInOut: function quinticInOut(e) {
        return (e *= 2) < 1 ? .5 * e * e * e * e * e : .5 * ((e -= 2) * e * e * e * e + 2);
      },
      sinusoidalIn: function sinusoidalIn(e) {
        return 1 - Math.cos(e * Math.PI / 2);
      },
      sinusoidalOut: function sinusoidalOut(e) {
        return Math.sin(e * Math.PI / 2);
      },
      sinusoidalInOut: function sinusoidalInOut(e) {
        return .5 * (1 - Math.cos(Math.PI * e));
      },
      exponentialIn: function exponentialIn(e) {
        return 0 === e ? 0 : Math.pow(1024, e - 1);
      },
      exponentialOut: function exponentialOut(e) {
        return 1 === e ? 1 : 1 - Math.pow(2, -10 * e);
      },
      exponentialInOut: function exponentialInOut(e) {
        return 0 === e ? 0 : 1 === e ? 1 : (e *= 2) < 1 ? .5 * Math.pow(1024, e - 1) : .5 * (2 - Math.pow(2, -10 * (e - 1)));
      },
      circularIn: function circularIn(e) {
        return 1 - Math.sqrt(1 - e * e);
      },
      circularOut: function circularOut(e) {
        return Math.sqrt(1 - --e * e);
      },
      circularInOut: function circularInOut(e) {
        return (e *= 2) < 1 ? -.5 * (Math.sqrt(1 - e * e) - 1) : .5 * (Math.sqrt(1 - (e -= 2) * e) + 1);
      },
      elasticIn: function elasticIn(e) {
        var t,
            n = .1;
        return 0 === e ? 0 : 1 === e ? 1 : (!n || n < 1 ? (n = 1, t = .1) : t = .4 * Math.asin(1 / n) / (2 * Math.PI), -n * Math.pow(2, 10 * (e -= 1)) * Math.sin((e - t) * (2 * Math.PI) / .4));
      },
      elasticOut: function elasticOut(e) {
        var t,
            n = .1;
        return 0 === e ? 0 : 1 === e ? 1 : (!n || n < 1 ? (n = 1, t = .1) : t = .4 * Math.asin(1 / n) / (2 * Math.PI), n * Math.pow(2, -10 * e) * Math.sin((e - t) * (2 * Math.PI) / .4) + 1);
      },
      elasticInOut: function elasticInOut(e) {
        var t,
            n = .1,
            i = .4;
        return 0 === e ? 0 : 1 === e ? 1 : (!n || n < 1 ? (n = 1, t = .1) : t = i * Math.asin(1 / n) / (2 * Math.PI), (e *= 2) < 1 ? n * Math.pow(2, 10 * (e -= 1)) * Math.sin((e - t) * (2 * Math.PI) / i) * -.5 : n * Math.pow(2, -10 * (e -= 1)) * Math.sin((e - t) * (2 * Math.PI) / i) * .5 + 1);
      },
      backIn: function backIn(e) {
        var t = 1.70158;
        return e * e * ((t + 1) * e - t);
      },
      backOut: function backOut(e) {
        var t = 1.70158;
        return --e * e * ((t + 1) * e + t) + 1;
      },
      backInOut: function backInOut(e) {
        var t = 2.5949095;
        return (e *= 2) < 1 ? e * e * ((t + 1) * e - t) * .5 : .5 * ((e -= 2) * e * ((t + 1) * e + t) + 2);
      },
      bounceIn: function bounceIn(e) {
        return 1 - n.bounceOut(1 - e);
      },
      bounceOut: function bounceOut(e) {
        return e < 1 / 2.75 ? 7.5625 * e * e : e < 2 / 2.75 ? 7.5625 * (e -= 1.5 / 2.75) * e + .75 : e < 2.5 / 2.75 ? 7.5625 * (e -= 2.25 / 2.75) * e + .9375 : 7.5625 * (e -= 2.625 / 2.75) * e + .984375;
      },
      bounceInOut: function bounceInOut(e) {
        return e < .5 ? .5 * n.bounceIn(2 * e) : .5 * n.bounceOut(2 * e - 1) + .5;
      }
    },
        i = n;
    e.exports = i;
  }, function (e, t, n) {
    var i = n(154).devicePixelRatio,
        r = n(1),
        o = n(118),
        a = n(17),
        s = n(203),
        l = n(654),
        u = n(291),
        c = n(100),
        h = n(21);

    function d(e) {
      return parseInt(e, 10);
    }

    var f = new a(0, 0, 0, 0),
        p = new a(0, 0, 0, 0);

    var g = function g(e, t, n) {
      this.type = "canvas";
      var o = !e.nodeName || "CANVAS" === e.nodeName.toUpperCase();
      this._opts = n = r.extend({}, n || {}), this.dpr = n.devicePixelRatio || i, this._singleCanvas = o, this.root = e;
      var a = e.style;
      a && (a["-webkit-tap-highlight-color"] = "transparent", a["-webkit-user-select"] = a["user-select"] = a["-webkit-touch-callout"] = "none", e.innerHTML = ""), this.storage = t;
      var s = this._zlevelList = [],
          u = this._layers = {};

      if (this._layerConfig = {}, this._needsManuallyCompositing = !1, o) {
        var c = e.width,
            h = e.height;
        null != n.width && (c = n.width), null != n.height && (h = n.height), this.dpr = n.devicePixelRatio || 1, e.width = c * this.dpr, e.height = h * this.dpr, this._width = c, this._height = h;
        var d = new l(e, this, this.dpr);
        d.__builtin__ = !0, d.initContext(), u[314159] = d, d.zlevel = 314159, s.push(314159), this._domRoot = e;
      } else {
        this._width = this._getSize(0), this._height = this._getSize(1);

        var f = this._domRoot = function (e, t) {
          var n = document.createElement("div");
          return n.style.cssText = ["position:relative", "width:" + e + "px", "height:" + t + "px", "padding:0", "margin:0", "border-width:0"].join(";") + ";", n;
        }(this._width, this._height);

        e.appendChild(f);
      }

      this._hoverlayer = null, this._hoverElements = [];
    };

    g.prototype = {
      constructor: g,
      getType: function getType() {
        return "canvas";
      },
      isSingleCanvas: function isSingleCanvas() {
        return this._singleCanvas;
      },
      getViewportRoot: function getViewportRoot() {
        return this._domRoot;
      },
      getViewportRootOffset: function getViewportRootOffset() {
        var e = this.getViewportRoot();
        if (e) return {
          offsetLeft: e.offsetLeft || 0,
          offsetTop: e.offsetTop || 0
        };
      },
      refresh: function refresh(e) {
        var t = this.storage.getDisplayList(!0),
            n = this._zlevelList;
        this._redrawId = Math.random(), this._paintList(t, e, this._redrawId);

        for (var i = 0; i < n.length; i++) {
          var r = n[i],
              o = this._layers[r];

          if (!o.__builtin__ && o.refresh) {
            var a = 0 === i ? this._backgroundColor : null;
            o.refresh(a);
          }
        }

        return this.refreshHover(), this;
      },
      addHover: function addHover(e, t) {
        if (!e.__hoverMir) {
          var n = new e.constructor({
            style: e.style,
            shape: e.shape,
            z: e.z,
            z2: e.z2,
            silent: e.silent
          });
          return n.__from = e, e.__hoverMir = n, t && n.setStyle(t), this._hoverElements.push(n), n;
        }
      },
      removeHover: function removeHover(e) {
        var t = e.__hoverMir,
            n = this._hoverElements,
            i = r.indexOf(n, t);
        i >= 0 && n.splice(i, 1), e.__hoverMir = null;
      },
      clearHover: function clearHover(e) {
        for (var t = this._hoverElements, n = 0; n < t.length; n++) {
          var i = t[n].__from;
          i && (i.__hoverMir = null);
        }

        t.length = 0;
      },
      refreshHover: function refreshHover() {
        var e = this._hoverElements,
            t = e.length,
            n = this._hoverlayer;

        if (n && n.clear(), t) {
          s(e, this.storage.displayableSortFunc), n || (n = this._hoverlayer = this.getLayer(1e5));
          var i = {};
          n.ctx.save();

          for (var r = 0; r < t;) {
            var o = e[r],
                a = o.__from;
            a && a.__zr ? (r++, a.invisible || (o.transform = a.transform, o.invTransform = a.invTransform, o.__clipPaths = a.__clipPaths, this._doPaintEl(o, n, !0, i))) : (e.splice(r, 1), a.__hoverMir = null, t--);
          }

          n.ctx.restore();
        }
      },
      getHoverLayer: function getHoverLayer() {
        return this.getLayer(1e5);
      },
      _paintList: function _paintList(e, t, n) {
        if (this._redrawId === n) {
          t = t || !1, this._updateLayerStatus(e);

          var i = this._doPaintList(e, t);

          if (this._needsManuallyCompositing && this._compositeManually(), !i) {
            var r = this;
            u(function () {
              r._paintList(e, t, n);
            });
          }
        }
      },
      _compositeManually: function _compositeManually() {
        var e = this.getLayer(314159).ctx,
            t = this._domRoot.width,
            n = this._domRoot.height;
        e.clearRect(0, 0, t, n), this.eachBuiltinLayer(function (i) {
          i.virtual && e.drawImage(i.dom, 0, 0, t, n);
        });
      },
      _doPaintList: function _doPaintList(e, t) {
        for (var n = [], i = 0; i < this._zlevelList.length; i++) {
          var o = this._zlevelList[i];
          (l = this._layers[o]).__builtin__ && l !== this._hoverlayer && (l.__dirty || t) && n.push(l);
        }

        for (var a = !0, s = 0; s < n.length; s++) {
          var l,
              u = (l = n[s]).ctx,
              c = {};
          u.save();
          var d = t ? l.__startIndex : l.__drawIndex,
              f = !t && l.incremental && Date.now,
              p = f && Date.now(),
              g = l.zlevel === this._zlevelList[0] ? this._backgroundColor : null;
          if (l.__startIndex === l.__endIndex) l.clear(!1, g);else if (d === l.__startIndex) {
            var v = e[d];
            v.incremental && v.notClear && !t || l.clear(!1, g);
          }
          -1 === d && (console.error("For some unknown reason. drawIndex is -1"), d = l.__startIndex);

          for (var m = d; m < l.__endIndex; m++) {
            var y = e[m];
            if (this._doPaintEl(y, l, t, c), y.__dirty = y.__dirtyText = !1, f) if (Date.now() - p > 15) break;
          }

          l.__drawIndex = m, l.__drawIndex < l.__endIndex && (a = !1), c.prevElClipPaths && u.restore(), u.restore();
        }

        return h.wxa && r.each(this._layers, function (e) {
          e && e.ctx && e.ctx.draw && e.ctx.draw();
        }), a;
      },
      _doPaintEl: function _doPaintEl(e, t, n, i) {
        var r = t.ctx,
            o = e.transform;

        if ((t.__dirty || n) && !e.invisible && 0 !== e.style.opacity && (!o || o[0] || o[3]) && (!e.culling || !function (e, t, n) {
          return f.copy(e.getBoundingRect()), e.transform && f.applyTransform(e.transform), p.width = t, p.height = n, !f.intersect(p);
        }(e, this._width, this._height))) {
          var a = e.__clipPaths,
              s = i.prevElClipPaths;
          s && !function (e, t) {
            if (e === t) return !1;
            if (!e || !t || e.length !== t.length) return !0;

            for (var n = 0; n < e.length; n++) {
              if (e[n] !== t[n]) return !0;
            }

            return !1;
          }(a, s) || (s && (r.restore(), i.prevElClipPaths = null, i.prevEl = null), a && (r.save(), function (e, t) {
            for (var n = 0; n < e.length; n++) {
              var i = e[n];
              i.setTransform(t), t.beginPath(), i.buildPath(t, i.shape), t.clip(), i.restoreTransform(t);
            }
          }(a, r), i.prevElClipPaths = a)), e.beforeBrush && e.beforeBrush(r), e.brush(r, i.prevEl || null), i.prevEl = e, e.afterBrush && e.afterBrush(r);
        }
      },
      getLayer: function getLayer(e, t) {
        this._singleCanvas && !this._needsManuallyCompositing && (e = 314159);
        var n = this._layers[e];
        return n || ((n = new l("zr_" + e, this, this.dpr)).zlevel = e, n.__builtin__ = !0, this._layerConfig[e] ? r.merge(n, this._layerConfig[e], !0) : this._layerConfig[e - .01] && r.merge(n, this._layerConfig[e - .01], !0), t && (n.virtual = t), this.insertLayer(e, n), n.initContext()), n;
      },
      insertLayer: function insertLayer(e, t) {
        var n = this._layers,
            i = this._zlevelList,
            r = i.length,
            a = null,
            s = -1,
            l = this._domRoot;
        if (n[e]) o("ZLevel " + e + " has been used already");else if (function (e) {
          return !!e && (!!e.__builtin__ || "function" == typeof e.resize && "function" == typeof e.refresh);
        }(t)) {
          if (r > 0 && e > i[0]) {
            for (s = 0; s < r - 1 && !(i[s] < e && i[s + 1] > e); s++) {
              ;
            }

            a = n[i[s]];
          }

          if (i.splice(s + 1, 0, e), n[e] = t, !t.virtual) if (a) {
            var u = a.dom;
            u.nextSibling ? l.insertBefore(t.dom, u.nextSibling) : l.appendChild(t.dom);
          } else l.firstChild ? l.insertBefore(t.dom, l.firstChild) : l.appendChild(t.dom);
        } else o("Layer of zlevel " + e + " is not valid");
      },
      eachLayer: function eachLayer(e, t) {
        var n,
            i,
            r = this._zlevelList;

        for (i = 0; i < r.length; i++) {
          n = r[i], e.call(t, this._layers[n], n);
        }
      },
      eachBuiltinLayer: function eachBuiltinLayer(e, t) {
        var n,
            i,
            r,
            o = this._zlevelList;

        for (r = 0; r < o.length; r++) {
          i = o[r], (n = this._layers[i]).__builtin__ && e.call(t, n, i);
        }
      },
      eachOtherLayer: function eachOtherLayer(e, t) {
        var n,
            i,
            r,
            o = this._zlevelList;

        for (r = 0; r < o.length; r++) {
          i = o[r], (n = this._layers[i]).__builtin__ || e.call(t, n, i);
        }
      },
      getLayers: function getLayers() {
        return this._layers;
      },
      _updateLayerStatus: function _updateLayerStatus(e) {
        function t(e) {
          r && (r.__endIndex !== e && (r.__dirty = !0), r.__endIndex = e);
        }

        if (this.eachBuiltinLayer(function (e, t) {
          e.__dirty = e.__used = !1;
        }), this._singleCanvas) for (var n = 1; n < e.length; n++) {
          if ((s = e[n]).zlevel !== e[n - 1].zlevel || s.incremental) {
            this._needsManuallyCompositing = !0;
            break;
          }
        }
        var i,
            r = null,
            a = 0;

        for (n = 0; n < e.length; n++) {
          var s,
              l,
              u = (s = e[n]).zlevel;
          i !== u && (i = u, a = 0), s.incremental ? ((l = this.getLayer(u + .001, this._needsManuallyCompositing)).incremental = !0, a = 1) : l = this.getLayer(u + (a > 0 ? .01 : 0), this._needsManuallyCompositing), l.__builtin__ || o("ZLevel " + u + " has been used by unkown layer " + l.id), l !== r && (l.__used = !0, l.__startIndex !== n && (l.__dirty = !0), l.__startIndex = n, l.incremental ? l.__drawIndex = -1 : l.__drawIndex = n, t(n), r = l), s.__dirty && (l.__dirty = !0, l.incremental && l.__drawIndex < 0 && (l.__drawIndex = n));
        }

        t(n), this.eachBuiltinLayer(function (e, t) {
          !e.__used && e.getElementCount() > 0 && (e.__dirty = !0, e.__startIndex = e.__endIndex = e.__drawIndex = 0), e.__dirty && e.__drawIndex < 0 && (e.__drawIndex = e.__startIndex);
        });
      },
      clear: function clear() {
        return this.eachBuiltinLayer(this._clearLayer), this;
      },
      _clearLayer: function _clearLayer(e) {
        e.clear();
      },
      setBackgroundColor: function setBackgroundColor(e) {
        this._backgroundColor = e;
      },
      configLayer: function configLayer(e, t) {
        if (t) {
          var n = this._layerConfig;
          n[e] ? r.merge(n[e], t, !0) : n[e] = t;

          for (var i = 0; i < this._zlevelList.length; i++) {
            var o = this._zlevelList[i];

            if (o === e || o === e + .01) {
              var a = this._layers[o];
              r.merge(a, n[e], !0);
            }
          }
        }
      },
      delLayer: function delLayer(e) {
        var t = this._layers,
            n = this._zlevelList,
            i = t[e];
        i && (i.dom.parentNode.removeChild(i.dom), delete t[e], n.splice(r.indexOf(n, e), 1));
      },
      resize: function resize(e, t) {
        if (this._domRoot.style) {
          var n = this._domRoot;
          n.style.display = "none";
          var i = this._opts;

          if (null != e && (i.width = e), null != t && (i.height = t), e = this._getSize(0), t = this._getSize(1), n.style.display = "", this._width !== e || t !== this._height) {
            for (var o in n.style.width = e + "px", n.style.height = t + "px", this._layers) {
              this._layers.hasOwnProperty(o) && this._layers[o].resize(e, t);
            }

            r.each(this._progressiveLayers, function (n) {
              n.resize(e, t);
            }), this.refresh(!0);
          }

          this._width = e, this._height = t;
        } else {
          if (null == e || null == t) return;
          this._width = e, this._height = t, this.getLayer(314159).resize(e, t);
        }

        return this;
      },
      clearLayer: function clearLayer(e) {
        var t = this._layers[e];
        t && t.clear();
      },
      dispose: function dispose() {
        this.root.innerHTML = "", this.root = this.storage = this._domRoot = this._layers = null;
      },
      getRenderedCanvas: function getRenderedCanvas(e) {
        if (e = e || {}, this._singleCanvas && !this._compositeManually) return this._layers[314159].dom;
        var t = new l("image", this, e.pixelRatio || this.dpr);

        if (t.initContext(), t.clear(!1, e.backgroundColor || this._backgroundColor), e.pixelRatio <= this.dpr) {
          this.refresh();
          var n = t.dom.width,
              i = t.dom.height,
              r = t.ctx;
          this.eachLayer(function (e) {
            e.__builtin__ ? r.drawImage(e.dom, 0, 0, n, i) : e.renderToCanvas && (t.ctx.save(), e.renderToCanvas(t.ctx), t.ctx.restore());
          });
        } else for (var o = {}, a = this.storage.getDisplayList(!0), s = 0; s < a.length; s++) {
          var u = a[s];

          this._doPaintEl(u, t, !0, o);
        }

        return t.dom;
      },
      getWidth: function getWidth() {
        return this._width;
      },
      getHeight: function getHeight() {
        return this._height;
      },
      _getSize: function _getSize(e) {
        var t = this._opts,
            n = ["width", "height"][e],
            i = ["clientWidth", "clientHeight"][e],
            r = ["paddingLeft", "paddingTop"][e],
            o = ["paddingRight", "paddingBottom"][e];
        if (null != t[n] && "auto" !== t[n]) return parseFloat(t[n]);
        var a = this.root,
            s = document.defaultView.getComputedStyle(a);
        return (a[i] || d(s[n]) || d(a.style[n])) - (d(s[r]) || 0) - (d(s[o]) || 0) | 0;
      },
      pathToImage: function pathToImage(e, t) {
        t = t || this.dpr;
        var n = document.createElement("canvas"),
            i = n.getContext("2d"),
            r = e.getBoundingRect(),
            o = e.style,
            a = o.shadowBlur * t,
            s = o.shadowOffsetX * t,
            l = o.shadowOffsetY * t,
            u = o.hasStroke() ? o.lineWidth : 0,
            h = Math.max(u / 2, -s + a),
            d = Math.max(u / 2, s + a),
            f = Math.max(u / 2, -l + a),
            p = Math.max(u / 2, l + a),
            g = r.width + h + d,
            v = r.height + f + p;
        n.width = g * t, n.height = v * t, i.scale(t, t), i.clearRect(0, 0, g, v), i.dpr = t;
        var m = {
          position: e.position,
          rotation: e.rotation,
          scale: e.scale
        };
        e.position = [h - r.x, f - r.y], e.rotation = 0, e.scale = [1, 1], e.updateTransform(), e && e.brush(i);
        var y = new c({
          style: {
            x: 0,
            y: 0,
            image: n
          }
        });
        return null != m.position && (y.position = e.position = m.position), null != m.rotation && (y.rotation = e.rotation = m.rotation), null != m.scale && (y.scale = e.scale = m.scale), y;
      }
    };
    var v = g;
    e.exports = v;
  }, function (e, t, n) {
    var i = n(1),
        r = n(154).devicePixelRatio,
        o = n(204),
        a = n(290);

    function s() {
      return !1;
    }

    function l(e, t, n) {
      var r = i.createCanvas(),
          o = t.getWidth(),
          a = t.getHeight(),
          s = r.style;
      return s && (s.position = "absolute", s.left = 0, s.top = 0, s.width = o + "px", s.height = a + "px", r.setAttribute("data-zr-dom-id", e)), r.width = o * n, r.height = a * n, r;
    }

    var u = function u(e, t, n) {
      var o;
      n = n || r, "string" == typeof e ? o = l(e, t, n) : i.isObject(e) && (e = (o = e).id), this.id = e, this.dom = o;
      var a = o.style;
      a && (o.onselectstart = s, a["-webkit-user-select"] = "none", a["user-select"] = "none", a["-webkit-touch-callout"] = "none", a["-webkit-tap-highlight-color"] = "rgba(0,0,0,0)", a.padding = 0, a.margin = 0, a["border-width"] = 0), this.domBack = null, this.ctxBack = null, this.painter = t, this.config = null, this.clearColor = 0, this.motionBlur = !1, this.lastFrameAlpha = .7, this.dpr = n;
    };

    u.prototype = {
      constructor: u,
      __dirty: !0,
      __used: !1,
      __drawIndex: 0,
      __startIndex: 0,
      __endIndex: 0,
      incremental: !1,
      getElementCount: function getElementCount() {
        return this.__endIndex - this.__startIndex;
      },
      initContext: function initContext() {
        this.ctx = this.dom.getContext("2d"), this.ctx.dpr = this.dpr;
      },
      createBackBuffer: function createBackBuffer() {
        var e = this.dpr;
        this.domBack = l("back-" + this.id, this.painter, e), this.ctxBack = this.domBack.getContext("2d"), 1 !== e && this.ctxBack.scale(e, e);
      },
      resize: function resize(e, t) {
        var n = this.dpr,
            i = this.dom,
            r = i.style,
            o = this.domBack;
        r && (r.width = e + "px", r.height = t + "px"), i.width = e * n, i.height = t * n, o && (o.width = e * n, o.height = t * n, 1 !== n && this.ctxBack.scale(n, n));
      },
      clear: function clear(e, t) {
        var n,
            i = this.dom,
            r = this.ctx,
            s = i.width,
            l = i.height,
            u = (t = t || this.clearColor, this.motionBlur && !e),
            c = this.lastFrameAlpha,
            h = this.dpr;
        (u && (this.domBack || this.createBackBuffer(), this.ctxBack.globalCompositeOperation = "copy", this.ctxBack.drawImage(i, 0, 0, s / h, l / h)), r.clearRect(0, 0, s, l), t && "transparent" !== t) && (t.colorStops ? (n = t.__canvasGradient || o.getGradient(r, t, {
          x: 0,
          y: 0,
          width: s,
          height: l
        }), t.__canvasGradient = n) : t.image && (n = a.prototype.getCanvasPattern.call(t, r)), r.save(), r.fillStyle = n || t, r.fillRect(0, 0, s, l), r.restore());

        if (u) {
          var d = this.domBack;
          r.save(), r.globalAlpha = c, r.drawImage(d, 0, 0, s, l), r.restore();
        }
      }
    };
    var c = u;
    e.exports = c;
  }, function (e, t, n) {
    var i = n(1),
        r = n(52).Dispatcher,
        o = n(291),
        a = n(287),
        s = function s(e) {
      e = e || {}, this.stage = e.stage || {}, this.onframe = e.onframe || function () {}, this._clips = [], this._running = !1, this._time, this._pausedTime, this._pauseStart, this._paused = !1, r.call(this);
    };

    s.prototype = {
      constructor: s,
      addClip: function addClip(e) {
        this._clips.push(e);
      },
      addAnimator: function addAnimator(e) {
        e.animation = this;

        for (var t = e.getClips(), n = 0; n < t.length; n++) {
          this.addClip(t[n]);
        }
      },
      removeClip: function removeClip(e) {
        var t = i.indexOf(this._clips, e);
        t >= 0 && this._clips.splice(t, 1);
      },
      removeAnimator: function removeAnimator(e) {
        for (var t = e.getClips(), n = 0; n < t.length; n++) {
          this.removeClip(t[n]);
        }

        e.animation = null;
      },
      _update: function _update() {
        for (var e = new Date().getTime() - this._pausedTime, t = e - this._time, n = this._clips, i = n.length, r = [], o = [], a = 0; a < i; a++) {
          var s = n[a],
              l = s.step(e, t);
          l && (r.push(l), o.push(s));
        }

        for (a = 0; a < i;) {
          n[a]._needsRemove ? (n[a] = n[i - 1], n.pop(), i--) : a++;
        }

        i = r.length;

        for (a = 0; a < i; a++) {
          o[a].fire(r[a]);
        }

        this._time = e, this.onframe(t), this.trigger("frame", t), this.stage.update && this.stage.update();
      },
      _startLoop: function _startLoop() {
        var e = this;
        this._running = !0, o(function t() {
          e._running && (o(t), !e._paused && e._update());
        });
      },
      start: function start() {
        this._time = new Date().getTime(), this._pausedTime = 0, this._startLoop();
      },
      stop: function stop() {
        this._running = !1;
      },
      pause: function pause() {
        this._paused || (this._pauseStart = new Date().getTime(), this._paused = !0);
      },
      resume: function resume() {
        this._paused && (this._pausedTime += new Date().getTime() - this._pauseStart, this._paused = !1);
      },
      clear: function clear() {
        this._clips = [];
      },
      isFinished: function isFinished() {
        return !this._clips.length;
      },
      animate: function animate(e, t) {
        var n = new a(e, (t = t || {}).loop, t.getter, t.setter);
        return this.addAnimator(n), n;
      }
    }, i.mixin(s, r);
    var l = s;
    e.exports = l;
  }, function (e, t, n) {
    var i,
        r,
        o = n(52),
        a = o.addEventListener,
        s = o.removeEventListener,
        l = o.normalizeEvent,
        u = o.getNativeEvent,
        c = n(1),
        h = n(83),
        d = n(21),
        f = d.domSupported,
        p = (r = {
      pointerdown: 1,
      pointerup: 1,
      pointermove: 1,
      pointerout: 1
    }, {
      mouse: i = ["click", "dblclick", "mousewheel", "mouseout", "mouseup", "mousedown", "mousemove", "contextmenu"],
      touch: ["touchstart", "touchend", "touchmove"],
      pointer: c.map(i, function (e) {
        var t = e.replace("mouse", "pointer");
        return r.hasOwnProperty(t) ? t : e;
      })
    }),
        g = ["mousemove", "mouseup"],
        v = ["pointermove", "pointerup"];

    function m(e) {
      return "mousewheel" === e && d.browser.firefox ? "DOMMouseScroll" : e;
    }

    function y(e) {
      var t = e.pointerType;
      return "pen" === t || "touch" === t;
    }

    function x(e) {
      e && (e.zrByTouch = !0);
    }

    function _(e, t) {
      for (var n = t, i = !1; n && 9 !== n.nodeType && !(i = n.domBelongToZr || n !== t && n === e.painterRoot);) {
        n = n.parentNode;
      }

      return i;
    }

    function b(e, t) {
      this.type = t.type, this.target = this.currentTarget = e.dom, this.pointerType = t.pointerType, this.clientX = t.clientX, this.clientY = t.clientY;
    }

    var w = b.prototype;
    w.stopPropagation = w.stopImmediatePropagation = w.preventDefault = c.noop;
    var S = {
      mousedown: function mousedown(e) {
        e = l(this.dom, e), this._mayPointerCapture = [e.zrX, e.zrY], this.trigger("mousedown", e);
      },
      mousemove: function mousemove(e) {
        e = l(this.dom, e);
        var t = this._mayPointerCapture;
        !t || e.zrX === t[0] && e.zrY === t[1] || A(this, !0), this.trigger("mousemove", e);
      },
      mouseup: function mouseup(e) {
        e = l(this.dom, e), A(this, !1), this.trigger("mouseup", e);
      },
      mouseout: function mouseout(e) {
        e = l(this.dom, e), this._pointerCapturing && (e.zrEventControl = "no_globalout");
        var t = e.toElement || e.relatedTarget;
        e.zrIsToLocalDOM = _(this, t), this.trigger("mouseout", e);
      },
      touchstart: function touchstart(e) {
        x(e = l(this.dom, e)), this._lastTouchMoment = new Date(), this.handler.processGesture(e, "start"), S.mousemove.call(this, e), S.mousedown.call(this, e);
      },
      touchmove: function touchmove(e) {
        x(e = l(this.dom, e)), this.handler.processGesture(e, "change"), S.mousemove.call(this, e);
      },
      touchend: function touchend(e) {
        x(e = l(this.dom, e)), this.handler.processGesture(e, "end"), S.mouseup.call(this, e), +new Date() - this._lastTouchMoment < 300 && S.click.call(this, e);
      },
      pointerdown: function pointerdown(e) {
        S.mousedown.call(this, e);
      },
      pointermove: function pointermove(e) {
        y(e) || S.mousemove.call(this, e);
      },
      pointerup: function pointerup(e) {
        S.mouseup.call(this, e);
      },
      pointerout: function pointerout(e) {
        y(e) || S.mouseout.call(this, e);
      }
    };
    c.each(["click", "mousewheel", "dblclick", "contextmenu"], function (e) {
      S[e] = function (t) {
        t = l(this.dom, t), this.trigger(e, t);
      };
    });
    var T = {
      pointermove: function pointermove(e) {
        y(e) || T.mousemove.call(this, e);
      },
      pointerup: function pointerup(e) {
        T.mouseup.call(this, e);
      },
      mousemove: function mousemove(e) {
        this.trigger("mousemove", e);
      },
      mouseup: function mouseup(e) {
        var t = this._pointerCapturing;
        A(this, !1), this.trigger("mouseup", e), t && (e.zrEventControl = "only_globalout", this.trigger("mouseout", e));
      }
    };

    function C(e, t) {
      var n = t.domHandlers;
      d.pointerEventsSupported ? c.each(p.pointer, function (i) {
        M(t, i, function (t) {
          n[i].call(e, t);
        });
      }) : (d.touchEventsSupported && c.each(p.touch, function (i) {
        M(t, i, function (r) {
          n[i].call(e, r), function (e) {
            e.touching = !0, null != e.touchTimer && (clearTimeout(e.touchTimer), e.touchTimer = null), e.touchTimer = setTimeout(function () {
              e.touching = !1, e.touchTimer = null;
            }, 700);
          }(t);
        });
      }), c.each(p.mouse, function (i) {
        M(t, i, function (r) {
          r = u(r), t.touching || n[i].call(e, r);
        });
      }));
    }

    function k(e, t) {
      function n(n) {
        M(t, n, function (i) {
          i = u(i), _(e, i.target) || (i = function (e, t) {
            return l(e.dom, new b(e, t), !0);
          }(e, i), t.domHandlers[n].call(e, i));
        }, {
          capture: !0
        });
      }

      d.pointerEventsSupported ? c.each(v, n) : d.touchEventsSupported || c.each(g, n);
    }

    function M(e, t, n, i) {
      e.mounted[t] = n, e.listenerOpts[t] = i, a(e.domTarget, m(t), n, i);
    }

    function E(e) {
      var t = e.mounted;

      for (var n in t) {
        t.hasOwnProperty(n) && s(e.domTarget, m(n), t[n], e.listenerOpts[n]);
      }

      e.mounted = {};
    }

    function A(e, t) {
      if (e._mayPointerCapture = null, f && e._pointerCapturing ^ t) {
        e._pointerCapturing = t;
        var n = e._globalHandlerScope;
        t ? k(e, n) : E(n);
      }
    }

    function I(e, t) {
      this.domTarget = e, this.domHandlers = t, this.mounted = {}, this.listenerOpts = {}, this.touchTimer = null, this.touching = !1;
    }

    function P(e, t) {
      h.call(this), this.dom = e, this.painterRoot = t, this._localHandlerScope = new I(e, S), f && (this._globalHandlerScope = new I(document, T)), this._pointerCapturing = !1, this._mayPointerCapture = null, C(this, this._localHandlerScope);
    }

    var O = P.prototype;
    O.dispose = function () {
      E(this._localHandlerScope), f && E(this._globalHandlerScope);
    }, O.setCursor = function (e) {
      this.dom.style && (this.dom.style.cursor = e || "default");
    }, c.mixin(P, h);
    var L = P;
    e.exports = L;
  }, function (e, t, n) {
    var i = n(101)([["lineWidth", "width"], ["stroke", "color"], ["opacity"], ["shadowBlur"], ["shadowOffsetX"], ["shadowOffsetY"], ["shadowColor"]]),
        r = {
      getLineStyle: function getLineStyle(e) {
        var t = i(this, e);
        return t.lineDash = this.getLineDash(t.lineWidth), t;
      },
      getLineDash: function getLineDash(e) {
        null == e && (e = 1);
        var t = this.get("type"),
            n = Math.max(e, 2),
            i = 4 * e;
        return "solid" !== t && null != t && ("dashed" === t ? [i, i] : [n, n]);
      }
    };
    e.exports = r;
  }, function (e, t, n) {
    var i = n(101)([["fill", "color"], ["shadowBlur"], ["shadowOffsetX"], ["shadowOffsetY"], ["opacity"], ["shadowColor"]]),
        r = {
      getAreaStyle: function getAreaStyle(e, t) {
        return i(this, e, t);
      }
    };
    e.exports = r;
  }, function (e, t, n) {
    var i = n(35),
        r = n(5),
        o = ["textStyle", "color"],
        a = {
      getTextColor: function getTextColor(e) {
        var t = this.ecModel;
        return this.getShallow("color") || (!e && t ? t.get(o) : null);
      },
      getFont: function getFont() {
        return r.getFont({
          fontStyle: this.getShallow("fontStyle"),
          fontWeight: this.getShallow("fontWeight"),
          fontSize: this.getShallow("fontSize"),
          fontFamily: this.getShallow("fontFamily")
        }, this.ecModel);
      },
      getTextRect: function getTextRect(e) {
        return i.getBoundingRect(e, this.getFont(), this.getShallow("align"), this.getShallow("verticalAlign") || this.getShallow("baseline"), this.getShallow("padding"), this.getShallow("lineHeight"), this.getShallow("rich"), this.getShallow("truncateText"));
      }
    };
    e.exports = a;
  }, function (e, t, n) {
    var i = n(102),
        r = n(296),
        o = n(661),
        a = n(297),
        s = n(662),
        l = n(298).normalizeRadian,
        u = n(66),
        c = n(299),
        h = i.CMD,
        d = 2 * Math.PI;
    var f = [-1, -1, -1],
        p = [-1, -1];

    function g(e, t, n, i, r, o, a, s, l, c) {
      if (c > t && c > i && c > o && c > s || c < t && c < i && c < o && c < s) return 0;
      var h,
          d = u.cubicRootAt(t, i, o, s, c, f);
      if (0 === d) return 0;

      for (var g, v, m = 0, y = -1, x = 0; x < d; x++) {
        var _ = f[x],
            b = 0 === _ || 1 === _ ? .5 : 1;
        u.cubicAt(e, n, r, a, _) < l || (y < 0 && (y = u.cubicExtrema(t, i, o, s, p), p[1] < p[0] && y > 1 && (h = void 0, h = p[0], p[0] = p[1], p[1] = h), g = u.cubicAt(t, i, o, s, p[0]), y > 1 && (v = u.cubicAt(t, i, o, s, p[1]))), 2 === y ? _ < p[0] ? m += g < t ? b : -b : _ < p[1] ? m += v < g ? b : -b : m += s < v ? b : -b : _ < p[0] ? m += g < t ? b : -b : m += s < g ? b : -b);
      }

      return m;
    }

    function v(e, t, n, i, r, o, a, s) {
      if (s > t && s > i && s > o || s < t && s < i && s < o) return 0;
      var l = u.quadraticRootAt(t, i, o, s, f);
      if (0 === l) return 0;
      var c = u.quadraticExtremum(t, i, o);

      if (c >= 0 && c <= 1) {
        for (var h = 0, d = u.quadraticAt(t, i, o, c), p = 0; p < l; p++) {
          var g = 0 === f[p] || 1 === f[p] ? .5 : 1;
          u.quadraticAt(e, n, r, f[p]) < a || (f[p] < c ? h += d < t ? g : -g : h += o < d ? g : -g);
        }

        return h;
      }

      g = 0 === f[0] || 1 === f[0] ? .5 : 1;
      return u.quadraticAt(e, n, r, f[0]) < a ? 0 : o < t ? g : -g;
    }

    function m(e, t, n, i, r, o, a, s) {
      if ((s -= t) > n || s < -n) return 0;
      var u = Math.sqrt(n * n - s * s);
      f[0] = -u, f[1] = u;
      var c = Math.abs(i - r);
      if (c < 1e-4) return 0;

      if (c % d < 1e-4) {
        i = 0, r = d;
        var h = o ? 1 : -1;
        return a >= f[0] + e && a <= f[1] + e ? h : 0;
      }

      if (o) {
        u = i;
        i = l(r), r = l(u);
      } else i = l(i), r = l(r);

      i > r && (r += d);

      for (var p = 0, g = 0; g < 2; g++) {
        var v = f[g];

        if (v + e > a) {
          var m = Math.atan2(s, v);
          h = o ? 1 : -1;
          m < 0 && (m = d + m), (m >= i && m <= r || m + d >= i && m + d <= r) && (m > Math.PI / 2 && m < 1.5 * Math.PI && (h = -h), p += h);
        }
      }

      return p;
    }

    function y(e, t, n, i, l) {
      for (var u, d, f = 0, p = 0, y = 0, x = 0, _ = 0, b = 0; b < e.length;) {
        var w = e[b++];

        switch (w === h.M && b > 1 && (n || (f += c(p, y, x, _, i, l))), 1 === b && (x = p = e[b], _ = y = e[b + 1]), w) {
          case h.M:
            p = x = e[b++], y = _ = e[b++];
            break;

          case h.L:
            if (n) {
              if (r.containStroke(p, y, e[b], e[b + 1], t, i, l)) return !0;
            } else f += c(p, y, e[b], e[b + 1], i, l) || 0;

            p = e[b++], y = e[b++];
            break;

          case h.C:
            if (n) {
              if (o.containStroke(p, y, e[b++], e[b++], e[b++], e[b++], e[b], e[b + 1], t, i, l)) return !0;
            } else f += g(p, y, e[b++], e[b++], e[b++], e[b++], e[b], e[b + 1], i, l) || 0;

            p = e[b++], y = e[b++];
            break;

          case h.Q:
            if (n) {
              if (a.containStroke(p, y, e[b++], e[b++], e[b], e[b + 1], t, i, l)) return !0;
            } else f += v(p, y, e[b++], e[b++], e[b], e[b + 1], i, l) || 0;

            p = e[b++], y = e[b++];
            break;

          case h.A:
            var S = e[b++],
                T = e[b++],
                C = e[b++],
                k = e[b++],
                M = e[b++],
                E = e[b++];
            b += 1;
            var A = 1 - e[b++],
                I = Math.cos(M) * C + S,
                P = Math.sin(M) * k + T;
            b > 1 ? f += c(p, y, I, P, i, l) : (x = I, _ = P);
            var O = (i - S) * k / C + S;

            if (n) {
              if (s.containStroke(S, T, k, M, M + E, A, t, O, l)) return !0;
            } else f += m(S, T, k, M, M + E, A, O, l);

            p = Math.cos(M + E) * C + S, y = Math.sin(M + E) * k + T;
            break;

          case h.R:
            x = p = e[b++], _ = y = e[b++];
            I = x + e[b++], P = _ + e[b++];

            if (n) {
              if (r.containStroke(x, _, I, _, t, i, l) || r.containStroke(I, _, I, P, t, i, l) || r.containStroke(I, P, x, P, t, i, l) || r.containStroke(x, P, x, _, t, i, l)) return !0;
            } else f += c(I, _, I, P, i, l), f += c(x, P, x, _, i, l);

            break;

          case h.Z:
            if (n) {
              if (r.containStroke(p, y, x, _, t, i, l)) return !0;
            } else f += c(p, y, x, _, i, l);

            p = x, y = _;
        }
      }

      return n || (u = y, d = _, Math.abs(u - d) < 1e-4) || (f += c(p, y, x, _, i, l) || 0), 0 !== f;
    }

    t.contain = function (e, t, n) {
      return y(e, 0, !1, t, n);
    }, t.containStroke = function (e, t, n, i) {
      return y(e, t, !0, n, i);
    };
  }, function (e, t, n) {
    var i = n(66);

    t.containStroke = function (e, t, n, r, o, a, s, l, u, c, h) {
      if (0 === u) return !1;
      var d = u;
      return !(h > t + d && h > r + d && h > a + d && h > l + d || h < t - d && h < r - d && h < a - d && h < l - d || c > e + d && c > n + d && c > o + d && c > s + d || c < e - d && c < n - d && c < o - d && c < s - d) && i.cubicProjectPoint(e, t, n, r, o, a, s, l, c, h, null) <= d / 2;
    };
  }, function (e, t, n) {
    var i = n(298).normalizeRadian,
        r = 2 * Math.PI;

    t.containStroke = function (e, t, n, o, a, s, l, u, c) {
      if (0 === l) return !1;
      var h = l;
      u -= e, c -= t;
      var d = Math.sqrt(u * u + c * c);
      if (d - h > n || d + h < n) return !1;
      if (Math.abs(o - a) % r < 1e-4) return !0;

      if (s) {
        var f = o;
        o = i(a), a = i(f);
      } else o = i(o), a = i(a);

      o > a && (a += r);
      var p = Math.atan2(c, u);
      return p < 0 && (p += r), p >= o && p <= a || p + r >= o && p + r <= a;
    };
  }, function (e, t, n) {
    var i = n(102),
        r = n(16).applyTransform,
        o = i.CMD,
        a = [[], [], []],
        s = Math.sqrt,
        l = Math.atan2;

    e.exports = function (e, t) {
      var n,
          i,
          u,
          c,
          h,
          d = e.data,
          f = o.M,
          p = o.C,
          g = o.L,
          v = o.R,
          m = o.A,
          y = o.Q;

      for (u = 0, c = 0; u < d.length;) {
        switch (n = d[u++], c = u, i = 0, n) {
          case f:
          case g:
            i = 1;
            break;

          case p:
            i = 3;
            break;

          case y:
            i = 2;
            break;

          case m:
            var x = t[4],
                _ = t[5],
                b = s(t[0] * t[0] + t[1] * t[1]),
                w = s(t[2] * t[2] + t[3] * t[3]),
                S = l(-t[1] / w, t[0] / b);
            d[u] *= b, d[u++] += x, d[u] *= w, d[u++] += _, d[u++] *= b, d[u++] *= w, d[u++] += S, d[u++] += S, c = u += 2;
            break;

          case v:
            T[0] = d[u++], T[1] = d[u++], r(T, T, t), d[c++] = T[0], d[c++] = T[1], T[0] += d[u++], T[1] += d[u++], r(T, T, t), d[c++] = T[0], d[c++] = T[1];
        }

        for (h = 0; h < i; h++) {
          var T;
          (T = a[h])[0] = d[u++], T[1] = d[u++], r(T, T, t), d[c++] = T[0], d[c++] = T[1];
        }
      }
    };
  }, function (e, t, n) {
    var i = n(20),
        r = n(301),
        o = i.extend({
      type: "sector",
      shape: {
        cx: 0,
        cy: 0,
        r0: 0,
        r: 0,
        startAngle: 0,
        endAngle: 2 * Math.PI,
        clockwise: !0
      },
      brush: r(i.prototype.brush),
      buildPath: function buildPath(e, t) {
        var n = t.cx,
            i = t.cy,
            r = Math.max(t.r0 || 0, 0),
            o = Math.max(t.r, 0),
            a = t.startAngle,
            s = t.endAngle,
            l = t.clockwise,
            u = Math.cos(a),
            c = Math.sin(a);
        e.moveTo(u * r + n, c * r + i), e.lineTo(u * o + n, c * o + i), e.arc(n, i, o, a, s, !l), e.lineTo(Math.cos(s) * r + n, Math.sin(s) * r + i), 0 !== r && e.arc(n, i, r, s, a, l), e.closePath();
      }
    });
    e.exports = o;
  }, function (e, t, n) {
    var i = n(20).extend({
      type: "ring",
      shape: {
        cx: 0,
        cy: 0,
        r: 0,
        r0: 0
      },
      buildPath: function buildPath(e, t) {
        var n = t.cx,
            i = t.cy,
            r = 2 * Math.PI;
        e.moveTo(n + t.r, i), e.arc(n, i, t.r, 0, r, !1), e.moveTo(n + t.r0, i), e.arc(n, i, t.r0, 0, r, !0);
      }
    });
    e.exports = i;
  }, function (e, t, n) {
    var i = n(16).distance;

    function r(e, t, n, i, r, o, a) {
      var s = .5 * (n - e),
          l = .5 * (i - t);
      return (2 * (t - n) + s + l) * a + (-3 * (t - n) - 2 * s - l) * o + s * r + t;
    }

    e.exports = function (e, t) {
      for (var n = e.length, o = [], a = 0, s = 1; s < n; s++) {
        a += i(e[s - 1], e[s]);
      }

      var l = a / 2;

      for (l = l < n ? n : l, s = 0; s < l; s++) {
        var u,
            c,
            h,
            d = s / (l - 1) * (t ? n : n - 1),
            f = Math.floor(d),
            p = d - f,
            g = e[f % n];
        t ? (u = e[(f - 1 + n) % n], c = e[(f + 1) % n], h = e[(f + 2) % n]) : (u = e[0 === f ? f : f - 1], c = e[f > n - 2 ? n - 1 : f + 1], h = e[f > n - 3 ? n - 1 : f + 2]);
        var v = p * p,
            m = p * v;
        o.push([r(u[0], g[0], c[0], h[0], p, v, m), r(u[1], g[1], c[1], h[1], p, v, m)]);
      }

      return o;
    };
  }, function (e, t, n) {
    var i = n(16),
        r = i.min,
        o = i.max,
        a = i.scale,
        s = i.distance,
        l = i.add,
        u = i.clone,
        c = i.sub;

    e.exports = function (e, t, n, i) {
      var h,
          d,
          f,
          p,
          g = [],
          v = [],
          m = [],
          y = [];

      if (i) {
        f = [1 / 0, 1 / 0], p = [-1 / 0, -1 / 0];

        for (var x = 0, _ = e.length; x < _; x++) {
          r(f, f, e[x]), o(p, p, e[x]);
        }

        r(f, f, i[0]), o(p, p, i[1]);
      }

      for (x = 0, _ = e.length; x < _; x++) {
        var b = e[x];
        if (n) h = e[x ? x - 1 : _ - 1], d = e[(x + 1) % _];else {
          if (0 === x || x === _ - 1) {
            g.push(u(e[x]));
            continue;
          }

          h = e[x - 1], d = e[x + 1];
        }
        c(v, d, h), a(v, v, t);
        var w = s(b, h),
            S = s(b, d),
            T = w + S;
        0 !== T && (w /= T, S /= T), a(m, v, -w), a(y, v, S);
        var C = l([], b, m),
            k = l([], b, y);
        i && (o(C, C, f), r(C, C, p), o(k, k, f), r(k, k, p)), g.push(C), g.push(k);
      }

      return n && g.push(g.shift()), g;
    };
  }, function (e, t, n) {
    var i = n(20),
        r = n(16),
        o = n(66),
        a = o.quadraticSubdivide,
        s = o.cubicSubdivide,
        l = o.quadraticAt,
        u = o.cubicAt,
        c = o.quadraticDerivativeAt,
        h = o.cubicDerivativeAt,
        d = [];

    function f(e, t, n) {
      var i = e.cpx2,
          r = e.cpy2;
      return null === i || null === r ? [(n ? h : u)(e.x1, e.cpx1, e.cpx2, e.x2, t), (n ? h : u)(e.y1, e.cpy1, e.cpy2, e.y2, t)] : [(n ? c : l)(e.x1, e.cpx1, e.x2, t), (n ? c : l)(e.y1, e.cpy1, e.y2, t)];
    }

    var p = i.extend({
      type: "bezier-curve",
      shape: {
        x1: 0,
        y1: 0,
        x2: 0,
        y2: 0,
        cpx1: 0,
        cpy1: 0,
        percent: 1
      },
      style: {
        stroke: "#000",
        fill: null
      },
      buildPath: function buildPath(e, t) {
        var n = t.x1,
            i = t.y1,
            r = t.x2,
            o = t.y2,
            l = t.cpx1,
            u = t.cpy1,
            c = t.cpx2,
            h = t.cpy2,
            f = t.percent;
        0 !== f && (e.moveTo(n, i), null == c || null == h ? (f < 1 && (a(n, l, r, f, d), l = d[1], r = d[2], a(i, u, o, f, d), u = d[1], o = d[2]), e.quadraticCurveTo(l, u, r, o)) : (f < 1 && (s(n, l, c, r, f, d), l = d[1], c = d[2], r = d[3], s(i, u, h, o, f, d), u = d[1], h = d[2], o = d[3]), e.bezierCurveTo(l, u, c, h, r, o)));
      },
      pointAt: function pointAt(e) {
        return f(this.shape, e, !1);
      },
      tangentAt: function tangentAt(e) {
        var t = f(this.shape, e, !0);
        return r.normalize(t, t);
      }
    });
    e.exports = p;
  }, function (e, t, n) {
    var i = n(20).extend({
      type: "arc",
      shape: {
        cx: 0,
        cy: 0,
        r: 0,
        startAngle: 0,
        endAngle: 2 * Math.PI,
        clockwise: !0
      },
      style: {
        stroke: "#000",
        fill: null
      },
      buildPath: function buildPath(e, t) {
        var n = t.cx,
            i = t.cy,
            r = Math.max(t.r, 0),
            o = t.startAngle,
            a = t.endAngle,
            s = t.clockwise,
            l = Math.cos(o),
            u = Math.sin(o);
        e.moveTo(l * r + n, u * r + i), e.arc(n, i, r, o, a, !s);
      }
    });
    e.exports = i;
  }, function (e, t, n) {
    var i = n(20),
        r = i.extend({
      type: "compound",
      shape: {
        paths: null
      },
      _updatePathDirty: function _updatePathDirty() {
        for (var e = this.__dirtyPath, t = this.shape.paths, n = 0; n < t.length; n++) {
          e = e || t[n].__dirtyPath;
        }

        this.__dirtyPath = e, this.__dirty = this.__dirty || e;
      },
      beforeBrush: function beforeBrush() {
        this._updatePathDirty();

        for (var e = this.shape.paths || [], t = this.getGlobalScale(), n = 0; n < e.length; n++) {
          e[n].path || e[n].createPathProxy(), e[n].path.setScale(t[0], t[1], e[n].segmentIgnoreThreshold);
        }
      },
      buildPath: function buildPath(e, t) {
        for (var n = t.paths || [], i = 0; i < n.length; i++) {
          n[i].buildPath(e, n[i].shape, !0);
        }
      },
      afterBrush: function afterBrush() {
        for (var e = this.shape.paths || [], t = 0; t < e.length; t++) {
          e[t].__dirtyPath = !1;
        }
      },
      getBoundingRect: function getBoundingRect() {
        return this._updatePathDirty(), i.prototype.getBoundingRect.call(this);
      }
    });
    e.exports = r;
  }, function (e, t, n) {
    var i = n(1),
        r = n(157),
        o = function o(e, t, n, i, _o3) {
      this.x = null == e ? .5 : e, this.y = null == t ? .5 : t, this.r = null == n ? .5 : n, this.type = "radial", this.global = _o3 || !1, r.call(this, i);
    };

    o.prototype = {
      constructor: o
    }, i.inherits(o, r);
    var a = o;
    e.exports = a;
  }, function (e, t, n) {
    var i = n(101)([["fill", "color"], ["stroke", "borderColor"], ["lineWidth", "borderWidth"], ["opacity"], ["shadowBlur"], ["shadowOffsetX"], ["shadowOffsetY"], ["shadowColor"], ["textPosition"], ["textAlign"]]),
        r = {
      getItemStyle: function getItemStyle(e, t) {
        var n = i(this, e, t),
            r = this.getBorderLineDash();
        return r && (n.lineDash = r), n;
      },
      getBorderLineDash: function getBorderLineDash() {
        var e = this.get("borderType");
        return "solid" === e || null == e ? null : "dashed" === e ? [5, 5] : [1, 1];
      }
    };
    e.exports = r;
  }, function (e, t) {
    e.exports = {
      getBoxLayoutParams: function getBoxLayoutParams() {
        return {
          left: this.get("left"),
          top: this.get("top"),
          right: this.get("right"),
          bottom: this.get("bottom"),
          width: this.get("width"),
          height: this.get("height")
        };
      }
    };
  }, function (e, t) {
    var n = "";
    "undefined" != typeof navigator && (n = navigator.platform || "");
    var i = {
      color: ["#c23531", "#2f4554", "#61a0a8", "#d48265", "#91c7ae", "#749f83", "#ca8622", "#bda29a", "#6e7074", "#546570", "#c4ccd3"],
      gradientColor: ["#f6efa6", "#d88273", "#bf444c"],
      textStyle: {
        fontFamily: n.match(/^Win/) ? "Microsoft YaHei" : "sans-serif",
        fontSize: 12,
        fontStyle: "normal",
        fontWeight: "normal"
      },
      blendMode: null,
      animation: "auto",
      animationDuration: 1e3,
      animationDurationUpdate: 300,
      animationEasing: "exponentialOut",
      animationEasingUpdate: "cubicOut",
      animationThreshold: 2e3,
      progressiveThreshold: 3e3,
      progressive: 400,
      hoverLayerThreshold: 3e3,
      useUTC: !1
    };
    e.exports = i;
  }, function (e, t, n) {
    var i = n(1),
        r = n(8),
        o = n(26),
        a = i.each,
        s = i.clone,
        l = i.map,
        u = i.merge,
        c = /^(min|max)?(.+)$/;

    function h(e) {
      this._api = e, this._timelineOptions = [], this._mediaList = [], this._mediaDefault, this._currentMediaIndices = [], this._optionBackup, this._newBaseOption;
    }

    function d(e, t, n) {
      var r,
          o,
          s = [],
          l = [],
          u = e.timeline;

      if (e.baseOption && (o = e.baseOption), (u || e.options) && (o = o || {}, s = (e.options || []).slice()), e.media) {
        o = o || {};
        var c = e.media;
        a(c, function (e) {
          e && e.option && (e.query ? l.push(e) : r || (r = e));
        });
      }

      return o || (o = e), o.timeline || (o.timeline = u), a([o].concat(s).concat(i.map(l, function (e) {
        return e.option;
      })), function (e) {
        a(t, function (t) {
          t(e, n);
        });
      }), {
        baseOption: o,
        timelineOptions: s,
        mediaDefault: r,
        mediaList: l
      };
    }

    function f(e, t, n) {
      var r = {
        width: t,
        height: n,
        aspectratio: t / n
      },
          o = !0;
      return i.each(e, function (e, t) {
        var n = t.match(c);

        if (n && n[1] && n[2]) {
          var i = n[1],
              a = n[2].toLowerCase();
          (function (e, t, n) {
            return "min" === n ? e >= t : "max" === n ? e <= t : e === t;
          })(r[a], e, i) || (o = !1);
        }
      }), o;
    }

    h.prototype = {
      constructor: h,
      setOption: function setOption(e, t) {
        e && i.each(r.normalizeToArray(e.series), function (e) {
          e && e.data && i.isTypedArray(e.data) && i.setAsPrimitive(e.data);
        }), e = s(e);
        var n,
            c,
            h = this._optionBackup,
            f = d.call(this, e, t, !h);
        this._newBaseOption = f.baseOption, h ? (n = h.baseOption, c = f.baseOption, a(c = c || {}, function (e, t) {
          if (null != e) {
            var i = n[t];

            if (o.hasClass(t)) {
              e = r.normalizeToArray(e), i = r.normalizeToArray(i);
              var a = r.mappingToExists(i, e);
              n[t] = l(a, function (e) {
                return e.option && e.exist ? u(e.exist, e.option, !0) : e.exist || e.option;
              });
            } else n[t] = u(i, e, !0);
          }
        }), f.timelineOptions.length && (h.timelineOptions = f.timelineOptions), f.mediaList.length && (h.mediaList = f.mediaList), f.mediaDefault && (h.mediaDefault = f.mediaDefault)) : this._optionBackup = f;
      },
      mountOption: function mountOption(e) {
        var t = this._optionBackup;
        return this._timelineOptions = l(t.timelineOptions, s), this._mediaList = l(t.mediaList, s), this._mediaDefault = s(t.mediaDefault), this._currentMediaIndices = [], s(e ? t.baseOption : this._newBaseOption);
      },
      getTimelineOption: function getTimelineOption(e) {
        var t,
            n = this._timelineOptions;

        if (n.length) {
          var i = e.getComponent("timeline");
          i && (t = s(n[i.getCurrentIndex()], !0));
        }

        return t;
      },
      getMediaOption: function getMediaOption(e) {
        var t,
            n,
            i = this._api.getWidth(),
            r = this._api.getHeight(),
            o = this._mediaList,
            a = this._mediaDefault,
            u = [],
            c = [];

        if (!o.length && !a) return c;

        for (var h = 0, d = o.length; h < d; h++) {
          f(o[h].query, i, r) && u.push(h);
        }

        return !u.length && a && (u = [-1]), u.length && (t = u, n = this._currentMediaIndices, t.join(",") !== n.join(",")) && (c = l(u, function (e) {
          return s(-1 === e ? a.option : o[e].option);
        })), this._currentMediaIndices = u, c;
      }
    };
    var p = h;
    e.exports = p;
  }, function (e, t, n) {
    var i = n(1),
        r = i.each,
        o = i.isArray,
        a = i.isObject,
        s = n(677),
        l = n(8).normalizeToArray;

    function u(e) {
      r(c, function (t) {
        t[0] in e && !(t[1] in e) && (e[t[1]] = e[t[0]]);
      });
    }

    var c = [["x", "left"], ["y", "top"], ["x2", "right"], ["y2", "bottom"]],
        h = ["grid", "geo", "parallel", "legend", "toolbox", "title", "visualMap", "dataZoom", "timeline"];

    e.exports = function (e, t) {
      s(e, t), e.series = l(e.series), r(e.series, function (e) {
        if (a(e)) {
          var t = e.type;
          if ("line" === t) null != e.clipOverflow && (e.clip = e.clipOverflow);else if ("pie" === t || "gauge" === t) null != e.clockWise && (e.clockwise = e.clockWise);else if ("gauge" === t) {
            var n = function (e, t) {
              t = t.split(",");

              for (var n = e, i = 0; i < t.length && null != (n = n && n[t[i]]); i++) {
                ;
              }

              return n;
            }(e, "pointer.color");

            null != n && function (e, t, n, i) {
              t = t.split(",");

              for (var r, o = e, a = 0; a < t.length - 1; a++) {
                null == o[r = t[a]] && (o[r] = {}), o = o[r];
              }

              (i || null == o[t[a]]) && (o[t[a]] = n);
            }(e, "itemStyle.color", n);
          }
          u(e);
        }
      }), e.dataRange && (e.visualMap = e.dataRange), r(h, function (t) {
        var n = e[t];
        n && (o(n) || (n = [n]), r(n, function (e) {
          u(e);
        }));
      });
    };
  }, function (e, t, n) {
    var i = n(1),
        r = n(8),
        o = i.each,
        a = i.isObject,
        s = ["areaStyle", "lineStyle", "nodeStyle", "linkStyle", "chordStyle", "label", "labelLine"];

    function l(e) {
      var t = e && e.itemStyle;
      if (t) for (var n = 0, r = s.length; n < r; n++) {
        var o = s[n],
            a = t.normal,
            l = t.emphasis;
        a && a[o] && (e[o] = e[o] || {}, e[o].normal ? i.merge(e[o].normal, a[o]) : e[o].normal = a[o], a[o] = null), l && l[o] && (e[o] = e[o] || {}, e[o].emphasis ? i.merge(e[o].emphasis, l[o]) : e[o].emphasis = l[o], l[o] = null);
      }
    }

    function u(e, t, n) {
      if (e && e[t] && (e[t].normal || e[t].emphasis)) {
        var r = e[t].normal,
            o = e[t].emphasis;
        r && (n ? (e[t].normal = e[t].emphasis = null, i.defaults(e[t], r)) : e[t] = r), o && (e.emphasis = e.emphasis || {}, e.emphasis[t] = o);
      }
    }

    function c(e) {
      u(e, "itemStyle"), u(e, "lineStyle"), u(e, "areaStyle"), u(e, "label"), u(e, "labelLine"), u(e, "upperLabel"), u(e, "edgeLabel");
    }

    function h(e, t) {
      var n = a(e) && e[t],
          i = a(n) && n.textStyle;
      if (i) for (var o = 0, s = r.TEXT_STYLE_OPTIONS.length; o < s; o++) {
        t = r.TEXT_STYLE_OPTIONS[o];
        i.hasOwnProperty(t) && (n[t] = i[t]);
      }
    }

    function d(e) {
      e && (c(e), h(e, "label"), e.emphasis && h(e.emphasis, "label"));
    }

    function f(e) {
      return i.isArray(e) ? e : e ? [e] : [];
    }

    function p(e) {
      return (i.isArray(e) ? e[0] : e) || {};
    }

    e.exports = function (e, t) {
      o(f(e.series), function (e) {
        a(e) && function (e) {
          if (a(e)) {
            l(e), c(e), h(e, "label"), h(e, "upperLabel"), h(e, "edgeLabel"), e.emphasis && (h(e.emphasis, "label"), h(e.emphasis, "upperLabel"), h(e.emphasis, "edgeLabel")), (n = e.markPoint) && (l(n), d(n)), (r = e.markLine) && (l(r), d(r));
            var t = e.markArea;
            t && d(t);
            var n,
                r,
                o = e.data;

            if ("graph" === e.type) {
              o = o || e.nodes;
              var s = e.links || e.edges;
              if (s && !i.isTypedArray(s)) for (var f = 0; f < s.length; f++) {
                d(s[f]);
              }
              i.each(e.categories, function (e) {
                c(e);
              });
            }

            if (o && !i.isTypedArray(o)) for (f = 0; f < o.length; f++) {
              d(o[f]);
            }

            if ((n = e.markPoint) && n.data) {
              var p = n.data;

              for (f = 0; f < p.length; f++) {
                d(p[f]);
              }
            }

            if ((r = e.markLine) && r.data) {
              var g = r.data;

              for (f = 0; f < g.length; f++) {
                i.isArray(g[f]) ? (d(g[f][0]), d(g[f][1])) : d(g[f]);
              }
            }

            "gauge" === e.type ? (h(e, "axisLabel"), h(e, "title"), h(e, "detail")) : "treemap" === e.type ? (u(e.breadcrumb, "itemStyle"), i.each(e.levels, function (e) {
              c(e);
            })) : "tree" === e.type && c(e.leaves);
          }
        }(e);
      });
      var n = ["xAxis", "yAxis", "radiusAxis", "angleAxis", "singleAxis", "parallelAxis", "radar"];
      t && n.push("valueAxis", "categoryAxis", "logAxis", "timeAxis"), o(n, function (t) {
        o(f(e[t]), function (e) {
          e && (h(e, "axisLabel"), h(e.axisPointer, "label"));
        });
      }), o(f(e.parallel), function (e) {
        var t = e && e.parallelAxisDefault;
        h(t, "axisLabel"), h(t && t.axisPointer, "label");
      }), o(f(e.calendar), function (e) {
        u(e, "itemStyle"), h(e, "dayLabel"), h(e, "monthLabel"), h(e, "yearLabel");
      }), o(f(e.radar), function (e) {
        h(e, "name");
      }), o(f(e.geo), function (e) {
        a(e) && (d(e), o(f(e.regions), function (e) {
          d(e);
        }));
      }), o(f(e.timeline), function (e) {
        d(e), u(e, "label"), u(e, "itemStyle"), u(e, "controlStyle", !0);
        var t = e.data;
        i.isArray(t) && i.each(t, function (e) {
          i.isObject(e) && (u(e, "label"), u(e, "itemStyle"));
        });
      }), o(f(e.toolbox), function (e) {
        u(e, "iconStyle"), o(e.feature, function (e) {
          u(e, "iconStyle");
        });
      }), h(p(e.axisPointer), "label"), h(p(e.tooltip).axisPointer, "label");
    };
  }, function (e, t, n) {
    var i = n(1),
        r = i.createHashMap,
        o = i.each;

    function a(e) {
      o(e, function (t, n) {
        var i = [],
            r = [NaN, NaN],
            o = [t.stackResultDimension, t.stackedOverDimension],
            a = t.data,
            s = t.isStackedByIndex,
            l = a.map(o, function (o, l, u) {
          var c,
              h,
              d = a.get(t.stackedDimension, u);
          if (isNaN(d)) return r;
          s ? h = a.getRawIndex(u) : c = a.get(t.stackedByDimension, u);

          for (var f = NaN, p = n - 1; p >= 0; p--) {
            var g = e[p];

            if (s || (h = g.data.rawIndexOf(g.stackedByDimension, c)), h >= 0) {
              var v = g.data.getByRawIndex(g.stackResultDimension, h);

              if (d >= 0 && v > 0 || d <= 0 && v < 0) {
                d += v, f = v;
                break;
              }
            }
          }

          return i[0] = d, i[1] = f, i;
        });
        a.hostModel.setData(l), t.data = l;
      });
    }

    e.exports = function (e) {
      var t = r();
      e.eachSeries(function (e) {
        var n = e.get("stack");

        if (n) {
          var i = t.get(n) || t.set(n, []),
              r = e.getData(),
              o = {
            stackResultDimension: r.getCalculationInfo("stackResultDimension"),
            stackedOverDimension: r.getCalculationInfo("stackedOverDimension"),
            stackedDimension: r.getCalculationInfo("stackedDimension"),
            stackedByDimension: r.getCalculationInfo("stackedByDimension"),
            isStackedByIndex: r.getCalculationInfo("isStackedByIndex"),
            data: r,
            seriesModel: e
          };
          if (!o.stackedDimension || !o.isStackedByIndex && !o.stackedByDimension) return;
          i.length && r.setCalculationInfo("stackedOnSeries", i[i.length - 1].seriesModel), i.push(o);
        }
      }), t.each(a);
    };
  }, function (e, t, n) {
    var i = n(157),
        r = n(1).isFunction,
        o = {
      createOnAllSeries: !0,
      performRawSeries: !0,
      reset: function reset(e, t) {
        var n = e.getData(),
            o = (e.visualColorAccessPath || "itemStyle.color").split("."),
            a = e.get(o),
            s = !r(a) || a instanceof i ? null : a;
        a && !s || (a = e.getColorFromPalette(e.name, null, t.getSeriesCount())), n.setVisual("color", a);
        var l = (e.visualBorderColorAccessPath || "itemStyle.borderColor").split("."),
            u = e.get(l);

        if (n.setVisual("borderColor", u), !t.isSeriesFiltered(e)) {
          s && n.each(function (t) {
            n.setItemVisual(t, "color", s(e.getDataParams(t)));
          });
          return {
            dataEach: n.hasItemOption ? function (e, t) {
              var n = e.getItemModel(t),
                  i = n.get(o, !0),
                  r = n.get(l, !0);
              null != i && e.setItemVisual(t, "color", i), null != r && e.setItemVisual(t, "borderColor", r);
            } : null
          };
        }
      }
    };
    e.exports = o;
  }, function (e, t, n) {
    var i = n(1),
        r = n(68),
        o = n(86).retrieveRawValue;

    e.exports = function (e, t) {
      var n = t.getModel("aria");
      if (n.get("show")) if (n.get("description")) e.setAttribute("aria-label", n.get("description"));else {
        var a = 0;
        t.eachSeries(function (e, t) {
          ++a;
        }, this);
        var s,
            l = n.get("data.maxCount") || 10,
            u = n.get("series.maxCount") || 10,
            c = Math.min(a, u);

        if (!(a < 1)) {
          var h = function () {
            var e = t.getModel("title").option;
            e && e.length && (e = e[0]);
            return e && e.text;
          }();

          s = h ? f(p("general.withTitle"), {
            title: h
          }) : p("general.withoutTitle");
          var d = [];
          s += f(p(a > 1 ? "series.multiple.prefix" : "series.single.prefix"), {
            seriesCount: a
          }), t.eachSeries(function (e, t) {
            if (t < c) {
              var n,
                  i = e.get("name"),
                  s = "series." + (a > 1 ? "multiple" : "single") + ".";
              n = f(n = p(i ? s + "withName" : s + "withoutName"), {
                seriesId: e.seriesIndex,
                seriesName: e.get("name"),
                seriesType: (y = e.subType, r.series.typeNames[y] || "自定义图")
              });
              var u = e.getData();
              window.data = u, u.count() > l ? n += f(p("data.partialData"), {
                displayCnt: l
              }) : n += p("data.allData");

              for (var h = [], g = 0; g < u.count(); g++) {
                if (g < l) {
                  var v = u.getName(g),
                      m = o(u, g);
                  h.push(f(p(v ? "data.withName" : "data.withoutName"), {
                    name: v,
                    value: m
                  }));
                }
              }

              n += h.join(p("data.separator.middle")) + p("data.separator.end"), d.push(n);
            }

            var y;
          }), s += d.join(p("series.multiple.separator.middle")) + p("series.multiple.separator.end"), e.setAttribute("aria-label", s);
        }
      }

      function f(e, t) {
        if ("string" != typeof e) return e;
        var n = e;
        return i.each(t, function (e, t) {
          n = n.replace(new RegExp("\\{\\s*" + t + "\\s*\\}", "g"), e);
        }), n;
      }

      function p(e) {
        var t = n.get(e);

        if (null == t) {
          for (var i = e.split("."), o = r.aria, a = 0; a < i.length; ++a) {
            o = o[i[a]];
          }

          return o;
        }

        return t;
      }
    };
  }, function (e, t, n) {
    var i = n(1),
        r = n(5),
        o = n(35),
        a = Math.PI;

    e.exports = function (e, t) {
      t = t || {}, i.defaults(t, {
        text: "loading",
        textColor: "#000",
        fontSize: "12px",
        maskColor: "rgba(255, 255, 255, 0.8)",
        showSpinner: !0,
        color: "#c23531",
        spinnerRadius: 10,
        lineWidth: 5,
        zlevel: 0
      });
      var n = new r.Group(),
          s = new r.Rect({
        style: {
          fill: t.maskColor
        },
        zlevel: t.zlevel,
        z: 1e4
      });
      n.add(s);
      var l = t.fontSize + " sans-serif",
          u = new r.Rect({
        style: {
          fill: "none",
          text: t.text,
          font: l,
          textPosition: "right",
          textDistance: 10,
          textFill: t.textColor
        },
        zlevel: t.zlevel,
        z: 10001
      });

      if (n.add(u), t.showSpinner) {
        var c = new r.Arc({
          shape: {
            startAngle: -a / 2,
            endAngle: -a / 2 + .1,
            r: t.spinnerRadius
          },
          style: {
            stroke: t.color,
            lineCap: "round",
            lineWidth: t.lineWidth
          },
          zlevel: t.zlevel,
          z: 10001
        });
        c.animateShape(!0).when(1e3, {
          endAngle: 3 * a / 2
        }).start("circularInOut"), c.animateShape(!0).when(1e3, {
          startAngle: 3 * a / 2
        }).delay(300).start("circularInOut"), n.add(c);
      }

      return n.resize = function () {
        var n = o.getWidth(t.text, l),
            i = t.showSpinner ? t.spinnerRadius : 0,
            r = (e.getWidth() - 2 * i - (t.showSpinner && n ? 10 : 0) - n) / 2 - (t.showSpinner ? 0 : n / 2),
            a = e.getHeight() / 2;
        t.showSpinner && c.setShape({
          cx: r,
          cy: a
        }), u.setShape({
          x: r - i,
          y: a - i,
          width: 2 * i,
          height: 2 * i
        }), s.setShape({
          x: 0,
          y: 0,
          width: e.getWidth(),
          height: e.getHeight()
        });
      }, n.resize(), n;
    };
  }, function (e, t, n) {
    var i = n(1),
        r = i.each,
        o = i.map,
        a = i.isFunction,
        s = i.createHashMap,
        l = i.noop,
        u = n(211).createTask,
        c = n(121).getUID,
        h = n(294),
        d = n(307),
        f = n(8).normalizeToArray;

    function p(e, t, n, i) {
      this.ecInstance = e, this.api = t, this.unfinished;
      n = this._dataProcessorHandlers = n.slice(), i = this._visualHandlers = i.slice();
      this._allHandlers = n.concat(i), this._stageTaskMap = s();
    }

    var g = p.prototype;

    function v(e, t, n, i, o) {
      var a;

      function s(e, t) {
        return e.setDirty && (!e.dirtyMap || e.dirtyMap.get(t.__pipeline.id));
      }

      o = o || {}, r(t, function (t, r) {
        if (!o.visualType || o.visualType === t.visualType) {
          var l = e._stageTaskMap.get(t.uid),
              u = l.seriesTaskMap,
              c = l.overallTask;

          if (c) {
            var h,
                d = c.agentStubMap;
            d.each(function (e) {
              s(o, e) && (e.dirty(), h = !0);
            }), h && c.dirty(), m(c, i);
            var f = e.getPerformArgs(c, o.block);
            d.each(function (e) {
              e.perform(f);
            }), a |= c.perform(f);
          } else u && u.each(function (r, l) {
            s(o, r) && r.dirty();
            var u = e.getPerformArgs(r, o.block);
            u.skip = !t.performRawSeries && n.isSeriesFiltered(r.context.model), m(r, i), a |= r.perform(u);
          });
        }
      }), e.unfinished |= a;
    }

    g.restoreData = function (e, t) {
      e.restoreData(t), this._stageTaskMap.each(function (e) {
        var t = e.overallTask;
        t && t.dirty();
      });
    }, g.getPerformArgs = function (e, t) {
      if (e.__pipeline) {
        var n = this._pipelineMap.get(e.__pipeline.id),
            i = n.context,
            r = !t && n.progressiveEnabled && (!i || i.progressiveRender) && e.__idxInPipeline > n.blockIndex ? n.step : null,
            o = i && i.modDataCount;

        return {
          step: r,
          modBy: null != o ? Math.ceil(o / r) : null,
          modDataCount: o
        };
      }
    }, g.getPipeline = function (e) {
      return this._pipelineMap.get(e);
    }, g.updateStreamModes = function (e, t) {
      var n = this._pipelineMap.get(e.uid),
          i = e.getData().count(),
          r = n.progressiveEnabled && t.incrementalPrepareRender && i >= n.threshold,
          o = e.get("large") && i >= e.get("largeThreshold"),
          a = "mod" === e.get("progressiveChunkMode") ? i : null;

      e.pipelineContext = n.context = {
        progressiveRender: r,
        modDataCount: a,
        large: o
      };
    }, g.restorePipelines = function (e) {
      var t = this,
          n = t._pipelineMap = s();
      e.eachSeries(function (e) {
        var i = e.getProgressive(),
            r = e.uid;
        n.set(r, {
          id: r,
          head: null,
          tail: null,
          threshold: e.getProgressiveThreshold(),
          progressiveEnabled: i && !(e.preventIncremental && e.preventIncremental()),
          blockIndex: -1,
          step: Math.round(i || 700),
          count: 0
        }), M(t, e, e.dataTask);
      });
    }, g.prepareStageTasks = function () {
      var e = this._stageTaskMap,
          t = this.ecInstance.getModel(),
          n = this.api;
      r(this._allHandlers, function (i) {
        var o = e.get(i.uid) || e.set(i.uid, []);
        i.reset && function (e, t, n, i, r) {
          var o = n.seriesTaskMap || (n.seriesTaskMap = s()),
              a = t.seriesType,
              l = t.getTargetSeries;
          t.createOnAllSeries ? i.eachRawSeries(c) : a ? i.eachRawSeriesByType(a, c) : l && l(i, r).each(c);

          function c(n) {
            var a = n.uid,
                s = o.get(a) || o.set(a, u({
              plan: w,
              reset: S,
              count: k
            }));
            s.context = {
              model: n,
              ecModel: i,
              api: r,
              useClearVisual: t.isVisual && !t.isLayout,
              plan: t.plan,
              reset: t.reset,
              scheduler: e
            }, M(e, n, s);
          }

          var h = e._pipelineMap;
          o.each(function (e, t) {
            h.get(t) || (e.dispose(), o.removeKey(t));
          });
        }(this, i, o, t, n), i.overallReset && function (e, t, n, i, o) {
          var a = n.overallTask = n.overallTask || u({
            reset: y
          });
          a.context = {
            ecModel: i,
            api: o,
            overallReset: t.overallReset,
            scheduler: e
          };
          var l = a.agentStubMap = a.agentStubMap || s(),
              c = t.seriesType,
              h = t.getTargetSeries,
              d = !0,
              f = t.modifyOutputEnd;
          c ? i.eachRawSeriesByType(c, p) : h ? h(i, o).each(p) : (d = !1, r(i.getSeries(), p));

          function p(t) {
            var n = t.uid,
                i = l.get(n);
            i || (i = l.set(n, u({
              reset: x,
              onDirty: b
            })), a.dirty()), i.context = {
              model: t,
              overallProgress: d,
              modifyOutputEnd: f
            }, i.agent = a, i.__block = d, M(e, t, i);
          }

          var g = e._pipelineMap;
          l.each(function (e, t) {
            g.get(t) || (e.dispose(), a.dirty(), l.removeKey(t));
          });
        }(this, i, o, t, n);
      }, this);
    }, g.prepareView = function (e, t, n, i) {
      var r = e.renderTask,
          o = r.context;
      o.model = t, o.ecModel = n, o.api = i, r.__block = !e.incrementalPrepareRender, M(this, t, r);
    }, g.performDataProcessorTasks = function (e, t) {
      v(this, this._dataProcessorHandlers, e, t, {
        block: !0
      });
    }, g.performVisualTasks = function (e, t, n) {
      v(this, this._visualHandlers, e, t, n);
    }, g.performSeriesTasks = function (e) {
      var t;
      e.eachSeries(function (e) {
        t |= e.dataTask.perform();
      }), this.unfinished |= t;
    }, g.plan = function () {
      this._pipelineMap.each(function (e) {
        var t = e.tail;

        do {
          if (t.__block) {
            e.blockIndex = t.__idxInPipeline;
            break;
          }

          t = t.getUpstream();
        } while (t);
      });
    };

    var m = g.updatePayload = function (e, t) {
      "remain" !== t && (e.context.payload = t);
    };

    function y(e) {
      e.overallReset(e.ecModel, e.api, e.payload);
    }

    function x(e, t) {
      return e.overallProgress && _;
    }

    function _() {
      this.agent.dirty(), this.getDownstream().dirty();
    }

    function b() {
      this.agent && this.agent.dirty();
    }

    function w(e) {
      return e.plan && e.plan(e.model, e.ecModel, e.api, e.payload);
    }

    function S(e) {
      e.useClearVisual && e.data.clearAllVisual();
      var t = e.resetDefines = f(e.reset(e.model, e.ecModel, e.api, e.payload));
      return t.length > 1 ? o(t, function (e, t) {
        return C(t);
      }) : T;
    }

    var T = C(0);

    function C(e) {
      return function (t, n) {
        var i = n.data,
            r = n.resetDefines[e];
        if (r && r.dataEach) for (var o = t.start; o < t.end; o++) {
          r.dataEach(i, o);
        } else r && r.progress && r.progress(t, i);
      };
    }

    function k(e) {
      return e.data.count();
    }

    function M(e, t, n) {
      var i = t.uid,
          r = e._pipelineMap.get(i);

      !r.head && (r.head = n), r.tail && r.tail.pipe(n), r.tail = n, n.__idxInPipeline = r.count++, n.__pipeline = r;
    }

    function E(e) {
      A = null;

      try {
        e(I, P);
      } catch (e) {}

      return A;
    }

    p.wrapStageHandler = function (e, t) {
      return a(e) && (e = {
        overallReset: e,
        seriesType: E(e)
      }), e.uid = c("stageHandler"), t && (e.visualType = t), e;
    };

    var A,
        I = {},
        P = {};

    function O(e, t) {
      for (var n in t.prototype) {
        e[n] = l;
      }
    }

    O(I, h), O(P, d), I.eachSeriesByType = I.eachRawSeriesByType = function (e) {
      A = e;
    }, I.eachComponent = function (e) {
      "series" === e.mainType && e.subType && (A = e.subType);
    };
    var L = p;
    e.exports = L;
  }, function (e, t) {
    var n = ["#37A2DA", "#32C5E9", "#67E0E3", "#9FE6B8", "#FFDB5C", "#ff9f7f", "#fb7293", "#E062AE", "#E690D1", "#e7bcf3", "#9d96f5", "#8378EA", "#96BFFF"],
        i = {
      color: n,
      colorLayer: [["#37A2DA", "#ffd85c", "#fd7b5f"], ["#37A2DA", "#67E0E3", "#FFDB5C", "#ff9f7f", "#E062AE", "#9d96f5"], ["#37A2DA", "#32C5E9", "#9FE6B8", "#FFDB5C", "#ff9f7f", "#fb7293", "#e7bcf3", "#8378EA", "#96BFFF"], n]
    };
    e.exports = i;
  }, function (e, t) {
    var n = ["#dd6b66", "#759aa0", "#e69d87", "#8dc1a9", "#ea7e53", "#eedd78", "#73a373", "#73b9bc", "#7289ab", "#91ca8c", "#f49f42"],
        i = {
      color: n,
      backgroundColor: "#333",
      tooltip: {
        axisPointer: {
          lineStyle: {
            color: "#eee"
          },
          crossStyle: {
            color: "#eee"
          },
          label: {
            color: "#000"
          }
        }
      },
      legend: {
        textStyle: {
          color: "#eee"
        }
      },
      textStyle: {
        color: "#eee"
      },
      title: {
        textStyle: {
          color: "#eee"
        }
      },
      toolbox: {
        iconStyle: {
          normal: {
            borderColor: "#eee"
          }
        }
      },
      dataZoom: {
        textStyle: {
          color: "#eee"
        }
      },
      visualMap: {
        textStyle: {
          color: "#eee"
        }
      },
      timeline: {
        lineStyle: {
          color: "#eee"
        },
        itemStyle: {
          normal: {
            color: n[1]
          }
        },
        label: {
          normal: {
            textStyle: {
              color: "#eee"
            }
          }
        },
        controlStyle: {
          normal: {
            color: "#eee",
            borderColor: "#eee"
          }
        }
      },
      timeAxis: {
        axisLine: {
          lineStyle: {
            color: "#eee"
          }
        },
        axisTick: {
          lineStyle: {
            color: "#eee"
          }
        },
        axisLabel: {
          textStyle: {
            color: "#eee"
          }
        },
        splitLine: {
          lineStyle: {
            type: "dashed",
            color: "#aaa"
          }
        },
        splitArea: {
          areaStyle: {
            color: "#eee"
          }
        }
      },
      logAxis: {
        axisLine: {
          lineStyle: {
            color: "#eee"
          }
        },
        axisTick: {
          lineStyle: {
            color: "#eee"
          }
        },
        axisLabel: {
          textStyle: {
            color: "#eee"
          }
        },
        splitLine: {
          lineStyle: {
            type: "dashed",
            color: "#aaa"
          }
        },
        splitArea: {
          areaStyle: {
            color: "#eee"
          }
        }
      },
      valueAxis: {
        axisLine: {
          lineStyle: {
            color: "#eee"
          }
        },
        axisTick: {
          lineStyle: {
            color: "#eee"
          }
        },
        axisLabel: {
          textStyle: {
            color: "#eee"
          }
        },
        splitLine: {
          lineStyle: {
            type: "dashed",
            color: "#aaa"
          }
        },
        splitArea: {
          areaStyle: {
            color: "#eee"
          }
        }
      },
      categoryAxis: {
        axisLine: {
          lineStyle: {
            color: "#eee"
          }
        },
        axisTick: {
          lineStyle: {
            color: "#eee"
          }
        },
        axisLabel: {
          textStyle: {
            color: "#eee"
          }
        },
        splitLine: {
          lineStyle: {
            type: "dashed",
            color: "#aaa"
          }
        },
        splitArea: {
          areaStyle: {
            color: "#eee"
          }
        }
      },
      line: {
        symbol: "circle"
      },
      graph: {
        color: n
      },
      gauge: {
        title: {
          textStyle: {
            color: "#eee"
          }
        }
      },
      candlestick: {
        itemStyle: {
          normal: {
            color: "#FD1050",
            color0: "#0CF49B",
            borderColor: "#FD1050",
            borderColor0: "#0CF49B"
          }
        }
      }
    };
    i.categoryAxis.splitLine.show = !1;
    var r = i;
    e.exports = r;
  }, function (e, t, n) {
    var i = n(20).extend({
      type: "ellipse",
      shape: {
        cx: 0,
        cy: 0,
        rx: 0,
        ry: 0
      },
      buildPath: function buildPath(e, t) {
        var n = .5522848,
            i = t.cx,
            r = t.cy,
            o = t.rx,
            a = t.ry,
            s = o * n,
            l = a * n;
        e.moveTo(i - o, r), e.bezierCurveTo(i - o, r - l, i - s, r - a, i, r - a), e.bezierCurveTo(i + s, r - a, i + o, r - l, i + o, r), e.bezierCurveTo(i + o, r + l, i + s, r + a, i, r + a), e.bezierCurveTo(i - s, r + a, i - o, r + l, i - o, r), e.closePath();
      }
    });
    e.exports = i;
  }, function (e, t, n) {
    var i = n(1),
        r = n(62),
        o = n(43),
        a = n(105),
        s = n(22),
        l = n(14);
    l.getLayoutRect;
    t.getLayoutRect = l.getLayoutRect;
    var u = n(55),
        c = u.enableDataStack,
        h = u.isDimensionStacked,
        d = u.getStackedDimension,
        f = n(312);
    t.completeDimensions = f;
    var p = n(104);
    t.createDimensions = p;
    var g = n(40);
    t.createSymbol = g.createSymbol;
    var v = {
      isDimensionStacked: h,
      enableDataStack: c,
      getStackedDimension: d
    };
    t.createList = function (e) {
      return r(e.getSource(), e);
    }, t.dataStack = v, t.createScale = function (e, t) {
      var n = t;
      s.isInstance(t) || (n = new s(t), i.mixin(n, a));
      var r = o.createScaleByModel(n);
      return r.setExtent(e[0], e[1]), o.niceScaleExtent(r, n), r;
    }, t.mixinAxisModelCommonMethods = function (e) {
      i.mixin(e, a);
    };
  }, function (e, t, n) {
    n(9).__DEV__;
    var i = n(1),
        r = i.createHashMap,
        o = (i.retrieve, i.each);

    function a(e) {
      this.coordSysName = e, this.coordSysDims = [], this.axisMap = r(), this.categoryAxisMap = r(), this.firstCategoryDimIndex = null;
    }

    var s = {
      cartesian2d: function cartesian2d(e, t, n, i) {
        var r = e.getReferringComponents("xAxis")[0],
            o = e.getReferringComponents("yAxis")[0];
        t.coordSysDims = ["x", "y"], n.set("x", r), n.set("y", o), l(r) && (i.set("x", r), t.firstCategoryDimIndex = 0), l(o) && (i.set("y", o), t.firstCategoryDimIndex, t.firstCategoryDimIndex = 1);
      },
      singleAxis: function singleAxis(e, t, n, i) {
        var r = e.getReferringComponents("singleAxis")[0];
        t.coordSysDims = ["single"], n.set("single", r), l(r) && (i.set("single", r), t.firstCategoryDimIndex = 0);
      },
      polar: function polar(e, t, n, i) {
        var r = e.getReferringComponents("polar")[0],
            o = r.findAxisModel("radiusAxis"),
            a = r.findAxisModel("angleAxis");
        t.coordSysDims = ["radius", "angle"], n.set("radius", o), n.set("angle", a), l(o) && (i.set("radius", o), t.firstCategoryDimIndex = 0), l(a) && (i.set("angle", a), null == t.firstCategoryDimIndex && (t.firstCategoryDimIndex = 1));
      },
      geo: function geo(e, t, n, i) {
        t.coordSysDims = ["lng", "lat"];
      },
      parallel: function parallel(e, t, n, i) {
        var r = e.ecModel,
            a = r.getComponent("parallel", e.get("parallelIndex")),
            s = t.coordSysDims = a.dimensions.slice();
        o(a.parallelAxisIndex, function (e, o) {
          var a = r.getComponent("parallelAxis", e),
              u = s[o];
          n.set(u, a), l(a) && null == t.firstCategoryDimIndex && (i.set(u, a), t.firstCategoryDimIndex = o);
        });
      }
    };

    function l(e) {
      return "category" === e.get("type");
    }

    t.getCoordSysInfoBySeries = function (e) {
      var t = e.get("coordinateSystem"),
          n = new a(t),
          i = s[t];
      if (i) return i(e, n, n.axisMap, n.categoryAxisMap), n;
    };
  }, function (e, t, n) {
    var i = n(1),
        r = n(159),
        o = n(313),
        a = r.prototype,
        s = r.extend({
      type: "ordinal",
      init: function init(e, t) {
        e && !i.isArray(e) || (e = new o({
          categories: e
        })), this._ordinalMeta = e, this._extent = t || [0, e.categories.length - 1];
      },
      parse: function parse(e) {
        return "string" == typeof e ? this._ordinalMeta.getOrdinal(e) : Math.round(e);
      },
      contain: function contain(e) {
        return e = this.parse(e), a.contain.call(this, e) && null != this._ordinalMeta.categories[e];
      },
      normalize: function normalize(e) {
        return a.normalize.call(this, this.parse(e));
      },
      scale: function scale(e) {
        return Math.round(a.scale.call(this, e));
      },
      getTicks: function getTicks() {
        for (var e = [], t = this._extent, n = t[0]; n <= t[1];) {
          e.push(n), n++;
        }

        return e;
      },
      getLabel: function getLabel(e) {
        if (!this.isBlank()) return this._ordinalMeta.categories[e];
      },
      count: function count() {
        return this._extent[1] - this._extent[0] + 1;
      },
      unionExtentFromData: function unionExtentFromData(e, t) {
        this.unionExtent(e.getApproximateExtent(t));
      },
      getOrdinalMeta: function getOrdinalMeta() {
        return this._ordinalMeta;
      },
      niceTicks: i.noop,
      niceExtent: i.noop
    });

    s.create = function () {
      return new s();
    };

    var l = s;
    e.exports = l;
  }, function (e, t, n) {
    var i = n(1),
        r = n(6),
        o = n(15),
        a = n(314),
        s = n(160),
        l = s.prototype,
        u = Math.ceil,
        c = Math.floor,
        h = 864e5,
        d = s.extend({
      type: "time",
      getLabel: function getLabel(e) {
        var t = this._stepLvl,
            n = new Date(e);
        return o.formatTime(t[0], n, this.getSetting("useUTC"));
      },
      niceExtent: function niceExtent(e) {
        var t = this._extent;

        if (t[0] === t[1] && (t[0] -= h, t[1] += h), t[1] === -1 / 0 && t[0] === 1 / 0) {
          var n = new Date();
          t[1] = +new Date(n.getFullYear(), n.getMonth(), n.getDate()), t[0] = t[1] - h;
        }

        this.niceTicks(e.splitNumber, e.minInterval, e.maxInterval);
        var i = this._interval;
        e.fixMin || (t[0] = r.round(c(t[0] / i) * i)), e.fixMax || (t[1] = r.round(u(t[1] / i) * i));
      },
      niceTicks: function niceTicks(e, t, n) {
        e = e || 10;
        var i = this._extent,
            o = i[1] - i[0],
            s = o / e;
        null != t && s < t && (s = t), null != n && s > n && (s = n);

        var l = f.length,
            h = function (e, t, n, i) {
          for (; n < i;) {
            var r = n + i >>> 1;
            e[r][1] < t ? n = r + 1 : i = r;
          }

          return n;
        }(f, s, 0, l),
            d = f[Math.min(h, l - 1)],
            p = d[1];

        if ("year" === d[0]) {
          var g = o / p;
          p *= r.nice(g / e, !0);
        }

        var v = this.getSetting("useUTC") ? 0 : 60 * new Date(+i[0] || +i[1]).getTimezoneOffset() * 1e3,
            m = [Math.round(u((i[0] - v) / p) * p + v), Math.round(c((i[1] - v) / p) * p + v)];
        a.fixExtent(m, i), this._stepLvl = d, this._interval = p, this._niceExtent = m;
      },
      parse: function parse(e) {
        return +r.parseDate(e);
      }
    });
    i.each(["contain", "normalize"], function (e) {
      d.prototype[e] = function (t) {
        return l[e].call(this, this.parse(t));
      };
    });
    var f = [["hh:mm:ss", 1e3], ["hh:mm:ss", 5e3], ["hh:mm:ss", 1e4], ["hh:mm:ss", 15e3], ["hh:mm:ss", 3e4], ["hh:mm\nMM-dd", 6e4], ["hh:mm\nMM-dd", 3e5], ["hh:mm\nMM-dd", 6e5], ["hh:mm\nMM-dd", 9e5], ["hh:mm\nMM-dd", 18e5], ["hh:mm\nMM-dd", 36e5], ["hh:mm\nMM-dd", 72e5], ["hh:mm\nMM-dd", 216e5], ["hh:mm\nMM-dd", 432e5], ["MM-dd\nyyyy", h], ["MM-dd\nyyyy", 2 * h], ["MM-dd\nyyyy", 3 * h], ["MM-dd\nyyyy", 4 * h], ["MM-dd\nyyyy", 5 * h], ["MM-dd\nyyyy", 6 * h], ["week", 7 * h], ["MM-dd\nyyyy", 10 * h], ["week", 14 * h], ["week", 21 * h], ["month", 31 * h], ["week", 42 * h], ["month", 62 * h], ["week", 70 * h], ["quarter", 95 * h], ["month", 31 * h * 4], ["month", 31 * h * 5], ["half-year", 380 * h / 2], ["month", 31 * h * 8], ["month", 31 * h * 10], ["year", 380 * h]];

    d.create = function (e) {
      return new d({
        useUTC: e.ecModel.get("useUTC")
      });
    };

    var p = d;
    e.exports = p;
  }, function (e, t, n) {
    var i = n(1),
        r = n(35),
        o = n(8).makeInner,
        a = n(43),
        s = a.makeLabelFormatter,
        l = a.getOptionCategoryInterval,
        u = a.shouldShowAllLabels,
        c = o();

    function h(e, t) {
      var n,
          r,
          o = d(e, "labels"),
          a = l(t),
          s = f(o, a);
      return s || (i.isFunction(a) ? n = v(e, a) : (r = "auto" === a ? function (e) {
        var t = c(e).autoInterval;
        return null != t ? t : c(e).autoInterval = e.calculateCategoryInterval();
      }(e) : a, n = g(e, r)), p(o, a, {
        labels: n,
        labelCategoryInterval: r
      }));
    }

    function d(e, t) {
      return c(e)[t] || (c(e)[t] = []);
    }

    function f(e, t) {
      for (var n = 0; n < e.length; n++) {
        if (e[n].key === t) return e[n].value;
      }
    }

    function p(e, t, n) {
      return e.push({
        key: t,
        value: n
      }), n;
    }

    function g(e, t, n) {
      var i = s(e),
          r = e.scale,
          o = r.getExtent(),
          a = e.getLabelModel(),
          l = [],
          c = Math.max((t || 0) + 1, 1),
          h = o[0],
          d = r.count();
      0 !== h && c > 1 && d / c > 2 && (h = Math.round(Math.ceil(h / c) * c));
      var f = u(e),
          p = a.get("showMinLabel") || f,
          g = a.get("showMaxLabel") || f;
      p && h !== o[0] && m(o[0]);

      for (var v = h; v <= o[1]; v += c) {
        m(v);
      }

      function m(e) {
        l.push(n ? e : {
          formattedLabel: i(e),
          rawLabel: r.getLabel(e),
          tickValue: e
        });
      }

      return g && v - c !== o[1] && m(o[1]), l;
    }

    function v(e, t, n) {
      var r = e.scale,
          o = s(e),
          a = [];
      return i.each(r.getTicks(), function (e) {
        var i = r.getLabel(e);
        t(e, i) && a.push(n ? e : {
          formattedLabel: o(e),
          rawLabel: i,
          tickValue: e
        });
      }), a;
    }

    t.createAxisLabels = function (e) {
      return "category" === e.type ? function (e) {
        var t = e.getLabelModel(),
            n = h(e, t);
        return !t.get("show") || e.scale.isBlank() ? {
          labels: [],
          labelCategoryInterval: n.labelCategoryInterval
        } : n;
      }(e) : function (e) {
        var t = e.scale.getTicks(),
            n = s(e);
        return {
          labels: i.map(t, function (t, i) {
            return {
              formattedLabel: n(t, i),
              rawLabel: e.scale.getLabel(t),
              tickValue: t
            };
          })
        };
      }(e);
    }, t.createAxisTicks = function (e, t) {
      return "category" === e.type ? function (e, t) {
        var n,
            r,
            o = d(e, "ticks"),
            a = l(t),
            s = f(o, a);
        if (s) return s;
        t.get("show") && !e.scale.isBlank() || (n = []);
        if (i.isFunction(a)) n = v(e, a, !0);else if ("auto" === a) {
          var u = h(e, e.getLabelModel());
          r = u.labelCategoryInterval, n = i.map(u.labels, function (e) {
            return e.tickValue;
          });
        } else n = g(e, r = a, !0);
        return p(o, a, {
          ticks: n,
          tickCategoryInterval: r
        });
      }(e, t) : {
        ticks: e.scale.getTicks()
      };
    }, t.calculateCategoryInterval = function (e) {
      var t = function (e) {
        var t = e.getLabelModel();
        return {
          axisRotate: e.getRotate ? e.getRotate() : e.isHorizontal && !e.isHorizontal() ? 90 : 0,
          labelRotate: t.get("rotate") || 0,
          font: t.getFont()
        };
      }(e),
          n = s(e),
          i = (t.axisRotate - t.labelRotate) / 180 * Math.PI,
          o = e.scale,
          a = o.getExtent(),
          l = o.count();

      if (a[1] - a[0] < 1) return 0;
      var u = 1;
      l > 40 && (u = Math.max(1, Math.floor(l / 40)));

      for (var h = a[0], d = e.dataToCoord(h + 1) - e.dataToCoord(h), f = Math.abs(d * Math.cos(i)), p = Math.abs(d * Math.sin(i)), g = 0, v = 0; h <= a[1]; h += u) {
        var m,
            y,
            x = r.getBoundingRect(n(h), t.font, "center", "top");
        m = 1.3 * x.width, y = 1.3 * x.height, g = Math.max(g, m, 7), v = Math.max(v, y, 7);
      }

      var _ = g / f,
          b = v / p;

      isNaN(_) && (_ = 1 / 0), isNaN(b) && (b = 1 / 0);
      var w = Math.max(0, Math.floor(Math.min(_, b))),
          S = c(e.model),
          T = e.getExtent(),
          C = S.lastAutoInterval,
          k = S.lastTickCount;
      return null != C && null != k && Math.abs(C - w) <= 1 && Math.abs(k - l) <= 1 && C > w && S.axisExtend0 === T[0] && S.axisExtend1 === T[1] ? w = C : (S.lastTickCount = l, S.lastAutoInterval = w, S.axisExtend0 = T[0], S.axisExtend1 = T[1]), w;
    };
  }, function (e, t, n) {
    var i = n(4);
    n(692), n(693);
    var r = n(88),
        o = n(127),
        a = n(695);
    n(128), i.registerVisual(r("line", "circle", "line")), i.registerLayout(o("line")), i.registerProcessor(i.PRIORITY.PROCESSOR.STATISTIC, a("line"));
  }, function (e, t, n) {
    n(9).__DEV__;
    var i = n(62),
        r = n(27).extend({
      type: "series.line",
      dependencies: ["grid", "polar"],
      getInitialData: function getInitialData(e, t) {
        return i(this.getSource(), this, {
          useEncodeDefaulter: !0
        });
      },
      defaultOption: {
        zlevel: 0,
        z: 2,
        coordinateSystem: "cartesian2d",
        legendHoverLink: !0,
        hoverAnimation: !0,
        clip: !0,
        label: {
          position: "top"
        },
        lineStyle: {
          width: 2,
          type: "solid"
        },
        step: !1,
        smooth: !1,
        smoothMonotone: null,
        symbol: "emptyCircle",
        symbolSize: 4,
        symbolRotate: null,
        showSymbol: !0,
        showAllSymbol: "auto",
        connectNulls: !1,
        sampling: "none",
        animationEasing: "linear",
        progressive: 0,
        hoverLayerThreshold: 1 / 0
      }
    });
    e.exports = r;
  }, function (e, t, n) {
    n(9).__DEV__;
    var i = n(1),
        r = n(120).fromPoints,
        o = n(125),
        a = n(162),
        s = n(694),
        l = n(5),
        u = n(8),
        c = n(320),
        h = c.Polyline,
        d = c.Polygon,
        f = n(54),
        p = n(319),
        g = p.prepareDataCoordInfo,
        v = p.getStackedOnPoint,
        m = n(126),
        y = m.createGridClipPath,
        x = m.createPolarClipPath;

    function _(e, t) {
      if (e.length === t.length) {
        for (var n = 0; n < e.length; n++) {
          var i = e[n],
              r = t[n];
          if (i[0] !== r[0] || i[1] !== r[1]) return;
        }

        return !0;
      }
    }

    function b(e, t) {
      var n = [],
          i = [],
          o = [],
          a = [];
      return r(e, n, i), r(t, o, a), Math.max(Math.abs(n[0] - o[0]), Math.abs(n[1] - o[1]), Math.abs(i[0] - a[0]), Math.abs(i[1] - a[1]));
    }

    function w(e) {
      return "number" == typeof e ? e : e ? .5 : 0;
    }

    function S(e, t, n) {
      for (var i = t.getBaseAxis(), r = "x" === i.dim || "radius" === i.dim ? 0 : 1, o = [], a = 0; a < e.length - 1; a++) {
        var s = e[a + 1],
            l = e[a];
        o.push(l);
        var u = [];

        switch (n) {
          case "end":
            u[r] = s[r], u[1 - r] = l[1 - r], o.push(u);
            break;

          case "middle":
            var c = (l[r] + s[r]) / 2,
                h = [];
            u[r] = h[r] = c, u[1 - r] = l[1 - r], h[1 - r] = s[1 - r], o.push(u), o.push(h);
            break;

          default:
            u[r] = l[r], u[1 - r] = s[1 - r], o.push(u);
        }
      }

      return e[a] && o.push(e[a]), o;
    }

    function T(e, t, n) {
      var r = e.get("showAllSymbol"),
          o = "auto" === r;

      if (!r || o) {
        var s = n.getAxesByScale("ordinal")[0];

        if (s && (!o || !function (e, t) {
          var n = e.getExtent(),
              i = Math.abs(n[1] - n[0]) / e.scale.count();
          isNaN(i) && (i = 0);

          for (var r = t.count(), o = Math.max(1, Math.round(r / 5)), s = 0; s < r; s += o) {
            if (1.5 * a.getSymbolSize(t, s)[e.isHorizontal() ? 1 : 0] > i) return !1;
          }

          return !0;
        }(s, t))) {
          var l = t.mapDimension(s.dim),
              u = {};
          return i.each(s.getViewLabels(), function (e) {
            u[e.tickValue] = 1;
          }), function (e) {
            return !u.hasOwnProperty(t.get(l, e));
          };
        }
      }
    }

    function C(e, t, n) {
      if ("cartesian2d" === e.type) {
        var i = e.getBaseAxis().isHorizontal(),
            r = y(e, t, n);

        if (!n.get("clip", !0)) {
          var o = r.shape,
              a = Math.max(o.width, o.height);
          i ? (o.y -= a, o.height += 2 * a) : (o.x -= a, o.width += 2 * a);
        }

        return r;
      }

      return x(e, t, n);
    }

    var k = f.extend({
      type: "line",
      init: function init() {
        var e = new l.Group(),
            t = new o();
        this.group.add(t.group), this._symbolDraw = t, this._lineGroup = e;
      },
      render: function render(e, t, n) {
        var r = e.coordinateSystem,
            o = this.group,
            a = e.getData(),
            s = e.getModel("lineStyle"),
            u = e.getModel("areaStyle"),
            c = a.mapArray(a.getItemLayout),
            h = "polar" === r.type,
            d = this._coordSys,
            f = this._symbolDraw,
            p = this._polyline,
            m = this._polygon,
            y = this._lineGroup,
            x = e.get("animation"),
            b = !u.isEmpty(),
            k = u.get("origin"),
            M = function (e, t, n) {
          if (!n.valueDim) return [];

          for (var i = [], r = 0, o = t.count(); r < o; r++) {
            i.push(v(n, e, t, r));
          }

          return i;
        }(r, a, g(r, a, k)),
            E = e.get("showSymbol"),
            A = E && !h && T(e, a, r),
            I = this._data;

        I && I.eachItemGraphicEl(function (e, t) {
          e.__temp && (o.remove(e), I.setItemGraphicEl(t, null));
        }), E || f.remove(), o.add(y);
        var P,
            O = !h && e.get("step");
        r && r.getArea && e.get("clip", !0) && (null != (P = r.getArea()).width ? (P.x -= .1, P.y -= .1, P.width += .2, P.height += .2) : P.r0 && (P.r0 -= .5, P.r1 += .5)), this._clipShapeForSymbol = P, p && d.type === r.type && O === this._step ? (b && !m ? m = this._newPolygon(c, M, r, x) : m && !b && (y.remove(m), m = this._polygon = null), y.setClipPath(C(r, !1, e)), E && f.updateData(a, {
          isIgnore: A,
          clipShape: P
        }), a.eachItemGraphicEl(function (e) {
          e.stopAnimation(!0);
        }), _(this._stackedOnPoints, M) && _(this._points, c) || (x ? this._updateAnimation(a, M, r, n, O, k) : (O && (c = S(c, r, O), M = S(M, r, O)), p.setShape({
          points: c
        }), m && m.setShape({
          points: c,
          stackedOnPoints: M
        })))) : (E && f.updateData(a, {
          isIgnore: A,
          clipShape: P
        }), O && (c = S(c, r, O), M = S(M, r, O)), p = this._newPolyline(c, r, x), b && (m = this._newPolygon(c, M, r, x)), y.setClipPath(C(r, !0, e)));

        var L = function (e, t) {
          var n = e.getVisual("visualMeta");

          if (n && n.length && e.count() && "cartesian2d" === t.type) {
            for (var r, o, a = n.length - 1; a >= 0; a--) {
              var s = n[a].dimension,
                  u = e.dimensions[s],
                  c = e.getDimensionInfo(u);

              if ("x" === (r = c && c.coordDim) || "y" === r) {
                o = n[a];
                break;
              }
            }

            if (o) {
              var h = t.getAxis(r),
                  d = i.map(o.stops, function (e) {
                return {
                  coord: h.toGlobalCoord(h.dataToCoord(e.value)),
                  color: e.color
                };
              }),
                  f = d.length,
                  p = o.outerColors.slice();
              f && d[0].coord > d[f - 1].coord && (d.reverse(), p.reverse());
              var g = d[0].coord - 10,
                  v = d[f - 1].coord + 10,
                  m = v - g;
              if (m < .001) return "transparent";
              i.each(d, function (e) {
                e.offset = (e.coord - g) / m;
              }), d.push({
                offset: f ? d[f - 1].offset : .5,
                color: p[1] || "transparent"
              }), d.unshift({
                offset: f ? d[0].offset : .5,
                color: p[0] || "transparent"
              });
              var y = new l.LinearGradient(0, 0, 0, 0, d, !0);
              return y[r] = g, y[r + "2"] = v, y;
            }
          }
        }(a, r) || a.getVisual("color");

        p.useStyle(i.defaults(s.getLineStyle(), {
          fill: "none",
          stroke: L,
          lineJoin: "bevel"
        }));
        var D = e.get("smooth");

        if (D = w(e.get("smooth")), p.setShape({
          smooth: D,
          smoothMonotone: e.get("smoothMonotone"),
          connectNulls: e.get("connectNulls")
        }), m) {
          var N = a.getCalculationInfo("stackedOnSeries"),
              j = 0;
          m.useStyle(i.defaults(u.getAreaStyle(), {
            fill: L,
            opacity: .7,
            lineJoin: "bevel"
          })), N && (j = w(N.get("smooth"))), m.setShape({
            smooth: D,
            stackedOnSmooth: j,
            smoothMonotone: e.get("smoothMonotone"),
            connectNulls: e.get("connectNulls")
          });
        }

        this._data = a, this._coordSys = r, this._stackedOnPoints = M, this._points = c, this._step = O, this._valueOrigin = k;
      },
      dispose: function dispose() {},
      highlight: function highlight(e, t, n, i) {
        var r = e.getData(),
            o = u.queryDataIndex(r, i);

        if (!(o instanceof Array) && null != o && o >= 0) {
          var s = r.getItemGraphicEl(o);

          if (!s) {
            var l = r.getItemLayout(o);
            if (!l) return;
            if (this._clipShapeForSymbol && !this._clipShapeForSymbol.contain(l[0], l[1])) return;
            (s = new a(r, o)).position = l, s.setZ(e.get("zlevel"), e.get("z")), s.ignore = isNaN(l[0]) || isNaN(l[1]), s.__temp = !0, r.setItemGraphicEl(o, s), s.stopSymbolAnimation(!0), this.group.add(s);
          }

          s.highlight();
        } else f.prototype.highlight.call(this, e, t, n, i);
      },
      downplay: function downplay(e, t, n, i) {
        var r = e.getData(),
            o = u.queryDataIndex(r, i);

        if (null != o && o >= 0) {
          var a = r.getItemGraphicEl(o);
          a && (a.__temp ? (r.setItemGraphicEl(o, null), this.group.remove(a)) : a.downplay());
        } else f.prototype.downplay.call(this, e, t, n, i);
      },
      _newPolyline: function _newPolyline(e) {
        var t = this._polyline;
        return t && this._lineGroup.remove(t), t = new h({
          shape: {
            points: e
          },
          silent: !0,
          z2: 10
        }), this._lineGroup.add(t), this._polyline = t, t;
      },
      _newPolygon: function _newPolygon(e, t) {
        var n = this._polygon;
        return n && this._lineGroup.remove(n), n = new d({
          shape: {
            points: e,
            stackedOnPoints: t
          },
          silent: !0
        }), this._lineGroup.add(n), this._polygon = n, n;
      },
      _updateAnimation: function _updateAnimation(e, t, n, i, r, o) {
        var a = this._polyline,
            u = this._polygon,
            c = e.hostModel,
            h = s(this._data, e, this._stackedOnPoints, t, this._coordSys, n, this._valueOrigin, o),
            d = h.current,
            f = h.stackedOnCurrent,
            p = h.next,
            g = h.stackedOnNext;
        if (r && (d = S(h.current, n, r), f = S(h.stackedOnCurrent, n, r), p = S(h.next, n, r), g = S(h.stackedOnNext, n, r)), b(d, p) > 3e3 || u && b(f, g) > 3e3) return a.setShape({
          points: p
        }), void (u && u.setShape({
          points: p,
          stackedOnPoints: g
        }));
        a.shape.__points = h.current, a.shape.points = d, l.updateProps(a, {
          shape: {
            points: p
          }
        }, c), u && (u.setShape({
          points: d,
          stackedOnPoints: f
        }), l.updateProps(u, {
          shape: {
            points: p,
            stackedOnPoints: g
          }
        }, c));

        for (var v = [], m = h.status, y = 0; y < m.length; y++) {
          if ("=" === m[y].cmd) {
            var x = e.getItemGraphicEl(m[y].idx1);
            x && v.push({
              el: x,
              ptIdx: y
            });
          }
        }

        a.animators && a.animators.length && a.animators[0].during(function () {
          for (var e = 0; e < v.length; e++) {
            v[e].el.attr("position", a.shape.__points[v[e].ptIdx]);
          }
        });
      },
      remove: function remove(e) {
        var t = this.group,
            n = this._data;
        this._lineGroup.removeAll(), this._symbolDraw.remove(!0), n && n.eachItemGraphicEl(function (e, i) {
          e.__temp && (t.remove(e), n.setItemGraphicEl(i, null));
        }), this._polyline = this._polygon = this._coordSys = this._points = this._stackedOnPoints = this._data = null;
      }
    });
    e.exports = k;
  }, function (e, t, n) {
    var i = n(319),
        r = i.prepareDataCoordInfo,
        o = i.getStackedOnPoint;

    e.exports = function (e, t, n, i, a, s, l, u) {
      for (var c = function (e, t) {
        var n = [];
        return t.diff(e).add(function (e) {
          n.push({
            cmd: "+",
            idx: e
          });
        }).update(function (e, t) {
          n.push({
            cmd: "=",
            idx: t,
            idx1: e
          });
        }).remove(function (e) {
          n.push({
            cmd: "-",
            idx: e
          });
        }).execute(), n;
      }(e, t), h = [], d = [], f = [], p = [], g = [], v = [], m = [], y = r(a, t, l), x = r(s, e, u), _ = 0; _ < c.length; _++) {
        var b = c[_],
            w = !0;

        switch (b.cmd) {
          case "=":
            var S = e.getItemLayout(b.idx),
                T = t.getItemLayout(b.idx1);
            (isNaN(S[0]) || isNaN(S[1])) && (S = T.slice()), h.push(S), d.push(T), f.push(n[b.idx]), p.push(i[b.idx1]), m.push(t.getRawIndex(b.idx1));
            break;

          case "+":
            var C = b.idx;
            h.push(a.dataToPoint([t.get(y.dataDimsForPoint[0], C), t.get(y.dataDimsForPoint[1], C)])), d.push(t.getItemLayout(C).slice()), f.push(o(y, a, t, C)), p.push(i[C]), m.push(t.getRawIndex(C));
            break;

          case "-":
            C = b.idx;
            var k = e.getRawIndex(C);
            k !== C ? (h.push(e.getItemLayout(C)), d.push(s.dataToPoint([e.get(x.dataDimsForPoint[0], C), e.get(x.dataDimsForPoint[1], C)])), f.push(n[C]), p.push(o(x, s, e, C)), m.push(k)) : w = !1;
        }

        w && (g.push(b), v.push(v.length));
      }

      v.sort(function (e, t) {
        return m[e] - m[t];
      });
      var M = [],
          E = [],
          A = [],
          I = [],
          P = [];

      for (_ = 0; _ < v.length; _++) {
        C = v[_];
        M[_] = h[C], E[_] = d[C], A[_] = f[C], I[_] = p[C], P[_] = g[C];
      }

      return {
        current: M,
        next: E,
        stackedOnCurrent: A,
        stackedOnNext: I,
        status: P
      };
    };
  }, function (e, t) {
    var n = {
      average: function average(e) {
        for (var t = 0, n = 0, i = 0; i < e.length; i++) {
          isNaN(e[i]) || (t += e[i], n++);
        }

        return 0 === n ? NaN : t / n;
      },
      sum: function sum(e) {
        for (var t = 0, n = 0; n < e.length; n++) {
          t += e[n] || 0;
        }

        return t;
      },
      max: function max(e) {
        for (var t = -1 / 0, n = 0; n < e.length; n++) {
          e[n] > t && (t = e[n]);
        }

        return isFinite(t) ? t : NaN;
      },
      min: function min(e) {
        for (var t = 1 / 0, n = 0; n < e.length; n++) {
          e[n] < t && (t = e[n]);
        }

        return isFinite(t) ? t : NaN;
      },
      nearest: function nearest(e) {
        return e[0];
      }
    },
        i = function i(e, t) {
      return Math.round(e.length / 2);
    };

    e.exports = function (e) {
      return {
        seriesType: e,
        modifyOutputEnd: !0,
        reset: function reset(e, t, r) {
          var o = e.getData(),
              a = e.get("sampling"),
              s = e.coordinateSystem;

          if ("cartesian2d" === s.type && a) {
            var l,
                u = s.getBaseAxis(),
                c = s.getOtherAxis(u),
                h = u.getExtent(),
                d = h[1] - h[0],
                f = Math.round(o.count() / d);
            if (f > 1) "string" == typeof a ? l = n[a] : "function" == typeof a && (l = a), l && e.setData(o.downSample(o.mapDimension(c.dim), 1 / f, l, i));
          }
        }
      };
    };
  }, function (e, t, n) {
    var i = n(1),
        r = n(17),
        o = n(697);

    function a(e) {
      o.call(this, e);
    }

    a.prototype = {
      constructor: a,
      type: "cartesian2d",
      dimensions: ["x", "y"],
      getBaseAxis: function getBaseAxis() {
        return this.getAxesByScale("ordinal")[0] || this.getAxesByScale("time")[0] || this.getAxis("x");
      },
      containPoint: function containPoint(e) {
        var t = this.getAxis("x"),
            n = this.getAxis("y");
        return t.contain(t.toLocalCoord(e[0])) && n.contain(n.toLocalCoord(e[1]));
      },
      containData: function containData(e) {
        return this.getAxis("x").containData(e[0]) && this.getAxis("y").containData(e[1]);
      },
      dataToPoint: function dataToPoint(e, t, n) {
        var i = this.getAxis("x"),
            r = this.getAxis("y");
        return (n = n || [])[0] = i.toGlobalCoord(i.dataToCoord(e[0])), n[1] = r.toGlobalCoord(r.dataToCoord(e[1])), n;
      },
      clampData: function clampData(e, t) {
        var n = this.getAxis("x").scale,
            i = this.getAxis("y").scale,
            r = n.getExtent(),
            o = i.getExtent(),
            a = n.parse(e[0]),
            s = i.parse(e[1]);
        return (t = t || [])[0] = Math.min(Math.max(Math.min(r[0], r[1]), a), Math.max(r[0], r[1])), t[1] = Math.min(Math.max(Math.min(o[0], o[1]), s), Math.max(o[0], o[1])), t;
      },
      pointToData: function pointToData(e, t) {
        var n = this.getAxis("x"),
            i = this.getAxis("y");
        return (t = t || [])[0] = n.coordToData(n.toLocalCoord(e[0])), t[1] = i.coordToData(i.toLocalCoord(e[1])), t;
      },
      getOtherAxis: function getOtherAxis(e) {
        return this.getAxis("x" === e.dim ? "y" : "x");
      },
      getArea: function getArea() {
        var e = this.getAxis("x").getGlobalExtent(),
            t = this.getAxis("y").getGlobalExtent(),
            n = Math.min(e[0], e[1]),
            i = Math.min(t[0], t[1]),
            o = Math.max(e[0], e[1]) - n,
            a = Math.max(t[0], t[1]) - i;
        return new r(n, i, o, a);
      }
    }, i.inherits(a, o);
    var s = a;
    e.exports = s;
  }, function (e, t, n) {
    var i = n(1);

    function r(e) {
      return this._axes[e];
    }

    var o = function o(e) {
      this._axes = {}, this._dimList = [], this.name = e || "";
    };

    o.prototype = {
      constructor: o,
      type: "cartesian",
      getAxis: function getAxis(e) {
        return this._axes[e];
      },
      getAxes: function getAxes() {
        return i.map(this._dimList, r, this);
      },
      getAxesByScale: function getAxesByScale(e) {
        return e = e.toLowerCase(), i.filter(this.getAxes(), function (t) {
          return t.scale.type === e;
        });
      },
      addAxis: function addAxis(e) {
        var t = e.dim;
        this._axes[t] = e, this._dimList.push(t);
      },
      dataToCoord: function dataToCoord(e) {
        return this._dataCoordConvert(e, "dataToCoord");
      },
      coordToData: function coordToData(e) {
        return this._dataCoordConvert(e, "coordToData");
      },
      _dataCoordConvert: function _dataCoordConvert(e, t) {
        for (var n = this._dimList, i = e instanceof Array ? [] : {}, r = 0; r < n.length; r++) {
          var o = n[r],
              a = this._axes[o];
          i[o] = a[t](e[o]);
        }

        return i;
      }
    };
    var a = o;
    e.exports = a;
  }, function (e, t, n) {
    var i = n(1),
        r = n(69),
        o = function o(e, t, n, i, _o4) {
      r.call(this, e, t, n), this.type = i || "value", this.position = _o4 || "bottom";
    };

    o.prototype = {
      constructor: o,
      index: 0,
      getAxesOnZeroOf: null,
      model: null,
      isHorizontal: function isHorizontal() {
        var e = this.position;
        return "top" === e || "bottom" === e;
      },
      getGlobalExtent: function getGlobalExtent(e) {
        var t = this.getExtent();
        return t[0] = this.toGlobalCoord(t[0]), t[1] = this.toGlobalCoord(t[1]), e && t[0] > t[1] && t.reverse(), t;
      },
      getOtherAxis: function getOtherAxis() {
        this.grid.getOtherAxis();
      },
      pointToData: function pointToData(e, t) {
        return this.coordToData(this.toLocalCoord(e["x" === this.dim ? 0 : 1]), t);
      },
      toLocalCoord: null,
      toGlobalCoord: null
    }, i.inherits(o, r);
    var a = o;
    e.exports = a;
  }, function (e, t, n) {
    n(321);
    var i = n(26).extend({
      type: "grid",
      dependencies: ["xAxis", "yAxis"],
      layoutMode: "box",
      coordinateSystem: null,
      defaultOption: {
        show: !1,
        zlevel: 0,
        z: 0,
        left: "10%",
        top: 60,
        right: "10%",
        bottom: 60,
        containLabel: !1,
        backgroundColor: "rgba(0,0,0,0)",
        borderWidth: 1,
        borderColor: "#ccc"
      }
    });
    e.exports = i;
  }, function (e, t, n) {
    n(321), n(701);
  }, function (e, t, n) {
    var i = n(1),
        r = n(5),
        o = n(70),
        a = n(89),
        s = n(323),
        l = n(324),
        u = l.rectCoordAxisBuildSplitArea,
        c = l.rectCoordAxisHandleRemove,
        h = ["axisLine", "axisTickLabel", "axisName"],
        d = ["splitArea", "splitLine", "minorSplitLine"],
        f = a.extend({
      type: "cartesianAxis",
      axisPointerClass: "CartesianAxisPointer",
      render: function render(e, t, n, a) {
        this.group.removeAll();
        var l = this._axisGroup;

        if (this._axisGroup = new r.Group(), this.group.add(this._axisGroup), e.get("show")) {
          var u = e.getCoordSysModel(),
              c = s.layout(u, e),
              p = new o(e, c);
          i.each(h, p.add, p), this._axisGroup.add(p.getGroup()), i.each(d, function (t) {
            e.get(t + ".show") && this["_" + t](e, u);
          }, this), r.groupTransition(l, this._axisGroup, e), f.superCall(this, "render", e, t, n, a);
        }
      },
      remove: function remove() {
        c(this);
      },
      _splitLine: function _splitLine(e, t) {
        var n = e.axis;

        if (!n.scale.isBlank()) {
          var o = e.getModel("splitLine"),
              a = o.getModel("lineStyle"),
              s = a.get("color");
          s = i.isArray(s) ? s : [s];

          for (var l = t.coordinateSystem.getRect(), u = n.isHorizontal(), c = 0, h = n.getTicksCoords({
            tickModel: o
          }), d = [], f = [], p = a.getLineStyle(), g = 0; g < h.length; g++) {
            var v = n.toGlobalCoord(h[g].coord);
            u ? (d[0] = v, d[1] = l.y, f[0] = v, f[1] = l.y + l.height) : (d[0] = l.x, d[1] = v, f[0] = l.x + l.width, f[1] = v);
            var m = c++ % s.length,
                y = h[g].tickValue;

            this._axisGroup.add(new r.Line({
              anid: null != y ? "line_" + h[g].tickValue : null,
              subPixelOptimize: !0,
              shape: {
                x1: d[0],
                y1: d[1],
                x2: f[0],
                y2: f[1]
              },
              style: i.defaults({
                stroke: s[m]
              }, p),
              silent: !0
            }));
          }
        }
      },
      _minorSplitLine: function _minorSplitLine(e, t) {
        var n = e.axis,
            i = e.getModel("minorSplitLine").getModel("lineStyle"),
            o = t.coordinateSystem.getRect(),
            a = n.isHorizontal(),
            s = n.getMinorTicksCoords();
        if (s.length) for (var l = [], u = [], c = i.getLineStyle(), h = 0; h < s.length; h++) {
          for (var d = 0; d < s[h].length; d++) {
            var f = n.toGlobalCoord(s[h][d].coord);
            a ? (l[0] = f, l[1] = o.y, u[0] = f, u[1] = o.y + o.height) : (l[0] = o.x, l[1] = f, u[0] = o.x + o.width, u[1] = f), this._axisGroup.add(new r.Line({
              anid: "minor_line_" + s[h][d].tickValue,
              subPixelOptimize: !0,
              shape: {
                x1: l[0],
                y1: l[1],
                x2: u[0],
                y2: u[1]
              },
              style: c,
              silent: !0
            }));
          }
        }
      },
      _splitArea: function _splitArea(e, t) {
        u(this, this._axisGroup, e, t);
      }
    });
    f.extend({
      type: "xAxis"
    }), f.extend({
      type: "yAxis"
    });
  }, function (e, t, n) {
    var i = n(4),
        r = n(1),
        o = n(161),
        a = o.layout,
        s = o.largeLayout;
    n(214), n(703), n(704), n(128), i.registerLayout(i.PRIORITY.VISUAL.LAYOUT, r.curry(a, "bar")), i.registerLayout(i.PRIORITY.VISUAL.PROGRESSIVE_LAYOUT, s), i.registerVisual({
      seriesType: "bar",
      reset: function reset(e) {
        e.getData().setVisual("legendSymbol", "roundRect");
      }
    });
  }, function (e, t, n) {
    var i = n(325).extend({
      type: "series.bar",
      dependencies: ["grid", "polar"],
      brushSelector: "rect",
      getProgressive: function getProgressive() {
        return !!this.get("large") && this.get("progressive");
      },
      getProgressiveThreshold: function getProgressiveThreshold() {
        var e = this.get("progressiveThreshold"),
            t = this.get("largeThreshold");
        return t > e && (e = t), e;
      },
      defaultOption: {
        clip: !0,
        roundCap: !1,
        showBackground: !1,
        backgroundStyle: {
          color: "rgba(180, 180, 180, 0.2)",
          borderColor: null,
          borderWidth: 0,
          borderType: "solid",
          borderRadius: 0,
          shadowBlur: 0,
          shadowColor: null,
          shadowOffsetX: 0,
          shadowOffsetY: 0,
          opacity: 1
        }
      }
    });
    e.exports = i;
  }, function (e, t, n) {
    n(9).__DEV__;
    var i = n(4),
        r = n(1),
        o = n(5),
        a = n(326).setLabel,
        s = n(22),
        l = n(705),
        u = n(20),
        c = n(84),
        h = n(67).throttle,
        d = n(126).createClipPath,
        f = n(706),
        p = ["itemStyle", "barBorderWidth"],
        g = [0, 0];
    r.extend(s.prototype, l);
    var v = i.extendChartView({
      type: "bar",
      render: function render(e, t, n) {
        this._updateDrawMode(e);

        var i = e.get("coordinateSystem");
        return "cartesian2d" !== i && "polar" !== i || (this._isLargeDraw ? this._renderLarge(e, t, n) : this._renderNormal(e, t, n)), this.group;
      },
      incrementalPrepareRender: function incrementalPrepareRender(e, t, n) {
        this._clear(), this._updateDrawMode(e);
      },
      incrementalRender: function incrementalRender(e, t, n, i) {
        this._incrementalRenderLarge(e, t);
      },
      _updateDrawMode: function _updateDrawMode(e) {
        var t = e.pipelineContext.large;
        (null == this._isLargeDraw || t ^ this._isLargeDraw) && (this._isLargeDraw = t, this._clear());
      },
      _renderNormal: function _renderNormal(e, t, n) {
        var i,
            r = this.group,
            a = e.getData(),
            s = this._data,
            l = e.coordinateSystem,
            u = l.getBaseAxis();
        "cartesian2d" === l.type ? i = u.isHorizontal() : "polar" === l.type && (i = "angle" === u.dim);

        var h = e.isAnimationEnabled() ? e : null,
            d = e.get("clip", !0),
            f = function (e, t) {
          var n = e.getArea && e.getArea();

          if ("cartesian2d" === e.type) {
            var i = e.getBaseAxis();

            if ("category" !== i.type || !i.onBand) {
              var r = t.getLayout("bandWidth");
              i.isHorizontal() ? (n.x -= r, n.width += 2 * r) : (n.y -= r, n.height += 2 * r);
            }
          }

          return n;
        }(l, a);

        r.removeClipPath();
        var p = e.get("roundCap", !0),
            g = e.get("showBackground", !0),
            v = e.getModel("backgroundStyle"),
            m = v.get("barBorderRadius") || 0,
            y = [],
            T = this._backgroundEls || [];
        a.diff(s).add(function (t) {
          var n = a.getItemModel(t),
              s = S[l.type](a, t, n);

          if (g) {
            var u = S[l.type](a, t),
                c = function (e, t, n) {
              return new ("polar" === e.type ? o.Sector : o.Rect)({
                shape: A(t, n, e),
                silent: !0,
                z2: 0
              });
            }(l, i, u);

            c.useStyle(v.getBarItemStyle()), "cartesian2d" === l.type && c.setShape("r", m), y[t] = c;
          }

          if (a.hasValue(t)) {
            if (d) if (x[l.type](f, s)) return void r.remove(b);

            var b = _[l.type](t, s, i, h, !1, p);

            a.setItemGraphicEl(t, b), r.add(b), C(b, a, t, n, s, e, i, "polar" === l.type);
          }
        }).update(function (t, n) {
          var u = a.getItemModel(t),
              c = S[l.type](a, t, u);

          if (g) {
            var b = T[n];
            b.useStyle(v.getBarItemStyle()), "cartesian2d" === l.type && b.setShape("r", m), y[t] = b;
            var w = S[l.type](a, t),
                k = A(i, w, l);
            o.updateProps(b, {
              shape: k
            }, h, t);
          }

          var M = s.getItemGraphicEl(n);

          if (a.hasValue(t)) {
            if (d) if (x[l.type](f, c)) return void r.remove(M);
            M ? o.updateProps(M, {
              shape: c
            }, h, t) : M = _[l.type](t, c, i, h, !0, p), a.setItemGraphicEl(t, M), r.add(M), C(M, a, t, u, c, e, i, "polar" === l.type);
          } else r.remove(M);
        }).remove(function (e) {
          var t = s.getItemGraphicEl(e);
          "cartesian2d" === l.type ? t && b(e, h, t) : t && w(e, h, t);
        }).execute();
        var k = this._backgroundGroup || (this._backgroundGroup = new c());
        k.removeAll();

        for (var M = 0; M < y.length; ++M) {
          k.add(y[M]);
        }

        r.add(k), this._backgroundEls = y, this._data = a;
      },
      _renderLarge: function _renderLarge(e, t, n) {
        this._clear(), M(e, this.group);
        var i = e.get("clip", !0) ? d(e.coordinateSystem, !1, e) : null;
        i ? this.group.setClipPath(i) : this.group.removeClipPath();
      },
      _incrementalRenderLarge: function _incrementalRenderLarge(e, t) {
        this._removeBackground(), M(t, this.group, !0);
      },
      dispose: r.noop,
      remove: function remove(e) {
        this._clear(e);
      },
      _clear: function _clear(e) {
        var t = this.group,
            n = this._data;
        e && e.get("animation") && n && !this._isLargeDraw ? (this._removeBackground(), this._backgroundEls = [], n.eachItemGraphicEl(function (t) {
          "sector" === t.type ? w(t.dataIndex, e, t) : b(t.dataIndex, e, t);
        })) : t.removeAll(), this._data = null;
      },
      _removeBackground: function _removeBackground() {
        this.group.remove(this._backgroundGroup), this._backgroundGroup = null;
      }
    }),
        m = Math.max,
        y = Math.min,
        x = {
      cartesian2d: function cartesian2d(e, t) {
        var n = t.width < 0 ? -1 : 1,
            i = t.height < 0 ? -1 : 1;
        n < 0 && (t.x += t.width, t.width = -t.width), i < 0 && (t.y += t.height, t.height = -t.height);
        var r = m(t.x, e.x),
            o = y(t.x + t.width, e.x + e.width),
            a = m(t.y, e.y),
            s = y(t.y + t.height, e.y + e.height);
        t.x = r, t.y = a, t.width = o - r, t.height = s - a;
        var l = t.width < 0 || t.height < 0;
        return n < 0 && (t.x += t.width, t.width = -t.width), i < 0 && (t.y += t.height, t.height = -t.height), l;
      },
      polar: function polar(e) {
        return !1;
      }
    },
        _ = {
      cartesian2d: function cartesian2d(e, t, n, i, a) {
        var s = new o.Rect({
          shape: r.extend({}, t),
          z2: 1
        });

        if (s.name = "item", i) {
          var l = n ? "height" : "width",
              u = {};
          s.shape[l] = 0, u[l] = t[l], o[a ? "updateProps" : "initProps"](s, {
            shape: u
          }, i, e);
        }

        return s;
      },
      polar: function polar(e, t, n, i, a, s) {
        var l = t.startAngle < t.endAngle,
            u = new (!n && s ? f : o.Sector)({
          shape: r.defaults({
            clockwise: l
          }, t),
          z2: 1
        });

        if (u.name = "item", i) {
          var c = n ? "r" : "endAngle",
              h = {};
          u.shape[c] = n ? 0 : t.startAngle, h[c] = t[c], o[a ? "updateProps" : "initProps"](u, {
            shape: h
          }, i, e);
        }

        return u;
      }
    };

    function b(e, t, n) {
      n.style.text = null, o.updateProps(n, {
        shape: {
          width: 0
        }
      }, t, e, function () {
        n.parent && n.parent.remove(n);
      });
    }

    function w(e, t, n) {
      n.style.text = null, o.updateProps(n, {
        shape: {
          r: n.shape.r0
        }
      }, t, e, function () {
        n.parent && n.parent.remove(n);
      });
    }

    var S = {
      cartesian2d: function cartesian2d(e, t, n) {
        var i = e.getItemLayout(t),
            r = n ? function (e, t) {
          var n = e.get(p) || 0,
              i = isNaN(t.width) ? Number.MAX_VALUE : Math.abs(t.width),
              r = isNaN(t.height) ? Number.MAX_VALUE : Math.abs(t.height);
          return Math.min(n, i, r);
        }(n, i) : 0,
            o = i.width > 0 ? 1 : -1,
            a = i.height > 0 ? 1 : -1;
        return {
          x: i.x + o * r / 2,
          y: i.y + a * r / 2,
          width: i.width - o * r,
          height: i.height - a * r
        };
      },
      polar: function polar(e, t, n) {
        var i = e.getItemLayout(t);
        return {
          cx: i.cx,
          cy: i.cy,
          r0: i.r0,
          r: i.r,
          startAngle: i.startAngle,
          endAngle: i.endAngle
        };
      }
    };

    function T(e) {
      return null != e.startAngle && null != e.endAngle && e.startAngle === e.endAngle;
    }

    function C(e, t, n, i, s, l, u, c) {
      var h = t.getItemVisual(n, "color"),
          d = t.getItemVisual(n, "opacity"),
          f = t.getVisual("borderColor"),
          p = i.getModel("itemStyle"),
          g = i.getModel("emphasis.itemStyle").getBarItemStyle();
      c || e.setShape("r", p.get("barBorderRadius") || 0), e.useStyle(r.defaults({
        stroke: T(s) ? "none" : f,
        fill: T(s) ? "none" : h,
        opacity: d
      }, p.getBarItemStyle()));
      var v = i.getShallow("cursor");
      v && e.attr("cursor", v);
      var m = u ? s.height > 0 ? "bottom" : "top" : s.width > 0 ? "left" : "right";
      c || a(e.style, g, i, h, l, n, m), T(s) && (g.fill = g.stroke = "none"), o.setHoverStyle(e, g);
    }

    var k = u.extend({
      type: "largeBar",
      shape: {
        points: []
      },
      buildPath: function buildPath(e, t) {
        for (var n = t.points, i = this.__startPoint, r = this.__baseDimIdx, o = 0; o < n.length; o += 2) {
          i[r] = n[o + r], e.moveTo(i[0], i[1]), e.lineTo(n[o], n[o + 1]);
        }
      }
    });

    function M(e, t, n) {
      var i = e.getData(),
          r = [],
          o = i.getLayout("valueAxisHorizontal") ? 1 : 0;
      r[1 - o] = i.getLayout("valueAxisStart");
      var a = i.getLayout("largeDataIndices"),
          s = i.getLayout("barWidth"),
          l = e.getModel("backgroundStyle");

      if (e.get("showBackground", !0)) {
        var u = i.getLayout("largeBackgroundPoints"),
            c = [];
        c[1 - o] = i.getLayout("backgroundStart");
        var h = new k({
          shape: {
            points: u
          },
          incremental: !!n,
          __startPoint: c,
          __baseDimIdx: o,
          __largeDataIndices: a,
          __barWidth: s,
          silent: !0,
          z2: 0
        });
        !function (e, t, n) {
          var i = t.get("borderColor") || t.get("color"),
              r = t.getItemStyle(["color", "borderColor"]);
          e.useStyle(r), e.style.fill = null, e.style.stroke = i, e.style.lineWidth = n.getLayout("barWidth");
        }(h, l, i), t.add(h);
      }

      var d = new k({
        shape: {
          points: i.getLayout("largePoints")
        },
        incremental: !!n,
        __startPoint: r,
        __baseDimIdx: o,
        __largeDataIndices: a,
        __barWidth: s
      });
      t.add(d), function (e, t, n) {
        var i = n.getVisual("borderColor") || n.getVisual("color"),
            r = t.getModel("itemStyle").getItemStyle(["color", "borderColor"]);
        e.useStyle(r), e.style.fill = null, e.style.stroke = i, e.style.lineWidth = n.getLayout("barWidth");
      }(d, e, i), d.seriesIndex = e.seriesIndex, e.get("silent") || (d.on("mousedown", E), d.on("mousemove", E));
    }

    var E = h(function (e) {
      var t = function (e, t, n) {
        var i = e.__baseDimIdx,
            r = 1 - i,
            o = e.shape.points,
            a = e.__largeDataIndices,
            s = Math.abs(e.__barWidth / 2),
            l = e.__startPoint[r];
        g[0] = t, g[1] = n;

        for (var u = g[i], c = g[1 - i], h = u - s, d = u + s, f = 0, p = o.length / 2; f < p; f++) {
          var v = 2 * f,
              m = o[v + i],
              y = o[v + r];
          if (m >= h && m <= d && (l <= y ? c >= l && c <= y : c >= y && c <= l)) return a[f];
        }

        return -1;
      }(this, e.offsetX, e.offsetY);

      this.dataIndex = t >= 0 ? t : null;
    }, 30, !1);

    function A(e, t, n) {
      var i,
          r = "polar" === n.type;
      return i = r ? n.getArea() : n.grid.getRect(), r ? {
        cx: i.cx,
        cy: i.cy,
        r0: e ? i.r0 : t.r0,
        r: e ? i.r : t.r,
        startAngle: e ? t.startAngle : 0,
        endAngle: e ? t.endAngle : 2 * Math.PI
      } : {
        x: e ? t.x : i.x,
        y: e ? i.y : t.y,
        width: e ? t.width : i.width,
        height: e ? i.height : t.height
      };
    }

    e.exports = v;
  }, function (e, t, n) {
    var i = n(101)([["fill", "color"], ["stroke", "borderColor"], ["lineWidth", "borderWidth"], ["stroke", "barBorderColor"], ["lineWidth", "barBorderWidth"], ["opacity"], ["shadowBlur"], ["shadowOffsetX"], ["shadowOffsetY"], ["shadowColor"]]),
        r = {
      getBarItemStyle: function getBarItemStyle(e) {
        var t = i(this, e);

        if (this.getBorderLineDash) {
          var n = this.getBorderLineDash();
          n && (t.lineDash = n);
        }

        return t;
      }
    };
    e.exports = r;
  }, function (e, t, n) {
    var i = (0, n(5).extendShape)({
      type: "sausage",
      shape: {
        cx: 0,
        cy: 0,
        r0: 0,
        r: 0,
        startAngle: 0,
        endAngle: 2 * Math.PI,
        clockwise: !0
      },
      buildPath: function buildPath(e, t) {
        var n = t.cx,
            i = t.cy,
            r = Math.max(t.r0 || 0, 0),
            o = Math.max(t.r, 0),
            a = .5 * (o - r),
            s = r + a,
            l = t.startAngle,
            u = t.endAngle,
            c = t.clockwise,
            h = Math.cos(l),
            d = Math.sin(l),
            f = Math.cos(u),
            p = Math.sin(u);
        (c ? u - l < 2 * Math.PI : l - u < 2 * Math.PI) && (e.moveTo(h * r + n, d * r + i), e.arc(h * s + n, d * s + i, a, -Math.PI + l, l, !c)), e.arc(n, i, o, l, u, !c), e.moveTo(f * o + n, p * o + i), e.arc(f * s + n, p * s + i, a, u - 2 * Math.PI, u - Math.PI, !c), 0 !== r && (e.arc(n, i, r, u, l, c), e.moveTo(h * r + n, p * r + i)), e.closePath();
      }
    });
    e.exports = i;
  }, function (e, t, n) {
    var i = n(4),
        r = n(1);
    n(708), n(709);
    var o = n(327),
        a = n(165),
        s = n(710),
        l = n(130);
    o("pie", [{
      type: "pieToggleSelect",
      event: "pieselectchanged",
      method: "toggleSelected"
    }, {
      type: "pieSelect",
      event: "pieselected",
      method: "select"
    }, {
      type: "pieUnSelect",
      event: "pieunselected",
      method: "unSelect"
    }]), i.registerVisual(a("pie")), i.registerLayout(r.curry(s, "pie")), i.registerProcessor(l("pie"));
  }, function (e, t, n) {
    var i = n(4),
        r = n(106),
        o = n(1),
        a = n(8),
        s = n(6).getPercentWithPrecision,
        l = n(215),
        u = n(86).retrieveRawAttr,
        c = n(61).makeSeriesEncodeForNameBased,
        h = n(129),
        d = i.extendSeriesModel({
      type: "series.pie",
      init: function init(e) {
        d.superApply(this, "init", arguments), this.legendVisualProvider = new h(o.bind(this.getData, this), o.bind(this.getRawData, this)), this.updateSelectedMap(this._createSelectableList()), this._defaultLabelLine(e);
      },
      mergeOption: function mergeOption(e) {
        d.superCall(this, "mergeOption", e), this.updateSelectedMap(this._createSelectableList());
      },
      getInitialData: function getInitialData(e, t) {
        return r(this, {
          coordDimensions: ["value"],
          encodeDefaulter: o.curry(c, this)
        });
      },
      _createSelectableList: function _createSelectableList() {
        for (var e = this.getRawData(), t = e.mapDimension("value"), n = [], i = 0, r = e.count(); i < r; i++) {
          n.push({
            name: e.getName(i),
            value: e.get(t, i),
            selected: u(e, i, "selected")
          });
        }

        return n;
      },
      getDataParams: function getDataParams(e) {
        var t = this.getData(),
            n = d.superCall(this, "getDataParams", e),
            i = [];
        return t.each(t.mapDimension("value"), function (e) {
          i.push(e);
        }), n.percent = s(i, e, t.hostModel.get("percentPrecision")), n.$vars.push("percent"), n;
      },
      _defaultLabelLine: function _defaultLabelLine(e) {
        a.defaultEmphasis(e, "labelLine", ["show"]);
        var t = e.labelLine,
            n = e.emphasis.labelLine;
        t.show = t.show && e.label.show, n.show = n.show && e.emphasis.label.show;
      },
      defaultOption: {
        zlevel: 0,
        z: 2,
        legendHoverLink: !0,
        hoverAnimation: !0,
        center: ["50%", "50%"],
        radius: [0, "75%"],
        clockwise: !0,
        startAngle: 90,
        minAngle: 0,
        minShowLabelAngle: 0,
        selectedOffset: 10,
        hoverOffset: 10,
        avoidLabelOverlap: !0,
        percentPrecision: 2,
        stillShowZeroSum: !0,
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        width: null,
        height: null,
        label: {
          rotate: !1,
          show: !0,
          position: "outer",
          alignTo: "none",
          margin: "25%",
          bleedMargin: 10,
          distanceToLabelLine: 5
        },
        labelLine: {
          show: !0,
          length: 15,
          length2: 15,
          smooth: !1,
          lineStyle: {
            width: 1,
            type: "solid"
          }
        },
        itemStyle: {
          borderWidth: 1
        },
        animationType: "expansion",
        animationTypeUpdate: "transition",
        animationEasing: "cubicOut"
      }
    });
    o.mixin(d, l);
    var f = d;
    e.exports = f;
  }, function (e, t, n) {
    var i = n(1),
        r = n(5),
        o = n(54);

    function a(e, t, n, i) {
      var r = t.getData(),
          o = this.dataIndex,
          a = r.getName(o),
          l = t.get("selectedOffset");
      i.dispatchAction({
        type: "pieToggleSelect",
        from: e,
        name: a,
        seriesId: t.id
      }), r.each(function (e) {
        s(r.getItemGraphicEl(e), r.getItemLayout(e), t.isSelected(r.getName(e)), l, n);
      });
    }

    function s(e, t, n, i, r) {
      var o = (t.startAngle + t.endAngle) / 2,
          a = n ? i : 0,
          s = [Math.cos(o) * a, Math.sin(o) * a];
      r ? e.animate().when(200, {
        position: s
      }).start("bounceOut") : e.attr("position", s);
    }

    function l(e, t) {
      r.Group.call(this);
      var n = new r.Sector({
        z2: 2
      }),
          i = new r.Polyline(),
          o = new r.Text();
      this.add(n), this.add(i), this.add(o), this.updateData(e, t, !0);
    }

    var u = l.prototype;
    u.updateData = function (e, t, n) {
      var o = this.childAt(0),
          a = this.childAt(1),
          l = this.childAt(2),
          u = e.hostModel,
          c = e.getItemModel(t),
          h = e.getItemLayout(t),
          d = i.extend({}, h);
      d.label = null;
      var f = u.getShallow("animationTypeUpdate");
      n ? (o.setShape(d), "scale" === u.getShallow("animationType") ? (o.shape.r = h.r0, r.initProps(o, {
        shape: {
          r: h.r
        }
      }, u, t)) : (o.shape.endAngle = h.startAngle, r.updateProps(o, {
        shape: {
          endAngle: h.endAngle
        }
      }, u, t))) : "expansion" === f ? o.setShape(d) : r.updateProps(o, {
        shape: d
      }, u, t);
      var p = e.getItemVisual(t, "color");
      o.useStyle(i.defaults({
        lineJoin: "bevel",
        fill: p
      }, c.getModel("itemStyle").getItemStyle())), o.hoverStyle = c.getModel("emphasis.itemStyle").getItemStyle();
      var g = c.getShallow("cursor");
      g && o.attr("cursor", g), s(this, e.getItemLayout(t), u.isSelected(e.getName(t)), u.get("selectedOffset"), u.get("animation"));
      var v = !n && "transition" === f;
      this._updateLabel(e, t, v), this.highDownOnUpdate = u.get("silent") ? null : function (e, t) {
        var n = u.isAnimationEnabled() && c.get("hoverAnimation");
        "emphasis" === t ? (a.ignore = a.hoverIgnore, l.ignore = l.hoverIgnore, n && (o.stopAnimation(!0), o.animateTo({
          shape: {
            r: h.r + u.get("hoverOffset")
          }
        }, 300, "elasticOut"))) : (a.ignore = a.normalIgnore, l.ignore = l.normalIgnore, n && (o.stopAnimation(!0), o.animateTo({
          shape: {
            r: h.r
          }
        }, 300, "elasticOut")));
      }, r.setHoverStyle(this);
    }, u._updateLabel = function (e, t, n) {
      var i = this.childAt(1),
          o = this.childAt(2),
          a = e.hostModel,
          s = e.getItemModel(t),
          l = e.getItemLayout(t).label,
          u = e.getItemVisual(t, "color");
      if (!l || isNaN(l.x) || isNaN(l.y)) o.ignore = o.normalIgnore = o.hoverIgnore = i.ignore = i.normalIgnore = i.hoverIgnore = !0;else {
        var c = {
          points: l.linePoints || [[l.x, l.y], [l.x, l.y], [l.x, l.y]]
        },
            h = {
          x: l.x,
          y: l.y
        };
        n ? (r.updateProps(i, {
          shape: c
        }, a, t), r.updateProps(o, {
          style: h
        }, a, t)) : (i.attr({
          shape: c
        }), o.attr({
          style: h
        })), o.attr({
          rotation: l.rotation,
          origin: [l.x, l.y],
          z2: 10
        });
        var d = s.getModel("label"),
            f = s.getModel("emphasis.label"),
            p = s.getModel("labelLine"),
            g = s.getModel("emphasis.labelLine");
        u = e.getItemVisual(t, "color");
        r.setLabelStyle(o.style, o.hoverStyle = {}, d, f, {
          labelFetcher: e.hostModel,
          labelDataIndex: t,
          defaultText: l.text,
          autoColor: u,
          useInsideStyle: !!l.inside
        }, {
          textAlign: l.textAlign,
          textVerticalAlign: l.verticalAlign,
          opacity: e.getItemVisual(t, "opacity")
        }), o.ignore = o.normalIgnore = !d.get("show"), o.hoverIgnore = !f.get("show"), i.ignore = i.normalIgnore = !p.get("show"), i.hoverIgnore = !g.get("show"), i.setStyle({
          stroke: u,
          opacity: e.getItemVisual(t, "opacity")
        }), i.setStyle(p.getModel("lineStyle").getLineStyle()), i.hoverStyle = g.getModel("lineStyle").getLineStyle();
        var v = p.get("smooth");
        v && !0 === v && (v = .4), i.setShape({
          smooth: v
        });
      }
    }, i.inherits(l, r.Group);
    var c = o.extend({
      type: "pie",
      init: function init() {
        var e = new r.Group();
        this._sectorGroup = e;
      },
      render: function render(e, t, n, r) {
        if (!r || r.from !== this.uid) {
          var o = e.getData(),
              s = this._data,
              u = this.group,
              c = t.get("animation"),
              h = !s,
              d = e.get("animationType"),
              f = e.get("animationTypeUpdate"),
              p = i.curry(a, this.uid, e, c, n),
              g = e.get("selectedMode");

          if (o.diff(s).add(function (e) {
            var t = new l(o, e);
            h && "scale" !== d && t.eachChild(function (e) {
              e.stopAnimation(!0);
            }), g && t.on("click", p), o.setItemGraphicEl(e, t), u.add(t);
          }).update(function (e, t) {
            var n = s.getItemGraphicEl(t);
            h || "transition" === f || n.eachChild(function (e) {
              e.stopAnimation(!0);
            }), n.updateData(o, e), n.off("click"), g && n.on("click", p), u.add(n), o.setItemGraphicEl(e, n);
          }).remove(function (e) {
            var t = s.getItemGraphicEl(e);
            u.remove(t);
          }).execute(), c && o.count() > 0 && (h ? "scale" !== d : "transition" !== f)) {
            for (var v = o.getItemLayout(0), m = 1; isNaN(v.startAngle) && m < o.count(); ++m) {
              v = o.getItemLayout(m);
            }

            var y = Math.max(n.getWidth(), n.getHeight()) / 2,
                x = i.bind(u.removeClipPath, u);
            u.setClipPath(this._createClipPath(v.cx, v.cy, y, v.startAngle, v.clockwise, x, e, h));
          } else u.removeClipPath();

          this._data = o;
        }
      },
      dispose: function dispose() {},
      _createClipPath: function _createClipPath(e, t, n, i, o, a, s, l) {
        var u = new r.Sector({
          shape: {
            cx: e,
            cy: t,
            r0: 0,
            r: n,
            startAngle: i,
            endAngle: i,
            clockwise: o
          }
        });
        return (l ? r.initProps : r.updateProps)(u, {
          shape: {
            endAngle: i + (o ? 1 : -1) * Math.PI * 2
          }
        }, s, a), u;
      },
      containPoint: function containPoint(e, t) {
        var n = t.getData().getItemLayout(0);

        if (n) {
          var i = e[0] - n.cx,
              r = e[1] - n.cy,
              o = Math.sqrt(i * i + r * r);
          return o <= n.r && o >= n.r0;
        }
      }
    });
    e.exports = c;
  }, function (e, t, n) {
    var i = n(6),
        r = i.parsePercent,
        o = i.linearMap,
        a = n(14),
        s = n(711),
        l = n(1),
        u = 2 * Math.PI,
        c = Math.PI / 180;

    e.exports = function (e, t, n, i) {
      t.eachSeriesByType(e, function (e) {
        var t = e.getData(),
            i = t.mapDimension("value"),
            h = function (e, t) {
          return a.getLayoutRect(e.getBoxLayoutParams(), {
            width: t.getWidth(),
            height: t.getHeight()
          });
        }(e, n),
            d = e.get("center"),
            f = e.get("radius");

        l.isArray(f) || (f = [0, f]), l.isArray(d) || (d = [d, d]);

        var p = r(h.width, n.getWidth()),
            g = r(h.height, n.getHeight()),
            v = Math.min(p, g),
            m = r(d[0], p) + h.x,
            y = r(d[1], g) + h.y,
            x = r(f[0], v / 2),
            _ = r(f[1], v / 2),
            b = -e.get("startAngle") * c,
            w = e.get("minAngle") * c,
            S = 0;

        t.each(i, function (e) {
          !isNaN(e) && S++;
        });
        var T = t.getSum(i),
            C = Math.PI / (T || S) * 2,
            k = e.get("clockwise"),
            M = e.get("roseType"),
            E = e.get("stillShowZeroSum"),
            A = t.getDataExtent(i);
        A[0] = 0;
        var I = u,
            P = 0,
            O = b,
            L = k ? 1 : -1;
        if (t.each(i, function (e, n) {
          var i;
          if (isNaN(e)) t.setItemLayout(n, {
            angle: NaN,
            startAngle: NaN,
            endAngle: NaN,
            clockwise: k,
            cx: m,
            cy: y,
            r0: x,
            r: M ? NaN : _,
            viewRect: h
          });else {
            (i = "area" !== M ? 0 === T && E ? C : e * C : u / S) < w ? (i = w, I -= w) : P += e;
            var r = O + L * i;
            t.setItemLayout(n, {
              angle: i,
              startAngle: O,
              endAngle: r,
              clockwise: k,
              cx: m,
              cy: y,
              r0: x,
              r: M ? o(e, A, [x, _]) : _,
              viewRect: h
            }), O = r;
          }
        }), I < u && S) if (I <= .001) {
          var D = u / S;
          t.each(i, function (e, n) {
            if (!isNaN(e)) {
              var i = t.getItemLayout(n);
              i.angle = D, i.startAngle = b + L * n * D, i.endAngle = b + L * (n + 1) * D;
            }
          });
        } else C = I / P, O = b, t.each(i, function (e, n) {
          if (!isNaN(e)) {
            var i = t.getItemLayout(n),
                r = i.angle === w ? w : e * C;
            i.startAngle = O, i.endAngle = O + L * r, O += L * r;
          }
        });
        s(e, _, h.width, h.height, h.x, h.y);
      });
    };
  }, function (e, t, n) {
    var i = n(35),
        r = n(6).parsePercent,
        o = Math.PI / 180;

    function a(e, t, n, i, r, o, a, s, l, u) {
      function c(t, n, i, r) {
        for (var o = t; o < n && !(e[o].y + i > l + a); o++) {
          if (e[o].y += i, o > t && o + 1 < n && e[o + 1].y > e[o].y + e[o].height) return void h(o, i / 2);
        }

        h(n - 1, i / 2);
      }

      function h(t, n) {
        for (var i = t; i >= 0 && !(e[i].y - n < l) && (e[i].y -= n, !(i > 0 && e[i].y > e[i - 1].y + e[i - 1].height)); i--) {
          ;
        }
      }

      function d(e, t, n, i, r, o) {
        for (var a = t ? Number.MAX_VALUE : 0, s = 0, l = e.length; s < l; s++) {
          if ("none" === e[s].labelAlignTo) {
            var u = Math.abs(e[s].y - i),
                c = e[s].len,
                h = e[s].len2,
                d = u < r + c ? Math.sqrt((r + c + h) * (r + c + h) - u * u) : Math.abs(e[s].x - n);
            t && d >= a && (d = a - 10), !t && d <= a && (d = a + 10), e[s].x = n + d * o, a = d;
          }
        }
      }

      e.sort(function (e, t) {
        return e.y - t.y;
      });

      for (var f, p = 0, g = e.length, v = [], m = [], y = 0; y < g; y++) {
        if ("outer" === e[y].position && "labelLine" === e[y].labelAlignTo) {
          var x = e[y].x - u;
          e[y].linePoints[1][0] += x, e[y].x = u;
        }

        (f = e[y].y - p) < 0 && c(y, g, -f), p = e[y].y + e[y].height;
      }

      a - p < 0 && h(g - 1, p - a);

      for (y = 0; y < g; y++) {
        e[y].y >= n ? m.push(e[y]) : v.push(e[y]);
      }

      d(v, !1, t, n, i, r), d(m, !0, t, n, i, r);
    }

    function s(e) {
      return "center" === e.position;
    }

    e.exports = function (e, t, n, l, u, c) {
      var h,
          d,
          f = e.getData(),
          p = [],
          g = !1,
          v = (e.get("minShowLabelAngle") || 0) * o;
      f.each(function (o) {
        var a = f.getItemLayout(o),
            s = f.getItemModel(o),
            l = s.getModel("label"),
            c = l.get("position") || s.get("emphasis.label.position"),
            m = l.get("distanceToLabelLine"),
            y = l.get("alignTo"),
            x = r(l.get("margin"), n),
            _ = l.get("bleedMargin"),
            b = l.getFont(),
            w = s.getModel("labelLine"),
            S = w.get("length");

        S = r(S, n);
        var T = w.get("length2");

        if (T = r(T, n), !(a.angle < v)) {
          var C,
              k,
              M,
              E,
              A = (a.startAngle + a.endAngle) / 2,
              I = Math.cos(A),
              P = Math.sin(A);
          h = a.cx, d = a.cy;
          var O,
              L = e.getFormattedLabel(o, "normal") || f.getName(o),
              D = i.getBoundingRect(L, b, E, "top"),
              N = "inside" === c || "inner" === c;
          if ("center" === c) C = a.cx, k = a.cy, E = "center";else {
            var j = (N ? (a.r + a.r0) / 2 * I : a.r * I) + h,
                R = (N ? (a.r + a.r0) / 2 * P : a.r * P) + d;

            if (C = j + 3 * I, k = R + 3 * P, !N) {
              var F = j + I * (S + t - a.r),
                  z = R + P * (S + t - a.r),
                  B = F + (I < 0 ? -1 : 1) * T;
              C = "edge" === y ? I < 0 ? u + x : u + n - x : B + (I < 0 ? -m : m), k = z, M = [[j, R], [F, z], [B, z]];
            }

            E = N ? "center" : "edge" === y ? I > 0 ? "right" : "left" : I > 0 ? "left" : "right";
          }
          var V = l.get("rotate");
          O = "number" == typeof V ? V * (Math.PI / 180) : V ? I < 0 ? -A + Math.PI : -A : 0, g = !!O, a.label = {
            x: C,
            y: k,
            position: c,
            height: D.height,
            len: S,
            len2: T,
            linePoints: M,
            textAlign: E,
            verticalAlign: "middle",
            rotation: O,
            inside: N,
            labelDistance: m,
            labelAlignTo: y,
            labelMargin: x,
            bleedMargin: _,
            textRect: D,
            text: L,
            font: b
          }, N || p.push(a.label);
        }
      }), !g && e.get("avoidLabelOverlap") && function (e, t, n, r, o, l, u, c) {
        for (var h = [], d = [], f = Number.MAX_VALUE, p = -Number.MAX_VALUE, g = 0; g < e.length; g++) {
          s(e[g]) || (e[g].x < t ? (f = Math.min(f, e[g].x), h.push(e[g])) : (p = Math.max(p, e[g].x), d.push(e[g])));
        }

        for (a(d, t, n, r, 1, 0, l, 0, c, p), a(h, t, n, r, -1, 0, l, 0, c, f), g = 0; g < e.length; g++) {
          var v = e[g];

          if (!s(v)) {
            var m = v.linePoints;

            if (m) {
              var y,
                  x = "edge" === v.labelAlignTo,
                  _ = v.textRect.width;
              (y = x ? v.x < t ? m[2][0] - v.labelDistance - u - v.labelMargin : u + o - v.labelMargin - m[2][0] - v.labelDistance : v.x < t ? v.x - u - v.bleedMargin : u + o - v.x - v.bleedMargin) < v.textRect.width && (v.text = i.truncateText(v.text, y, v.font), "edge" === v.labelAlignTo && (_ = i.getWidth(v.text, v.font)));
              var b = m[1][0] - m[2][0];
              x ? v.x < t ? m[2][0] = u + v.labelMargin + _ + v.labelDistance : m[2][0] = u + o - v.labelMargin - _ - v.labelDistance : (v.x < t ? m[2][0] = v.x + v.labelDistance : m[2][0] = v.x - v.labelDistance, m[1][0] = m[2][0] + b), m[1][1] = m[2][1] = v.y;
            }
          }
        }
      }(p, h, d, t, n, l, u, c);
    };
  }, function (e, t, n) {
    var i = n(4);
    n(713), n(714);
    var r = n(88),
        o = n(127);
    n(128), i.registerVisual(r("scatter", "circle")), i.registerLayout(o("scatter"));
  }, function (e, t, n) {
    var i = n(62),
        r = n(27).extend({
      type: "series.scatter",
      dependencies: ["grid", "polar", "geo", "singleAxis", "calendar"],
      getInitialData: function getInitialData(e, t) {
        return i(this.getSource(), this, {
          useEncodeDefaulter: !0
        });
      },
      brushSelector: "point",
      getProgressive: function getProgressive() {
        var e = this.option.progressive;
        return null == e ? this.option.large ? 5e3 : this.get("progressive") : e;
      },
      getProgressiveThreshold: function getProgressiveThreshold() {
        var e = this.option.progressiveThreshold;
        return null == e ? this.option.large ? 1e4 : this.get("progressiveThreshold") : e;
      },
      defaultOption: {
        coordinateSystem: "cartesian2d",
        zlevel: 0,
        z: 2,
        legendHoverLink: !0,
        hoverAnimation: !0,
        symbolSize: 10,
        large: !1,
        largeThreshold: 2e3,
        itemStyle: {
          opacity: .8
        },
        clip: !0
      }
    });
    e.exports = r;
  }, function (e, t, n) {
    var i = n(4),
        r = n(125),
        o = n(715),
        a = n(127);
    i.extendChartView({
      type: "scatter",
      render: function render(e, t, n) {
        var i = e.getData();
        this._updateSymbolDraw(i, e).updateData(i, {
          clipShape: this._getClipShape(e)
        }), this._finished = !0;
      },
      incrementalPrepareRender: function incrementalPrepareRender(e, t, n) {
        var i = e.getData();
        this._updateSymbolDraw(i, e).incrementalPrepareUpdate(i), this._finished = !1;
      },
      incrementalRender: function incrementalRender(e, t, n) {
        this._symbolDraw.incrementalUpdate(e, t.getData(), {
          clipShape: this._getClipShape(t)
        }), this._finished = e.end === t.getData().count();
      },
      updateTransform: function updateTransform(e, t, n) {
        var i = e.getData();
        if (this.group.dirty(), !this._finished || i.count() > 1e4 || !this._symbolDraw.isPersistent()) return {
          update: !0
        };
        var r = a().reset(e);
        r.progress && r.progress({
          start: 0,
          end: i.count()
        }, i), this._symbolDraw.updateLayout(i);
      },
      _getClipShape: function _getClipShape(e) {
        var t = e.coordinateSystem,
            n = t && t.getArea && t.getArea();
        return e.get("clip", !0) ? n : null;
      },
      _updateSymbolDraw: function _updateSymbolDraw(e, t) {
        var n = this._symbolDraw,
            i = t.pipelineContext.large;
        return n && i === this._isLargeDraw || (n && n.remove(), n = this._symbolDraw = i ? new o() : new r(), this._isLargeDraw = i, this.group.removeAll()), this.group.add(n.group), n;
      },
      remove: function remove(e, t) {
        this._symbolDraw && this._symbolDraw.remove(!0), this._symbolDraw = null;
      },
      dispose: function dispose() {}
    });
  }, function (e, t, n) {
    var i = n(5),
        r = n(40).createSymbol,
        o = n(209),
        a = i.extendShape({
      shape: {
        points: null
      },
      symbolProxy: null,
      softClipShape: null,
      buildPath: function buildPath(e, t) {
        var n = t.points,
            i = t.size,
            r = this.symbolProxy,
            o = r.shape;
        if (!((e.getContext ? e.getContext() : e) && i[0] < 4)) for (var a = 0; a < n.length;) {
          var s = n[a++],
              l = n[a++];
          isNaN(s) || isNaN(l) || this.softClipShape && !this.softClipShape.contain(s, l) || (o.x = s - i[0] / 2, o.y = l - i[1] / 2, o.width = i[0], o.height = i[1], r.buildPath(e, o, !0));
        }
      },
      afterBrush: function afterBrush(e) {
        var t = this.shape,
            n = t.points,
            i = t.size;

        if (i[0] < 4) {
          this.setTransform(e);

          for (var r = 0; r < n.length;) {
            var o = n[r++],
                a = n[r++];
            isNaN(o) || isNaN(a) || this.softClipShape && !this.softClipShape.contain(o, a) || e.fillRect(o - i[0] / 2, a - i[1] / 2, i[0], i[1]);
          }

          this.restoreTransform(e);
        }
      },
      findDataIndex: function findDataIndex(e, t) {
        for (var n = this.shape, i = n.points, r = n.size, o = Math.max(r[0], 4), a = Math.max(r[1], 4), s = i.length / 2 - 1; s >= 0; s--) {
          var l = 2 * s,
              u = i[l] - o / 2,
              c = i[l + 1] - a / 2;
          if (e >= u && t >= c && e <= u + o && t <= c + a) return s;
        }

        return -1;
      }
    });

    function s() {
      this.group = new i.Group();
    }

    var l = s.prototype;
    l.isPersistent = function () {
      return !this._incremental;
    }, l.updateData = function (e, t) {
      this.group.removeAll();
      var n = new a({
        rectHover: !0,
        cursor: "default"
      });
      n.setShape({
        points: e.getLayout("symbolPoints")
      }), this._setCommon(n, e, !1, t), this.group.add(n), this._incremental = null;
    }, l.updateLayout = function (e) {
      if (!this._incremental) {
        var t = e.getLayout("symbolPoints");
        this.group.eachChild(function (e) {
          if (null != e.startIndex) {
            var n = 2 * (e.endIndex - e.startIndex),
                i = 4 * e.startIndex * 2;
            t = new Float32Array(t.buffer, i, n);
          }

          e.setShape("points", t);
        });
      }
    }, l.incrementalPrepareUpdate = function (e) {
      this.group.removeAll(), this._clearIncremental(), e.count() > 2e6 ? (this._incremental || (this._incremental = new o({
        silent: !0
      })), this.group.add(this._incremental)) : this._incremental = null;
    }, l.incrementalUpdate = function (e, t, n) {
      var i;
      this._incremental ? (i = new a(), this._incremental.addDisplayable(i, !0)) : ((i = new a({
        rectHover: !0,
        cursor: "default",
        startIndex: e.start,
        endIndex: e.end
      })).incremental = !0, this.group.add(i)), i.setShape({
        points: t.getLayout("symbolPoints")
      }), this._setCommon(i, t, !!this._incremental, n);
    }, l._setCommon = function (e, t, n, i) {
      var o = t.hostModel;
      i = i || {};
      var a = t.getVisual("symbolSize");
      e.setShape("size", a instanceof Array ? a : [a, a]), e.softClipShape = i.clipShape || null, e.symbolProxy = r(t.getVisual("symbol"), 0, 0, 0, 0), e.setColor = e.symbolProxy.setColor;
      var s = e.shape.size[0] < 4;
      e.useStyle(o.getModel("itemStyle").getItemStyle(s ? ["color", "shadowBlur", "shadowColor"] : ["color"]));
      var l = t.getVisual("color");
      l && e.setColor(l), n || (e.seriesIndex = o.seriesIndex, e.on("mousemove", function (t) {
        e.dataIndex = null;
        var n = e.findDataIndex(t.offsetX, t.offsetY);
        n >= 0 && (e.dataIndex = n + (e.startIndex || 0));
      }));
    }, l.remove = function () {
      this._clearIncremental(), this._incremental = null, this.group.removeAll();
    }, l._clearIncremental = function () {
      var e = this._incremental;
      e && e.clearDisplaybles();
    };
    var u = s;
    e.exports = u;
  }, function (e, t, n) {
    var i = n(4);
    n(717), n(722), n(723);
    var r = n(165),
        o = n(88),
        a = n(724),
        s = n(130),
        l = n(725);
    i.registerVisual(r("radar")), i.registerVisual(o("radar", "circle")), i.registerLayout(a), i.registerProcessor(s("radar")), i.registerPreprocessor(l);
  }, function (e, t, n) {
    n(718), n(720), n(721);
  }, function (e, t, n) {
    var i = n(1),
        r = n(719),
        o = n(160),
        a = n(6),
        s = n(43),
        l = s.getScaleExtent,
        u = s.niceScaleExtent,
        c = n(42),
        h = n(315);

    function d(e, t, n) {
      this._model = e, this.dimensions = [], this._indicatorAxes = i.map(e.getIndicatorModels(), function (e, t) {
        var n = "indicator_" + t,
            i = new r(n, "log" === e.get("axisType") ? new h() : new o());
        return i.name = e.get("name"), i.model = e, e.axis = i, this.dimensions.push(n), i;
      }, this), this.resize(e, n), this.cx, this.cy, this.r, this.r0, this.startAngle;
    }

    d.prototype.getIndicatorAxes = function () {
      return this._indicatorAxes;
    }, d.prototype.dataToPoint = function (e, t) {
      var n = this._indicatorAxes[t];
      return this.coordToPoint(n.dataToCoord(e), t);
    }, d.prototype.coordToPoint = function (e, t) {
      var n = this._indicatorAxes[t].angle;
      return [this.cx + e * Math.cos(n), this.cy - e * Math.sin(n)];
    }, d.prototype.pointToData = function (e) {
      var t = e[0] - this.cx,
          n = e[1] - this.cy,
          i = Math.sqrt(t * t + n * n);
      t /= i, n /= i;

      for (var r, o = Math.atan2(-n, t), a = 1 / 0, s = -1, l = 0; l < this._indicatorAxes.length; l++) {
        var u = this._indicatorAxes[l],
            c = Math.abs(o - u.angle);
        c < a && (r = u, s = l, a = c);
      }

      return [s, +(r && r.coordToData(i))];
    }, d.prototype.resize = function (e, t) {
      var n = e.get("center"),
          r = t.getWidth(),
          o = t.getHeight(),
          s = Math.min(r, o) / 2;
      this.cx = a.parsePercent(n[0], r), this.cy = a.parsePercent(n[1], o), this.startAngle = e.get("startAngle") * Math.PI / 180;
      var l = e.get("radius");
      "string" != typeof l && "number" != typeof l || (l = [0, l]), this.r0 = a.parsePercent(l[0], s), this.r = a.parsePercent(l[1], s), i.each(this._indicatorAxes, function (e, t) {
        e.setExtent(this.r0, this.r);
        var n = this.startAngle + t * Math.PI * 2 / this._indicatorAxes.length;
        n = Math.atan2(Math.sin(n), Math.cos(n)), e.angle = n;
      }, this);
    }, d.prototype.update = function (e, t) {
      var n = this._indicatorAxes,
          r = this._model;
      i.each(n, function (e) {
        e.scale.setExtent(1 / 0, -1 / 0);
      }), e.eachSeriesByType("radar", function (t, o) {
        if ("radar" === t.get("coordinateSystem") && e.getComponent("radar", t.get("radarIndex")) === r) {
          var a = t.getData();
          i.each(n, function (e) {
            e.scale.unionExtentFromData(a, a.mapDimension(e.dim));
          });
        }
      }, this);
      var o = r.get("splitNumber");

      function s(e) {
        var t = Math.pow(10, Math.floor(Math.log(e) / Math.LN10)),
            n = e / t;
        return 2 === n ? n = 5 : n *= 2, n * t;
      }

      i.each(n, function (e, t) {
        var n = l(e.scale, e.model).extent;
        u(e.scale, e.model);
        var i = e.model,
            r = e.scale,
            c = i.getMin(),
            h = i.getMax(),
            d = r.getInterval();
        if (null != c && null != h) r.setExtent(+c, +h), r.setInterval((h - c) / o);else if (null != c) {
          do {
            f = c + d * o, r.setExtent(+c, f), r.setInterval(d), d = s(d);
          } while (f < n[1] && isFinite(f) && isFinite(n[1]));
        } else if (null != h) {
          do {
            p = h - d * o, r.setExtent(p, +h), r.setInterval(d), d = s(d);
          } while (p > n[0] && isFinite(p) && isFinite(n[0]));
        } else {
          r.getTicks().length - 1 > o && (d = s(d));
          var f = Math.ceil(n[1] / d) * d,
              p = a.round(f - d * o);
          r.setExtent(p, f), r.setInterval(d);
        }
      });
    }, d.dimensions = [], d.create = function (e, t) {
      var n = [];
      return e.eachComponent("radar", function (i) {
        var r = new d(i, e, t);
        n.push(r), i.coordinateSystem = r;
      }), e.eachSeriesByType("radar", function (e) {
        "radar" === e.get("coordinateSystem") && (e.coordinateSystem = n[e.get("radarIndex") || 0]);
      }), n;
    }, c.register("radar", d);
    var f = d;
    e.exports = f;
  }, function (e, t, n) {
    var i = n(1),
        r = n(69);

    function o(e, t, n) {
      r.call(this, e, t, n), this.type = "value", this.angle = 0, this.name = "", this.model;
    }

    i.inherits(o, r);
    var a = o;
    e.exports = a;
  }, function (e, t, n) {
    var i = n(4),
        r = n(1),
        o = n(322),
        a = n(22),
        s = n(105),
        l = o.valueAxis;

    function u(e, t) {
      return r.defaults({
        show: t
      }, e);
    }

    var c = i.extendComponentModel({
      type: "radar",
      optionUpdated: function optionUpdated() {
        var e = this.get("boundaryGap"),
            t = this.get("splitNumber"),
            n = this.get("scale"),
            i = this.get("axisLine"),
            o = this.get("axisTick"),
            l = this.get("axisType"),
            u = this.get("axisLabel"),
            c = this.get("name"),
            h = this.get("name.show"),
            d = this.get("name.formatter"),
            f = this.get("nameGap"),
            p = this.get("triggerEvent"),
            g = r.map(this.get("indicator") || [], function (g) {
          null != g.max && g.max > 0 && !g.min ? g.min = 0 : null != g.min && g.min < 0 && !g.max && (g.max = 0);
          var v = c;

          if (null != g.color && (v = r.defaults({
            color: g.color
          }, c)), g = r.merge(r.clone(g), {
            boundaryGap: e,
            splitNumber: t,
            scale: n,
            axisLine: i,
            axisTick: o,
            axisType: l,
            axisLabel: u,
            name: g.text,
            nameLocation: "end",
            nameGap: f,
            nameTextStyle: v,
            triggerEvent: p
          }, !1), h || (g.name = ""), "string" == typeof d) {
            var m = g.name;
            g.name = d.replace("{value}", null != m ? m : "");
          } else "function" == typeof d && (g.name = d(g.name, g));

          var y = r.extend(new a(g, null, this.ecModel), s);
          return y.mainType = "radar", y.componentIndex = this.componentIndex, y;
        }, this);

        this.getIndicatorModels = function () {
          return g;
        };
      },
      defaultOption: {
        zlevel: 0,
        z: 0,
        center: ["50%", "50%"],
        radius: "75%",
        startAngle: 90,
        name: {
          show: !0
        },
        boundaryGap: [0, 0],
        splitNumber: 5,
        nameGap: 15,
        scale: !1,
        shape: "polygon",
        axisLine: r.merge({
          lineStyle: {
            color: "#bbb"
          }
        }, l.axisLine),
        axisLabel: u(l.axisLabel, !1),
        axisTick: u(l.axisTick, !1),
        axisType: "interval",
        splitLine: u(l.splitLine, !0),
        splitArea: u(l.splitArea, !0),
        indicator: []
      }
    });
    e.exports = c;
  }, function (e, t, n) {
    n(9).__DEV__;
    var i = n(4),
        r = n(1),
        o = n(70),
        a = n(5),
        s = ["axisLine", "axisTickLabel", "axisName"],
        l = i.extendComponentView({
      type: "radar",
      render: function render(e, t, n) {
        this.group.removeAll(), this._buildAxes(e), this._buildSplitLineAndArea(e);
      },
      _buildAxes: function _buildAxes(e) {
        var t = e.coordinateSystem,
            n = t.getIndicatorAxes(),
            i = r.map(n, function (e) {
          return new o(e.model, {
            position: [t.cx, t.cy],
            rotation: e.angle,
            labelDirection: -1,
            tickDirection: -1,
            nameDirection: 1
          });
        });
        r.each(i, function (e) {
          r.each(s, e.add, e), this.group.add(e.getGroup());
        }, this);
      },
      _buildSplitLineAndArea: function _buildSplitLineAndArea(e) {
        var t = e.coordinateSystem,
            n = t.getIndicatorAxes();

        if (n.length) {
          var i = e.get("shape"),
              o = e.getModel("splitLine"),
              s = e.getModel("splitArea"),
              l = o.getModel("lineStyle"),
              u = s.getModel("areaStyle"),
              c = o.get("show"),
              h = s.get("show"),
              d = l.get("color"),
              f = u.get("color");
          d = r.isArray(d) ? d : [d], f = r.isArray(f) ? f : [f];
          var p = [],
              g = [];
          if ("circle" === i) for (var v = n[0].getTicksCoords(), m = t.cx, y = t.cy, x = 0; x < v.length; x++) {
            if (c) p[M(p, d, x)].push(new a.Circle({
              shape: {
                cx: m,
                cy: y,
                r: v[x].coord
              }
            }));
            if (h && x < v.length - 1) g[M(g, f, x)].push(new a.Ring({
              shape: {
                cx: m,
                cy: y,
                r0: v[x].coord,
                r: v[x + 1].coord
              }
            }));
          } else {
            var _,
                b = r.map(n, function (e, n) {
              var i = e.getTicksCoords();
              return _ = null == _ ? i.length - 1 : Math.min(i.length - 1, _), r.map(i, function (e) {
                return t.coordToPoint(e.coord, n);
              });
            }),
                w = [];

            for (x = 0; x <= _; x++) {
              for (var S = [], T = 0; T < n.length; T++) {
                S.push(b[T][x]);
              }

              if (S[0] && S.push(S[0].slice()), c) p[M(p, d, x)].push(new a.Polyline({
                shape: {
                  points: S
                }
              }));
              if (h && w) g[M(g, f, x - 1)].push(new a.Polygon({
                shape: {
                  points: S.concat(w)
                }
              }));
              w = S.slice().reverse();
            }
          }
          var C = l.getLineStyle(),
              k = u.getAreaStyle();
          r.each(g, function (e, t) {
            this.group.add(a.mergePath(e, {
              style: r.defaults({
                stroke: "none",
                fill: f[t % f.length]
              }, k),
              silent: !0
            }));
          }, this), r.each(p, function (e, t) {
            this.group.add(a.mergePath(e, {
              style: r.defaults({
                fill: "none",
                stroke: d[t % d.length]
              }, C),
              silent: !0
            }));
          }, this);
        }

        function M(e, t, n) {
          var i = n % t.length;
          return e[i] = e[i] || [], i;
        }
      }
    });
    e.exports = l;
  }, function (e, t, n) {
    var i = n(27),
        r = n(106),
        o = n(1),
        a = n(15).encodeHTML,
        s = n(129),
        l = i.extend({
      type: "series.radar",
      dependencies: ["radar"],
      init: function init(e) {
        l.superApply(this, "init", arguments), this.legendVisualProvider = new s(o.bind(this.getData, this), o.bind(this.getRawData, this));
      },
      getInitialData: function getInitialData(e, t) {
        return r(this, {
          generateCoord: "indicator_",
          generateCoordCount: 1 / 0
        });
      },
      formatTooltip: function formatTooltip(e) {
        var t = this.getData(),
            n = this.coordinateSystem.getIndicatorAxes(),
            i = this.getData().getName(e);
        return a("" === i ? this.name : i) + "<br/>" + o.map(n, function (n, i) {
          var r = t.get(t.mapDimension(n.dim), e);
          return a(n.name + " : " + r);
        }).join("<br />");
      },
      getTooltipPosition: function getTooltipPosition(e) {
        if (null != e) for (var t = this.getData(), n = this.coordinateSystem, i = t.getValues(o.map(n.dimensions, function (e) {
          return t.mapDimension(e);
        }), e, !0), r = 0, a = i.length; r < a; r++) {
          if (!isNaN(i[r])) {
            var s = n.getIndicatorAxes();
            return n.coordToPoint(s[r].dataToCoord(i[r]), r);
          }
        }
      },
      defaultOption: {
        zlevel: 0,
        z: 2,
        coordinateSystem: "radar",
        legendHoverLink: !0,
        radarIndex: 0,
        lineStyle: {
          width: 2,
          type: "solid"
        },
        label: {
          position: "top"
        },
        symbol: "emptyCircle",
        symbolSize: 4
      }
    }),
        u = l;
    e.exports = u;
  }, function (e, t, n) {
    var i = n(4),
        r = n(5),
        o = n(1),
        a = n(40);
    var s = i.extendChartView({
      type: "radar",
      render: function render(e, t, n) {
        var i = e.coordinateSystem,
            s = this.group,
            l = e.getData(),
            u = this._data;

        function c(e, t) {
          var n = e.getItemVisual(t, "symbol") || "circle",
              i = e.getItemVisual(t, "color");

          if ("none" !== n) {
            var r = function (e) {
              return o.isArray(e) || (e = [+e, +e]), e;
            }(e.getItemVisual(t, "symbolSize")),
                s = a.createSymbol(n, -1, -1, 2, 2, i);

            return s.attr({
              style: {
                strokeNoScale: !0
              },
              z2: 100,
              scale: [r[0] / 2, r[1] / 2]
            }), s;
          }
        }

        function h(t, n, i, o, a, s) {
          i.removeAll();

          for (var l = 0; l < n.length - 1; l++) {
            var u = c(o, a);
            u && (u.__dimIdx = l, t[l] ? (u.attr("position", t[l]), r[s ? "initProps" : "updateProps"](u, {
              position: n[l]
            }, e, a)) : u.attr("position", n[l]), i.add(u));
          }
        }

        function d(e) {
          return o.map(e, function (e) {
            return [i.cx, i.cy];
          });
        }

        l.diff(u).add(function (t) {
          var n = l.getItemLayout(t);

          if (n) {
            var i = new r.Polygon(),
                o = new r.Polyline(),
                a = {
              shape: {
                points: n
              }
            };
            i.shape.points = d(n), o.shape.points = d(n), r.initProps(i, a, e, t), r.initProps(o, a, e, t);
            var s = new r.Group(),
                u = new r.Group();
            s.add(o), s.add(i), s.add(u), h(o.shape.points, n, u, l, t, !0), l.setItemGraphicEl(t, s);
          }
        }).update(function (t, n) {
          var i = u.getItemGraphicEl(n),
              o = i.childAt(0),
              a = i.childAt(1),
              s = i.childAt(2),
              c = {
            shape: {
              points: l.getItemLayout(t)
            }
          };
          c.shape.points && (h(o.shape.points, c.shape.points, s, l, t, !1), r.updateProps(o, c, e), r.updateProps(a, c, e), l.setItemGraphicEl(t, i));
        }).remove(function (e) {
          s.remove(u.getItemGraphicEl(e));
        }).execute(), l.eachItemGraphicEl(function (e, t) {
          var n = l.getItemModel(t),
              i = e.childAt(0),
              a = e.childAt(1),
              u = e.childAt(2),
              c = l.getItemVisual(t, "color");
          s.add(e), i.useStyle(o.defaults(n.getModel("lineStyle").getLineStyle(), {
            fill: "none",
            stroke: c
          })), i.hoverStyle = n.getModel("emphasis.lineStyle").getLineStyle();
          var h = n.getModel("areaStyle"),
              d = n.getModel("emphasis.areaStyle"),
              f = h.isEmpty() && h.parentModel.isEmpty(),
              p = d.isEmpty() && d.parentModel.isEmpty();
          p = p && f, a.ignore = f, a.useStyle(o.defaults(h.getAreaStyle(), {
            fill: c,
            opacity: .7
          })), a.hoverStyle = d.getAreaStyle();
          var g = n.getModel("itemStyle").getItemStyle(["color"]),
              v = n.getModel("emphasis.itemStyle").getItemStyle(),
              m = n.getModel("label"),
              y = n.getModel("emphasis.label");
          u.eachChild(function (e) {
            e.setStyle(g), e.hoverStyle = o.clone(v);
            var n = l.get(l.dimensions[e.__dimIdx], t);
            (null == n || isNaN(n)) && (n = ""), r.setLabelStyle(e.style, e.hoverStyle, m, y, {
              labelFetcher: l.hostModel,
              labelDataIndex: t,
              labelDimIndex: e.__dimIdx,
              defaultText: n,
              autoColor: c,
              isRectText: !0
            });
          }), e.highDownOnUpdate = function (e, t) {
            a.attr("ignore", "emphasis" === t ? p : f);
          }, r.setHoverStyle(e);
        }), this._data = l;
      },
      remove: function remove() {
        this.group.removeAll(), this._data = null;
      },
      dispose: function dispose() {}
    });
    e.exports = s;
  }, function (e, t, n) {
    var i = n(1);

    function r(e) {
      return !isNaN(e[0]) && !isNaN(e[1]);
    }

    function o(e) {
      return [e.cx, e.cy];
    }

    e.exports = function (e) {
      e.eachSeriesByType("radar", function (e) {
        var t = e.getData(),
            n = [],
            a = e.coordinateSystem;

        if (a) {
          var s = a.getIndicatorAxes();
          i.each(s, function (e, i) {
            t.each(t.mapDimension(s[i].dim), function (e, t) {
              n[t] = n[t] || [];
              var s = a.dataToPoint(e, i);
              n[t][i] = r(s) ? s : o(a);
            });
          }), t.each(function (e) {
            var s = i.find(n[e], function (e) {
              return r(e);
            }) || o(a);
            n[e].push(s.slice()), t.setItemLayout(e, n[e]);
          });
        }
      });
    };
  }, function (e, t, n) {
    var i = n(1);

    e.exports = function (e) {
      var t = e.polar;

      if (t) {
        i.isArray(t) || (t = [t]);
        var n = [];
        i.each(t, function (t, r) {
          t.indicator ? (t.type && !t.shape && (t.shape = t.type), e.radar = e.radar || [], i.isArray(e.radar) || (e.radar = [e.radar]), e.radar.push(t)) : n.push(t);
        }), e.polar = n;
      }

      i.each(e.series, function (e) {
        e && "radar" === e.type && e.polarIndex && (e.radarIndex = e.polarIndex);
      });
    };
  }, function (e, t, n) {
    var i = n(4);
    n(727), n(734), n(330), n(218);
    var r = n(736),
        o = n(737),
        a = n(738),
        s = n(739),
        l = n(327);
    i.registerLayout(r), i.registerVisual(o), i.registerProcessor(i.PRIORITY.PROCESSOR.STATISTIC, a), i.registerPreprocessor(s), l("map", [{
      type: "mapToggleSelect",
      event: "mapselectchanged",
      method: "toggleSelected"
    }, {
      type: "mapSelect",
      event: "mapselected",
      method: "select"
    }, {
      type: "mapUnSelect",
      event: "mapunselected",
      method: "unSelect"
    }]);
  }, function (e, t, n) {
    var i = n(1),
        r = n(106),
        o = n(27),
        a = n(15),
        s = a.encodeHTML,
        l = a.addCommas,
        u = n(215),
        c = n(86).retrieveRawAttr,
        h = n(166),
        d = n(61).makeSeriesEncodeForNameBased,
        f = o.extend({
      type: "series.map",
      dependencies: ["geo"],
      layoutMode: "box",
      needsDrawMap: !1,
      seriesGroup: [],
      getInitialData: function getInitialData(e) {
        for (var t = r(this, {
          coordDimensions: ["value"],
          encodeDefaulter: i.curry(d, this)
        }), n = t.mapDimension("value"), o = i.createHashMap(), a = [], s = [], l = 0, u = t.count(); l < u; l++) {
          var f = t.getName(l);
          o.set(f, !0), a.push({
            name: f,
            value: t.get(n, l),
            selected: c(t, l, "selected")
          });
        }

        var p = h.load(this.getMapType(), this.option.nameMap, this.option.nameProperty);
        return i.each(p.regions, function (e) {
          var t = e.name;
          o.get(t) || (a.push({
            name: t
          }), s.push(t));
        }), this.updateSelectedMap(a), t.appendValues([], s), t;
      },
      getHostGeoModel: function getHostGeoModel() {
        var e = this.option.geoIndex;
        return null != e ? this.dependentModels.geo[e] : null;
      },
      getMapType: function getMapType() {
        return (this.getHostGeoModel() || this).option.map;
      },
      getRawValue: function getRawValue(e) {
        var t = this.getData();
        return t.get(t.mapDimension("value"), e);
      },
      getRegionModel: function getRegionModel(e) {
        var t = this.getData();
        return t.getItemModel(t.indexOfName(e));
      },
      formatTooltip: function formatTooltip(e) {
        for (var t = this.getData(), n = l(this.getRawValue(e)), i = t.getName(e), r = this.seriesGroup, o = [], a = 0; a < r.length; a++) {
          var u = r[a].originalData.indexOfName(i),
              c = t.mapDimension("value");
          isNaN(r[a].originalData.get(c, u)) || o.push(s(r[a].name));
        }

        return o.join(", ") + "<br />" + s(i + " : " + n);
      },
      getTooltipPosition: function getTooltipPosition(e) {
        if (null != e) {
          var t = this.getData().getName(e),
              n = this.coordinateSystem,
              i = n.getRegion(t);
          return i && n.dataToPoint(i.center);
        }
      },
      setZoom: function setZoom(e) {
        this.option.zoom = e;
      },
      setCenter: function setCenter(e) {
        this.option.center = e;
      },
      defaultOption: {
        zlevel: 0,
        z: 2,
        coordinateSystem: "geo",
        map: "",
        left: "center",
        top: "center",
        aspectScale: .75,
        showLegendSymbol: !0,
        dataRangeHoverLink: !0,
        boundingCoords: null,
        center: null,
        zoom: 1,
        scaleLimit: null,
        label: {
          show: !1,
          color: "#000"
        },
        itemStyle: {
          borderWidth: .5,
          borderColor: "#444",
          areaColor: "#eee"
        },
        emphasis: {
          label: {
            show: !0,
            color: "rgb(100,0,0)"
          },
          itemStyle: {
            areaColor: "rgba(255,215,0,0.8)"
          }
        },
        nameProperty: "name"
      }
    });
    i.mixin(f, u);
    var p = f;
    e.exports = p;
  }, function (e, t, n) {
    var i = n(1).each,
        r = n(316),
        o = n(8).makeInner,
        a = n(729),
        s = n(730),
        l = n(731),
        u = n(732),
        c = o(),
        h = {
      load: function load(e, t, n) {
        var o = c(t).parsed;
        if (o) return o;
        var h,
            f = t.specialAreas || {},
            p = t.geoJSON;

        try {
          h = p ? r(p, n) : [];
        } catch (e) {
          throw new Error("Invalid geoJson format\n" + e.message);
        }

        return a(e, h), i(h, function (t) {
          var n = t.name;
          s(e, t), l(e, t), u(e, t);
          var i = f[n];
          i && t.transformTo(i.left, i.top, i.width, i.height);
        }), c(t).parsed = {
          regions: h,
          boundingRect: d(h)
        };
      }
    };

    function d(e) {
      for (var t, n = 0; n < e.length; n++) {
        var i = e[n].getBoundingRect();
        (t = t || i.clone()).union(i);
      }

      return t;
    }

    e.exports = h;
  }, function (e, t, n) {
    for (var i = n(1), r = n(317), o = [126, 25], a = [[[0, 3.5], [7, 11.2], [15, 11.9], [30, 7], [42, .7], [52, .7], [56, 7.7], [59, .7], [64, .7], [64, 0], [5, 0], [0, 3.5]], [[13, 16.1], [19, 14.7], [16, 21.7], [11, 23.1], [13, 16.1]], [[12, 32.2], [14, 38.5], [15, 38.5], [13, 32.2], [12, 32.2]], [[16, 47.6], [12, 53.2], [13, 53.2], [18, 47.6], [16, 47.6]], [[6, 64.4], [8, 70], [9, 70], [8, 64.4], [6, 64.4]], [[23, 82.6], [29, 79.8], [30, 79.8], [25, 82.6], [23, 82.6]], [[37, 70.7], [43, 62.3], [44, 62.3], [39, 70.7], [37, 70.7]], [[48, 51.1], [51, 45.5], [53, 45.5], [50, 51.1], [48, 51.1]], [[51, 35], [51, 28.7], [53, 28.7], [53, 35], [51, 35]], [[52, 22.4], [55, 17.5], [56, 17.5], [53, 22.4], [52, 22.4]], [[58, 12.6], [62, 7], [63, 7], [60, 12.6], [58, 12.6]], [[0, 3.5], [0, 93.1], [64, 93.1], [64, 0], [63, 0], [63, 92.4], [1, 92.4], [1, 3.5], [0, 3.5]]], s = 0; s < a.length; s++) {
      for (var l = 0; l < a[s].length; l++) {
        a[s][l][0] /= 10.5, a[s][l][1] /= -14, a[s][l][0] += o[0], a[s][l][1] += o[1];
      }
    }

    e.exports = function (e, t) {
      "china" === e && t.push(new r("南海诸岛", i.map(a, function (e) {
        return {
          type: "polygon",
          exterior: e
        };
      }), o));
    };
  }, function (e, t) {
    var n = {
      南海诸岛: [32, 80],
      广东: [0, -10],
      香港: [10, 5],
      澳门: [-10, 10],
      天津: [5, 5]
    };

    e.exports = function (e, t) {
      if ("china" === e) {
        var i = n[t.name];

        if (i) {
          var r = t.center;
          r[0] += i[0] / 10.5, r[1] += -i[1] / 14;
        }
      }
    };
  }, function (e, t) {
    var n = {
      Russia: [100, 60],
      "United States": [-99, 38],
      "United States of America": [-99, 38]
    };

    e.exports = function (e, t) {
      if ("world" === e) {
        var i = n[t.name];

        if (i) {
          var r = t.center;
          r[0] = i[0], r[1] = i[1];
        }
      }
    };
  }, function (e, t) {
    var n = [[[123.45165252685547, 25.73527164402261], [123.49731445312499, 25.73527164402261], [123.49731445312499, 25.750734064600884], [123.45165252685547, 25.750734064600884], [123.45165252685547, 25.73527164402261]]];

    e.exports = function (e, t) {
      "china" === e && "台湾" === t.name && t.geometries.push({
        type: "polygon",
        exterior: n[0]
      });
    };
  }, function (e, t, n) {
    var i = n(309),
        r = i.parseSVG,
        o = i.makeViewBoxTransform,
        a = n(84),
        s = n(206),
        l = n(1),
        u = l.assert,
        c = l.createHashMap,
        h = n(17),
        d = (0, n(8).makeInner)(),
        f = {
      load: function load(e, t) {
        var n = d(t).originRoot;
        if (n) return {
          root: n,
          boundingRect: d(t).boundingRect
        };
        var i = p(t);
        return d(t).originRoot = i.root, d(t).boundingRect = i.boundingRect, i;
      },
      makeGraphic: function makeGraphic(e, t, n) {
        var i = d(t),
            r = i.rootMap || (i.rootMap = c()),
            o = r.get(n);
        if (o) return o;
        var a = i.originRoot,
            s = i.boundingRect;
        return i.originRootHostKey ? o = p(t, s).root : (i.originRootHostKey = n, o = a), r.set(n, o);
      },
      removeGraphic: function removeGraphic(e, t, n) {
        var i = d(t),
            r = i.rootMap;
        r && r.removeKey(n), n === i.originRootHostKey && (i.originRootHostKey = null);
      }
    };

    function p(e, t) {
      var n,
          i,
          l = e.svgXML;

      try {
        i = (n = l && r(l, {
          ignoreViewBox: !0,
          ignoreRootClip: !0
        }) || {}).root, u(null != i);
      } catch (e) {
        throw new Error("Invalid svg format\n" + e.message);
      }

      var c = n.width,
          d = n.height,
          f = n.viewBoxRect;

      if (t || (t = null == c || null == d ? i.getBoundingRect() : new h(0, 0, 0, 0), null != c && (t.width = c), null != d && (t.height = d)), f) {
        var p = o(f, t.width, t.height),
            g = i;
        (i = new a()).add(g), g.scale = p.scale, g.position = p.position;
      }

      return i.setClipPath(new s({
        shape: t.plain()
      })), {
        root: i,
        boundingRect: t
      };
    }

    e.exports = f;
  }, function (e, t, n) {
    var i = n(4),
        r = n(1),
        o = n(5),
        a = n(328),
        s = i.extendChartView({
      type: "map",
      render: function render(e, t, n, i) {
        if (!i || "mapToggleSelect" !== i.type || i.from !== this.uid) {
          var r = this.group;

          if (r.removeAll(), !e.getHostGeoModel()) {
            if (i && "geoRoam" === i.type && "series" === i.componentType && i.seriesId === e.id) (o = this._mapDraw) && r.add(o.group);else if (e.needsDrawMap) {
              var o = this._mapDraw || new a(n, !0);
              r.add(o.group), o.draw(e, t, n, this, i), this._mapDraw = o;
            } else this._mapDraw && this._mapDraw.remove(), this._mapDraw = null;
            e.get("showLegendSymbol") && t.getComponent("legend") && this._renderSymbols(e, t, n);
          }
        }
      },
      remove: function remove() {
        this._mapDraw && this._mapDraw.remove(), this._mapDraw = null, this.group.removeAll();
      },
      dispose: function dispose() {
        this._mapDraw && this._mapDraw.remove(), this._mapDraw = null;
      },
      _renderSymbols: function _renderSymbols(e, t, n) {
        var i = e.originalData,
            a = this.group;
        i.each(i.mapDimension("value"), function (t, n) {
          if (!isNaN(t)) {
            var s = i.getItemLayout(n);

            if (s && s.point) {
              var c = s.point,
                  h = s.offset,
                  d = new o.Circle({
                style: {
                  fill: e.getData().getVisual("color")
                },
                shape: {
                  cx: c[0] + 9 * h,
                  cy: c[1],
                  r: 3
                },
                silent: !0,
                z2: 8 + (h ? 0 : o.Z2_EMPHASIS_LIFT + 1)
              });

              if (!h) {
                var f = e.mainSeries.getData(),
                    p = i.getName(n),
                    g = f.indexOfName(p),
                    v = i.getItemModel(n),
                    m = v.getModel("label"),
                    y = v.getModel("emphasis.label"),
                    x = f.getItemGraphicEl(g),
                    _ = r.retrieve2(e.getFormattedLabel(g, "normal"), p),
                    b = r.retrieve2(e.getFormattedLabel(g, "emphasis"), _),
                    w = x.__seriesMapHighDown,
                    S = Math.random();

                if (!w) {
                  w = x.__seriesMapHighDown = {};
                  var T = r.curry(l, !0),
                      C = r.curry(l, !1);
                  x.on("mouseover", T).on("mouseout", C).on("emphasis", T).on("normal", C);
                }

                x.__seriesMapCallKey = S, r.extend(w, {
                  recordVersion: S,
                  circle: d,
                  labelModel: m,
                  hoverLabelModel: y,
                  emphasisText: b,
                  normalText: _
                }), u(w, !1);
              }

              a.add(d);
            }
          }
        });
      }
    });

    function l(e) {
      var t = this.__seriesMapHighDown;
      t && t.recordVersion === this.__seriesMapCallKey && u(t, e);
    }

    function u(e, t) {
      var n = e.circle,
          i = e.labelModel,
          r = e.hoverLabelModel,
          a = e.emphasisText,
          s = e.normalText;
      t ? (n.style.extendFrom(o.setTextStyle({}, r, {
        text: r.get("show") ? a : null
      }, {
        isRectText: !0,
        useInsideStyle: !1
      }, !0)), n.__mapOriginalZ2 = n.z2, n.z2 += o.Z2_EMPHASIS_LIFT) : (o.setTextStyle(n.style, i, {
        text: i.get("show") ? s : null,
        textPosition: i.getShallow("position") || "bottom"
      }, {
        isRectText: !0,
        useInsideStyle: !1
      }), n.dirty(!1), null != n.__mapOriginalZ2 && (n.z2 = n.__mapOriginalZ2, n.__mapOriginalZ2 = null));
    }

    e.exports = s;
  }, function (e, t, n) {
    var i = n(1),
        r = n(17),
        o = n(219),
        a = n(166);

    function s(e, t, n, i) {
      o.call(this, e), this.map = t;
      var r = a.load(t, n);
      this._nameCoordMap = r.nameCoordMap, this._regionsMap = r.regionsMap, this._invertLongitute = null == i || i, this.regions = r.regions, this._rect = r.boundingRect;
    }

    function l(e, t, n, i) {
      var r = n.geoModel,
          o = n.seriesModel,
          a = r ? r.coordinateSystem : o ? o.coordinateSystem || (o.getReferringComponents("geo")[0] || {}).coordinateSystem : null;
      return a === this ? a[e](i) : null;
    }

    s.prototype = {
      constructor: s,
      type: "geo",
      dimensions: ["lng", "lat"],
      containCoord: function containCoord(e) {
        for (var t = this.regions, n = 0; n < t.length; n++) {
          if (t[n].contain(e)) return !0;
        }

        return !1;
      },
      transformTo: function transformTo(e, t, n, i) {
        var o = this.getBoundingRect(),
            a = this._invertLongitute;
        o = o.clone(), a && (o.y = -o.y - o.height);
        var s = this._rawTransformable;

        if (s.transform = o.calculateTransform(new r(e, t, n, i)), s.decomposeTransform(), a) {
          var l = s.scale;
          l[1] = -l[1];
        }

        s.updateTransform(), this._updateTransform();
      },
      getRegion: function getRegion(e) {
        return this._regionsMap.get(e);
      },
      getRegionByCoord: function getRegionByCoord(e) {
        for (var t = this.regions, n = 0; n < t.length; n++) {
          if (t[n].contain(e)) return t[n];
        }
      },
      addGeoCoord: function addGeoCoord(e, t) {
        this._nameCoordMap.set(e, t);
      },
      getGeoCoord: function getGeoCoord(e) {
        return this._nameCoordMap.get(e);
      },
      getBoundingRect: function getBoundingRect() {
        return this._rect;
      },
      dataToPoint: function dataToPoint(e, t, n) {
        if ("string" == typeof e && (e = this.getGeoCoord(e)), e) return o.prototype.dataToPoint.call(this, e, t, n);
      },
      convertToPixel: i.curry(l, "dataToPoint"),
      convertFromPixel: i.curry(l, "pointToData")
    }, i.mixin(s, o);
    var u = s;
    e.exports = u;
  }, function (e, t, n) {
    var i = n(1);

    e.exports = function (e) {
      var t = {};
      e.eachSeriesByType("map", function (n) {
        var r = n.getMapType();

        if (!n.getHostGeoModel() && !t[r]) {
          var o = {};
          i.each(n.seriesGroup, function (t) {
            var n = t.coordinateSystem,
                i = t.originalData;
            t.get("showLegendSymbol") && e.getComponent("legend") && i.each(i.mapDimension("value"), function (e, t) {
              var r = i.getName(t),
                  a = n.getRegion(r);

              if (a && !isNaN(e)) {
                var s = o[r] || 0,
                    l = n.dataToPoint(a.center);
                o[r] = s + 1, i.setItemLayout(t, {
                  point: l,
                  offset: s
                });
              }
            });
          });
          var a = n.getData();
          a.each(function (e) {
            var t = a.getName(e),
                n = a.getItemLayout(e) || {};
            n.showLabel = !o[t], a.setItemLayout(e, n);
          }), t[r] = !0;
        }
      });
    };
  }, function (e, t) {
    e.exports = function (e) {
      e.eachSeriesByType("map", function (e) {
        var t = e.get("color"),
            n = e.getModel("itemStyle"),
            i = n.get("areaColor"),
            r = n.get("color") || t[e.seriesIndex % t.length];
        e.getData().setVisual({
          areaColor: i,
          color: r
        });
      });
    };
  }, function (e, t, n) {
    var i = n(1);

    e.exports = function (e) {
      var t = {};
      e.eachSeriesByType("map", function (e) {
        var n = e.getHostGeoModel(),
            i = n ? "o" + n.id : "i" + e.getMapType();
        (t[i] = t[i] || []).push(e);
      }), i.each(t, function (e, t) {
        for (var n, r, o, a = (n = i.map(e, function (e) {
          return e.getData();
        }), r = e[0].get("mapValueCalculation"), o = {}, i.each(n, function (e) {
          e.each(e.mapDimension("value"), function (t, n) {
            var i = "ec-" + e.getName(n);
            o[i] = o[i] || [], isNaN(t) || o[i].push(t);
          });
        }), n[0].map(n[0].mapDimension("value"), function (e, t) {
          for (var i, a = "ec-" + n[0].getName(t), s = 0, l = 1 / 0, u = -1 / 0, c = o[a].length, h = 0; h < c; h++) {
            l = Math.min(l, o[a][h]), u = Math.max(u, o[a][h]), s += o[a][h];
          }

          return i = "min" === r ? l : "max" === r ? u : "average" === r ? s / c : s, 0 === c ? NaN : i;
        })), s = 0; s < e.length; s++) {
          e[s].originalData = e[s].getData();
        }

        for (s = 0; s < e.length; s++) {
          e[s].seriesGroup = e, e[s].needsDrawMap = 0 === s && !e[s].getHostGeoModel(), e[s].setData(a.cloneShallow()), e[s].mainSeries = e[0];
        }
      });
    };
  }, function (e, t, n) {
    var i = n(1);

    e.exports = function (e) {
      var t = [];
      i.each(e.series, function (e) {
        e && "map" === e.type && (t.push(e), e.map = e.map || e.mapType, i.defaults(e, e.mapLocation));
      });
    };
  }, function (e, t, n) {
    var i = n(4);
    n(741), n(742), n(743);
    var r = n(88),
        o = n(744);
    i.registerVisual(r("tree", "circle")), i.registerLayout(o);
  }, function (e, t, n) {
    var i = n(27),
        r = n(220),
        o = n(15).encodeHTML,
        a = n(22),
        s = i.extend({
      type: "series.tree",
      layoutInfo: null,
      layoutMode: "box",
      getInitialData: function getInitialData(e) {
        var t = {
          name: e.name,
          children: e.data
        },
            n = e.leaves || {},
            i = new a(n, this, this.ecModel),
            o = r.createTree(t, this, {}, function (e) {
          e.wrapMethod("getItemModel", function (e, t) {
            var n = o.getNodeByDataIndex(t);
            return n.children.length && n.isExpand || (e.parentModel = i), e;
          });
        });
        var s = 0;
        o.eachNode("preorder", function (e) {
          e.depth > s && (s = e.depth);
        });
        var l = e.expandAndCollapse && e.initialTreeDepth >= 0 ? e.initialTreeDepth : s;
        return o.root.eachNode("preorder", function (e) {
          var t = e.hostTree.data.getRawDataItem(e.dataIndex);
          e.isExpand = t && null != t.collapsed ? !t.collapsed : e.depth <= l;
        }), o.data;
      },
      getOrient: function getOrient() {
        var e = this.get("orient");
        return "horizontal" === e ? e = "LR" : "vertical" === e && (e = "TB"), e;
      },
      setZoom: function setZoom(e) {
        this.option.zoom = e;
      },
      setCenter: function setCenter(e) {
        this.option.center = e;
      },
      formatTooltip: function formatTooltip(e) {
        for (var t = this.getData().tree, n = t.root.children[0], i = t.getNodeByDataIndex(e), r = i.getValue(), a = i.name; i && i !== n;) {
          a = i.parentNode.name + "." + a, i = i.parentNode;
        }

        return o(a + (isNaN(r) || null == r ? "" : " : " + r));
      },
      defaultOption: {
        zlevel: 0,
        z: 2,
        coordinateSystem: "view",
        left: "12%",
        top: "12%",
        right: "12%",
        bottom: "12%",
        layout: "orthogonal",
        edgeShape: "curve",
        edgeForkPosition: "50%",
        roam: !1,
        nodeScaleRatio: .4,
        center: null,
        zoom: 1,
        orient: "LR",
        symbol: "emptyCircle",
        symbolSize: 7,
        expandAndCollapse: !0,
        initialTreeDepth: 2,
        lineStyle: {
          color: "#ccc",
          width: 1.5,
          curveness: .5
        },
        itemStyle: {
          color: "lightsteelblue",
          borderColor: "#c23531",
          borderWidth: 1.5
        },
        label: {
          show: !0,
          color: "#555"
        },
        leaves: {
          label: {
            show: !0
          }
        },
        animationEasing: "linear",
        animationDuration: 700,
        animationDurationUpdate: 1e3
      }
    });
    e.exports = s;
  }, function (e, t, n) {
    var i = n(1),
        r = n(5),
        o = n(162),
        a = n(332).radialCoordinate,
        s = n(4),
        l = n(120),
        u = n(219),
        c = n(216),
        h = n(131),
        d = n(167).onIrrelevantElement,
        f = (n(9).__DEV__, n(6).parsePercent),
        p = r.extendShape({
      shape: {
        parentPoint: [],
        childPoints: [],
        orient: "",
        forkPosition: ""
      },
      style: {
        stroke: "#000",
        fill: null
      },
      buildPath: function buildPath(e, t) {
        var n = t.childPoints,
            i = n.length,
            r = t.parentPoint,
            o = n[0],
            a = n[i - 1];
        if (1 === i) return e.moveTo(r[0], r[1]), void e.lineTo(o[0], o[1]);
        var s = t.orient,
            l = "TB" === s || "BT" === s ? 0 : 1,
            u = 1 - l,
            c = f(t.forkPosition, 1),
            h = [];
        h[l] = r[l], h[u] = r[u] + (a[u] - r[u]) * c, e.moveTo(r[0], r[1]), e.lineTo(h[0], h[1]), e.moveTo(o[0], o[1]), h[l] = o[l], e.lineTo(h[0], h[1]), h[l] = a[l], e.lineTo(h[0], h[1]), e.lineTo(a[0], a[1]);

        for (var d = 1; d < i - 1; d++) {
          var p = n[d];
          e.moveTo(p[0], p[1]), h[l] = p[l], e.lineTo(h[0], h[1]);
        }
      }
    }),
        g = s.extendChartView({
      type: "tree",
      init: function init(e, t) {
        this._oldTree, this._mainGroup = new r.Group(), this._controller = new h(t.getZr()), this._controllerHost = {
          target: this.group
        }, this.group.add(this._mainGroup);
      },
      render: function render(e, t, n, i) {
        var r = e.getData(),
            o = e.layoutInfo,
            a = this._mainGroup,
            s = e.get("layout");
        "radial" === s ? a.attr("position", [o.x + o.width / 2, o.y + o.height / 2]) : a.attr("position", [o.x, o.y]), this._updateViewCoordSys(e, o, s), this._updateController(e, t, n);
        var l = this._data,
            u = {
          expandAndCollapse: e.get("expandAndCollapse"),
          layout: s,
          edgeShape: e.get("edgeShape"),
          edgeForkPosition: e.get("edgeForkPosition"),
          orient: e.getOrient(),
          curvature: e.get("lineStyle.curveness"),
          symbolRotate: e.get("symbolRotate"),
          symbolOffset: e.get("symbolOffset"),
          hoverAnimation: e.get("hoverAnimation"),
          useNameLabel: !0,
          fadeIn: !0
        };
        r.diff(l).add(function (t) {
          v(r, t) && y(r, t, null, a, e, u);
        }).update(function (t, n) {
          var i = l.getItemGraphicEl(n);
          v(r, t) ? y(r, t, i, a, e, u) : i && x(l, n, i, a, e, u);
        }).remove(function (t) {
          var n = l.getItemGraphicEl(t);
          n && x(l, t, n, a, e, u);
        }).execute(), this._nodeScaleRatio = e.get("nodeScaleRatio"), this._updateNodeAndLinkScale(e), !0 === u.expandAndCollapse && r.eachItemGraphicEl(function (t, i) {
          t.off("click").on("click", function () {
            n.dispatchAction({
              type: "treeExpandAndCollapse",
              seriesId: e.id,
              dataIndex: i
            });
          });
        }), this._data = r;
      },
      _updateViewCoordSys: function _updateViewCoordSys(e) {
        var t = e.getData(),
            n = [];
        t.each(function (e) {
          var i = t.getItemLayout(e);
          !i || isNaN(i.x) || isNaN(i.y) || n.push([+i.x, +i.y]);
        });
        var i = [],
            r = [];
        l.fromPoints(n, i, r);
        var o = this._min,
            a = this._max;
        r[0] - i[0] == 0 && (i[0] = o ? o[0] : i[0] - 1, r[0] = a ? a[0] : r[0] + 1), r[1] - i[1] == 0 && (i[1] = o ? o[1] : i[1] - 1, r[1] = a ? a[1] : r[1] + 1);
        var s = e.coordinateSystem = new u();
        s.zoomLimit = e.get("scaleLimit"), s.setBoundingRect(i[0], i[1], r[0] - i[0], r[1] - i[1]), s.setCenter(e.get("center")), s.setZoom(e.get("zoom")), this.group.attr({
          position: s.position,
          scale: s.scale
        }), this._viewCoordSys = s, this._min = i, this._max = r;
      },
      _updateController: function _updateController(e, t, n) {
        var i = this._controller,
            r = this._controllerHost,
            o = this.group;
        i.setPointerChecker(function (t, i, r) {
          var a = o.getBoundingRect();
          return a.applyTransform(o.transform), a.contain(i, r) && !d(t, n, e);
        }), i.enable(e.get("roam")), r.zoomLimit = e.get("scaleLimit"), r.zoom = e.coordinateSystem.getZoom(), i.off("pan").off("zoom").on("pan", function (t) {
          c.updateViewOnPan(r, t.dx, t.dy), n.dispatchAction({
            seriesId: e.id,
            type: "treeRoam",
            dx: t.dx,
            dy: t.dy
          });
        }, this).on("zoom", function (t) {
          c.updateViewOnZoom(r, t.scale, t.originX, t.originY), n.dispatchAction({
            seriesId: e.id,
            type: "treeRoam",
            zoom: t.scale,
            originX: t.originX,
            originY: t.originY
          }), this._updateNodeAndLinkScale(e);
        }, this);
      },
      _updateNodeAndLinkScale: function _updateNodeAndLinkScale(e) {
        var t = e.getData(),
            n = this._getNodeGlobalScale(e),
            i = [n, n];

        t.eachItemGraphicEl(function (e, t) {
          e.attr("scale", i);
        });
      },
      _getNodeGlobalScale: function _getNodeGlobalScale(e) {
        var t = e.coordinateSystem;
        if ("view" !== t.type) return 1;
        var n = this._nodeScaleRatio,
            i = t.scale,
            r = i && i[0] || 1;
        return ((t.getZoom() - 1) * n + 1) / r;
      },
      dispose: function dispose() {
        this._controller && this._controller.dispose(), this._controllerHost = {};
      },
      remove: function remove() {
        this._mainGroup.removeAll(), this._data = null;
      }
    });

    function v(e, t) {
      var n = e.getItemLayout(t);
      return n && !isNaN(n.x) && !isNaN(n.y) && "none" !== e.getItemVisual(t, "symbol");
    }

    function m(e, t, n) {
      return n.itemModel = t, n.itemStyle = t.getModel("itemStyle").getItemStyle(), n.hoverItemStyle = t.getModel("emphasis.itemStyle").getItemStyle(), n.lineStyle = t.getModel("lineStyle").getLineStyle(), n.labelModel = t.getModel("label"), n.hoverLabelModel = t.getModel("emphasis.label"), !1 === e.isExpand && 0 !== e.children.length ? n.symbolInnerColor = n.itemStyle.fill : n.symbolInnerColor = "#fff", n;
    }

    function y(e, t, n, a, s, l) {
      var u = !n,
          c = e.tree.getNodeByDataIndex(t),
          h = c.getModel(),
          d = (l = m(c, h, l), e.tree.root),
          f = c.parentNode === d ? c : c.parentNode || c,
          g = e.getItemGraphicEl(f.dataIndex),
          v = f.getLayout(),
          y = g ? {
        x: g.position[0],
        y: g.position[1],
        rawX: g.__radialOldRawX,
        rawY: g.__radialOldRawY
      } : v,
          x = c.getLayout();
      u ? (n = new o(e, t, l)).attr("position", [y.x, y.y]) : n.updateData(e, t, l), n.__radialOldRawX = n.__radialRawX, n.__radialOldRawY = n.__radialRawY, n.__radialRawX = x.rawX, n.__radialRawY = x.rawY, a.add(n), e.setItemGraphicEl(t, n), r.updateProps(n, {
        position: [x.x, x.y]
      }, s);
      var b = n.getSymbolPath();

      if ("radial" === l.layout) {
        var w,
            S,
            T = d.children[0],
            C = T.getLayout(),
            k = T.children.length;

        if (x.x === C.x && !0 === c.isExpand) {
          var M = {};
          M.x = (T.children[0].getLayout().x + T.children[k - 1].getLayout().x) / 2, M.y = (T.children[0].getLayout().y + T.children[k - 1].getLayout().y) / 2, (w = Math.atan2(M.y - C.y, M.x - C.x)) < 0 && (w = 2 * Math.PI + w), (S = M.x < C.x) && (w -= Math.PI);
        } else (w = Math.atan2(x.y - C.y, x.x - C.x)) < 0 && (w = 2 * Math.PI + w), 0 === c.children.length || 0 !== c.children.length && !1 === c.isExpand ? (S = x.x < C.x) && (w -= Math.PI) : (S = x.x > C.x) || (w -= Math.PI);

        var E = S ? "left" : "right",
            A = l.labelModel.get("rotate"),
            I = A * (Math.PI / 180);
        b.setStyle({
          textPosition: l.labelModel.get("position") || E,
          textRotation: null == A ? -w : I,
          textOrigin: "center",
          verticalAlign: "middle"
        });
      }

      !function (e, t, n, o, a, s, l, u, c) {
        var h = c.edgeShape,
            d = o.__edge;
        if ("curve" === h) t.parentNode && t.parentNode !== n && (d || (d = o.__edge = new r.BezierCurve({
          shape: _(c, a, a),
          style: i.defaults({
            opacity: 0,
            strokeNoScale: !0
          }, c.lineStyle)
        })), r.updateProps(d, {
          shape: _(c, s, l),
          style: {
            opacity: 1
          }
        }, e));else if ("polyline" === h && "orthogonal" === c.layout && t !== n && t.children && 0 !== t.children.length && !0 === t.isExpand) {
          for (var f = t.children, g = [], v = 0; v < f.length; v++) {
            var m = f[v].getLayout();
            g.push([m.x, m.y]);
          }

          d || (d = o.__edge = new p({
            shape: {
              parentPoint: [l.x, l.y],
              childPoints: [[l.x, l.y]],
              orient: c.orient,
              forkPosition: c.edgeForkPosition
            },
            style: i.defaults({
              opacity: 0,
              strokeNoScale: !0
            }, c.lineStyle)
          })), r.updateProps(d, {
            shape: {
              parentPoint: [l.x, l.y],
              childPoints: g
            },
            style: {
              opacity: 1
            }
          }, e);
        }
        u.add(d);
      }(s, c, d, n, y, v, x, a, l);
    }

    function x(e, t, n, i, o, a) {
      for (var s, l = e.tree.getNodeByDataIndex(t), u = e.tree.root, c = l.getModel(), h = (a = m(l, c, a), l.parentNode === u ? l : l.parentNode || l), d = a.edgeShape; null == (s = h.getLayout());) {
        h = h.parentNode === u ? h : h.parentNode || h;
      }

      r.updateProps(n, {
        position: [s.x + 1, s.y + 1]
      }, o, function () {
        i.remove(n), e.setItemGraphicEl(t, null);
      }), n.fadeOut(null, {
        keepLabel: !0
      });

      var f = e.getItemGraphicEl(h.dataIndex).__edge,
          p = n.__edge || (!1 === h.isExpand || 1 === h.children.length ? f : void 0);

      d = a.edgeShape;
      p && ("curve" === d ? r.updateProps(p, {
        shape: _(a, s, s),
        style: {
          opacity: 0
        }
      }, o, function () {
        i.remove(p);
      }) : "polyline" === d && "orthogonal" === a.layout && r.updateProps(p, {
        shape: {
          parentPoint: [s.x, s.y],
          childPoints: [[s.x, s.y]]
        },
        style: {
          opacity: 0
        }
      }, o, function () {
        i.remove(p);
      }));
    }

    function _(e, t, n) {
      var i,
          r,
          o,
          s,
          l,
          u,
          c,
          h,
          d = e.orient;

      if ("radial" === e.layout) {
        l = t.rawX, c = t.rawY, u = n.rawX, h = n.rawY;
        var f = a(l, c),
            p = a(l, c + (h - c) * e.curvature),
            g = a(u, h + (c - h) * e.curvature),
            v = a(u, h);
        return {
          x1: f.x,
          y1: f.y,
          x2: v.x,
          y2: v.y,
          cpx1: p.x,
          cpy1: p.y,
          cpx2: g.x,
          cpy2: g.y
        };
      }

      return l = t.x, c = t.y, u = n.x, h = n.y, "LR" !== d && "RL" !== d || (i = l + (u - l) * e.curvature, r = c, o = u + (l - u) * e.curvature, s = h), "TB" !== d && "BT" !== d || (i = l, r = c + (h - c) * e.curvature, o = u, s = h + (c - h) * e.curvature), {
        x1: l,
        y1: c,
        x2: u,
        y2: h,
        cpx1: i,
        cpy1: r,
        cpx2: o,
        cpy2: s
      };
    }

    e.exports = g;
  }, function (e, t, n) {
    var i = n(4),
        r = n(217).updateCenterAndZoom;
    i.registerAction({
      type: "treeExpandAndCollapse",
      event: "treeExpandAndCollapse",
      update: "update"
    }, function (e, t) {
      t.eachComponent({
        mainType: "series",
        subType: "tree",
        query: e
      }, function (t) {
        var n = e.dataIndex,
            i = t.getData().tree.getNodeByDataIndex(n);
        i.isExpand = !i.isExpand;
      });
    }), i.registerAction({
      type: "treeRoam",
      event: "treeRoam",
      update: "none"
    }, function (e, t) {
      t.eachComponent({
        mainType: "series",
        subType: "tree",
        query: e
      }, function (t) {
        var n = t.coordinateSystem,
            i = r(n, e);
        t.setCenter && t.setCenter(i.center), t.setZoom && t.setZoom(i.zoom);
      });
    });
  }, function (e, t, n) {
    var i = n(745),
        r = i.eachAfter,
        o = i.eachBefore,
        a = n(332),
        s = a.init,
        l = a.firstWalk,
        u = a.secondWalk,
        c = a.separation,
        h = a.radialCoordinate,
        d = a.getViewRect;

    e.exports = function (e, t) {
      e.eachSeriesByType("tree", function (e) {
        !function (e, t) {
          var n = d(e, t);
          e.layoutInfo = n;
          var i = e.get("layout"),
              a = 0,
              f = 0,
              p = null;
          "radial" === i ? (a = 2 * Math.PI, f = Math.min(n.height, n.width) / 2, p = c(function (e, t) {
            return (e.parentNode === t.parentNode ? 1 : 2) / e.depth;
          })) : (a = n.width, f = n.height, p = c());
          var g = e.getData().tree.root,
              v = g.children[0];

          if (v) {
            s(g), r(v, l, p), g.hierNode.modifier = -v.hierNode.prelim, o(v, u);
            var m = v,
                y = v,
                x = v;
            o(v, function (e) {
              var t = e.getLayout().x;
              t < m.getLayout().x && (m = e), t > y.getLayout().x && (y = e), e.depth > x.depth && (x = e);
            });

            var _ = m === y ? 1 : p(m, y) / 2,
                b = _ - m.getLayout().x,
                w = 0,
                S = 0,
                T = 0,
                C = 0;

            if ("radial" === i) w = a / (y.getLayout().x + _ + b), S = f / (x.depth - 1 || 1), o(v, function (e) {
              T = (e.getLayout().x + b) * w, C = (e.depth - 1) * S;
              var t = h(T, C);
              e.setLayout({
                x: t.x,
                y: t.y,
                rawX: T,
                rawY: C
              }, !0);
            });else {
              var k = e.getOrient();
              "RL" === k || "LR" === k ? (S = f / (y.getLayout().x + _ + b), w = a / (x.depth - 1 || 1), o(v, function (e) {
                C = (e.getLayout().x + b) * S, T = "LR" === k ? (e.depth - 1) * w : a - (e.depth - 1) * w, e.setLayout({
                  x: T,
                  y: C
                }, !0);
              })) : "TB" !== k && "BT" !== k || (w = a / (y.getLayout().x + _ + b), S = f / (x.depth - 1 || 1), o(v, function (e) {
                T = (e.getLayout().x + b) * w, C = "TB" === k ? (e.depth - 1) * S : f - (e.depth - 1) * S, e.setLayout({
                  x: T,
                  y: C
                }, !0);
              }));
            }
          }
        }(e, t);
      });
    };
  }, function (e, t) {
    t.eachAfter = function (e, t, n) {
      for (var i, r = [e], o = []; i = r.pop();) {
        if (o.push(i), i.isExpand) {
          var a = i.children;
          if (a.length) for (var s = 0; s < a.length; s++) {
            r.push(a[s]);
          }
        }
      }

      for (; i = o.pop();) {
        t(i, n);
      }
    }, t.eachBefore = function (e, t) {
      for (var n, i = [e]; n = i.pop();) {
        if (t(n), n.isExpand) {
          var r = n.children;
          if (r.length) for (var o = r.length - 1; o >= 0; o--) {
            i.push(r[o]);
          }
        }
      }
    };
  }, function (e, t, n) {
    var i = n(4);
    n(747), n(748), n(751);
    var r = n(752),
        o = n(753);
    i.registerVisual(r), i.registerLayout(o);
  }, function (e, t, n) {
    var i = n(1),
        r = n(27),
        o = n(220),
        a = n(22),
        s = n(15),
        l = s.encodeHTML,
        u = s.addCommas,
        c = n(90).wrapTreePathInfo,
        h = r.extend({
      type: "series.treemap",
      layoutMode: "box",
      dependencies: ["grid", "polar"],
      preventUsingHoverLayer: !0,
      _viewRoot: null,
      defaultOption: {
        progressive: 0,
        left: "center",
        top: "middle",
        right: null,
        bottom: null,
        width: "80%",
        height: "80%",
        sort: !0,
        clipWindow: "origin",
        squareRatio: .5 * (1 + Math.sqrt(5)),
        leafDepth: null,
        drillDownIcon: "▶",
        zoomToNodeRatio: .1024,
        roam: !0,
        nodeClick: "zoomToNode",
        animation: !0,
        animationDurationUpdate: 900,
        animationEasing: "quinticInOut",
        breadcrumb: {
          show: !0,
          height: 22,
          left: "center",
          top: "bottom",
          emptyItemWidth: 25,
          itemStyle: {
            color: "rgba(0,0,0,0.7)",
            borderColor: "rgba(255,255,255,0.7)",
            borderWidth: 1,
            shadowColor: "rgba(150,150,150,1)",
            shadowBlur: 3,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            textStyle: {
              color: "#fff"
            }
          },
          emphasis: {
            textStyle: {}
          }
        },
        label: {
          show: !0,
          distance: 0,
          padding: 5,
          position: "inside",
          color: "#fff",
          ellipsis: !0
        },
        upperLabel: {
          show: !1,
          position: [0, "50%"],
          height: 20,
          color: "#fff",
          ellipsis: !0,
          verticalAlign: "middle"
        },
        itemStyle: {
          color: null,
          colorAlpha: null,
          colorSaturation: null,
          borderWidth: 0,
          gapWidth: 0,
          borderColor: "#fff",
          borderColorSaturation: null
        },
        emphasis: {
          upperLabel: {
            show: !0,
            position: [0, "50%"],
            color: "#fff",
            ellipsis: !0,
            verticalAlign: "middle"
          }
        },
        visualDimension: 0,
        visualMin: null,
        visualMax: null,
        color: [],
        colorAlpha: null,
        colorSaturation: null,
        colorMappingBy: "index",
        visibleMin: 10,
        childrenVisibleMin: null,
        levels: []
      },
      getInitialData: function getInitialData(e, t) {
        var n = {
          name: e.name,
          children: e.data
        };
        !function e(t) {
          var n = 0;
          i.each(t.children, function (t) {
            e(t);
            var r = t.value;
            i.isArray(r) && (r = r[0]), n += r;
          });
          var r = t.value;
          i.isArray(r) && (r = r[0]);
          (null == r || isNaN(r)) && (r = n);
          r < 0 && (r = 0);
          i.isArray(t.value) ? t.value[0] = r : t.value = r;
        }(n);
        var r = e.levels || [];

        r = e.levels = function (e, t) {
          var n,
              r = t.get("color");
          if (!r) return;

          if (e = e || [], i.each(e, function (e) {
            var t = new a(e),
                i = t.get("color");
            (t.get("itemStyle.color") || i && "none" !== i) && (n = !0);
          }), !n) {
            (e[0] || (e[0] = {})).color = r.slice();
          }

          return e;
        }(r, t);

        var s = i.map(r || [], function (e) {
          return new a(e, this, t);
        }, this),
            l = o.createTree(n, this, null, function (e) {
          e.wrapMethod("getItemModel", function (e, t) {
            var n = l.getNodeByDataIndex(t),
                i = s[n.depth];
            return i && (e.parentModel = i), e;
          });
        });
        return l.data;
      },
      optionUpdated: function optionUpdated() {
        this.resetViewRoot();
      },
      formatTooltip: function formatTooltip(e) {
        var t = this.getData(),
            n = this.getRawValue(e),
            r = i.isArray(n) ? u(n[0]) : u(n),
            o = t.getName(e);
        return l(o + ": " + r);
      },
      getDataParams: function getDataParams(e) {
        var t = r.prototype.getDataParams.apply(this, arguments),
            n = this.getData().tree.getNodeByDataIndex(e);
        return t.treePathInfo = c(n, this), t;
      },
      setLayoutInfo: function setLayoutInfo(e) {
        this.layoutInfo = this.layoutInfo || {}, i.extend(this.layoutInfo, e);
      },
      mapIdToIndex: function mapIdToIndex(e) {
        var t = this._idIndexMap;
        t || (t = this._idIndexMap = i.createHashMap(), this._idIndexMapCount = 0);
        var n = t.get(e);
        return null == n && t.set(e, n = this._idIndexMapCount++), n;
      },
      getViewRoot: function getViewRoot() {
        return this._viewRoot;
      },
      resetViewRoot: function resetViewRoot(e) {
        e ? this._viewRoot = e : e = this._viewRoot;
        var t = this.getRawData().tree.root;
        e && (e === t || t.contains(e)) || (this._viewRoot = t);
      }
    });
    e.exports = h;
  }, function (e, t, n) {
    var i = n(4),
        r = n(1),
        o = n(5),
        a = n(87),
        s = n(90),
        l = n(749),
        u = n(131),
        c = n(17),
        h = n(31),
        d = n(750),
        f = n(101),
        p = n(15).windowOpen,
        g = r.bind,
        v = o.Group,
        m = o.Rect,
        y = r.each,
        x = ["label"],
        _ = ["emphasis", "label"],
        b = ["upperLabel"],
        w = ["emphasis", "upperLabel"],
        S = f([["fill", "color"], ["stroke", "strokeColor"], ["lineWidth", "strokeWidth"], ["shadowBlur"], ["shadowOffsetX"], ["shadowOffsetY"], ["shadowColor"]]),
        T = function T(e) {
      var t = S(e);
      return t.stroke = t.fill = t.lineWidth = null, t;
    },
        C = i.extendChartView({
      type: "treemap",
      init: function init(e, t) {
        this._containerGroup, this._storage = {
          nodeGroup: [],
          background: [],
          content: []
        }, this._oldTree, this._breadcrumb, this._controller, this._state = "ready";
      },
      render: function render(e, t, n, i) {
        var o = t.findComponents({
          mainType: "series",
          subType: "treemap",
          query: i
        });

        if (!(r.indexOf(o, e) < 0)) {
          this.seriesModel = e, this.api = n, this.ecModel = t;

          var a = s.retrieveTargetInfo(i, ["treemapZoomToNode", "treemapRootToNode"], e),
              l = i && i.type,
              u = e.layoutInfo,
              c = !this._oldTree,
              h = this._storage,
              d = "treemapRootToNode" === l && a && h ? {
            rootNodeGroup: h.nodeGroup[a.node.getRawIndex()],
            direction: i.direction
          } : null,
              f = this._giveContainerGroup(u),
              p = this._doRender(f, e, d);

          c || l && "treemapZoomToNode" !== l && "treemapRootToNode" !== l ? p.renderFinally() : this._doAnimation(f, p, e, d), this._resetController(n), this._renderBreadcrumb(e, n, a);
        }
      },
      _giveContainerGroup: function _giveContainerGroup(e) {
        var t = this._containerGroup;
        return t || (t = this._containerGroup = new v(), this._initEvents(t), this.group.add(t)), t.attr("position", [e.x, e.y]), t;
      },
      _doRender: function _doRender(e, t, n) {
        var i = t.getData().tree,
            o = this._oldTree,
            s = {
          nodeGroup: [],
          background: [],
          content: []
        },
            l = {
          nodeGroup: [],
          background: [],
          content: []
        },
            u = this._storage,
            c = [],
            h = r.curry(k, t, l, u, n, s, c);
        !function e(t, n, i, o, s) {
          o ? (n = t, y(t, function (e, t) {
            !e.isRemoved() && u(t, t);
          })) : new a(n, t, l, l).add(u).update(u).remove(r.curry(u, null)).execute();

          function l(e) {
            return e.getId();
          }

          function u(r, a) {
            var l = null != r ? t[r] : null,
                u = null != a ? n[a] : null,
                c = h(l, u, i, s);
            c && e(l && l.viewChildren || [], u && u.viewChildren || [], c, o, s + 1);
          }
        }(i.root ? [i.root] : [], o && o.root ? [o.root] : [], e, i === o || !o, 0);

        var d = function (e) {
          var t = {
            nodeGroup: [],
            background: [],
            content: []
          };
          return e && y(e, function (e, n) {
            var i = t[n];
            y(e, function (e) {
              e && (i.push(e), e.__tmWillDelete = 1);
            });
          }), t;
        }(u);

        return this._oldTree = i, this._storage = l, {
          lastsForAnimation: s,
          willDeleteEls: d,
          renderFinally: function renderFinally() {
            y(d, function (e) {
              y(e, function (e) {
                e.parent && e.parent.remove(e);
              });
            }), y(c, function (e) {
              e.invisible = !0, e.dirty();
            });
          }
        };
      },
      _doAnimation: function _doAnimation(e, t, n, i) {
        if (n.get("animation")) {
          var o = n.get("animationDurationUpdate"),
              a = n.get("animationEasing"),
              s = d.createWrap();
          y(t.willDeleteEls, function (e, t) {
            y(e, function (e, n) {
              if (!e.invisible) {
                var r,
                    l = e.parent;
                if (i && "drillDown" === i.direction) r = l === i.rootNodeGroup ? {
                  shape: {
                    x: 0,
                    y: 0,
                    width: l.__tmNodeWidth,
                    height: l.__tmNodeHeight
                  },
                  style: {
                    opacity: 0
                  }
                } : {
                  style: {
                    opacity: 0
                  }
                };else {
                  var u = 0,
                      c = 0;
                  l.__tmWillDelete || (u = l.__tmNodeWidth / 2, c = l.__tmNodeHeight / 2), r = "nodeGroup" === t ? {
                    position: [u, c],
                    style: {
                      opacity: 0
                    }
                  } : {
                    shape: {
                      x: u,
                      y: c,
                      width: 0,
                      height: 0
                    },
                    style: {
                      opacity: 0
                    }
                  };
                }
                r && s.add(e, r, o, a);
              }
            });
          }), y(this._storage, function (e, n) {
            y(e, function (e, i) {
              var l = t.lastsForAnimation[n][i],
                  u = {};
              l && ("nodeGroup" === n ? l.old && (u.position = e.position.slice(), e.attr("position", l.old)) : (l.old && (u.shape = r.extend({}, e.shape), e.setShape(l.old)), l.fadein ? (e.setStyle("opacity", 0), u.style = {
                opacity: 1
              }) : 1 !== e.style.opacity && (u.style = {
                opacity: 1
              })), s.add(e, u, o, a));
            });
          }, this), this._state = "animating", s.done(g(function () {
            this._state = "ready", t.renderFinally();
          }, this)).start();
        }
      },
      _resetController: function _resetController(e) {
        var t = this._controller;
        t || ((t = this._controller = new u(e.getZr())).enable(this.seriesModel.get("roam")), t.on("pan", g(this._onPan, this)), t.on("zoom", g(this._onZoom, this)));
        var n = new c(0, 0, e.getWidth(), e.getHeight());
        t.setPointerChecker(function (e, t, i) {
          return n.contain(t, i);
        });
      },
      _clearController: function _clearController() {
        var e = this._controller;
        e && (e.dispose(), e = null);
      },
      _onPan: function _onPan(e) {
        if ("animating" !== this._state && (Math.abs(e.dx) > 3 || Math.abs(e.dy) > 3)) {
          var t = this.seriesModel.getData().tree.root;
          if (!t) return;
          var n = t.getLayout();
          if (!n) return;
          this.api.dispatchAction({
            type: "treemapMove",
            from: this.uid,
            seriesId: this.seriesModel.id,
            rootRect: {
              x: n.x + e.dx,
              y: n.y + e.dy,
              width: n.width,
              height: n.height
            }
          });
        }
      },
      _onZoom: function _onZoom(e) {
        var t = e.originX,
            n = e.originY;

        if ("animating" !== this._state) {
          var i = this.seriesModel.getData().tree.root;
          if (!i) return;
          var r = i.getLayout();
          if (!r) return;
          var o = new c(r.x, r.y, r.width, r.height),
              a = this.seriesModel.layoutInfo;
          t -= a.x, n -= a.y;
          var s = h.create();
          h.translate(s, s, [-t, -n]), h.scale(s, s, [e.scale, e.scale]), h.translate(s, s, [t, n]), o.applyTransform(s), this.api.dispatchAction({
            type: "treemapRender",
            from: this.uid,
            seriesId: this.seriesModel.id,
            rootRect: {
              x: o.x,
              y: o.y,
              width: o.width,
              height: o.height
            }
          });
        }
      },
      _initEvents: function _initEvents(e) {
        e.on("click", function (e) {
          if ("ready" === this._state) {
            var t = this.seriesModel.get("nodeClick", !0);

            if (t) {
              var n = this.findTarget(e.offsetX, e.offsetY);

              if (n) {
                var i = n.node;
                if (i.getLayout().isLeafRoot) this._rootToNode(n);else if ("zoomToNode" === t) this._zoomToNode(n);else if ("link" === t) {
                  var r = i.hostTree.data.getItemModel(i.dataIndex),
                      o = r.get("link", !0),
                      a = r.get("target", !0) || "blank";
                  o && p(o, a);
                }
              }
            }
          }
        }, this);
      },
      _renderBreadcrumb: function _renderBreadcrumb(e, t, n) {
        n || (n = null != e.get("leafDepth", !0) ? {
          node: e.getViewRoot()
        } : this.findTarget(t.getWidth() / 2, t.getHeight() / 2)) || (n = {
          node: e.getData().tree.root
        }), (this._breadcrumb || (this._breadcrumb = new l(this.group))).render(e, t, n.node, g(function (t) {
          "animating" !== this._state && (s.aboveViewRoot(e.getViewRoot(), t) ? this._rootToNode({
            node: t
          }) : this._zoomToNode({
            node: t
          }));
        }, this));
      },
      remove: function remove() {
        this._clearController(), this._containerGroup && this._containerGroup.removeAll(), this._storage = {
          nodeGroup: [],
          background: [],
          content: []
        }, this._state = "ready", this._breadcrumb && this._breadcrumb.remove();
      },
      dispose: function dispose() {
        this._clearController();
      },
      _zoomToNode: function _zoomToNode(e) {
        this.api.dispatchAction({
          type: "treemapZoomToNode",
          from: this.uid,
          seriesId: this.seriesModel.id,
          targetNode: e.node
        });
      },
      _rootToNode: function _rootToNode(e) {
        this.api.dispatchAction({
          type: "treemapRootToNode",
          from: this.uid,
          seriesId: this.seriesModel.id,
          targetNode: e.node
        });
      },
      findTarget: function findTarget(e, t) {
        var n;
        return this.seriesModel.getViewRoot().eachNode({
          attr: "viewChildren",
          order: "preorder"
        }, function (i) {
          var r = this._storage.background[i.getRawIndex()];

          if (r) {
            var o = r.transformCoordToLocal(e, t),
                a = r.shape;
            if (!(a.x <= o[0] && o[0] <= a.x + a.width && a.y <= o[1] && o[1] <= a.y + a.height)) return !1;
            n = {
              node: i,
              offsetX: o[0],
              offsetY: o[1]
            };
          }
        }, this), n;
      }
    });

    function k(e, t, n, i, a, s, l, u, c, h) {
      if (l) {
        var d = l.getLayout(),
            f = e.getData();

        if (f.setItemGraphicEl(l.dataIndex, null), d && d.isInView) {
          var p = d.width,
              g = d.height,
              y = d.borderWidth,
              C = d.invisible,
              k = l.getRawIndex(),
              E = u && u.getRawIndex(),
              A = l.viewChildren,
              I = d.upperHeight,
              P = A && A.length,
              O = l.getModel("itemStyle"),
              L = l.getModel("emphasis.itemStyle"),
              D = V("nodeGroup", v);

          if (D) {
            if (c.add(D), D.attr("position", [d.x || 0, d.y || 0]), D.__tmNodeWidth = p, D.__tmNodeHeight = g, d.isAboveViewRoot) return D;
            var N = l.getModel(),
                j = V("background", m, h, 1);
            if (j && function (t, n, i) {
              if (n.dataIndex = l.dataIndex, n.seriesIndex = e.seriesIndex, n.setShape({
                x: 0,
                y: 0,
                width: p,
                height: g
              }), C) F(n);else {
                n.invisible = !1;
                var r = l.getVisual("borderColor", !0),
                    a = L.get("borderColor"),
                    s = T(O);
                s.fill = r;
                var u = S(L);

                if (u.fill = a, i) {
                  var c = p - 2 * y;
                  z(s, u, r, c, I, {
                    x: y,
                    y: 0,
                    width: c,
                    height: I
                  });
                } else s.text = u.text = null;

                n.setStyle(s), o.setElementHoverStyle(n, u);
              }
              t.add(n);
            }(D, j, P && d.upperLabelHeight), P) o.isHighDownDispatcher(D) && o.setAsHighDownDispatcher(D, !1), j && (o.setAsHighDownDispatcher(j, !0), f.setItemGraphicEl(l.dataIndex, j));else {
              var R = V("content", m, h, 2);
              R && function (t, n) {
                n.dataIndex = l.dataIndex, n.seriesIndex = e.seriesIndex;
                var i = Math.max(p - 2 * y, 0),
                    r = Math.max(g - 2 * y, 0);
                if (n.culling = !0, n.setShape({
                  x: y,
                  y: y,
                  width: i,
                  height: r
                }), C) F(n);else {
                  n.invisible = !1;
                  var a = l.getVisual("color", !0),
                      s = T(O);
                  s.fill = a;
                  var u = S(L);
                  z(s, u, a, i, r), n.setStyle(s), o.setElementHoverStyle(n, u);
                }
                t.add(n);
              }(D, R), j && o.isHighDownDispatcher(j) && o.setAsHighDownDispatcher(j, !1), o.setAsHighDownDispatcher(D, !0), f.setItemGraphicEl(l.dataIndex, D);
            }
            return D;
          }
        }
      }

      function F(e) {
        !e.invisible && s.push(e);
      }

      function z(t, n, i, a, s, u) {
        var c = N.get("name"),
            h = N.getModel(u ? b : x),
            f = N.getModel(u ? w : _),
            p = h.getShallow("show");
        o.setLabelStyle(t, n, h, f, {
          defaultText: p ? c : null,
          autoColor: i,
          isRectText: !0,
          labelFetcher: e,
          labelDataIndex: l.dataIndex,
          labelProp: u ? "upperLabel" : "label"
        }), B(t, u, d), B(n, u, d), u && (t.textRect = r.clone(u)), t.truncate = p && h.get("ellipsis") ? {
          outerWidth: a,
          outerHeight: s,
          minChar: 2
        } : null;
      }

      function B(t, n, i) {
        var r = t.text;

        if (!n && i.isLeafRoot && null != r) {
          var o = e.get("drillDownIcon", !0);
          t.text = o ? o + " " + r : r;
        }
      }

      function V(e, o, s, u) {
        var c = null != E && n[e][E],
            h = a[e];
        return c ? (n[e][E] = null, function (e, t, n) {
          (e[k] = {}).old = "nodeGroup" === n ? t.position.slice() : r.extend({}, t.shape);
        }(h, c, e)) : C || ((c = new o({
          z: M(s, u)
        })).__tmDepth = s, c.__tmStorageName = e, function (e, t, n) {
          var r = e[k] = {},
              o = l.parentNode;

          if (o && (!i || "drillDown" === i.direction)) {
            var s = 0,
                u = 0,
                c = a.background[o.getRawIndex()];
            !i && c && c.old && (s = c.old.width, u = c.old.height), r.old = "nodeGroup" === n ? [0, u] : {
              x: s,
              y: u,
              width: 0,
              height: 0
            };
          }

          r.fadein = "nodeGroup" !== n;
        }(h, 0, e)), t[e][k] = c;
      }
    }

    function M(e, t) {
      var n = 10 * e + t;
      return (n - 1) / n;
    }

    e.exports = C;
  }, function (e, t, n) {
    var i = n(5),
        r = n(14),
        o = n(1),
        a = n(90).wrapTreePathInfo;

    function s(e) {
      this.group = new i.Group(), e.add(this.group);
    }

    function l(e, t, n, i, r, o) {
      var a = [[r ? e : e - 5, t], [e + n, t], [e + n, t + i], [r ? e : e - 5, t + i]];
      return !o && a.splice(2, 0, [e + n + 5, t + i / 2]), !r && a.push([e, t + i / 2]), a;
    }

    function u(e, t, n) {
      e.eventData = {
        componentType: "series",
        componentSubType: "treemap",
        componentIndex: t.componentIndex,
        seriesIndex: t.componentIndex,
        seriesName: t.name,
        seriesType: "treemap",
        selfType: "breadcrumb",
        nodeData: {
          dataIndex: n && n.dataIndex,
          name: n && n.name
        },
        treePathInfo: n && a(n, t)
      };
    }

    s.prototype = {
      constructor: s,
      render: function render(e, t, n, i) {
        var o = e.getModel("breadcrumb"),
            a = this.group;

        if (a.removeAll(), o.get("show") && n) {
          var s = o.getModel("itemStyle"),
              l = s.getModel("textStyle"),
              u = {
            pos: {
              left: o.get("left"),
              right: o.get("right"),
              top: o.get("top"),
              bottom: o.get("bottom")
            },
            box: {
              width: t.getWidth(),
              height: t.getHeight()
            },
            emptyItemWidth: o.get("emptyItemWidth"),
            totalWidth: 0,
            renderList: []
          };
          this._prepare(n, u, l), this._renderContent(e, u, s, l, i), r.positionElement(a, u.pos, u.box);
        }
      },
      _prepare: function _prepare(e, t, n) {
        for (var i = e; i; i = i.parentNode) {
          var r = i.getModel().get("name"),
              o = n.getTextRect(r),
              a = Math.max(o.width + 16, t.emptyItemWidth);
          t.totalWidth += a + 8, t.renderList.push({
            node: i,
            text: r,
            width: a
          });
        }
      },
      _renderContent: function _renderContent(e, t, n, a, s) {
        for (var c = 0, h = t.emptyItemWidth, d = e.get("breadcrumb.height"), f = r.getAvailableSize(t.pos, t.box), p = t.totalWidth, g = t.renderList, v = g.length - 1; v >= 0; v--) {
          var m = g[v],
              y = m.node,
              x = m.width,
              _ = m.text;
          p > f.width && (p -= x - h, x = h, _ = null);
          var b = new i.Polygon({
            shape: {
              points: l(c, 0, x, d, v === g.length - 1, 0 === v)
            },
            style: o.defaults(n.getItemStyle(), {
              lineJoin: "bevel",
              text: _,
              textFill: a.getTextColor(),
              textFont: a.getFont()
            }),
            z: 10,
            onclick: o.curry(s, y)
          });
          this.group.add(b), u(b, e, y), c += x + 8;
        }
      },
      remove: function remove() {
        this.group.removeAll();
      }
    };
    var c = s;
    e.exports = c;
  }, function (e, t, n) {
    var i = n(1);

    t.createWrap = function () {
      var e,
          t = [],
          n = {};
      return {
        add: function add(e, r, o, a, s) {
          return i.isString(a) && (s = a, a = 0), !n[e.id] && (n[e.id] = 1, t.push({
            el: e,
            target: r,
            time: o,
            delay: a,
            easing: s
          }), !0);
        },
        done: function done(t) {
          return e = t, this;
        },
        start: function start() {
          for (var i = t.length, r = 0, o = t.length; r < o; r++) {
            var a = t[r];
            a.el.animateTo(a.target, a.time, a.delay, a.easing, s);
          }

          return this;

          function s() {
            --i || (t.length = 0, n = {}, e && e());
          }
        }
      };
    };
  }, function (e, t, n) {
    for (var i = n(4), r = n(90), o = function o() {}, a = ["treemapZoomToNode", "treemapRender", "treemapMove"], s = 0; s < a.length; s++) {
      i.registerAction({
        type: a[s],
        update: "updateView"
      }, o);
    }

    i.registerAction({
      type: "treemapRootToNode",
      update: "updateView"
    }, function (e, t) {
      t.eachComponent({
        mainType: "series",
        subType: "treemap",
        query: e
      }, function (t, n) {
        var i = r.retrieveTargetInfo(e, ["treemapZoomToNode", "treemapRootToNode"], t);

        if (i) {
          var o = t.getViewRoot();
          o && (e.direction = r.aboveViewRoot(o, i.node) ? "rollUp" : "drillDown"), t.resetViewRoot(i.node);
        }
      });
    });
  }, function (e, t, n) {
    var i = n(91),
        r = n(53),
        o = n(1),
        a = o.isArray,
        s = {
      seriesType: "treemap",
      reset: function reset(e, t, n, a) {
        var s = e.getData().tree,
            u = s.root,
            h = e.getModel("itemStyle");
        u.isRemoved() || function e(t, n, a, s, u, h) {
          var d = t.getModel(),
              f = t.getLayout();
          if (!f || f.invisible || !f.isInView) return;

          var p,
              g = t.getModel("itemStyle"),
              v = a[t.depth],
              m = function (e, t, n, i) {
            var r = o.extend({}, t);
            return o.each(["color", "colorAlpha", "colorSaturation"], function (o) {
              var a = e.get(o, !0);
              null == a && n && (a = n[o]), null == a && (a = t[o]), null == a && (a = i.get(o)), null != a && (r[o] = a);
            }), r;
          }(g, n, v, s),
              y = g.get("borderColor"),
              x = g.get("borderColorSaturation");

          null != x && (p = l(m), y = function (e, t) {
            return null != t ? r.modifyHSL(t, null, null, e) : null;
          }(x, p));
          t.setVisual("borderColor", y);
          var _ = t.viewChildren;

          if (_ && _.length) {
            var b = function (e, t, n, r, o, a) {
              if (!a || !a.length) return;
              var s = c(t, "color") || null != o.color && "none" !== o.color && (c(t, "colorAlpha") || c(t, "colorSaturation"));
              if (!s) return;
              var l = t.get("visualMin"),
                  u = t.get("visualMax"),
                  h = n.dataExtent.slice();
              null != l && l < h[0] && (h[0] = l), null != u && u > h[1] && (h[1] = u);
              var d = t.get("colorMappingBy"),
                  f = {
                type: s.name,
                dataExtent: h,
                visual: s.range
              };
              "color" !== f.type || "index" !== d && "id" !== d ? f.mappingMethod = "linear" : (f.mappingMethod = "category", f.loop = !0);
              var p = new i(f);
              return p.__drColorMappingBy = d, p;
            }(0, d, f, 0, m, _);

            o.each(_, function (t, n) {
              if (t.depth >= u.length || t === u[t.depth]) {
                var i = function (e, t, n, i, r, a) {
                  var s = o.extend({}, t);

                  if (r) {
                    var l = r.type,
                        u = "color" === l && r.__drColorMappingBy,
                        c = "index" === u ? i : "id" === u ? a.mapIdToIndex(n.getId()) : n.getValue(e.get("visualDimension"));
                    s[l] = r.mapValueToVisual(c);
                  }

                  return s;
                }(d, m, t, n, b, h);

                e(t, i, a, s, u, h);
              }
            });
          } else p = l(m), t.setVisual("color", p);
        }(u, {}, o.map(s.levelModels, function (e) {
          return e ? e.get("itemStyle") : null;
        }), h, e.getViewRoot().getAncestors(), e);
      }
    };

    function l(e) {
      var t = u(e, "color");

      if (t) {
        var n = u(e, "colorAlpha"),
            i = u(e, "colorSaturation");
        return i && (t = r.modifyHSL(t, null, null, i)), n && (t = r.modifyAlpha(t, n)), t;
      }
    }

    function u(e, t) {
      var n = e[t];
      if (null != n && "none" !== n) return n;
    }

    function c(e, t) {
      var n = e.get(t);
      return a(n) && n.length ? {
        name: t,
        range: n
      } : null;
    }

    e.exports = s;
  }, function (e, t, n) {
    var i = n(1),
        r = n(17),
        o = n(6),
        a = o.parsePercent,
        s = o.MAX_SAFE_INTEGER,
        l = n(14),
        u = n(90),
        c = Math.max,
        h = Math.min,
        d = i.retrieve,
        f = i.each,
        p = ["itemStyle", "borderWidth"],
        g = ["itemStyle", "gapWidth"],
        v = ["upperLabel", "show"],
        m = ["upperLabel", "height"],
        y = {
      seriesType: "treemap",
      reset: function reset(e, t, n, o) {
        var v = n.getWidth(),
            m = n.getHeight(),
            y = e.option,
            S = l.getLayoutRect(e.getBoxLayoutParams(), {
          width: n.getWidth(),
          height: n.getHeight()
        }),
            T = y.size || [],
            C = a(d(S.width, T[0]), v),
            k = a(d(S.height, T[1]), m),
            M = o && o.type,
            E = u.retrieveTargetInfo(o, ["treemapZoomToNode", "treemapRootToNode"], e),
            A = "treemapRender" === M || "treemapMove" === M ? o.rootRect : null,
            I = e.getViewRoot(),
            P = u.getPathToRoot(I);

        if ("treemapMove" !== M) {
          var O = "treemapZoomToNode" === M ? function (e, t, n, i, r) {
            var o,
                a = (t || {}).node,
                l = [i, r];
            if (!a || a === n) return l;
            var u = i * r,
                c = u * e.option.zoomToNodeRatio;

            for (; o = a.parentNode;) {
              for (var h = 0, d = o.children, f = 0, g = d.length; f < g; f++) {
                h += d[f].getValue();
              }

              var v = a.getValue();
              if (0 === v) return l;
              c *= h / v;
              var m = o.getModel(),
                  y = m.get(p),
                  x = Math.max(y, w(m));
              (c += 4 * y * y + (3 * y + x) * Math.pow(c, .5)) > s && (c = s), a = o;
            }

            c < u && (c = u);

            var _ = Math.pow(c / u, .5);

            return [i * _, r * _];
          }(e, E, I, C, k) : A ? [A.width, A.height] : [C, k],
              L = y.sort;
          L && "asc" !== L && "desc" !== L && (L = "desc");
          var D = {
            squareRatio: y.squareRatio,
            sort: L,
            leafDepth: y.leafDepth
          };
          I.hostTree.clearLayouts();
          var N = {
            x: 0,
            y: 0,
            width: O[0],
            height: O[1],
            area: O[0] * O[1]
          };
          I.setLayout(N), function e(t, n, i, r) {
            var o, a;
            if (t.isRemoved()) return;
            var s = t.getLayout();
            o = s.width, a = s.height;
            var l = (y = t.getModel()).get(p),
                u = y.get(g) / 2,
                d = w(y),
                f = Math.max(l, d),
                v = l - u,
                m = f - u,
                y = t.getModel();
            t.setLayout({
              borderWidth: l,
              upperHeight: f,
              upperLabelHeight: d
            }, !0), o = c(o - 2 * v, 0), a = c(a - v - m, 0);
            var S = o * a,
                T = x(t, y, S, n, i, r);
            if (!T.length) return;
            var C = {
              x: v,
              y: m,
              width: o,
              height: a
            },
                k = h(o, a),
                M = 1 / 0,
                E = [];
            E.area = 0;

            for (var A = 0, I = T.length; A < I;) {
              var P = T[A];
              E.push(P), E.area += P.getLayout().area;

              var O = _(E, k, n.squareRatio);

              O <= M ? (A++, M = O) : (E.area -= E.pop().getLayout().area, b(E, k, C, u, !1), k = h(C.width, C.height), E.length = E.area = 0, M = 1 / 0);
            }

            E.length && b(E, k, C, u, !0);

            if (!i) {
              var L = y.get("childrenVisibleMin");
              null != L && S < L && (i = !0);
            }

            for (A = 0, I = T.length; A < I; A++) {
              e(T[A], n, i, r + 1);
            }
          }(I, D, !1, 0);
          N = I.getLayout();
          f(P, function (e, t) {
            var n = (P[t + 1] || I).getValue();
            e.setLayout(i.extend({
              dataExtent: [n, n],
              borderWidth: 0,
              upperHeight: 0
            }, N));
          });
        }

        var j = e.getData().tree.root;
        j.setLayout(function (e, t, n) {
          if (t) return {
            x: t.x,
            y: t.y
          };
          var i = {
            x: 0,
            y: 0
          };
          if (!n) return i;
          var r = n.node,
              o = r.getLayout();
          if (!o) return i;
          var a = [o.width / 2, o.height / 2],
              s = r;

          for (; s;) {
            var l = s.getLayout();
            a[0] += l.x, a[1] += l.y, s = s.parentNode;
          }

          return {
            x: e.width / 2 - a[0],
            y: e.height / 2 - a[1]
          };
        }(S, A, E), !0), e.setLayoutInfo(S), function e(t, n, i, o, a) {
          var s = t.getLayout(),
              l = i[a],
              u = l && l === t;
          if (l && !u || a === i.length && t !== o) return;
          t.setLayout({
            isInView: !0,
            invisible: !u && !n.intersect(s),
            isAboveViewRoot: u
          }, !0);
          var c = new r(n.x - s.x, n.y - s.y, n.width, n.height);
          f(t.viewChildren || [], function (t) {
            e(t, c, i, o, a + 1);
          });
        }(j, new r(-S.x, -S.y, v, m), P, I, 0);
      }
    };

    function x(e, t, n, r, o, a) {
      var s = e.children || [],
          l = r.sort;
      "asc" !== l && "desc" !== l && (l = null);
      var u = null != r.leafDepth && r.leafDepth <= a;
      if (o && !u) return e.viewChildren = [];
      !function (e, t) {
        t && e.sort(function (e, n) {
          var i = "asc" === t ? e.getValue() - n.getValue() : n.getValue() - e.getValue();
          return 0 === i ? "asc" === t ? e.dataIndex - n.dataIndex : n.dataIndex - e.dataIndex : i;
        });
      }(s = i.filter(s, function (e) {
        return !e.isRemoved();
      }), l);

      var c = function (e, t, n) {
        for (var i = 0, r = 0, o = t.length; r < o; r++) {
          i += t[r].getValue();
        }

        var a = e.get("visualDimension");
        if (t && t.length) {
          if ("value" === a && n) s = [t[t.length - 1].getValue(), t[0].getValue()], "asc" === n && s.reverse();else {
            var s = [1 / 0, -1 / 0];
            f(t, function (e) {
              var t = e.getValue(a);
              t < s[0] && (s[0] = t), t > s[1] && (s[1] = t);
            });
          }
        } else s = [NaN, NaN];
        return {
          sum: i,
          dataExtent: s
        };
      }(t, s, l);

      if (0 === c.sum) return e.viewChildren = [];
      if (c.sum = function (e, t, n, i, r) {
        if (!i) return n;

        for (var o = e.get("visibleMin"), a = r.length, s = a, l = a - 1; l >= 0; l--) {
          var u = r["asc" === i ? a - l - 1 : l].getValue();
          u / n * t < o && (s = l, n -= u);
        }

        return "asc" === i ? r.splice(0, a - s) : r.splice(s, a - s), n;
      }(t, n, c.sum, l, s), 0 === c.sum) return e.viewChildren = [];

      for (var h = 0, d = s.length; h < d; h++) {
        var p = s[h].getValue() / c.sum * n;
        s[h].setLayout({
          area: p
        });
      }

      return u && (s.length && e.setLayout({
        isLeafRoot: !0
      }, !0), s.length = 0), e.viewChildren = s, e.setLayout({
        dataExtent: c.dataExtent
      }, !0), s;
    }

    function _(e, t, n) {
      for (var i, r = 0, o = 1 / 0, a = 0, s = e.length; a < s; a++) {
        (i = e[a].getLayout().area) && (i < o && (o = i), i > r && (r = i));
      }

      var l = e.area * e.area,
          u = t * t * n;
      return l ? c(u * r / l, l / (u * o)) : 1 / 0;
    }

    function b(e, t, n, i, r) {
      var o = t === n.width ? 0 : 1,
          a = 1 - o,
          s = ["x", "y"],
          l = ["width", "height"],
          u = n[s[o]],
          d = t ? e.area / t : 0;
      (r || d > n[l[a]]) && (d = n[l[a]]);

      for (var f = 0, p = e.length; f < p; f++) {
        var g = e[f],
            v = {},
            m = d ? g.getLayout().area / d : 0,
            y = v[l[a]] = c(d - 2 * i, 0),
            x = n[s[o]] + n[l[o]] - u,
            _ = f === p - 1 || x < m ? x : m,
            b = v[l[o]] = c(_ - 2 * i, 0);

        v[s[a]] = n[s[a]] + h(i, y / 2), v[s[o]] = u + h(i, b / 2), u += _, g.setLayout(v, !0);
      }

      n[s[a]] += d, n[l[a]] -= d;
    }

    function w(e) {
      return e.get(v) ? e.get(m) : 0;
    }

    e.exports = y;
  }, function (e, t, n) {
    var i = n(4);
    n(755), n(757), n(760);
    var r = n(761),
        o = n(88),
        a = n(762),
        s = n(763),
        l = n(764),
        u = n(765),
        c = n(766),
        h = n(768);
    i.registerProcessor(r), i.registerVisual(o("graph", "circle", null)), i.registerVisual(a), i.registerVisual(s), i.registerLayout(l), i.registerLayout(i.PRIORITY.VISUAL.POST_CHART_LAYOUT, u), i.registerLayout(c), i.registerCoordinateSystem("graphView", {
      create: h
    });
  }, function (e, t, n) {
    var i = n(4),
        r = n(39),
        o = n(1),
        a = n(8).defaultEmphasis,
        s = n(22),
        l = n(15).encodeHTML,
        u = n(333),
        c = n(129),
        h = i.extendSeriesModel({
      type: "series.graph",
      init: function init(e) {
        h.superApply(this, "init", arguments);
        var t = this;

        function n() {
          return t._categoriesData;
        }

        this.legendVisualProvider = new c(n, n), this.fillDataTextStyle(e.edges || e.links), this._updateCategoriesData();
      },
      mergeOption: function mergeOption(e) {
        h.superApply(this, "mergeOption", arguments), this.fillDataTextStyle(e.edges || e.links), this._updateCategoriesData();
      },
      mergeDefaultAndTheme: function mergeDefaultAndTheme(e) {
        h.superApply(this, "mergeDefaultAndTheme", arguments), a(e, ["edgeLabel"], ["show"]);
      },
      getInitialData: function getInitialData(e, t) {
        var n = e.edges || e.links || [],
            i = e.data || e.nodes || [],
            r = this;
        if (i && n) return u(i, n, this, !0, function (e, n) {
          e.wrapMethod("getItemModel", function (e) {
            var t = r._categoriesModels[e.getShallow("category")];

            return t && (t.parentModel = e.parentModel, e.parentModel = t), e;
          });
          var i = r.getModel("edgeLabel"),
              o = new s({
            label: i.option
          }, i.parentModel, t),
              a = r.getModel("emphasis.edgeLabel"),
              l = new s({
            emphasis: {
              label: a.option
            }
          }, a.parentModel, t);

          function u(e) {
            return (e = this.parsePath(e)) && "label" === e[0] ? o : e && "emphasis" === e[0] && "label" === e[1] ? l : this.parentModel;
          }

          n.wrapMethod("getItemModel", function (e) {
            return e.customizeGetParent(u), e;
          });
        }).data;
      },
      getGraph: function getGraph() {
        return this.getData().graph;
      },
      getEdgeData: function getEdgeData() {
        return this.getGraph().edgeData;
      },
      getCategoriesData: function getCategoriesData() {
        return this._categoriesData;
      },
      formatTooltip: function formatTooltip(e, t, n) {
        if ("edge" === n) {
          var i = this.getData(),
              r = this.getDataParams(e, n),
              o = i.graph.getEdgeByIndex(e),
              a = i.getName(o.node1.dataIndex),
              s = i.getName(o.node2.dataIndex),
              u = [];
          return null != a && u.push(a), null != s && u.push(s), u = l(u.join(" > ")), r.value && (u += " : " + l(r.value)), u;
        }

        return h.superApply(this, "formatTooltip", arguments);
      },
      _updateCategoriesData: function _updateCategoriesData() {
        var e = o.map(this.option.categories || [], function (e) {
          return null != e.value ? e : o.extend({
            value: 0
          }, e);
        }),
            t = new r(["value"], this);
        t.initData(e), this._categoriesData = t, this._categoriesModels = t.mapArray(function (e) {
          return t.getItemModel(e, !0);
        });
      },
      setZoom: function setZoom(e) {
        this.option.zoom = e;
      },
      setCenter: function setCenter(e) {
        this.option.center = e;
      },
      isAnimationEnabled: function isAnimationEnabled() {
        return h.superCall(this, "isAnimationEnabled") && !("force" === this.get("layout") && this.get("force.layoutAnimation"));
      },
      defaultOption: {
        zlevel: 0,
        z: 2,
        coordinateSystem: "view",
        legendHoverLink: !0,
        hoverAnimation: !0,
        layout: null,
        focusNodeAdjacency: !1,
        circular: {
          rotateLabel: !1
        },
        force: {
          initLayout: null,
          repulsion: [0, 50],
          gravity: .1,
          friction: .6,
          edgeLength: 30,
          layoutAnimation: !0
        },
        left: "center",
        top: "center",
        symbol: "circle",
        symbolSize: 10,
        edgeSymbol: ["none", "none"],
        edgeSymbolSize: 10,
        edgeLabel: {
          position: "middle",
          distance: 5
        },
        draggable: !1,
        roam: !1,
        center: null,
        zoom: 1,
        nodeScaleRatio: .6,
        label: {
          show: !1,
          formatter: "{b}"
        },
        itemStyle: {},
        lineStyle: {
          color: "#aaa",
          width: 1,
          curveness: 0,
          opacity: .5
        },
        emphasis: {
          label: {
            show: !0
          }
        }
      }
    }),
        d = h;
    e.exports = d;
  }, function (e, t, n) {
    n(9).__DEV__;
    var i = n(1),
        r = n(60).enableClassCheck;

    function o(e) {
      return "_EC_" + e;
    }

    var a = function a(e) {
      this._directed = e || !1, this.nodes = [], this.edges = [], this._nodesMap = {}, this._edgesMap = {}, this.data, this.edgeData;
    },
        s = a.prototype;

    function l(e, t) {
      this.id = null == e ? "" : e, this.inEdges = [], this.outEdges = [], this.edges = [], this.hostGraph, this.dataIndex = null == t ? -1 : t;
    }

    function u(e, t, n) {
      this.node1 = e, this.node2 = t, this.dataIndex = null == n ? -1 : n;
    }

    s.type = "graph", s.isDirected = function () {
      return this._directed;
    }, s.addNode = function (e, t) {
      e = null == e ? "" + t : "" + e;
      var n = this._nodesMap;

      if (!n[o(e)]) {
        var i = new l(e, t);
        return i.hostGraph = this, this.nodes.push(i), n[o(e)] = i, i;
      }
    }, s.getNodeByIndex = function (e) {
      var t = this.data.getRawIndex(e);
      return this.nodes[t];
    }, s.getNodeById = function (e) {
      return this._nodesMap[o(e)];
    }, s.addEdge = function (e, t, n) {
      var i = this._nodesMap,
          r = this._edgesMap;

      if ("number" == typeof e && (e = this.nodes[e]), "number" == typeof t && (t = this.nodes[t]), l.isInstance(e) || (e = i[o(e)]), l.isInstance(t) || (t = i[o(t)]), e && t) {
        var a = e.id + "-" + t.id;

        if (!r[a]) {
          var s = new u(e, t, n);
          return s.hostGraph = this, this._directed && (e.outEdges.push(s), t.inEdges.push(s)), e.edges.push(s), e !== t && t.edges.push(s), this.edges.push(s), r[a] = s, s;
        }
      }
    }, s.getEdgeByIndex = function (e) {
      var t = this.edgeData.getRawIndex(e);
      return this.edges[t];
    }, s.getEdge = function (e, t) {
      l.isInstance(e) && (e = e.id), l.isInstance(t) && (t = t.id);
      var n = this._edgesMap;
      return this._directed ? n[e + "-" + t] : n[e + "-" + t] || n[t + "-" + e];
    }, s.eachNode = function (e, t) {
      for (var n = this.nodes, i = n.length, r = 0; r < i; r++) {
        n[r].dataIndex >= 0 && e.call(t, n[r], r);
      }
    }, s.eachEdge = function (e, t) {
      for (var n = this.edges, i = n.length, r = 0; r < i; r++) {
        n[r].dataIndex >= 0 && n[r].node1.dataIndex >= 0 && n[r].node2.dataIndex >= 0 && e.call(t, n[r], r);
      }
    }, s.breadthFirstTraverse = function (e, t, n, i) {
      if (l.isInstance(t) || (t = this._nodesMap[o(t)]), t) {
        for (var r = "out" === n ? "outEdges" : "in" === n ? "inEdges" : "edges", a = 0; a < this.nodes.length; a++) {
          this.nodes[a].__visited = !1;
        }

        if (!e.call(i, t, null)) for (var s = [t]; s.length;) {
          var u = s.shift(),
              c = u[r];

          for (a = 0; a < c.length; a++) {
            var h = c[a],
                d = h.node1 === u ? h.node2 : h.node1;

            if (!d.__visited) {
              if (e.call(i, d, u)) return;
              s.push(d), d.__visited = !0;
            }
          }
        }
      }
    }, s.update = function () {
      for (var e = this.data, t = this.edgeData, n = this.nodes, i = this.edges, r = 0, o = n.length; r < o; r++) {
        n[r].dataIndex = -1;
      }

      for (r = 0, o = e.count(); r < o; r++) {
        n[e.getRawIndex(r)].dataIndex = r;
      }

      t.filterSelf(function (e) {
        var n = i[t.getRawIndex(e)];
        return n.node1.dataIndex >= 0 && n.node2.dataIndex >= 0;
      });

      for (r = 0, o = i.length; r < o; r++) {
        i[r].dataIndex = -1;
      }

      for (r = 0, o = t.count(); r < o; r++) {
        i[t.getRawIndex(r)].dataIndex = r;
      }
    }, s.clone = function () {
      for (var e = new a(this._directed), t = this.nodes, n = this.edges, i = 0; i < t.length; i++) {
        e.addNode(t[i].id, t[i].dataIndex);
      }

      for (i = 0; i < n.length; i++) {
        var r = n[i];
        e.addEdge(r.node1.id, r.node2.id, r.dataIndex);
      }

      return e;
    }, l.prototype = {
      constructor: l,
      degree: function degree() {
        return this.edges.length;
      },
      inDegree: function inDegree() {
        return this.inEdges.length;
      },
      outDegree: function outDegree() {
        return this.outEdges.length;
      },
      getModel: function getModel(e) {
        if (!(this.dataIndex < 0)) return this.hostGraph.data.getItemModel(this.dataIndex).getModel(e);
      }
    }, u.prototype.getModel = function (e) {
      if (!(this.dataIndex < 0)) return this.hostGraph.edgeData.getItemModel(this.dataIndex).getModel(e);
    };

    var c = function c(e, t) {
      return {
        getValue: function getValue(n) {
          var i = this[e][t];
          return i.get(i.getDimension(n || "value"), this.dataIndex);
        },
        setVisual: function setVisual(n, i) {
          this.dataIndex >= 0 && this[e][t].setItemVisual(this.dataIndex, n, i);
        },
        getVisual: function getVisual(n, i) {
          return this[e][t].getItemVisual(this.dataIndex, n, i);
        },
        setLayout: function setLayout(n, i) {
          this.dataIndex >= 0 && this[e][t].setItemLayout(this.dataIndex, n, i);
        },
        getLayout: function getLayout() {
          return this[e][t].getItemLayout(this.dataIndex);
        },
        getGraphicEl: function getGraphicEl() {
          return this[e][t].getItemGraphicEl(this.dataIndex);
        },
        getRawIndex: function getRawIndex() {
          return this[e][t].getRawIndex(this.dataIndex);
        }
      };
    };

    i.mixin(l, c("hostGraph", "data")), i.mixin(u, c("hostGraph", "edgeData")), a.Node = l, a.Edge = u, r(l), r(u);
    var h = a;
    e.exports = h;
  }, function (e, t, n) {
    var i = n(4),
        r = n(1),
        o = n(125),
        a = n(221),
        s = n(131),
        l = n(216),
        u = n(167).onIrrelevantElement,
        c = n(5),
        h = n(759),
        d = n(223).getNodeGlobalScale,
        f = "__focusNodeAdjacency",
        p = ["itemStyle", "opacity"],
        g = ["lineStyle", "opacity"];

    function v(e, t) {
      var n = e.getVisual("opacity");
      return null != n ? n : e.getModel().get(t);
    }

    function m(e, t, n) {
      var i = e.getGraphicEl(),
          r = v(e, t);
      null != n && (null == r && (r = 1), r *= n), i.downplay && i.downplay(), i.traverse(function (e) {
        if (!e.isGroup) {
          var t = e.lineLabelOriginalOpacity;
          null != t && null == n || (t = r), e.setStyle("opacity", t);
        }
      });
    }

    function y(e, t) {
      var n = v(e, t),
          i = e.getGraphicEl();
      i.traverse(function (e) {
        !e.isGroup && e.setStyle("opacity", n);
      }), i.highlight && i.highlight();
    }

    var x = i.extendChartView({
      type: "graph",
      init: function init(e, t) {
        var n = new o(),
            i = new a(),
            r = this.group;
        this._controller = new s(t.getZr()), this._controllerHost = {
          target: r
        }, r.add(n.group), r.add(i.group), this._symbolDraw = n, this._lineDraw = i, this._firstRender = !0;
      },
      render: function render(e, t, n) {
        var i = this,
            r = e.coordinateSystem;
        this._model = e;
        var o = this._symbolDraw,
            a = this._lineDraw,
            s = this.group;

        if ("view" === r.type) {
          var l = {
            position: r.position,
            scale: r.scale
          };
          this._firstRender ? s.attr(l) : c.updateProps(s, l, e);
        }

        h(e.getGraph(), d(e));
        var u = e.getData();
        o.updateData(u);
        var p = e.getEdgeData();
        a.updateData(p), this._updateNodeAndLinkScale(), this._updateController(e, t, n), clearTimeout(this._layoutTimeout);
        var g = e.forceLayout,
            v = e.get("force.layoutAnimation");
        g && this._startForceLayoutIteration(g, v), u.eachItemGraphicEl(function (t, r) {
          var o = u.getItemModel(r);
          t.off("drag").off("dragend");
          var a = o.get("draggable");
          a && t.on("drag", function () {
            g && (g.warmUp(), !this._layouting && this._startForceLayoutIteration(g, v), g.setFixed(r), u.setItemLayout(r, t.position));
          }, this).on("dragend", function () {
            g && g.setUnfixed(r);
          }, this), t.setDraggable(a && g), t[f] && t.off("mouseover", t[f]), t.__unfocusNodeAdjacency && t.off("mouseout", t.__unfocusNodeAdjacency), o.get("focusNodeAdjacency") && (t.on("mouseover", t[f] = function () {
            i._clearTimer(), n.dispatchAction({
              type: "focusNodeAdjacency",
              seriesId: e.id,
              dataIndex: t.dataIndex
            });
          }), t.on("mouseout", t.__unfocusNodeAdjacency = function () {
            i._dispatchUnfocus(n);
          }));
        }, this), u.graph.eachEdge(function (t) {
          var r = t.getGraphicEl();
          r[f] && r.off("mouseover", r[f]), r.__unfocusNodeAdjacency && r.off("mouseout", r.__unfocusNodeAdjacency), t.getModel().get("focusNodeAdjacency") && (r.on("mouseover", r[f] = function () {
            i._clearTimer(), n.dispatchAction({
              type: "focusNodeAdjacency",
              seriesId: e.id,
              edgeDataIndex: t.dataIndex
            });
          }), r.on("mouseout", r.__unfocusNodeAdjacency = function () {
            i._dispatchUnfocus(n);
          }));
        });
        var m = "circular" === e.get("layout") && e.get("circular.rotateLabel"),
            y = u.getLayout("cx"),
            x = u.getLayout("cy");
        u.eachItemGraphicEl(function (e, t) {
          var n = u.getItemModel(t).get("label.rotate") || 0,
              i = e.getSymbolPath();

          if (m) {
            var r = u.getItemLayout(t),
                o = Math.atan2(r[1] - x, r[0] - y);
            o < 0 && (o = 2 * Math.PI + o);
            var a = r[0] < y;
            a && (o -= Math.PI);
            var s = a ? "left" : "right";
            c.modifyLabelStyle(i, {
              textRotation: -o,
              textPosition: s,
              textOrigin: "center"
            }, {
              textPosition: s
            });
          } else c.modifyLabelStyle(i, {
            textRotation: n *= Math.PI / 180
          });
        }), this._firstRender = !1;
      },
      dispose: function dispose() {
        this._controller && this._controller.dispose(), this._controllerHost = {}, this._clearTimer();
      },
      _dispatchUnfocus: function _dispatchUnfocus(e, t) {
        var n = this;
        this._clearTimer(), this._unfocusDelayTimer = setTimeout(function () {
          n._unfocusDelayTimer = null, e.dispatchAction({
            type: "unfocusNodeAdjacency",
            seriesId: n._model.id
          });
        }, 500);
      },
      _clearTimer: function _clearTimer() {
        this._unfocusDelayTimer && (clearTimeout(this._unfocusDelayTimer), this._unfocusDelayTimer = null);
      },
      focusNodeAdjacency: function focusNodeAdjacency(e, t, n, i) {
        var o = e.getData().graph,
            a = i.dataIndex,
            s = i.edgeDataIndex,
            l = o.getNodeByIndex(a),
            u = o.getEdgeByIndex(s);
        (l || u) && (o.eachNode(function (e) {
          m(e, p, .1);
        }), o.eachEdge(function (e) {
          m(e, g, .1);
        }), l && (y(l, p), r.each(l.edges, function (e) {
          e.dataIndex < 0 || (y(e, g), y(e.node1, p), y(e.node2, p));
        })), u && (y(u, g), y(u.node1, p), y(u.node2, p)));
      },
      unfocusNodeAdjacency: function unfocusNodeAdjacency(e, t, n, i) {
        var r = e.getData().graph;
        r.eachNode(function (e) {
          m(e, p);
        }), r.eachEdge(function (e) {
          m(e, g);
        });
      },
      _startForceLayoutIteration: function _startForceLayoutIteration(e, t) {
        var n = this;
        !function i() {
          e.step(function (e) {
            n.updateLayout(n._model), (n._layouting = !e) && (t ? n._layoutTimeout = setTimeout(i, 16) : i());
          });
        }();
      },
      _updateController: function _updateController(e, t, n) {
        var i = this._controller,
            r = this._controllerHost,
            o = this.group;
        i.setPointerChecker(function (t, i, r) {
          var a = o.getBoundingRect();
          return a.applyTransform(o.transform), a.contain(i, r) && !u(t, n, e);
        }), "view" === e.coordinateSystem.type ? (i.enable(e.get("roam")), r.zoomLimit = e.get("scaleLimit"), r.zoom = e.coordinateSystem.getZoom(), i.off("pan").off("zoom").on("pan", function (t) {
          l.updateViewOnPan(r, t.dx, t.dy), n.dispatchAction({
            seriesId: e.id,
            type: "graphRoam",
            dx: t.dx,
            dy: t.dy
          });
        }).on("zoom", function (t) {
          l.updateViewOnZoom(r, t.scale, t.originX, t.originY), n.dispatchAction({
            seriesId: e.id,
            type: "graphRoam",
            zoom: t.scale,
            originX: t.originX,
            originY: t.originY
          }), this._updateNodeAndLinkScale(), h(e.getGraph(), d(e)), this._lineDraw.updateLayout();
        }, this)) : i.disable();
      },
      _updateNodeAndLinkScale: function _updateNodeAndLinkScale() {
        var e = this._model,
            t = e.getData(),
            n = d(e),
            i = [n, n];
        t.eachItemGraphicEl(function (e, t) {
          e.attr("scale", i);
        });
      },
      updateLayout: function updateLayout(e) {
        h(e.getGraph(), d(e)), this._symbolDraw.updateLayout(), this._lineDraw.updateLayout();
      },
      remove: function remove(e, t) {
        this._symbolDraw && this._symbolDraw.remove(), this._lineDraw && this._lineDraw.remove();
      }
    });
    e.exports = x;
  }, function (e, t, n) {
    var i = n(5),
        r = n(16),
        o = i.Line.prototype,
        a = i.BezierCurve.prototype;

    function s(e) {
      return isNaN(+e.cpx1) || isNaN(+e.cpy1);
    }

    var l = i.extendShape({
      type: "ec-line",
      style: {
        stroke: "#000",
        fill: null
      },
      shape: {
        x1: 0,
        y1: 0,
        x2: 0,
        y2: 0,
        percent: 1,
        cpx1: null,
        cpy1: null
      },
      buildPath: function buildPath(e, t) {
        this[s(t) ? "_buildPathLine" : "_buildPathCurve"](e, t);
      },
      _buildPathLine: o.buildPath,
      _buildPathCurve: a.buildPath,
      pointAt: function pointAt(e) {
        return this[s(this.shape) ? "_pointAtLine" : "_pointAtCurve"](e);
      },
      _pointAtLine: o.pointAt,
      _pointAtCurve: a.pointAt,
      tangentAt: function tangentAt(e) {
        var t = this.shape,
            n = s(t) ? [t.x2 - t.x1, t.y2 - t.y1] : this._tangentAtCurve(e);
        return r.normalize(n, n);
      },
      _tangentAtCurve: a.tangentAt
    });
    e.exports = l;
  }, function (e, t, n) {
    var i = n(66),
        r = n(16),
        o = n(223).getSymbolSize,
        a = [],
        s = [],
        l = [],
        u = i.quadraticAt,
        c = r.distSquare,
        h = Math.abs;

    function d(e, t, n) {
      for (var i, r = e[0], o = e[1], d = e[2], f = 1 / 0, p = n * n, g = .1, v = .1; v <= .9; v += .1) {
        a[0] = u(r[0], o[0], d[0], v), a[1] = u(r[1], o[1], d[1], v), (x = h(c(a, t) - p)) < f && (f = x, i = v);
      }

      for (var m = 0; m < 32; m++) {
        var y = i + g;
        s[0] = u(r[0], o[0], d[0], i), s[1] = u(r[1], o[1], d[1], i), l[0] = u(r[0], o[0], d[0], y), l[1] = u(r[1], o[1], d[1], y);
        var x = c(s, t) - p;
        if (h(x) < .01) break;

        var _ = c(l, t) - p;

        g /= 2, x < 0 ? _ >= 0 ? i += g : i -= g : _ >= 0 ? i -= g : i += g;
      }

      return i;
    }

    e.exports = function (e, t) {
      var n = [],
          a = i.quadraticSubdivide,
          s = [[], [], []],
          l = [[], []],
          u = [];
      t /= 2, e.eachEdge(function (e, i) {
        var c = e.getLayout(),
            h = e.getVisual("fromSymbol"),
            f = e.getVisual("toSymbol");
        c.__original || (c.__original = [r.clone(c[0]), r.clone(c[1])], c[2] && c.__original.push(r.clone(c[2])));
        var p = c.__original;

        if (null != c[2]) {
          if (r.copy(s[0], p[0]), r.copy(s[1], p[2]), r.copy(s[2], p[1]), h && "none" !== h) {
            var g = o(e.node1),
                v = d(s, p[0], g * t);
            a(s[0][0], s[1][0], s[2][0], v, n), s[0][0] = n[3], s[1][0] = n[4], a(s[0][1], s[1][1], s[2][1], v, n), s[0][1] = n[3], s[1][1] = n[4];
          }

          if (f && "none" !== f) {
            g = o(e.node2), v = d(s, p[1], g * t);
            a(s[0][0], s[1][0], s[2][0], v, n), s[1][0] = n[1], s[2][0] = n[2], a(s[0][1], s[1][1], s[2][1], v, n), s[1][1] = n[1], s[2][1] = n[2];
          }

          r.copy(c[0], s[0]), r.copy(c[1], s[2]), r.copy(c[2], s[1]);
        } else {
          if (r.copy(l[0], p[0]), r.copy(l[1], p[1]), r.sub(u, l[1], l[0]), r.normalize(u, u), h && "none" !== h) {
            g = o(e.node1);
            r.scaleAndAdd(l[0], l[0], u, g * t);
          }

          if (f && "none" !== f) {
            g = o(e.node2);
            r.scaleAndAdd(l[1], l[1], u, -g * t);
          }

          r.copy(c[0], l[0]), r.copy(c[1], l[1]);
        }
      });
    };
  }, function (e, t, n) {
    var i = n(4),
        r = n(217).updateCenterAndZoom;
    n(334);
    i.registerAction({
      type: "graphRoam",
      event: "graphRoam",
      update: "none"
    }, function (e, t) {
      t.eachComponent({
        mainType: "series",
        query: e
      }, function (t) {
        var n = t.coordinateSystem,
            i = r(n, e);
        t.setCenter && t.setCenter(i.center), t.setZoom && t.setZoom(i.zoom);
      });
    });
  }, function (e, t) {
    e.exports = function (e) {
      var t = e.findComponents({
        mainType: "legend"
      });
      t && t.length && e.eachSeriesByType("graph", function (e) {
        var n = e.getCategoriesData(),
            i = e.getGraph().data,
            r = n.mapArray(n.getName);
        i.filterSelf(function (e) {
          var n = i.getItemModel(e).getShallow("category");

          if (null != n) {
            "number" == typeof n && (n = r[n]);

            for (var o = 0; o < t.length; o++) {
              if (!t[o].isSelected(n)) return !1;
            }
          }

          return !0;
        });
      }, this);
    };
  }, function (e, t) {
    e.exports = function (e) {
      var t = {};
      e.eachSeriesByType("graph", function (e) {
        var n = e.getCategoriesData(),
            i = e.getData(),
            r = {};
        n.each(function (i) {
          var o = n.getName(i);
          r["ec-" + o] = i;
          var a = n.getItemModel(i),
              s = a.get("itemStyle.color") || e.getColorFromPalette(o, t);
          n.setItemVisual(i, "color", s);

          for (var l = ["opacity", "symbol", "symbolSize", "symbolKeepAspect"], u = 0; u < l.length; u++) {
            var c = a.getShallow(l[u], !0);
            null != c && n.setItemVisual(i, l[u], c);
          }
        }), n.count() && i.each(function (e) {
          var t = i.getItemModel(e).getShallow("category");

          if (null != t) {
            "string" == typeof t && (t = r["ec-" + t]);

            for (var o = ["color", "opacity", "symbol", "symbolSize", "symbolKeepAspect"], a = 0; a < o.length; a++) {
              null == i.getItemVisual(e, o[a], !0) && i.setItemVisual(e, o[a], n.getItemVisual(t, o[a]));
            }
          }
        });
      });
    };
  }, function (e, t) {
    function n(e) {
      return e instanceof Array || (e = [e, e]), e;
    }

    e.exports = function (e) {
      e.eachSeriesByType("graph", function (e) {
        var t = e.getGraph(),
            i = e.getEdgeData(),
            r = n(e.get("edgeSymbol")),
            o = n(e.get("edgeSymbolSize")),
            a = "lineStyle.color".split("."),
            s = "lineStyle.opacity".split(".");
        i.setVisual("fromSymbol", r && r[0]), i.setVisual("toSymbol", r && r[1]), i.setVisual("fromSymbolSize", o && o[0]), i.setVisual("toSymbolSize", o && o[1]), i.setVisual("color", e.get(a)), i.setVisual("opacity", e.get(s)), i.each(function (e) {
          var r = i.getItemModel(e),
              o = t.getEdgeByIndex(e),
              l = n(r.getShallow("symbol", !0)),
              u = n(r.getShallow("symbolSize", !0)),
              c = r.get(a),
              h = r.get(s);

          switch (c) {
            case "source":
              c = o.node1.getVisual("color");
              break;

            case "target":
              c = o.node2.getVisual("color");
          }

          l[0] && o.setVisual("fromSymbol", l[0]), l[1] && o.setVisual("toSymbol", l[1]), u[0] && o.setVisual("fromSymbolSize", u[0]), u[1] && o.setVisual("toSymbolSize", u[1]), o.setVisual("color", c), o.setVisual("opacity", h);
        });
      });
    };
  }, function (e, t, n) {
    var i = n(1).each,
        r = n(335),
        o = r.simpleLayout,
        a = r.simpleLayoutEdge;

    e.exports = function (e, t) {
      e.eachSeriesByType("graph", function (e) {
        var t = e.get("layout"),
            n = e.coordinateSystem;

        if (n && "view" !== n.type) {
          var r = e.getData(),
              s = [];
          i(n.dimensions, function (e) {
            s = s.concat(r.mapDimension(e, !0));
          });

          for (var l = 0; l < r.count(); l++) {
            for (var u = [], c = !1, h = 0; h < s.length; h++) {
              var d = r.get(s[h], l);
              isNaN(d) || (c = !0), u.push(d);
            }

            c ? r.setItemLayout(l, n.dataToPoint(u)) : r.setItemLayout(l, [NaN, NaN]);
          }

          a(r.graph);
        } else t && "none" !== t || o(e);
      });
    };
  }, function (e, t, n) {
    var i = n(336).circularLayout;

    e.exports = function (e) {
      e.eachSeriesByType("graph", function (e) {
        "circular" === e.get("layout") && i(e, "symbolSize");
      });
    };
  }, function (e, t, n) {
    var i = n(767).forceLayout,
        r = n(335).simpleLayout,
        o = n(336).circularLayout,
        a = n(6).linearMap,
        s = n(16),
        l = n(1);

    e.exports = function (e) {
      e.eachSeriesByType("graph", function (e) {
        if (!(m = e.coordinateSystem) || "view" === m.type) if ("force" === e.get("layout")) {
          var t = e.preservedPoints || {},
              n = e.getGraph(),
              u = n.data,
              c = n.edgeData,
              h = e.getModel("force"),
              d = h.get("initLayout");
          e.preservedPoints ? u.each(function (e) {
            var n = u.getId(e);
            u.setItemLayout(e, t[n] || [NaN, NaN]);
          }) : d && "none" !== d ? "circular" === d && o(e, "value") : r(e);
          var f = u.getDataExtent("value"),
              p = c.getDataExtent("value"),
              g = h.get("repulsion"),
              v = h.get("edgeLength");
          l.isArray(g) || (g = [g, g]), l.isArray(v) || (v = [v, v]), v = [v[1], v[0]];

          var m,
              y = u.mapArray("value", function (e, t) {
            var n = u.getItemLayout(t),
                i = a(e, f, g);
            return isNaN(i) && (i = (g[0] + g[1]) / 2), {
              w: i,
              rep: i,
              fixed: u.getItemModel(t).get("fixed"),
              p: !n || isNaN(n[0]) || isNaN(n[1]) ? null : n
            };
          }),
              x = c.mapArray("value", function (e, t) {
            var i = n.getEdgeByIndex(t),
                r = a(e, p, v);
            isNaN(r) && (r = (v[0] + v[1]) / 2);
            var o = i.getModel();
            return {
              n1: y[i.node1.dataIndex],
              n2: y[i.node2.dataIndex],
              d: r,
              curveness: o.get("lineStyle.curveness") || 0,
              ignoreForceLayout: o.get("ignoreForceLayout")
            };
          }),
              _ = (m = e.coordinateSystem).getBoundingRect(),
              b = i(y, x, {
            rect: _,
            gravity: h.get("gravity"),
            friction: h.get("friction")
          }),
              w = b.step;

          b.step = function (e) {
            for (var i = 0, r = y.length; i < r; i++) {
              y[i].fixed && s.copy(y[i].p, n.getNodeByIndex(i).getLayout());
            }

            w(function (i, r, o) {
              for (var a = 0, l = i.length; a < l; a++) {
                i[a].fixed || n.getNodeByIndex(a).setLayout(i[a].p), t[u.getId(a)] = i[a].p;
              }

              for (a = 0, l = r.length; a < l; a++) {
                var c = r[a],
                    h = n.getEdgeByIndex(a),
                    d = c.n1.p,
                    f = c.n2.p,
                    p = h.getLayout();
                (p = p ? p.slice() : [])[0] = p[0] || [], p[1] = p[1] || [], s.copy(p[0], d), s.copy(p[1], f), +c.curveness && (p[2] = [(d[0] + f[0]) / 2 - (d[1] - f[1]) * c.curveness, (d[1] + f[1]) / 2 - (f[0] - d[0]) * c.curveness]), h.setLayout(p);
              }

              e && e(o);
            });
          }, e.forceLayout = b, e.preservedPoints = t, b.step();
        } else e.forceLayout = null;
      });
    };
  }, function (e, t, n) {
    var i = n(16),
        r = i.scaleAndAdd;

    t.forceLayout = function (e, t, n) {
      for (var o = n.rect, a = o.width, s = o.height, l = [o.x + a / 2, o.y + s / 2], u = null == n.gravity ? .1 : n.gravity, c = 0; c < e.length; c++) {
        var h = e[c];
        h.p || (h.p = i.create(a * (Math.random() - .5) + l[0], s * (Math.random() - .5) + l[1])), h.pp = i.clone(h.p), h.edges = null;
      }

      var d = null == n.friction ? .6 : n.friction,
          f = d;
      return {
        warmUp: function warmUp() {
          f = .8 * d;
        },
        setFixed: function setFixed(t) {
          e[t].fixed = !0;
        },
        setUnfixed: function setUnfixed(t) {
          e[t].fixed = !1;
        },
        step: function step(n) {
          for (var o = [], a = e.length, s = 0; s < t.length; s++) {
            var c = t[s];

            if (!c.ignoreForceLayout) {
              var h = c.n1,
                  d = c.n2;
              i.sub(o, d.p, h.p);
              var p = i.len(o) - c.d,
                  g = d.w / (h.w + d.w);
              isNaN(g) && (g = 0), i.normalize(o, o), !h.fixed && r(h.p, h.p, o, g * p * f), !d.fixed && r(d.p, d.p, o, -(1 - g) * p * f);
            }
          }

          for (s = 0; s < a; s++) {
            (x = e[s]).fixed || (i.sub(o, l, x.p), r(x.p, x.p, o, u * f));
          }

          for (s = 0; s < a; s++) {
            h = e[s];

            for (var v = s + 1; v < a; v++) {
              d = e[v];
              i.sub(o, d.p, h.p), 0 === (p = i.len(o)) && (i.set(o, Math.random() - .5, Math.random() - .5), p = 1);
              var m = (h.rep + d.rep) / p / p;
              !h.fixed && r(h.pp, h.pp, o, m), !d.fixed && r(d.pp, d.pp, o, -m);
            }
          }

          var y = [];

          for (s = 0; s < a; s++) {
            var x;
            (x = e[s]).fixed || (i.sub(y, x.p, x.pp), r(x.p, x.p, y, f), i.copy(x.pp, x.p));
          }

          f *= .992, n && n(e, t, f < .01);
        }
      };
    };
  }, function (e, t, n) {
    var i = n(219),
        r = n(14).getLayoutRect,
        o = n(120);

    e.exports = function (e, t) {
      var n = [];
      return e.eachSeriesByType("graph", function (e) {
        var a = e.get("coordinateSystem");

        if (!a || "view" === a) {
          var s = e.getData(),
              l = s.mapArray(function (e) {
            var t = s.getItemModel(e);
            return [+t.get("x"), +t.get("y")];
          }),
              u = [],
              c = [];
          o.fromPoints(l, u, c), c[0] - u[0] == 0 && (c[0] += 1, u[0] -= 1), c[1] - u[1] == 0 && (c[1] += 1, u[1] -= 1);

          var h = (c[0] - u[0]) / (c[1] - u[1]),
              d = function (e, t, n) {
            var i = e.getBoxLayoutParams();
            return i.aspect = n, r(i, {
              width: t.getWidth(),
              height: t.getHeight()
            });
          }(e, t, h);

          isNaN(h) && (u = [d.x, d.y], c = [d.x + d.width, d.y + d.height]);
          var f = c[0] - u[0],
              p = c[1] - u[1],
              g = d.width,
              v = d.height,
              m = e.coordinateSystem = new i();
          m.zoomLimit = e.get("scaleLimit"), m.setBoundingRect(u[0], u[1], f, p), m.setViewRect(d.x, d.y, g, v), m.setCenter(e.get("center")), m.setZoom(e.get("zoom")), n.push(m);
        }
      }), n;
    };
  }, function (e, t, n) {
    n(770), n(771);
  }, function (e, t, n) {
    var i = n(106),
        r = n(27).extend({
      type: "series.gauge",
      getInitialData: function getInitialData(e, t) {
        return i(this, ["value"]);
      },
      defaultOption: {
        zlevel: 0,
        z: 2,
        center: ["50%", "50%"],
        legendHoverLink: !0,
        radius: "75%",
        startAngle: 225,
        endAngle: -45,
        clockwise: !0,
        min: 0,
        max: 100,
        splitNumber: 10,
        axisLine: {
          show: !0,
          lineStyle: {
            color: [[.2, "#91c7ae"], [.8, "#63869e"], [1, "#c23531"]],
            width: 30
          }
        },
        splitLine: {
          show: !0,
          length: 30,
          lineStyle: {
            color: "#eee",
            width: 2,
            type: "solid"
          }
        },
        axisTick: {
          show: !0,
          splitNumber: 5,
          length: 8,
          lineStyle: {
            color: "#eee",
            width: 1,
            type: "solid"
          }
        },
        axisLabel: {
          show: !0,
          distance: 5,
          color: "auto"
        },
        pointer: {
          show: !0,
          length: "80%",
          width: 8
        },
        itemStyle: {
          color: "auto"
        },
        title: {
          show: !0,
          offsetCenter: [0, "-40%"],
          color: "#333",
          fontSize: 15
        },
        detail: {
          show: !0,
          backgroundColor: "rgba(0,0,0,0)",
          borderWidth: 0,
          borderColor: "#ccc",
          width: 100,
          height: null,
          padding: [5, 10],
          offsetCenter: [0, "40%"],
          color: "auto",
          fontSize: 30
        }
      }
    });
    e.exports = r;
  }, function (e, t, n) {
    var i = n(772),
        r = n(5),
        o = n(54),
        a = n(6),
        s = a.parsePercent,
        l = a.round,
        u = a.linearMap;

    function c(e, t) {
      return t && ("string" == typeof t ? e = t.replace("{value}", null != e ? e : "") : "function" == typeof t && (e = t(e))), e;
    }

    var h = 2 * Math.PI,
        d = o.extend({
      type: "gauge",
      render: function render(e, t, n) {
        this.group.removeAll();

        var i = e.get("axisLine.lineStyle.color"),
            r = function (e, t) {
          var n = e.get("center"),
              i = t.getWidth(),
              r = t.getHeight(),
              o = Math.min(i, r);
          return {
            cx: s(n[0], t.getWidth()),
            cy: s(n[1], t.getHeight()),
            r: s(e.get("radius"), o / 2)
          };
        }(e, n);

        this._renderMain(e, t, n, i, r);
      },
      dispose: function dispose() {},
      _renderMain: function _renderMain(e, t, n, i, o) {
        for (var a = this.group, s = e.getModel("axisLine"), l = s.getModel("lineStyle"), u = e.get("clockwise"), c = -e.get("startAngle") / 180 * Math.PI, d = ((m = -e.get("endAngle") / 180 * Math.PI) - c) % h, f = c, p = l.get("width"), g = s.get("show"), v = 0; g && v < i.length; v++) {
          var m = c + d * Math.min(Math.max(i[v][0], 0), 1),
              y = new r.Sector({
            shape: {
              startAngle: f,
              endAngle: m,
              cx: o.cx,
              cy: o.cy,
              clockwise: u,
              r0: o.r - p,
              r: o.r
            },
            silent: !0
          });
          y.setStyle({
            fill: i[v][1]
          }), y.setStyle(l.getLineStyle(["color", "borderWidth", "borderColor"])), a.add(y), f = m;
        }

        var x = function x(e) {
          if (e <= 0) return i[0][1];

          for (var t = 0; t < i.length; t++) {
            if (i[t][0] >= e && (0 === t ? 0 : i[t - 1][0]) < e) return i[t][1];
          }

          return i[t - 1][1];
        };

        if (!u) {
          var _ = c;
          c = m, m = _;
        }

        this._renderTicks(e, t, n, x, o, c, m, u), this._renderPointer(e, t, n, x, o, c, m, u), this._renderTitle(e, t, n, x, o), this._renderDetail(e, t, n, x, o);
      },
      _renderTicks: function _renderTicks(e, t, n, i, o, a, u, h) {
        for (var d = this.group, f = o.cx, p = o.cy, g = o.r, v = +e.get("min"), m = +e.get("max"), y = e.getModel("splitLine"), x = e.getModel("axisTick"), _ = e.getModel("axisLabel"), b = e.get("splitNumber"), w = x.get("splitNumber"), S = s(y.get("length"), g), T = s(x.get("length"), g), C = a, k = (u - a) / b, M = k / w, E = y.getModel("lineStyle").getLineStyle(), A = x.getModel("lineStyle").getLineStyle(), I = 0; I <= b; I++) {
          var P = Math.cos(C),
              O = Math.sin(C);

          if (y.get("show")) {
            var L = new r.Line({
              shape: {
                x1: P * g + f,
                y1: O * g + p,
                x2: P * (g - S) + f,
                y2: O * (g - S) + p
              },
              style: E,
              silent: !0
            });
            "auto" === E.stroke && L.setStyle({
              stroke: i(I / b)
            }), d.add(L);
          }

          if (_.get("show")) {
            var D = c(l(I / b * (m - v) + v), _.get("formatter")),
                N = _.get("distance"),
                j = i(I / b);

            d.add(new r.Text({
              style: r.setTextStyle({}, _, {
                text: D,
                x: P * (g - S - N) + f,
                y: O * (g - S - N) + p,
                textVerticalAlign: O < -.4 ? "top" : O > .4 ? "bottom" : "middle",
                textAlign: P < -.4 ? "left" : P > .4 ? "right" : "center"
              }, {
                autoColor: j
              }),
              silent: !0
            }));
          }

          if (x.get("show") && I !== b) {
            for (var R = 0; R <= w; R++) {
              P = Math.cos(C), O = Math.sin(C);
              var F = new r.Line({
                shape: {
                  x1: P * g + f,
                  y1: O * g + p,
                  x2: P * (g - T) + f,
                  y2: O * (g - T) + p
                },
                silent: !0,
                style: A
              });
              "auto" === A.stroke && F.setStyle({
                stroke: i((I + R / w) / b)
              }), d.add(F), C += M;
            }

            C -= M;
          } else C += k;
        }
      },
      _renderPointer: function _renderPointer(e, t, n, o, a, l, c, h) {
        var d = this.group,
            f = this._data;

        if (e.get("pointer.show")) {
          var p = [+e.get("min"), +e.get("max")],
              g = [l, c],
              v = e.getData(),
              m = v.mapDimension("value");
          v.diff(f).add(function (t) {
            var n = new i({
              shape: {
                angle: l
              }
            });
            r.initProps(n, {
              shape: {
                angle: u(v.get(m, t), p, g, !0)
              }
            }, e), d.add(n), v.setItemGraphicEl(t, n);
          }).update(function (t, n) {
            var i = f.getItemGraphicEl(n);
            r.updateProps(i, {
              shape: {
                angle: u(v.get(m, t), p, g, !0)
              }
            }, e), d.add(i), v.setItemGraphicEl(t, i);
          }).remove(function (e) {
            var t = f.getItemGraphicEl(e);
            d.remove(t);
          }).execute(), v.eachItemGraphicEl(function (e, t) {
            var n = v.getItemModel(t),
                i = n.getModel("pointer");
            e.setShape({
              x: a.cx,
              y: a.cy,
              width: s(i.get("width"), a.r),
              r: s(i.get("length"), a.r)
            }), e.useStyle(n.getModel("itemStyle").getItemStyle()), "auto" === e.style.fill && e.setStyle("fill", o(u(v.get(m, t), p, [0, 1], !0))), r.setHoverStyle(e, n.getModel("emphasis.itemStyle").getItemStyle());
          }), this._data = v;
        } else f && f.eachItemGraphicEl(function (e) {
          d.remove(e);
        });
      },
      _renderTitle: function _renderTitle(e, t, n, i, o) {
        var a = e.getData(),
            l = a.mapDimension("value"),
            c = e.getModel("title");

        if (c.get("show")) {
          var h = c.get("offsetCenter"),
              d = o.cx + s(h[0], o.r),
              f = o.cy + s(h[1], o.r),
              p = +e.get("min"),
              g = +e.get("max"),
              v = e.getData().get(l, 0),
              m = i(u(v, [p, g], [0, 1], !0));
          this.group.add(new r.Text({
            silent: !0,
            style: r.setTextStyle({}, c, {
              x: d,
              y: f,
              text: a.getName(0),
              textAlign: "center",
              textVerticalAlign: "middle"
            }, {
              autoColor: m,
              forceRich: !0
            })
          }));
        }
      },
      _renderDetail: function _renderDetail(e, t, n, i, o) {
        var a = e.getModel("detail"),
            l = +e.get("min"),
            h = +e.get("max");

        if (a.get("show")) {
          var d = a.get("offsetCenter"),
              f = o.cx + s(d[0], o.r),
              p = o.cy + s(d[1], o.r),
              g = s(a.get("width"), o.r),
              v = s(a.get("height"), o.r),
              m = e.getData(),
              y = m.get(m.mapDimension("value"), 0),
              x = i(u(y, [l, h], [0, 1], !0));
          this.group.add(new r.Text({
            silent: !0,
            style: r.setTextStyle({}, a, {
              x: f,
              y: p,
              text: c(y, a.get("formatter")),
              textWidth: isNaN(g) ? null : g,
              textHeight: isNaN(v) ? null : v,
              textAlign: "center",
              textVerticalAlign: "middle"
            }, {
              autoColor: x,
              forceRich: !0
            })
          }));
        }
      }
    });
    e.exports = d;
  }, function (e, t, n) {
    var i = n(20).extend({
      type: "echartsGaugePointer",
      shape: {
        angle: 0,
        width: 10,
        r: 10,
        x: 0,
        y: 0
      },
      buildPath: function buildPath(e, t) {
        var n = Math.cos,
            i = Math.sin,
            r = t.r,
            o = t.width,
            a = t.angle,
            s = t.x - n(a) * o * (o >= r / 3 ? 1 : 2),
            l = t.y - i(a) * o * (o >= r / 3 ? 1 : 2);
        a = t.angle - Math.PI / 2, e.moveTo(s, l), e.lineTo(t.x + n(a) * o, t.y + i(a) * o), e.lineTo(t.x + n(t.angle) * r, t.y + i(t.angle) * r), e.lineTo(t.x - n(a) * o, t.y - i(a) * o), e.lineTo(s, l);
      }
    });
    e.exports = i;
  }, function (e, t, n) {
    var i = n(4);
    n(774), n(775);
    var r = n(165),
        o = n(776),
        a = n(130);
    i.registerVisual(r("funnel")), i.registerLayout(o), i.registerProcessor(a("funnel"));
  }, function (e, t, n) {
    var i = n(4),
        r = n(1),
        o = n(106),
        a = n(8).defaultEmphasis,
        s = n(61).makeSeriesEncodeForNameBased,
        l = n(129),
        u = i.extendSeriesModel({
      type: "series.funnel",
      init: function init(e) {
        u.superApply(this, "init", arguments), this.legendVisualProvider = new l(r.bind(this.getData, this), r.bind(this.getRawData, this)), this._defaultLabelLine(e);
      },
      getInitialData: function getInitialData(e, t) {
        return o(this, {
          coordDimensions: ["value"],
          encodeDefaulter: r.curry(s, this)
        });
      },
      _defaultLabelLine: function _defaultLabelLine(e) {
        a(e, "labelLine", ["show"]);
        var t = e.labelLine,
            n = e.emphasis.labelLine;
        t.show = t.show && e.label.show, n.show = n.show && e.emphasis.label.show;
      },
      getDataParams: function getDataParams(e) {
        var t = this.getData(),
            n = u.superCall(this, "getDataParams", e),
            i = t.mapDimension("value"),
            r = t.getSum(i);
        return n.percent = r ? +(t.get(i, e) / r * 100).toFixed(2) : 0, n.$vars.push("percent"), n;
      },
      defaultOption: {
        zlevel: 0,
        z: 2,
        legendHoverLink: !0,
        left: 80,
        top: 60,
        right: 80,
        bottom: 60,
        minSize: "0%",
        maxSize: "100%",
        sort: "descending",
        gap: 0,
        funnelAlign: "center",
        label: {
          show: !0,
          position: "outer"
        },
        labelLine: {
          show: !0,
          length: 20,
          lineStyle: {
            width: 1,
            type: "solid"
          }
        },
        itemStyle: {
          borderColor: "#fff",
          borderWidth: 1
        },
        emphasis: {
          label: {
            show: !0
          }
        }
      }
    }),
        c = u;
    e.exports = c;
  }, function (e, t, n) {
    var i = n(5),
        r = n(1),
        o = n(54);

    function a(e, t) {
      i.Group.call(this);
      var n = new i.Polygon(),
          r = new i.Polyline(),
          o = new i.Text();
      this.add(n), this.add(r), this.add(o), this.highDownOnUpdate = function (e, t) {
        "emphasis" === t ? (r.ignore = r.hoverIgnore, o.ignore = o.hoverIgnore) : (r.ignore = r.normalIgnore, o.ignore = o.normalIgnore);
      }, this.updateData(e, t, !0);
    }

    var s = a.prototype,
        l = ["itemStyle", "opacity"];
    s.updateData = function (e, t, n) {
      var o = this.childAt(0),
          a = e.hostModel,
          s = e.getItemModel(t),
          u = e.getItemLayout(t),
          c = e.getItemModel(t).get(l);
      c = null == c ? 1 : c, o.useStyle({}), n ? (o.setShape({
        points: u.points
      }), o.setStyle({
        opacity: 0
      }), i.initProps(o, {
        style: {
          opacity: c
        }
      }, a, t)) : i.updateProps(o, {
        style: {
          opacity: c
        },
        shape: {
          points: u.points
        }
      }, a, t);
      var h = s.getModel("itemStyle"),
          d = e.getItemVisual(t, "color");
      o.setStyle(r.defaults({
        lineJoin: "round",
        fill: d
      }, h.getItemStyle(["opacity"]))), o.hoverStyle = h.getModel("emphasis").getItemStyle(), this._updateLabel(e, t), i.setHoverStyle(this);
    }, s._updateLabel = function (e, t) {
      var n = this.childAt(1),
          r = this.childAt(2),
          o = e.hostModel,
          a = e.getItemModel(t),
          s = e.getItemLayout(t).label,
          l = e.getItemVisual(t, "color");
      i.updateProps(n, {
        shape: {
          points: s.linePoints || s.linePoints
        }
      }, o, t), i.updateProps(r, {
        style: {
          x: s.x,
          y: s.y
        }
      }, o, t), r.attr({
        rotation: s.rotation,
        origin: [s.x, s.y],
        z2: 10
      });
      var u = a.getModel("label"),
          c = a.getModel("emphasis.label"),
          h = a.getModel("labelLine"),
          d = a.getModel("emphasis.labelLine");
      l = e.getItemVisual(t, "color");
      i.setLabelStyle(r.style, r.hoverStyle = {}, u, c, {
        labelFetcher: e.hostModel,
        labelDataIndex: t,
        defaultText: e.getName(t),
        autoColor: l,
        useInsideStyle: !!s.inside
      }, {
        textAlign: s.textAlign,
        textVerticalAlign: s.verticalAlign
      }), r.ignore = r.normalIgnore = !u.get("show"), r.hoverIgnore = !c.get("show"), n.ignore = n.normalIgnore = !h.get("show"), n.hoverIgnore = !d.get("show"), n.setStyle({
        stroke: l
      }), n.setStyle(h.getModel("lineStyle").getLineStyle()), n.hoverStyle = d.getModel("lineStyle").getLineStyle();
    }, r.inherits(a, i.Group);
    var u = o.extend({
      type: "funnel",
      render: function render(e, t, n) {
        var i = e.getData(),
            r = this._data,
            o = this.group;
        i.diff(r).add(function (e) {
          var t = new a(i, e);
          i.setItemGraphicEl(e, t), o.add(t);
        }).update(function (e, t) {
          var n = r.getItemGraphicEl(t);
          n.updateData(i, e), o.add(n), i.setItemGraphicEl(e, n);
        }).remove(function (e) {
          var t = r.getItemGraphicEl(e);
          o.remove(t);
        }).execute(), this._data = i;
      },
      remove: function remove() {
        this.group.removeAll(), this._data = null;
      },
      dispose: function dispose() {}
    });
    e.exports = u;
  }, function (e, t, n) {
    var i = n(14),
        r = n(6),
        o = r.parsePercent,
        a = r.linearMap;

    e.exports = function (e, t, n) {
      e.eachSeriesByType("funnel", function (e) {
        var n = e.getData(),
            r = n.mapDimension("value"),
            s = e.get("sort"),
            l = function (e, t) {
          return i.getLayoutRect(e.getBoxLayoutParams(), {
            width: t.getWidth(),
            height: t.getHeight()
          });
        }(e, t),
            u = function (e, t) {
          for (var n = e.mapDimension("value"), i = e.mapArray(n, function (e) {
            return e;
          }), r = [], o = "ascending" === t, a = 0, s = e.count(); a < s; a++) {
            r[a] = a;
          }

          return "function" == typeof t ? r.sort(t) : "none" !== t && r.sort(function (e, t) {
            return o ? i[e] - i[t] : i[t] - i[e];
          }), r;
        }(n, s),
            c = [o(e.get("minSize"), l.width), o(e.get("maxSize"), l.width)],
            h = n.getDataExtent(r),
            d = e.get("min"),
            f = e.get("max");

        null == d && (d = Math.min(h[0], 0)), null == f && (f = h[1]);

        var p = e.get("funnelAlign"),
            g = e.get("gap"),
            v = (l.height - g * (n.count() - 1)) / n.count(),
            m = l.y,
            y = function y(e, t) {
          var i,
              o = n.get(r, e) || 0,
              s = a(o, [d, f], c, !0);

          switch (p) {
            case "left":
              i = l.x;
              break;

            case "center":
              i = l.x + (l.width - s) / 2;
              break;

            case "right":
              i = l.x + l.width - s;
          }

          return [[i, t], [i + s, t]];
        };

        "ascending" === s && (v = -v, g = -g, m += l.height, u = u.reverse());

        for (var x = 0; x < u.length; x++) {
          var _ = u[x],
              b = u[x + 1],
              w = n.getItemModel(_).get("itemStyle.height");
          null == w ? w = v : (w = o(w, l.height), "ascending" === s && (w = -w));
          var S = y(_, m),
              T = y(b, m + w);
          m += w + g, n.setItemLayout(_, {
            points: S.concat(T.slice().reverse())
          });
        }

        !function (e) {
          e.each(function (t) {
            var n,
                i,
                r,
                o,
                a = e.getItemModel(t),
                s = a.getModel("label").get("position"),
                l = a.getModel("labelLine"),
                u = e.getItemLayout(t),
                c = u.points,
                h = "inner" === s || "inside" === s || "center" === s || "insideLeft" === s || "insideRight" === s;
            if (h) "insideLeft" === s ? (i = (c[0][0] + c[3][0]) / 2 + 5, r = (c[0][1] + c[3][1]) / 2, n = "left") : "insideRight" === s ? (i = (c[1][0] + c[2][0]) / 2 - 5, r = (c[1][1] + c[2][1]) / 2, n = "right") : (i = (c[0][0] + c[1][0] + c[2][0] + c[3][0]) / 4, r = (c[0][1] + c[1][1] + c[2][1] + c[3][1]) / 4, n = "center"), o = [[i, r], [i, r]];else {
              var d,
                  f,
                  p,
                  g = l.get("length");
              "left" === s ? (d = (c[3][0] + c[0][0]) / 2, f = (c[3][1] + c[0][1]) / 2, i = (p = d - g) - 5, n = "right") : "right" === s ? (d = (c[1][0] + c[2][0]) / 2, f = (c[1][1] + c[2][1]) / 2, i = (p = d + g) + 5, n = "left") : "rightTop" === s ? (d = c[1][0], f = c[1][1], i = (p = d + g) + 5, n = "top") : "rightBottom" === s ? (d = c[2][0], f = c[2][1], i = (p = d + g) + 5, n = "bottom") : "leftTop" === s ? (d = c[0][0], f = c[1][1], i = (p = d - g) - 5, n = "right") : "leftBottom" === s ? (d = c[3][0], f = c[2][1], i = (p = d - g) - 5, n = "right") : (d = (c[1][0] + c[2][0]) / 2, f = (c[1][1] + c[2][1]) / 2, i = (p = d + g) + 5, n = "left");
              o = [[d, f], [p, f]], r = f;
            }
            u.label = {
              linePoints: o,
              x: i,
              y: r,
              verticalAlign: "middle",
              textAlign: n,
              inside: h
            };
          });
        }(n);
      });
    };
  }, function (e, t, n) {
    var i = n(4);
    n(337), n(786), n(787);
    var r = n(788);
    i.registerVisual(r);
  }, function (e, t, n) {
    var i = n(1),
        r = n(8);

    e.exports = function (e) {
      !function (e) {
        if (e.parallel) return;
        var t = !1;
        i.each(e.series, function (e) {
          e && "parallel" === e.type && (t = !0);
        }), t && (e.parallel = [{}]);
      }(e), function (e) {
        var t = r.normalizeToArray(e.parallelAxis);
        i.each(t, function (t) {
          if (i.isObject(t)) {
            var n = t.parallelIndex || 0,
                o = r.normalizeToArray(e.parallel)[n];
            o && o.parallelAxisDefault && i.merge(t, o.parallelAxisDefault, !1);
          }
        });
      }(e);
    };
  }, function (e, t, n) {
    var i = n(1),
        r = n(31),
        o = n(14),
        a = n(43),
        s = n(780),
        l = n(5),
        u = n(6),
        c = n(107),
        h = i.each,
        d = Math.min,
        f = Math.max,
        p = Math.floor,
        g = Math.ceil,
        v = u.round,
        m = Math.PI;

    function y(e, t, n) {
      this._axesMap = i.createHashMap(), this._axesLayout = {}, this.dimensions = e.dimensions, this._rect, this._model = e, this._init(e, t, n);
    }

    function x(e, t) {
      return d(f(e, t[0]), t[1]);
    }

    function _(e, t) {
      var n = t.layoutLength / (t.axisCount - 1);
      return {
        position: n * e,
        axisNameAvailableWidth: n,
        axisLabelShow: !0
      };
    }

    function b(e, t) {
      var n,
          i,
          r = t.layoutLength,
          o = t.axisExpandWidth,
          a = t.axisCount,
          s = t.axisCollapseWidth,
          l = t.winInnerIndices,
          u = s,
          c = !1;
      return e < l[0] ? (n = e * s, i = s) : e <= l[1] ? (n = t.axisExpandWindow0Pos + e * o - t.axisExpandWindow[0], u = o, c = !0) : (n = r - (a - 1 - e) * s, i = s), {
        position: n,
        axisNameAvailableWidth: u,
        axisLabelShow: c,
        nameTruncateMaxWidth: i
      };
    }

    y.prototype = {
      type: "parallel",
      constructor: y,
      _init: function _init(e, t, n) {
        var i = e.dimensions,
            r = e.parallelAxisIndex;
        h(i, function (e, n) {
          var i = r[n],
              o = t.getComponent("parallelAxis", i),
              l = this._axesMap.set(e, new s(e, a.createScaleByModel(o), [0, 0], o.get("type"), i)),
              u = "category" === l.type;

          l.onBand = u && o.get("boundaryGap"), l.inverse = o.get("inverse"), o.axis = l, l.model = o, l.coordinateSystem = o.coordinateSystem = this;
        }, this);
      },
      update: function update(e, t) {
        this._updateAxesFromSeries(this._model, e);
      },
      containPoint: function containPoint(e) {
        var t = this._makeLayoutInfo(),
            n = t.axisBase,
            i = t.layoutBase,
            r = t.pixelDimIndex,
            o = e[1 - r],
            a = e[r];

        return o >= n && o <= n + t.axisLength && a >= i && a <= i + t.layoutLength;
      },
      getModel: function getModel() {
        return this._model;
      },
      _updateAxesFromSeries: function _updateAxesFromSeries(e, t) {
        t.eachSeries(function (n) {
          if (e.contains(n, t)) {
            var i = n.getData();
            h(this.dimensions, function (e) {
              var t = this._axesMap.get(e);

              t.scale.unionExtentFromData(i, i.mapDimension(e)), a.niceScaleExtent(t.scale, t.model);
            }, this);
          }
        }, this);
      },
      resize: function resize(e, t) {
        this._rect = o.getLayoutRect(e.getBoxLayoutParams(), {
          width: t.getWidth(),
          height: t.getHeight()
        }), this._layoutAxes();
      },
      getRect: function getRect() {
        return this._rect;
      },
      _makeLayoutInfo: function _makeLayoutInfo() {
        var e,
            t = this._model,
            n = this._rect,
            i = ["x", "y"],
            r = ["width", "height"],
            o = t.get("layout"),
            a = "horizontal" === o ? 0 : 1,
            s = n[r[a]],
            l = [0, s],
            u = this.dimensions.length,
            c = x(t.get("axisExpandWidth"), l),
            h = x(t.get("axisExpandCount") || 0, [0, u]),
            d = t.get("axisExpandable") && u > 3 && u > h && h > 1 && c > 0 && s > 0,
            f = t.get("axisExpandWindow");
        f ? (e = x(f[1] - f[0], l), f[1] = f[0] + e) : (e = x(c * (h - 1), l), (f = [c * (t.get("axisExpandCenter") || p(u / 2)) - e / 2])[1] = f[0] + e);
        var m = (s - e) / (u - h);
        m < 3 && (m = 0);

        var y = [p(v(f[0] / c, 1)) + 1, g(v(f[1] / c, 1)) - 1],
            _ = m / c * f[0];

        return {
          layout: o,
          pixelDimIndex: a,
          layoutBase: n[i[a]],
          layoutLength: s,
          axisBase: n[i[1 - a]],
          axisLength: n[r[1 - a]],
          axisExpandable: d,
          axisExpandWidth: c,
          axisCollapseWidth: m,
          axisExpandWindow: f,
          axisCount: u,
          winInnerIndices: y,
          axisExpandWindow0Pos: _
        };
      },
      _layoutAxes: function _layoutAxes() {
        var e = this._rect,
            t = this._axesMap,
            n = this.dimensions,
            i = this._makeLayoutInfo(),
            o = i.layout;

        t.each(function (e) {
          var t = [0, i.axisLength],
              n = e.inverse ? 1 : 0;
          e.setExtent(t[n], t[1 - n]);
        }), h(n, function (t, n) {
          var a = (i.axisExpandable ? b : _)(n, i),
              s = {
            horizontal: {
              x: a.position,
              y: i.axisLength
            },
            vertical: {
              x: 0,
              y: a.position
            }
          },
              l = {
            horizontal: m / 2,
            vertical: 0
          },
              u = [s[o].x + e.x, s[o].y + e.y],
              c = l[o],
              h = r.create();
          r.rotate(h, h, c), r.translate(h, h, u), this._axesLayout[t] = {
            position: u,
            rotation: c,
            transform: h,
            axisNameAvailableWidth: a.axisNameAvailableWidth,
            axisLabelShow: a.axisLabelShow,
            nameTruncateMaxWidth: a.nameTruncateMaxWidth,
            tickDirection: 1,
            labelDirection: 1
          };
        }, this);
      },
      getAxis: function getAxis(e) {
        return this._axesMap.get(e);
      },
      dataToPoint: function dataToPoint(e, t) {
        return this.axisCoordToPoint(this._axesMap.get(t).dataToCoord(e), t);
      },
      eachActiveState: function eachActiveState(e, t, n, r) {
        null == n && (n = 0), null == r && (r = e.count());
        var o = this._axesMap,
            a = this.dimensions,
            s = [],
            l = [];
        i.each(a, function (t) {
          s.push(e.mapDimension(t)), l.push(o.get(t).model);
        });

        for (var u = this.hasAxisBrushed(), c = n; c < r; c++) {
          var h;

          if (u) {
            h = "active";

            for (var d = e.getValues(s, c), f = 0, p = a.length; f < p; f++) {
              if ("inactive" === l[f].getActiveState(d[f])) {
                h = "inactive";
                break;
              }
            }
          } else h = "normal";

          t(h, c);
        }
      },
      hasAxisBrushed: function hasAxisBrushed() {
        for (var e = this.dimensions, t = this._axesMap, n = !1, i = 0, r = e.length; i < r; i++) {
          "normal" !== t.get(e[i]).model.getActiveState() && (n = !0);
        }

        return n;
      },
      axisCoordToPoint: function axisCoordToPoint(e, t) {
        var n = this._axesLayout[t];
        return l.applyTransform([e, 0], n.transform);
      },
      getAxisLayout: function getAxisLayout(e) {
        return i.clone(this._axesLayout[e]);
      },
      getSlidedAxisExpandWindow: function getSlidedAxisExpandWindow(e) {
        var t = this._makeLayoutInfo(),
            n = t.pixelDimIndex,
            i = t.axisExpandWindow.slice(),
            r = i[1] - i[0],
            o = [0, t.axisExpandWidth * (t.axisCount - 1)];

        if (!this.containPoint(e)) return {
          behavior: "none",
          axisExpandWindow: i
        };

        var a,
            s = e[n] - t.layoutBase - t.axisExpandWindow0Pos,
            l = "slide",
            u = t.axisCollapseWidth,
            h = this._model.get("axisExpandSlideTriggerArea"),
            p = null != h[0];

        if (u) p && u && s < r * h[0] ? (l = "jump", a = s - r * h[2]) : p && u && s > r * (1 - h[0]) ? (l = "jump", a = s - r * (1 - h[2])) : (a = s - r * h[1]) >= 0 && (a = s - r * (1 - h[1])) <= 0 && (a = 0), (a *= t.axisExpandWidth / u) ? c(a, i, o, "all") : l = "none";else {
          r = i[1] - i[0];
          (i = [f(0, o[1] * s / r - r / 2)])[1] = d(o[1], i[0] + r), i[0] = i[1] - r;
        }
        return {
          axisExpandWindow: i,
          behavior: l
        };
      }
    };
    var w = y;
    e.exports = w;
  }, function (e, t, n) {
    var i = n(1),
        r = n(69),
        o = function o(e, t, n, i, _o5) {
      r.call(this, e, t, n), this.type = i || "value", this.axisIndex = _o5;
    };

    o.prototype = {
      constructor: o,
      model: null,
      isHorizontal: function isHorizontal() {
        return "horizontal" !== this.coordinateSystem.getModel().get("layout");
      }
    }, i.inherits(o, r);
    var a = o;
    e.exports = a;
  }, function (e, t, n) {
    var i = n(1),
        r = n(26);
    n(782);
    var o = r.extend({
      type: "parallel",
      dependencies: ["parallelAxis"],
      coordinateSystem: null,
      dimensions: null,
      parallelAxisIndex: null,
      layoutMode: "box",
      defaultOption: {
        zlevel: 0,
        z: 0,
        left: 80,
        top: 60,
        right: 80,
        bottom: 60,
        layout: "horizontal",
        axisExpandable: !1,
        axisExpandCenter: null,
        axisExpandCount: 0,
        axisExpandWidth: 50,
        axisExpandRate: 17,
        axisExpandDebounce: 50,
        axisExpandSlideTriggerArea: [-.15, .05, .4],
        axisExpandTriggerOn: "click",
        parallelAxisDefault: null
      },
      init: function init() {
        r.prototype.init.apply(this, arguments), this.mergeOption({});
      },
      mergeOption: function mergeOption(e) {
        var t = this.option;
        e && i.merge(t, e, !0), this._initDimensions();
      },
      contains: function contains(e, t) {
        var n = e.get("parallelIndex");
        return null != n && t.getComponent("parallel", n) === this;
      },
      setAxisExpand: function setAxisExpand(e) {
        i.each(["axisExpandable", "axisExpandCenter", "axisExpandCount", "axisExpandWidth", "axisExpandWindow"], function (t) {
          e.hasOwnProperty(t) && (this.option[t] = e[t]);
        }, this);
      },
      _initDimensions: function _initDimensions() {
        var e = this.dimensions = [],
            t = this.parallelAxisIndex = [],
            n = i.filter(this.dependentModels.parallelAxis, function (e) {
          return (e.get("parallelIndex") || 0) === this.componentIndex;
        }, this);
        i.each(n, function (n) {
          e.push("dim" + n.get("dim")), t.push(n.componentIndex);
        });
      }
    });
    e.exports = o;
  }, function (e, t, n) {
    var i = n(1),
        r = n(26),
        o = n(101),
        a = n(163),
        s = n(6),
        l = n(105),
        u = r.extend({
      type: "baseParallelAxis",
      axis: null,
      activeIntervals: [],
      getAreaSelectStyle: function getAreaSelectStyle() {
        return o([["fill", "color"], ["lineWidth", "borderWidth"], ["stroke", "borderColor"], ["width", "width"], ["opacity", "opacity"]])(this.getModel("areaSelectStyle"));
      },
      setActiveIntervals: function setActiveIntervals(e) {
        var t = this.activeIntervals = i.clone(e);
        if (t) for (var n = t.length - 1; n >= 0; n--) {
          s.asc(t[n]);
        }
      },
      getActiveState: function getActiveState(e) {
        var t = this.activeIntervals;
        if (!t.length) return "normal";
        if (null == e || isNaN(e)) return "inactive";

        if (1 === t.length) {
          var n = t[0];
          if (n[0] <= e && e <= n[1]) return "active";
        } else for (var i = 0, r = t.length; i < r; i++) {
          if (t[i][0] <= e && e <= t[i][1]) return "active";
        }

        return "inactive";
      }
    });
    i.merge(u.prototype, l), a("parallel", u, function (e, t) {
      return t.type || (t.data ? "category" : "value");
    }, {
      type: "value",
      dim: null,
      areaSelectStyle: {
        width: 20,
        borderWidth: 1,
        borderColor: "rgba(160,197,232)",
        color: "rgba(160,197,232)",
        opacity: .3
      },
      realtime: !0,
      z: 10
    });
    var c = u;
    e.exports = c;
  }, function (e, t, n) {
    n(338), n(784), n(785);
  }, function (e, t, n) {
    var i = n(4);
    i.registerAction({
      type: "axisAreaSelect",
      event: "axisAreaSelected"
    }, function (e, t) {
      t.eachComponent({
        mainType: "parallelAxis",
        query: e
      }, function (t) {
        t.axis.model.setActiveIntervals(e.intervals);
      });
    }), i.registerAction("parallelAxisExpand", function (e, t) {
      t.eachComponent({
        mainType: "parallel",
        query: e
      }, function (t) {
        t.setAxisExpand(e);
      });
    });
  }, function (e, t, n) {
    var i = n(4),
        r = n(1),
        o = n(70),
        a = n(224),
        s = n(339),
        l = n(5),
        u = ["axisLine", "axisTickLabel", "axisName"],
        c = i.extendComponentView({
      type: "parallelAxis",
      init: function init(e, t) {
        c.superApply(this, "init", arguments), (this._brushController = new a(t.getZr())).on("brush", r.bind(this._onBrush, this));
      },
      render: function render(e, t, n, i) {
        if (!function (e, t, n) {
          return n && "axisAreaSelect" === n.type && t.findComponents({
            mainType: "parallelAxis",
            query: n
          })[0] === e;
        }(e, t, i)) {
          this.axisModel = e, this.api = n, this.group.removeAll();
          var a = this._axisGroup;

          if (this._axisGroup = new l.Group(), this.group.add(this._axisGroup), e.get("show")) {
            var s = function (e, t) {
              return t.getComponent("parallel", e.get("parallelIndex"));
            }(e, t),
                c = s.coordinateSystem,
                h = e.getAreaSelectStyle(),
                d = h.width,
                f = e.axis.dim,
                p = c.getAxisLayout(f),
                g = r.extend({
              strokeContainThreshold: d
            }, p),
                v = new o(e, g);

            r.each(u, v.add, v), this._axisGroup.add(v.getGroup()), this._refreshBrushController(g, h, e, s, d, n);
            var m = i && !1 === i.animation ? null : e;
            l.groupTransition(a, this._axisGroup, m);
          }
        }
      },
      _refreshBrushController: function _refreshBrushController(e, t, n, i, o, a) {
        var u = n.axis.getExtent(),
            c = u[1] - u[0],
            h = Math.min(30, .1 * Math.abs(c)),
            d = l.BoundingRect.create({
          x: u[0],
          y: -o / 2,
          width: c,
          height: o
        });
        d.x -= h, d.width += 2 * h, this._brushController.mount({
          enableGlobalPan: !0,
          rotation: e.rotation,
          position: e.position
        }).setPanels([{
          panelId: "pl",
          clipPath: s.makeRectPanelClipPath(d),
          isTargetByCursor: s.makeRectIsTargetByCursor(d, a, i),
          getLinearBrushOtherExtent: s.makeLinearBrushOtherExtent(d, 0)
        }]).enableBrush({
          brushType: "lineX",
          brushStyle: t,
          removeOnClick: !0
        }).updateCovers(function (e) {
          var t = e.axis;
          return r.map(e.activeIntervals, function (e) {
            return {
              brushType: "lineX",
              panelId: "pl",
              range: [t.dataToCoord(e[0], !0), t.dataToCoord(e[1], !0)]
            };
          });
        }(n));
      },
      _onBrush: function _onBrush(e, t) {
        var n = this.axisModel,
            i = n.axis,
            o = r.map(e, function (e) {
          return [i.coordToData(e.range[0], !0), i.coordToData(e.range[1], !0)];
        });
        (!n.option.realtime === t.isEnd || t.removeOnClick) && this.api.dispatchAction({
          type: "axisAreaSelect",
          parallelAxisId: n.id,
          intervals: o
        });
      },
      dispose: function dispose() {
        this._brushController.dispose();
      }
    });
    var h = c;
    e.exports = h;
  }, function (e, t, n) {
    var i = n(1),
        r = i.each,
        o = i.createHashMap,
        a = n(27),
        s = n(62),
        l = a.extend({
      type: "series.parallel",
      dependencies: ["parallel"],
      visualColorAccessPath: "lineStyle.color",
      getInitialData: function getInitialData(e, t) {
        var n = this.getSource();
        return function (e, t) {
          if (e.encodeDefine) return;
          var n = t.ecModel.getComponent("parallel", t.get("parallelIndex"));
          if (!n) return;
          var i = e.encodeDefine = o();
          r(n.dimensions, function (e) {
            var t = +e.replace("dim", "");
            i.set(e, t);
          });
        }(n, this), s(n, this);
      },
      getRawIndicesByActiveState: function getRawIndicesByActiveState(e) {
        var t = this.coordinateSystem,
            n = this.getData(),
            i = [];
        return t.eachActiveState(n, function (t, r) {
          e === t && i.push(n.getRawIndex(r));
        }), i;
      },
      defaultOption: {
        zlevel: 0,
        z: 2,
        coordinateSystem: "parallel",
        parallelIndex: 0,
        label: {
          show: !1
        },
        inactiveOpacity: .05,
        activeOpacity: 1,
        lineStyle: {
          width: 1,
          opacity: .45,
          type: "solid"
        },
        emphasis: {
          label: {
            show: !1
          }
        },
        progressive: 500,
        smooth: !1,
        animationEasing: "linear"
      }
    });
    e.exports = l;
  }, function (e, t, n) {
    var i = n(5),
        r = n(54);

    function o(e, t, n, i) {
      for (var r, o = [], a = 0; a < n.length; a++) {
        var s = n[a],
            l = e.get(e.mapDimension(s), t);
        r = l, ("category" === i.getAxis(s).type ? null == r : null == r || isNaN(r)) || o.push(i.dataToPoint(l, s));
      }

      return o;
    }

    function a(e, t, n, r, a) {
      var s = o(e, n, r, a),
          l = new i.Polyline({
        shape: {
          points: s
        },
        silent: !0,
        z2: 10
      });
      return t.add(l), e.setItemGraphicEl(n, l), l;
    }

    function s(e) {
      var t = e.get("smooth", !0);
      return !0 === t && (t = .3), {
        lineStyle: e.getModel("lineStyle").getLineStyle(),
        smooth: null != t ? t : .3
      };
    }

    function l(e, t, n, i) {
      var r = i.lineStyle;
      t.hasItemOption && (r = t.getItemModel(n).getModel("lineStyle").getLineStyle());
      e.useStyle(r);
      var o = e.style;
      o.fill = null, o.stroke = t.getItemVisual(n, "color"), o.opacity = t.getItemVisual(n, "opacity"), i.smooth && (e.shape.smooth = i.smooth);
    }

    var u = r.extend({
      type: "parallel",
      init: function init() {
        this._dataGroup = new i.Group(), this.group.add(this._dataGroup), this._data, this._initialized;
      },
      render: function render(e, t, n, r) {
        var u = this._dataGroup,
            c = e.getData(),
            h = this._data,
            d = e.coordinateSystem,
            f = d.dimensions,
            p = s(e);

        if (c.diff(h).add(function (e) {
          l(a(c, u, e, f, d), c, e, p);
        }).update(function (t, n) {
          var a = h.getItemGraphicEl(n),
              s = o(c, t, f, d);
          c.setItemGraphicEl(t, a);
          var u = r && !1 === r.animation ? null : e;
          i.updateProps(a, {
            shape: {
              points: s
            }
          }, u, t), l(a, c, t, p);
        }).remove(function (e) {
          var t = h.getItemGraphicEl(e);
          u.remove(t);
        }).execute(), !this._initialized) {
          this._initialized = !0;

          var g = function (e, t, n) {
            var r = e.model,
                o = e.getRect(),
                a = new i.Rect({
              shape: {
                x: o.x,
                y: o.y,
                width: o.width,
                height: o.height
              }
            }),
                s = "horizontal" === r.get("layout") ? "width" : "height";
            return a.setShape(s, 0), i.initProps(a, {
              shape: {
                width: o.width,
                height: o.height
              }
            }, t, n), a;
          }(d, e, function () {
            setTimeout(function () {
              u.removeClipPath();
            });
          });

          u.setClipPath(g);
        }

        this._data = c;
      },
      incrementalPrepareRender: function incrementalPrepareRender(e, t, n) {
        this._initialized = !0, this._data = null, this._dataGroup.removeAll();
      },
      incrementalRender: function incrementalRender(e, t, n) {
        for (var i = t.getData(), r = t.coordinateSystem, o = r.dimensions, u = s(t), c = e.start; c < e.end; c++) {
          var h = a(i, this._dataGroup, c, o, r);
          h.incremental = !0, l(h, i, c, u);
        }
      },
      dispose: function dispose() {},
      remove: function remove() {
        this._dataGroup && this._dataGroup.removeAll(), this._data = null;
      }
    });
    e.exports = u;
  }, function (e, t) {
    var n = ["lineStyle", "normal", "opacity"],
        i = {
      seriesType: "parallel",
      reset: function reset(e, t, i) {
        var r = e.getModel("itemStyle"),
            o = e.getModel("lineStyle"),
            a = t.get("color"),
            s = o.get("color") || r.get("color") || a[e.seriesIndex % a.length],
            l = e.get("inactiveOpacity"),
            u = e.get("activeOpacity"),
            c = e.getModel("lineStyle").getLineStyle(),
            h = e.coordinateSystem,
            d = e.getData(),
            f = {
          normal: c.opacity,
          active: u,
          inactive: l
        };
        return d.setVisual("color", s), {
          progress: function progress(e, t) {
            h.eachActiveState(t, function (e, i) {
              var r = f[e];

              if ("normal" === e && t.hasItemOption) {
                var o = t.getItemModel(i).get(n, !0);
                null != o && (r = o);
              }

              t.setItemVisual(i, "opacity", r);
            }, e.start, e.end);
          }
        };
      }
    };
    e.exports = i;
  }, function (e, t, n) {
    var i = n(4);
    n(790), n(791), n(792);
    var r = n(793),
        o = n(794);
    i.registerLayout(r), i.registerVisual(o);
  }, function (e, t, n) {
    var i = n(27),
        r = n(333),
        o = n(15).encodeHTML,
        a = n(22),
        s = (n(9).__DEV__, i.extend({
      type: "series.sankey",
      layoutInfo: null,
      levelModels: null,
      getInitialData: function getInitialData(e, t) {
        for (var n = e.edges || e.links, i = e.data || e.nodes, o = e.levels, s = this.levelModels = {}, l = 0; l < o.length; l++) {
          null != o[l].depth && o[l].depth >= 0 && (s[o[l].depth] = new a(o[l], this, t));
        }

        if (i && n) return r(i, n, this, !0, function (e, t) {
          e.wrapMethod("getItemModel", function (e, t) {
            return e.customizeGetParent(function (e) {
              var n = this.parentModel,
                  i = n.getData().getItemLayout(t).depth;
              return n.levelModels[i] || this.parentModel;
            }), e;
          }), t.wrapMethod("getItemModel", function (e, t) {
            return e.customizeGetParent(function (e) {
              var n = this.parentModel,
                  i = n.getGraph().getEdgeByIndex(t).node1.getLayout().depth;
              return n.levelModels[i] || this.parentModel;
            }), e;
          });
        }).data;
      },
      setNodePosition: function setNodePosition(e, t) {
        var n = this.option.data[e];
        n.localX = t[0], n.localY = t[1];
      },
      getGraph: function getGraph() {
        return this.getData().graph;
      },
      getEdgeData: function getEdgeData() {
        return this.getGraph().edgeData;
      },
      formatTooltip: function formatTooltip(e, t, n) {
        if ("edge" === n) {
          var i = this.getDataParams(e, n),
              r = i.data,
              a = r.source + " -- " + r.target;
          return i.value && (a += " : " + i.value), o(a);
        }

        if ("node" === n) {
          var l = this.getGraph().getNodeByIndex(e).getLayout().value,
              u = this.getDataParams(e, n).data.name;
          if (l) a = u + " : " + l;
          return o(a);
        }

        return s.superCall(this, "formatTooltip", e, t);
      },
      optionUpdated: function optionUpdated() {
        var e = this.option;
        !0 === e.focusNodeAdjacency && (e.focusNodeAdjacency = "allEdges");
      },
      getDataParams: function getDataParams(e, t) {
        var n = s.superCall(this, "getDataParams", e, t);

        if (null == n.value && "node" === t) {
          var i = this.getGraph().getNodeByIndex(e).getLayout().value;
          n.value = i;
        }

        return n;
      },
      defaultOption: {
        zlevel: 0,
        z: 2,
        coordinateSystem: "view",
        layout: null,
        left: "5%",
        top: "5%",
        right: "20%",
        bottom: "5%",
        orient: "horizontal",
        nodeWidth: 20,
        nodeGap: 8,
        draggable: !0,
        focusNodeAdjacency: !1,
        layoutIterations: 32,
        label: {
          show: !0,
          position: "right",
          color: "#000",
          fontSize: 12
        },
        levels: [],
        nodeAlign: "justify",
        itemStyle: {
          borderWidth: 1,
          borderColor: "#333"
        },
        lineStyle: {
          color: "#314656",
          opacity: .2,
          curveness: .5
        },
        emphasis: {
          label: {
            show: !0
          },
          lineStyle: {
            opacity: .5
          }
        },
        animationEasing: "linear",
        animationDuration: 1e3
      }
    })),
        l = s;
    e.exports = l;
  }, function (e, t, n) {
    var i = n(5),
        r = n(4),
        o = n(1),
        a = ["itemStyle", "opacity"],
        s = ["emphasis", "itemStyle", "opacity"],
        l = ["lineStyle", "opacity"],
        u = ["emphasis", "lineStyle", "opacity"];

    function c(e, t) {
      return e.getVisual("opacity") || e.getModel().get(t);
    }

    function h(e, t, n) {
      var i = e.getGraphicEl(),
          r = c(e, t);
      null != n && (null == r && (r = 1), r *= n), i.downplay && i.downplay(), i.traverse(function (e) {
        "group" !== e.type && e.setStyle("opacity", r);
      });
    }

    function d(e, t) {
      var n = c(e, t),
          i = e.getGraphicEl();
      i.traverse(function (e) {
        "group" !== e.type && e.setStyle("opacity", n);
      }), i.highlight && i.highlight();
    }

    var f = i.extendShape({
      shape: {
        x1: 0,
        y1: 0,
        x2: 0,
        y2: 0,
        cpx1: 0,
        cpy1: 0,
        cpx2: 0,
        cpy2: 0,
        extent: 0,
        orient: ""
      },
      buildPath: function buildPath(e, t) {
        var n = t.extent;
        e.moveTo(t.x1, t.y1), e.bezierCurveTo(t.cpx1, t.cpy1, t.cpx2, t.cpy2, t.x2, t.y2), "vertical" === t.orient ? (e.lineTo(t.x2 + n, t.y2), e.bezierCurveTo(t.cpx2 + n, t.cpy2, t.cpx1 + n, t.cpy1, t.x1 + n, t.y1)) : (e.lineTo(t.x2, t.y2 + n), e.bezierCurveTo(t.cpx2, t.cpy2 + n, t.cpx1, t.cpy1 + n, t.x1, t.y1 + n)), e.closePath();
      },
      highlight: function highlight() {
        this.trigger("emphasis");
      },
      downplay: function downplay() {
        this.trigger("normal");
      }
    }),
        p = r.extendChartView({
      type: "sankey",
      _model: null,
      _focusAdjacencyDisabled: !1,
      render: function render(e, t, n) {
        var r = this,
            o = e.getGraph(),
            a = this.group,
            s = e.layoutInfo,
            l = s.width,
            u = s.height,
            c = e.getData(),
            h = e.getData("edge"),
            d = e.get("orient");
        this._model = e, a.removeAll(), a.attr("position", [s.x, s.y]), o.eachEdge(function (t) {
          var n = new f();
          n.dataIndex = t.dataIndex, n.seriesIndex = e.seriesIndex, n.dataType = "edge";

          var r,
              o,
              s,
              c,
              p,
              g,
              v,
              m,
              y = t.getModel("lineStyle"),
              x = y.get("curveness"),
              _ = t.node1.getLayout(),
              b = t.node1.getModel(),
              w = b.get("localX"),
              S = b.get("localY"),
              T = t.node2.getLayout(),
              C = t.node2.getModel(),
              k = C.get("localX"),
              M = C.get("localY"),
              E = t.getLayout();

          switch (n.shape.extent = Math.max(1, E.dy), n.shape.orient = d, "vertical" === d ? (r = (null != w ? w * l : _.x) + E.sy, o = (null != S ? S * u : _.y) + _.dy, s = (null != k ? k * l : T.x) + E.ty, p = r, g = o * (1 - x) + (c = null != M ? M * u : T.y) * x, v = s, m = o * x + c * (1 - x)) : (r = (null != w ? w * l : _.x) + _.dx, o = (null != S ? S * u : _.y) + E.sy, p = r * (1 - x) + (s = null != k ? k * l : T.x) * x, g = o, v = r * x + s * (1 - x), m = c = (null != M ? M * u : T.y) + E.ty), n.setShape({
            x1: r,
            y1: o,
            x2: s,
            y2: c,
            cpx1: p,
            cpy1: g,
            cpx2: v,
            cpy2: m
          }), n.setStyle(y.getItemStyle()), n.style.fill) {
            case "source":
              n.style.fill = t.node1.getVisual("color");
              break;

            case "target":
              n.style.fill = t.node2.getVisual("color");
          }

          i.setHoverStyle(n, t.getModel("emphasis.lineStyle").getItemStyle()), a.add(n), h.setItemGraphicEl(t.dataIndex, n);
        }), o.eachNode(function (t) {
          var n = t.getLayout(),
              r = t.getModel(),
              o = r.get("localX"),
              s = r.get("localY"),
              h = r.getModel("label"),
              d = r.getModel("emphasis.label"),
              f = new i.Rect({
            shape: {
              x: null != o ? o * l : n.x,
              y: null != s ? s * u : n.y,
              width: n.dx,
              height: n.dy
            },
            style: r.getModel("itemStyle").getItemStyle()
          }),
              p = t.getModel("emphasis.itemStyle").getItemStyle();
          i.setLabelStyle(f.style, p, h, d, {
            labelFetcher: e,
            labelDataIndex: t.dataIndex,
            defaultText: t.id,
            isRectText: !0
          }), f.setStyle("fill", t.getVisual("color")), i.setHoverStyle(f, p), a.add(f), c.setItemGraphicEl(t.dataIndex, f), f.dataType = "node";
        }), c.eachItemGraphicEl(function (t, i) {
          var o = c.getItemModel(i);
          o.get("draggable") && (t.drift = function (t, o) {
            r._focusAdjacencyDisabled = !0, this.shape.x += t, this.shape.y += o, this.dirty(), n.dispatchAction({
              type: "dragNode",
              seriesId: e.id,
              dataIndex: c.getRawIndex(i),
              localX: this.shape.x / l,
              localY: this.shape.y / u
            });
          }, t.ondragend = function () {
            r._focusAdjacencyDisabled = !1;
          }, t.draggable = !0, t.cursor = "move"), t.highlight = function () {
            this.trigger("emphasis");
          }, t.downplay = function () {
            this.trigger("normal");
          }, t.focusNodeAdjHandler && t.off("mouseover", t.focusNodeAdjHandler), t.unfocusNodeAdjHandler && t.off("mouseout", t.unfocusNodeAdjHandler), o.get("focusNodeAdjacency") && (t.on("mouseover", t.focusNodeAdjHandler = function () {
            r._focusAdjacencyDisabled || (r._clearTimer(), n.dispatchAction({
              type: "focusNodeAdjacency",
              seriesId: e.id,
              dataIndex: t.dataIndex
            }));
          }), t.on("mouseout", t.unfocusNodeAdjHandler = function () {
            r._focusAdjacencyDisabled || r._dispatchUnfocus(n);
          }));
        }), h.eachItemGraphicEl(function (t, i) {
          var o = h.getItemModel(i);
          t.focusNodeAdjHandler && t.off("mouseover", t.focusNodeAdjHandler), t.unfocusNodeAdjHandler && t.off("mouseout", t.unfocusNodeAdjHandler), o.get("focusNodeAdjacency") && (t.on("mouseover", t.focusNodeAdjHandler = function () {
            r._focusAdjacencyDisabled || (r._clearTimer(), n.dispatchAction({
              type: "focusNodeAdjacency",
              seriesId: e.id,
              edgeDataIndex: t.dataIndex
            }));
          }), t.on("mouseout", t.unfocusNodeAdjHandler = function () {
            r._focusAdjacencyDisabled || r._dispatchUnfocus(n);
          }));
        }), !this._data && e.get("animation") && a.setClipPath(function (e, t, n) {
          var r = new i.Rect({
            shape: {
              x: e.x - 10,
              y: e.y - 10,
              width: 0,
              height: e.height + 20
            }
          });
          return i.initProps(r, {
            shape: {
              width: e.width + 20
            }
          }, t, n), r;
        }(a.getBoundingRect(), e, function () {
          a.removeClipPath();
        })), this._data = e.getData();
      },
      dispose: function dispose() {
        this._clearTimer();
      },
      _dispatchUnfocus: function _dispatchUnfocus(e) {
        var t = this;
        this._clearTimer(), this._unfocusDelayTimer = setTimeout(function () {
          t._unfocusDelayTimer = null, e.dispatchAction({
            type: "unfocusNodeAdjacency",
            seriesId: t._model.id
          });
        }, 500);
      },
      _clearTimer: function _clearTimer() {
        this._unfocusDelayTimer && (clearTimeout(this._unfocusDelayTimer), this._unfocusDelayTimer = null);
      },
      focusNodeAdjacency: function focusNodeAdjacency(e, t, n, i) {
        var r = e.getData(),
            c = r.graph,
            f = i.dataIndex,
            p = r.getItemModel(f),
            g = i.edgeDataIndex;

        if (null != f || null != g) {
          var v = c.getNodeByIndex(f),
              m = c.getEdgeByIndex(g);

          if (c.eachNode(function (e) {
            h(e, a, .1);
          }), c.eachEdge(function (e) {
            h(e, l, .1);
          }), v) {
            d(v, s);
            var y = p.get("focusNodeAdjacency");
            "outEdges" === y ? o.each(v.outEdges, function (e) {
              e.dataIndex < 0 || (d(e, u), d(e.node2, s));
            }) : "inEdges" === y ? o.each(v.inEdges, function (e) {
              e.dataIndex < 0 || (d(e, u), d(e.node1, s));
            }) : "allEdges" === y && o.each(v.edges, function (e) {
              e.dataIndex < 0 || (d(e, u), e.node1 !== v && d(e.node1, s), e.node2 !== v && d(e.node2, s));
            });
          }

          m && (d(m, u), d(m.node1, s), d(m.node2, s));
        }
      },
      unfocusNodeAdjacency: function unfocusNodeAdjacency(e, t, n, i) {
        var r = e.getGraph();
        r.eachNode(function (e) {
          h(e, a);
        }), r.eachEdge(function (e) {
          h(e, l);
        });
      }
    });
    e.exports = p;
  }, function (e, t, n) {
    var i = n(4);
    n(334), i.registerAction({
      type: "dragNode",
      event: "dragnode",
      update: "update"
    }, function (e, t) {
      t.eachComponent({
        mainType: "series",
        subType: "sankey",
        query: e
      }, function (t) {
        t.setNodePosition(e.dataIndex, [e.localX, e.localY]);
      });
    });
  }, function (e, t, n) {
    var i = n(14),
        r = n(1),
        o = n(8).groupData;

    function a(e) {
      var t = e.hostGraph.data.getRawDataItem(e.dataIndex);
      return null != t.depth && t.depth >= 0;
    }

    function s(e, t, n, i, o) {
      var a = "vertical" === o ? "x" : "y";
      r.each(e, function (e) {
        var r, s, l;
        e.sort(function (e, t) {
          return e.getLayout()[a] - t.getLayout()[a];
        });

        for (var u = 0, c = e.length, h = "vertical" === o ? "dx" : "dy", d = 0; d < c; d++) {
          (l = u - (s = e[d]).getLayout()[a]) > 0 && (r = s.getLayout()[a] + l, "vertical" === o ? s.setLayout({
            x: r
          }, !0) : s.setLayout({
            y: r
          }, !0)), u = s.getLayout()[a] + s.getLayout()[h] + t;
        }

        if ((l = u - t - ("vertical" === o ? i : n)) > 0) for (r = s.getLayout()[a] - l, "vertical" === o ? s.setLayout({
          x: r
        }, !0) : s.setLayout({
          y: r
        }, !0), u = r, d = c - 2; d >= 0; --d) {
          (l = (s = e[d]).getLayout()[a] + s.getLayout()[h] + t - u) > 0 && (r = s.getLayout()[a] - l, "vertical" === o ? s.setLayout({
            x: r
          }, !0) : s.setLayout({
            y: r
          }, !0)), u = s.getLayout()[a];
        }
      });
    }

    function l(e, t, n) {
      r.each(e.slice().reverse(), function (e) {
        r.each(e, function (e) {
          if (e.outEdges.length) {
            var i = g(e.outEdges, u, n) / g(e.outEdges, p, n);

            if (isNaN(i)) {
              var r = e.outEdges.length;
              i = r ? g(e.outEdges, c, n) / r : 0;
            }

            if ("vertical" === n) {
              var o = e.getLayout().x + (i - f(e, n)) * t;
              e.setLayout({
                x: o
              }, !0);
            } else {
              var a = e.getLayout().y + (i - f(e, n)) * t;
              e.setLayout({
                y: a
              }, !0);
            }
          }
        });
      });
    }

    function u(e, t) {
      return f(e.node2, t) * e.getValue();
    }

    function c(e, t) {
      return f(e.node2, t);
    }

    function h(e, t) {
      return f(e.node1, t) * e.getValue();
    }

    function d(e, t) {
      return f(e.node1, t);
    }

    function f(e, t) {
      return "vertical" === t ? e.getLayout().x + e.getLayout().dx / 2 : e.getLayout().y + e.getLayout().dy / 2;
    }

    function p(e) {
      return e.getValue();
    }

    function g(e, t, n) {
      for (var i = 0, r = e.length, o = -1; ++o < r;) {
        var a = +t.call(e, e[o], n);
        isNaN(a) || (i += a);
      }

      return i;
    }

    function v(e, t, n) {
      r.each(e, function (e) {
        r.each(e, function (e) {
          if (e.inEdges.length) {
            var i = g(e.inEdges, h, n) / g(e.inEdges, p, n);

            if (isNaN(i)) {
              var r = e.inEdges.length;
              i = r ? g(e.inEdges, d, n) / r : 0;
            }

            if ("vertical" === n) {
              var o = e.getLayout().x + (i - f(e, n)) * t;
              e.setLayout({
                x: o
              }, !0);
            } else {
              var a = e.getLayout().y + (i - f(e, n)) * t;
              e.setLayout({
                y: a
              }, !0);
            }
          }
        });
      });
    }

    e.exports = function (e, t, n) {
      e.eachSeriesByType("sankey", function (e) {
        var n = e.get("nodeWidth"),
            u = e.get("nodeGap"),
            c = function (e, t) {
          return i.getLayoutRect(e.getBoxLayoutParams(), {
            width: t.getWidth(),
            height: t.getHeight()
          });
        }(e, t);

        e.layoutInfo = c;
        var h = c.width,
            d = c.height,
            f = e.getGraph(),
            m = f.nodes,
            y = f.edges;
        !function (e) {
          r.each(e, function (e) {
            var t = g(e.outEdges, p),
                n = g(e.inEdges, p),
                i = e.getValue() || 0,
                r = Math.max(t, n, i);
            e.setLayout({
              value: r
            }, !0);
          });
        }(m), function (e, t, n, i, u, c, h, d, f) {
          (function (e, t, n, i, o, s, l) {
            for (var u = [], c = [], h = [], d = [], f = 0, p = 0; p < t.length; p++) {
              u[p] = 1;
            }

            for (p = 0; p < e.length; p++) {
              c[p] = e[p].inEdges.length, 0 === c[p] && h.push(e[p]);
            }

            var g = -1;

            for (; h.length;) {
              for (var v = 0; v < h.length; v++) {
                var m = h[v],
                    y = m.hostGraph.data.getRawDataItem(m.dataIndex),
                    x = null != y.depth && y.depth >= 0;
                x && y.depth > g && (g = y.depth), m.setLayout({
                  depth: x ? y.depth : f
                }, !0), "vertical" === s ? m.setLayout({
                  dy: n
                }, !0) : m.setLayout({
                  dx: n
                }, !0);

                for (var _ = 0; _ < m.outEdges.length; _++) {
                  var b = m.outEdges[_],
                      w = t.indexOf(b);
                  u[w] = 0;
                  var S = b.node2,
                      T = e.indexOf(S);
                  0 == --c[T] && d.indexOf(S) < 0 && d.push(S);
                }
              }

              ++f, h = d, d = [];
            }

            for (p = 0; p < u.length; p++) {
              if (1 === u[p]) throw new Error("Sankey is a DAG, the original data has cycle!");
            }

            var C = g > f - 1 ? g : f - 1;
            l && "left" !== l && function (e, t, n, i) {
              if ("right" === t) {
                for (var o = [], s = e, l = 0; s.length;) {
                  for (var u = 0; u < s.length; u++) {
                    var c = s[u];
                    c.setLayout({
                      skNodeHeight: l
                    }, !0);

                    for (var h = 0; h < c.inEdges.length; h++) {
                      var d = c.inEdges[h];
                      o.indexOf(d.node1) < 0 && o.push(d.node1);
                    }
                  }

                  s = o, o = [], ++l;
                }

                r.each(e, function (e) {
                  a(e) || e.setLayout({
                    depth: Math.max(0, i - e.getLayout().skNodeHeight)
                  }, !0);
                });
              } else "justify" === t && function (e, t) {
                r.each(e, function (e) {
                  a(e) || e.outEdges.length || e.setLayout({
                    depth: t
                  }, !0);
                });
              }(e, i);
            }(e, l, 0, C);
            !function (e, t, n) {
              r.each(e, function (e) {
                var i = e.getLayout().depth * t;
                "vertical" === n ? e.setLayout({
                  y: i
                }, !0) : e.setLayout({
                  x: i
                }, !0);
              });
            }(e, "vertical" === s ? (o - n) / C : (i - n) / C, s);
          })(e, t, n, u, c, d, f), function (e, t, n, i, a, u, c) {
            var h = function (e, t) {
              var n = [],
                  i = "vertical" === t ? "y" : "x",
                  a = o(e, function (e) {
                return e.getLayout()[i];
              });
              return a.keys.sort(function (e, t) {
                return e - t;
              }), r.each(a.keys, function (e) {
                n.push(a.buckets.get(e));
              }), n;
            }(e, c);

            (function (e, t, n, i, o, a) {
              var s = 1 / 0;
              r.each(e, function (e) {
                var t = e.length,
                    l = 0;
                r.each(e, function (e) {
                  l += e.getLayout().value;
                });
                var u = "vertical" === a ? (i - (t - 1) * o) / l : (n - (t - 1) * o) / l;
                u < s && (s = u);
              }), r.each(e, function (e) {
                r.each(e, function (e, t) {
                  var n = e.getLayout().value * s;
                  "vertical" === a ? (e.setLayout({
                    x: t
                  }, !0), e.setLayout({
                    dx: n
                  }, !0)) : (e.setLayout({
                    y: t
                  }, !0), e.setLayout({
                    dy: n
                  }, !0));
                });
              }), r.each(t, function (e) {
                var t = +e.getValue() * s;
                e.setLayout({
                  dy: t
                }, !0);
              });
            })(h, t, n, i, a, c), s(h, a, n, i, c);

            for (var d = 1; u > 0; u--) {
              l(h, d *= .99, c), s(h, a, n, i, c), v(h, d, c), s(h, a, n, i, c);
            }
          }(e, t, c, u, i, h, d), function (e, t) {
            var n = "vertical" === t ? "x" : "y";
            r.each(e, function (e) {
              e.outEdges.sort(function (e, t) {
                return e.node2.getLayout()[n] - t.node2.getLayout()[n];
              }), e.inEdges.sort(function (e, t) {
                return e.node1.getLayout()[n] - t.node1.getLayout()[n];
              });
            }), r.each(e, function (e) {
              var t = 0,
                  n = 0;
              r.each(e.outEdges, function (e) {
                e.setLayout({
                  sy: t
                }, !0), t += e.getLayout().dy;
              }), r.each(e.inEdges, function (e) {
                e.setLayout({
                  ty: n
                }, !0), n += e.getLayout().dy;
              });
            });
          }(e, d);
        }(m, y, n, u, h, d, 0 !== r.filter(m, function (e) {
          return 0 === e.getLayout().value;
        }).length ? 0 : e.get("layoutIterations"), e.get("orient"), e.get("nodeAlign"));
      });
    };
  }, function (e, t, n) {
    var i = n(91),
        r = n(1);

    e.exports = function (e, t) {
      e.eachSeriesByType("sankey", function (e) {
        var t = e.getGraph().nodes;

        if (t.length) {
          var n = 1 / 0,
              o = -1 / 0;
          r.each(t, function (e) {
            var t = e.getLayout().value;
            t < n && (n = t), t > o && (o = t);
          }), r.each(t, function (t) {
            var r = new i({
              type: "color",
              mappingMethod: "linear",
              dataExtent: [n, o],
              visual: e.get("color")
            }).mapValueToVisual(t.getLayout().value),
                a = t.getModel().get("itemStyle.color");
            null != a ? t.setVisual("color", a) : t.setVisual("color", r);
          });
        }
      });
    };
  }, function (e, t, n) {
    var i = n(4);
    n(796), n(797);
    var r = n(798),
        o = n(799);
    i.registerVisual(r), i.registerLayout(o);
  }, function (e, t, n) {
    var i = n(1),
        r = n(27),
        o = n(340).seriesModelMixin,
        a = r.extend({
      type: "series.boxplot",
      dependencies: ["xAxis", "yAxis", "grid"],
      defaultValueDimensions: [{
        name: "min",
        defaultTooltip: !0
      }, {
        name: "Q1",
        defaultTooltip: !0
      }, {
        name: "median",
        defaultTooltip: !0
      }, {
        name: "Q3",
        defaultTooltip: !0
      }, {
        name: "max",
        defaultTooltip: !0
      }],
      dimensions: null,
      defaultOption: {
        zlevel: 0,
        z: 2,
        coordinateSystem: "cartesian2d",
        legendHoverLink: !0,
        hoverAnimation: !0,
        layout: null,
        boxWidth: [7, 50],
        itemStyle: {
          color: "#fff",
          borderWidth: 1
        },
        emphasis: {
          itemStyle: {
            borderWidth: 2,
            shadowBlur: 5,
            shadowOffsetX: 2,
            shadowOffsetY: 2,
            shadowColor: "rgba(0,0,0,0.4)"
          }
        },
        animationEasing: "elasticOut",
        animationDuration: 800
      }
    });
    i.mixin(a, o, !0);
    var s = a;
    e.exports = s;
  }, function (e, t, n) {
    var i = n(1),
        r = n(54),
        o = n(5),
        a = n(20),
        s = ["itemStyle"],
        l = ["emphasis", "itemStyle"],
        u = r.extend({
      type: "boxplot",
      render: function render(e, t, n) {
        var i = e.getData(),
            r = this.group,
            o = this._data;
        this._data || r.removeAll();
        var a = "horizontal" === e.get("layout") ? 1 : 0;
        i.diff(o).add(function (e) {
          if (i.hasValue(e)) {
            var t = h(i.getItemLayout(e), i, e, a, !0);
            i.setItemGraphicEl(e, t), r.add(t);
          }
        }).update(function (e, t) {
          var n = o.getItemGraphicEl(t);

          if (i.hasValue(e)) {
            var s = i.getItemLayout(e);
            n ? d(s, n, i, e) : n = h(s, i, e, a), r.add(n), i.setItemGraphicEl(e, n);
          } else r.remove(n);
        }).remove(function (e) {
          var t = o.getItemGraphicEl(e);
          t && r.remove(t);
        }).execute(), this._data = i;
      },
      remove: function remove(e) {
        var t = this.group,
            n = this._data;
        this._data = null, n && n.eachItemGraphicEl(function (e) {
          e && t.remove(e);
        });
      },
      dispose: i.noop
    }),
        c = a.extend({
      type: "boxplotBoxPath",
      shape: {},
      buildPath: function buildPath(e, t) {
        var n = t.points,
            i = 0;

        for (e.moveTo(n[i][0], n[i][1]), i++; i < 4; i++) {
          e.lineTo(n[i][0], n[i][1]);
        }

        for (e.closePath(); i < n.length; i++) {
          e.moveTo(n[i][0], n[i][1]), i++, e.lineTo(n[i][0], n[i][1]);
        }
      }
    });

    function h(e, t, n, i, r) {
      var o = e.ends,
          a = new c({
        shape: {
          points: r ? f(o, i, e) : o
        }
      });
      return d(e, a, t, n, r), a;
    }

    function d(e, t, n, i, r) {
      var a = n.hostModel;
      (0, o[r ? "initProps" : "updateProps"])(t, {
        shape: {
          points: e.ends
        }
      }, a, i);
      var u = n.getItemModel(i),
          c = u.getModel(s),
          h = n.getItemVisual(i, "color"),
          d = c.getItemStyle(["borderColor"]);
      d.stroke = h, d.strokeNoScale = !0, t.useStyle(d), t.z2 = 100;
      var f = u.getModel(l).getItemStyle();
      o.setHoverStyle(t, f);
    }

    function f(e, t, n) {
      return i.map(e, function (e) {
        return (e = e.slice())[t] = n.initBaseline, e;
      });
    }

    var p = u;
    e.exports = p;
  }, function (e, t) {
    var n = ["itemStyle", "borderColor"];

    e.exports = function (e, t) {
      var i = e.get("color");
      e.eachRawSeriesByType("boxplot", function (t) {
        var r = i[t.seriesIndex % i.length],
            o = t.getData();
        o.setVisual({
          legendSymbol: "roundRect",
          color: t.get(n) || r
        }), e.isSeriesFiltered(t) || o.each(function (e) {
          var t = o.getItemModel(e);
          o.setItemVisual(e, {
            color: t.get(n, !0)
          });
        });
      });
    };
  }, function (e, t, n) {
    var i = n(1),
        r = n(6).parsePercent,
        o = i.each;

    e.exports = function (e) {
      var t = function (e) {
        var t = [],
            n = [];
        return e.eachSeriesByType("boxplot", function (e) {
          var r = e.getBaseAxis(),
              o = i.indexOf(n, r);
          o < 0 && (o = n.length, n[o] = r, t[o] = {
            axis: r,
            seriesModels: []
          }), t[o].seriesModels.push(e);
        }), t;
      }(e);

      o(t, function (e) {
        var t = e.seriesModels;
        t.length && (!function (e) {
          var t,
              n,
              a = e.axis,
              s = e.seriesModels,
              l = s.length,
              u = e.boxWidthList = [],
              c = e.boxOffsetList = [],
              h = [];
          if ("category" === a.type) n = a.getBandWidth();else {
            var d = 0;
            o(s, function (e) {
              d = Math.max(d, e.getData().count());
            }), t = a.getExtent(), Math.abs(t[1] - t[0]);
          }
          o(s, function (e) {
            var t = e.get("boxWidth");
            i.isArray(t) || (t = [t, t]), h.push([r(t[0], n) || 0, r(t[1], n) || 0]);
          });
          var f = .8 * n - 2,
              p = f / l * .3,
              g = (f - p * (l - 1)) / l,
              v = g / 2 - f / 2;
          o(s, function (e, t) {
            c.push(v), v += p + g, u.push(Math.min(Math.max(g, h[t][0]), h[t][1]));
          });
        }(e), o(t, function (t, n) {
          !function (e, t, n) {
            var i = e.coordinateSystem,
                r = e.getData(),
                o = n / 2,
                a = "horizontal" === e.get("layout") ? 0 : 1,
                s = 1 - a,
                l = ["x", "y"],
                u = r.mapDimension(l[a]),
                c = r.mapDimension(l[s], !0);
            if (null == u || c.length < 5) return;

            for (var h = 0; h < r.count(); h++) {
              var d = r.get(u, h),
                  f = x(d, c[2], h),
                  p = x(d, c[0], h),
                  g = x(d, c[1], h),
                  v = x(d, c[3], h),
                  m = x(d, c[4], h),
                  y = [];
              _(y, g, 0), _(y, v, 1), y.push(p, g, m, v), b(y, p), b(y, m), b(y, f), r.setItemLayout(h, {
                initBaseline: f[s],
                ends: y
              });
            }

            function x(e, n, o) {
              var l,
                  u = r.get(n, o),
                  c = [];
              return c[a] = e, c[s] = u, isNaN(e) || isNaN(u) ? l = [NaN, NaN] : (l = i.dataToPoint(c))[a] += t, l;
            }

            function _(e, t, n) {
              var i = t.slice(),
                  r = t.slice();
              i[a] += o, r[a] -= o, n ? e.push(i, r) : e.push(r, i);
            }

            function b(e, t) {
              var n = t.slice(),
                  i = t.slice();
              n[a] -= o, i[a] += o, e.push(n, i);
            }
          }(t, e.boxOffsetList[n], e.boxWidthList[n]);
        }));
      });
    };
  }, function (e, t, n) {
    var i = n(4);
    n(801), n(802);
    var r = n(803),
        o = n(804),
        a = n(805);
    i.registerPreprocessor(r), i.registerVisual(o), i.registerLayout(a);
  }, function (e, t, n) {
    var i = n(1),
        r = n(27),
        o = n(340).seriesModelMixin,
        a = r.extend({
      type: "series.candlestick",
      dependencies: ["xAxis", "yAxis", "grid"],
      defaultValueDimensions: [{
        name: "open",
        defaultTooltip: !0
      }, {
        name: "close",
        defaultTooltip: !0
      }, {
        name: "lowest",
        defaultTooltip: !0
      }, {
        name: "highest",
        defaultTooltip: !0
      }],
      dimensions: null,
      defaultOption: {
        zlevel: 0,
        z: 2,
        coordinateSystem: "cartesian2d",
        legendHoverLink: !0,
        hoverAnimation: !0,
        layout: null,
        clip: !0,
        itemStyle: {
          color: "#c23531",
          color0: "#314656",
          borderWidth: 1,
          borderColor: "#c23531",
          borderColor0: "#314656"
        },
        emphasis: {
          itemStyle: {
            borderWidth: 2
          }
        },
        barMaxWidth: null,
        barMinWidth: null,
        barWidth: null,
        large: !0,
        largeThreshold: 600,
        progressive: 3e3,
        progressiveThreshold: 1e4,
        progressiveChunkMode: "mod",
        animationUpdate: !1,
        animationEasing: "linear",
        animationDuration: 300
      },
      getShadowDim: function getShadowDim() {
        return "open";
      },
      brushSelector: function brushSelector(e, t, n) {
        var i = t.getItemLayout(e);
        return i && n.rect(i.brushRect);
      }
    });
    i.mixin(a, o, !0);
    var s = a;
    e.exports = s;
  }, function (e, t, n) {
    var i = n(1),
        r = n(54),
        o = n(5),
        a = n(20),
        s = n(126).createClipPath,
        l = ["itemStyle"],
        u = ["emphasis", "itemStyle"],
        c = ["color", "color0", "borderColor", "borderColor0"],
        h = r.extend({
      type: "candlestick",
      render: function render(e, t, n) {
        this.group.removeClipPath(), this._updateDrawMode(e), this._isLargeDraw ? this._renderLarge(e) : this._renderNormal(e);
      },
      incrementalPrepareRender: function incrementalPrepareRender(e, t, n) {
        this._clear(), this._updateDrawMode(e);
      },
      incrementalRender: function incrementalRender(e, t, n, i) {
        this._isLargeDraw ? this._incrementalRenderLarge(e, t) : this._incrementalRenderNormal(e, t);
      },
      _updateDrawMode: function _updateDrawMode(e) {
        var t = e.pipelineContext.large;
        (null == this._isLargeDraw || t ^ this._isLargeDraw) && (this._isLargeDraw = t, this._clear());
      },
      _renderNormal: function _renderNormal(e) {
        var t = e.getData(),
            n = this._data,
            i = this.group,
            r = t.getLayout("isSimpleBox"),
            a = e.get("clip", !0),
            s = e.coordinateSystem,
            l = s.getArea && s.getArea();
        this._data || i.removeAll(), t.diff(n).add(function (n) {
          if (t.hasValue(n)) {
            var s,
                u = t.getItemLayout(n);
            if (a && p(l, u)) return;
            s = f(u, n, !0), o.initProps(s, {
              shape: {
                points: u.ends
              }
            }, e, n), g(s, t, n, r), i.add(s), t.setItemGraphicEl(n, s);
          }
        }).update(function (s, u) {
          var c = n.getItemGraphicEl(u);

          if (t.hasValue(s)) {
            var h = t.getItemLayout(s);
            a && p(l, h) ? i.remove(c) : (c ? o.updateProps(c, {
              shape: {
                points: h.ends
              }
            }, e, s) : c = f(h, s), g(c, t, s, r), i.add(c), t.setItemGraphicEl(s, c));
          } else i.remove(c);
        }).remove(function (e) {
          var t = n.getItemGraphicEl(e);
          t && i.remove(t);
        }).execute(), this._data = t;
      },
      _renderLarge: function _renderLarge(e) {
        this._clear(), y(e, this.group);
        var t = e.get("clip", !0) ? s(e.coordinateSystem, !1, e) : null;
        t ? this.group.setClipPath(t) : this.group.removeClipPath();
      },
      _incrementalRenderNormal: function _incrementalRenderNormal(e, t) {
        for (var n, i = t.getData(), r = i.getLayout("isSimpleBox"); null != (n = e.next());) {
          var o;
          g(o = f(i.getItemLayout(n), n), i, n, r), o.incremental = !0, this.group.add(o);
        }
      },
      _incrementalRenderLarge: function _incrementalRenderLarge(e, t) {
        y(t, this.group, !0);
      },
      remove: function remove(e) {
        this._clear();
      },
      _clear: function _clear() {
        this.group.removeAll(), this._data = null;
      },
      dispose: i.noop
    }),
        d = a.extend({
      type: "normalCandlestickBox",
      shape: {},
      buildPath: function buildPath(e, t) {
        var n = t.points;
        this.__simpleBox ? (e.moveTo(n[4][0], n[4][1]), e.lineTo(n[6][0], n[6][1])) : (e.moveTo(n[0][0], n[0][1]), e.lineTo(n[1][0], n[1][1]), e.lineTo(n[2][0], n[2][1]), e.lineTo(n[3][0], n[3][1]), e.closePath(), e.moveTo(n[4][0], n[4][1]), e.lineTo(n[5][0], n[5][1]), e.moveTo(n[6][0], n[6][1]), e.lineTo(n[7][0], n[7][1]));
      }
    });

    function f(e, t, n) {
      var i = e.ends;
      return new d({
        shape: {
          points: n ? v(i, e) : i
        },
        z2: 100
      });
    }

    function p(e, t) {
      for (var n = !0, i = 0; i < t.ends.length; i++) {
        if (e.contain(t.ends[i][0], t.ends[i][1])) {
          n = !1;
          break;
        }
      }

      return n;
    }

    function g(e, t, n, i) {
      var r = t.getItemModel(n),
          a = r.getModel(l),
          s = t.getItemVisual(n, "color"),
          h = t.getItemVisual(n, "borderColor") || s,
          d = a.getItemStyle(c);
      e.useStyle(d), e.style.strokeNoScale = !0, e.style.fill = s, e.style.stroke = h, e.__simpleBox = i;
      var f = r.getModel(u).getItemStyle();
      o.setHoverStyle(e, f);
    }

    function v(e, t) {
      return i.map(e, function (e) {
        return (e = e.slice())[1] = t.initBaseline, e;
      });
    }

    var m = a.extend({
      type: "largeCandlestickBox",
      shape: {},
      buildPath: function buildPath(e, t) {
        for (var n = t.points, i = 0; i < n.length;) {
          if (this.__sign === n[i++]) {
            var r = n[i++];
            e.moveTo(r, n[i++]), e.lineTo(r, n[i++]);
          } else i += 3;
        }
      }
    });

    function y(e, t, n) {
      var i = e.getData(),
          r = i.getLayout("largePoints"),
          o = new m({
        shape: {
          points: r
        },
        __sign: 1
      });
      t.add(o);
      var a = new m({
        shape: {
          points: r
        },
        __sign: -1
      });
      t.add(a), x(1, o, e, i), x(-1, a, e, i), n && (o.incremental = !0, a.incremental = !0);
    }

    function x(e, t, n, i) {
      var r = e > 0 ? "P" : "N",
          o = i.getVisual("borderColor" + r) || i.getVisual("color" + r),
          a = n.getModel(l).getItemStyle(c);
      t.useStyle(a), t.style.fill = null, t.style.stroke = o;
    }

    var _ = h;
    e.exports = _;
  }, function (e, t, n) {
    var i = n(1);

    e.exports = function (e) {
      e && i.isArray(e.series) && i.each(e.series, function (e) {
        i.isObject(e) && "k" === e.type && (e.type = "candlestick");
      });
    };
  }, function (e, t, n) {
    var i = n(103),
        r = ["itemStyle", "borderColor"],
        o = ["itemStyle", "borderColor0"],
        a = ["itemStyle", "color"],
        s = ["itemStyle", "color0"],
        l = {
      seriesType: "candlestick",
      plan: i(),
      performRawSeries: !0,
      reset: function reset(e, t) {
        if (e.getData().setVisual({
          legendSymbol: "roundRect",
          colorP: n(1, e),
          colorN: n(-1, e),
          borderColorP: i(1, e),
          borderColorN: i(-1, e)
        }), !t.isSeriesFiltered(e)) return !e.pipelineContext.large && {
          progress: function progress(e, t) {
            var r;

            for (; null != (r = e.next());) {
              var o = t.getItemModel(r),
                  a = t.getItemLayout(r).sign;
              t.setItemVisual(r, {
                color: n(a, o),
                borderColor: i(a, o)
              });
            }
          }
        };

        function n(e, t) {
          return t.get(e > 0 ? a : s);
        }

        function i(e, t) {
          return t.get(e > 0 ? r : o);
        }
      }
    };
    e.exports = l;
  }, function (e, t, n) {
    var i = n(5).subPixelOptimize,
        r = n(103),
        o = n(6).parsePercent,
        a = n(1).retrieve2,
        s = "undefined" != typeof Float32Array ? Float32Array : Array,
        l = {
      seriesType: "candlestick",
      plan: r(),
      reset: function reset(e) {
        var t = e.coordinateSystem,
            n = e.getData(),
            r = function (e, t) {
          var n,
              i = e.getBaseAxis(),
              r = "category" === i.type ? i.getBandWidth() : (n = i.getExtent(), Math.abs(n[1] - n[0]) / t.count()),
              s = o(a(e.get("barMaxWidth"), r), r),
              l = o(a(e.get("barMinWidth"), 1), r),
              u = e.get("barWidth");
          return null != u ? o(u, r) : Math.max(Math.min(r / 2, s), l);
        }(e, n),
            l = ["x", "y"],
            c = n.mapDimension(l[0]),
            h = n.mapDimension(l[1], !0),
            d = h[0],
            f = h[1],
            p = h[2],
            g = h[3];

        if (n.setLayout({
          candleWidth: r,
          isSimpleBox: r <= 1.3
        }), !(null == c || h.length < 4)) return {
          progress: e.pipelineContext.large ? function (e, n) {
            var i,
                r,
                o = new s(4 * e.count),
                a = 0,
                l = [],
                h = [];

            for (; null != (r = e.next());) {
              var v = n.get(c, r),
                  m = n.get(d, r),
                  y = n.get(f, r),
                  x = n.get(p, r),
                  _ = n.get(g, r);

              isNaN(v) || isNaN(x) || isNaN(_) ? (o[a++] = NaN, a += 3) : (o[a++] = u(n, r, m, y, f), l[0] = v, l[1] = x, i = t.dataToPoint(l, null, h), o[a++] = i ? i[0] : NaN, o[a++] = i ? i[1] : NaN, l[1] = _, i = t.dataToPoint(l, null, h), o[a++] = i ? i[1] : NaN);
            }

            n.setLayout("largePoints", o);
          } : function (e, n) {
            var o;

            for (; null != (o = e.next());) {
              var a = n.get(c, o),
                  s = n.get(d, o),
                  l = n.get(f, o),
                  h = n.get(p, o),
                  v = n.get(g, o),
                  m = Math.min(s, l),
                  y = Math.max(s, l),
                  x = T(m, a),
                  _ = T(y, a),
                  b = T(h, a),
                  w = T(v, a),
                  S = [];

              C(S, _, 0), C(S, x, 1), S.push(M(w), M(_), M(b), M(x)), n.setItemLayout(o, {
                sign: u(n, o, s, l, f),
                initBaseline: s > l ? _[1] : x[1],
                ends: S,
                brushRect: k(h, v, a)
              });
            }

            function T(e, n) {
              var i = [];
              return i[0] = n, i[1] = e, isNaN(n) || isNaN(e) ? [NaN, NaN] : t.dataToPoint(i);
            }

            function C(e, t, n) {
              var o = t.slice(),
                  a = t.slice();
              o[0] = i(o[0] + r / 2, 1, !1), a[0] = i(a[0] - r / 2, 1, !0), n ? e.push(o, a) : e.push(a, o);
            }

            function k(e, t, n) {
              var i = T(e, n),
                  o = T(t, n);
              return i[0] -= r / 2, o[0] -= r / 2, {
                x: i[0],
                y: i[1],
                width: r,
                height: o[1] - i[1]
              };
            }

            function M(e) {
              return e[0] = i(e[0], 1), e;
            }
          }
        };
      }
    };

    function u(e, t, n, i, r) {
      return n > i ? -1 : n < i ? 1 : t > 0 ? e.get(r, t - 1) <= i ? 1 : -1 : 1;
    }

    e.exports = l;
  }, function (e, t, n) {
    var i = n(4);
    n(807), n(808);
    var r = n(88),
        o = n(127);
    i.registerVisual(r("effectScatter", "circle")), i.registerLayout(o("effectScatter"));
  }, function (e, t, n) {
    var i = n(62),
        r = n(27).extend({
      type: "series.effectScatter",
      dependencies: ["grid", "polar"],
      getInitialData: function getInitialData(e, t) {
        return i(this.getSource(), this, {
          useEncodeDefaulter: !0
        });
      },
      brushSelector: "point",
      defaultOption: {
        coordinateSystem: "cartesian2d",
        zlevel: 0,
        z: 2,
        legendHoverLink: !0,
        effectType: "ripple",
        progressive: 0,
        showEffectOn: "render",
        rippleEffect: {
          period: 4,
          scale: 2.5,
          brushType: "fill"
        },
        symbolSize: 10
      }
    });
    e.exports = r;
  }, function (e, t, n) {
    var i = n(4),
        r = n(125),
        o = n(809),
        a = n(31),
        s = n(127),
        l = i.extendChartView({
      type: "effectScatter",
      init: function init() {
        this._symbolDraw = new r(o);
      },
      render: function render(e, t, n) {
        var i = e.getData(),
            r = this._symbolDraw;
        r.updateData(i), this.group.add(r.group);
      },
      updateTransform: function updateTransform(e, t, n) {
        var i = e.getData();
        this.group.dirty();
        var r = s().reset(e);
        r.progress && r.progress({
          start: 0,
          end: i.count()
        }, i), this._symbolDraw.updateLayout(i);
      },
      _updateGroupTransform: function _updateGroupTransform(e) {
        var t = e.coordinateSystem;
        t && t.getRoamTransform && (this.group.transform = a.clone(t.getRoamTransform()), this.group.decomposeTransform());
      },
      remove: function remove(e, t) {
        this._symbolDraw && this._symbolDraw.remove(t);
      },
      dispose: function dispose() {}
    });
    e.exports = l;
  }, function (e, t, n) {
    var i = n(1),
        r = n(40).createSymbol,
        o = n(5).Group,
        a = n(6).parsePercent,
        s = n(162);

    function l(e, t) {
      var n = t.rippleEffectColor || t.color;
      e.eachChild(function (e) {
        e.attr({
          z: t.z,
          zlevel: t.zlevel,
          style: {
            stroke: "stroke" === t.brushType ? n : null,
            fill: "fill" === t.brushType ? n : null
          }
        });
      });
    }

    function u(e, t) {
      o.call(this);
      var n = new s(e, t),
          i = new o();
      this.add(n), this.add(i), i.beforeUpdate = function () {
        this.attr(n.getScale());
      }, this.updateData(e, t);
    }

    var c = u.prototype;
    c.stopEffectAnimation = function () {
      this.childAt(1).removeAll();
    }, c.startEffectAnimation = function (e) {
      for (var t = e.symbolType, n = e.color, i = this.childAt(1), o = 0; o < 3; o++) {
        var a = r(t, -1, -1, 2, 2, n);
        a.attr({
          style: {
            strokeNoScale: !0
          },
          z2: 99,
          silent: !0,
          scale: [.5, .5]
        });
        var s = -o / 3 * e.period + e.effectOffset;
        a.animate("", !0).when(e.period, {
          scale: [e.rippleScale / 2, e.rippleScale / 2]
        }).delay(s).start(), a.animateStyle(!0).when(e.period, {
          opacity: 0
        }).delay(s).start(), i.add(a);
      }

      l(i, e);
    }, c.updateEffectAnimation = function (e) {
      for (var t = this._effectCfg, n = this.childAt(1), i = ["symbolType", "period", "rippleScale"], r = 0; r < i.length; r++) {
        var o = i[r];
        if (t[o] !== e[o]) return this.stopEffectAnimation(), void this.startEffectAnimation(e);
      }

      l(n, e);
    }, c.highlight = function () {
      this.trigger("emphasis");
    }, c.downplay = function () {
      this.trigger("normal");
    }, c.updateData = function (e, t) {
      var n = e.hostModel;
      this.childAt(0).updateData(e, t);

      var r = this.childAt(1),
          o = e.getItemModel(t),
          s = e.getItemVisual(t, "symbol"),
          l = function (e) {
        return i.isArray(e) || (e = [+e, +e]), e;
      }(e.getItemVisual(t, "symbolSize")),
          u = e.getItemVisual(t, "color");

      r.attr("scale", l), r.traverse(function (e) {
        e.attr({
          fill: u
        });
      });
      var c = o.getShallow("symbolOffset");

      if (c) {
        var h = r.position;
        h[0] = a(c[0], l[0]), h[1] = a(c[1], l[1]);
      }

      var d = e.getItemVisual(t, "symbolRotate");
      r.rotation = (d || 0) * Math.PI / 180 || 0;
      var f = {};
      if (f.showEffectOn = n.get("showEffectOn"), f.rippleScale = o.get("rippleEffect.scale"), f.brushType = o.get("rippleEffect.brushType"), f.period = 1e3 * o.get("rippleEffect.period"), f.effectOffset = t / e.count(), f.z = o.getShallow("z") || 0, f.zlevel = o.getShallow("zlevel") || 0, f.symbolType = s, f.color = u, f.rippleEffectColor = o.get("rippleEffect.color"), this.off("mouseover").off("mouseout").off("emphasis").off("normal"), "render" === f.showEffectOn) this._effectCfg ? this.updateEffectAnimation(f) : this.startEffectAnimation(f), this._effectCfg = f;else {
        this._effectCfg = null, this.stopEffectAnimation();

        var p = this.childAt(0),
            g = function g() {
          p.highlight(), "render" !== f.showEffectOn && this.startEffectAnimation(f);
        },
            v = function v() {
          p.downplay(), "render" !== f.showEffectOn && this.stopEffectAnimation();
        };

        this.on("mouseover", g, this).on("mouseout", v, this).on("emphasis", g, this).on("normal", v, this);
      }
      this._effectCfg = f;
    }, c.fadeOut = function (e) {
      this.off("mouseover").off("mouseout").off("emphasis").off("normal"), e && e();
    }, i.inherits(u, o);
    var h = u;
    e.exports = h;
  }, function (e, t, n) {
    var i = n(4);
    n(811), n(812);
    var r = n(343),
        o = n(815);
    i.registerLayout(r), i.registerVisual(o);
  }, function (e, t, n) {
    n(9).__DEV__;
    var i = n(27),
        r = n(39),
        o = n(1),
        a = o.concatArray,
        s = o.mergeAll,
        l = o.map,
        u = n(15).encodeHTML,
        c = (n(42), "undefined" == typeof Uint32Array ? Array : Uint32Array),
        h = "undefined" == typeof Float64Array ? Array : Float64Array;

    function d(e) {
      var t = e.data;
      t && t[0] && t[0][0] && t[0][0].coord && (e.data = l(t, function (e) {
        var t = {
          coords: [e[0].coord, e[1].coord]
        };
        return e[0].name && (t.fromName = e[0].name), e[1].name && (t.toName = e[1].name), s([t, e[0], e[1]]);
      }));
    }

    var f = i.extend({
      type: "series.lines",
      dependencies: ["grid", "polar"],
      visualColorAccessPath: "lineStyle.color",
      init: function init(e) {
        e.data = e.data || [], d(e);

        var t = this._processFlatCoordsArray(e.data);

        this._flatCoords = t.flatCoords, this._flatCoordsOffset = t.flatCoordsOffset, t.flatCoords && (e.data = new Float32Array(t.count)), f.superApply(this, "init", arguments);
      },
      mergeOption: function mergeOption(e) {
        if (e.data = e.data || [], d(e), e.data) {
          var t = this._processFlatCoordsArray(e.data);

          this._flatCoords = t.flatCoords, this._flatCoordsOffset = t.flatCoordsOffset, t.flatCoords && (e.data = new Float32Array(t.count));
        }

        f.superApply(this, "mergeOption", arguments);
      },
      appendData: function appendData(e) {
        var t = this._processFlatCoordsArray(e.data);

        t.flatCoords && (this._flatCoords ? (this._flatCoords = a(this._flatCoords, t.flatCoords), this._flatCoordsOffset = a(this._flatCoordsOffset, t.flatCoordsOffset)) : (this._flatCoords = t.flatCoords, this._flatCoordsOffset = t.flatCoordsOffset), e.data = new Float32Array(t.count)), this.getRawData().appendData(e.data);
      },
      _getCoordsFromItemModel: function _getCoordsFromItemModel(e) {
        var t = this.getData().getItemModel(e);
        return t.option instanceof Array ? t.option : t.getShallow("coords");
      },
      getLineCoordsCount: function getLineCoordsCount(e) {
        return this._flatCoordsOffset ? this._flatCoordsOffset[2 * e + 1] : this._getCoordsFromItemModel(e).length;
      },
      getLineCoords: function getLineCoords(e, t) {
        if (this._flatCoordsOffset) {
          for (var n = this._flatCoordsOffset[2 * e], i = this._flatCoordsOffset[2 * e + 1], r = 0; r < i; r++) {
            t[r] = t[r] || [], t[r][0] = this._flatCoords[n + 2 * r], t[r][1] = this._flatCoords[n + 2 * r + 1];
          }

          return i;
        }

        var o = this._getCoordsFromItemModel(e);

        for (r = 0; r < o.length; r++) {
          t[r] = t[r] || [], t[r][0] = o[r][0], t[r][1] = o[r][1];
        }

        return o.length;
      },
      _processFlatCoordsArray: function _processFlatCoordsArray(e) {
        var t = 0;

        if (this._flatCoords && (t = this._flatCoords.length), "number" == typeof e[0]) {
          for (var n = e.length, i = new c(n), r = new h(n), o = 0, a = 0, s = 0, l = 0; l < n;) {
            s++;
            var u = e[l++];
            i[a++] = o + t, i[a++] = u;

            for (var d = 0; d < u; d++) {
              var f = e[l++],
                  p = e[l++];
              r[o++] = f, r[o++] = p;
            }
          }

          return {
            flatCoordsOffset: new Uint32Array(i.buffer, 0, a),
            flatCoords: r,
            count: s
          };
        }

        return {
          flatCoordsOffset: null,
          flatCoords: null,
          count: e.length
        };
      },
      getInitialData: function getInitialData(e, t) {
        var n = new r(["value"], this);
        return n.hasItemOption = !1, n.initData(e.data, [], function (e, t, i, r) {
          if (e instanceof Array) return NaN;
          n.hasItemOption = !0;
          var o = e.value;
          return null != o ? o instanceof Array ? o[r] : o : void 0;
        }), n;
      },
      formatTooltip: function formatTooltip(e) {
        var t = this.getData().getItemModel(e),
            n = t.get("name");
        if (n) return n;
        var i = t.get("fromName"),
            r = t.get("toName"),
            o = [];
        return null != i && o.push(i), null != r && o.push(r), u(o.join(" > "));
      },
      preventIncremental: function preventIncremental() {
        return !!this.get("effect.show");
      },
      getProgressive: function getProgressive() {
        var e = this.option.progressive;
        return null == e ? this.option.large ? 1e4 : this.get("progressive") : e;
      },
      getProgressiveThreshold: function getProgressiveThreshold() {
        var e = this.option.progressiveThreshold;
        return null == e ? this.option.large ? 2e4 : this.get("progressiveThreshold") : e;
      },
      defaultOption: {
        coordinateSystem: "geo",
        zlevel: 0,
        z: 2,
        legendHoverLink: !0,
        hoverAnimation: !0,
        xAxisIndex: 0,
        yAxisIndex: 0,
        symbol: ["none", "none"],
        symbolSize: [10, 10],
        geoIndex: 0,
        effect: {
          show: !1,
          period: 4,
          constantSpeed: 0,
          symbol: "circle",
          symbolSize: 3,
          loop: !0,
          trailLength: .2
        },
        large: !1,
        largeThreshold: 2e3,
        polyline: !1,
        clip: !0,
        label: {
          show: !1,
          position: "end"
        },
        lineStyle: {
          opacity: .5
        }
      }
    }),
        p = f;
    e.exports = p;
  }, function (e, t, n) {
    n(9).__DEV__;
    var i = n(4),
        r = n(221),
        o = n(341),
        a = n(222),
        s = n(342),
        l = n(813),
        u = n(814),
        c = n(343),
        h = n(126).createClipPath,
        d = i.extendChartView({
      type: "lines",
      init: function init() {},
      render: function render(e, t, n) {
        var i = e.getData(),
            r = this._updateLineDraw(i, e),
            o = e.get("zlevel"),
            a = e.get("effect.trailLength"),
            s = n.getZr(),
            l = "svg" === s.painter.getType();

        l || s.painter.getLayer(o).clear(!0), null == this._lastZlevel || l || s.configLayer(this._lastZlevel, {
          motionBlur: !1
        }), this._showEffect(e) && a && (l || s.configLayer(o, {
          motionBlur: !0,
          lastFrameAlpha: Math.max(Math.min(a / 10 + .9, 1), 0)
        })), r.updateData(i);
        var u = e.get("clip", !0) && h(e.coordinateSystem, !1, e);
        u ? this.group.setClipPath(u) : this.group.removeClipPath(), this._lastZlevel = o, this._finished = !0;
      },
      incrementalPrepareRender: function incrementalPrepareRender(e, t, n) {
        var i = e.getData();
        this._updateLineDraw(i, e).incrementalPrepareUpdate(i), this._clearLayer(n), this._finished = !1;
      },
      incrementalRender: function incrementalRender(e, t, n) {
        this._lineDraw.incrementalUpdate(e, t.getData()), this._finished = e.end === t.getData().count();
      },
      updateTransform: function updateTransform(e, t, n) {
        var i = e.getData(),
            r = e.pipelineContext;
        if (!this._finished || r.large || r.progressiveRender) return {
          update: !0
        };
        var o = c.reset(e);
        o.progress && o.progress({
          start: 0,
          end: i.count()
        }, i), this._lineDraw.updateLayout(), this._clearLayer(n);
      },
      _updateLineDraw: function _updateLineDraw(e, t) {
        var n = this._lineDraw,
            i = this._showEffect(t),
            c = !!t.get("polyline"),
            h = t.pipelineContext.large;

        return n && i === this._hasEffet && c === this._isPolyline && h === this._isLargeDraw || (n && n.remove(), n = this._lineDraw = h ? new u() : new r(c ? i ? l : s : i ? o : a), this._hasEffet = i, this._isPolyline = c, this._isLargeDraw = h, this.group.removeAll()), this.group.add(n.group), n;
      },
      _showEffect: function _showEffect(e) {
        return !!e.get("effect.show");
      },
      _clearLayer: function _clearLayer(e) {
        var t = e.getZr();
        "svg" === t.painter.getType() || null == this._lastZlevel || t.painter.getLayer(this._lastZlevel).clear(!0);
      },
      remove: function remove(e, t) {
        this._lineDraw && this._lineDraw.remove(), this._lineDraw = null, this._clearLayer(t);
      },
      dispose: function dispose() {}
    });
    e.exports = d;
  }, function (e, t, n) {
    var i = n(342),
        r = n(1),
        o = n(341),
        a = n(16);

    function s(e, t, n) {
      o.call(this, e, t, n), this._lastFrame = 0, this._lastFramePercent = 0;
    }

    var l = s.prototype;
    l.createLine = function (e, t, n) {
      return new i(e, t, n);
    }, l.updateAnimationPoints = function (e, t) {
      this._points = t;

      for (var n = [0], i = 0, r = 1; r < t.length; r++) {
        var o = t[r - 1],
            s = t[r];
        i += a.dist(o, s), n.push(i);
      }

      if (0 !== i) {
        for (r = 0; r < n.length; r++) {
          n[r] /= i;
        }

        this._offsets = n, this._length = i;
      }
    }, l.getLineLength = function (e) {
      return this._length;
    }, l.updateSymbolPosition = function (e) {
      var t = e.__t,
          n = this._points,
          i = this._offsets,
          r = n.length;

      if (i) {
        var o = this._lastFrame;

        if (t < this._lastFramePercent) {
          for (s = Math.min(o + 1, r - 1); s >= 0 && !(i[s] <= t); s--) {
            ;
          }

          s = Math.min(s, r - 2);
        } else {
          for (var s = o; s < r && !(i[s] > t); s++) {
            ;
          }

          s = Math.min(s - 1, r - 2);
        }

        a.lerp(e.position, n[s], n[s + 1], (t - i[s]) / (i[s + 1] - i[s]));
        var l = n[s + 1][0] - n[s][0],
            u = n[s + 1][1] - n[s][1];
        e.rotation = -Math.atan2(u, l) - Math.PI / 2, this._lastFrame = s, this._lastFramePercent = t, e.ignore = !1;
      }
    }, r.inherits(s, o);
    var u = s;
    e.exports = u;
  }, function (e, t, n) {
    var i = n(5),
        r = n(209),
        o = n(296),
        a = n(297),
        s = i.extendShape({
      shape: {
        polyline: !1,
        curveness: 0,
        segs: []
      },
      buildPath: function buildPath(e, t) {
        var n = t.segs,
            i = t.curveness;
        if (t.polyline) for (var r = 0; r < n.length;) {
          var o = n[r++];

          if (o > 0) {
            e.moveTo(n[r++], n[r++]);

            for (var a = 1; a < o; a++) {
              e.lineTo(n[r++], n[r++]);
            }
          }
        } else for (r = 0; r < n.length;) {
          var s = n[r++],
              l = n[r++],
              u = n[r++],
              c = n[r++];

          if (e.moveTo(s, l), i > 0) {
            var h = (s + u) / 2 - (l - c) * i,
                d = (l + c) / 2 - (u - s) * i;
            e.quadraticCurveTo(h, d, u, c);
          } else e.lineTo(u, c);
        }
      },
      findDataIndex: function findDataIndex(e, t) {
        var n = this.shape,
            i = n.segs,
            r = n.curveness;
        if (n.polyline) for (var s = 0, l = 0; l < i.length;) {
          var u = i[l++];
          if (u > 0) for (var c = i[l++], h = i[l++], d = 1; d < u; d++) {
            var f = i[l++],
                p = i[l++];
            if (o.containStroke(c, h, f, p)) return s;
          }
          s++;
        } else for (s = 0, l = 0; l < i.length;) {
          c = i[l++], h = i[l++], f = i[l++], p = i[l++];

          if (r > 0) {
            var g = (c + f) / 2 - (h - p) * r,
                v = (h + p) / 2 - (f - c) * r;
            if (a.containStroke(c, h, g, v, f, p)) return s;
          } else if (o.containStroke(c, h, f, p)) return s;

          s++;
        }
        return -1;
      }
    });

    function l() {
      this.group = new i.Group();
    }

    var u = l.prototype;
    u.isPersistent = function () {
      return !this._incremental;
    }, u.updateData = function (e) {
      this.group.removeAll();
      var t = new s({
        rectHover: !0,
        cursor: "default"
      });
      t.setShape({
        segs: e.getLayout("linesPoints")
      }), this._setCommon(t, e), this.group.add(t), this._incremental = null;
    }, u.incrementalPrepareUpdate = function (e) {
      this.group.removeAll(), this._clearIncremental(), e.count() > 5e5 ? (this._incremental || (this._incremental = new r({
        silent: !0
      })), this.group.add(this._incremental)) : this._incremental = null;
    }, u.incrementalUpdate = function (e, t) {
      var n = new s();
      n.setShape({
        segs: t.getLayout("linesPoints")
      }), this._setCommon(n, t, !!this._incremental), this._incremental ? this._incremental.addDisplayable(n, !0) : (n.rectHover = !0, n.cursor = "default", n.__startIndex = e.start, this.group.add(n));
    }, u.remove = function () {
      this._clearIncremental(), this._incremental = null, this.group.removeAll();
    }, u._setCommon = function (e, t, n) {
      var i = t.hostModel;
      e.setShape({
        polyline: i.get("polyline"),
        curveness: i.get("lineStyle.curveness")
      }), e.useStyle(i.getModel("lineStyle").getLineStyle()), e.style.strokeNoScale = !0;
      var r = t.getVisual("color");
      r && e.setStyle("stroke", r), e.setStyle("fill"), n || (e.seriesIndex = i.seriesIndex, e.on("mousemove", function (t) {
        e.dataIndex = null;
        var n = e.findDataIndex(t.offsetX, t.offsetY);
        n > 0 && (e.dataIndex = n + e.__startIndex);
      }));
    }, u._clearIncremental = function () {
      var e = this._incremental;
      e && e.clearDisplaybles();
    };
    var c = l;
    e.exports = c;
  }, function (e, t) {
    function n(e) {
      return e instanceof Array || (e = [e, e]), e;
    }

    var i = "lineStyle.opacity".split("."),
        r = {
      seriesType: "lines",
      reset: function reset(e, t, r) {
        var o = n(e.get("symbol")),
            a = n(e.get("symbolSize")),
            s = e.getData();
        return s.setVisual("fromSymbol", o && o[0]), s.setVisual("toSymbol", o && o[1]), s.setVisual("fromSymbolSize", a && a[0]), s.setVisual("toSymbolSize", a && a[1]), s.setVisual("opacity", e.get(i)), {
          dataEach: s.hasItemOption ? function (e, t) {
            var r = e.getItemModel(t),
                o = n(r.getShallow("symbol", !0)),
                a = n(r.getShallow("symbolSize", !0)),
                s = r.get(i);
            o[0] && e.setItemVisual(t, "fromSymbol", o[0]), o[1] && e.setItemVisual(t, "toSymbol", o[1]), a[0] && e.setItemVisual(t, "fromSymbolSize", a[0]), a[1] && e.setItemVisual(t, "toSymbolSize", a[1]), e.setItemVisual(t, "opacity", s);
          } : null
        };
      }
    };
    e.exports = r;
  }, function (e, t, n) {
    n(817), n(818);
  }, function (e, t, n) {
    var i = n(27),
        r = n(62),
        o = n(42),
        a = i.extend({
      type: "series.heatmap",
      getInitialData: function getInitialData(e, t) {
        return r(this.getSource(), this, {
          generateCoord: "value"
        });
      },
      preventIncremental: function preventIncremental() {
        var e = o.get(this.get("coordinateSystem"));
        if (e && e.dimensions) return "lng" === e.dimensions[0] && "lat" === e.dimensions[1];
      },
      defaultOption: {
        coordinateSystem: "cartesian2d",
        zlevel: 0,
        z: 2,
        geoIndex: 0,
        blurSize: 30,
        pointSize: 20,
        maxOpacity: 1,
        minOpacity: 0
      }
    });
    e.exports = a;
  }, function (e, t, n) {
    n(9).__DEV__;
    var i = n(4),
        r = n(5),
        o = n(819),
        a = n(1);
    var s = i.extendChartView({
      type: "heatmap",
      render: function render(e, t, n) {
        var i;
        t.eachComponent("visualMap", function (t) {
          t.eachTargetSeries(function (n) {
            n === e && (i = t);
          });
        }), this.group.removeAll(), this._incrementalDisplayable = null;
        var r = e.coordinateSystem;
        "cartesian2d" === r.type || "calendar" === r.type ? this._renderOnCartesianAndCalendar(e, n, 0, e.getData().count()) : function (e) {
          var t = e.dimensions;
          return "lng" === t[0] && "lat" === t[1];
        }(r) && this._renderOnGeo(r, e, i, n);
      },
      incrementalPrepareRender: function incrementalPrepareRender(e, t, n) {
        this.group.removeAll();
      },
      incrementalRender: function incrementalRender(e, t, n, i) {
        t.coordinateSystem && this._renderOnCartesianAndCalendar(t, i, e.start, e.end, !0);
      },
      _renderOnCartesianAndCalendar: function _renderOnCartesianAndCalendar(e, t, n, i, o) {
        var s,
            l,
            u = e.coordinateSystem;

        if ("cartesian2d" === u.type) {
          var c = u.getAxis("x"),
              h = u.getAxis("y");
          s = c.getBandWidth(), l = h.getBandWidth();
        }

        for (var d = this.group, f = e.getData(), p = e.getModel("itemStyle").getItemStyle(["color"]), g = e.getModel("emphasis.itemStyle").getItemStyle(), v = e.getModel("label"), m = e.getModel("emphasis.label"), y = u.type, x = "cartesian2d" === y ? [f.mapDimension("x"), f.mapDimension("y"), f.mapDimension("value")] : [f.mapDimension("time"), f.mapDimension("value")], _ = n; _ < i; _++) {
          var b;

          if ("cartesian2d" === y) {
            if (isNaN(f.get(x[2], _))) continue;
            var w = u.dataToPoint([f.get(x[0], _), f.get(x[1], _)]);
            b = new r.Rect({
              shape: {
                x: Math.floor(Math.round(w[0]) - s / 2),
                y: Math.floor(Math.round(w[1]) - l / 2),
                width: Math.ceil(s),
                height: Math.ceil(l)
              },
              style: {
                fill: f.getItemVisual(_, "color"),
                opacity: f.getItemVisual(_, "opacity")
              }
            });
          } else {
            if (isNaN(f.get(x[1], _))) continue;
            b = new r.Rect({
              z2: 1,
              shape: u.dataToRect([f.get(x[0], _)]).contentShape,
              style: {
                fill: f.getItemVisual(_, "color"),
                opacity: f.getItemVisual(_, "opacity")
              }
            });
          }

          var S = f.getItemModel(_);
          f.hasItemOption && (p = S.getModel("itemStyle").getItemStyle(["color"]), g = S.getModel("emphasis.itemStyle").getItemStyle(), v = S.getModel("label"), m = S.getModel("emphasis.label"));
          var T = e.getRawValue(_),
              C = "-";
          T && null != T[2] && (C = T[2]), r.setLabelStyle(p, g, v, m, {
            labelFetcher: e,
            labelDataIndex: _,
            defaultText: C,
            isRectText: !0
          }), b.setStyle(p), r.setHoverStyle(b, f.hasItemOption ? g : a.extend({}, g)), b.incremental = o, o && (b.useHoverLayer = !0), d.add(b), f.setItemGraphicEl(_, b);
        }
      },
      _renderOnGeo: function _renderOnGeo(e, t, n, i) {
        var s = n.targetVisuals.inRange,
            l = n.targetVisuals.outOfRange,
            u = t.getData(),
            c = this._hmLayer || this._hmLayer || new o();
        c.blurSize = t.get("blurSize"), c.pointSize = t.get("pointSize"), c.minOpacity = t.get("minOpacity"), c.maxOpacity = t.get("maxOpacity");
        var h = e.getViewRect().clone(),
            d = e.getRoamTransform();
        h.applyTransform(d);

        var f = Math.max(h.x, 0),
            p = Math.max(h.y, 0),
            g = Math.min(h.width + h.x, i.getWidth()),
            v = Math.min(h.height + h.y, i.getHeight()),
            m = g - f,
            y = v - p,
            x = [u.mapDimension("lng"), u.mapDimension("lat"), u.mapDimension("value")],
            _ = u.mapArray(x, function (t, n, i) {
          var r = e.dataToPoint([t, n]);
          return r[0] -= f, r[1] -= p, r.push(i), r;
        }),
            b = n.getExtent(),
            w = "visualMap.continuous" === n.type ? function (e, t) {
          var n = e[1] - e[0];
          return t = [(t[0] - e[0]) / n, (t[1] - e[0]) / n], function (e) {
            return e >= t[0] && e <= t[1];
          };
        }(b, n.option.range) : function (e, t, n) {
          var i = e[1] - e[0],
              r = (t = a.map(t, function (t) {
            return {
              interval: [(t.interval[0] - e[0]) / i, (t.interval[1] - e[0]) / i]
            };
          })).length,
              o = 0;
          return function (e) {
            for (var i = o; i < r; i++) {
              if ((a = t[i].interval)[0] <= e && e <= a[1]) {
                o = i;
                break;
              }
            }

            if (i === r) for (i = o - 1; i >= 0; i--) {
              var a;

              if ((a = t[i].interval)[0] <= e && e <= a[1]) {
                o = i;
                break;
              }
            }
            return i >= 0 && i < r && n[i];
          };
        }(b, n.getPieceList(), n.option.selected);

        c.update(_, m, y, s.color.getNormalizer(), {
          inRange: s.color.getColorMapper(),
          outOfRange: l.color.getColorMapper()
        }, w);
        var S = new r.Image({
          style: {
            width: m,
            height: y,
            x: f,
            y: p,
            image: c.canvas
          },
          silent: !0
        });
        this.group.add(S);
      },
      dispose: function dispose() {}
    });
    e.exports = s;
  }, function (e, t, n) {
    var i = n(1);

    function r() {
      var e = i.createCanvas();
      this.canvas = e, this.blurSize = 30, this.pointSize = 20, this.maxOpacity = 1, this.minOpacity = 0, this._gradientPixels = {};
    }

    r.prototype = {
      update: function update(e, t, n, i, r, o) {
        var a = this._getBrush(),
            s = this._getGradient(e, r, "inRange"),
            l = this._getGradient(e, r, "outOfRange"),
            u = this.pointSize + this.blurSize,
            c = this.canvas,
            h = c.getContext("2d"),
            d = e.length;

        c.width = t, c.height = n;

        for (var f = 0; f < d; ++f) {
          var p = e[f],
              g = p[0],
              v = p[1],
              m = i(p[2]);
          h.globalAlpha = m, h.drawImage(a, g - u, v - u);
        }

        if (!c.width || !c.height) return c;

        for (var y = h.getImageData(0, 0, c.width, c.height), x = y.data, _ = 0, b = x.length, w = this.minOpacity, S = this.maxOpacity - w; _ < b;) {
          m = x[_ + 3] / 256;
          var T = 4 * Math.floor(255 * m);

          if (m > 0) {
            var C = o(m) ? s : l;
            m > 0 && (m = m * S + w), x[_++] = C[T], x[_++] = C[T + 1], x[_++] = C[T + 2], x[_++] = C[T + 3] * m * 256;
          } else _ += 4;
        }

        return h.putImageData(y, 0, 0), c;
      },
      _getBrush: function _getBrush() {
        var e = this._brushCanvas || (this._brushCanvas = i.createCanvas()),
            t = this.pointSize + this.blurSize,
            n = 2 * t;
        e.width = n, e.height = n;
        var r = e.getContext("2d");
        return r.clearRect(0, 0, n, n), r.shadowOffsetX = n, r.shadowBlur = this.blurSize, r.shadowColor = "#000", r.beginPath(), r.arc(-t, t, this.pointSize, 0, 2 * Math.PI, !0), r.closePath(), r.fill(), e;
      },
      _getGradient: function _getGradient(e, t, n) {
        for (var i = this._gradientPixels, r = i[n] || (i[n] = new Uint8ClampedArray(1024)), o = [0, 0, 0, 0], a = 0, s = 0; s < 256; s++) {
          t[n](s / 255, !0, o), r[a++] = o[0], r[a++] = o[1], r[a++] = o[2], r[a++] = o[3];
        }

        return r;
      }
    };
    var o = r;
    e.exports = o;
  }, function (e, t, n) {
    var i = n(4),
        r = n(1);
    n(214), n(821), n(822);
    var o = n(161).layout,
        a = n(88);
    n(128), i.registerLayout(r.curry(o, "pictorialBar")), i.registerVisual(a("pictorialBar", "roundRect"));
  }, function (e, t, n) {
    var i = n(325).extend({
      type: "series.pictorialBar",
      dependencies: ["grid"],
      defaultOption: {
        symbol: "circle",
        symbolSize: null,
        symbolRotate: null,
        symbolPosition: null,
        symbolOffset: null,
        symbolMargin: null,
        symbolRepeat: !1,
        symbolRepeatDirection: "end",
        symbolClip: !1,
        symbolBoundingData: null,
        symbolPatternSize: 400,
        barGap: "-100%",
        progressive: 0,
        hoverAnimation: !1
      },
      getInitialData: function getInitialData(e) {
        return e.stack = null, i.superApply(this, "getInitialData", arguments);
      }
    }),
        r = i;
    e.exports = r;
  }, function (e, t, n) {
    var i = n(4),
        r = n(1),
        o = n(5),
        a = n(40).createSymbol,
        s = n(6),
        l = s.parsePercent,
        u = s.isNumeric,
        c = n(326).setLabel,
        h = ["itemStyle", "borderWidth"],
        d = [{
      xy: "x",
      wh: "width",
      index: 0,
      posDesc: ["left", "right"]
    }, {
      xy: "y",
      wh: "height",
      index: 1,
      posDesc: ["top", "bottom"]
    }],
        f = new o.Circle();

    function p(e, t, n, i) {
      var o = e.getItemLayout(t),
          a = n.get("symbolRepeat"),
          s = n.get("symbolClip"),
          c = n.get("symbolPosition") || "start",
          d = (n.get("symbolRotate") || 0) * Math.PI / 180 || 0,
          p = n.get("symbolPatternSize") || 2,
          v = n.isAnimationEnabled(),
          m = {
        dataIndex: t,
        layout: o,
        itemModel: n,
        symbolType: e.getItemVisual(t, "symbol") || "circle",
        color: e.getItemVisual(t, "color"),
        symbolClip: s,
        symbolRepeat: a,
        symbolRepeatDirection: n.get("symbolRepeatDirection"),
        symbolPatternSize: p,
        rotation: d,
        animationModel: v ? n : null,
        hoverAnimation: v && n.get("hoverAnimation"),
        z2: n.getShallow("z", !0) || 0
      };
      !function (e, t, n, i, o) {
        var a,
            s = i.valueDim,
            l = e.get("symbolBoundingData"),
            u = i.coordSys.getOtherAxis(i.coordSys.getBaseAxis()),
            c = u.toGlobalCoord(u.dataToCoord(0)),
            h = 1 - +(n[s.wh] <= 0);

        if (r.isArray(l)) {
          var d = [g(u, l[0]) - c, g(u, l[1]) - c];
          d[1] < d[0] && d.reverse(), a = d[h];
        } else a = null != l ? g(u, l) - c : t ? i.coordSysExtent[s.index][h] - c : n[s.wh];

        o.boundingLength = a, t && (o.repeatCutLength = n[s.wh]);
        o.pxSign = a > 0 ? 1 : a < 0 ? -1 : 0;
      }(n, a, o, i, m), function (e, t, n, i, o, a, s, u, c, h) {
        var d = c.valueDim,
            f = c.categoryDim,
            p = Math.abs(n[f.wh]),
            g = e.getItemVisual(t, "symbolSize");
        r.isArray(g) ? g = g.slice() : (null == g && (g = "100%"), g = [g, g]);
        g[f.index] = l(g[f.index], p), g[d.index] = l(g[d.index], i ? p : Math.abs(a)), h.symbolSize = g, (h.symbolScale = [g[0] / u, g[1] / u])[d.index] *= (c.isHorizontal ? -1 : 1) * s;
      }(e, t, o, a, 0, m.boundingLength, m.pxSign, p, i, m), function (e, t, n, i, r) {
        var o = e.get(h) || 0;
        o && (f.attr({
          scale: t.slice(),
          rotation: n
        }), f.updateTransform(), o /= f.getLineScale(), o *= t[i.valueDim.index]);
        r.valueLineWidth = o;
      }(n, m.symbolScale, d, i, m);
      var y = m.symbolSize,
          x = n.get("symbolOffset");
      return r.isArray(x) && (x = [l(x[0], y[0]), l(x[1], y[1])]), function (e, t, n, i, o, a, s, c, h, d, f, p) {
        var g = f.categoryDim,
            v = f.valueDim,
            m = p.pxSign,
            y = Math.max(t[v.index] + c, 0),
            x = y;

        if (i) {
          var _ = Math.abs(h),
              b = r.retrieve(e.get("symbolMargin"), "15%") + "",
              w = !1;

          b.lastIndexOf("!") === b.length - 1 && (w = !0, b = b.slice(0, b.length - 1)), b = l(b, t[v.index]);
          var S = Math.max(y + 2 * b, 0),
              T = w ? 0 : 2 * b,
              C = u(i),
              k = C ? i : P((_ + T) / S);
          S = y + 2 * (b = (_ - k * y) / 2 / (w ? k : k - 1)), T = w ? 0 : 2 * b, C || "fixed" === i || (k = d ? P((Math.abs(d) + T) / S) : 0), x = k * S - T, p.repeatTimes = k, p.symbolMargin = b;
        }

        var M = m * (x / 2),
            E = p.pathPosition = [];
        E[g.index] = n[g.wh] / 2, E[v.index] = "start" === s ? M : "end" === s ? h - M : h / 2, a && (E[0] += a[0], E[1] += a[1]);
        var A = p.bundlePosition = [];
        A[g.index] = n[g.xy], A[v.index] = n[v.xy];
        var I = p.barRectShape = r.extend({}, n);
        I[v.wh] = m * Math.max(Math.abs(n[v.wh]), Math.abs(E[v.index] + M)), I[g.wh] = n[g.wh];
        var O = p.clipShape = {};
        O[g.xy] = -n[g.xy], O[g.wh] = f.ecSize[g.wh], O[v.xy] = 0, O[v.wh] = n[v.wh];
      }(n, y, o, a, 0, x, c, m.valueLineWidth, m.boundingLength, m.repeatCutLength, i, m), m;
    }

    function g(e, t) {
      return e.toGlobalCoord(e.dataToCoord(e.scale.parse(t)));
    }

    function v(e) {
      var t = e.symbolPatternSize,
          n = a(e.symbolType, -t / 2, -t / 2, t, t, e.color);
      return n.attr({
        culling: !0
      }), "image" !== n.type && n.setStyle({
        strokeNoScale: !0
      }), n;
    }

    function m(e, t, n, i) {
      var r = e.__pictorialBundle,
          o = n.symbolSize,
          a = n.valueLineWidth,
          s = n.pathPosition,
          l = t.valueDim,
          u = n.repeatTimes || 0,
          c = 0,
          h = o[t.valueDim.index] + a + 2 * n.symbolMargin;

      for (E(e, function (e) {
        e.__pictorialAnimationIndex = c, e.__pictorialRepeatTimes = u, c < u ? A(e, null, p(c), n, i) : A(e, null, {
          scale: [0, 0]
        }, n, i, function () {
          r.remove(e);
        }), T(e, n), c++;
      }); c < u; c++) {
        var d = v(n);
        d.__pictorialAnimationIndex = c, d.__pictorialRepeatTimes = u, r.add(d);
        var f = p(c);
        A(d, {
          position: f.position,
          scale: [0, 0]
        }, {
          scale: f.scale,
          rotation: f.rotation
        }, n, i), d.on("mouseover", g).on("mouseout", m), T(d, n);
      }

      function p(e) {
        var t = s.slice(),
            i = n.pxSign,
            r = e;
        return ("start" === n.symbolRepeatDirection ? i > 0 : i < 0) && (r = u - 1 - e), t[l.index] = h * (r - u / 2 + .5) + s[l.index], {
          position: t,
          scale: n.symbolScale.slice(),
          rotation: n.rotation
        };
      }

      function g() {
        E(e, function (e) {
          e.trigger("emphasis");
        });
      }

      function m() {
        E(e, function (e) {
          e.trigger("normal");
        });
      }
    }

    function y(e, t, n, i) {
      var r = e.__pictorialBundle,
          o = e.__pictorialMainPath;
      o ? A(o, null, {
        position: n.pathPosition.slice(),
        scale: n.symbolScale.slice(),
        rotation: n.rotation
      }, n, i) : (o = e.__pictorialMainPath = v(n), r.add(o), A(o, {
        position: n.pathPosition.slice(),
        scale: [0, 0],
        rotation: n.rotation
      }, {
        scale: n.symbolScale.slice()
      }, n, i), o.on("mouseover", function () {
        this.trigger("emphasis");
      }).on("mouseout", function () {
        this.trigger("normal");
      })), T(o, n);
    }

    function x(e, t, n) {
      var i = r.extend({}, t.barRectShape),
          a = e.__pictorialBarRect;
      a ? A(a, null, {
        shape: i
      }, t, n) : (a = e.__pictorialBarRect = new o.Rect({
        z2: 2,
        shape: i,
        silent: !0,
        style: {
          stroke: "transparent",
          fill: "transparent",
          lineWidth: 0
        }
      }), e.add(a));
    }

    function _(e, t, n, i) {
      if (n.symbolClip) {
        var a = e.__pictorialClipPath,
            s = r.extend({}, n.clipShape),
            l = t.valueDim,
            u = n.animationModel,
            c = n.dataIndex;
        if (a) o.updateProps(a, {
          shape: s
        }, u, c);else {
          s[l.wh] = 0, a = new o.Rect({
            shape: s
          }), e.__pictorialBundle.setClipPath(a), e.__pictorialClipPath = a;
          var h = {};
          h[l.wh] = n.clipShape[l.wh], o[i ? "updateProps" : "initProps"](a, {
            shape: h
          }, u, c);
        }
      }
    }

    function b(e, t) {
      var n = e.getItemModel(t);
      return n.getAnimationDelayParams = w, n.isAnimationEnabled = S, n;
    }

    function w(e) {
      return {
        index: e.__pictorialAnimationIndex,
        count: e.__pictorialRepeatTimes
      };
    }

    function S() {
      return this.parentModel.isAnimationEnabled() && !!this.getShallow("animation");
    }

    function T(e, t) {
      e.off("emphasis").off("normal");
      var n = t.symbolScale.slice();
      t.hoverAnimation && e.on("emphasis", function () {
        this.animateTo({
          scale: [1.1 * n[0], 1.1 * n[1]]
        }, 400, "elasticOut");
      }).on("normal", function () {
        this.animateTo({
          scale: n.slice()
        }, 400, "elasticOut");
      });
    }

    function C(e, t, n, i) {
      var r = new o.Group(),
          a = new o.Group();
      return r.add(a), r.__pictorialBundle = a, a.attr("position", n.bundlePosition.slice()), n.symbolRepeat ? m(r, t, n) : y(r, 0, n), x(r, n, i), _(r, t, n, i), r.__pictorialShapeStr = M(e, n), r.__pictorialSymbolMeta = n, r;
    }

    function k(e, t, n, i) {
      var a = i.__pictorialBarRect;
      a && (a.style.text = null);
      var s = [];
      E(i, function (e) {
        s.push(e);
      }), i.__pictorialMainPath && s.push(i.__pictorialMainPath), i.__pictorialClipPath && (n = null), r.each(s, function (e) {
        o.updateProps(e, {
          scale: [0, 0]
        }, n, t, function () {
          i.parent && i.parent.remove(i);
        });
      }), e.setItemGraphicEl(t, null);
    }

    function M(e, t) {
      return [e.getItemVisual(t.dataIndex, "symbol") || "none", !!t.symbolRepeat, !!t.symbolClip].join(":");
    }

    function E(e, t, n) {
      r.each(e.__pictorialBundle.children(), function (i) {
        i !== e.__pictorialBarRect && t.call(n, i);
      });
    }

    function A(e, t, n, i, r, a) {
      t && e.attr(t), i.symbolClip && !r ? n && e.attr(n) : n && o[r ? "updateProps" : "initProps"](e, n, i.animationModel, i.dataIndex, a);
    }

    function I(e, t, n) {
      var i = n.color,
          a = n.dataIndex,
          s = n.itemModel,
          l = s.getModel("itemStyle").getItemStyle(["color"]),
          u = s.getModel("emphasis.itemStyle").getItemStyle(),
          h = s.getShallow("cursor");
      E(e, function (e) {
        e.setColor(i), e.setStyle(r.defaults({
          fill: i,
          opacity: n.opacity
        }, l)), o.setHoverStyle(e, u), h && (e.cursor = h), e.z2 = n.z2;
      });
      var d = {},
          f = t.valueDim.posDesc[+(n.boundingLength > 0)],
          p = e.__pictorialBarRect;
      c(p.style, d, s, i, t.seriesModel, a, f), o.setHoverStyle(p, d);
    }

    function P(e) {
      var t = Math.round(e);
      return Math.abs(e - t) < 1e-4 ? t : Math.ceil(e);
    }

    var O = i.extendChartView({
      type: "pictorialBar",
      render: function render(e, t, n) {
        var i = this.group,
            r = e.getData(),
            a = this._data,
            s = e.coordinateSystem,
            l = !!s.getBaseAxis().isHorizontal(),
            u = s.grid.getRect(),
            c = {
          ecSize: {
            width: n.getWidth(),
            height: n.getHeight()
          },
          seriesModel: e,
          coordSys: s,
          coordSysExtent: [[u.x, u.x + u.width], [u.y, u.y + u.height]],
          isHorizontal: l,
          valueDim: d[+l],
          categoryDim: d[1 - l]
        };
        return r.diff(a).add(function (e) {
          if (r.hasValue(e)) {
            var t = b(r, e),
                n = p(r, e, t, c),
                o = C(r, c, n);
            r.setItemGraphicEl(e, o), i.add(o), I(o, c, n);
          }
        }).update(function (e, t) {
          var n = a.getItemGraphicEl(t);

          if (r.hasValue(e)) {
            var s = b(r, e),
                l = p(r, e, s, c),
                u = M(r, l);
            n && u !== n.__pictorialShapeStr && (i.remove(n), r.setItemGraphicEl(e, null), n = null), n ? function (e, t, n) {
              var i = n.animationModel,
                  r = n.dataIndex,
                  a = e.__pictorialBundle;
              o.updateProps(a, {
                position: n.bundlePosition.slice()
              }, i, r), n.symbolRepeat ? m(e, t, n, !0) : y(e, t, n, !0);
              x(e, n, !0), _(e, t, n, !0);
            }(n, c, l) : n = C(r, c, l, !0), r.setItemGraphicEl(e, n), n.__pictorialSymbolMeta = l, i.add(n), I(n, c, l);
          } else i.remove(n);
        }).remove(function (e) {
          var t = a.getItemGraphicEl(e);
          t && k(a, e, t.__pictorialSymbolMeta.animationModel, t);
        }).execute(), this._data = r, this.group;
      },
      dispose: r.noop,
      remove: function remove(e, t) {
        var n = this.group,
            i = this._data;
        e.get("animation") ? i && i.eachItemGraphicEl(function (t) {
          k(i, t.dataIndex, e, t);
        }) : n.removeAll();
      }
    });
    e.exports = O;
  }, function (e, t, n) {
    var i = n(4);
    n(344), n(833), n(834);
    var r = n(835),
        o = n(836),
        a = n(130);
    i.registerLayout(r), i.registerVisual(o), i.registerProcessor(a("themeRiver"));
  }, function (e, t, n) {
    var i = n(825);
    n(42).register("single", {
      create: function create(e, t) {
        var n = [];
        return e.eachComponent("singleAxis", function (r, o) {
          var a = new i(r, e, t);
          a.name = "single_" + o, a.resize(r, t), r.coordinateSystem = a, n.push(a);
        }), e.eachSeries(function (t) {
          if ("singleAxis" === t.get("coordinateSystem")) {
            var n = e.queryComponents({
              mainType: "singleAxis",
              index: t.get("singleAxisIndex"),
              id: t.get("singleAxisId")
            })[0];
            t.coordinateSystem = n && n.coordinateSystem;
          }
        }), n;
      },
      dimensions: i.prototype.dimensions
    });
  }, function (e, t, n) {
    var i = n(826),
        r = n(43),
        o = n(14).getLayoutRect,
        a = n(1).each;

    function s(e, t, n) {
      this.dimension = "single", this.dimensions = ["single"], this._axis = null, this._rect, this._init(e, t, n), this.model = e;
    }

    s.prototype = {
      type: "singleAxis",
      axisPointerEnabled: !0,
      constructor: s,
      _init: function _init(e, t, n) {
        var o = this.dimension,
            a = new i(o, r.createScaleByModel(e), [0, 0], e.get("type"), e.get("position")),
            s = "category" === a.type;
        a.onBand = s && e.get("boundaryGap"), a.inverse = e.get("inverse"), a.orient = e.get("orient"), e.axis = a, a.model = e, a.coordinateSystem = this, this._axis = a;
      },
      update: function update(e, t) {
        e.eachSeries(function (e) {
          if (e.coordinateSystem === this) {
            var t = e.getData();
            a(t.mapDimension(this.dimension, !0), function (e) {
              this._axis.scale.unionExtentFromData(t, e);
            }, this), r.niceScaleExtent(this._axis.scale, this._axis.model);
          }
        }, this);
      },
      resize: function resize(e, t) {
        this._rect = o({
          left: e.get("left"),
          top: e.get("top"),
          right: e.get("right"),
          bottom: e.get("bottom"),
          width: e.get("width"),
          height: e.get("height")
        }, {
          width: t.getWidth(),
          height: t.getHeight()
        }), this._adjustAxis();
      },
      getRect: function getRect() {
        return this._rect;
      },
      _adjustAxis: function _adjustAxis() {
        var e = this._rect,
            t = this._axis,
            n = t.isHorizontal(),
            i = n ? [0, e.width] : [0, e.height],
            r = t.reverse ? 1 : 0;
        t.setExtent(i[r], i[1 - r]), this._updateAxisTransform(t, n ? e.x : e.y);
      },
      _updateAxisTransform: function _updateAxisTransform(e, t) {
        var n = e.getExtent(),
            i = n[0] + n[1],
            r = e.isHorizontal();
        e.toGlobalCoord = r ? function (e) {
          return e + t;
        } : function (e) {
          return i - e + t;
        }, e.toLocalCoord = r ? function (e) {
          return e - t;
        } : function (e) {
          return i - e + t;
        };
      },
      getAxis: function getAxis() {
        return this._axis;
      },
      getBaseAxis: function getBaseAxis() {
        return this._axis;
      },
      getAxes: function getAxes() {
        return [this._axis];
      },
      getTooltipAxes: function getTooltipAxes() {
        return {
          baseAxes: [this.getAxis()]
        };
      },
      containPoint: function containPoint(e) {
        var t = this.getRect(),
            n = this.getAxis();
        return "horizontal" === n.orient ? n.contain(n.toLocalCoord(e[0])) && e[1] >= t.y && e[1] <= t.y + t.height : n.contain(n.toLocalCoord(e[1])) && e[0] >= t.y && e[0] <= t.y + t.height;
      },
      pointToData: function pointToData(e) {
        var t = this.getAxis();
        return [t.coordToData(t.toLocalCoord(e["horizontal" === t.orient ? 0 : 1]))];
      },
      dataToPoint: function dataToPoint(e) {
        var t = this.getAxis(),
            n = this.getRect(),
            i = [],
            r = "horizontal" === t.orient ? 0 : 1;
        return e instanceof Array && (e = e[0]), i[r] = t.toGlobalCoord(t.dataToCoord(+e)), i[1 - r] = 0 === r ? n.y + n.height / 2 : n.x + n.width / 2, i;
      }
    };
    var l = s;
    e.exports = l;
  }, function (e, t, n) {
    var i = n(1),
        r = n(69),
        o = function o(e, t, n, i, _o6) {
      r.call(this, e, t, n), this.type = i || "value", this.position = _o6 || "bottom", this.orient = null;
    };

    o.prototype = {
      constructor: o,
      model: null,
      isHorizontal: function isHorizontal() {
        var e = this.position;
        return "top" === e || "bottom" === e;
      },
      pointToData: function pointToData(e, t) {
        return this.coordinateSystem.pointToData(e, t)[0];
      },
      toGlobalCoord: null,
      toLocalCoord: null
    }, i.inherits(o, r);
    var a = o;
    e.exports = a;
  }, function (e, t, n) {
    var i = n(1),
        r = n(70),
        o = n(5),
        a = n(345),
        s = n(89),
        l = n(324),
        u = l.rectCoordAxisBuildSplitArea,
        c = l.rectCoordAxisHandleRemove,
        h = ["axisLine", "axisTickLabel", "axisName"],
        d = ["splitArea", "splitLine"],
        f = s.extend({
      type: "singleAxis",
      axisPointerClass: "SingleAxisPointer",
      render: function render(e, t, n, s) {
        var l = this.group;
        l.removeAll();
        var u = this._axisGroup;
        this._axisGroup = new o.Group();
        var c = a.layout(e),
            p = new r(e, c);
        i.each(h, p.add, p), l.add(this._axisGroup), l.add(p.getGroup()), i.each(d, function (t) {
          e.get(t + ".show") && this["_" + t](e);
        }, this), o.groupTransition(u, this._axisGroup, e), f.superCall(this, "render", e, t, n, s);
      },
      remove: function remove() {
        c(this);
      },
      _splitLine: function _splitLine(e) {
        var t = e.axis;

        if (!t.scale.isBlank()) {
          var n = e.getModel("splitLine"),
              i = n.getModel("lineStyle"),
              r = i.get("width"),
              a = i.get("color");
          a = a instanceof Array ? a : [a];

          for (var s = e.coordinateSystem.getRect(), l = t.isHorizontal(), u = [], c = 0, h = t.getTicksCoords({
            tickModel: n
          }), d = [], f = [], p = 0; p < h.length; ++p) {
            var g = t.toGlobalCoord(h[p].coord);
            l ? (d[0] = g, d[1] = s.y, f[0] = g, f[1] = s.y + s.height) : (d[0] = s.x, d[1] = g, f[0] = s.x + s.width, f[1] = g);
            var v = c++ % a.length;
            u[v] = u[v] || [], u[v].push(new o.Line({
              subPixelOptimize: !0,
              shape: {
                x1: d[0],
                y1: d[1],
                x2: f[0],
                y2: f[1]
              },
              style: {
                lineWidth: r
              },
              silent: !0
            }));
          }

          for (p = 0; p < u.length; ++p) {
            this.group.add(o.mergePath(u[p], {
              style: {
                stroke: a[p % a.length],
                lineDash: i.getLineDash(r),
                lineWidth: r
              },
              silent: !0
            }));
          }
        }
      },
      _splitArea: function _splitArea(e) {
        u(this, this._axisGroup, e, e);
      }
    }),
        p = f;
    e.exports = p;
  }, function (e, t, n) {
    var i = n(1),
        r = n(26),
        o = n(163),
        a = n(105),
        s = r.extend({
      type: "singleAxis",
      layoutMode: "box",
      axis: null,
      coordinateSystem: null,
      getCoordSysModel: function getCoordSysModel() {
        return this;
      }
    });
    i.merge(s.prototype, a), o("single", s, function (e, t) {
      return t.type || (t.data ? "category" : "value");
    }, {
      left: "5%",
      top: "5%",
      right: "5%",
      bottom: "5%",
      type: "value",
      position: "bottom",
      orient: "horizontal",
      axisLine: {
        show: !0,
        lineStyle: {
          width: 1,
          type: "solid"
        }
      },
      tooltip: {
        show: !0
      },
      axisTick: {
        show: !0,
        length: 6,
        lineStyle: {
          width: 1
        }
      },
      axisLabel: {
        show: !0,
        interval: "auto"
      },
      splitLine: {
        show: !0,
        lineStyle: {
          type: "dashed",
          opacity: .2
        }
      }
    });
    var l = s;
    e.exports = l;
  }, function (e, t, n) {
    var i = n(1),
        r = n(8).makeInner,
        o = n(164),
        a = n(346),
        s = i.each,
        l = i.curry,
        u = r();

    function c(e, t, n, r, o) {
      var a = e.axis;
      if (!a.scale.isBlank() && a.containData(t)) if (e.involveSeries) {
        var l = function (e, t) {
          var n = t.axis,
              i = n.dim,
              r = e,
              o = [],
              a = Number.MAX_VALUE,
              l = -1;
          return s(t.seriesModels, function (t, u) {
            var c,
                h,
                d = t.getData().mapDimension(i, !0);

            if (t.getAxisTooltipData) {
              var f = t.getAxisTooltipData(d, e, n);
              h = f.dataIndices, c = f.nestestValue;
            } else {
              if (!(h = t.getData().indicesOfNearest(d[0], e, "category" === n.type ? .5 : null)).length) return;
              c = t.getData().get(d[0], h[0]);
            }

            if (null != c && isFinite(c)) {
              var p = e - c,
                  g = Math.abs(p);
              g <= a && ((g < a || p >= 0 && l < 0) && (a = g, l = p, r = c, o.length = 0), s(h, function (e) {
                o.push({
                  seriesIndex: t.seriesIndex,
                  dataIndexInside: e,
                  dataIndex: t.getData().getRawIndex(e)
                });
              }));
            }
          }), {
            payloadBatch: o,
            snapToValue: r
          };
        }(t, e),
            u = l.payloadBatch,
            c = l.snapToValue;

        u[0] && null == o.seriesIndex && i.extend(o, u[0]), !r && e.snap && a.containData(c) && null != c && (t = c), n.showPointer(e, t, u, o), n.showTooltip(e, l, c);
      } else n.showPointer(e, t);
    }

    function h(e, t, n, i) {
      e[t.key] = {
        value: n,
        payloadBatch: i
      };
    }

    function d(e, t, n, i) {
      var r = n.payloadBatch,
          a = t.axis,
          s = a.model,
          l = t.axisPointerModel;

      if (t.triggerTooltip && r.length) {
        var u = t.coordSys.model,
            c = o.makeKey(u),
            h = e.map[c];
        h || (h = e.map[c] = {
          coordSysId: u.id,
          coordSysIndex: u.componentIndex,
          coordSysType: u.type,
          coordSysMainType: u.mainType,
          dataByAxis: []
        }, e.list.push(h)), h.dataByAxis.push({
          axisDim: a.dim,
          axisIndex: s.componentIndex,
          axisType: s.type,
          axisId: s.id,
          value: i,
          valueLabelOpt: {
            precision: l.get("label.precision"),
            formatter: l.get("label.formatter")
          },
          seriesDataIndices: r.slice()
        });
      }
    }

    function f(e) {
      var t = e.axis.model,
          n = {},
          i = n.axisDim = e.axis.dim;
      return n.axisIndex = n[i + "AxisIndex"] = t.componentIndex, n.axisName = n[i + "AxisName"] = t.name, n.axisId = n[i + "AxisId"] = t.id, n;
    }

    function p(e) {
      return !e || null == e[0] || isNaN(e[0]) || null == e[1] || isNaN(e[1]);
    }

    e.exports = function (e, t, n) {
      var r = e.currTrigger,
          o = [e.x, e.y],
          g = e,
          v = e.dispatchAction || i.bind(n.dispatchAction, n),
          m = t.getComponent("axisPointer").coordSysAxesInfo;

      if (m) {
        p(o) && (o = a({
          seriesIndex: g.seriesIndex,
          dataIndex: g.dataIndex
        }, t).point);
        var y = p(o),
            x = g.axesInfo,
            _ = m.axesInfo,
            b = "leave" === r || p(o),
            w = {},
            S = {},
            T = {
          list: [],
          map: {}
        },
            C = {
          showPointer: l(h, S),
          showTooltip: l(d, T)
        };
        s(m.coordSysMap, function (e, t) {
          var n = y || e.containPoint(o);
          s(m.coordSysAxesInfo[t], function (e, t) {
            var i = e.axis,
                r = function (e, t) {
              for (var n = 0; n < (e || []).length; n++) {
                var i = e[n];
                if (t.axis.dim === i.axisDim && t.axis.model.componentIndex === i.axisIndex) return i;
              }
            }(x, e);

            if (!b && n && (!x || r)) {
              var a = r && r.value;
              null != a || y || (a = i.pointToData(o)), null != a && c(e, a, C, !1, w);
            }
          });
        });
        var k = {};
        return s(_, function (e, t) {
          var n = e.linkGroup;
          n && !S[t] && s(n.axesInfo, function (t, i) {
            var r = S[i];

            if (t !== e && r) {
              var o = r.value;
              n.mapper && (o = e.axis.scale.parse(n.mapper(o, f(t), f(e)))), k[e.key] = o;
            }
          });
        }), s(k, function (e, t) {
          c(_[t], e, C, !0, w);
        }), function (e, t, n) {
          var i = n.axesInfo = [];
          s(t, function (t, n) {
            var r = t.axisPointerModel.option,
                o = e[n];
            o ? (!t.useHandle && (r.status = "show"), r.value = o.value, r.seriesDataIndices = (o.payloadBatch || []).slice()) : !t.useHandle && (r.status = "hide"), "show" === r.status && i.push({
              axisDim: t.axis.dim,
              axisIndex: t.axis.model.componentIndex,
              value: r.value
            });
          });
        }(S, _, w), function (e, t, n, i) {
          if (p(t) || !e.list.length) return void i({
            type: "hideTip"
          });
          var r = ((e.list[0].dataByAxis[0] || {}).seriesDataIndices || [])[0] || {};
          i({
            type: "showTip",
            escapeConnect: !0,
            x: t[0],
            y: t[1],
            tooltipOption: n.tooltipOption,
            position: n.position,
            dataIndexInside: r.dataIndexInside,
            dataIndex: r.dataIndex,
            seriesIndex: r.seriesIndex,
            dataByCoordSys: e.list
          });
        }(T, o, e, v), function (e, t, n) {
          var r = n.getZr(),
              o = u(r).axisPointerLastHighlights || {},
              a = u(r).axisPointerLastHighlights = {};
          s(e, function (e, t) {
            var n = e.axisPointerModel.option;
            "show" === n.status && s(n.seriesDataIndices, function (e) {
              var t = e.seriesIndex + " | " + e.dataIndex;
              a[t] = e;
            });
          });
          var l = [],
              c = [];
          i.each(o, function (e, t) {
            !a[t] && c.push(e);
          }), i.each(a, function (e, t) {
            !o[t] && l.push(e);
          }), c.length && n.dispatchAction({
            type: "downplay",
            escapeConnect: !0,
            batch: c
          }), l.length && n.dispatchAction({
            type: "highlight",
            escapeConnect: !0,
            batch: l
          });
        }(_, 0, n), w;
      }
    };
  }, function (e, t, n) {
    var i = n(4).extendComponentModel({
      type: "axisPointer",
      coordSysAxesInfo: null,
      defaultOption: {
        show: "auto",
        triggerOn: null,
        zlevel: 0,
        z: 50,
        type: "line",
        snap: !1,
        triggerTooltip: !0,
        value: null,
        status: null,
        link: [],
        animation: null,
        animationDurationUpdate: 200,
        lineStyle: {
          color: "#aaa",
          width: 1,
          type: "solid"
        },
        shadowStyle: {
          color: "rgba(150,150,150,0.3)"
        },
        label: {
          show: !0,
          formatter: null,
          precision: "auto",
          margin: 3,
          color: "#fff",
          padding: [5, 7, 5, 7],
          backgroundColor: "auto",
          borderColor: null,
          borderWidth: 0,
          shadowBlur: 3,
          shadowColor: "#aaa"
        },
        handle: {
          show: !1,
          icon: "M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7v-1.2h6.6z M13.3,22H6.7v-1.2h6.6z M13.3,19.6H6.7v-1.2h6.6z",
          size: 45,
          margin: 50,
          color: "#333",
          shadowBlur: 3,
          shadowColor: "#aaa",
          shadowOffsetX: 0,
          shadowOffsetY: 2,
          throttle: 40
        }
      }
    });
    e.exports = i;
  }, function (e, t, n) {
    var i = n(4),
        r = n(347),
        o = i.extendComponentView({
      type: "axisPointer",
      render: function render(e, t, n) {
        var i = t.getComponent("tooltip"),
            o = e.get("triggerOn") || i && i.get("triggerOn") || "mousemove|click";
        r.register("axisPointer", n, function (e, t, n) {
          "none" !== o && ("leave" === e || o.indexOf(e) >= 0) && n({
            type: "updateAxisPointer",
            currTrigger: e,
            x: t && t.offsetX,
            y: t && t.offsetY
          });
        });
      },
      remove: function remove(e, t) {
        r.unregister(t.getZr(), "axisPointer"), o.superApply(this._model, "remove", arguments);
      },
      dispose: function dispose(e, t) {
        r.unregister("axisPointer", t), o.superApply(this._model, "dispose", arguments);
      }
    }),
        a = o;
    e.exports = a;
  }, function (e, t, n) {
    var i = n(225),
        r = n(168),
        o = n(345),
        a = n(89),
        s = ["x", "y"],
        l = ["width", "height"],
        u = i.extend({
      makeElOption: function makeElOption(e, t, n, i, a) {
        var s = n.axis,
            l = s.coordinateSystem,
            u = d(l, 1 - h(s)),
            f = l.dataToPoint(t)[0],
            p = i.get("type");

        if (p && "none" !== p) {
          var g = r.buildElStyle(i),
              v = c[p](s, f, u);
          v.style = g, e.graphicKey = v.type, e.pointer = v;
        }

        var m = o.layout(n);
        r.buildCartesianSingleLabelElOption(t, e, m, n, i, a);
      },
      getHandleTransform: function getHandleTransform(e, t, n) {
        var i = o.layout(t, {
          labelInside: !1
        });
        return i.labelMargin = n.get("handle.margin"), {
          position: r.getTransformedPosition(t.axis, e, i),
          rotation: i.rotation + (i.labelDirection < 0 ? Math.PI : 0)
        };
      },
      updateHandleTransform: function updateHandleTransform(e, t, n, i) {
        var r = n.axis,
            o = r.coordinateSystem,
            a = h(r),
            s = d(o, a),
            l = e.position;
        l[a] += t[a], l[a] = Math.min(s[1], l[a]), l[a] = Math.max(s[0], l[a]);
        var u = d(o, 1 - a),
            c = (u[1] + u[0]) / 2,
            f = [c, c];
        return f[a] = l[a], {
          position: l,
          rotation: e.rotation,
          cursorPoint: f,
          tooltipOption: {
            verticalAlign: "middle"
          }
        };
      }
    }),
        c = {
      line: function line(e, t, n) {
        return {
          type: "Line",
          subPixelOptimize: !0,
          shape: r.makeLineShape([t, n[0]], [t, n[1]], h(e))
        };
      },
      shadow: function shadow(e, t, n) {
        var i = e.getBandWidth(),
            o = n[1] - n[0];
        return {
          type: "Rect",
          shape: r.makeRectShape([t - i / 2, n[0]], [i, o], h(e))
        };
      }
    };

    function h(e) {
      return e.isHorizontal() ? 0 : 1;
    }

    function d(e, t) {
      var n = e.getRect();
      return [n[s[t]], n[s[t]] + n[l[t]]];
    }

    a.registerAxisPointerClass("SingleAxisPointer", u);
    var f = u;
    e.exports = f;
  }, function (e, t, n) {
    var i = n(27),
        r = n(104),
        o = n(124).getDimensionTypeByAxis,
        a = n(39),
        s = n(1),
        l = n(8).groupData,
        u = n(15).encodeHTML,
        c = n(129),
        h = i.extend({
      type: "series.themeRiver",
      dependencies: ["singleAxis"],
      nameMap: null,
      init: function init(e) {
        h.superApply(this, "init", arguments), this.legendVisualProvider = new c(s.bind(this.getData, this), s.bind(this.getRawData, this));
      },
      fixData: function fixData(e) {
        var t = e.length,
            n = l(e, function (e) {
          return e[2];
        }),
            i = [];
        n.buckets.each(function (e, t) {
          i.push({
            name: t,
            dataList: e
          });
        });

        for (var r = i.length, o = -1, a = -1, s = 0; s < r; ++s) {
          var u = i[s].dataList.length;
          u > o && (o = u, a = s);
        }

        for (var c = 0; c < r; ++c) {
          if (c !== a) for (var h = i[c].name, d = 0; d < o; ++d) {
            for (var f = i[a].dataList[d][0], p = i[c].dataList.length, g = -1, v = 0; v < p; ++v) {
              if (i[c].dataList[v][0] === f) {
                g = v;
                break;
              }
            }

            -1 === g && (e[t] = [], e[t][0] = f, e[t][1] = 0, e[t][2] = h, t++);
          }
        }

        return e;
      },
      getInitialData: function getInitialData(e, t) {
        for (var n = t.queryComponents({
          mainType: "singleAxis",
          index: this.get("singleAxisIndex"),
          id: this.get("singleAxisId")
        })[0].get("type"), i = s.filter(e.data, function (e) {
          return void 0 !== e[2];
        }), l = this.fixData(i || []), u = [], c = this.nameMap = s.createHashMap(), h = 0, d = 0; d < l.length; ++d) {
          u.push(l[d][2]), c.get(l[d][2]) || (c.set(l[d][2], h), h++);
        }

        var f = r(l, {
          coordDimensions: ["single"],
          dimensionsDefine: [{
            name: "time",
            type: o(n)
          }, {
            name: "value",
            type: "float"
          }, {
            name: "name",
            type: "ordinal"
          }],
          encodeDefine: {
            single: 0,
            value: 1,
            itemName: 2
          }
        }),
            p = new a(f, this);
        return p.initData(l), p;
      },
      getLayerSeries: function getLayerSeries() {
        for (var e = this.getData(), t = e.count(), n = [], i = 0; i < t; ++i) {
          n[i] = i;
        }

        var r = e.mapDimension("single"),
            o = l(n, function (t) {
          return e.get("name", t);
        }),
            a = [];
        return o.buckets.each(function (t, n) {
          t.sort(function (t, n) {
            return e.get(r, t) - e.get(r, n);
          }), a.push({
            name: n,
            indices: t
          });
        }), a;
      },
      getAxisTooltipData: function getAxisTooltipData(e, t, n) {
        s.isArray(e) || (e = e ? [e] : []);

        for (var i, r = this.getData(), o = this.getLayerSeries(), a = [], l = o.length, u = 0; u < l; ++u) {
          for (var c = Number.MAX_VALUE, h = -1, d = o[u].indices.length, f = 0; f < d; ++f) {
            var p = r.get(e[0], o[u].indices[f]),
                g = Math.abs(p - t);
            g <= c && (i = p, c = g, h = o[u].indices[f]);
          }

          a.push(h);
        }

        return {
          dataIndices: a,
          nestestValue: i
        };
      },
      formatTooltip: function formatTooltip(e) {
        var t = this.getData(),
            n = t.getName(e),
            i = t.get(t.mapDimension("value"), e);
        return (isNaN(i) || null == i) && (i = "-"), u(n + " : " + i);
      },
      defaultOption: {
        zlevel: 0,
        z: 2,
        coordinateSystem: "singleAxis",
        boundaryGap: ["10%", "10%"],
        singleAxisIndex: 0,
        animationEasing: "linear",
        label: {
          margin: 4,
          show: !0,
          position: "left",
          color: "#000",
          fontSize: 11
        },
        emphasis: {
          label: {
            show: !0
          }
        }
      }
    }),
        d = h;
    e.exports = d;
  }, function (e, t, n) {
    var i = n(4),
        r = n(320).Polygon,
        o = n(5),
        a = n(1),
        s = a.bind,
        l = a.extend,
        u = n(87),
        c = i.extendChartView({
      type: "themeRiver",
      init: function init() {
        this._layers = [];
      },
      render: function render(e, t, n) {
        var i = e.getData(),
            a = this.group,
            c = e.getLayerSeries(),
            h = i.getLayout("layoutInfo"),
            d = h.rect,
            f = h.boundaryGap;

        function p(e) {
          return e.name;
        }

        a.attr("position", [0, d.y + f[0]]);
        var g = new u(this._layersSeries || [], c, p, p),
            v = {};

        function m(t, n, s) {
          var u = this._layers;

          if ("remove" !== t) {
            for (var h, d, f, p = [], g = [], m = c[n].indices, y = 0; y < m.length; y++) {
              var x = i.getItemLayout(m[y]),
                  _ = x.x,
                  b = x.y0,
                  w = x.y;
              p.push([_, b]), g.push([_, b + w]), h = i.getItemVisual(m[y], "color");
            }

            var S = i.getItemLayout(m[0]),
                T = i.getItemModel(m[y - 1]),
                C = T.getModel("label"),
                k = C.get("margin");

            if ("add" === t) {
              var M = v[n] = new o.Group();
              d = new r({
                shape: {
                  points: p,
                  stackedOnPoints: g,
                  smooth: .4,
                  stackedOnSmooth: .4,
                  smoothConstraint: !1
                },
                z2: 0
              }), f = new o.Text({
                style: {
                  x: S.x - k,
                  y: S.y0 + S.y / 2
                }
              }), M.add(d), M.add(f), a.add(M), d.setClipPath(function (e, t, n) {
                var i = new o.Rect({
                  shape: {
                    x: e.x - 10,
                    y: e.y - 10,
                    width: 0,
                    height: e.height + 20
                  }
                });
                return o.initProps(i, {
                  shape: {
                    width: e.width + 20,
                    height: e.height + 20
                  }
                }, t, n), i;
              }(d.getBoundingRect(), e, function () {
                d.removeClipPath();
              }));
            } else {
              M = u[s];
              d = M.childAt(0), f = M.childAt(1), a.add(M), v[n] = M, o.updateProps(d, {
                shape: {
                  points: p,
                  stackedOnPoints: g
                }
              }, e), o.updateProps(f, {
                style: {
                  x: S.x - k,
                  y: S.y0 + S.y / 2
                }
              }, e);
            }

            var E = T.getModel("emphasis.itemStyle"),
                A = T.getModel("itemStyle");
            o.setTextStyle(f.style, C, {
              text: C.get("show") ? e.getFormattedLabel(m[y - 1], "normal") || i.getName(m[y - 1]) : null,
              textVerticalAlign: "middle"
            }), d.setStyle(l({
              fill: h
            }, A.getItemStyle(["color"]))), o.setHoverStyle(d, E.getItemStyle());
          } else a.remove(u[n]);
        }

        g.add(s(m, this, "add")).update(s(m, this, "update")).remove(s(m, this, "remove")).execute(), this._layersSeries = c, this._layers = v;
      },
      dispose: function dispose() {}
    });
    e.exports = c;
  }, function (e, t, n) {
    var i = n(1),
        r = n(6);

    function o(e, t, n) {
      if (e.count()) for (var r, o = t.coordinateSystem, a = t.getLayerSeries(), s = e.mapDimension("single"), l = e.mapDimension("value"), u = i.map(a, function (t) {
        return i.map(t.indices, function (t) {
          var n = o.dataToPoint(e.get(s, t));
          return n[1] = e.get(l, t), n;
        });
      }), c = function (e) {
        for (var t = e.length, n = e[0].length, i = [], r = [], o = 0, a = {}, s = 0; s < n; ++s) {
          for (var l = 0, u = 0; l < t; ++l) {
            u += e[l][s][1];
          }

          u > o && (o = u), i.push(u);
        }

        for (var c = 0; c < n; ++c) {
          r[c] = (o - i[c]) / 2;
        }

        o = 0;

        for (var h = 0; h < n; ++h) {
          var d = i[h] + r[h];
          d > o && (o = d);
        }

        return a.y0 = r, a.max = o, a;
      }(u), h = c.y0, d = n / c.max, f = a.length, p = a[0].indices.length, g = 0; g < p; ++g) {
        r = h[g] * d, e.setItemLayout(a[0].indices[g], {
          layerIndex: 0,
          x: u[0][g][0],
          y0: r,
          y: u[0][g][1] * d
        });

        for (var v = 1; v < f; ++v) {
          r += u[v - 1][g][1] * d, e.setItemLayout(a[v].indices[g], {
            layerIndex: v,
            x: u[v][g][0],
            y0: r,
            y: u[v][g][1] * d
          });
        }
      }
    }

    e.exports = function (e, t) {
      e.eachSeriesByType("themeRiver", function (e) {
        var t = e.getData(),
            n = e.coordinateSystem,
            i = {},
            a = n.getRect();
        i.rect = a;
        var s = e.get("boundaryGap"),
            l = n.getAxis();
        (i.boundaryGap = s, "horizontal" === l.orient) ? (s[0] = r.parsePercent(s[0], a.height), s[1] = r.parsePercent(s[1], a.height), o(t, e, a.height - s[0] - s[1])) : (s[0] = r.parsePercent(s[0], a.width), s[1] = r.parsePercent(s[1], a.width), o(t, e, a.width - s[0] - s[1]));
        t.setLayout("layoutInfo", i);
      });
    };
  }, function (e, t, n) {
    var i = n(1).createHashMap;

    e.exports = function (e) {
      e.eachSeriesByType("themeRiver", function (e) {
        var t = e.getData(),
            n = e.getRawData(),
            r = e.get("color"),
            o = i();
        t.each(function (e) {
          o.set(t.getRawIndex(e), e);
        }), n.each(function (i) {
          var a = n.getName(i),
              s = r[(e.nameMap.get(a) - 1) % r.length];
          n.setItemVisual(i, "color", s);
          var l = o.get(i);
          null != l && t.setItemVisual(l, "color", s);
        });
      });
    };
  }, function (e, t, n) {
    var i = n(4),
        r = n(1);
    n(838), n(839), n(841);
    var o = n(165),
        a = n(842),
        s = n(130);
    i.registerVisual(r.curry(o, "sunburst")), i.registerLayout(r.curry(a, "sunburst")), i.registerProcessor(r.curry(s, "sunburst"));
  }, function (e, t, n) {
    var i = n(1),
        r = n(27),
        o = n(220),
        a = n(90).wrapTreePathInfo,
        s = r.extend({
      type: "series.sunburst",
      _viewRoot: null,
      getInitialData: function getInitialData(e, t) {
        var n = {
          name: e.name,
          children: e.data
        };
        !function e(t) {
          var n = 0;
          i.each(t.children, function (t) {
            e(t);
            var r = t.value;
            i.isArray(r) && (r = r[0]), n += r;
          });
          var r = t.value;
          i.isArray(r) && (r = r[0]);
          (null == r || isNaN(r)) && (r = n);
          r < 0 && (r = 0);
          i.isArray(t.value) ? t.value[0] = r : t.value = r;
        }(n);
        var r = e.levels || [],
            a = {};
        return a.levels = r, o.createTree(n, this, a).data;
      },
      optionUpdated: function optionUpdated() {
        this.resetViewRoot();
      },
      getDataParams: function getDataParams(e) {
        var t = r.prototype.getDataParams.apply(this, arguments),
            n = this.getData().tree.getNodeByDataIndex(e);
        return t.treePathInfo = a(n, this), t;
      },
      defaultOption: {
        zlevel: 0,
        z: 2,
        center: ["50%", "50%"],
        radius: [0, "75%"],
        clockwise: !0,
        startAngle: 90,
        minAngle: 0,
        percentPrecision: 2,
        stillShowZeroSum: !0,
        highlightPolicy: "descendant",
        nodeClick: "rootToNode",
        renderLabelForZeroData: !1,
        label: {
          rotate: "radial",
          show: !0,
          opacity: 1,
          align: "center",
          position: "inside",
          distance: 5,
          silent: !0
        },
        itemStyle: {
          borderWidth: 1,
          borderColor: "white",
          borderType: "solid",
          shadowBlur: 0,
          shadowColor: "rgba(0, 0, 0, 0.2)",
          shadowOffsetX: 0,
          shadowOffsetY: 0,
          opacity: 1
        },
        highlight: {
          itemStyle: {
            opacity: 1
          }
        },
        downplay: {
          itemStyle: {
            opacity: .5
          },
          label: {
            opacity: .6
          }
        },
        animationType: "expansion",
        animationDuration: 1e3,
        animationDurationUpdate: 500,
        animationEasing: "cubicOut",
        data: [],
        levels: [],
        sort: "desc"
      },
      getViewRoot: function getViewRoot() {
        return this._viewRoot;
      },
      resetViewRoot: function resetViewRoot(e) {
        e ? this._viewRoot = e : e = this._viewRoot;
        var t = this.getRawData().tree.root;
        e && (e === t || t.contains(e)) || (this._viewRoot = t);
      }
    });
    e.exports = s;
  }, function (e, t, n) {
    var i = n(1),
        r = n(54),
        o = n(840),
        a = n(87),
        s = n(15).windowOpen,
        l = r.extend({
      type: "sunburst",
      init: function init() {},
      render: function render(e, t, n, r) {
        var s = this;
        this.seriesModel = e, this.api = n, this.ecModel = t;
        var l = e.getData(),
            u = l.tree.root,
            c = e.getViewRoot(),
            h = this.group,
            d = e.get("renderLabelForZeroData"),
            f = [];
        c.eachNode(function (e) {
          f.push(e);
        });
        var p = this._oldChildren || [];

        if (function (n, r) {
          if (0 === n.length && 0 === r.length) return;

          function s(e) {
            return e.getId();
          }

          function c(i, a) {
            !function (n, i) {
              d || !n || n.getValue() || (n = null);
              if (n !== u && i !== u) if (i && i.piece) n ? (i.piece.updateData(!1, n, "normal", e, t), l.setItemGraphicEl(n.dataIndex, i.piece)) : function (e) {
                if (!e) return;
                e.piece && (h.remove(e.piece), e.piece = null);
              }(i);else if (n) {
                var r = new o(n, e, t);
                h.add(r), l.setItemGraphicEl(n.dataIndex, r);
              }
            }(null == i ? null : n[i], null == a ? null : r[a]);
          }

          new a(r, n, s, s).add(c).update(c).remove(i.curry(c, null)).execute();
        }(f, p), function (n, i) {
          if (i.depth > 0) {
            s.virtualPiece ? s.virtualPiece.updateData(!1, n, "normal", e, t) : (s.virtualPiece = new o(n, e, t), h.add(s.virtualPiece)), i.piece._onclickEvent && i.piece.off("click", i.piece._onclickEvent);

            var r = function r(e) {
              s._rootToNode(i.parentNode);
            };

            i.piece._onclickEvent = r, s.virtualPiece.on("click", r);
          } else s.virtualPiece && (h.remove(s.virtualPiece), s.virtualPiece = null);
        }(u, c), r && r.highlight && r.highlight.piece) {
          var g = e.getShallow("highlightPolicy");
          r.highlight.piece.onEmphasis(g);
        } else if (r && r.unhighlight) {
          var v = this.virtualPiece;
          !v && u.children.length && (v = u.children[0].piece), v && v.onNormal();
        }

        this._initEvents(), this._oldChildren = f;
      },
      dispose: function dispose() {},
      _initEvents: function _initEvents() {
        var e = this,
            t = function t(_t6) {
          var n = !1;
          e.seriesModel.getViewRoot().eachNode(function (i) {
            if (!n && i.piece && i.piece.childAt(0) === _t6.target) {
              var r = i.getModel().get("nodeClick");
              if ("rootToNode" === r) e._rootToNode(i);else if ("link" === r) {
                var o = i.getModel(),
                    a = o.get("link");

                if (a) {
                  var l = o.get("target", !0) || "_blank";
                  s(a, l);
                }
              }
              n = !0;
            }
          });
        };

        this.group._onclickEvent && this.group.off("click", this.group._onclickEvent), this.group.on("click", t), this.group._onclickEvent = t;
      },
      _rootToNode: function _rootToNode(e) {
        e !== this.seriesModel.getViewRoot() && this.api.dispatchAction({
          type: "sunburstRootToNode",
          from: this.uid,
          seriesId: this.seriesModel.id,
          targetNode: e
        });
      },
      containPoint: function containPoint(e, t) {
        var n = t.getData().getItemLayout(0);

        if (n) {
          var i = e[0] - n.cx,
              r = e[1] - n.cy,
              o = Math.sqrt(i * i + r * r);
          return o <= n.r && o >= n.r0;
        }
      }
    });
    e.exports = l;
  }, function (e, t, n) {
    var i = n(1),
        r = n(5),
        o = "none",
        a = "ancestor",
        s = "self";

    function l(e, t, n) {
      r.Group.call(this);
      var i = new r.Sector({
        z2: 2
      });
      i.seriesIndex = t.seriesIndex;
      var o = new r.Text({
        z2: 4,
        silent: e.getModel("label").get("silent")
      });

      function a() {
        o.ignore = o.hoverIgnore;
      }

      function s() {
        o.ignore = o.normalIgnore;
      }

      this.add(i), this.add(o), this.updateData(!0, e, "normal", t, n), this.on("emphasis", a).on("normal", s).on("mouseover", a).on("mouseout", s);
    }

    var u = l.prototype;
    u.updateData = function (e, t, n, o, a) {
      this.node = t, t.piece = this, o = o || this._seriesModel, a = a || this._ecModel;
      var s = this.childAt(0);
      s.dataIndex = t.dataIndex;
      var l = t.getModel(),
          u = t.getLayout(),
          c = i.extend({}, u);
      c.label = null;

      var h = function (e, t, n) {
        var r = e.getVisual("color"),
            o = e.getVisual("visualMeta");
        o && 0 !== o.length || (r = null);
        var a = e.getModel("itemStyle").get("color");
        if (a) return a;
        if (r) return r;
        if (0 === e.depth) return n.option.color[0];
        var s = n.option.color.length;

        a = n.option.color[function (e) {
          var t = e;

          for (; t.depth > 1;) {
            t = t.parentNode;
          }

          var n = e.getAncestors()[0];
          return i.indexOf(n.children, t);
        }(e) % s];

        return a;
      }(t, 0, a);

      !function (e, t, n) {
        t.getData().setItemVisual(e.dataIndex, "color", n);
      }(t, o, h);
      var d,
          f = l.getModel("itemStyle").getItemStyle();
      if ("normal" === n) d = f;else {
        var p = l.getModel(n + ".itemStyle").getItemStyle();
        d = i.merge(p, f);
      }
      d = i.defaults({
        lineJoin: "bevel",
        fill: d.fill || h
      }, d), e ? (s.setShape(c), s.shape.r = u.r0, r.updateProps(s, {
        shape: {
          r: u.r
        }
      }, o, t.dataIndex), s.useStyle(d)) : "object" == typeof d.fill && d.fill.type || "object" == typeof s.style.fill && s.style.fill.type ? (r.updateProps(s, {
        shape: c
      }, o), s.useStyle(d)) : r.updateProps(s, {
        shape: c,
        style: d
      }, o), this._updateLabel(o, h, n);
      var g = l.getShallow("cursor");

      if (g && s.attr("cursor", g), e) {
        var v = o.getShallow("highlightPolicy");

        this._initEvents(s, t, o, v);
      }

      this._seriesModel = o || this._seriesModel, this._ecModel = a || this._ecModel, r.setHoverStyle(this);
    }, u.onEmphasis = function (e) {
      var t = this;
      this.node.hostTree.root.eachNode(function (n) {
        var i, r, l;
        n.piece && (t.node === n ? n.piece.updateData(!1, n, "emphasis") : (i = n, r = t.node, (l = e) !== o && (l === s ? i === r : l === a ? i === r || i.isAncestorOf(r) : i === r || i.isDescendantOf(r)) ? n.piece.childAt(0).trigger("highlight") : e !== o && n.piece.childAt(0).trigger("downplay")));
      });
    }, u.onNormal = function () {
      this.node.hostTree.root.eachNode(function (e) {
        e.piece && e.piece.updateData(!1, e, "normal");
      });
    }, u.onHighlight = function () {
      this.updateData(!1, this.node, "highlight");
    }, u.onDownplay = function () {
      this.updateData(!1, this.node, "downplay");
    }, u._updateLabel = function (e, t, n) {
      var o = this.node.getModel(),
          a = o.getModel("label"),
          s = "normal" === n || "emphasis" === n ? a : o.getModel(n + ".label"),
          l = o.getModel("emphasis.label"),
          u = i.retrieve(e.getFormattedLabel(this.node.dataIndex, n, null, null, "label"), this.node.name);
      !1 === C("show") && (u = "");
      var c = this.node.getLayout(),
          h = s.get("minAngle");
      null == h && (h = a.get("minAngle")), h = h / 180 * Math.PI;
      var d = c.endAngle - c.startAngle;
      null != h && Math.abs(d) < h && (u = "");
      var f = this.childAt(1);
      r.setLabelStyle(f.style, f.hoverStyle || {}, a, l, {
        defaultText: s.getShallow("show") ? u : null,
        autoColor: t,
        useInsideStyle: !0
      });

      var p,
          g = (c.startAngle + c.endAngle) / 2,
          v = Math.cos(g),
          m = Math.sin(g),
          y = C("position"),
          x = C("distance") || 0,
          _ = C("align");

      "outside" === y ? (p = c.r + x, _ = g > Math.PI / 2 ? "right" : "left") : _ && "center" !== _ ? "left" === _ ? (p = c.r0 + x, g > Math.PI / 2 && (_ = "right")) : "right" === _ && (p = c.r - x, g > Math.PI / 2 && (_ = "left")) : (p = (c.r + c.r0) / 2, _ = "center"), f.attr("style", {
        text: u,
        textAlign: _,
        textVerticalAlign: C("verticalAlign") || "middle",
        opacity: C("opacity")
      });
      var b = p * v + c.cx,
          w = p * m + c.cy;
      f.attr("position", [b, w]);
      var S = C("rotate"),
          T = 0;

      function C(e) {
        var t = s.get(e);
        return null == t ? a.get(e) : t;
      }

      "radial" === S ? (T = -g) < -Math.PI / 2 && (T += Math.PI) : "tangential" === S ? (T = Math.PI / 2 - g) > Math.PI / 2 ? T -= Math.PI : T < -Math.PI / 2 && (T += Math.PI) : "number" == typeof S && (T = S * Math.PI / 180), f.attr("rotation", T);
    }, u._initEvents = function (e, t, n, i) {
      e.off("mouseover").off("mouseout").off("emphasis").off("normal");

      var r = this,
          o = function o() {
        r.onEmphasis(i);
      },
          a = function a() {
        r.onNormal();
      };

      n.isAnimationEnabled() && e.on("mouseover", o).on("mouseout", a).on("emphasis", o).on("normal", a).on("downplay", function () {
        r.onDownplay();
      }).on("highlight", function () {
        r.onHighlight();
      });
    }, i.inherits(l, r.Group);
    var c = l;
    e.exports = c;
  }, function (e, t, n) {
    var i = n(4),
        r = n(90);
    i.registerAction({
      type: "sunburstRootToNode",
      update: "updateView"
    }, function (e, t) {
      t.eachComponent({
        mainType: "series",
        subType: "sunburst",
        query: e
      }, function (t, n) {
        var i = r.retrieveTargetInfo(e, ["sunburstRootToNode"], t);

        if (i) {
          var o = t.getViewRoot();
          o && (e.direction = r.aboveViewRoot(o, i.node) ? "rollUp" : "drillDown"), t.resetViewRoot(i.node);
        }
      });
    });
    i.registerAction({
      type: "sunburstHighlight",
      update: "updateView"
    }, function (e, t) {
      t.eachComponent({
        mainType: "series",
        subType: "sunburst",
        query: e
      }, function (t, n) {
        var i = r.retrieveTargetInfo(e, ["sunburstHighlight"], t);
        i && (e.highlight = i.node);
      });
    });
    i.registerAction({
      type: "sunburstUnhighlight",
      update: "updateView"
    }, function (e, t) {
      t.eachComponent({
        mainType: "series",
        subType: "sunburst",
        query: e
      }, function (t, n) {
        e.unhighlight = !0;
      });
    });
  }, function (e, t, n) {
    var i = n(6).parsePercent,
        r = n(1),
        o = Math.PI / 180;

    function a(e, t) {
      var n = e.children || [];
      e.children = function (e, t) {
        if ("function" == typeof t) return e.sort(t);
        var n = "asc" === t;
        return e.sort(function (e, t) {
          var i = (e.getValue() - t.getValue()) * (n ? 1 : -1);
          return 0 === i ? (e.dataIndex - t.dataIndex) * (n ? -1 : 1) : i;
        });
      }(n, t), n.length && r.each(e.children, function (e) {
        a(e, t);
      });
    }

    e.exports = function (e, t, n, s) {
      t.eachSeriesByType(e, function (e) {
        var t = e.get("center"),
            s = e.get("radius");
        r.isArray(s) || (s = [0, s]), r.isArray(t) || (t = [t, t]);

        var l = n.getWidth(),
            u = n.getHeight(),
            c = Math.min(l, u),
            h = i(t[0], l),
            d = i(t[1], u),
            f = i(s[0], c / 2),
            p = i(s[1], c / 2),
            g = -e.get("startAngle") * o,
            v = e.get("minAngle") * o,
            m = e.getData().tree.root,
            y = e.getViewRoot(),
            x = y.depth,
            _ = e.get("sort");

        null != _ && a(y, _);
        var b = 0;
        r.each(y.children, function (e) {
          !isNaN(e.getValue()) && b++;
        });

        var w = y.getValue(),
            S = Math.PI / (w || b) * 2,
            T = y.depth > 0,
            C = y.height - (T ? -1 : 1),
            k = (p - f) / (C || 1),
            M = e.get("clockwise"),
            E = e.get("stillShowZeroSum"),
            A = M ? 1 : -1,
            I = function I(e, t) {
          if (e) {
            var n = t;

            if (e !== m) {
              var o = e.getValue(),
                  a = 0 === w && E ? S : o * S;
              a < v && (a = v), n = t + A * a;
              var s = e.depth - x - (T ? -1 : 1),
                  l = f + k * s,
                  u = f + k * (s + 1),
                  p = e.getModel();
              null != p.get("r0") && (l = i(p.get("r0"), c / 2)), null != p.get("r") && (u = i(p.get("r"), c / 2)), e.setLayout({
                angle: a,
                startAngle: t,
                endAngle: n,
                clockwise: M,
                cx: h,
                cy: d,
                r0: l,
                r: u
              });
            }

            if (e.children && e.children.length) {
              var g = 0;
              r.each(e.children, function (e) {
                g += I(e, t + g);
              });
            }

            return n - t;
          }
        };

        if (T) {
          var P = f,
              O = f + k,
              L = 2 * Math.PI;
          m.setLayout({
            angle: L,
            startAngle: g,
            endAngle: g + L,
            clockwise: M,
            cx: h,
            cy: d,
            r0: P,
            r: O
          });
        }

        I(y, g);
      });
    };
  }, function (e, t, n) {
    n(9).__DEV__;
    var i = n(1),
        r = n(5),
        o = n(213).getDefaultLabel,
        a = n(62),
        s = n(161).getLayoutOnAxis,
        l = n(87),
        u = n(27),
        c = n(22),
        h = n(54),
        d = n(126).createClipPath,
        f = n(844),
        p = n(845),
        g = n(846),
        v = n(847),
        m = n(848),
        y = r.CACHED_LABEL_STYLE_PROPERTIES,
        x = ["itemStyle"],
        _ = ["emphasis", "itemStyle"],
        b = ["label"],
        w = ["emphasis", "label"],
        S = {
      cartesian2d: f,
      geo: p,
      singleAxis: g,
      polar: v,
      calendar: m
    };

    function T(e, t, n, i, r) {
      null == n[e] || r || (t[e] = n[e], n[e] = i[e]);
    }

    function C(e, t, n, a) {
      var l = e.get("renderItem"),
          u = e.coordinateSystem,
          c = {};
      u && (c = u.prepareCustoms ? u.prepareCustoms() : S[u.type](u));
      var h,
          d,
          f,
          p,
          g,
          v = i.defaults({
        getWidth: a.getWidth,
        getHeight: a.getHeight,
        getZr: a.getZr,
        getDevicePixelRatio: a.getDevicePixelRatio,
        value: function value(e, n) {
          return null == n && (n = h), t.get(t.getDimension(e || 0), n);
        },
        style: function style(n, a) {
          null == a && (a = h), T(a);
          var s = d.getModel(x).getItemStyle();
          null != g && (s.fill = g);
          var l = t.getItemVisual(a, "opacity");
          null != l && (s.opacity = l);
          var u = n ? P(n, f) : f;
          return r.setTextStyle(s, u, null, {
            autoColor: g,
            isRectText: !0
          }), s.text = u.getShallow("show") ? i.retrieve2(e.getFormattedLabel(a, "normal"), o(t, a)) : null, n && O(s, n), s;
        },
        styleEmphasis: function styleEmphasis(n, a) {
          null == a && (a = h), T(a);
          var s = d.getModel(_).getItemStyle(),
              l = n ? P(n, p) : p;
          return r.setTextStyle(s, l, null, {
            isRectText: !0
          }, !0), s.text = l.getShallow("show") ? i.retrieve3(e.getFormattedLabel(a, "emphasis"), e.getFormattedLabel(a, "normal"), o(t, a)) : null, n && O(s, n), s;
        },
        visual: function visual(e, n) {
          return null == n && (n = h), t.getItemVisual(n, e);
        },
        barLayout: function barLayout(e) {
          if (u.getBaseAxis) {
            var t = u.getBaseAxis();
            return s(i.defaults({
              axis: t
            }, e), a);
          }
        },
        currentSeriesIndices: function currentSeriesIndices() {
          return n.getCurrentSeriesIndices();
        },
        font: function font(e) {
          return r.getFont(e, n);
        }
      }, c.api || {}),
          m = {
        context: {},
        seriesId: e.id,
        seriesName: e.name,
        seriesIndex: e.seriesIndex,
        coordSys: c.coordSys,
        dataInsideLength: t.count(),
        encode: k(e.getData())
      },
          y = !0;
      return function (e, n) {
        return h = e, y = !0, l && l(i.defaults({
          dataIndexInside: e,
          dataIndex: t.getRawIndex(e),
          actionType: n ? n.type : null
        }, m), v);
      };

      function T(e) {
        null == e && (e = h), y && (d = t.getItemModel(e), f = d.getModel(b), p = d.getModel(w), g = t.getItemVisual(e, "color"), y = !1);
      }
    }

    function k(e) {
      var t = {};
      return i.each(e.dimensions, function (n, i) {
        var r = e.getDimensionInfo(n);

        if (!r.isExtraCoord) {
          var o = r.coordDim;
          (t[o] = t[o] || [])[r.coordDimIndex] = i;
        }
      }), t;
    }

    function M(e, t, n, i, r, o) {
      return (e = E(e, t, n, i, r, o, !0)) && o.setItemGraphicEl(t, e), e;
    }

    function E(e, t, n, o, a, s, u) {
      var c,
          h = !n,
          d = (n = n || {}).type,
          f = n.shape,
          p = n.style;

      if (e && (h || null != d && d !== e.__customGraphicType || "path" === d && (c = f) && (c.hasOwnProperty("pathData") || c.hasOwnProperty("d")) && D(f) !== e.__customPathData || "image" === d && N(p, "image") && p.image !== e.__customImagePath || "text" === d && N(f, "text") && p.text !== e.__customText) && (a.remove(e), e = null), !h) {
        var g = !e;
        return !e && (e = function (e) {
          var t,
              n = e.type;

          if ("path" === n) {
            var i = e.shape,
                o = null != i.width && null != i.height ? {
              x: i.x || 0,
              y: i.y || 0,
              width: i.width,
              height: i.height
            } : null,
                a = D(i);
            (t = r.makePath(a, null, o, i.layout || "center")).__customPathData = a;
          } else if ("image" === n) (t = new r.Image({})).__customImagePath = e.style.image;else if ("text" === n) (t = new r.Text({})).__customText = e.style.text;else if ("group" === n) t = new r.Group();else {
            if ("compoundPath" === n) throw new Error('"compoundPath" is not supported yet.');
            t = new (r.getShapeClass(n))();
          }

          return t.__customGraphicType = n, t.name = e.name, t;
        }(n)), function (e, t, n, o, a, s, l) {
          var u = {},
              c = n.style || {};

          if (n.shape && (u.shape = i.clone(n.shape)), n.position && (u.position = n.position.slice()), n.scale && (u.scale = n.scale.slice()), n.origin && (u.origin = n.origin.slice()), n.rotation && (u.rotation = n.rotation), "image" === e.type && n.style) {
            var h = u.style = {};
            i.each(["x", "y", "width", "height"], function (t) {
              T(t, h, c, e.style, s);
            });
          }

          if ("text" === e.type && n.style) {
            h = u.style = {};
            i.each(["x", "y"], function (t) {
              T(t, h, c, e.style, s);
            }), !c.hasOwnProperty("textFill") && c.fill && (c.textFill = c.fill), !c.hasOwnProperty("textStroke") && c.stroke && (c.textStroke = c.stroke);
          }

          if ("group" !== e.type && (e.useStyle(c), s)) {
            e.style.opacity = 0;
            var d = c.opacity;
            null == d && (d = 1), r.initProps(e, {
              style: {
                opacity: d
              }
            }, o, t);
          }

          s ? e.attr(u) : r.updateProps(e, u, o, t), n.hasOwnProperty("z2") && e.attr("z2", n.z2 || 0), n.hasOwnProperty("silent") && e.attr("silent", n.silent), n.hasOwnProperty("invisible") && e.attr("invisible", n.invisible), n.hasOwnProperty("ignore") && e.attr("ignore", n.ignore), n.hasOwnProperty("info") && e.attr("info", n.info);
          var f = n.styleEmphasis;
          r.setElementHoverStyle(e, f), l && r.setAsHighDownDispatcher(e, !1 !== f);
        }(e, t, n, o, 0, g, u), "group" === d && function (e, t, n, i, r) {
          var o = n.children,
              a = o ? o.length : 0,
              s = n.$mergeChildren,
              u = "byName" === s || n.diffChildrenByName,
              c = !1 === s;
          if (!a && !u && !c) return;
          if (u) return h = {
            oldChildren: e.children() || [],
            newChildren: o || [],
            dataIndex: t,
            animatableModel: i,
            group: e,
            data: r
          }, void new l(h.oldChildren, h.newChildren, A, A, h).add(I).update(I).remove(L).execute();
          var h;
          c && e.removeAll();

          for (var d = 0; d < a; d++) {
            o[d] && E(e.childAt(d), t, o[d], i, e, r);
          }
        }(e, t, n, o, s), a.add(e), e;
      }
    }

    function A(e, t) {
      var n = e && e.name;
      return null != n ? n : "e\0\0" + t;
    }

    function I(e, t) {
      var n = this.context,
          i = null != e ? n.newChildren[e] : null;
      E(null != t ? n.oldChildren[t] : null, n.dataIndex, i, n.animatableModel, n.group, n.data);
    }

    function P(e, t) {
      var n = new c({}, t);
      return i.each(y, function (t, i) {
        e.hasOwnProperty(t) && (n.option[i] = e[t]);
      }), n;
    }

    function O(e, t) {
      for (var n in t) {
        !t.hasOwnProperty(n) && y.hasOwnProperty(n) || (e[n] = t[n]);
      }
    }

    function L(e) {
      var t = this.context,
          n = t.oldChildren[e];
      n && t.group.remove(n);
    }

    function D(e) {
      return e && (e.pathData || e.d);
    }

    function N(e, t) {
      return e && e.hasOwnProperty(t);
    }

    u.extend({
      type: "series.custom",
      dependencies: ["grid", "polar", "geo", "singleAxis", "calendar"],
      defaultOption: {
        coordinateSystem: "cartesian2d",
        zlevel: 0,
        z: 2,
        legendHoverLink: !0,
        useTransform: !0,
        clip: !1
      },
      getInitialData: function getInitialData(e, t) {
        return a(this.getSource(), this);
      },
      getDataParams: function getDataParams(e, t, n) {
        var i = u.prototype.getDataParams.apply(this, arguments);
        return n && (i.info = n.info), i;
      }
    }), h.extend({
      type: "custom",
      _data: null,
      render: function render(e, t, n, i) {
        var r = this._data,
            o = e.getData(),
            a = this.group,
            s = C(e, o, t, n);
        o.diff(r).add(function (t) {
          M(null, t, s(t, i), e, a, o);
        }).update(function (t, n) {
          M(r.getItemGraphicEl(n), t, s(t, i), e, a, o);
        }).remove(function (e) {
          var t = r.getItemGraphicEl(e);
          t && a.remove(t);
        }).execute();
        var l = e.get("clip", !0) ? d(e.coordinateSystem, !1, e) : null;
        l ? a.setClipPath(l) : a.removeClipPath(), this._data = o;
      },
      incrementalPrepareRender: function incrementalPrepareRender(e, t, n) {
        this.group.removeAll(), this._data = null;
      },
      incrementalRender: function incrementalRender(e, t, n, i, r) {
        var o = t.getData(),
            a = C(t, o, n, i);

        function s(e) {
          e.isGroup || (e.incremental = !0, e.useHoverLayer = !0);
        }

        for (var l = e.start; l < e.end; l++) {
          M(null, l, a(l, r), t, this.group, o).traverse(s);
        }
      },
      dispose: i.noop,
      filterForExposedEvent: function filterForExposedEvent(e, t, n, i) {
        var r = t.element;
        if (null == r || n.name === r) return !0;

        for (; (n = n.parent) && n !== this.group;) {
          if (n.name === r) return !0;
        }

        return !1;
      }
    });
  }, function (e, t, n) {
    var i = n(1);

    function r(e, t) {
      return t = t || [0, 0], i.map(["x", "y"], function (n, i) {
        var r = this.getAxis(n),
            o = t[i],
            a = e[i] / 2;
        return "category" === r.type ? r.getBandWidth() : Math.abs(r.dataToCoord(o - a) - r.dataToCoord(o + a));
      }, this);
    }

    e.exports = function (e) {
      var t = e.grid.getRect();
      return {
        coordSys: {
          type: "cartesian2d",
          x: t.x,
          y: t.y,
          width: t.width,
          height: t.height
        },
        api: {
          coord: function coord(t) {
            return e.dataToPoint(t);
          },
          size: i.bind(r, e)
        }
      };
    };
  }, function (e, t, n) {
    var i = n(1);

    function r(e, t) {
      return t = t || [0, 0], i.map([0, 1], function (n) {
        var i = t[n],
            r = e[n] / 2,
            o = [],
            a = [];
        return o[n] = i - r, a[n] = i + r, o[1 - n] = a[1 - n] = t[1 - n], Math.abs(this.dataToPoint(o)[n] - this.dataToPoint(a)[n]);
      }, this);
    }

    e.exports = function (e) {
      var t = e.getBoundingRect();
      return {
        coordSys: {
          type: "geo",
          x: t.x,
          y: t.y,
          width: t.width,
          height: t.height,
          zoom: e.getZoom()
        },
        api: {
          coord: function coord(t) {
            return e.dataToPoint(t);
          },
          size: i.bind(r, e)
        }
      };
    };
  }, function (e, t, n) {
    var i = n(1);

    function r(e, t) {
      var n = this.getAxis(),
          i = t instanceof Array ? t[0] : t,
          r = (e instanceof Array ? e[0] : e) / 2;
      return "category" === n.type ? n.getBandWidth() : Math.abs(n.dataToCoord(i - r) - n.dataToCoord(i + r));
    }

    e.exports = function (e) {
      var t = e.getRect();
      return {
        coordSys: {
          type: "singleAxis",
          x: t.x,
          y: t.y,
          width: t.width,
          height: t.height
        },
        api: {
          coord: function coord(t) {
            return e.dataToPoint(t);
          },
          size: i.bind(r, e)
        }
      };
    };
  }, function (e, t, n) {
    var i = n(1);

    function r(e, t) {
      return i.map(["Radius", "Angle"], function (n, i) {
        var r = this["get" + n + "Axis"](),
            o = t[i],
            a = e[i] / 2,
            s = "dataTo" + n,
            l = "category" === r.type ? r.getBandWidth() : Math.abs(r[s](o - a) - r[s](o + a));
        return "Angle" === n && (l = l * Math.PI / 180), l;
      }, this);
    }

    e.exports = function (e) {
      var t = e.getRadiusAxis(),
          n = e.getAngleAxis(),
          o = t.getExtent();
      return o[0] > o[1] && o.reverse(), {
        coordSys: {
          type: "polar",
          cx: e.cx,
          cy: e.cy,
          r: o[1],
          r0: o[0]
        },
        api: {
          coord: i.bind(function (i) {
            var r = t.dataToRadius(i[0]),
                o = n.dataToAngle(i[1]),
                a = e.coordToPoint([r, o]);
            return a.push(r, o * Math.PI / 180), a;
          }),
          size: i.bind(r, e)
        }
      };
    };
  }, function (e, t) {
    e.exports = function (e) {
      var t = e.getRect(),
          n = e.getRangeInfo();
      return {
        coordSys: {
          type: "calendar",
          x: t.x,
          y: t.y,
          width: t.width,
          height: t.height,
          cellWidth: e.getCellWidth(),
          cellHeight: e.getCellHeight(),
          rangeInfo: {
            start: n.start,
            end: n.end,
            weeks: n.weeks,
            dayCount: n.allDay
          }
        },
        api: {
          coord: function coord(t, n) {
            return e.dataToPoint(t, n);
          }
        }
      };
    };
  }, function (e, t, n) {
    n(128), n(348), n(132);
  }, function (e, t, n) {
    var i = n(4),
        r = n(1),
        o = n(851);
    n(226), n(857), n(859), n(132), n(861), i.registerLayout(r.curry(o, "bar")), i.extendComponentView({
      type: "polar"
    });
  }, function (e, t, n) {
    var i = n(1),
        r = n(6).parsePercent,
        o = n(55).isDimensionStacked;

    function a(e) {
      return e.get("stack") || "__ec_stack_" + e.seriesIndex;
    }

    function s(e, t) {
      return t.dim + e.model.componentIndex;
    }

    var l = function l(e, t, n) {
      var l = {},
          u = function (e, t) {
        var n = {};
        i.each(e, function (e, t) {
          var i = e.getData(),
              o = e.coordinateSystem,
              l = o.getBaseAxis(),
              u = s(o, l),
              c = l.getExtent(),
              h = "category" === l.type ? l.getBandWidth() : Math.abs(c[1] - c[0]) / i.count(),
              d = n[u] || {
            bandWidth: h,
            remainedWidth: h,
            autoWidthCount: 0,
            categoryGap: "20%",
            gap: "30%",
            stacks: {}
          },
              f = d.stacks;
          n[u] = d;
          var p = a(e);
          f[p] || d.autoWidthCount++, f[p] = f[p] || {
            width: 0,
            maxWidth: 0
          };
          var g = r(e.get("barWidth"), h),
              v = r(e.get("barMaxWidth"), h),
              m = e.get("barGap"),
              y = e.get("barCategoryGap");
          g && !f[p].width && (g = Math.min(d.remainedWidth, g), f[p].width = g, d.remainedWidth -= g), v && (f[p].maxWidth = v), null != m && (d.gap = m), null != y && (d.categoryGap = y);
        });
        var o = {};
        return i.each(n, function (e, t) {
          o[t] = {};
          var n = e.stacks,
              a = e.bandWidth,
              s = r(e.categoryGap, a),
              l = r(e.gap, 1),
              u = e.remainedWidth,
              c = e.autoWidthCount,
              h = (u - s) / (c + (c - 1) * l);
          h = Math.max(h, 0), i.each(n, function (e, t) {
            var n = e.maxWidth;
            n && n < h && (n = Math.min(n, u), e.width && (n = Math.min(n, e.width)), u -= n, e.width = n, c--);
          }), h = (u - s) / (c + (c - 1) * l), h = Math.max(h, 0);
          var d,
              f = 0;
          i.each(n, function (e, t) {
            e.width || (e.width = h), d = e, f += e.width * (1 + l);
          }), d && (f -= d.width * l);
          var p = -f / 2;
          i.each(n, function (e, n) {
            o[t][n] = o[t][n] || {
              offset: p,
              width: e.width
            }, p += e.width * (1 + l);
          });
        }), o;
      }(i.filter(t.getSeriesByType(e), function (e) {
        return !t.isSeriesFiltered(e) && e.coordinateSystem && "polar" === e.coordinateSystem.type;
      }));

      t.eachSeriesByType(e, function (e) {
        if ("polar" === e.coordinateSystem.type) {
          var t = e.getData(),
              n = e.coordinateSystem,
              i = n.getBaseAxis(),
              r = s(n, i),
              c = a(e),
              h = u[r][c],
              d = h.offset,
              f = h.width,
              p = n.getOtherAxis(i),
              g = e.coordinateSystem.cx,
              v = e.coordinateSystem.cy,
              m = e.get("barMinHeight") || 0,
              y = e.get("barMinAngle") || 0;
          l[c] = l[c] || [];

          for (var x = t.mapDimension(p.dim), _ = t.mapDimension(i.dim), b = o(t, x), w = "radius" !== i.dim || !e.get("roundCap", !0), S = p.getExtent()[0], T = 0, C = t.count(); T < C; T++) {
            var k,
                M,
                E,
                A,
                I = t.get(x, T),
                P = t.get(_, T),
                O = I >= 0 ? "p" : "n",
                L = S;

            if (b && (l[c][P] || (l[c][P] = {
              p: S,
              n: S
            }), L = l[c][P][O]), "radius" === p.dim) {
              var D = p.dataToRadius(I) - S,
                  N = i.dataToAngle(P);
              Math.abs(D) < m && (D = (D < 0 ? -1 : 1) * m), k = L, M = L + D, A = (E = N - d) - f, b && (l[c][P][O] = M);
            } else {
              var j = p.dataToAngle(I, w) - S,
                  R = i.dataToRadius(P);
              Math.abs(j) < y && (j = (j < 0 ? -1 : 1) * y), M = (k = R + d) + f, E = L, A = L + j, b && (l[c][P][O] = A);
            }

            t.setItemLayout(T, {
              cx: g,
              cy: v,
              r0: k,
              r: M,
              startAngle: -E * Math.PI / 180,
              endAngle: -A * Math.PI / 180
            });
          }
        }
      }, this);
    };

    e.exports = l;
  }, function (e, t, n) {
    var i = n(853),
        r = n(854),
        o = function o(e) {
      this.name = e || "", this.cx = 0, this.cy = 0, this._radiusAxis = new i(), this._angleAxis = new r(), this._radiusAxis.polar = this._angleAxis.polar = this;
    };

    o.prototype = {
      type: "polar",
      axisPointerEnabled: !0,
      constructor: o,
      dimensions: ["radius", "angle"],
      model: null,
      containPoint: function containPoint(e) {
        var t = this.pointToCoord(e);
        return this._radiusAxis.contain(t[0]) && this._angleAxis.contain(t[1]);
      },
      containData: function containData(e) {
        return this._radiusAxis.containData(e[0]) && this._angleAxis.containData(e[1]);
      },
      getAxis: function getAxis(e) {
        return this["_" + e + "Axis"];
      },
      getAxes: function getAxes() {
        return [this._radiusAxis, this._angleAxis];
      },
      getAxesByScale: function getAxesByScale(e) {
        var t = [],
            n = this._angleAxis,
            i = this._radiusAxis;
        return n.scale.type === e && t.push(n), i.scale.type === e && t.push(i), t;
      },
      getAngleAxis: function getAngleAxis() {
        return this._angleAxis;
      },
      getRadiusAxis: function getRadiusAxis() {
        return this._radiusAxis;
      },
      getOtherAxis: function getOtherAxis(e) {
        var t = this._angleAxis;
        return e === t ? this._radiusAxis : t;
      },
      getBaseAxis: function getBaseAxis() {
        return this.getAxesByScale("ordinal")[0] || this.getAxesByScale("time")[0] || this.getAngleAxis();
      },
      getTooltipAxes: function getTooltipAxes(e) {
        var t = null != e && "auto" !== e ? this.getAxis(e) : this.getBaseAxis();
        return {
          baseAxes: [t],
          otherAxes: [this.getOtherAxis(t)]
        };
      },
      dataToPoint: function dataToPoint(e, t) {
        return this.coordToPoint([this._radiusAxis.dataToRadius(e[0], t), this._angleAxis.dataToAngle(e[1], t)]);
      },
      pointToData: function pointToData(e, t) {
        var n = this.pointToCoord(e);
        return [this._radiusAxis.radiusToData(n[0], t), this._angleAxis.angleToData(n[1], t)];
      },
      pointToCoord: function pointToCoord(e) {
        var t = e[0] - this.cx,
            n = e[1] - this.cy,
            i = this.getAngleAxis(),
            r = i.getExtent(),
            o = Math.min(r[0], r[1]),
            a = Math.max(r[0], r[1]);
        i.inverse ? o = a - 360 : a = o + 360;
        var s = Math.sqrt(t * t + n * n);
        t /= s, n /= s;

        for (var l = Math.atan2(-n, t) / Math.PI * 180, u = l < o ? 1 : -1; l < o || l > a;) {
          l += 360 * u;
        }

        return [s, l];
      },
      coordToPoint: function coordToPoint(e) {
        var t = e[0],
            n = e[1] / 180 * Math.PI;
        return [Math.cos(n) * t + this.cx, -Math.sin(n) * t + this.cy];
      },
      getArea: function getArea() {
        var e = this.getAngleAxis(),
            t = this.getRadiusAxis().getExtent().slice();
        t[0] > t[1] && t.reverse();
        var n = e.getExtent(),
            i = Math.PI / 180;
        return {
          cx: this.cx,
          cy: this.cy,
          r0: t[0],
          r: t[1],
          startAngle: -n[0] * i,
          endAngle: -n[1] * i,
          clockwise: e.inverse,
          contain: function contain(e, t) {
            var n = e - this.cx,
                i = t - this.cy,
                r = n * n + i * i,
                o = this.r,
                a = this.r0;
            return r <= o * o && r >= a * a;
          }
        };
      }
    };
    var a = o;
    e.exports = a;
  }, function (e, t, n) {
    var i = n(1),
        r = n(69);

    function o(e, t) {
      r.call(this, "radius", e, t), this.type = "category";
    }

    o.prototype = {
      constructor: o,
      pointToData: function pointToData(e, t) {
        return this.polar.pointToData(e, t)["radius" === this.dim ? 0 : 1];
      },
      dataToRadius: r.prototype.dataToCoord,
      radiusToData: r.prototype.coordToData
    }, i.inherits(o, r);
    var a = o;
    e.exports = a;
  }, function (e, t, n) {
    var i = n(1),
        r = n(35),
        o = n(69),
        a = (0, n(8).makeInner)();

    function s(e, t) {
      t = t || [0, 360], o.call(this, "angle", e, t), this.type = "category";
    }

    s.prototype = {
      constructor: s,
      pointToData: function pointToData(e, t) {
        return this.polar.pointToData(e, t)["radius" === this.dim ? 0 : 1];
      },
      dataToAngle: o.prototype.dataToCoord,
      angleToData: o.prototype.coordToData,
      calculateCategoryInterval: function calculateCategoryInterval() {
        var e = this.getLabelModel(),
            t = this.scale,
            n = t.getExtent(),
            i = t.count();
        if (n[1] - n[0] < 1) return 0;
        var o = n[0],
            s = this.dataToCoord(o + 1) - this.dataToCoord(o),
            l = Math.abs(s),
            u = r.getBoundingRect(o, e.getFont(), "center", "top"),
            c = Math.max(u.height, 7) / l;
        isNaN(c) && (c = 1 / 0);
        var h = Math.max(0, Math.floor(c)),
            d = a(this.model),
            f = d.lastAutoInterval,
            p = d.lastTickCount;
        return null != f && null != p && Math.abs(f - h) <= 1 && Math.abs(p - i) <= 1 && f > h ? h = f : (d.lastTickCount = i, d.lastAutoInterval = h), h;
      }
    }, i.inherits(s, o);
    var l = s;
    e.exports = l;
  }, function (e, t, n) {
    var i = n(4);
    n(856);
    var r = i.extendComponentModel({
      type: "polar",
      dependencies: ["polarAxis", "angleAxis"],
      coordinateSystem: null,
      findAxisModel: function findAxisModel(e) {
        var t;
        return this.ecModel.eachComponent(e, function (e) {
          e.getCoordSysModel() === this && (t = e);
        }, this), t;
      },
      defaultOption: {
        zlevel: 0,
        z: 0,
        center: ["50%", "50%"],
        radius: "80%"
      }
    });
    e.exports = r;
  }, function (e, t, n) {
    var i = n(1),
        r = n(26),
        o = n(163),
        a = n(105),
        s = r.extend({
      type: "polarAxis",
      axis: null,
      getCoordSysModel: function getCoordSysModel() {
        return this.ecModel.queryComponents({
          mainType: "polar",
          index: this.option.polarIndex,
          id: this.option.polarId
        })[0];
      }
    });
    i.merge(s.prototype, a);
    var l = {
      splitNumber: 5
    };

    function u(e, t) {
      return t.type || (t.data ? "category" : "value");
    }

    o("angle", s, u, {
      startAngle: 90,
      clockwise: !0,
      splitNumber: 12,
      axisLabel: {
        rotate: !1
      }
    }), o("radius", s, u, l);
  }, function (e, t, n) {
    n(226), n(858);
  }, function (e, t, n) {
    var i = n(1),
        r = n(5),
        o = n(22),
        a = n(89),
        s = n(70),
        l = ["axisLine", "axisLabel", "axisTick", "minorTick", "splitLine", "minorSplitLine", "splitArea"];

    function u(e, t, n) {
      t[1] > t[0] && (t = t.slice().reverse());
      var i = e.coordToPoint([t[0], n]),
          r = e.coordToPoint([t[1], n]);
      return {
        x1: i[0],
        y1: i[1],
        x2: r[0],
        y2: r[1]
      };
    }

    function c(e) {
      return e.getRadiusAxis().inverse ? 0 : 1;
    }

    function h(e) {
      var t = e[0],
          n = e[e.length - 1];
      t && n && Math.abs(Math.abs(t.coord - n.coord) - 360) < 1e-4 && e.pop();
    }

    var d = a.extend({
      type: "angleAxis",
      axisPointerClass: "PolarAxisPointer",
      render: function render(e, t) {
        if (this.group.removeAll(), e.get("show")) {
          var n = e.axis,
              r = n.polar,
              o = r.getRadiusAxis().getExtent(),
              a = n.getTicksCoords(),
              s = n.getMinorTicksCoords(),
              u = i.map(n.getViewLabels(), function (e) {
            return (e = i.clone(e)).coord = n.dataToCoord(e.tickValue), e;
          });
          h(u), h(a), i.each(l, function (t) {
            !e.get(t + ".show") || n.scale.isBlank() && "axisLine" !== t || this["_" + t](e, r, a, s, o, u);
          }, this);
        }
      },
      _axisLine: function _axisLine(e, t, n, i, o) {
        var a,
            s = e.getModel("axisLine.lineStyle"),
            l = c(t),
            u = l ? 0 : 1;
        (a = 0 === o[u] ? new r.Circle({
          shape: {
            cx: t.cx,
            cy: t.cy,
            r: o[l]
          },
          style: s.getLineStyle(),
          z2: 1,
          silent: !0
        }) : new r.Ring({
          shape: {
            cx: t.cx,
            cy: t.cy,
            r: o[l],
            r0: o[u]
          },
          style: s.getLineStyle(),
          z2: 1,
          silent: !0
        })).style.fill = null, this.group.add(a);
      },
      _axisTick: function _axisTick(e, t, n, o, a) {
        var s = e.getModel("axisTick"),
            l = (s.get("inside") ? -1 : 1) * s.get("length"),
            h = a[c(t)],
            d = i.map(n, function (e) {
          return new r.Line({
            shape: u(t, [h, h + l], e.coord)
          });
        });
        this.group.add(r.mergePath(d, {
          style: i.defaults(s.getModel("lineStyle").getLineStyle(), {
            stroke: e.get("axisLine.lineStyle.color")
          })
        }));
      },
      _minorTick: function _minorTick(e, t, n, o, a) {
        if (o.length) {
          for (var s = e.getModel("axisTick"), l = e.getModel("minorTick"), h = (s.get("inside") ? -1 : 1) * l.get("length"), d = a[c(t)], f = [], p = 0; p < o.length; p++) {
            for (var g = 0; g < o[p].length; g++) {
              f.push(new r.Line({
                shape: u(t, [d, d + h], o[p][g].coord)
              }));
            }
          }

          this.group.add(r.mergePath(f, {
            style: i.defaults(l.getModel("lineStyle").getLineStyle(), i.defaults(s.getLineStyle(), {
              stroke: e.get("axisLine.lineStyle.color")
            }))
          }));
        }
      },
      _axisLabel: function _axisLabel(e, t, n, a, l, u) {
        var h = e.getCategories(!0),
            d = e.getModel("axisLabel"),
            f = d.get("margin"),
            p = e.get("triggerEvent");
        i.each(u, function (n, i) {
          var a = d,
              u = n.tickValue,
              g = l[c(t)],
              v = t.coordToPoint([g + f, n.coord]),
              m = t.cx,
              y = t.cy,
              x = Math.abs(v[0] - m) / g < .3 ? "center" : v[0] > m ? "left" : "right",
              _ = Math.abs(v[1] - y) / g < .3 ? "middle" : v[1] > y ? "top" : "bottom";

          h && h[u] && h[u].textStyle && (a = new o(h[u].textStyle, d, d.ecModel));
          var b = new r.Text({
            silent: s.isLabelSilent(e)
          });
          this.group.add(b), r.setTextStyle(b.style, a, {
            x: v[0],
            y: v[1],
            textFill: a.getTextColor() || e.get("axisLine.lineStyle.color"),
            text: n.formattedLabel,
            textAlign: x,
            textVerticalAlign: _
          }), p && (b.eventData = s.makeAxisEventDataBase(e), b.eventData.targetType = "axisLabel", b.eventData.value = n.rawLabel);
        }, this);
      },
      _splitLine: function _splitLine(e, t, n, o, a) {
        var s = e.getModel("splitLine").getModel("lineStyle"),
            l = s.get("color"),
            c = 0;
        l = l instanceof Array ? l : [l];

        for (var h = [], d = 0; d < n.length; d++) {
          var f = c++ % l.length;
          h[f] = h[f] || [], h[f].push(new r.Line({
            shape: u(t, a, n[d].coord)
          }));
        }

        for (d = 0; d < h.length; d++) {
          this.group.add(r.mergePath(h[d], {
            style: i.defaults({
              stroke: l[d % l.length]
            }, s.getLineStyle()),
            silent: !0,
            z: e.get("z")
          }));
        }
      },
      _minorSplitLine: function _minorSplitLine(e, t, n, i, o) {
        if (i.length) {
          for (var a = e.getModel("minorSplitLine").getModel("lineStyle"), s = [], l = 0; l < i.length; l++) {
            for (var c = 0; c < i[l].length; c++) {
              s.push(new r.Line({
                shape: u(t, o, i[l][c].coord)
              }));
            }
          }

          this.group.add(r.mergePath(s, {
            style: a.getLineStyle(),
            silent: !0,
            z: e.get("z")
          }));
        }
      },
      _splitArea: function _splitArea(e, t, n, o, a) {
        if (n.length) {
          var s = e.getModel("splitArea").getModel("areaStyle"),
              l = s.get("color"),
              u = 0;
          l = l instanceof Array ? l : [l];

          for (var c = [], h = Math.PI / 180, d = -n[0].coord * h, f = Math.min(a[0], a[1]), p = Math.max(a[0], a[1]), g = e.get("clockwise"), v = 1; v < n.length; v++) {
            var m = u++ % l.length;
            c[m] = c[m] || [], c[m].push(new r.Sector({
              shape: {
                cx: t.cx,
                cy: t.cy,
                r0: f,
                r: p,
                startAngle: d,
                endAngle: -n[v].coord * h,
                clockwise: g
              },
              silent: !0
            })), d = -n[v].coord * h;
          }

          for (v = 0; v < c.length; v++) {
            this.group.add(r.mergePath(c[v], {
              style: i.defaults({
                fill: l[v % l.length]
              }, s.getAreaStyle()),
              silent: !0
            }));
          }
        }
      }
    });
    e.exports = d;
  }, function (e, t, n) {
    n(226), n(860);
  }, function (e, t, n) {
    var i = n(1),
        r = n(5),
        o = n(70),
        a = n(89),
        s = ["axisLine", "axisTickLabel", "axisName"],
        l = ["splitLine", "splitArea", "minorSplitLine"],
        u = a.extend({
      type: "radiusAxis",
      axisPointerClass: "PolarAxisPointer",
      render: function render(e, t) {
        if (this.group.removeAll(), e.get("show")) {
          var n = e.axis,
              r = n.polar,
              a = r.getAngleAxis(),
              u = n.getTicksCoords(),
              c = n.getMinorTicksCoords(),
              h = a.getExtent()[0],
              d = n.getExtent(),
              f = function (e, t, n) {
            return {
              position: [e.cx, e.cy],
              rotation: n / 180 * Math.PI,
              labelDirection: -1,
              tickDirection: -1,
              nameDirection: 1,
              labelRotate: t.getModel("axisLabel").get("rotate"),
              z2: 1
            };
          }(r, e, h),
              p = new o(e, f);

          i.each(s, p.add, p), this.group.add(p.getGroup()), i.each(l, function (t) {
            e.get(t + ".show") && !n.scale.isBlank() && this["_" + t](e, r, h, d, u, c);
          }, this);
        }
      },
      _splitLine: function _splitLine(e, t, n, o, a) {
        var s = e.getModel("splitLine").getModel("lineStyle"),
            l = s.get("color"),
            u = 0;
        l = l instanceof Array ? l : [l];

        for (var c = [], h = 0; h < a.length; h++) {
          var d = u++ % l.length;
          c[d] = c[d] || [], c[d].push(new r.Circle({
            shape: {
              cx: t.cx,
              cy: t.cy,
              r: a[h].coord
            }
          }));
        }

        for (h = 0; h < c.length; h++) {
          this.group.add(r.mergePath(c[h], {
            style: i.defaults({
              stroke: l[h % l.length],
              fill: null
            }, s.getLineStyle()),
            silent: !0
          }));
        }
      },
      _minorSplitLine: function _minorSplitLine(e, t, n, o, a, s) {
        if (s.length) {
          for (var l = e.getModel("minorSplitLine").getModel("lineStyle"), u = [], c = 0; c < s.length; c++) {
            for (var h = 0; h < s[c].length; h++) {
              u.push(new r.Circle({
                shape: {
                  cx: t.cx,
                  cy: t.cy,
                  r: s[c][h].coord
                }
              }));
            }
          }

          this.group.add(r.mergePath(u, {
            style: i.defaults({
              fill: null
            }, l.getLineStyle()),
            silent: !0
          }));
        }
      },
      _splitArea: function _splitArea(e, t, n, o, a) {
        if (a.length) {
          var s = e.getModel("splitArea").getModel("areaStyle"),
              l = s.get("color"),
              u = 0;
          l = l instanceof Array ? l : [l];

          for (var c = [], h = a[0].coord, d = 1; d < a.length; d++) {
            var f = u++ % l.length;
            c[f] = c[f] || [], c[f].push(new r.Sector({
              shape: {
                cx: t.cx,
                cy: t.cy,
                r0: h,
                r: a[d].coord,
                startAngle: 0,
                endAngle: 2 * Math.PI
              },
              silent: !0
            })), h = a[d].coord;
          }

          for (d = 0; d < c.length; d++) {
            this.group.add(r.mergePath(c[d], {
              style: i.defaults({
                fill: l[d % l.length]
              }, s.getAreaStyle()),
              silent: !0
            }));
          }
        }
      }
    });
    e.exports = u;
  }, function (e, t, n) {
    var i = n(15),
        r = n(225),
        o = n(5),
        a = n(168),
        s = n(31),
        l = n(70),
        u = n(89),
        c = r.extend({
      makeElOption: function makeElOption(e, t, n, r, u) {
        var c = n.axis;
        "angle" === c.dim && (this.animationThreshold = Math.PI / 18);
        var d,
            f = c.polar,
            p = f.getOtherAxis(c).getExtent();
        d = c["dataTo" + i.capitalFirst(c.dim)](t);
        var g = r.get("type");

        if (g && "none" !== g) {
          var v = a.buildElStyle(r),
              m = h[g](c, f, d, p, v);
          m.style = v, e.graphicKey = m.type, e.pointer = m;
        }

        var y = function (e, t, n, i, r) {
          var a = t.axis,
              u = a.dataToCoord(e),
              c = i.getAngleAxis().getExtent()[0];
          c = c / 180 * Math.PI;
          var h,
              d,
              f,
              p = i.getRadiusAxis().getExtent();

          if ("radius" === a.dim) {
            var g = s.create();
            s.rotate(g, g, c), s.translate(g, g, [i.cx, i.cy]), h = o.applyTransform([u, -r], g);
            var v = t.getModel("axisLabel").get("rotate") || 0,
                m = l.innerTextLayout(c, v * Math.PI / 180, -1);
            d = m.textAlign, f = m.textVerticalAlign;
          } else {
            var y = p[1];
            h = i.coordToPoint([y + r, u]);
            var x = i.cx,
                _ = i.cy;
            d = Math.abs(h[0] - x) / y < .3 ? "center" : h[0] > x ? "left" : "right", f = Math.abs(h[1] - _) / y < .3 ? "middle" : h[1] > _ ? "top" : "bottom";
          }

          return {
            position: h,
            align: d,
            verticalAlign: f
          };
        }(t, n, 0, f, r.get("label.margin"));

        a.buildLabelElOption(e, n, r, u, y);
      }
    });
    var h = {
      line: function line(e, t, n, i, r) {
        return "angle" === e.dim ? {
          type: "Line",
          shape: a.makeLineShape(t.coordToPoint([i[0], n]), t.coordToPoint([i[1], n]))
        } : {
          type: "Circle",
          shape: {
            cx: t.cx,
            cy: t.cy,
            r: n
          }
        };
      },
      shadow: function shadow(e, t, n, i, r) {
        var o = Math.max(1, e.getBandWidth()),
            s = Math.PI / 180;
        return "angle" === e.dim ? {
          type: "Sector",
          shape: a.makeSectorShape(t.cx, t.cy, i[0], i[1], (-n - o / 2) * s, (o / 2 - n) * s)
        } : {
          type: "Sector",
          shape: a.makeSectorShape(t.cx, t.cy, n - o / 2, n + o / 2, 0, 2 * Math.PI)
        };
      }
    };
    u.registerAxisPointerClass("PolarAxisPointer", c);
    var d = c;
    e.exports = d;
  }, function (e, t, n) {
    var i = n(4),
        r = n(1);

    function o(e, t) {
      t.update = "updateView", i.registerAction(t, function (t, n) {
        var i = {};
        return n.eachComponent({
          mainType: "geo",
          query: t
        }, function (n) {
          n[e](t.name);
          var o = n.coordinateSystem;
          r.each(o.regions, function (e) {
            i[e.name] = n.isSelected(e.name) || !1;
          });
        }), {
          selected: i,
          name: t.name
        };
      });
    }

    n(863), n(218), n(864), n(330), o("toggleSelected", {
      type: "geoToggleSelect",
      event: "geoselectchanged"
    }), o("select", {
      type: "geoSelect",
      event: "geoselected"
    }), o("unSelect", {
      type: "geoUnSelect",
      event: "geounselected"
    });
  }, function (e, t, n) {
    var i = n(1),
        r = n(8),
        o = n(26),
        a = n(22),
        s = n(215),
        l = n(218),
        u = o.extend({
      type: "geo",
      coordinateSystem: null,
      layoutMode: "box",
      init: function init(e) {
        o.prototype.init.apply(this, arguments), r.defaultEmphasis(e, "label", ["show"]);
      },
      optionUpdated: function optionUpdated() {
        var e = this.option,
            t = this;
        e.regions = l.getFilledRegions(e.regions, e.map, e.nameMap), this._optionModelMap = i.reduce(e.regions || [], function (e, n) {
          return n.name && e.set(n.name, new a(n, t)), e;
        }, i.createHashMap()), this.updateSelectedMap(e.regions);
      },
      defaultOption: {
        zlevel: 0,
        z: 0,
        show: !0,
        left: "center",
        top: "center",
        aspectScale: null,
        silent: !1,
        map: "",
        boundingCoords: null,
        center: null,
        zoom: 1,
        scaleLimit: null,
        label: {
          show: !1,
          color: "#000"
        },
        itemStyle: {
          borderWidth: .5,
          borderColor: "#444",
          color: "#eee"
        },
        emphasis: {
          label: {
            show: !0,
            color: "rgb(100,0,0)"
          },
          itemStyle: {
            color: "rgba(255,215,0,0.8)"
          }
        },
        regions: []
      },
      getRegionModel: function getRegionModel(e) {
        return this._optionModelMap.get(e) || new a(null, this, this.ecModel);
      },
      getFormattedLabel: function getFormattedLabel(e, t) {
        var n = this.getRegionModel(e).get("label" + ("normal" === t ? "." : t + ".") + "formatter"),
            i = {
          name: e
        };
        return "function" == typeof n ? (i.status = t, n(i)) : "string" == typeof n ? n.replace("{a}", null != e ? e : "") : void 0;
      },
      setZoom: function setZoom(e) {
        this.option.zoom = e;
      },
      setCenter: function setCenter(e) {
        this.option.center = e;
      }
    });
    i.mixin(u, s);
    var c = u;
    e.exports = c;
  }, function (e, t, n) {
    var i = n(328),
        r = n(4).extendComponentView({
      type: "geo",
      init: function init(e, t) {
        var n = new i(t, !0);
        this._mapDraw = n, this.group.add(n.group);
      },
      render: function render(e, t, n, i) {
        if (!i || "geoToggleSelect" !== i.type || i.from !== this.uid) {
          var r = this._mapDraw;
          e.get("show") ? r.draw(e, t, n, this, i) : this._mapDraw.group.removeAll(), this.group.silent = e.get("silent");
        }
      },
      dispose: function dispose() {
        this._mapDraw && this._mapDraw.remove();
      }
    });
    e.exports = r;
  }, function (e, t, n) {
    n(866), n(867), n(868);
  }, function (e, t, n) {
    var i = n(1),
        r = n(14),
        o = n(6),
        a = n(42);

    function s(e, t, n) {
      this._model = e;
    }

    function l(e, t, n, i) {
      var r = n.calendarModel,
          o = n.seriesModel,
          a = r ? r.coordinateSystem : o ? o.coordinateSystem : null;
      return a === this ? a[e](i) : null;
    }

    s.prototype = {
      constructor: s,
      type: "calendar",
      dimensions: ["time", "value"],
      getDimensionsInfo: function getDimensionsInfo() {
        return [{
          name: "time",
          type: "time"
        }, "value"];
      },
      getRangeInfo: function getRangeInfo() {
        return this._rangeInfo;
      },
      getModel: function getModel() {
        return this._model;
      },
      getRect: function getRect() {
        return this._rect;
      },
      getCellWidth: function getCellWidth() {
        return this._sw;
      },
      getCellHeight: function getCellHeight() {
        return this._sh;
      },
      getOrient: function getOrient() {
        return this._orient;
      },
      getFirstDayOfWeek: function getFirstDayOfWeek() {
        return this._firstDayOfWeek;
      },
      getDateInfo: function getDateInfo(e) {
        var t = (e = o.parseDate(e)).getFullYear(),
            n = e.getMonth() + 1;
        n = n < 10 ? "0" + n : n;
        var i = e.getDate();
        i = i < 10 ? "0" + i : i;
        var r = e.getDay();
        return {
          y: t,
          m: n,
          d: i,
          day: r = Math.abs((r + 7 - this.getFirstDayOfWeek()) % 7),
          time: e.getTime(),
          formatedDate: t + "-" + n + "-" + i,
          date: e
        };
      },
      getNextNDay: function getNextNDay(e, t) {
        return 0 === (t = t || 0) || (e = new Date(this.getDateInfo(e).time)).setDate(e.getDate() + t), this.getDateInfo(e);
      },
      update: function update(e, t) {
        this._firstDayOfWeek = +this._model.getModel("dayLabel").get("firstDay"), this._orient = this._model.get("orient"), this._lineWidth = this._model.getModel("itemStyle").getItemStyle().lineWidth || 0, this._rangeInfo = this._getRangeInfo(this._initRangeOption());

        var n = this._rangeInfo.weeks || 1,
            o = ["width", "height"],
            a = this._model.get("cellSize").slice(),
            s = this._model.getBoxLayoutParams(),
            l = "horizontal" === this._orient ? [n, 7] : [7, n];

        i.each([0, 1], function (e) {
          h(a, e) && (s[o[e]] = a[e] * l[e]);
        });
        var u = {
          width: t.getWidth(),
          height: t.getHeight()
        },
            c = this._rect = r.getLayoutRect(s, u);

        function h(e, t) {
          return null != e[t] && "auto" !== e[t];
        }

        i.each([0, 1], function (e) {
          h(a, e) || (a[e] = c[o[e]] / l[e]);
        }), this._sw = a[0], this._sh = a[1];
      },
      dataToPoint: function dataToPoint(e, t) {
        i.isArray(e) && (e = e[0]), null == t && (t = !0);
        var n = this.getDateInfo(e),
            r = this._rangeInfo,
            o = n.formatedDate;
        if (t && !(n.time >= r.start.time && n.time < r.end.time + 864e5)) return [NaN, NaN];

        var a = n.day,
            s = this._getRangeInfo([r.start.time, o]).nthWeek;

        return "vertical" === this._orient ? [this._rect.x + a * this._sw + this._sw / 2, this._rect.y + s * this._sh + this._sh / 2] : [this._rect.x + s * this._sw + this._sw / 2, this._rect.y + a * this._sh + this._sh / 2];
      },
      pointToData: function pointToData(e) {
        var t = this.pointToDate(e);
        return t && t.time;
      },
      dataToRect: function dataToRect(e, t) {
        var n = this.dataToPoint(e, t);
        return {
          contentShape: {
            x: n[0] - (this._sw - this._lineWidth) / 2,
            y: n[1] - (this._sh - this._lineWidth) / 2,
            width: this._sw - this._lineWidth,
            height: this._sh - this._lineWidth
          },
          center: n,
          tl: [n[0] - this._sw / 2, n[1] - this._sh / 2],
          tr: [n[0] + this._sw / 2, n[1] - this._sh / 2],
          br: [n[0] + this._sw / 2, n[1] + this._sh / 2],
          bl: [n[0] - this._sw / 2, n[1] + this._sh / 2]
        };
      },
      pointToDate: function pointToDate(e) {
        var t = Math.floor((e[0] - this._rect.x) / this._sw) + 1,
            n = Math.floor((e[1] - this._rect.y) / this._sh) + 1,
            i = this._rangeInfo.range;
        return "vertical" === this._orient ? this._getDateByWeeksAndDay(n, t - 1, i) : this._getDateByWeeksAndDay(t, n - 1, i);
      },
      convertToPixel: i.curry(l, "dataToPoint"),
      convertFromPixel: i.curry(l, "pointToData"),
      _initRangeOption: function _initRangeOption() {
        var e = this._model.get("range"),
            t = e;

        if (i.isArray(t) && 1 === t.length && (t = t[0]), /^\d{4}$/.test(t) && (e = [t + "-01-01", t + "-12-31"]), /^\d{4}[\/|-]\d{1,2}$/.test(t)) {
          var n = this.getDateInfo(t),
              r = n.date;
          r.setMonth(r.getMonth() + 1);
          var o = this.getNextNDay(r, -1);
          e = [n.formatedDate, o.formatedDate];
        }

        /^\d{4}[\/|-]\d{1,2}[\/|-]\d{1,2}$/.test(t) && (e = [t, t]);

        var a = this._getRangeInfo(e);

        return a.start.time > a.end.time && e.reverse(), e;
      },
      _getRangeInfo: function _getRangeInfo(e) {
        var t;
        (e = [this.getDateInfo(e[0]), this.getDateInfo(e[1])])[0].time > e[1].time && (t = !0, e.reverse());
        var n = Math.floor(e[1].time / 864e5) - Math.floor(e[0].time / 864e5) + 1,
            i = new Date(e[0].time),
            r = i.getDate(),
            o = e[1].date.getDate();
        i.setDate(r + n - 1);
        var a = i.getDate();
        if (a !== o) for (var s = i.getTime() - e[1].time > 0 ? 1 : -1; (a = i.getDate()) !== o && (i.getTime() - e[1].time) * s > 0;) {
          n -= s, i.setDate(a - s);
        }
        var l = Math.floor((n + e[0].day + 6) / 7),
            u = t ? 1 - l : l - 1;
        return t && e.reverse(), {
          range: [e[0].formatedDate, e[1].formatedDate],
          start: e[0],
          end: e[1],
          allDay: n,
          weeks: l,
          nthWeek: u,
          fweek: e[0].day,
          lweek: e[1].day
        };
      },
      _getDateByWeeksAndDay: function _getDateByWeeksAndDay(e, t, n) {
        var i = this._getRangeInfo(n);

        if (e > i.weeks || 0 === e && t < i.fweek || e === i.weeks && t > i.lweek) return !1;
        var r = 7 * (e - 1) - i.fweek + t,
            o = new Date(i.start.time);
        return o.setDate(i.start.d + r), this.getDateInfo(o);
      }
    }, s.dimensions = s.prototype.dimensions, s.getDimensionsInfo = s.prototype.getDimensionsInfo, s.create = function (e, t) {
      var n = [];
      return e.eachComponent("calendar", function (i) {
        var r = new s(i, e, t);
        n.push(r), i.coordinateSystem = r;
      }), e.eachSeries(function (e) {
        "calendar" === e.get("coordinateSystem") && (e.coordinateSystem = n[e.get("calendarIndex") || 0]);
      }), n;
    }, a.register("calendar", s);
    var u = s;
    e.exports = u;
  }, function (e, t, n) {
    var i = n(1),
        r = n(26),
        o = n(14),
        a = o.getLayoutParams,
        s = o.sizeCalculable,
        l = o.mergeLayoutParam,
        u = r.extend({
      type: "calendar",
      coordinateSystem: null,
      defaultOption: {
        zlevel: 0,
        z: 2,
        left: 80,
        top: 60,
        cellSize: 20,
        orient: "horizontal",
        splitLine: {
          show: !0,
          lineStyle: {
            color: "#000",
            width: 1,
            type: "solid"
          }
        },
        itemStyle: {
          color: "#fff",
          borderWidth: 1,
          borderColor: "#ccc"
        },
        dayLabel: {
          show: !0,
          firstDay: 0,
          position: "start",
          margin: "50%",
          nameMap: "en",
          color: "#000"
        },
        monthLabel: {
          show: !0,
          position: "start",
          margin: 5,
          align: "center",
          nameMap: "en",
          formatter: null,
          color: "#000"
        },
        yearLabel: {
          show: !0,
          position: null,
          margin: 30,
          formatter: null,
          color: "#ccc",
          fontFamily: "sans-serif",
          fontWeight: "bolder",
          fontSize: 20
        }
      },
      init: function init(e, t, n, i) {
        var r = a(e);
        u.superApply(this, "init", arguments), c(e, r);
      },
      mergeOption: function mergeOption(e, t) {
        u.superApply(this, "mergeOption", arguments), c(this.option, e);
      }
    });

    function c(e, t) {
      var n = e.cellSize;
      i.isArray(n) ? 1 === n.length && (n[1] = n[0]) : n = e.cellSize = [n, n];
      var r = i.map([0, 1], function (e) {
        return s(t, e) && (n[e] = "auto"), null != n[e] && "auto" !== n[e];
      });
      l(e, t, {
        type: "box",
        ignoreSize: r
      });
    }

    var h = u;
    e.exports = h;
  }, function (e, t, n) {
    var i = n(4),
        r = n(1),
        o = n(5),
        a = n(15),
        s = n(6),
        l = {
      EN: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
      CN: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"]
    },
        u = {
      EN: ["S", "M", "T", "W", "T", "F", "S"],
      CN: ["日", "一", "二", "三", "四", "五", "六"]
    },
        c = i.extendComponentView({
      type: "calendar",
      _tlpoints: null,
      _blpoints: null,
      _firstDayOfMonth: null,
      _firstDayPoints: null,
      render: function render(e, t, n) {
        var i = this.group;
        i.removeAll();
        var r = e.coordinateSystem,
            o = r.getRangeInfo(),
            a = r.getOrient();
        this._renderDayRect(e, o, i), this._renderLines(e, o, a, i), this._renderYearText(e, o, a, i), this._renderMonthText(e, a, i), this._renderWeekText(e, o, a, i);
      },
      _renderDayRect: function _renderDayRect(e, t, n) {
        for (var i = e.coordinateSystem, r = e.getModel("itemStyle").getItemStyle(), a = i.getCellWidth(), s = i.getCellHeight(), l = t.start.time; l <= t.end.time; l = i.getNextNDay(l, 1).time) {
          var u = i.dataToRect([l], !1).tl,
              c = new o.Rect({
            shape: {
              x: u[0],
              y: u[1],
              width: a,
              height: s
            },
            cursor: "default",
            style: r
          });
          n.add(c);
        }
      },
      _renderLines: function _renderLines(e, t, n, i) {
        var r = this,
            o = e.coordinateSystem,
            a = e.getModel("splitLine.lineStyle").getLineStyle(),
            s = e.get("splitLine.show"),
            l = a.lineWidth;
        this._tlpoints = [], this._blpoints = [], this._firstDayOfMonth = [], this._firstDayPoints = [];

        for (var u = t.start, c = 0; u.time <= t.end.time; c++) {
          d(u.formatedDate), 0 === c && (u = o.getDateInfo(t.start.y + "-" + t.start.m));
          var h = u.date;
          h.setMonth(h.getMonth() + 1), u = o.getDateInfo(h);
        }

        function d(t) {
          r._firstDayOfMonth.push(o.getDateInfo(t)), r._firstDayPoints.push(o.dataToRect([t], !1).tl);

          var l = r._getLinePointsOfOneWeek(e, t, n);

          r._tlpoints.push(l[0]), r._blpoints.push(l[l.length - 1]), s && r._drawSplitline(l, a, i);
        }

        d(o.getNextNDay(t.end.time, 1).formatedDate), s && this._drawSplitline(r._getEdgesPoints(r._tlpoints, l, n), a, i), s && this._drawSplitline(r._getEdgesPoints(r._blpoints, l, n), a, i);
      },
      _getEdgesPoints: function _getEdgesPoints(e, t, n) {
        var i = [e[0].slice(), e[e.length - 1].slice()],
            r = "horizontal" === n ? 0 : 1;
        return i[0][r] = i[0][r] - t / 2, i[1][r] = i[1][r] + t / 2, i;
      },
      _drawSplitline: function _drawSplitline(e, t, n) {
        var i = new o.Polyline({
          z2: 20,
          shape: {
            points: e
          },
          style: t
        });
        n.add(i);
      },
      _getLinePointsOfOneWeek: function _getLinePointsOfOneWeek(e, t, n) {
        var i = e.coordinateSystem;
        t = i.getDateInfo(t);

        for (var r = [], o = 0; o < 7; o++) {
          var a = i.getNextNDay(t.time, o),
              s = i.dataToRect([a.time], !1);
          r[2 * a.day] = s.tl, r[2 * a.day + 1] = s["horizontal" === n ? "bl" : "tr"];
        }

        return r;
      },
      _formatterLabel: function _formatterLabel(e, t) {
        return "string" == typeof e && e ? a.formatTplSimple(e, t) : "function" == typeof e ? e(t) : t.nameMap;
      },
      _yearTextPositionControl: function _yearTextPositionControl(e, t, n, i, r) {
        t = t.slice();
        var o = ["center", "bottom"];
        "bottom" === i ? (t[1] += r, o = ["center", "top"]) : "left" === i ? t[0] -= r : "right" === i ? (t[0] += r, o = ["center", "top"]) : t[1] -= r;
        var a = 0;
        return "left" !== i && "right" !== i || (a = Math.PI / 2), {
          rotation: a,
          position: t,
          style: {
            textAlign: o[0],
            textVerticalAlign: o[1]
          }
        };
      },
      _renderYearText: function _renderYearText(e, t, n, i) {
        var r = e.getModel("yearLabel");

        if (r.get("show")) {
          var a = r.get("margin"),
              s = r.get("position");
          s || (s = "horizontal" !== n ? "top" : "left");
          var l = [this._tlpoints[this._tlpoints.length - 1], this._blpoints[0]],
              u = (l[0][0] + l[1][0]) / 2,
              c = (l[0][1] + l[1][1]) / 2,
              h = "horizontal" === n ? 0 : 1,
              d = {
            top: [u, l[h][1]],
            bottom: [u, l[1 - h][1]],
            left: [l[1 - h][0], c],
            right: [l[h][0], c]
          },
              f = t.start.y;
          +t.end.y > +t.start.y && (f = f + "-" + t.end.y);

          var p = r.get("formatter"),
              g = {
            start: t.start.y,
            end: t.end.y,
            nameMap: f
          },
              v = this._formatterLabel(p, g),
              m = new o.Text({
            z2: 30
          });

          o.setTextStyle(m.style, r, {
            text: v
          }), m.attr(this._yearTextPositionControl(m, d[s], n, s, a)), i.add(m);
        }
      },
      _monthTextPositionControl: function _monthTextPositionControl(e, t, n, i, r) {
        var o = "left",
            a = "top",
            s = e[0],
            l = e[1];
        return "horizontal" === n ? (l += r, t && (o = "center"), "start" === i && (a = "bottom")) : (s += r, t && (a = "middle"), "start" === i && (o = "right")), {
          x: s,
          y: l,
          textAlign: o,
          textVerticalAlign: a
        };
      },
      _renderMonthText: function _renderMonthText(e, t, n) {
        var i = e.getModel("monthLabel");

        if (i.get("show")) {
          var a = i.get("nameMap"),
              s = i.get("margin"),
              u = i.get("position"),
              c = i.get("align"),
              h = [this._tlpoints, this._blpoints];
          r.isString(a) && (a = l[a.toUpperCase()] || []);
          var d = "start" === u ? 0 : 1,
              f = "horizontal" === t ? 0 : 1;
          s = "start" === u ? -s : s;

          for (var p = "center" === c, g = 0; g < h[d].length - 1; g++) {
            var v = h[d][g].slice(),
                m = this._firstDayOfMonth[g];

            if (p) {
              var y = this._firstDayPoints[g];
              v[f] = (y[f] + h[0][g + 1][f]) / 2;
            }

            var x = i.get("formatter"),
                _ = a[+m.m - 1],
                b = {
              yyyy: m.y,
              yy: (m.y + "").slice(2),
              MM: m.m,
              M: +m.m,
              nameMap: _
            },
                w = this._formatterLabel(x, b),
                S = new o.Text({
              z2: 30
            });

            r.extend(o.setTextStyle(S.style, i, {
              text: w
            }), this._monthTextPositionControl(v, p, t, u, s)), n.add(S);
          }
        }
      },
      _weekTextPositionControl: function _weekTextPositionControl(e, t, n, i, r) {
        var o = "center",
            a = "middle",
            s = e[0],
            l = e[1],
            u = "start" === n;
        return "horizontal" === t ? (s = s + i + (u ? 1 : -1) * r[0] / 2, o = u ? "right" : "left") : (l = l + i + (u ? 1 : -1) * r[1] / 2, a = u ? "bottom" : "top"), {
          x: s,
          y: l,
          textAlign: o,
          textVerticalAlign: a
        };
      },
      _renderWeekText: function _renderWeekText(e, t, n, i) {
        var a = e.getModel("dayLabel");

        if (a.get("show")) {
          var l = e.coordinateSystem,
              c = a.get("position"),
              h = a.get("nameMap"),
              d = a.get("margin"),
              f = l.getFirstDayOfWeek();
          r.isString(h) && (h = u[h.toUpperCase()] || []);
          var p = l.getNextNDay(t.end.time, 7 - t.lweek).time,
              g = [l.getCellWidth(), l.getCellHeight()];
          d = s.parsePercent(d, g["horizontal" === n ? 0 : 1]), "start" === c && (p = l.getNextNDay(t.start.time, -(7 + t.fweek)).time, d = -d);

          for (var v = 0; v < 7; v++) {
            var m,
                y = l.getNextNDay(p, v),
                x = l.dataToRect([y.time], !1).center;
            m = Math.abs((v + f) % 7);

            var _ = new o.Text({
              z2: 30
            });

            r.extend(o.setTextStyle(_.style, a, {
              text: h[m]
            }), this._weekTextPositionControl(x, n, c, d, g)), i.add(_);
          }
        }
      }
    });
    e.exports = c;
  }, function (e, t, n) {
    n(9).__DEV__;
    var i = n(4),
        r = n(1),
        o = n(8),
        a = n(5),
        s = n(14),
        l = n(6).parsePercent,
        u = {
      path: null,
      compoundPath: null,
      group: a.Group,
      image: a.Image,
      text: a.Text
    };
    i.registerPreprocessor(function (e) {
      var t = e.graphic;
      r.isArray(t) ? t[0] && t[0].elements ? e.graphic = [e.graphic[0]] : e.graphic = [{
        elements: t
      }] : t && !t.elements && (e.graphic = [{
        elements: [t]
      }]);
    });
    var c = i.extendComponentModel({
      type: "graphic",
      defaultOption: {
        elements: [],
        parentId: null
      },
      _elOptionsToUpdate: null,
      mergeOption: function mergeOption(e) {
        var t = this.option.elements;
        this.option.elements = null, c.superApply(this, "mergeOption", arguments), this.option.elements = t;
      },
      optionUpdated: function optionUpdated(e, t) {
        var n = this.option,
            i = (t ? n : e).elements,
            a = n.elements = t ? [] : n.elements,
            l = [];

        this._flatten(i, l);

        var u = o.mappingToExists(a, l);
        o.makeIdAndName(u);
        var c = this._elOptionsToUpdate = [];
        r.each(u, function (e, t) {
          var n = e.option;
          n && (c.push(n), function (e, t) {
            var n = e.exist;

            if (t.id = e.keyInfo.id, !t.type && n && (t.type = n.type), null == t.parentId) {
              var i = t.parentOption;
              i ? t.parentId = i.id : n && (t.parentId = n.parentId);
            }

            t.parentOption = null;
          }(e, n), function (e, t, n) {
            var i = r.extend({}, n),
                o = e[t],
                a = n.$action || "merge";
            "merge" === a ? o ? (r.merge(o, i, !0), s.mergeLayoutParam(o, i, {
              ignoreSize: !0
            }), s.copyLayoutParams(n, o)) : e[t] = i : "replace" === a ? e[t] = i : "remove" === a && o && (e[t] = null);
          }(a, t, n), function (e, t) {
            if (!e) return;
            e.hv = t.hv = [f(t, ["left", "right"]), f(t, ["top", "bottom"])], "group" === e.type && (null == e.width && (e.width = t.width = 0), null == e.height && (e.height = t.height = 0));
          }(a[t], n));
        }, this);

        for (var h = a.length - 1; h >= 0; h--) {
          null == a[h] ? a.splice(h, 1) : delete a[h].$action;
        }
      },
      _flatten: function _flatten(e, t, n) {
        r.each(e, function (e) {
          if (e) {
            n && (e.parentOption = n), t.push(e);
            var i = e.children;
            "group" === e.type && i && this._flatten(i, t, e), delete e.children;
          }
        }, this);
      },
      useElOptionsToUpdate: function useElOptionsToUpdate() {
        var e = this._elOptionsToUpdate;
        return this._elOptionsToUpdate = null, e;
      }
    });

    function h(e, t, n, i) {
      var r = n.type,
          o = new (u.hasOwnProperty(r) ? u[r] : a.getShapeClass(r))(n);
      t.add(o), i.set(e, o), o.__ecGraphicId = e;
    }

    function d(e, t) {
      var n = e && e.parent;
      n && ("group" === e.type && e.traverse(function (e) {
        d(e, t);
      }), t.removeKey(e.__ecGraphicId), n.remove(e));
    }

    function f(e, t) {
      var n;
      return r.each(t, function (t) {
        null != e[t] && "auto" !== e[t] && (n = !0);
      }), n;
    }

    i.extendComponentView({
      type: "graphic",
      init: function init(e, t) {
        this._elMap = r.createHashMap(), this._lastGraphicModel;
      },
      render: function render(e, t, n) {
        e !== this._lastGraphicModel && this._clear(), this._lastGraphicModel = e, this._updateElements(e), this._relocate(e, n);
      },
      _updateElements: function _updateElements(e) {
        var t = e.useElOptionsToUpdate();

        if (t) {
          var n = this._elMap,
              i = this.group;
          r.each(t, function (t) {
            var o = t.$action,
                a = t.id,
                l = n.get(a),
                u = t.parentId,
                c = null != u ? n.get(u) : i,
                f = t.style;
            "text" === t.type && f && (t.hv && t.hv[1] && (f.textVerticalAlign = f.textBaseline = null), !f.hasOwnProperty("textFill") && f.fill && (f.textFill = f.fill), !f.hasOwnProperty("textStroke") && f.stroke && (f.textStroke = f.stroke));

            var p = function (e) {
              return e = r.extend({}, e), r.each(["id", "parentId", "$action", "hv", "bounding"].concat(s.LOCATION_PARAMS), function (t) {
                delete e[t];
              }), e;
            }(t);

            o && "merge" !== o ? "replace" === o ? (d(l, n), h(a, c, p, n)) : "remove" === o && d(l, n) : l ? l.attr(p) : h(a, c, p, n);
            var g = n.get(a);
            g && (g.__ecGraphicWidthOption = t.width, g.__ecGraphicHeightOption = t.height, function (e, t, n) {
              var i = e.eventData;
              e.silent || e.ignore || i || (i = e.eventData = {
                componentType: "graphic",
                componentIndex: t.componentIndex,
                name: e.name
              });
              i && (i.info = e.info);
            }(g, e));
          });
        }
      },
      _relocate: function _relocate(e, t) {
        for (var n = e.option.elements, i = this.group, r = this._elMap, o = t.getWidth(), a = t.getHeight(), u = 0; u < n.length; u++) {
          var c = n[u];

          if ((d = r.get(c.id)) && d.isGroup) {
            var h = (f = d.parent) === i;
            d.__ecGraphicWidth = l(d.__ecGraphicWidthOption, h ? o : f.__ecGraphicWidth) || 0, d.__ecGraphicHeight = l(d.__ecGraphicHeightOption, h ? a : f.__ecGraphicHeight) || 0;
          }
        }

        for (u = n.length - 1; u >= 0; u--) {
          var d;
          c = n[u];

          if (d = r.get(c.id)) {
            var f,
                p = (f = d.parent) === i ? {
              width: o,
              height: a
            } : {
              width: f.__ecGraphicWidth,
              height: f.__ecGraphicHeight
            };
            s.positionElement(d, c, p, null, {
              hv: c.hv,
              boundingMode: c.bounding
            });
          }
        }
      },
      _clear: function _clear() {
        var e = this._elMap;
        e.each(function (t) {
          d(t, e);
        }), this._elMap = r.createHashMap();
      },
      dispose: function dispose() {
        this._clear();
      }
    });
  }, function (e, t, n) {
    n(871), n(872), n(873), n(874), n(875), n(876), n(881);
  }, function (e, t, n) {
    var i = n(4),
        r = n(1),
        o = n(71),
        a = i.extendComponentModel({
      type: "toolbox",
      layoutMode: {
        type: "box",
        ignoreSize: !0
      },
      optionUpdated: function optionUpdated() {
        a.superApply(this, "optionUpdated", arguments), r.each(this.option.feature, function (e, t) {
          var n = o.get(t);
          n && r.merge(e, n.defaultOption);
        });
      },
      defaultOption: {
        show: !0,
        z: 6,
        zlevel: 0,
        orient: "horizontal",
        left: "right",
        top: "top",
        backgroundColor: "transparent",
        borderColor: "#ccc",
        borderRadius: 0,
        borderWidth: 0,
        padding: 5,
        itemSize: 15,
        itemGap: 8,
        showTitle: !0,
        iconStyle: {
          borderColor: "#666",
          color: "none"
        },
        emphasis: {
          iconStyle: {
            borderColor: "#3E98C5"
          }
        },
        tooltip: {
          show: !1
        }
      }
    }),
        s = a;
    e.exports = s;
  }, function (e, t, n) {
    var i = n(4),
        r = n(1),
        o = n(35),
        a = n(71),
        s = n(5),
        l = n(22),
        u = n(87),
        c = n(349),
        h = i.extendComponentView({
      type: "toolbox",
      render: function render(e, t, n, i) {
        var h = this.group;

        if (h.removeAll(), e.get("show")) {
          var d = +e.get("itemSize"),
              f = e.get("feature") || {},
              p = this._features || (this._features = {}),
              g = [];
          r.each(f, function (e, t) {
            g.push(t);
          }), new u(this._featureNames || [], g).add(v).update(v).remove(r.curry(v, null)).execute(), this._featureNames = g, c.layout(h, e, n), h.add(c.makeBackground(h.getBoundingRect(), e)), h.eachChild(function (e) {
            var t = e.__title,
                i = e.hoverStyle;

            if (i && t) {
              var r = o.getBoundingRect(t, o.makeFont(i)),
                  a = e.position[0] + h.position[0],
                  s = !1;
              e.position[1] + h.position[1] + d + r.height > n.getHeight() && (i.textPosition = "top", s = !0);
              var l = s ? -5 - r.height : d + 8;
              a + r.width / 2 > n.getWidth() ? (i.textPosition = ["100%", l], i.textAlign = "right") : a - r.width / 2 < 0 && (i.textPosition = [0, l], i.textAlign = "left");
            }
          });
        }

        function v(o, u) {
          var c,
              v = g[o],
              m = g[u],
              y = f[v],
              x = new l(y, e, e.ecModel);

          if (i && null != i.newTitle && i.featureName === v && (y.title = i.newTitle), v && !m) {
            if (function (e) {
              return 0 === e.indexOf("my");
            }(v)) c = {
              model: x,
              onclick: x.option.onclick,
              featureName: v
            };else {
              var _ = a.get(v);

              if (!_) return;
              c = new _(x, t, n);
            }
            p[v] = c;
          } else {
            if (!(c = p[m])) return;
            c.model = x, c.ecModel = t, c.api = n;
          }

          v || !m ? x.get("show") && !c.unusable ? (!function (i, o, a) {
            var l = i.getModel("iconStyle"),
                u = i.getModel("emphasis.iconStyle"),
                c = o.getIcons ? o.getIcons() : i.get("icon"),
                f = i.get("title") || {};

            if ("string" == typeof c) {
              var p = c,
                  g = f;
              f = {}, (c = {})[a] = p, f[a] = g;
            }

            var v = i.iconPaths = {};
            r.each(c, function (a, c) {
              var p = s.createIcon(a, {}, {
                x: -d / 2,
                y: -d / 2,
                width: d,
                height: d
              });
              p.setStyle(l.getItemStyle()), p.hoverStyle = u.getItemStyle(), p.setStyle({
                text: f[c],
                textAlign: u.get("textAlign"),
                textBorderRadius: u.get("textBorderRadius"),
                textPadding: u.get("textPadding"),
                textFill: null
              });
              var g = e.getModel("tooltip");
              g && g.get("show") && p.attr("tooltip", r.extend({
                content: f[c],
                formatter: g.get("formatter", !0) || function () {
                  return f[c];
                },
                formatterParams: {
                  componentType: "toolbox",
                  name: c,
                  title: f[c],
                  $vars: ["name", "title"]
                },
                position: g.get("position", !0) || "bottom"
              }, g.option)), s.setHoverStyle(p), e.get("showTitle") && (p.__title = f[c], p.on("mouseover", function () {
                var t = u.getItemStyle(),
                    n = "vertical" === e.get("orient") ? null == e.get("right") ? "right" : "left" : null == e.get("bottom") ? "bottom" : "top";
                p.setStyle({
                  textFill: u.get("textFill") || t.fill || t.stroke || "#000",
                  textBackgroundColor: u.get("textBackgroundColor"),
                  textPosition: u.get("textPosition") || n
                });
              }).on("mouseout", function () {
                p.setStyle({
                  textFill: null,
                  textBackgroundColor: null
                });
              })), p.trigger(i.get("iconStatus." + c) || "normal"), h.add(p), p.on("click", r.bind(o.onclick, o, t, n, c)), v[c] = p;
            });
          }(x, c, v), x.setIconStatus = function (e, t) {
            var n = this.option,
                i = this.iconPaths;
            n.iconStatus = n.iconStatus || {}, n.iconStatus[e] = t, i[e] && i[e].trigger(t);
          }, c.render && c.render(x, t, n, i)) : c.remove && c.remove(t, n) : c.dispose && c.dispose(t, n);
        }
      },
      updateView: function updateView(e, t, n, i) {
        r.each(this._features, function (e) {
          e.updateView && e.updateView(e.model, t, n, i);
        });
      },
      remove: function remove(e, t) {
        r.each(this._features, function (n) {
          n.remove && n.remove(e, t);
        }), this.group.removeAll();
      },
      dispose: function dispose(e, t) {
        r.each(this._features, function (n) {
          n.dispose && n.dispose(e, t);
        });
      }
    });
    e.exports = h;
  }, function (e, t, n) {
    var i = n(21),
        r = n(68),
        o = n(71),
        a = r.toolbox.saveAsImage;

    function s(e) {
      this.model = e;
    }

    s.defaultOption = {
      show: !0,
      icon: "M4.7,22.9L29.3,45.5L54.7,23.4M4.6,43.6L4.6,58L53.8,58L53.8,43.6M29.2,45.1L29.2,0",
      title: a.title,
      type: "png",
      connectedBackgroundColor: "#fff",
      name: "",
      excludeComponents: ["toolbox"],
      pixelRatio: 1,
      lang: a.lang.slice()
    }, s.prototype.unusable = !i.canvasSupported, s.prototype.onclick = function (e, t) {
      var n = this.model,
          r = n.get("name") || e.get("title.0.text") || "echarts",
          o = "svg" === t.getZr().painter.getType() ? "svg" : n.get("type", !0) || "png",
          a = t.getConnectedDataURL({
        type: o,
        backgroundColor: n.get("backgroundColor", !0) || e.get("backgroundColor") || "#fff",
        connectedBackgroundColor: n.get("connectedBackgroundColor"),
        excludeComponents: n.get("excludeComponents"),
        pixelRatio: n.get("pixelRatio")
      });
      if ("function" != typeof MouseEvent || i.browser.ie || i.browser.edge) {
        if (window.navigator.msSaveOrOpenBlob) {
          for (var s = atob(a.split(",")[1]), l = s.length, u = new Uint8Array(l); l--;) {
            u[l] = s.charCodeAt(l);
          }

          var c = new Blob([u]);
          window.navigator.msSaveOrOpenBlob(c, r + "." + o);
        } else {
          var h = n.get("lang"),
              d = '<body style="margin:0;"><img src="' + a + '" style="max-width:100%;" title="' + (h && h[0] || "") + '" /></body>';
          window.open().document.write(d);
        }
      } else {
        var f = document.createElement("a");
        f.download = r + "." + o, f.target = "_blank", f.href = a;
        var p = new MouseEvent("click", {
          view: window,
          bubbles: !0,
          cancelable: !1
        });
        f.dispatchEvent(p);
      }
    }, o.register("saveAsImage", s);
    var l = s;
    e.exports = l;
  }, function (e, t, n) {
    var i = n(4),
        r = n(1),
        o = n(68),
        a = n(71),
        s = o.toolbox.magicType;

    function l(e) {
      this.model = e;
    }

    l.defaultOption = {
      show: !0,
      type: [],
      icon: {
        line: "M4.1,28.9h7.1l9.3-22l7.4,38l9.7-19.7l3,12.8h14.9M4.1,58h51.4",
        bar: "M6.7,22.9h10V48h-10V22.9zM24.9,13h10v35h-10V13zM43.2,2h10v46h-10V2zM3.1,58h53.7",
        stack: "M8.2,38.4l-8.4,4.1l30.6,15.3L60,42.5l-8.1-4.1l-21.5,11L8.2,38.4z M51.9,30l-8.1,4.2l-13.4,6.9l-13.9-6.9L8.2,30l-8.4,4.2l8.4,4.2l22.2,11l21.5-11l8.1-4.2L51.9,30z M51.9,21.7l-8.1,4.2L35.7,30l-5.3,2.8L24.9,30l-8.4-4.1l-8.3-4.2l-8.4,4.2L8.2,30l8.3,4.2l13.9,6.9l13.4-6.9l8.1-4.2l8.1-4.1L51.9,21.7zM30.4,2.2L-0.2,17.5l8.4,4.1l8.3,4.2l8.4,4.2l5.5,2.7l5.3-2.7l8.1-4.2l8.1-4.2l8.1-4.1L30.4,2.2z"
      },
      title: r.clone(s.title),
      option: {},
      seriesIndex: {}
    };
    var u = l.prototype;

    u.getIcons = function () {
      var e = this.model,
          t = e.get("icon"),
          n = {};
      return r.each(e.get("type"), function (e) {
        t[e] && (n[e] = t[e]);
      }), n;
    };

    var c = {
      line: function line(e, t, n, i) {
        if ("bar" === e) return r.merge({
          id: t,
          type: "line",
          data: n.get("data"),
          stack: n.get("stack"),
          markPoint: n.get("markPoint"),
          markLine: n.get("markLine")
        }, i.get("option.line") || {}, !0);
      },
      bar: function bar(e, t, n, i) {
        if ("line" === e) return r.merge({
          id: t,
          type: "bar",
          data: n.get("data"),
          stack: n.get("stack"),
          markPoint: n.get("markPoint"),
          markLine: n.get("markLine")
        }, i.get("option.bar") || {}, !0);
      },
      stack: function stack(e, t, n, i) {
        var o = "__ec_magicType_stack__" === n.get("stack");
        if ("line" === e || "bar" === e) return i.setIconStatus("stack", o ? "normal" : "emphasis"), r.merge({
          id: t,
          stack: o ? "" : "__ec_magicType_stack__"
        }, i.get("option.stack") || {}, !0);
      }
    },
        h = [["line", "bar"], ["stack"]];
    u.onclick = function (e, t, n) {
      var i = this.model,
          o = i.get("seriesIndex." + n);

      if (c[n]) {
        var a,
            l = {
          series: []
        };
        if (r.each(h, function (e) {
          r.indexOf(e, n) >= 0 && r.each(e, function (e) {
            i.setIconStatus(e, "normal");
          });
        }), i.setIconStatus(n, "emphasis"), e.eachComponent({
          mainType: "series",
          query: null == o ? null : {
            seriesIndex: o
          }
        }, function (t) {
          var o = t.subType,
              a = t.id,
              s = c[n](o, a, t, i);
          s && (r.defaults(s, t.option), l.series.push(s));
          var u = t.coordinateSystem;

          if (u && "cartesian2d" === u.type && ("line" === n || "bar" === n)) {
            var h = u.getAxesByScale("ordinal")[0];

            if (h) {
              var d = h.dim + "Axis",
                  f = e.queryComponents({
                mainType: d,
                index: t.get(name + "Index"),
                id: t.get(name + "Id")
              })[0].componentIndex;
              l[d] = l[d] || [];

              for (var p = 0; p <= f; p++) {
                l[d][f] = l[d][f] || {};
              }

              l[d][f].boundaryGap = "bar" === n;
            }
          }
        }), "stack" === n) a = l.series && l.series[0] && "__ec_magicType_stack__" === l.series[0].stack ? r.merge({
          stack: s.title.tiled
        }, s.title) : r.clone(s.title);
        t.dispatchAction({
          type: "changeMagicType",
          currentType: n,
          newOption: l,
          newTitle: a,
          featureName: "magicType"
        });
      }
    }, i.registerAction({
      type: "changeMagicType",
      event: "magicTypeChanged",
      update: "prepareAndUpdate"
    }, function (e, t) {
      t.mergeOption(e.newOption);
    }), a.register("magicType", l);
    var d = l;
    e.exports = d;
  }, function (e, t, n) {
    var i = n(4),
        r = n(1),
        o = n(52),
        a = n(68),
        s = n(71),
        l = a.toolbox.dataView,
        u = new Array(60).join("-");

    function c(e) {
      return r.map(e, function (e) {
        var t = e.getRawData(),
            n = [e.name],
            i = [];
        return t.each(t.dimensions, function () {
          for (var e = arguments.length, r = arguments[e - 1], o = t.getName(r), a = 0; a < e - 1; a++) {
            i[a] = arguments[a];
          }

          n.push((o ? o + "\t" : "") + i.join("\t"));
        }), n.join("\n");
      }).join("\n\n" + u + "\n\n");
    }

    function h(e) {
      return e.replace(/^\s\s*/, "").replace(/\s\s*$/, "");
    }

    var d = new RegExp("[\t]+", "g");

    function f(e, t) {
      var n = e.split(new RegExp("\n*" + u + "\n*", "g")),
          i = {
        series: []
      };
      return r.each(n, function (e, n) {
        if (function (e) {
          if (e.slice(0, e.indexOf("\n")).indexOf("\t") >= 0) return !0;
        }(e)) {
          var o = function (e) {
            for (var t = e.split(/\n+/g), n = h(t.shift()).split(d), i = [], o = r.map(n, function (e) {
              return {
                name: e,
                data: []
              };
            }), a = 0; a < t.length; a++) {
              var s = h(t[a]).split(d);
              i.push(s.shift());

              for (var l = 0; l < s.length; l++) {
                o[l] && (o[l].data[a] = s[l]);
              }
            }

            return {
              series: o,
              categories: i
            };
          }(e),
              a = t[n],
              s = a.axisDim + "Axis";

          a && (i[s] = i[s] || [], i[s][a.axisIndex] = {
            data: o.categories
          }, i.series = i.series.concat(o.series));
        } else {
          o = function (e) {
            for (var t = e.split(/\n+/g), n = h(t.shift()), i = [], r = 0; r < t.length; r++) {
              var o,
                  a = h(t[r]).split(d),
                  s = "",
                  l = !1;
              isNaN(a[0]) ? (l = !0, s = a[0], a = a.slice(1), i[r] = {
                name: s,
                value: []
              }, o = i[r].value) : o = i[r] = [];

              for (var u = 0; u < a.length; u++) {
                o.push(+a[u]);
              }

              1 === o.length && (l ? i[r].value = o[0] : i[r] = o[0]);
            }

            return {
              name: n,
              data: i
            };
          }(e);

          i.series.push(o);
        }
      }), i;
    }

    function p(e) {
      this._dom = null, this.model = e;
    }

    function g(e, t) {
      return r.map(e, function (e, n) {
        var i = t && t[n];
        return r.isObject(i) && !r.isArray(i) ? (r.isObject(e) && !r.isArray(e) && (e = e.value), r.defaults({
          value: e
        }, i)) : e;
      });
    }

    p.defaultOption = {
      show: !0,
      readOnly: !1,
      optionToContent: null,
      contentToOption: null,
      icon: "M17.5,17.3H33 M17.5,17.3H33 M45.4,29.5h-28 M11.5,2v56H51V14.8L38.4,2H11.5z M38.4,2.2v12.7H51 M45.4,41.7h-28",
      title: r.clone(l.title),
      lang: r.clone(l.lang),
      backgroundColor: "#fff",
      textColor: "#000",
      textareaColor: "#fff",
      textareaBorderColor: "#333",
      buttonColor: "#c23531",
      buttonTextColor: "#fff"
    }, p.prototype.onclick = function (e, t) {
      var n = t.getDom(),
          i = this.model;
      this._dom && n.removeChild(this._dom);
      var a = document.createElement("div");
      a.style.cssText = "position:absolute;left:5px;top:5px;bottom:5px;right:5px;", a.style.backgroundColor = i.get("backgroundColor") || "#fff";
      var s = document.createElement("h4"),
          l = i.get("lang") || [];
      s.innerHTML = l[0] || i.get("title"), s.style.cssText = "margin: 10px 20px;", s.style.color = i.get("textColor");
      var h = document.createElement("div"),
          d = document.createElement("textarea");
      h.style.cssText = "display:block;width:100%;overflow:auto;";

      var p = i.get("optionToContent"),
          g = i.get("contentToOption"),
          v = function (e) {
        var t,
            n,
            i = function (e) {
          var t = {},
              n = [],
              i = [];
          return e.eachRawSeries(function (e) {
            var r = e.coordinateSystem;
            if (!r || "cartesian2d" !== r.type && "polar" !== r.type) n.push(e);else {
              var o = r.getBaseAxis();

              if ("category" === o.type) {
                var a = o.dim + "_" + o.index;
                t[a] || (t[a] = {
                  categoryAxis: o,
                  valueAxis: r.getOtherAxis(o),
                  series: []
                }, i.push({
                  axisDim: o.dim,
                  axisIndex: o.index
                })), t[a].series.push(e);
              } else n.push(e);
            }
          }), {
            seriesGroupByCategoryAxis: t,
            other: n,
            meta: i
          };
        }(e);

        return {
          value: r.filter([(t = i.seriesGroupByCategoryAxis, n = [], r.each(t, function (e, t) {
            var i = e.categoryAxis,
                o = e.valueAxis.dim,
                a = [" "].concat(r.map(e.series, function (e) {
              return e.name;
            })),
                s = [i.model.getCategories()];
            r.each(e.series, function (e) {
              s.push(e.getRawData().mapArray(o, function (e) {
                return e;
              }));
            });

            for (var l = [a.join("\t")], u = 0; u < s[0].length; u++) {
              for (var c = [], h = 0; h < s.length; h++) {
                c.push(s[h][u]);
              }

              l.push(c.join("\t"));
            }

            n.push(l.join("\n"));
          }), n.join("\n\n" + u + "\n\n")), c(i.other)], function (e) {
            return e.replace(/[\n\t\s]/g, "");
          }).join("\n\n" + u + "\n\n"),
          meta: i.meta
        };
      }(e);

      if ("function" == typeof p) {
        var m = p(t.getOption());
        "string" == typeof m ? h.innerHTML = m : r.isDom(m) && h.appendChild(m);
      } else h.appendChild(d), d.readOnly = i.get("readOnly"), d.style.cssText = "width:100%;height:100%;font-family:monospace;font-size:14px;line-height:1.6rem;", d.style.color = i.get("textColor"), d.style.borderColor = i.get("textareaBorderColor"), d.style.backgroundColor = i.get("textareaColor"), d.value = v.value;

      var y = v.meta,
          x = document.createElement("div");
      x.style.cssText = "position:absolute;bottom:0;left:0;right:0;";
      var _ = "float:right;margin-right:20px;border:none;cursor:pointer;padding:2px 5px;font-size:12px;border-radius:3px",
          b = document.createElement("div"),
          w = document.createElement("div");
      _ += ";background-color:" + i.get("buttonColor"), _ += ";color:" + i.get("buttonTextColor");
      var S = this;

      function T() {
        n.removeChild(a), S._dom = null;
      }

      o.addEventListener(b, "click", T), o.addEventListener(w, "click", function () {
        var e;

        try {
          e = "function" == typeof g ? g(h, t.getOption()) : f(d.value, y);
        } catch (e) {
          throw T(), new Error("Data view format error " + e);
        }

        e && t.dispatchAction({
          type: "changeDataView",
          newOption: e
        }), T();
      }), b.innerHTML = l[1], w.innerHTML = l[2], w.style.cssText = _, b.style.cssText = _, !i.get("readOnly") && x.appendChild(w), x.appendChild(b), a.appendChild(s), a.appendChild(h), a.appendChild(x), h.style.height = n.clientHeight - 80 + "px", n.appendChild(a), this._dom = a;
    }, p.prototype.remove = function (e, t) {
      this._dom && t.getDom().removeChild(this._dom);
    }, p.prototype.dispose = function (e, t) {
      this.remove(e, t);
    }, s.register("dataView", p), i.registerAction({
      type: "changeDataView",
      event: "dataViewChanged",
      update: "prepareAndUpdate"
    }, function (e, t) {
      var n = [];
      r.each(e.newOption.series, function (e) {
        var i = t.getSeriesByName(e.name)[0];

        if (i) {
          var o = i.get("data");
          n.push({
            name: e.name,
            data: g(e.data, o)
          });
        } else n.push(r.extend({
          type: "scatter"
        }, e));
      }), t.mergeOption(r.defaults({
        series: n
      }, e.newOption));
    });
    var v = p;
    e.exports = v;
  }, function (e, t, n) {
    var i = n(4),
        r = n(1),
        o = n(224),
        a = n(350),
        s = n(351),
        l = n(107),
        u = n(68),
        c = n(71);
    n(877);
    var h = u.toolbox.dataZoom,
        d = r.each;

    function f(e, t, n) {
      (this._brushController = new o(n.getZr())).on("brush", r.bind(this._onBrush, this)).mount(), this._isZoomActive;
    }

    f.defaultOption = {
      show: !0,
      filterMode: "filter",
      icon: {
        zoom: "M0,13.5h26.9 M13.5,26.9V0 M32.1,13.5H58V58H13.5 V32.1",
        back: "M22,1.4L9.9,13.5l12.3,12.3 M10.3,13.5H54.9v44.6 H10.3v-26"
      },
      title: r.clone(h.title)
    };
    var p = f.prototype;
    p.render = function (e, t, n, i) {
      this.model = e, this.ecModel = t, this.api = n, function (e, t, n, i, r) {
        var o = n._isZoomActive;
        i && "takeGlobalCursor" === i.type && (o = "dataZoomSelect" === i.key && i.dataZoomSelectActive);
        n._isZoomActive = o, e.setIconStatus("zoom", o ? "emphasis" : "normal");
        var s = new a(v(e.option), t, {
          include: ["grid"]
        });

        n._brushController.setPanels(s.makePanelOpts(r, function (e) {
          return e.xAxisDeclared && !e.yAxisDeclared ? "lineX" : !e.xAxisDeclared && e.yAxisDeclared ? "lineY" : "rect";
        })).enableBrush(!!o && {
          brushType: "auto",
          brushStyle: {
            lineWidth: 0,
            fill: "rgba(0,0,0,0.2)"
          }
        });
      }(e, t, this, i, n), function (e, t) {
        e.setIconStatus("back", s.count(t) > 1 ? "emphasis" : "normal");
      }(e, t);
    }, p.onclick = function (e, t, n) {
      g[n].call(this);
    }, p.remove = function (e, t) {
      this._brushController.unmount();
    }, p.dispose = function (e, t) {
      this._brushController.dispose();
    };
    var g = {
      zoom: function zoom() {
        var e = !this._isZoomActive;
        this.api.dispatchAction({
          type: "takeGlobalCursor",
          key: "dataZoomSelect",
          dataZoomSelectActive: e
        });
      },
      back: function back() {
        this._dispatchZoomAction(s.pop(this.ecModel));
      }
    };

    function v(e) {
      var t = {};
      return r.each(["xAxisIndex", "yAxisIndex"], function (n) {
        t[n] = e[n], null == t[n] && (t[n] = "all"), (!1 === t[n] || "none" === t[n]) && (t[n] = []);
      }), t;
    }

    p._onBrush = function (e, t) {
      if (t.isEnd && e.length) {
        var n = {},
            i = this.ecModel;
        this._brushController.updateCovers([]), new a(v(this.model.option), i, {
          include: ["grid"]
        }).matchOutputRanges(e, i, function (e, t, n) {
          if ("cartesian2d" === n.type) {
            var i = e.brushType;
            "rect" === i ? (r("x", n, t[0]), r("y", n, t[1])) : r({
              lineX: "x",
              lineY: "y"
            }[i], n, t);
          }
        }), s.push(i, n), this._dispatchZoomAction(n);
      }

      function r(e, t, r) {
        var o = t.getAxis(e),
            a = o.model,
            s = function (e, t, n) {
          var i;
          return n.eachComponent({
            mainType: "dataZoom",
            subType: "select"
          }, function (n) {
            n.getAxisModel(e, t.componentIndex) && (i = n);
          }), i;
        }(e, a, i),
            u = s.findRepresentativeAxisProxy(a).getMinMaxSpan();

        null == u.minValueSpan && null == u.maxValueSpan || (r = l(0, r.slice(), o.scale.getExtent(), 0, u.minValueSpan, u.maxValueSpan)), s && (n[s.id] = {
          dataZoomId: s.id,
          startValue: r[0],
          endValue: r[1]
        });
      }
    }, p._dispatchZoomAction = function (e) {
      var t = [];
      d(e, function (e, n) {
        t.push(r.clone(e));
      }), t.length && this.api.dispatchAction({
        type: "dataZoom",
        from: this.uid,
        batch: t
      });
    }, c.register("dataZoom", f), i.registerPreprocessor(function (e) {
      if (e) {
        var t = e.dataZoom || (e.dataZoom = []);
        r.isArray(t) || (e.dataZoom = t = [t]);
        var n = e.toolbox;

        if (n && (r.isArray(n) && (n = n[0]), n && n.feature)) {
          var i = n.feature.dataZoom;
          o("xAxis", i), o("yAxis", i);
        }
      }

      function o(n, i) {
        if (i) {
          var o = n + "Index",
              a = i[o];
          null == a || "all" === a || r.isArray(a) || (a = !1 === a || "none" === a ? [] : [a]), function (t, n) {
            var i = e[t];
            r.isArray(i) || (i = i ? [i] : []);
            d(i, n);
          }(n, function (e, s) {
            if (null == a || "all" === a || -1 !== r.indexOf(a, s)) {
              var l = {
                type: "select",
                $fromToolbox: !0,
                filterMode: i.filterMode || "filter",
                id: "\0_ec_\0toolbox-dataZoom_" + n + s
              };
              l[o] = s, t.push(l);
            }
          });
        }
      }
    });
    var m = f;
    e.exports = m;
  }, function (e, t, n) {
    n(227), n(108), n(109), n(879), n(880), n(229), n(230);
  }, function (e, t, n) {
    var i = n(1),
        r = n(6),
        o = n(228),
        a = n(107),
        s = i.each,
        l = r.asc,
        u = function u(e, t, n, i) {
      this._dimName = e, this._axisIndex = t, this._valueWindow, this._percentWindow, this._dataExtent, this._minMaxSpan, this.ecModel = i, this._dataZoomModel = n;
    };

    function c(e, t) {
      var n = e.getAxisModel(),
          i = e._percentWindow,
          o = e._valueWindow;

      if (i) {
        var a = r.getPixelPrecision(o, [0, 500]);
        a = Math.min(a, 20);
        var s = t || 0 === i[0] && 100 === i[1];
        n.setRange(s ? null : +o[0].toFixed(a), s ? null : +o[1].toFixed(a));
      }
    }

    u.prototype = {
      constructor: u,
      hostedBy: function hostedBy(e) {
        return this._dataZoomModel === e;
      },
      getDataValueWindow: function getDataValueWindow() {
        return this._valueWindow.slice();
      },
      getDataPercentWindow: function getDataPercentWindow() {
        return this._percentWindow.slice();
      },
      getTargetSeriesModels: function getTargetSeriesModels() {
        var e = [],
            t = this.ecModel;
        return t.eachSeries(function (n) {
          if (o.isCoordSupported(n.get("coordinateSystem"))) {
            var i = this._dimName,
                r = t.queryComponents({
              mainType: i + "Axis",
              index: n.get(i + "AxisIndex"),
              id: n.get(i + "AxisId")
            })[0];
            this._axisIndex === (r && r.componentIndex) && e.push(n);
          }
        }, this), e;
      },
      getAxisModel: function getAxisModel() {
        return this.ecModel.getComponent(this._dimName + "Axis", this._axisIndex);
      },
      getOtherAxisModel: function getOtherAxisModel() {
        var e,
            t,
            n,
            i = this._dimName,
            r = this.ecModel,
            o = this.getAxisModel();
        return "x" === i || "y" === i ? (t = "gridIndex", e = "x" === i ? "y" : "x") : (t = "polarIndex", e = "angle" === i ? "radius" : "angle"), r.eachComponent(e + "Axis", function (e) {
          (e.get(t) || 0) === (o.get(t) || 0) && (n = e);
        }), n;
      },
      getMinMaxSpan: function getMinMaxSpan() {
        return i.clone(this._minMaxSpan);
      },
      calculateDataWindow: function calculateDataWindow(e) {
        var t,
            n = this._dataExtent,
            i = this.getAxisModel().axis.scale,
            o = this._dataZoomModel.getRangePropMode(),
            u = [0, 100],
            c = [],
            h = [];

        s(["start", "end"], function (a, s) {
          var l = e[a],
              d = e[a + "Value"];
          "percent" === o[s] ? (null == l && (l = u[s]), d = i.parse(r.linearMap(l, u, n))) : (t = !0, d = null == d ? n[s] : i.parse(d), l = r.linearMap(d, n, u)), h[s] = d, c[s] = l;
        }), l(h), l(c);
        var d = this._minMaxSpan;

        function f(e, t, n, o, s) {
          var l = s ? "Span" : "ValueSpan";
          a(0, e, n, "all", d["min" + l], d["max" + l]);

          for (var u = 0; u < 2; u++) {
            t[u] = r.linearMap(e[u], n, o, !0), s && (t[u] = i.parse(t[u]));
          }
        }

        return t ? f(h, c, n, u, !1) : f(c, h, u, n, !0), {
          valueWindow: h,
          percentWindow: c
        };
      },
      reset: function reset(e) {
        if (e === this._dataZoomModel) {
          var t = this.getTargetSeriesModels();
          this._dataExtent = function (e, t, n) {
            var i = [1 / 0, -1 / 0];
            s(n, function (e) {
              var n = e.getData();
              n && s(n.mapDimension(t, !0), function (e) {
                var t = n.getApproximateExtent(e);
                t[0] < i[0] && (i[0] = t[0]), t[1] > i[1] && (i[1] = t[1]);
              });
            }), i[1] < i[0] && (i = [NaN, NaN]);
            return function (e, t) {
              var n = e.getAxisModel(),
                  i = n.getMin(!0),
                  r = "category" === n.get("type"),
                  o = r && n.getCategories().length;
              null != i && "dataMin" !== i && "function" != typeof i ? t[0] = i : r && (t[0] = o > 0 ? 0 : NaN);
              var a = n.getMax(!0);
              null != a && "dataMax" !== a && "function" != typeof a ? t[1] = a : r && (t[1] = o > 0 ? o - 1 : NaN);
              n.get("scale", !0) || (t[0] > 0 && (t[0] = 0), t[1] < 0 && (t[1] = 0));
            }(e, i), i;
          }(this, this._dimName, t), function (e) {
            var t = e._minMaxSpan = {},
                n = e._dataZoomModel,
                i = e._dataExtent;
            s(["min", "max"], function (o) {
              var a = n.get(o + "Span"),
                  s = n.get(o + "ValueSpan");
              null != s && (s = e.getAxisModel().axis.scale.parse(s)), null != s ? a = r.linearMap(i[0] + s, i, [0, 100], !0) : null != a && (s = r.linearMap(a, [0, 100], i, !0) - i[0]), t[o + "Span"] = a, t[o + "ValueSpan"] = s;
            });
          }(this);
          var n = this.calculateDataWindow(e.settledOption);
          this._valueWindow = n.valueWindow, this._percentWindow = n.percentWindow, c(this);
        }
      },
      restore: function restore(e) {
        e === this._dataZoomModel && (this._valueWindow = this._percentWindow = null, c(this, !0));
      },
      filterData: function filterData(e, t) {
        if (e === this._dataZoomModel) {
          var n = this._dimName,
              i = this.getTargetSeriesModels(),
              r = e.get("filterMode"),
              o = this._valueWindow;
          "none" !== r && s(i, function (e) {
            var t = e.getData(),
                i = t.mapDimension(n, !0);
            i.length && ("weakFilter" === r ? t.filterSelf(function (e) {
              for (var n, r, a, s = 0; s < i.length; s++) {
                var l = t.get(i[s], e),
                    u = !isNaN(l),
                    c = l < o[0],
                    h = l > o[1];
                if (u && !c && !h) return !0;
                u && (a = !0), c && (n = !0), h && (r = !0);
              }

              return a && n && r;
            }) : s(i, function (n) {
              if ("empty" === r) e.setData(t = t.map(n, function (e) {
                return function (e) {
                  return e >= o[0] && e <= o[1];
                }(e) ? e : NaN;
              }));else {
                var i = {};
                i[n] = o, t.selectRange(i);
              }
            }), s(i, function (e) {
              t.setApproximateExtent(o, e);
            }));
          });
        }
      }
    };
    var h = u;
    e.exports = h;
  }, function (e, t, n) {
    var i = n(108).extend({
      type: "dataZoom.select"
    });
    e.exports = i;
  }, function (e, t, n) {
    var i = n(109).extend({
      type: "dataZoom.select"
    });
    e.exports = i;
  }, function (e, t, n) {
    var i = n(4),
        r = n(351),
        o = n(68),
        a = n(71),
        s = o.toolbox.restore;

    function l(e) {
      this.model = e;
    }

    l.defaultOption = {
      show: !0,
      icon: "M3.8,33.4 M47,18.9h9.8V8.7 M56.3,20.1 C52.1,9,40.5,0.6,26.8,2.1C12.6,3.7,1.6,16.2,2.1,30.6 M13,41.1H3.1v10.2 M3.7,39.9c4.2,11.1,15.8,19.5,29.5,18 c14.2-1.6,25.2-14.1,24.7-28.5",
      title: s.title
    }, l.prototype.onclick = function (e, t, n) {
      r.clear(e), t.dispatchAction({
        type: "restore",
        from: this.uid
      });
    }, a.register("restore", l), i.registerAction({
      type: "restore",
      event: "restore",
      update: "prepareAndUpdate"
    }, function (e, t) {
      t.resetOption("recreate");
    });
    var u = l;
    e.exports = u;
  }, function (e, t, n) {
    var i = n(4);
    n(132), n(883), n(884), i.registerAction({
      type: "showTip",
      event: "showTip",
      update: "tooltip:manuallyShowTip"
    }, function () {}), i.registerAction({
      type: "hideTip",
      event: "hideTip",
      update: "tooltip:manuallyHideTip"
    }, function () {});
  }, function (e, t, n) {
    var i = n(4).extendComponentModel({
      type: "tooltip",
      dependencies: ["axisPointer"],
      defaultOption: {
        zlevel: 0,
        z: 60,
        show: !0,
        showContent: !0,
        trigger: "item",
        triggerOn: "mousemove|click",
        alwaysShowContent: !1,
        displayMode: "single",
        renderMode: "auto",
        confine: !1,
        showDelay: 0,
        hideDelay: 100,
        transitionDuration: .4,
        enterable: !1,
        backgroundColor: "rgba(50,50,50,0.7)",
        borderColor: "#333",
        borderRadius: 4,
        borderWidth: 0,
        padding: 5,
        extraCssText: "",
        axisPointer: {
          type: "line",
          axis: "auto",
          animation: "auto",
          animationDurationUpdate: 200,
          animationEasingUpdate: "exponentialOut",
          crossStyle: {
            color: "#999",
            width: 1,
            type: "dashed",
            textStyle: {}
          }
        },
        textStyle: {
          color: "#fff",
          fontSize: 14
        }
      }
    });
    e.exports = i;
  }, function (e, t, n) {
    var i = n(4),
        r = n(1),
        o = n(21),
        a = n(885),
        s = n(886),
        l = n(15),
        u = n(6),
        c = n(5),
        h = n(346),
        d = n(14),
        f = n(22),
        p = n(347),
        g = n(43),
        v = n(168),
        m = n(8).getTooltipRenderMode,
        y = r.bind,
        x = r.each,
        _ = u.parsePercent,
        b = new c.Rect({
      shape: {
        x: -1,
        y: -1,
        width: 2,
        height: 2
      }
    }),
        w = i.extendComponentView({
      type: "tooltip",
      init: function init(e, t) {
        if (!o.node) {
          var n,
              i = e.getComponent("tooltip"),
              r = i.get("renderMode");
          this._renderMode = m(r), "html" === this._renderMode ? (n = new a(t.getDom(), t, {
            appendToBody: i.get("appendToBody", !0)
          }), this._newLine = "<br/>") : (n = new s(t), this._newLine = "\n"), this._tooltipContent = n;
        }
      },
      render: function render(e, t, n) {
        if (!o.node) {
          this.group.removeAll(), this._tooltipModel = e, this._ecModel = t, this._api = n, this._lastDataByCoordSys = null, this._alwaysShowContent = e.get("alwaysShowContent");
          var i = this._tooltipContent;
          i.update(), i.setEnterable(e.get("enterable")), this._initGlobalListener(), this._keepShow();
        }
      },
      _initGlobalListener: function _initGlobalListener() {
        var e = this._tooltipModel.get("triggerOn");

        p.register("itemTooltip", this._api, y(function (t, n, i) {
          "none" !== e && (e.indexOf(t) >= 0 ? this._tryShow(n, i) : "leave" === t && this._hide(i));
        }, this));
      },
      _keepShow: function _keepShow() {
        var e = this._tooltipModel,
            t = this._ecModel,
            n = this._api;

        if (null != this._lastX && null != this._lastY && "none" !== e.get("triggerOn")) {
          var i = this;
          clearTimeout(this._refreshUpdateTimeout), this._refreshUpdateTimeout = setTimeout(function () {
            !n.isDisposed() && i.manuallyShowTip(e, t, n, {
              x: i._lastX,
              y: i._lastY
            });
          });
        }
      },
      manuallyShowTip: function manuallyShowTip(e, t, n, i) {
        if (i.from !== this.uid && !o.node) {
          var r = T(i, n);
          this._ticket = "";
          var a = i.dataByCoordSys;

          if (i.tooltip && null != i.x && null != i.y) {
            var s = b;
            s.position = [i.x, i.y], s.update(), s.tooltip = i.tooltip, this._tryShow({
              offsetX: i.x,
              offsetY: i.y,
              target: s
            }, r);
          } else if (a) this._tryShow({
            offsetX: i.x,
            offsetY: i.y,
            position: i.position,
            dataByCoordSys: i.dataByCoordSys,
            tooltipOption: i.tooltipOption
          }, r);else if (null != i.seriesIndex) {
            if (this._manuallyAxisShowTip(e, t, n, i)) return;
            var l = h(i, t),
                u = l.point[0],
                c = l.point[1];
            null != u && null != c && this._tryShow({
              offsetX: u,
              offsetY: c,
              position: i.position,
              target: l.el
            }, r);
          } else null != i.x && null != i.y && (n.dispatchAction({
            type: "updateAxisPointer",
            x: i.x,
            y: i.y
          }), this._tryShow({
            offsetX: i.x,
            offsetY: i.y,
            position: i.position,
            target: n.getZr().findHover(i.x, i.y).target
          }, r));
        }
      },
      manuallyHideTip: function manuallyHideTip(e, t, n, i) {
        var r = this._tooltipContent;
        !this._alwaysShowContent && this._tooltipModel && r.hideLater(this._tooltipModel.get("hideDelay")), this._lastX = this._lastY = null, i.from !== this.uid && this._hide(T(i, n));
      },
      _manuallyAxisShowTip: function _manuallyAxisShowTip(e, t, n, i) {
        var r = i.seriesIndex,
            o = i.dataIndex,
            a = t.getComponent("axisPointer").coordSysAxesInfo;

        if (null != r && null != o && null != a) {
          var s = t.getSeriesByIndex(r);
          if (s) if ("axis" === (e = S([s.getData().getItemModel(o), s, (s.coordinateSystem || {}).model, e])).get("trigger")) return n.dispatchAction({
            type: "updateAxisPointer",
            seriesIndex: r,
            dataIndex: o,
            position: i.position
          }), !0;
        }
      },
      _tryShow: function _tryShow(e, t) {
        var n = e.target;

        if (this._tooltipModel) {
          this._lastX = e.offsetX, this._lastY = e.offsetY;
          var i = e.dataByCoordSys;
          i && i.length ? this._showAxisTooltip(i, e) : n && null != n.dataIndex ? (this._lastDataByCoordSys = null, this._showSeriesItemTooltip(e, n, t)) : n && n.tooltip ? (this._lastDataByCoordSys = null, this._showComponentItemTooltip(e, n, t)) : (this._lastDataByCoordSys = null, this._hide(t));
        }
      },
      _showOrMove: function _showOrMove(e, t) {
        var n = e.get("showDelay");
        t = r.bind(t, this), clearTimeout(this._showTimout), n > 0 ? this._showTimout = setTimeout(t, n) : t();
      },
      _showAxisTooltip: function _showAxisTooltip(e, t) {
        var n = this._ecModel,
            i = this._tooltipModel,
            o = [t.offsetX, t.offsetY],
            a = [],
            s = [],
            u = S([t.tooltipOption, i]),
            c = this._renderMode,
            h = this._newLine,
            d = {};
        x(e, function (e) {
          x(e.dataByAxis, function (e) {
            var t = n.getComponent(e.axisDim + "Axis", e.axisIndex),
                i = e.value,
                o = [];

            if (t && null != i) {
              var u = v.getValueLabel(i, t.axis, n, e.seriesDataIndices, e.valueLabelOpt);
              r.each(e.seriesDataIndices, function (a) {
                var l = n.getSeriesByIndex(a.seriesIndex),
                    h = a.dataIndexInside,
                    f = l && l.getDataParams(h);

                if (f.axisDim = e.axisDim, f.axisIndex = e.axisIndex, f.axisType = e.axisType, f.axisId = e.axisId, f.axisValue = g.getAxisRawValue(t.axis, i), f.axisValueLabel = u, f) {
                  s.push(f);
                  var p,
                      v = l.formatTooltip(h, !0, null, c);

                  if (r.isObject(v)) {
                    p = v.html;
                    var m = v.markers;
                    r.merge(d, m);
                  } else p = v;

                  o.push(p);
                }
              });
              var f = u;
              "html" !== c ? a.push(o.join(h)) : a.push((f ? l.encodeHTML(f) + h : "") + o.join(h));
            }
          });
        }, this), a.reverse(), a = a.join(this._newLine + this._newLine);
        var f = t.position;

        this._showOrMove(u, function () {
          this._updateContentNotChangedOnAxis(e) ? this._updatePosition(u, f, o[0], o[1], this._tooltipContent, s) : this._showTooltipContent(u, a, s, Math.random(), o[0], o[1], f, void 0, d);
        });
      },
      _showSeriesItemTooltip: function _showSeriesItemTooltip(e, t, n) {
        var i = this._ecModel,
            o = t.seriesIndex,
            a = i.getSeriesByIndex(o),
            s = t.dataModel || a,
            l = t.dataIndex,
            u = t.dataType,
            c = s.getData(u),
            h = S([c.getItemModel(l), s, a && (a.coordinateSystem || {}).model, this._tooltipModel]),
            d = h.get("trigger");

        if (null == d || "item" === d) {
          var f,
              p,
              g = s.getDataParams(l, u),
              v = s.formatTooltip(l, !1, u, this._renderMode);
          r.isObject(v) ? (f = v.html, p = v.markers) : (f = v, p = null);
          var m = "item_" + s.name + "_" + l;
          this._showOrMove(h, function () {
            this._showTooltipContent(h, f, g, m, e.offsetX, e.offsetY, e.position, e.target, p);
          }), n({
            type: "showTip",
            dataIndexInside: l,
            dataIndex: c.getRawIndex(l),
            seriesIndex: o,
            from: this.uid
          });
        }
      },
      _showComponentItemTooltip: function _showComponentItemTooltip(e, t, n) {
        var i = t.tooltip;

        if ("string" == typeof i) {
          i = {
            content: i,
            formatter: i
          };
        }

        var r = new f(i, this._tooltipModel, this._ecModel),
            o = r.get("content"),
            a = Math.random();
        this._showOrMove(r, function () {
          this._showTooltipContent(r, o, r.get("formatterParams") || {}, a, e.offsetX, e.offsetY, e.position, t);
        }), n({
          type: "showTip",
          from: this.uid
        });
      },
      _showTooltipContent: function _showTooltipContent(e, t, n, i, r, o, a, s, u) {
        if (this._ticket = "", e.get("showContent") && e.get("show")) {
          var c = this._tooltipContent,
              h = e.get("formatter");
          a = a || e.get("position");
          var d = t;
          if (h && "string" == typeof h) d = l.formatTpl(h, n, !0);else if ("function" == typeof h) {
            var f = y(function (t, i) {
              t === this._ticket && (c.setContent(i, u, e), this._updatePosition(e, a, r, o, c, n, s));
            }, this);
            this._ticket = i, d = h(n, i, f);
          }
          c.setContent(d, u, e), c.show(e), this._updatePosition(e, a, r, o, c, n, s);
        }
      },
      _updatePosition: function _updatePosition(e, t, n, i, o, a, s) {
        var l = this._api.getWidth(),
            u = this._api.getHeight();

        t = t || e.get("position");
        var c = o.getSize(),
            h = e.get("align"),
            f = e.get("verticalAlign"),
            p = s && s.getBoundingRect().clone();
        if (s && p.applyTransform(s.transform), "function" == typeof t && (t = t([n, i], a, o.el, p, {
          viewSize: [l, u],
          contentSize: c.slice()
        })), r.isArray(t)) n = _(t[0], l), i = _(t[1], u);else if (r.isObject(t)) {
          t.width = c[0], t.height = c[1];
          var g = d.getLayoutRect(t, {
            width: l,
            height: u
          });
          n = g.x, i = g.y, h = null, f = null;
        } else if ("string" == typeof t && s) {
          var v = function (e, t, n) {
            var i = n[0],
                r = n[1],
                o = 0,
                a = 0,
                s = t.width,
                l = t.height;

            switch (e) {
              case "inside":
                o = t.x + s / 2 - i / 2, a = t.y + l / 2 - r / 2;
                break;

              case "top":
                o = t.x + s / 2 - i / 2, a = t.y - r - 5;
                break;

              case "bottom":
                o = t.x + s / 2 - i / 2, a = t.y + l + 5;
                break;

              case "left":
                o = t.x - i - 5, a = t.y + l / 2 - r / 2;
                break;

              case "right":
                o = t.x + s + 5, a = t.y + l / 2 - r / 2;
            }

            return [o, a];
          }(t, p, c);

          n = v[0], i = v[1];
        } else {
          v = function (e, t, n, i, r, o, a) {
            var s = n.getOuterSize(),
                l = s.width,
                u = s.height;
            null != o && (e + l + o > i ? e -= l + o : e += o);
            null != a && (t + u + a > r ? t -= u + a : t += a);
            return [e, t];
          }(n, i, o, l, u, h ? null : 20, f ? null : 20);

          n = v[0], i = v[1];
        }

        if (h && (n -= C(h) ? c[0] / 2 : "right" === h ? c[0] : 0), f && (i -= C(f) ? c[1] / 2 : "bottom" === f ? c[1] : 0), e.get("confine")) {
          v = function (e, t, n, i, r) {
            var o = n.getOuterSize(),
                a = o.width,
                s = o.height;
            return e = Math.min(e + a, i) - a, t = Math.min(t + s, r) - s, e = Math.max(e, 0), t = Math.max(t, 0), [e, t];
          }(n, i, o, l, u);

          n = v[0], i = v[1];
        }

        o.moveTo(n, i);
      },
      _updateContentNotChangedOnAxis: function _updateContentNotChangedOnAxis(e) {
        var t = this._lastDataByCoordSys,
            n = !!t && t.length === e.length;
        return n && x(t, function (t, i) {
          var r = t.dataByAxis || {},
              o = (e[i] || {}).dataByAxis || [];
          (n &= r.length === o.length) && x(r, function (e, t) {
            var i = o[t] || {},
                r = e.seriesDataIndices || [],
                a = i.seriesDataIndices || [];
            (n &= e.value === i.value && e.axisType === i.axisType && e.axisId === i.axisId && r.length === a.length) && x(r, function (e, t) {
              var i = a[t];
              n &= e.seriesIndex === i.seriesIndex && e.dataIndex === i.dataIndex;
            });
          });
        }), this._lastDataByCoordSys = e, !!n;
      },
      _hide: function _hide(e) {
        this._lastDataByCoordSys = null, e({
          type: "hideTip",
          from: this.uid
        });
      },
      dispose: function dispose(e, t) {
        o.node || (this._tooltipContent.dispose(), p.unregister("itemTooltip", t));
      }
    });

    function S(e) {
      for (var t = e.pop(); e.length;) {
        var n = e.pop();
        n && (f.isInstance(n) && (n = n.get("tooltip", !0)), "string" == typeof n && (n = {
          formatter: n
        }), t = new f(n, t, t.ecModel));
      }

      return t;
    }

    function T(e, t) {
      return e.dispatchAction || r.bind(t.dispatchAction, t);
    }

    function C(e) {
      return "center" === e || "middle" === e;
    }

    e.exports = w;
  }, function (e, t, n) {
    var i = n(1),
        r = n(53),
        o = n(52),
        a = n(285),
        s = n(21),
        l = n(15),
        u = i.each,
        c = l.toCamelCase,
        h = ["", "-webkit-", "-moz-", "-o-"];

    function d(e) {
      var t,
          n,
          o = [],
          a = e.get("transitionDuration"),
          d = e.get("backgroundColor"),
          f = e.getModel("textStyle"),
          p = e.get("padding");
      return a && o.push((n = "left " + (t = a) + "s cubic-bezier(0.23, 1, 0.32, 1),top " + t + "s cubic-bezier(0.23, 1, 0.32, 1)", i.map(h, function (e) {
        return e + "transition:" + n;
      }).join(";"))), d && (s.canvasSupported ? o.push("background-Color:" + d) : (o.push("background-Color:#" + r.toHex(d)), o.push("filter:alpha(opacity=70)"))), u(["width", "color", "radius"], function (t) {
        var n = "border-" + t,
            i = c(n),
            r = e.get(i);
        null != r && o.push(n + ":" + r + ("color" === t ? "" : "px"));
      }), o.push(function (e) {
        var t = [],
            n = e.get("fontSize"),
            i = e.getTextColor();
        return i && t.push("color:" + i), t.push("font:" + e.getFont()), n && t.push("line-height:" + Math.round(3 * n / 2) + "px"), u(["decoration", "align"], function (n) {
          var i = e.get(n);
          i && t.push("text-" + n + ":" + i);
        }), t.join(";");
      }(f)), null != p && o.push("padding:" + l.normalizeCssArray(p).join("px ") + "px"), o.join(";") + ";";
    }

    function f(e, t, n, i, r) {
      var o = t && t.painter;

      if (n) {
        var s = o && o.getViewportRoot();
        s && a.transformLocalCoord(e, s, document.body, i, r);
      } else {
        e[0] = i, e[1] = r;
        var l = o && o.getViewportRootOffset();
        l && (e[0] += l.offsetLeft, e[1] += l.offsetTop);
      }
    }

    function p(e, t, n) {
      if (s.wxa) return null;
      var i = document.createElement("div");
      i.domBelongToZr = !0, this.el = i;
      var r = this._zr = t.getZr(),
          a = this._appendToBody = n && n.appendToBody;
      this._styleCoord = [0, 0], f(this._styleCoord, r, a, t.getWidth() / 2, t.getHeight() / 2), a ? document.body.appendChild(i) : e.appendChild(i), this._container = e, this._show = !1, this._hideTimeout;
      var l = this;
      i.onmouseenter = function () {
        l._enterable && (clearTimeout(l._hideTimeout), l._show = !0), l._inContent = !0;
      }, i.onmousemove = function (e) {
        if (e = e || window.event, !l._enterable) {
          var t = r.handler,
              n = r.painter.getViewportRoot();
          o.normalizeEvent(n, e, !0), t.dispatch("mousemove", e);
        }
      }, i.onmouseleave = function () {
        l._enterable && l._show && l.hideLater(l._hideDelay), l._inContent = !1;
      };
    }

    p.prototype = {
      constructor: p,
      _enterable: !0,
      update: function update() {
        var e = this._container,
            t = e.currentStyle || document.defaultView.getComputedStyle(e),
            n = e.style;
        "absolute" !== n.position && "absolute" !== t.position && (n.position = "relative");
      },
      show: function show(e) {
        clearTimeout(this._hideTimeout);
        var t = this.el,
            n = this._styleCoord;
        t.style.cssText = "position:absolute;display:block;border-style:solid;white-space:nowrap;z-index:9999999;" + d(e) + ";left:" + n[0] + "px;top:" + n[1] + "px;" + (e.get("extraCssText") || ""), t.style.display = t.innerHTML ? "block" : "none", t.style.pointerEvents = this._enterable ? "auto" : "none", this._show = !0;
      },
      setContent: function setContent(e) {
        this.el.innerHTML = null == e ? "" : e;
      },
      setEnterable: function setEnterable(e) {
        this._enterable = e;
      },
      getSize: function getSize() {
        var e = this.el;
        return [e.clientWidth, e.clientHeight];
      },
      moveTo: function moveTo(e, t) {
        var n = this._styleCoord;
        f(n, this._zr, this._appendToBody, e, t);
        var i = this.el.style;
        i.left = n[0] + "px", i.top = n[1] + "px";
      },
      hide: function hide() {
        this.el.style.display = "none", this._show = !1;
      },
      hideLater: function hideLater(e) {
        !this._show || this._inContent && this._enterable || (e ? (this._hideDelay = e, this._show = !1, this._hideTimeout = setTimeout(i.bind(this.hide, this), e)) : this.hide());
      },
      isShow: function isShow() {
        return this._show;
      },
      dispose: function dispose() {
        this.el.parentNode.removeChild(this.el);
      },
      getOuterSize: function getOuterSize() {
        var e = this.el.clientWidth,
            t = this.el.clientHeight;

        if (document.defaultView && document.defaultView.getComputedStyle) {
          var n = document.defaultView.getComputedStyle(this.el);
          n && (e += parseInt(n.borderLeftWidth, 10) + parseInt(n.borderRightWidth, 10), t += parseInt(n.borderTopWidth, 10) + parseInt(n.borderBottomWidth, 10));
        }

        return {
          width: e,
          height: t
        };
      }
    };
    var g = p;
    e.exports = g;
  }, function (e, t, n) {
    var i = n(1),
        r = n(85);

    function o(e) {
      this._zr = e.getZr(), this._show = !1, this._hideTimeout;
    }

    o.prototype = {
      constructor: o,
      _enterable: !0,
      update: function update() {},
      show: function show(e) {
        this._hideTimeout && clearTimeout(this._hideTimeout), this.el.attr("show", !0), this._show = !0;
      },
      setContent: function setContent(e, t, n) {
        this.el && this._zr.remove(this.el);

        for (var i = {}, o = e, a = o.indexOf("{marker"); a >= 0;) {
          var s = o.indexOf("|}"),
              l = o.substr(a + "{marker".length, s - a - "{marker".length);
          l.indexOf("sub") > -1 ? i["marker" + l] = {
            textWidth: 4,
            textHeight: 4,
            textBorderRadius: 2,
            textBackgroundColor: t[l],
            textOffset: [3, 0]
          } : i["marker" + l] = {
            textWidth: 10,
            textHeight: 10,
            textBorderRadius: 5,
            textBackgroundColor: t[l]
          }, a = (o = o.substr(s + 1)).indexOf("{marker");
        }

        this.el = new r({
          style: {
            rich: i,
            text: e,
            textLineHeight: 20,
            textBackgroundColor: n.get("backgroundColor"),
            textBorderRadius: n.get("borderRadius"),
            textFill: n.get("textStyle.color"),
            textPadding: n.get("padding")
          },
          z: n.get("z")
        }), this._zr.add(this.el);
        var u = this;
        this.el.on("mouseover", function () {
          u._enterable && (clearTimeout(u._hideTimeout), u._show = !0), u._inContent = !0;
        }), this.el.on("mouseout", function () {
          u._enterable && u._show && u.hideLater(u._hideDelay), u._inContent = !1;
        });
      },
      setEnterable: function setEnterable(e) {
        this._enterable = e;
      },
      getSize: function getSize() {
        var e = this.el.getBoundingRect();
        return [e.width, e.height];
      },
      moveTo: function moveTo(e, t) {
        this.el && this.el.attr("position", [e, t]);
      },
      hide: function hide() {
        this.el && this.el.hide(), this._show = !1;
      },
      hideLater: function hideLater(e) {
        !this._show || this._inContent && this._enterable || (e ? (this._hideDelay = e, this._show = !1, this._hideTimeout = setTimeout(i.bind(this.hide, this), e)) : this.hide());
      },
      isShow: function isShow() {
        return this._show;
      },
      getOuterSize: function getOuterSize() {
        var e = this.getSize();
        return {
          width: e[0],
          height: e[1]
        };
      }
    };
    var a = o;
    e.exports = a;
  }, function (e, t, n) {
    var i = n(4),
        r = n(888);
    n(352), n(890), n(891), n(892), n(893), i.registerPreprocessor(r);
  }, function (e, t, n) {
    var i = n(1),
        r = ["rect", "polygon", "keep", "clear"];

    e.exports = function (e, t) {
      var n = e && e.brush;

      if (i.isArray(n) || (n = n ? [n] : []), n.length) {
        var o = [];
        i.each(n, function (e) {
          var t = e.hasOwnProperty("toolbox") ? e.toolbox : [];
          t instanceof Array && (o = o.concat(t));
        });
        var a = e && e.toolbox;
        i.isArray(a) && (a = a[0]), a || (a = {
          feature: {}
        }, e.toolbox = [a]);
        var s,
            l,
            u = a.feature || (a.feature = {}),
            c = u.brush || (u.brush = {}),
            h = c.type || (c.type = []);
        h.push.apply(h, o), s = h, l = {}, i.each(s, function (e) {
          l[e] = 1;
        }), s.length = 0, i.each(l, function (e, t) {
          s.push(t);
        }), t && !h.length && h.push.apply(h, r);
      }
    };
  }, function (e, t, n) {
    var i = n(318),
        r = n(17),
        o = n(5).linePolygonIntersect;

    function a(e) {
      var t = ["x", "y"],
          n = ["width", "height"];
      return {
        point: function point(t, n, i) {
          if (t) {
            var r = i.range;
            return s(t[e], r);
          }
        },
        rect: function rect(i, r, o) {
          if (i) {
            var a = o.range,
                l = [i[t[e]], i[t[e]] + i[n[e]]];
            return l[1] < l[0] && l.reverse(), s(l[0], a) || s(l[1], a) || s(a[0], l) || s(a[1], l);
          }
        }
      };
    }

    function s(e, t) {
      return t[0] <= e && e <= t[1];
    }

    var l = {
      lineX: a(0),
      lineY: a(1),
      rect: {
        point: function point(e, t, n) {
          return e && n.boundingRect.contain(e[0], e[1]);
        },
        rect: function rect(e, t, n) {
          return e && n.boundingRect.intersect(e);
        }
      },
      polygon: {
        point: function point(e, t, n) {
          return e && n.boundingRect.contain(e[0], e[1]) && i.contain(n.range, e[0], e[1]);
        },
        rect: function rect(e, t, n) {
          var a = n.range;
          if (!e || a.length <= 1) return !1;
          var s = e.x,
              l = e.y,
              u = e.width,
              c = e.height,
              h = a[0];
          return !!(i.contain(a, s, l) || i.contain(a, s + u, l) || i.contain(a, s, l + c) || i.contain(a, s + u, l + c) || r.create(e).contain(h[0], h[1]) || o(s, l, s + u, l, a) || o(s, l, s, l + c, a) || o(s + u, l, s + u, l + c, a) || o(s, l + c, s + u, l + c, a)) || void 0;
        }
      }
    };
    e.exports = l;
  }, function (e, t, n) {
    n(9).__DEV__;
    var i = n(4),
        r = n(1),
        o = n(169),
        a = n(22),
        s = ["#ddd"];

    function l(e, t) {
      return r.merge({
        brushType: e.brushType,
        brushMode: e.brushMode,
        transformable: e.transformable,
        brushStyle: new a(e.brushStyle).getItemStyle(),
        removeOnClick: e.removeOnClick,
        z: e.z
      }, t, !0);
    }

    var u = i.extendComponentModel({
      type: "brush",
      dependencies: ["geo", "grid", "xAxis", "yAxis", "parallel", "series"],
      defaultOption: {
        toolbox: null,
        brushLink: null,
        seriesIndex: "all",
        geoIndex: null,
        xAxisIndex: null,
        yAxisIndex: null,
        brushType: "rect",
        brushMode: "single",
        transformable: !0,
        brushStyle: {
          borderWidth: 1,
          color: "rgba(120,140,180,0.3)",
          borderColor: "rgba(120,140,180,0.8)"
        },
        throttleType: "fixRate",
        throttleDelay: 0,
        removeOnClick: !0,
        z: 1e4
      },
      areas: [],
      brushType: null,
      brushOption: {},
      coordInfoList: [],
      optionUpdated: function optionUpdated(e, t) {
        var n = this.option;
        !t && o.replaceVisualOption(n, e, ["inBrush", "outOfBrush"]);
        var i = n.inBrush = n.inBrush || {};
        n.outOfBrush = n.outOfBrush || {
          color: s
        }, i.hasOwnProperty("liftZ") || (i.liftZ = 5);
      },
      setAreas: function setAreas(e) {
        e && (this.areas = r.map(e, function (e) {
          return l(this.option, e);
        }, this));
      },
      setBrushOption: function setBrushOption(e) {
        this.brushOption = l(this.option, e), this.brushType = this.brushOption.brushType;
      }
    });
    e.exports = u;
  }, function (e, t, n) {
    var i = n(4),
        r = n(1),
        o = n(224),
        a = n(352).layoutCovers,
        s = i.extendComponentView({
      type: "brush",
      init: function init(e, t) {
        this.ecModel = e, this.api = t, this.model, (this._brushController = new o(t.getZr())).on("brush", r.bind(this._onBrush, this)).mount();
      },
      render: function render(e) {
        return this.model = e, l.apply(this, arguments);
      },
      updateTransform: function updateTransform(e, t) {
        return a(t), l.apply(this, arguments);
      },
      updateView: l,
      dispose: function dispose() {
        this._brushController.dispose();
      },
      _onBrush: function _onBrush(e, t) {
        var n = this.model.id;
        this.model.brushTargetManager.setOutputRanges(e, this.ecModel), (!t.isEnd || t.removeOnClick) && this.api.dispatchAction({
          type: "brush",
          brushId: n,
          areas: r.clone(e),
          $from: n
        }), t.isEnd && this.api.dispatchAction({
          type: "brushEnd",
          brushId: n,
          areas: r.clone(e),
          $from: n
        });
      }
    });

    function l(e, t, n, i) {
      (!i || i.$from !== e.id) && this._brushController.setPanels(e.brushTargetManager.makePanelOpts(n)).enableBrush(e.brushOption).updateCovers(e.areas.slice());
    }

    e.exports = s;
  }, function (e, t, n) {
    var i = n(4);
    i.registerAction({
      type: "brush",
      event: "brush"
    }, function (e, t) {
      t.eachComponent({
        mainType: "brush",
        query: e
      }, function (t) {
        t.setAreas(e.areas);
      });
    }), i.registerAction({
      type: "brushSelect",
      event: "brushSelected",
      update: "none"
    }, function () {}), i.registerAction({
      type: "brushEnd",
      event: "brushEnd",
      update: "none"
    }, function () {});
  }, function (e, t, n) {
    var i = n(1),
        r = n(71),
        o = n(68).toolbox.brush;

    function a(e, t, n) {
      this.model = e, this.ecModel = t, this.api = n, this._brushType, this._brushMode;
    }

    a.defaultOption = {
      show: !0,
      type: ["rect", "polygon", "lineX", "lineY", "keep", "clear"],
      icon: {
        rect: "M7.3,34.7 M0.4,10V-0.2h9.8 M89.6,10V-0.2h-9.8 M0.4,60v10.2h9.8 M89.6,60v10.2h-9.8 M12.3,22.4V10.5h13.1 M33.6,10.5h7.8 M49.1,10.5h7.8 M77.5,22.4V10.5h-13 M12.3,31.1v8.2 M77.7,31.1v8.2 M12.3,47.6v11.9h13.1 M33.6,59.5h7.6 M49.1,59.5 h7.7 M77.5,47.6v11.9h-13",
        polygon: "M55.2,34.9c1.7,0,3.1,1.4,3.1,3.1s-1.4,3.1-3.1,3.1 s-3.1-1.4-3.1-3.1S53.5,34.9,55.2,34.9z M50.4,51c1.7,0,3.1,1.4,3.1,3.1c0,1.7-1.4,3.1-3.1,3.1c-1.7,0-3.1-1.4-3.1-3.1 C47.3,52.4,48.7,51,50.4,51z M55.6,37.1l1.5-7.8 M60.1,13.5l1.6-8.7l-7.8,4 M59,19l-1,5.3 M24,16.1l6.4,4.9l6.4-3.3 M48.5,11.6 l-5.9,3.1 M19.1,12.8L9.7,5.1l1.1,7.7 M13.4,29.8l1,7.3l6.6,1.6 M11.6,18.4l1,6.1 M32.8,41.9 M26.6,40.4 M27.3,40.2l6.1,1.6 M49.9,52.1l-5.6-7.6l-4.9-1.2",
        lineX: "M15.2,30 M19.7,15.6V1.9H29 M34.8,1.9H40.4 M55.3,15.6V1.9H45.9 M19.7,44.4V58.1H29 M34.8,58.1H40.4 M55.3,44.4 V58.1H45.9 M12.5,20.3l-9.4,9.6l9.6,9.8 M3.1,29.9h16.5 M62.5,20.3l9.4,9.6L62.3,39.7 M71.9,29.9H55.4",
        lineY: "M38.8,7.7 M52.7,12h13.2v9 M65.9,26.6V32 M52.7,46.3h13.2v-9 M24.9,12H11.8v9 M11.8,26.6V32 M24.9,46.3H11.8v-9 M48.2,5.1l-9.3-9l-9.4,9.2 M38.9-3.9V12 M48.2,53.3l-9.3,9l-9.4-9.2 M38.9,62.3V46.4",
        keep: "M4,10.5V1h10.3 M20.7,1h6.1 M33,1h6.1 M55.4,10.5V1H45.2 M4,17.3v6.6 M55.6,17.3v6.6 M4,30.5V40h10.3 M20.7,40 h6.1 M33,40h6.1 M55.4,30.5V40H45.2 M21,18.9h62.9v48.6H21V18.9z",
        clear: "M22,14.7l30.9,31 M52.9,14.7L22,45.7 M4.7,16.8V4.2h13.1 M26,4.2h7.8 M41.6,4.2h7.8 M70.3,16.8V4.2H57.2 M4.7,25.9v8.6 M70.3,25.9v8.6 M4.7,43.2v12.6h13.1 M26,55.8h7.8 M41.6,55.8h7.8 M70.3,43.2v12.6H57.2"
      },
      title: i.clone(o.title)
    };
    var s = a.prototype;
    s.render = s.updateView = function (e, t, n) {
      var r, o, a;
      t.eachComponent({
        mainType: "brush"
      }, function (e) {
        r = e.brushType, o = e.brushOption.brushMode || "single", a |= e.areas.length;
      }), this._brushType = r, this._brushMode = o, i.each(e.get("type", !0), function (t) {
        e.setIconStatus(t, ("keep" === t ? "multiple" === o : "clear" === t ? a : t === r) ? "emphasis" : "normal");
      });
    }, s.getIcons = function () {
      var e = this.model,
          t = e.get("icon", !0),
          n = {};
      return i.each(e.get("type", !0), function (e) {
        t[e] && (n[e] = t[e]);
      }), n;
    }, s.onclick = function (e, t, n) {
      var i = this._brushType,
          r = this._brushMode;
      "clear" === n ? (t.dispatchAction({
        type: "axisAreaSelect",
        intervals: []
      }), t.dispatchAction({
        type: "brush",
        command: "clear",
        areas: []
      })) : t.dispatchAction({
        type: "takeGlobalCursor",
        key: "brush",
        brushOption: {
          brushType: "keep" === n ? i : i !== n && n,
          brushMode: "keep" === n ? "multiple" === r ? "single" : "multiple" : r
        }
      });
    }, r.register("brush", a);
    var l = a;
    e.exports = l;
  }, function (e, t, n) {
    var i = n(1),
        r = n(4),
        o = n(5),
        a = n(14).getLayoutRect,
        s = n(15).windowOpen;
    r.extendComponentModel({
      type: "title",
      layoutMode: {
        type: "box",
        ignoreSize: !0
      },
      defaultOption: {
        zlevel: 0,
        z: 6,
        show: !0,
        text: "",
        target: "blank",
        subtext: "",
        subtarget: "blank",
        left: 0,
        top: 0,
        backgroundColor: "rgba(0,0,0,0)",
        borderColor: "#ccc",
        borderWidth: 0,
        padding: 5,
        itemGap: 10,
        textStyle: {
          fontSize: 18,
          fontWeight: "bolder",
          color: "#333"
        },
        subtextStyle: {
          color: "#aaa"
        }
      }
    }), r.extendComponentView({
      type: "title",
      render: function render(e, t, n) {
        if (this.group.removeAll(), e.get("show")) {
          var r = this.group,
              l = e.getModel("textStyle"),
              u = e.getModel("subtextStyle"),
              c = e.get("textAlign"),
              h = i.retrieve2(e.get("textBaseline"), e.get("textVerticalAlign")),
              d = new o.Text({
            style: o.setTextStyle({}, l, {
              text: e.get("text"),
              textFill: l.getTextColor()
            }, {
              disableBox: !0
            }),
            z2: 10
          }),
              f = d.getBoundingRect(),
              p = e.get("subtext"),
              g = new o.Text({
            style: o.setTextStyle({}, u, {
              text: p,
              textFill: u.getTextColor(),
              y: f.height + e.get("itemGap"),
              textVerticalAlign: "top"
            }, {
              disableBox: !0
            }),
            z2: 10
          }),
              v = e.get("link"),
              m = e.get("sublink"),
              y = e.get("triggerEvent", !0);
          d.silent = !v && !y, g.silent = !m && !y, v && d.on("click", function () {
            s(v, "_" + e.get("target"));
          }), m && g.on("click", function () {
            s(v, "_" + e.get("subtarget"));
          }), d.eventData = g.eventData = y ? {
            componentType: "title",
            componentIndex: e.componentIndex
          } : null, r.add(d), p && r.add(g);

          var x = r.getBoundingRect(),
              _ = e.getBoxLayoutParams();

          _.width = x.width, _.height = x.height;
          var b = a(_, {
            width: n.getWidth(),
            height: n.getHeight()
          }, e.get("padding"));
          c || ("middle" === (c = e.get("left") || e.get("right")) && (c = "center"), "right" === c ? b.x += b.width : "center" === c && (b.x += b.width / 2)), h || ("center" === (h = e.get("top") || e.get("bottom")) && (h = "middle"), "bottom" === h ? b.y += b.height : "middle" === h && (b.y += b.height / 2), h = h || "top"), r.attr("position", [b.x, b.y]);
          var w = {
            textAlign: c,
            textVerticalAlign: h
          };
          d.setStyle(w), g.setStyle(w), x = r.getBoundingRect();
          var S = b.margin,
              T = e.getItemStyle(["color", "opacity"]);
          T.fill = e.get("backgroundColor");
          var C = new o.Rect({
            shape: {
              x: x.x - S[3],
              y: x.y - S[0],
              width: x.width + S[1] + S[3],
              height: x.height + S[0] + S[2],
              r: e.get("borderRadius")
            },
            style: T,
            subPixelOptimize: !0,
            silent: !0
          });
          r.add(C);
        }
      }
    });
  }, function (e, t, n) {
    var i = n(4),
        r = n(896);
    n(897), n(898), n(899), n(901), i.registerPreprocessor(r);
  }, function (e, t, n) {
    var i = n(1);

    function r(e) {
      var t = e.itemStyle || (e.itemStyle = {}),
          n = t.emphasis || (t.emphasis = {}),
          r = e.label || e.label || {},
          a = r.normal || (r.normal = {}),
          s = {
        normal: 1,
        emphasis: 1
      };
      i.each(r, function (e, t) {
        s[t] || o(a, t) || (a[t] = e);
      }), n.label && !o(r, "emphasis") && (r.emphasis = n.label, delete n.label);
    }

    function o(e, t) {
      return e.hasOwnProperty(t);
    }

    e.exports = function (e) {
      var t = e && e.timeline;
      i.isArray(t) || (t = t ? [t] : []), i.each(t, function (e) {
        e && function (e) {
          var t = e.type,
              n = {
            number: "value",
            time: "time"
          };
          n[t] && (e.axisType = n[t], delete e.type);

          if (r(e), o(e, "controlPosition")) {
            var a = e.controlStyle || (e.controlStyle = {});
            o(a, "position") || (a.position = e.controlPosition), "none" !== a.position || o(a, "show") || (a.show = !1, delete a.position), delete e.controlPosition;
          }

          i.each(e.data || [], function (e) {
            i.isObject(e) && !i.isArray(e) && (!o(e, "value") && o(e, "name") && (e.value = e.name), r(e));
          });
        }(e);
      });
    };
  }, function (e, t, n) {
    n(26).registerSubTypeDefaulter("timeline", function () {
      return "slider";
    });
  }, function (e, t, n) {
    var i = n(4),
        r = n(1);
    i.registerAction({
      type: "timelineChange",
      event: "timelineChanged",
      update: "prepareAndUpdate"
    }, function (e, t) {
      var n = t.getComponent("timeline");
      return n && null != e.currentIndex && (n.setCurrentIndex(e.currentIndex), !n.get("loop", !0) && n.isIndexMax() && n.setPlayState(!1)), t.resetOption("timeline"), r.defaults({
        currentIndex: n.option.currentIndex
      }, e);
    }), i.registerAction({
      type: "timelinePlayChange",
      event: "timelinePlayChanged",
      update: "update"
    }, function (e, t) {
      var n = t.getComponent("timeline");
      n && null != e.playState && n.setPlayState(e.playState);
    });
  }, function (e, t, n) {
    var i = n(1),
        r = n(900),
        o = n(210),
        a = r.extend({
      type: "timeline.slider",
      defaultOption: {
        backgroundColor: "rgba(0,0,0,0)",
        borderColor: "#ccc",
        borderWidth: 0,
        orient: "horizontal",
        inverse: !1,
        tooltip: {
          trigger: "item"
        },
        symbol: "emptyCircle",
        symbolSize: 10,
        lineStyle: {
          show: !0,
          width: 2,
          color: "#304654"
        },
        label: {
          position: "auto",
          show: !0,
          interval: "auto",
          rotate: 0,
          color: "#304654"
        },
        itemStyle: {
          color: "#304654",
          borderWidth: 1
        },
        checkpointStyle: {
          symbol: "circle",
          symbolSize: 13,
          color: "#c23531",
          borderWidth: 5,
          borderColor: "rgba(194,53,49, 0.5)",
          animation: !0,
          animationDuration: 300,
          animationEasing: "quinticInOut"
        },
        controlStyle: {
          show: !0,
          showPlayBtn: !0,
          showPrevBtn: !0,
          showNextBtn: !0,
          itemSize: 22,
          itemGap: 12,
          position: "left",
          playIcon: "path://M31.6,53C17.5,53,6,41.5,6,27.4S17.5,1.8,31.6,1.8C45.7,1.8,57.2,13.3,57.2,27.4S45.7,53,31.6,53z M31.6,3.3 C18.4,3.3,7.5,14.1,7.5,27.4c0,13.3,10.8,24.1,24.1,24.1C44.9,51.5,55.7,40.7,55.7,27.4C55.7,14.1,44.9,3.3,31.6,3.3z M24.9,21.3 c0-2.2,1.6-3.1,3.5-2l10.5,6.1c1.899,1.1,1.899,2.9,0,4l-10.5,6.1c-1.9,1.1-3.5,0.2-3.5-2V21.3z",
          stopIcon: "path://M30.9,53.2C16.8,53.2,5.3,41.7,5.3,27.6S16.8,2,30.9,2C45,2,56.4,13.5,56.4,27.6S45,53.2,30.9,53.2z M30.9,3.5C17.6,3.5,6.8,14.4,6.8,27.6c0,13.3,10.8,24.1,24.101,24.1C44.2,51.7,55,40.9,55,27.6C54.9,14.4,44.1,3.5,30.9,3.5z M36.9,35.8c0,0.601-0.4,1-0.9,1h-1.3c-0.5,0-0.9-0.399-0.9-1V19.5c0-0.6,0.4-1,0.9-1H36c0.5,0,0.9,0.4,0.9,1V35.8z M27.8,35.8 c0,0.601-0.4,1-0.9,1h-1.3c-0.5,0-0.9-0.399-0.9-1V19.5c0-0.6,0.4-1,0.9-1H27c0.5,0,0.9,0.4,0.9,1L27.8,35.8L27.8,35.8z",
          nextIcon: "path://M18.6,50.8l22.5-22.5c0.2-0.2,0.3-0.4,0.3-0.7c0-0.3-0.1-0.5-0.3-0.7L18.7,4.4c-0.1-0.1-0.2-0.3-0.2-0.5 c0-0.4,0.3-0.8,0.8-0.8c0.2,0,0.5,0.1,0.6,0.3l23.5,23.5l0,0c0.2,0.2,0.3,0.4,0.3,0.7c0,0.3-0.1,0.5-0.3,0.7l-0.1,0.1L19.7,52 c-0.1,0.1-0.3,0.2-0.5,0.2c-0.4,0-0.8-0.3-0.8-0.8C18.4,51.2,18.5,51,18.6,50.8z",
          prevIcon: "path://M43,52.8L20.4,30.3c-0.2-0.2-0.3-0.4-0.3-0.7c0-0.3,0.1-0.5,0.3-0.7L42.9,6.4c0.1-0.1,0.2-0.3,0.2-0.5 c0-0.4-0.3-0.8-0.8-0.8c-0.2,0-0.5,0.1-0.6,0.3L18.3,28.8l0,0c-0.2,0.2-0.3,0.4-0.3,0.7c0,0.3,0.1,0.5,0.3,0.7l0.1,0.1L41.9,54 c0.1,0.1,0.3,0.2,0.5,0.2c0.4,0,0.8-0.3,0.8-0.8C43.2,53.2,43.1,53,43,52.8z",
          color: "#304654",
          borderColor: "#304654",
          borderWidth: 1
        },
        emphasis: {
          label: {
            show: !0,
            color: "#c23531"
          },
          itemStyle: {
            color: "#c23531"
          },
          controlStyle: {
            color: "#c23531",
            borderColor: "#c23531",
            borderWidth: 2
          }
        },
        data: []
      }
    });
    i.mixin(a, o);
    var s = a;
    e.exports = s;
  }, function (e, t, n) {
    var i = n(1),
        r = n(26),
        o = n(39),
        a = n(8),
        s = r.extend({
      type: "timeline",
      layoutMode: "box",
      defaultOption: {
        zlevel: 0,
        z: 4,
        show: !0,
        axisType: "time",
        realtime: !0,
        left: "20%",
        top: null,
        right: "20%",
        bottom: 0,
        width: null,
        height: 40,
        padding: 5,
        controlPosition: "left",
        autoPlay: !1,
        rewind: !1,
        loop: !0,
        playInterval: 2e3,
        currentIndex: 0,
        itemStyle: {},
        label: {
          color: "#000"
        },
        data: []
      },
      init: function init(e, t, n) {
        this._data, this._names, this.mergeDefaultAndTheme(e, n), this._initData();
      },
      mergeOption: function mergeOption(e) {
        s.superApply(this, "mergeOption", arguments), this._initData();
      },
      setCurrentIndex: function setCurrentIndex(e) {
        null == e && (e = this.option.currentIndex);

        var t = this._data.count();

        this.option.loop ? e = (e % t + t) % t : (e >= t && (e = t - 1), e < 0 && (e = 0)), this.option.currentIndex = e;
      },
      getCurrentIndex: function getCurrentIndex() {
        return this.option.currentIndex;
      },
      isIndexMax: function isIndexMax() {
        return this.getCurrentIndex() >= this._data.count() - 1;
      },
      setPlayState: function setPlayState(e) {
        this.option.autoPlay = !!e;
      },
      getPlayState: function getPlayState() {
        return !!this.option.autoPlay;
      },
      _initData: function _initData() {
        var e = this.option,
            t = e.data || [],
            n = e.axisType,
            r = this._names = [];

        if ("category" === n) {
          var s = [];
          i.each(t, function (e, t) {
            var n,
                o = a.getDataItemValue(e);
            i.isObject(e) ? (n = i.clone(e)).value = t : n = t, s.push(n), i.isString(o) || null != o && !isNaN(o) || (o = ""), r.push(o + "");
          }), t = s;
        }

        var l = {
          category: "ordinal",
          time: "time"
        }[n] || "number";
        (this._data = new o([{
          name: "value",
          type: l
        }], this)).initData(t, r);
      },
      getData: function getData() {
        return this._data;
      },
      getCategories: function getCategories() {
        if ("category" === this.get("axisType")) return this._names.slice();
      }
    }),
        l = s;
    e.exports = l;
  }, function (e, t, n) {
    var i = n(1),
        r = n(17),
        o = n(31),
        a = n(5),
        s = n(14),
        l = n(902),
        u = n(903),
        c = n(40).createSymbol,
        h = n(43),
        d = n(6),
        f = n(15).encodeHTML,
        p = i.bind,
        g = i.each,
        v = Math.PI,
        m = l.extend({
      type: "timeline.slider",
      init: function init(e, t) {
        this.api = t, this._axis, this._viewRect, this._timer, this._currentPointer, this._mainGroup, this._labelGroup;
      },
      render: function render(e, t, n, i) {
        if (this.model = e, this.api = n, this.ecModel = t, this.group.removeAll(), e.get("show", !0)) {
          var r = this._layout(e, n),
              o = this._createGroup("mainGroup"),
              a = this._createGroup("labelGroup"),
              s = this._axis = this._createAxis(r, e);

          e.formatTooltip = function (e) {
            return f(s.scale.getLabel(e));
          }, g(["AxisLine", "AxisTick", "Control", "CurrentPointer"], function (t) {
            this["_render" + t](r, o, s, e);
          }, this), this._renderAxisLabel(r, a, s, e), this._position(r, e);
        }

        this._doPlayStop();
      },
      remove: function remove() {
        this._clearTimer(), this.group.removeAll();
      },
      dispose: function dispose() {
        this._clearTimer();
      },
      _layout: function _layout(e, t) {
        var n = e.get("label.position"),
            i = e.get("orient"),
            r = function (e, t) {
          return s.getLayoutRect(e.getBoxLayoutParams(), {
            width: t.getWidth(),
            height: t.getHeight()
          }, e.get("padding"));
        }(e, t);

        null == n || "auto" === n ? n = "horizontal" === i ? r.y + r.height / 2 < t.getHeight() / 2 ? "-" : "+" : r.x + r.width / 2 < t.getWidth() / 2 ? "+" : "-" : isNaN(n) && (n = {
          horizontal: {
            top: "-",
            bottom: "+"
          },
          vertical: {
            left: "-",
            right: "+"
          }
        }[i][n]);

        var o,
            a,
            l,
            u,
            c = {
          horizontal: "center",
          vertical: n >= 0 || "+" === n ? "left" : "right"
        },
            h = {
          horizontal: n >= 0 || "+" === n ? "top" : "bottom",
          vertical: "middle"
        },
            d = {
          horizontal: 0,
          vertical: v / 2
        },
            f = "vertical" === i ? r.height : r.width,
            p = e.getModel("controlStyle"),
            g = p.get("show", !0),
            m = g ? p.get("itemSize") : 0,
            y = g ? p.get("itemGap") : 0,
            x = m + y,
            _ = e.get("label.rotate") || 0;

        _ = _ * v / 180;
        var b = p.get("position", !0),
            w = g && p.get("showPlayBtn", !0),
            S = g && p.get("showPrevBtn", !0),
            T = g && p.get("showNextBtn", !0),
            C = 0,
            k = f;
        return "left" === b || "bottom" === b ? (w && (o = [0, 0], C += x), S && (a = [C, 0], C += x), T && (l = [k - m, 0], k -= x)) : (w && (o = [k - m, 0], k -= x), S && (a = [0, 0], C += x), T && (l = [k - m, 0], k -= x)), u = [C, k], e.get("inverse") && u.reverse(), {
          viewRect: r,
          mainLength: f,
          orient: i,
          rotation: d[i],
          labelRotation: _,
          labelPosOpt: n,
          labelAlign: e.get("label.align") || c[i],
          labelBaseline: e.get("label.verticalAlign") || e.get("label.baseline") || h[i],
          playPosition: o,
          prevBtnPosition: a,
          nextBtnPosition: l,
          axisExtent: u,
          controlSize: m,
          controlGap: y
        };
      },
      _position: function _position(e, t) {
        var n = this._mainGroup,
            i = this._labelGroup,
            r = e.viewRect;

        if ("vertical" === e.orient) {
          var a = o.create(),
              s = r.x,
              l = r.y + r.height;
          o.translate(a, a, [-s, -l]), o.rotate(a, a, -v / 2), o.translate(a, a, [s, l]), (r = r.clone()).applyTransform(a);
        }

        var u = y(r),
            c = y(n.getBoundingRect()),
            h = y(i.getBoundingRect()),
            d = n.position,
            f = i.position;
        f[0] = d[0] = u[0][0];
        var p,
            g = e.labelPosOpt;
        isNaN(g) ? (x(d, c, u, 1, p = "+" === g ? 0 : 1), x(f, h, u, 1, 1 - p)) : (x(d, c, u, 1, p = g >= 0 ? 0 : 1), f[1] = d[1] + g);

        function m(e) {
          var t = e.position;
          e.origin = [u[0][0] - t[0], u[1][0] - t[1]];
        }

        function y(e) {
          return [[e.x, e.x + e.width], [e.y, e.y + e.height]];
        }

        function x(e, t, n, i, r) {
          e[i] += n[i][r] - t[i][r];
        }

        n.attr("position", d), i.attr("position", f), n.rotation = i.rotation = e.rotation, m(n), m(i);
      },
      _createAxis: function _createAxis(e, t) {
        var n = t.getData(),
            i = t.get("axisType"),
            r = h.createScaleByModel(t, i);

        r.getTicks = function () {
          return n.mapArray(["value"], function (e) {
            return e;
          });
        };

        var o = n.getDataExtent("value");
        r.setExtent(o[0], o[1]), r.niceTicks();
        var a = new u("value", r, e.axisExtent, i);
        return a.model = t, a;
      },
      _createGroup: function _createGroup(e) {
        var t = this["_" + e] = new a.Group();
        return this.group.add(t), t;
      },
      _renderAxisLine: function _renderAxisLine(e, t, n, r) {
        var o = n.getExtent();
        r.get("lineStyle.show") && t.add(new a.Line({
          shape: {
            x1: o[0],
            y1: 0,
            x2: o[1],
            y2: 0
          },
          style: i.extend({
            lineCap: "round"
          }, r.getModel("lineStyle").getLineStyle()),
          silent: !0,
          z2: 1
        }));
      },
      _renderAxisTick: function _renderAxisTick(e, t, n, i) {
        var r = i.getData(),
            o = n.scale.getTicks();
        g(o, function (e) {
          var o = n.dataToCoord(e),
              s = r.getItemModel(e),
              l = s.getModel("itemStyle"),
              u = s.getModel("emphasis.itemStyle"),
              c = {
            position: [o, 0],
            onclick: p(this._changeTimeline, this, e)
          },
              h = y(s, l, t, c);
          a.setHoverStyle(h, u.getItemStyle()), s.get("tooltip") ? (h.dataIndex = e, h.dataModel = i) : h.dataIndex = h.dataModel = null;
        }, this);
      },
      _renderAxisLabel: function _renderAxisLabel(e, t, n, i) {
        if (n.getLabelModel().get("show")) {
          var r = i.getData(),
              o = n.getViewLabels();
          g(o, function (i) {
            var o = i.tickValue,
                s = r.getItemModel(o),
                l = s.getModel("label"),
                u = s.getModel("emphasis.label"),
                c = n.dataToCoord(i.tickValue),
                h = new a.Text({
              position: [c, 0],
              rotation: e.labelRotation - e.rotation,
              onclick: p(this._changeTimeline, this, o),
              silent: !1
            });
            a.setTextStyle(h.style, l, {
              text: i.formattedLabel,
              textAlign: e.labelAlign,
              textVerticalAlign: e.labelBaseline
            }), t.add(h), a.setHoverStyle(h, a.setTextStyle({}, u));
          }, this);
        }
      },
      _renderControl: function _renderControl(e, t, n, o) {
        var s = e.controlSize,
            l = e.rotation,
            u = o.getModel("controlStyle").getItemStyle(),
            c = o.getModel("emphasis.controlStyle").getItemStyle(),
            h = [0, -s / 2, s, s],
            d = o.getPlayState(),
            f = o.get("inverse", !0);

        function g(e, n, d, f) {
          if (e) {
            var p = function (e, t, n, o) {
              return a.makePath(e.get(t).replace(/^path:\/\//, ""), i.clone(o || {}), new r(n[0], n[1], n[2], n[3]), "center");
            }(o, n, h, {
              position: e,
              origin: [s / 2, 0],
              rotation: f ? -l : 0,
              rectHover: !0,
              style: u,
              onclick: d
            });

            t.add(p), a.setHoverStyle(p, c);
          }
        }

        g(e.nextBtnPosition, "controlStyle.nextIcon", p(this._changeTimeline, this, f ? "-" : "+")), g(e.prevBtnPosition, "controlStyle.prevIcon", p(this._changeTimeline, this, f ? "+" : "-")), g(e.playPosition, "controlStyle." + (d ? "stopIcon" : "playIcon"), p(this._handlePlayClick, this, !d), !0);
      },
      _renderCurrentPointer: function _renderCurrentPointer(e, t, n, i) {
        var r = i.getData(),
            o = i.getCurrentIndex(),
            a = r.getItemModel(o).getModel("checkpointStyle"),
            s = this,
            l = {
          onCreate: function onCreate(e) {
            e.draggable = !0, e.drift = p(s._handlePointerDrag, s), e.ondragend = p(s._handlePointerDragend, s), x(e, o, n, i, !0);
          },
          onUpdate: function onUpdate(e) {
            x(e, o, n, i);
          }
        };
        this._currentPointer = y(a, a, this._mainGroup, {}, this._currentPointer, l);
      },
      _handlePlayClick: function _handlePlayClick(e) {
        this._clearTimer(), this.api.dispatchAction({
          type: "timelinePlayChange",
          playState: e,
          from: this.uid
        });
      },
      _handlePointerDrag: function _handlePointerDrag(e, t, n) {
        this._clearTimer(), this._pointerChangeTimeline([n.offsetX, n.offsetY]);
      },
      _handlePointerDragend: function _handlePointerDragend(e) {
        this._pointerChangeTimeline([e.offsetX, e.offsetY], !0);
      },
      _pointerChangeTimeline: function _pointerChangeTimeline(e, t) {
        var n = this._toAxisCoord(e)[0],
            i = this._axis,
            r = d.asc(i.getExtent().slice());

        n > r[1] && (n = r[1]), n < r[0] && (n = r[0]), this._currentPointer.position[0] = n, this._currentPointer.dirty();

        var o = this._findNearestTick(n),
            a = this.model;

        (t || o !== a.getCurrentIndex() && a.get("realtime")) && this._changeTimeline(o);
      },
      _doPlayStop: function _doPlayStop() {
        this._clearTimer(), this.model.getPlayState() && (this._timer = setTimeout(p(function () {
          var e = this.model;

          this._changeTimeline(e.getCurrentIndex() + (e.get("rewind", !0) ? -1 : 1));
        }, this), this.model.get("playInterval")));
      },
      _toAxisCoord: function _toAxisCoord(e) {
        var t = this._mainGroup.getLocalTransform();

        return a.applyTransform(e, t, !0);
      },
      _findNearestTick: function _findNearestTick(e) {
        var t,
            n = this.model.getData(),
            i = 1 / 0,
            r = this._axis;
        return n.each(["value"], function (n, o) {
          var a = r.dataToCoord(n),
              s = Math.abs(a - e);
          s < i && (i = s, t = o);
        }), t;
      },
      _clearTimer: function _clearTimer() {
        this._timer && (clearTimeout(this._timer), this._timer = null);
      },
      _changeTimeline: function _changeTimeline(e) {
        var t = this.model.getCurrentIndex();
        "+" === e ? e = t + 1 : "-" === e && (e = t - 1), this.api.dispatchAction({
          type: "timelineChange",
          currentIndex: e,
          from: this.uid
        });
      }
    });

    function y(e, t, n, r, o, a) {
      var s = t.get("color");
      if (o) o.setColor(s), n.add(o), a && a.onUpdate(o);else {
        var l = e.get("symbol");
        (o = c(l, -1, -1, 2, 2, s)).setStyle("strokeNoScale", !0), n.add(o), a && a.onCreate(o);
      }
      var u = t.getItemStyle(["color", "symbol", "symbolSize"]);
      o.setStyle(u), r = i.merge({
        rectHover: !0,
        z2: 100
      }, r, !0);
      var h = e.get("symbolSize");
      (h = h instanceof Array ? h.slice() : [+h, +h])[0] /= 2, h[1] /= 2, r.scale = h;
      var f = e.get("symbolOffset");

      if (f) {
        var p = r.position = r.position || [0, 0];
        p[0] += d.parsePercent(f[0], h[0]), p[1] += d.parsePercent(f[1], h[1]);
      }

      var g = e.get("symbolRotate");
      return r.rotation = (g || 0) * Math.PI / 180 || 0, o.attr(r), o.updateTransform(), o;
    }

    function x(e, t, n, i, r) {
      if (!e.dragging) {
        var o = i.getModel("checkpointStyle"),
            a = n.dataToCoord(i.getData().get(["value"], t));
        r || !o.get("animation", !0) ? e.attr({
          position: [a, 0]
        }) : (e.stopAnimation(!0), e.animateTo({
          position: [a, 0]
        }, o.get("animationDuration", !0), o.get("animationEasing", !0)));
      }
    }

    e.exports = m;
  }, function (e, t, n) {
    var i = n(158).extend({
      type: "timeline"
    });
    e.exports = i;
  }, function (e, t, n) {
    var i = n(1),
        r = n(69),
        o = function o(e, t, n, i) {
      r.call(this, e, t, n), this.type = i || "value", this.model = null;
    };

    o.prototype = {
      constructor: o,
      getLabelModel: function getLabelModel() {
        return this.model.getModel("label");
      },
      isHorizontal: function isHorizontal() {
        return "horizontal" === this.model.get("orient");
      }
    }, i.inherits(o, r);
    var a = o;
    e.exports = a;
  }, function (e, t, n) {
    var i = n(4);
    n(905), n(906), i.registerPreprocessor(function (e) {
      e.markPoint = e.markPoint || {};
    });
  }, function (e, t, n) {
    var i = n(231).extend({
      type: "markPoint",
      defaultOption: {
        zlevel: 0,
        z: 5,
        symbol: "pin",
        symbolSize: 50,
        tooltip: {
          trigger: "item"
        },
        label: {
          show: !0,
          position: "inside"
        },
        itemStyle: {
          borderWidth: 2
        },
        emphasis: {
          label: {
            show: !0
          }
        }
      }
    });
    e.exports = i;
  }, function (e, t, n) {
    var i = n(1),
        r = n(125),
        o = n(6),
        a = n(39),
        s = n(232);

    function l(e, t, n) {
      var i = t.coordinateSystem;
      e.each(function (r) {
        var a,
            s = e.getItemModel(r),
            l = o.parsePercent(s.get("x"), n.getWidth()),
            u = o.parsePercent(s.get("y"), n.getHeight());

        if (isNaN(l) || isNaN(u)) {
          if (t.getMarkerPosition) a = t.getMarkerPosition(e.getValues(e.dimensions, r));else if (i) {
            var c = e.get(i.dimensions[0], r),
                h = e.get(i.dimensions[1], r);
            a = i.dataToPoint([c, h]);
          }
        } else a = [l, u];

        isNaN(l) || (a[0] = l), isNaN(u) || (a[1] = u), e.setItemLayout(r, a);
      });
    }

    var u = n(233).extend({
      type: "markPoint",
      updateTransform: function updateTransform(e, t, n) {
        t.eachSeries(function (e) {
          var t = e.markPointModel;
          t && (l(t.getData(), e, n), this.markerGroupMap.get(e.id).updateLayout(t));
        }, this);
      },
      renderSeries: function renderSeries(e, t, n, o) {
        var u = e.coordinateSystem,
            c = e.id,
            h = e.getData(),
            d = this.markerGroupMap,
            f = d.get(c) || d.set(c, new r()),
            p = function (e, t, n) {
          var r;
          r = e ? i.map(e && e.dimensions, function (e) {
            var n = t.getData().getDimensionInfo(t.getData().mapDimension(e)) || {};
            return i.defaults({
              name: e
            }, n);
          }) : [{
            name: "value",
            type: "float"
          }];
          var o = new a(r, n),
              l = i.map(n.get("data"), i.curry(s.dataTransform, t));
          e && (l = i.filter(l, i.curry(s.dataFilter, e)));
          return o.initData(l, null, e ? s.dimValueGetter : function (e) {
            return e.value;
          }), o;
        }(u, e, t);

        t.setData(p), l(t.getData(), e, o), p.each(function (e) {
          var n = p.getItemModel(e),
              r = n.getShallow("symbol"),
              o = n.getShallow("symbolSize"),
              a = i.isFunction(r),
              s = i.isFunction(o);

          if (a || s) {
            var l = t.getRawValue(e),
                u = t.getDataParams(e);
            a && (r = r(l, u)), s && (o = o(l, u));
          }

          p.setItemVisual(e, {
            symbol: r,
            symbolSize: o,
            color: n.get("itemStyle.color") || h.getVisual("color")
          });
        }), f.updateData(p), this.group.add(f.group), p.eachItemGraphicEl(function (e) {
          e.traverse(function (e) {
            e.dataModel = t;
          });
        }), f.__keep = !0, f.group.silent = t.get("silent") || e.get("silent");
      }
    });
    e.exports = u;
  }, function (e, t, n) {
    var i = n(4);
    n(908), n(909), i.registerPreprocessor(function (e) {
      e.markLine = e.markLine || {};
    });
  }, function (e, t, n) {
    var i = n(231).extend({
      type: "markLine",
      defaultOption: {
        zlevel: 0,
        z: 5,
        symbol: ["circle", "arrow"],
        symbolSize: [8, 16],
        precision: 2,
        tooltip: {
          trigger: "item"
        },
        label: {
          show: !0,
          position: "end",
          distance: 5
        },
        lineStyle: {
          type: "dashed"
        },
        emphasis: {
          label: {
            show: !0
          },
          lineStyle: {
            width: 3
          }
        },
        animationEasing: "linear"
      }
    });
    e.exports = i;
  }, function (e, t, n) {
    var i = n(1),
        r = n(39),
        o = n(6),
        a = n(232),
        s = n(221),
        l = n(233),
        u = n(55).getStackedDimension,
        c = function c(e, t, n, r) {
      var o = e.getData(),
          s = r.type;

      if (!i.isArray(r) && ("min" === s || "max" === s || "average" === s || "median" === s || null != r.xAxis || null != r.yAxis)) {
        var l, c;
        if (null != r.yAxis || null != r.xAxis) l = t.getAxis(null != r.yAxis ? "y" : "x"), c = i.retrieve(r.yAxis, r.xAxis);else {
          var h = a.getAxisInfo(r, o, t, e);
          l = h.valueAxis;
          var d = u(o, h.valueDataDim);
          c = a.numCalculate(o, d, s);
        }
        var f = "x" === l.dim ? 0 : 1,
            p = 1 - f,
            g = i.clone(r),
            v = {};
        g.type = null, g.coord = [], v.coord = [], g.coord[p] = -1 / 0, v.coord[p] = 1 / 0;
        var m = n.get("precision");
        m >= 0 && "number" == typeof c && (c = +c.toFixed(Math.min(m, 20))), g.coord[f] = v.coord[f] = c, r = [g, v, {
          type: s,
          valueIndex: r.valueIndex,
          value: c
        }];
      }

      return (r = [a.dataTransform(e, r[0]), a.dataTransform(e, r[1]), i.extend({}, r[2])])[2].type = r[2].type || "", i.merge(r[2], r[0]), i.merge(r[2], r[1]), r;
    };

    function h(e) {
      return !isNaN(e) && !isFinite(e);
    }

    function d(e, t, n, i) {
      var r = 1 - e,
          o = i.dimensions[e];
      return h(t[r]) && h(n[r]) && t[e] === n[e] && i.getAxis(o).containData(t[e]);
    }

    function f(e, t) {
      if ("cartesian2d" === e.type) {
        var n = t[0].coord,
            i = t[1].coord;
        if (n && i && (d(1, n, i, e) || d(0, n, i, e))) return !0;
      }

      return a.dataFilter(e, t[0]) && a.dataFilter(e, t[1]);
    }

    function p(e, t, n, i, r) {
      var a,
          s = i.coordinateSystem,
          l = e.getItemModel(t),
          u = o.parsePercent(l.get("x"), r.getWidth()),
          c = o.parsePercent(l.get("y"), r.getHeight());

      if (isNaN(u) || isNaN(c)) {
        if (i.getMarkerPosition) a = i.getMarkerPosition(e.getValues(e.dimensions, t));else {
          var d = s.dimensions,
              f = e.get(d[0], t),
              p = e.get(d[1], t);
          a = s.dataToPoint([f, p]);
        }

        if ("cartesian2d" === s.type) {
          var g = s.getAxis("x"),
              v = s.getAxis("y");
          d = s.dimensions;
          h(e.get(d[0], t)) ? a[0] = g.toGlobalCoord(g.getExtent()[n ? 0 : 1]) : h(e.get(d[1], t)) && (a[1] = v.toGlobalCoord(v.getExtent()[n ? 0 : 1]));
        }

        isNaN(u) || (a[0] = u), isNaN(c) || (a[1] = c);
      } else a = [u, c];

      e.setItemLayout(t, a);
    }

    var g = l.extend({
      type: "markLine",
      updateTransform: function updateTransform(e, t, n) {
        t.eachSeries(function (e) {
          var t = e.markLineModel;

          if (t) {
            var i = t.getData(),
                r = t.__from,
                o = t.__to;
            r.each(function (t) {
              p(r, t, !0, e, n), p(o, t, !1, e, n);
            }), i.each(function (e) {
              i.setItemLayout(e, [r.getItemLayout(e), o.getItemLayout(e)]);
            }), this.markerGroupMap.get(e.id).updateLayout();
          }
        }, this);
      },
      renderSeries: function renderSeries(e, t, n, o) {
        var l = e.coordinateSystem,
            u = e.id,
            h = e.getData(),
            d = this.markerGroupMap,
            g = d.get(u) || d.set(u, new s());
        this.group.add(g.group);

        var v = function (e, t, n) {
          var o;
          o = e ? i.map(e && e.dimensions, function (e) {
            var n = t.getData().getDimensionInfo(t.getData().mapDimension(e)) || {};
            return i.defaults({
              name: e
            }, n);
          }) : [{
            name: "value",
            type: "float"
          }];
          var s = new r(o, n),
              l = new r(o, n),
              u = new r([], n),
              h = i.map(n.get("data"), i.curry(c, t, e, n));
          e && (h = i.filter(h, i.curry(f, e)));
          var d = e ? a.dimValueGetter : function (e) {
            return e.value;
          };
          return s.initData(i.map(h, function (e) {
            return e[0];
          }), null, d), l.initData(i.map(h, function (e) {
            return e[1];
          }), null, d), u.initData(i.map(h, function (e) {
            return e[2];
          })), u.hasItemOption = !0, {
            from: s,
            to: l,
            line: u
          };
        }(l, e, t),
            m = v.from,
            y = v.to,
            x = v.line;

        t.__from = m, t.__to = y, t.setData(x);

        var _ = t.get("symbol"),
            b = t.get("symbolSize");

        function w(t, n, i) {
          var r = t.getItemModel(n);
          p(t, n, i, e, o), t.setItemVisual(n, {
            symbolSize: r.get("symbolSize") || b[i ? 0 : 1],
            symbol: r.get("symbol", !0) || _[i ? 0 : 1],
            color: r.get("itemStyle.color") || h.getVisual("color")
          });
        }

        i.isArray(_) || (_ = [_, _]), "number" == typeof b && (b = [b, b]), v.from.each(function (e) {
          w(m, e, !0), w(y, e, !1);
        }), x.each(function (e) {
          var t = x.getItemModel(e).get("lineStyle.color");
          x.setItemVisual(e, {
            color: t || m.getItemVisual(e, "color")
          }), x.setItemLayout(e, [m.getItemLayout(e), y.getItemLayout(e)]), x.setItemVisual(e, {
            fromSymbolSize: m.getItemVisual(e, "symbolSize"),
            fromSymbol: m.getItemVisual(e, "symbol"),
            toSymbolSize: y.getItemVisual(e, "symbolSize"),
            toSymbol: y.getItemVisual(e, "symbol")
          });
        }), g.updateData(x), v.line.eachItemGraphicEl(function (e, n) {
          e.traverse(function (e) {
            e.dataModel = t;
          });
        }), g.__keep = !0, g.group.silent = t.get("silent") || e.get("silent");
      }
    });
    e.exports = g;
  }, function (e, t, n) {
    var i = n(4);
    n(911), n(912), i.registerPreprocessor(function (e) {
      e.markArea = e.markArea || {};
    });
  }, function (e, t, n) {
    var i = n(231).extend({
      type: "markArea",
      defaultOption: {
        zlevel: 0,
        z: 1,
        tooltip: {
          trigger: "item"
        },
        animation: !1,
        label: {
          show: !0,
          position: "top"
        },
        itemStyle: {
          borderWidth: 0
        },
        emphasis: {
          label: {
            show: !0,
            position: "top"
          }
        }
      }
    });
    e.exports = i;
  }, function (e, t, n) {
    var i = n(1),
        r = n(53),
        o = n(39),
        a = n(6),
        s = n(5),
        l = n(232),
        u = n(233),
        c = function c(e, t, n, r) {
      var o = l.dataTransform(e, r[0]),
          a = l.dataTransform(e, r[1]),
          s = i.retrieve,
          u = o.coord,
          c = a.coord;
      u[0] = s(u[0], -1 / 0), u[1] = s(u[1], -1 / 0), c[0] = s(c[0], 1 / 0), c[1] = s(c[1], 1 / 0);
      var h = i.mergeAll([{}, o, a]);
      return h.coord = [o.coord, a.coord], h.x0 = o.x, h.y0 = o.y, h.x1 = a.x, h.y1 = a.y, h;
    };

    function h(e) {
      return !isNaN(e) && !isFinite(e);
    }

    function d(e, t, n, i) {
      var r = 1 - e;
      return h(t[r]) && h(n[r]);
    }

    function f(e, t) {
      var n = t.coord[0],
          i = t.coord[1];
      return !("cartesian2d" !== e.type || !n || !i || !d(1, n, i) && !d(0, n, i)) || l.dataFilter(e, {
        coord: n,
        x: t.x0,
        y: t.y0
      }) || l.dataFilter(e, {
        coord: i,
        x: t.x1,
        y: t.y1
      });
    }

    function p(e, t, n, i, r) {
      var o,
          s = i.coordinateSystem,
          l = e.getItemModel(t),
          u = a.parsePercent(l.get(n[0]), r.getWidth()),
          c = a.parsePercent(l.get(n[1]), r.getHeight());

      if (isNaN(u) || isNaN(c)) {
        if (i.getMarkerPosition) o = i.getMarkerPosition(e.getValues(n, t));else {
          var d = [g = e.get(n[0], t), v = e.get(n[1], t)];
          s.clampData && s.clampData(d, d), o = s.dataToPoint(d, !0);
        }

        if ("cartesian2d" === s.type) {
          var f = s.getAxis("x"),
              p = s.getAxis("y"),
              g = e.get(n[0], t),
              v = e.get(n[1], t);
          h(g) ? o[0] = f.toGlobalCoord(f.getExtent()["x0" === n[0] ? 0 : 1]) : h(v) && (o[1] = p.toGlobalCoord(p.getExtent()["y0" === n[1] ? 0 : 1]));
        }

        isNaN(u) || (o[0] = u), isNaN(c) || (o[1] = c);
      } else o = [u, c];

      return o;
    }

    var g = [["x0", "y0"], ["x1", "y0"], ["x1", "y1"], ["x0", "y1"]];
    u.extend({
      type: "markArea",
      updateTransform: function updateTransform(e, t, n) {
        t.eachSeries(function (e) {
          var t = e.markAreaModel;

          if (t) {
            var r = t.getData();
            r.each(function (t) {
              var o = i.map(g, function (i) {
                return p(r, t, i, e, n);
              });
              r.setItemLayout(t, o), r.getItemGraphicEl(t).setShape("points", o);
            });
          }
        }, this);
      },
      renderSeries: function renderSeries(e, t, n, a) {
        var l = e.coordinateSystem,
            u = e.id,
            h = e.getData(),
            d = this.markerGroupMap,
            v = d.get(u) || d.set(u, {
          group: new s.Group()
        });
        this.group.add(v.group), v.__keep = !0;

        var m = function (e, t, n) {
          var r, a;
          e ? (r = i.map(e && e.dimensions, function (e) {
            var n = t.getData(),
                r = n.getDimensionInfo(n.mapDimension(e)) || {};
            return i.defaults({
              name: e
            }, r);
          }), a = new o(i.map(["x0", "y0", "x1", "y1"], function (e, t) {
            return {
              name: e,
              type: r[t % 2].type
            };
          }), n)) : a = new o(r = [{
            name: "value",
            type: "float"
          }], n);
          var s = i.map(n.get("data"), i.curry(c, t, e, n));
          e && (s = i.filter(s, i.curry(f, e)));
          var l = e ? function (e, t, n, i) {
            return e.coord[Math.floor(i / 2)][i % 2];
          } : function (e) {
            return e.value;
          };
          return a.initData(s, null, l), a.hasItemOption = !0, a;
        }(l, e, t);

        t.setData(m), m.each(function (t) {
          m.setItemLayout(t, i.map(g, function (n) {
            return p(m, t, n, e, a);
          })), m.setItemVisual(t, {
            color: h.getVisual("color")
          });
        }), m.diff(v.__data).add(function (e) {
          var t = new s.Polygon({
            shape: {
              points: m.getItemLayout(e)
            }
          });
          m.setItemGraphicEl(e, t), v.group.add(t);
        }).update(function (e, n) {
          var i = v.__data.getItemGraphicEl(n);

          s.updateProps(i, {
            shape: {
              points: m.getItemLayout(e)
            }
          }, t, e), v.group.add(i), m.setItemGraphicEl(e, i);
        }).remove(function (e) {
          var t = v.__data.getItemGraphicEl(e);

          v.group.remove(t);
        }).execute(), m.eachItemGraphicEl(function (e, n) {
          var o = m.getItemModel(n),
              a = o.getModel("label"),
              l = o.getModel("emphasis.label"),
              u = m.getItemVisual(n, "color");
          e.useStyle(i.defaults(o.getModel("itemStyle").getItemStyle(), {
            fill: r.modifyAlpha(u, .4),
            stroke: u
          })), e.hoverStyle = o.getModel("emphasis.itemStyle").getItemStyle(), s.setLabelStyle(e.style, e.hoverStyle, a, l, {
            labelFetcher: t,
            labelDataIndex: n,
            defaultText: m.getName(n) || "",
            isRectText: !0,
            autoColor: u
          }), s.setHoverStyle(e, {}), e.dataModel = t;
        }), v.__data = m, v.group.silent = t.get("silent") || e.get("silent");
      }
    });
  }, function (e, t, n) {
    n(353), n(916), n(917), n(918);
  }, function (e, t, n) {
    var i = n(4),
        r = n(1);

    function o(e, t, n) {
      var i,
          o = {},
          a = "toggleSelected" === e;
      return n.eachComponent("legend", function (n) {
        a && null != i ? n[i ? "select" : "unSelect"](t.name) : "allSelect" === e || "inverseSelect" === e ? n[e]() : (n[e](t.name), i = n.isSelected(t.name));
        var s = n.getData();
        r.each(s, function (e) {
          var t = e.get("name");

          if ("\n" !== t && "" !== t) {
            var i = n.isSelected(t);
            o.hasOwnProperty(t) ? o[t] = o[t] && i : o[t] = i;
          }
        });
      }), "allSelect" === e || "inverseSelect" === e ? {
        selected: o
      } : {
        name: t.name,
        selected: o
      };
    }

    i.registerAction("legendToggleSelect", "legendselectchanged", r.curry(o, "toggleSelected")), i.registerAction("legendAllSelect", "legendselectall", r.curry(o, "allSelect")), i.registerAction("legendInverseSelect", "legendinverseselect", r.curry(o, "inverseSelect")), i.registerAction("legendSelect", "legendselected", r.curry(o, "select")), i.registerAction("legendUnSelect", "legendunselected", r.curry(o, "unSelect"));
  }, function (e, t) {
    e.exports = function (e) {
      var t = e.findComponents({
        mainType: "legend"
      });
      t && t.length && e.filterSeries(function (e) {
        for (var n = 0; n < t.length; n++) {
          if (!t[n].isSelected(e.name)) return !1;
        }

        return !0;
      });
    };
  }, function (e, t, n) {
    var i = n(354),
        r = n(14),
        o = r.mergeLayoutParam,
        a = r.getLayoutParams,
        s = i.extend({
      type: "legend.scroll",
      setScrollDataIndex: function setScrollDataIndex(e) {
        this.option.scrollDataIndex = e;
      },
      defaultOption: {
        scrollDataIndex: 0,
        pageButtonItemGap: 5,
        pageButtonGap: null,
        pageButtonPosition: "end",
        pageFormatter: "{current}/{total}",
        pageIcons: {
          horizontal: ["M0,0L12,-10L12,10z", "M0,0L-12,-10L-12,10z"],
          vertical: ["M0,0L20,0L10,-20z", "M0,0L20,0L10,20z"]
        },
        pageIconColor: "#2f4554",
        pageIconInactiveColor: "#aaa",
        pageIconSize: 15,
        pageTextStyle: {
          color: "#333"
        },
        animationDurationUpdate: 800
      },
      init: function init(e, t, n, i) {
        var r = a(e);
        s.superCall(this, "init", e, t, n, i), l(this, e, r);
      },
      mergeOption: function mergeOption(e, t) {
        s.superCall(this, "mergeOption", e, t), l(this, this.option, e);
      }
    });

    function l(e, t, n) {
      var i = [1, 1];
      i[e.getOrient().index] = 0, o(t, n, {
        type: "box",
        ignoreSize: i
      });
    }

    var u = s;
    e.exports = u;
  }, function (e, t, n) {
    var i = n(1),
        r = n(5),
        o = n(14),
        a = n(355),
        s = r.Group,
        l = ["width", "height"],
        u = ["x", "y"],
        c = a.extend({
      type: "legend.scroll",
      newlineDisabled: !0,
      init: function init() {
        c.superCall(this, "init"), this._currentIndex = 0, this.group.add(this._containerGroup = new s()), this._containerGroup.add(this.getContentGroup()), this.group.add(this._controllerGroup = new s()), this._showController;
      },
      resetInner: function resetInner() {
        c.superCall(this, "resetInner"), this._controllerGroup.removeAll(), this._containerGroup.removeClipPath(), this._containerGroup.__rectSize = null;
      },
      renderInner: function renderInner(e, t, n, o, a, s, l) {
        var u = this;
        c.superCall(this, "renderInner", e, t, n, o, a, s, l);
        var h = this._controllerGroup,
            d = t.get("pageIconSize", !0);
        i.isArray(d) || (d = [d, d]), p("pagePrev", 0);
        var f = t.getModel("pageTextStyle");

        function p(e, n) {
          var a = e + "DataIndex",
              s = r.createIcon(t.get("pageIcons", !0)[t.getOrient().name][n], {
            onclick: i.bind(u._pageGo, u, a, t, o)
          }, {
            x: -d[0] / 2,
            y: -d[1] / 2,
            width: d[0],
            height: d[1]
          });
          s.name = e, h.add(s);
        }

        h.add(new r.Text({
          name: "pageText",
          style: {
            textFill: f.getTextColor(),
            font: f.getFont(),
            textVerticalAlign: "middle",
            textAlign: "center"
          },
          silent: !0
        })), p("pageNext", 1);
      },
      layoutInner: function layoutInner(e, t, n, r, a, s) {
        var c = this.getSelectorGroup(),
            h = e.getOrient().index,
            d = l[h],
            f = u[h],
            p = l[1 - h],
            g = u[1 - h];
        a && o.box("horizontal", c, e.get("selectorItemGap", !0));
        var v = e.get("selectorButtonGap", !0),
            m = c.getBoundingRect(),
            y = [-m.x, -m.y],
            x = i.clone(n);
        a && (x[d] = n[d] - m[d] - v);

        var _ = this._layoutContentAndController(e, r, x, h, d, p, g);

        if (a) {
          if ("end" === s) y[h] += _[d] + v;else {
            var b = m[d] + v;
            y[h] -= b, _[f] -= b;
          }
          _[d] += m[d] + v, y[1 - h] += _[g] + _[p] / 2 - m[p] / 2, _[p] = Math.max(_[p], m[p]), _[g] = Math.min(_[g], m[g] + y[1 - h]), c.attr("position", y);
        }

        return _;
      },
      _layoutContentAndController: function _layoutContentAndController(e, t, n, a, s, l, u) {
        var c = this.getContentGroup(),
            h = this._containerGroup,
            d = this._controllerGroup;
        o.box(e.get("orient"), c, e.get("itemGap"), a ? n.width : null, a ? null : n.height), o.box("horizontal", d, e.get("pageButtonItemGap", !0));
        var f = c.getBoundingRect(),
            p = d.getBoundingRect(),
            g = this._showController = f[s] > n[s],
            v = [-f.x, -f.y];
        t || (v[a] = c.position[a]);
        var m = [0, 0],
            y = [-p.x, -p.y],
            x = i.retrieve2(e.get("pageButtonGap", !0), e.get("itemGap", !0));
        g && ("end" === e.get("pageButtonPosition", !0) ? y[a] += n[s] - p[s] : m[a] += p[s] + x);
        y[1 - a] += f[l] / 2 - p[l] / 2, c.attr("position", v), h.attr("position", m), d.attr("position", y);
        var _ = {
          x: 0,
          y: 0
        };

        if (_[s] = g ? n[s] : f[s], _[l] = Math.max(f[l], p[l]), _[u] = Math.min(0, p[u] + y[1 - a]), h.__rectSize = n[s], g) {
          var b = {
            x: 0,
            y: 0
          };
          b[s] = Math.max(n[s] - p[s] - x, 0), b[l] = _[l], h.setClipPath(new r.Rect({
            shape: b
          })), h.__rectSize = b[s];
        } else d.eachChild(function (e) {
          e.attr({
            invisible: !0,
            silent: !0
          });
        });

        var w = this._getPageInfo(e);

        return null != w.pageIndex && r.updateProps(c, {
          position: w.contentPosition
        }, !!g && e), this._updatePageInfoView(e, w), _;
      },
      _pageGo: function _pageGo(e, t, n) {
        var i = this._getPageInfo(t)[e];

        null != i && n.dispatchAction({
          type: "legendScroll",
          scrollDataIndex: i,
          legendId: t.id
        });
      },
      _updatePageInfoView: function _updatePageInfoView(e, t) {
        var n = this._controllerGroup;
        i.each(["pagePrev", "pageNext"], function (i) {
          var r = null != t[i + "DataIndex"],
              o = n.childOfName(i);
          o && (o.setStyle("fill", r ? e.get("pageIconColor", !0) : e.get("pageIconInactiveColor", !0)), o.cursor = r ? "pointer" : "default");
        });
        var r = n.childOfName("pageText"),
            o = e.get("pageFormatter"),
            a = t.pageIndex,
            s = null != a ? a + 1 : 0,
            l = t.pageCount;
        r && o && r.setStyle("text", i.isString(o) ? o.replace("{current}", s).replace("{total}", l) : o({
          current: s,
          total: l
        }));
      },
      _getPageInfo: function _getPageInfo(e) {
        var t = e.get("scrollDataIndex", !0),
            n = this.getContentGroup(),
            i = this._containerGroup.__rectSize,
            r = e.getOrient().index,
            o = l[r],
            a = u[r],
            s = this._findTargetItemIndex(t),
            c = n.children(),
            h = c[s],
            d = c.length,
            f = d ? 1 : 0,
            p = {
          contentPosition: n.position.slice(),
          pageCount: f,
          pageIndex: f - 1,
          pagePrevDataIndex: null,
          pageNextDataIndex: null
        };

        if (!h) return p;

        var g = _(h);

        p.contentPosition[r] = -g.s;

        for (var v = s + 1, m = g, y = g, x = null; v <= d; ++v) {
          (!(x = _(c[v])) && y.e > m.s + i || x && !b(x, m.s)) && (m = y.i > m.i ? y : x) && (null == p.pageNextDataIndex && (p.pageNextDataIndex = m.i), ++p.pageCount), y = x;
        }

        for (v = s - 1, m = g, y = g, x = null; v >= -1; --v) {
          (x = _(c[v])) && b(y, x.s) || !(m.i < y.i) || (y = m, null == p.pagePrevDataIndex && (p.pagePrevDataIndex = m.i), ++p.pageCount, ++p.pageIndex), m = x;
        }

        return p;

        function _(e) {
          if (e) {
            var t = e.getBoundingRect(),
                n = t[a] + e.position[r];
            return {
              s: n,
              e: n + t[o],
              i: e.__legendDataIndex
            };
          }
        }

        function b(e, t) {
          return e.e >= t && e.s <= t + i;
        }
      },
      _findTargetItemIndex: function _findTargetItemIndex(e) {
        return this._showController ? (this.getContentGroup().eachChild(function (i, r) {
          var o = i.__legendDataIndex;
          null == n && null != o && (n = r), o === e && (t = r);
        }), null != t ? t : n) : 0;
        var t, n;
      }
    }),
        h = c;
    e.exports = h;
  }, function (e, t, n) {
    n(4).registerAction("legendScroll", "legendscroll", function (e, t) {
      var n = e.scrollDataIndex;
      null != n && t.eachComponent({
        mainType: "legend",
        subType: "scroll",
        query: e
      }, function (e) {
        e.setScrollDataIndex(n);
      });
    });
  }, function (e, t, n) {
    n(356), n(357);
  }, function (e, t, n) {
    var i = n(108).extend({
      type: "dataZoom.slider",
      layoutMode: "box",
      defaultOption: {
        show: !0,
        right: "ph",
        top: "ph",
        width: "ph",
        height: "ph",
        left: null,
        bottom: null,
        backgroundColor: "rgba(47,69,84,0)",
        dataBackground: {
          lineStyle: {
            color: "#2f4554",
            width: .5,
            opacity: .3
          },
          areaStyle: {
            color: "rgba(47,69,84,0.3)",
            opacity: .3
          }
        },
        borderColor: "#ddd",
        fillerColor: "rgba(167,183,204,0.4)",
        handleIcon: "M8.2,13.6V3.9H6.3v9.7H3.1v14.9h3.3v9.7h1.8v-9.7h3.3V13.6H8.2z M9.7,24.4H4.8v-1.4h4.9V24.4z M9.7,19.1H4.8v-1.4h4.9V19.1z",
        handleSize: "100%",
        handleStyle: {
          color: "#a7b7cc"
        },
        labelPrecision: null,
        labelFormatter: null,
        showDetail: !0,
        showDataShadow: "auto",
        realtime: !0,
        zoomLock: !1,
        textStyle: {
          color: "#333"
        }
      }
    });
    e.exports = i;
  }, function (e, t, n) {
    var i = n(1),
        r = n(52),
        o = n(5),
        a = n(67),
        s = n(109),
        l = n(6),
        u = n(14),
        c = n(107),
        h = o.Rect,
        d = l.linearMap,
        f = l.asc,
        p = i.bind,
        g = i.each,
        v = ["line", "bar", "candlestick", "scatter"],
        m = s.extend({
      type: "dataZoom.slider",
      init: function init(e, t) {
        this._displayables = {}, this._orient, this._range, this._handleEnds, this._size, this._handleWidth, this._handleHeight, this._location, this._dragging, this._dataShadowInfo, this.api = t;
      },
      render: function render(e, t, n, i) {
        m.superApply(this, "render", arguments), a.createOrUpdate(this, "_dispatchZoomAction", this.dataZoomModel.get("throttle"), "fixRate"), this._orient = e.get("orient"), !1 !== this.dataZoomModel.get("show") ? (i && "dataZoom" === i.type && i.from === this.uid || this._buildView(), this._updateView()) : this.group.removeAll();
      },
      remove: function remove() {
        m.superApply(this, "remove", arguments), a.clear(this, "_dispatchZoomAction");
      },
      dispose: function dispose() {
        m.superApply(this, "dispose", arguments), a.clear(this, "_dispatchZoomAction");
      },
      _buildView: function _buildView() {
        var e = this.group;
        e.removeAll(), this._resetLocation(), this._resetInterval();
        var t = this._displayables.barGroup = new o.Group();
        this._renderBackground(), this._renderHandle(), this._renderDataShadow(), e.add(t), this._positionGroup();
      },
      _resetLocation: function _resetLocation() {
        var e = this.dataZoomModel,
            t = this.api,
            n = this._findCoordRect(),
            r = {
          width: t.getWidth(),
          height: t.getHeight()
        },
            o = "horizontal" === this._orient ? {
          right: r.width - n.x - n.width,
          top: r.height - 30 - 7,
          width: n.width,
          height: 30
        } : {
          right: 7,
          top: n.y,
          width: 30,
          height: n.height
        },
            a = u.getLayoutParams(e.option);

        i.each(["right", "top", "width", "height"], function (e) {
          "ph" === a[e] && (a[e] = o[e]);
        });
        var s = u.getLayoutRect(a, r, e.padding);
        this._location = {
          x: s.x,
          y: s.y
        }, this._size = [s.width, s.height], "vertical" === this._orient && this._size.reverse();
      },
      _positionGroup: function _positionGroup() {
        var e = this.group,
            t = this._location,
            n = this._orient,
            i = this.dataZoomModel.getFirstTargetAxisModel(),
            r = i && i.get("inverse"),
            o = this._displayables.barGroup,
            a = (this._dataShadowInfo || {}).otherAxisInverse;
        o.attr("horizontal" !== n || r ? "horizontal" === n && r ? {
          scale: a ? [-1, 1] : [-1, -1]
        } : "vertical" !== n || r ? {
          scale: a ? [-1, -1] : [-1, 1],
          rotation: Math.PI / 2
        } : {
          scale: a ? [1, -1] : [1, 1],
          rotation: Math.PI / 2
        } : {
          scale: a ? [1, 1] : [1, -1]
        });
        var s = e.getBoundingRect([o]);
        e.attr("position", [t.x - s.x, t.y - s.y]);
      },
      _getViewExtent: function _getViewExtent() {
        return [0, this._size[0]];
      },
      _renderBackground: function _renderBackground() {
        var e = this.dataZoomModel,
            t = this._size,
            n = this._displayables.barGroup;
        n.add(new h({
          silent: !0,
          shape: {
            x: 0,
            y: 0,
            width: t[0],
            height: t[1]
          },
          style: {
            fill: e.get("backgroundColor")
          },
          z2: -40
        })), n.add(new h({
          shape: {
            x: 0,
            y: 0,
            width: t[0],
            height: t[1]
          },
          style: {
            fill: "transparent"
          },
          z2: 0,
          onclick: i.bind(this._onClickPanelClick, this)
        }));
      },
      _renderDataShadow: function _renderDataShadow() {
        var e = this._dataShadowInfo = this._prepareDataShadowInfo();

        if (e) {
          var t = this._size,
              n = e.series,
              r = n.getRawData(),
              a = n.getShadowDim ? n.getShadowDim() : e.otherDim;

          if (null != a) {
            var s = r.getDataExtent(a),
                l = .3 * (s[1] - s[0]);
            s = [s[0] - l, s[1] + l];
            var u,
                c = [0, t[1]],
                h = [0, t[0]],
                f = [[t[0], 0], [0, 0]],
                p = [],
                g = h[1] / (r.count() - 1),
                v = 0,
                m = Math.round(r.count() / t[0]);
            r.each([a], function (e, t) {
              if (m > 0 && t % m) v += g;else {
                var n = null == e || isNaN(e) || "" === e,
                    i = n ? 0 : d(e, s, c, !0);
                n && !u && t ? (f.push([f[f.length - 1][0], 0]), p.push([p[p.length - 1][0], 0])) : !n && u && (f.push([v, 0]), p.push([v, 0])), f.push([v, i]), p.push([v, i]), v += g, u = n;
              }
            });
            var y = this.dataZoomModel;
            this._displayables.barGroup.add(new o.Polygon({
              shape: {
                points: f
              },
              style: i.defaults({
                fill: y.get("dataBackgroundColor")
              }, y.getModel("dataBackground.areaStyle").getAreaStyle()),
              silent: !0,
              z2: -20
            })), this._displayables.barGroup.add(new o.Polyline({
              shape: {
                points: p
              },
              style: y.getModel("dataBackground.lineStyle").getLineStyle(),
              silent: !0,
              z2: -19
            }));
          }
        }
      },
      _prepareDataShadowInfo: function _prepareDataShadowInfo() {
        var e = this.dataZoomModel,
            t = e.get("showDataShadow");

        if (!1 !== t) {
          var n,
              r = this.ecModel;
          return e.eachTargetAxis(function (o, a) {
            var s = e.getAxisProxy(o.name, a).getTargetSeriesModels();
            i.each(s, function (e) {
              if (!(n || !0 !== t && i.indexOf(v, e.get("type")) < 0)) {
                var s,
                    l = r.getComponent(o.axis, a).axis,
                    u = {
                  x: "y",
                  y: "x",
                  radius: "angle",
                  angle: "radius"
                }[o.name],
                    c = e.coordinateSystem;
                null != u && c.getOtherAxis && (s = c.getOtherAxis(l).inverse), u = e.getData().mapDimension(u), n = {
                  thisAxis: l,
                  series: e,
                  thisDim: o.name,
                  otherDim: u,
                  otherAxisInverse: s
                };
              }
            }, this);
          }, this), n;
        }
      },
      _renderHandle: function _renderHandle() {
        var e = this._displayables,
            t = e.handles = [],
            n = e.handleLabels = [],
            i = this._displayables.barGroup,
            r = this._size,
            a = this.dataZoomModel;
        i.add(e.filler = new h({
          draggable: !0,
          cursor: y(this._orient),
          drift: p(this._onDragMove, this, "all"),
          ondragstart: p(this._showDataInfo, this, !0),
          ondragend: p(this._onDragEnd, this),
          onmouseover: p(this._showDataInfo, this, !0),
          onmouseout: p(this._showDataInfo, this, !1),
          style: {
            fill: a.get("fillerColor"),
            textPosition: "inside"
          }
        })), i.add(new h({
          silent: !0,
          subPixelOptimize: !0,
          shape: {
            x: 0,
            y: 0,
            width: r[0],
            height: r[1]
          },
          style: {
            stroke: a.get("dataBackgroundColor") || a.get("borderColor"),
            lineWidth: 1,
            fill: "rgba(0,0,0,0)"
          }
        })), g([0, 1], function (e) {
          var r = o.createIcon(a.get("handleIcon"), {
            cursor: y(this._orient),
            draggable: !0,
            drift: p(this._onDragMove, this, e),
            ondragend: p(this._onDragEnd, this),
            onmouseover: p(this._showDataInfo, this, !0),
            onmouseout: p(this._showDataInfo, this, !1)
          }, {
            x: -1,
            y: 0,
            width: 2,
            height: 2
          }),
              s = r.getBoundingRect();
          this._handleHeight = l.parsePercent(a.get("handleSize"), this._size[1]), this._handleWidth = s.width / s.height * this._handleHeight, r.setStyle(a.getModel("handleStyle").getItemStyle());
          var u = a.get("handleColor");
          null != u && (r.style.fill = u), i.add(t[e] = r);
          var c = a.textStyleModel;
          this.group.add(n[e] = new o.Text({
            silent: !0,
            invisible: !0,
            style: {
              x: 0,
              y: 0,
              text: "",
              textVerticalAlign: "middle",
              textAlign: "center",
              textFill: c.getTextColor(),
              textFont: c.getFont()
            },
            z2: 10
          }));
        }, this);
      },
      _resetInterval: function _resetInterval() {
        var e = this._range = this.dataZoomModel.getPercentRange(),
            t = this._getViewExtent();

        this._handleEnds = [d(e[0], [0, 100], t, !0), d(e[1], [0, 100], t, !0)];
      },
      _updateInterval: function _updateInterval(e, t) {
        var n = this.dataZoomModel,
            i = this._handleEnds,
            r = this._getViewExtent(),
            o = n.findRepresentativeAxisProxy().getMinMaxSpan(),
            a = [0, 100];

        c(t, i, r, n.get("zoomLock") ? "all" : e, null != o.minSpan ? d(o.minSpan, a, r, !0) : null, null != o.maxSpan ? d(o.maxSpan, a, r, !0) : null);
        var s = this._range,
            l = this._range = f([d(i[0], r, a, !0), d(i[1], r, a, !0)]);
        return !s || s[0] !== l[0] || s[1] !== l[1];
      },
      _updateView: function _updateView(e) {
        var t = this._displayables,
            n = this._handleEnds,
            i = f(n.slice()),
            r = this._size;
        g([0, 1], function (e) {
          var i = t.handles[e],
              o = this._handleHeight;
          i.attr({
            scale: [o / 2, o / 2],
            position: [n[e], r[1] / 2 - o / 2]
          });
        }, this), t.filler.setShape({
          x: i[0],
          y: 0,
          width: i[1] - i[0],
          height: r[1]
        }), this._updateDataInfo(e);
      },
      _updateDataInfo: function _updateDataInfo(e) {
        var t = this.dataZoomModel,
            n = this._displayables,
            i = n.handleLabels,
            r = this._orient,
            a = ["", ""];

        if (t.get("showDetail")) {
          var s = t.findRepresentativeAxisProxy();

          if (s) {
            var l = s.getAxisModel().axis,
                u = this._range,
                c = e ? s.calculateDataWindow({
              start: u[0],
              end: u[1]
            }).valueWindow : s.getDataValueWindow();
            a = [this._formatLabel(c[0], l), this._formatLabel(c[1], l)];
          }
        }

        var h = f(this._handleEnds.slice());

        function d(e) {
          var t = o.getTransform(n.handles[e].parent, this.group),
              s = o.transformDirection(0 === e ? "right" : "left", t),
              l = this._handleWidth / 2 + 5,
              u = o.applyTransform([h[e] + (0 === e ? -l : l), this._size[1] / 2], t);
          i[e].setStyle({
            x: u[0],
            y: u[1],
            textVerticalAlign: "horizontal" === r ? "middle" : s,
            textAlign: "horizontal" === r ? s : "center",
            text: a[e]
          });
        }

        d.call(this, 0), d.call(this, 1);
      },
      _formatLabel: function _formatLabel(e, t) {
        var n = this.dataZoomModel,
            r = n.get("labelFormatter"),
            o = n.get("labelPrecision");
        null != o && "auto" !== o || (o = t.getPixelPrecision());
        var a = null == e || isNaN(e) ? "" : "category" === t.type || "time" === t.type ? t.scale.getLabel(Math.round(e)) : e.toFixed(Math.min(o, 20));
        return i.isFunction(r) ? r(e, a) : i.isString(r) ? r.replace("{value}", a) : a;
      },
      _showDataInfo: function _showDataInfo(e) {
        e = this._dragging || e;
        var t = this._displayables.handleLabels;
        t[0].attr("invisible", !e), t[1].attr("invisible", !e);
      },
      _onDragMove: function _onDragMove(e, t, n, i) {
        this._dragging = !0, r.stop(i.event);

        var a = this._displayables.barGroup.getLocalTransform(),
            s = o.applyTransform([t, n], a, !0),
            l = this._updateInterval(e, s[0]),
            u = this.dataZoomModel.get("realtime");

        this._updateView(!u), l && u && this._dispatchZoomAction();
      },
      _onDragEnd: function _onDragEnd() {
        this._dragging = !1, this._showDataInfo(!1), !this.dataZoomModel.get("realtime") && this._dispatchZoomAction();
      },
      _onClickPanelClick: function _onClickPanelClick(e) {
        var t = this._size,
            n = this._displayables.barGroup.transformCoordToLocal(e.offsetX, e.offsetY);

        if (!(n[0] < 0 || n[0] > t[0] || n[1] < 0 || n[1] > t[1])) {
          var i = this._handleEnds,
              r = (i[0] + i[1]) / 2,
              o = this._updateInterval("all", n[0] - r);

          this._updateView(), o && this._dispatchZoomAction();
        }
      },
      _dispatchZoomAction: function _dispatchZoomAction() {
        var e = this._range;
        this.api.dispatchAction({
          type: "dataZoom",
          from: this.uid,
          dataZoomId: this.dataZoomModel.id,
          start: e[0],
          end: e[1]
        });
      },
      _findCoordRect: function _findCoordRect() {
        var e;

        if (g(this.getTargetCoordInfo(), function (t) {
          if (!e && t.length) {
            var n = t[0].model.coordinateSystem;
            e = n.getRect && n.getRect();
          }
        }), !e) {
          var t = this.api.getWidth(),
              n = this.api.getHeight();
          e = {
            x: .2 * t,
            y: .2 * n,
            width: .6 * t,
            height: .6 * n
          };
        }

        return e;
      }
    });

    function y(e) {
      return "vertical" === e ? "ns-resize" : "ew-resize";
    }

    var x = m;
    e.exports = x;
  }, function (e, t, n) {
    var i = n(108).extend({
      type: "dataZoom.inside",
      defaultOption: {
        disabled: !1,
        zoomLock: !1,
        zoomOnMouseWheel: !0,
        moveOnMouseMove: !0,
        moveOnMouseWheel: !1,
        preventDefaultMouseMove: !0
      }
    });
    e.exports = i;
  }, function (e, t, n) {
    var i = n(1),
        r = n(109),
        o = n(107),
        a = n(924),
        s = i.bind,
        l = r.extend({
      type: "dataZoom.inside",
      init: function init(e, t) {
        this._range;
      },
      render: function render(e, t, n, r) {
        l.superApply(this, "render", arguments), this._range = e.getPercentRange(), i.each(this.getTargetCoordInfo(), function (t, r) {
          var o = i.map(t, function (e) {
            return a.generateCoordId(e.model);
          });
          i.each(t, function (t) {
            var l = t.model,
                c = {};
            i.each(["pan", "zoom", "scrollMove"], function (e) {
              c[e] = s(u[e], this, t, r);
            }, this), a.register(n, {
              coordId: a.generateCoordId(l),
              allCoordIds: o,
              containsPoint: function containsPoint(e, t, n) {
                return l.coordinateSystem.containPoint([t, n]);
              },
              dataZoomId: e.id,
              dataZoomModel: e,
              getRange: c
            });
          }, this);
        }, this);
      },
      dispose: function dispose() {
        a.unregister(this.api, this.dataZoomModel.id), l.superApply(this, "dispose", arguments), this._range = null;
      }
    }),
        u = {
      zoom: function zoom(e, t, n, i) {
        var r = this._range,
            a = r.slice(),
            s = e.axisModels[0];

        if (s) {
          var l = h[t](null, [i.originX, i.originY], s, n, e),
              u = (l.signal > 0 ? l.pixelStart + l.pixelLength - l.pixel : l.pixel - l.pixelStart) / l.pixelLength * (a[1] - a[0]) + a[0],
              c = Math.max(1 / i.scale, 0);
          a[0] = (a[0] - u) * c + u, a[1] = (a[1] - u) * c + u;
          var d = this.dataZoomModel.findRepresentativeAxisProxy().getMinMaxSpan();
          return o(0, a, [0, 100], 0, d.minSpan, d.maxSpan), this._range = a, r[0] !== a[0] || r[1] !== a[1] ? a : void 0;
        }
      },
      pan: c(function (e, t, n, i, r, o) {
        var a = h[i]([o.oldX, o.oldY], [o.newX, o.newY], t, r, n);
        return a.signal * (e[1] - e[0]) * a.pixel / a.pixelLength;
      }),
      scrollMove: c(function (e, t, n, i, r, o) {
        return h[i]([0, 0], [o.scrollDelta, o.scrollDelta], t, r, n).signal * (e[1] - e[0]) * o.scrollDelta;
      })
    };

    function c(e) {
      return function (t, n, i, r) {
        var a = this._range,
            s = a.slice(),
            l = t.axisModels[0];

        if (l) {
          var u = e(s, l, t, n, i, r);
          return o(u, s, [0, 100], "all"), this._range = s, a[0] !== s[0] || a[1] !== s[1] ? s : void 0;
        }
      };
    }

    var h = {
      grid: function grid(e, t, n, i, r) {
        var o = n.axis,
            a = {},
            s = r.model.coordinateSystem.getRect();
        return e = e || [0, 0], "x" === o.dim ? (a.pixel = t[0] - e[0], a.pixelLength = s.width, a.pixelStart = s.x, a.signal = o.inverse ? 1 : -1) : (a.pixel = t[1] - e[1], a.pixelLength = s.height, a.pixelStart = s.y, a.signal = o.inverse ? -1 : 1), a;
      },
      polar: function polar(e, t, n, i, r) {
        var o = n.axis,
            a = {},
            s = r.model.coordinateSystem,
            l = s.getRadiusAxis().getExtent(),
            u = s.getAngleAxis().getExtent();
        return e = e ? s.pointToCoord(e) : [0, 0], t = s.pointToCoord(t), "radiusAxis" === n.mainType ? (a.pixel = t[0] - e[0], a.pixelLength = l[1] - l[0], a.pixelStart = l[0], a.signal = o.inverse ? 1 : -1) : (a.pixel = t[1] - e[1], a.pixelLength = u[1] - u[0], a.pixelStart = u[0], a.signal = o.inverse ? -1 : 1), a;
      },
      singleAxis: function singleAxis(e, t, n, i, r) {
        var o = n.axis,
            a = r.model.coordinateSystem.getRect(),
            s = {};
        return e = e || [0, 0], "horizontal" === o.orient ? (s.pixel = t[0] - e[0], s.pixelLength = a.width, s.pixelStart = a.x, s.signal = o.inverse ? 1 : -1) : (s.pixel = t[1] - e[1], s.pixelLength = a.height, s.pixelStart = a.y, s.signal = o.inverse ? -1 : 1), s;
      }
    },
        d = l;
    e.exports = d;
  }, function (e, t, n) {
    var i = n(1),
        r = n(131),
        o = n(67),
        a = "\0_ec_dataZoom_roams";

    function s(e) {
      var t = e.getZr();
      return t[a] || (t[a] = {});
    }

    function l(e) {
      i.each(e, function (t, n) {
        t.count || (t.controller.dispose(), delete e[n]);
      });
    }

    function u(e, t) {
      e.dispatchAction({
        type: "dataZoom",
        batch: t
      });
    }

    t.register = function (e, t) {
      var n = s(e),
          a = t.dataZoomId,
          c = t.coordId;
      i.each(n, function (e, n) {
        var r = e.dataZoomInfos;
        r[a] && i.indexOf(t.allCoordIds, c) < 0 && (delete r[a], e.count--);
      }), l(n);
      var h = n[c];
      h || ((h = n[c] = {
        coordId: c,
        dataZoomInfos: {},
        count: 0
      }).controller = function (e, t) {
        var n = new r(e.getZr());
        return i.each(["pan", "zoom", "scrollMove"], function (e) {
          n.on(e, function (n) {
            var r = [];
            i.each(t.dataZoomInfos, function (i) {
              if (n.isAvailableBehavior(i.dataZoomModel.option)) {
                var o = (i.getRange || {})[e],
                    a = o && o(t.controller, n);
                !i.dataZoomModel.get("disabled", !0) && a && r.push({
                  dataZoomId: i.dataZoomId,
                  start: a[0],
                  end: a[1]
                });
              }
            }), r.length && t.dispatchAction(r);
          });
        }), n;
      }(e, h), h.dispatchAction = i.curry(u, e)), !h.dataZoomInfos[a] && h.count++, h.dataZoomInfos[a] = t;
      var d,
          f,
          p,
          g,
          v = (d = h.dataZoomInfos, p = {
        type_true: 2,
        type_move: 1,
        type_false: 0,
        type_undefined: -1
      }, g = !0, i.each(d, function (e) {
        var t = e.dataZoomModel,
            n = !t.get("disabled", !0) && (!t.get("zoomLock", !0) || "move");
        p["type_" + n] > p["type_" + f] && (f = n), g &= t.get("preventDefaultMouseMove", !0);
      }), {
        controlType: f,
        opt: {
          zoomOnMouseWheel: !0,
          moveOnMouseMove: !0,
          moveOnMouseWheel: !0,
          preventDefaultMouseMove: !!g
        }
      });
      h.controller.enable(v.controlType, v.opt), h.controller.setPointerChecker(t.containsPoint), o.createOrUpdate(h, "dispatchAction", t.dataZoomModel.get("throttle", !0), "fixRate");
    }, t.unregister = function (e, t) {
      var n = s(e);
      i.each(n, function (e) {
        e.controller.dispose();
        var n = e.dataZoomInfos;
        n[t] && (delete n[t], e.count--);
      }), l(n);
    }, t.generateCoordId = function (e) {
      return e.type + "\0_" + e.id;
    };
  }, function (e, t, n) {
    n(358), n(367);
  }, function (e, t, n) {
    var i = n(1),
        r = n(362),
        o = n(6),
        a = [20, 140],
        s = r.extend({
      type: "visualMap.continuous",
      defaultOption: {
        align: "auto",
        calculable: !1,
        range: null,
        realtime: !0,
        itemHeight: null,
        itemWidth: null,
        hoverLink: !0,
        hoverLinkDataSize: null,
        hoverLinkOnHandle: null
      },
      optionUpdated: function optionUpdated(e, t) {
        s.superApply(this, "optionUpdated", arguments), this.resetExtent(), this.resetVisual(function (e) {
          e.mappingMethod = "linear", e.dataExtent = this.getExtent();
        }), this._resetRange();
      },
      resetItemSize: function resetItemSize() {
        s.superApply(this, "resetItemSize", arguments);
        var e = this.itemSize;
        "horizontal" === this._orient && e.reverse(), (null == e[0] || isNaN(e[0])) && (e[0] = a[0]), (null == e[1] || isNaN(e[1])) && (e[1] = a[1]);
      },
      _resetRange: function _resetRange() {
        var e = this.getExtent(),
            t = this.option.range;
        !t || t.auto ? (e.auto = 1, this.option.range = e) : i.isArray(t) && (t[0] > t[1] && t.reverse(), t[0] = Math.max(t[0], e[0]), t[1] = Math.min(t[1], e[1]));
      },
      completeVisualOption: function completeVisualOption() {
        r.prototype.completeVisualOption.apply(this, arguments), i.each(this.stateList, function (e) {
          var t = this.option.controller[e].symbolSize;
          t && t[0] !== t[1] && (t[0] = 0);
        }, this);
      },
      setSelected: function setSelected(e) {
        this.option.range = e.slice(), this._resetRange();
      },
      getSelected: function getSelected() {
        var e = this.getExtent(),
            t = o.asc((this.get("range") || []).slice());
        return t[0] > e[1] && (t[0] = e[1]), t[1] > e[1] && (t[1] = e[1]), t[0] < e[0] && (t[0] = e[0]), t[1] < e[0] && (t[1] = e[0]), t;
      },
      getValueState: function getValueState(e) {
        var t = this.option.range,
            n = this.getExtent();
        return (t[0] <= n[0] || t[0] <= e) && (t[1] >= n[1] || e <= t[1]) ? "inRange" : "outOfRange";
      },
      findTargetDataIndices: function findTargetDataIndices(e) {
        var t = [];
        return this.eachTargetSeries(function (n) {
          var i = [],
              r = n.getData();
          r.each(this.getDataDimension(r), function (t, n) {
            e[0] <= t && t <= e[1] && i.push(n);
          }, this), t.push({
            seriesId: n.id,
            dataIndex: i
          });
        }, this), t;
      },
      getVisualMeta: function getVisualMeta(e) {
        var t = l(this, "outOfRange", this.getExtent()),
            n = l(this, "inRange", this.option.range.slice()),
            i = [];

        function r(t, n) {
          i.push({
            value: t,
            color: e(t, n)
          });
        }

        for (var o = 0, a = 0, s = n.length, u = t.length; a < u && (!n.length || t[a] <= n[0]); a++) {
          t[a] < n[o] && r(t[a], "outOfRange");
        }

        for (var c = 1; o < s; o++, c = 0) {
          c && i.length && r(n[o], "outOfRange"), r(n[o], "inRange");
        }

        for (c = 1; a < u; a++) {
          (!n.length || n[n.length - 1] < t[a]) && (c && (i.length && r(i[i.length - 1].value, "outOfRange"), c = 0), r(t[a], "outOfRange"));
        }

        var h = i.length;
        return {
          stops: i,
          outerColors: [h ? i[0].color : "transparent", h ? i[h - 1].color : "transparent"]
        };
      }
    });

    function l(e, t, n) {
      if (n[0] === n[1]) return n.slice();

      for (var i = (n[1] - n[0]) / 200, r = n[0], o = [], a = 0; a <= 200 && r < n[1]; a++) {
        o.push(r), r += i;
      }

      return o.push(n[1]), o;
    }

    var u = s;
    e.exports = u;
  }, function (e, t, n) {
    var i = n(1),
        r = n(208),
        o = n(52),
        a = n(364),
        s = n(5),
        l = n(6),
        u = n(107),
        c = n(365),
        h = n(8),
        d = l.linearMap,
        f = i.each,
        p = Math.min,
        g = Math.max,
        v = a.extend({
      type: "visualMap.continuous",
      init: function init() {
        v.superApply(this, "init", arguments), this._shapes = {}, this._dataInterval = [], this._handleEnds = [], this._orient, this._useHandle, this._hoverLinkDataIndices = [], this._dragging, this._hovering;
      },
      doRender: function doRender(e, t, n, i) {
        i && "selectDataRange" === i.type && i.from === this.uid || this._buildView();
      },
      _buildView: function _buildView() {
        this.group.removeAll();
        var e = this.visualMapModel,
            t = this.group;
        this._orient = e.get("orient"), this._useHandle = e.get("calculable"), this._resetInterval(), this._renderBar(t);
        var n = e.get("text");
        this._renderEndsText(t, n, 0), this._renderEndsText(t, n, 1), this._updateView(!0), this.renderBackground(t), this._updateView(), this._enableHoverLinkToSeries(), this._enableHoverLinkFromSeries(), this.positionGroup(t);
      },
      _renderEndsText: function _renderEndsText(e, t, n) {
        if (t) {
          var i = t[1 - n];
          i = null != i ? i + "" : "";

          var r = this.visualMapModel,
              o = r.get("textGap"),
              a = r.itemSize,
              l = this._shapes.barGroup,
              u = this._applyTransform([a[0] / 2, 0 === n ? -o : a[1] + o], l),
              c = this._applyTransform(0 === n ? "bottom" : "top", l),
              h = this._orient,
              d = this.visualMapModel.textStyleModel;

          this.group.add(new s.Text({
            style: {
              x: u[0],
              y: u[1],
              textVerticalAlign: "horizontal" === h ? "middle" : c,
              textAlign: "horizontal" === h ? c : "center",
              text: i,
              textFont: d.getFont(),
              textFill: d.getTextColor()
            }
          }));
        }
      },
      _renderBar: function _renderBar(e) {
        var t = this.visualMapModel,
            n = this._shapes,
            r = t.itemSize,
            o = this._orient,
            a = this._useHandle,
            s = c.getItemAlign(t, this.api, r),
            l = n.barGroup = this._createBarGroup(s);

        l.add(n.outOfRange = m()), l.add(n.inRange = m(null, a ? x(this._orient) : null, i.bind(this._dragHandle, this, "all", !1), i.bind(this._dragHandle, this, "all", !0)));
        var u = t.textStyleModel.getTextRect("国"),
            h = g(u.width, u.height);
        a && (n.handleThumbs = [], n.handleLabels = [], n.handleLabelPoints = [], this._createHandle(l, 0, r, h, o, s), this._createHandle(l, 1, r, h, o, s)), this._createIndicator(l, r, h, o), e.add(l);
      },
      _createHandle: function _createHandle(e, t, n, r, a) {
        var l = i.bind(this._dragHandle, this, t, !1),
            u = i.bind(this._dragHandle, this, t, !0),
            c = m(function (e, t) {
          return 0 === e ? [[0, 0], [t, 0], [t, -t]] : [[0, 0], [t, 0], [t, t]];
        }(t, r), x(this._orient), l, u);
        c.position[0] = n[0], e.add(c);
        var h = this.visualMapModel.textStyleModel,
            d = new s.Text({
          draggable: !0,
          drift: l,
          onmousemove: function onmousemove(e) {
            o.stop(e.event);
          },
          ondragend: u,
          style: {
            x: 0,
            y: 0,
            text: "",
            textFont: h.getFont(),
            textFill: h.getTextColor()
          }
        });
        this.group.add(d);
        var f = ["horizontal" === a ? r / 2 : 1.5 * r, "horizontal" === a ? 0 === t ? -1.5 * r : 1.5 * r : 0 === t ? -r / 2 : r / 2],
            p = this._shapes;
        p.handleThumbs[t] = c, p.handleLabelPoints[t] = f, p.handleLabels[t] = d;
      },
      _createIndicator: function _createIndicator(e, t, n, i) {
        var r = m([[0, 0]], "move");
        r.position[0] = t[0], r.attr({
          invisible: !0,
          silent: !0
        }), e.add(r);
        var o = this.visualMapModel.textStyleModel,
            a = new s.Text({
          silent: !0,
          invisible: !0,
          style: {
            x: 0,
            y: 0,
            text: "",
            textFont: o.getFont(),
            textFill: o.getTextColor()
          }
        });
        this.group.add(a);
        var l = ["horizontal" === i ? n / 2 : 9, 0],
            u = this._shapes;
        u.indicator = r, u.indicatorLabel = a, u.indicatorLabelPoint = l;
      },
      _dragHandle: function _dragHandle(e, t, n, i) {
        if (this._useHandle) {
          if (this._dragging = !t, !t) {
            var r = this._applyTransform([n, i], this._shapes.barGroup, !0);

            this._updateInterval(e, r[1]), this._updateView();
          }

          t === !this.visualMapModel.get("realtime") && this.api.dispatchAction({
            type: "selectDataRange",
            from: this.uid,
            visualMapId: this.visualMapModel.id,
            selected: this._dataInterval.slice()
          }), t ? !this._hovering && this._clearHoverLinkToSeries() : y(this.visualMapModel) && this._doHoverLinkToSeries(this._handleEnds[e], !1);
        }
      },
      _resetInterval: function _resetInterval() {
        var e = this.visualMapModel,
            t = this._dataInterval = e.getSelected(),
            n = e.getExtent(),
            i = [0, e.itemSize[1]];
        this._handleEnds = [d(t[0], n, i, !0), d(t[1], n, i, !0)];
      },
      _updateInterval: function _updateInterval(e, t) {
        t = t || 0;
        var n = this.visualMapModel,
            i = this._handleEnds,
            r = [0, n.itemSize[1]];
        u(t, i, r, e, 0);
        var o = n.getExtent();
        this._dataInterval = [d(i[0], r, o, !0), d(i[1], r, o, !0)];
      },
      _updateView: function _updateView(e) {
        var t = this.visualMapModel,
            n = t.getExtent(),
            i = this._shapes,
            r = [0, t.itemSize[1]],
            o = e ? r : this._handleEnds,
            a = this._createBarVisual(this._dataInterval, n, o, "inRange"),
            s = this._createBarVisual(n, n, r, "outOfRange");

        i.inRange.setStyle({
          fill: a.barColor,
          opacity: a.opacity
        }).setShape("points", a.barPoints), i.outOfRange.setStyle({
          fill: s.barColor,
          opacity: s.opacity
        }).setShape("points", s.barPoints), this._updateHandle(o, a);
      },
      _createBarVisual: function _createBarVisual(e, t, n, i) {
        var o = {
          forceState: i,
          convertOpacityToAlpha: !0
        },
            a = this._makeColorGradient(e, o),
            s = [this.getControllerVisual(e[0], "symbolSize", o), this.getControllerVisual(e[1], "symbolSize", o)],
            l = this._createBarPoints(n, s);

        return {
          barColor: new r(0, 0, 0, 1, a),
          barPoints: l,
          handlesColor: [a[0].color, a[a.length - 1].color]
        };
      },
      _makeColorGradient: function _makeColorGradient(e, t) {
        var n = [],
            i = (e[1] - e[0]) / 100;
        n.push({
          color: this.getControllerVisual(e[0], "color", t),
          offset: 0
        });

        for (var r = 1; r < 100; r++) {
          var o = e[0] + i * r;
          if (o > e[1]) break;
          n.push({
            color: this.getControllerVisual(o, "color", t),
            offset: r / 100
          });
        }

        return n.push({
          color: this.getControllerVisual(e[1], "color", t),
          offset: 1
        }), n;
      },
      _createBarPoints: function _createBarPoints(e, t) {
        var n = this.visualMapModel.itemSize;
        return [[n[0] - t[0], e[0]], [n[0], e[0]], [n[0], e[1]], [n[0] - t[1], e[1]]];
      },
      _createBarGroup: function _createBarGroup(e) {
        var t = this._orient,
            n = this.visualMapModel.get("inverse");
        return new s.Group("horizontal" !== t || n ? "horizontal" === t && n ? {
          scale: "bottom" === e ? [-1, 1] : [1, 1],
          rotation: -Math.PI / 2
        } : "vertical" !== t || n ? {
          scale: "left" === e ? [1, 1] : [-1, 1]
        } : {
          scale: "left" === e ? [1, -1] : [-1, -1]
        } : {
          scale: "bottom" === e ? [1, 1] : [-1, 1],
          rotation: Math.PI / 2
        });
      },
      _updateHandle: function _updateHandle(e, t) {
        if (this._useHandle) {
          var n = this._shapes,
              i = this.visualMapModel,
              r = n.handleThumbs,
              o = n.handleLabels;
          f([0, 1], function (a) {
            var l = r[a];
            l.setStyle("fill", t.handlesColor[a]), l.position[1] = e[a];
            var u = s.applyTransform(n.handleLabelPoints[a], s.getTransform(l, this.group));
            o[a].setStyle({
              x: u[0],
              y: u[1],
              text: i.formatValueText(this._dataInterval[a]),
              textVerticalAlign: "middle",
              textAlign: this._applyTransform("horizontal" === this._orient ? 0 === a ? "bottom" : "top" : "left", n.barGroup)
            });
          }, this);
        }
      },
      _showIndicator: function _showIndicator(e, t, n, i) {
        var r = this.visualMapModel,
            o = r.getExtent(),
            a = r.itemSize,
            l = [0, a[1]],
            u = d(e, o, l, !0),
            c = this._shapes,
            h = c.indicator;

        if (h) {
          h.position[1] = u, h.attr("invisible", !1), h.setShape("points", function (e, t, n, i) {
            return e ? [[0, -p(t, g(n, 0))], [6, 0], [0, p(t, g(i - n, 0))]] : [[0, 0], [5, -5], [5, 5]];
          }(!!n, i, u, a[1]));
          var f = this.getControllerVisual(e, "color", {
            convertOpacityToAlpha: !0
          });
          h.setStyle("fill", f);
          var v = s.applyTransform(c.indicatorLabelPoint, s.getTransform(h, this.group)),
              m = c.indicatorLabel;
          m.attr("invisible", !1);

          var y = this._applyTransform("left", c.barGroup),
              x = this._orient;

          m.setStyle({
            text: (n || "") + r.formatValueText(t),
            textVerticalAlign: "horizontal" === x ? y : "middle",
            textAlign: "horizontal" === x ? "center" : y,
            x: v[0],
            y: v[1]
          });
        }
      },
      _enableHoverLinkToSeries: function _enableHoverLinkToSeries() {
        var e = this;

        this._shapes.barGroup.on("mousemove", function (t) {
          if (e._hovering = !0, !e._dragging) {
            var n = e.visualMapModel.itemSize,
                i = e._applyTransform([t.offsetX, t.offsetY], e._shapes.barGroup, !0, !0);

            i[1] = p(g(0, i[1]), n[1]), e._doHoverLinkToSeries(i[1], 0 <= i[0] && i[0] <= n[0]);
          }
        }).on("mouseout", function () {
          e._hovering = !1, !e._dragging && e._clearHoverLinkToSeries();
        });
      },
      _enableHoverLinkFromSeries: function _enableHoverLinkFromSeries() {
        var e = this.api.getZr();
        this.visualMapModel.option.hoverLink ? (e.on("mouseover", this._hoverLinkFromSeriesMouseOver, this), e.on("mouseout", this._hideIndicator, this)) : this._clearHoverLinkFromSeries();
      },
      _doHoverLinkToSeries: function _doHoverLinkToSeries(e, t) {
        var n = this.visualMapModel,
            i = n.itemSize;

        if (n.option.hoverLink) {
          var r = [0, i[1]],
              o = n.getExtent();
          e = p(g(r[0], e), r[1]);

          var a = function (e, t, n) {
            var i = 6,
                r = e.get("hoverLinkDataSize");
            r && (i = d(r, t, n, !0) / 2);
            return i;
          }(n, o, r),
              s = [e - a, e + a],
              l = d(e, r, o, !0),
              u = [d(s[0], r, o, !0), d(s[1], r, o, !0)];

          s[0] < r[0] && (u[0] = -1 / 0), s[1] > r[1] && (u[1] = 1 / 0), t && (u[0] === -1 / 0 ? this._showIndicator(l, u[1], "< ", a) : u[1] === 1 / 0 ? this._showIndicator(l, u[0], "> ", a) : this._showIndicator(l, l, "≈ ", a));
          var f = this._hoverLinkDataIndices,
              v = [];
          (t || y(n)) && (v = this._hoverLinkDataIndices = n.findTargetDataIndices(u));
          var m = h.compressBatches(f, v);
          this._dispatchHighDown("downplay", c.makeHighDownBatch(m[0], n)), this._dispatchHighDown("highlight", c.makeHighDownBatch(m[1], n));
        }
      },
      _hoverLinkFromSeriesMouseOver: function _hoverLinkFromSeriesMouseOver(e) {
        var t = e.target,
            n = this.visualMapModel;

        if (t && null != t.dataIndex) {
          var i = this.ecModel.getSeriesByIndex(t.seriesIndex);

          if (n.isTargetSeries(i)) {
            var r = i.getData(t.dataType),
                o = r.get(n.getDataDimension(r), t.dataIndex, !0);
            isNaN(o) || this._showIndicator(o, o);
          }
        }
      },
      _hideIndicator: function _hideIndicator() {
        var e = this._shapes;
        e.indicator && e.indicator.attr("invisible", !0), e.indicatorLabel && e.indicatorLabel.attr("invisible", !0);
      },
      _clearHoverLinkToSeries: function _clearHoverLinkToSeries() {
        this._hideIndicator();

        var e = this._hoverLinkDataIndices;
        this._dispatchHighDown("downplay", c.makeHighDownBatch(e, this.visualMapModel)), e.length = 0;
      },
      _clearHoverLinkFromSeries: function _clearHoverLinkFromSeries() {
        this._hideIndicator();

        var e = this.api.getZr();
        e.off("mouseover", this._hoverLinkFromSeriesMouseOver), e.off("mouseout", this._hideIndicator);
      },
      _applyTransform: function _applyTransform(e, t, n, r) {
        var o = s.getTransform(t, r ? null : this.group);
        return s[i.isArray(e) ? "applyTransform" : "transformDirection"](e, o, n);
      },
      _dispatchHighDown: function _dispatchHighDown(e, t) {
        t && t.length && this.api.dispatchAction({
          type: e,
          batch: t
        });
      },
      dispose: function dispose() {
        this._clearHoverLinkFromSeries(), this._clearHoverLinkToSeries();
      },
      remove: function remove() {
        this._clearHoverLinkFromSeries(), this._clearHoverLinkToSeries();
      }
    });

    function m(e, t, n, i) {
      return new s.Polygon({
        shape: {
          points: e
        },
        draggable: !!n,
        cursor: t,
        drift: n,
        onmousemove: function onmousemove(e) {
          o.stop(e.event);
        },
        ondragend: i
      });
    }

    function y(e) {
      var t = e.get("hoverLinkOnHandle");
      return !!(null == t ? e.get("realtime") : t);
    }

    function x(e) {
      return "vertical" === e ? "ns-resize" : "ew-resize";
    }

    var _ = v;
    e.exports = _;
  }, function (e, t, n) {
    n(9).__DEV__;
    var i = n(1),
        r = n(362),
        o = n(91),
        a = n(363),
        s = n(6).reformIntervals,
        l = r.extend({
      type: "visualMap.piecewise",
      defaultOption: {
        selected: null,
        minOpen: !1,
        maxOpen: !1,
        align: "auto",
        itemWidth: 20,
        itemHeight: 14,
        itemSymbol: "roundRect",
        pieceList: null,
        categories: null,
        splitNumber: 5,
        selectedMode: "multiple",
        itemGap: 10,
        hoverLink: !0,
        showLabel: null
      },
      optionUpdated: function optionUpdated(e, t) {
        l.superApply(this, "optionUpdated", arguments), this._pieceList = [], this.resetExtent();

        var n = this._mode = this._determineMode();

        u[this._mode].call(this), this._resetSelected(e, t);
        var r = this.option.categories;
        this.resetVisual(function (e, t) {
          "categories" === n ? (e.mappingMethod = "category", e.categories = i.clone(r)) : (e.dataExtent = this.getExtent(), e.mappingMethod = "piecewise", e.pieceList = i.map(this._pieceList, function (e) {
            e = i.clone(e);
            return "inRange" !== t && (e.visual = null), e;
          }));
        });
      },
      completeVisualOption: function completeVisualOption() {
        var e = this.option,
            t = {},
            n = o.listVisualTypes(),
            s = this.isCategory();

        function l(e, t, n) {
          return e && e[t] && (i.isObject(e[t]) ? e[t].hasOwnProperty(n) : e[t] === n);
        }

        i.each(e.pieces, function (e) {
          i.each(n, function (n) {
            e.hasOwnProperty(n) && (t[n] = 1);
          });
        }), i.each(t, function (t, n) {
          var r = 0;
          i.each(this.stateList, function (t) {
            r |= l(e, t, n) || l(e.target, t, n);
          }, this), !r && i.each(this.stateList, function (t) {
            (e[t] || (e[t] = {}))[n] = a.get(n, "inRange" === t ? "active" : "inactive", s);
          });
        }, this), r.prototype.completeVisualOption.apply(this, arguments);
      },
      _resetSelected: function _resetSelected(e, t) {
        var n = this.option,
            r = this._pieceList,
            o = (t ? n : e).selected || {};

        if (n.selected = o, i.each(r, function (e, t) {
          var n = this.getSelectedMapKey(e);
          o.hasOwnProperty(n) || (o[n] = !0);
        }, this), "single" === n.selectedMode) {
          var a = !1;
          i.each(r, function (e, t) {
            var n = this.getSelectedMapKey(e);
            o[n] && (a ? o[n] = !1 : a = !0);
          }, this);
        }
      },
      getSelectedMapKey: function getSelectedMapKey(e) {
        return "categories" === this._mode ? e.value + "" : e.index + "";
      },
      getPieceList: function getPieceList() {
        return this._pieceList;
      },
      _determineMode: function _determineMode() {
        var e = this.option;
        return e.pieces && e.pieces.length > 0 ? "pieces" : this.option.categories ? "categories" : "splitNumber";
      },
      setSelected: function setSelected(e) {
        this.option.selected = i.clone(e);
      },
      getValueState: function getValueState(e) {
        var t = o.findPieceIndex(e, this._pieceList);
        return null != t && this.option.selected[this.getSelectedMapKey(this._pieceList[t])] ? "inRange" : "outOfRange";
      },
      findTargetDataIndices: function findTargetDataIndices(e) {
        var t = [];
        return this.eachTargetSeries(function (n) {
          var i = [],
              r = n.getData();
          r.each(this.getDataDimension(r), function (t, n) {
            o.findPieceIndex(t, this._pieceList) === e && i.push(n);
          }, this), t.push({
            seriesId: n.id,
            dataIndex: i
          });
        }, this), t;
      },
      getRepresentValue: function getRepresentValue(e) {
        var t;
        if (this.isCategory()) t = e.value;else if (null != e.value) t = e.value;else {
          var n = e.interval || [];
          t = n[0] === -1 / 0 && n[1] === 1 / 0 ? 0 : (n[0] + n[1]) / 2;
        }
        return t;
      },
      getVisualMeta: function getVisualMeta(e) {
        if (!this.isCategory()) {
          var t = [],
              n = [],
              r = this,
              o = this._pieceList.slice();

          if (o.length) {
            var a = o[0].interval[0];
            a !== -1 / 0 && o.unshift({
              interval: [-1 / 0, a]
            }), (a = o[o.length - 1].interval[1]) !== 1 / 0 && o.push({
              interval: [a, 1 / 0]
            });
          } else o.push({
            interval: [-1 / 0, 1 / 0]
          });

          var s = -1 / 0;
          return i.each(o, function (e) {
            var t = e.interval;
            t && (t[0] > s && l([s, t[0]], "outOfRange"), l(t.slice()), s = t[1]);
          }, this), {
            stops: t,
            outerColors: n
          };
        }

        function l(i, o) {
          var a = r.getRepresentValue({
            interval: i
          });
          o || (o = r.getValueState(a));
          var s = e(a, o);
          i[0] === -1 / 0 ? n[0] = s : i[1] === 1 / 0 ? n[1] = s : t.push({
            value: i[0],
            color: s
          }, {
            value: i[1],
            color: s
          });
        }
      }
    }),
        u = {
      splitNumber: function splitNumber() {
        var e = this.option,
            t = this._pieceList,
            n = Math.min(e.precision, 20),
            r = this.getExtent(),
            o = e.splitNumber;
        o = Math.max(parseInt(o, 10), 1), e.splitNumber = o;

        for (var a = (r[1] - r[0]) / o; +a.toFixed(n) !== a && n < 5;) {
          n++;
        }

        e.precision = n, a = +a.toFixed(n), e.minOpen && t.push({
          interval: [-1 / 0, r[0]],
          close: [0, 0]
        });

        for (var l = 0, u = r[0]; l < o; u += a, l++) {
          var c = l === o - 1 ? r[1] : u + a;
          t.push({
            interval: [u, c],
            close: [1, 1]
          });
        }

        e.maxOpen && t.push({
          interval: [r[1], 1 / 0],
          close: [0, 0]
        }), s(t), i.each(t, function (e, t) {
          e.index = t, e.text = this.formatValueText(e.interval);
        }, this);
      },
      categories: function categories() {
        var e = this.option;
        i.each(e.categories, function (e) {
          this._pieceList.push({
            text: this.formatValueText(e, !0),
            value: e
          });
        }, this), c(e, this._pieceList);
      },
      pieces: function pieces() {
        var e = this.option,
            t = this._pieceList;
        i.each(e.pieces, function (e, n) {
          i.isObject(e) || (e = {
            value: e
          });
          var r = {
            text: "",
            index: n
          };

          if (null != e.label && (r.text = e.label), e.hasOwnProperty("value")) {
            var a = r.value = e.value;
            r.interval = [a, a], r.close = [1, 1];
          } else {
            for (var s = r.interval = [], l = r.close = [0, 0], u = [1, 0, 1], c = [-1 / 0, 1 / 0], h = [], d = 0; d < 2; d++) {
              for (var f = [["gte", "gt", "min"], ["lte", "lt", "max"]][d], p = 0; p < 3 && null == s[d]; p++) {
                s[d] = e[f[p]], l[d] = u[p], h[d] = 2 === p;
              }

              null == s[d] && (s[d] = c[d]);
            }

            h[0] && s[1] === 1 / 0 && (l[0] = 0), h[1] && s[0] === -1 / 0 && (l[1] = 0), s[0] === s[1] && l[0] && l[1] && (r.value = s[0]);
          }

          r.visual = o.retrieveVisuals(e), t.push(r);
        }, this), c(e, t), s(t), i.each(t, function (e) {
          var t = e.close,
              n = [["<", "≤"][t[1]], [">", "≥"][t[0]]];
          e.text = e.text || this.formatValueText(null != e.value ? e.value : e.interval, !1, n);
        }, this);
      }
    };

    function c(e, t) {
      var n = e.inverse;
      ("vertical" === e.orient ? !n : n) && t.reverse();
    }

    var h = l;
    e.exports = h;
  }, function (e, t, n) {
    var i = n(1),
        r = n(364),
        o = n(5),
        a = n(40).createSymbol,
        s = n(14),
        l = n(365),
        u = r.extend({
      type: "visualMap.piecewise",
      doRender: function doRender() {
        var e = this.group;
        e.removeAll();

        var t = this.visualMapModel,
            n = t.get("textGap"),
            r = t.textStyleModel,
            a = r.getFont(),
            l = r.getTextColor(),
            u = this._getItemAlign(),
            c = t.itemSize,
            h = this._getViewData(),
            d = h.endsText,
            f = i.retrieve(t.get("showLabel", !0), !d);

        d && this._renderEndsText(e, d[0], c, f, u), i.each(h.viewPieceList, function (r) {
          var s = r.piece,
              h = new o.Group();
          h.onclick = i.bind(this._onItemClick, this, s), this._enableHoverLink(h, r.indexInModelPieceList);
          var d = t.getRepresentValue(s);

          if (this._createItemSymbol(h, d, [0, 0, c[0], c[1]]), f) {
            var p = this.visualMapModel.getValueState(d);
            h.add(new o.Text({
              style: {
                x: "right" === u ? -n : c[0] + n,
                y: c[1] / 2,
                text: s.text,
                textVerticalAlign: "middle",
                textAlign: u,
                textFont: a,
                textFill: l,
                opacity: "outOfRange" === p ? .5 : 1
              }
            }));
          }

          e.add(h);
        }, this), d && this._renderEndsText(e, d[1], c, f, u), s.box(t.get("orient"), e, t.get("itemGap")), this.renderBackground(e), this.positionGroup(e);
      },
      _enableHoverLink: function _enableHoverLink(e, t) {
        function n(e) {
          var n = this.visualMapModel;
          n.option.hoverLink && this.api.dispatchAction({
            type: e,
            batch: l.makeHighDownBatch(n.findTargetDataIndices(t), n)
          });
        }

        e.on("mouseover", i.bind(n, this, "highlight")).on("mouseout", i.bind(n, this, "downplay"));
      },
      _getItemAlign: function _getItemAlign() {
        var e = this.visualMapModel,
            t = e.option;
        if ("vertical" === t.orient) return l.getItemAlign(e, this.api, e.itemSize);
        var n = t.align;
        return n && "auto" !== n || (n = "left"), n;
      },
      _renderEndsText: function _renderEndsText(e, t, n, i, r) {
        if (t) {
          var a = new o.Group(),
              s = this.visualMapModel.textStyleModel;
          a.add(new o.Text({
            style: {
              x: i ? "right" === r ? n[0] : 0 : n[0] / 2,
              y: n[1] / 2,
              textVerticalAlign: "middle",
              textAlign: i ? r : "center",
              text: t,
              textFont: s.getFont(),
              textFill: s.getTextColor()
            }
          })), e.add(a);
        }
      },
      _getViewData: function _getViewData() {
        var e = this.visualMapModel,
            t = i.map(e.getPieceList(), function (e, t) {
          return {
            piece: e,
            indexInModelPieceList: t
          };
        }),
            n = e.get("text"),
            r = e.get("orient"),
            o = e.get("inverse");
        return ("horizontal" === r ? o : !o) ? t.reverse() : n && (n = n.slice().reverse()), {
          viewPieceList: t,
          endsText: n
        };
      },
      _createItemSymbol: function _createItemSymbol(e, t, n) {
        e.add(a(this.getControllerVisual(t, "symbol"), n[0], n[1], n[2], n[3], this.getControllerVisual(t, "color")));
      },
      _onItemClick: function _onItemClick(e) {
        var t = this.visualMapModel,
            n = t.option,
            r = i.clone(n.selected),
            o = t.getSelectedMapKey(e);
        "single" === n.selectedMode ? (r[o] = !0, i.each(r, function (e, t) {
          r[t] = t === o;
        })) : r[o] = !r[o], this.api.dispatchAction({
          type: "selectDataRange",
          from: this.uid,
          visualMapId: this.visualMapModel.id,
          selected: r
        });
      }
    });
    e.exports = u;
  }, function (e, t, n) {
    n(931), (0, n(152).registerPainter)("vml", n(932));
  }, function (e, t, n) {
    var i = n(21),
        r = n(16).applyTransform,
        o = n(17),
        a = n(53),
        s = n(35),
        l = n(156),
        u = n(292),
        c = n(119),
        h = n(100),
        d = n(85),
        f = n(20),
        p = n(102),
        g = n(157),
        v = n(368),
        m = p.CMD,
        y = Math.round,
        x = Math.sqrt,
        _ = Math.abs,
        b = Math.cos,
        w = Math.sin,
        S = Math.max;

    if (!i.canvasSupported) {
      var T = 21600,
          C = T / 2,
          k = function k(e) {
        e.style.cssText = "position:absolute;left:0;top:0;width:1px;height:1px;", e.coordsize = T + "," + T, e.coordorigin = "0,0";
      },
          M = function M(e, t, n) {
        return "rgb(" + [e, t, n].join(",") + ")";
      },
          E = function E(e, t) {
        t && e && t.parentNode !== e && e.appendChild(t);
      },
          A = function A(e, t) {
        t && e && t.parentNode === e && e.removeChild(t);
      },
          I = function I(e, t, n) {
        return 1e5 * (parseFloat(e) || 0) + 1e3 * (parseFloat(t) || 0) + n;
      },
          P = l.parsePercent,
          O = function O(e, t, n) {
        var i = a.parse(t);
        n = +n, isNaN(n) && (n = 1), i && (e.color = M(i[0], i[1], i[2]), e.opacity = n * i[3]);
      },
          L = function L(e, t, n, i) {
        var o = "fill" === t,
            s = e.getElementsByTagName(t)[0];
        null != n[t] && "none" !== n[t] && (o || !o && n.lineWidth) ? (e[o ? "filled" : "stroked"] = "true", n[t] instanceof g && A(e, s), s || (s = v.createNode(t)), o ? function (e, t, n) {
          var i,
              o,
              s = t.fill;
          if (null != s) if (s instanceof g) {
            var l,
                u = 0,
                c = [0, 0],
                h = 0,
                d = 1,
                f = n.getBoundingRect(),
                p = f.width,
                v = f.height;

            if ("linear" === s.type) {
              l = "gradient";
              var m = n.transform,
                  y = [s.x * p, s.y * v],
                  x = [s.x2 * p, s.y2 * v];
              m && (r(y, y, m), r(x, x, m));

              var _ = x[0] - y[0],
                  b = x[1] - y[1];

              (u = 180 * Math.atan2(_, b) / Math.PI) < 0 && (u += 360), u < 1e-6 && (u = 0);
            } else {
              l = "gradientradial";
              y = [s.x * p, s.y * v], m = n.transform;
              var w = n.scale,
                  C = p,
                  k = v;
              c = [(y[0] - f.x) / C, (y[1] - f.y) / k], m && r(y, y, m), C /= w[0] * T, k /= w[1] * T;
              var E = S(C, k);
              h = 0 / E, d = 2 * s.r / E - h;
            }

            var A = s.colorStops.slice();
            A.sort(function (e, t) {
              return e.offset - t.offset;
            });

            for (var I = A.length, P = [], L = [], D = 0; D < I; D++) {
              var N = A[D],
                  j = (i = N.color, o = void 0, o = a.parse(i), [M(o[0], o[1], o[2]), o[3]]);
              L.push(N.offset * d + h + " " + j[0]), 0 !== D && D !== I - 1 || P.push(j);
            }

            if (I >= 2) {
              var R = P[0][0],
                  F = P[1][0],
                  z = P[0][1] * t.opacity,
                  B = P[1][1] * t.opacity;
              e.type = l, e.method = "none", e.focus = "100%", e.angle = u, e.color = R, e.color2 = F, e.colors = L.join(","), e.opacity = B, e.opacity2 = z;
            }

            "radial" === l && (e.focusposition = c.join(","));
          } else O(e, s, t.opacity);
        }(s, n, i) : function (e, t) {
          t.lineDash && (e.dashstyle = t.lineDash.join(" ")), null == t.stroke || t.stroke instanceof g || O(e, t.stroke, t.opacity);
        }(s, n), E(e, s)) : (e[o ? "filled" : "stroked"] = "false", A(e, s));
      },
          D = [[], [], []];

      f.prototype.brushVML = function (e) {
        var t = this.style,
            n = this._vmlEl;
        n || (n = v.createNode("shape"), k(n), this._vmlEl = n), L(n, "fill", t, this), L(n, "stroke", t, this);
        var i = this.transform,
            o = null != i,
            a = n.getElementsByTagName("stroke")[0];

        if (a) {
          var s = t.lineWidth;

          if (o && !t.strokeNoScale) {
            var l = i[0] * i[3] - i[1] * i[2];
            s *= x(_(l));
          }

          a.weight = s + "px";
        }

        var u = this.path || (this.path = new p());
        this.__dirtyPath && (u.beginPath(), u.subPixelOptimize = !1, this.buildPath(u, this.shape), u.toStatic(), this.__dirtyPath = !1), n.path = function (e, t) {
          var n,
              i,
              o,
              a,
              s,
              l,
              u = m.M,
              c = m.C,
              h = m.L,
              d = m.A,
              f = m.Q,
              p = [],
              g = e.data,
              v = e.len();

          for (a = 0; a < v;) {
            switch (i = "", n = 0, o = g[a++]) {
              case u:
                i = " m ", n = 1, s = g[a++], l = g[a++], D[0][0] = s, D[0][1] = l;
                break;

              case h:
                i = " l ", n = 1, s = g[a++], l = g[a++], D[0][0] = s, D[0][1] = l;
                break;

              case f:
              case c:
                i = " c ", n = 3;

                var _,
                    S,
                    k = g[a++],
                    M = g[a++],
                    E = g[a++],
                    A = g[a++];

                o === f ? (_ = E, S = A, E = (E + 2 * k) / 3, A = (A + 2 * M) / 3, k = (s + 2 * k) / 3, M = (l + 2 * M) / 3) : (_ = g[a++], S = g[a++]), D[0][0] = k, D[0][1] = M, D[1][0] = E, D[1][1] = A, D[2][0] = _, D[2][1] = S, s = _, l = S;
                break;

              case d:
                var I = 0,
                    P = 0,
                    O = 1,
                    L = 1,
                    N = 0;
                t && (I = t[4], P = t[5], O = x(t[0] * t[0] + t[1] * t[1]), L = x(t[2] * t[2] + t[3] * t[3]), N = Math.atan2(-t[1] / L, t[0] / O));
                var j = g[a++],
                    R = g[a++],
                    F = g[a++],
                    z = g[a++],
                    B = g[a++] + N,
                    V = g[a++] + B + N;
                a++;
                var H = g[a++],
                    W = j + b(B) * F,
                    G = R + w(B) * z,
                    U = (k = j + b(V) * F, M = R + w(V) * z, H ? " wa " : " at ");
                Math.abs(W - k) < 1e-4 && (Math.abs(V - B) > .01 ? H && (W += .0125) : Math.abs(G - R) < 1e-4 ? H && W < j || !H && W > j ? M -= .0125 : M += .0125 : H && G < R || !H && G > R ? k += .0125 : k -= .0125), p.push(U, y(((j - F) * O + I) * T - C), ",", y(((R - z) * L + P) * T - C), ",", y(((j + F) * O + I) * T - C), ",", y(((R + z) * L + P) * T - C), ",", y((W * O + I) * T - C), ",", y((G * L + P) * T - C), ",", y((k * O + I) * T - C), ",", y((M * L + P) * T - C)), s = k, l = M;
                break;

              case m.R:
                var Y = D[0],
                    X = D[1];
                Y[0] = g[a++], Y[1] = g[a++], X[0] = Y[0] + g[a++], X[1] = Y[1] + g[a++], t && (r(Y, Y, t), r(X, X, t)), Y[0] = y(Y[0] * T - C), X[0] = y(X[0] * T - C), Y[1] = y(Y[1] * T - C), X[1] = y(X[1] * T - C), p.push(" m ", Y[0], ",", Y[1], " l ", X[0], ",", Y[1], " l ", X[0], ",", X[1], " l ", Y[0], ",", X[1]);
                break;

              case m.Z:
                p.push(" x ");
            }

            if (n > 0) {
              p.push(i);

              for (var q = 0; q < n; q++) {
                var Z = D[q];
                t && r(Z, Z, t), p.push(y(Z[0] * T - C), ",", y(Z[1] * T - C), q < n - 1 ? "," : "");
              }
            }
          }

          return p.join("");
        }(u, this.transform), n.style.zIndex = I(this.zlevel, this.z, this.z2), E(e, n), null != t.text ? this.drawRectText(e, this.getBoundingRect()) : this.removeRectText(e);
      }, f.prototype.onRemove = function (e) {
        A(e, this._vmlEl), this.removeRectText(e);
      }, f.prototype.onAdd = function (e) {
        E(e, this._vmlEl), this.appendRectText(e);
      };
      h.prototype.brushVML = function (e) {
        var t,
            n,
            i,
            o = this.style,
            a = o.image;

        if ("object" == typeof (i = a) && i.tagName && "IMG" === i.tagName.toUpperCase()) {
          var s = a.src;
          if (s === this._imageSrc) t = this._imageWidth, n = this._imageHeight;else {
            var l = a.runtimeStyle,
                u = l.width,
                c = l.height;
            l.width = "auto", l.height = "auto", t = a.width, n = a.height, l.width = u, l.height = c, this._imageSrc = s, this._imageWidth = t, this._imageHeight = n;
          }
          a = s;
        } else a === this._imageSrc && (t = this._imageWidth, n = this._imageHeight);

        if (a) {
          var h = o.x || 0,
              d = o.y || 0,
              f = o.width,
              p = o.height,
              g = o.sWidth,
              m = o.sHeight,
              _ = o.sx || 0,
              b = o.sy || 0,
              w = g && m,
              T = this._vmlEl;

          T || (T = v.doc.createElement("div"), k(T), this._vmlEl = T);
          var C,
              M = T.style,
              A = !1,
              P = 1,
              O = 1;

          if (this.transform && (C = this.transform, P = x(C[0] * C[0] + C[1] * C[1]), O = x(C[2] * C[2] + C[3] * C[3]), A = C[1] || C[2]), A) {
            var L = [h, d],
                D = [h + f, d],
                N = [h, d + p],
                j = [h + f, d + p];
            r(L, L, C), r(D, D, C), r(N, N, C), r(j, j, C);
            var R = S(L[0], D[0], N[0], j[0]),
                F = S(L[1], D[1], N[1], j[1]),
                z = [];
            z.push("M11=", C[0] / P, ",", "M12=", C[2] / O, ",", "M21=", C[1] / P, ",", "M22=", C[3] / O, ",", "Dx=", y(h * P + C[4]), ",", "Dy=", y(d * O + C[5])), M.padding = "0 " + y(R) + "px " + y(F) + "px 0", M.filter = "progid:DXImageTransform.Microsoft.Matrix(" + z.join("") + ", SizingMethod=clip)";
          } else C && (h = h * P + C[4], d = d * O + C[5]), M.filter = "", M.left = y(h) + "px", M.top = y(d) + "px";

          var B = this._imageEl,
              V = this._cropEl;
          B || (B = v.doc.createElement("div"), this._imageEl = B);
          var H = B.style;

          if (w) {
            if (t && n) H.width = y(P * t * f / g) + "px", H.height = y(O * n * p / m) + "px";else {
              var W = new Image(),
                  G = this;
              W.onload = function () {
                W.onload = null, t = W.width, n = W.height, H.width = y(P * t * f / g) + "px", H.height = y(O * n * p / m) + "px", G._imageWidth = t, G._imageHeight = n, G._imageSrc = a;
              }, W.src = a;
            }
            V || ((V = v.doc.createElement("div")).style.overflow = "hidden", this._cropEl = V);
            var U = V.style;
            U.width = y((f + _ * f / g) * P), U.height = y((p + b * p / m) * O), U.filter = "progid:DXImageTransform.Microsoft.Matrix(Dx=" + -_ * f / g * P + ",Dy=" + -b * p / m * O + ")", V.parentNode || T.appendChild(V), B.parentNode !== V && V.appendChild(B);
          } else H.width = y(P * f) + "px", H.height = y(O * p) + "px", T.appendChild(B), V && V.parentNode && (T.removeChild(V), this._cropEl = null);

          var Y = "",
              X = o.opacity;
          X < 1 && (Y += ".Alpha(opacity=" + y(100 * X) + ") "), Y += "progid:DXImageTransform.Microsoft.AlphaImageLoader(src=" + a + ", SizingMethod=scale)", H.filter = Y, T.style.zIndex = I(this.zlevel, this.z, this.z2), E(e, T), null != o.text && this.drawRectText(e, this.getBoundingRect());
        }
      }, h.prototype.onRemove = function (e) {
        A(e, this._vmlEl), this._vmlEl = null, this._cropEl = null, this._imageEl = null, this.removeRectText(e);
      }, h.prototype.onAdd = function (e) {
        E(e, this._vmlEl), this.appendRectText(e);
      };
      var N,
          j = {},
          R = 0,
          F = document.createElement("div");
      s.$override("measureText", function (e, t) {
        var n = v.doc;
        N || ((N = n.createElement("div")).style.cssText = "position:absolute;top:-20000px;left:0;padding:0;margin:0;border:none;white-space:pre;", v.doc.body.appendChild(N));

        try {
          N.style.font = t;
        } catch (e) {}

        return N.innerHTML = "", N.appendChild(n.createTextNode(e)), {
          width: N.offsetWidth
        };
      });

      for (var z = new o(), B = function B(e, t, n, i) {
        var o = this.style;
        this.__dirty && l.normalizeTextStyle(o, !0);
        var a = o.text;

        if (null != a && (a += ""), a) {
          if (o.rich) {
            var u = s.parseRichText(a, o);
            a = [];

            for (var c = 0; c < u.lines.length; c++) {
              for (var h = u.lines[c].tokens, d = [], f = 0; f < h.length; f++) {
                d.push(h[f].text);
              }

              a.push(d.join(""));
            }

            a = a.join("\n");
          }

          var p,
              g,
              m = o.textAlign,
              x = o.textVerticalAlign,
              _ = function (e) {
            var t = j[e];

            if (!t) {
              R > 100 && (R = 0, j = {});
              var n,
                  i = F.style;

              try {
                i.font = e, n = i.fontFamily.split(",")[0];
              } catch (e) {}

              t = {
                style: i.fontStyle || "normal",
                variant: i.fontVariant || "normal",
                weight: i.fontWeight || "normal",
                size: 0 | parseFloat(i.fontSize || 12),
                family: n || "Microsoft YaHei"
              }, j[e] = t, R++;
            }

            return t;
          }(o.font),
              b = _.style + " " + _.variant + " " + _.weight + " " + _.size + 'px "' + _.family + '"';

          n = n || s.getBoundingRect(a, b, m, x, o.textPadding, o.textLineHeight);
          var w = this.transform;
          if (w && !i && (z.copy(t), z.applyTransform(w), t = z), i) p = t.x, g = t.y;else {
            var S = o.textPosition;
            if (S instanceof Array) p = t.x + P(S[0], t.width), g = t.y + P(S[1], t.height), m = m || "left";else {
              var T = this.calculateTextPosition ? this.calculateTextPosition({}, o, t) : s.calculateTextPosition({}, o, t);
              p = T.x, g = T.y, m = m || T.textAlign, x = x || T.textVerticalAlign;
            }
          }
          p = s.adjustTextX(p, n.width, m), g = s.adjustTextY(g, n.height, x), g += n.height / 2;
          var C,
              M,
              A,
              O = v.createNode,
              D = this._textVmlEl;
          D ? M = (C = (A = D.firstChild).nextSibling).nextSibling : (D = O("line"), C = O("path"), M = O("textpath"), A = O("skew"), M.style["v-text-align"] = "left", k(D), C.textpathok = !0, M.on = !0, D.from = "0 0", D.to = "1000 0.05", E(D, A), E(D, C), E(D, M), this._textVmlEl = D);
          var N = [p, g],
              B = D.style;
          w && i ? (r(N, N, w), A.on = !0, A.matrix = w[0].toFixed(3) + "," + w[2].toFixed(3) + "," + w[1].toFixed(3) + "," + w[3].toFixed(3) + ",0,0", A.offset = (y(N[0]) || 0) + "," + (y(N[1]) || 0), A.origin = "0 0", B.left = "0px", B.top = "0px") : (A.on = !1, B.left = y(p) + "px", B.top = y(g) + "px"), M.string = String(a).replace(/&/g, "&amp;").replace(/"/g, "&quot;");

          try {
            M.style.font = b;
          } catch (e) {}

          L(D, "fill", {
            fill: o.textFill,
            opacity: o.opacity
          }, this), L(D, "stroke", {
            stroke: o.textStroke,
            opacity: o.opacity,
            lineDash: o.lineDash || null
          }, this), D.style.zIndex = I(this.zlevel, this.z, this.z2), E(e, D);
        }
      }, V = function V(e) {
        A(e, this._textVmlEl), this._textVmlEl = null;
      }, H = function H(e) {
        E(e, this._textVmlEl);
      }, W = [u, c, h, f, d], G = 0; G < W.length; G++) {
        var U = W[G].prototype;
        U.drawRectText = B, U.removeRectText = V, U.appendRectText = H;
      }

      d.prototype.brushVML = function (e) {
        var t = this.style;
        null != t.text ? this.drawRectText(e, {
          x: t.x || 0,
          y: t.y || 0,
          width: 0,
          height: 0
        }, this.getBoundingRect(), !0) : this.removeRectText(e);
      }, d.prototype.onRemove = function (e) {
        this.removeRectText(e);
      }, d.prototype.onAdd = function (e) {
        this.appendRectText(e);
      };
    }
  }, function (e, t, n) {
    var i = n(118),
        r = n(368),
        o = n(1).each;

    function a(e) {
      return parseInt(e, 10);
    }

    function s(e, t) {
      r.initVML(), this.root = e, this.storage = t;
      var n = document.createElement("div"),
          i = document.createElement("div");
      n.style.cssText = "display:inline-block;overflow:hidden;position:relative;width:300px;height:150px;", i.style.cssText = "position:absolute;left:0;top:0;", e.appendChild(n), this._vmlRoot = i, this._vmlViewport = n, this.resize();
      var o = t.delFromStorage,
          a = t.addToStorage;
      t.delFromStorage = function (e) {
        o.call(t, e), e && e.onRemove && e.onRemove(i);
      }, t.addToStorage = function (e) {
        e.onAdd && e.onAdd(i), a.call(t, e);
      }, this._firstPaint = !0;
    }

    s.prototype = {
      constructor: s,
      getType: function getType() {
        return "vml";
      },
      getViewportRoot: function getViewportRoot() {
        return this._vmlViewport;
      },
      getViewportRootOffset: function getViewportRootOffset() {
        var e = this.getViewportRoot();
        if (e) return {
          offsetLeft: e.offsetLeft || 0,
          offsetTop: e.offsetTop || 0
        };
      },
      refresh: function refresh() {
        var e = this.storage.getDisplayList(!0, !0);

        this._paintList(e);
      },
      _paintList: function _paintList(e) {
        for (var t = this._vmlRoot, n = 0; n < e.length; n++) {
          var i = e[n];
          i.invisible || i.ignore ? (i.__alreadyNotVisible || i.onRemove(t), i.__alreadyNotVisible = !0) : (i.__alreadyNotVisible && i.onAdd(t), i.__alreadyNotVisible = !1, i.__dirty && (i.beforeBrush && i.beforeBrush(), (i.brushVML || i.brush).call(i, t), i.afterBrush && i.afterBrush())), i.__dirty = !1;
        }

        this._firstPaint && (this._vmlViewport.appendChild(t), this._firstPaint = !1);
      },
      resize: function resize(e, t) {
        e = null == e ? this._getWidth() : e, t = null == t ? this._getHeight() : t;

        if (this._width !== e || this._height !== t) {
          this._width = e, this._height = t;
          var n = this._vmlViewport.style;
          n.width = e + "px", n.height = t + "px";
        }
      },
      dispose: function dispose() {
        this.root.innerHTML = "", this._vmlRoot = this._vmlViewport = this.storage = null;
      },
      getWidth: function getWidth() {
        return this._width;
      },
      getHeight: function getHeight() {
        return this._height;
      },
      clear: function clear() {
        this._vmlViewport && this.root.removeChild(this._vmlViewport);
      },
      _getWidth: function _getWidth() {
        var e = this.root,
            t = e.currentStyle;
        return (e.clientWidth || a(t.width)) - a(t.paddingLeft) - a(t.paddingRight) | 0;
      },
      _getHeight: function _getHeight() {
        var e = this.root,
            t = e.currentStyle;
        return (e.clientHeight || a(t.height)) - a(t.paddingTop) - a(t.paddingBottom) | 0;
      }
    }, o(["getLayer", "insertLayer", "eachLayer", "eachBuiltinLayer", "eachOtherLayer", "getLayers", "modLayer", "delLayer", "clearLayer", "toDataURL", "pathToImage"], function (e) {
      var t;
      s.prototype[e] = (t = e, function () {
        i('In IE8.0 VML mode painter not support method "' + t + '"');
      });
    });
    var l = s;
    e.exports = l;
  }, function (e, t, n) {
    n(234), (0, n(152).registerPainter)("svg", n(934));
  }, function (e, t, n) {
    var i = n(235).createElement,
        r = n(1),
        o = n(118),
        a = n(20),
        s = n(100),
        l = n(85),
        u = n(935),
        c = n(936),
        h = n(937),
        d = n(938),
        f = n(234),
        p = f.path,
        g = f.image,
        v = f.text;

    function m(e) {
      return parseInt(e, 10);
    }

    function y(e, t) {
      return t && e && t.parentNode !== e;
    }

    function x(e, t, n) {
      if (y(e, t) && n) {
        var i = n.nextSibling;
        i ? e.insertBefore(t, i) : e.appendChild(t);
      }
    }

    function _(e, t) {
      if (y(e, t)) {
        var n = e.firstChild;
        n ? e.insertBefore(t, n) : e.appendChild(t);
      }
    }

    function b(e, t) {
      t && e && t.parentNode === e && e.removeChild(t);
    }

    function w(e) {
      return e.__textSvgEl;
    }

    function S(e) {
      return e.__svgEl;
    }

    var T = function T(e, t, n, o) {
      this.root = e, this.storage = t, this._opts = n = r.extend({}, n || {});
      var a = i("svg");
      a.setAttribute("xmlns", "http://www.w3.org/2000/svg"), a.setAttribute("version", "1.1"), a.setAttribute("baseProfile", "full"), a.style.cssText = "user-select:none;position:absolute;left:0;top:0;";
      var s = i("g");
      a.appendChild(s);
      var l = i("g");
      a.appendChild(l), this.gradientManager = new c(o, l), this.clipPathManager = new h(o, l), this.shadowManager = new d(o, l);
      var u = document.createElement("div");
      u.style.cssText = "overflow:hidden;position:relative", this._svgDom = a, this._svgRoot = l, this._backgroundRoot = s, this._viewport = u, e.appendChild(u), u.appendChild(a), this.resize(n.width, n.height), this._visibleList = [];
    };

    T.prototype = {
      constructor: T,
      getType: function getType() {
        return "svg";
      },
      getViewportRoot: function getViewportRoot() {
        return this._viewport;
      },
      getSvgDom: function getSvgDom() {
        return this._svgDom;
      },
      getSvgRoot: function getSvgRoot() {
        return this._svgRoot;
      },
      getViewportRootOffset: function getViewportRootOffset() {
        var e = this.getViewportRoot();
        if (e) return {
          offsetLeft: e.offsetLeft || 0,
          offsetTop: e.offsetTop || 0
        };
      },
      refresh: function refresh() {
        var e = this.storage.getDisplayList(!0);

        this._paintList(e);
      },
      setBackgroundColor: function setBackgroundColor(e) {
        this._backgroundRoot && this._backgroundNode && this._backgroundRoot.removeChild(this._backgroundNode);
        var t = i("rect");
        t.setAttribute("width", this.getWidth()), t.setAttribute("height", this.getHeight()), t.setAttribute("x", 0), t.setAttribute("y", 0), t.setAttribute("id", 0), t.style.fill = e, this._backgroundRoot.appendChild(t), this._backgroundNode = t;
      },
      _paintList: function _paintList(e) {
        this.gradientManager.markAllUnused(), this.clipPathManager.markAllUnused(), this.shadowManager.markAllUnused();
        var t,
            n,
            i = this._svgRoot,
            r = this._visibleList,
            o = e.length,
            c = [];

        for (t = 0; t < o; t++) {
          var h = e[t],
              d = (n = h) instanceof a ? p : n instanceof s ? g : n instanceof l ? v : p,
              f = S(h) || w(h);
          h.invisible || (h.__dirty && (d && d.brush(h), this.clipPathManager.update(h), h.style && (this.gradientManager.update(h.style.fill), this.gradientManager.update(h.style.stroke), this.shadowManager.update(f, h)), h.__dirty = !1), c.push(h));
        }

        var m,
            y = u(r, c);

        for (t = 0; t < y.length; t++) {
          if ((k = y[t]).removed) for (var T = 0; T < k.count; T++) {
            f = S(h = r[k.indices[T]]);
            var C = w(h);
            b(i, f), b(i, C);
          }
        }

        for (t = 0; t < y.length; t++) {
          var k;
          if ((k = y[t]).added) for (T = 0; T < k.count; T++) {
            f = S(h = c[k.indices[T]]), C = w(h);
            m ? x(i, f, m) : _(i, f), f ? x(i, C, f) : m ? x(i, C, m) : _(i, C), x(i, C, f), m = C || f || m, this.gradientManager.addWithoutUpdate(f || C, h), this.shadowManager.addWithoutUpdate(f || C, h), this.clipPathManager.markUsed(h);
          } else if (!k.removed) for (T = 0; T < k.count; T++) {
            f = S(h = c[k.indices[T]]), C = w(h), f = S(h), C = w(h);
            this.gradientManager.markUsed(h), this.gradientManager.addWithoutUpdate(f || C, h), this.shadowManager.markUsed(h), this.shadowManager.addWithoutUpdate(f || C, h), this.clipPathManager.markUsed(h), C && x(i, C, f), m = f || C || m;
          }
        }

        this.gradientManager.removeUnused(), this.clipPathManager.removeUnused(), this.shadowManager.removeUnused(), this._visibleList = c;
      },
      _getDefs: function _getDefs(e) {
        var t,
            n = this._svgDom;
        return 0 === (t = n.getElementsByTagName("defs")).length ? e ? ((t = n.insertBefore(i("defs"), n.firstChild)).contains || (t.contains = function (e) {
          var n = t.children;
          if (!n) return !1;

          for (var i = n.length - 1; i >= 0; --i) {
            if (n[i] === e) return !0;
          }

          return !1;
        }), t) : null : t[0];
      },
      resize: function resize(e, t) {
        var n = this._viewport;
        n.style.display = "none";
        var i = this._opts;

        if (null != e && (i.width = e), null != t && (i.height = t), e = this._getSize(0), t = this._getSize(1), n.style.display = "", this._width !== e || this._height !== t) {
          this._width = e, this._height = t;
          var r = n.style;
          r.width = e + "px", r.height = t + "px";
          var o = this._svgDom;
          o.setAttribute("width", e), o.setAttribute("height", t);
        }

        this._backgroundNode && (this._backgroundNode.setAttribute("width", e), this._backgroundNode.setAttribute("height", t));
      },
      getWidth: function getWidth() {
        return this._width;
      },
      getHeight: function getHeight() {
        return this._height;
      },
      _getSize: function _getSize(e) {
        var t = this._opts,
            n = ["width", "height"][e],
            i = ["clientWidth", "clientHeight"][e],
            r = ["paddingLeft", "paddingTop"][e],
            o = ["paddingRight", "paddingBottom"][e];
        if (null != t[n] && "auto" !== t[n]) return parseFloat(t[n]);
        var a = this.root,
            s = document.defaultView.getComputedStyle(a);
        return (a[i] || m(s[n]) || m(a.style[n])) - (m(s[r]) || 0) - (m(s[o]) || 0) | 0;
      },
      dispose: function dispose() {
        this.root.innerHTML = "", this._svgRoot = this._backgroundRoot = this._svgDom = this._backgroundNode = this._viewport = this.storage = null;
      },
      clear: function clear() {
        this._viewport && this.root.removeChild(this._viewport);
      },
      toDataURL: function toDataURL() {
        return this.refresh(), "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(this._svgDom.outerHTML.replace(/></g, ">\n\r<"));
      }
    }, r.each(["getLayer", "insertLayer", "eachLayer", "eachBuiltinLayer", "eachOtherLayer", "getLayers", "modLayer", "delLayer", "clearLayer", "pathToImage"], function (e) {
      var t;
      T.prototype[e] = (t = e, function () {
        o('In SVG mode painter not support method "' + t + '"');
      });
    });
    var C = T;
    e.exports = C;
  }, function (e, t) {
    function n() {}

    function i(e, t, n, i) {
      for (var r = 0, o = t.length, a = 0, s = 0; r < o; r++) {
        var l = t[r];

        if (l.removed) {
          for (u = [], c = s; c < s + l.count; c++) {
            u.push(c);
          }

          l.indices = u, s += l.count;
        } else {
          for (var u = [], c = a; c < a + l.count; c++) {
            u.push(c);
          }

          l.indices = u, a += l.count, l.added || (s += l.count);
        }
      }

      return t;
    }

    n.prototype = {
      diff: function diff(e, t, n) {
        n || (n = function n(e, t) {
          return e === t;
        }), this.equals = n;
        var r = this;
        e = e.slice();
        var o = (t = t.slice()).length,
            a = e.length,
            s = 1,
            l = o + a,
            u = [{
          newPos: -1,
          components: []
        }],
            c = this.extractCommon(u[0], t, e, 0);

        if (u[0].newPos + 1 >= o && c + 1 >= a) {
          for (var h = [], d = 0; d < t.length; d++) {
            h.push(d);
          }

          return [{
            indices: h,
            count: t.length
          }];
        }

        function f() {
          for (var n = -1 * s; n <= s; n += 2) {
            var l,
                c = u[n - 1],
                h = u[n + 1],
                d = (h ? h.newPos : 0) - n;
            c && (u[n - 1] = void 0);
            var f = c && c.newPos + 1 < o,
                p = h && 0 <= d && d < a;

            if (f || p) {
              if (!f || p && c.newPos < h.newPos ? (l = {
                newPos: (g = h).newPos,
                components: g.components.slice(0)
              }, r.pushComponent(l.components, void 0, !0)) : ((l = c).newPos++, r.pushComponent(l.components, !0, void 0)), d = r.extractCommon(l, t, e, n), l.newPos + 1 >= o && d + 1 >= a) return i(r, l.components, t, e);
              u[n] = l;
            } else u[n] = void 0;
          }

          var g;
          s++;
        }

        for (; s <= l;) {
          var p = f();
          if (p) return p;
        }
      },
      pushComponent: function pushComponent(e, t, n) {
        var i = e[e.length - 1];
        i && i.added === t && i.removed === n ? e[e.length - 1] = {
          count: i.count + 1,
          added: t,
          removed: n
        } : e.push({
          count: 1,
          added: t,
          removed: n
        });
      },
      extractCommon: function extractCommon(e, t, n, i) {
        for (var r = t.length, o = n.length, a = e.newPos, s = a - i, l = 0; a + 1 < r && s + 1 < o && this.equals(t[a + 1], n[s + 1]);) {
          a++, s++, l++;
        }

        return l && e.components.push({
          count: l
        }), e.newPos = a, s;
      },
      tokenize: function tokenize(e) {
        return e.slice();
      },
      join: function join(e) {
        return e.slice();
      }
    };
    var r = new n();

    e.exports = function (e, t, n) {
      return r.diff(e, t, n);
    };
  }, function (e, t, n) {
    var i = n(236),
        r = n(1),
        o = n(118),
        a = n(53);

    function s(e, t) {
      i.call(this, e, t, ["linearGradient", "radialGradient"], "__gradient_in_use__");
    }

    r.inherits(s, i), s.prototype.addWithoutUpdate = function (e, t) {
      if (t && t.style) {
        var n = this;
        r.each(["fill", "stroke"], function (i) {
          if (t.style[i] && ("linear" === t.style[i].type || "radial" === t.style[i].type)) {
            var r,
                o = t.style[i],
                a = n.getDefs(!0);
            o._dom ? (r = o._dom, a.contains(o._dom) || n.addDom(r)) : r = n.add(o), n.markUsed(t);
            var s = r.getAttribute("id");
            e.setAttribute(i, "url(#" + s + ")");
          }
        });
      }
    }, s.prototype.add = function (e) {
      var t;
      if ("linear" === e.type) t = this.createElement("linearGradient");else {
        if ("radial" !== e.type) return o("Illegal gradient type."), null;
        t = this.createElement("radialGradient");
      }
      return e.id = e.id || this.nextId++, t.setAttribute("id", "zr" + this._zrId + "-gradient-" + e.id), this.updateDom(e, t), this.addDom(t), t;
    }, s.prototype.update = function (e) {
      var t = this;
      i.prototype.update.call(this, e, function () {
        var n = e.type,
            i = e._dom.tagName;
        "linear" === n && "linearGradient" === i || "radial" === n && "radialGradient" === i ? t.updateDom(e, e._dom) : (t.removeDom(e), t.add(e));
      });
    }, s.prototype.updateDom = function (e, t) {
      if ("linear" === e.type) t.setAttribute("x1", e.x), t.setAttribute("y1", e.y), t.setAttribute("x2", e.x2), t.setAttribute("y2", e.y2);else {
        if ("radial" !== e.type) return void o("Illegal gradient type.");
        t.setAttribute("cx", e.x), t.setAttribute("cy", e.y), t.setAttribute("r", e.r);
      }
      e.global ? t.setAttribute("gradientUnits", "userSpaceOnUse") : t.setAttribute("gradientUnits", "objectBoundingBox"), t.innerHTML = "";

      for (var n = e.colorStops, i = 0, r = n.length; i < r; ++i) {
        var s = this.createElement("stop");
        s.setAttribute("offset", 100 * n[i].offset + "%");
        var l = n[i].color;

        if (l.indexOf(!1)) {
          var u = a.parse(l)[3],
              c = a.toHex(l);
          s.setAttribute("stop-color", "#" + c), s.setAttribute("stop-opacity", u);
        } else s.setAttribute("stop-color", n[i].color);

        t.appendChild(s);
      }

      e._dom = t;
    }, s.prototype.markUsed = function (e) {
      if (e.style) {
        var t = e.style.fill;
        t && t._dom && i.prototype.markUsed.call(this, t._dom), (t = e.style.stroke) && t._dom && i.prototype.markUsed.call(this, t._dom);
      }
    };
    var l = s;
    e.exports = l;
  }, function (e, t, n) {
    var i = n(236),
        r = n(1),
        o = n(31);

    function a(e, t) {
      i.call(this, e, t, "clipPath", "__clippath_in_use__");
    }

    r.inherits(a, i), a.prototype.update = function (e) {
      var t = this.getSvgElement(e);
      t && this.updateDom(t, e.__clipPaths, !1);
      var n = this.getTextSvgElement(e);
      n && this.updateDom(n, e.__clipPaths, !0), this.markUsed(e);
    }, a.prototype.updateDom = function (e, t, n) {
      if (t && t.length > 0) {
        var i,
            r,
            a = this.getDefs(!0),
            s = t[0],
            l = n ? "_textDom" : "_dom";
        s[l] ? (r = s[l].getAttribute("id"), i = s[l], a.contains(i) || a.appendChild(i)) : (r = "zr" + this._zrId + "-clip-" + this.nextId, ++this.nextId, (i = this.createElement("clipPath")).setAttribute("id", r), a.appendChild(i), s[l] = i);
        var u = this.getSvgProxy(s);

        if (s.transform && s.parent.invTransform && !n) {
          var c = Array.prototype.slice.call(s.transform);
          o.mul(s.transform, s.parent.invTransform, s.transform), u.brush(s), s.transform = c;
        } else u.brush(s);

        var h = this.getSvgElement(s);
        i.innerHTML = "", i.appendChild(h.cloneNode()), e.setAttribute("clip-path", "url(#" + r + ")"), t.length > 1 && this.updateDom(i, t.slice(1), n);
      } else e && e.setAttribute("clip-path", "none");
    }, a.prototype.markUsed = function (e) {
      var t = this;
      e.__clipPaths && r.each(e.__clipPaths, function (e) {
        e._dom && i.prototype.markUsed.call(t, e._dom), e._textDom && i.prototype.markUsed.call(t, e._textDom);
      });
    };
    var s = a;
    e.exports = s;
  }, function (e, t, n) {
    var i = n(236);

    function r(e, t) {
      i.call(this, e, t, ["filter"], "__filter_in_use__", "_shadowDom");
    }

    function o(e) {
      return e && (e.shadowBlur || e.shadowOffsetX || e.shadowOffsetY || e.textShadowBlur || e.textShadowOffsetX || e.textShadowOffsetY);
    }

    n(1).inherits(r, i), r.prototype.addWithoutUpdate = function (e, t) {
      if (t && o(t.style)) {
        var n;
        if (t._shadowDom) n = t._shadowDom, this.getDefs(!0).contains(t._shadowDom) || this.addDom(n);else n = this.add(t);
        this.markUsed(t);
        var i = n.getAttribute("id");
        e.style.filter = "url(#" + i + ")";
      }
    }, r.prototype.add = function (e) {
      var t = this.createElement("filter");
      return e._shadowDomId = e._shadowDomId || this.nextId++, t.setAttribute("id", "zr" + this._zrId + "-shadow-" + e._shadowDomId), this.updateDom(e, t), this.addDom(t), t;
    }, r.prototype.update = function (e, t) {
      if (o(t.style)) {
        var n = this;
        i.prototype.update.call(this, t, function () {
          n.updateDom(t, t._shadowDom);
        });
      } else this.remove(e, t);
    }, r.prototype.remove = function (e, t) {
      null != t._shadowDomId && (this.removeDom(e), e.style.filter = "");
    }, r.prototype.updateDom = function (e, t) {
      var n = t.getElementsByTagName("feDropShadow");
      n = 0 === n.length ? this.createElement("feDropShadow") : n[0];
      var i,
          r,
          o,
          a,
          s = e.style,
          l = e.scale && e.scale[0] || 1,
          u = e.scale && e.scale[1] || 1;
      if (s.shadowBlur || s.shadowOffsetX || s.shadowOffsetY) i = s.shadowOffsetX || 0, r = s.shadowOffsetY || 0, o = s.shadowBlur, a = s.shadowColor;else {
        if (!s.textShadowBlur) return void this.removeDom(t, s);
        i = s.textShadowOffsetX || 0, r = s.textShadowOffsetY || 0, o = s.textShadowBlur, a = s.textShadowColor;
      }
      n.setAttribute("dx", i / l), n.setAttribute("dy", r / u), n.setAttribute("flood-color", a);
      var c = o / 2 / l + " " + o / 2 / u;
      n.setAttribute("stdDeviation", c), t.setAttribute("x", "-100%"), t.setAttribute("y", "-100%"), t.setAttribute("width", Math.ceil(o / 2 * 200) + "%"), t.setAttribute("height", Math.ceil(o / 2 * 200) + "%"), t.appendChild(n), e._shadowDom = t;
    }, r.prototype.markUsed = function (e) {
      e._shadowDom && i.prototype.markUsed.call(this, e._shadowDom);
    };
    var a = r;
    e.exports = a;
  }, function (e, t, n) {
    e.exports = n(940);
  }, function (e, t, n) {
    (function (e, t) {
      !function e(t, n, i) {
        function r(a, s) {
          if (!n[a]) {
            if (!t[a]) {
              if (o) return o(a, !0);
              var l = new Error("Cannot find module '" + a + "'");
              throw l.code = "MODULE_NOT_FOUND", l;
            }

            var u = n[a] = {
              exports: {}
            };
            t[a][0].call(u.exports, function (e) {
              var n = t[a][1][e];
              return r(n || e);
            }, u, u.exports, e, t, n, i);
          }

          return n[a].exports;
        }

        for (var o = !1, a = 0; a < i.length; a++) {
          r(i[a]);
        }

        return r;
      }({
        1: [function (e, t, n) {}, {}],
        2: [function (t, n, i) {
          (function (e) {
            var i,
                r = void 0 !== e ? e : "undefined" != typeof window ? window : {},
                o = t(1);
            "undefined" != typeof document ? i = document : (i = r["__GLOBAL_DOCUMENT_CACHE@4"]) || (i = r["__GLOBAL_DOCUMENT_CACHE@4"] = o), n.exports = i;
          }).call(this, void 0 !== e ? e : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
        }, {
          1: 1
        }],
        3: [function (t, n, i) {
          (function (e) {
            var t;
            t = "undefined" != typeof window ? window : void 0 !== e ? e : "undefined" != typeof self ? self : {}, n.exports = t;
          }).call(this, void 0 !== e ? e : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
        }, {}],
        4: [function (e, n, i) {
          !function (e) {
            var i = setTimeout;

            function r() {}

            function o(e) {
              if ("object" != typeof this) throw new TypeError("Promises must be constructed via new");
              if ("function" != typeof e) throw new TypeError("not a function");
              this._state = 0, this._handled = !1, this._value = void 0, this._deferreds = [], h(e, this);
            }

            function a(e, t) {
              for (; 3 === e._state;) {
                e = e._value;
              }

              0 !== e._state ? (e._handled = !0, o._immediateFn(function () {
                var n = 1 === e._state ? t.onFulfilled : t.onRejected;

                if (null !== n) {
                  var i;

                  try {
                    i = n(e._value);
                  } catch (e) {
                    return void l(t.promise, e);
                  }

                  s(t.promise, i);
                } else (1 === e._state ? s : l)(t.promise, e._value);
              })) : e._deferreds.push(t);
            }

            function s(e, t) {
              try {
                if (t === e) throw new TypeError("A promise cannot be resolved with itself.");

                if (t && ("object" == typeof t || "function" == typeof t)) {
                  var n = t.then;
                  if (t instanceof o) return e._state = 3, e._value = t, void u(e);
                  if ("function" == typeof n) return void h((i = n, r = t, function () {
                    i.apply(r, arguments);
                  }), e);
                }

                e._state = 1, e._value = t, u(e);
              } catch (t) {
                l(e, t);
              }

              var i, r;
            }

            function l(e, t) {
              e._state = 2, e._value = t, u(e);
            }

            function u(e) {
              2 === e._state && 0 === e._deferreds.length && o._immediateFn(function () {
                e._handled || o._unhandledRejectionFn(e._value);
              });

              for (var t = 0, n = e._deferreds.length; t < n; t++) {
                a(e, e._deferreds[t]);
              }

              e._deferreds = null;
            }

            function c(e, t, n) {
              this.onFulfilled = "function" == typeof e ? e : null, this.onRejected = "function" == typeof t ? t : null, this.promise = n;
            }

            function h(e, t) {
              var n = !1;

              try {
                e(function (e) {
                  n || (n = !0, s(t, e));
                }, function (e) {
                  n || (n = !0, l(t, e));
                });
              } catch (e) {
                if (n) return;
                n = !0, l(t, e);
              }
            }

            o.prototype.catch = function (e) {
              return this.then(null, e);
            }, o.prototype.then = function (e, t) {
              var n = new this.constructor(r);
              return a(this, new c(e, t, n)), n;
            }, o.all = function (e) {
              var t = Array.prototype.slice.call(e);
              return new o(function (e, n) {
                if (0 === t.length) return e([]);
                var i = t.length;

                function r(o, a) {
                  try {
                    if (a && ("object" == typeof a || "function" == typeof a)) {
                      var s = a.then;
                      if ("function" == typeof s) return void s.call(a, function (e) {
                        r(o, e);
                      }, n);
                    }

                    t[o] = a, 0 == --i && e(t);
                  } catch (e) {
                    n(e);
                  }
                }

                for (var o = 0; o < t.length; o++) {
                  r(o, t[o]);
                }
              });
            }, o.resolve = function (e) {
              return e && "object" == typeof e && e.constructor === o ? e : new o(function (t) {
                t(e);
              });
            }, o.reject = function (e) {
              return new o(function (t, n) {
                n(e);
              });
            }, o.race = function (e) {
              return new o(function (t, n) {
                for (var i = 0, r = e.length; i < r; i++) {
                  e[i].then(t, n);
                }
              });
            }, o._immediateFn = "function" == typeof t && function (e) {
              t(e);
            } || function (e) {
              i(e, 0);
            }, o._unhandledRejectionFn = function (e) {
              "undefined" != typeof console && console && console.warn("Possible Unhandled Promise Rejection:", e);
            }, o._setImmediateFn = function (e) {
              o._immediateFn = e;
            }, o._setUnhandledRejectionFn = function (e) {
              o._unhandledRejectionFn = e;
            }, void 0 !== n && n.exports ? n.exports = o : e.Promise || (e.Promise = o);
          }(this);
        }, {}],
        5: [function (e, t, n) {
          "use strict";

          Object.defineProperty(n, "__esModule", {
            value: !0
          });
          var i,
              r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
            return typeof e;
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
          },
              o = e(7),
              a = (i = o) && i.__esModule ? i : {
            default: i
          },
              s = e(15),
              l = e(27);
          var u = {
            lang: "en",
            en: s.EN,
            language: function language() {
              for (var e = arguments.length, t = Array(e), n = 0; n < e; n++) {
                t[n] = arguments[n];
              }

              if (null != t && t.length) {
                if ("string" != typeof t[0]) throw new TypeError("Language code must be a string value");
                if (!/^[a-z]{2,3}((\-|_)[a-z]{2})?$/i.test(t[0])) throw new TypeError("Language code must have format 2-3 letters and. optionally, hyphen, underscore followed by 2 more letters");
                u.lang = t[0], void 0 === u[t[0]] ? (t[1] = null !== t[1] && void 0 !== t[1] && "object" === r(t[1]) ? t[1] : {}, u[t[0]] = (0, l.isObjectEmpty)(t[1]) ? s.EN : t[1]) : null !== t[1] && void 0 !== t[1] && "object" === r(t[1]) && (u[t[0]] = t[1]);
              }

              return u.lang;
            },
            t: function t(e) {
              var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;

              if ("string" == typeof e && e.length) {
                var n = void 0,
                    i = void 0,
                    o = u.language(),
                    a = function a(e, t, n) {
                  return "object" !== (void 0 === e ? "undefined" : r(e)) || "number" != typeof t || "number" != typeof n ? e : [function () {
                    return arguments.length <= 1 ? void 0 : arguments[1];
                  }, function () {
                    return 1 === (arguments.length <= 0 ? void 0 : arguments[0]) ? arguments.length <= 1 ? void 0 : arguments[1] : arguments.length <= 2 ? void 0 : arguments[2];
                  }, function () {
                    return 0 === (arguments.length <= 0 ? void 0 : arguments[0]) || 1 === (arguments.length <= 0 ? void 0 : arguments[0]) ? arguments.length <= 1 ? void 0 : arguments[1] : arguments.length <= 2 ? void 0 : arguments[2];
                  }, function () {
                    return (arguments.length <= 0 ? void 0 : arguments[0]) % 10 == 1 && (arguments.length <= 0 ? void 0 : arguments[0]) % 100 != 11 ? arguments.length <= 1 ? void 0 : arguments[1] : 0 !== (arguments.length <= 0 ? void 0 : arguments[0]) ? arguments.length <= 2 ? void 0 : arguments[2] : arguments.length <= 3 ? void 0 : arguments[3];
                  }, function () {
                    return 1 === (arguments.length <= 0 ? void 0 : arguments[0]) || 11 === (arguments.length <= 0 ? void 0 : arguments[0]) ? arguments.length <= 1 ? void 0 : arguments[1] : 2 === (arguments.length <= 0 ? void 0 : arguments[0]) || 12 === (arguments.length <= 0 ? void 0 : arguments[0]) ? arguments.length <= 2 ? void 0 : arguments[2] : (arguments.length <= 0 ? void 0 : arguments[0]) > 2 && (arguments.length <= 0 ? void 0 : arguments[0]) < 20 ? arguments.length <= 3 ? void 0 : arguments[3] : arguments.length <= 4 ? void 0 : arguments[4];
                  }, function () {
                    return 1 === (arguments.length <= 0 ? void 0 : arguments[0]) ? arguments.length <= 1 ? void 0 : arguments[1] : 0 === (arguments.length <= 0 ? void 0 : arguments[0]) || (arguments.length <= 0 ? void 0 : arguments[0]) % 100 > 0 && (arguments.length <= 0 ? void 0 : arguments[0]) % 100 < 20 ? arguments.length <= 2 ? void 0 : arguments[2] : arguments.length <= 3 ? void 0 : arguments[3];
                  }, function () {
                    return (arguments.length <= 0 ? void 0 : arguments[0]) % 10 == 1 && (arguments.length <= 0 ? void 0 : arguments[0]) % 100 != 11 ? arguments.length <= 1 ? void 0 : arguments[1] : (arguments.length <= 0 ? void 0 : arguments[0]) % 10 >= 2 && ((arguments.length <= 0 ? void 0 : arguments[0]) % 100 < 10 || (arguments.length <= 0 ? void 0 : arguments[0]) % 100 >= 20) ? arguments.length <= 2 ? void 0 : arguments[2] : [3];
                  }, function () {
                    return (arguments.length <= 0 ? void 0 : arguments[0]) % 10 == 1 && (arguments.length <= 0 ? void 0 : arguments[0]) % 100 != 11 ? arguments.length <= 1 ? void 0 : arguments[1] : (arguments.length <= 0 ? void 0 : arguments[0]) % 10 >= 2 && (arguments.length <= 0 ? void 0 : arguments[0]) % 10 <= 4 && ((arguments.length <= 0 ? void 0 : arguments[0]) % 100 < 10 || (arguments.length <= 0 ? void 0 : arguments[0]) % 100 >= 20) ? arguments.length <= 2 ? void 0 : arguments[2] : arguments.length <= 3 ? void 0 : arguments[3];
                  }, function () {
                    return 1 === (arguments.length <= 0 ? void 0 : arguments[0]) ? arguments.length <= 1 ? void 0 : arguments[1] : (arguments.length <= 0 ? void 0 : arguments[0]) >= 2 && (arguments.length <= 0 ? void 0 : arguments[0]) <= 4 ? arguments.length <= 2 ? void 0 : arguments[2] : arguments.length <= 3 ? void 0 : arguments[3];
                  }, function () {
                    return 1 === (arguments.length <= 0 ? void 0 : arguments[0]) ? arguments.length <= 1 ? void 0 : arguments[1] : (arguments.length <= 0 ? void 0 : arguments[0]) % 10 >= 2 && (arguments.length <= 0 ? void 0 : arguments[0]) % 10 <= 4 && ((arguments.length <= 0 ? void 0 : arguments[0]) % 100 < 10 || (arguments.length <= 0 ? void 0 : arguments[0]) % 100 >= 20) ? arguments.length <= 2 ? void 0 : arguments[2] : arguments.length <= 3 ? void 0 : arguments[3];
                  }, function () {
                    return (arguments.length <= 0 ? void 0 : arguments[0]) % 100 == 1 ? arguments.length <= 2 ? void 0 : arguments[2] : (arguments.length <= 0 ? void 0 : arguments[0]) % 100 == 2 ? arguments.length <= 3 ? void 0 : arguments[3] : (arguments.length <= 0 ? void 0 : arguments[0]) % 100 == 3 || (arguments.length <= 0 ? void 0 : arguments[0]) % 100 == 4 ? arguments.length <= 4 ? void 0 : arguments[4] : arguments.length <= 1 ? void 0 : arguments[1];
                  }, function () {
                    return 1 === (arguments.length <= 0 ? void 0 : arguments[0]) ? arguments.length <= 1 ? void 0 : arguments[1] : 2 === (arguments.length <= 0 ? void 0 : arguments[0]) ? arguments.length <= 2 ? void 0 : arguments[2] : (arguments.length <= 0 ? void 0 : arguments[0]) > 2 && (arguments.length <= 0 ? void 0 : arguments[0]) < 7 ? arguments.length <= 3 ? void 0 : arguments[3] : (arguments.length <= 0 ? void 0 : arguments[0]) > 6 && (arguments.length <= 0 ? void 0 : arguments[0]) < 11 ? arguments.length <= 4 ? void 0 : arguments[4] : arguments.length <= 5 ? void 0 : arguments[5];
                  }, function () {
                    return 0 === (arguments.length <= 0 ? void 0 : arguments[0]) ? arguments.length <= 1 ? void 0 : arguments[1] : 1 === (arguments.length <= 0 ? void 0 : arguments[0]) ? arguments.length <= 2 ? void 0 : arguments[2] : 2 === (arguments.length <= 0 ? void 0 : arguments[0]) ? arguments.length <= 3 ? void 0 : arguments[3] : (arguments.length <= 0 ? void 0 : arguments[0]) % 100 >= 3 && (arguments.length <= 0 ? void 0 : arguments[0]) % 100 <= 10 ? arguments.length <= 4 ? void 0 : arguments[4] : (arguments.length <= 0 ? void 0 : arguments[0]) % 100 >= 11 ? arguments.length <= 5 ? void 0 : arguments[5] : arguments.length <= 6 ? void 0 : arguments[6];
                  }, function () {
                    return 1 === (arguments.length <= 0 ? void 0 : arguments[0]) ? arguments.length <= 1 ? void 0 : arguments[1] : 0 === (arguments.length <= 0 ? void 0 : arguments[0]) || (arguments.length <= 0 ? void 0 : arguments[0]) % 100 > 1 && (arguments.length <= 0 ? void 0 : arguments[0]) % 100 < 11 ? arguments.length <= 2 ? void 0 : arguments[2] : (arguments.length <= 0 ? void 0 : arguments[0]) % 100 > 10 && (arguments.length <= 0 ? void 0 : arguments[0]) % 100 < 20 ? arguments.length <= 3 ? void 0 : arguments[3] : arguments.length <= 4 ? void 0 : arguments[4];
                  }, function () {
                    return (arguments.length <= 0 ? void 0 : arguments[0]) % 10 == 1 ? arguments.length <= 1 ? void 0 : arguments[1] : (arguments.length <= 0 ? void 0 : arguments[0]) % 10 == 2 ? arguments.length <= 2 ? void 0 : arguments[2] : arguments.length <= 3 ? void 0 : arguments[3];
                  }, function () {
                    return 11 !== (arguments.length <= 0 ? void 0 : arguments[0]) && (arguments.length <= 0 ? void 0 : arguments[0]) % 10 == 1 ? arguments.length <= 1 ? void 0 : arguments[1] : arguments.length <= 2 ? void 0 : arguments[2];
                  }, function () {
                    return 1 === (arguments.length <= 0 ? void 0 : arguments[0]) ? arguments.length <= 1 ? void 0 : arguments[1] : (arguments.length <= 0 ? void 0 : arguments[0]) % 10 >= 2 && (arguments.length <= 0 ? void 0 : arguments[0]) % 10 <= 4 && ((arguments.length <= 0 ? void 0 : arguments[0]) % 100 < 10 || (arguments.length <= 0 ? void 0 : arguments[0]) % 100 >= 20) ? arguments.length <= 2 ? void 0 : arguments[2] : arguments.length <= 3 ? void 0 : arguments[3];
                  }, function () {
                    return 1 === (arguments.length <= 0 ? void 0 : arguments[0]) ? arguments.length <= 1 ? void 0 : arguments[1] : 2 === (arguments.length <= 0 ? void 0 : arguments[0]) ? arguments.length <= 2 ? void 0 : arguments[2] : 8 !== (arguments.length <= 0 ? void 0 : arguments[0]) && 11 !== (arguments.length <= 0 ? void 0 : arguments[0]) ? arguments.length <= 3 ? void 0 : arguments[3] : arguments.length <= 4 ? void 0 : arguments[4];
                  }, function () {
                    return 0 === (arguments.length <= 0 ? void 0 : arguments[0]) ? arguments.length <= 1 ? void 0 : arguments[1] : arguments.length <= 2 ? void 0 : arguments[2];
                  }, function () {
                    return 1 === (arguments.length <= 0 ? void 0 : arguments[0]) ? arguments.length <= 1 ? void 0 : arguments[1] : 2 === (arguments.length <= 0 ? void 0 : arguments[0]) ? arguments.length <= 2 ? void 0 : arguments[2] : 3 === (arguments.length <= 0 ? void 0 : arguments[0]) ? arguments.length <= 3 ? void 0 : arguments[3] : arguments.length <= 4 ? void 0 : arguments[4];
                  }, function () {
                    return 0 === (arguments.length <= 0 ? void 0 : arguments[0]) ? arguments.length <= 1 ? void 0 : arguments[1] : 1 === (arguments.length <= 0 ? void 0 : arguments[0]) ? arguments.length <= 2 ? void 0 : arguments[2] : arguments.length <= 3 ? void 0 : arguments[3];
                  }][n].apply(null, [t].concat(e));
                };

                return void 0 !== u[o] && (n = u[o][e], null !== t && "number" == typeof t && (i = u[o]["mejs.plural-form"], n = a.apply(null, [n, t, i]))), !n && u.en && (n = u.en[e], null !== t && "number" == typeof t && (i = u.en["mejs.plural-form"], n = a.apply(null, [n, t, i]))), n = n || e, null !== t && "number" == typeof t && (n = n.replace("%1", t)), (0, l.escapeHTML)(n);
              }

              return e;
            }
          };
          a.default.i18n = u, "undefined" != typeof mejsL10n && a.default.i18n.language(mejsL10n.language, mejsL10n.strings), n.default = u;
        }, {
          15: 15,
          27: 27,
          7: 7
        }],
        6: [function (e, t, n) {
          "use strict";

          Object.defineProperty(n, "__esModule", {
            value: !0
          });
          var i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
            return typeof e;
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
          },
              r = h(e(3)),
              o = h(e(2)),
              a = h(e(7)),
              s = e(27),
              l = e(28),
              u = e(8),
              c = e(25);

          function h(e) {
            return e && e.__esModule ? e : {
              default: e
            };
          }

          var d = function e(t, n, h) {
            var d = this;
            !function (e, t) {
              if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            }(this, e);
            var f = this;
            h = Array.isArray(h) ? h : null, f.defaults = {
              renderers: [],
              fakeNodeName: "mediaelementwrapper",
              pluginPath: "build/",
              shimScriptAccess: "sameDomain"
            }, n = Object.assign(f.defaults, n), f.mediaElement = o.default.createElement(n.fakeNodeName);
            var p = t,
                g = !1;
            if ("string" == typeof t ? f.mediaElement.originalNode = o.default.getElementById(t) : (f.mediaElement.originalNode = t, p = t.id), void 0 === f.mediaElement.originalNode || null === f.mediaElement.originalNode) return null;
            f.mediaElement.options = n, p = p || "mejs_" + Math.random().toString().slice(2), f.mediaElement.originalNode.setAttribute("id", p + "_from_mejs");
            var v = f.mediaElement.originalNode.tagName.toLowerCase();
            ["video", "audio"].indexOf(v) > -1 && !f.mediaElement.originalNode.getAttribute("preload") && f.mediaElement.originalNode.setAttribute("preload", "none"), f.mediaElement.originalNode.parentNode.insertBefore(f.mediaElement, f.mediaElement.originalNode), f.mediaElement.appendChild(f.mediaElement.originalNode);

            var m = function m(e, t) {
              if ("https:" === r.default.location.protocol && 0 === e.indexOf("http:") && c.IS_IOS && a.default.html5media.mediaTypes.indexOf(t) > -1) {
                var n = new XMLHttpRequest();
                n.onreadystatechange = function () {
                  if (4 === this.readyState && 200 === this.status) {
                    var t = (r.default.URL || r.default.webkitURL).createObjectURL(this.response);
                    return f.mediaElement.originalNode.setAttribute("src", t), t;
                  }

                  return e;
                }, n.open("GET", e), n.responseType = "blob", n.send();
              }

              return e;
            },
                y = void 0;

            if (null !== h) y = h;else if (null !== f.mediaElement.originalNode) switch (y = [], f.mediaElement.originalNode.nodeName.toLowerCase()) {
              case "iframe":
                y.push({
                  type: "",
                  src: f.mediaElement.originalNode.getAttribute("src")
                });
                break;

              case "audio":
              case "video":
                var x = f.mediaElement.originalNode.children.length,
                    _ = f.mediaElement.originalNode.getAttribute("src");

                if (_) {
                  var b = f.mediaElement.originalNode,
                      w = (0, l.formatType)(_, b.getAttribute("type"));
                  y.push({
                    type: w,
                    src: m(_, w)
                  });
                }

                for (var S = 0; S < x; S++) {
                  var T = f.mediaElement.originalNode.children[S];

                  if ("source" === T.tagName.toLowerCase()) {
                    var C = T.getAttribute("src"),
                        k = (0, l.formatType)(C, T.getAttribute("type"));
                    y.push({
                      type: k,
                      src: m(C, k)
                    });
                  }
                }

            }
            f.mediaElement.id = p, f.mediaElement.renderers = {}, f.mediaElement.events = {}, f.mediaElement.promises = [], f.mediaElement.renderer = null, f.mediaElement.rendererName = null, f.mediaElement.changeRenderer = function (e, t) {
              var n = d,
                  i = Object.keys(t[0]).length > 2 ? t[0] : t[0].src;
              if (void 0 !== n.mediaElement.renderer && null !== n.mediaElement.renderer && n.mediaElement.renderer.name === e) return n.mediaElement.renderer.pause(), n.mediaElement.renderer.stop && n.mediaElement.renderer.stop(), n.mediaElement.renderer.show(), n.mediaElement.renderer.setSrc(i), !0;
              void 0 !== n.mediaElement.renderer && null !== n.mediaElement.renderer && (n.mediaElement.renderer.pause(), n.mediaElement.renderer.stop && n.mediaElement.renderer.stop(), n.mediaElement.renderer.hide());
              var r = n.mediaElement.renderers[e],
                  o = null;
              if (null != r) return r.show(), r.setSrc(i), n.mediaElement.renderer = r, n.mediaElement.rendererName = e, !0;

              for (var a = n.mediaElement.options.renderers.length ? n.mediaElement.options.renderers : u.renderer.order, s = 0, l = a.length; s < l; s++) {
                var c = a[s];

                if (c === e) {
                  o = u.renderer.renderers[c];
                  var h = Object.assign(o.options, n.mediaElement.options);
                  return (r = o.create(n.mediaElement, h, t)).name = e, n.mediaElement.renderers[o.name] = r, n.mediaElement.renderer = r, n.mediaElement.rendererName = e, r.show(), !0;
                }
              }

              return !1;
            }, f.mediaElement.setSize = function (e, t) {
              void 0 !== f.mediaElement.renderer && null !== f.mediaElement.renderer && f.mediaElement.renderer.setSize(e, t);
            }, f.mediaElement.generateError = function (e, t) {
              e = e || "", t = Array.isArray(t) ? t : [];
              var n = (0, s.createEvent)("error", f.mediaElement);
              n.message = e, n.urls = t, f.mediaElement.dispatchEvent(n), g = !0;
            };

            var M = a.default.html5media.properties,
                E = a.default.html5media.methods,
                A = function A(e, t, n, i) {
              var r = e[t];
              Object.defineProperty(e, t, {
                get: function get() {
                  return n.apply(e, [r]);
                },
                set: function set(t) {
                  return r = i.apply(e, [t]);
                }
              });
            },
                I = function I(e) {
              if ("src" !== e) {
                var t = "" + e.substring(0, 1).toUpperCase() + e.substring(1),
                    n = function n() {
                  return void 0 !== f.mediaElement.renderer && null !== f.mediaElement.renderer && "function" == typeof f.mediaElement.renderer["get" + t] ? f.mediaElement.renderer["get" + t]() : null;
                },
                    i = function i(e) {
                  void 0 !== f.mediaElement.renderer && null !== f.mediaElement.renderer && "function" == typeof f.mediaElement.renderer["set" + t] && f.mediaElement.renderer["set" + t](e);
                };

                A(f.mediaElement, e, n, i), f.mediaElement["get" + t] = n, f.mediaElement["set" + t] = i;
              }
            },
                P = function P() {
              return void 0 !== f.mediaElement.renderer && null !== f.mediaElement.renderer ? f.mediaElement.renderer.getSrc() : null;
            },
                O = function O(e) {
              var t = [];
              if ("string" == typeof e) t.push({
                src: e,
                type: e ? (0, l.getTypeFromFile)(e) : ""
              });else if ("object" === (void 0 === e ? "undefined" : i(e)) && void 0 !== e.src) {
                var n = (0, l.absolutizeUrl)(e.src),
                    r = e.type,
                    o = Object.assign(e, {
                  src: n,
                  type: "" !== r && null != r || !n ? r : (0, l.getTypeFromFile)(n)
                });
                t.push(o);
              } else if (Array.isArray(e)) for (var a = 0, c = e.length; a < c; a++) {
                var h = (0, l.absolutizeUrl)(e[a].src),
                    d = e[a].type,
                    p = Object.assign(e[a], {
                  src: h,
                  type: "" !== d && null != d || !h ? d : (0, l.getTypeFromFile)(h)
                });
                t.push(p);
              }
              var g = u.renderer.select(t, f.mediaElement.options.renderers.length ? f.mediaElement.options.renderers : []),
                  v = void 0;
              if (f.mediaElement.paused || null == f.mediaElement.src || "" === f.mediaElement.src || (f.mediaElement.pause(), v = (0, s.createEvent)("pause", f.mediaElement), f.mediaElement.dispatchEvent(v)), f.mediaElement.originalNode.src = t[0].src || "", null !== g || !t[0].src) return !(null == t[0].src || "" === t[0].src) ? f.mediaElement.changeRenderer(g.rendererName, t) : null;
              f.mediaElement.generateError("No renderer found", t);
            },
                L = function L(e, t) {
              try {
                if ("play" !== e || "native_dash" !== f.mediaElement.rendererName && "native_hls" !== f.mediaElement.rendererName && "vimeo_iframe" !== f.mediaElement.rendererName) f.mediaElement.renderer[e](t);else {
                  var n = f.mediaElement.renderer[e](t);
                  n && "function" == typeof n.then && n.catch(function () {
                    f.mediaElement.paused && setTimeout(function () {
                      var e = f.mediaElement.renderer.play();
                      void 0 !== e && e.catch(function () {
                        f.mediaElement.renderer.paused || f.mediaElement.renderer.pause();
                      });
                    }, 150);
                  });
                }
              } catch (e) {
                f.mediaElement.generateError(e, y);
              }
            },
                D = function D(e) {
              f.mediaElement[e] = function () {
                for (var t = arguments.length, n = Array(t), i = 0; i < t; i++) {
                  n[i] = arguments[i];
                }

                return void 0 !== f.mediaElement.renderer && null !== f.mediaElement.renderer && "function" == typeof f.mediaElement.renderer[e] && (f.mediaElement.promises.length ? Promise.all(f.mediaElement.promises).then(function () {
                  L(e, n);
                }).catch(function (e) {
                  f.mediaElement.generateError(e, y);
                }) : L(e, n)), null;
              };
            };

            A(f.mediaElement, "src", P, O), f.mediaElement.getSrc = P, f.mediaElement.setSrc = O;

            for (var N = 0, j = M.length; N < j; N++) {
              I(M[N]);
            }

            for (var R = 0, F = E.length; R < F; R++) {
              D(E[R]);
            }

            return f.mediaElement.addEventListener = function (e, t) {
              f.mediaElement.events[e] = f.mediaElement.events[e] || [], f.mediaElement.events[e].push(t);
            }, f.mediaElement.removeEventListener = function (e, t) {
              if (!e) return f.mediaElement.events = {}, !0;
              var n = f.mediaElement.events[e];
              if (!n) return !0;
              if (!t) return f.mediaElement.events[e] = [], !0;

              for (var i = 0; i < n.length; i++) {
                if (n[i] === t) return f.mediaElement.events[e].splice(i, 1), !0;
              }

              return !1;
            }, f.mediaElement.dispatchEvent = function (e) {
              var t = f.mediaElement.events[e.type];
              if (t) for (var n = 0; n < t.length; n++) {
                t[n].apply(null, [e]);
              }
            }, f.mediaElement.destroy = function () {
              var e = f.mediaElement.originalNode.cloneNode(!0),
                  t = f.mediaElement.parentElement;
              e.removeAttribute("id"), e.remove(), f.mediaElement.remove(), t.appendChild(e);
            }, y.length && (f.mediaElement.src = y), f.mediaElement.promises.length ? Promise.all(f.mediaElement.promises).then(function () {
              f.mediaElement.options.success && f.mediaElement.options.success(f.mediaElement, f.mediaElement.originalNode);
            }).catch(function () {
              g && f.mediaElement.options.error && f.mediaElement.options.error(f.mediaElement, f.mediaElement.originalNode);
            }) : (f.mediaElement.options.success && f.mediaElement.options.success(f.mediaElement, f.mediaElement.originalNode), g && f.mediaElement.options.error && f.mediaElement.options.error(f.mediaElement, f.mediaElement.originalNode)), f.mediaElement;
          };

          r.default.MediaElement = d, a.default.MediaElement = d, n.default = d;
        }, {
          2: 2,
          25: 25,
          27: 27,
          28: 28,
          3: 3,
          7: 7,
          8: 8
        }],
        7: [function (e, t, n) {
          "use strict";

          Object.defineProperty(n, "__esModule", {
            value: !0
          });
          var i,
              r = e(3);
          var o = {
            version: "4.2.16",
            html5media: {
              properties: ["volume", "src", "currentTime", "muted", "duration", "paused", "ended", "buffered", "error", "networkState", "readyState", "seeking", "seekable", "currentSrc", "preload", "bufferedBytes", "bufferedTime", "initialTime", "startOffsetTime", "defaultPlaybackRate", "playbackRate", "played", "autoplay", "loop", "controls"],
              readOnlyProperties: ["duration", "paused", "ended", "buffered", "error", "networkState", "readyState", "seeking", "seekable"],
              methods: ["load", "play", "pause", "canPlayType"],
              events: ["loadstart", "durationchange", "loadedmetadata", "loadeddata", "progress", "canplay", "canplaythrough", "suspend", "abort", "error", "emptied", "stalled", "play", "playing", "pause", "waiting", "seeking", "seeked", "timeupdate", "ended", "ratechange", "volumechange"],
              mediaTypes: ["audio/mp3", "audio/ogg", "audio/oga", "audio/wav", "audio/x-wav", "audio/wave", "audio/x-pn-wav", "audio/mpeg", "audio/mp4", "video/mp4", "video/webm", "video/ogg", "video/ogv"]
            }
          };
          ((i = r) && i.__esModule ? i : {
            default: i
          }).default.mejs = o, n.default = o;
        }, {
          3: 3
        }],
        8: [function (e, t, n) {
          "use strict";

          Object.defineProperty(n, "__esModule", {
            value: !0
          }), n.renderer = void 0;

          var i,
              r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
            return typeof e;
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
          },
              o = function () {
            function e(e, t) {
              for (var n = 0; n < t.length; n++) {
                var i = t[n];
                i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
              }
            }

            return function (t, n, i) {
              return n && e(t.prototype, n), i && e(t, i), t;
            };
          }(),
              a = e(7),
              s = (i = a) && i.__esModule ? i : {
            default: i
          };

          var l = function () {
            function e() {
              !function (e, t) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
              }(this, e), this.renderers = {}, this.order = [];
            }

            return o(e, [{
              key: "add",
              value: function value(e) {
                if (void 0 === e.name) throw new TypeError("renderer must contain at least `name` property");
                this.renderers[e.name] = e, this.order.push(e.name);
              }
            }, {
              key: "select",
              value: function value(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [],
                    n = t.length;

                if (t = t.length ? t : this.order, !n) {
                  var i = [/^(html5|native)/i, /^flash/i, /iframe$/i],
                      r = function r(e) {
                    for (var t = 0, n = i.length; t < n; t++) {
                      if (i[t].test(e)) return t;
                    }

                    return i.length;
                  };

                  t.sort(function (e, t) {
                    return r(e) - r(t);
                  });
                }

                for (var o = 0, a = t.length; o < a; o++) {
                  var s = t[o],
                      l = this.renderers[s];
                  if (null != l) for (var u = 0, c = e.length; u < c; u++) {
                    if ("function" == typeof l.canPlayType && "string" == typeof e[u].type && l.canPlayType(e[u].type)) return {
                      rendererName: l.name,
                      src: e[u].src
                    };
                  }
                }

                return null;
              }
            }, {
              key: "order",
              set: function set(e) {
                if (!Array.isArray(e)) throw new TypeError("order must be an array of strings.");
                this._order = e;
              },
              get: function get() {
                return this._order;
              }
            }, {
              key: "renderers",
              set: function set(e) {
                if (null !== e && "object" !== (void 0 === e ? "undefined" : r(e))) throw new TypeError("renderers must be an array of objects.");
                this._renderers = e;
              },
              get: function get() {
                return this._renderers;
              }
            }]), e;
          }(),
              u = n.renderer = new l();

          s.default.Renderers = u;
        }, {
          7: 7
        }],
        9: [function (e, t, n) {
          "use strict";

          var i = d(e(3)),
              r = d(e(2)),
              o = d(e(5)),
              a = e(16),
              s = d(a),
              l = function (e) {
            if (e && e.__esModule) return e;
            var t = {};
            if (null != e) for (var n in e) {
              Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }
            return t.default = e, t;
          }(e(25)),
              u = e(27),
              c = e(26),
              h = e(28);

          function d(e) {
            return e && e.__esModule ? e : {
              default: e
            };
          }

          Object.assign(a.config, {
            usePluginFullScreen: !0,
            fullscreenText: null,
            useFakeFullscreen: !1
          }), Object.assign(s.default.prototype, {
            isFullScreen: !1,
            isNativeFullScreen: !1,
            isInIframe: !1,
            isPluginClickThroughCreated: !1,
            fullscreenMode: "",
            containerSizeTimeout: null,
            buildfullscreen: function buildfullscreen(e) {
              if (e.isVideo) {
                e.isInIframe = i.default.location !== i.default.parent.location, e.detectFullscreenMode();
                var t = this,
                    n = (0, u.isString)(t.options.fullscreenText) ? t.options.fullscreenText : o.default.t("mejs.fullscreen"),
                    a = r.default.createElement("div");

                if (a.className = t.options.classPrefix + "button " + t.options.classPrefix + "fullscreen-button", a.innerHTML = '<button type="button" aria-controls="' + t.id + '" title="' + n + '" aria-label="' + n + '" tabindex="0"></button>', t.addControlElement(a, "fullscreen"), a.addEventListener("click", function () {
                  l.HAS_TRUE_NATIVE_FULLSCREEN && l.IS_FULLSCREEN || e.isFullScreen ? e.exitFullScreen() : e.enterFullScreen();
                }), e.fullscreenBtn = a, t.options.keyActions.push({
                  keys: [70],
                  action: function action(e, t, n, i) {
                    i.ctrlKey || void 0 !== e.enterFullScreen && (e.isFullScreen ? e.exitFullScreen() : e.enterFullScreen());
                  }
                }), t.exitFullscreenCallback = function (n) {
                  var i = n.which || n.keyCode || 0;
                  t.options.enableKeyboard && 27 === i && (l.HAS_TRUE_NATIVE_FULLSCREEN && l.IS_FULLSCREEN || t.isFullScreen) && e.exitFullScreen();
                }, t.globalBind("keydown", t.exitFullscreenCallback), t.normalHeight = 0, t.normalWidth = 0, l.HAS_TRUE_NATIVE_FULLSCREEN) {
                  e.globalBind(l.FULLSCREEN_EVENT_NAME, function () {
                    e.isFullScreen && (l.isFullScreen() ? (e.isNativeFullScreen = !0, e.setControlsSize()) : (e.isNativeFullScreen = !1, e.exitFullScreen()));
                  });
                }
              }
            },
            cleanfullscreen: function cleanfullscreen(e) {
              e.exitFullScreen(), e.globalUnbind("keydown", e.exitFullscreenCallback);
            },
            detectFullscreenMode: function detectFullscreenMode() {
              var e = this,
                  t = null !== e.media.rendererName && /(native|html5)/i.test(e.media.rendererName),
                  n = "";
              return l.HAS_TRUE_NATIVE_FULLSCREEN && t ? n = "native-native" : l.HAS_TRUE_NATIVE_FULLSCREEN && !t ? n = "plugin-native" : e.usePluginFullScreen && l.SUPPORT_POINTER_EVENTS && (n = "plugin-click"), e.fullscreenMode = n, n;
            },
            enterFullScreen: function enterFullScreen() {
              var e = this,
                  t = null !== e.media.rendererName && /(html5|native)/i.test(e.media.rendererName),
                  n = getComputedStyle(e.getElement(e.container));
              if (e.isVideo) if (!1 === e.options.useFakeFullscreen && l.IS_IOS && l.HAS_IOS_FULLSCREEN && "function" == typeof e.media.originalNode.webkitEnterFullscreen && e.media.originalNode.canPlayType((0, h.getTypeFromFile)(e.media.getSrc()))) e.media.originalNode.webkitEnterFullscreen();else {
                if ((0, c.addClass)(r.default.documentElement, e.options.classPrefix + "fullscreen"), (0, c.addClass)(e.getElement(e.container), e.options.classPrefix + "container-fullscreen"), e.normalHeight = parseFloat(n.height), e.normalWidth = parseFloat(n.width), "native-native" !== e.fullscreenMode && "plugin-native" !== e.fullscreenMode || (l.requestFullScreen(e.getElement(e.container)), e.isInIframe && setTimeout(function t() {
                  if (e.isNativeFullScreen) {
                    var n = i.default.innerWidth || r.default.documentElement.clientWidth || r.default.body.clientWidth,
                        o = screen.width;
                    Math.abs(o - n) > .002 * o ? e.exitFullScreen() : setTimeout(t, 500);
                  }
                }, 1e3)), e.getElement(e.container).style.width = "100%", e.getElement(e.container).style.height = "100%", e.containerSizeTimeout = setTimeout(function () {
                  e.getElement(e.container).style.width = "100%", e.getElement(e.container).style.height = "100%", e.setControlsSize();
                }, 500), t) e.node.style.width = "100%", e.node.style.height = "100%";else for (var o = e.getElement(e.container).querySelectorAll("embed, object, video"), a = o.length, s = 0; s < a; s++) {
                  o[s].style.width = "100%", o[s].style.height = "100%";
                }
                e.options.setDimensions && "function" == typeof e.media.setSize && e.media.setSize(screen.width, screen.height);

                for (var d = e.getElement(e.layers).children, f = d.length, p = 0; p < f; p++) {
                  d[p].style.width = "100%", d[p].style.height = "100%";
                }

                e.fullscreenBtn && ((0, c.removeClass)(e.fullscreenBtn, e.options.classPrefix + "fullscreen"), (0, c.addClass)(e.fullscreenBtn, e.options.classPrefix + "unfullscreen")), e.setControlsSize(), e.isFullScreen = !0;
                var g = Math.min(screen.width / e.width, screen.height / e.height),
                    v = e.getElement(e.container).querySelector("." + e.options.classPrefix + "captions-text");
                v && (v.style.fontSize = 100 * g + "%", v.style.lineHeight = "normal", e.getElement(e.container).querySelector("." + e.options.classPrefix + "captions-position").style.bottom = (screen.height - e.normalHeight) / 2 - e.getElement(e.controls).offsetHeight / 2 + g + 15 + "px");
                var m = (0, u.createEvent)("enteredfullscreen", e.getElement(e.container));
                e.getElement(e.container).dispatchEvent(m);
              }
            },
            exitFullScreen: function exitFullScreen() {
              var e = this,
                  t = null !== e.media.rendererName && /(native|html5)/i.test(e.media.rendererName);

              if (e.isVideo) {
                if (clearTimeout(e.containerSizeTimeout), l.HAS_TRUE_NATIVE_FULLSCREEN && (l.IS_FULLSCREEN || e.isFullScreen) && l.cancelFullScreen(), (0, c.removeClass)(r.default.documentElement, e.options.classPrefix + "fullscreen"), (0, c.removeClass)(e.getElement(e.container), e.options.classPrefix + "container-fullscreen"), e.options.setDimensions) {
                  if (e.getElement(e.container).style.width = e.normalWidth + "px", e.getElement(e.container).style.height = e.normalHeight + "px", t) e.node.style.width = e.normalWidth + "px", e.node.style.height = e.normalHeight + "px";else for (var n = e.getElement(e.container).querySelectorAll("embed, object, video"), i = n.length, o = 0; o < i; o++) {
                    n[o].style.width = e.normalWidth + "px", n[o].style.height = e.normalHeight + "px";
                  }
                  "function" == typeof e.media.setSize && e.media.setSize(e.normalWidth, e.normalHeight);

                  for (var a = e.getElement(e.layers).children, s = a.length, h = 0; h < s; h++) {
                    a[h].style.width = e.normalWidth + "px", a[h].style.height = e.normalHeight + "px";
                  }
                }

                e.fullscreenBtn && ((0, c.removeClass)(e.fullscreenBtn, e.options.classPrefix + "unfullscreen"), (0, c.addClass)(e.fullscreenBtn, e.options.classPrefix + "fullscreen")), e.setControlsSize(), e.isFullScreen = !1;
                var d = e.getElement(e.container).querySelector("." + e.options.classPrefix + "captions-text");
                d && (d.style.fontSize = "", d.style.lineHeight = "", e.getElement(e.container).querySelector("." + e.options.classPrefix + "captions-position").style.bottom = "");
                var f = (0, u.createEvent)("exitedfullscreen", e.getElement(e.container));
                e.getElement(e.container).dispatchEvent(f);
              }
            }
          });
        }, {
          16: 16,
          2: 2,
          25: 25,
          26: 26,
          27: 27,
          28: 28,
          3: 3,
          5: 5
        }],
        10: [function (e, t, n) {
          "use strict";

          var i = u(e(2)),
              r = e(16),
              o = u(r),
              a = u(e(5)),
              s = e(27),
              l = e(26);

          function u(e) {
            return e && e.__esModule ? e : {
              default: e
            };
          }

          Object.assign(r.config, {
            playText: null,
            pauseText: null
          }), Object.assign(o.default.prototype, {
            buildplaypause: function buildplaypause(e, t, n, r) {
              var o = this,
                  u = o.options,
                  c = (0, s.isString)(u.playText) ? u.playText : a.default.t("mejs.play"),
                  h = (0, s.isString)(u.pauseText) ? u.pauseText : a.default.t("mejs.pause"),
                  d = i.default.createElement("div");
              d.className = o.options.classPrefix + "button " + o.options.classPrefix + "playpause-button " + o.options.classPrefix + "play", d.innerHTML = '<button type="button" aria-controls="' + o.id + '" title="' + c + '" aria-label="' + h + '" tabindex="0"></button>', d.addEventListener("click", function () {
                o.paused ? o.play() : o.pause();
              });
              var f = d.querySelector("button");

              function p(e) {
                "play" === e ? ((0, l.removeClass)(d, o.options.classPrefix + "play"), (0, l.removeClass)(d, o.options.classPrefix + "replay"), (0, l.addClass)(d, o.options.classPrefix + "pause"), f.setAttribute("title", h), f.setAttribute("aria-label", h)) : ((0, l.removeClass)(d, o.options.classPrefix + "pause"), (0, l.removeClass)(d, o.options.classPrefix + "replay"), (0, l.addClass)(d, o.options.classPrefix + "play"), f.setAttribute("title", c), f.setAttribute("aria-label", c));
              }

              o.addControlElement(d, "playpause"), p("pse"), r.addEventListener("loadedmetadata", function () {
                -1 === r.rendererName.indexOf("flash") && p("pse");
              }), r.addEventListener("play", function () {
                p("play");
              }), r.addEventListener("playing", function () {
                p("play");
              }), r.addEventListener("pause", function () {
                p("pse");
              }), r.addEventListener("ended", function () {
                e.options.loop || ((0, l.removeClass)(d, o.options.classPrefix + "pause"), (0, l.removeClass)(d, o.options.classPrefix + "play"), (0, l.addClass)(d, o.options.classPrefix + "replay"), f.setAttribute("title", c), f.setAttribute("aria-label", c));
              });
            }
          });
        }, {
          16: 16,
          2: 2,
          26: 26,
          27: 27,
          5: 5
        }],
        11: [function (e, t, n) {
          "use strict";

          var i = c(e(2)),
              r = e(16),
              o = c(r),
              a = c(e(5)),
              s = e(25),
              l = e(30),
              u = e(26);

          function c(e) {
            return e && e.__esModule ? e : {
              default: e
            };
          }

          Object.assign(r.config, {
            enableProgressTooltip: !0,
            useSmoothHover: !0,
            forceLive: !1
          }), Object.assign(o.default.prototype, {
            buildprogress: function buildprogress(e, t, n, r) {
              var o = 0,
                  c = !1,
                  h = !1,
                  d = this,
                  f = e.options.autoRewind,
                  p = e.options.enableProgressTooltip ? '<span class="' + d.options.classPrefix + 'time-float"><span class="' + d.options.classPrefix + 'time-float-current">00:00</span><span class="' + d.options.classPrefix + 'time-float-corner"></span></span>' : "",
                  g = i.default.createElement("div");
              g.className = d.options.classPrefix + "time-rail", g.innerHTML = '<span class="' + d.options.classPrefix + "time-total " + d.options.classPrefix + 'time-slider"><span class="' + d.options.classPrefix + 'time-buffering"></span><span class="' + d.options.classPrefix + 'time-loaded"></span><span class="' + d.options.classPrefix + 'time-current"></span><span class="' + d.options.classPrefix + 'time-hovered no-hover"></span><span class="' + d.options.classPrefix + 'time-handle"><span class="' + d.options.classPrefix + 'time-handle-content"></span></span>' + p + "</span>", d.addControlElement(g, "progress"), d.options.keyActions.push({
                keys: [37, 227],
                action: function action(e) {
                  if (!isNaN(e.duration) && e.duration > 0) {
                    e.isVideo && (e.showControls(), e.startControlsTimer());
                    var t = e.getElement(e.container).querySelector("." + d.options.classPrefix + "time-total");
                    t && t.focus();
                    var n = Math.max(e.currentTime - e.options.defaultSeekBackwardInterval(e), 0);
                    e.paused || e.pause(), setTimeout(function () {
                      e.setCurrentTime(n);
                    }, 0), setTimeout(function () {
                      e.play();
                    }, 0);
                  }
                }
              }, {
                keys: [39, 228],
                action: function action(e) {
                  if (!isNaN(e.duration) && e.duration > 0) {
                    e.isVideo && (e.showControls(), e.startControlsTimer());
                    var t = e.getElement(e.container).querySelector("." + d.options.classPrefix + "time-total");
                    t && t.focus();
                    var n = Math.min(e.currentTime + e.options.defaultSeekForwardInterval(e), e.duration);
                    e.paused || e.pause(), setTimeout(function () {
                      e.setCurrentTime(n);
                    }, 0), setTimeout(function () {
                      e.play();
                    }, 0);
                  }
                }
              }), d.rail = t.querySelector("." + d.options.classPrefix + "time-rail"), d.total = t.querySelector("." + d.options.classPrefix + "time-total"), d.loaded = t.querySelector("." + d.options.classPrefix + "time-loaded"), d.current = t.querySelector("." + d.options.classPrefix + "time-current"), d.handle = t.querySelector("." + d.options.classPrefix + "time-handle"), d.timefloat = t.querySelector("." + d.options.classPrefix + "time-float"), d.timefloatcurrent = t.querySelector("." + d.options.classPrefix + "time-float-current"), d.slider = t.querySelector("." + d.options.classPrefix + "time-slider"), d.hovered = t.querySelector("." + d.options.classPrefix + "time-hovered"), d.buffer = t.querySelector("." + d.options.classPrefix + "time-buffering"), d.newTime = 0, d.forcedHandlePause = !1, d.setTransformStyle = function (e, t) {
                e.style.transform = t, e.style.webkitTransform = t, e.style.MozTransform = t, e.style.msTransform = t, e.style.OTransform = t;
              }, d.buffer.style.display = "none";

              var v = function v(t) {
                var n = getComputedStyle(d.total),
                    i = (0, u.offset)(d.total),
                    r = d.total.offsetWidth,
                    o = void 0 !== n.webkitTransform ? "webkitTransform" : void 0 !== n.mozTransform ? "mozTransform " : void 0 !== n.oTransform ? "oTransform" : void 0 !== n.msTransform ? "msTransform" : "transform",
                    a = "WebKitCSSMatrix" in window ? "WebKitCSSMatrix" : "MSCSSMatrix" in window ? "MSCSSMatrix" : "CSSMatrix" in window ? "CSSMatrix" : void 0,
                    h = 0,
                    f = 0,
                    p = 0,
                    g = void 0;

                if (g = t.originalEvent && t.originalEvent.changedTouches ? t.originalEvent.changedTouches[0].pageX : t.changedTouches ? t.changedTouches[0].pageX : t.pageX, d.getDuration()) {
                  if (g < i.left ? g = i.left : g > r + i.left && (g = r + i.left), h = (p = g - i.left) / r, d.newTime = h * d.getDuration(), c && null !== d.getCurrentTime() && d.newTime.toFixed(4) !== d.getCurrentTime().toFixed(4) && (d.setCurrentRailHandle(d.newTime), d.updateCurrent(d.newTime)), !s.IS_IOS && !s.IS_ANDROID) {
                    if (p < 0 && (p = 0), d.options.useSmoothHover && null !== a && void 0 !== window[a]) {
                      var v = new window[a](getComputedStyle(d.handle)[o]).m41,
                          m = p / parseFloat(getComputedStyle(d.total).width) - v / parseFloat(getComputedStyle(d.total).width);
                      d.hovered.style.left = v + "px", d.setTransformStyle(d.hovered, "scaleX(" + m + ")"), d.hovered.setAttribute("pos", p), m >= 0 ? (0, u.removeClass)(d.hovered, "negative") : (0, u.addClass)(d.hovered, "negative");
                    }

                    if (d.timefloat) {
                      var y = d.timefloat.offsetWidth / 2,
                          x = mejs.Utils.offset(d.getElement(d.container)),
                          _ = getComputedStyle(d.timefloat);

                      f = g - x.left < d.timefloat.offsetWidth ? y : g - x.left >= d.getElement(d.container).offsetWidth - y ? d.total.offsetWidth - y : p, (0, u.hasClass)(d.getElement(d.container), d.options.classPrefix + "long-video") && (f += parseFloat(_.marginLeft) / 2 + d.timefloat.offsetWidth / 2), d.timefloat.style.left = f + "px", d.timefloatcurrent.innerHTML = (0, l.secondsToTimeCode)(d.newTime, e.options.alwaysShowHours, e.options.showTimecodeFrameCount, e.options.framesPerSecond, e.options.secondsDecimalLength, e.options.timeFormat), d.timefloat.style.display = "block";
                    }
                  }
                } else s.IS_IOS || s.IS_ANDROID || !d.timefloat || (f = d.timefloat.offsetWidth + r >= d.getElement(d.container).offsetWidth ? d.timefloat.offsetWidth / 2 : 0, d.timefloat.style.left = f + "px", d.timefloat.style.left = f + "px", d.timefloat.style.display = "block");
              },
                  m = function m() {
                new Date() - o >= 1e3 && d.play();
              };

              d.slider.addEventListener("focus", function () {
                e.options.autoRewind = !1;
              }), d.slider.addEventListener("blur", function () {
                e.options.autoRewind = f;
              }), d.slider.addEventListener("keydown", function (t) {
                if (new Date() - o >= 1e3 && (h = d.paused), d.options.enableKeyboard && d.options.keyActions.length) {
                  var n = t.which || t.keyCode || 0,
                      i = d.getDuration(),
                      a = e.options.defaultSeekForwardInterval(r),
                      l = e.options.defaultSeekBackwardInterval(r),
                      u = d.getCurrentTime(),
                      c = d.getElement(d.container).querySelector("." + d.options.classPrefix + "volume-slider");

                  if (38 === n || 40 === n) {
                    c && (c.style.display = "block"), d.isVideo && (d.showControls(), d.startControlsTimer());
                    var f = 38 === n ? Math.min(d.volume + .1, 1) : Math.max(d.volume - .1, 0),
                        p = f <= 0;
                    return d.setVolume(f), void d.setMuted(p);
                  }

                  switch (c && (c.style.display = "none"), n) {
                    case 37:
                      d.getDuration() !== 1 / 0 && (u -= l);
                      break;

                    case 39:
                      d.getDuration() !== 1 / 0 && (u += a);
                      break;

                    case 36:
                      u = 0;
                      break;

                    case 35:
                      u = i;
                      break;

                    case 13:
                    case 32:
                      return void (s.IS_FIREFOX && (d.paused ? d.play() : d.pause()));

                    default:
                      return;
                  }

                  u = u < 0 || isNaN(u) ? 0 : u >= i ? i : Math.floor(u), o = new Date(), h || e.pause(), setTimeout(function () {
                    d.setCurrentTime(u);
                  }, 0), u < d.getDuration() && !h && setTimeout(m, 1100), e.showControls(), t.preventDefault(), t.stopPropagation();
                }
              });
              var y = ["mousedown", "touchstart"];
              d.slider.addEventListener("dragstart", function () {
                return !1;
              });

              for (var x = 0, _ = y.length; x < _; x++) {
                d.slider.addEventListener(y[x], function (e) {
                  if (d.forcedHandlePause = !1, d.getDuration() !== 1 / 0 && (1 === e.which || 0 === e.which)) {
                    d.paused || (d.pause(), d.forcedHandlePause = !0), c = !0, v(e);

                    for (var t = ["mouseup", "touchend"], n = 0, i = t.length; n < i; n++) {
                      d.getElement(d.container).addEventListener(t[n], function (e) {
                        var t = e.target;
                        (t === d.slider || t.closest("." + d.options.classPrefix + "time-slider")) && v(e);
                      });
                    }

                    d.globalBind("mouseup.dur touchend.dur", function () {
                      c && null !== d.getCurrentTime() && d.newTime.toFixed(4) !== d.getCurrentTime().toFixed(4) && (d.setCurrentTime(d.newTime), d.setCurrentRailHandle(d.newTime), d.updateCurrent(d.newTime)), d.forcedHandlePause && (d.slider.focus(), d.play()), d.forcedHandlePause = !1, c = !1, d.timefloat && (d.timefloat.style.display = "none");
                    });
                  }
                }, !(!s.SUPPORT_PASSIVE_EVENT || "touchstart" !== y[x]) && {
                  passive: !0
                });
              }

              d.slider.addEventListener("mouseenter", function (e) {
                e.target === d.slider && d.getDuration() !== 1 / 0 && (d.getElement(d.container).addEventListener("mousemove", function (e) {
                  var t = e.target;
                  (t === d.slider || t.closest("." + d.options.classPrefix + "time-slider")) && v(e);
                }), !d.timefloat || s.IS_IOS || s.IS_ANDROID || (d.timefloat.style.display = "block"), d.hovered && !s.IS_IOS && !s.IS_ANDROID && d.options.useSmoothHover && (0, u.removeClass)(d.hovered, "no-hover"));
              }), d.slider.addEventListener("mouseleave", function () {
                d.getDuration() !== 1 / 0 && (c || (d.timefloat && (d.timefloat.style.display = "none"), d.hovered && d.options.useSmoothHover && (0, u.addClass)(d.hovered, "no-hover")));
              }), d.broadcastCallback = function (n) {
                var o,
                    s,
                    u,
                    c,
                    h = t.querySelector("." + d.options.classPrefix + "broadcast");

                if (d.options.forceLive || d.getDuration() === 1 / 0) {
                  if (!h && d.options.forceLive) {
                    var f = i.default.createElement("span");
                    f.className = d.options.classPrefix + "broadcast", f.innerText = a.default.t("mejs.live-broadcast"), d.slider.style.display = "none", d.rail.appendChild(f);
                  }
                } else h && (d.slider.style.display = "", h.remove()), e.setProgressRail(n), d.forcedHandlePause || e.setCurrentRail(n), o = d.getCurrentTime(), s = a.default.t("mejs.time-slider"), u = (0, l.secondsToTimeCode)(o, e.options.alwaysShowHours, e.options.showTimecodeFrameCount, e.options.framesPerSecond, e.options.secondsDecimalLength, e.options.timeFormat), c = d.getDuration(), d.slider.setAttribute("role", "slider"), d.slider.tabIndex = 0, r.paused ? (d.slider.setAttribute("aria-label", s), d.slider.setAttribute("aria-valuemin", 0), d.slider.setAttribute("aria-valuemax", isNaN(c) ? 0 : c), d.slider.setAttribute("aria-valuenow", o), d.slider.setAttribute("aria-valuetext", u)) : (d.slider.removeAttribute("aria-label"), d.slider.removeAttribute("aria-valuemin"), d.slider.removeAttribute("aria-valuemax"), d.slider.removeAttribute("aria-valuenow"), d.slider.removeAttribute("aria-valuetext"));
              }, r.addEventListener("progress", d.broadcastCallback), r.addEventListener("timeupdate", d.broadcastCallback), r.addEventListener("play", function () {
                d.buffer.style.display = "none";
              }), r.addEventListener("playing", function () {
                d.buffer.style.display = "none";
              }), r.addEventListener("seeking", function () {
                d.buffer.style.display = "";
              }), r.addEventListener("seeked", function () {
                d.buffer.style.display = "none";
              }), r.addEventListener("pause", function () {
                d.buffer.style.display = "none";
              }), r.addEventListener("waiting", function () {
                d.buffer.style.display = "";
              }), r.addEventListener("loadeddata", function () {
                d.buffer.style.display = "";
              }), r.addEventListener("canplay", function () {
                d.buffer.style.display = "none";
              }), r.addEventListener("error", function () {
                d.buffer.style.display = "none";
              }), d.getElement(d.container).addEventListener("controlsresize", function (t) {
                d.getDuration() !== 1 / 0 && (e.setProgressRail(t), d.forcedHandlePause || e.setCurrentRail(t));
              });
            },
            cleanprogress: function cleanprogress(e, t, n, i) {
              i.removeEventListener("progress", e.broadcastCallback), i.removeEventListener("timeupdate", e.broadcastCallback), e.rail && e.rail.remove();
            },
            setProgressRail: function setProgressRail(e) {
              var t = this,
                  n = void 0 !== e ? e.detail.target || e.target : t.media,
                  i = null;
              n && n.buffered && n.buffered.length > 0 && n.buffered.end && t.getDuration() ? i = n.buffered.end(n.buffered.length - 1) / t.getDuration() : n && void 0 !== n.bytesTotal && n.bytesTotal > 0 && void 0 !== n.bufferedBytes ? i = n.bufferedBytes / n.bytesTotal : e && e.lengthComputable && 0 !== e.total && (i = e.loaded / e.total), null !== i && (i = Math.min(1, Math.max(0, i)), t.loaded && t.setTransformStyle(t.loaded, "scaleX(" + i + ")"));
            },
            setCurrentRailHandle: function setCurrentRailHandle(e) {
              this.setCurrentRailMain(this, e);
            },
            setCurrentRail: function setCurrentRail() {
              this.setCurrentRailMain(this);
            },
            setCurrentRailMain: function setCurrentRailMain(e, t) {
              if (void 0 !== e.getCurrentTime() && e.getDuration()) {
                var n = void 0 === t ? e.getCurrentTime() : t;

                if (e.total && e.handle) {
                  var i = parseFloat(getComputedStyle(e.total).width),
                      r = Math.round(i * n / e.getDuration()),
                      o = r - Math.round(e.handle.offsetWidth / 2);

                  if (o = o < 0 ? 0 : o, e.setTransformStyle(e.current, "scaleX(" + r / i + ")"), e.setTransformStyle(e.handle, "translateX(" + o + "px)"), e.options.useSmoothHover && !(0, u.hasClass)(e.hovered, "no-hover")) {
                    var a = parseInt(e.hovered.getAttribute("pos"), 10),
                        s = (a = isNaN(a) ? 0 : a) / i - o / i;
                    e.hovered.style.left = o + "px", e.setTransformStyle(e.hovered, "scaleX(" + s + ")"), s >= 0 ? (0, u.removeClass)(e.hovered, "negative") : (0, u.addClass)(e.hovered, "negative");
                  }
                }
              }
            }
          });
        }, {
          16: 16,
          2: 2,
          25: 25,
          26: 26,
          30: 30,
          5: 5
        }],
        12: [function (e, t, n) {
          "use strict";

          var i = l(e(2)),
              r = e(16),
              o = l(r),
              a = e(30),
              s = e(26);

          function l(e) {
            return e && e.__esModule ? e : {
              default: e
            };
          }

          Object.assign(r.config, {
            duration: 0,
            timeAndDurationSeparator: "<span> | </span>"
          }), Object.assign(o.default.prototype, {
            buildcurrent: function buildcurrent(e, t, n, r) {
              var o = this,
                  s = i.default.createElement("div");
              s.className = o.options.classPrefix + "time", s.setAttribute("role", "timer"), s.setAttribute("aria-live", "off"), s.innerHTML = '<span class="' + o.options.classPrefix + 'currenttime">' + (0, a.secondsToTimeCode)(0, e.options.alwaysShowHours, e.options.showTimecodeFrameCount, e.options.framesPerSecond, e.options.secondsDecimalLength, e.options.timeFormat) + "</span>", o.addControlElement(s, "current"), e.updateCurrent(), o.updateTimeCallback = function () {
                o.controlsAreVisible && e.updateCurrent();
              }, r.addEventListener("timeupdate", o.updateTimeCallback);
            },
            cleancurrent: function cleancurrent(e, t, n, i) {
              i.removeEventListener("timeupdate", e.updateTimeCallback);
            },
            buildduration: function buildduration(e, t, n, r) {
              var o = this;
              if (t.lastChild.querySelector("." + o.options.classPrefix + "currenttime")) t.querySelector("." + o.options.classPrefix + "time").innerHTML += o.options.timeAndDurationSeparator + '<span class="' + o.options.classPrefix + 'duration">' + (0, a.secondsToTimeCode)(o.options.duration, o.options.alwaysShowHours, o.options.showTimecodeFrameCount, o.options.framesPerSecond, o.options.secondsDecimalLength, o.options.timeFormat) + "</span>";else {
                t.querySelector("." + o.options.classPrefix + "currenttime") && (0, s.addClass)(t.querySelector("." + o.options.classPrefix + "currenttime").parentNode, o.options.classPrefix + "currenttime-container");
                var l = i.default.createElement("div");
                l.className = o.options.classPrefix + "time " + o.options.classPrefix + "duration-container", l.innerHTML = '<span class="' + o.options.classPrefix + 'duration">' + (0, a.secondsToTimeCode)(o.options.duration, o.options.alwaysShowHours, o.options.showTimecodeFrameCount, o.options.framesPerSecond, o.options.secondsDecimalLength, o.options.timeFormat) + "</span>", o.addControlElement(l, "duration");
              }
              o.updateDurationCallback = function () {
                o.controlsAreVisible && e.updateDuration();
              }, r.addEventListener("timeupdate", o.updateDurationCallback);
            },
            cleanduration: function cleanduration(e, t, n, i) {
              i.removeEventListener("timeupdate", e.updateDurationCallback);
            },
            updateCurrent: function updateCurrent() {
              var e = this,
                  t = e.getCurrentTime();
              isNaN(t) && (t = 0);
              var n = (0, a.secondsToTimeCode)(t, e.options.alwaysShowHours, e.options.showTimecodeFrameCount, e.options.framesPerSecond, e.options.secondsDecimalLength, e.options.timeFormat);
              n.length > 5 ? (0, s.addClass)(e.getElement(e.container), e.options.classPrefix + "long-video") : (0, s.removeClass)(e.getElement(e.container), e.options.classPrefix + "long-video"), e.getElement(e.controls).querySelector("." + e.options.classPrefix + "currenttime") && (e.getElement(e.controls).querySelector("." + e.options.classPrefix + "currenttime").innerText = n);
            },
            updateDuration: function updateDuration() {
              var e = this,
                  t = e.getDuration();
              void 0 !== e.media && (isNaN(t) || t === 1 / 0 || t < 0) && (e.media.duration = e.options.duration = t = 0), e.options.duration > 0 && (t = e.options.duration);
              var n = (0, a.secondsToTimeCode)(t, e.options.alwaysShowHours, e.options.showTimecodeFrameCount, e.options.framesPerSecond, e.options.secondsDecimalLength, e.options.timeFormat);
              n.length > 5 ? (0, s.addClass)(e.getElement(e.container), e.options.classPrefix + "long-video") : (0, s.removeClass)(e.getElement(e.container), e.options.classPrefix + "long-video"), e.getElement(e.controls).querySelector("." + e.options.classPrefix + "duration") && t > 0 && (e.getElement(e.controls).querySelector("." + e.options.classPrefix + "duration").innerHTML = n);
            }
          });
        }, {
          16: 16,
          2: 2,
          26: 26,
          30: 30
        }],
        13: [function (e, t, n) {
          "use strict";

          var i = h(e(2)),
              r = h(e(7)),
              o = h(e(5)),
              a = e(16),
              s = h(a),
              l = e(30),
              u = e(27),
              c = e(26);

          function h(e) {
            return e && e.__esModule ? e : {
              default: e
            };
          }

          Object.assign(a.config, {
            startLanguage: "",
            tracksText: null,
            chaptersText: null,
            tracksAriaLive: !1,
            hideCaptionsButtonWhenEmpty: !0,
            toggleCaptionsButtonWhenOnlyOne: !1,
            slidesSelector: ""
          }), Object.assign(s.default.prototype, {
            hasChapters: !1,
            buildtracks: function buildtracks(e, t, n, r) {
              if (this.findTracks(), e.tracks.length || e.trackFiles && 0 !== !e.trackFiles.length) {
                var a = this,
                    s = a.options.tracksAriaLive ? ' role="log" aria-live="assertive" aria-atomic="false"' : "",
                    l = (0, u.isString)(a.options.tracksText) ? a.options.tracksText : o.default.t("mejs.captions-subtitles"),
                    h = (0, u.isString)(a.options.chaptersText) ? a.options.chaptersText : o.default.t("mejs.captions-chapters"),
                    d = null === e.trackFiles ? e.tracks.length : e.trackFiles.length;
                if (a.domNode.textTracks) for (var f = a.domNode.textTracks.length - 1; f >= 0; f--) {
                  a.domNode.textTracks[f].mode = "hidden";
                }
                a.cleartracks(e), e.captions = i.default.createElement("div"), e.captions.className = a.options.classPrefix + "captions-layer " + a.options.classPrefix + "layer", e.captions.innerHTML = '<div class="' + a.options.classPrefix + "captions-position " + a.options.classPrefix + 'captions-position-hover"' + s + '><span class="' + a.options.classPrefix + 'captions-text"></span></div>', e.captions.style.display = "none", n.insertBefore(e.captions, n.firstChild), e.captionsText = e.captions.querySelector("." + a.options.classPrefix + "captions-text"), e.captionsButton = i.default.createElement("div"), e.captionsButton.className = a.options.classPrefix + "button " + a.options.classPrefix + "captions-button", e.captionsButton.innerHTML = '<button type="button" aria-controls="' + a.id + '" title="' + l + '" aria-label="' + l + '" tabindex="0"></button><div class="' + a.options.classPrefix + "captions-selector " + a.options.classPrefix + 'offscreen"><ul class="' + a.options.classPrefix + 'captions-selector-list"><li class="' + a.options.classPrefix + 'captions-selector-list-item"><input type="radio" class="' + a.options.classPrefix + 'captions-selector-input" name="' + e.id + '_captions" id="' + e.id + '_captions_none" value="none" checked disabled><label class="' + a.options.classPrefix + "captions-selector-label " + a.options.classPrefix + 'captions-selected" for="' + e.id + '_captions_none">' + o.default.t("mejs.none") + "</label></li></ul></div>", a.addControlElement(e.captionsButton, "tracks"), e.captionsButton.querySelector("." + a.options.classPrefix + "captions-selector-input").disabled = !1, e.chaptersButton = i.default.createElement("div"), e.chaptersButton.className = a.options.classPrefix + "button " + a.options.classPrefix + "chapters-button", e.chaptersButton.innerHTML = '<button type="button" aria-controls="' + a.id + '" title="' + h + '" aria-label="' + h + '" tabindex="0"></button><div class="' + a.options.classPrefix + "chapters-selector " + a.options.classPrefix + 'offscreen"><ul class="' + a.options.classPrefix + 'chapters-selector-list"></ul></div>';

                for (var p = 0, g = 0; g < d; g++) {
                  var v = e.tracks[g].kind;
                  e.tracks[g].src.trim() && ("subtitles" === v || "captions" === v ? p++ : "chapters" !== v || t.querySelector("." + a.options.classPrefix + "chapter-selector") || e.captionsButton.parentNode.insertBefore(e.chaptersButton, e.captionsButton));
                }

                e.trackToLoad = -1, e.selectedTrack = null, e.isLoadingTrack = !1;

                for (var m = 0; m < d; m++) {
                  var y = e.tracks[m].kind;
                  !e.tracks[m].src.trim() || "subtitles" !== y && "captions" !== y || e.addTrackButton(e.tracks[m].trackId, e.tracks[m].srclang, e.tracks[m].label);
                }

                e.loadNextTrack();
                var x = ["mouseenter", "focusin"],
                    _ = ["mouseleave", "focusout"];
                if (a.options.toggleCaptionsButtonWhenOnlyOne && 1 === p) e.captionsButton.addEventListener("click", function (t) {
                  var n = "none";
                  null === e.selectedTrack && (n = e.tracks[0].trackId);
                  var i = t.keyCode || t.which;
                  e.setTrack(n, void 0 !== i);
                });else {
                  for (var b = e.captionsButton.querySelectorAll("." + a.options.classPrefix + "captions-selector-label"), w = e.captionsButton.querySelectorAll("input[type=radio]"), S = 0, T = x.length; S < T; S++) {
                    e.captionsButton.addEventListener(x[S], function () {
                      (0, c.removeClass)(this.querySelector("." + a.options.classPrefix + "captions-selector"), a.options.classPrefix + "offscreen");
                    });
                  }

                  for (var C = 0, k = _.length; C < k; C++) {
                    e.captionsButton.addEventListener(_[C], function () {
                      (0, c.addClass)(this.querySelector("." + a.options.classPrefix + "captions-selector"), a.options.classPrefix + "offscreen");
                    });
                  }

                  for (var M = 0, E = w.length; M < E; M++) {
                    w[M].addEventListener("click", function (t) {
                      var n = t.keyCode || t.which;
                      e.setTrack(this.value, void 0 !== n);
                    });
                  }

                  for (var A = 0, I = b.length; A < I; A++) {
                    b[A].addEventListener("click", function (e) {
                      var t = (0, c.siblings)(this, function (e) {
                        return "INPUT" === e.tagName;
                      })[0],
                          n = (0, u.createEvent)("click", t);
                      t.dispatchEvent(n), e.preventDefault();
                    });
                  }

                  e.captionsButton.addEventListener("keydown", function (e) {
                    e.stopPropagation();
                  });
                }

                for (var P = 0, O = x.length; P < O; P++) {
                  e.chaptersButton.addEventListener(x[P], function () {
                    this.querySelector("." + a.options.classPrefix + "chapters-selector-list").children.length && (0, c.removeClass)(this.querySelector("." + a.options.classPrefix + "chapters-selector"), a.options.classPrefix + "offscreen");
                  });
                }

                for (var L = 0, D = _.length; L < D; L++) {
                  e.chaptersButton.addEventListener(_[L], function () {
                    (0, c.addClass)(this.querySelector("." + a.options.classPrefix + "chapters-selector"), a.options.classPrefix + "offscreen");
                  });
                }

                e.chaptersButton.addEventListener("keydown", function (e) {
                  e.stopPropagation();
                }), e.options.alwaysShowControls ? (0, c.addClass)(e.getElement(e.container).querySelector("." + a.options.classPrefix + "captions-position"), a.options.classPrefix + "captions-position-hover") : (e.getElement(e.container).addEventListener("controlsshown", function () {
                  (0, c.addClass)(e.getElement(e.container).querySelector("." + a.options.classPrefix + "captions-position"), a.options.classPrefix + "captions-position-hover");
                }), e.getElement(e.container).addEventListener("controlshidden", function () {
                  r.paused || (0, c.removeClass)(e.getElement(e.container).querySelector("." + a.options.classPrefix + "captions-position"), a.options.classPrefix + "captions-position-hover");
                })), r.addEventListener("timeupdate", function () {
                  e.displayCaptions();
                }), "" !== e.options.slidesSelector && (e.slidesContainer = i.default.querySelectorAll(e.options.slidesSelector), r.addEventListener("timeupdate", function () {
                  e.displaySlides();
                }));
              }
            },
            cleartracks: function cleartracks(e) {
              e && (e.captions && e.captions.remove(), e.chapters && e.chapters.remove(), e.captionsText && e.captionsText.remove(), e.captionsButton && e.captionsButton.remove(), e.chaptersButton && e.chaptersButton.remove());
            },
            rebuildtracks: function rebuildtracks() {
              var e = this;
              e.findTracks(), e.buildtracks(e, e.getElement(e.controls), e.getElement(e.layers), e.media);
            },
            findTracks: function findTracks() {
              var e = this,
                  t = null === e.trackFiles ? e.node.querySelectorAll("track") : e.trackFiles,
                  n = t.length;
              e.tracks = [];

              for (var i = 0; i < n; i++) {
                var r = t[i],
                    o = r.getAttribute("srclang").toLowerCase() || "",
                    a = e.id + "_track_" + i + "_" + r.getAttribute("kind") + "_" + o;
                e.tracks.push({
                  trackId: a,
                  srclang: o,
                  src: r.getAttribute("src"),
                  kind: r.getAttribute("kind"),
                  label: r.getAttribute("label") || "",
                  entries: [],
                  isLoaded: !1
                });
              }
            },
            setTrack: function setTrack(e, t) {
              for (var n = this, i = n.captionsButton.querySelectorAll('input[type="radio"]'), r = n.captionsButton.querySelectorAll("." + n.options.classPrefix + "captions-selected"), o = n.captionsButton.querySelector('input[value="' + e + '"]'), a = 0, s = i.length; a < s; a++) {
                i[a].checked = !1;
              }

              for (var l = 0, h = r.length; l < h; l++) {
                (0, c.removeClass)(r[l], n.options.classPrefix + "captions-selected");
              }

              o.checked = !0;

              for (var d = (0, c.siblings)(o, function (e) {
                return (0, c.hasClass)(e, n.options.classPrefix + "captions-selector-label");
              }), f = 0, p = d.length; f < p; f++) {
                (0, c.addClass)(d[f], n.options.classPrefix + "captions-selected");
              }

              if ("none" === e) n.selectedTrack = null, (0, c.removeClass)(n.captionsButton, n.options.classPrefix + "captions-enabled");else for (var g = 0, v = n.tracks.length; g < v; g++) {
                var m = n.tracks[g];

                if (m.trackId === e) {
                  null === n.selectedTrack && (0, c.addClass)(n.captionsButton, n.options.classPrefix + "captions-enabled"), n.selectedTrack = m, n.captions.setAttribute("lang", n.selectedTrack.srclang), n.displayCaptions();
                  break;
                }
              }
              var y = (0, u.createEvent)("captionschange", n.media);
              y.detail.caption = n.selectedTrack, n.media.dispatchEvent(y), t || setTimeout(function () {
                n.getElement(n.container).focus();
              }, 500);
            },
            loadNextTrack: function loadNextTrack() {
              var e = this;
              e.trackToLoad++, e.trackToLoad < e.tracks.length ? (e.isLoadingTrack = !0, e.loadTrack(e.trackToLoad)) : (e.isLoadingTrack = !1, e.checkForTracks());
            },
            loadTrack: function loadTrack(e) {
              var t = this,
                  n = t.tracks[e];
              void 0 === n || void 0 === n.src && "" === n.src || (0, c.ajax)(n.src, "text", function (e) {
                n.entries = "string" == typeof e && /<tt\s+xml/gi.exec(e) ? r.default.TrackFormatParser.dfxp.parse(e) : r.default.TrackFormatParser.webvtt.parse(e), n.isLoaded = !0, t.enableTrackButton(n), t.loadNextTrack(), "slides" === n.kind ? t.setupSlides(n) : "chapters" !== n.kind || t.hasChapters || (t.drawChapters(n), t.hasChapters = !0);
              }, function () {
                t.removeTrackButton(n.trackId), t.loadNextTrack();
              });
            },
            enableTrackButton: function enableTrackButton(e) {
              var t = this,
                  n = e.srclang,
                  a = i.default.getElementById("" + e.trackId);

              if (a) {
                var s = e.label;
                "" === s && (s = o.default.t(r.default.language.codes[n]) || n), a.disabled = !1;

                for (var l = (0, c.siblings)(a, function (e) {
                  return (0, c.hasClass)(e, t.options.classPrefix + "captions-selector-label");
                }), h = 0, d = l.length; h < d; h++) {
                  l[h].innerHTML = s;
                }

                if (t.options.startLanguage === n) {
                  a.checked = !0;
                  var f = (0, u.createEvent)("click", a);
                  a.dispatchEvent(f);
                }
              }
            },
            removeTrackButton: function removeTrackButton(e) {
              var t = i.default.getElementById("" + e);

              if (t) {
                var n = t.closest("li");
                n && n.remove();
              }
            },
            addTrackButton: function addTrackButton(e, t, n) {
              var i = this;
              "" === n && (n = o.default.t(r.default.language.codes[t]) || t), i.captionsButton.querySelector("ul").innerHTML += '<li class="' + i.options.classPrefix + 'captions-selector-list-item"><input type="radio" class="' + i.options.classPrefix + 'captions-selector-input" name="' + i.id + '_captions" id="' + e + '" value="' + e + '" disabled><label class="' + i.options.classPrefix + 'captions-selector-label"for="' + e + '">' + n + " (loading)</label></li>";
            },
            checkForTracks: function checkForTracks() {
              var e = this,
                  t = !1;

              if (e.options.hideCaptionsButtonWhenEmpty) {
                for (var n = 0, i = e.tracks.length; n < i; n++) {
                  var r = e.tracks[n].kind;

                  if (("subtitles" === r || "captions" === r) && e.tracks[n].isLoaded) {
                    t = !0;
                    break;
                  }
                }

                e.captionsButton.style.display = t ? "" : "none", e.setControlsSize();
              }
            },
            displayCaptions: function displayCaptions() {
              if (void 0 !== this.tracks) {
                var e = this,
                    t = e.selectedTrack;

                if (null !== t && t.isLoaded) {
                  var n = e.searchTrackPosition(t.entries, e.media.currentTime);

                  if (n > -1) {
                    var r = t.entries[n].text;
                    return "function" == typeof e.options.captionTextPreprocessor && (r = e.options.captionTextPreprocessor(r)), e.captionsText.innerHTML = function (e) {
                      var t = i.default.createElement("div");
                      t.innerHTML = e;

                      for (var n = t.getElementsByTagName("script"), r = n.length; r--;) {
                        n[r].remove();
                      }

                      for (var o = t.getElementsByTagName("*"), a = 0, s = o.length; a < s; a++) {
                        for (var l = o[a].attributes, u = Array.prototype.slice.call(l), c = 0, h = u.length; c < h; c++) {
                          u[c].name.startsWith("on") || u[c].value.startsWith("javascript") ? o[a].remove() : "style" === u[c].name && o[a].removeAttribute(u[c].name);
                        }
                      }

                      return t.innerHTML;
                    }(r), e.captionsText.className = e.options.classPrefix + "captions-text " + (t.entries[n].identifier || ""), e.captions.style.display = "", void (e.captions.style.height = "0px");
                  }

                  e.captions.style.display = "none";
                } else e.captions.style.display = "none";
              }
            },
            setupSlides: function setupSlides(e) {
              var t = this;
              t.slides = e, t.slides.entries.imgs = [t.slides.entries.length], t.showSlide(0);
            },
            showSlide: function showSlide(e) {
              var t = this,
                  n = this;

              if (void 0 !== n.tracks && void 0 !== n.slidesContainer) {
                var r = n.slides.entries[e].text,
                    o = n.slides.entries[e].imgs;

                if (void 0 === o || void 0 === o.fadeIn) {
                  var a = i.default.createElement("img");
                  a.src = r, a.addEventListener("load", function () {
                    var e = t,
                        i = (0, c.siblings)(e, function (e) {
                      return i(e);
                    });
                    e.style.display = "none", n.slidesContainer.innerHTML += e.innerHTML, (0, c.fadeIn)(n.slidesContainer.querySelector(a));

                    for (var r = 0, o = i.length; r < o; r++) {
                      (0, c.fadeOut)(i[r], 400);
                    }
                  }), n.slides.entries[e].imgs = o = a;
                } else if (!(0, c.visible)(o)) {
                  var s = (0, c.siblings)(self, function (e) {
                    return s(e);
                  });
                  (0, c.fadeIn)(n.slidesContainer.querySelector(o));

                  for (var l = 0, u = s.length; l < u; l++) {
                    (0, c.fadeOut)(s[l]);
                  }
                }
              }
            },
            displaySlides: function displaySlides() {
              var e = this;

              if (void 0 !== this.slides) {
                var t = e.slides,
                    n = e.searchTrackPosition(t.entries, e.media.currentTime);
                n > -1 && e.showSlide(n);
              }
            },
            drawChapters: function drawChapters(e) {
              var t = this,
                  n = e.entries.length;

              if (n) {
                t.chaptersButton.querySelector("ul").innerHTML = "";

                for (var i = 0; i < n; i++) {
                  t.chaptersButton.querySelector("ul").innerHTML += '<li class="' + t.options.classPrefix + 'chapters-selector-list-item" role="menuitemcheckbox" aria-live="polite" aria-disabled="false" aria-checked="false"><input type="radio" class="' + t.options.classPrefix + 'captions-selector-input" name="' + t.id + '_chapters" id="' + t.id + "_chapters_" + i + '" value="' + e.entries[i].start + '" disabled><label class="' + t.options.classPrefix + 'chapters-selector-label"for="' + t.id + "_chapters_" + i + '">' + e.entries[i].text + "</label></li>";
                }

                for (var r = t.chaptersButton.querySelectorAll('input[type="radio"]'), o = t.chaptersButton.querySelectorAll("." + t.options.classPrefix + "chapters-selector-label"), a = 0, s = r.length; a < s; a++) {
                  r[a].disabled = !1, r[a].checked = !1, r[a].addEventListener("click", function (e) {
                    var n = t.chaptersButton.querySelectorAll("li"),
                        i = (0, c.siblings)(this, function (e) {
                      return (0, c.hasClass)(e, t.options.classPrefix + "chapters-selector-label");
                    })[0];
                    this.checked = !0, this.parentNode.setAttribute("aria-checked", !0), (0, c.addClass)(i, t.options.classPrefix + "chapters-selected"), (0, c.removeClass)(t.chaptersButton.querySelector("." + t.options.classPrefix + "chapters-selected"), t.options.classPrefix + "chapters-selected");

                    for (var r = 0, o = n.length; r < o; r++) {
                      n[r].setAttribute("aria-checked", !1);
                    }

                    void 0 === (e.keyCode || e.which) && setTimeout(function () {
                      t.getElement(t.container).focus();
                    }, 500), t.media.setCurrentTime(parseFloat(this.value)), t.media.paused && t.media.play();
                  });
                }

                for (var l = 0, h = o.length; l < h; l++) {
                  o[l].addEventListener("click", function (e) {
                    var t = (0, c.siblings)(this, function (e) {
                      return "INPUT" === e.tagName;
                    })[0],
                        n = (0, u.createEvent)("click", t);
                    t.dispatchEvent(n), e.preventDefault();
                  });
                }
              }
            },
            searchTrackPosition: function searchTrackPosition(e, t) {
              for (var n = 0, i = e.length - 1, r = void 0, o = void 0, a = void 0; n <= i;) {
                if (o = e[r = n + i >> 1].start, a = e[r].stop, t >= o && t < a) return r;
                o < t ? n = r + 1 : o > t && (i = r - 1);
              }

              return -1;
            }
          }), r.default.language = {
            codes: {
              af: "mejs.afrikaans",
              sq: "mejs.albanian",
              ar: "mejs.arabic",
              be: "mejs.belarusian",
              bg: "mejs.bulgarian",
              ca: "mejs.catalan",
              zh: "mejs.chinese",
              "zh-cn": "mejs.chinese-simplified",
              "zh-tw": "mejs.chines-traditional",
              hr: "mejs.croatian",
              cs: "mejs.czech",
              da: "mejs.danish",
              nl: "mejs.dutch",
              en: "mejs.english",
              et: "mejs.estonian",
              fl: "mejs.filipino",
              fi: "mejs.finnish",
              fr: "mejs.french",
              gl: "mejs.galician",
              de: "mejs.german",
              el: "mejs.greek",
              ht: "mejs.haitian-creole",
              iw: "mejs.hebrew",
              hi: "mejs.hindi",
              hu: "mejs.hungarian",
              is: "mejs.icelandic",
              id: "mejs.indonesian",
              ga: "mejs.irish",
              it: "mejs.italian",
              ja: "mejs.japanese",
              ko: "mejs.korean",
              lv: "mejs.latvian",
              lt: "mejs.lithuanian",
              mk: "mejs.macedonian",
              ms: "mejs.malay",
              mt: "mejs.maltese",
              no: "mejs.norwegian",
              fa: "mejs.persian",
              pl: "mejs.polish",
              pt: "mejs.portuguese",
              ro: "mejs.romanian",
              ru: "mejs.russian",
              sr: "mejs.serbian",
              sk: "mejs.slovak",
              sl: "mejs.slovenian",
              es: "mejs.spanish",
              sw: "mejs.swahili",
              sv: "mejs.swedish",
              tl: "mejs.tagalog",
              th: "mejs.thai",
              tr: "mejs.turkish",
              uk: "mejs.ukrainian",
              vi: "mejs.vietnamese",
              cy: "mejs.welsh",
              yi: "mejs.yiddish"
            }
          }, r.default.TrackFormatParser = {
            webvtt: {
              pattern: /^((?:[0-9]{1,2}:)?[0-9]{2}:[0-9]{2}([,.][0-9]{1,3})?) --\> ((?:[0-9]{1,2}:)?[0-9]{2}:[0-9]{2}([,.][0-9]{3})?)(.*)$/,
              parse: function parse(e) {
                for (var t = e.split(/\r?\n/), n = [], i = void 0, r = void 0, o = void 0, a = 0, s = t.length; a < s; a++) {
                  if ((i = this.pattern.exec(t[a])) && a < t.length) {
                    for (a - 1 >= 0 && "" !== t[a - 1] && (o = t[a - 1]), r = t[++a], a++; "" !== t[a] && a < t.length;) {
                      r = r + "\n" + t[a], a++;
                    }

                    r = null === r ? "" : r.trim().replace(/(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi, "<a href='$1' target='_blank'>$1</a>"), n.push({
                      identifier: o,
                      start: 0 === (0, l.convertSMPTEtoSeconds)(i[1]) ? .2 : (0, l.convertSMPTEtoSeconds)(i[1]),
                      stop: (0, l.convertSMPTEtoSeconds)(i[3]),
                      text: r,
                      settings: i[5]
                    });
                  }

                  o = "";
                }

                return n;
              }
            },
            dfxp: {
              parse: function parse(e) {
                var t = (e = $(e).filter("tt")).firstChild,
                    n = t.querySelectorAll("p"),
                    i = e.getElementById("" + t.attr("style")),
                    r = [],
                    o = void 0;

                if (i.length) {
                  i.removeAttribute("id");
                  var a = i.attributes;

                  if (a.length) {
                    o = {};

                    for (var s = 0, u = a.length; s < u; s++) {
                      o[a[s].name.split(":")[1]] = a[s].value;
                    }
                  }
                }

                for (var c = 0, h = n.length; c < h; c++) {
                  var d = void 0,
                      f = {
                    start: null,
                    stop: null,
                    style: null,
                    text: null
                  };
                  if (n.eq(c).attr("begin") && (f.start = (0, l.convertSMPTEtoSeconds)(n.eq(c).attr("begin"))), !f.start && n.eq(c - 1).attr("end") && (f.start = (0, l.convertSMPTEtoSeconds)(n.eq(c - 1).attr("end"))), n.eq(c).attr("end") && (f.stop = (0, l.convertSMPTEtoSeconds)(n.eq(c).attr("end"))), !f.stop && n.eq(c + 1).attr("begin") && (f.stop = (0, l.convertSMPTEtoSeconds)(n.eq(c + 1).attr("begin"))), o) for (var p in d = "", o) {
                    d += p + ":" + o[p] + ";";
                  }
                  d && (f.style = d), 0 === f.start && (f.start = .2), f.text = n.eq(c).innerHTML.trim().replace(/(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi, "<a href='$1' target='_blank'>$1</a>"), r.push(f);
                }

                return r;
              }
            }
          };
        }, {
          16: 16,
          2: 2,
          26: 26,
          27: 27,
          30: 30,
          5: 5,
          7: 7
        }],
        14: [function (e, t, n) {
          "use strict";

          var i = c(e(2)),
              r = e(16),
              o = c(r),
              a = c(e(5)),
              s = e(25),
              l = e(27),
              u = e(26);

          function c(e) {
            return e && e.__esModule ? e : {
              default: e
            };
          }

          Object.assign(r.config, {
            muteText: null,
            unmuteText: null,
            allyVolumeControlText: null,
            hideVolumeOnTouchDevices: !0,
            audioVolume: "horizontal",
            videoVolume: "vertical",
            startVolume: .8
          }), Object.assign(o.default.prototype, {
            buildvolume: function buildvolume(e, t, n, r) {
              if (!s.IS_ANDROID && !s.IS_IOS || !this.options.hideVolumeOnTouchDevices) {
                var o = this,
                    c = o.isVideo ? o.options.videoVolume : o.options.audioVolume,
                    h = (0, l.isString)(o.options.muteText) ? o.options.muteText : a.default.t("mejs.mute"),
                    d = (0, l.isString)(o.options.unmuteText) ? o.options.unmuteText : a.default.t("mejs.unmute"),
                    f = (0, l.isString)(o.options.allyVolumeControlText) ? o.options.allyVolumeControlText : a.default.t("mejs.volume-help-text"),
                    p = i.default.createElement("div");

                if (p.className = o.options.classPrefix + "button " + o.options.classPrefix + "volume-button " + o.options.classPrefix + "mute", p.innerHTML = "horizontal" === c ? '<button type="button" aria-controls="' + o.id + '" title="' + h + '" aria-label="' + h + '" tabindex="0"></button>' : '<button type="button" aria-controls="' + o.id + '" title="' + h + '" aria-label="' + h + '" tabindex="0"></button><a href="javascript:void(0);" class="' + o.options.classPrefix + 'volume-slider" aria-label="' + a.default.t("mejs.volume-slider") + '" aria-valuemin="0" aria-valuemax="100" role="slider" aria-orientation="vertical"><span class="' + o.options.classPrefix + 'offscreen">' + f + '</span><div class="' + o.options.classPrefix + 'volume-total"><div class="' + o.options.classPrefix + 'volume-current"></div><div class="' + o.options.classPrefix + 'volume-handle"></div></div></a>', o.addControlElement(p, "volume"), o.options.keyActions.push({
                  keys: [38],
                  action: function action(e) {
                    var t = e.getElement(e.container).querySelector("." + o.options.classPrefix + "volume-slider");
                    t && t.matches(":focus") && (t.style.display = "block"), e.isVideo && (e.showControls(), e.startControlsTimer());
                    var n = Math.min(e.volume + .1, 1);
                    e.setVolume(n), n > 0 && e.setMuted(!1);
                  }
                }, {
                  keys: [40],
                  action: function action(e) {
                    var t = e.getElement(e.container).querySelector("." + o.options.classPrefix + "volume-slider");
                    t && (t.style.display = "block"), e.isVideo && (e.showControls(), e.startControlsTimer());
                    var n = Math.max(e.volume - .1, 0);
                    e.setVolume(n), n <= .1 && e.setMuted(!0);
                  }
                }, {
                  keys: [77],
                  action: function action(e) {
                    var t = e.getElement(e.container).querySelector("." + o.options.classPrefix + "volume-slider");
                    t && (t.style.display = "block"), e.isVideo && (e.showControls(), e.startControlsTimer()), e.media.muted ? e.setMuted(!1) : e.setMuted(!0);
                  }
                }), "horizontal" === c) {
                  var g = i.default.createElement("a");
                  g.className = o.options.classPrefix + "horizontal-volume-slider", g.href = "javascript:void(0);", g.setAttribute("aria-label", a.default.t("mejs.volume-slider")), g.setAttribute("aria-valuemin", 0), g.setAttribute("aria-valuemax", 100), g.setAttribute("aria-valuenow", 100), g.setAttribute("role", "slider"), g.innerHTML += '<span class="' + o.options.classPrefix + 'offscreen">' + f + '</span><div class="' + o.options.classPrefix + 'horizontal-volume-total"><div class="' + o.options.classPrefix + 'horizontal-volume-current"></div><div class="' + o.options.classPrefix + 'horizontal-volume-handle"></div></div>', p.parentNode.insertBefore(g, p.nextSibling);
                }

                var v = !1,
                    m = !1,
                    y = !1,
                    x = "vertical" === c ? o.getElement(o.container).querySelector("." + o.options.classPrefix + "volume-slider") : o.getElement(o.container).querySelector("." + o.options.classPrefix + "horizontal-volume-slider"),
                    _ = "vertical" === c ? o.getElement(o.container).querySelector("." + o.options.classPrefix + "volume-total") : o.getElement(o.container).querySelector("." + o.options.classPrefix + "horizontal-volume-total"),
                    b = "vertical" === c ? o.getElement(o.container).querySelector("." + o.options.classPrefix + "volume-current") : o.getElement(o.container).querySelector("." + o.options.classPrefix + "horizontal-volume-current"),
                    w = "vertical" === c ? o.getElement(o.container).querySelector("." + o.options.classPrefix + "volume-handle") : o.getElement(o.container).querySelector("." + o.options.classPrefix + "horizontal-volume-handle"),
                    S = function S(e) {
                  if (null !== e && !isNaN(e) && void 0 !== e) {
                    if (e = Math.max(0, e), 0 === (e = Math.min(e, 1))) {
                      (0, u.removeClass)(p, o.options.classPrefix + "mute"), (0, u.addClass)(p, o.options.classPrefix + "unmute");
                      var t = p.firstElementChild;
                      t.setAttribute("title", d), t.setAttribute("aria-label", d);
                    } else {
                      (0, u.removeClass)(p, o.options.classPrefix + "unmute"), (0, u.addClass)(p, o.options.classPrefix + "mute");
                      var n = p.firstElementChild;
                      n.setAttribute("title", h), n.setAttribute("aria-label", h);
                    }

                    var i = 100 * e + "%",
                        r = getComputedStyle(w);
                    "vertical" === c ? (b.style.bottom = 0, b.style.height = i, w.style.bottom = i, w.style.marginBottom = -parseFloat(r.height) / 2 + "px") : (b.style.left = 0, b.style.width = i, w.style.left = i, w.style.marginLeft = -parseFloat(r.width) / 2 + "px");
                  }
                },
                    T = function T(e) {
                  var t = (0, u.offset)(_),
                      n = getComputedStyle(_);
                  y = !0;
                  var i = null;

                  if ("vertical" === c) {
                    var r = parseFloat(n.height);
                    if (i = (r - (e.pageY - t.top)) / r, 0 === t.top || 0 === t.left) return;
                  } else {
                    var a = parseFloat(n.width);
                    i = (e.pageX - t.left) / a;
                  }

                  i = Math.max(0, i), i = Math.min(i, 1), S(i), o.setMuted(0 === i), o.setVolume(i), e.preventDefault(), e.stopPropagation();
                },
                    C = function C() {
                  o.muted ? (S(0), (0, u.removeClass)(p, o.options.classPrefix + "mute"), (0, u.addClass)(p, o.options.classPrefix + "unmute")) : (S(r.volume), (0, u.removeClass)(p, o.options.classPrefix + "unmute"), (0, u.addClass)(p, o.options.classPrefix + "mute"));
                };

                e.getElement(e.container).addEventListener("keydown", function (e) {
                  !!e.target.closest("." + o.options.classPrefix + "container") || "vertical" !== c || (x.style.display = "none");
                }), p.addEventListener("mouseenter", function (e) {
                  e.target === p && (x.style.display = "block", m = !0, e.preventDefault(), e.stopPropagation());
                }), p.addEventListener("focusin", function () {
                  x.style.display = "block", m = !0;
                }), p.addEventListener("focusout", function (e) {
                  e.relatedTarget && (!e.relatedTarget || e.relatedTarget.matches("." + o.options.classPrefix + "volume-slider")) || "vertical" !== c || (x.style.display = "none");
                }), p.addEventListener("mouseleave", function () {
                  m = !1, v || "vertical" !== c || (x.style.display = "none");
                }), p.addEventListener("focusout", function () {
                  m = !1;
                }), p.addEventListener("keydown", function (e) {
                  if (o.options.enableKeyboard && o.options.keyActions.length) {
                    var t = e.which || e.keyCode || 0,
                        n = r.volume;

                    switch (t) {
                      case 38:
                        n = Math.min(n + .1, 1);
                        break;

                      case 40:
                        n = Math.max(0, n - .1);
                        break;

                      default:
                        return !0;
                    }

                    v = !1, S(n), r.setVolume(n), e.preventDefault(), e.stopPropagation();
                  }
                }), p.querySelector("button").addEventListener("click", function () {
                  r.setMuted(!r.muted);
                  var e = (0, l.createEvent)("volumechange", r);
                  r.dispatchEvent(e);
                }), x.addEventListener("dragstart", function () {
                  return !1;
                }), x.addEventListener("mouseover", function () {
                  m = !0;
                }), x.addEventListener("focusin", function () {
                  x.style.display = "block", m = !0;
                }), x.addEventListener("focusout", function () {
                  m = !1, v || "vertical" !== c || (x.style.display = "none");
                }), x.addEventListener("mousedown", function (e) {
                  T(e), o.globalBind("mousemove.vol", function (e) {
                    var t = e.target;
                    v && (t === x || t.closest("vertical" === c ? "." + o.options.classPrefix + "volume-slider" : "." + o.options.classPrefix + "horizontal-volume-slider")) && T(e);
                  }), o.globalBind("mouseup.vol", function () {
                    v = !1, m || "vertical" !== c || (x.style.display = "none");
                  }), v = !0, e.preventDefault(), e.stopPropagation();
                }), r.addEventListener("volumechange", function (e) {
                  var t;
                  v || C(), t = Math.floor(100 * r.volume), x.setAttribute("aria-valuenow", t), x.setAttribute("aria-valuetext", t + "%");
                });
                var k = !1;
                r.addEventListener("rendererready", function () {
                  y || setTimeout(function () {
                    k = !0, (0 === e.options.startVolume || r.originalNode.muted) && (r.setMuted(!0), e.options.startVolume = 0), r.setVolume(e.options.startVolume), o.setControlsSize();
                  }, 250);
                }), r.addEventListener("loadedmetadata", function () {
                  setTimeout(function () {
                    y || k || ((0 === e.options.startVolume || r.originalNode.muted) && r.setMuted(!0), r.setVolume(e.options.startVolume), o.setControlsSize()), k = !1;
                  }, 250);
                }), (0 === e.options.startVolume || r.originalNode.muted) && (r.setMuted(!0), e.options.startVolume = 0, C()), o.getElement(o.container).addEventListener("controlsresize", function () {
                  C();
                });
              }
            }
          });
        }, {
          16: 16,
          2: 2,
          25: 25,
          26: 26,
          27: 27,
          5: 5
        }],
        15: [function (e, t, n) {
          "use strict";

          Object.defineProperty(n, "__esModule", {
            value: !0
          });
          n.EN = {
            "mejs.plural-form": 1,
            "mejs.download-file": "Download File",
            "mejs.install-flash": "You are using a browser that does not have Flash player enabled or installed. Please turn on your Flash player plugin or download the latest version from https://get.adobe.com/flashplayer/",
            "mejs.fullscreen": "Fullscreen",
            "mejs.play": "Play",
            "mejs.pause": "Pause",
            "mejs.time-slider": "Time Slider",
            "mejs.time-help-text": "Use Left/Right Arrow keys to advance one second, Up/Down arrows to advance ten seconds.",
            "mejs.live-broadcast": "Live Broadcast",
            "mejs.volume-help-text": "Use Up/Down Arrow keys to increase or decrease volume.",
            "mejs.unmute": "Unmute",
            "mejs.mute": "Mute",
            "mejs.volume-slider": "Volume Slider",
            "mejs.video-player": "Video Player",
            "mejs.audio-player": "Audio Player",
            "mejs.captions-subtitles": "Captions/Subtitles",
            "mejs.captions-chapters": "Chapters",
            "mejs.none": "None",
            "mejs.afrikaans": "Afrikaans",
            "mejs.albanian": "Albanian",
            "mejs.arabic": "Arabic",
            "mejs.belarusian": "Belarusian",
            "mejs.bulgarian": "Bulgarian",
            "mejs.catalan": "Catalan",
            "mejs.chinese": "Chinese",
            "mejs.chinese-simplified": "Chinese (Simplified)",
            "mejs.chinese-traditional": "Chinese (Traditional)",
            "mejs.croatian": "Croatian",
            "mejs.czech": "Czech",
            "mejs.danish": "Danish",
            "mejs.dutch": "Dutch",
            "mejs.english": "English",
            "mejs.estonian": "Estonian",
            "mejs.filipino": "Filipino",
            "mejs.finnish": "Finnish",
            "mejs.french": "French",
            "mejs.galician": "Galician",
            "mejs.german": "German",
            "mejs.greek": "Greek",
            "mejs.haitian-creole": "Haitian Creole",
            "mejs.hebrew": "Hebrew",
            "mejs.hindi": "Hindi",
            "mejs.hungarian": "Hungarian",
            "mejs.icelandic": "Icelandic",
            "mejs.indonesian": "Indonesian",
            "mejs.irish": "Irish",
            "mejs.italian": "Italian",
            "mejs.japanese": "Japanese",
            "mejs.korean": "Korean",
            "mejs.latvian": "Latvian",
            "mejs.lithuanian": "Lithuanian",
            "mejs.macedonian": "Macedonian",
            "mejs.malay": "Malay",
            "mejs.maltese": "Maltese",
            "mejs.norwegian": "Norwegian",
            "mejs.persian": "Persian",
            "mejs.polish": "Polish",
            "mejs.portuguese": "Portuguese",
            "mejs.romanian": "Romanian",
            "mejs.russian": "Russian",
            "mejs.serbian": "Serbian",
            "mejs.slovak": "Slovak",
            "mejs.slovenian": "Slovenian",
            "mejs.spanish": "Spanish",
            "mejs.swahili": "Swahili",
            "mejs.swedish": "Swedish",
            "mejs.tagalog": "Tagalog",
            "mejs.thai": "Thai",
            "mejs.turkish": "Turkish",
            "mejs.ukrainian": "Ukrainian",
            "mejs.vietnamese": "Vietnamese",
            "mejs.welsh": "Welsh",
            "mejs.yiddish": "Yiddish"
          };
        }, {}],
        16: [function (e, t, n) {
          "use strict";

          Object.defineProperty(n, "__esModule", {
            value: !0
          }), n.config = void 0;

          var i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
            return typeof e;
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
          },
              r = function () {
            function e(e, t) {
              for (var n = 0; n < t.length; n++) {
                var i = t[n];
                i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
              }
            }

            return function (t, n, i) {
              return n && e(t.prototype, n), i && e(t, i), t;
            };
          }(),
              o = v(e(3)),
              a = v(e(2)),
              s = v(e(7)),
              l = v(e(6)),
              u = v(e(17)),
              c = v(e(5)),
              h = e(25),
              d = e(27),
              f = e(30),
              p = e(28),
              g = function (e) {
            if (e && e.__esModule) return e;
            var t = {};
            if (null != e) for (var n in e) {
              Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }
            return t.default = e, t;
          }(e(26));

          function v(e) {
            return e && e.__esModule ? e : {
              default: e
            };
          }

          s.default.mepIndex = 0, s.default.players = {};
          var m = n.config = {
            poster: "",
            showPosterWhenEnded: !1,
            showPosterWhenPaused: !1,
            defaultVideoWidth: 480,
            defaultVideoHeight: 270,
            videoWidth: -1,
            videoHeight: -1,
            defaultAudioWidth: 400,
            defaultAudioHeight: 40,
            defaultSeekBackwardInterval: function defaultSeekBackwardInterval(e) {
              return .05 * e.getDuration();
            },
            defaultSeekForwardInterval: function defaultSeekForwardInterval(e) {
              return .05 * e.getDuration();
            },
            setDimensions: !0,
            audioWidth: -1,
            audioHeight: -1,
            loop: !1,
            autoRewind: !0,
            enableAutosize: !0,
            timeFormat: "",
            alwaysShowHours: !1,
            showTimecodeFrameCount: !1,
            framesPerSecond: 25,
            alwaysShowControls: !1,
            hideVideoControlsOnLoad: !1,
            hideVideoControlsOnPause: !1,
            clickToPlayPause: !0,
            controlsTimeoutDefault: 1500,
            controlsTimeoutMouseEnter: 2500,
            controlsTimeoutMouseLeave: 1e3,
            iPadUseNativeControls: !1,
            iPhoneUseNativeControls: !1,
            AndroidUseNativeControls: !1,
            features: ["playpause", "current", "progress", "duration", "tracks", "volume", "fullscreen"],
            useDefaultControls: !1,
            isVideo: !0,
            stretching: "auto",
            classPrefix: "mejs__",
            enableKeyboard: !0,
            pauseOtherPlayers: !0,
            secondsDecimalLength: 0,
            customError: null,
            keyActions: [{
              keys: [32, 179],
              action: function action(e) {
                h.IS_FIREFOX || (e.paused || e.ended ? e.play() : e.pause());
              }
            }]
          };
          s.default.MepDefaults = m;

          var y = function () {
            function e(t, n) {
              !function (e, t) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
              }(this, e);
              var i = this,
                  r = "string" == typeof t ? a.default.getElementById(t) : t;
              if (!(i instanceof e)) return new e(r, n);

              if (i.node = i.media = r, i.node) {
                if (i.media.player) return i.media.player;

                if (i.hasFocus = !1, i.controlsAreVisible = !0, i.controlsEnabled = !0, i.controlsTimer = null, i.currentMediaTime = 0, i.proxy = null, void 0 === n) {
                  var o = i.node.getAttribute("data-mejsoptions");
                  n = o ? JSON.parse(o) : {};
                }

                return i.options = Object.assign({}, m, n), i.options.loop && !i.media.getAttribute("loop") ? (i.media.loop = !0, i.node.loop = !0) : i.media.loop && (i.options.loop = !0), i.options.timeFormat || (i.options.timeFormat = "mm:ss", i.options.alwaysShowHours && (i.options.timeFormat = "hh:mm:ss"), i.options.showTimecodeFrameCount && (i.options.timeFormat += ":ff")), (0, f.calculateTimeFormat)(0, i.options, i.options.framesPerSecond || 25), i.id = "mep_" + s.default.mepIndex++, s.default.players[i.id] = i, i.init(), i;
              }
            }

            return r(e, [{
              key: "getElement",
              value: function value(e) {
                return e;
              }
            }, {
              key: "init",
              value: function value() {
                var e = this,
                    t = Object.assign({}, e.options, {
                  success: function success(t, n) {
                    e._meReady(t, n);
                  },
                  error: function error(t) {
                    e._handleError(t);
                  }
                }),
                    n = e.node.tagName.toLowerCase();
                if (e.isDynamic = "audio" !== n && "video" !== n && "iframe" !== n, e.isVideo = (e.isDynamic || "audio" !== n) && e.options.isVideo, e.mediaFiles = null, e.trackFiles = null, h.IS_IPAD && e.options.iPadUseNativeControls || h.IS_IPHONE && e.options.iPhoneUseNativeControls) e.node.setAttribute("controls", !0), h.IS_IPAD && e.node.getAttribute("autoplay") && e.play();else if (!e.isVideo && (e.isVideo || !e.options.features.length && !e.options.useDefaultControls) || h.IS_ANDROID && e.options.AndroidUseNativeControls) e.isVideo || e.options.features.length || e.options.useDefaultControls || (e.node.style.display = "none");else {
                  e.node.removeAttribute("controls");
                  var i = e.isVideo ? c.default.t("mejs.video-player") : c.default.t("mejs.audio-player"),
                      r = a.default.createElement("span");

                  if (r.className = e.options.classPrefix + "offscreen", r.innerText = i, e.media.parentNode.insertBefore(r, e.media), e.container = a.default.createElement("div"), e.getElement(e.container).id = e.id, e.getElement(e.container).className = e.options.classPrefix + "container " + e.options.classPrefix + "container-keyboard-inactive " + e.media.className, e.getElement(e.container).tabIndex = 0, e.getElement(e.container).setAttribute("role", "application"), e.getElement(e.container).setAttribute("aria-label", i), e.getElement(e.container).innerHTML = '<div class="' + e.options.classPrefix + 'inner"><div class="' + e.options.classPrefix + 'mediaelement"></div><div class="' + e.options.classPrefix + 'layers"></div><div class="' + e.options.classPrefix + 'controls"></div></div>', e.getElement(e.container).addEventListener("focus", function (t) {
                    if (!e.controlsAreVisible && !e.hasFocus && e.controlsEnabled) {
                      e.showControls(!0);
                      var n = (0, d.isNodeAfter)(t.relatedTarget, e.getElement(e.container)) ? "." + e.options.classPrefix + "controls ." + e.options.classPrefix + "button:last-child > button" : "." + e.options.classPrefix + "playpause-button > button";
                      e.getElement(e.container).querySelector(n).focus();
                    }
                  }), e.node.parentNode.insertBefore(e.getElement(e.container), e.node), e.options.features.length || e.options.useDefaultControls || (e.getElement(e.container).style.background = "transparent", e.getElement(e.container).querySelector("." + e.options.classPrefix + "controls").style.display = "none"), e.isVideo && "fill" === e.options.stretching && !g.hasClass(e.getElement(e.container).parentNode, e.options.classPrefix + "fill-container")) {
                    e.outerContainer = e.media.parentNode;
                    var o = a.default.createElement("div");
                    o.className = e.options.classPrefix + "fill-container", e.getElement(e.container).parentNode.insertBefore(o, e.getElement(e.container)), o.appendChild(e.getElement(e.container));
                  }

                  h.IS_ANDROID && g.addClass(e.getElement(e.container), e.options.classPrefix + "android"), h.IS_IOS && g.addClass(e.getElement(e.container), e.options.classPrefix + "ios"), h.IS_IPAD && g.addClass(e.getElement(e.container), e.options.classPrefix + "ipad"), h.IS_IPHONE && g.addClass(e.getElement(e.container), e.options.classPrefix + "iphone"), g.addClass(e.getElement(e.container), e.isVideo ? e.options.classPrefix + "video" : e.options.classPrefix + "audio"), e.getElement(e.container).querySelector("." + e.options.classPrefix + "mediaelement").appendChild(e.node), e.media.player = e, e.controls = e.getElement(e.container).querySelector("." + e.options.classPrefix + "controls"), e.layers = e.getElement(e.container).querySelector("." + e.options.classPrefix + "layers");
                  var u = e.isVideo ? "video" : "audio",
                      f = u.substring(0, 1).toUpperCase() + u.substring(1);
                  e.options[u + "Width"] > 0 || e.options[u + "Width"].toString().indexOf("%") > -1 ? e.width = e.options[u + "Width"] : "" !== e.node.style.width && null !== e.node.style.width ? e.width = e.node.style.width : e.node.getAttribute("width") ? e.width = e.node.getAttribute("width") : e.width = e.options["default" + f + "Width"], e.options[u + "Height"] > 0 || e.options[u + "Height"].toString().indexOf("%") > -1 ? e.height = e.options[u + "Height"] : "" !== e.node.style.height && null !== e.node.style.height ? e.height = e.node.style.height : e.node.getAttribute("height") ? e.height = e.node.getAttribute("height") : e.height = e.options["default" + f + "Height"], e.initialAspectRatio = e.height >= e.width ? e.width / e.height : e.height / e.width, e.setPlayerSize(e.width, e.height), t.pluginWidth = e.width, t.pluginHeight = e.height;
                }

                if (s.default.MepDefaults = t, new l.default(e.media, t, e.mediaFiles), void 0 !== e.getElement(e.container) && e.options.features.length && e.controlsAreVisible && !e.options.hideVideoControlsOnLoad) {
                  var p = (0, d.createEvent)("controlsshown", e.getElement(e.container));
                  e.getElement(e.container).dispatchEvent(p);
                }
              }
            }, {
              key: "showControls",
              value: function value(e) {
                var t = this;

                if (e = void 0 === e || e, !t.controlsAreVisible && t.isVideo) {
                  if (e) !function () {
                    g.fadeIn(t.getElement(t.controls), 200, function () {
                      g.removeClass(t.getElement(t.controls), t.options.classPrefix + "offscreen");
                      var e = (0, d.createEvent)("controlsshown", t.getElement(t.container));
                      t.getElement(t.container).dispatchEvent(e);
                    });

                    for (var e = t.getElement(t.container).querySelectorAll("." + t.options.classPrefix + "control"), n = function n(_n3, i) {
                      g.fadeIn(e[_n3], 200, function () {
                        g.removeClass(e[_n3], t.options.classPrefix + "offscreen");
                      });
                    }, i = 0, r = e.length; i < r; i++) {
                      n(i);
                    }
                  }();else {
                    g.removeClass(t.getElement(t.controls), t.options.classPrefix + "offscreen"), t.getElement(t.controls).style.display = "", t.getElement(t.controls).style.opacity = 1;

                    for (var n = t.getElement(t.container).querySelectorAll("." + t.options.classPrefix + "control"), i = 0, r = n.length; i < r; i++) {
                      g.removeClass(n[i], t.options.classPrefix + "offscreen"), n[i].style.display = "";
                    }

                    var o = (0, d.createEvent)("controlsshown", t.getElement(t.container));
                    t.getElement(t.container).dispatchEvent(o);
                  }
                  t.controlsAreVisible = !0, t.setControlsSize();
                }
              }
            }, {
              key: "hideControls",
              value: function value(e, t) {
                var n = this;

                if (e = void 0 === e || e, !0 === t || !(!n.controlsAreVisible || n.options.alwaysShowControls || n.paused && 4 === n.readyState && (!n.options.hideVideoControlsOnLoad && n.currentTime <= 0 || !n.options.hideVideoControlsOnPause && n.currentTime > 0) || n.isVideo && !n.options.hideVideoControlsOnLoad && !n.readyState || n.ended)) {
                  if (e) !function () {
                    g.fadeOut(n.getElement(n.controls), 200, function () {
                      g.addClass(n.getElement(n.controls), n.options.classPrefix + "offscreen"), n.getElement(n.controls).style.display = "";
                      var e = (0, d.createEvent)("controlshidden", n.getElement(n.container));
                      n.getElement(n.container).dispatchEvent(e);
                    });

                    for (var e = n.getElement(n.container).querySelectorAll("." + n.options.classPrefix + "control"), t = function t(_t7, i) {
                      g.fadeOut(e[_t7], 200, function () {
                        g.addClass(e[_t7], n.options.classPrefix + "offscreen"), e[_t7].style.display = "";
                      });
                    }, i = 0, r = e.length; i < r; i++) {
                      t(i);
                    }
                  }();else {
                    g.addClass(n.getElement(n.controls), n.options.classPrefix + "offscreen"), n.getElement(n.controls).style.display = "", n.getElement(n.controls).style.opacity = 0;

                    for (var i = n.getElement(n.container).querySelectorAll("." + n.options.classPrefix + "control"), r = 0, o = i.length; r < o; r++) {
                      g.addClass(i[r], n.options.classPrefix + "offscreen"), i[r].style.display = "";
                    }

                    var a = (0, d.createEvent)("controlshidden", n.getElement(n.container));
                    n.getElement(n.container).dispatchEvent(a);
                  }
                  n.controlsAreVisible = !1;
                }
              }
            }, {
              key: "startControlsTimer",
              value: function value(e) {
                var t = this;
                e = void 0 !== e ? e : t.options.controlsTimeoutDefault, t.killControlsTimer("start"), t.controlsTimer = setTimeout(function () {
                  t.hideControls(), t.killControlsTimer("hide");
                }, e);
              }
            }, {
              key: "killControlsTimer",
              value: function value() {
                var e = this;
                null !== e.controlsTimer && (clearTimeout(e.controlsTimer), delete e.controlsTimer, e.controlsTimer = null);
              }
            }, {
              key: "disableControls",
              value: function value() {
                var e = this;
                e.killControlsTimer(), e.controlsEnabled = !1, e.hideControls(!1, !0);
              }
            }, {
              key: "enableControls",
              value: function value() {
                this.controlsEnabled = !0, this.showControls(!1);
              }
            }, {
              key: "_setDefaultPlayer",
              value: function value() {
                var e = this;
                e.proxy && e.proxy.pause(), e.proxy = new u.default(e), e.media.addEventListener("loadedmetadata", function () {
                  e.getCurrentTime() > 0 && e.currentMediaTime > 0 && (e.setCurrentTime(e.currentMediaTime), h.IS_IOS || h.IS_ANDROID || e.play());
                });
              }
            }, {
              key: "_meReady",
              value: function value(e, t) {
                var n = this,
                    i = t.getAttribute("autoplay"),
                    r = !(null == i || "false" === i),
                    l = null !== e.rendererName && /(native|html5)/i.test(n.media.rendererName);

                if (n.getElement(n.controls) && n.enableControls(), n.getElement(n.container) && n.getElement(n.container).querySelector("." + n.options.classPrefix + "overlay-play") && (n.getElement(n.container).querySelector("." + n.options.classPrefix + "overlay-play").style.display = ""), !n.created) {
                  if (n.created = !0, n.media = e, n.domNode = t, !(h.IS_ANDROID && n.options.AndroidUseNativeControls || h.IS_IPAD && n.options.iPadUseNativeControls || h.IS_IPHONE && n.options.iPhoneUseNativeControls)) {
                    if (!n.isVideo && !n.options.features.length && !n.options.useDefaultControls) return r && l && n.play(), void (n.options.success && ("string" == typeof n.options.success ? o.default[n.options.success](n.media, n.domNode, n) : n.options.success(n.media, n.domNode, n)));

                    if (n.featurePosition = {}, n._setDefaultPlayer(), n.buildposter(n, n.getElement(n.controls), n.getElement(n.layers), n.media), n.buildkeyboard(n, n.getElement(n.controls), n.getElement(n.layers), n.media), n.buildoverlays(n, n.getElement(n.controls), n.getElement(n.layers), n.media), n.options.useDefaultControls) {
                      var u = ["playpause", "current", "progress", "duration", "tracks", "volume", "fullscreen"];
                      n.options.features = u.concat(n.options.features.filter(function (e) {
                        return -1 === u.indexOf(e);
                      }));
                    }

                    n.buildfeatures(n, n.getElement(n.controls), n.getElement(n.layers), n.media);
                    var c = (0, d.createEvent)("controlsready", n.getElement(n.container));
                    n.getElement(n.container).dispatchEvent(c), n.setPlayerSize(n.width, n.height), n.setControlsSize(), n.isVideo && (n.clickToPlayPauseCallback = function () {
                      if (n.options.clickToPlayPause) {
                        var e = n.getElement(n.container).querySelector("." + n.options.classPrefix + "overlay-button"),
                            t = e.getAttribute("aria-pressed");
                        n.paused && t ? n.pause() : n.paused ? n.play() : n.pause(), e.setAttribute("aria-pressed", !t), n.getElement(n.container).focus();
                      }
                    }, n.createIframeLayer(), n.media.addEventListener("click", n.clickToPlayPauseCallback), !h.IS_ANDROID && !h.IS_IOS || n.options.alwaysShowControls ? (n.getElement(n.container).addEventListener("mouseenter", function () {
                      n.controlsEnabled && (n.options.alwaysShowControls || (n.killControlsTimer("enter"), n.showControls(), n.startControlsTimer(n.options.controlsTimeoutMouseEnter)));
                    }), n.getElement(n.container).addEventListener("mousemove", function () {
                      n.controlsEnabled && (n.controlsAreVisible || n.showControls(), n.options.alwaysShowControls || n.startControlsTimer(n.options.controlsTimeoutMouseEnter));
                    }), n.getElement(n.container).addEventListener("mouseleave", function () {
                      n.controlsEnabled && (n.paused || n.options.alwaysShowControls || n.startControlsTimer(n.options.controlsTimeoutMouseLeave));
                    })) : n.node.addEventListener("touchstart", function () {
                      n.controlsAreVisible ? n.hideControls(!1) : n.controlsEnabled && n.showControls(!1);
                    }, !!h.SUPPORT_PASSIVE_EVENT && {
                      passive: !0
                    }), n.options.hideVideoControlsOnLoad && n.hideControls(!1), n.options.enableAutosize && n.media.addEventListener("loadedmetadata", function (e) {
                      var t = void 0 !== e ? e.detail.target || e.target : n.media;
                      n.options.videoHeight <= 0 && !n.domNode.getAttribute("height") && !n.domNode.style.height && null !== t && !isNaN(t.videoHeight) && (n.setPlayerSize(t.videoWidth, t.videoHeight), n.setControlsSize(), n.media.setSize(t.videoWidth, t.videoHeight));
                    })), n.media.addEventListener("play", function () {
                      for (var e in n.hasFocus = !0, s.default.players) {
                        if (s.default.players.hasOwnProperty(e)) {
                          var t = s.default.players[e];
                          t.id === n.id || !n.options.pauseOtherPlayers || t.paused || t.ended || !0 === t.options.ignorePauseOtherPlayersOption || (t.pause(), t.hasFocus = !1);
                        }
                      }

                      h.IS_ANDROID || h.IS_IOS || n.options.alwaysShowControls || !n.isVideo || n.hideControls();
                    }), n.media.addEventListener("ended", function () {
                      if (n.options.autoRewind) try {
                        n.setCurrentTime(0), setTimeout(function () {
                          var e = n.getElement(n.container).querySelector("." + n.options.classPrefix + "overlay-loading");
                          e && e.parentNode && (e.parentNode.style.display = "none");
                        }, 20);
                      } catch (e) {}
                      "function" == typeof n.media.renderer.stop ? n.media.renderer.stop() : n.pause(), n.setProgressRail && n.setProgressRail(), n.setCurrentRail && n.setCurrentRail(), n.options.loop ? n.play() : !n.options.alwaysShowControls && n.controlsEnabled && n.showControls();
                    }), n.media.addEventListener("loadedmetadata", function () {
                      (0, f.calculateTimeFormat)(n.getDuration(), n.options, n.options.framesPerSecond || 25), n.updateDuration && n.updateDuration(), n.updateCurrent && n.updateCurrent(), n.isFullScreen || (n.setPlayerSize(n.width, n.height), n.setControlsSize());
                    });
                    var p = null;
                    n.media.addEventListener("timeupdate", function () {
                      isNaN(n.getDuration()) || p === n.getDuration() || (p = n.getDuration(), (0, f.calculateTimeFormat)(p, n.options, n.options.framesPerSecond || 25), n.updateDuration && n.updateDuration(), n.updateCurrent && n.updateCurrent(), n.setControlsSize());
                    }), n.getElement(n.container).addEventListener("click", function (e) {
                      g.addClass(e.currentTarget, n.options.classPrefix + "container-keyboard-inactive");
                    }), n.getElement(n.container).addEventListener("focusin", function (e) {
                      g.removeClass(e.currentTarget, n.options.classPrefix + "container-keyboard-inactive"), !n.isVideo || h.IS_ANDROID || h.IS_IOS || !n.controlsEnabled || n.options.alwaysShowControls || (n.killControlsTimer("enter"), n.showControls(), n.startControlsTimer(n.options.controlsTimeoutMouseEnter));
                    }), n.getElement(n.container).addEventListener("focusout", function (e) {
                      setTimeout(function () {
                        e.relatedTarget && n.keyboardAction && !e.relatedTarget.closest("." + n.options.classPrefix + "container") && (n.keyboardAction = !1, !n.isVideo || n.options.alwaysShowControls || n.paused || n.startControlsTimer(n.options.controlsTimeoutMouseLeave));
                      }, 0);
                    }), setTimeout(function () {
                      n.setPlayerSize(n.width, n.height), n.setControlsSize();
                    }, 0), n.globalResizeCallback = function () {
                      n.isFullScreen || h.HAS_TRUE_NATIVE_FULLSCREEN && a.default.webkitIsFullScreen || n.setPlayerSize(n.width, n.height), n.setControlsSize();
                    }, n.globalBind("resize", n.globalResizeCallback);
                  }

                  r && l && n.play(), n.options.success && ("string" == typeof n.options.success ? o.default[n.options.success](n.media, n.domNode, n) : n.options.success(n.media, n.domNode, n));
                }
              }
            }, {
              key: "_handleError",
              value: function value(e, t, n) {
                var i = this,
                    r = i.getElement(i.layers).querySelector("." + i.options.classPrefix + "overlay-play");
                r && (r.style.display = "none"), i.options.error && i.options.error(e, t, n), i.getElement(i.container).querySelector("." + i.options.classPrefix + "cannotplay") && i.getElement(i.container).querySelector("." + i.options.classPrefix + "cannotplay").remove();
                var o = a.default.createElement("div");
                o.className = i.options.classPrefix + "cannotplay", o.style.width = "100%", o.style.height = "100%";
                var l = "function" == typeof i.options.customError ? i.options.customError(i.media, i.media.originalNode) : i.options.customError,
                    u = "";

                if (!l) {
                  var c = i.media.originalNode.getAttribute("poster");
                  if (c && (u = '<img src="' + c + '" alt="' + s.default.i18n.t("mejs.download-file") + '">'), e.message && (l = "<p>" + e.message + "</p>"), e.urls) for (var h = 0, d = e.urls.length; h < d; h++) {
                    var f = e.urls[h];
                    l += '<a href="' + f.src + '" data-type="' + f.type + '"><span>' + s.default.i18n.t("mejs.download-file") + ": " + f.src + "</span></a>";
                  }
                }

                l && i.getElement(i.layers).querySelector("." + i.options.classPrefix + "overlay-error") && (o.innerHTML = l, i.getElement(i.layers).querySelector("." + i.options.classPrefix + "overlay-error").innerHTML = "" + u + o.outerHTML, i.getElement(i.layers).querySelector("." + i.options.classPrefix + "overlay-error").parentNode.style.display = "block"), i.controlsEnabled && i.disableControls();
              }
            }, {
              key: "setPlayerSize",
              value: function value(e, t) {
                var n = this;
                if (!n.options.setDimensions) return !1;

                switch (void 0 !== e && (n.width = e), void 0 !== t && (n.height = t), n.options.stretching) {
                  case "fill":
                    n.isVideo ? n.setFillMode() : n.setDimensions(n.width, n.height);
                    break;

                  case "responsive":
                    n.setResponsiveMode();
                    break;

                  case "none":
                    n.setDimensions(n.width, n.height);
                    break;

                  default:
                    !0 === n.hasFluidMode() ? n.setResponsiveMode() : n.setDimensions(n.width, n.height);
                }
              }
            }, {
              key: "hasFluidMode",
              value: function value() {
                var e = this;
                return -1 !== e.height.toString().indexOf("%") || e.node && e.node.style.maxWidth && "none" !== e.node.style.maxWidth && e.node.style.maxWidth !== e.width || e.node && e.node.currentStyle && "100%" === e.node.currentStyle.maxWidth;
              }
            }, {
              key: "setResponsiveMode",
              value: function value() {
                var e,
                    t = this,
                    n = function () {
                  for (var e = void 0, n = t.getElement(t.container); n;) {
                    try {
                      if (h.IS_FIREFOX && "html" === n.tagName.toLowerCase() && o.default.self !== o.default.top && null !== o.default.frameElement) return o.default.frameElement;
                      e = n.parentElement;
                    } catch (t) {
                      e = n.parentElement;
                    }

                    if (e && g.visible(e)) return e;
                    n = e;
                  }

                  return null;
                }(),
                    i = n ? getComputedStyle(n, null) : getComputedStyle(a.default.body, null),
                    r = t.isVideo ? t.node.videoWidth && t.node.videoWidth > 0 ? t.node.videoWidth : t.node.getAttribute("width") ? t.node.getAttribute("width") : t.options.defaultVideoWidth : t.options.defaultAudioWidth,
                    s = t.isVideo ? t.node.videoHeight && t.node.videoHeight > 0 ? t.node.videoHeight : t.node.getAttribute("height") ? t.node.getAttribute("height") : t.options.defaultVideoHeight : t.options.defaultAudioHeight,
                    l = (e = 1, t.isVideo ? (e = t.node.videoWidth && t.node.videoWidth > 0 && t.node.videoHeight && t.node.videoHeight > 0 ? t.height >= t.width ? t.node.videoWidth / t.node.videoHeight : t.node.videoHeight / t.node.videoWidth : t.initialAspectRatio, (isNaN(e) || e < .01 || e > 100) && (e = 1), e) : e),
                    u = parseFloat(i.height),
                    c = void 0,
                    d = parseFloat(i.width);

                if (c = t.isVideo ? "100%" === t.height ? parseFloat(d * s / r, 10) : t.height >= t.width ? parseFloat(d / l, 10) : parseFloat(d * l, 10) : s, isNaN(c) && (c = u), t.getElement(t.container).parentNode.length > 0 && "body" === t.getElement(t.container).parentNode.tagName.toLowerCase() && (d = o.default.innerWidth || a.default.documentElement.clientWidth || a.default.body.clientWidth, c = o.default.innerHeight || a.default.documentElement.clientHeight || a.default.body.clientHeight), c && d) {
                  t.getElement(t.container).style.width = d + "px", t.getElement(t.container).style.height = c + "px", t.node.style.width = "100%", t.node.style.height = "100%", t.isVideo && t.media.setSize && t.media.setSize(d, c);

                  for (var f = t.getElement(t.layers).children, p = 0, v = f.length; p < v; p++) {
                    f[p].style.width = "100%", f[p].style.height = "100%";
                  }
                }
              }
            }, {
              key: "setFillMode",
              value: function value() {
                var e = this,
                    t = o.default.self !== o.default.top && null !== o.default.frameElement,
                    n = function () {
                  for (var t = void 0, n = e.getElement(e.container); n;) {
                    try {
                      if (h.IS_FIREFOX && "html" === n.tagName.toLowerCase() && o.default.self !== o.default.top && null !== o.default.frameElement) return o.default.frameElement;
                      t = n.parentElement;
                    } catch (e) {
                      t = n.parentElement;
                    }

                    if (t && g.visible(t)) return t;
                    n = t;
                  }

                  return null;
                }(),
                    i = n ? getComputedStyle(n, null) : getComputedStyle(a.default.body, null);

                "none" !== e.node.style.height && e.node.style.height !== e.height && (e.node.style.height = "auto"), "none" !== e.node.style.maxWidth && e.node.style.maxWidth !== e.width && (e.node.style.maxWidth = "none"), "none" !== e.node.style.maxHeight && e.node.style.maxHeight !== e.height && (e.node.style.maxHeight = "none"), e.node.currentStyle && ("100%" === e.node.currentStyle.height && (e.node.currentStyle.height = "auto"), "100%" === e.node.currentStyle.maxWidth && (e.node.currentStyle.maxWidth = "none"), "100%" === e.node.currentStyle.maxHeight && (e.node.currentStyle.maxHeight = "none")), t || parseFloat(i.width) || (n.style.width = e.media.offsetWidth + "px"), t || parseFloat(i.height) || (n.style.height = e.media.offsetHeight + "px"), i = getComputedStyle(n);
                var r = parseFloat(i.width),
                    s = parseFloat(i.height);
                e.setDimensions("100%", "100%");
                var l = e.getElement(e.container).querySelector("." + e.options.classPrefix + "poster>img");
                l && (l.style.display = "");

                for (var u = e.getElement(e.container).querySelectorAll("object, embed, iframe, video"), c = e.height, d = e.width, f = r, p = c * r / d, v = d * s / c, m = s, y = v > r == !1, x = y ? Math.floor(f) : Math.floor(v), _ = y ? Math.floor(p) : Math.floor(m), b = y ? r + "px" : x + "px", w = y ? _ + "px" : s + "px", S = 0, T = u.length; S < T; S++) {
                  u[S].style.height = w, u[S].style.width = b, e.media.setSize && e.media.setSize(b, w), u[S].style.marginLeft = Math.floor((r - x) / 2) + "px", u[S].style.marginTop = 0;
                }
              }
            }, {
              key: "setDimensions",
              value: function value(e, t) {
                var n = this;
                e = (0, d.isString)(e) && e.indexOf("%") > -1 ? e : parseFloat(e) + "px", t = (0, d.isString)(t) && t.indexOf("%") > -1 ? t : parseFloat(t) + "px", n.getElement(n.container).style.width = e, n.getElement(n.container).style.height = t;

                for (var i = n.getElement(n.layers).children, r = 0, o = i.length; r < o; r++) {
                  i[r].style.width = e, i[r].style.height = t;
                }
              }
            }, {
              key: "setControlsSize",
              value: function value() {
                var e = this;
                if (g.visible(e.getElement(e.container))) if (e.rail && g.visible(e.rail)) {
                  for (var t = e.total ? getComputedStyle(e.total, null) : null, n = t ? parseFloat(t.marginLeft) + parseFloat(t.marginRight) : 0, i = getComputedStyle(e.rail), r = parseFloat(i.marginLeft) + parseFloat(i.marginRight), o = 0, a = g.siblings(e.rail, function (t) {
                    return t !== e.rail;
                  }), s = a.length, l = 0; l < s; l++) {
                    o += a[l].offsetWidth;
                  }

                  o += n + (0 === n ? 2 * r : r) + 1, e.getElement(e.container).style.minWidth = o + "px";
                  var u = (0, d.createEvent)("controlsresize", e.getElement(e.container));
                  e.getElement(e.container).dispatchEvent(u);
                } else {
                  for (var c = e.getElement(e.controls).children, h = 0, f = 0, p = c.length; f < p; f++) {
                    h += c[f].offsetWidth;
                  }

                  e.getElement(e.container).style.minWidth = h + "px";
                }
              }
            }, {
              key: "addControlElement",
              value: function value(e, t) {
                var n = this;

                if (void 0 !== n.featurePosition[t]) {
                  var i = n.getElement(n.controls).children[n.featurePosition[t] - 1];
                  i.parentNode.insertBefore(e, i.nextSibling);
                } else {
                  n.getElement(n.controls).appendChild(e);

                  for (var r = n.getElement(n.controls).children, o = 0, a = r.length; o < a; o++) {
                    if (e === r[o]) {
                      n.featurePosition[t] = o;
                      break;
                    }
                  }
                }
              }
            }, {
              key: "createIframeLayer",
              value: function value() {
                var e = this;

                if (e.isVideo && null !== e.media.rendererName && e.media.rendererName.indexOf("iframe") > -1 && !a.default.getElementById(e.media.id + "-iframe-overlay")) {
                  var t = a.default.createElement("div"),
                      n = a.default.getElementById(e.media.id + "_" + e.media.rendererName);
                  t.id = e.media.id + "-iframe-overlay", t.className = e.options.classPrefix + "iframe-overlay", t.addEventListener("click", function (t) {
                    e.options.clickToPlayPause && (e.paused ? e.play() : e.pause(), t.preventDefault(), t.stopPropagation());
                  }), n.parentNode.insertBefore(t, n);
                }
              }
            }, {
              key: "resetSize",
              value: function value() {
                var e = this;
                setTimeout(function () {
                  e.setPlayerSize(e.width, e.height), e.setControlsSize();
                }, 50);
              }
            }, {
              key: "setPoster",
              value: function value(e) {
                var t = this;

                if (t.getElement(t.container)) {
                  var n = t.getElement(t.container).querySelector("." + t.options.classPrefix + "poster");
                  n || ((n = a.default.createElement("div")).className = t.options.classPrefix + "poster " + t.options.classPrefix + "layer", t.getElement(t.layers).appendChild(n));
                  var i = n.querySelector("img");
                  !i && e && ((i = a.default.createElement("img")).className = t.options.classPrefix + "poster-img", i.width = "100%", i.height = "100%", n.style.display = "", n.appendChild(i)), e ? (i.setAttribute("src", e), n.style.backgroundImage = 'url("' + e + '")', n.style.display = "") : i ? (n.style.backgroundImage = "none", n.style.display = "none", i.remove()) : n.style.display = "none";
                } else (h.IS_IPAD && t.options.iPadUseNativeControls || h.IS_IPHONE && t.options.iPhoneUseNativeControls || h.IS_ANDROID && t.options.AndroidUseNativeControls) && (t.media.originalNode.poster = e);
              }
            }, {
              key: "changeSkin",
              value: function value(e) {
                var t = this;
                t.getElement(t.container).className = t.options.classPrefix + "container " + e, t.setPlayerSize(t.width, t.height), t.setControlsSize();
              }
            }, {
              key: "globalBind",
              value: function value(e, t) {
                var n = this,
                    i = n.node ? n.node.ownerDocument : a.default;
                if ((e = (0, d.splitEvents)(e, n.id)).d) for (var r = e.d.split(" "), s = 0, l = r.length; s < l; s++) {
                  r[s].split(".").reduce(function (e, n) {
                    return i.addEventListener(n, t, !1), n;
                  }, "");
                }
                if (e.w) for (var u = e.w.split(" "), c = 0, h = u.length; c < h; c++) {
                  u[c].split(".").reduce(function (e, n) {
                    return o.default.addEventListener(n, t, !1), n;
                  }, "");
                }
              }
            }, {
              key: "globalUnbind",
              value: function value(e, t) {
                var n = this,
                    i = n.node ? n.node.ownerDocument : a.default;
                if ((e = (0, d.splitEvents)(e, n.id)).d) for (var r = e.d.split(" "), s = 0, l = r.length; s < l; s++) {
                  r[s].split(".").reduce(function (e, n) {
                    return i.removeEventListener(n, t, !1), n;
                  }, "");
                }
                if (e.w) for (var u = e.w.split(" "), c = 0, h = u.length; c < h; c++) {
                  u[c].split(".").reduce(function (e, n) {
                    return o.default.removeEventListener(n, t, !1), n;
                  }, "");
                }
              }
            }, {
              key: "buildfeatures",
              value: function value(e, t, n, i) {
                for (var r = this, o = 0, a = r.options.features.length; o < a; o++) {
                  var s = r.options.features[o];
                  if (r["build" + s]) try {
                    r["build" + s](e, t, n, i);
                  } catch (e) {
                    console.error("error building " + s, e);
                  }
                }
              }
            }, {
              key: "buildposter",
              value: function value(e, t, n, i) {
                var r = this,
                    o = a.default.createElement("div");
                o.className = r.options.classPrefix + "poster " + r.options.classPrefix + "layer", n.appendChild(o);
                var s = i.originalNode.getAttribute("poster");
                "" !== e.options.poster && (s && h.IS_IOS && i.originalNode.removeAttribute("poster"), s = e.options.poster), s ? r.setPoster(s) : null !== r.media.renderer && "function" == typeof r.media.renderer.getPosterUrl ? r.setPoster(r.media.renderer.getPosterUrl()) : o.style.display = "none", i.addEventListener("play", function () {
                  o.style.display = "none";
                }), i.addEventListener("playing", function () {
                  o.style.display = "none";
                }), e.options.showPosterWhenEnded && e.options.autoRewind && i.addEventListener("ended", function () {
                  o.style.display = "";
                }), i.addEventListener("error", function () {
                  o.style.display = "none";
                }), e.options.showPosterWhenPaused && i.addEventListener("pause", function () {
                  e.ended || (o.style.display = "");
                });
              }
            }, {
              key: "buildoverlays",
              value: function value(e, t, n, i) {
                if (e.isVideo) {
                  var r = this,
                      o = a.default.createElement("div"),
                      s = a.default.createElement("div"),
                      l = a.default.createElement("div");
                  o.style.display = "none", o.className = r.options.classPrefix + "overlay " + r.options.classPrefix + "layer", o.innerHTML = '<div class="' + r.options.classPrefix + 'overlay-loading"><span class="' + r.options.classPrefix + 'overlay-loading-bg-img"></span></div>', n.appendChild(o), s.style.display = "none", s.className = r.options.classPrefix + "overlay " + r.options.classPrefix + "layer", s.innerHTML = '<div class="' + r.options.classPrefix + 'overlay-error"></div>', n.appendChild(s), l.className = r.options.classPrefix + "overlay " + r.options.classPrefix + "layer " + r.options.classPrefix + "overlay-play", l.innerHTML = '<div class="' + r.options.classPrefix + 'overlay-button" role="button" tabindex="0" aria-label="' + c.default.t("mejs.play") + '" aria-pressed="false"></div>', l.addEventListener("click", function () {
                    if (r.options.clickToPlayPause) {
                      var e = r.getElement(r.container).querySelector("." + r.options.classPrefix + "overlay-button"),
                          t = e.getAttribute("aria-pressed");
                      r.paused ? r.play() : r.pause(), e.setAttribute("aria-pressed", !!t), r.getElement(r.container).focus();
                    }
                  }), l.addEventListener("keydown", function (e) {
                    var t = e.keyCode || e.which || 0;

                    if (13 === t || h.IS_FIREFOX && 32 === t) {
                      var n = (0, d.createEvent)("click", l);
                      return l.dispatchEvent(n), !1;
                    }
                  }), n.appendChild(l), null !== r.media.rendererName && (/(youtube|facebook)/i.test(r.media.rendererName) && !(r.media.originalNode.getAttribute("poster") || e.options.poster || "function" == typeof r.media.renderer.getPosterUrl && r.media.renderer.getPosterUrl()) || h.IS_STOCK_ANDROID || r.media.originalNode.getAttribute("autoplay")) && (l.style.display = "none");
                  var u = !1;
                  i.addEventListener("play", function () {
                    l.style.display = "none", o.style.display = "none", s.style.display = "none", u = !1;
                  }), i.addEventListener("playing", function () {
                    l.style.display = "none", o.style.display = "none", s.style.display = "none", u = !1;
                  }), i.addEventListener("seeking", function () {
                    l.style.display = "none", o.style.display = "", u = !1;
                  }), i.addEventListener("seeked", function () {
                    l.style.display = r.paused && !h.IS_STOCK_ANDROID ? "" : "none", o.style.display = "none", u = !1;
                  }), i.addEventListener("pause", function () {
                    o.style.display = "none", h.IS_STOCK_ANDROID || u || (l.style.display = ""), u = !1;
                  }), i.addEventListener("waiting", function () {
                    o.style.display = "", u = !1;
                  }), i.addEventListener("loadeddata", function () {
                    o.style.display = "", h.IS_ANDROID && (i.canplayTimeout = setTimeout(function () {
                      if (a.default.createEvent) {
                        var e = a.default.createEvent("HTMLEvents");
                        return e.initEvent("canplay", !0, !0), i.dispatchEvent(e);
                      }
                    }, 300)), u = !1;
                  }), i.addEventListener("canplay", function () {
                    o.style.display = "none", clearTimeout(i.canplayTimeout), u = !1;
                  }), i.addEventListener("error", function (e) {
                    r._handleError(e, r.media, r.node), o.style.display = "none", l.style.display = "none", u = !0;
                  }), i.addEventListener("loadedmetadata", function () {
                    r.controlsEnabled || r.enableControls();
                  }), i.addEventListener("keydown", function (t) {
                    r.onkeydown(e, i, t), u = !1;
                  });
                }
              }
            }, {
              key: "buildkeyboard",
              value: function value(e, t, n, i) {
                var r = this;
                r.getElement(r.container).addEventListener("keydown", function () {
                  r.keyboardAction = !0;
                }), r.globalKeydownCallback = function (t) {
                  var n = a.default.activeElement.closest("." + r.options.classPrefix + "container"),
                      o = r.media.closest("." + r.options.classPrefix + "container");
                  return r.hasFocus = !(!n || !o || n.id !== o.id), r.onkeydown(e, i, t);
                }, r.globalClickCallback = function (e) {
                  r.hasFocus = !!e.target.closest("." + r.options.classPrefix + "container");
                }, r.globalBind("keydown", r.globalKeydownCallback), r.globalBind("click", r.globalClickCallback);
              }
            }, {
              key: "onkeydown",
              value: function value(e, t, n) {
                if (e.hasFocus && e.options.enableKeyboard) for (var i = 0, r = e.options.keyActions.length; i < r; i++) {
                  for (var o = e.options.keyActions[i], a = 0, s = o.keys.length; a < s; a++) {
                    if (n.keyCode === o.keys[a]) return o.action(e, t, n.keyCode, n), n.preventDefault(), void n.stopPropagation();
                  }
                }
                return !0;
              }
            }, {
              key: "play",
              value: function value() {
                this.proxy.play();
              }
            }, {
              key: "pause",
              value: function value() {
                this.proxy.pause();
              }
            }, {
              key: "load",
              value: function value() {
                this.proxy.load();
              }
            }, {
              key: "setCurrentTime",
              value: function value(e) {
                this.proxy.setCurrentTime(e);
              }
            }, {
              key: "getCurrentTime",
              value: function value() {
                return this.proxy.currentTime;
              }
            }, {
              key: "getDuration",
              value: function value() {
                return this.proxy.duration;
              }
            }, {
              key: "setVolume",
              value: function value(e) {
                this.proxy.volume = e;
              }
            }, {
              key: "getVolume",
              value: function value() {
                return this.proxy.getVolume();
              }
            }, {
              key: "setMuted",
              value: function value(e) {
                this.proxy.setMuted(e);
              }
            }, {
              key: "setSrc",
              value: function value(e) {
                this.controlsEnabled || this.enableControls(), this.proxy.setSrc(e);
              }
            }, {
              key: "getSrc",
              value: function value() {
                return this.proxy.getSrc();
              }
            }, {
              key: "canPlayType",
              value: function value(e) {
                return this.proxy.canPlayType(e);
              }
            }, {
              key: "remove",
              value: function value() {
                var e = this,
                    t = e.media.rendererName,
                    n = e.media.originalNode.src;

                for (var r in e.options.features) {
                  var o = e.options.features[r];
                  if (e["clean" + o]) try {
                    e["clean" + o](e, e.getElement(e.layers), e.getElement(e.controls), e.media);
                  } catch (e) {
                    console.error("error cleaning " + o, e);
                  }
                }

                var l = e.node.getAttribute("width"),
                    u = e.node.getAttribute("height");
                (l ? -1 === l.indexOf("%") && (l += "px") : l = "auto", u ? -1 === u.indexOf("%") && (u += "px") : u = "auto", e.node.style.width = l, e.node.style.height = u, e.setPlayerSize(0, 0), e.isDynamic ? e.getElement(e.container).parentNode.insertBefore(e.node, e.getElement(e.container)) : function () {
                  e.node.setAttribute("controls", !0), e.node.setAttribute("id", e.node.getAttribute("id").replace("_" + t, "").replace("_from_mejs", ""));
                  var i = e.getElement(e.container).querySelector("." + e.options.classPrefix + "poster>img");
                  (i && e.node.setAttribute("poster", i.src), delete e.node.autoplay, e.node.setAttribute("src", ""), "" !== e.media.canPlayType((0, p.getTypeFromFile)(n)) && e.node.setAttribute("src", n), t && t.indexOf("iframe") > -1) && a.default.getElementById(e.media.id + "-iframe-overlay").remove();
                  var r = e.node.cloneNode();
                  if (r.style.display = "", e.getElement(e.container).parentNode.insertBefore(r, e.getElement(e.container)), e.node.remove(), e.mediaFiles) for (var o = 0, s = e.mediaFiles.length; o < s; o++) {
                    var l = a.default.createElement("source");
                    l.setAttribute("src", e.mediaFiles[o].src), l.setAttribute("type", e.mediaFiles[o].type), r.appendChild(l);
                  }
                  if (e.trackFiles) for (var u = function u(t, n) {
                    var i = e.trackFiles[t],
                        o = a.default.createElement("track");
                    o.kind = i.kind, o.label = i.label, o.srclang = i.srclang, o.src = i.src, r.appendChild(o), o.addEventListener("load", function () {
                      this.mode = "showing", r.textTracks[t].mode = "showing";
                    });
                  }, c = 0, h = e.trackFiles.length; c < h; c++) {
                    u(c);
                  }
                  delete e.node, delete e.mediaFiles, delete e.trackFiles;
                }(), e.media.renderer && "function" == typeof e.media.renderer.destroy && e.media.renderer.destroy(), delete s.default.players[e.id], "object" === i(e.getElement(e.container))) && (e.getElement(e.container).parentNode.querySelector("." + e.options.classPrefix + "offscreen").remove(), e.getElement(e.container).remove());
                e.globalUnbind("resize", e.globalResizeCallback), e.globalUnbind("keydown", e.globalKeydownCallback), e.globalUnbind("click", e.globalClickCallback), delete e.media.player;
              }
            }, {
              key: "paused",
              get: function get() {
                return this.proxy.paused;
              }
            }, {
              key: "muted",
              get: function get() {
                return this.proxy.muted;
              },
              set: function set(e) {
                this.setMuted(e);
              }
            }, {
              key: "ended",
              get: function get() {
                return this.proxy.ended;
              }
            }, {
              key: "readyState",
              get: function get() {
                return this.proxy.readyState;
              }
            }, {
              key: "currentTime",
              set: function set(e) {
                this.setCurrentTime(e);
              },
              get: function get() {
                return this.getCurrentTime();
              }
            }, {
              key: "duration",
              get: function get() {
                return this.getDuration();
              }
            }, {
              key: "volume",
              set: function set(e) {
                this.setVolume(e);
              },
              get: function get() {
                return this.getVolume();
              }
            }, {
              key: "src",
              set: function set(e) {
                this.setSrc(e);
              },
              get: function get() {
                return this.getSrc();
              }
            }]), e;
          }();

          o.default.MediaElementPlayer = y, s.default.MediaElementPlayer = y, n.default = y;
        }, {
          17: 17,
          2: 2,
          25: 25,
          26: 26,
          27: 27,
          28: 28,
          3: 3,
          30: 30,
          5: 5,
          6: 6,
          7: 7
        }],
        17: [function (e, t, n) {
          "use strict";

          Object.defineProperty(n, "__esModule", {
            value: !0
          });

          var i,
              r = function () {
            function e(e, t) {
              for (var n = 0; n < t.length; n++) {
                var i = t[n];
                i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
              }
            }

            return function (t, n, i) {
              return n && e(t.prototype, n), i && e(t, i), t;
            };
          }(),
              o = e(3),
              a = (i = o) && i.__esModule ? i : {
            default: i
          };

          var s = function () {
            function e(t) {
              return function (e, t) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
              }(this, e), this.media = t.media, this.isVideo = t.isVideo, this.classPrefix = t.options.classPrefix, this.createIframeLayer = function () {
                return t.createIframeLayer();
              }, this.setPoster = function (e) {
                return t.setPoster(e);
              }, this;
            }

            return r(e, [{
              key: "play",
              value: function value() {
                this.media.play();
              }
            }, {
              key: "pause",
              value: function value() {
                this.media.pause();
              }
            }, {
              key: "load",
              value: function value() {
                var e = this;
                e.isLoaded || e.media.load(), e.isLoaded = !0;
              }
            }, {
              key: "setCurrentTime",
              value: function value(e) {
                this.media.setCurrentTime(e);
              }
            }, {
              key: "getCurrentTime",
              value: function value() {
                return this.media.currentTime;
              }
            }, {
              key: "getDuration",
              value: function value() {
                var e = this.media.getDuration();
                return e === 1 / 0 && this.media.seekable && this.media.seekable.length && (e = this.media.seekable.end(0)), e;
              }
            }, {
              key: "setVolume",
              value: function value(e) {
                this.media.setVolume(e);
              }
            }, {
              key: "getVolume",
              value: function value() {
                return this.media.getVolume();
              }
            }, {
              key: "setMuted",
              value: function value(e) {
                this.media.setMuted(e);
              }
            }, {
              key: "setSrc",
              value: function value(e) {
                var t = this,
                    n = document.getElementById(t.media.id + "-iframe-overlay");
                n && n.remove(), t.media.setSrc(e), t.createIframeLayer(), null !== t.media.renderer && "function" == typeof t.media.renderer.getPosterUrl && t.setPoster(t.media.renderer.getPosterUrl());
              }
            }, {
              key: "getSrc",
              value: function value() {
                return this.media.getSrc();
              }
            }, {
              key: "canPlayType",
              value: function value(e) {
                return this.media.canPlayType(e);
              }
            }, {
              key: "paused",
              get: function get() {
                return this.media.paused;
              }
            }, {
              key: "muted",
              set: function set(e) {
                this.setMuted(e);
              },
              get: function get() {
                return this.media.muted;
              }
            }, {
              key: "ended",
              get: function get() {
                return this.media.ended;
              }
            }, {
              key: "readyState",
              get: function get() {
                return this.media.readyState;
              }
            }, {
              key: "currentTime",
              set: function set(e) {
                this.setCurrentTime(e);
              },
              get: function get() {
                return this.getCurrentTime();
              }
            }, {
              key: "duration",
              get: function get() {
                return this.getDuration();
              }
            }, {
              key: "remainingTime",
              get: function get() {
                return this.getDuration() - this.currentTime();
              }
            }, {
              key: "volume",
              set: function set(e) {
                this.setVolume(e);
              },
              get: function get() {
                return this.getVolume();
              }
            }, {
              key: "src",
              set: function set(e) {
                this.setSrc(e);
              },
              get: function get() {
                return this.getSrc();
              }
            }]), e;
          }();

          n.default = s, a.default.DefaultPlayer = s;
        }, {
          3: 3
        }],
        18: [function (e, t, n) {
          "use strict";

          o(e(3));
          var i = o(e(7)),
              r = o(e(16));

          function o(e) {
            return e && e.__esModule ? e : {
              default: e
            };
          }

          "undefined" != typeof jQuery ? i.default.$ = jQuery : "undefined" != typeof Zepto ? i.default.$ = Zepto : "undefined" != typeof ender && (i.default.$ = ender), function (e) {
            void 0 !== e && (e.fn.mediaelementplayer = function (t) {
              return !1 === t ? this.each(function () {
                var t = e(this).data("mediaelementplayer");
                t && t.remove(), e(this).removeData("mediaelementplayer");
              }) : this.each(function () {
                e(this).data("mediaelementplayer", new r.default(this, t));
              }), this;
            }, e(document).ready(function () {
              e("." + i.default.MepDefaults.classPrefix + "player").mediaelementplayer();
            }));
          }(i.default.$);
        }, {
          16: 16,
          3: 3,
          7: 7
        }],
        19: [function (e, t, n) {
          "use strict";

          var i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
            return typeof e;
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
          },
              r = h(e(3)),
              o = h(e(7)),
              a = e(8),
              s = e(27),
              l = e(28),
              u = e(25),
              c = e(26);

          function h(e) {
            return e && e.__esModule ? e : {
              default: e
            };
          }

          var d = {
            promise: null,
            load: function load(e) {
              return "undefined" != typeof dashjs ? d.promise = new Promise(function (e) {
                e();
              }).then(function () {
                d._createPlayer(e);
              }) : (e.options.path = "string" == typeof e.options.path ? e.options.path : "https://cdn.dashjs.org/latest/dash.all.min.js", d.promise = d.promise || (0, c.loadScript)(e.options.path), d.promise.then(function () {
                d._createPlayer(e);
              })), d.promise;
            },
            _createPlayer: function _createPlayer(e) {
              var t = dashjs.MediaPlayer().create();
              return r.default["__ready__" + e.id](t), t;
            }
          },
              f = {
            name: "native_dash",
            options: {
              prefix: "native_dash",
              dash: {
                path: "https://cdn.dashjs.org/latest/dash.all.min.js",
                debug: !1,
                drm: {},
                robustnessLevel: ""
              }
            },
            canPlayType: function canPlayType(e) {
              return u.HAS_MSE && ["application/dash+xml"].indexOf(e.toLowerCase()) > -1;
            },
            create: function create(e, t, n) {
              var l = e.originalNode,
                  u = e.id + "_" + t.prefix,
                  c = l.autoplay,
                  h = l.children,
                  f = null,
                  p = null;
              l.removeAttribute("type");

              for (var g = 0, v = h.length; g < v; g++) {
                h[g].removeAttribute("type");
              }

              f = l.cloneNode(!0), t = Object.assign(t, e.options);

              for (var m = o.default.html5media.properties, y = o.default.html5media.events.concat(["click", "mouseover", "mouseout"]).filter(function (e) {
                return "error" !== e;
              }), x = function x(t) {
                var n = (0, s.createEvent)(t.type, e);
                e.dispatchEvent(n);
              }, _ = function _(e) {
                var n = "" + e.substring(0, 1).toUpperCase() + e.substring(1);
                f["get" + n] = function () {
                  return null !== p ? f[e] : null;
                }, f["set" + n] = function (n) {
                  if (-1 === o.default.html5media.readOnlyProperties.indexOf(e)) if ("src" === e) {
                    var r = "object" === (void 0 === n ? "undefined" : i(n)) && n.src ? n.src : n;

                    if (f[e] = r, null !== p) {
                      p.reset();

                      for (var a = 0, l = y.length; a < l; a++) {
                        f.removeEventListener(y[a], x);
                      }

                      p = d._createPlayer({
                        options: t.dash,
                        id: u
                      }), n && "object" === (void 0 === n ? "undefined" : i(n)) && "object" === i(n.drm) && (p.setProtectionData(n.drm), (0, s.isString)(t.dash.robustnessLevel) && t.dash.robustnessLevel && p.getProtectionController().setRobustnessLevel(t.dash.robustnessLevel)), p.attachSource(r), c && p.play();
                    }
                  } else f[e] = n;
                };
              }, b = 0, w = m.length; b < w; b++) {
                _(m[b]);
              }

              if (r.default["__ready__" + u] = function (n) {
                e.dashPlayer = p = n;

                for (var r, a = dashjs.MediaPlayer.events, l = 0, u = y.length; l < u; l++) {
                  "loadedmetadata" === (r = y[l]) && (p.initialize(), p.attachView(f), p.setAutoPlay(!1), "object" !== i(t.dash.drm) || o.default.Utils.isObjectEmpty(t.dash.drm) || (p.setProtectionData(t.dash.drm), (0, s.isString)(t.dash.robustnessLevel) && t.dash.robustnessLevel && p.getProtectionController().setRobustnessLevel(t.dash.robustnessLevel)), p.attachSource(f.getSrc())), f.addEventListener(r, x);
                }

                var c = function c(t) {
                  if ("error" === t.type.toLowerCase()) e.generateError(t.message, f.src), console.error(t);else {
                    var n = (0, s.createEvent)(t.type, e);
                    n.data = t, e.dispatchEvent(n);
                  }
                };

                for (var h in a) {
                  a.hasOwnProperty(h) && p.on(a[h], function (e) {
                    return c(e);
                  });
                }
              }, n && n.length > 0) for (var S = 0, T = n.length; S < T; S++) {
                if (a.renderer.renderers[t.prefix].canPlayType(n[S].type)) {
                  f.setAttribute("src", n[S].src), void 0 !== n[S].drm && (t.dash.drm = n[S].drm);
                  break;
                }
              }
              f.setAttribute("id", u), l.parentNode.insertBefore(f, l), l.autoplay = !1, l.style.display = "none", f.setSize = function (e, t) {
                return f.style.width = e + "px", f.style.height = t + "px", f;
              }, f.hide = function () {
                return f.pause(), f.style.display = "none", f;
              }, f.show = function () {
                return f.style.display = "", f;
              }, f.destroy = function () {
                null !== p && p.reset();
              };
              var C = (0, s.createEvent)("rendererready", f);
              return e.dispatchEvent(C), e.promises.push(d.load({
                options: t.dash,
                id: u
              })), f;
            }
          };
          l.typeChecks.push(function (e) {
            return ~e.toLowerCase().indexOf(".mpd") ? "application/dash+xml" : null;
          }), a.renderer.add(f);
        }, {
          25: 25,
          26: 26,
          27: 27,
          28: 28,
          3: 3,
          7: 7,
          8: 8
        }],
        20: [function (e, t, n) {
          "use strict";

          Object.defineProperty(n, "__esModule", {
            value: !0
          }), n.PluginDetector = void 0;
          var i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
            return typeof e;
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
          },
              r = d(e(3)),
              o = d(e(2)),
              a = d(e(7)),
              s = d(e(5)),
              l = e(8),
              u = e(27),
              c = e(25),
              h = e(28);

          function d(e) {
            return e && e.__esModule ? e : {
              default: e
            };
          }

          var f = n.PluginDetector = {
            plugins: [],
            hasPluginVersion: function hasPluginVersion(e, t) {
              var n = f.plugins[e];
              return t[1] = t[1] || 0, t[2] = t[2] || 0, n[0] > t[0] || n[0] === t[0] && n[1] > t[1] || n[0] === t[0] && n[1] === t[1] && n[2] >= t[2];
            },
            addPlugin: function addPlugin(e, t, n, i, r) {
              f.plugins[e] = f.detectPlugin(t, n, i, r);
            },
            detectPlugin: function detectPlugin(e, t, n, o) {
              var a = [0, 0, 0],
                  s = void 0,
                  l = void 0;

              if (null !== c.NAV.plugins && void 0 !== c.NAV.plugins && "object" === i(c.NAV.plugins[e])) {
                if ((s = c.NAV.plugins[e].description) && (void 0 === c.NAV.mimeTypes || !c.NAV.mimeTypes[t] || c.NAV.mimeTypes[t].enabledPlugin)) for (var u = 0, h = (a = s.replace(e, "").replace(/^\s+/, "").replace(/\sr/gi, ".").split(".")).length; u < h; u++) {
                  a[u] = parseInt(a[u].match(/\d+/), 10);
                }
              } else if (void 0 !== r.default.ActiveXObject) try {
                (l = new ActiveXObject(n)) && (a = o(l));
              } catch (e) {}

              return a;
            }
          };
          f.addPlugin("flash", "Shockwave Flash", "application/x-shockwave-flash", "ShockwaveFlash.ShockwaveFlash", function (e) {
            var t = [],
                n = e.GetVariable("$version");
            return n && (n = n.split(" ")[1].split(","), t = [parseInt(n[0], 10), parseInt(n[1], 10), parseInt(n[2], 10)]), t;
          });
          var p = {
            create: function create(e, t, n) {
              var i = {},
                  d = !1;
              i.options = t, i.id = e.id + "_" + i.options.prefix, i.mediaElement = e, i.flashState = {}, i.flashApi = null, i.flashApiStack = [];

              for (var f = a.default.html5media.properties, p = function p(e) {
                i.flashState[e] = null;
                var t = "" + e.substring(0, 1).toUpperCase() + e.substring(1);
                i["get" + t] = function () {
                  if (null !== i.flashApi) {
                    if ("function" == typeof i.flashApi["get_" + e]) {
                      var t = i.flashApi["get_" + e]();
                      return "buffered" === e ? {
                        start: function start() {
                          return 0;
                        },
                        end: function end() {
                          return t;
                        },
                        length: 1
                      } : t;
                    }

                    return null;
                  }

                  return null;
                }, i["set" + t] = function (t) {
                  if ("src" === e && (t = (0, h.absolutizeUrl)(t)), null !== i.flashApi && void 0 !== i.flashApi["set_" + e]) try {
                    i.flashApi["set_" + e](t);
                  } catch (e) {} else i.flashApiStack.push({
                    type: "set",
                    propName: e,
                    value: t
                  });
                };
              }, g = 0, v = f.length; g < v; g++) {
                p(f[g]);
              }

              var m = a.default.html5media.methods,
                  y = function y(e) {
                i[e] = function () {
                  if (d) if (null !== i.flashApi) {
                    if (i.flashApi["fire_" + e]) try {
                      i.flashApi["fire_" + e]();
                    } catch (e) {}
                  } else i.flashApiStack.push({
                    type: "call",
                    methodName: e
                  });
                };
              };

              m.push("stop");

              for (var x = 0, _ = m.length; x < _; x++) {
                y(m[x]);
              }

              for (var b = ["rendererready"], w = 0, S = b.length; w < S; w++) {
                var T = (0, u.createEvent)(b[w], i);
                e.dispatchEvent(T);
              }

              r.default["__ready__" + i.id] = function () {
                if (i.flashReady = !0, i.flashApi = o.default.getElementById("__" + i.id), i.flashApiStack.length) for (var e = 0, t = i.flashApiStack.length; e < t; e++) {
                  var n = i.flashApiStack[e];

                  if ("set" === n.type) {
                    var r = n.propName,
                        a = "" + r.substring(0, 1).toUpperCase() + r.substring(1);
                    i["set" + a](n.value);
                  } else "call" === n.type && i[n.methodName]();
                }
              }, r.default["__event__" + i.id] = function (e, t) {
                var n = (0, u.createEvent)(e, i);
                if (t) try {
                  n.data = JSON.parse(t), n.details.data = JSON.parse(t);
                } catch (e) {
                  n.message = t;
                }
                i.mediaElement.dispatchEvent(n);
              }, i.flashWrapper = o.default.createElement("div"), -1 === ["always", "sameDomain"].indexOf(i.options.shimScriptAccess) && (i.options.shimScriptAccess = "sameDomain");
              var C = e.originalNode.autoplay,
                  k = ["uid=" + i.id, "autoplay=" + C, "allowScriptAccess=" + i.options.shimScriptAccess, "preload=" + (e.originalNode.getAttribute("preload") || "")],
                  M = null !== e.originalNode && "video" === e.originalNode.tagName.toLowerCase(),
                  E = M ? e.originalNode.height : 1,
                  A = M ? e.originalNode.width : 1;
              e.originalNode.getAttribute("src") && k.push("src=" + e.originalNode.getAttribute("src")), !0 === i.options.enablePseudoStreaming && (k.push("pseudostreamstart=" + i.options.pseudoStreamingStartQueryParam), k.push("pseudostreamtype=" + i.options.pseudoStreamingType)), i.options.streamDelimiter && k.push("streamdelimiter=" + encodeURIComponent(i.options.streamDelimiter)), i.options.proxyType && k.push("proxytype=" + i.options.proxyType), e.appendChild(i.flashWrapper), e.originalNode.style.display = "none";
              var I = [];

              if (c.IS_IE || c.IS_EDGE) {
                var P = o.default.createElement("div");
                i.flashWrapper.appendChild(P), I = c.IS_EDGE ? ['type="application/x-shockwave-flash"', 'data="' + i.options.pluginPath + i.options.filename + '"', 'id="__' + i.id + '"', 'width="' + A + '"', 'height="' + E + "'\""] : ['classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000"', 'codebase="//download.macromedia.com/pub/shockwave/cabs/flash/swflash.cab"', 'id="__' + i.id + '"', 'width="' + A + '"', 'height="' + E + '"'], M || I.push('style="clip: rect(0 0 0 0); position: absolute;"'), P.outerHTML = "<object " + I.join(" ") + '><param name="movie" value="' + i.options.pluginPath + i.options.filename + "?x=" + new Date() + '" /><param name="flashvars" value="' + k.join("&amp;") + '" /><param name="quality" value="high" /><param name="bgcolor" value="#000000" /><param name="wmode" value="transparent" /><param name="allowScriptAccess" value="' + i.options.shimScriptAccess + '" /><param name="allowFullScreen" value="true" /><div>' + s.default.t("mejs.install-flash") + "</div></object>";
              } else I = ['id="__' + i.id + '"', 'name="__' + i.id + '"', 'play="true"', 'loop="false"', 'quality="high"', 'bgcolor="#000000"', 'wmode="transparent"', 'allowScriptAccess="' + i.options.shimScriptAccess + '"', 'allowFullScreen="true"', 'type="application/x-shockwave-flash"', 'pluginspage="//www.macromedia.com/go/getflashplayer"', 'src="' + i.options.pluginPath + i.options.filename + '"', 'flashvars="' + k.join("&") + '"'], M ? (I.push('width="' + A + '"'), I.push('height="' + E + '"')) : I.push('style="position: fixed; left: -9999em; top: -9999em;"'), i.flashWrapper.innerHTML = "<embed " + I.join(" ") + ">";

              if (i.flashNode = i.flashWrapper.lastChild, i.hide = function () {
                d = !1, M && (i.flashNode.style.display = "none");
              }, i.show = function () {
                d = !0, M && (i.flashNode.style.display = "");
              }, i.setSize = function (e, t) {
                i.flashNode.style.width = e + "px", i.flashNode.style.height = t + "px", null !== i.flashApi && "function" == typeof i.flashApi.fire_setSize && i.flashApi.fire_setSize(e, t);
              }, i.destroy = function () {
                i.flashNode.remove();
              }, n && n.length > 0) for (var O = 0, L = n.length; O < L; O++) {
                if (l.renderer.renderers[t.prefix].canPlayType(n[O].type)) {
                  i.setSrc(n[O].src);
                  break;
                }
              }
              return i;
            }
          };

          if (f.hasPluginVersion("flash", [10, 0, 0])) {
            h.typeChecks.push(function (e) {
              return (e = e.toLowerCase()).startsWith("rtmp") ? ~e.indexOf(".mp3") ? "audio/rtmp" : "video/rtmp" : /\.og(a|g)/i.test(e) ? "audio/ogg" : ~e.indexOf(".m3u8") ? "application/x-mpegURL" : ~e.indexOf(".mpd") ? "application/dash+xml" : ~e.indexOf(".flv") ? "video/flv" : null;
            });
            var g = {
              name: "flash_video",
              options: {
                prefix: "flash_video",
                filename: "mediaelement-flash-video.swf",
                enablePseudoStreaming: !1,
                pseudoStreamingStartQueryParam: "start",
                pseudoStreamingType: "byte",
                proxyType: "",
                streamDelimiter: ""
              },
              canPlayType: function canPlayType(e) {
                return ~["video/mp4", "video/rtmp", "audio/rtmp", "rtmp/mp4", "audio/mp4", "video/flv", "video/x-flv"].indexOf(e.toLowerCase());
              },
              create: p.create
            };
            l.renderer.add(g);
            var v = {
              name: "flash_hls",
              options: {
                prefix: "flash_hls",
                filename: "mediaelement-flash-video-hls.swf"
              },
              canPlayType: function canPlayType(e) {
                return ~["application/x-mpegurl", "application/vnd.apple.mpegurl", "audio/mpegurl", "audio/hls", "video/hls"].indexOf(e.toLowerCase());
              },
              create: p.create
            };
            l.renderer.add(v);
            var m = {
              name: "flash_dash",
              options: {
                prefix: "flash_dash",
                filename: "mediaelement-flash-video-mdash.swf"
              },
              canPlayType: function canPlayType(e) {
                return ~["application/dash+xml"].indexOf(e.toLowerCase());
              },
              create: p.create
            };
            l.renderer.add(m);
            var y = {
              name: "flash_audio",
              options: {
                prefix: "flash_audio",
                filename: "mediaelement-flash-audio.swf"
              },
              canPlayType: function canPlayType(e) {
                return ~["audio/mp3"].indexOf(e.toLowerCase());
              },
              create: p.create
            };
            l.renderer.add(y);
            var x = {
              name: "flash_audio_ogg",
              options: {
                prefix: "flash_audio_ogg",
                filename: "mediaelement-flash-audio-ogg.swf"
              },
              canPlayType: function canPlayType(e) {
                return ~["audio/ogg", "audio/oga", "audio/ogv"].indexOf(e.toLowerCase());
              },
              create: p.create
            };
            l.renderer.add(x);
          }
        }, {
          2: 2,
          25: 25,
          27: 27,
          28: 28,
          3: 3,
          5: 5,
          7: 7,
          8: 8
        }],
        21: [function (e, t, n) {
          "use strict";

          var i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
            return typeof e;
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
          },
              r = h(e(3)),
              o = h(e(7)),
              a = e(8),
              s = e(27),
              l = e(25),
              u = e(28),
              c = e(26);

          function h(e) {
            return e && e.__esModule ? e : {
              default: e
            };
          }

          var d = {
            promise: null,
            load: function load(e) {
              return "undefined" != typeof flvjs ? d.promise = new Promise(function (e) {
                e();
              }).then(function () {
                d._createPlayer(e);
              }) : (e.options.path = "string" == typeof e.options.path ? e.options.path : "https://cdn.jsdelivr.net/npm/flv.js@latest", d.promise = d.promise || (0, c.loadScript)(e.options.path), d.promise.then(function () {
                d._createPlayer(e);
              })), d.promise;
            },
            _createPlayer: function _createPlayer(e) {
              flvjs.LoggingControl.enableDebug = e.options.debug, flvjs.LoggingControl.enableVerbose = e.options.debug;
              var t = flvjs.createPlayer(e.options, e.configs);
              return r.default["__ready__" + e.id](t), t;
            }
          },
              f = {
            name: "native_flv",
            options: {
              prefix: "native_flv",
              flv: {
                path: "https://cdn.jsdelivr.net/npm/flv.js@latest",
                cors: !0,
                debug: !1
              }
            },
            canPlayType: function canPlayType(e) {
              return l.HAS_MSE && ["video/x-flv", "video/flv"].indexOf(e.toLowerCase()) > -1;
            },
            create: function create(e, t, n) {
              var l = e.originalNode,
                  u = e.id + "_" + t.prefix,
                  c = null,
                  h = null;
              c = l.cloneNode(!0), t = Object.assign(t, e.options);

              for (var f = o.default.html5media.properties, p = o.default.html5media.events.concat(["click", "mouseover", "mouseout"]).filter(function (e) {
                return "error" !== e;
              }), g = function g(t) {
                var n = (0, s.createEvent)(t.type, e);
                e.dispatchEvent(n);
              }, v = function v(e) {
                var n = "" + e.substring(0, 1).toUpperCase() + e.substring(1);
                c["get" + n] = function () {
                  return null !== h ? c[e] : null;
                }, c["set" + n] = function (n) {
                  if (-1 === o.default.html5media.readOnlyProperties.indexOf(e)) if ("src" === e) {
                    if (c[e] = "object" === (void 0 === n ? "undefined" : i(n)) && n.src ? n.src : n, null !== h) {
                      var r = {
                        type: "flv"
                      };
                      r.url = n, r.cors = t.flv.cors, r.debug = t.flv.debug, r.path = t.flv.path;
                      var a = t.flv.configs;
                      h.destroy();

                      for (var s = 0, l = p.length; s < l; s++) {
                        c.removeEventListener(p[s], g);
                      }

                      (h = d._createPlayer({
                        options: r,
                        configs: a,
                        id: u
                      })).attachMediaElement(c), h.load();
                    }
                  } else c[e] = n;
                };
              }, m = 0, y = f.length; m < y; m++) {
                v(f[m]);
              }

              if (r.default["__ready__" + u] = function (t) {
                e.flvPlayer = h = t;

                for (var n, i = flvjs.Events, r = 0, o = p.length; r < o; r++) {
                  "loadedmetadata" === (n = p[r]) && (h.unload(), h.detachMediaElement(), h.attachMediaElement(c), h.load()), c.addEventListener(n, g);
                }

                var a = function a(t, n) {
                  if ("error" === t) {
                    var i = n[0] + ": " + n[1] + " " + n[2].msg;
                    e.generateError(i, c.src);
                  } else {
                    var r = (0, s.createEvent)(t, e);
                    r.data = n, e.dispatchEvent(r);
                  }
                },
                    l = function l(e) {
                  i.hasOwnProperty(e) && h.on(i[e], function () {
                    for (var t = arguments.length, n = Array(t), r = 0; r < t; r++) {
                      n[r] = arguments[r];
                    }

                    return a(i[e], n);
                  });
                };

                for (var u in i) {
                  l(u);
                }
              }, n && n.length > 0) for (var x = 0, _ = n.length; x < _; x++) {
                if (a.renderer.renderers[t.prefix].canPlayType(n[x].type)) {
                  c.setAttribute("src", n[x].src);
                  break;
                }
              }
              c.setAttribute("id", u), l.parentNode.insertBefore(c, l), l.autoplay = !1, l.style.display = "none";
              var b = {
                type: "flv"
              };
              b.url = c.src, b.cors = t.flv.cors, b.debug = t.flv.debug, b.path = t.flv.path;
              var w = t.flv.configs;
              c.setSize = function (e, t) {
                return c.style.width = e + "px", c.style.height = t + "px", c;
              }, c.hide = function () {
                return null !== h && h.pause(), c.style.display = "none", c;
              }, c.show = function () {
                return c.style.display = "", c;
              }, c.destroy = function () {
                null !== h && h.destroy();
              };
              var S = (0, s.createEvent)("rendererready", c);
              return e.dispatchEvent(S), e.promises.push(d.load({
                options: b,
                configs: w,
                id: u
              })), c;
            }
          };
          u.typeChecks.push(function (e) {
            return ~e.toLowerCase().indexOf(".flv") ? "video/flv" : null;
          }), a.renderer.add(f);
        }, {
          25: 25,
          26: 26,
          27: 27,
          28: 28,
          3: 3,
          7: 7,
          8: 8
        }],
        22: [function (e, t, n) {
          "use strict";

          var i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
            return typeof e;
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
          },
              r = h(e(3)),
              o = h(e(7)),
              a = e(8),
              s = e(27),
              l = e(25),
              u = e(28),
              c = e(26);

          function h(e) {
            return e && e.__esModule ? e : {
              default: e
            };
          }

          var d = {
            promise: null,
            load: function load(e) {
              return "undefined" != typeof Hls ? d.promise = new Promise(function (e) {
                e();
              }).then(function () {
                d._createPlayer(e);
              }) : (e.options.path = "string" == typeof e.options.path ? e.options.path : "https://cdn.jsdelivr.net/npm/hls.js@latest", d.promise = d.promise || (0, c.loadScript)(e.options.path), d.promise.then(function () {
                d._createPlayer(e);
              })), d.promise;
            },
            _createPlayer: function _createPlayer(e) {
              var t = new Hls(e.options);
              return r.default["__ready__" + e.id](t), t;
            }
          },
              f = {
            name: "native_hls",
            options: {
              prefix: "native_hls",
              hls: {
                path: "https://cdn.jsdelivr.net/npm/hls.js@latest",
                autoStartLoad: !1,
                debug: !1
              }
            },
            canPlayType: function canPlayType(e) {
              return l.HAS_MSE && ["application/x-mpegurl", "application/vnd.apple.mpegurl", "audio/mpegurl", "audio/hls", "video/hls"].indexOf(e.toLowerCase()) > -1;
            },
            create: function create(e, t, n) {
              var l = e.originalNode,
                  u = e.id + "_" + t.prefix,
                  c = l.getAttribute("preload"),
                  h = l.autoplay,
                  f = null,
                  p = null,
                  g = 0,
                  v = n.length;
              p = l.cloneNode(!0), (t = Object.assign(t, e.options)).hls.autoStartLoad = c && "none" !== c || h;

              for (var m = o.default.html5media.properties, y = o.default.html5media.events.concat(["click", "mouseover", "mouseout"]).filter(function (e) {
                return "error" !== e;
              }), x = function x(t) {
                var n = (0, s.createEvent)(t.type, e);
                e.dispatchEvent(n);
              }, _ = function _(e) {
                var n = "" + e.substring(0, 1).toUpperCase() + e.substring(1);
                p["get" + n] = function () {
                  return null !== f ? p[e] : null;
                }, p["set" + n] = function (n) {
                  if (-1 === o.default.html5media.readOnlyProperties.indexOf(e)) if ("src" === e) {
                    if (p[e] = "object" === (void 0 === n ? "undefined" : i(n)) && n.src ? n.src : n, null !== f) {
                      f.destroy();

                      for (var r = 0, a = y.length; r < a; r++) {
                        p.removeEventListener(y[r], x);
                      }

                      (f = d._createPlayer({
                        options: t.hls,
                        id: u
                      })).loadSource(n), f.attachMedia(p);
                    }
                  } else p[e] = n;
                };
              }, b = 0, w = m.length; b < w; b++) {
                _(m[b]);
              }

              if (r.default["__ready__" + u] = function (t) {
                e.hlsPlayer = f = t;

                for (var i = Hls.Events, r = function r(t) {
                  if ("loadedmetadata" === t) {
                    var n = e.originalNode.src;
                    f.detachMedia(), f.loadSource(n), f.attachMedia(p);
                  }

                  p.addEventListener(t, x);
                }, o = 0, a = y.length; o < a; o++) {
                  r(y[o]);
                }

                var l = void 0,
                    u = void 0,
                    c = function c(t, i) {
                  if ("hlsError" === t && (console.warn(i), (i = i[1]).fatal)) switch (i.type) {
                    case "mediaError":
                      var r = new Date().getTime();
                      if (!l || r - l > 3e3) l = new Date().getTime(), f.recoverMediaError();else if (!u || r - u > 3e3) u = new Date().getTime(), console.warn("Attempting to swap Audio Codec and recover from media error"), f.swapAudioCodec(), f.recoverMediaError();else {
                        var o = "Cannot recover, last media error recovery failed";
                        e.generateError(o, p.src), console.error(o);
                      }
                      break;

                    case "networkError":
                      if ("manifestLoadError" === i.details) {
                        if (g < v && void 0 !== n[g + 1]) p.setSrc(n[g++].src), p.load(), p.play();else {
                          e.generateError("Network error", n), console.error("Network error");
                        }
                      } else {
                        e.generateError("Network error", n), console.error("Network error");
                      }
                      break;

                    default:
                      f.destroy();
                  } else {
                    var a = (0, s.createEvent)(t, e);
                    a.data = i, e.dispatchEvent(a);
                  }
                },
                    h = function h(e) {
                  i.hasOwnProperty(e) && f.on(i[e], function () {
                    for (var t = arguments.length, n = Array(t), r = 0; r < t; r++) {
                      n[r] = arguments[r];
                    }

                    return c(i[e], n);
                  });
                };

                for (var d in i) {
                  h(d);
                }
              }, v > 0) for (; g < v; g++) {
                if (a.renderer.renderers[t.prefix].canPlayType(n[g].type)) {
                  p.setAttribute("src", n[g].src);
                  break;
                }
              }
              "auto" === c || h || (p.addEventListener("play", function () {
                null !== f && f.startLoad();
              }), p.addEventListener("pause", function () {
                null !== f && f.stopLoad();
              })), p.setAttribute("id", u), l.parentNode.insertBefore(p, l), l.autoplay = !1, l.style.display = "none", p.setSize = function (e, t) {
                return p.style.width = e + "px", p.style.height = t + "px", p;
              }, p.hide = function () {
                return p.pause(), p.style.display = "none", p;
              }, p.show = function () {
                return p.style.display = "", p;
              }, p.destroy = function () {
                null !== f && (f.stopLoad(), f.destroy());
              };
              var S = (0, s.createEvent)("rendererready", p);
              return e.dispatchEvent(S), e.promises.push(d.load({
                options: t.hls,
                id: u
              })), p;
            }
          };
          u.typeChecks.push(function (e) {
            return ~e.toLowerCase().indexOf(".m3u8") ? "application/x-mpegURL" : null;
          }), a.renderer.add(f);
        }, {
          25: 25,
          26: 26,
          27: 27,
          28: 28,
          3: 3,
          7: 7,
          8: 8
        }],
        23: [function (e, t, n) {
          "use strict";

          var i = u(e(3)),
              r = u(e(2)),
              o = u(e(7)),
              a = e(8),
              s = e(27),
              l = e(25);

          function u(e) {
            return e && e.__esModule ? e : {
              default: e
            };
          }

          var c = {
            name: "html5",
            options: {
              prefix: "html5"
            },
            canPlayType: function canPlayType(e) {
              var t = r.default.createElement("video");
              return l.IS_ANDROID && /\/mp(3|4)$/i.test(e) || ~["application/x-mpegurl", "vnd.apple.mpegurl", "audio/mpegurl", "audio/hls", "video/hls"].indexOf(e.toLowerCase()) && l.SUPPORTS_NATIVE_HLS ? "yes" : t.canPlayType ? t.canPlayType(e.toLowerCase()).replace(/no/, "") : "";
            },
            create: function create(e, t, n) {
              var i = e.id + "_" + t.prefix,
                  l = !1,
                  u = null;
              void 0 === e.originalNode || null === e.originalNode ? (u = r.default.createElement("audio"), e.appendChild(u)) : u = e.originalNode, u.setAttribute("id", i);

              for (var c = o.default.html5media.properties, h = function h(e) {
                var t = "" + e.substring(0, 1).toUpperCase() + e.substring(1);
                u["get" + t] = function () {
                  return u[e];
                }, u["set" + t] = function (t) {
                  -1 === o.default.html5media.readOnlyProperties.indexOf(e) && (u[e] = t);
                };
              }, d = 0, f = c.length; d < f; d++) {
                h(c[d]);
              }

              for (var p, g = o.default.html5media.events.concat(["click", "mouseover", "mouseout"]).filter(function (e) {
                return "error" !== e;
              }), v = 0, m = g.length; v < m; v++) {
                p = g[v], u.addEventListener(p, function (t) {
                  if (l) {
                    var n = (0, s.createEvent)(t.type, t.target);
                    e.dispatchEvent(n);
                  }
                });
              }

              u.setSize = function (e, t) {
                return u.style.width = e + "px", u.style.height = t + "px", u;
              }, u.hide = function () {
                return l = !1, u.style.display = "none", u;
              }, u.show = function () {
                return l = !0, u.style.display = "", u;
              };
              var y = 0,
                  x = n.length;
              if (x > 0) for (; y < x; y++) {
                if (a.renderer.renderers[t.prefix].canPlayType(n[y].type)) {
                  u.setAttribute("src", n[y].src);
                  break;
                }
              }
              u.addEventListener("error", function (t) {
                t && t.target && t.target.error && 4 === t.target.error.code && l && (y < x && void 0 !== n[y + 1] ? (u.src = n[y++].src, u.load(), u.play()) : e.generateError("Media error: Format(s) not supported or source(s) not found", n));
              });

              var _ = (0, s.createEvent)("rendererready", u);

              return e.dispatchEvent(_), u;
            }
          };
          i.default.HtmlMediaElement = o.default.HtmlMediaElement = c, a.renderer.add(c);
        }, {
          2: 2,
          25: 25,
          27: 27,
          3: 3,
          7: 7,
          8: 8
        }],
        24: [function (e, t, n) {
          "use strict";

          var i = c(e(3)),
              r = c(e(2)),
              o = c(e(7)),
              a = e(8),
              s = e(27),
              l = e(28),
              u = e(26);

          function c(e) {
            return e && e.__esModule ? e : {
              default: e
            };
          }

          var h = {
            isIframeStarted: !1,
            isIframeLoaded: !1,
            iframeQueue: [],
            enqueueIframe: function enqueueIframe(e) {
              h.isLoaded = "undefined" != typeof YT && YT.loaded, h.isLoaded ? h.createIframe(e) : (h.loadIframeApi(), h.iframeQueue.push(e));
            },
            loadIframeApi: function loadIframeApi() {
              h.isIframeStarted || ((0, u.loadScript)("https://www.youtube.com/player_api"), h.isIframeStarted = !0);
            },
            iFrameReady: function iFrameReady() {
              for (h.isLoaded = !0, h.isIframeLoaded = !0; h.iframeQueue.length > 0;) {
                var e = h.iframeQueue.pop();
                h.createIframe(e);
              }
            },
            createIframe: function createIframe(e) {
              return new YT.Player(e.containerId, e);
            },
            getYouTubeId: function getYouTubeId(e) {
              var t = "";
              e.indexOf("?") > 0 ? "" === (t = h.getYouTubeIdFromParam(e)) && (t = h.getYouTubeIdFromUrl(e)) : t = h.getYouTubeIdFromUrl(e);
              var n = t.substring(t.lastIndexOf("/") + 1);
              return (t = n.split("?"))[0];
            },
            getYouTubeIdFromParam: function getYouTubeIdFromParam(e) {
              if (null == e || !e.trim().length) return null;

              for (var t = e.split("?")[1].split("&"), n = "", i = 0, r = t.length; i < r; i++) {
                var o = t[i].split("=");

                if ("v" === o[0]) {
                  n = o[1];
                  break;
                }
              }

              return n;
            },
            getYouTubeIdFromUrl: function getYouTubeIdFromUrl(e) {
              if (null == e || !e.trim().length) return null;
              var t = e.split("?");
              return (e = t[0]).substring(e.lastIndexOf("/") + 1);
            },
            getYouTubeNoCookieUrl: function getYouTubeNoCookieUrl(e) {
              if (null == e || !e.trim().length || -1 === e.indexOf("//www.youtube")) return e;
              var t = e.split("/");
              return t[2] = t[2].replace(".com", "-nocookie.com"), t.join("/");
            }
          },
              d = {
            name: "youtube_iframe",
            options: {
              prefix: "youtube_iframe",
              youtube: {
                autoplay: 0,
                controls: 0,
                disablekb: 1,
                end: 0,
                loop: 0,
                modestbranding: 0,
                playsinline: 0,
                rel: 0,
                showinfo: 0,
                start: 0,
                iv_load_policy: 3,
                nocookie: !1,
                imageQuality: null
              }
            },
            canPlayType: function canPlayType(e) {
              return ~["video/youtube", "video/x-youtube"].indexOf(e.toLowerCase());
            },
            create: function create(e, t, n) {
              var a = {},
                  l = [],
                  u = null,
                  c = !0,
                  d = !1,
                  f = null;
              a.options = t, a.id = e.id + "_" + t.prefix, a.mediaElement = e;

              for (var p = o.default.html5media.properties, g = function g(t) {
                var n = "" + t.substring(0, 1).toUpperCase() + t.substring(1);
                a["get" + n] = function () {
                  if (null !== u) {
                    switch (t) {
                      case "currentTime":
                        return u.getCurrentTime();

                      case "duration":
                        return u.getDuration();

                      case "volume":
                        return u.getVolume() / 100;

                      case "playbackRate":
                        return u.getPlaybackRate();

                      case "paused":
                        return c;

                      case "ended":
                        return d;

                      case "muted":
                        return u.isMuted();

                      case "buffered":
                        var e = u.getVideoLoadedFraction(),
                            n = u.getDuration();
                        return {
                          start: function start() {
                            return 0;
                          },
                          end: function end() {
                            return e * n;
                          },
                          length: 1
                        };

                      case "src":
                        return u.getVideoUrl();

                      case "readyState":
                        return 4;
                    }

                    return null;
                  }

                  return null;
                }, a["set" + n] = function (n) {
                  if (null !== u) switch (t) {
                    case "src":
                      var i = "string" == typeof n ? n : n[0].src,
                          r = h.getYouTubeId(i);
                      e.originalNode.autoplay ? u.loadVideoById(r) : u.cueVideoById(r);
                      break;

                    case "currentTime":
                      u.seekTo(n);
                      break;

                    case "muted":
                      n ? u.mute() : u.unMute(), setTimeout(function () {
                        var t = (0, s.createEvent)("volumechange", a);
                        e.dispatchEvent(t);
                      }, 50);
                      break;

                    case "volume":
                      n, u.setVolume(100 * n), setTimeout(function () {
                        var t = (0, s.createEvent)("volumechange", a);
                        e.dispatchEvent(t);
                      }, 50);
                      break;

                    case "playbackRate":
                      u.setPlaybackRate(n), setTimeout(function () {
                        var t = (0, s.createEvent)("ratechange", a);
                        e.dispatchEvent(t);
                      }, 50);
                      break;

                    case "readyState":
                      var o = (0, s.createEvent)("canplay", a);
                      e.dispatchEvent(o);
                  } else l.push({
                    type: "set",
                    propName: t,
                    value: n
                  });
                };
              }, v = 0, m = p.length; v < m; v++) {
                g(p[v]);
              }

              for (var y = o.default.html5media.methods, x = function x(e) {
                a[e] = function () {
                  if (null !== u) switch (e) {
                    case "play":
                      return c = !1, u.playVideo();

                    case "pause":
                      return c = !0, u.pauseVideo();

                    case "load":
                      return null;
                  } else l.push({
                    type: "call",
                    methodName: e
                  });
                };
              }, _ = 0, b = y.length; _ < b; _++) {
                x(y[_]);
              }

              var w = r.default.createElement("div");
              w.id = a.id, a.options.youtube.nocookie && (e.originalNode.src = h.getYouTubeNoCookieUrl(n[0].src)), e.originalNode.parentNode.insertBefore(w, e.originalNode), e.originalNode.style.display = "none";
              var S = "audio" === e.originalNode.tagName.toLowerCase(),
                  T = S ? "1" : e.originalNode.height,
                  C = S ? "1" : e.originalNode.width,
                  k = h.getYouTubeId(n[0].src),
                  M = {
                id: a.id,
                containerId: w.id,
                videoId: k,
                height: T,
                width: C,
                playerVars: Object.assign({
                  controls: 0,
                  rel: 0,
                  disablekb: 1,
                  showinfo: 0,
                  modestbranding: 0,
                  html5: 1,
                  iv_load_policy: 3
                }, a.options.youtube),
                origin: i.default.location.host,
                events: {
                  onReady: function onReady(t) {
                    if (e.youTubeApi = u = t.target, e.youTubeState = {
                      paused: !0,
                      ended: !1
                    }, l.length) for (var n = 0, i = l.length; n < i; n++) {
                      var r = l[n];

                      if ("set" === r.type) {
                        var o = r.propName,
                            c = "" + o.substring(0, 1).toUpperCase() + o.substring(1);
                        a["set" + c](r.value);
                      } else "call" === r.type && a[r.methodName]();
                    }
                    f = u.getIframe(), e.originalNode.muted && u.mute();

                    for (var h = ["mouseover", "mouseout"], d = function d(t) {
                      var n = (0, s.createEvent)(t.type, a);
                      e.dispatchEvent(n);
                    }, p = 0, g = h.length; p < g; p++) {
                      f.addEventListener(h[p], d, !1);
                    }

                    for (var v = ["rendererready", "loadedmetadata", "loadeddata", "canplay"], m = 0, y = v.length; m < y; m++) {
                      var x = (0, s.createEvent)(v[m], a);
                      e.dispatchEvent(x);
                    }
                  },
                  onStateChange: function onStateChange(t) {
                    var n = [];

                    switch (t.data) {
                      case -1:
                        n = ["loadedmetadata"], c = !0, d = !1;
                        break;

                      case 0:
                        n = ["ended"], c = !1, d = !a.options.youtube.loop, a.options.youtube.loop || a.stopInterval();
                        break;

                      case 1:
                        n = ["play", "playing"], c = !1, d = !1, a.startInterval();
                        break;

                      case 2:
                        n = ["pause"], c = !0, d = !1, a.stopInterval();
                        break;

                      case 3:
                        n = ["progress"], d = !1;
                        break;

                      case 5:
                        n = ["loadeddata", "loadedmetadata", "canplay"], c = !0, d = !1;
                    }

                    for (var i = 0, r = n.length; i < r; i++) {
                      var o = (0, s.createEvent)(n[i], a);
                      e.dispatchEvent(o);
                    }
                  },
                  onError: function onError(t) {
                    return function (t) {
                      var i = "";

                      switch (t.data) {
                        case 2:
                          i = "The request contains an invalid parameter value. Verify that video ID has 11 characters and that contains no invalid characters, such as exclamation points or asterisks.";
                          break;

                        case 5:
                          i = "The requested content cannot be played in an HTML5 player or another error related to the HTML5 player has occurred.";
                          break;

                        case 100:
                          i = "The video requested was not found. Either video has been removed or has been marked as private.";
                          break;

                        case 101:
                        case 105:
                          i = "The owner of the requested video does not allow it to be played in embedded players.";
                          break;

                        default:
                          i = "Unknown error.";
                      }

                      e.generateError("Code " + t.data + ": " + i, n);
                    }(t);
                  }
                }
              };
              return (S || e.originalNode.hasAttribute("playsinline")) && (M.playerVars.playsinline = 1), e.originalNode.controls && (M.playerVars.controls = 1), e.originalNode.autoplay && (M.playerVars.autoplay = 1), e.originalNode.loop && (M.playerVars.loop = 1), (M.playerVars.loop && 1 === parseInt(M.playerVars.loop, 10) || e.originalNode.src.indexOf("loop=") > -1) && !M.playerVars.playlist && -1 === e.originalNode.src.indexOf("playlist=") && (M.playerVars.playlist = h.getYouTubeId(e.originalNode.src)), h.enqueueIframe(M), a.onEvent = function (t, n, i) {
                null != i && (e.youTubeState = i);
              }, a.setSize = function (e, t) {
                null !== u && u.setSize(e, t);
              }, a.hide = function () {
                a.stopInterval(), a.pause(), f && (f.style.display = "none");
              }, a.show = function () {
                f && (f.style.display = "");
              }, a.destroy = function () {
                u.destroy();
              }, a.interval = null, a.startInterval = function () {
                a.interval = setInterval(function () {
                  var t = (0, s.createEvent)("timeupdate", a);
                  e.dispatchEvent(t);
                }, 250);
              }, a.stopInterval = function () {
                a.interval && clearInterval(a.interval);
              }, a.getPosterUrl = function () {
                var n = t.youtube.imageQuality,
                    i = h.getYouTubeId(e.originalNode.src);
                return n && ["default", "hqdefault", "mqdefault", "sddefault", "maxresdefault"].indexOf(n) > -1 && i ? "https://img.youtube.com/vi/" + i + "/" + n + ".jpg" : "";
              }, a;
            }
          };
          i.default.onYouTubePlayerAPIReady = function () {
            h.iFrameReady();
          }, l.typeChecks.push(function (e) {
            return /\/\/(www\.youtube|youtu\.?be)/i.test(e) ? "video/x-youtube" : null;
          }), a.renderer.add(d);
        }, {
          2: 2,
          26: 26,
          27: 27,
          28: 28,
          3: 3,
          7: 7,
          8: 8
        }],
        25: [function (e, t, n) {
          "use strict";

          Object.defineProperty(n, "__esModule", {
            value: !0
          }), n.cancelFullScreen = n.requestFullScreen = n.isFullScreen = n.FULLSCREEN_EVENT_NAME = n.HAS_NATIVE_FULLSCREEN_ENABLED = n.HAS_TRUE_NATIVE_FULLSCREEN = n.HAS_IOS_FULLSCREEN = n.HAS_MS_NATIVE_FULLSCREEN = n.HAS_MOZ_NATIVE_FULLSCREEN = n.HAS_WEBKIT_NATIVE_FULLSCREEN = n.HAS_NATIVE_FULLSCREEN = n.SUPPORTS_NATIVE_HLS = n.SUPPORT_PASSIVE_EVENT = n.SUPPORT_POINTER_EVENTS = n.HAS_MSE = n.IS_STOCK_ANDROID = n.IS_SAFARI = n.IS_FIREFOX = n.IS_CHROME = n.IS_EDGE = n.IS_IE = n.IS_ANDROID = n.IS_IOS = n.IS_IPOD = n.IS_IPHONE = n.IS_IPAD = n.UA = n.NAV = void 0;
          var i = a(e(3)),
              r = a(e(2)),
              o = a(e(7));

          function a(e) {
            return e && e.__esModule ? e : {
              default: e
            };
          }

          for (var s = n.NAV = i.default.navigator, l = n.UA = s.userAgent.toLowerCase(), u = n.IS_IPAD = /ipad/i.test(l) && !i.default.MSStream, c = n.IS_IPHONE = /iphone/i.test(l) && !i.default.MSStream, h = n.IS_IPOD = /ipod/i.test(l) && !i.default.MSStream, d = (n.IS_IOS = /ipad|iphone|ipod/i.test(l) && !i.default.MSStream, n.IS_ANDROID = /android/i.test(l)), f = n.IS_IE = /(trident|microsoft)/i.test(s.appName), p = n.IS_EDGE = ("msLaunchUri" in s) && !("documentMode" in r.default), g = n.IS_CHROME = /chrome/i.test(l), v = n.IS_FIREFOX = /firefox/i.test(l), m = n.IS_SAFARI = /safari/i.test(l) && !g, y = n.IS_STOCK_ANDROID = /^mozilla\/\d+\.\d+\s\(linux;\su;/i.test(l), x = n.HAS_MSE = ("MediaSource" in i.default), _ = n.SUPPORT_POINTER_EVENTS = function () {
            var e = r.default.createElement("x"),
                t = r.default.documentElement,
                n = i.default.getComputedStyle;
            if (!("pointerEvents" in e.style)) return !1;
            e.style.pointerEvents = "auto", e.style.pointerEvents = "x", t.appendChild(e);
            var o = n && "auto" === (n(e, "") || {}).pointerEvents;
            return e.remove(), !!o;
          }(), b = n.SUPPORT_PASSIVE_EVENT = function () {
            var e = !1;

            try {
              var t = Object.defineProperty({}, "passive", {
                get: function get() {
                  e = !0;
                }
              });
              i.default.addEventListener("test", null, t);
            } catch (e) {}

            return e;
          }(), w = ["source", "track", "audio", "video"], S = void 0, T = 0, C = w.length; T < C; T++) {
            S = r.default.createElement(w[T]);
          }

          var k = n.SUPPORTS_NATIVE_HLS = m || f && /edge/i.test(l),
              M = void 0 !== S.webkitEnterFullscreen,
              E = void 0 !== S.requestFullscreen;
          M && /mac os x 10_5/i.test(l) && (E = !1, M = !1);
          var A = void 0 !== S.webkitRequestFullScreen,
              I = void 0 !== S.mozRequestFullScreen,
              P = void 0 !== S.msRequestFullscreen,
              O = A || I || P,
              L = O,
              D = "",
              N = void 0,
              j = void 0,
              R = void 0;
          I ? L = r.default.mozFullScreenEnabled : P && (L = r.default.msFullscreenEnabled), g && (M = !1), O && (A ? D = "webkitfullscreenchange" : I ? D = "fullscreenchange" : P && (D = "MSFullscreenChange"), n.isFullScreen = N = function N() {
            return I ? r.default.mozFullScreen : A ? r.default.webkitIsFullScreen : P ? null !== r.default.msFullscreenElement : void 0;
          }, n.requestFullScreen = j = function j(e) {
            A ? e.webkitRequestFullScreen() : I ? e.mozRequestFullScreen() : P && e.msRequestFullscreen();
          }, n.cancelFullScreen = R = function R() {
            A ? r.default.webkitCancelFullScreen() : I ? r.default.mozCancelFullScreen() : P && r.default.msExitFullscreen();
          });
          var F = n.HAS_NATIVE_FULLSCREEN = E,
              z = n.HAS_WEBKIT_NATIVE_FULLSCREEN = A,
              B = n.HAS_MOZ_NATIVE_FULLSCREEN = I,
              V = n.HAS_MS_NATIVE_FULLSCREEN = P,
              H = n.HAS_IOS_FULLSCREEN = M,
              W = n.HAS_TRUE_NATIVE_FULLSCREEN = O,
              G = n.HAS_NATIVE_FULLSCREEN_ENABLED = L,
              U = n.FULLSCREEN_EVENT_NAME = D;
          n.isFullScreen = N, n.requestFullScreen = j, n.cancelFullScreen = R, o.default.Features = o.default.Features || {}, o.default.Features.isiPad = u, o.default.Features.isiPod = h, o.default.Features.isiPhone = c, o.default.Features.isiOS = o.default.Features.isiPhone || o.default.Features.isiPad, o.default.Features.isAndroid = d, o.default.Features.isIE = f, o.default.Features.isEdge = p, o.default.Features.isChrome = g, o.default.Features.isFirefox = v, o.default.Features.isSafari = m, o.default.Features.isStockAndroid = y, o.default.Features.hasMSE = x, o.default.Features.supportsNativeHLS = k, o.default.Features.supportsPointerEvents = _, o.default.Features.supportsPassiveEvent = b, o.default.Features.hasiOSFullScreen = H, o.default.Features.hasNativeFullscreen = F, o.default.Features.hasWebkitNativeFullScreen = z, o.default.Features.hasMozNativeFullScreen = B, o.default.Features.hasMsNativeFullScreen = V, o.default.Features.hasTrueNativeFullScreen = W, o.default.Features.nativeFullScreenEnabled = G, o.default.Features.fullScreenEventName = U, o.default.Features.isFullScreen = N, o.default.Features.requestFullScreen = j, o.default.Features.cancelFullScreen = R;
        }, {
          2: 2,
          3: 3,
          7: 7
        }],
        26: [function (e, t, n) {
          "use strict";

          Object.defineProperty(n, "__esModule", {
            value: !0
          }), n.removeClass = n.addClass = n.hasClass = void 0, n.loadScript = s, n.offset = l, n.toggleClass = g, n.fadeOut = v, n.fadeIn = m, n.siblings = y, n.visible = x, n.ajax = _;
          var i = a(e(3)),
              r = a(e(2)),
              o = a(e(7));

          function a(e) {
            return e && e.__esModule ? e : {
              default: e
            };
          }

          function s(e) {
            return new Promise(function (t, n) {
              var i = r.default.createElement("script");
              i.src = e, i.async = !0, i.onload = function () {
                i.remove(), t();
              }, i.onerror = function () {
                i.remove(), n();
              }, r.default.head.appendChild(i);
            });
          }

          function l(e) {
            var t = e.getBoundingClientRect(),
                n = i.default.pageXOffset || r.default.documentElement.scrollLeft,
                o = i.default.pageYOffset || r.default.documentElement.scrollTop;
            return {
              top: t.top + o,
              left: t.left + n
            };
          }

          var u = void 0,
              c = void 0,
              h = void 0;
          "classList" in r.default.documentElement ? (u = function u(e, t) {
            return void 0 !== e.classList && e.classList.contains(t);
          }, c = function c(e, t) {
            return e.classList.add(t);
          }, h = function h(e, t) {
            return e.classList.remove(t);
          }) : (u = function u(e, t) {
            return new RegExp("\\b" + t + "\\b").test(e.className);
          }, c = function c(e, t) {
            d(e, t) || (e.className += " " + t);
          }, h = function h(e, t) {
            e.className = e.className.replace(new RegExp("\\b" + t + "\\b", "g"), "");
          });
          var d = n.hasClass = u,
              f = n.addClass = c,
              p = n.removeClass = h;

          function g(e, t) {
            d(e, t) ? p(e, t) : f(e, t);
          }

          function v(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 400,
                n = arguments[2];
            e.style.opacity || (e.style.opacity = 1);
            var r = null;
            i.default.requestAnimationFrame(function o(a) {
              var s = a - (r = r || a),
                  l = parseFloat(1 - s / t, 2);
              e.style.opacity = l < 0 ? 0 : l, s > t ? n && "function" == typeof n && n() : i.default.requestAnimationFrame(o);
            });
          }

          function m(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 400,
                n = arguments[2];
            e.style.opacity || (e.style.opacity = 0);
            var r = null;
            i.default.requestAnimationFrame(function o(a) {
              var s = a - (r = r || a),
                  l = parseFloat(s / t, 2);
              e.style.opacity = l > 1 ? 1 : l, s > t ? n && "function" == typeof n && n() : i.default.requestAnimationFrame(o);
            });
          }

          function y(e, t) {
            var n = [];
            e = e.parentNode.firstChild;

            do {
              t && !t(e) || n.push(e);
            } while (e = e.nextSibling);

            return n;
          }

          function x(e) {
            return void 0 !== e.getClientRects && "function" === e.getClientRects ? !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length) : !(!e.offsetWidth && !e.offsetHeight);
          }

          function _(e, t, n, r) {
            var o = i.default.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject("Microsoft.XMLHTTP"),
                a = "application/x-www-form-urlencoded; charset=UTF-8",
                s = !1,
                l = "*/".concat("*");

            switch (t) {
              case "text":
                a = "text/plain";
                break;

              case "json":
                a = "application/json, text/javascript";
                break;

              case "html":
                a = "text/html";
                break;

              case "xml":
                a = "application/xml, text/xml";
            }

            "application/x-www-form-urlencoded" !== a && (l = a + ", */*; q=0.01"), o && (o.open("GET", e, !0), o.setRequestHeader("Accept", l), o.onreadystatechange = function () {
              if (!s && 4 === o.readyState) if (200 === o.status) {
                s = !0;
                var e = void 0;

                switch (t) {
                  case "json":
                    e = JSON.parse(o.responseText);
                    break;

                  case "xml":
                    e = o.responseXML;
                    break;

                  default:
                    e = o.responseText;
                }

                n(e);
              } else "function" == typeof r && r(o.status);
            }, o.send());
          }

          o.default.Utils = o.default.Utils || {}, o.default.Utils.offset = l, o.default.Utils.hasClass = d, o.default.Utils.addClass = f, o.default.Utils.removeClass = p, o.default.Utils.toggleClass = g, o.default.Utils.fadeIn = m, o.default.Utils.fadeOut = v, o.default.Utils.siblings = y, o.default.Utils.visible = x, o.default.Utils.ajax = _, o.default.Utils.loadScript = s;
        }, {
          2: 2,
          3: 3,
          7: 7
        }],
        27: [function (e, t, n) {
          "use strict";

          Object.defineProperty(n, "__esModule", {
            value: !0
          }), n.escapeHTML = a, n.debounce = s, n.isObjectEmpty = l, n.splitEvents = u, n.createEvent = c, n.isNodeAfter = h, n.isString = d;
          var i,
              r = e(7),
              o = (i = r) && i.__esModule ? i : {
            default: i
          };

          function a(e) {
            if ("string" != typeof e) throw new Error("Argument passed must be a string");
            var t = {
              "&": "&amp;",
              "<": "&lt;",
              ">": "&gt;",
              '"': "&quot;"
            };
            return e.replace(/[&<>"]/g, function (e) {
              return t[e];
            });
          }

          function s(e, t) {
            var n = this,
                i = arguments,
                r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
            if ("function" != typeof e) throw new Error("First argument must be a function");
            if ("number" != typeof t) throw new Error("Second argument must be a numeric value");
            var o = void 0;
            return function () {
              var a = n,
                  s = i,
                  l = r && !o;
              clearTimeout(o), o = setTimeout(function () {
                o = null, r || e.apply(a, s);
              }, t), l && e.apply(a, s);
            };
          }

          function l(e) {
            return Object.getOwnPropertyNames(e).length <= 0;
          }

          function u(e, t) {
            var n = /^((after|before)print|(before)?unload|hashchange|message|o(ff|n)line|page(hide|show)|popstate|resize|storage)\b/,
                i = {
              d: [],
              w: []
            };
            return (e || "").split(" ").forEach(function (e) {
              var r = e + (t ? "." + t : "");
              r.startsWith(".") ? (i.d.push(r), i.w.push(r)) : i[n.test(e) ? "w" : "d"].push(r);
            }), i.d = i.d.join(" "), i.w = i.w.join(" "), i;
          }

          function c(e, t) {
            if ("string" != typeof e) throw new Error("Event name must be a string");
            var n = e.match(/([a-z]+\.([a-z]+))/i),
                i = {
              target: t
            };
            return null !== n && (e = n[1], i.namespace = n[2]), new window.CustomEvent(e, {
              detail: i
            });
          }

          function h(e, t) {
            return !!(e && t && 2 & e.compareDocumentPosition(t));
          }

          function d(e) {
            return "string" == typeof e;
          }

          o.default.Utils = o.default.Utils || {}, o.default.Utils.escapeHTML = a, o.default.Utils.debounce = s, o.default.Utils.isObjectEmpty = l, o.default.Utils.splitEvents = u, o.default.Utils.createEvent = c, o.default.Utils.isNodeAfter = h, o.default.Utils.isString = d;
        }, {
          7: 7
        }],
        28: [function (e, t, n) {
          "use strict";

          Object.defineProperty(n, "__esModule", {
            value: !0
          }), n.typeChecks = void 0, n.absolutizeUrl = l, n.formatType = u, n.getMimeFromType = c, n.getTypeFromFile = h, n.getExtension = d, n.normalizeExtension = f;
          var i,
              r = e(7),
              o = (i = r) && i.__esModule ? i : {
            default: i
          },
              a = e(27);
          var s = n.typeChecks = [];

          function l(e) {
            if ("string" != typeof e) throw new Error("`url` argument must be a string");
            var t = document.createElement("div");
            return t.innerHTML = '<a href="' + (0, a.escapeHTML)(e) + '">x</a>', t.firstChild.href;
          }

          function u(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "";
            return e && !t ? h(e) : t;
          }

          function c(e) {
            if ("string" != typeof e) throw new Error("`type` argument must be a string");
            return e && e.indexOf(";") > -1 ? e.substr(0, e.indexOf(";")) : e;
          }

          function h(e) {
            if ("string" != typeof e) throw new Error("`url` argument must be a string");

            for (var t = 0, n = s.length; t < n; t++) {
              var i = s[t](e);
              if (i) return i;
            }

            var r = f(d(e)),
                o = "video/mp4";
            return r && (~["mp4", "m4v", "ogg", "ogv", "webm", "flv", "mpeg", "mov"].indexOf(r) ? o = "video/" + r : ~["mp3", "oga", "wav", "mid", "midi"].indexOf(r) && (o = "audio/" + r)), o;
          }

          function d(e) {
            if ("string" != typeof e) throw new Error("`url` argument must be a string");
            var t = e.split("?")[0].split("\\").pop().split("/").pop();
            return ~t.indexOf(".") ? t.substring(t.lastIndexOf(".") + 1) : "";
          }

          function f(e) {
            if ("string" != typeof e) throw new Error("`extension` argument must be a string");

            switch (e) {
              case "mp4":
              case "m4v":
                return "mp4";

              case "webm":
              case "webma":
              case "webmv":
                return "webm";

              case "ogg":
              case "oga":
              case "ogv":
                return "ogg";

              default:
                return e;
            }
          }

          o.default.Utils = o.default.Utils || {}, o.default.Utils.typeChecks = s, o.default.Utils.absolutizeUrl = l, o.default.Utils.formatType = u, o.default.Utils.getMimeFromType = c, o.default.Utils.getTypeFromFile = h, o.default.Utils.getExtension = d, o.default.Utils.normalizeExtension = f;
        }, {
          27: 27,
          7: 7
        }],
        29: [function (e, t, n) {
          "use strict";

          var i,
              r = a(e(2)),
              o = a(e(4));

          function a(e) {
            return e && e.__esModule ? e : {
              default: e
            };
          }

          if ([Element.prototype, CharacterData.prototype, DocumentType.prototype].forEach(function (e) {
            e.hasOwnProperty("remove") || Object.defineProperty(e, "remove", {
              configurable: !0,
              enumerable: !0,
              writable: !0,
              value: function value() {
                this.parentNode.removeChild(this);
              }
            });
          }), function () {
            if ("function" == typeof window.CustomEvent) return !1;

            function e(e, t) {
              t = t || {
                bubbles: !1,
                cancelable: !1,
                detail: void 0
              };
              var n = r.default.createEvent("CustomEvent");
              return n.initCustomEvent(e, t.bubbles, t.cancelable, t.detail), n;
            }

            e.prototype = window.Event.prototype, window.CustomEvent = e;
          }(), "function" != typeof Object.assign && (Object.assign = function (e) {
            if (null == e) throw new TypeError("Cannot convert undefined or null to object");

            for (var t = Object(e), n = 1, i = arguments.length; n < i; n++) {
              var r = arguments[n];
              if (null !== r) for (var o in r) {
                Object.prototype.hasOwnProperty.call(r, o) && (t[o] = r[o]);
              }
            }

            return t;
          }), String.prototype.startsWith || (String.prototype.startsWith = function (e, t) {
            return t = t || 0, this.substr(t, e.length) === e;
          }), Element.prototype.matches || (Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector || function (e) {
            for (var t = (this.document || this.ownerDocument).querySelectorAll(e), n = t.length - 1; --n >= 0 && t.item(n) !== this;) {
              ;
            }

            return n > -1;
          }), window.Element && !Element.prototype.closest && (Element.prototype.closest = function (e) {
            var t = (this.document || this.ownerDocument).querySelectorAll(e),
                n = void 0,
                i = this;

            do {
              for (n = t.length; --n >= 0 && t.item(n) !== i;) {
                ;
              }
            } while (n < 0 && (i = i.parentElement));

            return i;
          }), function () {
            for (var e = 0, t = ["ms", "moz", "webkit", "o"], n = 0; n < t.length && !window.requestAnimationFrame; ++n) {
              window.requestAnimationFrame = window[t[n] + "RequestAnimationFrame"], window.cancelAnimationFrame = window[t[n] + "CancelAnimationFrame"] || window[t[n] + "CancelRequestAnimationFrame"];
            }

            window.requestAnimationFrame || (window.requestAnimationFrame = function (t) {
              var n = new Date().getTime(),
                  i = Math.max(0, 16 - (n - e)),
                  r = window.setTimeout(function () {
                t(n + i);
              }, i);
              return e = n + i, r;
            }), window.cancelAnimationFrame || (window.cancelAnimationFrame = function (e) {
              clearTimeout(e);
            });
          }(), /firefox/i.test(navigator.userAgent)) {
            var s = window.getComputedStyle;

            window.getComputedStyle = function (e, t) {
              var n = s(e, t);
              return null === n ? {
                getPropertyValue: function getPropertyValue() {}
              } : n;
            };
          }

          window.Promise || (window.Promise = o.default), (i = window.Node || window.Element) && i.prototype && null === i.prototype.children && Object.defineProperty(i.prototype, "children", {
            get: function get() {
              for (var e = 0, t = void 0, n = this.childNodes, i = []; t = n[e++];) {
                1 === t.nodeType && i.push(t);
              }

              return i;
            }
          });
        }, {
          2: 2,
          4: 4
        }],
        30: [function (e, t, n) {
          "use strict";

          Object.defineProperty(n, "__esModule", {
            value: !0
          }), n.isDropFrame = a, n.secondsToTimeCode = s, n.timeCodeToSeconds = l, n.calculateTimeFormat = u, n.convertSMPTEtoSeconds = c;
          var i,
              r = e(7),
              o = (i = r) && i.__esModule ? i : {
            default: i
          };

          function a() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 25;
            return !(e % 1 == 0);
          }

          function s(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
                n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
                i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 25,
                r = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 0,
                o = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : "hh:mm:ss";
            e = !e || "number" != typeof e || e < 0 ? 0 : e;
            var s = Math.round(.066666 * i),
                l = Math.round(i),
                u = 24 * Math.round(3600 * i),
                c = Math.round(600 * i),
                h = a(i) ? ";" : ":",
                d = void 0,
                f = void 0,
                p = void 0,
                g = void 0,
                v = Math.round(e * i);

            if (a(i)) {
              v < 0 && (v = u + v), v %= u;
              var m = Math.floor(v / c),
                  y = v % c;
              v += 9 * s * m, y > s && (v += s * Math.floor((y - s) / Math.round(60 * l - s)));
              var x = Math.floor(v / l);
              d = Math.floor(Math.floor(x / 60) / 60), f = Math.floor(x / 60) % 60, p = n ? x % 60 : Math.floor(v / l % 60).toFixed(r);
            } else d = Math.floor(e / 3600) % 24, f = Math.floor(e / 60) % 60, p = n ? Math.floor(e % 60) : Math.floor(e % 60).toFixed(r);

            d = d <= 0 ? 0 : d, p = 60 === (p = p <= 0 ? 0 : p) ? 0 : p, f = 60 === (f = f <= 0 ? 0 : f) ? 0 : f;

            for (var _ = o.split(":"), b = {}, w = 0, S = _.length; w < S; ++w) {
              for (var T = "", C = 0, k = _[w].length; C < k; C++) {
                T.indexOf(_[w][C]) < 0 && (T += _[w][C]);
              }

              ~["f", "s", "m", "h"].indexOf(T) && (b[T] = _[w].length);
            }

            var M = t || d > 0 ? (d < 10 && b.h > 1 ? "0" + d : d) + ":" : "";
            return M += (f < 10 && b.m > 1 ? "0" + f : f) + ":", M += "" + (p < 10 && b.s > 1 ? "0" + p : p), n && (M += (g = (g = (v % l).toFixed(0)) <= 0 ? 0 : g) < 10 && b.f ? h + "0" + g : "" + h + g), M;
          }

          function l(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 25;
            if ("string" != typeof e) throw new TypeError("Time must be a string");
            if (e.indexOf(";") > 0 && (e = e.replace(";", ":")), !/\d{2}(\:\d{2}){0,3}/i.test(e)) throw new TypeError("Time code must have the format `00:00:00`");
            var n = e.split(":"),
                i = void 0,
                r = 0,
                o = 0,
                s = 0,
                l = 0,
                u = 0,
                c = Math.round(.066666 * t),
                h = Math.round(t),
                d = 3600 * h,
                f = 60 * h;

            switch (n.length) {
              default:
              case 1:
                s = parseInt(n[0], 10);
                break;

              case 2:
                o = parseInt(n[0], 10), s = parseInt(n[1], 10);
                break;

              case 3:
                r = parseInt(n[0], 10), o = parseInt(n[1], 10), s = parseInt(n[2], 10);
                break;

              case 4:
                r = parseInt(n[0], 10), o = parseInt(n[1], 10), s = parseInt(n[2], 10), l = parseInt(n[3], 10);
            }

            return i = a(t) ? d * r + f * o + h * s + l - c * ((u = 60 * r + o) - Math.floor(u / 10)) : (d * r + f * o + t * s + l) / t, parseFloat(i.toFixed(3));
          }

          function u(e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 25;
            e = !e || "number" != typeof e || e < 0 ? 0 : e;

            for (var i = Math.floor(e / 3600) % 24, r = Math.floor(e / 60) % 60, o = Math.floor(e % 60), a = Math.floor((e % 1 * n).toFixed(3)), s = [[a, "f"], [o, "s"], [r, "m"], [i, "h"]], l = t.timeFormat, u = l[1] === l[0], c = u ? 2 : 1, h = l.length < c ? l[c] : ":", d = l[0], f = !1, p = 0, g = s.length; p < g; p++) {
              if (~l.indexOf(s[p][1])) f = !0;else if (f) {
                for (var v = !1, m = p; m < g; m++) {
                  if (s[m][0] > 0) {
                    v = !0;
                    break;
                  }
                }

                if (!v) break;
                u || (l = d + l), l = s[p][1] + h + l, u && (l = s[p][1] + l), d = s[p][1];
              }
            }

            t.timeFormat = l;
          }

          function c(e) {
            if ("string" != typeof e) throw new TypeError("Argument must be a string value");

            for (var t = ~(e = e.replace(",", ".")).indexOf(".") ? e.split(".")[1].length : 0, n = 0, i = 1, r = 0, o = (e = e.split(":").reverse()).length; r < o; r++) {
              i = 1, r > 0 && (i = Math.pow(60, r)), n += Number(e[r]) * i;
            }

            return Number(n.toFixed(t));
          }

          o.default.Utils = o.default.Utils || {}, o.default.Utils.secondsToTimeCode = s, o.default.Utils.timeCodeToSeconds = l, o.default.Utils.calculateTimeFormat = u, o.default.Utils.convertSMPTEtoSeconds = c;
        }, {
          7: 7
        }]
      }, {}, [29, 6, 5, 15, 23, 20, 19, 21, 22, 24, 16, 18, 17, 9, 10, 11, 12, 13, 14]);
    }).call(this, n(65), n(941).setImmediate);
  }, function (e, t, n) {
    (function (e) {
      var i = void 0 !== e && e || "undefined" != typeof self && self || window,
          r = Function.prototype.apply;

      function o(e, t) {
        this._id = e, this._clearFn = t;
      }

      t.setTimeout = function () {
        return new o(r.call(setTimeout, i, arguments), clearTimeout);
      }, t.setInterval = function () {
        return new o(r.call(setInterval, i, arguments), clearInterval);
      }, t.clearTimeout = t.clearInterval = function (e) {
        e && e.close();
      }, o.prototype.unref = o.prototype.ref = function () {}, o.prototype.close = function () {
        this._clearFn.call(i, this._id);
      }, t.enroll = function (e, t) {
        clearTimeout(e._idleTimeoutId), e._idleTimeout = t;
      }, t.unenroll = function (e) {
        clearTimeout(e._idleTimeoutId), e._idleTimeout = -1;
      }, t._unrefActive = t.active = function (e) {
        clearTimeout(e._idleTimeoutId);
        var t = e._idleTimeout;
        t >= 0 && (e._idleTimeoutId = setTimeout(function () {
          e._onTimeout && e._onTimeout();
        }, t));
      }, n(942), t.setImmediate = "undefined" != typeof self && self.setImmediate || void 0 !== e && e.setImmediate || this && this.setImmediate, t.clearImmediate = "undefined" != typeof self && self.clearImmediate || void 0 !== e && e.clearImmediate || this && this.clearImmediate;
    }).call(this, n(65));
  }, function (e, t, n) {
    (function (e, t) {
      !function (e, n) {
        "use strict";

        if (!e.setImmediate) {
          var i,
              r,
              o,
              a,
              s,
              l = 1,
              u = {},
              c = !1,
              h = e.document,
              d = Object.getPrototypeOf && Object.getPrototypeOf(e);
          d = d && d.setTimeout ? d : e, "[object process]" === {}.toString.call(e.process) ? i = function i(e) {
            t.nextTick(function () {
              p(e);
            });
          } : !function () {
            if (e.postMessage && !e.importScripts) {
              var t = !0,
                  n = e.onmessage;
              return e.onmessage = function () {
                t = !1;
              }, e.postMessage("", "*"), e.onmessage = n, t;
            }
          }() ? e.MessageChannel ? ((o = new MessageChannel()).port1.onmessage = function (e) {
            p(e.data);
          }, i = function i(e) {
            o.port2.postMessage(e);
          }) : h && "onreadystatechange" in h.createElement("script") ? (r = h.documentElement, i = function i(e) {
            var t = h.createElement("script");
            t.onreadystatechange = function () {
              p(e), t.onreadystatechange = null, r.removeChild(t), t = null;
            }, r.appendChild(t);
          }) : i = function i(e) {
            setTimeout(p, 0, e);
          } : (a = "setImmediate$" + Math.random() + "$", s = function s(t) {
            t.source === e && "string" == typeof t.data && 0 === t.data.indexOf(a) && p(+t.data.slice(a.length));
          }, e.addEventListener ? e.addEventListener("message", s, !1) : e.attachEvent("onmessage", s), i = function i(t) {
            e.postMessage(a + t, "*");
          }), d.setImmediate = function (e) {
            "function" != typeof e && (e = new Function("" + e));

            for (var t = new Array(arguments.length - 1), n = 0; n < t.length; n++) {
              t[n] = arguments[n + 1];
            }

            var r = {
              callback: e,
              args: t
            };
            return u[l] = r, i(l), l++;
          }, d.clearImmediate = f;
        }

        function f(e) {
          delete u[e];
        }

        function p(e) {
          if (c) setTimeout(p, 0, e);else {
            var t = u[e];

            if (t) {
              c = !0;

              try {
                !function (e) {
                  var t = e.callback,
                      n = e.args;

                  switch (n.length) {
                    case 0:
                      t();
                      break;

                    case 1:
                      t(n[0]);
                      break;

                    case 2:
                      t(n[0], n[1]);
                      break;

                    case 3:
                      t(n[0], n[1], n[2]);
                      break;

                    default:
                      t.apply(void 0, n);
                  }
                }(t);
              } finally {
                f(e), c = !1;
              }
            }
          }
        }
      }("undefined" == typeof self ? void 0 === e ? this : e : self);
    }).call(this, n(65), n(943));
  }, function (e, t) {
    var n,
        i,
        r = e.exports = {};

    function o() {
      throw new Error("setTimeout has not been defined");
    }

    function a() {
      throw new Error("clearTimeout has not been defined");
    }

    function s(e) {
      if (n === setTimeout) return setTimeout(e, 0);
      if ((n === o || !n) && setTimeout) return n = setTimeout, setTimeout(e, 0);

      try {
        return n(e, 0);
      } catch (t) {
        try {
          return n.call(null, e, 0);
        } catch (t) {
          return n.call(this, e, 0);
        }
      }
    }

    !function () {
      try {
        n = "function" == typeof setTimeout ? setTimeout : o;
      } catch (e) {
        n = o;
      }

      try {
        i = "function" == typeof clearTimeout ? clearTimeout : a;
      } catch (e) {
        i = a;
      }
    }();
    var l,
        u = [],
        c = !1,
        h = -1;

    function d() {
      c && l && (c = !1, l.length ? u = l.concat(u) : h = -1, u.length && f());
    }

    function f() {
      if (!c) {
        var e = s(d);
        c = !0;

        for (var t = u.length; t;) {
          for (l = u, u = []; ++h < t;) {
            l && l[h].run();
          }

          h = -1, t = u.length;
        }

        l = null, c = !1, function (e) {
          if (i === clearTimeout) return clearTimeout(e);
          if ((i === a || !i) && clearTimeout) return i = clearTimeout, clearTimeout(e);

          try {
            i(e);
          } catch (t) {
            try {
              return i.call(null, e);
            } catch (t) {
              return i.call(this, e);
            }
          }
        }(e);
      }
    }

    function p(e, t) {
      this.fun = e, this.array = t;
    }

    function g() {}

    r.nextTick = function (e) {
      var t = new Array(arguments.length - 1);
      if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) {
        t[n - 1] = arguments[n];
      }
      u.push(new p(e, t)), 1 !== u.length || c || s(f);
    }, p.prototype.run = function () {
      this.fun.apply(null, this.array);
    }, r.title = "browser", r.browser = !0, r.env = {}, r.argv = [], r.version = "", r.versions = {}, r.on = g, r.addListener = g, r.once = g, r.off = g, r.removeListener = g, r.removeAllListeners = g, r.emit = g, r.prependListener = g, r.prependOnceListener = g, r.listeners = function (e) {
      return [];
    }, r.binding = function (e) {
      throw new Error("process.binding is not supported");
    }, r.cwd = function () {
      return "/";
    }, r.chdir = function (e) {
      throw new Error("process.chdir is not supported");
    }, r.umask = function () {
      return 0;
    };
  }, function (e, t, n) {
    var i = n(133),
        r = n(945);
    "string" == typeof (r = r.__esModule ? r.default : r) && (r = [[e.i, r, ""]]);
    var o = {
      insert: "head",
      singleton: !1
    };
    i(r, o);
    e.exports = r.locals || {};
  }, function (e, t, n) {
    var i = n(134),
        r = n(946),
        o = n(947);
    t = i(!1);
    var a = r(o);
    t.push([e.i, ".mejs__offscreen {\n  border: 0;\n  clip: rect(1px, 1px, 1px, 1px);\n  -webkit-clip-path: inset(50%);\n  clip-path: inset(50%);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n  word-wrap: normal;\n}\n.mejs__container {\n  background: #000;\n  font-family: Helvetica,Arial,serif;\n  position: relative;\n  text-align: left;\n  text-indent: 0;\n  vertical-align: top;\n}\n.mejs__container,\n.mejs__container * {\n  box-sizing: border-box;\n}\n.mejs__container video::-webkit-media-controls,\n.mejs__container video::-webkit-media-controls-panel,\n.mejs__container video::-webkit-media-controls-panel-container,\n.mejs__container video::-webkit-media-controls-start-playback-button {\n  -webkit-appearance: none;\n  display: none !important;\n}\n.mejs__fill-container,\n.mejs__fill-container .mejs__container {\n  height: 100%;\n  width: 100%;\n}\n.mejs__fill-container {\n  background: transparent;\n  margin: 0 auto;\n  overflow: hidden;\n  position: relative;\n}\n.mejs__container:focus {\n  outline: none;\n}\n.mejs__iframe-overlay {\n  height: 100%;\n  position: absolute;\n  width: 100%;\n}\n.mejs__embed,\n.mejs__embed body {\n  background: #000;\n  height: 100%;\n  margin: 0;\n  overflow: hidden;\n  padding: 0;\n  width: 100%;\n}\n.mejs__fullscreen {\n  overflow: hidden !important;\n}\n.mejs__container-fullscreen {\n  bottom: 0;\n  left: 0;\n  overflow: hidden;\n  position: fixed;\n  right: 0;\n  top: 0;\n  z-index: 1000;\n}\n.mejs__container-fullscreen .mejs__mediaelement,\n.mejs__container-fullscreen video {\n  height: 100%!important;\n  width: 100% !important;\n}\n.mejs__background,\n.mejs__mediaelement {\n  left: 0;\n  position: absolute;\n  top: 0;\n}\n.mejs__mediaelement {\n  height: 100%;\n  width: 100%;\n  z-index: 0;\n}\n.mejs__poster {\n  background-position: 50% 50%;\n  background-repeat: no-repeat;\n  background-size: cover;\n  left: 0;\n  position: absolute;\n  top: 0;\n  z-index: 1;\n}\n:root .mejs__poster-img {\n  display: none;\n}\n.mejs__poster-img {\n  border: 0;\n  padding: 0;\n}\n.mejs__overlay {\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  left: 0;\n  position: absolute;\n  top: 0;\n}\n.mejs__layer {\n  z-index: 1;\n}\n.mejs__overlay-play {\n  cursor: pointer;\n}\n.mejs__overlay-button {\n  background: url(" + a + ") no-repeat;\n  background-position: 0 -39px;\n  height: 80px;\n  width: 80px;\n}\n.mejs__overlay:hover > .mejs__overlay-button {\n  background-position: -80px -39px;\n}\n.mejs__overlay-loading {\n  height: 80px;\n  width: 80px;\n}\n.mejs__overlay-loading-bg-img {\n  -webkit-animation: a 1s linear infinite;\n  animation: a 1s linear infinite;\n  background: transparent url(" + a + ') -160px -40px no-repeat;\n  display: block;\n  height: 80px;\n  width: 80px;\n  z-index: 1;\n}\n@-webkit-keyframes a {\n  to {\n    -webkit-transform: rotate(1turn);\n    transform: rotate(1turn);\n  }\n}\n@keyframes a {\n  to {\n    -webkit-transform: rotate(1turn);\n    transform: rotate(1turn);\n  }\n}\n.mejs__controls {\n  bottom: 0;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  height: 40px;\n  left: 0;\n  list-style-type: none;\n  margin: 0;\n  padding: 0 10px;\n  position: absolute;\n  width: 100%;\n  z-index: 3;\n}\n.mejs__controls:not([style*="display: none"]) {\n  background: rgba(255, 0, 0, 0.7);\n  background: -webkit-linear-gradient(transparent, rgba(0, 0, 0, 0.35));\n  background: linear-gradient(transparent, rgba(0, 0, 0, 0.35));\n}\n.mejs__button,\n.mejs__time,\n.mejs__time-rail {\n  font-size: 10px;\n  height: 40px;\n  line-height: 10px;\n  margin: 0;\n  width: 32px;\n}\n.mejs__button > button {\n  background: transparent url(' + a + ");\n  border: 0;\n  cursor: pointer;\n  display: block;\n  font-size: 0;\n  height: 20px;\n  line-height: 0;\n  margin: 10px 6px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  text-decoration: none;\n  width: 20px;\n}\n.mejs__button > button:focus {\n  outline: 1px dotted #999;\n}\n.mejs__container-keyboard-inactive [role=slider],\n.mejs__container-keyboard-inactive [role=slider]:focus,\n.mejs__container-keyboard-inactive a,\n.mejs__container-keyboard-inactive a:focus,\n.mejs__container-keyboard-inactive button,\n.mejs__container-keyboard-inactive button:focus {\n  outline: 0;\n}\n.mejs__time {\n  box-sizing: content-box;\n  color: #fff;\n  font-size: 11px;\n  font-weight: 700;\n  height: 24px;\n  overflow: hidden;\n  padding: 16px 6px 0;\n  text-align: center;\n  width: auto;\n}\n.mejs__play > button {\n  background-position: 0 0;\n}\n.mejs__pause > button {\n  background-position: -20px 0;\n}\n.mejs__replay > button {\n  background-position: -160px 0;\n}\n.mejs__time-rail {\n  direction: ltr;\n  -webkit-box-flex: 1;\n  -webkit-flex-grow: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  height: 40px;\n  margin: 0 10px;\n  padding-top: 10px;\n  position: relative;\n}\n.mejs__time-buffering,\n.mejs__time-current,\n.mejs__time-float,\n.mejs__time-float-corner,\n.mejs__time-float-current,\n.mejs__time-hovered,\n.mejs__time-loaded,\n.mejs__time-marker,\n.mejs__time-total {\n  border-radius: 2px;\n  cursor: pointer;\n  display: block;\n  height: 10px;\n  position: absolute;\n}\n.mejs__time-total {\n  background: rgba(255, 255, 255, 0.3);\n  margin: 5px 0 0;\n  width: 100%;\n}\n.mejs__time-buffering {\n  -webkit-animation: b 2s linear infinite;\n  animation: b 2s linear infinite;\n  background: -webkit-linear-gradient(135deg, rgba(255, 255, 255, 0.4) 25%, transparent 0, transparent 50%, rgba(255, 255, 255, 0.4) 0, rgba(255, 255, 255, 0.4) 75%, transparent 0, transparent);\n  background: linear-gradient(-45deg, rgba(255, 255, 255, 0.4) 25%, transparent 0, transparent 50%, rgba(255, 255, 255, 0.4) 0, rgba(255, 255, 255, 0.4) 75%, transparent 0, transparent);\n  background-size: 15px 15px;\n  width: 100%;\n}\n@-webkit-keyframes b {\n  0% {\n    background-position: 0 0;\n  }\n  to {\n    background-position: 30px 0;\n  }\n}\n@keyframes b {\n  0% {\n    background-position: 0 0;\n  }\n  to {\n    background-position: 30px 0;\n  }\n}\n.mejs__time-loaded {\n  background: rgba(255, 255, 255, 0.3);\n}\n.mejs__time-current,\n.mejs__time-handle-content {\n  background: rgba(255, 255, 255, 0.9);\n}\n.mejs__time-hovered {\n  background: rgba(255, 255, 255, 0.5);\n  z-index: 10;\n}\n.mejs__time-hovered.negative {\n  background: rgba(0, 0, 0, 0.2);\n}\n.mejs__time-buffering,\n.mejs__time-current,\n.mejs__time-hovered,\n.mejs__time-loaded {\n  left: 0;\n  -webkit-transform: scaleX(0);\n  -ms-transform: scaleX(0);\n  transform: scaleX(0);\n  -webkit-transform-origin: 0 0;\n  -ms-transform-origin: 0 0;\n  transform-origin: 0 0;\n  -webkit-transition: all 0.15s ease-in;\n  transition: all 0.15s ease-in;\n  width: 100%;\n}\n.mejs__time-buffering {\n  -webkit-transform: scaleX(1);\n  -ms-transform: scaleX(1);\n  transform: scaleX(1);\n}\n.mejs__time-hovered {\n  -webkit-transition: height 0.1s cubic-bezier(0.44, 0, 1, 1);\n  transition: height 0.1s cubic-bezier(0.44, 0, 1, 1);\n}\n.mejs__time-hovered.no-hover {\n  -webkit-transform: scaleX(0) !important;\n  -ms-transform: scaleX(0) !important;\n  transform: scaleX(0) !important;\n}\n.mejs__time-handle,\n.mejs__time-handle-content {\n  border: 4px solid transparent;\n  cursor: pointer;\n  left: 0;\n  position: absolute;\n  -webkit-transform: translateX(0);\n  -ms-transform: translateX(0);\n  transform: translateX(0);\n  z-index: 11;\n}\n.mejs__time-handle-content {\n  border: 4px solid rgba(255, 255, 255, 0.9);\n  border-radius: 50%;\n  height: 10px;\n  left: -7px;\n  top: -4px;\n  -webkit-transform: scale(0);\n  -ms-transform: scale(0);\n  transform: scale(0);\n  width: 10px;\n}\n.mejs__time-rail .mejs__time-handle-content:active,\n.mejs__time-rail .mejs__time-handle-content:focus,\n.mejs__time-rail:hover .mejs__time-handle-content {\n  -webkit-transform: scale(1);\n  -ms-transform: scale(1);\n  transform: scale(1);\n}\n.mejs__time-float {\n  background: #eee;\n  border: 1px solid #333;\n  bottom: 100%;\n  color: #111;\n  display: none;\n  height: 17px;\n  margin-bottom: 9px;\n  position: absolute;\n  text-align: center;\n  -webkit-transform: translateX(-50%);\n  -ms-transform: translateX(-50%);\n  transform: translateX(-50%);\n  width: 36px;\n}\n.mejs__time-float-current {\n  display: block;\n  left: 0;\n  margin: 2px;\n  text-align: center;\n  width: 30px;\n}\n.mejs__time-float-corner {\n  border: 5px solid #eee;\n  border-color: #eee transparent transparent;\n  border-radius: 0;\n  display: block;\n  height: 0;\n  left: 50%;\n  line-height: 0;\n  position: absolute;\n  top: 100%;\n  -webkit-transform: translateX(-50%);\n  -ms-transform: translateX(-50%);\n  transform: translateX(-50%);\n  width: 0;\n}\n.mejs__long-video .mejs__time-float {\n  margin-left: -23px;\n  width: 64px;\n}\n.mejs__long-video .mejs__time-float-current {\n  width: 60px;\n}\n.mejs__broadcast {\n  color: #fff;\n  height: 10px;\n  position: absolute;\n  top: 15px;\n  width: 100%;\n}\n.mejs__fullscreen-button > button {\n  background-position: -80px 0;\n}\n.mejs__unfullscreen > button {\n  background-position: -100px 0;\n}\n.mejs__mute > button {\n  background-position: -60px 0;\n}\n.mejs__unmute > button {\n  background-position: -40px 0;\n}\n.mejs__volume-button {\n  position: relative;\n}\n.mejs__volume-button > .mejs__volume-slider {\n  -webkit-backface-visibility: hidden;\n  background: rgba(50, 50, 50, 0.7);\n  border-radius: 0;\n  bottom: 100%;\n  display: none;\n  height: 115px;\n  left: 50%;\n  margin: 0;\n  position: absolute;\n  -webkit-transform: translateX(-50%);\n  -ms-transform: translateX(-50%);\n  transform: translateX(-50%);\n  width: 25px;\n  z-index: 1;\n}\n.mejs__volume-button:hover {\n  border-radius: 0 0 4px 4px;\n}\n.mejs__volume-total {\n  background: rgba(255, 255, 255, 0.5);\n  height: 100px;\n  left: 50%;\n  margin: 0;\n  position: absolute;\n  top: 8px;\n  -webkit-transform: translateX(-50%);\n  -ms-transform: translateX(-50%);\n  transform: translateX(-50%);\n  width: 2px;\n}\n.mejs__volume-current {\n  left: 0;\n  margin: 0;\n  width: 100%;\n}\n.mejs__volume-current,\n.mejs__volume-handle {\n  background: rgba(255, 255, 255, 0.9);\n  position: absolute;\n}\n.mejs__volume-handle {\n  border-radius: 1px;\n  cursor: ns-resize;\n  height: 6px;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n  -ms-transform: translateX(-50%);\n  transform: translateX(-50%);\n  width: 16px;\n}\n.mejs__horizontal-volume-slider {\n  display: block;\n  height: 36px;\n  position: relative;\n  vertical-align: middle;\n  width: 56px;\n}\n.mejs__horizontal-volume-total {\n  background: rgba(50, 50, 50, 0.8);\n  height: 8px;\n  top: 16px;\n  width: 50px;\n}\n.mejs__horizontal-volume-current,\n.mejs__horizontal-volume-total {\n  border-radius: 2px;\n  font-size: 1px;\n  left: 0;\n  margin: 0;\n  padding: 0;\n  position: absolute;\n}\n.mejs__horizontal-volume-current {\n  background: rgba(255, 255, 255, 0.8);\n  height: 100%;\n  top: 0;\n  width: 100%;\n}\n.mejs__horizontal-volume-handle {\n  display: none;\n}\n.mejs__captions-button,\n.mejs__chapters-button {\n  position: relative;\n}\n.mejs__captions-button > button {\n  background-position: -140px 0;\n}\n.mejs__chapters-button > button {\n  background-position: -180px 0;\n}\n.mejs__captions-button > .mejs__captions-selector,\n.mejs__chapters-button > .mejs__chapters-selector {\n  background: rgba(50, 50, 50, 0.7);\n  border: 1px solid transparent;\n  border-radius: 0;\n  bottom: 100%;\n  margin-right: -43px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  right: 50%;\n  visibility: visible;\n  width: 86px;\n}\n.mejs__chapters-button > .mejs__chapters-selector {\n  margin-right: -55px;\n  width: 110px;\n}\n.mejs__captions-selector-list,\n.mejs__chapters-selector-list {\n  list-style-type: none!important;\n  margin: 0;\n  overflow: hidden;\n  padding: 0;\n}\n.mejs__captions-selector-list-item,\n.mejs__chapters-selector-list-item {\n  color: #fff;\n  cursor: pointer;\n  display: block;\n  list-style-type: none!important;\n  margin: 0 0 6px;\n  overflow: hidden;\n  padding: 0;\n}\n.mejs__captions-selector-list-item:hover,\n.mejs__chapters-selector-list-item:hover {\n  background-color: #c8c8c8!important;\n  background-color: rgba(255, 255, 255, 0.4) !important;\n}\n.mejs__captions-selector-input,\n.mejs__chapters-selector-input {\n  clear: both;\n  float: left;\n  left: -1000px;\n  margin: 3px 3px 0 5px;\n  position: absolute;\n}\n.mejs__captions-selector-label,\n.mejs__chapters-selector-label {\n  cursor: pointer;\n  float: left;\n  font-size: 10px;\n  line-height: 15px;\n  padding: 4px 10px 0;\n  width: 100%;\n}\n.mejs__captions-selected,\n.mejs__chapters-selected {\n  color: #21f8f8;\n}\n.mejs__captions-translations {\n  font-size: 10px;\n  margin: 0 0 5px;\n}\n.mejs__captions-layer {\n  bottom: 0;\n  color: #fff;\n  font-size: 16px;\n  left: 0;\n  line-height: 20px;\n  position: absolute;\n  text-align: center;\n}\n.mejs__captions-layer a {\n  color: #fff;\n  text-decoration: underline;\n}\n.mejs__captions-layer[lang=ar] {\n  font-size: 20px;\n  font-weight: 400;\n}\n.mejs__captions-position {\n  bottom: 15px;\n  left: 0;\n  position: absolute;\n  width: 100%;\n}\n.mejs__captions-position-hover {\n  bottom: 35px;\n}\n.mejs__captions-text,\n.mejs__captions-text * {\n  background: rgba(20, 20, 20, 0.5);\n  box-shadow: 5px 0 0 rgba(20, 20, 20, 0.5), -5px 0 0 rgba(20, 20, 20, 0.5);\n  padding: 0;\n  white-space: pre-wrap;\n}\n.mejs__container.mejs__hide-cues video::-webkit-media-text-track-container {\n  display: none;\n}\n.mejs__overlay-error {\n  position: relative;\n}\n.mejs__overlay-error > img {\n  left: 0;\n  max-width: 100%;\n  position: absolute;\n  top: 0;\n  z-index: -1;\n}\n.mejs__cannotplay,\n.mejs__cannotplay a {\n  color: #fff;\n  font-size: 0.8em;\n}\n.mejs__cannotplay {\n  position: relative;\n}\n.mejs__cannotplay a,\n.mejs__cannotplay p {\n  display: inline-block;\n  padding: 0 15px;\n  width: 100%;\n}\n", ""]), e.exports = t;
  }, function (e, t, n) {
    "use strict";

    e.exports = function (e, t) {
      return t || (t = {}), "string" != typeof (e = e && e.__esModule ? e.default : e) ? e : (/^['"].*['"]$/.test(e) && (e = e.slice(1, -1)), t.hash && (e += t.hash), /["'() \t\n]/.test(e) || t.needQuotes ? '"'.concat(e.replace(/"/g, '\\"').replace(/\n/g, "\\n"), '"') : e);
    };
  }, function (e, t, n) {
    "use strict";

    n.r(t), t.default = "data:image/svg+xml;base64,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";
  }, function (e, t, n) {
    var i = n(133),
        r = n(949);
    "string" == typeof (r = r.__esModule ? r.default : r) && (r = [[e.i, r, ""]]);
    var o = {
      insert: "head",
      singleton: !1
    };
    i(r, o);
    e.exports = r.locals || {};
  }, function (e, t, n) {
    (t = n(134)(!1)).push([e.i, ".rde-canvas {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n}\n.rde-canvas iframe {\n  pointer-events: none;\n}\n", ""]), e.exports = t;
  }, function (e, t, n) {
    var i = n(133),
        r = n(951);
    "string" == typeof (r = r.__esModule ? r.default : r) && (r = [[e.i, r, ""]]);
    var o = {
      insert: "head",
      singleton: !1
    };
    i(r, o);
    e.exports = r.locals || {};
  }, function (e, t, n) {
    (t = n(134)(!1)).push([e.i, ".rde-tooltip {\n  position: fixed;\n  -moz-animation: visibility .3s linear;\n  -webkit-animation: visibility .3s linear;\n  animation: visibility .3s linear;\n  z-index: 600000;\n}\n.rde-tooltip-right {\n  position: relative;\n  border-radius: 4px;\n  background: rgba(0, 0, 0, 0.35);\n  color: #fff;\n  font-size: 14px;\n  padding: 8px;\n  margin-left: 12px;\n}\n.rde-tooltip-right::after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 0;\n  /* To the left of the tooltip */\n  margin-left: -10px;\n  margin-top: -5px;\n  border-width: 5px;\n  border-style: solid;\n  border-color: transparent rgba(0, 0, 0, 0.35) transparent transparent;\n}\n.rde-tooltip-left {\n  position: relative;\n  border-radius: 4px;\n  background: rgba(0, 0, 0, 0.35);\n  color: #fff;\n  font-size: 14px;\n  padding: 8px;\n}\n.rde-tooltip-left::after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 100%;\n  /* To the left of the tooltip */\n  margin-top: -5px;\n  border-width: 5px;\n  border-style: solid;\n  border-color: transparent transparent transparent rgba(0, 0, 0, 0.35);\n}\n.rde-tooltip.tooltip-hidden {\n  display: none;\n  top: 0;\n  left: 0;\n}\n", ""]), e.exports = t;
  }, function (e, t, n) {
    var i = n(133),
        r = n(953);
    "string" == typeof (r = r.__esModule ? r.default : r) && (r = [[e.i, r, ""]]);
    var o = {
      insert: "head",
      singleton: !1
    };
    i(r, o);
    e.exports = r.locals || {};
  }, function (e, t, n) {
    (t = n(134)(!1)).push([e.i, ".rde-contextmenu {\n  position: fixed;\n  -moz-animation: visibility .3s linear;\n  -webkit-animation: visibility .3s linear;\n  animation: visibility .3s linear;\n  z-index: 600000;\n}\n.rde-contextmenu-right {\n  position: relative;\n  border-radius: 4px;\n  background: rgba(0, 0, 0, 0.35);\n  color: #fff;\n  font-size: 14px;\n  padding: 8px;\n  margin-left: 12px;\n}\n.rde-contextmenu-left {\n  position: relative;\n  border-radius: 4px;\n  background: rgba(0, 0, 0, 0.35);\n  color: #fff;\n  font-size: 14px;\n  padding: 8px;\n}\n.rde-contextmenu.contextmenu-hidden {\n  display: none;\n  top: 0;\n  left: 0;\n}\n", ""]), e.exports = t;
  }, function (e, t, n) {
    var i = n(133),
        r = n(955);
    "string" == typeof (r = r.__esModule ? r.default : r) && (r = [[e.i, r, ""]]);
    var o = {
      insert: "head",
      singleton: !1
    };
    i(r, o);
    e.exports = r.locals || {};
  }, function (e, t, n) {
    (t = n(134)(!1)).push([e.i, ".canvas-container {\n  outline: none;\n}\n", ""]), e.exports = t;
  }, function (e, t, n) {
    "use strict";

    n.r(t), n.d(t, "Canvas", function () {
      return Ti;
    }), n.d(t, "CanvasObject", function () {
      return li;
    }), n.d(t, "Handler", function () {
      return xi;
    }), n.d(t, "ImageHandler", function () {
      return U;
    }), n.d(t, "ChartHandler", function () {
      return Y;
    }), n.d(t, "ElementHandler", function () {
      return X;
    }), n.d(t, "CropHandler", function () {
      return q;
    }), n.d(t, "AnimationHandler", function () {
      return et;
    }), n.d(t, "ContextmenuHandler", function () {
      return ot;
    }), n.d(t, "TooltipHandler", function () {
      return at;
    }), n.d(t, "TransactionHandler", function () {
      return ut;
    }), n.d(t, "ZoomHandler", function () {
      return ct;
    }), n.d(t, "WorkareaHandler", function () {
      return ft;
    }), n.d(t, "InteractionHandler", function () {
      return pt;
    }), n.d(t, "GridHandler", function () {
      return mt;
    }), n.d(t, "PortHandler", function () {
      return xt;
    }), n.d(t, "LinkHandler", function () {
      return $n;
    }), n.d(t, "NodeHandler", function () {
      return Qn;
    }), n.d(t, "AlignmentHandler", function () {
      return Jn;
    }), n.d(t, "GuidelineHandler", function () {
      return ei;
    }), n.d(t, "EventHandler", function () {
      return ii;
    }), n.d(t, "DrawingHandler", function () {
      return ri;
    }), n.d(t, "ShortcutHandler", function () {
      return oi;
    }), n.d(t, "toObject", function () {
      return Ct;
    }), n.d(t, "Gif", function () {
      return bt;
    }), n.d(t, "Arrow", function () {
      return St;
    }), n.d(t, "Chart", function () {
      return Mt;
    }), n.d(t, "Element", function () {
      return It;
    }), n.d(t, "Iframe", function () {
      return Ot;
    }), n.d(t, "Video", function () {
      return Dt;
    }), n.d(t, "Node", function () {
      return Dn;
    }), n.d(t, "Link", function () {
      return jn;
    }), n.d(t, "CurvedLink", function () {
      return Fn;
    }), n.d(t, "OrthogonalLink", function () {
      return Bn;
    }), n.d(t, "Port", function () {
      return Cn;
    }), n.d(t, "Line", function () {
      return Hn;
    }), n.d(t, "CirclePort", function () {
      return Gn;
    }), n.d(t, "Cube", function () {
      return Yn;
    }), n.d(t, "Svg", function () {
      return qn;
    });
    var i = {};
    n.r(i), n.d(i, "canvasOption", function () {
      return ui;
    }), n.d(i, "keyEvent", function () {
      return ci;
    }), n.d(i, "gridOption", function () {
      return hi;
    }), n.d(i, "workareaOption", function () {
      return di;
    }), n.d(i, "objectOption", function () {
      return fi;
    }), n.d(i, "guidelineOption", function () {
      return pi;
    }), n.d(i, "activeSelectionOption", function () {
      return gi;
    }), n.d(i, "propertiesToInclude", function () {
      return vi;
    });

    var r = n(28),
        o = n.n(r),
        a = n(7),
        s = n.n(a),
        l = n(32),
        u = n.n(l),
        c = n(56),
        h = n.n(c),
        d = n(369),
        f = n.n(d),
        p = n(370),
        g = n.n(p),
        v = n(237),
        m = n.n(v),
        y = n(0),
        x = n.n(y),
        _ = n(110),
        b = n.n(_),
        w = n(2),
        S = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || "undefined" != typeof msCrypto && "function" == typeof msCrypto.getRandomValues && msCrypto.getRandomValues.bind(msCrypto),
        T = new Uint8Array(16);

    function C() {
      if (!S) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
      return S(T);
    }

    for (var k = [], M = 0; M < 256; ++M) {
      k[M] = (M + 256).toString(16).substr(1);
    }

    var E = function E(e, t) {
      var n = t || 0,
          i = k;
      return [i[e[n++]], i[e[n++]], i[e[n++]], i[e[n++]], "-", i[e[n++]], i[e[n++]], "-", i[e[n++]], i[e[n++]], "-", i[e[n++]], i[e[n++]], "-", i[e[n++]], i[e[n++]], i[e[n++]], i[e[n++]], i[e[n++]], i[e[n++]]].join("");
    };

    var A = function A(e, t, n) {
      var i = t && n || 0;
      "string" == typeof e && (t = "binary" === e ? new Array(16) : null, e = null);
      var r = (e = e || {}).random || (e.rng || C)();
      if (r[6] = 15 & r[6] | 64, r[8] = 63 & r[8] | 128, t) for (var o = 0; o < 16; ++o) {
        t[i + o] = r[o];
      }
      return t || E(r);
    },
        I = n(371),
        P = n(29),
        O = n.n(P),
        L = n(44),
        D = n.n(L),
        N = n(72),
        j = n.n(N),
        R = n(372),
        F = n(238),
        z = n.n(F);

    function B(e, t) {
      var n = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        t && (i = i.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, i);
      }

      return n;
    }

    function V(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? B(Object(n), !0).forEach(function (t) {
          x()(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : B(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }

      return e;
    }

    var H = ["grayscale", "invert", "remove-color", "sepia", "brownie", "brightness", "contrast", "saturation", "noise", "vintage", "pixelate", "blur", "sharpen", "emboss", "technicolor", "polaroid", "blend-color", "gamma", "kodachrome", "blackwhite", "blend-image", "hue", "resize", "tint", "mask", "multiply", "sepia2"],
        W = [0, -1, 0, -1, 5, -1, 0, -1, 0],
        G = [1, 1, 1, 1, .7, -1, -1, -1, -1],
        U = function e(t) {
      var n = this;
      s()(this, e), x()(this, "handler", void 0), x()(this, "createFilter", function (e) {
        var t = e.type,
            n = o()(e, ["type"]),
            i = t.toLowerCase();
        return "grayscale" === i ? new w.fabric.Image.filters.Grayscale(n) : "invert" === i ? new w.fabric.Image.filters.Invert() : "sepia" === i ? new w.fabric.Image.filters.Sepia() : "brightness" === i ? new w.fabric.Image.filters.Brightness({
          brightness: n.brightness
        }) : "contrast" === i ? new w.fabric.Image.filters.Contrast(n) : "saturation" === i ? new w.fabric.Image.filters.Saturation(n) : "noise" === i ? new w.fabric.Image.filters.Noise({
          noise: n.noise
        }) : "pixelate" === i ? new w.fabric.Image.filters.Pixelate(n) : "sharpen" === i ? new w.fabric.Image.filters.Convolute({
          matrix: W
        }) : "emboss" === i ? new w.fabric.Image.filters.Convolute({
          matrix: G
        }) : "blend-color" === i ? new w.fabric.Image.filters.BlendColor(n) : "blend-image" === i ? new w.fabric.Image.filters.BlendImage(n) : "resize" === i ? new w.fabric.Image.filters.Resize(n) : "tint" === i ? new w.fabric.Image.filters.Tint(n) : "mask" === i ? new w.fabric.Image.filters.Mask({
          channel: n.channel,
          mask: n.mask
        }) : "multiply" === i ? new w.fabric.Image.filters.Multiply({
          color: n.color
        }) : "sepia2" === i && new w.fabric.Image.filters.Sepia2(n);
      }), x()(this, "createFilters", function (e) {
        return e.reduce(function (e, t) {
          var i = t.type;
          "convolute" === i.toLowerCase() && z()(t.matrix, W) ? i = "sharpen" : "convolute" === i.toLowerCase() && z()(t.matrix, G) && (i = "emboss");
          var r = H.findIndex(function (e) {
            return i.toLowerCase() === e;
          });
          return r > -1 && (e[r] = n.createFilter(V(V({}, t), {}, {
            type: i
          }))), e;
        }, []);
      }), x()(this, "applyFilterByType", function (e) {
        var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
            i = arguments.length > 2 ? arguments[2] : void 0,
            r = arguments.length > 3 ? arguments[3] : void 0,
            o = r || n.handler.canvas.getActiveObject(),
            a = H.findIndex(function (t) {
          return t === e;
        });
        o.filters && a > -1 && (t ? (o.filters[a] = n.createFilter(V({
          type: e
        }, i)), o.applyFilters()) : (o.filters[a] = !1, o.applyFilters()), n.handler.canvas.requestRenderAll());
      }), x()(this, "applyFilter", function (e, t, i) {
        var r = i || n.handler.canvas.getActiveObject();
        r.filters && (r.filters[e] = t, r.applyFilters(), n.handler.canvas.requestRenderAll());
      }), x()(this, "applyFilterValue", function (e, t, i, r) {
        var o = r || n.handler.canvas.getActiveObject();

        if (o.filters) {
          var a = o.filters[e];
          a && (a.setOptions(x()({}, t, i)), o.applyFilters(), n.handler.canvas.requestRenderAll());
        }
      }), x()(this, "applyGrayscale", function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
            t = arguments.length > 1 ? arguments[1] : void 0,
            i = arguments.length > 2 ? arguments[2] : void 0;
        n.applyFilter(0, e && new w.fabric.Image.filters.Grayscale(t ? {
          mode: t
        } : void 0), i);
      }), x()(this, "applyInvert", function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
            t = arguments.length > 1 ? arguments[1] : void 0;
        n.applyFilter(1, e && new w.fabric.Image.filters.Invert(), t);
      }), x()(this, "applySepia", function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
            t = arguments.length > 1 ? arguments[1] : void 0;
        n.applyFilter(3, e && new w.fabric.Image.filters.Sepia(), t);
      }), x()(this, "applyBrightness", function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
            t = arguments.length > 1 ? arguments[1] : void 0,
            i = arguments.length > 2 ? arguments[2] : void 0;
        n.applyFilter(5, e && new w.fabric.Image.filters.Brightness(t ? {
          brightness: t
        } : void 0), i);
      }), x()(this, "applyContrast", function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
            t = arguments.length > 1 ? arguments[1] : void 0,
            i = arguments.length > 2 ? arguments[2] : void 0;
        n.applyFilter(6, e && new w.fabric.Image.filters.Contrast(t ? {
          contrast: t
        } : void 0), i);
      }), x()(this, "applySaturation", function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
            t = arguments.length > 1 ? arguments[1] : void 0,
            i = arguments.length > 2 ? arguments[2] : void 0;
        n.applyFilter(7, e && new w.fabric.Image.filters.Saturation(t ? {
          saturation: t
        } : void 0), i);
      }), x()(this, "applyNoise", function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
            t = arguments.length > 1 ? arguments[1] : void 0,
            i = arguments.length > 2 ? arguments[2] : void 0;
        n.applyFilter(8, e && new w.fabric.Image.filters.Noise(t ? {
          noise: t
        } : void 0), i);
      }), x()(this, "applyPixelate", function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
            t = arguments.length > 1 ? arguments[1] : void 0,
            i = arguments.length > 2 ? arguments[2] : void 0;
        n.applyFilter(10, e && new w.fabric.Image.filters.Pixelate(t ? {
          blocksize: t
        } : void 0), i);
      }), x()(this, "applySharpen", function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
            t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : W,
            i = arguments.length > 2 ? arguments[2] : void 0;
        n.applyFilter(12, e && new w.fabric.Image.filters.Convolute(t ? {
          matrix: t
        } : void 0), i);
      }), x()(this, "applyEmboss", function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
            t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : G,
            i = arguments.length > 2 ? arguments[2] : void 0;
        n.applyFilter(13, e && new w.fabric.Image.filters.Convolute(t ? {
          matrix: t
        } : void 0), i);
      }), x()(this, "applyBlendColor", function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
            t = arguments.length > 1 ? arguments[1] : void 0,
            i = arguments.length > 2 ? arguments[2] : void 0;
        n.applyFilter(16, e && new w.fabric.Image.filters.BlendColor(t), i);
      }), x()(this, "applyBlendImage", function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
            t = arguments.length > 1 ? arguments[1] : void 0,
            i = arguments.length > 2 ? arguments[2] : void 0;
        n.applyFilter(20, e && new w.fabric.Image.filters.BlendImage(t), i);
      }), x()(this, "applyResize", function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
            t = arguments.length > 1 ? arguments[1] : void 0,
            i = arguments.length > 2 ? arguments[2] : void 0;
        n.applyFilter(22, e && new w.fabric.Image.filters.Resize(t), i);
      }), x()(this, "applyTint", function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
            t = arguments.length > 1 ? arguments[1] : void 0,
            i = arguments.length > 2 ? arguments[2] : void 0;
        n.applyFilter(23, e && new w.fabric.Image.filters.Tint(t), i);
      }), x()(this, "applyMask", function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
            t = arguments.length > 1 ? arguments[1] : void 0,
            i = arguments.length > 2 ? arguments[2] : void 0;
        n.applyFilter(24, e && new w.fabric.Image.filters.Mask(t), i);
      }), x()(this, "applyMultiply", function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
            t = arguments.length > 1 ? arguments[1] : void 0,
            i = arguments.length > 2 ? arguments[2] : void 0;
        n.applyFilter(25, e && new w.fabric.Image.filters.Multiply(t), i);
      }), x()(this, "applySepia2", function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
            t = arguments.length > 1 ? arguments[1] : void 0;
        n.applyFilter(26, e && new w.fabric.Image.filters.Sepia2(), t);
      }), x()(this, "applyGradientTransparency", function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
            t = arguments.length > 1 ? arguments[1] : void 0,
            i = arguments.length > 2 ? arguments[2] : void 0;
        n.applyFilter(27, e && new w.fabric.Image.filters.GradientTransparency(t), i);
      }), x()(this, "applyColorMatrix", function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
            t = arguments.length > 1 ? arguments[1] : void 0,
            i = arguments.length > 2 ? arguments[2] : void 0;
        n.applyFilter(28, e && new w.fabric.Image.filters.ColorMatrix(t), i);
      }), x()(this, "applyRemoveWhite", function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
            t = arguments.length > 1 ? arguments[1] : void 0,
            i = arguments.length > 2 ? arguments[2] : void 0;
        n.applyFilter(29, e && new w.fabric.Image.filters.RemoveWhite(t), i);
      }), this.handler = t;
    },
        Y = function e(t) {
      s()(this, e), x()(this, "handler", void 0), x()(this, "instance", void 0), this.handler = t;
    },
        X = function e(t) {
      var n = this;
      s()(this, e), x()(this, "handler", void 0), x()(this, "setById", function (e, t) {
        var i = n.handler.findById(e);
        i && n.set(i, t);
      }), x()(this, "set", function (e, t) {
        e.setSource(t);
      }), x()(this, "findById", function (e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "container";
        return document.getElementById("".concat(e, "_").concat(t));
      }), x()(this, "remove", function (e) {
        e && n.handler.container.removeChild(e);
      }), x()(this, "removeById", function (e) {
        var t = n.findById(e),
            i = n.findById(e, "script"),
            r = n.findById(e, "style");
        t && (t.remove ? t.remove() : n.remove(t)), i && (i.remove ? i.remove() : document.head.removeChild(i)), r && (r.remove ? r.remove() : document.head.removeChild(r));
      }), x()(this, "removeByIds", function (e) {
        e.forEach(function (e) {
          n.removeById(e);
        });
      }), x()(this, "setPosition", function (e, t) {
        if (e) {
          t.setCoords();
          var i = n.handler.canvas.getZoom(),
              r = t.scaleX,
              o = t.scaleY,
              a = t.width,
              s = t.height,
              l = t.getBoundingRect(!1),
              u = l.left,
              c = l.top,
              h = (a * r * i - a) / 2,
              d = (s * o * i - s) / 2;
          e.style.left = "".concat(u + h, "px"), e.style.top = "".concat(c + d, "px");
        }
      }), x()(this, "setPositionByOrigin", function (e, t, i, r) {
        if (e) {
          t.setCoords();
          var o = n.handler.canvas.getZoom(),
              a = t.scaleX,
              s = t.scaleY,
              l = t.width,
              u = t.height,
              c = (l * a * o - l) / 2,
              h = (u * s * o - u) / 2;
          e.style.left = "".concat(i + c, "px"), e.style.top = "".concat(r + h, "px");
        }
      }), x()(this, "setSize", function (e, t) {
        if (e) {
          var n = t.width,
              i = t.height;
          e.style.width = "".concat(n, "px"), e.style.height = "".concat(i, "px");
        }
      }), x()(this, "setScaleOrAngle", function (e, t) {
        if (e) {
          var i = n.handler.canvas.getZoom(),
              r = t.scaleX,
              o = t.scaleY,
              a = t.angle;
          e.style.transform = "rotate(".concat(a, "deg) scale(").concat(r * i, ", ").concat(o * i, ")");
        }
      }), this.handler = t;
    },
        q = function e(t) {
      var n = this;
      s()(this, e), x()(this, "handler", void 0), x()(this, "cropRect", void 0), x()(this, "cropObject", void 0), x()(this, "validType", function () {
        var e = n.handler.canvas.getActiveObject();
        return !!e && "image" === e.type;
      }), x()(this, "start", function () {
        if (n.validType()) {
          n.handler.interactionMode = "crop", n.cropObject = n.handler.canvas.getActiveObject();
          var e = n.cropObject,
              t = e.left,
              i = e.top;
          n.cropRect = new w.fabric.Rect({
            width: n.cropObject.width,
            height: n.cropObject.height,
            scaleX: n.cropObject.scaleX,
            scaleY: n.cropObject.scaleY,
            originX: "left",
            originY: "top",
            left: t,
            top: i,
            hasRotatingPoint: !1,
            fill: "rgba(0, 0, 0, 0.2)"
          }), n.handler.canvas.add(n.cropRect), n.handler.canvas.setActiveObject(n.cropRect), n.cropObject.selectable = !1, n.cropObject.evented = !1, n.handler.canvas.renderAll();
        }
      }), x()(this, "finish", function () {
        var e = n.cropRect,
            t = e.left,
            i = e.top,
            r = e.width,
            o = e.height,
            a = e.scaleX,
            s = e.scaleY,
            l = n.cropObject.toDataURL({
          left: t - n.cropObject.left,
          top: i - n.cropObject.top,
          width: r * a,
          height: o * s
        });
        n.handler.setImage(n.cropObject, l), n.cancel();
      }), x()(this, "cancel", function () {
        n.handler.interactionMode = "selection", n.cropObject.selectable = !0, n.cropObject.evented = !0, n.handler.canvas.setActiveObject(n.cropObject), n.handler.canvas.remove(n.cropRect), n.cropRect = null, n.cropObject = null, n.handler.canvas.renderAll();
      }), x()(this, "resize", function (e) {
        var t = e.target,
            i = e.transform,
            r = i.original,
            o = i.corner,
            a = t.left,
            s = t.top,
            l = t.width,
            u = t.height,
            c = t.scaleX,
            h = t.scaleY,
            d = n.cropObject,
            f = d.left,
            p = d.top,
            g = d.width,
            v = d.height,
            m = d.scaleX,
            y = d.scaleY;

        if ("tl" === o) {
          if (Math.round(f) > Math.round(a)) {
            var x = 1 - (Math.round(f + g) - Math.round(t.getBoundingRect().left + t.getBoundingRect().width)) / g;
            t.set({
              left: f,
              scaleX: x > 1 ? 1 : x
            });
          }

          if (Math.round(p) > Math.round(s)) {
            var _ = 1 - (Math.round(p + v) - Math.round(t.getBoundingRect().top + t.getBoundingRect().height)) / v;

            t.set({
              top: p,
              scaleY: _ > 1 ? 1 : _
            });
          }
        } else if ("bl" === o) {
          if (Math.round(f) > Math.round(a)) {
            var b = 1 - (Math.round(f + g) - Math.round(t.getBoundingRect().left + t.getBoundingRect().width)) / g;
            t.set({
              left: f,
              scaleX: b > 1 ? 1 : b
            });
          }

          if (Math.round(p + v * y) < Math.round(s + u * h)) {
            var w = 1 - (r.top - p) / v;
            t.set({
              top: r.top,
              scaleY: w > 1 ? 1 : w
            });
          }
        } else if ("tr" === o) {
          if (Math.round(f + g * m) < Math.round(a + l * c)) {
            var S = 1 - (r.left - f) / g;
            t.set({
              left: r.left,
              scaleX: S > 1 ? 1 : S
            });
          }

          if (Math.round(p) > Math.round(s)) {
            var T = 1 - (Math.round(p + v) - Math.round(t.getBoundingRect().top + t.getBoundingRect().height)) / v;
            t.set({
              top: p,
              scaleY: T > 1 ? 1 : T
            });
          }
        } else if ("br" === o) {
          if (Math.round(f + g * m) < Math.round(a + l * c)) {
            var C = 1 - (r.left - f) / g;
            t.set({
              left: r.left,
              scaleX: C > 1 ? 1 : C
            });
          }

          if (Math.round(p + v * y) < Math.round(s + u * h)) {
            var k = 1 - (r.top - p) / v;
            t.set({
              top: r.top,
              scaleY: k > 1 ? 1 : k
            });
          }
        } else if ("ml" === o) {
          if (Math.round(f) > Math.round(a)) {
            var M = 1 - (Math.round(f + g) - Math.round(t.getBoundingRect().left + t.getBoundingRect().width)) / g;
            t.set({
              left: f,
              scaleX: M > 1 ? 1 : M
            });
          }
        } else if ("mt" === o) {
          if (Math.round(p) > Math.round(s)) {
            var E = 1 - (Math.round(p + v) - Math.round(t.getBoundingRect().top + t.getBoundingRect().height)) / v;
            t.set({
              top: p,
              scaleY: E > 1 ? 1 : E
            });
          }
        } else if ("mb" === o) {
          if (Math.round(p + v * y) < Math.round(s + u * h)) {
            var A = 1 - (r.top - p) / v;
            t.set({
              top: r.top,
              scaleY: A > 1 ? 1 : A
            });
          }
        } else if ("mr" === o && Math.round(f + g * m) < Math.round(a + l * c)) {
          var I = 1 - (r.left - f) / g;
          t.set({
            left: r.left,
            scaleX: I > 1 ? 1 : I
          });
        }
      }), x()(this, "moving", function (e) {
        var t = e.target,
            i = t.left,
            r = t.top,
            o = t.width,
            a = t.height,
            s = t.scaleX,
            l = t.scaleY,
            u = n.cropObject.getBoundingRect(),
            c = u.left,
            h = u.top,
            d = u.width,
            f = u.height,
            p = function p() {
          Math.round(h) >= Math.round(r) ? t.set({
            top: h
          }) : Math.round(h + f) <= Math.round(r + a * l) && t.set({
            top: h + f - a * l
          });
        };

        Math.round(c) >= Math.round(i) ? (t.set({
          left: Math.max(i, c)
        }), p()) : Math.round(c + d) <= Math.round(i + o * s) ? (t.set({
          left: c + d - o * s
        }), p()) : Math.round(h) >= Math.round(r) ? t.set({
          top: h
        }) : Math.round(h + f) <= Math.round(r + a * l) && t.set({
          top: h + f - a * l
        });
      }), this.handler = t, this.cropRect = null, this.cropObject = null;
    },
        Z = {
      update: null,
      begin: null,
      loopBegin: null,
      changeBegin: null,
      change: null,
      changeComplete: null,
      loopComplete: null,
      complete: null,
      loop: 1,
      direction: "normal",
      autoplay: !0,
      timelineOffset: 0
    },
        K = {
      duration: 1e3,
      delay: 0,
      endDelay: 0,
      easing: "easeOutElastic(1, .5)",
      round: 0
    },
        $ = ["translateX", "translateY", "translateZ", "rotate", "rotateX", "rotateY", "rotateZ", "scale", "scaleX", "scaleY", "scaleZ", "skew", "skewX", "skewY", "perspective", "matrix", "matrix3d"],
        Q = {
      CSS: {},
      springs: {}
    };

    function J(e, t, n) {
      return Math.min(Math.max(e, t), n);
    }

    function ee(e, t) {
      return e.indexOf(t) > -1;
    }

    function te(e, t) {
      return e.apply(null, t);
    }

    var ne = {
      arr: function arr(e) {
        return Array.isArray(e);
      },
      obj: function obj(e) {
        return ee(Object.prototype.toString.call(e), "Object");
      },
      pth: function pth(e) {
        return ne.obj(e) && e.hasOwnProperty("totalLength");
      },
      svg: function svg(e) {
        return e instanceof SVGElement;
      },
      inp: function inp(e) {
        return e instanceof HTMLInputElement;
      },
      dom: function dom(e) {
        return e.nodeType || ne.svg(e);
      },
      str: function str(e) {
        return "string" == typeof e;
      },
      fnc: function fnc(e) {
        return "function" == typeof e;
      },
      und: function und(e) {
        return void 0 === e;
      },
      hex: function hex(e) {
        return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(e);
      },
      rgb: function rgb(e) {
        return /^rgb/.test(e);
      },
      hsl: function hsl(e) {
        return /^hsl/.test(e);
      },
      col: function col(e) {
        return ne.hex(e) || ne.rgb(e) || ne.hsl(e);
      },
      key: function key(e) {
        return !Z.hasOwnProperty(e) && !K.hasOwnProperty(e) && "targets" !== e && "keyframes" !== e;
      }
    };

    function ie(e) {
      var t = /\(([^)]+)\)/.exec(e);
      return t ? t[1].split(",").map(function (e) {
        return parseFloat(e);
      }) : [];
    }

    function re(e, t) {
      var n = ie(e),
          i = J(ne.und(n[0]) ? 1 : n[0], .1, 100),
          r = J(ne.und(n[1]) ? 100 : n[1], .1, 100),
          o = J(ne.und(n[2]) ? 10 : n[2], .1, 100),
          a = J(ne.und(n[3]) ? 0 : n[3], .1, 100),
          s = Math.sqrt(r / i),
          l = o / (2 * Math.sqrt(r * i)),
          u = l < 1 ? s * Math.sqrt(1 - l * l) : 0,
          c = l < 1 ? (l * s - a) / u : -a + s;

      function h(e) {
        var n = t ? t * e / 1e3 : e;
        return n = l < 1 ? Math.exp(-n * l * s) * (1 * Math.cos(u * n) + c * Math.sin(u * n)) : (1 + c * n) * Math.exp(-n * s), 0 === e || 1 === e ? e : 1 - n;
      }

      return t ? h : function () {
        var t = Q.springs[e];
        if (t) return t;

        for (var n = 0, i = 0;;) {
          if (1 === h(n += 1 / 6)) {
            if (++i >= 16) break;
          } else i = 0;
        }

        var r = n * (1 / 6) * 1e3;
        return Q.springs[e] = r, r;
      };
    }

    function oe(e) {
      return void 0 === e && (e = 10), function (t) {
        return Math.ceil(J(t, 1e-6, 1) * e) * (1 / e);
      };
    }

    var ae,
        se,
        le = function () {
      function e(e, t) {
        return 1 - 3 * t + 3 * e;
      }

      function t(e, t) {
        return 3 * t - 6 * e;
      }

      function n(e) {
        return 3 * e;
      }

      function i(i, r, o) {
        return ((e(r, o) * i + t(r, o)) * i + n(r)) * i;
      }

      function r(i, r, o) {
        return 3 * e(r, o) * i * i + 2 * t(r, o) * i + n(r);
      }

      return function (e, t, n, o) {
        if (0 <= e && e <= 1 && 0 <= n && n <= 1) {
          var a = new Float32Array(11);
          if (e !== t || n !== o) for (var s = 0; s < 11; ++s) {
            a[s] = i(.1 * s, e, n);
          }
          return function (r) {
            return e === t && n === o || 0 === r || 1 === r ? r : i(l(r), t, o);
          };
        }

        function l(t) {
          for (var o = 0, s = 1; 10 !== s && a[s] <= t; ++s) {
            o += .1;
          }

          --s;
          var l = o + .1 * ((t - a[s]) / (a[s + 1] - a[s])),
              u = r(l, e, n);
          return u >= .001 ? function (e, t, n, o) {
            for (var a = 0; a < 4; ++a) {
              var s = r(t, n, o);
              if (0 === s) return t;
              t -= (i(t, n, o) - e) / s;
            }

            return t;
          }(t, l, e, n) : 0 === u ? l : function (e, t, n, r, o) {
            var a,
                s,
                l = 0;

            do {
              (a = i(s = t + (n - t) / 2, r, o) - e) > 0 ? n = s : t = s;
            } while (Math.abs(a) > 1e-7 && ++l < 10);

            return s;
          }(t, o, o + .1, e, n);
        }
      };
    }(),
        ue = (ae = {
      linear: function linear() {
        return function (e) {
          return e;
        };
      }
    }, se = {
      Sine: function Sine() {
        return function (e) {
          return 1 - Math.cos(e * Math.PI / 2);
        };
      },
      Circ: function Circ() {
        return function (e) {
          return 1 - Math.sqrt(1 - e * e);
        };
      },
      Back: function Back() {
        return function (e) {
          return e * e * (3 * e - 2);
        };
      },
      Bounce: function Bounce() {
        return function (e) {
          for (var t, n = 4; e < ((t = Math.pow(2, --n)) - 1) / 11;) {
            ;
          }

          return 1 / Math.pow(4, 3 - n) - 7.5625 * Math.pow((3 * t - 2) / 22 - e, 2);
        };
      },
      Elastic: function Elastic(e, t) {
        void 0 === e && (e = 1), void 0 === t && (t = .5);
        var n = J(e, 1, 10),
            i = J(t, .1, 2);
        return function (e) {
          return 0 === e || 1 === e ? e : -n * Math.pow(2, 10 * (e - 1)) * Math.sin((e - 1 - i / (2 * Math.PI) * Math.asin(1 / n)) * (2 * Math.PI) / i);
        };
      }
    }, ["Quad", "Cubic", "Quart", "Quint", "Expo"].forEach(function (e, t) {
      se[e] = function () {
        return function (e) {
          return Math.pow(e, t + 2);
        };
      };
    }), Object.keys(se).forEach(function (e) {
      var t = se[e];
      ae["easeIn" + e] = t, ae["easeOut" + e] = function (e, n) {
        return function (i) {
          return 1 - t(e, n)(1 - i);
        };
      }, ae["easeInOut" + e] = function (e, n) {
        return function (i) {
          return i < .5 ? t(e, n)(2 * i) / 2 : 1 - t(e, n)(-2 * i + 2) / 2;
        };
      };
    }), ae);

    function ce(e, t) {
      if (ne.fnc(e)) return e;
      var n = e.split("(")[0],
          i = ue[n],
          r = ie(e);

      switch (n) {
        case "spring":
          return re(e, t);

        case "cubicBezier":
          return te(le, r);

        case "steps":
          return te(oe, r);

        default:
          return te(i, r);
      }
    }

    function he(e) {
      try {
        return document.querySelectorAll(e);
      } catch (e) {
        return;
      }
    }

    function de(e, t) {
      for (var n = e.length, i = arguments.length >= 2 ? arguments[1] : void 0, r = [], o = 0; o < n; o++) {
        if (o in e) {
          var a = e[o];
          t.call(i, a, o, e) && r.push(a);
        }
      }

      return r;
    }

    function fe(e) {
      return e.reduce(function (e, t) {
        return e.concat(ne.arr(t) ? fe(t) : t);
      }, []);
    }

    function pe(e) {
      return ne.arr(e) ? e : (ne.str(e) && (e = he(e) || e), e instanceof NodeList || e instanceof HTMLCollection ? [].slice.call(e) : [e]);
    }

    function ge(e, t) {
      return e.some(function (e) {
        return e === t;
      });
    }

    function ve(e) {
      var t = {};

      for (var n in e) {
        t[n] = e[n];
      }

      return t;
    }

    function me(e, t) {
      var n = ve(e);

      for (var i in e) {
        n[i] = t.hasOwnProperty(i) ? t[i] : e[i];
      }

      return n;
    }

    function ye(e, t) {
      var n = ve(e);

      for (var i in t) {
        n[i] = ne.und(e[i]) ? t[i] : e[i];
      }

      return n;
    }

    function xe(e) {
      return ne.rgb(e) ? (n = /rgb\((\d+,\s*[\d]+,\s*[\d]+)\)/g.exec(t = e)) ? "rgba(" + n[1] + ",1)" : t : ne.hex(e) ? function (e) {
        var t = e.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, function (e, t, n, i) {
          return t + t + n + n + i + i;
        }),
            n = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(t);
        return "rgba(" + parseInt(n[1], 16) + "," + parseInt(n[2], 16) + "," + parseInt(n[3], 16) + ",1)";
      }(e) : ne.hsl(e) ? function (e) {
        var t,
            n,
            i,
            r = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(e) || /hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*([\d.]+)\)/g.exec(e),
            o = parseInt(r[1], 10) / 360,
            a = parseInt(r[2], 10) / 100,
            s = parseInt(r[3], 10) / 100,
            l = r[4] || 1;

        function u(e, t, n) {
          return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + 6 * (t - e) * n : n < .5 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
        }

        if (0 == a) t = n = i = s;else {
          var c = s < .5 ? s * (1 + a) : s + a - s * a,
              h = 2 * s - c;
          t = u(h, c, o + 1 / 3), n = u(h, c, o), i = u(h, c, o - 1 / 3);
        }
        return "rgba(" + 255 * t + "," + 255 * n + "," + 255 * i + "," + l + ")";
      }(e) : void 0;
      var t, n;
    }

    function _e(e) {
      var t = /[+-]?\d*\.?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?(%|px|pt|em|rem|in|cm|mm|ex|ch|pc|vw|vh|vmin|vmax|deg|rad|turn)?$/.exec(e);
      if (t) return t[1];
    }

    function be(e, t) {
      return ne.fnc(e) ? e(t.target, t.id, t.total) : e;
    }

    function we(e, t) {
      return e.getAttribute(t);
    }

    function Se(e, t, n) {
      if (ge([n, "deg", "rad", "turn"], _e(t))) return t;
      var i = Q.CSS[t + n];
      if (!ne.und(i)) return i;
      var r = document.createElement(e.tagName),
          o = e.parentNode && e.parentNode !== document ? e.parentNode : document.body;
      o.appendChild(r), r.style.position = "absolute", r.style.width = 100 + n;
      var a = 100 / r.offsetWidth;
      o.removeChild(r);
      var s = a * parseFloat(t);
      return Q.CSS[t + n] = s, s;
    }

    function Te(e, t, n) {
      if (t in e.style) {
        var i = t.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase(),
            r = e.style[t] || getComputedStyle(e).getPropertyValue(i) || "0";
        return n ? Se(e, r, n) : r;
      }
    }

    function Ce(e, t) {
      return ne.dom(e) && !ne.inp(e) && (we(e, t) || ne.svg(e) && e[t]) ? "attribute" : ne.dom(e) && ge($, t) ? "transform" : ne.dom(e) && "transform" !== t && Te(e, t) ? "css" : null != e[t] ? "object" : void 0;
    }

    function ke(e) {
      if (ne.dom(e)) {
        for (var t, n = e.style.transform || "", i = /(\w+)\(([^)]*)\)/g, r = new Map(); t = i.exec(n);) {
          r.set(t[1], t[2]);
        }

        return r;
      }
    }

    function Me(e, t, n, i) {
      var r = ee(t, "scale") ? 1 : 0 + function (e) {
        return ee(e, "translate") || "perspective" === e ? "px" : ee(e, "rotate") || ee(e, "skew") ? "deg" : void 0;
      }(t),
          o = ke(e).get(t) || r;
      return n && (n.transforms.list.set(t, o), n.transforms.last = t), i ? Se(e, o, i) : o;
    }

    function Ee(e, t, n, i) {
      switch (Ce(e, t)) {
        case "transform":
          return Me(e, t, i, n);

        case "css":
          return Te(e, t, n);

        case "attribute":
          return we(e, t);

        default:
          return e[t] || 0;
      }
    }

    function Ae(e, t) {
      var n = /^(\*=|\+=|-=)/.exec(e);
      if (!n) return e;
      var i = _e(e) || 0,
          r = parseFloat(t),
          o = parseFloat(e.replace(n[0], ""));

      switch (n[0][0]) {
        case "+":
          return r + o + i;

        case "-":
          return r - o + i;

        case "*":
          return r * o + i;
      }
    }

    function Ie(e, t) {
      if (ne.col(e)) return xe(e);
      if (/\s/g.test(e)) return e;

      var n = _e(e),
          i = n ? e.substr(0, e.length - n.length) : e;

      return t ? i + t : i;
    }

    function Pe(e, t) {
      return Math.sqrt(Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2));
    }

    function Oe(e) {
      for (var t, n = e.points, i = 0, r = 0; r < n.numberOfItems; r++) {
        var o = n.getItem(r);
        r > 0 && (i += Pe(t, o)), t = o;
      }

      return i;
    }

    function Le(e) {
      if (e.getTotalLength) return e.getTotalLength();

      switch (e.tagName.toLowerCase()) {
        case "circle":
          return function (e) {
            return 2 * Math.PI * we(e, "r");
          }(e);

        case "rect":
          return function (e) {
            return 2 * we(e, "width") + 2 * we(e, "height");
          }(e);

        case "line":
          return function (e) {
            return Pe({
              x: we(e, "x1"),
              y: we(e, "y1")
            }, {
              x: we(e, "x2"),
              y: we(e, "y2")
            });
          }(e);

        case "polyline":
          return Oe(e);

        case "polygon":
          return function (e) {
            var t = e.points;
            return Oe(e) + Pe(t.getItem(t.numberOfItems - 1), t.getItem(0));
          }(e);
      }
    }

    function De(e, t) {
      var n = t || {},
          i = n.el || function (e) {
        for (var t = e.parentNode; ne.svg(t) && ne.svg(t.parentNode);) {
          t = t.parentNode;
        }

        return t;
      }(e),
          r = i.getBoundingClientRect(),
          o = we(i, "viewBox"),
          a = r.width,
          s = r.height,
          l = n.viewBox || (o ? o.split(" ") : [0, 0, a, s]);

      return {
        el: i,
        viewBox: l,
        x: l[0] / 1,
        y: l[1] / 1,
        w: a / l[2],
        h: s / l[3]
      };
    }

    function Ne(e, t) {
      function n(n) {
        void 0 === n && (n = 0);
        var i = t + n >= 1 ? t + n : 0;
        return e.el.getPointAtLength(i);
      }

      var i = De(e.el, e.svg),
          r = n(),
          o = n(-1),
          a = n(1);

      switch (e.property) {
        case "x":
          return (r.x - i.x) * i.w;

        case "y":
          return (r.y - i.y) * i.h;

        case "angle":
          return 180 * Math.atan2(a.y - o.y, a.x - o.x) / Math.PI;
      }
    }

    function je(e, t) {
      var n = /[+-]?\d*\.?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?/g,
          i = Ie(ne.pth(e) ? e.totalLength : e, t) + "";
      return {
        original: i,
        numbers: i.match(n) ? i.match(n).map(Number) : [0],
        strings: ne.str(e) || t ? i.split(n) : []
      };
    }

    function Re(e) {
      return de(e ? fe(ne.arr(e) ? e.map(pe) : pe(e)) : [], function (e, t, n) {
        return n.indexOf(e) === t;
      });
    }

    function Fe(e) {
      var t = Re(e);
      return t.map(function (e, n) {
        return {
          target: e,
          id: n,
          total: t.length,
          transforms: {
            list: ke(e)
          }
        };
      });
    }

    function ze(e, t) {
      var n = ve(t);

      if (/^spring/.test(n.easing) && (n.duration = re(n.easing)), ne.arr(e)) {
        var i = e.length;
        2 === i && !ne.obj(e[0]) ? e = {
          value: e
        } : ne.fnc(t.duration) || (n.duration = t.duration / i);
      }

      var r = ne.arr(e) ? e : [e];
      return r.map(function (e, n) {
        var i = ne.obj(e) && !ne.pth(e) ? e : {
          value: e
        };
        return ne.und(i.delay) && (i.delay = n ? 0 : t.delay), ne.und(i.endDelay) && (i.endDelay = n === r.length - 1 ? t.endDelay : 0), i;
      }).map(function (e) {
        return ye(e, n);
      });
    }

    function Be(e, t) {
      var n = [],
          i = t.keyframes;

      for (var r in i && (t = ye(function (e) {
        for (var t = de(fe(e.map(function (e) {
          return Object.keys(e);
        })), function (e) {
          return ne.key(e);
        }).reduce(function (e, t) {
          return e.indexOf(t) < 0 && e.push(t), e;
        }, []), n = {}, i = function i(_i4) {
          var r = t[_i4];
          n[r] = e.map(function (e) {
            var t = {};

            for (var n in e) {
              ne.key(n) ? n == r && (t.value = e[n]) : t[n] = e[n];
            }

            return t;
          });
        }, r = 0; r < t.length; r++) {
          i(r);
        }

        return n;
      }(i), t)), t) {
        ne.key(r) && n.push({
          name: r,
          tweens: ze(t[r], e)
        });
      }

      return n;
    }

    function Ve(e, t) {
      var n;
      return e.tweens.map(function (i) {
        var r = function (e, t) {
          var n = {};

          for (var i in e) {
            var r = be(e[i], t);
            ne.arr(r) && 1 === (r = r.map(function (e) {
              return be(e, t);
            })).length && (r = r[0]), n[i] = r;
          }

          return n.duration = parseFloat(n.duration), n.delay = parseFloat(n.delay), n;
        }(i, t),
            o = r.value,
            a = ne.arr(o) ? o[1] : o,
            s = _e(a),
            l = Ee(t.target, e.name, s, t),
            u = n ? n.to.original : l,
            c = ne.arr(o) ? o[0] : u,
            h = _e(c) || _e(l),
            d = s || h;

        return ne.und(a) && (a = u), r.from = je(c, d), r.to = je(Ae(a, c), d), r.start = n ? n.end : 0, r.end = r.start + r.delay + r.duration + r.endDelay, r.easing = ce(r.easing, r.duration), r.isPath = ne.pth(o), r.isColor = ne.col(r.from.original), r.isColor && (r.round = 1), n = r, r;
      });
    }

    var He = {
      css: function css(e, t, n) {
        return e.style[t] = n;
      },
      attribute: function attribute(e, t, n) {
        return e.setAttribute(t, n);
      },
      object: function object(e, t, n) {
        return e[t] = n;
      },
      transform: function transform(e, t, n, i, r) {
        if (i.list.set(t, n), t === i.last || r) {
          var o = "";
          i.list.forEach(function (e, t) {
            o += t + "(" + e + ") ";
          }), e.style.transform = o;
        }
      }
    };

    function We(e, t) {
      Fe(e).forEach(function (e) {
        for (var n in t) {
          var i = be(t[n], e),
              r = e.target,
              o = _e(i),
              a = Ee(r, n, o, e),
              s = Ae(Ie(i, o || _e(a)), a),
              l = Ce(r, n);

          He[l](r, n, s, e.transforms, !0);
        }
      });
    }

    function Ge(e, t) {
      return de(fe(e.map(function (e) {
        return t.map(function (t) {
          return function (e, t) {
            var n = Ce(e.target, t.name);

            if (n) {
              var i = Ve(t, e),
                  r = i[i.length - 1];
              return {
                type: n,
                property: t.name,
                animatable: e,
                tweens: i,
                duration: r.end,
                delay: i[0].delay,
                endDelay: r.endDelay
              };
            }
          }(e, t);
        });
      })), function (e) {
        return !ne.und(e);
      });
    }

    function Ue(e, t) {
      var n = e.length,
          i = function i(e) {
        return e.timelineOffset ? e.timelineOffset : 0;
      },
          r = {};

      return r.duration = n ? Math.max.apply(Math, e.map(function (e) {
        return i(e) + e.duration;
      })) : t.duration, r.delay = n ? Math.min.apply(Math, e.map(function (e) {
        return i(e) + e.delay;
      })) : t.delay, r.endDelay = n ? r.duration - Math.max.apply(Math, e.map(function (e) {
        return i(e) + e.duration - e.endDelay;
      })) : t.endDelay, r;
    }

    var Ye = 0;

    var Xe,
        qe = [],
        Ze = [],
        Ke = function () {
      function e() {
        Xe = requestAnimationFrame(t);
      }

      function t(t) {
        var n = qe.length;

        if (n) {
          for (var i = 0; i < n;) {
            var r = qe[i];

            if (r.paused) {
              var o = qe.indexOf(r);
              o > -1 && (qe.splice(o, 1), n = qe.length);
            } else r.tick(t);

            i++;
          }

          e();
        } else Xe = cancelAnimationFrame(Xe);
      }

      return e;
    }();

    function $e(e) {
      void 0 === e && (e = {});
      var t,
          n = 0,
          i = 0,
          r = 0,
          o = 0,
          a = null;

      function s(e) {
        var t = window.Promise && new Promise(function (e) {
          return a = e;
        });
        return e.finished = t, t;
      }

      var l = function (e) {
        var t = me(Z, e),
            n = me(K, e),
            i = Be(n, e),
            r = Fe(e.targets),
            o = Ge(r, i),
            a = Ue(o, n),
            s = Ye;
        return Ye++, ye(t, {
          id: s,
          children: [],
          animatables: r,
          animations: o,
          duration: a.duration,
          delay: a.delay,
          endDelay: a.endDelay
        });
      }(e);

      s(l);

      function u() {
        var e = l.direction;
        "alternate" !== e && (l.direction = "normal" !== e ? "normal" : "reverse"), l.reversed = !l.reversed, t.forEach(function (e) {
          return e.reversed = l.reversed;
        });
      }

      function c(e) {
        return l.reversed ? l.duration - e : e;
      }

      function h() {
        n = 0, i = c(l.currentTime) * (1 / $e.speed);
      }

      function d(e, t) {
        t && t.seek(e - t.timelineOffset);
      }

      function f(e) {
        for (var t = 0, n = l.animations, i = n.length; t < i;) {
          var r = n[t],
              o = r.animatable,
              a = r.tweens,
              s = a.length - 1,
              u = a[s];
          s && (u = de(a, function (t) {
            return e < t.end;
          })[0] || u);

          for (var c = J(e - u.start - u.delay, 0, u.duration) / u.duration, h = isNaN(c) ? 1 : u.easing(c), d = u.to.strings, f = u.round, p = [], g = u.to.numbers.length, v = void 0, m = 0; m < g; m++) {
            var y = void 0,
                x = u.to.numbers[m],
                _ = u.from.numbers[m] || 0;

            y = u.isPath ? Ne(u.value, h * x) : _ + h * (x - _), f && (u.isColor && m > 2 || (y = Math.round(y * f) / f)), p.push(y);
          }

          var b = d.length;

          if (b) {
            v = d[0];

            for (var w = 0; w < b; w++) {
              d[w];
              var S = d[w + 1],
                  T = p[w];
              isNaN(T) || (v += S ? T + S : T + " ");
            }
          } else v = p[0];

          He[r.type](o.target, r.property, v, o.transforms), r.currentValue = v, t++;
        }
      }

      function p(e) {
        l[e] && !l.passThrough && l[e](l);
      }

      function g(e) {
        var h = l.duration,
            g = l.delay,
            v = h - l.endDelay,
            m = c(e);
        l.progress = J(m / h * 100, 0, 100), l.reversePlayback = m < l.currentTime, t && function (e) {
          if (l.reversePlayback) for (var n = o; n--;) {
            d(e, t[n]);
          } else for (var i = 0; i < o; i++) {
            d(e, t[i]);
          }
        }(m), !l.began && l.currentTime > 0 && (l.began = !0, p("begin")), !l.loopBegan && l.currentTime > 0 && (l.loopBegan = !0, p("loopBegin")), m <= g && 0 !== l.currentTime && f(0), (m >= v && l.currentTime !== h || !h) && f(h), m > g && m < v ? (l.changeBegan || (l.changeBegan = !0, l.changeCompleted = !1, p("changeBegin")), p("change"), f(m)) : l.changeBegan && (l.changeCompleted = !0, l.changeBegan = !1, p("changeComplete")), l.currentTime = J(m, 0, h), l.began && p("update"), e >= h && (i = 0, l.remaining && !0 !== l.remaining && l.remaining--, l.remaining ? (n = r, p("loopComplete"), l.loopBegan = !1, "alternate" === l.direction && u()) : (l.paused = !0, l.completed || (l.completed = !0, p("loopComplete"), p("complete"), !l.passThrough && "Promise" in window && (a(), s(l)))));
      }

      return l.reset = function () {
        var e = l.direction;
        l.passThrough = !1, l.currentTime = 0, l.progress = 0, l.paused = !0, l.began = !1, l.loopBegan = !1, l.changeBegan = !1, l.completed = !1, l.changeCompleted = !1, l.reversePlayback = !1, l.reversed = "reverse" === e, l.remaining = l.loop, t = l.children;

        for (var n = o = t.length; n--;) {
          l.children[n].reset();
        }

        (l.reversed && !0 !== l.loop || "alternate" === e && 1 === l.loop) && l.remaining++, f(l.reversed ? l.duration : 0);
      }, l.set = function (e, t) {
        return We(e, t), l;
      }, l.tick = function (e) {
        r = e, n || (n = r), g((r + (i - n)) * $e.speed);
      }, l.seek = function (e) {
        g(c(e));
      }, l.pause = function () {
        l.paused = !0, h();
      }, l.play = function () {
        l.paused && (l.completed && l.reset(), l.paused = !1, qe.push(l), h(), Xe || Ke());
      }, l.reverse = function () {
        u(), l.completed = !l.reversed, h();
      }, l.restart = function () {
        l.reset(), l.play();
      }, l.reset(), l.autoplay && l.play(), l;
    }

    function Qe(e, t) {
      for (var n = t.length; n--;) {
        ge(e, t[n].animatable.target) && t.splice(n, 1);
      }
    }

    "undefined" != typeof document && document.addEventListener("visibilitychange", function () {
      document.hidden ? (qe.forEach(function (e) {
        return e.pause();
      }), Ze = qe.slice(0), $e.running = qe = []) : Ze.forEach(function (e) {
        return e.play();
      });
    }), $e.version = "3.2.0", $e.speed = 1, $e.running = qe, $e.remove = function (e) {
      for (var t = Re(e), n = qe.length; n--;) {
        var i = qe[n],
            r = i.animations,
            o = i.children;
        Qe(t, r);

        for (var a = o.length; a--;) {
          var s = o[a],
              l = s.animations;
          Qe(t, l), l.length || s.children.length || o.splice(a, 1);
        }

        r.length || o.length || i.pause();
      }
    }, $e.get = Ee, $e.set = We, $e.convertPx = Se, $e.path = function (e, t) {
      var n = ne.str(e) ? he(e)[0] : e,
          i = t || 100;
      return function (e) {
        return {
          property: e,
          el: n,
          svg: De(n),
          totalLength: Le(n) * (i / 100)
        };
      };
    }, $e.setDashoffset = function (e) {
      var t = Le(e);
      return e.setAttribute("stroke-dasharray", t), t;
    }, $e.stagger = function (e, t) {
      void 0 === t && (t = {});
      var n = t.direction || "normal",
          i = t.easing ? ce(t.easing) : null,
          r = t.grid,
          o = t.axis,
          a = t.from || 0,
          s = "first" === a,
          l = "center" === a,
          u = "last" === a,
          c = ne.arr(e),
          h = c ? parseFloat(e[0]) : parseFloat(e),
          d = c ? parseFloat(e[1]) : 0,
          f = _e(c ? e[1] : e) || 0,
          p = t.start || 0 + (c ? h : 0),
          g = [],
          v = 0;
      return function (e, t, m) {
        if (s && (a = 0), l && (a = (m - 1) / 2), u && (a = m - 1), !g.length) {
          for (var y = 0; y < m; y++) {
            if (r) {
              var x = l ? (r[0] - 1) / 2 : a % r[0],
                  _ = l ? (r[1] - 1) / 2 : Math.floor(a / r[0]),
                  b = x - y % r[0],
                  w = _ - Math.floor(y / r[0]),
                  S = Math.sqrt(b * b + w * w);

              "x" === o && (S = -b), "y" === o && (S = -w), g.push(S);
            } else g.push(Math.abs(a - y));

            v = Math.max.apply(Math, g);
          }

          i && (g = g.map(function (e) {
            return i(e / v) * v;
          })), "reverse" === n && (g = g.map(function (e) {
            return o ? e < 0 ? -1 * e : -e : Math.abs(v - e);
          }));
        }

        return p + (c ? (d - h) / v : h) * (Math.round(100 * g[t]) / 100) + f;
      };
    }, $e.timeline = function (e) {
      void 0 === e && (e = {});
      var t = $e(e);
      return t.duration = 0, t.add = function (n, i) {
        var r = qe.indexOf(t),
            o = t.children;

        function a(e) {
          e.passThrough = !0;
        }

        r > -1 && qe.splice(r, 1);

        for (var s = 0; s < o.length; s++) {
          a(o[s]);
        }

        var l = ye(n, me(K, e));
        l.targets = l.targets || e.targets;
        var u = t.duration;
        l.autoplay = !1, l.direction = t.direction, l.timelineOffset = ne.und(i) ? u : Ae(i, u), a(t), t.seek(l.timelineOffset);
        var c = $e(l);
        a(c), o.push(c);
        var h = Ue(o, e);
        return t.delay = h.delay, t.endDelay = h.endDelay, t.duration = h.duration, t.seek(0), t.reset(), t.autoplay && t.play(), t;
      }, t;
    }, $e.easing = ce, $e.penner = ue, $e.random = function (e, t) {
      return Math.floor(Math.random() * (t - e + 1)) + e;
    };

    var Je = $e,
        et = function e(t) {
      var n = this;
      s()(this, e), x()(this, "handler", void 0), x()(this, "play", function (e, t) {
        var i = n.handler.findById(e);
        if (i) if (i.anime) i.anime.restart();else if ("none" !== i.animation.type) {
          var r = n.getAnime(i, t);
          r && (i.set("anime", r), i.set({
            hasControls: !1,
            lockMovementX: !0,
            lockMovementY: !0,
            hoverCursor: "pointer"
          }), n.handler.canvas.requestRenderAll(), r.play());
        }
      }), x()(this, "pause", function (e) {
        var t = n.handler.findById(e);
        t && t.anime.pause();
      }), x()(this, "stop", function (e) {
        var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
            i = n.handler.findById(e);
        i && n.resetAnimation(i, t);
      }), x()(this, "restart", function (e) {
        var t = n.handler.findById(e);
        t && t.anime && (n.stop(e), n.play(e));
      }), x()(this, "resetAnimation", function (e) {
        var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];

        if (e.anime) {
          var i;
          i = n.handler.editable ? {
            anime: null,
            hasControls: t,
            lockMovementX: !t,
            lockMovementY: !t,
            hoverCursor: t ? "move" : "pointer"
          } : {
            anime: null,
            hasControls: !1,
            lockMovementX: !0,
            lockMovementY: !0,
            hoverCursor: "pointer"
          }, Je.remove(e);
          var r = e.animation.type;
          "fade" === r ? Object.assign(i, {
            opacity: e.originOpacity,
            originOpacity: null
          }) : "bounce" === r ? "vertical" === e.animation.bounce ? Object.assign(i, {
            top: e.originTop,
            originTop: null
          }) : Object.assign(i, {
            left: e.originLeft,
            originLeft: null
          }) : "shake" === r ? "vertical" === e.animation.shake ? Object.assign(i, {
            top: e.originTop,
            originTop: null
          }) : Object.assign(i, {
            left: e.originLeft,
            originLeft: null
          }) : "scaling" === r ? Object.assign(i, {
            scaleX: e.originScaleX,
            scaleY: e.originScaleY,
            originScaleX: null,
            originScaleY: null
          }) : "rotation" === r ? Object.assign(i, {
            angle: e.originAngle,
            rotation: e.originAngle,
            left: e.originLeft,
            top: e.originTop,
            originLeft: null,
            originTop: null,
            originAngle: null
          }) : "flash" === r ? Object.assign(i, {
            fill: e.originFill,
            stroke: e.originStroke,
            originFill: null,
            origniStroke: null
          }) : console.warn("Not supported type."), e.set(i), n.handler.canvas.renderAll();
        }
      }), x()(this, "getAnime", function (e, t) {
        var i = e.animation,
            r = i.delay,
            a = void 0 === r ? 0 : r,
            s = i.duration,
            l = void 0 === s ? 100 : s,
            u = i.autoplay,
            c = void 0 === u || u,
            h = i.loop,
            d = void 0 === h || h,
            f = i.type,
            p = o()(i, ["delay", "duration", "autoplay", "loop", "type"]),
            g = {
          targets: e,
          delay: a,
          loop: d,
          autoplay: c,
          duration: l,
          direction: "alternate",
          begin: function begin() {
            e.set({
              hasControls: !1,
              lockMovementX: !0,
              lockMovementY: !0,
              hoverCursor: "pointer"
            }), n.handler.canvas.requestRenderAll();
          },
          update: function update(t) {
            if ("flash" === f) {
              var i = t.animations[0].currentValue,
                  r = t.animations[1].currentValue;
              e.set("fill", ""), e.set("fill", i), e.set("stroke", r);
            } else if ("rotation" === f) {
              var o = t.animations[0].currentValue;
              return e.rotate(o), void n.handler.canvas.requestRenderAll();
            }

            e.setCoords(), n.handler.canvas.requestRenderAll();
          },
          complete: function complete() {
            n.resetAnimation(e, t);
          }
        };

        if ("fade" === f) {
          var v = p.opacity,
              m = void 0 === v ? 0 : v;
          e.set("originOpacity", e.opacity), Object.assign(g, {
            opacity: m,
            easing: "easeInQuad"
          });
        } else if ("bounce" === f) {
          var y = p.offset,
              x = void 0 === y ? 1 : y;
          "vertical" === p.bounce ? (e.set("originTop", e.top), Object.assign(g, {
            top: e.top + x,
            easing: "easeInQuad"
          })) : (e.set("originLeft", e.left), Object.assign(g, {
            left: e.left + x,
            easing: "easeInQuad"
          }));
        } else if ("shake" === f) {
          var _ = p.offset,
              b = void 0 === _ ? 1 : _;
          "vertical" === p.shake ? (e.set("originTop", e.top), Object.assign(g, {
            top: e.top + b,
            delay: 0,
            elasticity: 1e3,
            duration: 500
          })) : (e.set("originLeft", e.left), Object.assign(g, {
            left: e.left + b,
            delay: 0,
            elasticity: 1e3,
            duration: 500
          }));
        } else if ("scaling" === f) {
          var w = p.scale,
              S = void 0 === w ? 2 : w;
          e.set("originScaleX", e.scaleX), e.set("originScaleY", e.scaleY), e.set({
            originScaleX: e.scaleX,
            originScaleY: e.scaleY
          });
          var T = e.scaleX * S,
              C = e.scaleY * S;
          Object.assign(g, {
            scaleX: T,
            scaleY: C,
            easing: "easeInQuad"
          });
        } else if ("rotation" === f) {
          var k = p.angle,
              M = void 0 === k ? 360 : k;
          e.set("rotation", e.angle), e.set("originAngle", e.angle), e.set("originLeft", e.left), e.set("originTop", e.top), Object.assign(g, {
            rotation: M,
            easing: "linear",
            direction: "normal"
          });
        } else {
          if ("flash" !== f) return console.warn("Not supported type."), null;
          var E = p.fill,
              A = void 0 === E ? e.fill : E,
              I = p.stroke,
              P = void 0 === I ? e.stroke : I;
          e.set("originFill", e.fill), e.set("originStroke", e.stroke), Object.assign(g, {
            fill: A,
            stroke: P,
            easing: "easeInQuad"
          });
        }

        return Je(g);
      }), this.handler = t;
    },
        tt = n(170),
        nt = n.n(tt),
        it = n(92),
        rt = n.n(it),
        ot = function () {
      function e(t) {
        var n = this;
        s()(this, e), x()(this, "handler", void 0), x()(this, "contextmenuEl", void 0), x()(this, "show", rt()(function () {
          var e = D()(O.a.mark(function e(t, i) {
            var r, o, a, s, l;
            return O.a.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    for (r = n.handler.onContext; n.contextmenuEl.hasChildNodes();) {
                      n.contextmenuEl.removeChild(n.contextmenuEl.firstChild);
                    }

                    return (o = document.createElement("div")).className = "rde-contextmenu-right", e.next = 6, r(n.contextmenuEl, t, i);

                  case 6:
                    if (a = e.sent) {
                      e.next = 9;
                      break;
                    }

                    return e.abrupt("return");

                  case 9:
                    o.innerHTML = a, n.contextmenuEl.appendChild(o), nt.a.render(a, o), n.contextmenuEl.classList.remove("contextmenu-hidden"), s = t.clientX, l = t.clientY, n.contextmenuEl.style.left = "".concat(s, "px"), n.contextmenuEl.style.top = "".concat(l, "px");

                  case 16:
                  case "end":
                    return e.stop();
                }
              }
            }, e);
          }));
          return function (t, n) {
            return e.apply(this, arguments);
          };
        }(), 100)), x()(this, "hide", rt()(function () {
          n.contextmenuEl && n.contextmenuEl.classList.add("contextmenu-hidden");
        }, 100)), this.handler = t, this.initialize();
      }

      return u()(e, [{
        key: "initialize",
        value: function value() {
          this.contextmenuEl = document.createElement("div"), this.contextmenuEl.id = "".concat(this.handler.id, "_contextmenu"), this.contextmenuEl.className = "rde-contextmenu contextmenu-hidden", document.body.appendChild(this.contextmenuEl);
        }
      }, {
        key: "destory",
        value: function value() {
          this.contextmenuEl && document.body.removeChild(this.contextmenuEl);
        }
      }]), e;
    }(),
        at = function () {
      function e(t) {
        var n = this;
        s()(this, e), x()(this, "handler", void 0), x()(this, "tooltipEl", void 0), x()(this, "target", void 0), x()(this, "show", rt()(function () {
          var e = D()(O.a.mark(function e(t) {
            var i, r, o, a, s, l, u, c, h, d, f, p, g, v, m, y, x, _;

            return O.a.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    if (!t.tooltip || !t.tooltip.enabled) {
                      e.next = 28;
                      break;
                    }

                    for (; n.tooltipEl.hasChildNodes();) {
                      n.tooltipEl.removeChild(n.tooltipEl.firstChild);
                    }

                    if ((i = document.createElement("div")).className = "rde-tooltip-right", r = t.name, !(o = n.handler.onTooltip)) {
                      e.next = 12;
                      break;
                    }

                    return e.next = 9, o(n.tooltipEl, t);

                  case 9:
                    if (r = e.sent) {
                      e.next = 12;
                      break;
                    }

                    return e.abrupt("return");

                  case 12:
                    i.innerHTML = r, n.tooltipEl.appendChild(i), nt.a.render(r, i), n.tooltipEl.classList.remove("tooltip-hidden"), a = n.handler.canvas.getZoom(), s = n.tooltipEl.clientHeight, l = t.width, u = t.height, c = t.scaleX, h = t.scaleY, d = t.getBoundingRect(), f = d.left, p = d.top, g = n.handler.canvas.calcOffset(), v = g._offset, m = l * c * a, y = u * h * a / 2 - s / 2, x = v.left + f + m, _ = v.top + p + y, document.body.clientWidth <= x + n.tooltipEl.offsetWidth ? (n.tooltipEl.style.left = "".concat(f + v.left - n.tooltipEl.offsetWidth, "px"), i.className = "rde-tooltip-left") : n.tooltipEl.style.left = "".concat(x, "px"), n.tooltipEl.style.top = "".concat(_, "px"), n.handler.target = t;

                  case 28:
                  case "end":
                    return e.stop();
                }
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(), 100)), x()(this, "hide", rt()(function (e) {
          n.handler.target = null, n.tooltipEl && n.tooltipEl.classList.add("tooltip-hidden");
        }, 100)), this.handler = t, t.editable || this.initialize();
      }

      return u()(e, [{
        key: "initialize",
        value: function value() {
          this.tooltipEl = document.createElement("div"), this.tooltipEl.id = "".concat(this.handler.id, "_tooltip"), this.tooltipEl.className = "rde-tooltip tooltip-hidden", document.body.appendChild(this.tooltipEl);
        }
      }, {
        key: "destroy",
        value: function value() {
          this.tooltipEl && document.body.removeChild(this.tooltipEl);
        }
      }]), e;
    }(),
        st = n(239),
        lt = n.n(st),
        ut = function e(t) {
      var n = this;
      s()(this, e), x()(this, "handler", void 0), x()(this, "redos", void 0), x()(this, "undos", void 0), x()(this, "active", !1), x()(this, "state", []), x()(this, "initialize", function () {
        n.redos = [], n.undos = [], n.state = [], n.active = !1;
      }), x()(this, "save", function (e, t) {
        if (n.handler.keyEvent.transaction) try {
          if (n.state) {
            var i = JSON.stringify(n.state);
            n.redos = [], n.undos.push({
              type: e,
              json: i
            });
          }

          var r = t || n.handler.canvas.toJSON(n.handler.propertiesToInclude),
              o = r.objects;
          n.state = o.filter(function (e) {
            return "workarea" !== e.id && "grid" !== e.id && "port" !== e.superType;
          });
        } catch (e) {
          console.error(e);
        }
      }), x()(this, "undo", lt()(function () {
        var e = n.undos.pop();
        e && (n.redos.push({
          type: "redo",
          json: JSON.stringify(n.state)
        }), n.replay(e));
      }, 100)), x()(this, "redo", lt()(function () {
        var e = n.redos.pop();
        e && (n.undos.push({
          type: "undo",
          json: JSON.stringify(n.state)
        }), n.replay(e));
      }, 100)), x()(this, "replay", function (e) {
        var t = JSON.parse(e.json);
        n.state = t, n.active = !0, n.handler.canvas.renderOnAddRemove = !1, n.handler.clear(), n.handler.canvas.discardActiveObject(), w.fabric.util.enlivenObjects(t, function (t) {
          t.forEach(function (e) {
            var t = n.handler.canvas._objects.length;
            if ("node" === e.superType) n.handler.canvas.insertAt(e, t, !1), n.handler.portHandler.create(e);else if ("link" === e.superType) {
              var i,
                  r,
                  o,
                  a,
                  s = e;
              n.handler.objects = n.handler.getObjects(), n.handler.linkHandler.create({
                type: "curvedLink",
                fromNodeId: null === (i = s.fromNode) || void 0 === i ? void 0 : i.id,
                fromPortId: null === (r = s.fromPort) || void 0 === r ? void 0 : r.id,
                toNodeId: null === (o = s.toNode) || void 0 === o ? void 0 : o.id,
                toPortId: null === (a = s.toPort) || void 0 === a ? void 0 : a.id
              });
            } else n.handler.canvas.insertAt(e, t, !1);
          }), n.handler.canvas.renderOnAddRemove = !0, n.active = !1, n.handler.canvas.renderAll(), n.handler.objects = n.handler.getObjects(), n.handler.onTransaction && n.handler.onTransaction(e);
        }, null);
      }), this.handler = t, this.handler.editable && this.initialize();
    },
        ct = function e(t) {
      var n = this;
      s()(this, e), x()(this, "handler", void 0), x()(this, "zoomToPoint", function (e, t) {
        var i = n.handler,
            r = i.minZoom,
            o = i.maxZoom,
            a = t;
        t <= r / 100 ? a = r / 100 : t >= o / 100 && (a = o / 100), n.handler.canvas.zoomToPoint(e, a), n.handler.getObjects().forEach(function (e) {
          if ("element" === e.superType) {
            var t = e,
                i = t.id,
                r = t.width,
                o = t.height,
                a = t.player,
                s = n.handler.elementHandler.findById(i);
            n.handler.elementHandler.setScaleOrAngle(s, e), n.handler.elementHandler.setSize(s, e), n.handler.elementHandler.setPosition(s, e), a && a.setPlayerSize(r, o);
          }
        }), n.handler.onZoom && n.handler.onZoom(a), n.handler.canvas.requestRenderAll();
      }), x()(this, "zoomOneToOne", function () {
        var e = n.handler.canvas.getCenter();
        n.handler.canvas.setViewportTransform([1, 0, 0, 1, 0, 0]), n.zoomToPoint(new w.fabric.Point(e.left, e.top), 1);
      }), x()(this, "zoomToFit", function () {
        var e = n.handler.canvas.getWidth() / n.handler.workarea.width,
            t = n.handler.canvas.getHeight() / n.handler.workarea.height;
        n.handler.workarea.height >= n.handler.workarea.width ? (e = t, n.handler.canvas.getWidth() < n.handler.workarea.width * e && (e *= n.handler.canvas.getWidth() / (n.handler.workarea.width * e))) : n.handler.canvas.getHeight() < n.handler.workarea.height * e && (e *= n.handler.canvas.getHeight() / (n.handler.workarea.height * e));
        var i = n.handler.canvas.getCenter();
        n.handler.canvas.setViewportTransform([1, 0, 0, 1, 0, 0]), n.zoomToPoint(new w.fabric.Point(i.left, i.top), e);
      }), x()(this, "zoomIn", function () {
        var e = n.handler.canvas.getZoom();
        e += .05;
        var t = n.handler.canvas.getCenter();
        n.zoomToPoint(new w.fabric.Point(t.left, t.top), e);
      }), x()(this, "zoomOut", function () {
        var e = n.handler.canvas.getZoom();
        e -= .05;
        var t = n.handler.canvas.getCenter();
        n.zoomToPoint(new w.fabric.Point(t.left, t.top), e);
      }), x()(this, "zoomToCenterWithObject", function (e, t) {
        var i = n.handler.canvas.getCenter(),
            r = i.left,
            o = i.top,
            a = e.left,
            s = e.top,
            l = e.width,
            u = e.height,
            c = o - (s + u / 2),
            h = r - (a + l / 2);

        if (t) {
          var d, f;
          d = n.handler.canvas.getWidth() / l, f = n.handler.canvas.getHeight() / u, u > l ? (d = f, n.handler.canvas.getWidth() < l * d && (d *= n.handler.canvas.getWidth() / (l * d))) : (f = d, n.handler.canvas.getHeight() < u * d && (d *= n.handler.canvas.getHeight() / (u * d))), n.handler.canvas.setViewportTransform([1, 0, 0, 1, h, c]), n.zoomToPoint(new w.fabric.Point(r, o), d);
        } else {
          var p = n.handler.canvas.getZoom();
          n.handler.canvas.setViewportTransform([1, 0, 0, 1, h, c]), n.zoomToPoint(new w.fabric.Point(r, o), p);
        }
      }), x()(this, "zoomToCenter", function (e) {
        var t = n.handler.canvas.getActiveObject();
        t && n.zoomToCenterWithObject(t, e);
      }), this.handler = t;
    };

    function ht(e, t) {
      var n = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        t && (i = i.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, i);
      }

      return n;
    }

    function dt(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? ht(Object(n), !0).forEach(function (t) {
          x()(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ht(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }

      return e;
    }

    var ft = function () {
      function e(t) {
        var n = this;
        s()(this, e), x()(this, "handler", void 0), x()(this, "setLayout", function (e) {
          n.handler.workarea.set("layout", e);
          var t = n.handler.workarea,
              i = t._element,
              r = t.isElement,
              o = t.workareaWidth,
              a = t.workareaHeight,
              s = n.handler.canvas,
              l = 1,
              u = 1,
              c = "fixed" === e,
              h = "responsive" === e,
              d = "fullscreen" === e;
          if (r) if (c) l = o / i.width, u = a / i.height;else if (h) {
            var f = n.calculateScale();
            l = f.scaleX, u = f.scaleY;
          } else l = s.getWidth() / i.width, u = s.getHeight() / i.height;

          if (n.handler.getObjects().forEach(function (e) {
            var t = e,
                i = t.id,
                r = t.player;

            if ("workarea" !== i) {
              var o = d ? l : 1,
                  a = d ? u : 1,
                  c = e.width * o * s.getZoom(),
                  h = e.height * a * s.getZoom(),
                  f = n.handler.elementHandler.findById(e.id);
              n.handler.elementHandler.setSize(f, e), r && r.setPlayerSize(c, h), e.set({
                scaleX: d ? o : 1,
                scaleY: d ? a : 1
              });
            }
          }), h) {
            var p = s.getCenter();
            return r ? (n.handler.workarea.set({
              scaleX: 1,
              scaleY: 1
            }), n.handler.zoomHandler.zoomToPoint(new w.fabric.Point(p.left, p.top), l)) : (n.handler.workarea.set({
              width: o,
              height: a
            }), l = s.getWidth() / o, u = s.getHeight() / a, a >= o ? l = u : u = l, n.handler.zoomHandler.zoomToPoint(new w.fabric.Point(p.left, p.top), l)), s.centerObject(n.handler.workarea), void s.renderAll();
          }

          if (r) n.handler.workarea.set({
            width: i.width,
            height: i.height,
            scaleX: l,
            scaleY: u
          });else {
            var g = c ? o : n.handler.canvas.getWidth(),
                v = c ? a : n.handler.canvas.getHeight();
            n.handler.workarea.set({
              width: g,
              height: v,
              backgroundColor: "rgba(255, 255, 255, 1)"
            }), n.handler.canvas.renderAll(), c ? s.centerObject(n.handler.workarea) : n.handler.workarea.set({
              left: 0,
              top: 0
            });
          }
          s.centerObject(n.handler.workarea);
          var m = s.getCenter();
          s.setViewportTransform([1, 0, 0, 1, 0, 0]), n.handler.zoomHandler.zoomToPoint(new w.fabric.Point(m.left, m.top), 1), s.renderAll();
        }), x()(this, "setResponsiveImage", function () {
          var e = D()(O.a.mark(function e(t, i) {
            var r, o;
            return O.a.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    if (r = function () {
                      var e = D()(O.a.mark(function e() {
                        var t,
                            r = arguments;
                        return O.a.wrap(function (e) {
                          for (;;) {
                            switch (e.prev = e.next) {
                              case 0:
                                return t = r.length > 0 && void 0 !== r[0] ? r[0] : "", e.abrupt("return", new Promise(function (e) {
                                  w.fabric.Image.fromURL(t, function (t) {
                                    var r = n.handler,
                                        o = r.canvas,
                                        a = r.workarea,
                                        s = r.editable,
                                        l = a.workareaWidth,
                                        u = a.workareaHeight,
                                        c = n.calculateScale(t),
                                        h = c.scaleX,
                                        d = c.scaleY;
                                    if (t._element) a.set(dt(dt({}, t), {}, {
                                      isElement: !0,
                                      selectable: !1
                                    }));else {
                                      var f = new Image(l, u);
                                      a.setElement(f), a.set({
                                        isElement: !1,
                                        selectable: !1,
                                        width: l,
                                        height: u
                                      });
                                    }
                                    s && !i && o.getObjects().forEach(function (e) {
                                      var t = e,
                                          i = t.id,
                                          r = t.player;

                                      if ("workarea" !== i) {
                                        var o = e.width * h,
                                            a = e.height * d,
                                            s = n.handler.elementHandler.findById(i);
                                        n.handler.elementHandler.setScaleOrAngle(s, e), n.handler.elementHandler.setSize(s, e), r && r.setPlayerSize(o, a), e.set({
                                          scaleX: 1,
                                          scaleY: 1
                                        }), e.setCoords();
                                      }
                                    }), n.handler.zoomHandler.zoomToFit(), o.centerObject(a), e(a);
                                  });
                                }));

                              case 2:
                              case "end":
                                return e.stop();
                            }
                          }
                        }, e);
                      }));
                      return function () {
                        return e.apply(this, arguments);
                      };
                    }(), o = n.handler.workarea, t) {
                      e.next = 5;
                      break;
                    }

                    return o.set({
                      src: null,
                      file: null
                    }), e.abrupt("return", r(t));

                  case 5:
                    if (!(t instanceof File)) {
                      e.next = 9;
                      break;
                    }

                    return e.abrupt("return", new Promise(function (e) {
                      var n = new FileReader();
                      n.onload = function () {
                        o.set({
                          file: t
                        }), r(n.result).then(e);
                      }, n.readAsDataURL(t);
                    }));

                  case 9:
                    return o.set({
                      src: t
                    }), e.abrupt("return", r(t));

                  case 11:
                  case "end":
                    return e.stop();
                }
              }
            }, e);
          }));
          return function (t, n) {
            return e.apply(this, arguments);
          };
        }()), x()(this, "setImage", function () {
          var e = D()(O.a.mark(function e(t) {
            var i,
                r,
                o,
                a,
                s,
                l,
                u = arguments;
            return O.a.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    if (i = u.length > 1 && void 0 !== u[1] && u[1], r = n.handler, o = r.canvas, a = r.workarea, s = r.editable, "responsive" !== a.layout) {
                      e.next = 4;
                      break;
                    }

                    return e.abrupt("return", n.setResponsiveImage(t, i));

                  case 4:
                    if (l = function () {
                      var e = D()(O.a.mark(function e(t) {
                        return O.a.wrap(function (e) {
                          for (;;) {
                            switch (e.prev = e.next) {
                              case 0:
                                return e.abrupt("return", new Promise(function (e) {
                                  w.fabric.Image.fromURL(t, function (t) {
                                    var r = o.getWidth(),
                                        l = o.getHeight();
                                    "fixed" === a.layout && (r = a.width * a.scaleX, l = a.height * a.scaleY);
                                    var u = 1,
                                        c = 1;

                                    if (t._element ? (u = r / t.width, c = l / t.height, t.set({
                                      originX: "left",
                                      originY: "top",
                                      scaleX: u,
                                      scaleY: c
                                    }), a.set(dt(dt({}, t), {}, {
                                      isElement: !0,
                                      selectable: !1
                                    }))) : (a.setElement(new Image()), a.set({
                                      width: r,
                                      height: l,
                                      scaleX: u,
                                      scaleY: c,
                                      isElement: !1,
                                      selectable: !1
                                    })), o.centerObject(a), s && !i) {
                                      var h = a.layout;
                                      o.getObjects().forEach(function (e) {
                                        var t = e,
                                            i = t.id,
                                            r = t.player;

                                        if ("workarea" !== i) {
                                          u = "fullscreen" === h ? u : e.scaleX, c = "fullscreen" === h ? c : e.scaleY;
                                          var o = n.handler.elementHandler.findById(i);

                                          if (n.handler.elementHandler.setSize(o, e), r) {
                                            var a = e.width * u,
                                                s = e.height * c;
                                            r.setPlayerSize(a, s);
                                          }

                                          e.set({
                                            scaleX: u,
                                            scaleY: c
                                          }), e.setCoords();
                                        }
                                      });
                                    }

                                    var d = o.getCenter(),
                                        f = i || "fullscreen" === a.layout ? 1 : n.handler.canvas.getZoom();
                                    o.setViewportTransform([1, 0, 0, 1, 0, 0]), n.handler.zoomHandler.zoomToPoint(new w.fabric.Point(d.left, d.top), f), o.renderAll(), e(a);
                                  });
                                }));

                              case 1:
                              case "end":
                                return e.stop();
                            }
                          }
                        }, e);
                      }));
                      return function (t) {
                        return e.apply(this, arguments);
                      };
                    }(), t) {
                      e.next = 8;
                      break;
                    }

                    return a.set({
                      src: null,
                      file: null
                    }), e.abrupt("return", l(t));

                  case 8:
                    if (!(t instanceof File)) {
                      e.next = 12;
                      break;
                    }

                    return e.abrupt("return", new Promise(function (e) {
                      var n = new FileReader();
                      n.onload = function () {
                        a.set({
                          file: t
                        }), l(n.result).then(e);
                      }, n.readAsDataURL(t);
                    }));

                  case 12:
                    return a.set({
                      src: t
                    }), e.abrupt("return", l(t));

                  case 14:
                  case "end":
                    return e.stop();
                }
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }()), x()(this, "calculateScale", function (e) {
          var t = n.handler,
              i = t.canvas,
              r = t.workarea,
              o = r.workareaWidth,
              a = r.workareaHeight,
              s = (e || r)._element,
              l = (null == s ? void 0 : s.width) || o,
              u = (null == s ? void 0 : s.height) || a,
              c = i.getWidth() / l,
              h = i.getHeight() / u;
          return u >= l ? (c = h, i.getWidth() < l * c && (c *= i.getWidth() / (l * c))) : (h = c, i.getHeight() < u * c && (c *= i.getHeight() / (u * c))), {
            scaleX: c,
            scaleY: h
          };
        }), this.handler = t, this.initialize();
      }

      return u()(e, [{
        key: "initialize",
        value: function value() {
          var e = this.handler.workareaOption,
              t = new Image(e.width, e.height);
          t.width = e.width, t.height = e.height, this.handler.workarea = new w.fabric.Image(t, e), this.handler.canvas.add(this.handler.workarea), this.handler.objects = this.handler.getObjects(), this.handler.canvas.centerObject(this.handler.workarea), this.handler.canvas.renderAll();
        }
      }]), e;
    }(),
        pt = function e(t) {
      var n = this;
      s()(this, e), x()(this, "handler", void 0), x()(this, "selection", function (e) {
        "selection" !== n.handler.interactionMode && (n.handler.interactionMode = "selection", void 0 === n.handler.canvasOption.selection ? n.handler.canvas.selection = !0 : n.handler.canvas.selection = n.handler.canvasOption.selection, n.handler.canvas.defaultCursor = "default", n.handler.workarea.hoverCursor = "default", n.handler.getObjects().forEach(function (t) {
          if (e) n.interactionCallback(t, e);else {
            if ("link" === t.superType || "port" === t.superType) return t.selectable = !1, t.evented = !0, void (t.hoverCursor = "pointer");
            t.hoverCursor = "move", t.selectable = !0, t.evented = !0;
          }
        }), n.handler.canvas.renderAll());
      }), x()(this, "grab", function (e) {
        "grab" !== n.handler.interactionMode && (n.handler.interactionMode = "grab", n.handler.canvas.selection = !1, n.handler.canvas.defaultCursor = "grab", n.handler.workarea.hoverCursor = "grab", n.handler.getObjects().forEach(function (t) {
          e ? n.interactionCallback(t, e) : (t.selectable = !1, t.evented = !n.handler.editable);
        }), n.handler.canvas.renderAll());
      }), x()(this, "drawing", function (e, t) {
        n.isDrawingMode() || (n.handler.interactionMode = e, n.handler.canvas.selection = !1, n.handler.canvas.defaultCursor = "pointer", n.handler.workarea.hoverCursor = "pointer", n.handler.getObjects().forEach(function (e) {
          t ? n.interactionCallback(e, t) : (e.selectable = !1, e.evented = !n.handler.editable);
        }), n.handler.canvas.renderAll());
      }), x()(this, "linking", function (e) {
        n.isDrawingMode() || (n.handler.interactionMode = "link", n.handler.canvas.selection = !1, n.handler.canvas.defaultCursor = "default", n.handler.workarea.hoverCursor = "default", n.handler.getObjects().forEach(function (t) {
          if (e) n.interactionCallback(t, e);else {
            if ("node" === t.superType || "port" === t.superType) return t.hoverCursor = "pointer", t.selectable = !1, void (t.evented = !0);
            t.selectable = !1, t.evented = !n.handler.editable;
          }
        }), n.handler.canvas.renderAll());
      }), x()(this, "moving", function (e) {
        if (!n.isDrawingMode()) {
          var t = new w.fabric.Point(e.movementX, e.movementY);
          n.handler.canvas.relativePan(t), n.handler.canvas.requestRenderAll(), n.handler.objects.forEach(function (e) {
            if ("element" === e.superType) {
              var t = e.id,
                  i = n.handler.elementHandler.findById(t);
              n.handler.elementHandler.setPosition(i, e);
            }
          });
        }
      }), x()(this, "isDrawingMode", function () {
        return "link" === n.handler.interactionMode || "arrow" === n.handler.interactionMode || "line" === n.handler.interactionMode || "polygon" === n.handler.interactionMode;
      }), x()(this, "interactionCallback", function (e, t) {
        t(e);
      }), this.handler = t, this.handler.editable && this.selection();
    };

    function gt(e, t) {
      var n = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        t && (i = i.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, i);
      }

      return n;
    }

    function vt(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? gt(Object(n), !0).forEach(function (t) {
          x()(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : gt(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }

      return e;
    }

    var mt = function e(t) {
      var n = this;
      s()(this, e), x()(this, "handler", void 0), x()(this, "initialize", function () {
        var e = n.handler.gridOption,
            t = e.grid,
            i = e.lineColor,
            r = e.borderColor;
        if (e.enabled && t) for (var o = 5e3 / t, a = {
          stroke: i,
          selectable: !1,
          evented: !1,
          id: "grid"
        }, s = 0; s < o; s++) {
          var l = s * t,
              u = new w.fabric.Line([l, -5e3, l, 5e3], a),
              c = new w.fabric.Line([l - 5e3, -5e3, l - 5e3, 5e3], a);
          n.handler.canvas.add(u), n.handler.canvas.add(c);
          var h = new w.fabric.Line([-5e3, l - 5e3, 5e3, l - 5e3], a),
              d = new w.fabric.Line([-5e3, l, 5e3, l], a);
          n.handler.canvas.add(h), n.handler.canvas.add(d), s % 5 == 0 && (u.set({
            stroke: r
          }), c.set({
            stroke: r
          }), h.set({
            stroke: r
          }), d.set({
            stroke: r
          }));
        }
      }), x()(this, "setCoords", function (e) {
        var t = n.handler.gridOption,
            i = t.enabled,
            r = t.grid,
            o = t.snapToGrid;

        if (i && r && o) {
          if ("activeSelection" === e.type) {
            var a = e;
            return a.set({
              left: Math.round(e.left / r) * r,
              top: Math.round(e.top / r) * r
            }), a.setCoords(), void a.getObjects().forEach(function (t) {
              if ("node" === t.superType) {
                var i = e.left + t.left + e.width / 2,
                    r = e.top + t.top + e.height / 2;
                n.handler.portHandler.setCoords(vt(vt({}, t), {}, {
                  left: i,
                  top: r
                }));
              }
            });
          }

          e.set({
            left: Math.round(e.left / r) * r,
            top: Math.round(e.top / r) * r
          }), e.setCoords(), n.handler.portHandler.setCoords(e);
        }
      }), this.handler = t, this.initialize();
    };

    function yt(e, t) {
      var n = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        t && (i = i.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, i);
      }

      return n;
    }

    var xt = function e(t) {
      var n = this;
      s()(this, e), x()(this, "handler", void 0), x()(this, "create", function (e) {
        if (e.createToPort) {
          var t = e.createToPort(e.left + e.width / 2, e.top);
          t && (t.on("mouseover", function () {
            if ("link" === n.handler.interactionMode && n.handler.activeLine && "line" === n.handler.activeLine.class) {
              if (t.links.some(function (e) {
                return e.fromNode === n.handler.activeLine.fromNode;
              })) return t.set({
                fill: "red"
              }), void n.handler.canvas.renderAll();
              t.set({
                fill: "green"
              }), n.handler.canvas.renderAll();
            }
          }), t.on("mouseout", function () {
            t.set({
              fill: t.originFill
            }), n.handler.canvas.renderAll();
          }), n.handler.canvas.add(t), t.setCoords(), n.handler.canvas.bringToFront(t));
          var i = e.createFromPort(e.left + e.width / 2, e.top + e.height);
          i && i.length && i.forEach(function (e) {
            e && (e.on("mouseover", function () {
              if ("link" !== n.handler.interactionMode) {
                if (e.enabled) return n.handler.activeLine ? (e.set({
                  fill: "red"
                }), void n.handler.canvas.renderAll()) : (e.set({
                  fill: "green"
                }), void n.handler.canvas.renderAll());
                e.set({
                  fill: "red"
                }), n.handler.canvas.renderAll();
              }
            }), e.on("mouseout", function () {
              "link" !== n.handler.interactionMode && e.set({
                fill: e.enabled ? e.originFill : e.hoverFill
              }), n.handler.canvas.renderAll();
            }), n.handler.canvas.add(e), e.setCoords(), n.handler.canvas.bringToFront(e));
          });
        }
      }), x()(this, "setCoords", function (e) {
        if (e.toPort) {
          var t = {
            left: e.left + e.width / 2,
            top: e.top
          };
          e.toPort.set(function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? yt(Object(n), !0).forEach(function (t) {
                x()(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : yt(Object(n)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }

            return e;
          }({}, t)), e.toPort.setCoords(), e.toPort.links.length && e.toPort.links.forEach(function (e) {
            var i = e.fromNode.fromPort.filter(function (t) {
              return t.id === e.fromPort.id;
            })[0];
            n.handler.linkHandler.setCoords(i.left, i.top, t.left, t.top, e);
          });
        }

        if (e.fromPort) {
          var i = {
            left: e.left + e.width / 2,
            top: e.top + e.height
          };
          e.fromPort.forEach(function (e) {
            var t = e.leftDiff ? i.left + e.leftDiff : i.left,
                r = e.topDiff ? i.top + e.topDiff : i.top;
            e.set({
              left: t,
              top: r
            }), e.setCoords(), e.links.length && e.links.forEach(function (e) {
              n.handler.linkHandler.setCoords(t, r, e.toNode.toPort.left, e.toNode.toPort.top, e);
            });
          });
        }
      }), x()(this, "recreate", function (e) {
        var t = e.fromPort,
            i = e.toPort,
            r = e.ports;
        r && r.forEach(function (t) {
          e.removeWithUpdate(t), n.handler.canvas.remove(t.fromPort);
        }), n.handler.canvas.remove(e.toPort), e.toPort && e.toPort.links.forEach(function (e) {
          n.handler.linkHandler.remove(e, "from");
        }), e.fromPort && e.fromPort.forEach(function (e) {
          e.links.length && e.links.forEach(function (e) {
            n.handler.linkHandler.remove(e, "to");
          });
        }), n.create(e), i.links.forEach(function (t) {
          t.fromNode = t.fromNode.id, t.fromPort = t.fromPort.id, t.toNode = e.toPort.nodeId, t.toPort = e.toPort.id, n.handler.linkHandler.create(t);
        }), t.filter(function (t) {
          return e.fromPort.some(function (e) {
            return e.id === t.id;
          });
        }).forEach(function (t) {
          t.links.forEach(function (i) {
            i.fromPort.id === t.id && (i.fromNode = t.nodeId, i.fromPort = t.id, i.toNode = i.toNode.id, i.toPort = i.toPort.id, n.handler.linkHandler.create(i), n.setCoords(e));
          });
        });
      }), this.handler = t;
    },
        _t = (n(644), w.fabric.util.createClass(w.fabric.Object, {
      type: "gif",
      superType: "image",
      gifCanvas: null,
      isStarted: !1,
      initialize: function initialize(e) {
        e = e || {}, this.callSuper("initialize", e), this.gifCanvas = document.createElement("canvas");
      },
      drawFrame: function drawFrame(e, t) {
        this.gifCanvas.width = t.width, this.gifCanvas.height = t.height, e.drawImage(t.buffer, -t.width / 2, -t.height / 2, t.width, t.height);
      },
      _render: function _render(e) {
        var t = this;
        this.callSuper("_render", e), this.isStarted || (this.isStarted = !0, window.gifler("./images/sample/earth.gif").frames(this.gifCanvas, function (n, i) {
          t.isStarted = !0, t.drawFrame(e, i);
        }));
      }
    }));

    _t.fromObject = function (e, t) {
      return t(new _t(e));
    }, window.fabric.Gif = _t;
    var bt = _t,
        wt = w.fabric.util.createClass(w.fabric.Line, {
      type: "arrow",
      superType: "drawing",
      initialize: function initialize(e, t) {
        if (!e) {
          var n = t,
              i = n.x1,
              r = n.x2;
          e = [i, n.y1, r, n.y2];
        }

        t = t || {}, this.callSuper("initialize", e, t);
      },
      _render: function _render(e) {
        this.callSuper("_render", e), e.save();
        var t = this.x2 - this.x1,
            n = this.y2 - this.y1,
            i = Math.atan2(n, t);
        e.translate((this.x2 - this.x1) / 2, (this.y2 - this.y1) / 2), e.rotate(i), e.beginPath(), e.moveTo(5, 0), e.lineTo(-5, 5), e.lineTo(-5, -5), e.closePath(), e.fillStyle = this.stroke, e.fill(), e.restore();
      }
    });
    wt.fromObject = function (e, t) {
      var n = e.x1,
          i = e.x2,
          r = e.y1,
          o = e.y2;
      return t(new wt([n, r, i, o], e));
    }, window.fabric.Arrow = wt;

    var St = wt,
        Tt = n(373),
        Ct = function Ct(e, t, n) {
      return w.fabric.util.object.extend(e.callSuper("toObject"), t.reduce(function (t, n) {
        return Object.assign(t, x()({}, n, e.get(n)));
      }, Object.assign({}, n)));
    },
        kt = w.fabric.util.createClass(w.fabric.Rect, {
      type: "chart",
      superType: "element",
      hasRotatingPoint: !1,
      initialize: function initialize(e, t) {
        t = t || {}, this.callSuper("initialize", t), this.set({
          chartOption: e,
          fill: "rgba(255, 255, 255, 0)",
          stroke: "rgba(255, 255, 255, 0)"
        });
      },
      setSource: function setSource(e) {
        "string" == typeof e ? this.setChartOptionStr(e) : this.setChartOption(e);
      },
      setChartOptionStr: function setChartOptionStr(e) {
        this.set({
          chartOptionStr: e
        });
      },
      setChartOption: function setChartOption(e) {
        this.set({
          chartOption: e
        }), this.distroyChart(), this.createChart(e);
      },
      createChart: function createChart(e) {
        this.instance = Tt.init(this.element), e ? this.instance.setOption(e) : this.instance.setOption({
          xAxis: {},
          yAxis: {},
          series: [{
            type: "line",
            data: [[0, 1], [1, 2], [2, 3], [3, 4]]
          }]
        });
      },
      distroyChart: function distroyChart() {
        this.instance && this.instance.dispose();
      },
      toObject: function toObject(e) {
        return Ct(this, e, {
          chartOption: this.get("chartOption"),
          container: this.get("container"),
          editable: this.get("editable")
        });
      },
      _render: function _render(e) {
        if (this.callSuper("_render", e), !this.instance) {
          var t = this.id,
              n = this.scaleX,
              i = this.scaleY,
              r = this.width,
              o = this.height,
              a = this.angle,
              s = this.editable,
              l = this.chartOption,
              u = this.canvas.getZoom(),
              c = this.calcCoords().tl.x,
              h = this.calcCoords().tl.y,
              d = (r * n * u - r) / 2,
              f = (o * i * u - o) / 2;
          this.element = w.fabric.util.makeElement("div", {
            id: "".concat(t, "_container"),
            style: "transform: rotate(".concat(a, "deg) scale(").concat(n * u, ", ").concat(i * u, ");\n                        width: ").concat(r, "px;\n                        height: ").concat(o, "px;\n                        left: ").concat(c + d, "px;\n                        top: ").concat(h + f, "px;\n                        position: absolute;\n                        user-select: ").concat(s ? "none" : "auto", ";\n                        pointer-events: ").concat(s ? "none" : "auto", ";")
          }), this.createChart(l), document.getElementById(this.container).appendChild(this.element);
        }
      }
    });

    kt.fromObject = function (e, t) {
      return t(new kt(e.chartOption, e));
    }, window.fabric.Chart = kt;
    var Mt = kt,
        Et = {
      html: "",
      css: "",
      js: ""
    },
        At = w.fabric.util.createClass(w.fabric.Rect, {
      type: "element",
      superType: "element",
      hasRotatingPoint: !1,
      initialize: function initialize() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Et,
            t = arguments.length > 1 ? arguments[1] : void 0;
        t = t || {}, this.callSuper("initialize", t), this.set({
          code: e,
          fill: "rgba(255, 255, 255, 0)",
          stroke: "rgba(255, 255, 255, 0)"
        });
      },
      setSource: function setSource(e) {
        this.setCode(e);
      },
      setCode: function setCode() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Et;
        this.set({
          code: e
        });
        var t = e.css,
            n = e.js,
            i = e.html;
        this.styleEl.innerHTML = t, this.scriptEl.innerHTML = n, this.element.innerHTML = i;
      },
      toObject: function toObject(e) {
        return Ct(this, e, {
          code: this.get("code"),
          container: this.get("container"),
          editable: this.get("editable")
        });
      },
      _render: function _render(e) {
        if (this.callSuper("_render", e), !this.element) {
          var t = this.id,
              n = this.scaleX,
              i = this.scaleY,
              r = this.width,
              o = this.height,
              a = this.angle,
              s = this.editable,
              l = this.code,
              u = this.canvas.getZoom(),
              c = this.calcCoords().tl.x,
              h = this.calcCoords().tl.y,
              d = (r * n * u - r) / 2,
              f = (o * i * u - o) / 2;
          this.element = w.fabric.util.makeElement("div", {
            id: "".concat(t, "_container"),
            style: "transform: rotate(".concat(a, "deg) scale(").concat(n * u, ", ").concat(i * u, ");\n                        width: ").concat(r, "px;\n                        height: ").concat(o, "px;\n                        left: ").concat(c + d, "px;\n                        top: ").concat(h + f, "px;\n                        position: absolute;\n                        user-select: ").concat(s ? "none" : "auto", ";\n                        pointer-events: ").concat(s ? "none" : "auto", ";")
          });
          var p = l.html,
              g = l.css,
              v = l.js;
          this.styleEl = document.createElement("style"), this.styleEl.id = "".concat(t, "_style"), this.styleEl.type = "text/css", this.styleEl.innerHTML = g, document.head.appendChild(this.styleEl), this.scriptEl = document.createElement("script"), this.scriptEl.id = "".concat(t, "_script"), this.scriptEl.type = "text/javascript", this.scriptEl.innerHTML = v, document.head.appendChild(this.scriptEl), document.getElementById(this.container).appendChild(this.element), this.element.innerHTML = p;
        }
      }
    });
    At.fromObject = function (e, t) {
      return t(new At(e.code, e));
    }, window.fabric.Element = At;
    var It = At,
        Pt = w.fabric.util.createClass(w.fabric.Rect, {
      type: "iframe",
      superType: "element",
      hasRotatingPoint: !1,
      initialize: function initialize() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
            t = arguments.length > 1 ? arguments[1] : void 0;
        t = t || {}, this.callSuper("initialize", t), this.set({
          src: e,
          fill: "rgba(255, 255, 255, 0)",
          stroke: "rgba(255, 255, 255, 0)"
        });
      },
      setSource: function setSource(e) {
        this.setSrc(e);
      },
      setSrc: function setSrc(e) {
        this.set({
          src: e
        }), this.iframeElement.src = e;
      },
      toObject: function toObject(e) {
        return Ct(this, e, {
          src: this.get("src"),
          container: this.get("container"),
          editable: this.get("editable")
        });
      },
      _render: function _render(e) {
        if (this.callSuper("_render", e), !this.element) {
          var t = this.id,
              n = this.scaleX,
              i = this.scaleY,
              r = this.width,
              o = this.height,
              a = this.angle,
              s = this.editable,
              l = this.src,
              u = this.canvas.getZoom(),
              c = this.calcCoords().tl.x,
              h = this.calcCoords().tl.y,
              d = (r * n * u - r) / 2,
              f = (o * i * u - o) / 2;
          this.iframeElement = w.fabric.util.makeElement("iframe", {
            id: t,
            src: l,
            width: "100%",
            height: "100%"
          }), this.element = w.fabric.util.wrapElement(this.iframeElement, "div", {
            id: "".concat(t, "_container"),
            style: "transform: rotate(".concat(a, "deg) scale(").concat(n * u, ", ").concat(i * u, ");\n                        width: ").concat(r, "px;\n                        height: ").concat(o, "px;\n                        left: ").concat(c + d, "px;\n                        top: ").concat(h + f, "px;\n                        position: absolute;\n                        user-select: ").concat(s ? "none" : "auto", ";\n                        pointer-events: ").concat(s ? "none" : "auto", ";")
          }), document.getElementById(this.container).appendChild(this.element);
        }
      }
    });
    Pt.fromObject = function (e, t) {
      return t(new Pt(e.src, e));
    }, window.fabric.Iframe = Pt;
    var Ot = Pt,
        Lt = (n(939), n(944), w.fabric.util.createClass(w.fabric.Rect, {
      type: "video",
      superType: "element",
      hasRotatingPoint: !1,
      initialize: function initialize(e, t) {
        t = t || {}, this.callSuper("initialize", t), e instanceof File ? this.set({
          file: e,
          src: null
        }) : this.set({
          file: null,
          src: e
        }), this.set({
          fill: "rgba(255, 255, 255, 0)",
          stroke: "rgba(255, 255, 255, 0)"
        });
      },
      setSource: function setSource(e) {
        e instanceof File ? this.setFile(e) : this.setSrc(e);
      },
      setFile: function setFile(e) {
        var t = this;
        this.set({
          file: e,
          src: null
        });
        var n = new FileReader();
        n.onload = function () {
          t.player.setSrc(n.result);
        }, n.readAsDataURL(e);
      },
      setSrc: function setSrc(e) {
        this.set({
          file: null,
          src: e
        }), this.player.setSrc(e);
      },
      toObject: function toObject(e) {
        return Ct(this, e, {
          src: this.get("src"),
          file: this.get("file"),
          container: this.get("container"),
          editable: this.get("editable")
        });
      },
      _render: function _render(e) {
        if (this.callSuper("_render", e), !this.element) {
          var t = this.id,
              n = this.scaleX,
              i = this.scaleY,
              r = this.width,
              o = this.height,
              a = this.angle,
              s = this.editable,
              l = this.src,
              u = this.file,
              c = this.autoplay,
              h = this.muted,
              d = this.loop,
              f = this.canvas.getZoom(),
              p = this.calcCoords().tl.x,
              g = this.calcCoords().tl.y,
              v = (r * n * f - r) / 2,
              m = (o * i * f - o) / 2;
          this.videoElement = w.fabric.util.makeElement("video", {
            id: t,
            autoplay: !s && c,
            muted: !s && h,
            loop: !s && d,
            preload: "none",
            controls: !1
          }), this.element = w.fabric.util.wrapElement(this.videoElement, "div", {
            id: "".concat(t, "_container"),
            style: "transform: rotate(".concat(a, "deg) scale(").concat(n * f, ", ").concat(i * f, ");\n                        width: ").concat(r, "px;\n                        height: ").concat(o, "px;\n                        left: ").concat(p + v, "px;\n                        top: ").concat(g + m, "px;\n                        position: absolute;\n                        user-select: ").concat(s ? "none" : "auto", ";\n                        pointer-events: ").concat(s ? "none" : "auto", ";")
          }), document.getElementById(this.container).appendChild(this.element), this.player = new MediaElementPlayer(t, {
            pauseOtherPlayers: !1,
            videoWidth: "100%",
            videoHeight: "100%",
            success: function success(e, t, n) {
              s && n.pause();
            }
          }), this.player.setPlayerSize(r, o), l ? this.setSrc(l) : u && this.setFile(u);
        }
      }
    }));
    Lt.fromObject = function (e, t) {
      return t(new Lt(e.src || e.file, e));
    }, window.fabric.Video = Lt;
    var Dt = Lt;

    function Nt(e) {
      return (Nt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function jt(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    function Rt(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? Object(arguments[t]) : {},
            i = Object.keys(n);
        "function" == typeof Object.getOwnPropertySymbols && (i = i.concat(Object.getOwnPropertySymbols(n).filter(function (e) {
          return Object.getOwnPropertyDescriptor(n, e).enumerable;
        }))), i.forEach(function (t) {
          jt(e, t, n[t]);
        });
      }

      return e;
    }

    function Ft(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function zt(e, t) {
      for (var n = 0; n < t.length; n++) {
        var i = t[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
      }
    }

    function Bt(e, t, n) {
      return t && zt(e.prototype, t), n && zt(e, n), e;
    }

    function Vt(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }

    function Ht(e, t) {
      return !t || "object" !== Nt(t) && "function" != typeof t ? Vt(e) : t;
    }

    function Wt(e) {
      return (Wt = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Gt(e, t) {
      return (Gt = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Ut(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && Gt(e, t);
    }

    var Yt = {
      type: "logger",
      log: function log(e) {
        this.output("log", e);
      },
      warn: function warn(e) {
        this.output("warn", e);
      },
      error: function error(e) {
        this.output("error", e);
      },
      output: function output(e, t) {
        console && console[e] && console[e].apply(console, t);
      }
    },
        Xt = new (function () {
      function e(t) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        Ft(this, e), this.init(t, n);
      }

      return Bt(e, [{
        key: "init",
        value: function value(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          this.prefix = t.prefix || "i18next:", this.logger = e || Yt, this.options = t, this.debug = t.debug;
        }
      }, {
        key: "setDebug",
        value: function value(e) {
          this.debug = e;
        }
      }, {
        key: "log",
        value: function value() {
          for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
            t[n] = arguments[n];
          }

          return this.forward(t, "log", "", !0);
        }
      }, {
        key: "warn",
        value: function value() {
          for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
            t[n] = arguments[n];
          }

          return this.forward(t, "warn", "", !0);
        }
      }, {
        key: "error",
        value: function value() {
          for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
            t[n] = arguments[n];
          }

          return this.forward(t, "error", "");
        }
      }, {
        key: "deprecate",
        value: function value() {
          for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
            t[n] = arguments[n];
          }

          return this.forward(t, "warn", "WARNING DEPRECATED: ", !0);
        }
      }, {
        key: "forward",
        value: function value(e, t, n, i) {
          return i && !this.debug ? null : ("string" == typeof e[0] && (e[0] = "".concat(n).concat(this.prefix, " ").concat(e[0])), this.logger[t](e));
        }
      }, {
        key: "create",
        value: function value(t) {
          return new e(this.logger, Rt({}, {
            prefix: "".concat(this.prefix, ":").concat(t, ":")
          }, this.options));
        }
      }]), e;
    }())(),
        qt = function () {
      function e() {
        Ft(this, e), this.observers = {};
      }

      return Bt(e, [{
        key: "on",
        value: function value(e, t) {
          var n = this;
          return e.split(" ").forEach(function (e) {
            n.observers[e] = n.observers[e] || [], n.observers[e].push(t);
          }), this;
        }
      }, {
        key: "off",
        value: function value(e, t) {
          this.observers[e] && (t ? this.observers[e] = this.observers[e].filter(function (e) {
            return e !== t;
          }) : delete this.observers[e]);
        }
      }, {
        key: "emit",
        value: function value(e) {
          for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++) {
            n[i - 1] = arguments[i];
          }

          if (this.observers[e]) {
            var r = [].concat(this.observers[e]);
            r.forEach(function (e) {
              e.apply(void 0, n);
            });
          }

          if (this.observers["*"]) {
            var o = [].concat(this.observers["*"]);
            o.forEach(function (t) {
              t.apply(t, [e].concat(n));
            });
          }
        }
      }]), e;
    }();

    function Zt() {
      var e,
          t,
          n = new Promise(function (n, i) {
        e = n, t = i;
      });
      return n.resolve = e, n.reject = t, n;
    }

    function Kt(e) {
      return null == e ? "" : "" + e;
    }

    function $t(e, t, n) {
      e.forEach(function (e) {
        t[e] && (n[e] = t[e]);
      });
    }

    function Qt(e, t, n) {
      function i(e) {
        return e && e.indexOf("###") > -1 ? e.replace(/###/g, ".") : e;
      }

      function r() {
        return !e || "string" == typeof e;
      }

      for (var o = "string" != typeof t ? [].concat(t) : t.split("."); o.length > 1;) {
        if (r()) return {};
        var a = i(o.shift());
        !e[a] && n && (e[a] = new n()), e = e[a];
      }

      return r() ? {} : {
        obj: e,
        k: i(o.shift())
      };
    }

    function Jt(e, t, n) {
      var i = Qt(e, t, Object);
      i.obj[i.k] = n;
    }

    function en(e, t) {
      var n = Qt(e, t),
          i = n.obj,
          r = n.k;
      if (i) return i[r];
    }

    function tn(e, t, n) {
      var i = en(e, n);
      return void 0 !== i ? i : en(t, n);
    }

    function nn(e, t, n) {
      for (var i in t) {
        "__proto__" !== i && (i in e ? "string" == typeof e[i] || e[i] instanceof String || "string" == typeof t[i] || t[i] instanceof String ? n && (e[i] = t[i]) : nn(e[i], t[i], n) : e[i] = t[i]);
      }

      return e;
    }

    function rn(e) {
      return e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
    }

    var on = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "/": "&#x2F;"
    };

    function an(e) {
      return "string" == typeof e ? e.replace(/[&<>"'\/]/g, function (e) {
        return on[e];
      }) : e;
    }

    var sn = "undefined" != typeof window && window.navigator && window.navigator.userAgent && window.navigator.userAgent.indexOf("MSIE") > -1,
        ln = function (e) {
      function t(e) {
        var n,
            i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
          ns: ["translation"],
          defaultNS: "translation"
        };
        return Ft(this, t), n = Ht(this, Wt(t).call(this)), sn && qt.call(Vt(n)), n.data = e || {}, n.options = i, void 0 === n.options.keySeparator && (n.options.keySeparator = "."), n;
      }

      return Ut(t, e), Bt(t, [{
        key: "addNamespaces",
        value: function value(e) {
          this.options.ns.indexOf(e) < 0 && this.options.ns.push(e);
        }
      }, {
        key: "removeNamespaces",
        value: function value(e) {
          var t = this.options.ns.indexOf(e);
          t > -1 && this.options.ns.splice(t, 1);
        }
      }, {
        key: "getResource",
        value: function value(e, t, n) {
          var i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
              r = void 0 !== i.keySeparator ? i.keySeparator : this.options.keySeparator,
              o = [e, t];
          return n && "string" != typeof n && (o = o.concat(n)), n && "string" == typeof n && (o = o.concat(r ? n.split(r) : n)), e.indexOf(".") > -1 && (o = e.split(".")), en(this.data, o);
        }
      }, {
        key: "addResource",
        value: function value(e, t, n, i) {
          var r = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : {
            silent: !1
          },
              o = this.options.keySeparator;
          void 0 === o && (o = ".");
          var a = [e, t];
          n && (a = a.concat(o ? n.split(o) : n)), e.indexOf(".") > -1 && (i = t, t = (a = e.split("."))[1]), this.addNamespaces(t), Jt(this.data, a, i), r.silent || this.emit("added", e, t, n, i);
        }
      }, {
        key: "addResources",
        value: function value(e, t, n) {
          var i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {
            silent: !1
          };

          for (var r in n) {
            "string" != typeof n[r] && "[object Array]" !== Object.prototype.toString.apply(n[r]) || this.addResource(e, t, r, n[r], {
              silent: !0
            });
          }

          i.silent || this.emit("added", e, t, n);
        }
      }, {
        key: "addResourceBundle",
        value: function value(e, t, n, i, r) {
          var o = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : {
            silent: !1
          },
              a = [e, t];
          e.indexOf(".") > -1 && (i = n, n = t, t = (a = e.split("."))[1]), this.addNamespaces(t);
          var s = en(this.data, a) || {};
          i ? nn(s, n, r) : s = Rt({}, s, n), Jt(this.data, a, s), o.silent || this.emit("added", e, t, n);
        }
      }, {
        key: "removeResourceBundle",
        value: function value(e, t) {
          this.hasResourceBundle(e, t) && delete this.data[e][t], this.removeNamespaces(t), this.emit("removed", e, t);
        }
      }, {
        key: "hasResourceBundle",
        value: function value(e, t) {
          return void 0 !== this.getResource(e, t);
        }
      }, {
        key: "getResourceBundle",
        value: function value(e, t) {
          return t || (t = this.options.defaultNS), "v1" === this.options.compatibilityAPI ? Rt({}, {}, this.getResource(e, t)) : this.getResource(e, t);
        }
      }, {
        key: "getDataByLanguage",
        value: function value(e) {
          return this.data[e];
        }
      }, {
        key: "toJSON",
        value: function value() {
          return this.data;
        }
      }]), t;
    }(qt),
        un = {
      processors: {},
      addPostProcessor: function addPostProcessor(e) {
        this.processors[e.name] = e;
      },
      handle: function handle(e, t, n, i, r) {
        var o = this;
        return e.forEach(function (e) {
          o.processors[e] && (t = o.processors[e].process(t, n, i, r));
        }), t;
      }
    },
        cn = {},
        hn = function (e) {
      function t(e) {
        var n,
            i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        return Ft(this, t), n = Ht(this, Wt(t).call(this)), sn && qt.call(Vt(n)), $t(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], e, Vt(n)), n.options = i, void 0 === n.options.keySeparator && (n.options.keySeparator = "."), n.logger = Xt.create("translator"), n;
      }

      return Ut(t, e), Bt(t, [{
        key: "changeLanguage",
        value: function value(e) {
          e && (this.language = e);
        }
      }, {
        key: "exists",
        value: function value(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
            interpolation: {}
          },
              n = this.resolve(e, t);
          return n && void 0 !== n.res;
        }
      }, {
        key: "extractFromKey",
        value: function value(e, t) {
          var n = void 0 !== t.nsSeparator ? t.nsSeparator : this.options.nsSeparator;
          void 0 === n && (n = ":");
          var i = void 0 !== t.keySeparator ? t.keySeparator : this.options.keySeparator,
              r = t.ns || this.options.defaultNS;

          if (n && e.indexOf(n) > -1) {
            var o = e.match(this.interpolator.nestingRegexp);
            if (o && o.length > 0) return {
              key: e,
              namespaces: r
            };
            var a = e.split(n);
            (n !== i || n === i && this.options.ns.indexOf(a[0]) > -1) && (r = a.shift()), e = a.join(i);
          }

          return "string" == typeof r && (r = [r]), {
            key: e,
            namespaces: r
          };
        }
      }, {
        key: "translate",
        value: function value(e, t, n) {
          var i = this;
          if ("object" !== Nt(t) && this.options.overloadTranslationOptionHandler && (t = this.options.overloadTranslationOptionHandler(arguments)), t || (t = {}), null == e) return "";
          Array.isArray(e) || (e = [String(e)]);
          var r = void 0 !== t.keySeparator ? t.keySeparator : this.options.keySeparator,
              o = this.extractFromKey(e[e.length - 1], t),
              a = o.key,
              s = o.namespaces,
              l = s[s.length - 1],
              u = t.lng || this.language,
              c = t.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;

          if (u && "cimode" === u.toLowerCase()) {
            if (c) {
              var h = t.nsSeparator || this.options.nsSeparator;
              return l + h + a;
            }

            return a;
          }

          var d = this.resolve(e, t),
              f = d && d.res,
              p = d && d.usedKey || a,
              g = d && d.exactUsedKey || a,
              v = Object.prototype.toString.apply(f),
              m = ["[object Number]", "[object Function]", "[object RegExp]"],
              y = void 0 !== t.joinArrays ? t.joinArrays : this.options.joinArrays,
              x = !this.i18nFormat || this.i18nFormat.handleAsObject,
              _ = "string" != typeof f && "boolean" != typeof f && "number" != typeof f;

          if (x && f && _ && m.indexOf(v) < 0 && ("string" != typeof y || "[object Array]" !== v)) {
            if (!t.returnObjects && !this.options.returnObjects) return this.logger.warn("accessing an object - but returnObjects options is not enabled!"), this.options.returnedObjectHandler ? this.options.returnedObjectHandler(p, f, t) : "key '".concat(a, " (").concat(this.language, ")' returned an object instead of string.");

            if (r) {
              var b = "[object Array]" === v,
                  w = b ? [] : {},
                  S = b ? g : p;

              for (var T in f) {
                if (Object.prototype.hasOwnProperty.call(f, T)) {
                  var C = "".concat(S).concat(r).concat(T);
                  w[T] = this.translate(C, Rt({}, t, {
                    joinArrays: !1,
                    ns: s
                  })), w[T] === C && (w[T] = f[T]);
                }
              }

              f = w;
            }
          } else if (x && "string" == typeof y && "[object Array]" === v) (f = f.join(y)) && (f = this.extendTranslation(f, e, t, n));else {
            var k = !1,
                M = !1;

            if (!this.isValidLookup(f) && void 0 !== t.defaultValue) {
              if (k = !0, void 0 !== t.count) {
                var E = this.pluralResolver.getSuffix(u, t.count);
                f = t["defaultValue".concat(E)];
              }

              f || (f = t.defaultValue);
            }

            this.isValidLookup(f) || (M = !0, f = a);
            var A = t.defaultValue && t.defaultValue !== f && this.options.updateMissing;

            if (M || k || A) {
              if (this.logger.log(A ? "updateKey" : "missingKey", u, l, a, A ? t.defaultValue : f), r) {
                var I = this.resolve(a, Rt({}, t, {
                  keySeparator: !1
                }));
                I && I.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
              }

              var P = [],
                  O = this.languageUtils.getFallbackCodes(this.options.fallbackLng, t.lng || this.language);
              if ("fallback" === this.options.saveMissingTo && O && O[0]) for (var L = 0; L < O.length; L++) {
                P.push(O[L]);
              } else "all" === this.options.saveMissingTo ? P = this.languageUtils.toResolveHierarchy(t.lng || this.language) : P.push(t.lng || this.language);

              var D = function D(e, n) {
                i.options.missingKeyHandler ? i.options.missingKeyHandler(e, l, n, A ? t.defaultValue : f, A, t) : i.backendConnector && i.backendConnector.saveMissing && i.backendConnector.saveMissing(e, l, n, A ? t.defaultValue : f, A, t), i.emit("missingKey", e, l, n, f);
              };

              if (this.options.saveMissing) {
                var N = void 0 !== t.count && "string" != typeof t.count;
                this.options.saveMissingPlurals && N ? P.forEach(function (e) {
                  i.pluralResolver.getPluralFormsOfKey(e, a).forEach(function (t) {
                    return D([e], t);
                  });
                }) : D(P, a);
              }
            }

            f = this.extendTranslation(f, e, t, d, n), M && f === a && this.options.appendNamespaceToMissingKey && (f = "".concat(l, ":").concat(a)), M && this.options.parseMissingKeyHandler && (f = this.options.parseMissingKeyHandler(f));
          }

          return f;
        }
      }, {
        key: "extendTranslation",
        value: function value(e, t, n, i, r) {
          var o = this;
          if (this.i18nFormat && this.i18nFormat.parse) e = this.i18nFormat.parse(e, n, i.usedLng, i.usedNS, i.usedKey, {
            resolved: i
          });else if (!n.skipInterpolation) {
            n.interpolation && this.interpolator.init(Rt({}, n, {
              interpolation: Rt({}, this.options.interpolation, n.interpolation)
            }));
            var a,
                s = n.interpolation && n.interpolation.skipOnVariables || this.options.interpolation.skipOnVariables;

            if (s) {
              var l = e.match(this.interpolator.nestingRegexp);
              a = l && l.length;
            }

            var u = n.replace && "string" != typeof n.replace ? n.replace : n;

            if (this.options.interpolation.defaultVariables && (u = Rt({}, this.options.interpolation.defaultVariables, u)), e = this.interpolator.interpolate(e, u, n.lng || this.language, n), s) {
              var c = e.match(this.interpolator.nestingRegexp);
              a < (c && c.length) && (n.nest = !1);
            }

            !1 !== n.nest && (e = this.interpolator.nest(e, function () {
              for (var e = arguments.length, n = new Array(e), i = 0; i < e; i++) {
                n[i] = arguments[i];
              }

              return r && r[0] === n[0] ? (o.logger.warn("It seems you are nesting recursively key: ".concat(n[0], " in key: ").concat(t[0])), null) : o.translate.apply(o, n.concat([t]));
            }, n)), n.interpolation && this.interpolator.reset();
          }
          var h = n.postProcess || this.options.postProcess,
              d = "string" == typeof h ? [h] : h;
          return null != e && d && d.length && !1 !== n.applyPostProcessor && (e = un.handle(d, e, t, this.options && this.options.postProcessPassResolved ? Rt({
            i18nResolved: i
          }, n) : n, this)), e;
        }
      }, {
        key: "resolve",
        value: function value(e) {
          var t,
              n,
              i,
              r,
              o,
              a = this,
              s = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return "string" == typeof e && (e = [e]), e.forEach(function (e) {
            if (!a.isValidLookup(t)) {
              var l = a.extractFromKey(e, s),
                  u = l.key;
              n = u;
              var c = l.namespaces;
              a.options.fallbackNS && (c = c.concat(a.options.fallbackNS));
              var h = void 0 !== s.count && "string" != typeof s.count,
                  d = void 0 !== s.context && "string" == typeof s.context && "" !== s.context,
                  f = s.lngs ? s.lngs : a.languageUtils.toResolveHierarchy(s.lng || a.language, s.fallbackLng);
              c.forEach(function (e) {
                a.isValidLookup(t) || (o = e, !cn["".concat(f[0], "-").concat(e)] && a.utils && a.utils.hasLoadedNamespace && !a.utils.hasLoadedNamespace(o) && (cn["".concat(f[0], "-").concat(e)] = !0, a.logger.warn('key "'.concat(n, '" for languages "').concat(f.join(", "), '" won\'t get resolved as namespace "').concat(o, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), f.forEach(function (n) {
                  if (!a.isValidLookup(t)) {
                    r = n;
                    var o,
                        l,
                        c = u,
                        f = [c];
                    if (a.i18nFormat && a.i18nFormat.addLookupKeys) a.i18nFormat.addLookupKeys(f, u, n, e, s);else h && (o = a.pluralResolver.getSuffix(n, s.count)), h && d && f.push(c + o), d && f.push(c += "".concat(a.options.contextSeparator).concat(s.context)), h && f.push(c += o);

                    for (; l = f.pop();) {
                      a.isValidLookup(t) || (i = l, t = a.getResource(n, e, l, s));
                    }
                  }
                }));
              });
            }
          }), {
            res: t,
            usedKey: n,
            exactUsedKey: i,
            usedLng: r,
            usedNS: o
          };
        }
      }, {
        key: "isValidLookup",
        value: function value(e) {
          return !(void 0 === e || !this.options.returnNull && null === e || !this.options.returnEmptyString && "" === e);
        }
      }, {
        key: "getResource",
        value: function value(e, t, n) {
          var i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
          return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(e, t, n, i) : this.resourceStore.getResource(e, t, n, i);
        }
      }]), t;
    }(qt);

    function dn(e) {
      return e.charAt(0).toUpperCase() + e.slice(1);
    }

    var fn = function () {
      function e(t) {
        Ft(this, e), this.options = t, this.whitelist = this.options.supportedLngs || !1, this.supportedLngs = this.options.supportedLngs || !1, this.logger = Xt.create("languageUtils");
      }

      return Bt(e, [{
        key: "getScriptPartFromCode",
        value: function value(e) {
          if (!e || e.indexOf("-") < 0) return null;
          var t = e.split("-");
          return 2 === t.length ? null : (t.pop(), "x" === t[t.length - 1].toLowerCase() ? null : this.formatLanguageCode(t.join("-")));
        }
      }, {
        key: "getLanguagePartFromCode",
        value: function value(e) {
          if (!e || e.indexOf("-") < 0) return e;
          var t = e.split("-");
          return this.formatLanguageCode(t[0]);
        }
      }, {
        key: "formatLanguageCode",
        value: function value(e) {
          if ("string" == typeof e && e.indexOf("-") > -1) {
            var t = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"],
                n = e.split("-");
            return this.options.lowerCaseLng ? n = n.map(function (e) {
              return e.toLowerCase();
            }) : 2 === n.length ? (n[0] = n[0].toLowerCase(), n[1] = n[1].toUpperCase(), t.indexOf(n[1].toLowerCase()) > -1 && (n[1] = dn(n[1].toLowerCase()))) : 3 === n.length && (n[0] = n[0].toLowerCase(), 2 === n[1].length && (n[1] = n[1].toUpperCase()), "sgn" !== n[0] && 2 === n[2].length && (n[2] = n[2].toUpperCase()), t.indexOf(n[1].toLowerCase()) > -1 && (n[1] = dn(n[1].toLowerCase())), t.indexOf(n[2].toLowerCase()) > -1 && (n[2] = dn(n[2].toLowerCase()))), n.join("-");
          }

          return this.options.cleanCode || this.options.lowerCaseLng ? e.toLowerCase() : e;
        }
      }, {
        key: "isWhitelisted",
        value: function value(e) {
          return this.logger.deprecate("languageUtils.isWhitelisted", 'function "isWhitelisted" will be renamed to "isSupportedCode" in the next major - please make sure to rename it\'s usage asap.'), this.isSupportedCode(e);
        }
      }, {
        key: "isSupportedCode",
        value: function value(e) {
          return ("languageOnly" === this.options.load || this.options.nonExplicitSupportedLngs) && (e = this.getLanguagePartFromCode(e)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(e) > -1;
        }
      }, {
        key: "getBestMatchFromCodes",
        value: function value(e) {
          var t,
              n = this;
          return e ? (e.forEach(function (e) {
            if (!t) {
              var i = n.formatLanguageCode(e);
              n.options.supportedLngs && !n.isSupportedCode(i) || (t = i);
            }
          }), !t && this.options.supportedLngs && e.forEach(function (e) {
            if (!t) {
              var i = n.getLanguagePartFromCode(e);
              if (n.isSupportedCode(i)) return t = i;
              t = n.options.supportedLngs.find(function (e) {
                if (0 === e.indexOf(i)) return e;
              });
            }
          }), t || (t = this.getFallbackCodes(this.options.fallbackLng)[0]), t) : null;
        }
      }, {
        key: "getFallbackCodes",
        value: function value(e, t) {
          if (!e) return [];
          if ("string" == typeof e && (e = [e]), "[object Array]" === Object.prototype.toString.apply(e)) return e;
          if (!t) return e.default || [];
          var n = e[t];
          return n || (n = e[this.getScriptPartFromCode(t)]), n || (n = e[this.formatLanguageCode(t)]), n || (n = e[this.getLanguagePartFromCode(t)]), n || (n = e.default), n || [];
        }
      }, {
        key: "toResolveHierarchy",
        value: function value(e, t) {
          var n = this,
              i = this.getFallbackCodes(t || this.options.fallbackLng || [], e),
              r = [],
              o = function o(e) {
            e && (n.isSupportedCode(e) ? r.push(e) : n.logger.warn("rejecting language code not found in supportedLngs: ".concat(e)));
          };

          return "string" == typeof e && e.indexOf("-") > -1 ? ("languageOnly" !== this.options.load && o(this.formatLanguageCode(e)), "languageOnly" !== this.options.load && "currentOnly" !== this.options.load && o(this.getScriptPartFromCode(e)), "currentOnly" !== this.options.load && o(this.getLanguagePartFromCode(e))) : "string" == typeof e && o(this.formatLanguageCode(e)), i.forEach(function (e) {
            r.indexOf(e) < 0 && o(n.formatLanguageCode(e));
          }), r;
        }
      }]), e;
    }(),
        pn = [{
      lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "ti", "tr", "uz", "wa"],
      nr: [1, 2],
      fc: 1
    }, {
      lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
      nr: [1, 2],
      fc: 2
    }, {
      lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "kk", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
      nr: [1],
      fc: 3
    }, {
      lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
      nr: [1, 2, 5],
      fc: 4
    }, {
      lngs: ["ar"],
      nr: [0, 1, 2, 3, 11, 100],
      fc: 5
    }, {
      lngs: ["cs", "sk"],
      nr: [1, 2, 5],
      fc: 6
    }, {
      lngs: ["csb", "pl"],
      nr: [1, 2, 5],
      fc: 7
    }, {
      lngs: ["cy"],
      nr: [1, 2, 3, 8],
      fc: 8
    }, {
      lngs: ["fr"],
      nr: [1, 2],
      fc: 9
    }, {
      lngs: ["ga"],
      nr: [1, 2, 3, 7, 11],
      fc: 10
    }, {
      lngs: ["gd"],
      nr: [1, 2, 3, 20],
      fc: 11
    }, {
      lngs: ["is"],
      nr: [1, 2],
      fc: 12
    }, {
      lngs: ["jv"],
      nr: [0, 1],
      fc: 13
    }, {
      lngs: ["kw"],
      nr: [1, 2, 3, 4],
      fc: 14
    }, {
      lngs: ["lt"],
      nr: [1, 2, 10],
      fc: 15
    }, {
      lngs: ["lv"],
      nr: [1, 2, 0],
      fc: 16
    }, {
      lngs: ["mk"],
      nr: [1, 2],
      fc: 17
    }, {
      lngs: ["mnk"],
      nr: [0, 1, 2],
      fc: 18
    }, {
      lngs: ["mt"],
      nr: [1, 2, 11, 20],
      fc: 19
    }, {
      lngs: ["or"],
      nr: [2, 1],
      fc: 2
    }, {
      lngs: ["ro"],
      nr: [1, 2, 20],
      fc: 20
    }, {
      lngs: ["sl"],
      nr: [5, 1, 2, 3],
      fc: 21
    }, {
      lngs: ["he", "iw"],
      nr: [1, 2, 20, 21],
      fc: 22
    }],
        gn = {
      1: function _(e) {
        return Number(e > 1);
      },
      2: function _(e) {
        return Number(1 != e);
      },
      3: function _(e) {
        return 0;
      },
      4: function _(e) {
        return Number(e % 10 == 1 && e % 100 != 11 ? 0 : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2);
      },
      5: function _(e) {
        return Number(0 == e ? 0 : 1 == e ? 1 : 2 == e ? 2 : e % 100 >= 3 && e % 100 <= 10 ? 3 : e % 100 >= 11 ? 4 : 5);
      },
      6: function _(e) {
        return Number(1 == e ? 0 : e >= 2 && e <= 4 ? 1 : 2);
      },
      7: function _(e) {
        return Number(1 == e ? 0 : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2);
      },
      8: function _(e) {
        return Number(1 == e ? 0 : 2 == e ? 1 : 8 != e && 11 != e ? 2 : 3);
      },
      9: function _(e) {
        return Number(e >= 2);
      },
      10: function _(e) {
        return Number(1 == e ? 0 : 2 == e ? 1 : e < 7 ? 2 : e < 11 ? 3 : 4);
      },
      11: function _(e) {
        return Number(1 == e || 11 == e ? 0 : 2 == e || 12 == e ? 1 : e > 2 && e < 20 ? 2 : 3);
      },
      12: function _(e) {
        return Number(e % 10 != 1 || e % 100 == 11);
      },
      13: function _(e) {
        return Number(0 !== e);
      },
      14: function _(e) {
        return Number(1 == e ? 0 : 2 == e ? 1 : 3 == e ? 2 : 3);
      },
      15: function _(e) {
        return Number(e % 10 == 1 && e % 100 != 11 ? 0 : e % 10 >= 2 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2);
      },
      16: function _(e) {
        return Number(e % 10 == 1 && e % 100 != 11 ? 0 : 0 !== e ? 1 : 2);
      },
      17: function _(e) {
        return Number(1 == e || e % 10 == 1 && e % 100 != 11 ? 0 : 1);
      },
      18: function _(e) {
        return Number(0 == e ? 0 : 1 == e ? 1 : 2);
      },
      19: function _(e) {
        return Number(1 == e ? 0 : 0 == e || e % 100 > 1 && e % 100 < 11 ? 1 : e % 100 > 10 && e % 100 < 20 ? 2 : 3);
      },
      20: function _(e) {
        return Number(1 == e ? 0 : 0 == e || e % 100 > 0 && e % 100 < 20 ? 1 : 2);
      },
      21: function _(e) {
        return Number(e % 100 == 1 ? 1 : e % 100 == 2 ? 2 : e % 100 == 3 || e % 100 == 4 ? 3 : 0);
      },
      22: function _(e) {
        return Number(1 == e ? 0 : 2 == e ? 1 : (e < 0 || e > 10) && e % 10 == 0 ? 2 : 3);
      }
    };

    function vn() {
      var e = {};
      return pn.forEach(function (t) {
        t.lngs.forEach(function (n) {
          e[n] = {
            numbers: t.nr,
            plurals: gn[t.fc]
          };
        });
      }), e;
    }

    var mn = function () {
      function e(t) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        Ft(this, e), this.languageUtils = t, this.options = n, this.logger = Xt.create("pluralResolver"), this.rules = vn();
      }

      return Bt(e, [{
        key: "addRule",
        value: function value(e, t) {
          this.rules[e] = t;
        }
      }, {
        key: "getRule",
        value: function value(e) {
          return this.rules[e] || this.rules[this.languageUtils.getLanguagePartFromCode(e)];
        }
      }, {
        key: "needsPlural",
        value: function value(e) {
          var t = this.getRule(e);
          return t && t.numbers.length > 1;
        }
      }, {
        key: "getPluralFormsOfKey",
        value: function value(e, t) {
          var n = this,
              i = [],
              r = this.getRule(e);
          return r ? (r.numbers.forEach(function (r) {
            var o = n.getSuffix(e, r);
            i.push("".concat(t).concat(o));
          }), i) : i;
        }
      }, {
        key: "getSuffix",
        value: function value(e, t) {
          var n = this,
              i = this.getRule(e);

          if (i) {
            var r = i.noAbs ? i.plurals(t) : i.plurals(Math.abs(t)),
                o = i.numbers[r];
            this.options.simplifyPluralSuffix && 2 === i.numbers.length && 1 === i.numbers[0] && (2 === o ? o = "plural" : 1 === o && (o = ""));

            var a = function a() {
              return n.options.prepend && o.toString() ? n.options.prepend + o.toString() : o.toString();
            };

            return "v1" === this.options.compatibilityJSON ? 1 === o ? "" : "number" == typeof o ? "_plural_".concat(o.toString()) : a() : "v2" === this.options.compatibilityJSON || this.options.simplifyPluralSuffix && 2 === i.numbers.length && 1 === i.numbers[0] ? a() : this.options.prepend && r.toString() ? this.options.prepend + r.toString() : r.toString();
          }

          return this.logger.warn("no plural rule found for: ".concat(e)), "";
        }
      }]), e;
    }(),
        yn = function () {
      function e() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        Ft(this, e), this.logger = Xt.create("interpolator"), this.options = t, this.format = t.interpolation && t.interpolation.format || function (e) {
          return e;
        }, this.init(t);
      }

      return Bt(e, [{
        key: "init",
        value: function value() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          e.interpolation || (e.interpolation = {
            escapeValue: !0
          });
          var t = e.interpolation;
          this.escape = void 0 !== t.escape ? t.escape : an, this.escapeValue = void 0 === t.escapeValue || t.escapeValue, this.useRawValueToEscape = void 0 !== t.useRawValueToEscape && t.useRawValueToEscape, this.prefix = t.prefix ? rn(t.prefix) : t.prefixEscaped || "{{", this.suffix = t.suffix ? rn(t.suffix) : t.suffixEscaped || "}}", this.formatSeparator = t.formatSeparator ? t.formatSeparator : t.formatSeparator || ",", this.unescapePrefix = t.unescapeSuffix ? "" : t.unescapePrefix || "-", this.unescapeSuffix = this.unescapePrefix ? "" : t.unescapeSuffix || "", this.nestingPrefix = t.nestingPrefix ? rn(t.nestingPrefix) : t.nestingPrefixEscaped || rn("$t("), this.nestingSuffix = t.nestingSuffix ? rn(t.nestingSuffix) : t.nestingSuffixEscaped || rn(")"), this.nestingOptionsSeparator = t.nestingOptionsSeparator ? t.nestingOptionsSeparator : t.nestingOptionsSeparator || ",", this.maxReplaces = t.maxReplaces ? t.maxReplaces : 1e3, this.alwaysFormat = void 0 !== t.alwaysFormat && t.alwaysFormat, this.resetRegExp();
        }
      }, {
        key: "reset",
        value: function value() {
          this.options && this.init(this.options);
        }
      }, {
        key: "resetRegExp",
        value: function value() {
          var e = "".concat(this.prefix, "(.+?)").concat(this.suffix);
          this.regexp = new RegExp(e, "g");
          var t = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
          this.regexpUnescape = new RegExp(t, "g");
          var n = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
          this.nestingRegexp = new RegExp(n, "g");
        }
      }, {
        key: "interpolate",
        value: function value(e, t, n, i) {
          var r,
              o,
              a,
              s = this,
              l = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};

          function u(e) {
            return e.replace(/\$/g, "$$$$");
          }

          var c = function c(e) {
            if (e.indexOf(s.formatSeparator) < 0) {
              var r = tn(t, l, e);
              return s.alwaysFormat ? s.format(r, void 0, n) : r;
            }

            var o = e.split(s.formatSeparator),
                a = o.shift().trim(),
                u = o.join(s.formatSeparator).trim();
            return s.format(tn(t, l, a), u, n, i);
          };

          this.resetRegExp();
          var h = i && i.missingInterpolationHandler || this.options.missingInterpolationHandler,
              d = i && i.interpolation && i.interpolation.skipOnVariables || this.options.interpolation.skipOnVariables;
          return [{
            regex: this.regexpUnescape,
            safeValue: function safeValue(e) {
              return u(e);
            }
          }, {
            regex: this.regexp,
            safeValue: function safeValue(e) {
              return s.escapeValue ? u(s.escape(e)) : u(e);
            }
          }].forEach(function (t) {
            for (a = 0; r = t.regex.exec(e);) {
              if (void 0 === (o = c(r[1].trim()))) {
                if ("function" == typeof h) {
                  var n = h(e, r, i);
                  o = "string" == typeof n ? n : "";
                } else {
                  if (d) {
                    o = r[0];
                    continue;
                  }

                  s.logger.warn("missed to pass in variable ".concat(r[1], " for interpolating ").concat(e)), o = "";
                }
              } else "string" == typeof o || s.useRawValueToEscape || (o = Kt(o));
              if (e = e.replace(r[0], t.safeValue(o)), t.regex.lastIndex = 0, ++a >= s.maxReplaces) break;
            }
          }), e;
        }
      }, {
        key: "nest",
        value: function value(e, t) {
          var n,
              i,
              r = this,
              o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              a = Rt({}, o);

          function s(e, t) {
            var n = this.nestingOptionsSeparator;
            if (e.indexOf(n) < 0) return e;
            var i = e.split(new RegExp("".concat(n, "[ ]*{"))),
                r = "{".concat(i[1]);
            e = i[0], r = (r = this.interpolate(r, a)).replace(/'/g, '"');

            try {
              a = JSON.parse(r), t && (a = Rt({}, t, a));
            } catch (t) {
              return this.logger.warn("failed parsing options string in nesting for key ".concat(e), t), "".concat(e).concat(n).concat(r);
            }

            return delete a.defaultValue, e;
          }

          for (a.applyPostProcessor = !1, delete a.defaultValue; n = this.nestingRegexp.exec(e);) {
            var l = [],
                u = !1;

            if (n[0].includes(this.formatSeparator) && !/{.*}/.test(n[1])) {
              var c = n[1].split(this.formatSeparator).map(function (e) {
                return e.trim();
              });
              n[1] = c.shift(), l = c, u = !0;
            }

            if ((i = t(s.call(this, n[1].trim(), a), a)) && n[0] === e && "string" != typeof i) return i;
            "string" != typeof i && (i = Kt(i)), i || (this.logger.warn("missed to resolve ".concat(n[1], " for nesting ").concat(e)), i = ""), u && (i = l.reduce(function (e, t) {
              return r.format(e, t, o.lng, o);
            }, i.trim())), e = e.replace(n[0], i), this.regexp.lastIndex = 0;
          }

          return e;
        }
      }]), e;
    }();

    var xn = function (e) {
      function t(e, n, i) {
        var r,
            o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
        return Ft(this, t), r = Ht(this, Wt(t).call(this)), sn && qt.call(Vt(r)), r.backend = e, r.store = n, r.services = i, r.languageUtils = i.languageUtils, r.options = o, r.logger = Xt.create("backendConnector"), r.state = {}, r.queue = [], r.backend && r.backend.init && r.backend.init(i, o.backend, o), r;
      }

      return Ut(t, e), Bt(t, [{
        key: "queueLoad",
        value: function value(e, t, n, i) {
          var r = this,
              o = [],
              a = [],
              s = [],
              l = [];
          return e.forEach(function (e) {
            var i = !0;
            t.forEach(function (t) {
              var s = "".concat(e, "|").concat(t);
              !n.reload && r.store.hasResourceBundle(e, t) ? r.state[s] = 2 : r.state[s] < 0 || (1 === r.state[s] ? a.indexOf(s) < 0 && a.push(s) : (r.state[s] = 1, i = !1, a.indexOf(s) < 0 && a.push(s), o.indexOf(s) < 0 && o.push(s), l.indexOf(t) < 0 && l.push(t)));
            }), i || s.push(e);
          }), (o.length || a.length) && this.queue.push({
            pending: a,
            loaded: {},
            errors: [],
            callback: i
          }), {
            toLoad: o,
            pending: a,
            toLoadLanguages: s,
            toLoadNamespaces: l
          };
        }
      }, {
        key: "loaded",
        value: function value(e, t, n) {
          var i = e.split("|"),
              r = i[0],
              o = i[1];
          t && this.emit("failedLoading", r, o, t), n && this.store.addResourceBundle(r, o, n), this.state[e] = t ? -1 : 2;
          var a = {};
          this.queue.forEach(function (n) {
            var i, s, l, u, c, h;
            i = n.loaded, s = o, u = Qt(i, [r], Object), c = u.obj, h = u.k, c[h] = c[h] || [], l && (c[h] = c[h].concat(s)), l || c[h].push(s), function (e, t) {
              for (var n = e.indexOf(t); -1 !== n;) {
                e.splice(n, 1), n = e.indexOf(t);
              }
            }(n.pending, e), t && n.errors.push(t), 0 !== n.pending.length || n.done || (Object.keys(n.loaded).forEach(function (e) {
              a[e] || (a[e] = []), n.loaded[e].length && n.loaded[e].forEach(function (t) {
                a[e].indexOf(t) < 0 && a[e].push(t);
              });
            }), n.done = !0, n.errors.length ? n.callback(n.errors) : n.callback());
          }), this.emit("loaded", a), this.queue = this.queue.filter(function (e) {
            return !e.done;
          });
        }
      }, {
        key: "read",
        value: function value(e, t, n) {
          var i = this,
              r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0,
              o = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 350,
              a = arguments.length > 5 ? arguments[5] : void 0;
          return e.length ? this.backend[n](e, t, function (s, l) {
            s && l && r < 5 ? setTimeout(function () {
              i.read.call(i, e, t, n, r + 1, 2 * o, a);
            }, o) : a(s, l);
          }) : a(null, {});
        }
      }, {
        key: "prepareLoading",
        value: function value(e, t) {
          var n = this,
              i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              r = arguments.length > 3 ? arguments[3] : void 0;
          if (!this.backend) return this.logger.warn("No backend was added via i18next.use. Will not load resources."), r && r();
          "string" == typeof e && (e = this.languageUtils.toResolveHierarchy(e)), "string" == typeof t && (t = [t]);
          var o = this.queueLoad(e, t, i, r);
          if (!o.toLoad.length) return o.pending.length || r(), null;
          o.toLoad.forEach(function (e) {
            n.loadOne(e);
          });
        }
      }, {
        key: "load",
        value: function value(e, t, n) {
          this.prepareLoading(e, t, {}, n);
        }
      }, {
        key: "reload",
        value: function value(e, t, n) {
          this.prepareLoading(e, t, {
            reload: !0
          }, n);
        }
      }, {
        key: "loadOne",
        value: function value(e) {
          var t = this,
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
              i = e.split("|"),
              r = i[0],
              o = i[1];
          this.read(r, o, "read", void 0, void 0, function (i, a) {
            i && t.logger.warn("".concat(n, "loading namespace ").concat(o, " for language ").concat(r, " failed"), i), !i && a && t.logger.log("".concat(n, "loaded namespace ").concat(o, " for language ").concat(r), a), t.loaded(e, i, a);
          });
        }
      }, {
        key: "saveMissing",
        value: function value(e, t, n, i, r) {
          var o = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : {};
          this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(t) ? this.logger.warn('did not save key "'.concat(n, '" as the namespace "').concat(t, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!") : null != n && "" !== n && (this.backend && this.backend.create && this.backend.create(e, t, n, i, null, Rt({}, o, {
            isUpdate: r
          })), e && e[0] && this.store.addResource(e[0], t, n, i));
        }
      }]), t;
    }(qt);

    function _n() {
      return {
        debug: !1,
        initImmediate: !0,
        ns: ["translation"],
        defaultNS: ["translation"],
        fallbackLng: ["dev"],
        fallbackNS: !1,
        whitelist: !1,
        nonExplicitWhitelist: !1,
        supportedLngs: !1,
        nonExplicitSupportedLngs: !1,
        load: "all",
        preload: !1,
        simplifyPluralSuffix: !0,
        keySeparator: ".",
        nsSeparator: ":",
        pluralSeparator: "_",
        contextSeparator: "_",
        partialBundledLanguages: !1,
        saveMissing: !1,
        updateMissing: !1,
        saveMissingTo: "fallback",
        saveMissingPlurals: !0,
        missingKeyHandler: !1,
        missingInterpolationHandler: !1,
        postProcess: !1,
        postProcessPassResolved: !1,
        returnNull: !0,
        returnEmptyString: !0,
        returnObjects: !1,
        joinArrays: !1,
        returnedObjectHandler: !1,
        parseMissingKeyHandler: !1,
        appendNamespaceToMissingKey: !1,
        appendNamespaceToCIMode: !1,
        overloadTranslationOptionHandler: function overloadTranslationOptionHandler(e) {
          var t = {};

          if ("object" === Nt(e[1]) && (t = e[1]), "string" == typeof e[1] && (t.defaultValue = e[1]), "string" == typeof e[2] && (t.tDescription = e[2]), "object" === Nt(e[2]) || "object" === Nt(e[3])) {
            var n = e[3] || e[2];
            Object.keys(n).forEach(function (e) {
              t[e] = n[e];
            });
          }

          return t;
        },
        interpolation: {
          escapeValue: !0,
          format: function format(e, t, n, i) {
            return e;
          },
          prefix: "{{",
          suffix: "}}",
          formatSeparator: ",",
          unescapePrefix: "-",
          nestingPrefix: "$t(",
          nestingSuffix: ")",
          nestingOptionsSeparator: ",",
          maxReplaces: 1e3,
          skipOnVariables: !1
        }
      };
    }

    function bn(e) {
      return "string" == typeof e.ns && (e.ns = [e.ns]), "string" == typeof e.fallbackLng && (e.fallbackLng = [e.fallbackLng]), "string" == typeof e.fallbackNS && (e.fallbackNS = [e.fallbackNS]), e.whitelist && (e.whitelist && e.whitelist.indexOf("cimode") < 0 && (e.whitelist = e.whitelist.concat(["cimode"])), e.supportedLngs = e.whitelist), e.nonExplicitWhitelist && (e.nonExplicitSupportedLngs = e.nonExplicitWhitelist), e.supportedLngs && e.supportedLngs.indexOf("cimode") < 0 && (e.supportedLngs = e.supportedLngs.concat(["cimode"])), e;
    }

    function wn() {}

    var Sn = new (function (e) {
      function t() {
        var e,
            n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            i = arguments.length > 1 ? arguments[1] : void 0;

        if (Ft(this, t), e = Ht(this, Wt(t).call(this)), sn && qt.call(Vt(e)), e.options = bn(n), e.services = {}, e.logger = Xt, e.modules = {
          external: []
        }, i && !e.isInitialized && !n.isClone) {
          if (!e.options.initImmediate) return e.init(n, i), Ht(e, Vt(e));
          setTimeout(function () {
            e.init(n, i);
          }, 0);
        }

        return e;
      }

      return Ut(t, e), Bt(t, [{
        key: "init",
        value: function value() {
          var e = this,
              t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              n = arguments.length > 1 ? arguments[1] : void 0;

          function i(e) {
            return e ? "function" == typeof e ? new e() : e : null;
          }

          if ("function" == typeof t && (n = t, t = {}), t.whitelist && !t.supportedLngs && this.logger.deprecate("whitelist", 'option "whitelist" will be renamed to "supportedLngs" in the next major - please make sure to rename this option asap.'), t.nonExplicitWhitelist && !t.nonExplicitSupportedLngs && this.logger.deprecate("whitelist", 'options "nonExplicitWhitelist" will be renamed to "nonExplicitSupportedLngs" in the next major - please make sure to rename this option asap.'), this.options = Rt({}, _n(), this.options, bn(t)), this.format = this.options.interpolation.format, n || (n = wn), !this.options.isClone) {
            this.modules.logger ? Xt.init(i(this.modules.logger), this.options) : Xt.init(null, this.options);
            var r = new fn(this.options);
            this.store = new ln(this.options.resources, this.options);
            var o = this.services;
            o.logger = Xt, o.resourceStore = this.store, o.languageUtils = r, o.pluralResolver = new mn(r, {
              prepend: this.options.pluralSeparator,
              compatibilityJSON: this.options.compatibilityJSON,
              simplifyPluralSuffix: this.options.simplifyPluralSuffix
            }), o.interpolator = new yn(this.options), o.utils = {
              hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
            }, o.backendConnector = new xn(i(this.modules.backend), o.resourceStore, o, this.options), o.backendConnector.on("*", function (t) {
              for (var n = arguments.length, i = new Array(n > 1 ? n - 1 : 0), r = 1; r < n; r++) {
                i[r - 1] = arguments[r];
              }

              e.emit.apply(e, [t].concat(i));
            }), this.modules.languageDetector && (o.languageDetector = i(this.modules.languageDetector), o.languageDetector.init(o, this.options.detection, this.options)), this.modules.i18nFormat && (o.i18nFormat = i(this.modules.i18nFormat), o.i18nFormat.init && o.i18nFormat.init(this)), this.translator = new hn(this.services, this.options), this.translator.on("*", function (t) {
              for (var n = arguments.length, i = new Array(n > 1 ? n - 1 : 0), r = 1; r < n; r++) {
                i[r - 1] = arguments[r];
              }

              e.emit.apply(e, [t].concat(i));
            }), this.modules.external.forEach(function (t) {
              t.init && t.init(e);
            });
          }

          this.modules.languageDetector || this.options.lng || this.logger.warn("init: no languageDetector is used and no lng is defined");
          var a = ["getResource", "addResource", "addResources", "addResourceBundle", "removeResourceBundle", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"];
          a.forEach(function (t) {
            e[t] = function () {
              var n;
              return (n = e.store)[t].apply(n, arguments);
            };
          });

          var s = Zt(),
              l = function l() {
            e.changeLanguage(e.options.lng, function (t, i) {
              e.isInitialized = !0, e.logger.log("initialized", e.options), e.emit("initialized", e.options), s.resolve(i), n(t, i);
            });
          };

          return this.options.resources || !this.options.initImmediate ? l() : setTimeout(l, 0), s;
        }
      }, {
        key: "loadResources",
        value: function value(e) {
          var t = this,
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : wn,
              i = n,
              r = "string" == typeof e ? e : this.language;

          if ("function" == typeof e && (i = e), !this.options.resources || this.options.partialBundledLanguages) {
            if (r && "cimode" === r.toLowerCase()) return i();

            var o = [],
                a = function a(e) {
              e && t.services.languageUtils.toResolveHierarchy(e).forEach(function (e) {
                o.indexOf(e) < 0 && o.push(e);
              });
            };

            if (r) a(r);else {
              var s = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
              s.forEach(function (e) {
                return a(e);
              });
            }
            this.options.preload && this.options.preload.forEach(function (e) {
              return a(e);
            }), this.services.backendConnector.load(o, this.options.ns, i);
          } else i(null);
        }
      }, {
        key: "reloadResources",
        value: function value(e, t, n) {
          var i = Zt();
          return e || (e = this.languages), t || (t = this.options.ns), n || (n = wn), this.services.backendConnector.reload(e, t, function (e) {
            i.resolve(), n(e);
          }), i;
        }
      }, {
        key: "use",
        value: function value(e) {
          if (!e) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
          if (!e.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
          return "backend" === e.type && (this.modules.backend = e), ("logger" === e.type || e.log && e.warn && e.error) && (this.modules.logger = e), "languageDetector" === e.type && (this.modules.languageDetector = e), "i18nFormat" === e.type && (this.modules.i18nFormat = e), "postProcessor" === e.type && un.addPostProcessor(e), "3rdParty" === e.type && this.modules.external.push(e), this;
        }
      }, {
        key: "changeLanguage",
        value: function value(e, t) {
          var n = this;
          this.isLanguageChangingTo = e;
          var i = Zt();
          this.emit("languageChanging", e);

          var r = function r(e) {
            var r = "string" == typeof e ? e : n.services.languageUtils.getBestMatchFromCodes(e);
            r && (n.language || (n.language = r, n.languages = n.services.languageUtils.toResolveHierarchy(r)), n.translator.language || n.translator.changeLanguage(r), n.services.languageDetector && n.services.languageDetector.cacheUserLanguage(r)), n.loadResources(r, function (e) {
              !function (e, r) {
                r ? (n.language = r, n.languages = n.services.languageUtils.toResolveHierarchy(r), n.translator.changeLanguage(r), n.isLanguageChangingTo = void 0, n.emit("languageChanged", r), n.logger.log("languageChanged", r)) : n.isLanguageChangingTo = void 0, i.resolve(function () {
                  return n.t.apply(n, arguments);
                }), t && t(e, function () {
                  return n.t.apply(n, arguments);
                });
              }(e, r);
            });
          };

          return e || !this.services.languageDetector || this.services.languageDetector.async ? !e && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect(r) : r(e) : r(this.services.languageDetector.detect()), i;
        }
      }, {
        key: "getFixedT",
        value: function value(e, t) {
          var n = this,
              i = function e(t, i) {
            var r;

            if ("object" !== Nt(i)) {
              for (var o = arguments.length, a = new Array(o > 2 ? o - 2 : 0), s = 2; s < o; s++) {
                a[s - 2] = arguments[s];
              }

              r = n.options.overloadTranslationOptionHandler([t, i].concat(a));
            } else r = Rt({}, i);

            return r.lng = r.lng || e.lng, r.lngs = r.lngs || e.lngs, r.ns = r.ns || e.ns, n.t(t, r);
          };

          return "string" == typeof e ? i.lng = e : i.lngs = e, i.ns = t, i;
        }
      }, {
        key: "t",
        value: function value() {
          var e;
          return this.translator && (e = this.translator).translate.apply(e, arguments);
        }
      }, {
        key: "exists",
        value: function value() {
          var e;
          return this.translator && (e = this.translator).exists.apply(e, arguments);
        }
      }, {
        key: "setDefaultNamespace",
        value: function value(e) {
          this.options.defaultNS = e;
        }
      }, {
        key: "hasLoadedNamespace",
        value: function value(e) {
          var t = this,
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          if (!this.isInitialized) return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
          if (!this.languages || !this.languages.length) return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
          var i = this.languages[0],
              r = !!this.options && this.options.fallbackLng,
              o = this.languages[this.languages.length - 1];
          if ("cimode" === i.toLowerCase()) return !0;

          var a = function a(e, n) {
            var i = t.services.backendConnector.state["".concat(e, "|").concat(n)];
            return -1 === i || 2 === i;
          };

          if (n.precheck) {
            var s = n.precheck(this, a);
            if (void 0 !== s) return s;
          }

          return !!this.hasResourceBundle(i, e) || !this.services.backendConnector.backend || !(!a(i, e) || r && !a(o, e));
        }
      }, {
        key: "loadNamespaces",
        value: function value(e, t) {
          var n = this,
              i = Zt();
          return this.options.ns ? ("string" == typeof e && (e = [e]), e.forEach(function (e) {
            n.options.ns.indexOf(e) < 0 && n.options.ns.push(e);
          }), this.loadResources(function (e) {
            i.resolve(), t && t(e);
          }), i) : (t && t(), Promise.resolve());
        }
      }, {
        key: "loadLanguages",
        value: function value(e, t) {
          var n = Zt();
          "string" == typeof e && (e = [e]);
          var i = this.options.preload || [],
              r = e.filter(function (e) {
            return i.indexOf(e) < 0;
          });
          return r.length ? (this.options.preload = i.concat(r), this.loadResources(function (e) {
            n.resolve(), t && t(e);
          }), n) : (t && t(), Promise.resolve());
        }
      }, {
        key: "dir",
        value: function value(e) {
          if (e || (e = this.languages && this.languages.length > 0 ? this.languages[0] : this.language), !e) return "rtl";
          return ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam"].indexOf(this.services.languageUtils.getLanguagePartFromCode(e)) >= 0 ? "rtl" : "ltr";
        }
      }, {
        key: "createInstance",
        value: function value() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              n = arguments.length > 1 ? arguments[1] : void 0;
          return new t(e, n);
        }
      }, {
        key: "cloneInstance",
        value: function value() {
          var e = this,
              n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : wn,
              r = Rt({}, this.options, n, {
            isClone: !0
          }),
              o = new t(r),
              a = ["store", "services", "language"];
          return a.forEach(function (t) {
            o[t] = e[t];
          }), o.services = Rt({}, this.services), o.services.utils = {
            hasLoadedNamespace: o.hasLoadedNamespace.bind(o)
          }, o.translator = new hn(o.services, o.options), o.translator.on("*", function (e) {
            for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++) {
              n[i - 1] = arguments[i];
            }

            o.emit.apply(o, [e].concat(n));
          }), o.init(r, i), o.translator.options = o.options, o.translator.backendConnector.services.utils = {
            hasLoadedNamespace: o.hasLoadedNamespace.bind(o)
          }, o;
        }
      }]), t;
    }(qt))(),
        Tn = w.fabric.util.createClass(w.fabric.Rect, {
      type: "port",
      superType: "port",
      initialize: function initialize(e) {
        e = e || {}, this.callSuper("initialize", e);
      },
      toObject: function toObject() {
        return w.fabric.util.object.extend(this.callSuper("toObject"), {
          id: this.get("id"),
          superType: this.get("superType"),
          enabled: this.get("enabled"),
          nodeId: this.get("nodeId")
        });
      },
      _render: function _render(e) {
        this.callSuper("_render", e);
      }
    });
    Tn.fromObject = function (e, t) {
      return t(new Tn(e));
    }, window.fabric.Port = Tn;
    var Cn = Tn;

    function kn(e, t) {
      var n = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        t && (i = i.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, i);
      }

      return n;
    }

    function Mn(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? kn(Object(n), !0).forEach(function (t) {
          x()(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : kn(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }

      return e;
    }

    var En = {
      TRIGGER: {
        fill: "#48C9B0",
        border: "#1ABC9C"
      },
      LOGIC: {
        fill: "#AF7AC5",
        border: "#9B59B6"
      },
      DATA: {
        fill: "#5DADE2",
        border: "#3498DB"
      },
      ACTION: {
        fill: "#F5B041",
        border: "rgb(243, 156, 18)"
      }
    },
        An = "STATIC",
        In = "DYNAMIC",
        Pn = "BROADCAST",
        On = "NONE",
        Ln = (Sn.t("common.name"), Sn.t("common.name"), Sn.t("common.name"), Sn.t("common.name"), w.fabric.util.createClass(w.fabric.Group, {
      type: "node",
      superType: "node",
      initialize: function initialize(e) {
        e = e || {};
        var t,
            n,
            i = new w.fabric.IText(e.icon || "", {
          fontFamily: "Font Awesome 5 Free",
          fontWeight: 900,
          fontSize: 20,
          fill: "rgba(255, 255, 255, 0.8)"
        }),
            r = "Default Node";
        e.name && (t = e.name, r = (n = 18) ? /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/.test(t) ? t.length > n / 2 ? t.substring(0, n / 2).concat("...") : t : t.length > n ? t.substring(0, n).concat("...") : t : /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/.test(t) ? t.length > 8 ? t.substring(0, 8).concat("...") : t : t.length > 15 ? t.substring(0, 15).concat("...") : t), this.label = new w.fabric.Text(r || "Default Node", {
          fontSize: 16,
          fontFamily: "polestar",
          fontWeight: 500,
          fill: "rgba(255, 255, 255, 0.8)"
        });
        var o = new w.fabric.Rect({
          rx: 10,
          ry: 10,
          width: 200,
          height: 40,
          fill: e.fill || "rgba(0, 0, 0, 0.3)",
          stroke: e.stroke || "rgba(0, 0, 0, 0)",
          strokeWidth: 2
        });
        this.errorFlag = new w.fabric.IText("", {
          fontFamily: "Font Awesome 5 Free",
          fontWeight: 900,
          fontSize: 14,
          fill: "rgba(255, 0, 0, 0.8)",
          visible: e.errors
        });
        var a = [o, i, this.label, this.errorFlag],
            s = Object.assign({}, e, {
          id: e.id || A(),
          width: 200,
          height: 40,
          originX: "left",
          originY: "top",
          hasRotatingPoint: !1,
          hasControls: !1
        });
        this.callSuper("initialize", a, s), i.set({
          top: i.top + 10,
          left: i.left + 10
        }), this.label.set({
          top: this.label.top + this.label.height / 2 + 4,
          left: this.label.left + 35
        }), this.errorFlag.set({
          left: o.left,
          top: o.top,
          visible: e.errors
        });
      },
      toObject: function toObject() {
        return w.fabric.util.object.extend(this.callSuper("toObject"), {
          id: this.get("id"),
          name: this.get("name"),
          icon: this.get("icon"),
          description: this.get("description"),
          superType: this.get("superType"),
          configuration: this.get("configuration"),
          nodeClazz: this.get("nodeClazz"),
          descriptor: this.get("descriptor"),
          borderColor: this.get("borderColor"),
          borderScaleFactor: this.get("borderScaleFactor"),
          dblclick: this.get("dblclick"),
          deletable: this.get("deletable"),
          cloneable: this.get("cloneable"),
          fromPort: this.get("fromPort"),
          toPort: this.get("toPort")
        });
      },
      defaultPortOption: function defaultPortOption() {
        var e = this.descriptor.type;
        return {
          nodeId: this.id,
          hasBorders: !1,
          hasControls: !1,
          hasRotatingPoint: !1,
          selectable: !1,
          originX: "center",
          originY: "center",
          lockScalingX: !0,
          lockScalingY: !0,
          superType: "port",
          originFill: "rgba(0, 0, 0, 0.1)",
          hoverFill: "rgba(0, 0, 0, 0.1)",
          selectFill: "rgba(0, 0, 0, 0.1)",
          fill: "rgba(0, 0, 0, 0.1)",
          hoverCursor: "pointer",
          strokeWidth: 2,
          stroke: this.descriptor ? En[e].border : "rgba(0, 0, 0, 1)",
          width: 10,
          height: 10,
          links: [],
          enabled: !0
        };
      },
      toPortOption: function toPortOption() {
        return Mn({}, this.defaultPortOption());
      },
      fromPortOption: function fromPortOption() {
        return Mn(Mn({}, this.defaultPortOption()), {}, {
          angle: 45
        });
      },
      createToPort: function createToPort(e, t) {
        return this.descriptor.inEnabled && (this.toPort = new Cn(Mn(Mn({
          id: "defaultInPort",
          type: "toPort"
        }, this.toPortOption()), {}, {
          left: e,
          top: t
        }))), this.toPort;
      },
      createFromPort: function createFromPort(e, t) {
        return this.descriptor.outPortType === Pn ? this.fromPort = this.broadcastPort(Mn(Mn({}, this.fromPortOption()), {}, {
          left: e,
          top: t
        })) : this.descriptor.outPortType === An ? this.fromPort = this.staticPort(Mn(Mn({}, this.fromPortOption()), {}, {
          left: e,
          top: t
        })) : this.descriptor.outPortType === In ? this.fromPort = this.dynamicPort(Mn(Mn({}, this.fromPortOption()), {}, {
          left: e,
          top: t
        })) : this.descriptor.outPortType === On ? this.fromPort = [] : this.fromPort = this.singlePort(Mn(Mn({}, this.fromPortOption()), {}, {
          left: e,
          top: t
        })), this.fromPort;
      },
      singlePort: function singlePort(e) {
        return [new Cn(Mn({
          id: "defaultFromPort",
          type: "fromPort"
        }, e))];
      },
      staticPort: function staticPort(e) {
        return this.descriptor.outPorts.map(function (t, n) {
          return new Cn(Mn(Mn({
            id: t,
            type: "fromPort"
          }, e), {}, {
            left: 0 === n ? e.left - 20 : e.left + 20,
            top: e.top,
            leftDiff: 0 === n ? -20 : 20,
            fill: 0 === n ? "rgba(0, 255, 0, 0.3)" : "rgba(255, 0, 0, 0.3)",
            originFill: 0 === n ? "rgba(0, 255, 0, 0.3)" : "rgba(255, 0, 0, 0.3)",
            hoverFill: 0 === n ? "rgba(0, 255, 0, 1)" : "rgba(255, 0, 0, 1)"
          }));
        });
      },
      dynamicPort: function dynamicPort(e) {
        return [];
      },
      broadcastPort: function broadcastPort(e) {
        return this.singlePort(e);
      },
      setErrors: function setErrors(e) {
        this.set({
          errors: e
        }), e ? this.errorFlag.set({
          visible: !0
        }) : this.errorFlag.set({
          visible: !1
        });
      },
      duplicate: function duplicate() {
        var e = this.toObject();
        return e.id = A(), e.name = "".concat(e.name, "_clone"), new Ln(e);
      },
      _render: function _render(e) {
        this.callSuper("_render", e);
      }
    }));
    Ln.fromObject = function (e, t) {
      return t(new Ln(e));
    }, window.fabric.FromPort = Cn, window.fabric.ToPort = Cn, window.fabric.Node = Ln;
    var Dn = Ln,
        Nn = w.fabric.util.createClass(w.fabric.Line, {
      type: "link",
      superType: "link",
      initialize: function initialize(e, t, n, i, r) {
        r = r || {};
        var o = [t.left, t.top, i.left, i.top];
        this.callSuper("initialize", o, r), this.set({
          strokeWidth: 4,
          id: r.id || A(),
          originX: "center",
          originY: "center",
          lockScalingX: !0,
          lockScalingY: !0,
          lockRotation: !0,
          hasRotatingPoint: !1,
          hasControls: !1,
          hasBorders: !1,
          perPixelTargetFind: !0,
          lockMovementX: !0,
          lockMovementY: !0,
          selectable: !1,
          fromNode: e,
          fromPort: t,
          toNode: n,
          toPort: i
        });
      },
      setPort: function setPort(e, t, n, i) {
        "BroadcastNode" === e.type && (t = e.fromPort[0]), t.links.push(this), i.links.push(this), this.setPortEnabled(e, t, !1);
      },
      setPortEnabled: function setPortEnabled(e, t, n) {
        if (e.descriptor.outPortType !== Pn) t.set({
          enabled: n,
          fill: n ? t.originFill : t.selectFill
        });else {
          if (e.toPort.id === t.id) return;
          t.links.forEach(function (e, n) {
            e.set({
              fromPort: t,
              fromPortIndex: n
            });
          }), e.set({
            configuration: {
              outputCount: t.links.length
            }
          });
        }
      },
      toObject: function toObject() {
        return w.fabric.util.object.extend(this.callSuper("toObject"), {
          id: this.get("id"),
          name: this.get("name"),
          superType: this.get("superType"),
          configuration: this.get("configuration"),
          fromNode: this.get("fromNode"),
          fromPort: this.get("fromPort"),
          toNode: this.get("toNode"),
          toPort: this.get("toPort")
        });
      },
      _render: function _render(e) {
        this.callSuper("_render", e), e.save();
        var t = this.x2 - this.x1,
            n = this.y2 - this.y1,
            i = Math.atan2(n, t);
        e.translate((this.x2 - this.x1) / 2, (this.y2 - this.y1) / 2), e.rotate(i), e.beginPath(), this.arrow && (e.moveTo(5, 0), e.lineTo(-5, 5), e.lineTo(-5, -5)), e.closePath(), e.fillStyle = this.stroke, e.fill(), e.restore();
      }
    });
    Nn.fromObject = function (e, t) {
      var n = e.fromNode,
          i = e.fromPort,
          r = e.toNode,
          o = e.toPort;
      return t(new Nn(n, i, r, o, e));
    }, window.fabric.Link = Nn;
    var jn = Nn,
        Rn = w.fabric.util.createClass(jn, {
      type: "curvedLink",
      superType: "link",
      initialize: function initialize(e, t, n, i, r) {
        r = r || {}, this.callSuper("initialize", e, t, n, i, r);
      },
      _render: function _render(e) {
        var t = this.x1,
            n = this.y1,
            i = this.x2,
            r = this.y2;
        e.strokeStyle = this.stroke;
        var o = {
          x: (t - i) / 2,
          y: (n - r) / 2
        },
            a = {
          x: (i - t) / 2,
          y: (r - n) / 2
        };
        e.beginPath(), e.moveTo(o.x, o.y), e.bezierCurveTo(o.x, a.y, a.x, o.y, a.x, a.y), e.stroke(), e.save();
        var s = i - t,
            l = r - n,
            u = Math.atan2(l, s);
        e.translate((i - t) / 2, (r - n) / 2), e.rotate(u >= 0 ? 1.57 : -1.57), e.beginPath(), this.arrow && (e.moveTo(5, 0), e.lineTo(-5, 5), e.lineTo(-5, -5)), e.closePath(), e.fillStyle = this.stroke, e.fill(), e.restore();
      }
    });
    Rn.fromObject = function (e, t) {
      var n = e.fromNode,
          i = e.fromPort,
          r = e.toNode,
          o = e.toPort;
      return t(new Rn(n, i, r, o, e));
    }, window.fabric.CurvedLink = Rn;
    var Fn = Rn,
        zn = w.fabric.util.createClass(jn, {
      type: "OrthogonalLink",
      superType: "link",
      initialize: function initialize(e, t, n, i, r) {
        r = r || {}, this.callSuper("initialize", e, t, n, i, r);
      },
      _render: function _render(e) {
        var t = this.x1,
            n = this.y1,
            i = this.x2,
            r = this.y2;
        e.strokeStyle = this.stroke;
        var o = {
          x: (t - i) / 2,
          y: (n - r) / 2
        },
            a = {
          x: (i - t) / 2,
          y: (r - n) / 2
        };
        e.lineJoin = "round", e.beginPath(), e.moveTo(o.x, o.y), e.lineTo(o.x, a.y / 2), e.lineTo(a.x, a.y / 2), e.lineTo(a.x, a.y), e.stroke(), e.save();
        var s = this.x2 - this.x1,
            l = this.y2 - this.y1,
            u = Math.atan2(l, s);
        e.translate((this.x2 - this.x1) / 2, (this.y2 - this.y1) / 2), e.rotate(u >= 0 ? 1.57 : -1.57), e.beginPath(), this.arrow && (e.moveTo(5, 0), e.lineTo(-5, 5), e.lineTo(-5, -5)), e.closePath(), e.fillStyle = this.stroke, e.fill(), e.restore();
      }
    });
    zn.fromObject = function (e, t) {
      var n = e.fromNode,
          i = e.fromPort,
          r = e.toNode,
          o = e.toPort;
      return t(new zn(n, i, r, o, e));
    }, window.fabric.OrthogonalLink = zn;
    var Bn = zn,
        Vn = w.fabric.util.createClass(w.fabric.Line, {
      type: "line",
      superType: "drawing",
      initialize: function initialize(e, t) {
        if (!e) {
          var n = t,
              i = n.x1,
              r = n.x2;
          e = [i, n.y1, r, n.y2];
        }

        t = t || {}, this.callSuper("initialize", e, t);
      },
      _render: function _render(e) {
        this.callSuper("_render", e);
      }
    });
    Vn.fromObject = function (e, t) {
      var n = e.x1,
          i = e.x2,
          r = e.y1,
          o = e.y2;
      return t(new Vn([n, r, i, o], e));
    }, window.fabric.Line = Vn;
    var Hn = Vn,
        Wn = w.fabric.util.createClass(w.fabric.Circle, {
      type: "port",
      superType: "port",
      initialize: function initialize(e) {
        e = e || {}, this.callSuper("initialize", e);
      },
      toObject: function toObject() {
        return w.fabric.util.object.extend(this.callSuper("toObject"), {
          id: this.get("id"),
          superType: this.get("superType"),
          enabled: this.get("enabled"),
          nodeId: this.get("nodeId")
        });
      },
      _render: function _render(e) {
        this.callSuper("_render", e);
      }
    });
    Wn.fromObject = function (e, t) {
      return t(new Wn(e));
    }, window.fabric.CirclePort = Wn;
    var Gn = Wn,
        Un = w.fabric.util.createClass(w.fabric.Object, {
      type: "cube",
      superType: "shape",
      initialize: function initialize(e) {
        e = e || {}, this.callSuper("initialize", e);
      },
      shadeColor: function shadeColor(e, t) {
        e = e.substr(1);
        var n = parseInt(e, 16),
            i = Math.round(2.55 * t),
            r = (n >> 16) + i,
            o = (n >> 8 & 255) + i,
            a = (255 & n) + i;
        return "#" + (16777216 + 65536 * (r < 255 ? r < 1 ? 0 : r : 255) + 256 * (o < 255 ? o < 1 ? 0 : o : 255) + (a < 255 ? a < 1 ? 0 : a : 255)).toString(16).slice(1);
      },
      _render: function _render(e) {
        var t = this.width,
            n = this.height,
            i = this.fill,
            r = t / 2,
            o = t / 2,
            a = n / 2,
            s = o;
        e.beginPath(), e.moveTo(0, s), e.lineTo(0 - r, s - .5 * r), e.lineTo(0 - r, s - a - .5 * r), e.lineTo(0, s - 1 * a), e.closePath(), e.fillStyle = this.shadeColor(i, -10), e.strokeStyle = i, e.stroke(), e.fill(), e.beginPath(), e.moveTo(0, s), e.lineTo(0 + o, s - .5 * o), e.lineTo(0 + o, s - a - .5 * o), e.lineTo(0, s - 1 * a), e.closePath(), e.fillStyle = this.shadeColor(i, 10), e.strokeStyle = this.shadeColor(i, 50), e.stroke(), e.fill(), e.beginPath(), e.moveTo(0, s - a), e.lineTo(0 - r, s - a - .5 * r), e.lineTo(0 - r + o, s - a - (.5 * r + .5 * o)), e.lineTo(0 + o, s - a - .5 * o), e.closePath(), e.fillStyle = this.shadeColor(i, 20), e.strokeStyle = this.shadeColor(i, 60), e.stroke(), e.fill(), e.restore();
      }
    });
    Un.fromObject = function (e, t) {
      return t(new Un(e));
    }, window.fabric.Cube = Un;
    var Yn = Un,
        Xn = w.fabric.util.createClass(w.fabric.Group, {
      type: "svg",
      initialize: function initialize() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            t = e.svg,
            n = e.loadType;
        this.callSuper("initialize", [], e), this.loadSvg(t, n);
      },
      addSvgElements: function addSvgElements(e, t, n) {
        var i = this,
            r = w.fabric.util.groupSVGElements(e, t, n);
        this.set(t), r.getObjects ? r.getObjects().forEach(function (e) {
          return i.add(e);
        }) : (r.set({
          originX: "center",
          originY: "center"
        }), this.add(r)), this.setCoords(), this.canvas && this.canvas.requestRenderAll();
      },
      loadSvg: function loadSvg(e, t) {
        var n = this;
        return new Promise(function (i) {
          "svg" === t ? w.fabric.loadSVGFromString(e, function (t, r) {
            i(n.addSvgElements(t, r, e));
          }) : w.fabric.loadSVGFromURL(e, function (t, r) {
            i(n.addSvgElements(t, r, e));
          });
        });
      },
      toObject: function toObject(e) {
        return Ct(this, e, {
          svg: this.get("svg"),
          loadType: this.get("loadType")
        });
      },
      _render: function _render(e) {
        this.callSuper("_render", e);
      }
    });
    Xn.fromObject = function (e, t) {
      return t(new Xn(e));
    }, window.fabric.Svg = Xn;
    var qn = Xn;

    function Zn(e, t) {
      var n = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        t && (i = i.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, i);
      }

      return n;
    }

    function Kn(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Zn(Object(n), !0).forEach(function (t) {
          x()(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Zn(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }

      return e;
    }

    var $n = function e(t) {
      var n = this;
      s()(this, e), x()(this, "port", null), x()(this, "handler", void 0), x()(this, "init", function (e) {
        if (!n.isDrawing() && !n.isConnected(e)) {
          n.port = e, n.port.set({
            fill: e.selectFill
          }), n.handler.interactionHandler.linking();
          var t = e.left,
              i = e.top,
              r = e.nodeId,
              o = {
            left: t,
            top: i,
            id: e.id
          },
              a = {
            left: t,
            top: i
          },
              s = n.handler.objectMap[r];
          n.handler.activeLine = new Fn(s, o, null, a, {
            strokeWidth: 2,
            fill: "#999999",
            stroke: "#999999",
            class: "line",
            originX: "center",
            originY: "center",
            selectable: !1,
            hasBorders: !1,
            hasControls: !1,
            evented: !1
          }), n.handler.canvas.add(n.handler.activeLine);
        }
      }), x()(this, "finish", function (e) {
        e || n.port.set({
          fill: n.port.originFill
        }), n.handler.interactionHandler.selection(), n.handler.canvas.remove(n.handler.activeLine), n.handler.activeLine = null, n.handler.canvas.renderAll();
      }), x()(this, "generate", function (e) {
        if (e) {
          if (!n.isDuplicate(e) && !n.isSameNode(e)) {
            var t = {
              type: "curvedLink",
              fromNodeId: n.handler.activeLine.fromNode.id,
              fromPortId: n.handler.activeLine.fromPort.id,
              toNodeId: e.nodeId,
              toPortId: e.id
            },
                i = n.create(t);
            n.finish(i), n.handler.transactionHandler.active || n.handler.transactionHandler.save("add");
          }
        } else j()(!e, "Does not exist target port.");
      }), x()(this, "create", function (e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
            i = n.handler.objectMap[e.fromNodeId],
            r = i.fromPort.filter(function (t) {
          return t.id === e.fromPortId || !t.id;
        })[0],
            o = n.handler.objectMap[e.toNodeId],
            a = o.toPort,
            s = n.handler.fabricObjects[e.type].create(i, r, o, a, Kn({}, e));
        n.handler.canvas.add(s), n.handler.objects = n.handler.getObjects();
        var l = n.handler.editable;
        return n.handler.onAdd && l && !t && n.handler.onAdd(s), n.handler.canvas.renderAll(), s.setPort(i, r, o, a), n.handler.portHandler.setCoords(i), n.handler.portHandler.setCoords(o), n.handler.canvas.requestRenderAll(), s;
      }), x()(this, "setCoords", function (e, t, n, i, r) {
        r.set({
          x1: e,
          y1: t,
          x2: n,
          y2: i
        }), r.setCoords();
      }), x()(this, "removeFrom", function (e) {
        if (e.fromPort) {
          var t = -1;
          e.fromPort.links.length && (e.fromPort.links.some(function (n, i) {
            return e.id === n.id && (t = i, !0);
          }), t > -1 && e.fromPort.links.splice(t, 1)), e.setPortEnabled(e.fromNode, e.fromPort, !0);
        }
      }), x()(this, "removeTo", function (e) {
        if (e.toNode.toPort.links.length) {
          var t = -1;
          e.toNode.toPort.links.some(function (n, i) {
            return e.id === n.id && (t = i, !0);
          }), t > -1 && e.toNode.toPort.links.splice(t, 1), e.setPortEnabled(e.toNode, e.toNode.toPort, !0);
        }
      }), x()(this, "removeAll", function (e) {
        n.removeFrom(e), n.removeTo(e);
      }), x()(this, "remove", function (e, t) {
        "from" === t ? n.removeFrom(e) : "to" === t ? n.removeTo(e) : n.removeAll(e), n.handler.canvas.remove(e), n.handler.objects = n.handler.getObjects();
      }), x()(this, "isConnected", function (e) {
        return j()(e.enabled, "A connected node already exists."), !e.enabled;
      }), x()(this, "isSameNode", function (e) {
        var t = e.nodeId === n.handler.activeLine.fromNode.id;
        return j()(!t, "Cannot select the same node."), t;
      }), x()(this, "isDuplicate", function (e) {
        var t = e.links.some(function (e) {
          return e.fromNode.id === n.handler.activeLine.fromNode.id;
        });
        return j()(!t, "Duplicate connections cannot be made."), t;
      }), x()(this, "isDrawing", function () {
        var e = "link" === n.handler.interactionMode && n.handler.activeLine;
        return j()(!e, "Already drawing links."), e;
      }), this.handler = t;
    },
        Qn = function e(t) {
      var n = this;
      s()(this, e), x()(this, "handler", void 0), x()(this, "getNodePath", function (e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [],
            i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "init";
        e && ("to" !== i && "init" !== i || (e.toPort && e.toPort.links.forEach(function (e) {
          e.fromNode && (t.push(e.fromNode), n.getNodePath(e.fromNode, t, "to"));
        }), "init" === i && t.push(e)), "from" !== i && "init" !== i || e.fromPort.forEach(function (e) {
          e.links.forEach(function (e) {
            e.toNode && (t.push(e.toNode), n.getNodePath(e.toNode, t, "from"));
          });
        }));
      }), x()(this, "selectByPath", function (e) {
        if (e && e.length) {
          var t = n.handler.objects.filter(function (t) {
            return e.some(function (e) {
              return e === t.id;
            });
          });
          n.handler.objects.filter(function (t) {
            return e.some(function (e) {
              return e !== t.id;
            });
          }).forEach(function (e) {
            if ("link" === e.superType) {
              var i = e,
                  r = i.fromNode,
                  o = i.toNode;

              if (r && o) {
                var a = t.findIndex(function (e) {
                  return e.id === r.id;
                }),
                    s = t.findIndex(function (e) {
                  return e.id === o.id;
                });
                if (a >= 0 && t[a] && s >= 0 && t[s]) return e.set({
                  opacity: 1
                }), e.setShadow({
                  color: e.stroke
                }), n.highlightingNode(e, 300), void n.handler.canvas.requestRenderAll();
              }
            }

            e.set({
              opacity: .2
            }), "node" === e.superType && (e.toPort && e.toPort.set({
              opacity: .2
            }), e.fromPort.forEach(function (e) {
              e.set({
                opacity: .2
              });
            })), e.animating || e.setShadow({
              blur: 0
            });
          }), t.forEach(function (e) {
            e.set({
              opacity: 1
            }), e.setShadow({
              color: e.stroke
            }), n.highlightingNode(e, 300), e.toPort && e.toPort.set({
              opacity: 1
            }), e.fromPort && e.fromPort.forEach(function (e) {
              e.set({
                opacity: 1
              });
            });
          }), n.handler.canvas.requestRenderAll();
        }
      }), x()(this, "selectById", function (e) {
        n.handler.objects.forEach(function (t) {
          e !== t.id ? e !== t.nodeId && t.setShadow({
            blur: 0
          }) : t.setShadow({
            color: t.stroke,
            blur: 50
          });
        }), n.handler.canvas.requestRenderAll();
      }), x()(this, "deselect", function () {
        n.handler.objects.forEach(function (e) {
          if (e.set({
            opacity: 1
          }), "node" === e.superType) {
            var t = e;
            t.toPort && t.toPort.set({
              opacity: 1
            }), t.fromPort.forEach(function (e) {
              e.set({
                opacity: 1
              });
            });
          }

          e.animating || e.setShadow({
            blur: 0
          });
        }), n.handler.canvas.renderAll();
      }), x()(this, "highlightingByPath", function (e) {
        if (e && e.length) {
          var t = n.handler.objects.filter(function (t) {
            return e.some(function (e) {
              return e === t.id;
            });
          }),
              i = n.handler.objects.filter(function (t) {
            return e.some(function (e) {
              return e !== t.id;
            });
          }),
              r = t.filter(function (t) {
            return t.id === e[e.length - 1];
          })[0];
          t.forEach(function (e) {
            r ? e.setShadow({
              color: r.stroke
            }) : e.setShadow({
              color: e.stroke
            }), n.highlightingNode(e), n.handler.canvas.requestRenderAll();
          }), i.forEach(function (e) {
            if ("link" === e.superType) {
              var i = e.fromNode,
                  o = e.toNode;

              if (i && o) {
                var a = t.findIndex(function (e) {
                  return e.id === i.id;
                }),
                    s = t.findIndex(function (e) {
                  return e.id === o.id;
                });
                if (a >= 0 && t[a] && s >= 0 && t[s]) return r ? e.setShadow({
                  color: r.stroke
                }) : e.setShadow({
                  color: e.stroke
                }), n.highlightingNode(e), void n.highlightingLink(e, r);
              }
            }
          }), n.handler.canvas.requestRenderAll();
        }
      }), x()(this, "highlightingLink", function (e, t) {
        var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 500;
        e.animation = {
          duration: i,
          type: "flash",
          stroke: t ? t.stroke : e.stroke,
          loop: 1,
          delay: 0
        }, n.handler.animationHandler.play(e.id, !1);
      }), x()(this, "highlightingNode", function (e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 500,
            i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0,
            r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 50,
            o = function o() {
          e.shadow.blur === r && (e.animating = !0, e.animate("shadow.blur", i, {
            easing: w.fabric.util.ease.easeInOutQuad,
            onChange: function onChange(t) {
              e.shadow.blur = t, n.handler.canvas.requestRenderAll();
            },
            onComplete: function onComplete() {
              e.animating = !1, "link" === e.superType && e.set({
                stroke: e.originStroke
              });
            }
          }));
        };

        e.animating = !0, e.animate("shadow.blur", r, {
          easing: w.fabric.util.ease.easeInOutQuad,
          duration: t,
          onChange: function onChange(t) {
            e.shadow.blur = t, n.handler.canvas.requestRenderAll();
          },
          onComplete: o
        });
      }), this.handler = t;
    },
        Jn = function e(t) {
      var n = this;
      s()(this, e), x()(this, "handler", void 0), x()(this, "left", function () {
        var e = n.handler.canvas.getActiveObject();

        if (e && "activeSelection" === e.type) {
          var t = e,
              i = -e.width / 2;
          t.forEachObject(function (e) {
            e.set({
              left: i
            }), e.setCoords(), n.handler.canvas.renderAll();
          });
        }
      }), x()(this, "center", function () {
        var e = n.handler.canvas.getActiveObject();
        e && "activeSelection" === e.type && e.forEachObject(function (e) {
          e.set({
            left: 0 - e.width * e.scaleX / 2
          }), e.setCoords(), n.handler.canvas.renderAll();
        });
      }), x()(this, "right", function () {
        var e = n.handler.canvas.getActiveObject();

        if (e && "activeSelection" === e.type) {
          var t = e,
              i = e.width / 2;
          t.forEachObject(function (e) {
            e.set({
              left: i - e.width * e.scaleX
            }), e.setCoords(), n.handler.canvas.renderAll();
          });
        }
      }), this.handler = t;
    },
        ei = function () {
      function e(t) {
        var n = this;
        s()(this, e), x()(this, "handler", void 0), x()(this, "verticalLines", void 0), x()(this, "horizontalLines", void 0), x()(this, "ctx", void 0), x()(this, "viewportTransform", void 0), x()(this, "aligningLineOffset", 5), x()(this, "aligningLineMargin", 4), x()(this, "aligningLineWidth", 1), x()(this, "aligningLineColor", "rgb(255, 0, 0)"), x()(this, "zoom", 1), x()(this, "beforeRender", function (e) {
          n.handler.canvas.clearContext(n.handler.guidelineHandler.ctx);
        }), x()(this, "afterRender", function (e) {
          for (var t = n.handler.guidelineHandler.verticalLines.length; t--;) {
            n.handler.guidelineHandler.drawVerticalLine(n.handler.guidelineHandler.verticalLines[t]);
          }

          for (var i = n.handler.guidelineHandler.horizontalLines.length; i--;) {
            n.handler.guidelineHandler.drawHorizontalLine(n.handler.guidelineHandler.horizontalLines[i]);
          }

          n.handler.guidelineHandler.verticalLines.length = 0, n.handler.guidelineHandler.horizontalLines.length = 0;
        }), x()(this, "drawVerticalLine", function (e) {
          n.drawLine(e.x + .5, e.y1 > e.y2 ? e.y2 : e.y1, e.x + .5, e.y2 > e.y1 ? e.y2 : e.y1);
        }), x()(this, "drawHorizontalLine", function (e) {
          n.drawLine(e.x1 > e.x2 ? e.x2 : e.x1, e.y + .5, e.x2 > e.x1 ? e.x2 : e.x1, e.y + .5);
        }), x()(this, "drawLine", function (e, t, i, r) {
          var o = n.ctx,
              a = n.aligningLineWidth,
              s = n.aligningLineColor,
              l = n.viewportTransform,
              u = n.zoom;
          o.save(), o.lineWidth = a, o.strokeStyle = s, o.beginPath(), o.moveTo(e * u + l[4], t * u + l[5]), o.lineTo(i * u + l[4], r * u + l[5]), o.stroke(), o.restore();
        }), x()(this, "isInRange", function (e, t) {
          var i = n.aligningLineMargin;
          e = Math.round(e), t = Math.round(t);

          for (var r = e - i, o = e + i; r <= o; r++) {
            if (r === t) return !0;
          }

          return !1;
        }), x()(this, "movingGuidelines", function (e) {
          var t = n.handler.canvas.getObjects(),
              i = e.getCenterPoint(),
              r = i.x,
              o = i.y,
              a = e.getBoundingRect(),
              s = a.height / n.viewportTransform[3],
              l = a.width / n.viewportTransform[0],
              u = !1,
              c = !1;

          if (n.handler.canvas._currentTransform) {
            for (var h = t.length; h--;) {
              if (t[h] !== e && "port" !== t[h].superType && "link" !== t[h].superType && t[h].evented) {
                var d = t[h].getCenterPoint(),
                    f = d.x,
                    p = d.y,
                    g = t[h].getBoundingRect(),
                    v = g.height / n.viewportTransform[3],
                    m = g.width / n.viewportTransform[0];

                if (n.isInRange(f, r)) {
                  if (c = !0, "workarea" === t[h].id) {
                    n.verticalLines.push({
                      x: f,
                      y1: -5e3,
                      y2: 5e3
                    });
                  } else n.verticalLines.push({
                    x: f,
                    y1: p < o ? p - v / 2 - n.aligningLineOffset : p + v / 2 + n.aligningLineOffset,
                    y2: o > p ? o + s / 2 + n.aligningLineOffset : o - s / 2 - n.aligningLineOffset
                  });

                  e.setPositionByOrigin(new w.fabric.Point(f, o), "center", "center");
                }

                if (n.isInRange(f - m / 2, r - l / 2)) {
                  if (c = !0, "workarea" === t[h].id) {
                    var y = f - m / 2;
                    "fullscreen" === t[h].layout && (y = 0), n.verticalLines.push({
                      x: y,
                      y1: -5e3,
                      y2: 5e3
                    });
                  } else n.verticalLines.push({
                    x: f - m / 2,
                    y1: p < o ? p - v / 2 - n.aligningLineOffset : p + v / 2 + n.aligningLineOffset,
                    y2: o > p ? o + s / 2 + n.aligningLineOffset : o - s / 2 - n.aligningLineOffset
                  });

                  e.setPositionByOrigin(new w.fabric.Point(f - m / 2 + l / 2, o), "center", "center");
                }

                if (n.isInRange(f + m / 2, r + l / 2)) {
                  if (c = !0, "workarea" === t[h].id) {
                    var x = f + m / 2;
                    "fullscreen" === t[h].layout && (x = n.handler.canvas.getWidth()), n.verticalLines.push({
                      x: x,
                      y1: -5e3,
                      y2: 5e3
                    });
                  } else n.verticalLines.push({
                    x: f + m / 2,
                    y1: p < o ? p - v / 2 - n.aligningLineOffset : p + v / 2 + n.aligningLineOffset,
                    y2: o > p ? o + s / 2 + n.aligningLineOffset : o - s / 2 - n.aligningLineOffset
                  });

                  e.setPositionByOrigin(new w.fabric.Point(f + m / 2 - l / 2, o), "center", "center");
                }

                if (n.isInRange(p, o)) {
                  if (u = !0, "workarea" === t[h].id) {
                    n.horizontalLines.push({
                      y: p,
                      x1: -5e3,
                      x2: 5e3
                    });
                  } else n.horizontalLines.push({
                    y: p,
                    x1: f < r ? f - m / 2 - n.aligningLineOffset : f + m / 2 + n.aligningLineOffset,
                    x2: r > f ? r + l / 2 + n.aligningLineOffset : r - l / 2 - n.aligningLineOffset
                  });

                  e.setPositionByOrigin(new w.fabric.Point(r, p), "center", "center");
                }

                if (n.isInRange(p - v / 2, o - s / 2)) {
                  if (u = !0, "workarea" === t[h].id) {
                    var _ = p - v / 2;

                    "fullscreen" === t[h].layout && (_ = 0), n.horizontalLines.push({
                      y: _,
                      x1: -5e3,
                      x2: 5e3
                    });
                  } else n.horizontalLines.push({
                    y: p - v / 2,
                    x1: f < r ? f - m / 2 - n.aligningLineOffset : f + m / 2 + n.aligningLineOffset,
                    x2: r > f ? r + l / 2 + n.aligningLineOffset : r - l / 2 - n.aligningLineOffset
                  });

                  e.setPositionByOrigin(new w.fabric.Point(r, p - v / 2 + s / 2), "center", "center");
                }

                if (n.isInRange(p + v / 2, o + s / 2)) {
                  if (u = !0, "workarea" === t[h].id) {
                    var b = p + v / 2;
                    "fullscreen" === t[h].layout && (b = n.handler.canvas.getHeight()), n.horizontalLines.push({
                      y: b,
                      x1: -5e3,
                      x2: 5e3
                    });
                  } else n.horizontalLines.push({
                    y: p + v / 2,
                    x1: f < r ? f - m / 2 - n.aligningLineOffset : f + m / 2 + n.aligningLineOffset,
                    x2: r > f ? r + l / 2 + n.aligningLineOffset : r - l / 2 - n.aligningLineOffset
                  });

                  e.setPositionByOrigin(new w.fabric.Point(r, p + v / 2 - s / 2), "center", "center");
                }
              }
            }

            u || (n.horizontalLines.length = 0), c || (n.verticalLines.length = 0);
          }
        }), x()(this, "scalingGuidelines", function (e) {}), this.handler = t, this.initialize();
      }

      return u()(e, [{
        key: "initialize",
        value: function value() {
          this.handler.guidelineOption.enabled ? this.handler.canvas.on({
            "before:render": this.beforeRender,
            "after:render": this.afterRender
          }) : this.handler.canvas.off({
            "before:render": this.beforeRender,
            "after:render": this.afterRender
          }), this.ctx = this.handler.canvas.getSelectionContext(), this.aligningLineOffset = 5, this.aligningLineMargin = 4, this.aligningLineWidth = 1, this.aligningLineColor = "rgb(255, 0, 0)", this.viewportTransform = this.handler.canvas.viewportTransform, this.zoom = 1, this.verticalLines = [], this.horizontalLines = [];
        }
      }, {
        key: "destroy",
        value: function value() {
          this.handler.canvas.off({
            "before:render": this.beforeRender,
            "after:render": this.afterRender
          });
        }
      }]), e;
    }();

    function ti(e, t) {
      var n = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        t && (i = i.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, i);
      }

      return n;
    }

    function ni(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? ti(Object(n), !0).forEach(function (t) {
          x()(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ti(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }

      return e;
    }

    var ii = function () {
      function e(t) {
        var n = this;
        s()(this, e), x()(this, "handler", void 0), x()(this, "keyCode", void 0), x()(this, "panning", void 0), x()(this, "destroy", function () {
          n.handler.editable ? n.handler.canvas.off({
            "object:modified": n.modified,
            "object:scaling": n.scaling,
            "object:moving": n.moving,
            "object:moved": n.moved,
            "object:rotating": n.rotating,
            "mouse:wheel": n.mousewheel,
            "mouse:down": n.mousedown,
            "mouse:move": n.mousemove,
            "mouse:up": n.mouseup,
            "selection:cleared": n.selection,
            "selection:created": n.selection,
            "selection:updated": n.selection
          }) : (n.handler.canvas.off({
            "mouse:down": n.mousedown,
            "mouse:move": n.mousemove,
            "mouse:out": n.mouseout,
            "mouse:up": n.mouseup,
            "mouse:wheel": n.mousewheel
          }), n.handler.getObjects().forEach(function (e) {
            e.off("mousedown", n.handler.eventHandler.object.mousedown), e.anime && Je.remove(e);
          })), n.handler.canvas.wrapperEl.removeEventListener("keydown", n.keydown), n.handler.canvas.wrapperEl.removeEventListener("keyup", n.keyup), n.handler.canvas.wrapperEl.removeEventListener("mousedown", n.onmousedown), n.handler.canvas.wrapperEl.removeEventListener("contextmenu", n.contextmenu), n.handler.keyEvent.clipboard && n.handler.canvas.wrapperEl.removeEventListener("paste", n.paste);
        }), x()(this, "object", {
          mousedown: function mousedown(e) {
            var t = e.target;

            if (t && t.link && t.link.enabled) {
              var i = n.handler.onClick;
              i && i(n.handler.canvas, t);
            }
          },
          mousedblclick: function mousedblclick(e) {
            var t = e.target;

            if (t) {
              var i = n.handler.onDblClick;
              i && i(n.handler.canvas, t);
            }
          }
        }), x()(this, "modified", function (e) {
          var t = e.target;

          if (t && ("circle" !== t.type || !t.parentId)) {
            var i = n.handler.onModified;
            i && i(t);
          }
        }), x()(this, "moving", function (e) {
          var t = e.target;
          if ("crop" === n.handler.interactionMode) n.handler.cropHandler.moving(e);else {
            if (n.handler.editable && n.handler.guidelineOption.enabled && n.handler.guidelineHandler.movingGuidelines(t), "activeSelection" === t.type) return void t.getObjects().forEach(function (e) {
              var i = t.left + e.left + t.width / 2,
                  r = t.top + e.top + t.height / 2;
              if ("node" === e.superType) n.handler.portHandler.setCoords(ni(ni({}, e), {}, {
                left: i,
                top: r
              }));else if ("element" === e.superType) {
                var o = e.id,
                    a = n.handler.elementHandler.findById(o);
                n.handler.elementHandler.setPositionByOrigin(a, e, i, r);
              }
            });
            if ("node" === t.superType) n.handler.portHandler.setCoords(t);else if ("element" === t.superType) {
              var i = t.id,
                  r = n.handler.elementHandler.findById(i);
              n.handler.elementHandler.setPosition(r, t);
            }
          }
        }), x()(this, "moved", function (e) {
          var t = e.target;

          if (n.handler.gridHandler.setCoords(t), n.handler.transactionHandler.active || n.handler.transactionHandler.save("moved"), "element" === t.superType) {
            var i = t.id,
                r = n.handler.elementHandler.findById(i);
            n.handler.elementHandler.setPosition(r, t);
          }
        }), x()(this, "scaling", function (e) {
          var t = e.target;

          if ("crop" === n.handler.interactionMode && n.handler.cropHandler.resize(e), "element" === t.superType) {
            var i = t.id,
                r = t.width,
                o = t.height,
                a = n.handler.elementHandler.findById(i);
            n.handler.elementHandler.setScaleOrAngle(a, t), n.handler.elementHandler.setSize(a, t), n.handler.elementHandler.setPosition(a, t);
            var s = t;
            "video" === s.type && s.player && s.player.setPlayerSize(r, o);
          }
        }), x()(this, "scaled", function (e) {
          n.handler.transactionHandler.active || n.handler.transactionHandler.save("scaled");
        }), x()(this, "rotating", function (e) {
          var t = e.target;

          if ("element" === t.superType) {
            var i = t.id,
                r = n.handler.elementHandler.findById(i);
            n.handler.elementHandler.setScaleOrAngle(r, t);
          }
        }), x()(this, "rotated", function (e) {
          n.handler.transactionHandler.active || n.handler.transactionHandler.save("rotated");
        }), x()(this, "arrowmoving", function (e) {
          var t = n.handler.canvas.getActiveObject();
          return !!t && "workarea" !== t.id && (38 === e.keyCode ? (t.set("top", t.top - 2), t.setCoords(), n.handler.canvas.renderAll(), !0) : 40 === e.keyCode ? (t.set("top", t.top + 2), t.setCoords(), n.handler.canvas.renderAll(), !0) : 37 === e.keyCode ? (t.set("left", t.left - 2), t.setCoords(), n.handler.canvas.renderAll(), !0) : 39 === e.keyCode ? (t.set("left", t.left + 2), t.setCoords(), n.handler.canvas.renderAll(), !0) : (n.handler.onModified && n.handler.onModified(t), !0));
        }), x()(this, "mousewheel", function (e) {
          var t = e;

          if (n.handler.zoomEnabled) {
            var i = t.e.deltaY,
                r = n.handler.canvas.getZoom();
            i > 0 ? r -= .05 : r += .05, n.handler.zoomHandler.zoomToPoint(new w.fabric.Point(n.handler.canvas.getWidth() / 2, n.handler.canvas.getHeight() / 2), r), t.e.preventDefault(), t.e.stopPropagation();
          }
        }), x()(this, "mousedown", function (e) {
          var t = e,
              i = n.handler.editable;
          if (t.e.altKey && i && !n.handler.interactionHandler.isDrawingMode()) return n.handler.interactionHandler.grab(), void (n.panning = !0);

          if ("grab" !== n.handler.interactionMode) {
            var r = t.target;

            if (i) {
              if (n.handler.prevTarget && "link" === n.handler.prevTarget.superType && n.handler.prevTarget.set({
                stroke: n.handler.prevTarget.originStroke
              }), r && "fromPort" === r.type) return void n.handler.linkHandler.init(r);
              var o;
              if (r && "link" === n.handler.interactionMode && ("toPort" === r.type || "node" === r.superType)) return o = "node" === r.superType ? r.toPort : r, void n.handler.linkHandler.generate(o);
              if (n.handler.guidelineHandler.viewportTransform = n.handler.canvas.viewportTransform, n.handler.guidelineHandler.zoom = n.handler.canvas.getZoom(), "selection" === n.handler.interactionMode) return r && "link" === r.superType && r.set({
                stroke: r.selectFill || "green"
              }), void (n.handler.prevTarget = r);
              "polygon" === n.handler.interactionMode ? r && n.handler.pointArray.length && r.id === n.handler.pointArray[0].id ? n.handler.drawingHandler.polygon.generate(n.handler.pointArray) : n.handler.drawingHandler.polygon.addPoint(t) : "line" === n.handler.interactionMode ? n.handler.pointArray.length && n.handler.activeLine ? n.handler.drawingHandler.line.generate(t) : n.handler.drawingHandler.line.addPoint(t) : "arrow" === n.handler.interactionMode && (n.handler.pointArray.length && n.handler.activeLine ? n.handler.drawingHandler.arrow.generate(t) : n.handler.drawingHandler.arrow.addPoint(t));
            }
          } else n.panning = !0;
        }), x()(this, "mousemove", function (e) {
          var t = e;

          if ("grab" === n.handler.interactionMode && n.panning && (n.handler.interactionHandler.moving(t.e), n.handler.canvas.requestRenderAll()), !n.handler.editable && t.target) {
            if ("element" === t.target.superType) return;
            "workarea" !== t.target.id ? t.target !== n.handler.target && n.handler.tooltipHandler.show(t.target) : n.handler.tooltipHandler.hide(t.target);
          }

          if ("polygon" === n.handler.interactionMode) {
            if (n.handler.activeLine && "line" === n.handler.activeLine.class) {
              var i = n.handler.canvas.getPointer(t.e);
              n.handler.activeLine.set({
                x2: i.x,
                y2: i.y
              });
              var r = n.handler.activeShape.get("points");
              r[n.handler.pointArray.length] = {
                x: i.x,
                y: i.y
              }, n.handler.activeShape.set({
                points: r
              }), n.handler.canvas.requestRenderAll();
            }
          } else if ("line" === n.handler.interactionMode) {
            if (n.handler.activeLine && "line" === n.handler.activeLine.class) {
              var o = n.handler.canvas.getPointer(t.e);
              n.handler.activeLine.set({
                x2: o.x,
                y2: o.y
              });
            }

            n.handler.canvas.requestRenderAll();
          } else if ("arrow" === n.handler.interactionMode) {
            if (n.handler.activeLine && "line" === n.handler.activeLine.class) {
              var a = n.handler.canvas.getPointer(t.e);
              n.handler.activeLine.set({
                x2: a.x,
                y2: a.y
              });
            }

            n.handler.canvas.requestRenderAll();
          } else if ("link" === n.handler.interactionMode) {
            if (n.handler.activeLine && "line" === n.handler.activeLine.class) {
              var s = n.handler.canvas.getPointer(t.e);
              n.handler.activeLine.set({
                x2: s.x,
                y2: s.y
              });
            }

            n.handler.canvas.requestRenderAll();
          }
        }), x()(this, "mouseup", function (e) {
          var t = e;

          if ("grab" !== n.handler.interactionMode) {
            var i = t.target,
                r = t.e;

            if ("selection" === n.handler.interactionMode && i && r.shiftKey && "node" === i.superType) {
              var o = i;
              n.handler.canvas.discardActiveObject();
              var a = [];
              n.handler.nodeHandler.getNodePath(o, a);
              var s = new w.fabric.ActiveSelection(a, ni({
                canvas: n.handler.canvas
              }, n.handler.activeSelectionOption));
              n.handler.canvas.setActiveObject(s), n.handler.canvas.requestRenderAll();
            }

            n.handler.editable && n.handler.guidelineOption.enabled && (n.handler.guidelineHandler.verticalLines.length = 0, n.handler.guidelineHandler.horizontalLines.length = 0), n.handler.canvas.renderAll();
          } else n.panning = !1;
        }), x()(this, "mouseout", function (e) {
          e.target || n.handler.tooltipHandler.hide();
        }), x()(this, "selection", function (e) {
          var t = n.handler,
              i = t.onSelect,
              r = t.activeSelectionOption,
              o = e.target;
          o && "activeSelection" === o.type && o.set(ni({}, r)), i && i(o);
        }), x()(this, "resize", function (e, t) {
          if (n.handler.canvas.setWidth(e).setHeight(t), n.handler.canvas.setBackgroundColor(n.handler.canvasOption.backgroundColor, n.handler.canvas.renderAll.bind(n.handler.canvas)), n.handler.workarea) {
            var i = e / 2 - n.handler.width / 2,
                r = t / 2 - n.handler.height / 2;

            if (n.handler.width = e, n.handler.height = t, "fixed" === n.handler.workarea.layout) {
              if (n.handler.canvas.centerObject(n.handler.workarea), n.handler.workarea.setCoords(), n.handler.gridOption.enabled) return;
              return n.handler.canvas.getObjects().forEach(function (e) {
                if ("workarea" !== e.id) {
                  var t = e.left + i,
                      o = e.top + r;

                  if (e.set({
                    left: t,
                    top: o
                  }), e.setCoords(), "element" === e.superType) {
                    var a = e.id,
                        s = n.handler.elementHandler.findById(a);
                    n.handler.elementHandler.setPosition(s, e);
                  }
                }
              }), void n.handler.canvas.requestRenderAll();
            }

            if ("responsive" === n.handler.workarea.layout) {
              var o = n.handler.workareaHandler.calculateScale().scaleX,
                  a = n.handler.canvas.getCenter(),
                  s = new w.fabric.Point(i, r);
              return n.handler.canvas.relativePan(s), void n.handler.zoomHandler.zoomToPoint(new w.fabric.Point(a.left, a.top), o);
            }

            var l = e / n.handler.workarea.width,
                u = t / n.handler.workarea.height,
                c = e / (n.handler.workarea.width * n.handler.workarea.scaleX),
                h = t / (n.handler.workarea.height * n.handler.workarea.scaleY);
            n.handler.workarea.set({
              scaleX: l,
              scaleY: u
            }), n.handler.canvas.getObjects().forEach(function (e) {
              var t = e.id;

              if ("workarea" !== e.id) {
                var i = e.left * c,
                    r = e.top * h,
                    o = e.scaleX * c,
                    a = e.scaleY * h;

                if (e.set({
                  scaleX: o,
                  scaleY: a,
                  left: i,
                  top: r
                }), e.setCoords(), "element" === e.superType) {
                  var s = e,
                      l = e.width,
                      u = e.height,
                      d = n.handler.elementHandler.findById(t);
                  n.handler.elementHandler.setSize(d, e), s.player && s.player.setPlayerSize(l, u), n.handler.elementHandler.setPosition(d, e);
                }
              }
            }), n.handler.canvas.renderAll();
          }
        }), x()(this, "paste", function (e) {
          if (n.handler.canvas.wrapperEl !== document.activeElement) return !1;
          e.preventDefault && e.preventDefault(), e.stopPropagation && e.stopPropagation();
          var t = e.clipboardData;
          return t.types.length && t.types.forEach(function (e) {
            if ("text/plain" === e) {
              var i = t.getData("text/plain");

              try {
                var r = JSON.parse(i),
                    o = n.handler,
                    a = o.gridOption.grid,
                    s = void 0 === a ? 10 : a,
                    l = o.isCut ? 0 : s;

                if (r && Array.isArray(r)) {
                  var u = r.filter(function (e) {
                    return null !== e;
                  });

                  if (1 === u.length) {
                    var c = u[0];
                    if (void 0 !== c.cloneable && !c.cloneable) return;
                    c.left = c.properties.left + l, c.top = c.properties.top + l;
                    var h = n.handler.add(c, !1, !0);
                    n.handler.canvas.setActiveObject(h), n.handler.canvas.requestRenderAll();
                  } else {
                    var d = [],
                        f = [];
                    r.forEach(function (e) {
                      if (e) {
                        "link" === e.superType ? (e.fromNodeId = d[e.fromNodeIndex].id, e.toNodeId = d[e.toNodeIndex].id) : (e.left = e.properties.left + l, e.top = e.properties.top + l);
                        var t = n.handler.add(e, !1, !0);
                        "node" === e.superType ? d.push(t) : f.push(t);
                      }
                    });
                    var p = new w.fabric.ActiveSelection(d.length ? d : f, ni({
                      canvas: n.handler.canvas
                    }, n.handler.activeSelectionOption));
                    n.handler.canvas.setActiveObject(p), n.handler.canvas.requestRenderAll();
                  }

                  n.handler.transactionHandler.active || n.handler.transactionHandler.save("paste"), n.handler.isCut = !1, n.handler.copy();
                }
              } catch (e) {
                console.error(e);
              }
            }
          }), !0;
        }), x()(this, "keydown", function (e) {
          var t = n.handler,
              i = t.keyEvent,
              r = t.editable;

          if (Object.keys(i).length) {
            var o = i.clipboard;
            if (!n.handler.interactionHandler.isDrawingMode()) return n.handler.shortcutHandler.isW(e) ? (n.keyCode = e.keyCode, void n.handler.interactionHandler.grab()) : void (e.altKey && r ? n.handler.interactionHandler.grab() : (n.handler.shortcutHandler.isEscape(e) && ("selection" === n.handler.interactionMode && (n.handler.canvas.discardActiveObject(), n.handler.canvas.renderAll()), n.handler.tooltipHandler.hide()), n.handler.canvas.wrapperEl === document.activeElement && r && (n.handler.shortcutHandler.isQ(e) ? n.keyCode = e.keyCode : n.handler.shortcutHandler.isDelete(e) ? n.handler.remove() : n.handler.shortcutHandler.isArrow(e) ? n.arrowmoving(e) : n.handler.shortcutHandler.isCtrlA(e) ? (e.preventDefault(), n.handler.selectAll()) : n.handler.shortcutHandler.isCtrlC(e) ? (e.preventDefault(), n.handler.copy()) : n.handler.shortcutHandler.isCtrlV(e) && !o ? (e.preventDefault(), n.handler.paste()) : n.handler.shortcutHandler.isCtrlX(e) ? (e.preventDefault(), n.handler.cut()) : n.handler.shortcutHandler.isCtrlZ(e) ? (e.preventDefault(), n.handler.transactionHandler.undo()) : n.handler.shortcutHandler.isCtrlY(e) ? (e.preventDefault(), n.handler.transactionHandler.redo()) : n.handler.shortcutHandler.isPlus(e) ? (e.preventDefault(), n.handler.zoomHandler.zoomIn()) : n.handler.shortcutHandler.isMinus(e) ? (e.preventDefault(), n.handler.zoomHandler.zoomOut()) : n.handler.shortcutHandler.isO(e) ? (e.preventDefault(), n.handler.zoomHandler.zoomOneToOne()) : n.handler.shortcutHandler.isP(e) && (e.preventDefault(), n.handler.zoomHandler.zoomToFit()))));
            n.handler.shortcutHandler.isEscape(e) && ("polygon" === n.handler.interactionMode ? n.handler.drawingHandler.polygon.finish() : "line" === n.handler.interactionMode ? n.handler.drawingHandler.line.finish() : "arrow" === n.handler.interactionMode ? n.handler.drawingHandler.arrow.finish() : "link" === n.handler.interactionMode && n.handler.linkHandler.finish());
          }
        }), x()(this, "keyup", function (e) {
          n.handler.interactionHandler.isDrawingMode() || n.handler.shortcutHandler.isW(e) || n.handler.interactionHandler.selection();
        }), x()(this, "contextmenu", function (e) {
          e.preventDefault();
          var t = n.handler,
              i = t.editable,
              r = t.onContext;

          if (i && r) {
            var o = n.handler.canvas.findTarget(e, !1);
            o && "activeSelection" !== o.type && n.handler.select(o), n.handler.contextmenuHandler.show(e, o);
          }
        }), x()(this, "onmousedown", function (e) {
          n.handler.contextmenuHandler.hide();
        }), this.handler = t, this.initialize();
      }

      return u()(e, [{
        key: "initialize",
        value: function value() {
          this.handler.editable ? this.handler.canvas.on({
            "object:modified": this.modified,
            "object:scaling": this.scaling,
            "object:scaled": this.scaled,
            "object:moving": this.moving,
            "object:moved": this.moved,
            "object:rotating": this.rotating,
            "object:rotated": this.rotated,
            "mouse:wheel": this.mousewheel,
            "mouse:down": this.mousedown,
            "mouse:move": this.mousemove,
            "mouse:up": this.mouseup,
            "selection:cleared": this.selection,
            "selection:created": this.selection,
            "selection:updated": this.selection
          }) : this.handler.canvas.on({
            "mouse:down": this.mousedown,
            "mouse:move": this.mousemove,
            "mouse:out": this.mouseout,
            "mouse:up": this.mouseup,
            "mouse:wheel": this.mousewheel
          }), this.handler.canvas.wrapperEl.tabIndex = 1e3, this.handler.canvas.wrapperEl.addEventListener("keydown", this.keydown, !1), this.handler.canvas.wrapperEl.addEventListener("keyup", this.keyup, !1), this.handler.canvas.wrapperEl.addEventListener("mousedown", this.onmousedown, !1), this.handler.canvas.wrapperEl.addEventListener("contextmenu", this.contextmenu, !1), this.handler.keyEvent.clipboard && document.addEventListener("paste", this.paste, !1);
        }
      }]), e;
    }(),
        ri = function e(t) {
      var n = this;
      s()(this, e), x()(this, "handler", void 0), x()(this, "polygon", {
        init: function init() {
          n.handler.interactionHandler.drawing("polygon"), n.handler.pointArray = [], n.handler.lineArray = [], n.handler.activeLine = null, n.handler.activeShape = null;
        },
        finish: function finish() {
          n.handler.pointArray.forEach(function (e) {
            n.handler.canvas.remove(e);
          }), n.handler.lineArray.forEach(function (e) {
            n.handler.canvas.remove(e);
          }), n.handler.canvas.remove(n.handler.activeLine), n.handler.canvas.remove(n.handler.activeShape), n.handler.pointArray = [], n.handler.lineArray = [], n.handler.activeLine = null, n.handler.activeShape = null, n.handler.canvas.renderAll(), n.handler.interactionHandler.selection();
        },
        addPoint: function addPoint(e) {
          var t = e.e,
              i = e.absolutePointer,
              r = i.x,
              o = i.y,
              a = new w.fabric.Circle({
            radius: 3,
            fill: "#ffffff",
            stroke: "#333333",
            strokeWidth: .5,
            left: r,
            top: o,
            selectable: !1,
            hasBorders: !1,
            hasControls: !1,
            originX: "center",
            originY: "center",
            hoverCursor: "pointer"
          });
          a.set({
            id: A()
          }), n.handler.pointArray.length || a.set({
            fill: "red"
          });
          var s = [r, o, r, o],
              l = new w.fabric.Line(s, {
            strokeWidth: 2,
            fill: "#999999",
            stroke: "#999999",
            originX: "center",
            originY: "center",
            selectable: !1,
            hasBorders: !1,
            hasControls: !1,
            evented: !1
          });

          if (l.set({
            class: "line"
          }), n.handler.activeShape) {
            var u = n.handler.canvas.getPointer(t),
                c = n.handler.activeShape.get("points");
            c.push({
              x: u.x,
              y: u.y
            });
            var h = new w.fabric.Polygon(c, {
              stroke: "#333333",
              strokeWidth: 1,
              fill: "#cccccc",
              opacity: .1,
              selectable: !1,
              hasBorders: !1,
              hasControls: !1,
              evented: !1
            });
            n.handler.canvas.remove(n.handler.activeShape), n.handler.canvas.add(h), n.handler.activeShape = h, n.handler.canvas.renderAll();
          } else {
            var d = [{
              x: r,
              y: o
            }],
                f = new w.fabric.Polygon(d, {
              stroke: "#333333",
              strokeWidth: 1,
              fill: "#cccccc",
              opacity: .1,
              selectable: !1,
              hasBorders: !1,
              hasControls: !1,
              evented: !1
            });
            n.handler.activeShape = f, n.handler.canvas.add(f);
          }

          n.handler.activeLine = l, n.handler.pointArray.push(a), n.handler.lineArray.push(l), n.handler.canvas.add(l), n.handler.canvas.add(a);
        },
        generate: function generate(e) {
          var t = [],
              i = A();
          e.forEach(function (e) {
            t.push({
              x: e.left,
              y: e.top
            }), n.handler.canvas.remove(e);
          }), n.handler.lineArray.forEach(function (e) {
            n.handler.canvas.remove(e);
          }), n.handler.canvas.remove(n.handler.activeShape).remove(n.handler.activeLine);
          var r = {
            id: i,
            points: t,
            type: "polygon",
            stroke: "rgba(0, 0, 0, 1)",
            strokeWidth: 3,
            fill: "rgba(0, 0, 0, 0.25)",
            opacity: 1,
            objectCaching: !n.handler.editable,
            name: "New polygon",
            superType: "drawing"
          };
          n.handler.add(r, !1), n.handler.pointArray = [], n.handler.activeLine = null, n.handler.activeShape = null, n.handler.interactionHandler.selection();
        }
      }), x()(this, "line", {
        init: function init() {
          n.handler.interactionHandler.drawing("line"), n.handler.pointArray = [], n.handler.activeLine = null;
        },
        finish: function finish() {
          n.handler.pointArray.forEach(function (e) {
            n.handler.canvas.remove(e);
          }), n.handler.canvas.remove(n.handler.activeLine), n.handler.pointArray = [], n.handler.activeLine = null, n.handler.canvas.renderAll(), n.handler.interactionHandler.selection();
        },
        addPoint: function addPoint(e) {
          var t = e.absolutePointer,
              i = t.x,
              r = t.y,
              o = new w.fabric.Circle({
            radius: 3,
            fill: "#ffffff",
            stroke: "#333333",
            strokeWidth: .5,
            left: i,
            top: r,
            selectable: !1,
            hasBorders: !1,
            hasControls: !1,
            originX: "center",
            originY: "center",
            hoverCursor: "pointer"
          });
          n.handler.pointArray.length || o.set({
            fill: "red"
          });
          var a = [i, r, i, r];
          n.handler.activeLine = new Hn(a, {
            strokeWidth: 2,
            fill: "#999999",
            stroke: "#999999",
            originX: "center",
            originY: "center",
            selectable: !1,
            hasBorders: !1,
            hasControls: !1,
            evented: !1
          }), n.handler.activeLine.set({
            class: "line"
          }), n.handler.pointArray.push(o), n.handler.canvas.add(n.handler.activeLine), n.handler.canvas.add(o);
        },
        generate: function generate(e) {
          var t = e.absolutePointer,
              i = t.x,
              r = t.y,
              o = [],
              a = A();
          n.handler.pointArray.forEach(function (e) {
            o = o.concat(e.left, e.top, i, r), n.handler.canvas.remove(e);
          }), n.handler.canvas.remove(n.handler.activeLine);
          var s = {
            id: a,
            points: o,
            type: "line",
            stroke: "rgba(0, 0, 0, 1)",
            strokeWidth: 3,
            opacity: 1,
            objectCaching: !n.handler.editable,
            name: "New line",
            superType: "drawing"
          };
          n.handler.add(s, !1), n.handler.pointArray = [], n.handler.activeLine = null, n.handler.interactionHandler.selection();
        }
      }), x()(this, "arrow", {
        init: function init() {
          n.handler.interactionHandler.drawing("arrow"), n.handler.pointArray = [], n.handler.activeLine = null;
        },
        finish: function finish() {
          n.handler.pointArray.forEach(function (e) {
            n.handler.canvas.remove(e);
          }), n.handler.canvas.remove(n.handler.activeLine), n.handler.pointArray = [], n.handler.activeLine = null, n.handler.canvas.renderAll(), n.handler.interactionHandler.selection();
        },
        addPoint: function addPoint(e) {
          var t = e.absolutePointer,
              i = t.x,
              r = t.y,
              o = new w.fabric.Circle({
            radius: 3,
            fill: "#ffffff",
            stroke: "#333333",
            strokeWidth: .5,
            left: i,
            top: r,
            selectable: !1,
            hasBorders: !1,
            hasControls: !1,
            originX: "center",
            originY: "center",
            hoverCursor: "pointer"
          });
          n.handler.pointArray.length || o.set({
            fill: "red"
          });
          var a = [i, r, i, r];
          n.handler.activeLine = new St(a, {
            strokeWidth: 2,
            fill: "#999999",
            stroke: "#999999",
            class: "line",
            originX: "center",
            originY: "center",
            selectable: !1,
            hasBorders: !1,
            hasControls: !1,
            evented: !1
          }), n.handler.pointArray.push(o), n.handler.canvas.add(n.handler.activeLine), n.handler.canvas.add(o);
        },
        generate: function generate(e) {
          var t = e.absolutePointer,
              i = t.x,
              r = t.y,
              o = [];
          n.handler.pointArray.forEach(function (e) {
            o = o.concat(e.left, e.top, i, r), n.handler.canvas.remove(e);
          }), n.handler.canvas.remove(n.handler.activeLine);
          var a = {
            id: A(),
            points: o,
            type: "arrow",
            stroke: "rgba(0, 0, 0, 1)",
            strokeWidth: 3,
            opacity: 1,
            objectCaching: !n.handler.editable,
            name: "New line",
            superType: "drawing"
          };
          n.handler.add(a, !1), n.handler.pointArray = [], n.handler.activeLine = null, n.handler.interactionHandler.selection();
        }
      }), x()(this, "orthogonal", {}), x()(this, "curve", {}), this.handler = t;
    },
        oi = function e(t) {
      var n = this;
      s()(this, e), x()(this, "handler", void 0), x()(this, "keyEvent", void 0), x()(this, "isEscape", function (e) {
        return 27 === e.keyCode && n.keyEvent.esc;
      }), x()(this, "isQ", function (e) {
        return 81 === e.keyCode;
      }), x()(this, "isW", function (e) {
        return 87 === e.keyCode;
      }), x()(this, "isDelete", function (e) {
        return (8 === e.keyCode || 46 === e.keyCode || 127 === e.keyCode) && n.keyEvent.del;
      }), x()(this, "isArrow", function (e) {
        return e.code.includes("Arrow") && n.keyEvent.move;
      }), x()(this, "isCtrlA", function (e) {
        return e.ctrlKey && 65 === e.keyCode && n.keyEvent.all;
      }), x()(this, "isCtrlC", function (e) {
        return e.ctrlKey && 67 === e.keyCode && n.keyEvent.copy;
      }), x()(this, "isCtrlV", function (e) {
        return e.ctrlKey && 86 === e.keyCode && n.keyEvent.paste;
      }), x()(this, "isCtrlZ", function (e) {
        return e.ctrlKey && 90 === e.keyCode && n.keyEvent.transaction;
      }), x()(this, "isCtrlY", function (e) {
        return e.ctrlKey && 89 === e.keyCode && n.keyEvent.transaction;
      }), x()(this, "isPlus", function (e) {
        return 187 === e.keyCode && n.keyEvent.zoom;
      }), x()(this, "isMinus", function (e) {
        return 189 === e.keyCode && n.keyEvent.zoom;
      }), x()(this, "isO", function (e) {
        return 79 === e.keyCode && n.keyEvent.zoom;
      }), x()(this, "isP", function (e) {
        return 80 === e.keyCode && n.keyEvent.zoom;
      }), x()(this, "isCtrlX", function (e) {
        return e.ctrlKey && 88 === e.keyCode && n.keyEvent.cut;
      }), this.handler = t, this.keyEvent = t.keyEvent;
    };

    function ai(e, t) {
      var n = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        t && (i = i.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, i);
      }

      return n;
    }

    function si(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? ai(Object(n), !0).forEach(function (t) {
          x()(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ai(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }

      return e;
    }

    var li = {
      group: {
        create: function create(e) {
          var t = e.objects,
              n = o()(e, ["objects"]);
          return new w.fabric.Group(t, n);
        }
      },
      "i-text": {
        create: function create(e) {
          var t = e.text,
              n = o()(e, ["text"]);
          return new w.fabric.IText(t, n);
        }
      },
      textbox: {
        create: function create(e) {
          var t = e.text,
              n = o()(e, ["text"]);
          return new w.fabric.Textbox(t, n);
        }
      },
      triangle: {
        create: function create(e) {
          return new w.fabric.Triangle(e);
        }
      },
      circle: {
        create: function create(e) {
          return new w.fabric.Circle(e);
        }
      },
      rect: {
        create: function create(e) {
          return new w.fabric.Rect(e);
        }
      },
      cube: {
        create: function create(e) {
          return new Yn(e);
        }
      },
      image: {
        create: function create(e) {
          var t = e.element,
              n = void 0 === t ? new Image() : t,
              i = o()(e, ["element"]);
          return new w.fabric.Image(n, si(si({}, i), {}, {
            crossOrigin: "anonymous"
          }));
        }
      },
      polygon: {
        create: function create(e) {
          var t = e.points,
              n = o()(e, ["points"]);
          return new w.fabric.Polygon(t, si(si({}, n), {}, {
            perPixelTargetFind: !0
          }));
        }
      },
      line: {
        create: function create(e) {
          var t = e.points,
              n = o()(e, ["points"]);
          return new Hn(t, n);
        }
      },
      arrow: {
        create: function create(e) {
          var t = e.points,
              n = o()(e, ["points"]);
          return new St(t, n);
        }
      },
      chart: {
        create: function create(e) {
          return new Mt(e.chartOption || {
            xAxis: {},
            yAxis: {},
            series: [{
              type: "line",
              data: [[0, 1], [1, 2], [2, 3], [3, 4]]
            }]
          }, e);
        }
      },
      element: {
        create: function create(e) {
          var t = e.code,
              n = o()(e, ["code"]);
          return new It(t, n);
        }
      },
      iframe: {
        create: function create(e) {
          var t = e.src,
              n = o()(e, ["src"]);
          return new Ot(t, n);
        }
      },
      video: {
        create: function create(e) {
          var t = e.src,
              n = e.file,
              i = o()(e, ["src", "file"]);
          return new Dt(t || n, i);
        }
      },
      gif: {
        create: function create(e) {
          return new bt(e);
        }
      },
      node: {
        create: function create(e) {
          return new Dn(e);
        }
      },
      link: {
        create: function create(e, t, n, i, r) {
          return new jn(e, t, n, i, r);
        }
      },
      curvedLink: {
        create: function create(e, t, n, i, r) {
          return new Fn(e, t, n, i, r);
        }
      },
      orthogonalLink: {
        create: function create(e, t, n, i, r) {
          return new Bn(e, t, n, i, r);
        }
      },
      svg: {
        create: function create(e) {
          return new qn(e);
        }
      }
    },
        ui = {
      preserveObjectStacking: !0,
      width: 300,
      height: 150,
      selection: !0,
      defaultCursor: "default",
      backgroundColor: "#f3f3f3"
    },
        ci = {
      move: !0,
      all: !0,
      copy: !0,
      paste: !0,
      esc: !0,
      del: !0,
      clipboard: !1,
      transaction: !0,
      zoom: !0,
      cut: !0
    },
        hi = {
      enabled: !1,
      grid: 10,
      snapToGrid: !1,
      lineColor: "#ebebeb",
      borderColor: "#cccccc"
    },
        di = {
      width: 600,
      height: 400,
      workareaWidth: 600,
      workareaHeight: 400,
      lockScalingX: !0,
      lockScalingY: !0,
      scaleX: 1,
      scaleY: 1,
      backgroundColor: "#fff",
      hasBorders: !1,
      hasControls: !1,
      selectable: !1,
      lockMovementX: !0,
      lockMovementY: !0,
      hoverCursor: "default",
      name: "",
      id: "workarea",
      type: "image",
      layout: "fixed",
      link: {},
      tooltip: {
        enabled: !1
      },
      isElement: !1
    },
        fi = {
      rotation: 0,
      centeredRotation: !0,
      strokeUniform: !0
    },
        pi = {
      enabled: !0
    },
        gi = {
      hasControls: !0
    },
        vi = ["id", "name", "locked", "editable"];

    function mi(e, t) {
      var n = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        t && (i = i.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, i);
      }

      return n;
    }

    function yi(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? mi(Object(n), !0).forEach(function (t) {
          x()(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : mi(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }

      return e;
    }

    var xi = function () {
      function e(t) {
        var n = this;
        s()(this, e), x()(this, "id", void 0), x()(this, "canvas", void 0), x()(this, "workarea", void 0), x()(this, "container", void 0), x()(this, "editable", void 0), x()(this, "interactionMode", void 0), x()(this, "minZoom", void 0), x()(this, "maxZoom", void 0), x()(this, "propertiesToInclude", i.propertiesToInclude), x()(this, "workareaOption", i.workareaOption), x()(this, "canvasOption", i.canvasOption), x()(this, "gridOption", i.gridOption), x()(this, "objectOption", i.objectOption), x()(this, "guidelineOption", i.guidelineOption), x()(this, "keyEvent", i.keyEvent), x()(this, "activeSelectionOption", i.activeSelectionOption), x()(this, "fabricObjects", li), x()(this, "zoomEnabled", void 0), x()(this, "width", void 0), x()(this, "height", void 0), x()(this, "onAdd", void 0), x()(this, "onContext", void 0), x()(this, "onTooltip", void 0), x()(this, "onZoom", void 0), x()(this, "onClick", void 0), x()(this, "onDblClick", void 0), x()(this, "onModified", void 0), x()(this, "onSelect", void 0), x()(this, "onRemove", void 0), x()(this, "onTransaction", void 0), x()(this, "onInteraction", void 0), x()(this, "onLoad", void 0), x()(this, "imageHandler", void 0), x()(this, "chartHandler", void 0), x()(this, "elementHandler", void 0), x()(this, "cropHandler", void 0), x()(this, "animationHandler", void 0), x()(this, "contextmenuHandler", void 0), x()(this, "tooltipHandler", void 0), x()(this, "zoomHandler", void 0), x()(this, "workareaHandler", void 0), x()(this, "interactionHandler", void 0), x()(this, "transactionHandler", void 0), x()(this, "gridHandler", void 0), x()(this, "portHandler", void 0), x()(this, "linkHandler", void 0), x()(this, "nodeHandler", void 0), x()(this, "alignmentHandler", void 0), x()(this, "guidelineHandler", void 0), x()(this, "eventHandler", void 0), x()(this, "drawingHandler", void 0), x()(this, "shortcutHandler", void 0), x()(this, "objectMap", {}), x()(this, "objects", void 0), x()(this, "activeLine", void 0), x()(this, "activeShape", void 0), x()(this, "zoom", 1), x()(this, "prevTarget", void 0), x()(this, "target", void 0), x()(this, "pointArray", void 0), x()(this, "lineArray", void 0), x()(this, "isCut", !1), x()(this, "isRequsetAnimFrame", !1), x()(this, "requestFrame", void 0), x()(this, "clipboard", void 0), x()(this, "initOption", function (e) {
          n.id = e.id, n.canvas = e.canvas, n.container = e.container, n.editable = e.editable, n.interactionMode = e.interactionMode, n.minZoom = e.minZoom, n.maxZoom = e.maxZoom, n.zoomEnabled = e.zoomEnabled, n.width = e.width, n.height = e.height, n.objects = [], n.setPropertiesToInclude(e.propertiesToInclude), n.setWorkareaOption(e.workareaOption), n.setCanvasOption(e.canvasOption), n.setGridOption(e.gridOption), n.setObjectOption(e.objectOption), n.setFabricObjects(e.fabricObjects), n.setGuidelineOption(e.guidelineOption), n.setActiveSelectionOption(e.activeSelectionOption), n.setKeyEvent(e.keyEvent);
        }), x()(this, "initCallback", function (e) {
          n.onAdd = e.onAdd, n.onTooltip = e.onTooltip, n.onZoom = e.onZoom, n.onContext = e.onContext, n.onClick = e.onClick, n.onModified = e.onModified, n.onDblClick = e.onDblClick, n.onSelect = e.onSelect, n.onRemove = e.onRemove, n.onTransaction = e.onTransaction, n.onInteraction = e.onInteraction, n.onLoad = e.onLoad;
        }), x()(this, "initHandler", function () {
          n.workareaHandler = new ft(n), n.imageHandler = new U(n), n.chartHandler = new Y(n), n.elementHandler = new X(n), n.cropHandler = new q(n), n.animationHandler = new et(n), n.contextmenuHandler = new ot(n), n.tooltipHandler = new at(n), n.zoomHandler = new ct(n), n.interactionHandler = new pt(n), n.transactionHandler = new ut(n), n.gridHandler = new mt(n), n.portHandler = new xt(n), n.linkHandler = new $n(n), n.nodeHandler = new Qn(n), n.alignmentHandler = new Jn(n), n.guidelineHandler = new ei(n), n.eventHandler = new ii(n), n.drawingHandler = new ri(n), n.shortcutHandler = new oi(n);
        }), x()(this, "getObjects", function () {
          var e = n.canvas.getObjects().filter(function (e) {
            return "workarea" !== e.id && "grid" !== e.id && "port" !== e.superType && !!e.id;
          });
          return e.length ? e.forEach(function (e) {
            return n.objectMap[e.id] = e;
          }) : n.objectMap = {}, e;
        }), x()(this, "set", function (e, t) {
          var i = n.canvas.getActiveObject();

          if (i) {
            i.set(e, t), i.setCoords(), n.canvas.requestRenderAll();
            var r = i,
                o = r.id,
                a = r.superType,
                s = r.type,
                l = r.player,
                u = r.width,
                c = r.height;

            if ("element" === a) {
              "visible" === e && (i.element.style.display = t ? "block" : "none");
              var h = n.elementHandler.findById(o);
              n.elementHandler.setScaleOrAngle(h, i), n.elementHandler.setSize(h, i), n.elementHandler.setPosition(h, i), "video" === s && l && l.setPlayerSize(u, c);
            }

            var d = n.onModified;
            d && d(i);
          }
        }), x()(this, "setObject", function (e) {
          var t = n.canvas.getActiveObject();

          if (t) {
            Object.keys(e).forEach(function (n) {
              e[n] !== t[n] && (t.set(n, e[n]), t.setCoords());
            }), n.canvas.requestRenderAll();
            var i = t.id,
                r = t.superType,
                o = t.type,
                a = t.player,
                s = t.width,
                l = t.height;

            if ("element" === r) {
              "visible" in e && (e.visible ? t.element.style.display = "block" : t.element.style.display = "none");
              var u = n.elementHandler.findById(i);
              n.elementHandler.setScaleOrAngle(u, t), n.elementHandler.setSize(u, t), n.elementHandler.setPosition(u, t), "video" === o && a && a.setPlayerSize(s, l);
            }

            var c = n.onModified;
            c && c(t);
          }
        }), x()(this, "setByObject", function (e, t, i) {
          if (e) {
            e.set(t, i), e.setCoords(), n.canvas.renderAll();
            var r = e,
                o = r.id,
                a = r.superType,
                s = r.type,
                l = r.player,
                u = r.width,
                c = r.height;

            if ("element" === a) {
              "visible" === t && (e.element.style.display = i ? "block" : "none");
              var h = n.elementHandler.findById(o);
              n.elementHandler.setScaleOrAngle(h, e), n.elementHandler.setSize(h, e), n.elementHandler.setPosition(h, e), "video" === s && l && l.setPlayerSize(u, c);
            }

            var d = n.onModified;
            d && d(e);
          }
        }), x()(this, "setById", function (e, t, i) {
          var r = n.findById(e);
          n.setByObject(r, t, i);
        }), x()(this, "setByPartial", function (e, t) {
          if (e) {
            e.set(t), e.setCoords(), n.canvas.renderAll();
            var i = e,
                r = i.id,
                o = i.superType,
                a = i.type,
                s = i.player,
                l = i.width,
                u = i.height;

            if ("element" === o) {
              "visible" in t && (t.visible ? e.element.style.display = "block" : e.element.style.display = "none");
              var c = n.elementHandler.findById(r);
              n.elementHandler.setScaleOrAngle(c, e), n.elementHandler.setSize(c, e), n.elementHandler.setPosition(c, e), "video" === a && s && s.setPlayerSize(l, u);
            }
          }
        }), x()(this, "setShadow", function (e) {
          var t = n.canvas.getActiveObject();

          if (t) {
            t.setShadow(e), n.canvas.requestRenderAll();
            var i = n.onModified;
            i && i(t);
          }
        }), x()(this, "setImage", function (e, t) {
          if (!t) return n.loadImage(e, null), e.set("file", null), void e.set("src", null);

          if (t instanceof File) {
            var i = new FileReader();
            i.onload = function () {
              n.loadImage(e, i.result), e.set("file", t), e.set("src", null);
            }, i.readAsDataURL(t);
          } else n.loadImage(e, t), e.set("file", null), e.set("src", t);
        }), x()(this, "setImageById", function (e, t) {
          var i = n.findById(e);
          n.setImage(i, t);
        }), x()(this, "setVisible", function (e) {
          var t = n.canvas.getActiveObject();
          t && ("element" === t.superType && (t.element.style.display = e ? "block" : "none"), t.set({
            visible: e
          }), n.canvas.renderAll());
        }), x()(this, "centerObject", function (e, t) {
          t ? (n.canvas.centerObject(e), e.setCoords()) : n.setByPartial(e, {
            left: e.left / n.canvas.getZoom() - e.width / 2 - n.canvas.viewportTransform[4] / n.canvas.getZoom(),
            top: e.top / n.canvas.getZoom() - e.height / 2 - n.canvas.viewportTransform[5] / n.canvas.getZoom()
          });
        }), x()(this, "add", function (e) {
          var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
              i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
              r = n.editable,
              o = n.onAdd,
              a = n.gridOption,
              s = n.objectOption,
              l = {
            hasControls: r,
            hasBorders: r,
            selectable: r,
            lockMovementX: !r,
            lockMovementY: !r,
            hoverCursor: r ? "move" : "pointer"
          };
          "i-text" === e.type ? l.editable = !1 : l.editable = r, r && "fullscreen" === n.workarea.layout && (l.scaleX = n.workarea.scaleX, l.scaleY = n.workarea.scaleY);
          var u,
              c = Object.assign({}, s, e, {
            container: n.container.id,
            editable: r
          }, l);
          if ("link" === e.superType) return n.linkHandler.create(c, i);
          if ("image" === e.type) u = n.addImage(c);else if ("group" === e.type) {
            var h = n.addGroup(c, t, i),
                d = Object.assign({}, c, {
              objects: h,
              name: "New Group"
            });
            u = n.fabricObjects[e.type].create(d);
          } else u = n.fabricObjects[e.type].create(c);
          return n.canvas.add(u), n.objects = n.getObjects(), r || "element" === e.superType || u.on("mousedown", n.eventHandler.object.mousedown), u.dblclick && u.on("mousedblclick", n.eventHandler.object.mousedblclick), n.objects.some(function (e) {
            return "gif" === e.type;
          }) ? n.startRequestAnimFrame() : n.stopRequestAnimFrame(), "drawing" !== e.superType && "link" !== e.superType && r && !i && n.centerObject(u, t), "node" === u.superType && (n.portHandler.create(u), u.iconButton && n.canvas.add(u.iconButton)), !r && u.animation && u.animation.autoplay && n.animationHandler.play(u.id), "node" === u.superType && u.setShadow({
            color: u.stroke
          }), a.enabled && n.gridHandler.setCoords(u), n.transactionHandler.active || i || n.transactionHandler.save("add"), o && r && !i && o(u), u;
        }), x()(this, "addGroup", function (e) {
          var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
              i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
          return e.objects.map(function (e) {
            return n.add(e, t, i);
          });
        }), x()(this, "addImage", function (e) {
          var t = n.objectOption,
              i = e.filters,
              r = void 0 === i ? [] : i,
              a = o()(e, ["filters"]),
              s = new Image();
          e.src && (s.src = e.src);
          var l = new w.fabric.Image(s, yi(yi({}, t), a));
          return l.set({
            filters: n.imageHandler.createFilters(r)
          }), n.setImage(l, e.src || e.file), l;
        }), x()(this, "remove", function (e) {
          var t = e || n.canvas.getActiveObject();
          if (n.prevTarget && "link" === n.prevTarget.superType) return n.linkHandler.remove(n.prevTarget), void (n.transactionHandler.active || n.transactionHandler.save("remove"));

          if (t && (void 0 === t.deletable || t.deletable)) {
            if ("activeSelection" !== t.type) n.canvas.discardActiveObject(), "element" === t.superType && n.elementHandler.removeById(t.id), "link" === t.superType ? n.linkHandler.remove(t) : "node" === t.superType && (t.toPort && (t.toPort.links.length && t.toPort.links.forEach(function (e) {
              n.linkHandler.remove(e, "from");
            }), n.canvas.remove(t.toPort)), t.fromPort && t.fromPort.length && t.fromPort.forEach(function (e) {
              e.links.length && e.links.forEach(function (e) {
                n.linkHandler.remove(e, "to");
              }), n.canvas.remove(e);
            })), n.canvas.remove(t);else {
              var i = t._objects;
              if (i.some(function (e) {
                return void 0 !== e.deletable && !e.deletable;
              })) return;
              n.canvas.discardActiveObject(), i.forEach(function (e) {
                "element" === e.superType ? n.elementHandler.removeById(e.id) : "node" === e.superType && (e.toPort && (e.toPort.links.length && e.toPort.links.forEach(function (e) {
                  n.linkHandler.remove(e, "from");
                }), n.canvas.remove(e.toPort)), e.fromPort && e.fromPort.length && e.fromPort.forEach(function (e) {
                  e.links.length && e.links.forEach(function (e) {
                    n.linkHandler.remove(e, "to");
                  }), n.canvas.remove(e);
                })), n.canvas.remove(e);
              });
            }
            n.transactionHandler.active || n.transactionHandler.save("remove"), n.objects = n.getObjects();
            var r = n.onRemove;
            r && r(t);
          }
        }), x()(this, "removeById", function (e) {
          var t = n.findById(e);
          t && n.remove(t);
        }), x()(this, "removeOriginById", function (e) {
          var t = n.findOriginByIdWithIndex(e);
          t.index > 0 && n.objects.splice(t.index, 1);
        }), x()(this, "duplicate", function () {
          var e = n.onAdd,
              t = n.propertiesToInclude,
              i = n.gridOption.grid,
              r = void 0 === i ? 10 : i,
              o = n.canvas.getActiveObject();
          o && (void 0 === o.cloneable || o.cloneable) && o.clone(function (t) {
            if (n.canvas.discardActiveObject(), t.set({
              left: t.left + r,
              top: t.top + r,
              evented: !0
            }), "activeSelection" === t.type) {
              var i = t;
              i.canvas = n.canvas, i.forEachObject(function (e) {
                e.set("id", A()), n.canvas.add(e), n.objects = n.getObjects(), e.dblclick && e.on("mousedblclick", n.eventHandler.object.mousedblclick);
              }), e && e(i), i.setCoords();
            } else o.id === t.id && t.set("id", A()), n.canvas.add(t), n.objects = n.getObjects(), t.dblclick && t.on("mousedblclick", n.eventHandler.object.mousedblclick), e && e(t);

            n.canvas.setActiveObject(t), n.portHandler.create(t), n.canvas.requestRenderAll();
          }, t);
        }), x()(this, "duplicateById", function (e) {
          var t = n.onAdd,
              i = n.propertiesToInclude,
              r = n.gridOption.grid,
              o = void 0 === r ? 10 : r,
              a = n.findById(e);

          if (a) {
            if (void 0 !== a.cloneable && !a.cloneable) return !1;
            a.clone(function (e) {
              e.set({
                left: e.left + o,
                top: e.top + o,
                id: A(),
                evented: !0
              }), n.canvas.add(e), n.objects = n.getObjects(), t && t(e), e.dblclick && e.on("mousedblclick", n.eventHandler.object.mousedblclick), n.canvas.setActiveObject(e), n.portHandler.create(e), n.canvas.requestRenderAll();
            }, i);
          }

          return !0;
        }), x()(this, "cut", function () {
          n.copy(), n.remove(), n.isCut = !0;
        }), x()(this, "copyToClipboard", function (e) {
          var t = document.createElement("textarea");
          document.body.appendChild(t), t.value = e, t.select(), document.execCommand("copy"), document.body.removeChild(t), n.canvas.wrapperEl.focus();
        }), x()(this, "copy", function () {
          var e = n.propertiesToInclude,
              t = n.canvas.getActiveObject();
          if (t && "link" === t.superType) return !1;

          if (t) {
            if (void 0 !== t.cloneable && !t.cloneable) return !1;

            if ("activeSelection" === t.type) {
              var i = t;

              if (i.getObjects().some(function (e) {
                return "node" === e.superType;
              })) {
                if (n.keyEvent.clipboard) {
                  var r = [],
                      o = i.getObjects().map(function (e, n) {
                    return void 0 === e.cloneable || e.cloneable ? (e.fromPort.length && e.fromPort.forEach(function (e) {
                      e.links.length && e.links.forEach(function (t) {
                        var o = {
                          fromNodeIndex: n,
                          fromPortId: e.id,
                          type: "curvedLink",
                          superType: "link"
                        },
                            a = i.getObjects().findIndex(function (e) {
                          return e.id === t.toNode.id;
                        });
                        a >= 0 && (o.toNodeIndex = a, r.push(o));
                      });
                    }), {
                      name: e.name,
                      description: e.description,
                      superType: e.superType,
                      type: e.type,
                      nodeClazz: e.nodeClazz,
                      configuration: e.configuration,
                      properties: {
                        left: t.left + t.width / 2 + e.left || 0,
                        top: t.top + t.height / 2 + e.top || 0,
                        iconName: e.descriptor.icon
                      }
                    }) : null;
                  });
                  return n.copyToClipboard(JSON.stringify(o.concat(r), null, "\t")), !0;
                }

                return n.clipboard = t, !0;
              }
            }

            t.clone(function (t) {
              if (n.keyEvent.clipboard) {
                if ("node" === t.superType) {
                  var i = [{
                    name: t.name,
                    description: t.description,
                    superType: t.superType,
                    type: t.type,
                    nodeClazz: t.nodeClazz,
                    configuration: t.configuration,
                    properties: {
                      left: t.left || 0,
                      top: t.top || 0,
                      iconName: t.descriptor.icon
                    }
                  }];
                  n.copyToClipboard(JSON.stringify(i, null, "\t"));
                } else n.copyToClipboard(JSON.stringify(t.toObject(e), null, "\t"));
              } else n.clipboard = t;
            }, e);
          }

          return !0;
        }), x()(this, "paste", function () {
          var e = n.onAdd,
              t = n.propertiesToInclude,
              i = n.gridOption.grid,
              r = void 0 === i ? 10 : i,
              o = n.clipboard,
              a = n.isCut,
              s = a ? 0 : r;
          if (!o) return !1;
          if (void 0 !== o.cloneable && !o.cloneable) return !1;

          if (n.isCut = !1, "activeSelection" === o.type && o.getObjects().some(function (e) {
            return "node" === e.superType;
          })) {
            n.canvas.discardActiveObject();
            var l = [],
                u = [];
            o.getObjects().forEach(function (e) {
              if (void 0 === e.cloneable || e.cloneable) {
                var t = e.duplicate();
                "SwitchNode" === t.type ? t.set({
                  left: e.left + s + s,
                  top: e.top + s
                }) : t.set({
                  left: e.left + s,
                  top: e.top + s
                }), e.fromPort.length && e.fromPort.forEach(function (e) {
                  e.links.length && e.links.forEach(function (n) {
                    var i = {
                      fromNode: t.id,
                      fromPort: e.id
                    },
                        r = o.getObjects().findIndex(function (e) {
                      return e.id === n.toNode.id;
                    });
                    r >= 0 && (i.toNodeIndex = r, u.push(i));
                  });
                }), t.dblclick && t.on("mousedblclick", n.eventHandler.object.mousedblclick), n.canvas.add(t), n.objects = n.getObjects(), n.portHandler.create(t), l.push(t);
              }
            }), u.length && u.forEach(function (e) {
              var t = e.fromNode,
                  i = e.fromPort,
                  r = e.toNodeIndex,
                  o = l[r],
                  a = {
                type: "curvedLink",
                fromNodeId: t,
                fromPortId: i,
                toNodeId: o.id,
                toPortId: o.toPort.id
              };
              n.linkHandler.create(a);
            });
            var c = new w.fabric.ActiveSelection(l, yi({
              canvas: n.canvas
            }, n.activeSelectionOption));
            return n.clipboard = a ? null : c, n.transactionHandler.active || n.transactionHandler.save("paste"), n.canvas.setActiveObject(c), n.canvas.renderAll(), !0;
          }

          return o.clone(function (t) {
            n.canvas.discardActiveObject(), t.set({
              left: t.left + s,
              top: t.top + s,
              id: a ? o.id : A(),
              evented: !0
            }), "activeSelection" === t.type ? (t.canvas = n.canvas, t.forEachObject(function (e) {
              e.set("id", a ? e.id : A()), n.canvas.add(e), e.dblclick && e.on("mousedblclick", n.eventHandler.object.mousedblclick);
            })) : ("node" === t.superType && (t = t.duplicate()), n.canvas.add(t), t.dblclick && t.on("mousedblclick", n.eventHandler.object.mousedblclick));
            var i = o.set({
              top: t.top,
              left: t.left
            });
            n.clipboard = a ? null : i, "node" === t.superType && n.portHandler.create(t), n.transactionHandler.active || n.transactionHandler.save("paste"), n.objects = n.getObjects(), e && e(t), t.setCoords(), n.canvas.setActiveObject(t), n.canvas.requestRenderAll();
          }, t), !0;
        }), x()(this, "loadImage", function (e, t) {
          var i = t;
          i || (i = "./images/sample/transparentBg.png"), w.fabric.util.loadImage(i, function (t) {
            if ("image" !== e.type) return e.setPatternFill({
              source: t,
              repeat: "repeat"
            }, null), e.setCoords(), void n.canvas.renderAll();
            e.setElement(t), e.setCoords(), n.canvas.renderAll();
          });
        }), x()(this, "find", function (e) {
          return n.findById(e.id);
        }), x()(this, "findById", function (e) {
          var t;
          return n.objects.some(function (n) {
            return n.id === e && (t = n, !0);
          }) ? t : (j()(!0, "Not found object by id."), null);
        }), x()(this, "findOriginById", function (e) {
          var t;
          return n.objects.some(function (n) {
            return n.id === e && (t = n, !0);
          }) ? t : (console.warn("Not found object by id."), null);
        }), x()(this, "findOriginByIdWithIndex", function (e) {
          var t,
              i = -1;
          return n.objects.some(function (n, r) {
            return n.id === e && (t = n, i = r, !0);
          }) ? {
            object: t,
            index: i
          } : (console.warn("Not found object by id."), {});
        }), x()(this, "select", function (e, t) {
          var i = e;
          t && (i = n.find(e)), i && (n.canvas.discardActiveObject(), n.canvas.setActiveObject(i), n.canvas.requestRenderAll());
        }), x()(this, "selectById", function (e) {
          var t = n.findById(e);
          t && (n.canvas.discardActiveObject(), n.canvas.setActiveObject(t), n.canvas.requestRenderAll());
        }), x()(this, "selectAll", function () {
          n.canvas.discardActiveObject();
          var e = n.canvas.getObjects().filter(function (e) {
            return "workarea" !== e.id && !!e.evented && "link" !== e.superType && "port" !== e.superType && "element" !== e.superType && !e.locked;
          });

          if (e.length) {
            if (1 === e.length) return n.canvas.setActiveObject(e[0]), void n.canvas.renderAll();
            var t = new w.fabric.ActiveSelection(e, yi({
              canvas: n.canvas
            }, n.activeSelectionOption));
            n.canvas.setActiveObject(t), n.canvas.renderAll();
          }
        }), x()(this, "originScaleToResize", function (e, t, i) {
          "workarea" === e.id && n.setByPartial(e, {
            workareaWidth: e.width,
            workareaHeight: e.height
          }), n.setByPartial(e, {
            scaleX: t / e.width,
            scaleY: i / e.height
          });
        }), x()(this, "scaleToResize", function (e, t) {
          var i = n.canvas.getActiveObject(),
              r = {
            id: i.id,
            scaleX: e / i.width,
            scaleY: t / i.height
          };
          n.setObject(r), i.setCoords(), n.canvas.requestRenderAll();
        }), x()(this, "importJSON", function () {
          var e = D()(O.a.mark(function e(t, i) {
            var r, o, a, s;
            return O.a.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    if ("string" == typeof t && (t = JSON.parse(t)), r = 0, o = 0, n.canvas.setBackgroundColor(n.canvasOption.backgroundColor, n.canvas.renderAll.bind(n.canvas)), a = t.filter(function (e) {
                      return "workarea" === e.id;
                    }), n.workarea || n.workareaHandler.initialize(), a.length) {
                      e.next = 13;
                      break;
                    }

                    n.canvas.centerObject(n.workarea), n.workarea.setCoords(), r = n.workarea.left, o = n.workarea.top, e.next = 20;
                    break;

                  case 13:
                    return s = a[0], r = s.left, o = s.top, n.workarea.set(s), e.next = 19, n.workareaHandler.setImage(s.src, !0);

                  case 19:
                    n.workarea.setCoords();

                  case 20:
                    return t.forEach(function (e) {
                      if ("workarea" !== e.id) {
                        var t = n.canvas.getWidth(),
                            i = n.canvas.getHeight(),
                            a = n.workarea,
                            s = a.width,
                            l = a.height,
                            u = a.scaleX,
                            c = a.scaleY,
                            h = a.layout,
                            d = a.left,
                            f = a.top;

                        if ("fullscreen" === h) {
                          var p = t / (s * u),
                              g = i / (l * c);
                          e.left *= p, e.top *= g, e.scaleX *= p, e.scaleY *= g;
                        } else {
                          var v = d - r,
                              m = f - o;
                          e.left += v, e.top += m;
                        }

                        "element" === e.superType && (e.id = A()), n.add(e, !1, !0), n.canvas.renderAll();
                      }
                    }), n.objects = n.getObjects(), i && i(n.canvas), e.abrupt("return", Promise.resolve(n.canvas));

                  case 24:
                  case "end":
                    return e.stop();
                }
              }
            }, e);
          }));
          return function (t, n) {
            return e.apply(this, arguments);
          };
        }()), x()(this, "exportJSON", function () {
          return n.canvas.toObject(n.propertiesToInclude).objects;
        }), x()(this, "toGroup", function (e) {
          var t = e || n.canvas.getActiveObject();
          if (!t) return null;
          if ("activeSelection" !== t.type) return null;
          var i = t.toGroup();
          return i.set(yi({
            id: A(),
            name: "New group",
            type: "group"
          }, n.objectOption)), n.objects = n.getObjects(), n.transactionHandler.active || n.transactionHandler.save("group"), n.onSelect && n.onSelect(i), n.canvas.renderAll(), i;
        }), x()(this, "toActiveSelection", function (e) {
          var t = e || n.canvas.getActiveObject();

          if (t && "group" === t.type) {
            var i = t.toActiveSelection();
            return n.objects = n.getObjects(), n.transactionHandler.active || n.transactionHandler.save("ungroup"), n.onSelect && n.onSelect(i), n.canvas.renderAll(), i;
          }
        }), x()(this, "bringForward", function () {
          var e = n.canvas.getActiveObject();

          if (e) {
            n.canvas.bringForward(e), n.transactionHandler.active || n.transactionHandler.save("bringForward");
            var t = n.onModified;
            t && t(e);
          }
        }), x()(this, "bringToFront", function () {
          var e = n.canvas.getActiveObject();

          if (e) {
            n.canvas.bringToFront(e), n.transactionHandler.active || n.transactionHandler.save("bringToFront");
            var t = n.onModified;
            t && t(e);
          }
        }), x()(this, "sendBackwards", function () {
          var e = n.canvas.getActiveObject();

          if (e) {
            if (n.canvas.getObjects()[1].id === e.id) return;
            n.transactionHandler.active || n.transactionHandler.save("sendBackwards"), n.canvas.sendBackwards(e);
            var t = n.onModified;
            t && t(e);
          }
        }), x()(this, "sendToBack", function () {
          var e = n.canvas.getActiveObject();

          if (e) {
            n.canvas.sendToBack(e), n.canvas.sendToBack(n.canvas.getObjects()[1]), n.transactionHandler.active || n.transactionHandler.save("sendToBack");
            var t = n.onModified;
            t && t(e);
          }
        }), x()(this, "clear", function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
              t = n.canvas.getObjects().reduce(function (e, t) {
            return "element" === t.superType ? (e.push(t.id), e) : e;
          }, []);
          n.elementHandler.removeByIds(t), e ? (n.canvas.clear(), n.workarea = null) : (n.canvas.discardActiveObject(), n.canvas.getObjects().forEach(function (e) {
            "grid" !== e.id && "workarea" !== e.id && n.canvas.remove(e);
          })), n.objects = n.getObjects(), n.canvas.renderAll();
        }), x()(this, "startRequestAnimFrame", function () {
          if (!n.isRequsetAnimFrame) {
            n.isRequsetAnimFrame = !0;
            w.fabric.util.requestAnimFrame(function e() {
              n.canvas.renderAll(), n.requestFrame = w.fabric.util.requestAnimFrame(e);
            });
          }
        }), x()(this, "stopRequestAnimFrame", function () {
          n.isRequsetAnimFrame = !1, (window.cancelAnimationFrame || clearTimeout)(n.requestFrame);
        }), x()(this, "saveImage", function (e) {
          var t,
              i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
            name: "New Image",
            format: "png",
            quality: 1
          },
              r = e;

          if ((r || (r = n.canvas.getActiveObject())) && (t = r.toDataURL(i)), t) {
            var o = document.createElement("a");
            o.href = t, o.download = "".concat(i.name, ".png"), document.body.appendChild(o), o.click(), o.remove();
          }
        }), x()(this, "saveCanvasImage", function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {
            name: "New Image",
            format: "png",
            quality: 1
          },
              t = n.canvas.toDataURL(e);

          if (t) {
            var i = document.createElement("a");
            i.href = t, i.download = "".concat(e.name, ".png"), document.body.appendChild(i), i.click(), i.remove();
          }
        }), x()(this, "rotate", function (e) {
          var t = n.canvas.getActiveObject();
          t && (n.set("rotation", e), t.rotate(e), n.canvas.requestRenderAll());
        }), x()(this, "destroy", function () {
          n.eventHandler.destroy(), n.guidelineHandler.destroy(), n.contextmenuHandler.destory(), n.tooltipHandler.destroy(), n.clear(!0);
        }), x()(this, "setCanvasOption", function (e) {
          n.canvasOption = Object.assign({}, n.canvasOption, e), n.canvas.setBackgroundColor(e.backgroundColor, n.canvas.renderAll.bind(n.canvas)), void 0 !== e.width && void 0 !== e.height && (n.eventHandler ? n.eventHandler.resize(e.width, e.height) : n.canvas.setWidth(e.width).setHeight(e.height)), void 0 !== e.selection && (n.canvas.selection = e.selection), void 0 !== e.hoverCursor && (n.canvas.hoverCursor = e.hoverCursor), void 0 !== e.defaultCursor && (n.canvas.defaultCursor = e.defaultCursor), void 0 !== e.preserveObjectStacking && (n.canvas.preserveObjectStacking = e.preserveObjectStacking);
        }), x()(this, "setKeyEvent", function (e) {
          n.keyEvent = Object.assign({}, n.keyEvent, e);
        }), x()(this, "setFabricObjects", function (e) {
          n.fabricObjects = Object.assign({}, n.fabricObjects, e);
        }), x()(this, "setWorkareaOption", function (e) {
          n.workareaOption = Object.assign({}, n.workareaOption, e), n.workarea && n.workarea.set(yi({}, e));
        }), x()(this, "setGuidelineOption", function (e) {
          n.guidelineOption = Object.assign({}, n.guidelineOption, e), n.guidelineHandler && n.guidelineHandler.initialize();
        }), x()(this, "setGridOption", function (e) {
          n.gridOption = Object.assign({}, n.gridOption, e);
        }), x()(this, "setObjectOption", function (e) {
          n.objectOption = Object.assign({}, n.objectOption, e);
        }), x()(this, "setActiveSelectionOption", function (e) {
          n.activeSelectionOption = Object.assign({}, n.activeSelectionOption, e);
        }), x()(this, "setPropertiesToInclude", function (e) {
          n.propertiesToInclude = Object(R.union)(e, n.propertiesToInclude);
        }), this.initialize(t);
      }

      return u()(e, [{
        key: "initialize",
        value: function value(e) {
          this.initOption(e), this.initCallback(e), this.initHandler();
        }
      }]), e;
    }();

    n(948), n(950), n(952), n(954);

    function _i(e, t) {
      var n = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        t && (i = i.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, i);
      }

      return n;
    }

    function bi(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? _i(Object(n), !0).forEach(function (t) {
          x()(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : _i(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }

      return e;
    }

    function wi(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var n,
            i = m()(e);

        if (t) {
          var r = m()(this).constructor;
          n = Reflect.construct(i, arguments, r);
        } else n = i.apply(this, arguments);

        return g()(this, n);
      };
    }

    var Si = function (e) {
      f()(n, e);
      var t = wi(n);

      function n() {
        var e;
        s()(this, n);

        for (var i = arguments.length, r = new Array(i), o = 0; o < i; o++) {
          r[o] = arguments[o];
        }

        return e = t.call.apply(t, [this].concat(r)), x()(h()(e), "handler", void 0), x()(h()(e), "canvas", void 0), x()(h()(e), "container", b.a.createRef()), x()(h()(e), "resizeObserver", void 0), x()(h()(e), "state", {
          id: A(),
          loaded: !1
        }), x()(h()(e), "createObserver", function () {
          e.resizeObserver = new I.a(function (t) {
            var n = t[0] && t[0].contentRect || {},
                i = n.width,
                r = void 0 === i ? 0 : i,
                o = n.height,
                a = void 0 === o ? 0 : o;
            e.handler.eventHandler.resize(r, a), e.state.loaded || e.handleLoad();
          }), e.resizeObserver.observe(e.container.current);
        }), x()(h()(e), "destroyObserver", function () {
          e.resizeObserver && (e.resizeObserver.disconnect(), e.resizeObserver = null);
        }), x()(h()(e), "handleLoad", function () {
          e.setState({
            loaded: !0
          }, function () {
            e.props.onLoad && e.props.onLoad(e.handler, e.canvas);
          });
        }), e;
      }

      return u()(n, [{
        key: "componentDidMount",
        value: function value() {
          var e = this.props,
              t = e.editable,
              n = e.canvasOption,
              r = e.width,
              a = e.height,
              s = (e.responsive, o()(e, ["editable", "canvasOption", "width", "height", "responsive"])),
              l = this.state.id,
              u = Object.assign({}, i.canvasOption, n, {
            width: r,
            height: a,
            selection: t
          });
          this.canvas = new w.fabric.Canvas("canvas_".concat(l), u), this.canvas.setBackgroundColor(u.backgroundColor, this.canvas.renderAll.bind(this.canvas)), this.canvas.renderAll(), this.handler = new xi(bi({
            id: l,
            width: r,
            height: a,
            editable: t,
            canvas: this.canvas,
            container: this.container.current,
            canvasOption: u
          }, s)), this.props.responsive ? this.createObserver() : this.handleLoad();
        }
      }, {
        key: "componentDidUpdate",
        value: function value(e) {
          this.props.width === e.width && this.props.height === e.height || this.handler.eventHandler.resize(this.props.width, this.props.height), this.props.editable !== e.editable && (this.handler.editable = this.props.editable), this.props.responsive !== e.responsive && (this.props.responsive ? (this.destroyObserver(), this.createObserver()) : this.destroyObserver()), JSON.stringify(this.props.canvasOption) !== JSON.stringify(e.canvasOption) && this.handler.setCanvasOption(this.props.canvasOption), JSON.stringify(this.props.keyEvent) !== JSON.stringify(e.keyEvent) && this.handler.setKeyEvent(this.props.keyEvent), JSON.stringify(this.props.fabricObjects) !== JSON.stringify(e.fabricObjects) && this.handler.setFabricObjects(this.props.fabricObjects), JSON.stringify(this.props.workareaOption) !== JSON.stringify(e.workareaOption) && this.handler.setWorkareaOption(this.props.workareaOption), JSON.stringify(this.props.guidelineOption) !== JSON.stringify(e.guidelineOption) && this.handler.setGuidelineOption(this.props.guidelineOption), JSON.stringify(this.props.objectOption) !== JSON.stringify(e.objectOption) && this.handler.setObjectOption(this.props.objectOption), JSON.stringify(this.props.gridOption) !== JSON.stringify(e.gridOption) && this.handler.setGridOption(this.props.gridOption), JSON.stringify(this.props.propertiesToInclude) !== JSON.stringify(e.propertiesToInclude) && this.handler.setPropertiesToInclude(this.props.propertiesToInclude), JSON.stringify(this.props.activeSelectionOption) !== JSON.stringify(e.activeSelectionOption) && this.handler.setActiveSelectionOption(this.props.activeSelectionOption);
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          this.destroyObserver(), this.handler.destroy();
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.props.style,
              t = this.state.id;
          return b.a.createElement("div", {
            ref: this.container,
            id: t,
            className: "rde-canvas",
            style: bi({
              width: "100%",
              height: "100%"
            }, e)
          }, b.a.createElement("canvas", {
            id: "canvas_".concat(t)
          }));
        }
      }]), n;
    }(_.Component);

    x()(Si, "defaultProps", {
      id: A(),
      editable: !0,
      zoomEnabled: !0,
      minZoom: 30,
      maxZoom: 300,
      responsive: !0,
      width: 0,
      height: 0
    });
    var Ti = Si;
  }]);
});